import lunr from "lunr-mutable-indexes";

export const DATA = [
  {
    ID: 3,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. ZHU, SHUANGTANG",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "ONE OF FRONT COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1185/2016",
    "Permit Date": "2016-11-11T00:00:00Z",
    "Meeting Number": "20/2016",
    "Meeting Date": "2016-10-28T09:41:26Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.78,
    "Total Amount Of Capital (in Millions)": 0.78,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW SAT YIN",
    "Land Area (units not specified in file)": 0.998,
    "Lease Term": 20,
    "Annual Lease Fee": 0.026,
    "Land Use Premium": null,
    "Number Of Local Employees": 348,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 5, TAI XI ROAD, SHI NAN ZONE, QINGDAO CITY, SHANDONG PROVINCE, CHINA",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 83, INDUSTRIAL ZONE (1), HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 6,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Win Lwin",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Myat Mi Ba Company Limited (မြတ်မိဘ ကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1106/2015",
    "Permit Date": "2015-12-10T00:00:00Z",
    "Meeting Number": "20/2015",
    "Meeting Date": "2015-11-13T10:11:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ဆပ်ပြာမှုန့်၊ ဆပ်ပြာရည်၊ ချေးချွတ်မှုန့်နှင့် အဝတ်လျှော်ဆပ်ပြာတောင့်များ ထုတ်လုပ်ရောင်းချခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 2.857,
    "Total Amount Of Capital (in Millions)": 5400,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "No (3) Heavy Industrial Enterprise",
    "Land Area (units not specified in file)": 13.23,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 132,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 98, Ground Floor, 50th Street, Botahtaung Township, Yangon",
    "Organization Address": "-",
    "Investment Permitted Address": "",
  },
  {
    ID: 8,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကေျာင်လင်း",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Kaung Myanmar Aung Shipping Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "884/2013",
    "Permit Date": "2013-11-02T00:00:00Z",
    "Meeting Number": "6/2013",
    "Meeting Date": "2013-02-06T04:07:20Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့်   ​ေ​မြငှားရမ်း၍ စက်သုံးဆီ သိုလေှာင်ကန်များနှင့် ဆက်စပ်အဆောက်အဦများ တည်ဆောက်ပြီး စက်သုံးဆီသို​လေှာင် ဖြန့် ဖြူးသည့် ဝန်ဆောင်မှု လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 10231,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "မြန်မာ့ဆိပ်ကမ်းအာဏာပိုင်​​ေ မြ",
    "Land Area (units not specified in file)": 24.71,
    "Lease Term": 30,
    "Annual Lease Fee": 160.284,
    "Land Use Premium": 370.65,
    "Number Of Local Employees": 50,
    "Number Of Foreign Employees": 0,
    Status: "Submitted",
    "Investor Address":
      "အမှတ်-၃၂(ဘီ)၁၊ (၃၂) ရိပ်သာ၊ (၁၁) ရပ်ကွက်၊ (၆) မိုင်ခွဲ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "​ေ​မြကွက်အမှတ်-၃၁၊ ၃၂ (စီ)၊ သီလဝါဆိပ်ကမ်းဒေသ၊ သန်လျင်-ကေျာက်တန်းနယ်​ေမြ၊ မြန်မာ့ဆိပ်ကမ်းအာဏာပိုင်",
  },
  {
    ID: 11,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Kyaw Min",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "United GP Development Company Limited (ယူနိုက်(တ်) တက် ဂျီပီ ဒီဗဲလက်(ပ) မဲ့(န်ထ်) ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "Manatha 1073/2015",
    "Permit Date": "2015-08-20T00:00:00Z",
    "Meeting Number": "13/2015",
    "Meeting Date": "2015-07-17T03:04:31Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "၂၇ ထပ်နှင့် Basement ၄ ထပ် ပါဝင်သော အဆောက်အဦ တည်ဆောက်၍ အဆင့်မြင့် Residential Apartment ရောင်းချခြင်းနှင့် Service Apartment ငှားရမ်းခြင်း ဝန်ဆောင်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 116.06,
    "Total Amount Of Capital (in Millions)": 132158.2,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 60,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "United GP Development Co., Ltd.",
    "Land Area (units not specified in file)": 0.934,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 114,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "အမှတ် - ၁၂၇ (က) ၊ ဓမ္မစေတီလမ်း၊ ကမာရွတ်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "44(A), Sayar San Road,Sayar San Quarter, Bahan, YANGON",
  },
  {
    ID: 14,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. DOAN NHAT MINH",
    "Name of Principal Organization":
      "FPT INFORMATION SYSTEM SINGAPORE PTE LTD",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar": "FPT MYANMAR COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1135/2016",
    "Permit Date": "2016-07-18T00:00:00Z",
    "Meeting Number": "13/2016",
    "Meeting Date": "2016-07-08T15:51:17Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "PROVIDING NETWORK FACILITIES SERVICES, VOIP (VOICE OVER INTERNET PROTOCOL), IPTV (INTERNET PROTOCOL TELEVISION) AND ADD-ON SERVICES",
    "Amount Of Foreign Capital USD (in Millions)": 50,
    "Total Amount Of Capital (in Millions)": 50,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 10,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW POE KYu @ DAW PHYU PHYU WIN",
    "Land Area (units not specified in file)": 0.303,
    "Lease Term": 10,
    "Annual Lease Fee": 180,
    "Land Use Premium": 0,
    "Number Of Local Employees": 220,
    "Number Of Foreign Employees": 95,
    Status: "Approved",
    "Investor Address":
      "ROOM NO.414, C-3, BUILDING 34/A, LANE, TRAN PHU STREET, HANOI CITY, VIETNAM",
    "Organization Address":
      "9, TEMASEK BOULEVARD # 31-00 SUNTEC TOWER TWO, SINGAPORE 038989",
    "Investment Permitted Address":
      "MYAYTAING BLOCK NO.46 (B), PLOT NO. 116 A/1 & 116A/2, NO. 60, PYI DAUNG SU YEIKTHA STREET, DAGON TOWNSHIP, YANGON REGION",
  },
  {
    ID: 15,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Myint Htay ",
    "Name of Principal Organization": "Shwe Sandar (E&P) Co., Ltd ",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "ALpha ECC (Myanmar) Private Limited ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "647/2013",
    "Permit Date": "2017-07-13T00:00:00Z",
    "Meeting Number": "647/2013",
    "Meeting Date": "2017-07-01T05:35:29Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Offshore Platform Components Fabrication , Pre-Commissioning and Maintenance Services",
    "Amount Of Foreign Capital USD (in Millions)": 1.6,
    "Total Amount Of Capital (in Millions)": 1.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Vietnam",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Thandar Kyaw ",
    "Land Area (units not specified in file)": 2.227,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 29,
    "Number Of Foreign Employees": 13,
    Status: "Draft",
    "Investor Address": "No.20, Maha Myaing Street, Kyun ( south) Ward, ",
    "Organization Address": "Room No.405, Business Twin Tower, Dhamazedi Road ",
    "Investment Permitted Address":
      "No.14, Koun ant Min Thar Roas, Dgon Seik Kan Industrial ZOne ",
  },
  {
    ID: 18,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Ko Ko Gyi @ U Soe Naing",
    "Name of Principal Organization": "Green Land International Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Green Land International Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "940/2015",
    "Permit Date": "2015-04-27T00:00:00Z",
    "Meeting Number": "5/2015",
    "Meeting Date": "2015-03-20T04:59:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Distribution of Wheat Flour",
    "Amount Of Foreign Capital USD (in Millions)": 1.8,
    "Total Amount Of Capital (in Millions)": 12.03,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "Pac Link Trading Ltd.",
    "Land Area (units not specified in file)": 9.361,
    "Lease Term": 50,
    "Annual Lease Fee": 0.90899,
    "Land Use Premium": null,
    "Number Of Local Employees": 331,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address": "No.34, University Avenue Road ",
    "Organization Address": "No. (126/A), Kabaraye Pagoda Road",
    "Investment Permitted Address":
      "Plot No. (53, 54, 55, 56), Myay Taing Block No. (113), Industrial Zone, ",
  },
  {
    ID: 23,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Byoung Tak Hur ",
    "Name of Principal Organization": "LotteMGS Beverage(Myanmar) Co., Ltd ",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar": "Lotte  MGS Berverage( Myanmar) Co., Ltd ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "667/2014",
    "Permit Date": "2017-07-13T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production, Bottling, DIstribution amd Sales  of Non-Alcoholic Berverages  and Purified Drinking Water ",
    "Amount Of Foreign Capital USD (in Millions)": 56.7,
    "Total Amount Of Capital (in Millions)": 56.7,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner":
      "MGS  Berverages Co., Ltd(Myanmar)\nU Thein Tun, U Oo Oo Tun, Daw Mar Mar Tun ",
    "Land Area (units not specified in file)": 6.06,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 792,
    "Number Of Foreign Employees": 7,
    Status: "Draft",
    "Investor Address": "Pangyowonmaeul  1101-301,147, Seopangyo-Ro ",
    "Organization Address": "LTD., 20Cecilst., # 14-01, Equity  Plaza,",
    "Investment Permitted Address":
      "Plot  No. (48/1A), (48/2.49),(50/2)(72/2)Thandaybin Village ",
  },
  {
    ID: 26,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Son, Seog Chang",
    "Name of Principal Organization": "INNO International Co., Ltd.",
    "Place of Incorporation": "Korea",
    "Company Name In Myanmar": "INNO Packaging Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "972/2015",
    "Permit Date": "2015-06-28T00:00:00Z",
    "Meeting Number": "10/2015",
    "Meeting Date": "2015-06-05T06:30:55Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Carton Boxes and Packaging Accessories (Tape and String)",
    "Amount Of Foreign Capital USD (in Millions)": 1.995,
    "Total Amount Of Capital (in Millions)": 2.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "JV",
    "Land Owner": "Myanmar Economic Holdings Limited",
    "Land Area (units not specified in file)": 6.17,
    "Lease Term": 30,
    "Annual Lease Fee": 0.114,
    "Land Use Premium": null,
    "Number Of Local Employees": 200,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 539-1, Sangdong, Wonmigu, Bucheon-Si,, Gyeonggi-Do, Republic of Korea",
    "Organization Address":
      "3F, IL -Dongbldg No. 968-5, Daechi-Dong, Gangnam-Gu, Seoul, Republic of Korea",
    "Investment Permitted Address":
      "Plot No. 19, Pyinmabin Industrial Complex, Mingalardon Township, Yangon Region",
  },
  {
    ID: 27,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Eisuke Ihara",
    "Name of Principal Organization": "World Kaihatsu Kogyo Co., Ltd. ",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Asia Myanmar WKK JV Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "924/2015",
    "Permit Date": "2015-04-07T00:00:00Z",
    "Meeting Number": "3/2015",
    "Meeting Date": "2015-02-27T04:00:05Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Sales of Asphalt Concrete for Construction and Road Paving Work",
    "Amount Of Foreign Capital USD (in Millions)": 8.63,
    "Total Amount Of Capital (in Millions)": 8.733,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "Asia Myanmar consortium Development Co., Ltd.",
    "Land Area (units not specified in file)": 3,
    "Lease Term": 10,
    "Annual Lease Fee": 0.061,
    "Land Use Premium": null,
    "Number Of Local Employees": 69,
    "Number Of Foreign Employees": 13,
    Status: "Rejected",
    "Investor Address": "No-1-32-19, Asahi-Cho, Fuchu-City, Tokyo, Japan",
    "Organization Address":
      "No-7484 Watauchi, Wakaho,Nagano-City, Nagano Pref.381-0101,Japan",
    "Investment Permitted Address":
      "Plot No-155 & 156, Industrial Zone-2, Dagon Seikkan Township,Yangon Region",
  },
  {
    ID: 28,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်ကိုဝင်း",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar Airways International Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "841/2012",
    "Permit Date": "2012-04-05T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Other Services",
    "Type Of Investment Business":
      "ပြည်တွင်း၊ ပြည်ပ  လေ ကြောင်းသယ်ယူပို့ဆောင်ရေးလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 26,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address": "အမှတ်-၆၁၅/၂၊ ပြည်လမ်း ",
    "Organization Address": "-",
    "Investment Permitted Address": "ရန်ကုန်အပြည်ပြည်ဆိုင်ရာလေဆိပ်",
  },
  {
    ID: 29,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ngai Siu Lung",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Golden Tri-Light Myanmar Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1094/2016",
    "Permit Date": "2016-02-29T00:00:00Z",
    "Meeting Number": "5/2016",
    "Meeting Date": "2016-02-15T05:23:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.845,
    "Total Amount Of Capital (in Millions)": 0.845,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Pwai Wan & U Kyaw Soe Moe",
    "Land Area (units not specified in file)": 0.735,
    "Lease Term": 20,
    "Annual Lease Fee": 0.015,
    "Land Use Premium": null,
    "Number Of Local Employees": 835,
    "Number Of Foreign Employees": 15,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.140, West Road, Hong Lok Yuen, Taipo N.T. Hong Kong",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No. 4, Myay Taing No.24, Ngwe Pinle Industrial Zone, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 32,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Myo Aung",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "San Myanmar International Impex Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "Ma Na Tha-1213/2016",
    "Permit Date": "2016-09-22T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "(Contract Processing )\nLivestock & Fisheries",
    "Amount Of Foreign Capital USD (in Millions)": 0.1,
    "Total Amount Of Capital (in Millions)": 897.5,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Lin Ei Pain (or) U Kyaw Myin",
    "Land Area (units not specified in file)": 0.31,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 83,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address":
      "No-(797), Room-(504/B),MAC Tower,Bogyoke Aung San Road and Wartan Road Conor, Lanmataw Township, Yangon",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Myay Kwet No.(469/3), Myay Taing Ward No.(23), Industrial Zone,Dagon New City (South) Township, Yangon Myay Area 2.571 Acres 0.31 Acres (1254.52 Square feet)",
  },
  {
    ID: 38,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chetta Apipatana ",
    "Name of Principal Organization": "Northwood Co., Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Northwood Industry Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1019/2015",
    "Permit Date": "2015-09-25T00:00:00Z",
    "Meeting Number": "16/2015",
    "Meeting Date": "2015-09-11T03:57:24Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Wood-Based Products Including Sawn Timber, Flooring, Veneer, Plywood and Furniture",
    "Amount Of Foreign Capital USD (in Millions)": 5.488,
    "Total Amount Of Capital (in Millions)": 5.488,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "Myanma Timber Enterprise",
    "Land Area (units not specified in file)": 4.04,
    "Lease Term": 30,
    "Annual Lease Fee": 0.033,
    "Land Use Premium": 0.49,
    "Number Of Local Employees": 645,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address": "No-41-43, Mahesak Road",
    "Organization Address": "Outram Road, #11-02, Tan Boon Liat Building",
    "Investment Permitted Address":
      "No.9,Taw Win Street,4 Ward,Mayangone Township,Yangon., Mayangone, YANGON",
  },
  {
    ID: 45,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS. LIU JING",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "PRETTEX MYANMAR COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1171/2016",
    "Permit Date": "2016-10-21T00:00:00Z",
    "Meeting Number": "18/2016",
    "Meeting Date": "2016-09-23T09:07:47Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENTS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.75,
    "Total Amount Of Capital (in Millions)": 0.75,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "PRIMARL DAEWAI @ DAW NILAR AUNG ",
    "Land Area (units not specified in file)": 1.994,
    "Lease Term": 20,
    "Annual Lease Fee": 0.028,
    "Land Use Premium": null,
    "Number Of Local Employees": 470,
    "Number Of Foreign Employees": 11,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 2588, KAIPING ROAD, WUJIANG DISTRICT, SUZHOU CITY, JIANGSU, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 4, BLOCK NO. NGA/12, THAR DU KAN INDUSTRIAL ZONE, SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 47,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhang Guilin ",
    "Name of Principal Organization": "Kunming Long Trading CO., ltd",
    "Place of Incorporation": "PEOPLE'S  REPUBLIC  OF  CHINA",
    "Company Name In Myanmar": "Asia  Agriculture Company Limited ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "573/2013",
    "Permit Date": "2013-01-05T00:00:00Z",
    "Meeting Number": "573/2013",
    "Meeting Date": "2013-01-01T05:50:57Z",
    Sector: "Agriculture",
    "Type Of Investment Business": "Production and Marketing of Rice and Corn ",
    "Amount Of Foreign Capital USD (in Millions)": 1.56,
    "Total Amount Of Capital (in Millions)": 2210,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner":
      "U Hla Thaung, Pa Phoe Hla, U Tun Lwin, U Hka Thaung, U Shwe, U Htay Naing, U San, U Kyaw Than, U Saw Myint Aung, U Aung, U Zaw Zaw Lin",
    "Land Area (units not specified in file)": 109.06,
    "Lease Term": 20,
    "Annual Lease Fee": 0.36,
    "Land Use Premium": null,
    "Number Of Local Employees": 93,
    "Number Of Foreign Employees": 13,
    Status: "Monitoring Approved",
    "Investor Address": "301-1-1, 100 HAO, Shu Lin Road, Kunming, ",
    "Organization Address":
      "No 101, 1 F, Building 1, No.15, Xunjin Xincun, Jinbi Sub-District Office,  Xishan District , Kunming City, Yunnan Province",
    "Investment Permitted Address":
      "No(56),6 th Floor,6th Street,No(2)Quarter., Lanmadaw, YANGON",
  },
  {
    ID: 48,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Enrique Santos Martinez",
    "Name of Principal Organization": "Asia Pacific Beverages Pte. Ltd.",
    "Place of Incorporation": "Philippines",
    "Company Name In Myanmar": "Asia Pacific Beverages Myanmar Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1124/2016",
    "Permit Date": "2016-03-26T00:00:00Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T07:02:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing, Marketing, Sales and Distribution of Non-Alcoholic Ready-To-drink Beverage Products",
    "Amount Of Foreign Capital USD (in Millions)": 9,
    "Total Amount Of Capital (in Millions)": 10,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "U Aung Maw Thein",
    "Land Area (units not specified in file)": 1.986,
    "Lease Term": 50,
    "Annual Lease Fee": 0.22869,
    "Land Use Premium": null,
    "Number Of Local Employees": 118,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address": "3 Mactan St., Magallanes Village ",
    "Organization Address": "6 temasek Boule Vard 29-00, Suntec Tower Four",
    "Investment Permitted Address": "Plot No. 151, Yangon Industrial Zone",
  },
  {
    ID: 50,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kin Cheung Tsang",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Pak Chun Industrial Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1079/2016",
    "Permit Date": "2016-02-04T00:00:00Z",
    "Meeting Number": "2/2016",
    "Meeting Date": "2016-01-22T07:57:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.707,
    "Total Amount Of Capital (in Millions)": 1.707,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Tun, Daw San San Yee",
    "Land Area (units not specified in file)": 2.878,
    "Lease Term": 10,
    "Annual Lease Fee": 0.065,
    "Land Use Premium": null,
    "Number Of Local Employees": 1300,
    "Number Of Foreign Employees": 30,
    Status: "Monitoring Approved",
    "Investor Address":
      "FLAT A, 3/F, FAST INDUSTRIAL BUILDING, 658 CASTLE PEAK ROAD, LAI CHI KOK, KOWLOON, HONG KONG",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၉၂၊ မြေတိုင်းရပ်ကွက်အမှတ်-၁၄၊ ရွှေသံလွင်စက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန် တိုင်းဒေသကြီး နှင့် မြေကွက်အမှတ်-၁၂၂၊ မြေတိုင်း ရပ်ကွက်အမှတ် အပိုင်း-၄၊ စက်မှုဇုန််၊ လှိုင်သာယာ မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 55,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးစံလင်း",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Super Seven Stars Motors Industry Co., Ltd.",
    "Financial Year From": 2011,
    "Financial Year To": 2012,
    "Permit Number": "840/2012",
    "Permit Date": "2012-03-23T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "မော်တော်ယာဉ်များ ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 9.56,
    "Total Amount Of Capital (in Millions)": 3181.73,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address": "အမှတ်-၁၆၂/၁၆၄၊ ၂ ရပ်ကွက်၊ မဟာဗန္ဓုလမ်း၊ ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၄၅၊ ၄၆၊ ၄၇၊ ၄၈၊ ၄၉၊ ၅၀၊ မြေတိုင်းရပ်ကွက်အမှတ်-၁၄၄၊ မြဝတီမင်းကြီးလမ်း၊ စက်မှုဇုန်၊ ",
  },
  {
    ID: 59,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Chit Khaing",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Denko Petrochemical Management Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "930/2014",
    "Permit Date": "2014-02-07T00:00:00Z",
    "Meeting Number": "21/2013",
    "Meeting Date": "2013-08-21T08:44:39Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် မြေငှားရမ်း၍ စက်သုံးဆီ တင်/ချ ဆိပ်ခံတံတားနှင့် ဆီသိုလှောင်ကန်များ တည်ဆောက်ပြီး စက်သုံးဆီ သိုလှောင်သည့် ဝန်ဆောင်မှု လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 36.46,
    "Total Amount Of Capital (in Millions)": 61037.14,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ပို့ဆော​င်ရေး ဝန်ကြီးဌာန၊ မြန်မာ့ဆိပ်ကမ်း အာဏာပိုင် ",
    "Land Area (units not specified in file)": 24.71,
    "Lease Term": 30,
    "Annual Lease Fee": 180.516,
    "Land Use Premium": 370.65,
    "Number Of Local Employees": 193,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address": "အမှတ်-၁၀၀-F၊ အင်းယားလမ်း",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၇/၁၈-ဘီ၊ ရှိ မြေ (၂၄.၇၁) ဧက၊ သန်လျင်-ကျောက်တန်း",
  },
  {
    ID: 60,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U YE MYINT",
    "Name of Principal Organization": "CHAN MYAE KYWE GROUP CO., LTD.,",
    "Place of Incorporation": "MYANMAR",
    "Company Name In Myanmar": "FILAND COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1228/2017",
    "Permit Date": "2017-01-15T00:00:00Z",
    "Meeting Number": "1/2017",
    "Meeting Date": "2017-01-06T06:58:19Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF FUR DRESSED GARMENT ON CONTRACT MANUFACTURING PROCESS (CMP) BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 4.12,
    "Total Amount Of Capital (in Millions)": 5.15,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Canada",
    "Form Of Investment": "JV",
    "Land Owner": "U KYAW KIN",
    "Land Area (units not specified in file)": 1.527,
    "Lease Term": 5,
    "Annual Lease Fee": 72,
    "Land Use Premium": null,
    "Number Of Local Employees": 230,
    "Number Of Foreign Employees": 110,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. A/9, AYE NANDAR HOUSING COMPLEX, AYEYARWUN ROAD, 10/ NORTH WARD, THARKAYTA TOWNSHIP, YANGON",
    "Organization Address":
      "NO. 388/398, MINGALAR AHSINTMYINT HOUSING COMPLEX, A(4/5) 3rd FLOOR, SINMIN QUARTER, KANNAR ROAD, AHLONE TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "PLOT NO. F-5, MYAY TAING BLOCK NO. 20, ANAWYAHTAR INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 62,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Hla Wai",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Myat Min Company Limited (မြတ်မင်းကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1113/2015",
    "Permit Date": "2015-12-31T00:00:00Z",
    "Meeting Number": "19/2015",
    "Meeting Date": "2015-10-30T06:34:54Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "နိုင်ငံတကာအဆင့်မီ ဝန်ဆောင်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 52.2,
    "Total Amount Of Capital (in Millions)": 79000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Hla Wai",
    "Land Area (units not specified in file)": 2.206,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 192,
    "Number Of Foreign Employees": 13,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် (၅၆)၊ ကမ္ဘာအေးဘုရားလမ်း, အမှတ်(၁၀) ရပ်ကွက်၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ မရမ်းကုန်းမြို့နယ်၊ (၈) ရပ်ကွက်၊ အမှတ် (၃)၊ အုတ်ပုံဆိပ်လမ်း၊ မြေတိုင်းရပ်ကွက်အမှတ် (၁၀)၊ မြေကွက်အမှတ် (၂/က၁) ရှိ မြေ (၁.၄၂၉) ဧက၊ မြေကွက်အမှတ် ၂/က၂ ရှိ မြေ (၀.၂၇၅) ဧကနှင့် မြေကွက်အမှတ် ၃/က ရှိ မြေ (၁.၅၀၂) ဧက စုစုပေါင်း မြေ (၃.၂၀၆) ဧကအနက် မြေ (၂.၂၀၆) ဧက",
  },
  {
    ID: 63,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Nandar Lwin OO",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Lwin Oo Htwe Trading Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "1025/2015",
    "Permit Date": "2015-01-20T00:00:00Z",
    "Meeting Number": "29/2014",
    "Meeting Date": "2014-12-26T09:27:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သွပ်ပြား ကုန်ချော (ပုံဖော်) ထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း၊ ပုံဖော်ခြင်း၊ ဖြတ်တောက်ခြင်း ဝန်ဆောင်မှုလုပ်ငန်းနှင့် လိုအပ်သော တပ်ဆင်ပစ္စည်းများ တွဲဖက်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 5368.44,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 4.616,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Submitted",
    "Investor Address":
      "အမှတ်-၂၀ ( အေ) ၊ ကျောက်ကုန်းလမ်း၊ (၁၄) ရပ်ကွက် ၊ ရန်ကင်းမြို့နယ် ၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "-",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး ၊ မင်္ဂလာဒုံမြို့နယ် ၊ ရန်ကုန်စက်မှုဇုန် ၊ မြေကွက်အမှတ် (၂၄၈) ရှိ မြေဧရိယာ ၄.၆၁၆ ဧက",
  },
  {
    ID: 70,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Praveen Kumar Jain",
    "Name of Principal Organization": "Valency International Trading Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Myanmar Evergreen Gurjan Wood Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1036/2015",
    "Permit Date": "2015-11-11T00:00:00Z",
    "Meeting Number": "18/2015",
    "Meeting Date": "2015-10-23T06:29:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Plywood, Face Veneer, Core Veneer, Teak Veneer and Sawn Timber",
    "Amount Of Foreign Capital USD (in Millions)": 4.226,
    "Total Amount Of Capital (in Millions)": 4.226,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 24,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "U Khin Mg Lay and Daw Thida",
    "Land Area (units not specified in file)": 4.726,
    "Lease Term": 15,
    "Annual Lease Fee": 0.105,
    "Land Use Premium": null,
    "Number Of Local Employees": 475,
    "Number Of Foreign Employees": 25,
    Status: "Monitoring Approved",
    "Investor Address": "110 Tanjong RHU Road, 05-05 Camelot ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Room No.504,Level 5,La Pyayt Wun Pluza, No.37, Alanpya Pagoda Road, Dagon Township,Yangon., Dagon, YANGON",
  },
  {
    ID: 76,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကျော်ညိုလင်း",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "AIR MYANMAR AVIATION SERVICES COMPANY LIMITED",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "Ma Na Tha 956/2014",
    "Permit Date": "2014-02-07T00:00:00Z",
    "Meeting Number": "1/2014",
    "Meeting Date": "2014-01-08T05:33:07Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "ပြည်တွင်း/ ပြည်ပ အထွေ ​ထွေ သယ်ယူပို့ ဆောင်ရေး ဝန်ဆောင်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 33.09,
    "Total Amount Of Capital (in Millions)": 32008.16,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Transport and Communications",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 201,
    "Number Of Foreign Employees": 10,
    Status: "Submitted",
    "Investor Address": "အမှတ်-၁၈၆၊ လေဆိပ်လမ်း၊ ၅ ရပ်ကွက်၊ ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No(56), Shwe Taung Gyar Street, Bahan Township, YANGON",
  },
  {
    ID: 85,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Min Din",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Kappa International Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "MaNaTha-1014/2014",
    "Permit Date": "2014-11-21T00:00:00Z",
    "Meeting Number": "26/2014",
    "Meeting Date": "2014-11-07T09:50:27Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "ဟိုတယ်ဝန်ဆောင်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 5000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "ပတ်ဝန်းကျင်ထိန်းသိမ်းရေးနှင့် သစ်တောရေးရာဝန်ကြီးဌာန ၊ သစ််တောဦးစီးဌာန",
    "Land Area (units not specified in file)": 21.77,
    "Lease Term": 50,
    "Annual Lease Fee": 43540000,
    "Land Use Premium": 1088500,
    "Number Of Local Employees": 180,
    "Number Of Foreign Employees": 3,
    Status: "Approved",
    "Investor Address":
      "အမှတ် -၉၅၊(အေ-၁) ၊ လမ်းသစ်လမ်း၊ နံ့သာကုန်း၊ အင်းစိန်မြို့နယ် ၊ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No.(22/24), Nawarat Condo 2(H),Pyi Sae Quarter, Samon street, Dagon, YANGON",
  },
  {
    ID: 89,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Scott  William Weenink ",
    "Name of Principal Organization": "Ooredoo Asian Investment  Pte. Ltd. ",
    "Place of Incorporation": "-80, Robinson # 02-00, Singapore (068898)",
    "Company Name In Myanmar": "Ooredoo Myanmar ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "621/2013",
    "Permit Date": "2014-01-27T04:02:53Z",
    "Meeting Number": "1/2014",
    "Meeting Date": "2014-01-08T04:03:33Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Mobile and Fixed Line Telecommunication Service ",
    "Amount Of Foreign Capital USD (in Millions)": 3830.5,
    "Total Amount Of Capital (in Millions)": 3830.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 1509,
    "Number Of Foreign Employees": 23,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "80, Robinson # 02-00, Singapore (068898)",
    "Investment Permitted Address":
      "No(339), Bokyoke Aung San Road, Sakura Tar War, 5 Floor , Room-0502",
  },
  {
    ID: 93,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးညီနိုင်အောင်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar Alinkar Hotel Group Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "MaNaTha-917/2013",
    "Permit Date": "2013-06-28T00:00:00Z",
    "Meeting Number": "14/2013",
    "Meeting Date": "2013-05-10T06:05:59Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ ဟိုတယ် တည်ဆောက်ခြင်းနှင့် ဟိုတယ် ဝန်ဆောင်မှု လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 7778.7,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်စံပယ်အောင်",
    "Land Area (units not specified in file)": 0.373,
    "Lease Term": 10,
    "Annual Lease Fee": 84000000,
    "Land Use Premium": 0,
    "Number Of Local Employees": 110,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address": "အမှတ်-၃၂/အေ၊ မင်္ဂလာလမ်း၊ နံသာကုန်းရပ်ကွက်",
    "Organization Address": "-",
    "Investment Permitted Address":
      "အမှတ်-၃၄၁၊ ပြည်လမ်း၊ မုန့်လုပ်ဆောင်း ကုန်း (တောင်) ရပ်ကွက်၊ မြေတိုင်းရပ်ကွက် အမှတ်-၂၅-B-1၊ မြေကွက်အမှတ်-၇၂-ဘီ/၁၊ ရှိမြေ (၀.၃၇၃၀ ဧက",
  },
  {
    ID: 96,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. HEO  JUNGHOON ",
    "Name of Principal Organization": "ICREGEM  INTERNATIONAL  CO.,  LTD ",
    "Place of Incorporation": "Republic  of  Korea",
    "Company Name In Myanmar": "ICREGEM  INTERNATIONAL  CO.,  LTD. ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "677/2014",
    "Permit Date": "2014-03-03T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing  of  Garment   on  CMP  basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.638,
    "Total Amount Of Capital (in Millions)": 0.638,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Democratic People's Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U  KYAW   KHIN ",
    "Land Area (units not specified in file)": 1.527,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 590,
    "Number Of Foreign Employees": 6,
    Status: "Draft",
    "Investor Address": "# 109-102,SEOGANG  SSANGYONG  YEGA  APT, ",
    "Organization Address":
      "ICREGEM  CORPORATION  SINDANG-DONG, 202, OLDIES B/D, SINDAND-DONG,122, ",
    "Investment Permitted Address":
      "PLOT  NO F-5M MYAY  TAING  BLOCK NO 20, ANAWRAHTA  INDUSTRIAL ZONE ",
  },
  {
    ID: 97,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. ANTHONY JOHN CORTHAN CLARK",
    "Name of Principal Organization": "MYANMAR CARLSBERG COMPANY LIMITED. ",
    "Place of Incorporation": "MYANMAR",
    "Company Name In Myanmar": "MCLL DIS COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1170/2016",
    "Permit Date": "2016-10-03T00:00:00Z",
    "Meeting Number": "17/2016",
    "Meeting Date": "2016-09-09T07:07:27Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "DISTRIBUTION AND LOGISTIC OF CARLSBERG BEER",
    "Amount Of Foreign Capital USD (in Millions)": 200,
    "Total Amount Of Capital (in Millions)": 28.763,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "U THEIN TUN",
    "Land Area (units not specified in file)": 0.312,
    "Lease Term": 3,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 126,
    "Number Of Foreign Employees": 5,
    Status: "Submitted",
    "Investor Address": "NO. 87-B, LINDEN DRIVE, SINGAPORE",
    "Organization Address":
      "NO. 332-A, PYAY LAN THWE, NORTH MYAYNIGONE, SAN CHAUNG TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "MYAY TAING BLOCK NO. 29-B 1, PLOT NO. 99-H/2, NO. 332 (A), PYAY LAN THWE, SAN CHAUNG TOWNSHIP, YANGON REGION",
  },
  {
    ID: 99,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. TONG YUNHONG",
    "Name of Principal Organization":
      "ZHEJIANG SANYUAN HOLDING GROUP CO., LTD.,",
    "Place of Incorporation": "PEOPLE'S REPUBLIC OF CHINA",
    "Company Name In Myanmar":
      "SANYUAN (MYANMAR) APPAREAL MANUFACTURING COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1148/2016",
    "Permit Date": "2016-09-14T00:00:00Z",
    "Meeting Number": "16/2016",
    "Meeting Date": "2016-08-26T08:46:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.21,
    "Total Amount Of Capital (in Millions)": 1.21,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U AYE MIN SOE, U MYAT MINN THAW, U DWE MINN YAN ",
    "Land Area (units not specified in file)": 2.032,
    "Lease Term": 20,
    "Annual Lease Fee": 0.043,
    "Land Use Premium": null,
    "Number Of Local Employees": 1000,
    "Number Of Foreign Employees": 21,
    Status: "Monitoring Approved",
    "Investor Address":
      "ROOM 101, BUILDING JIA, NO. 59 WENYI ROAD, SIHU DISTRICT, HANGZHOU, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address":
      "NO.1888 JIANGHUI ROAD, HANGZHOU CITY, PEOPLE'S REPUBLIC OF CHINA",
    "Investment Permitted Address":
      "PLOT NO. 87,  MYAY TAING BLOCK NO. 14, SHWE THAN LWIN INDUSTRIAL ZONE, HLAING THARYAR TOWNSHIP, YANGON REGION  ",
  },
  {
    ID: 102,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Kyi Lin ",
    "Name of Principal Organization": "Yee Shin Co., ltd ",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Yee Shin International Wood Industry Limited ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "777/2014",
    "Permit Date": "2014-08-14T00:00:00Z",
    "Meeting Number": "18/2014",
    "Meeting Date": "2014-07-09T09:11:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Wood-Based Furniture",
    "Amount Of Foreign Capital USD (in Millions)": 0.858,
    "Total Amount Of Capital (in Millions)": 1.75,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "U Kyi Lin & U Tun Lin ",
    "Land Area (units not specified in file)": 2,
    "Lease Term": 10,
    "Annual Lease Fee": 0.06,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No.51, Thirimon 6 th Street, Ward No.15, Thiri Mon Housing ",
    "Organization Address":
      "No.25/26, Bahosi Housing Eastate, Bogyoke Aung san Road , Ward No.10",
    "Investment Permitted Address": "Plot No.588, Block No.10/1, Ward No.-3",
  },
  {
    ID: 112,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Kyaw Min Tun",
    "Name of Principal Organization": "Shwe Pin Le Trading Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Sine Feng Global Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1129/2016",
    "Permit Date": "2016-03-26T00:00:00Z",
    "Meeting Number": "7/2016",
    "Meeting Date": "2016-02-26T10:11:24Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING   AND  SALES  OF CONCRETE  BLOCKS",
    "Amount Of Foreign Capital USD (in Millions)": 0.7,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Brunei Darussalam",
    "Form Of Investment": "JV",
    "Land Owner": "Shi Kyin Htke (a)      U Tin Myint",
    "Land Area (units not specified in file)": 2.726,
    "Lease Term": 20,
    "Annual Lease Fee": 0.552,
    "Land Use Premium": null,
    "Number Of Local Employees": 70,
    "Number Of Foreign Employees": 5,
    Status: "Approved",
    "Investor Address":
      "NO. 189/B,  52  LANE, THUKHA STREET,  HLAING     TOWNSHIP, YANGON",
    "Organization Address":
      "NO.189/B,  52  LANE,  THUKHA  STREET,  HLAING TOWNSHIP,  YANGON  ",
    "Investment Permitted Address":
      "PLOT  NO.68,    MYAY  TAING   BLOCK  NO.14 ,  SHWE  THAN LWIN  INDUSTRIAL  ZONE, HLAING THAR YAR TOWNSHIP, YANGON  REGION",
  },
  {
    ID: 114,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Theingi Lin",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Yadanarbon Fibre Services Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "MaNaTha-1036/2015",
    "Permit Date": "2015-02-25T00:00:00Z",
    "Meeting Number": "2/2015",
    "Meeting Date": "2015-01-31T06:26:55Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "မြေအောက်ဖိုင်ဘာ ဆက်ကြောင်းတည်ဆောက်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 7740,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 70,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "အမှတ် (၄၁/အေ)၊ ရွှေတောင်ကြားလမ်း၊ ရွှေတောင်ကြား(၂) ရပ်ကွက်၊ ဗဟန်းမြို့နယ် ၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "-",
    "Investment Permitted Address":
      "-ရန်ကုန်မြို့အတွင်း နှင့် မန္တလေးမြို့အတွင်း\n- Room No(101), Corner of Kabar Aye Pagoda Road & Pyay Road, Hotel Yangon      Building, , Mayangone, YANGON",
  },
  {
    ID: 119,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kwon Hua Moh Paul ",
    "Name of Principal Organization": "Diamond Dragon Global Limited ",
    "Place of Incorporation": "Hong  Kong",
    "Company Name In Myanmar":
      "Fidelity Garment Manufactory (International) Limited ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "855/2014",
    "Permit Date": "2014-11-22T00:00:00Z",
    "Meeting Number": "27/2014",
    "Meeting Date": "2014-11-07T10:15:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing  of  Garment   on  CMP  basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.009,
    "Total Amount Of Capital (in Millions)": 1.009,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Virgin Islands (British)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Naing Tun Oo ",
    "Land Area (units not specified in file)": 4.318,
    "Lease Term": 10,
    "Annual Lease Fee": 0.09,
    "Land Use Premium": null,
    "Number Of Local Employees": 302,
    "Number Of Foreign Employees": 9,
    Status: "Monitoring Approved",
    "Investor Address": "10B, 1 HOMANTIN HILL ROAD, KOWLOON, HONG KONG",
    "Organization Address":
      "Flat A-D, 10/F, Hop Hing Industrial Buildng, 704 Castle Peak Road ",
    "Investment Permitted Address":
      "PLOT NO.125/126, MYAY TAING BLOCK NO.51, THAR DU KAN INDUSTRIAL ZONE, SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 120,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Charles Woodworh ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Telenor Myanmar ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "620/2013",
    "Permit Date": "2014-08-03T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Transport & Communication",
    "Type Of Investment Business": "Mobile Telecommunications Services",
    "Amount Of Foreign Capital USD (in Millions)": 900,
    "Total Amount Of Capital (in Millions)": 900,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Inyar Kan Hotl , Kabar Aye pagoda road, No-37, Room-117",
  },
  {
    ID: 122,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Takashi Fukai",
    "Name of Principal Organization": "Daiwa Institute of Research LTD",
    "Place of Incorporation": "Japan ",
    "Company Name In Myanmar": "DMS Limited ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "756/2014",
    "Permit Date": "2014-08-06T00:00:00Z",
    "Meeting Number": "17/20144",
    "Meeting Date": "2014-06-20T06:45:51Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Services  Relating to Computer system Solution, Consulting , Research and Business Associated with such services ",
    "Amount Of Foreign Capital USD (in Millions)": 4.497,
    "Total Amount Of Capital (in Millions)": 4.497,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Sakura Residence ",
    "Land Area (units not specified in file)": 88357,
    "Lease Term": 10,
    "Annual Lease Fee": 62400,
    "Land Use Premium": 0,
    "Number Of Local Employees": 16,
    "Number Of Foreign Employees": 3,
    Status: "Submitted",
    "Investor Address": "1-4-33-1501, Shiohama, Koto-Ku, Tokyo, Japan",
    "Organization Address": "15-6, Fuyuki, Koto-Ku, Tokyo,135-0041",
    "Investment Permitted Address": "Plot No.3, Myaytaing Block No.87",
  },
  {
    ID: 125,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. FAN WENYE",
    "Name of Principal Organization":
      "SUMEC TEXTILE & LIGHT INDUSTRY CO., LTD., ",
    "Place of Incorporation": "PEOPLE'S REPUBLIC OF CHINA",
    "Company Name In Myanmar": "MYANMAR SUMEC WIN WIN GARMENTS COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1149/2016",
    "Permit Date": "2016-09-14T00:00:00Z",
    "Meeting Number": "16/2016",
    "Meeting Date": "2016-08-26T05:56:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENTS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 4.29,
    "Total Amount Of Capital (in Millions)": 4.29,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U PYAE PHYO KYAW",
    "Land Area (units not specified in file)": 2,
    "Lease Term": 20,
    "Annual Lease Fee": 0.042,
    "Land Use Premium": null,
    "Number Of Local Employees": 2536,
    "Number Of Foreign Employees": 25,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 13F, SUMEC BUILDING, NO. 198 CHANGJIANG ROAD, NANJING, CHINA 210018",
    "Organization Address":
      "NO. 13F , SUMEC BUILDING, NO., 198 CHANGJIANG ROAD, NANJING, CHINA 210018",
    "Investment Permitted Address":
      " မြေကွက်အမှတ် - ၁၄၊ ၁၅၊ မြေတိုင်းရပ်ကွက်အမှတ်- ၆၅ (စက်မှု)၊ ကင်းဝန် မင်းကြီးလမ်း၊ စက်မှုဇုန်အပိုင်း (၄)၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 126,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "DAW AYE SANDAR LWIN",
    "Name of Principal Organization": "LLUVIA LIMITED",
    "Place of Incorporation": "MYANMAR",
    "Company Name In Myanmar": "SAR TAW KAL NISSIN COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1265/2017",
    "Permit Date": "2017-04-11T00:00:00Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T07:13:22Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND DISTRIBUTION OF INSTANT NOODLES",
    "Amount Of Foreign Capital USD (in Millions)": 1.061,
    "Total Amount Of Capital (in Millions)": 7.083,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "DIAMOND STAR COMPANY LIMITED ",
    "Land Area (units not specified in file)": 1.991,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 67,
    "Number Of Foreign Employees": 4,
    Status: "Approved",
    "Investor Address":
      "NO. 383, THUNANDAR, 9th  STREET, (G) QUARTER, NORTH OKKALAPA TOWNSHIP, YANGON",
    "Organization Address":
      "NO. 126/A, KABAR AYE PAGODA ROAD, BAHAN TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "PLOT NO. 136, INDUSTRIAL ZONE (1), HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 132,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Jiang, Zuliang",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "ZHEJIANG LANSHAN MYANMAR CLOTHING COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1215/2017",
    "Permit Date": "2017-01-11T00:00:00Z",
    "Meeting Number": "1/2017",
    "Meeting Date": "2017-01-06T08:28:24Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.73,
    "Total Amount Of Capital (in Millions)": 0.73,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "MAN CHUU @ DAW HNIN YU KHAING",
    "Land Area (units not specified in file)": 1.432,
    "Lease Term": 10,
    "Annual Lease Fee": 0.031,
    "Land Use Premium": null,
    "Number Of Local Employees": 1183,
    "Number Of Foreign Employees": 20,
    Status: "Amend",
    "Investor Address":
      "Jiangsu Seng, Hai Men Shi, Hai Men Jie Dao, Qing Hai Lu, Ou Ju Wei Hai Liu Zu 114 Hao, China",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 3, INDUSTRIAL ZONE (2), DAGON MYOTHIT SEIKKAN TOWNSHIP, YANGON REGION",
  },
  {
    ID: 137,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U THAUNG WIN",
    "Name of Principal Organization": "GOLDEN LACE COMPANY LIMITED",
    "Place of Incorporation": "MYANMAR",
    "Company Name In Myanmar":
      "Golden Lace Posco International Company Limited ",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1222/2017",
    "Permit Date": "2017-01-18T00:00:00Z",
    "Meeting Number": "1/2017",
    "Meeting Date": "2017-01-06T05:22:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "PROCESSING, PRODUCTION AND SALE OF PARBOILED RICE, HIGH QUALITY WHITE RICE AND RICE PRODUCTS (FACTORY - 2)",
    "Amount Of Foreign Capital USD (in Millions)": 14.367,
    "Total Amount Of Capital (in Millions)": 16.612,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner":
      "Ministry of Transport and Communication, Directorate of Water Resources and Improvement of River System",
    "Land Area (units not specified in file)": 13.8,
    "Lease Term": 50,
    "Annual Lease Fee": 20942500,
    "Land Use Premium": 103500000,
    "Number Of Local Employees": 32,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 26, KHAY MAR STREET, THIRI KHAY MAR QUARTER, SANCHAUNG TOWNSHIP, YANGON",
    "Organization Address":
      "NO. 26, KHAY MAR STREET, THIRI KHAY MAR QUARTER, SANCHAUNG TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "HOLDING NO. CN/10, KWIN NO. 124/A, HLAY LAN KWIN, KALATAN VILLAGE TRACT,TWANTAY TOWNSHIP, YANGON SOUTHERN DISTRICT, YANGON REGION",
  },
  {
    ID: 140,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမောင်ကျေး",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Green Asia Services Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "MaNaTha-911/2013",
    "Permit Date": "2013-05-14T00:00:00Z",
    "Meeting Number": "14/2013",
    "Meeting Date": "2013-05-10T07:39:54Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "B. O.T စနစ်ဖြင့် မြေငှားရမ်း၍ စက်သုံးဆီ တင်/ချ ဆိပ်ခံတံတား နှင့် ဆီသိုလှောင်ကန်များ တည်​ဆောက်ပြီး စက်သုံးဆီသိုလှောင် ဖြန့်ဖြူးသည့် ဝန်ဆောင်မှု လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 12.01,
    "Total Amount Of Capital (in Millions)": 41705.82,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "မြန်မာ့ဆိပ်ကမ်းအာဏာပိုင် ",
    "Land Area (units not specified in file)": 24.71,
    "Lease Term": 30,
    "Annual Lease Fee": 180.48,
    "Land Use Premium": 370.65,
    "Number Of Local Employees": 42,
    "Number Of Foreign Employees": 0,
    Status: "Terminated",
    "Investor Address":
      "အမှတ်-စီ-၄၊ မွန်မြတ်မေတ္တာအဆင့်မြင့် အိမ်ရာ၊ ပင်ရေွှညောင်လမ်း၊ ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၇/၁၈(အေ)၊ သီလဝါဆိပ်ကမ်းဒေသ၊ သန်လျင်-ကျောက်တန်းနယ်မြေ၊ မြန်မာ့ဆိပ်ကမ်းအာဏာပိုင် မြေ (၂၄.၇၁) ဧက",
  },
  {
    ID: 141,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ashok Garg ",
    "Name of Principal Organization": "Fine Wood Products PVT., Ltd",
    "Place of Incorporation": "India",
    "Company Name In Myanmar": "Fine Ply Myanmar PVT., LTD",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "652/2013",
    "Permit Date": "2013-12-27T00:00:00Z",
    "Meeting Number": "31/2013",
    "Meeting Date": "2013-12-04T04:32:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing  and  Marketing  of  Veneer, Plywood and Swan Timber",
    "Amount Of Foreign Capital USD (in Millions)": 5,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "India",
    "Form Of Investment": "FDII",
    "Land Owner": "U Than Tun, U Than Sein ",
    "Land Area (units not specified in file)": 8.3,
    "Lease Term": 15,
    "Annual Lease Fee": 0.168,
    "Land Use Premium": null,
    "Number Of Local Employees": 295,
    "Number Of Foreign Employees": 46,
    Status: "Approved",
    "Investor Address":
      "99/2 Madukarai Village Pondicherry 605105,India. PVT., LTD.",
    "Organization Address": "99/2&99/3 Madukarai Village Pondicherry 605105",
    "Investment Permitted Address":
      "Plot No.101 To 105 and Part of 106 Industrial zone(2)",
  },
  {
    ID: 143,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Christopher Ladd Heffner ",
    "Name of Principal Organization": "Clipper Holdings  Ltd",
    "Place of Incorporation": "Hong  Kong",
    "Company Name In Myanmar": "Express Food Group ( Myanmar) Limited ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "643/2013",
    "Permit Date": "2017-07-13T00:00:00Z",
    "Meeting Number": "643/2013",
    "Meeting Date": "2017-07-01T07:03:14Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Production of Fast Food Products and Related Services ",
    "Amount Of Foreign Capital USD (in Millions)": 1.84,
    "Total Amount Of Capital (in Millions)": 1.84,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 4790,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 161,
    "Number Of Foreign Employees": 2,
    Status: "Draft",
    "Investor Address": "4/6, Casa  Langsuan, Lumpini, 10330",
    "Organization Address":
      "36/F, Tower  Two Times  Square, 1 Matheson Street   ,  Causeway  Bay ",
    "Investment Permitted Address":
      "Yangon  Region and  other regions  and  states ",
  },
  {
    ID: 145,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Deepak Agrawal",
    "Name of Principal Organization": "Brightex Singapore Pet. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Myanmar Brightex Veneer Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "984/2015",
    "Permit Date": "2015-07-14T00:00:00Z",
    "Meeting Number": "11/2015",
    "Meeting Date": "2015-06-19T08:47:41Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Plywood, Face Veneer, Core Veneer, Teak Veneer and Sawn Timber",
    "Amount Of Foreign Capital USD (in Millions)": 2.936,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 24,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "U Khin Mg Aye",
    "Land Area (units not specified in file)": 4.366,
    "Lease Term": 30,
    "Annual Lease Fee": 0.088,
    "Land Use Premium": null,
    "Number Of Local Employees": 386,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address": "18 E, Gemstar Tower, 23 Manlok Street Hunghom",
    "Organization Address": "8 UBI Road 2, # 07-07, Zervex ",
    "Investment Permitted Address":
      "Block No(49), Plot No 252 and 253 , War Tayar Industrial Zone , Shwe Pyi Thar Township, Yangon., Shwepyithar, YANGON",
  },
  {
    ID: 147,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Song Shang Feng",
    "Name of Principal Organization":
      "Hyday (South Pacific) Investment Pte. Ltd. ",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Qingjian (Myanmar) Enterprise Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "998/2015",
    "Permit Date": "2015-08-20T00:00:00Z",
    "Meeting Number": "14/2015",
    "Meeting Date": "2015-08-07T09:06:52Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Sales of Various Kinds of Furniture and Construction Products Made of Aluminum, Glass, Metal, Steel and Woods",
    "Amount Of Foreign Capital USD (in Millions)": 5.105,
    "Total Amount Of Capital (in Millions)": 5.105,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "Great Shwe Taung Development Co., Ltd.",
    "Land Area (units not specified in file)": 7.826,
    "Lease Term": 50,
    "Annual Lease Fee": 0.158,
    "Land Use Premium": null,
    "Number Of Local Employees": 148,
    "Number Of Foreign Employees": 99,
    Status: "Monitoring Approved",
    "Investor Address": "NO.51,  COMPASSVALE  BOW # 18-03,  SINGAPORE 544984 ",
    "Organization Address":
      "47 KALLANG PUDDING ROAD, 12-01 CRESCENT @ KALLANG SINGAPORE 349381 ",
    "Investment Permitted Address":
      "PLOT NO. 14 & 15 , MYAY TAING BLOCK NO. 21, MYA SEIN YAUNG INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON REGION                                                                                                                                ",
  },
  {
    ID: 148,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Maung Maung Soe",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Aung Phyo Myat Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "MaNaTha-1198/2016",
    "Permit Date": "2016-07-13T00:00:00Z",
    "Meeting Number": "13/2016",
    "Meeting Date": "2016-07-08T07:20:57Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Construct and Operate of Wharf and Fishery Market",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 4500,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": " Own of Fish Daperment",
    "Land Area (units not specified in file)": 2.06,
    "Lease Term": 50,
    "Annual Lease Fee": 49.3534,
    "Land Use Premium": null,
    "Number Of Local Employees": 213,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "Bulding No-6, Room-102, Naungtan Housing, Naungtan Road, Pazontaung Township, Yangon",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Bulding No-6, Room-102, Naungtan Housing, Naungtan Road, Pazontaung Township, Yangon\n",
  },
  {
    ID: 150,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. BABA MAKOTO",
    "Name of Principal Organization": "MATSUOKA APPAREL (HK) CO., LTD.",
    "Place of Incorporation": "HONG KONG",
    "Company Name In Myanmar": "MYANMAR POST ARION COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1195/2016",
    "Permit Date": "2016-11-13T00:00:00Z",
    "Meeting Number": "21/2016",
    "Meeting Date": "2016-11-12T05:58:13Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF GARMENT ON CMP BASIS (FACTORY - 2)",
    "Amount Of Foreign Capital USD (in Millions)": 1.45,
    "Total Amount Of Capital (in Millions)": 1.45,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "",
    "Land Owner": "U Mg Mg Oo @ Won Sei Lain",
    "Land Area (units not specified in file)": 2.732,
    "Lease Term": 30,
    "Annual Lease Fee": 0.15,
    "Land Use Premium": null,
    "Number Of Local Employees": 883,
    "Number Of Foreign Employees": 4,
    Status: "Approved",
    "Investor Address": "24/F PRINCE'S BUILDING, CENTRAL , HONG KONG",
    "Organization Address": "24/F PRINCE'S BUILDING, CENTRAL , HONG KONG",
    "Investment Permitted Address":
      "PLOT NO. 152, 160, MYAY TAING BLOCK NO. 42, INDUSTRY, SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 151,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးရဲသူရလတ်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Gulf Power Construction Co., Ltd.",
    "Financial Year From": 2011,
    "Financial Year To": 2012,
    "Permit Number": "manatha 811/2011",
    "Permit Date": "2011-09-27T00:00:00Z",
    "Meeting Number": "17/2011",
    "Meeting Date": "2011-09-21T08:16:33Z",
    Sector: "Construction",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် လမ်းပြုပြင်ဖောက်လုပ်၍ လမ်း၊ တံတား အသုံးပြုခများ ကောက်ခံခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 4253.85,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 120,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address": "အမှတ်-၄၂၊ ဦးရေွှဂွန်းလမ်း၊ ၇ ရပ်ကွက်၊ ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "အမှတ်-၄၂၊ ဦးရေွှဂွန်းလမ်း၊ ၇ ရပ်ကွက်၊ ပုဇွန်တောင်မြို့နယ်",
  },
  {
    ID: 154,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. DEJ PATHANASETHPONG",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "THONG THAI TEXTILE (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1237/2017",
    "Permit Date": "2017-04-11T00:00:00Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T05:42:41Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF SPORTWEAR AND CASUAL WEAR ON CMP BASIS (FACTORY -2)",
    "Amount Of Foreign Capital USD (in Millions)": 6.48,
    "Total Amount Of Capital (in Millions)": 6.48,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Thailand",
    "Form Of Investment": "FDII",
    "Land Owner": "U HTEIN MIN, U HTAIN LIN, U THAIN TIN AND U HLA THEIN",
    "Land Area (units not specified in file)": 2.782,
    "Lease Term": 16,
    "Annual Lease Fee": 0.532,
    "Land Use Premium": null,
    "Number Of Local Employees": 180,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address":
      "36/42-43 SOI KASEMSANTL WANGMAI PATHUMWAN BANGKOK 10330 THAILAND",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 151 & 152, INDUSTRIAL ZONE (1), HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 156,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyan Khinn",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "MSL Industries Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "MaNaTha-1206/2016",
    "Permit Date": "2016-08-31T00:00:00Z",
    "Meeting Number": "Ma Na Tha-1206/2016",
    "Meeting Date": "2016-08-01T03:52:22Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business": "Livestock & Fisheries",
    "Amount Of Foreign Capital USD (in Millions)": 0.25,
    "Total Amount Of Capital (in Millions)": 5690.93,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 4.2,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 670,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "No-(284/286),  Room (5), Shwe Dagon Pagoda Road, Yaw Min Gyi Quarter, Dagon Township, Yangon",
    "Organization Address": "-",
    "Investment Permitted Address": "-",
  },
  {
    ID: 157,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U SHWE LYNN",
    "Name of Principal Organization":
      "KAUNG MYANMAR AUNG SHIPPING COMPANY LIMITED",
    "Place of Incorporation": "MYANMAR",
    "Company Name In Myanmar": "KMA-SUZUE LOGISTICS MYANMAR LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1182/2016",
    "Permit Date": "2016-11-11T00:00:00Z",
    "Meeting Number": "1182/2016",
    "Meeting Date": "2016-11-01T08:49:05Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      'PROVIDING CONSOLIDATED LIGISTICS SERVICES WITH A CONTAINER FREIGHT STATION ("CFS") AND WAREHOUSE',
    "Amount Of Foreign Capital USD (in Millions)": 2.662,
    "Total Amount Of Capital (in Millions)": 5.324,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 17,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "KAUNG MYANMAR AUNG COMPANY LIMITED",
    "Land Area (units not specified in file)": 4.5,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 10,
    "Number Of Foreign Employees": 2,
    Status: "Submitted",
    "Investor Address":
      "NO. R/V-7, RIVER VIEW GARDEN 27 WARD, NORTH DAGON TOWNSHIP, YANGON",
    "Organization Address":
      "OLYMPIC TOWER, ROOM NO. 304, 305, 306, 3rd CORNER OF MAHABANDOOLA & BO AUNG KYAW STREET, KYAUKTADA TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "MYAY TAING BLOCK NO. 75, PLOT NO. 228/8, DAGON MYOTHIT SEIKKAN TOWNSHIP, YANGON REGION",
  },
  {
    ID: 159,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Samuel Dennis Allan Taylor",
    "Name of Principal Organization": "Pioneer Asia International Limited",
    "Place of Incorporation": "Birtish Virgin Islands",
    "Company Name In Myanmar": "Pioneer Asia Myanmar Engineering Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "910/2015",
    "Permit Date": "2015-02-25T00:00:00Z",
    "Meeting Number": "2/2015",
    "Meeting Date": "2015-01-31T09:47:39Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Machine Shop For Maintenance And Repair of Drill Pipe For Supporting Oil & Gas Industry",
    "Amount Of Foreign Capital USD (in Millions)": 7.74,
    "Total Amount Of Capital (in Millions)": 8.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 12,
    "Investing Country": "Virgin Islands (British)",
    "Form Of Investment": "JV",
    "Land Owner": "U Ann Ku @ Thu Ei Myo",
    "Land Area (units not specified in file)": 2.13,
    "Lease Term": 12,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 39,
    "Number Of Foreign Employees": 14,
    Status: "Terminated",
    "Investor Address": "15 Redwood Avenue, 276725, Singapore",
    "Organization Address":
      "Trident Chambers, P.O. Box 146, Road Town, Tortola British Virgin Islands",
    "Investment Permitted Address":
      "Plot No.77, Dagon Seik Kan Industrial Zone, Dagon Seik Kan Township, Yangon Region",
  },
  {
    ID: 166,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးခင်စိုး",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Apex Gas and Oil Public Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "923/2013",
    "Permit Date": "2013-08-12T00:00:00Z",
    "Meeting Number": "17/2013",
    "Meeting Date": "2013-06-29T03:53:26Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် ​မြေငှားရမ်း၍ စက်သုံးဆီ တင်/ချ ဆိပ်ခံ တံတားနှင့် ဆီသိုလှောင်ကန်များ တည်ဆောက်ပြီး စက်သုံးဆီ သိုလှောင်ဖြန့်ဖြူးသည့် ဝန်ဆောင်မှု လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 33.94,
    "Total Amount Of Capital (in Millions)": 67333.46,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "မြန်မာ့ဆိပ်ကမ်းအာဏာပိုင်မြေ",
    "Land Area (units not specified in file)": 24.71,
    "Lease Term": 30,
    "Annual Lease Fee": 179.76,
    "Land Use Premium": 370.65,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": 8,
    Status: "Approved",
    "Investor Address":
      "အမှတ်-၁၂၃၊ ဓမ္မစေတီလမ်း​၊  ​ရေွှတောင်ကြား -၂ ရပ်ကွက်၊ ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၊၂(ဘီ)၊ သီလဝါဆိပ်ကမ်းဒေသ၊ သန်လျင်-ကျောက်တန်း နယ်မြေ၊ မြန်မာ့ဆိပ်ကမ်းအာဏာပိုင်မြေ ၂၄.၇၁ ဧက",
  },
  {
    ID: 168,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Su Su Tin",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Sanctum Inle Resort Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "MaNaTha-1032/2015",
    "Permit Date": "2015-02-25T00:00:00Z",
    "Meeting Number": "2/2015",
    "Meeting Date": "2015-01-31T08:48:54Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ ဟိုတယ် ဝန်ဆောင်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 2.75,
    "Total Amount Of Capital (in Millions)": 5714.9,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "ပတ်ဝန်းကျင်ထိန်းသိမ်းရေးနှင့် သစ်တောရေးရာဝန်ကြီးဌာန ၊ သစ်တောဦးစီးဌာန",
    "Land Area (units not specified in file)": 6.01,
    "Lease Term": 50,
    "Annual Lease Fee": 1.202,
    "Land Use Premium": 305000,
    "Number Of Local Employees": 145,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် (၁၂) ၊ နဂါးရုံဘုရားလမ်း၊ (၅) ရပ်ကွက် ၊ မရမ်းကုန်းမြို့နယ် ၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No.(147), Shwegondaing Street, West Shwegondaing Ward, , Bahan Township, YANGON",
  },
  {
    ID: 169,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. katsumi Aoki",
    "Name of Principal Organization": "GFT Enterprise Co., Ltd.",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Manufacturer GFT Enterprise Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1051/2015",
    "Permit Date": "2015-12-16T00:00:00Z",
    "Meeting Number": "21/2015",
    "Meeting Date": "2015-11-27T04:03:27Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.54,
    "Total Amount Of Capital (in Millions)": 1.59,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "U Kyin Hoke @  Hla Oo",
    "Land Area (units not specified in file)": 2.267,
    "Lease Term": 30,
    "Annual Lease Fee": 0.06,
    "Land Use Premium": null,
    "Number Of Local Employees": 1292,
    "Number Of Foreign Employees": 15,
    Status: "Monitoring Approved",
    "Investor Address": "4-28, Tokiwacho, Chigasaki-Shi, Kanagawa Pref, Japan",
    "Organization Address": "204-2 Namazu, Mizuho-Shi, Gifu-ken, Japan",
    "Investment Permitted Address":
      "Plot No. 26, Yangon Industiral Park, North Okkalapa Township, Yangon Region",
  },
  {
    ID: 170,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw Nan Mouk Laung Seing",
    "Name of Principal Organization": "Golden Sky World Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Asian Blue Aviaton Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1121/2016",
    "Permit Date": "2016-03-26T00:00:00Z",
    "Meeting Number": "1121/2016",
    "Meeting Date": "2016-03-01T15:27:25Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business": "International Air Transport Services",
    "Amount Of Foreign Capital USD (in Millions)": 34.73,
    "Total Amount Of Capital (in Millions)": 70.87,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 260,
    "Number Of Foreign Employees": 17,
    Status: "Terminated",
    "Investor Address": "No.152/154/2/3, Floor, 19th Street, Ward No. 4, ",
    "Organization Address": "W-63, thirimon Estate, Bayintnaung Road",
    "Investment Permitted Address":
      "Yangon International Airport, Yangon Region",
  },
  {
    ID: 171,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyaw Moe Naing",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar Ease Net Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "MaNaTha-1203/2016",
    "Permit Date": "2016-08-31T00:00:00Z",
    "Meeting Number": "15/2016",
    "Meeting Date": "2016-08-19T05:58:32Z",
    Sector: "Other Services",
    "Type Of Investment Business": "BOT System Online e-Visa ",
    "Amount Of Foreign Capital USD (in Millions)": 16.369,
    "Total Amount Of Capital (in Millions)": 20481.18,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 10,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 18,
    "Number Of Foreign Employees": 2,
    Status: "Approved",
    "Investor Address":
      "Bulding No-203, Yankin Centre,(2) Ward, Yankin Township, Yangon",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No-14, Room(302), MICT Park, Hlaing Township, Yangon",
  },
  {
    ID: 172,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw Sandar Htun",
    "Name of Principal Organization":
      "Shwe Taung  Junction City Development Co.,Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "SHWE TAUNG JUNCTION CITY DEVELOPMENT COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "761/2014",
    "Permit Date": "2014-08-06T00:00:00Z",
    "Meeting Number": "18/2014",
    "Meeting Date": "2014-07-09T06:06:33Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Construction, Developing And Operation of Shopping Complex",
    "Amount Of Foreign Capital USD (in Millions)": 81.36,
    "Total Amount Of Capital (in Millions)": 149.28,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 4,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "YCDC",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 413,
    "Number Of Foreign Employees": 1,
    Status: "Submitted",
    "Investor Address":
      "Ahlone Tower , River View Garden Housing , Strand Road, Ahlone Township , Yangon",
    "Organization Address": "No.584, Strand Road, Lamdaw Township, Yangon",
    "Investment Permitted Address":
      "Ahlone Tower, Strand Road, , Ahlone, YANGON",
  },
  {
    ID: 175,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Dr.Somsiri Sakolsatayadorn ",
    "Name of Principal Organization": "SV Holding Co., Ltd",
    "Place of Incorporation": "Thaniland",
    "Company Name In Myanmar": "Samitivej International Company Limited ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "768/2014",
    "Permit Date": "2014-07-08T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Samitivej International Specialist Clinic for Health Care and Social Related  Services ",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Shwesin\nU Myo Aung ",
    "Land Area (units not specified in file)": 0.153,
    "Lease Term": 10,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 46,
    "Number Of Foreign Employees": 4,
    Status: "Draft",
    "Investor Address": "9/1 Soi Akrapat, Klongtan-Nua Sub-District",
    "Organization Address": "488 Srinakarin Road , Suan Laung District ",
    "Investment Permitted Address": "No.9E/2, Kabar Aye  Pagoda Road ",
  },
  {
    ID: 176,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kim Joo Han",
    "Name of Principal Organization": "Hanwha Singapore Pte. Ltd. ",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Livingsquare Hanwha Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "993/2015",
    "Permit Date": "2015-08-06T00:00:00Z",
    "Meeting Number": "993/2015",
    "Meeting Date": "2015-08-01T02:05:46Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Development, Lease and Management of Residential Apartments and Shopping Mall",
    "Amount Of Foreign Capital USD (in Millions)": 84.08,
    "Total Amount Of Capital (in Millions)": 152.872,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Aye Aye Twin",
    "Land Area (units not specified in file)": 4.018,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 343,
    "Number Of Foreign Employees": 25,
    Status: "Terminated",
    "Investor Address": "Hanwha Building 22FL 1 Janggyo-Dong, Jung-GU",
    "Organization Address": "4 Shenton Way, # 15-06, SGX Center II",
    "Investment Permitted Address":
      "Myay Taing Block No. 31/ Tamine, Plot No. 8, 15, 2/E2/A and 2/F2/A, No.106, Pyay Street ",
  },
  {
    ID: 180,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Sann Thwin",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Megason Investment Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1010/2015",
    "Permit Date": "2015-09-05T00:00:00Z",
    "Meeting Number": "15/2015",
    "Meeting Date": "2015-08-21T09:20:45Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Construction and Operation of  25 Storeyed Service Apartment",
    "Amount Of Foreign Capital USD (in Millions)": 60,
    "Total Amount Of Capital (in Millions)": 80,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "U Sai Ai Paung",
    "Land Area (units not specified in file)": 2.779,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 190,
    "Number Of Foreign Employees": 68,
    Status: "Monitoring Approved",
    "Investor Address": "No.350, Mingalar Street, Sawbwagyikone ",
    "Organization Address": "No.350, Mingalar Street, Sawbwagyikone ",
    "Investment Permitted Address":
      "Plot No. 13/A 2-1, A2 Holding No. 5 A On The Bank of Pazundaung Creek",
  },
  {
    ID: 181,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမြဟန်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Fortune Elevator & Escalator Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "Ma Na Tha-1243/2017",
    "Permit Date": "2017-04-11T00:00:00Z",
    "Meeting Number": "၅/၂၀၁၇",
    "Meeting Date": "2017-03-13T10:16:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ ဓာတ်လှေကားများ ထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.58,
    "Total Amount Of Capital (in Millions)": 3500,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Mya Han",
    "Land Area (units not specified in file)": 2.158,
    "Lease Term": 20,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 114,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၆၁၅-ဒီ ၊ ပြည်လမ်း၊ ကမာရွတ်မြို့နယ်၊ ရန်ကုန်မြို့\n",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၂၈၃၊ ရန်ကုန်စက်မှုဇုန်၊  မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး\t",
  },
  {
    ID: 185,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. ZHANG, YONGHONG",
    "Name of Principal Organization": "HANGZHOU CLEVE TRADING CO., LTD.,",
    "Place of Incorporation": "CHINA",
    "Company Name In Myanmar": "HUNDRED GARMENT (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1240/2017",
    "Permit Date": "2017-04-11T00:00:00Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T03:36:09Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 6,
    "Total Amount Of Capital (in Millions)": 6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U THEIN SHWE",
    "Land Area (units not specified in file)": 3,
    "Lease Term": 20,
    "Annual Lease Fee": 0.097,
    "Land Use Premium": null,
    "Number Of Local Employees": 1756,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 358, HONGDA ROAD, XIAOSHAN ECONOMIC & TECHNOLOGY DEVELOPMENT ZONE, HANGZHOU, ZHEJIANG, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address":
      "NO. 358, HONGDA ROAD, XIAOSHAN ECONOMIC & TECHNOLOGY DEVELOPMENT ZONE, HANGZHOU, ZHEJIANG, PEOPLE'S REPUBLIC OF CHINA",
    "Investment Permitted Address":
      "PLOT NO. 140, MYAY TAING BLOCK NO. 51, (THAR DU KAN INDUSTRIAL ZONE), SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 189,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Tetsuya Kyrokawa",
    "Name of Principal Organization": "Yamaman Co., Ltd.",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Hotel Yamaman Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1100/2016",
    "Permit Date": "2016-03-26T00:00:00Z",
    "Meeting Number": "1100/2016",
    "Meeting Date": "2016-03-01T05:53:27Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": 11.665,
    "Total Amount Of Capital (in Millions)": 11.665,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Mu Mu Naing",
    "Land Area (units not specified in file)": 0.276,
    "Lease Term": 50,
    "Annual Lease Fee": 3.3,
    "Land Use Premium": null,
    "Number Of Local Employees": 34,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address": "Minamikoshigaya 4-8-9-404,  Koshigaya City",
    "Organization Address": "6-1 Nihombashi-Koamicho, Chuo-KU",
    "Investment Permitted Address":
      "Myay Taing Block No. 34, Kanbe Plot No.16/ Kha-1,16 / Kha-2, Thit Sar Road .Yankin township, Yangon Region",
  },
  {
    ID: 191,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. KLEDCHAI BENJAATHONSIRIKUL",
    "Name of Principal Organization": "KLN (SINGAPORE) PTE. LTD.",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar": "KM TERMINAL AND LOGISTICS LIMITED ",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1247/2017",
    "Permit Date": "2017-04-11T00:00:00Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T11:04:06Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business": "DRY PORT SERVICE",
    "Amount Of Foreign Capital USD (in Millions)": 11.369,
    "Total Amount Of Capital (in Millions)": 11.369,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII,BOT",
    "Land Owner": "MYANMA RAILWAYS, MINISTRY OF TRANSPORT AND COMMUNICATIONS",
    "Land Area (units not specified in file)": 42.674,
    "Lease Term": 50,
    "Annual Lease Fee": 0.234,
    "Land Use Premium": 1120093,
    "Number Of Local Employees": 101,
    "Number Of Foreign Employees": 4,
    Status: "Approved",
    "Investor Address":
      "NO.51/60 SOI SUKHUMVIT 23 KLONG TOEY NUE WATTANA, BANGKOK, THAILAND",
    "Organization Address":
      "KERRY LOGISTICS CENTRE (TAMPINES) BUILDING 19 GREENWICH DRIVE LEVEL 7 (S) SINGAPORE 534021",
    "Investment Permitted Address":
      "No .44,Thein Phyu Road,Near Bogyoke Aung San Road., Pazuntaung Township, YANGON",
  },
  {
    ID: 192,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Htun Myint Naing",
    "Name of Principal Organization":
      "Pioneer Aerodrome Services Company Limited ",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Yangon Aerodrome Company Limited ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "750/2014",
    "Permit Date": "2015-06-01T00:00:00Z",
    "Meeting Number": "17/2014",
    "Meeting Date": "2014-06-20T04:00:37Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Yangon International Airport, Development Project and Airport Services",
    "Amount Of Foreign Capital USD (in Millions)": 177.056,
    "Total Amount Of Capital (in Millions)": 177.056,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 24,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Yangon International Airport ",
    "Land Area (units not specified in file)": 894,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 1135,
    "Number Of Foreign Employees": 1,
    Status: "Approved",
    "Investor Address": "NO.(124) 8/9 Quarter, Insein Road ,",
    "Organization Address":
      "No.(203/2014) Thiri Mingalar Housing, Strand Road ",
    "Investment Permitted Address":
      "No.(203/204), Thiri Mingalar Housing, Strand Road, Ahlone Township, Yangon., Ahlone, YANGON",
  },
  {
    ID: 198,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Arnold Henricus ",
    "Name of Principal Organization": "Myanmar Power PTE LTd",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar": "Maxpower(Tahketa) Co., Ltd ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "757/2014",
    "Permit Date": "2014-08-07T00:00:00Z",
    "Meeting Number": "16/2014",
    "Meeting Date": "2014-06-13T02:25:22Z",
    Sector: "Power",
    "Type Of Investment Business":
      "Construction of 50 MW Gas-Fired Engine Power Plant For Electricity Generation",
    "Amount Of Foreign Capital USD (in Millions)": 40.11,
    "Total Amount Of Capital (in Millions)": 40.11,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 4,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "Ministry of Energy ",
    "Land Area (units not specified in file)": 2.07,
    "Lease Term": 0,
    "Annual Lease Fee": 8388,
    "Land Use Premium": null,
    "Number Of Local Employees": 27,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address": "Wijaya 3, No.9, Kebayoran Baru Jakarta Selatan 12160,",
    "Organization Address": "80 Robinson Road,# 02-00 ",
    "Investment Permitted Address":
      "Thaketa Power, Plant Compound , Ayerwun Street, 9 th Quarter, ",
  },
  {
    ID: 205,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhang Yuewen  ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Qiyan Fashion Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "949/2015",
    "Permit Date": "2015-05-07T00:00:00Z",
    "Meeting Number": "6/2015",
    "Meeting Date": "2015-04-03T08:21:59Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Knit and Embroidery on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.865,
    "Total Amount Of Capital (in Millions)": 0.865,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Sai Kyin",
    "Land Area (units not specified in file)": 2.6,
    "Lease Term": 10,
    "Annual Lease Fee": 0.63,
    "Land Use Premium": null,
    "Number Of Local Employees": 476,
    "Number Of Foreign Employees": 6,
    Status: "Terminated",
    "Investor Address":
      "No.7, DONGAN GONG YE YUAN, HUNAN, PEOPLE'S \tREPUBLIC OF CHINA ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO.103, MYAY TAING QUARTER NO.51, THARDUKAN INDUSTRIAL ZONE, SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 206,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U THEIN MYINT ",
    "Name of Principal Organization": "ELEVEN MEDIA GROUP CO., LTD. ",
    "Place of Incorporation": "MYANMAR",
    "Company Name In Myanmar": "ELEVEN-NATION MEDIA COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1133/2016",
    "Permit Date": "2016-07-12T00:00:00Z",
    "Meeting Number": "12/2016",
    "Meeting Date": "2016-07-27T06:50:18Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "PUBLISHING OF NEWSPAPER IN FOREIGN LANGUAGE (ENGLISH)",
    "Amount Of Foreign Capital USD (in Millions)": 0.539,
    "Total Amount Of Capital (in Millions)": 0.539,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "U THAN HTUT AUNG",
    "Land Area (units not specified in file)": 3112.5,
    "Lease Term": 3,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 28,
    "Number Of Foreign Employees": 7,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 64, GROUND FLOOR, SIN YAE KAN STREET, SIN MIN WARD, AHLONE TOWNSHIP, YANGON",
    "Organization Address":
      "NO. 22, 5th FLOOR, SOUTH HORSE RACING ROAD, TAMWEGYI WARD (B) , TAMWE TOWNSHIP, YANGON REGION",
    "Investment Permitted Address":
      "NO. 22, 5th FLOOR, SOUTH HORSE RACING ROAD, TAMWEGYI WARD (B) , TAMWE TOWNSHIP, YANGON REGION",
  },
  {
    ID: 214,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးထွန်းထွန်းအောင်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Royal Hi-Tech Group Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "867/2012",
    "Permit Date": "2012-11-19T00:00:00Z",
    "Meeting Number": "34/2012",
    "Meeting Date": "2012-11-14T07:00:58Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "စက်မှု ဥယာဉ်(မြို့သာ) စက်မှုအထူးဒေသ တည်ဆောက်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 59.74,
    "Total Amount Of Capital (in Millions)": 248200,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 70,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Royal Hi-Tech Group Co., Ltd.",
    "Land Area (units not specified in file)": 10000,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 122,
    "Number Of Foreign Employees": 0,
    Status: "Submitted",
    "Investor Address":
      "အမှတ်-၂၃၊ ၆၄ လမ်း၊ ၂၆ လမ်းနှင့် ၂၇ လမ်းကြား၊ အောင်တော်မူရပ်ကွက်",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No-216/222. Room No-(1/B), Mahabandoola Road, Pazundaung Township, Yangon.",
  },
  {
    ID: 220,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Chit Khaing",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Eden Hotels & Resorts Company Limited (ဧဒင်ဟိုတယ်နှင့် အပန်းဖြေလုပ်ငန်း ကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "Manatha 1108/2015",
    "Permit Date": "2015-12-16T00:00:00Z",
    "Meeting Number": "21/2015",
    "Meeting Date": "2015-11-27T06:24:45Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "ဟိုတယ်ဝန်ဆောင်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 29.452,
    "Total Amount Of Capital (in Millions)": 45025.81,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Naypyitaw City Development Committee",
    "Land Area (units not specified in file)": 75.509,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 225,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် (၁၀၀-F) ၊ အင်းယားလမ်း၊ ကမာရွတ်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No. 32(D), New University Avenue Rd, Saya San North Ward, Bahan, YANGON",
  },
  {
    ID: 223,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyaw Thet Lwin ",
    "Name of Principal Organization":
      "Maha Nadi Maritime Services Company Limited ",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Maha Nadi Maritime Services Company Limited ",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "မနသ-၁၀၇၈/၂၀၁၅",
    "Permit Date": "2015-08-20T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်ခွဲသားနှင့်ကြမ်းခင်းပစ္စည်းအမျိုးမျိုးထုတ်လုပ်ဖြန့်ဖြူးရောင်းချခြင်းလုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": 0.566,
    "Total Amount Of Capital (in Millions)": 0.566,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 1.731,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 62,
    "Number Of Foreign Employees": 8,
    Status: "Draft",
    "Investor Address": "အမှတ်-၁၀၂၊ပထမထပ်၊ ၄၂ လမ်း၊ ၈ ရပ်ကွက်၊ ",
    "Organization Address": "-",
    "Investment Permitted Address": "စက်မှုဇုန်(၂)၊မြေကွက်အမှတ်-၈၃၊ ",
  },
  {
    ID: 224,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lee Ho",
    "Name of Principal Organization": "Mirae C & T Co., Ltd.",
    "Place of Incorporation": "Korea",
    "Company Name In Myanmar": "Mirae Myanmar Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "999/2015",
    "Permit Date": "2015-08-20T00:00:00Z",
    "Meeting Number": "14/2015",
    "Meeting Date": "2015-08-07T09:33:46Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.957,
    "Total Amount Of Capital (in Millions)": 2.957,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 4,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "New Way Industries Ltd.",
    "Land Area (units not specified in file)": 1.385,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 620,
    "Number Of Foreign Employees": 19,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.206,402, Suyong Heapsung Lvesangs Town. 741Road, 46, Suyongro, Suyonggy Bussan, Korea  ",
    "Organization Address":
      "2/F, MUHAKSONG-RO, 142, GEUMJEONG-KU, BUSAN, REPUBLIC OF KOREA  ",
    "Investment Permitted Address":
      "PLOT NO. 180-D, INDUSTRIAL ZONE 4 (EXTENSION), HLAING THAR YAR TOWNSHIP, YANGON REGION  ",
  },
  {
    ID: 226,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS. PUI KI LEUNG",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "SAUNG OO SHWE NAY (GOLDEN SUNSHINE) COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1150/2016",
    "Permit Date": "2016-09-14T00:00:00Z",
    "Meeting Number": "16/2016",
    "Meeting Date": "2018-08-26T06:19:10Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 4.43,
    "Total Amount Of Capital (in Millions)": 4.43,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U HLA MYINT SHWE",
    "Land Area (units not specified in file)": 8.325,
    "Lease Term": 10,
    "Annual Lease Fee": 0.85,
    "Land Use Premium": null,
    "Number Of Local Employees": 743,
    "Number Of Foreign Employees": 9,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.5,17th  FLOOR, HUAYIN BUILDING, DONGHAI WEAT  ROAD, QINGDAO,  PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 32, 33, 34, 35, MYAY TAING BLOCK NO. 24, NGWE PIN LAE INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 227,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. KIM SEONGHO",
    "Name of Principal Organization": "KEVIN HOUSE, RWACHEON-DONG",
    "Place of Incorporation": "REPUBLIC OF KOREA",
    "Company Name In Myanmar": "SMK MINGALADON COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1208/2017",
    "Permit Date": "2017-01-11T00:00:00Z",
    "Meeting Number": "23/2016",
    "Meeting Date": "2016-12-17T06:22:13Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENTS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 8.97,
    "Total Amount Of Capital (in Millions)": 8.97,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 31,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "Directorate of Urban and Housing Development",
    "Land Area (units not specified in file)": 2.48,
    "Lease Term": 31,
    "Annual Lease Fee": 0.003,
    "Land Use Premium": 0.68,
    "Number Of Local Employees": 1908,
    "Number Of Foreign Employees": 25,
    Status: "Monitoring Approved",
    "Investor Address":
      "56, DWING KOL ROAD, GWACHEON CITY, GYOUNG GI DO, REPUBLIC OF KOREA",
    "Organization Address":
      "(KEVIN HOUSE, GWACHEON-DONG) 16, DWITGOL 2-RO, GWACHEON-SI, GYEONGGI-DO, REPUBLIC OF KOREA                                                       ",
    "Investment Permitted Address":
      "PLOT NO. A4, CORNER OF NO-3, HIGHWAY ROAD AND KHAYEBIN ROAD, MINGALADON INDUSTRIAL PARK, MINGALADON TOWNSHIP, YANGON REGION",
  },
  {
    ID: 230,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါက်တာထွန်းမင်းလတ်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Star Sapphire Hotel Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "MaNaTha-946/2013",
    "Permit Date": "2013-12-13T00:00:00Z",
    "Meeting Number": "30/2013",
    "Meeting Date": "2013-11-26T08:28:59Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "BOT စနစ်ဖြင့် ဟိုတယ် ဝန်ဆောင်မှု လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 9888.48,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ပြည်ထဲရေးဝန်ကြီးဌာန၊ အထွေထွေအုပ်ချုပ်ရေးဦးစီးဌာနပိုင်",
    "Land Area (units not specified in file)": 3.899,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": 6000000,
    "Number Of Local Employees": 90,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address": "အမှတ်-၄၅၊ ဇေယျသုခလမ်း၊ ၅၄ ရပ်ကွက်၊ သုဝဏ္ဏ ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Room 201, Building (c), Tatkatho Yeikmon Housing, New University Avenue Road, Bahan, YANGON",
  },
  {
    ID: 231,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Peter Egbertsen",
    "Name of Principal Organization": "Capitol Advisory Pte.Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Pan Asia Majestic Eagle Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "721/2014",
    "Permit Date": "2014-04-29T00:00:00Z",
    "Meeting Number": "12/2014",
    "Meeting Date": "2014-04-10T05:48:32Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Construction and Lease of Passive Infrastructure to Licensed Operators",
    "Amount Of Foreign Capital USD (in Millions)": 137.31,
    "Total Amount Of Capital (in Millions)": 137.31,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Yin Win Thu (Office Owner)",
    "Land Area (units not specified in file)": 3042,
    "Lease Term": 1,
    "Annual Lease Fee": 0.128,
    "Land Use Premium": 0,
    "Number Of Local Employees": 346,
    "Number Of Foreign Employees": 11,
    Status: "Approved",
    "Investor Address": "6 Mount Faber Road, Singapore 099198",
    "Organization Address": "80 Robinson Road, # 02-00, Singapore 068898",
    "Investment Permitted Address":
      "Nation Wide\n(Room (202) 1 Floor, Bulding No (15) , MICT Part, Hlaing Township, Yangon)",
  },
  {
    ID: 233,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမင်းသိမ်း",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Htun Nay Linn Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "963/2014",
    "Permit Date": "2014-02-11T00:00:00Z",
    "Meeting Number": "4/2014",
    "Meeting Date": "2014-01-30T08:09:14Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "တန် (၁၀၀၀) ဆန့် အအေးခန် စက်ရုံ တည်ဆောက်ပြီး အေးခဲ ငါး၊ ပုစွန်များ ထုတ်လုပ်ရောင်းချခြင်း နှင့် Contract Processing စနစ်ဖြင့် ငါး အသားလွှာများ ပြုပြင်ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.852,
    "Total Amount Of Capital (in Millions)": 3350.57,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်မြင့်မြင့်အေး",
    "Land Area (units not specified in file)": 4.027,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 196,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်-၇(က)၊ မာလာမြိုင်လမ်း၊ \nအမှတ်-၁၆ ရပ်ကွက်၊ ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "အမှတ်-၄၃၀၊ ၄၃၁၊ ဆိပ်ကမ်းသာလမ်း၊ မြေတိုင်းရပ်ကွက် အမှတ်-၂၅၊ ရေွှလင်ပန်း စက်မှုဇုန်၊ ",
  },
  {
    ID: 234,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Pyay Aung ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Pristine Lotus Hotel Group Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "MaNaTha-1041/2015",
    "Permit Date": "2015-03-17T00:00:00Z",
    "Meeting Number": "3/2015",
    "Meeting Date": "2015-02-27T08:13:39Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ ဟိုတယ်ဝန်ဆောင်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.14,
    "Total Amount Of Capital (in Millions)": 464.5,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "ပတ်ဝန်းကျင် ထိန်းသိမ်းရေးနှင့် သစ်တောရေးရာဝန်ကြီးဌာန၊ သစ်တောဦးစီးဌာနပိုင်",
    "Land Area (units not specified in file)": 8.54,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 427000,
    "Number Of Local Employees": 122,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်( ဘီ/၇) တော်ဝင်လမ်း၊ (၄) ရပ်ကွက် ၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No-B/17, Tawwin Road, 4-Ward, , Mayangone, YANGON",
  },
  {
    ID: 235,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Managing Director, Myanma Economic Bank",
    "Name of Principal Organization": "Ministry of Finance ",
    "Place of Incorporation": "Nay Pyi Taw",
    "Company Name In Myanmar": "Yangon Stock Exchange Joint-Venture Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "877/2014",
    "Permit Date": "2014-12-15T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Services Relating To Stock Exchange, Clearing and Settlement for Securities",
    "Amount Of Foreign Capital USD (in Millions)": 15.68,
    "Total Amount Of Capital (in Millions)": 33.68,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "Ministry of Finance",
    "Land Area (units not specified in file)": 31500,
    "Lease Term": 3,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 26,
    "Number Of Foreign Employees": 6,
    Status: "Monitoring Approved",
    "Investor Address": "Thiri Kyawswar Road, Bank Zone",
    "Organization Address": "Building No. 26 ",
    "Investment Permitted Address": "No. 24-26, Sulepagoda Road",
  },
  {
    ID: 236,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U San Oo",
    "Name of Principal Organization": "Myanmar Economic Holding Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Myanmar Inno Line Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "920/2015",
    "Permit Date": "2015-03-26T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Construction And Operation of Bus Terminaland Convention Center",
    "Amount Of Foreign Capital USD (in Millions)": 14.08,
    "Total Amount Of Capital (in Millions)": 17.59,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "JV",
    "Land Owner": "Ministry of Defence",
    "Land Area (units not specified in file)": 1.45,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 52,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "No.189/191 Maha Bandoola Street, Botataung Township ,Yangon",
    "Organization Address":
      "No.189/191 Maha Bandoola Street, Botataung Township ,Yangon",
    "Investment Permitted Address":
      "Shwe Man Thu Bus Compound, Corner of Wayzayantar Road & Parami Road, Plot No-(148,149,150) ,Myay Taing Block No-(4+5 Kaytumarlar), South Okkalapa Township, Yangon Region",
  },
  {
    ID: 237,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦး​ထွန်းအေး",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Shwe Yamone Value Added Sea Food Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "973/2014",
    "Permit Date": "2014-03-28T00:00:00Z",
    "Meeting Number": "8/2014",
    "Meeting Date": "2014-03-05T05:38:59Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "Normal စနစ်နှင့် Contract Processing စနစ် (၂) မျိုးဖြင့်  ငါး၊ ပုစွန် ပြုပြင်အေးခဲ ထုတ်လုပ်ခြင်း နှင့် အရည်အသွေး မြင့်မားသည့် တန်ဘိုးမြင့် ငါး၊ ပုစွန် ကုန်ခေျာ ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.11,
    "Total Amount Of Capital (in Millions)": 1100,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-ရွှေယမုံထုတ်လုပ်မှု ကုမ္ပဏီလီမိတက်",
    "Land Area (units not specified in file)": 0.94,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 836,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-(ဂျီ-၁)၊ မိုးကောင်းလမ်း၊ မြကန်သာ ဥယျာဉ် အိမ်ယာ၊ ၁၄-ရပ်ကွက်၊ ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "​မြေကွက်အမှတ်-၁၇၄-ခ ၁၊ ဆိပ်ကမ်းသာလမ်း၊ စက်မှုဇုန်-၄၊ ",
  },
  {
    ID: 241,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. ZHANG, JUNFEI",
    "Name of Principal Organization":
      "GOLDEN 11 INVESTMENT INTERNATIONAL PTE LTD",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar":
      "GOLDEN MYANMAR BUSINESS EXCHANGE COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1211/2017",
    "Permit Date": "2017-01-11T00:00:00Z",
    "Meeting Number": "1/2017",
    "Meeting Date": "2017-01-06T15:58:36Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "CONSTRUCTION & OPERATION OF CO-LOCATION HOSTING DATA CENTER SERVICES",
    "Amount Of Foreign Capital USD (in Millions)": 12.894,
    "Total Amount Of Capital (in Millions)": 12.894,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "U TIN OO AND U SOMIYAT @ U THOMAS ",
    "Land Area (units not specified in file)": 0.864,
    "Lease Term": 15,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 32,
    "Number Of Foreign Employees": 5,
    Status: "Approved",
    "Investor Address": "ROOM NO. 201, NO. 177, ANHUA ROAD, SHANGHAI, CHINA",
    "Organization Address":
      "10 ANSON ROAD, # 19-01 INTERNATIONAL PLAZA SINGAPORE",
    "Investment Permitted Address":
      "PLOT NO 196, MYAY TAING BLOCK NO. INDUSTRIAL ZONE (1) 113, DAGON MYO THIT (EAST) TOWNSHIP, YANGON REGION",
  },
  {
    ID: 244,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Tseng, Chen-Yi",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "TOPLINE GLOBAL COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1207/2016",
    "Permit Date": "2016-12-23T00:00:00Z",
    "Meeting Number": "23/2016",
    "Meeting Date": "2016-12-17T05:49:55Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF VARIOUS KINDS OF UNDERWEAR ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 2.1,
    "Total Amount Of Capital (in Millions)": 2.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Sha Yin Tate @ Yin Tate @ U Kyaw Min",
    "Land Area (units not specified in file)": 0.79,
    "Lease Term": 10,
    "Annual Lease Fee": 0.016,
    "Land Use Premium": null,
    "Number Of Local Employees": 800,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address":
      "Xichang Rd, No.67, Dounan Township, Yunlin Country 630, Taiwan,Republic of China.",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 245, MYAY TAING BLOCK NO. (25), SHWE LIN BAN SETHMU MYO, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 249,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Shiv Kumar Dhanuka",
    "Name of Principal Organization": "Sudima International PTE LTD. ",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar": "Myanmar Veneer& Plywood PVT., LTD.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "653/2013",
    "Permit Date": "2013-12-27T00:00:00Z",
    "Meeting Number": "31/2013",
    "Meeting Date": "2013-12-04T11:04:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing  and  Marketing  of  Veneer,  Swan Timber and Plywood \n",
    "Amount Of Foreign Capital USD (in Millions)": 9.7,
    "Total Amount Of Capital (in Millions)": 9.7,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaw Lwin ",
    "Land Area (units not specified in file)": 10,
    "Lease Term": 30,
    "Annual Lease Fee": 0.04,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": 37,
    Status: "Rejected",
    "Investor Address": "7 Bright Street, Flat No.1 E, Kolkata-700019",
    "Organization Address":
      "151 Chin Swee road, # 09-08 Mangattan House 169876",
    "Investment Permitted Address":
      "Holding No.Zamyinzwe-4/Kagyi, Zamyinzwe-4/Khakway and Zamyinzwe-4/Gagyi, Plot No.783/Taung Nyo-West, Padamyar Ward, Sagaing",
  },
  {
    ID: 253,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးသန်းဝင်း​ဆွေ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "International Group of Entrepreneur Services Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "910/2013",
    "Permit Date": "2013-05-14T00:00:00Z",
    "Meeting Number": "14/2013",
    "Meeting Date": "2013-05-10T07:45:59Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "B. O.T စနစ်ဖြင့် မြေငှားရမ်း၍ စက်သုံးဆီ တင်/ချ ဆိပ်ခံတံတား နှင့် ဆီသိုလှောင်ကန်များ တည်​ဆောက်ပြီး စက်သုံးဆီသိုလှောင် ဖြန့်ဖြူးသည့် ဝန်ဆောင်မှု လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 2.01,
    "Total Amount Of Capital (in Millions)": 5990.55,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "မြန်မာ့ဆိပ်ကမ်းအာဏာပိုင် ",
    "Land Area (units not specified in file)": 24.71,
    "Lease Term": 30,
    "Annual Lease Fee": 190.116,
    "Land Use Premium": 370.65,
    "Number Of Local Employees": 130,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address": "အမှတ်-၅၆/၆၁၊ ဗိုလ်မင်းရောင်လမ်း၊ ၄၀ ရပ်ကွက်",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၃၁၊ ၃၂ (ဘီ)၊ သီလဝါဆိပ်ကမ်းဒေသ၊ သန်လျင်-ကျောက်တန်းနယ်မြေ၊ မြန်မာ့ဆိပ်ကမ်းအာဏာပိုင် မြေ (၂၄.၇၁) ဧက",
  },
  {
    ID: 257,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်သက်မန်း",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Elite Petrochemical Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "879/2013",
    "Permit Date": "2013-01-16T00:00:00Z",
    "Meeting Number": "3/2013",
    "Meeting Date": "2013-01-16T06:54:24Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "BOTစနစ်ဖြင့် မြေငှားရမ်း၍ စက်သုံးဆီ တင်/ချ ဆိပ်ခံတံတားနှင့် ဆီသိုလှောင်ကန်များ တည်ဆောက်ပြီး စက်သုံးဆီသိုလှောင်သည့် ဝန်ဆောင်မှု လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 24,
    "Total Amount Of Capital (in Millions)": 30332.4,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "မြန်မာ့ဆိပ်ကမ်းအာဏာပိုင်",
    "Land Area (units not specified in file)": 49.42,
    "Lease Term": 30,
    "Annual Lease Fee": 367.713,
    "Land Use Premium": 741.3,
    "Number Of Local Employees": 135,
    "Number Of Foreign Employees": 1,
    Status: "Approved",
    "Investor Address":
      "အမှတ်-၁၀၃/၇၊ အော​င်မြေသာလမ်း​၊  ရေွှ​တောင်ကြား-၂ ရပ်ကွက်",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၅/၁၆(အေ၊ဘီ)၊ သီလဝါဆိပ်ကမ်းဒေသ၊ သန်လျင်-ကျောက်တန်းနယ်မြေ  မြန်မာ့ဆိပ်ကမ်းအာဏာပိုင်​မြေ",
  },
  {
    ID: 261,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Aung Gyi ",
    "Name of Principal Organization": "Aung Engineering CO., Ltd ",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Hanro KM ( Myanmar)  Co., Ltd",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "742/2014",
    "Permit Date": "2014-04-07T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production, Packaging and Marketing of Lubricants",
    "Amount Of Foreign Capital USD (in Millions)": 0.735,
    "Total Amount Of Capital (in Millions)": 0.735,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "U Aung Gyi ",
    "Land Area (units not specified in file)": 0.156,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 52,
    "Number Of Foreign Employees": 2,
    Status: "Draft",
    "Investor Address": "No.29, Aung  Zaya Street, ",
    "Organization Address":
      "No.B-302, Dagon Center, Corner of Bagayar and Pyay Road ",
    "Investment Permitted Address":
      "Plot No.B-32,33,34, U Wisara Road, North Dagon Industrial Zone",
  },
  {
    ID: 264,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chang, Ta-wei",
    "Name of Principal Organization": "Star Dragon Enterprise Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Star Dragon ( Myanmar) Enterprise Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "893/2015",
    "Permit Date": "2015-01-21T00:00:00Z",
    "Meeting Number": "29/2014",
    "Meeting Date": "2014-12-26T04:01:39Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Garment, Embroidery Fabric And Garment Accessories on CMP Basis ( Factory -1)",
    "Amount Of Foreign Capital USD (in Millions)": 2.351,
    "Total Amount Of Capital (in Millions)": 2.351,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Hla Hla Yin",
    "Land Area (units not specified in file)": 1.158,
    "Lease Term": 30,
    "Annual Lease Fee": 0.23,
    "Land Use Premium": null,
    "Number Of Local Employees": 800,
    "Number Of Foreign Employees": 22,
    Status: "Amend",
    "Investor Address":
      "18/F, Ginza Square, 565-567 Nathan Road, Mongkok , Kowloon, Hong Kong\n",
    "Organization Address":
      "Universal International Development Limited, Golden Center 188 Des Voeux Road, Flat/ Rm 1201-12/F, Central, Hong Kong.",
    "Investment Permitted Address":
      "Polt No.179,180, Myay Taing Block No-5- Extension , Industrial Zone (5), Hlaing Tharyar Township, Yangon",
  },
  {
    ID: 267,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. HOI YIN LAU",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "#ERROR!",
    "Company Name In Myanmar": "OCEAN MUSE FISHERIES LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1191/2016",
    "Permit Date": "2016-11-11T00:00:00Z",
    "Meeting Number": "1191/2016",
    "Meeting Date": "2016-11-01T03:56:55Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "PROCESSING, DRYING, FREEZING, ALUMINIUM FOIL PACKING, PACKAGING AND MARKETING OF AQUATIC PRODUCTS UNDER NORMAL SYSTEM AND CONTRACT PROCESSING SYSTEM",
    "Amount Of Foreign Capital USD (in Millions)": 0.56,
    "Total Amount Of Capital (in Millions)": 0.586,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Ko Ko Zaw",
    "Land Area (units not specified in file)": 0.927,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 72,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address":
      "ROOM-1501, 15/F, BLK B, WAH TAT IND CTR, 8-10 WAH SING ST, KWAI CHUNG, N.T, HONG KONG",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 135, MYAY TAING BLOCK NO.25, SHWE LIN BAN INDUSTRIAL ZONE, HLAING THARYAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 269,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်သန်း",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Global Electirc Technology Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "845/2012",
    "Permit Date": "2012-05-09T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီ ထရန်စဖော်မာ အပိုပစ်စည်းထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.16,
    "Total Amount Of Capital (in Millions)": 214.21,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address": "အမှတ်-၈၁၊ ရေွှနှင်းဆီလမ်း၊ ၅ ရပ်ကွက်၊ ၈ မိုင်ခွဲ၊ ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၂၃၅၊ ကနောင်မင်းသာကြီးလမ်း၊ စက်မှုဖုန် ၂",
  },
  {
    ID: 270,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Theim Wai @ Mr. Serge Pun",
    "Name of Principal Organization": "First Myanmar Investment Co., Ltd. ",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Yoma Siloam Hospital Pun Hlaing Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "923/2015",
    "Permit Date": "2015-04-07T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Other Services",
    "Type Of Investment Business":
      "International Standard Hospital Diagnosia Center, Clinic and Health Care Services",
    "Amount Of Foreign Capital USD (in Millions)": 0.59,
    "Total Amount Of Capital (in Millions)": 13.19,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Indonesia",
    "Form Of Investment": "JV",
    "Land Owner": "Pun Hlaing International Hospital Ltd.",
    "Land Area (units not specified in file)": 22185.25,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 338,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "FMI Centre, Level 10 & 11, No. 380, Bogyoke Aung San Road,",
    "Organization Address":
      "FMI Centre, Level 10 & 11, No. 380, Bogyoke Aung San Road,",
    "Investment Permitted Address":
      "Pun Hlaing Golf Estate Avenue Myay Taing Block No. 12, Plot No.49, ",
  },
  {
    ID: 272,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. GUAN YUKUN",
    "Name of Principal Organization": "UREC ENERGY INTERNATIONAL CO., LTD. ",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "U ENERGY THAKETA POWER COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1157/2016",
    "Permit Date": "2016-09-19T00:00:00Z",
    "Meeting Number": "17/2016",
    "Meeting Date": "2016-09-09T02:31:58Z",
    Sector: "Power",
    "Type Of Investment Business":
      "CONSTRUCTION OF 106 MW GAS FIRED COMBINED CYCLE POWER PLANT FOR ELECTRICITY GENERATION AND POWER SUPPLY ",
    "Amount Of Foreign Capital USD (in Millions)": 125.672,
    "Total Amount Of Capital (in Millions)": 125.672,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "DEPARTMENT OF ELECTRICITY POWER PLANNING ",
    "Land Area (units not specified in file)": 10.12,
    "Lease Term": 30,
    "Annual Lease Fee": 40976,
    "Land Use Premium": null,
    "Number Of Local Employees": 25,
    "Number Of Foreign Employees": 35,
    Status: "Monitoring Approved",
    "Investor Address":
      "175 # BEIJING RD, YUNNAN FOREIGN TRADE BUILDING KUNMING, YUNNAN, CHINA",
    "Organization Address":
      "UNIT C, 16th FL, CNT TOWER, 338 HENNERSSY ROAD , WANCHAI, HONG KONG",
    "Investment Permitted Address":
      "THAKETA POWER PLANT COMPOUND, THAKETA TOWNSHIP, YANGON REGION",
  },
  {
    ID: 277,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U MaungTee   (a)    U  Aung  Than ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Family    Business   Group   Hotel  Limited ",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "Manatha 1086/2015",
    "Permit Date": "2015-09-21T05:13:26Z",
    "Meeting Number": "16/2015",
    "Meeting Date": "2015-09-11T08:30:15Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "ဟိုတယ်ဝန်ဆောင်မှုလုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": 11.36,
    "Total Amount Of Capital (in Millions)": 56000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 1.235,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 350,
    "Number Of Foreign Employees": 5,
    Status: "Approved",
    "Investor Address": "စ/သုမင်္ဂလာရပ်ကွက် ",
    "Organization Address": " -",
    "Investment Permitted Address":
      "No.(8), U Tun Myat Street,Natmauk Quarter, Tamwe, YANGON",
  },
  {
    ID: 278,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LIU ZHIYING",
    "Name of Principal Organization":
      "Shandong Shenda Coating Material Co., Ltd.",
    "Place of Incorporation": "China",
    "Company Name In Myanmar":
      "Myanmar Wantong Construction MA Terials Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "946/2015",
    "Permit Date": "2015-05-07T08:27:49Z",
    "Meeting Number": "5/2015",
    "Meeting Date": "2015-03-20T08:02:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Colour Steel Tile, Galvinized Watts, Galvanized Steel Pipe and Rectangular and Square Tubes",
    "Amount Of Foreign Capital USD (in Millions)": 5.01,
    "Total Amount Of Capital (in Millions)": 5.019,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Tin Latt",
    "Land Area (units not specified in file)": 3.829,
    "Lease Term": 15,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address": "Geng Village, ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No. 4,5, Myat Taing Block No.108 B, Industrial Zone",
  },
  {
    ID: 280,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Ein Yar ",
    "Name of Principal Organization":
      "Myay Latt Thar General Trading Co-op Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Paragon Myay Latt Thar Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1049/2015",
    "Permit Date": "2015-12-01T00:00:00Z",
    "Meeting Number": "20/2015",
    "Meeting Date": "2015-11-13T06:44:56Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Roasted Sesame Oil and Huskless Sesame Seeds",
    "Amount Of Foreign Capital USD (in Millions)": 2.94,
    "Total Amount Of Capital (in Millions)": 6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "JV",
    "Land Owner": "U Bo Aung",
    "Land Area (units not specified in file)": 3.55,
    "Lease Term": 30,
    "Annual Lease Fee": 5,
    "Land Use Premium": null,
    "Number Of Local Employees": 200,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address": "No.82, Padauk Road, Aye yeik Mon Housing ",
    "Organization Address": "Nwar Guu Village, Magway taung Dwingyi Road",
    "Investment Permitted Address":
      "Holding No. 129/2 and 130, Kwin No 1646 Nwar Guu Myauk, Sartinekan Village Tract ",
  },
  {
    ID: 284,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Rajiv Kumar Nemani",
    "Name of Principal Organization": "Nemani Plywood Private Ltd.",
    "Place of Incorporation": "India",
    "Company Name In Myanmar": "New Bamaw Timber Products Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1108/2016",
    "Permit Date": "2016-03-26T00:00:00Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T03:30:52Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Plywood, Face Veneer, Core Venner, Sawn Timber and Furniture  Products",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "India",
    "Form Of Investment": "FDII",
    "Land Owner":
      "Daw Ni Ni Htwe and Daw Aye Aye Mu (Maya Kwat No. 43) \nU Tin Aung Late (Maya Kwat No.44)",
    "Land Area (units not specified in file)": 3.541,
    "Lease Term": 30,
    "Annual Lease Fee": 0.84,
    "Land Use Premium": null,
    "Number Of Local Employees": 355,
    "Number Of Foreign Employees": 25,
    Status: "Terminated",
    "Investor Address":
      "5 East Avas Vikas Colony Post-Betiahata, Gorakhpur, Pin 273001",
    "Organization Address": "Al-10 Sector 13 Gida",
    "Investment Permitted Address":
      "Plot No. 43 and 44 Block No.64-Sethmu, Industrial Zone -3, ",
  },
  {
    ID: 291,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Tint Naing Tun",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Meik Ta Aung Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "Ma Na Tha-1229/2016",
    "Permit Date": "2016-12-23T00:00:00Z",
    "Meeting Number": "23/2016",
    "Meeting Date": "2016-12-17T02:43:42Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP System Jacket, Shirt, Polo-Shirt and Pants Producting",
    "Amount Of Foreign Capital USD (in Millions)": 0.41,
    "Total Amount Of Capital (in Millions)": 1116.17,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Tint Naing Tun,Daw Aye Myat Myat Khaing",
    "Land Area (units not specified in file)": 2.341,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 500,
    "Number Of Foreign Employees": 0,
    Status: "Submitted",
    "Investor Address":
      "Bulding (5), Room(10), 3 Floor, Rose Road, Tharyar Kone Quarter, Mingalar Taung Nyunt Township, Yangon",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Myay Kwat No.53, Myay Taing Block No.144, Industrial Zone, Dagon New City ( South) Township, Yangon Myay Area 2.341 Acres",
  },
  {
    ID: 296,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Moe Moe",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Capital Development Limited (မြို့တော်ဖွံ့ဖြိုးတိုးတက်ရေး လီမိတက်)",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1117/2016",
    "Permit Date": "2016-01-26T00:00:00Z",
    "Meeting Number": "1117/2016",
    "Meeting Date": "2016-01-01T06:00:14Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "စားသောက်ကုန်များ၊ စိုက်ပျိုးရေးအခြေခံသစ်သီးဝလံနှင့် ဟင်းသီးဟင်းရွက်များအား သန့်စင်ခြင်း၊ ပြုပြင်ထုပ်ပိုးခြင်း၊ ရောင်းချခြင်း၊ သိုလှောင်ခြင်းနှင့် ငှားရမ်းခြင်း ဝန်ဆောင်မှု လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 2.347,
    "Total Amount Of Capital (in Millions)": 9660.992,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "စက်မှုသီးနှံဖွံ့ဖြိုးရေးဦးစီးဌာန၊ ဆည်မြောင်းဝန်ကြီးဌာန",
    "Land Area (units not specified in file)": 39.839,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 563,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address":
      "အမှတ်-၁၂၆၊ ကမ္ဘာအေးဘုရားလမ်း၊ ဆရာစံရပ်ကွက်၊ ဗဟန်းမြို့နယ်, ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေတိုင်းရပ်ကွက်အမှတ်-၂၊ မြေကွက်အမှတ်- ၂၅+ ၂၅E +၂၅F၊ ၆A၊ ၆H၊ ၄၃၁၊ ၂၅A၊ ၂၅B၊ ၂၅C၊ ၂၅D၊ ၄၁၊ ၄၊ ၇ ၊ မင်းနန္ဒာလမ်း၊ နွယ်အေးရပ်ကွက်၊ ဒေါ်ပုံမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီးရှိ မြေဧရိယာ ၃၉.၈၃၉ ဧက",
  },
  {
    ID: 297,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမျိုးတင်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "NGWE SAUNG YACHT CLUB & MARINA DEVELOPMENT LIMITED",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "Manatha 947/2014",
    "Permit Date": "2014-01-10T04:19:27Z",
    "Meeting Number": "32/2013",
    "Meeting Date": "2013-12-19T04:21:21Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "B.O.T စနစ်ဖြင့် ဟိုတယ်ဝန်ဆောင်မှု လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 15001.15,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "အားကစားဝန်ကြီးဌာန၊ အားကစားနှင့် ကာယပညာဦးစီးဌာနပိုင်",
    "Land Area (units not specified in file)": 9.64,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": 9.64,
    "Number Of Local Employees": 140,
    "Number Of Foreign Employees": 8,
    Status: "Approved",
    "Investor Address": "အမှတ်-၂၂၃-ဘီ၊ ရေွှဂုံတိုင်လမ်း၊ ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No.(623), Pyay Road, University P.O, Kamayut, YANGON",
  },
  {
    ID: 306,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကျော်သူ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "The Myth Apparal Myanmar Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "844/2012",
    "Permit Date": "2012-05-09T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 201.61,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address":
      "တိုက်အမှတ်-၂၆(အေ)၊ အခန်း-၁၉၊ နဝဒေးလမ်း၊ယောမင်းကြီးရပ်ကွက်",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၂၀၊ ရေွှဘိုလမ်း၊ စက်မှုဇုန်အပိုင်း-၇ ",
  },
  {
    ID: 307,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. CHI YAM CYRUS PUN",
    "Name of Principal Organization": "YOMA DEVELOPMENT GROUP PTE LTD",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar": "PUN HLAING LODGE HOTEL MANAGEMENT LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1143/2016",
    "Permit Date": "2016-08-31T00:00:00Z",
    "Meeting Number": "15/2016",
    "Meeting Date": "2016-08-19T08:25:28Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "FIVE STAR HOTEL SERVICES",
    "Amount Of Foreign Capital USD (in Millions)": 19,
    "Total Amount Of Capital (in Millions)": 19,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "PAN HLAING LODGE LIMITED",
    "Land Area (units not specified in file)": 2.196,
    "Lease Term": 50,
    "Annual Lease Fee": 0.06,
    "Land Use Premium": null,
    "Number Of Local Employees": 90,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address": "3/F 620 KING'S ROAD, NORTH POINT, HONG KONG",
    "Organization Address": "78 SHENT ON WAY | 32-00 SINGAPORE 079120",
    "Investment Permitted Address":
      "MYAY TAING BLOCK NO. 12, PLOT- 121 (B), PUN HLAING GOLF ESTATE AVENUE, HLAING THARYAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 308,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Chang, Ta-Wei",
    "Name of Principal Organization": "Star Dragon Enterprise Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Star Dragon ( Myanmar) Enterprise Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "894/2015",
    "Permit Date": "2015-01-21T00:00:00Z",
    "Meeting Number": "29/2014",
    "Meeting Date": "2014-12-26T04:32:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Garment, Embroidery Fabric and Garment Accessories on CMP Basis ( Factory -2)",
    "Amount Of Foreign Capital USD (in Millions)": 2.298,
    "Total Amount Of Capital (in Millions)": 2.298,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Hla Hla Yin",
    "Land Area (units not specified in file)": 1.377,
    "Lease Term": 30,
    "Annual Lease Fee": 0.028,
    "Land Use Premium": null,
    "Number Of Local Employees": 900,
    "Number Of Foreign Employees": 20,
    Status: "Amend",
    "Investor Address":
      "18/F, Ginza Square, 565-567 Nathan Road, Mongkok Kowloon , Hong Kong",
    "Organization Address":
      "Universal International Development Limited, Golden Center 188 Des Voeux Road, Flat/Rm 1201-12/F, Central, Hongkong",
    "Investment Permitted Address":
      "Plot No.152, Myay Taing Block No 18, Industrial Zone (5), Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 311,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Lu Yeo Lee",
    "Name of Principal Organization": "Spacious Global Company Limited",
    "Place of Incorporation": "Brunei Darussalam",
    "Company Name In Myanmar": "SG Crabs World Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "884/2015",
    "Permit Date": "2015-01-02T00:00:00Z",
    "Meeting Number": "28/2014",
    "Meeting Date": "2014-12-12T06:59:12Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "Breeding, Processing And Manufacturing of Value- Added Products ( VAP) And Contract Processing ( CP) of Soft Shekk Crabs",
    "Amount Of Foreign Capital USD (in Millions)": 2.597,
    "Total Amount Of Capital (in Millions)": 2880,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Brunei Darussalam",
    "Form Of Investment": "JV",
    "Land Owner": "Crabs World Induatrials Company Limited",
    "Land Area (units not specified in file)": 275.86,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 1050,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.116, Chonged 20th Street, Tainan City , Taiwan , R. O .C",
    "Organization Address":
      "Room 51, 5 th Floor , Britannia House, Jalan Cator Bandar Seri Begawan Bs 8811, Negara Brunei Darussalam",
    "Investment Permitted Address":
      "Kwin No.612,613,/KA,618/ KA, Gway Pin Kwin , West SeikGyi Kwin, Kayat Kwin, Holding No7,3,2,6,1,1,2, Kyauk Tan Aquacukture Zone, Thidamyaing Village Tract, Kyauk Tan Township , Yangon Region",
  },
  {
    ID: 312,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Nay Lin Htun",
    "Name of Principal Organization": "Ever Smart Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Smart Concrete Products Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "950/2015",
    "Permit Date": "2015-05-07T00:00:00Z",
    "Meeting Number": "6/2015",
    "Meeting Date": "2015-04-03T09:21:28Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Sales of Smart Wall Concrete Panels",
    "Amount Of Foreign Capital USD (in Millions)": 1.02,
    "Total Amount Of Capital (in Millions)": 3.4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Thida Tin",
    "Land Area (units not specified in file)": 4,
    "Lease Term": 10,
    "Annual Lease Fee": 0.09,
    "Land Use Premium": null,
    "Number Of Local Employees": 32,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 237, THIRI HAY MAR(WEST), CHANG  AYE THARZAN  TOWNSHIP,  MANDALAY",
    "Organization Address":
      "No.171,172,  R-2  STREET,  MINGALARDON  GARDEN  CITY, MINGALARDON  TOWNSHIP,  YANGON",
    "Investment Permitted Address":
      "PLOT N0. 172/173, YANGON INDUSTRIAL  ZONE,  MINGALARDON TOWNSHIP,  YANGON  REGION",
  },
  {
    ID: 321,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Khun Naung Myint Wai",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Wa Min Group of Companies Co.,Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "977/2014",
    "Permit Date": "2014-04-29T00:00:00Z",
    "Meeting Number": "10/2014",
    "Meeting Date": "2014-03-19T09:35:11Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Waste Water Treatment Unit တပ်ဆင်ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 231.8,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "စက်မှုဝန်ကြီးဌာန",
    "Land Area (units not specified in file)": 6.15,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Submitted",
    "Investor Address":
      "အမှတ် (၆၆၉/စီ)၊ မြကန်သာလမ်း၊ ကမာရွတ်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "-",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး ၊ မရမ်းကုန်းမြို့နယ်၊ အမှတ်(၂)ရပ်ကွက်၊ သမိုင်းဘူတာရုံလမ်း၊ အမှတ်(၁၁၆) ၊ စက်မှုဝန်ကြီးဌာနပိုင် ကြွေရည်စိမ်ပစ္စည်းစက်ရုံ (မရမ်းကုန်း)၊",
  },
  {
    ID: 325,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Liu Xianmin",
    "Name of Principal Organization": "DJF INTERNATIONAL TRADE LIMITED",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "DJY KNITTING (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1153/2016",
    "Permit Date": "2016-09-16T00:00:00Z",
    "Meeting Number": "17/2016",
    "Meeting Date": "2016-09-09T05:22:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF SOCKS, HOSIERIES, FOOT COVER AND TROUSERS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 3.61,
    "Total Amount Of Capital (in Millions)": 3.8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "DAW Yin Lee Yint @ Li Li San ",
    "Land Area (units not specified in file)": 1.88,
    "Lease Term": 10,
    "Annual Lease Fee": 0.036,
    "Land Use Premium": null,
    "Number Of Local Employees": 580,
    "Number Of Foreign Employees": 12,
    Status: "Monitoring Approved",
    "Investor Address":
      "RM 404, BLDG 3, AOSHENG GARDEN, HAINING CITY, ZHENJIANG PROVINCE, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address":
      "FLAT/ RM 905, WORKINGBERG COMM BLDG, 41-47 MARBLE RD, HONG KONG",
    "Investment Permitted Address":
      "PLOT NO.8, MYAY TAING BLOCK NO.3, INDUSTRIAL ZONE, HLAING THARYAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 329,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Sai Yu Wai",
    "Name of Principal Organization": "Globus Chemical Industry Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Globus Carpoly Chemical Industry Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1008/2015",
    "Permit Date": "2015-09-05T00:00:00Z",
    "Meeting Number": "15/2015",
    "Meeting Date": "2015-08-21T09:48:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of All Kinds of Paint",
    "Amount Of Foreign Capital USD (in Millions)": 0.68,
    "Total Amount Of Capital (in Millions)": 3.4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 35,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "U Li Myint",
    "Land Area (units not specified in file)": 0.66,
    "Lease Term": 15,
    "Annual Lease Fee": 0.014,
    "Land Use Premium": null,
    "Number Of Local Employees": 150,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "BLOCK NO. 784, PADAMYAR WARD, PADAMYAR INDUSTRIAL ZONE, SAGAING TOWNSHIP, SAGAING REGION    ",
    "Organization Address":
      "PLOT NO. 150, YANGON INDUSTRIAL ZONE, NORTH OKKALAPA TOWNSHIP, YANGON REGION  ",
    "Investment Permitted Address":
      "PLOT NO. 150, YANGON INDUSTRIAL ZONE, NORTH OKKALAPA TOWNSHIP, YANGON REGION ",
  },
  {
    ID: 331,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mrs. Yin Yin Aye",
    "Name of Principal Organization": "TYTC Waste Equipment Pty Ltd.",
    "Place of Incorporation": "Australia",
    "Company Name In Myanmar": "TYTC Services Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "980/2015",
    "Permit Date": "2015-07-10T06:59:30Z",
    "Meeting Number": "10/2015",
    "Meeting Date": "2015-06-05T03:47:04Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Waste Collection Bins Plastic Products and Appliances",
    "Amount Of Foreign Capital USD (in Millions)": 2.99,
    "Total Amount Of Capital (in Millions)": 2.993,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Australia",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Aye Myint ",
    "Land Area (units not specified in file)": 1.51,
    "Lease Term": 10,
    "Annual Lease Fee": 0.03,
    "Land Use Premium": null,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Amend",
    "Investor Address": "No.20, Ritchie Street, Rosehill, NSW 2142, Australia",
    "Organization Address":
      "Po Box 465 Granville NsW 2142 Australia, No.20-22, Plasser Crescent, North ST Marys, NSW 2706, Australia",
    "Investment Permitted Address":
      "Plot No. 381, Myay taing Block No.25, Shwe Lin Pan Industrial Zone, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 333,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်မြင့်မြင့်ဝင်း",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Than Lwin Aye Yar Industrial Production & Construction Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "852/2012",
    "Permit Date": "2012-07-11T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "အချိုရည်ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.45,
    "Total Amount Of Capital (in Millions)": 8533.13,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address": "အမှတ်-၁၂၆-A၊ လမ်း၂၀ ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "​မြေကွက်အမှတ်-၆၃၊ မြေတိုင်းရပ်ကွက်အမှတ်-၁၄၊ ရေွှသံလွင် စက်မှုဇုန်",
  },
  {
    ID: 334,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Luo Xindong",
    "Name of Principal Organization": "UNI Global Power Investment Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar":
      "Southern Metal Industrial Real Estate Development Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1093/2016",
    "Permit Date": "2016-03-09T00:00:00Z",
    "Meeting Number": "5/2016",
    "Meeting Date": "2016-02-15T07:24:06Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Construction, leasing and Management of Commercial and Residential Buildings",
    "Amount Of Foreign Capital USD (in Millions)": 76.95,
    "Total Amount Of Capital (in Millions)": 135,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 4,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Southern Metal Industrial Co., Ltd.",
    "Land Area (units not specified in file)": 10,
    "Lease Term": 0,
    "Annual Lease Fee": 214438,
    "Land Use Premium": null,
    "Number Of Local Employees": 190,
    "Number Of Foreign Employees": 7,
    Status: "Monitoring Approved",
    "Investor Address": "2-7-301, Yindu Garden, No.8, Xinguang Road",
    "Organization Address": "3 Shention Way, 25-05, Shenton House",
    "Investment Permitted Address":
      "Plot No. 2-B, Myay Taing Block No.7/A, Between Bayintnaung Bridge and Aung Zeya Bridge",
  },
  {
    ID: 337,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MRS. SHEN YAN ",
    "Name of Principal Organization": "OUMI TRADE (SINGAPORE) PTE., LTD.",
    "Place of Incorporation": "REPUBLIC OF SINGAPORE",
    "Company Name In Myanmar": "OUMI FASHION (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1168/2016",
    "Permit Date": "2016-10-13T00:00:00Z",
    "Meeting Number": "18/2016",
    "Meeting Date": "2016-09-23T07:37:55Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING ON GARMENTS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 12,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW MYINT MYINT THAN",
    "Land Area (units not specified in file)": 0.999,
    "Lease Term": 12,
    "Annual Lease Fee": 0.022,
    "Land Use Premium": null,
    "Number Of Local Employees": 515,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address":
      "BLK: 12, L IAN HUA YUAN # 103, CONG CHUAN DISTRICT, NAN TONG, JIANG SU, PEOPLE'S REPUBLIC OF CHINA ",
    "Organization Address":
      "61, UBI ROAD 1 # 01-18 OXLEY BIZHUB, SINGAPORE  408727",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၅၃၊ ဦးထွန်းညိုလမ်း၊    လှိုင်သာယာစက်မှုဇုန်(၁)၊ စက်မှုဇုန်၊လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 339,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးချစ်ညီညီ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Tough Way Garment Manufacturing Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "861/2012",
    "Permit Date": "2012-09-27T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အထည်အမျိုးမျိုး ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 80.63,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address": "အမှတ်-၂၉/၃၉၉၊ ဗိုလ်ချုပ်အောင်ဆန်းလမ်း၊ ၂ ရပ်ကွက်၊ ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၅၂/က၊ခ၊ မြေတိုင်းရပ်ကွက်အမျတ်-၄၂၊ ကနောင်မင်းသားကြိးလမ်း၊ ",
  },
  {
    ID: 341,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Myint Oo",
    "Name of Principal Organization": "M.K Co., Ltd",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Dutch Mill(Myanmar) Dairy Co., Ltd ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "725/2014",
    "Permit Date": "2017-07-18T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Sales of UHT(Ultra-High-Temperature)and Pasteurized Milk",
    "Amount Of Foreign Capital USD (in Millions)": 0.905,
    "Total Amount Of Capital (in Millions)": 0.905,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 3,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Tin Tin Htay ",
    "Land Area (units not specified in file)": 0.358,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 11,
    "Number Of Foreign Employees": 4,
    Status: "Submitted",
    "Investor Address": "No.50, Yankin Street",
    "Organization Address": "No 333, Pyay Road",
    "Investment Permitted Address":
      "Plot No.4/229, No.312, Kar Ya 11 Street, Kar Ya Ward, ",
  },
  {
    ID: 342,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyan Khinn",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "MSL Industries Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "MaNaTha-1205/2016",
    "Permit Date": "2016-08-31T00:00:00Z",
    "Meeting Number": "Ma Na Tha-1205/2016",
    "Meeting Date": "2016-08-01T16:21:39Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "BOT System Warehouse ( Cold & Dry) Bulding and Goods Deliever Services",
    "Amount Of Foreign Capital USD (in Millions)": 0.315,
    "Total Amount Of Capital (in Millions)": 1132.54,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT",
    "Land Owner": "Fishing Daperment",
    "Land Area (units not specified in file)": 1.9,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 43,
    "Number Of Foreign Employees": 1,
    Status: "Draft",
    "Investor Address":
      "No-284/286, Room No-5, Shwedagon Pagoda Road, Yaw Mingyi Ward, Dagon Township, Yangon",
    "Organization Address": "-",
    "Investment Permitted Address": "-",
  },
  {
    ID: 343,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.  Toru Fukamatsu",
    "Name of Principal Organization": "Fukamatsugumi Co., Ltd.",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Fukamatsugumi Myanmar Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1037/2015",
    "Permit Date": "2015-11-11T00:00:00Z",
    "Meeting Number": "18/2015",
    "Meeting Date": "2015-10-23T04:08:20Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Construction, Leasing and Management of Office and Serviced Apartment",
    "Amount Of Foreign Capital USD (in Millions)": 6.497,
    "Total Amount Of Capital (in Millions)": 6.768,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Mya Kyi",
    "Land Area (units not specified in file)": 0.252,
    "Lease Term": 25,
    "Annual Lease Fee": 0.18,
    "Land Use Premium": null,
    "Number Of Local Employees": 30,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address": "3-15-1021, Syouwamachi,  Aoba-Ku, sendai shi, Miyagi",
    "Organization Address":
      "1-2-15, Kitayama, Aoba-Ku,  sendai shi, Miyagi,981-0931, Japan",
    "Investment Permitted Address":
      "Myay Taing Block No.35B, Plot No. 16-D/3 0 1 +16D/3P2, New University Avenue Road, Sayasan Ward, Bahan T/s, Yangon Region",
  },
  {
    ID: 351,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. THOMAS JOSEPH LIM KIM GUAN (LIN QINYUAN)",
    "Name of Principal Organization": "WILMAR INVESTMENT HOLDINGS PTE. LTD., ",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar": "WILMAR MYANMAR FLOUR MILLS LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1264/2017",
    "Permit Date": "2017-04-11T00:00:00Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T07:57:45Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND SALES OF FLOUR PRODUCTS AND BY-PRODUCTS OF FLOUR",
    "Amount Of Foreign Capital USD (in Millions)": 7.56,
    "Total Amount Of Capital (in Millions)": 31.495,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 25,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "WILMAR MYANMAR PORT TERMINALS (THILAWA) LIMITED",
    "Land Area (units not specified in file)": 7.413,
    "Lease Term": 50,
    "Annual Lease Fee": 0.15,
    "Land Use Premium": null,
    "Number Of Local Employees": 138,
    "Number Of Foreign Employees": 7,
    Status: "Monitoring Approved",
    "Investor Address": "56 NEIL ROAD, SINGAPORE 088830",
    "Organization Address": "56 NEIL ROAD, SINGAPORE 088830",
    "Investment Permitted Address":
      "PLOT NO. 20&21 AND THE PARCEL OF LAND ADJOINING PLOT NO. 20 AND 211, THILAWA PORT AREA, KYAUKTAN TOWNSHIP, YANGON REGION",
  },
  {
    ID: 353,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Tin Aung ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Info 9 Co.,Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "983/2014",
    "Permit Date": "2014-05-28T00:00:00Z",
    "Meeting Number": "14/2014",
    "Meeting Date": "2014-05-14T09:44:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာ စံချိန်မီ ရုပ်/သံ ပါသောDVD 9 Disc  နှင့်Audio CD များ ထုတ်လုပ်ခြင်း နှင့် ကူးယူခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1450,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးခင်မောင်စန်း",
    "Land Area (units not specified in file)": 2.42,
    "Lease Term": 10,
    "Annual Lease Fee": 0.0015,
    "Land Use Premium": null,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Submitted",
    "Investor Address":
      "အခန်း (၄၁၀ ) ၊ တာဝါ-ဘီ၊ နှင်းဆီလမ်း၊ဟိုင်း​ေး ကွန်ပလက် (စ်) ၊ (၆) ရပ်ကွက်၊ ကမာရွတ်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး ၊ လှိုင်သာယာစက်မှုဇုန် ၊ မြေတိုင်းရပ်ကွက်အမှတ် အပိုင်း-၂ ၊မြေကွက်အမှတ် (၂၄၆-M) ",
  },
  {
    ID: 356,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mrs. Wu Qi",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar Longsheng Fashion Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1031/2015",
    "Permit Date": "2015-11-11T00:00:00Z",
    "Meeting Number": "18/2015",
    "Meeting Date": "2015-10-23T10:08:59Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.423,
    "Total Amount Of Capital (in Millions)": 1.423,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Than, U Aung Myint",
    "Land Area (units not specified in file)": 1.484,
    "Lease Term": 20,
    "Annual Lease Fee": 0.42,
    "Land Use Premium": null,
    "Number Of Local Employees": 800,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address": "19F, Dhengda Building, No 71, Renmin road",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No. 218, Myay Taing Block No. Industrial zone 2, Myinwon U Aung Thu Road, Hlaing Thar  Township, Yangon Region ",
  },
  {
    ID: 364,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Myo Myat",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar Consumer Enterprise Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "MaNaTha-1134/2016",
    "Permit Date": "2016-02-29T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Detergent and Detergent liquid Production and Selling",
    "Amount Of Foreign Capital USD (in Millions)": 0.15,
    "Total Amount Of Capital (in Millions)": 2780.79,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Aung Myo Myat",
    "Land Area (units not specified in file)": 2.023,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 334,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address":
      "No-22, Thiri Yatanar Housing, Wazayantar Road, Michaung Kan,  Part-3 Quarter,  Thin Gan Kyun  Township, Yangon",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Yangon, Dagon Seikkan Township, Myay Taing Blotch No- Industrial Zone, Myay Kwat No-129 Myay Area (2.023) Acres",
  },
  {
    ID: 368,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. WANG RUJUN",
    "Name of Principal Organization": "EVERGREEN SPORTS LIMITED.",
    "Place of Incorporation": "HONG KONG",
    "Company Name In Myanmar": "EVERGREEN SPORTS MYANMAR LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1256/2017",
    "Permit Date": "2017-04-11T00:00:00Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T08:20:41Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF ALL KINDS OF BAG ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 4.5,
    "Total Amount Of Capital (in Millions)": 4.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U SAI KYIN",
    "Land Area (units not specified in file)": 2.605,
    "Lease Term": 20,
    "Annual Lease Fee": 0.052,
    "Land Use Premium": null,
    "Number Of Local Employees": 790,
    "Number Of Foreign Employees": 4,
    Status: "Approved",
    "Investor Address":
      "NO. 10, 5th LANE, HONG YU 2nd STREET, GUAN CHENG ZONE, DONG GUAN, GWANG DONG, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address":
      "UNIT-1, 11/F, BLK B HOI LUEN IND CTR 55, HOI YUEN RD, KWUN TONG, KLN  HONG KONG                                                                                                             ",
    "Investment Permitted Address":
      "PLOT NO. 103, MYAY TAING BLOCK NO. 51, THARDUKAN INDUSTRIAL ZONE, SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 374,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Myo Swe",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Sein Hinn Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "MaNaTha-1039/2015",
    "Permit Date": "2015-03-10T00:00:00Z",
    "Meeting Number": "Ma Na Tha-1039/2015",
    "Meeting Date": "2015-02-27T08:47:54Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business":
      "စနစ်ဖြင့် မြေနှင့် အဆောက်အဦငှားရမ်း၍ ဟိုတယ် ဝန်ဆောင်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 7.09,
    "Total Amount Of Capital (in Millions)": 9617.05,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT",
    "Land Owner": "အထွေထွေအုပ်ချုပ်ရေးဦးစီးဌာန၊ ရန်ကုန်တိုင်းဒေသကြီး၊",
    "Land Area (units not specified in file)": 1.652,
    "Lease Term": 50,
    "Annual Lease Fee": 0.1,
    "Land Use Premium": 2065000,
    "Number Of Local Employees": 90,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address":
      "တိုက်အမှတ် (၃၆) ၊ ကျောက်စိမ်းလမ်း၊ စော်ဘွားကြီးကုန်း၊ အင်းစိန်မြို့နယ် ၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No.36, Room(5/6), Kyauk Seinn St, , Insein Township, YANGON",
  },
  {
    ID: 375,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးသိန်းသန်းအောင်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "မြန်မာမော်တော်ယာဥ် ကော်ပိုရေးရှင်းအများနှင့် သက်ဆိုင်သော ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "Ma Na Tha-1231/2017",
    "Permit Date": "2017-01-11T00:00:00Z",
    "Meeting Number": "23/2016",
    "Meeting Date": "2016-12-17T09:33:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Coach Bus, City Bus မော်တော်ယာဥ် ကိုယ်ထည် ထုတ်လုပ် တပ်ဆင် ရောင်းချခြင်း (Body Building)လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 6,
    "Total Amount Of Capital (in Millions)": 14618,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "မြန်မာမော်တော်ယာဥ်ကော်ပိုရေးရှင်း အများနှင့် သက်ဆိုင်သော ကုမ္ပဏီလီမိတက် ",
    "Land Area (units not specified in file)": 3.226,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 196,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၁)၊ ချယ်ရီဥယျာဥ်မြို့တော်အိမ်ရာ၊ (၁၄/၃) ရပ်ကွက်၊ တောင်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ မြောက်ဥက္ကလာပ မြို့နယ်၊ ရွှေပေါက်ကံစက်မှုဇုန်၊ မြေတိုင်းရပ်ကွက်အမှတ်-၁၈၊ မြေကွက်အမှတ်-၂၃၂/c၂ ရှိ မြေဧရိယာ ၁.၂၂၇ ဧက နှင့် မင်္ဂလာဒုံမြို့နယ်၊ ရန်ကုန်စက်မှုဇုန်၊ မြေကွက်အမှတ်-၈ ရှိ မြေဧရိယာ ၁.၉၉၉ဧက စုစုပေါင်း မြေဧရိယာ ၃.၂၂၆ ဧက",
  },
  {
    ID: 376,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Jia Xinhua",
    "Name of Principal Organization": "Sun pak International Group Limted",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Myanmar Juice Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "969/2015",
    "Permit Date": "2015-06-28T00:00:00Z",
    "Meeting Number": "10/2015",
    "Meeting Date": "2015-06-05T08:11:20Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Distribution of Purified Drinking Water and Juice",
    "Amount Of Foreign Capital USD (in Millions)": 2.1,
    "Total Amount Of Capital (in Millions)": 3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "Myanma Economic Holdings Ltd.",
    "Land Area (units not specified in file)": 8.6,
    "Lease Term": 30,
    "Annual Lease Fee": 0.318,
    "Land Use Premium": null,
    "Number Of Local Employees": 253,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address":
      "FLAT C-5-601, JIANG DOG HUA CHENG PEN LONG QU KUE MING CITY",
    "Organization Address":
      "FLAT/RM 901 AB, 9/F HO KUNG COMM CTR2-16, FA YUEN ST",
    "Investment Permitted Address":
      "Ploe No. (40), No 3 Road, Pyinmabin Industrial Zone",
  },
  {
    ID: 389,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U YONE MU",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "GOLDEN MYAN-TAI COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1192/2016",
    "Permit Date": "2016-11-21T00:00:00Z",
    "Meeting Number": "20/2016",
    "Meeting Date": "2016-10-28T08:35:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF SUGAR AND MOLASSES",
    "Amount Of Foreign Capital USD (in Millions)": 13,
    "Total Amount Of Capital (in Millions)": 20,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "MYANMA ECONOMIC HOLDINGS LIMITED",
    "Land Area (units not specified in file)": 108.89,
    "Lease Term": 30,
    "Annual Lease Fee": 1.12,
    "Land Use Premium": null,
    "Number Of Local Employees": 268,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 814, 63 rd STREET, CORNER OF 30th STREET, PYIGYI MYAT SHIN WARD, CHAN AYE THAR ZAN TOWHSHIP, MANDALAY",
    "Organization Address": "-",
    "Investment Permitted Address":
      "HOLDING NOL. 29+47/KA+26, N-3 TO N-81, NO. 880/E, TAW KWIN, GONG NYIN TAN VILLAGE TRACT, TAIKKYI TOWNSHIP, YANGON REGION",
  },
  {
    ID: 398,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအယ်(လ်)လမိန်းဒိန်း(ခ)ဦးလဖိုင်ဒိုင်နာလ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Grand Wynn  Manufacturing Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "866/2012",
    "Permit Date": "2012-11-13T00:00:00Z",
    "Meeting Number": "33/2012",
    "Meeting Date": "2012-10-31T04:50:45Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "Contract Processing System & Normal System -၂, မျိုးဖြင့် ငါး၊ ပုစွန် ပြုပြင်အေးခဲခြင်း\nလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.077,
    "Total Amount Of Capital (in Millions)": 400,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Hla Win",
    "Land Area (units not specified in file)": 0.688,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 208,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်-၁၃၆/၁၊ သံသုမာလမ်း၊ စုပေါင်းအိမ်ရာရပ်ကွက်၊ ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "​မြေကွက်အမှတ်(၅၀၊၅၁), ရန်နိုင်​ဆွေလမ်း၊ စက်မှုလက်မှုရပ်ကွက်,",
  },
  {
    ID: 399,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Pradeep Kumar",
    "Name of Principal Organization": "Bhagwati International Pte. Ltd,",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Bhagwati Veneer Private Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1025/2015",
    "Permit Date": "2015-09-14T00:00:00Z",
    "Meeting Number": "17/2015",
    "Meeting Date": "2015-09-28T08:07:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Plywood, Face Veneer, Core veneer, Teak Veneer and Sawn Timber",
    "Amount Of Foreign Capital USD (in Millions)": 4.5,
    "Total Amount Of Capital (in Millions)": 4.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "U Ba Yan @ U Sar ban Ku Mar",
    "Land Area (units not specified in file)": 6.264,
    "Lease Term": 30,
    "Annual Lease Fee": 0.127,
    "Land Use Premium": null,
    "Number Of Local Employees": 246,
    "Number Of Foreign Employees": 18,
    Status: "Monitoring Approved",
    "Investor Address": "19 D Himalayan Heights ",
    "Organization Address": "23-12 Tong Eng Building, 101 Cecil Street",
    "Investment Permitted Address":
      "Plot No (61 /62) Myay Taing No.(51) ,Thardu kan Indistrial Zone ., Shwepyithar, YANGON",
  },
  {
    ID: 400,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Dr. Zay Ya Aye",
    "Name of Principal Organization": "Royal Parami Life Sciences Co.,Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "European Hearing Care ( Myanmar) Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "824/2014",
    "Permit Date": "2014-10-24T00:00:00Z",
    "Meeting Number": "824/2014",
    "Meeting Date": "2014-10-01T06:57:59Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Hearing Assessment, Hearing Aids Production, Fitting And Post Treatment Care Services",
    "Amount Of Foreign Capital USD (in Millions)": 0.57,
    "Total Amount Of Capital (in Millions)": 1.14,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner":
      "Royal Parami Life Sciences Co.,Ltd, Daw Tin Htwe Htwe Tun, Daw Alnar Thain",
    "Land Area (units not specified in file)": 1464.65,
    "Lease Term": 10,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 11,
    "Number Of Foreign Employees": 2,
    Status: "Draft",
    "Investor Address":
      "No.60, G-2, New Parami Road, Ward No.(10), Chaw Twin  Gone , Mayangone Township, Yangon",
    "Organization Address":
      "No.60, G-1, New Parami Road, Ward No.(10), Chaw Twin  Gone , Mayangone Township, Yangon",
    "Investment Permitted Address":
      "No.60, G-1, New Parami Road, Ward No.(10), Chaw Twin  Gone , Mayangone Township,  No.31,(G-F), Groung Floor ( Right), U Tun Myat Street, Natmauk Ward, Tamwe Township And No.271, Bo Soon Pat Street, Pabedan Township , Yangon",
  },
  {
    ID: 404,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Khin Htay Lin",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Grand Hantha Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "Ma Na Tha-1224/2016",
    "Permit Date": "2016-11-21T00:00:00Z",
    "Meeting Number": "Ma Na Tha-1224/2016",
    "Meeting Date": "2016-11-01T07:27:09Z",
    Sector: "Other Services",
    "Type Of Investment Business": " Private Hospital services",
    "Amount Of Foreign Capital USD (in Millions)": 31.13,
    "Total Amount Of Capital (in Millions)": 63000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Yuzana Construction Company",
    "Land Area (units not specified in file)": 1.794,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 1210,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "No.(615/R), Phay Road, ( 2) Quarter, Kamaryuat Township, Yangon",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Yangon, Kamayuat Township, Kyimyin Taing Kannar Street and conor Narnetaw street ,Yuzana Road , No.3, 8 floor, Bulding No.(F) 205,051.75 Square feet",
  },
  {
    ID: 405,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Zaw Hlaing Myint",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar Luxury Group Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "MaNaTha-1017/2014",
    "Permit Date": "2014-12-09T00:00:00Z",
    "Meeting Number": "27/2014",
    "Meeting Date": "2018-11-28T11:14:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် Jacket ,Bag နှင့် အဝတ်အထည် မျိုးစုံချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 120,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-ဦးစိန်ဦး(ခ)လောရိန်ကြစ်",
    "Land Area (units not specified in file)": 0.245,
    "Lease Term": 10,
    "Annual Lease Fee": 2,
    "Land Use Premium": null,
    "Number Of Local Employees": 198,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် (၄၂) ၊ မာလာမြိုင်(၃) လမ်း၊ (၁၆) ရပ်ကွက် ၊ လှိုင်မြို့နယ်၊ ရန်ကုန်တိုင်ဒေသကြီး",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၉၀၊ မြေတိုင်းရပ်ကွက်အမှတ်-၄၂၊ ရွှေပြည်သာစက်မှုဇုန်၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး။",
  },
  {
    ID: 409,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Doctor Bhone Myint",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Sein Myint Mo Tours And Travels Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "MaNaTha-1196/2016",
    "Permit Date": "2016-07-05T00:00:00Z",
    "Meeting Number": "12/2016",
    "Meeting Date": "2016-06-27T06:17:34Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "International Hotel Services BOT Basic",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 3100,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT",
    "Land Owner": "Own of Hotel and Travel Daperment ",
    "Land Area (units not specified in file)": 1.374,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 121,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "No(81-B), Inya Mying Total Road, Bahan Township, Yangon\n",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Room No.(11), First Floor,Building No.(38), Shwe Ohn Pin Housing, Yankin, YANGON",
  },
  {
    ID: 413,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦး​​ကျော်စိန်(ခ​) ဝေ ချင်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Royal Sky Company Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "Manatha-950/2013",
    "Permit Date": "2013-12-31T00:00:00Z",
    "Meeting Number": "31/2013",
    "Meeting Date": "2013-12-04T05:42:12Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီ ဂေါက်​ကွင်း Club House & Golf Resort နှင့် ဘန်ဂလို တည်ဆောက်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 23.72,
    "Total Amount Of Capital (in Millions)": 28459.48,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "စစ်ထောက်ချုပ်ရုံးပိုင်",
    "Land Area (units not specified in file)": 208,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": 62.4,
    "Number Of Local Employees": 345,
    "Number Of Foreign Employees": 5,
    Status: "Submitted",
    "Investor Address":
      "အမှတ်-၈၃၈၊ ဦးဝိစာရလမ်းနှင့် ယမနေ (၆) လမ်းထောင့်၊ ၃၄ ရပ်ကွက်၊ ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Olympic Hotel , National Swimming Pool Compound , U Wisara Road , ",
  },
  {
    ID: 414,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U MAUNG MAUNG OO @ WIN SAYLAIN",
    "Name of Principal Organization": "ASIAN JUST CO., LTD.",
    "Place of Incorporation": "MYANMAR",
    "Company Name In Myanmar": "ASIAN JUST COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1260/2017",
    "Permit Date": "2017-04-11T00:00:00Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T08:23:21Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING  OF  GARMENT      ON CMP BASIS ",
    "Amount Of Foreign Capital USD (in Millions)": 0.403,
    "Total Amount Of Capital (in Millions)": 0.403,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "U MAUNG MAUNG OO @ WIN SAYLEIN",
    "Land Area (units not specified in file)": 4.633,
    "Lease Term": 30,
    "Annual Lease Fee": 0.036,
    "Land Use Premium": null,
    "Number Of Local Employees": 1850,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address": "NO. 26, ZAWTIKA STREET, SANCHAUNG TOWNSHIP, YANGON",
    "Organization Address":
      "NO. 150, 151, PLOT NO.64, SHWE PYI THAR INDUSTRIAL ZONE 3, YANGON REGION",
    "Investment Permitted Address":
      "NO. 150, 151, PLOT NO.64, SHWE PYI THAR INDUSTRIAL ZONE 3, YANGON REGION",
  },
  {
    ID: 422,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wang Junqiang",
    "Name of Principal Organization":
      "Jiangsu Zhongrun Textile Technology Co., Ltd.",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Zhongrun (Myanmar) Garment Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "973/2015",
    "Permit Date": "2015-06-28T00:00:00Z",
    "Meeting Number": "10/2015",
    "Meeting Date": "2015-06-05T07:19:47Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.617,
    "Total Amount Of Capital (in Millions)": 1.617,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Khin May Linn",
    "Land Area (units not specified in file)": 1.886,
    "Lease Term": 20,
    "Annual Lease Fee": 0.041,
    "Land Use Premium": null,
    "Number Of Local Employees": 1036,
    "Number Of Foreign Employees": 32,
    Status: "Monitoring Approved",
    "Investor Address":
      "Touzao Qiangdun Nanyang Yancheng  Jiangsu. People's Republic of China",
    "Organization Address":
      "Touzao Qiangdun Nanyang Yancheng, Jiangsu Province, People's Republic of China",
    "Investment Permitted Address":
      "Plot No. 73/KA, Myay Taing Block No. 65, Industrial Zone-4, Shwe Pyithar Township , Yangon Region",
  },
  {
    ID: 424,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Tin Maung Tun",
    "Name of Principal Organization": "",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar Aquariums Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "MaNaTha-1201/2016",
    "Permit Date": "2016-08-11T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Other Services",
    "Type Of Investment Business":
      "International Standard Under the Water Fish World Bulding and Showing Services",
    "Amount Of Foreign Capital USD (in Millions)": 33.58,
    "Total Amount Of Capital (in Millions)": 42021.73,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Yangon  Fish Daperment",
    "Land Area (units not specified in file)": 5,
    "Lease Term": 20,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 76,
    "Number Of Foreign Employees": 4,
    Status: "Approved",
    "Investor Address":
      "Bulding ( B-15), Room No(302), Shwe Gabar Housing, Mindama Road, (3) Ward, Mayangone Township , Yangon",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Yangon, Bahan  Township, Bocho (1)Ward, NatMouth Road, Bogyoke Garden, Kantawgyi Water sweet Fish Garden, estimate  Area (5.00)Acres",
  },
  {
    ID: 425,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Myint Ohn",
    "Name of Principal Organization": "Campana Myanmar Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Campana Mythic Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1089/2016",
    "Permit Date": "2016-02-17T00:00:00Z",
    "Meeting Number": "1089/2016",
    "Meeting Date": "2016-01-01T15:36:06Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Domestic Submarine Fiber Cable Facilities and Terrestrial Fiber Cable Network Facilities Services Including Data Center (Not Including International Gateway)",
    "Amount Of Foreign Capital USD (in Millions)": 15.97,
    "Total Amount Of Capital (in Millions)": 16,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Mu Mu Thin",
    "Land Area (units not specified in file)": 0.23,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 23,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address":
      "Room. 203, Building No.2, Zizawa Condo, Thanthumar Street, Ward No.15, ",
    "Organization Address":
      "No. 217, Ingyin Myaing Street lane-2, Ward No. 23, Thuwunna",
    "Investment Permitted Address":
      "U Paing No.25/2, Plot No.665 D, Southern Part of Kanyin Pin Chaung, Latyatsan Village Tract",
  },
  {
    ID: 427,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw KhinKhin Cho",
    "Name of Principal Organization": "Stellar    Star   Company Limited ",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Stellar    Star   Company Limited ",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "မနသ-၁၀၈၄/၂၀၁၅",
    "Permit Date": "2015-09-21T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production  of   Plastics    base on Contract   Manufacturing   Process(CMP) ",
    "Amount Of Foreign Capital USD (in Millions)": 0.085,
    "Total Amount Of Capital (in Millions)": 500,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U  Soe   Myint   ",
    "Land Area (units not specified in file)": 1.364,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 41,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address": " အမှတ်(၅၁)၊ရွှေတောင်တန်းလမ်း,",
    "Organization Address":
      "မြေကွက်အမှတ်-၅၆၊မြေတိုင်းရပ်ကွက်အမှတ်-၄၂၊ရွှေပြည်သာစက်မှုဇုန်",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၅၉၊ မြေတိုင်းရပ်ကွက် အမှတ်-၄၂",
  },
  {
    ID: 428,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kerim Altintas",
    "Name of Principal Organization": "Kakado Trading Co., Ltd.",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Kakado Myanmar Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1007/2015",
    "Permit Date": "2015-09-05T00:00:00Z",
    "Meeting Number": "15/2015",
    "Meeting Date": "2015-08-21T08:32:13Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.479,
    "Total Amount Of Capital (in Millions)": 1.479,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Hla Tun, U Hote Kyi",
    "Land Area (units not specified in file)": 1.5,
    "Lease Term": 10,
    "Annual Lease Fee": 0.031,
    "Land Use Premium": null,
    "Number Of Local Employees": 600,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "FLAT C-23/F, EGL TOWER 83 HUNG TO ROAD, KWUN TONG, KOWLOON, HONG KONG     ",
    "Organization Address":
      "FLAT C-23/F, EGL TOWER 83 HUNG TO ROAD, KWUN TONG, KOWLOON, HONG KONG  ",
    "Investment Permitted Address":
      "PLOT NO. 282+283, MYAY TAING BLOCK NO. 25, SHWE LIN BAN INDUSTRIAL ZONE, HLAING THARYAR TOWNSHIP, YANGON REGION  ",
  },
  {
    ID: 433,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဝင်းမြင့်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myat Myinttar Mon Services Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "880/2013",
    "Permit Date": "2013-01-16T00:00:00Z",
    "Meeting Number": "3/2013",
    "Meeting Date": "2013-01-16T10:22:02Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "BOTစနစ်ဖြင့် မြေငှားရမ်း၍ စက်သုံးဆီ တင်/ချ ဆိပ်ခံတံတားနှင့် ဆီသိုလှောင်ကန်များ တည်ဆောက်ပြီး စက်သုံးဆီသိုလှောင်သည့် ဝန်ဆောင်မှု လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 18,
    "Total Amount Of Capital (in Millions)": 22414,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "မြန်မာ့ဆိပ်ကမ်းအာဏာပိုင်",
    "Land Area (units not specified in file)": 24.71,
    "Lease Term": 30,
    "Annual Lease Fee": 197.508,
    "Land Use Premium": 370.65,
    "Number Of Local Employees": 77,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "အမှတ်-၅၆/၅၇၊ လှိုင်ရတနာမွန် -၆ လမ်း၊ လှိုင်ရတနာမွန်အိမ်ရာ,",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁/၂(အေ)၊ သီလဝါဆိပ်ကမ်းဒေသ၊ သန်လျင်-ကျောက်တန်းနယ်မြေ  မြန်မာ့ဆိပ်ကမ်းအာဏာပိုင်​မြေ",
  },
  {
    ID: 435,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. David Pettinari ",
    "Name of Principal Organization": "Nestle S.A ",
    "Place of Incorporation": "Switzerland ",
    "Company Name In Myanmar": "Nestle Myanmar Limited ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "852/2014",
    "Permit Date": "2014-11-26T06:33:14Z",
    "Meeting Number": "24/2014",
    "Meeting Date": "2014-10-17T06:33:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production and Distribution of Food and Beverage ",
    "Amount Of Foreign Capital USD (in Millions)": 23.75,
    "Total Amount Of Capital (in Millions)": 23.75,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 6,
    "Investing Country": "Switzerland",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Maw Thein \nDaw Moe Myat Win ",
    "Land Area (units not specified in file)": 3.162,
    "Lease Term": 6,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 61,
    "Number Of Foreign Employees": 9,
    Status: "Submitted",
    "Investor Address": "1103,Ye Ta Khun Tower, Upper Kyimyindaing Road ",
    "Organization Address": "Avenue Nestle 55 Vevey , Vaud",
    "Investment Permitted Address": "Plot No. 95, Industrial Zone(1)",
  },
  {
    ID: 436,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U THAUNG WIN",
    "Name of Principal Organization": "GOLDEN LACE COMPANY LIMITED",
    "Place of Incorporation": "MYANMAR",
    "Company Name In Myanmar":
      "Golden Lace Posco International Company Limited ",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1221/2017",
    "Permit Date": "2017-01-11T00:00:00Z",
    "Meeting Number": "1/2017",
    "Meeting Date": "2017-01-06T07:19:23Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "PROCESSING, PRODUCTION AND SALE OF PARBOILED RICE, HIGH QUALITY WHITE RICE AND RICE PRODUCTS (FACTORY -1)",
    "Amount Of Foreign Capital USD (in Millions)": 2.633,
    "Total Amount Of Capital (in Millions)": 4.387,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "GOLDEN LACE COMPANY LIMITED",
    "Land Area (units not specified in file)": 3.388,
    "Lease Term": 50,
    "Annual Lease Fee": 0.0291,
    "Land Use Premium": null,
    "Number Of Local Employees": 22,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 26, KHAY MAR STREET, THIRI KHAY MAR QUARTER, SANCHAUNG TOWNSHIP, YANGON",
    "Organization Address":
      "NO. 26, KHAY MAR STREET, THIRI KHAY MAR QUARTER, SANCHAUNG TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "PLOT NO. 322, NO. 323, MYAY TAING BLOCK NO. 25, SHWE LIN BAN INDUSTRIAL ZONE, HLAING THARYAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 438,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Ko Ko Gyi (or) U Soe Naing",
    "Name of Principal Organization": "Lluvia Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Lluvia Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "938/2015",
    "Permit Date": "2015-04-27T00:00:00Z",
    "Meeting Number": "5/2015",
    "Meeting Date": "2015-03-20T08:31:39Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Distribution of Instant Coffee , Instant TEa, Milk Powder and Ceral",
    "Amount Of Foreign Capital USD (in Millions)": 2.79,
    "Total Amount Of Capital (in Millions)": 18.61,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "Green Land Food Industrials Ltd.",
    "Land Area (units not specified in file)": 9.687,
    "Lease Term": 50,
    "Annual Lease Fee": 940846,
    "Land Use Premium": null,
    "Number Of Local Employees": 291,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "No.34, University Avenue Road, Bahan Township, Yangon",
    "Organization Address":
      "No.126/A, Kabaraye Pagoda Road, Bahan Township, Yangon",
    "Investment Permitted Address":
      "Plot No.108(A/B), Industrial Zone (3), Hlaing Tharyar Township, Yangon",
  },
  {
    ID: 440,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyi Soe @ တော်ကြူးကျိန်း ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "KHG Development Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "MaNaTha-1008/2014",
    "Permit Date": "2014-12-23T00:00:00Z",
    "Meeting Number": "24/2014",
    "Meeting Date": "2014-10-17T06:35:08Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "အဆင့်မြင့် လူနေအိမ်ခန်း ၁၄၈ ခန်းပါ အထပ်် ၂၈ ထပ် Twin Tower ဆောက်လုပ် အခန်းများ ငှားရမ်းခြင်းနှင့် ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 20,
    "Total Amount Of Capital (in Millions)": 67897.8,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 0.5,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 64,
    "Number Of Foreign Employees": 0,
    Status: "Submitted",
    "Investor Address":
      "အမှတ် (၄) ၊ ငွေပြည်သာရိပ်သာလမ်း ၊ ကျိုက္ကစံ အနောက်ရပ်ကွက် သင်္ဃန်းကျွန်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No.(25/A-8), Aye Yeikthar (2nd) Street, New University Avenue Road, Bahan, YANGON",
  },
  {
    ID: 443,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Nazir Ahmad Bashiri ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Texworld Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1109/2016",
    "Permit Date": "2016-03-26T00:00:00Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T03:30:51Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Embroidery and Sequins Beautifying on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.653,
    "Total Amount Of Capital (in Millions)": 0.653,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Afghanistan",
    "Form Of Investment": "FDII",
    "Land Owner": "U Maung Maung Aye",
    "Land Area (units not specified in file)": 0.258,
    "Lease Term": 10,
    "Annual Lease Fee": 0.018,
    "Land Use Premium": null,
    "Number Of Local Employees": 550,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address": "Room 16018, 16th Floor, B Building Wonder Plaza ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No. 182, Myay Taing No.144, East Dagon Industrial Zone-2 Extension, ",
  },
  {
    ID: 444,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးခွန်နောင်မြင့်​ေ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Wa Minn Mining Co., Lutd",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "882/2017",
    "Permit Date": "2013-01-16T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် Steel မီးဖိုချောင်သုံးနှင့် လူသုံးကုန် ပစ္စည်းများ ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.074,
    "Total Amount Of Capital (in Millions)": 150,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address": "အမှတ်-၆၆၉/စီ၊ မြကန်သာလမ်း၊ ၂ ရပ်ကွက်၊ ပြည်လမ်း",
    "Organization Address": "-",
    "Investment Permitted Address":
      "အမှတ်-၁၁၆၊ သမိုင်းဘူးတာရုံးလမ်း၊ ၂ ရပ်ကွက်၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသ   ကြီးရှိ စက်မှု ဝန်ကြီးဌာန စက္ကူနှင့် အိမ်သုံးပစ္စည်းလုပ်ငန်း",
  },
  {
    ID: 446,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးထွန်းလွင်၊ ဦးမိုးနိုင်နှင့် ဦးရဲလွင်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "ရေွှ​မဲ  ထောက်​ပို့ရေးဝ​န်ဆောင်မှု ကုမ္မဏီ လီမိတက် ",
    "Financial Year From": 2011,
    "Financial Year To": 2012,
    "Permit Number": "-",
    "Permit Date": "2017-08-08T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Other Services",
    "Type Of Investment Business":
      "မိတ္ထီလာ-မလှိုင်-တောင်သာ-မြင်းခြံ လမ်းအပိုင်းအား BOT စနစ်ဖြင့် ပြုပြင်ဖောက်လုပ်၍ လမ်းအသုံးပြုခ ကောက်ခံခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 16.288,
    "Total Amount Of Capital (in Millions)": 4300,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 217,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address": "-",
  },
  {
    ID: 447,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Thalangara Abdulla Sarfraz ",
    "Name of Principal Organization": "MAK Plywood Industries PVT., LTD ",
    "Place of Incorporation": "India",
    "Company Name In Myanmar": "MAK(Myanmar) Plywood Industries PVT., LTd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "649/2013",
    "Permit Date": "2013-12-27T00:00:00Z",
    "Meeting Number": "30/2013",
    "Meeting Date": "2013-11-26T07:35:58Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing  and  Marketing  of  Veneer Plywood and Swan Timber",
    "Amount Of Foreign Capital USD (in Millions)": 3,
    "Total Amount Of Capital (in Millions)": 3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 24,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "India",
    "Form Of Investment": "FDII",
    "Land Owner": "U Win Maung \nMKA (Myanmar) Plywood Industries Pvt. Ltd",
    "Land Area (units not specified in file)": 3.501,
    "Lease Term": 30,
    "Annual Lease Fee": 0.12,
    "Land Use Premium": null,
    "Number Of Local Employees": 266,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "A803, Mantri Elegance, Bannergatta road, Bangalore 560076 ",
    "Organization Address":
      "Padav, Kunjathur Post, Manjeshwaram, Kasaragod , Kerala-671323",
    "Investment Permitted Address":
      "Plot No.15, Dagon Seik Kan Industrial Zone(2), ",
  },
  {
    ID: 448,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Sone Han",
    "Name of Principal Organization": "--",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "First Myanmar Construction Company Limited (ပထမ မြန်မာ ဆောက်လုပ်ရေး ကုမ္ပဏီ လီမိတက်)",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "Manatha 1120/2016",
    "Permit Date": "2016-01-11T00:00:00Z",
    "Meeting Number": "23/2015",
    "Meeting Date": "2015-12-28T03:43:02Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "အခြေခံအဆောက်အအုံများ တည်ဆောက်၍ မြေယာဖော်ထုတ်ခြင်းနှင့် ထပ်ဆင့်ငှားရမ်းခြင်း ဝန်ဆောင်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 53.54,
    "Total Amount Of Capital (in Millions)": 117939.96,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Yangon City Development Committee",
    "Land Area (units not specified in file)": 36.551,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 232,
    "Number Of Foreign Employees": 8,
    Status: "Approved",
    "Investor Address":
      "အမှတ်-၁၀၊ ကန်ရိပ်သာလမ်း၊ FMI City၊ လှိုင်သာယာမြို့၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "\nNo.(107/109), Room No.(901/902), Anawyadar Street and Sinohtan Street, , Latha, YANGON",
  },
  {
    ID: 450,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Aung Zaw OO",
    "Name of Principal Organization": "Aung Naing Thit Sar Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Yoma Sun Co.,Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "732/2014",
    "Permit Date": "2014-06-18T00:00:00Z",
    "Meeting Number": "14/2014",
    "Meeting Date": "2014-06-18T08:05:00Z",
    Sector: "Agriculture",
    "Type Of Investment Business":
      "Contract Farming, Seeds Production, Pre and Post Harvest Technology Application, Rice Milling and Warehousing",
    "Amount Of Foreign Capital USD (in Millions)": 9.5,
    "Total Amount Of Capital (in Millions)": 18050,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "U Aung Zaw Oo",
    "Land Area (units not specified in file)": 2.83,
    "Lease Term": 30,
    "Annual Lease Fee": 0.0229,
    "Land Use Premium": null,
    "Number Of Local Employees": 998,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "Room 401, Aung Zaya Condo, Corner of Theikpan Street and Alone Street, Ahlone Township, Yangon",
    "Organization Address":
      "No.2, Room No.504, 5th Floor, Thirimingalar Housing , Strand Road, Ahlone Township, Yangon",
    "Investment Permitted Address":
      "Dagon Centre II,Pyay Road,No(268),Room14(C),14 Floor,Myaynigone , Sanchaung, YANGON",
  },
  {
    ID: 455,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. KIM CHUL MIN",
    "Name of Principal Organization": "CMF KOREA INC.,",
    "Place of Incorporation": "KOREA",
    "Company Name In Myanmar": "CMF MYANMAR COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1263/2017",
    "Permit Date": "2017-04-11T00:00:00Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T04:38:03Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF BAG ON CMP BASIS (FACTORY 2)",
    "Amount Of Foreign Capital USD (in Millions)": 1.94,
    "Total Amount Of Capital (in Millions)": 1.94,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U NAY WIN @ U TIN SEIN",
    "Land Area (units not specified in file)": 2.535,
    "Lease Term": 20,
    "Annual Lease Fee": 0.056,
    "Land Use Premium": null,
    "Number Of Local Employees": 1359,
    "Number Of Foreign Employees": 7,
    Status: "Monitoring Approved",
    "Investor Address":
      "143, EUNGAM-RO, SEODAEMUN-GU, SEOUL, REPUBLIC OF KOREA",
    "Organization Address":
      " # B-1605, NONHYEON-DONG, GANGNAM PARAGON, 338, HAKDONG-RO, GANGNAM-GU, SEOUL, REPUBLIC OF KOREA",
    "Investment Permitted Address":
      "PLOT NO. 140, MYAY TAING BLOCK NO. 14/ SHWE THAN LWIN INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON",
  },
  {
    ID: 457,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Moe Myint Kyaw ",
    "Name of Principal Organization":
      "Myanmar Makro Industry Company Limited No(82)",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Makro Manufacturing Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "769/2014",
    "Permit Date": "2014-08-08T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufactring of Food products ",
    "Amount Of Foreign Capital USD (in Millions)": 0.599,
    "Total Amount Of Capital (in Millions)": 0.599,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Thailand",
    "Form Of Investment": "FDII",
    "Land Owner": "U Moe Myint Kyaw ",
    "Land Area (units not specified in file)": 2.21,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 197,
    "Number Of Foreign Employees": 0,
    Status: "Rejected",
    "Investor Address": "12/B, Khatter Street",
    "Organization Address": "Myamarlar Street, Thaketa Industrial Zone ",
    "Investment Permitted Address":
      "Myay Taing Block No. Industrial Zone 2, Plot No.14, Thukitar  Road, Dagon Seikkan Industrial Zone ",
  },
  {
    ID: 480,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Lee Man Ching",
    "Name of Principal Organization": "Lee & Man Development Co., Ltd. ",
    "Place of Incorporation": "British Virgin Islands,",
    "Company Name In Myanmar": "Harvey Handbags Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1030/2015",
    "Permit Date": "2015-11-11T00:00:00Z",
    "Meeting Number": "18/2015",
    "Meeting Date": "2015-10-23T09:09:40Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of  Various Kinds of Bags and Wallets on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 6.613,
    "Total Amount Of Capital (in Millions)": 6.613,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Virgin Islands (British)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Khin Mg Saw, Daw Win Win",
    "Land Area (units not specified in file)": 5.052,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 2591,
    "Number Of Foreign Employees": 22,
    Status: "Monitoring Approved",
    "Investor Address": "8/F Liven House, 61-63 King Yip Street, Kwun Tong ",
    "Organization Address": "3rd Floor, J& C Building, P.O Box 362, Road Town",
    "Investment Permitted Address":
      "PLOT NO. K1A/ K1B, MYAY TAING BLOCK NO.20, ANAWYAHTA  INDUSTRIAL ZONE, HLAING THARYAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 484,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Soe Myint",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Pacific Food Industries Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "Ma Na Tha-1215/2016",
    "Permit Date": "2016-10-03T00:00:00Z",
    "Meeting Number": "18/2016",
    "Meeting Date": "2016-09-23T05:02:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Dairy Products",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 5946.74,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "Department of Urban and Housing Development, Ministry of Construction",
    "Land Area (units not specified in file)": 2.011,
    "Lease Term": 30,
    "Annual Lease Fee": 0.406912,
    "Land Use Premium": null,
    "Number Of Local Employees": 85,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address": "No-125,2nd-Floor,19-Street, Latha Township, Yangon",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No(83), Hlaing Tharyar Industrial Zone (3), Hlaing Tharyar Township, Yangon Myay Area 2.011 Acres",
  },
  {
    ID: 486,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Permanent Secretary",
    "Name of Principal Organization": " Ministry of Energy ",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Asia Ava Gas Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1105/2016",
    "Permit Date": "2016-03-26T00:00:00Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T04:47:38Z",
    Sector: "Oil and Gas",
    "Type Of Investment Business":
      "Importing, Storage, Bottling and Distribution of Liquefied Petroleum Gas",
    "Amount Of Foreign Capital USD (in Millions)": 48,
    "Total Amount Of Capital (in Millions)": 60,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "U Myo Aung & Daw Aye Aye Mon",
    "Land Area (units not specified in file)": 31.78,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 87,
    "Number Of Foreign Employees": 15,
    Status: "Approved",
    "Investor Address": "Building No.6 ",
    "Organization Address": "Building No.6 Nay Pyi Taw",
    "Investment Permitted Address":
      "Plot No. 672, Weast Kyaung Gone Kwin, Hokding No. 12,13,14,and 15/2,22.11 Acres and Plot No.675-KA, Hokding No. 11,9.67 Acres Total 31.78 Acres, Bogyoke Village Tract, ",
  },
  {
    ID: 487,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MRS. NITHIMA WINTAHI",
    "Name of Principal Organization":
      "BANGKOK INDUSTRIAL GAS COMPANY LIMITED, ",
    "Place of Incorporation": "Thailand",
    "Company Name In Myanmar": "YANGON INDUSTRIAL GAS COMPANY LIMITED ",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1242/2017",
    "Permit Date": "2017-04-11T00:00:00Z",
    "Meeting Number": "1242/2017",
    "Meeting Date": "2017-04-01T05:00:43Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "PRODUCTION, MARKETING AND DISTRIBUTION OF INDUSTRIAL GS SUCH AS OXYGEN, NITROGEN, ARGON AND CARBON DIOXIDE",
    "Amount Of Foreign Capital USD (in Millions)": 2.145,
    "Total Amount Of Capital (in Millions)": 3.3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "U TIN MAUNG NYUNT",
    "Land Area (units not specified in file)": 1.537,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 25,
    "Number Of Foreign Employees": 1,
    Status: "Draft",
    "Investor Address":
      "38/27 MOO 3 BANFA GREEKPARK, BHUDAMONTHON SAI 1, BANGCHEUKNANG, TALINGCHAN, BANGKOK, THAILAND 10170",
    "Organization Address":
      "N0.3 RAJANAKARN BUILDING, 11th  FLOOR, SOUTH SATHORN ROAD, YANANWA, SATHORN, BANGKOK, THAILAND 10120",
    "Investment Permitted Address":
      "MYAY TAING BLOCK NO. 143/1, PLOT NO. 37, KYANSITTHAR YEIK MON INDUSTRIAL ZONE, DAGON MYOTHIT (SOUTH) TOWNSHIP, YANGON REGION",
  },
  {
    ID: 490,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Wu Chi Chiu ",
    "Name of Principal Organization": "HSL investment PTE. LTD ",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "HSL Group JV Co., Ltd ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "755/2014",
    "Permit Date": "2014-08-05T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Long-Term Lease on Residental Apartments and Commercial Lease on Retail Space (Polo Club Residence)",
    "Amount Of Foreign Capital USD (in Millions)": 153.5,
    "Total Amount Of Capital (in Millions)": 178.11,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Myanma Economic Holding Ltd.",
    "Land Area (units not specified in file)": 8.933,
    "Lease Term": 50,
    "Annual Lease Fee": 3.1,
    "Land Use Premium": 1,
    "Number Of Local Employees": 650,
    "Number Of Foreign Employees": 9,
    Status: "Submitted",
    "Investor Address": "Flat E, 3/F, Yat Tien Mansion ",
    "Organization Address": "No.9 Battery Road,#15-01 Straits Trading Building",
    "Investment Permitted Address":
      "Plot No.18, 51-A, Myay Taing Block No. 34-D , Corner of East Race Course Road and Laydaunkkan Road.",
  },
  {
    ID: 494,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ooi Chin Khoon",
    "Name of Principal Organization": "OCK Setia Engineering Sdn Bhd ",
    "Place of Incorporation": "Malaysia",
    "Company Name In Myanmar": "OCK Yangon Private Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1126/2016",
    "Permit Date": "2016-03-26T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "2016-03-01T16:32:09Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "To Construct, Deploy and Maintain Passive Telecommunications Network Infrastructure and To Lease Such Infrastructure to licensed Operators",
    "Amount Of Foreign Capital USD (in Millions)": 243.55,
    "Total Amount Of Capital (in Millions)": 243.55,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Malaysia",
    "Form Of Investment": "FDII",
    "Land Owner": "U Khin Maung Htwe",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 28,
    "Number Of Foreign Employees": 7,
    Status: "Monitoring Approved",
    "Investor Address":
      "35 Jalan Wawasan 4/4, Pusat Bandar Puchong, 47100 Puchong",
    "Organization Address":
      "No. 18 Jalan Jurunilai U 1/20, Seksyen U 1, Hicom Glenmaric Industrial Park",
    "Investment Permitted Address": "Myanmar Nationwide",
  },
  {
    ID: 496,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. WU,KOU- WEI",
    "Name of Principal Organization": "BROAD GREEN INDUSTRIAL LIMITED",
    "Place of Incorporation": "VIRGIN ISLANDS (BRITISH)",
    "Company Name In Myanmar": "MYANMAR INFOCHAMP COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1130/2016",
    "Permit Date": "2016-07-06T00:00:00Z",
    "Meeting Number": "12/2016",
    "Meeting Date": "2016-06-27T10:09:29Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF COMPONENTS FOR FOOTWEAR (SUCH AS OUTSOLES, MIDSOLES AND RELATED PRODUCTS)",
    "Amount Of Foreign Capital USD (in Millions)": 0.78,
    "Total Amount Of Capital (in Millions)": 0.78,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 24,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Virgin Islands (British)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Jocky @ U Sein Htay ",
    "Land Area (units not specified in file)": 2.275,
    "Lease Term": 15,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 25,
    "Number Of Foreign Employees": 2,
    Status: "Approved",
    "Investor Address":
      "NO. 600, SEC.4, TAIWAN BLVD., XITUN DIST., TAICHUNG, 40764, TAIWAN, REPUBLIC OF CHINA",
    "Organization Address":
      "P.O. BOX 957, OFFSHORE INCORPORATIONS CENTRE, ROAD TOWN, TORTOLA, BRITISH VIRGIN ISLANDS",
    "Investment Permitted Address":
      "Plot No. 20, Myay Taing Block No. 25, Shwe Lin Pan Industrial Zone, Hlaing Thar Yar Township, Yangon",
  },
  {
    ID: 500,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်မျိုးမင်းဒင်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Adventure Myanmar Tours & Incentives Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "964/2014",
    "Permit Date": "2014-02-17T00:00:00Z",
    "Meeting Number": "964/2014",
    "Meeting Date": "2014-02-01T03:53:04Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီ ကြယ်ငါးပွင့် ဟိုတယ်၊ Shopping Mall, Business Centre နှင့် Service Apartment  လုပ်ငန်းများ",
    "Amount Of Foreign Capital USD (in Millions)": 34.83,
    "Total Amount Of Capital (in Millions)": 46000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT",
    "Land Owner":
      "နိုင်ငံတော်ကာကွယ်ရေး တက္ကသိုလ် (ဝင်းဟောင်း) နယ်မြေရှိ စစ် ထောက်ချုပ် ရုံး ပိုင်",
    "Land Area (units not specified in file)": 7.427,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 154,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address": "အမှတ်-၉၉-အို၊ သံလွင်လမ်း၊ ၁၀ ရပ်ကွက်၊ ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "နိုင်ငံတော်ကာကွယ်ရေး တက္ကသိုလ် (ဝင်းဟောင်း) နယ်မြေရှိ စစ် ထောက်ချုပ် ရုံး ပိုင် မြေ ၇.၄၂၇ ဧက၊ ​မြေတိုင်းရပ်ကွက် အမှတ်-၆၃၊ ရေွှတိဂုံ ဘုရားလမ်း၊ ",
  },
  {
    ID: 502,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Sanjiv Ahuja ",
    "Name of Principal Organization": "Apollo Towers Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Apollo Tower Co., Ltd ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "689/2014",
    "Permit Date": "2014-03-17T00:00:00Z",
    "Meeting Number": "8/2014",
    "Meeting Date": "2014-03-05T15:25:59Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Providing  tower sites to be used by telecommunication network operators ",
    "Amount Of Foreign Capital USD (in Millions)": 85.622,
    "Total Amount Of Capital (in Millions)": 85.622,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "0",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": 0,
    "Land Use Premium": 0,
    "Number Of Local Employees": 37,
    "Number Of Foreign Employees": 3,
    Status: "Approved",
    "Investor Address": "1 Central Park  West APT 28 A, NYC, NY 10023",
    "Organization Address":
      "96 Robinson Road, # 16-04, SIF Building, Singapore 068899",
    "Investment Permitted Address":
      "Nay Pyi Taw, Yangon, Mandalay, Bago, Ayeyarwaddy, Sagaing, Magway, Kayin, Mon State",
  },
  {
    ID: 503,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်မြင့်မြင့်ဝင်း",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Than Lwin Aye Yar Industrial Production & Construction Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "853/2012",
    "Permit Date": "2012-07-11T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "ဘီယာထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 2.16,
    "Total Amount Of Capital (in Millions)": 14468.88,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address": "အမျတ်-၁၂၆-A၊ လမ်း-၂၀၊ ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၆၃, မြေတိုင်းရပ်ကွက်အမှတ်-၁၄၊ ရေွှသံလွင် စက်မှုဇုန်",
  },
  {
    ID: 504,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Katsuhisa Ueda",
    "Name of Principal Organization": "King Sun Enterprises Ltd.",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "King A Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1103/2016",
    "Permit Date": "2016-03-26T00:00:00Z",
    "Meeting Number": "10/2016",
    "Meeting Date": "2016-03-18T03:50:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of All Kinds of Sport Bag and Accessories on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.018,
    "Total Amount Of Capital (in Millions)": 1.018,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Pay Hote Arr @  Kyaw Win",
    "Land Area (units not specified in file)": 1.591,
    "Lease Term": 10,
    "Annual Lease Fee": 0.018,
    "Land Use Premium": null,
    "Number Of Local Employees": 386,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "5-7-54 INA Minoh City, Osaka , Post No 562-0015, Japan",
    "Organization Address":
      "Room 10, 9/F, Wah Lai Industrial Center 10-14 Kwei Tei Street, Fotan, N.T, Hong Kong",
    "Investment Permitted Address":
      "Plot No. 122/A , Block No. 51, Thar Du Kan Industrial Zone",
  },
  {
    ID: 505,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U  Zaw  Lwin Oo ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Trends  Design Furnishing  Company  Limited ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "670/2014",
    "Permit Date": "2014-02-02T00:00:00Z",
    "Meeting Number": "1/2014",
    "Meeting Date": "2014-08-01T09:21:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing  and  Marketing  of  Furniture  And  Fixture ",
    "Amount Of Foreign Capital USD (in Millions)": 6.717,
    "Total Amount Of Capital (in Millions)": 10.334,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Daw  Hla  Hla  Tint ",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 15,
    "Annual Lease Fee": 0.012,
    "Land Use Premium": null,
    "Number Of Local Employees": 228,
    "Number Of Foreign Employees": 12,
    Status: "Monitoring Approved",
    "Investor Address": "No.161,3rd Floor, Ahlone  Street ,Htarnar  Ward ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No.(146), U Ta Yoke Gyi Street, Hlaing Thar Yar Industurial Zone (4)., Hlaingtharyar, YANGON",
  },
  {
    ID: 513,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Myint Oo @ Adbul Basad",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "May Yu Marine Products Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "881/2013",
    "Permit Date": "2013-01-16T00:00:00Z",
    "Meeting Number": "3/2013",
    "Meeting Date": "2013-01-16T07:30:14Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "Contract Processing and Normal စနစ် -၂ မျိုးဖြင့် ငါး, ပုဇွန် ပြုပြင် အေး ခဲခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 3.43,
    "Total Amount Of Capital (in Millions)": 4650,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "မြို့ရွာနှင့် အိုးအိမ်ဖွံ့ဖြိုးရေးဦးစီးဌာန",
    "Land Area (units not specified in file)": 4.326,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 412,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်-၁၄၉၊ အခန်း-၃၊ ဘိုက​လေးစျေးလမ်း၊",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၅၂၅)၊ မြေတိုင်းရပ်ကွက်အမှတ်(၂၃)မေယုလမ်း၊ စက်မှုဇုန်-၁၊ ",
  },
  {
    ID: 516,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. WANG GENQUAN",
    "Name of Principal Organization": "WEDTEX INDUSTRIAL (HK) CO., LTD. ",
    "Place of Incorporation": "HONG KONG",
    "Company Name In Myanmar": "JERRY TEXTILE COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1206/2016",
    "Permit Date": "2016-12-23T09:05:10Z",
    "Meeting Number": "23/2016",
    "Meeting Date": "2016-12-17T09:05:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF LACE FABRIC, PRINT FABRIC, EMBROIDERY AND GARMENT ACCESSORIES ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 5,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW NANG MYA SEIN",
    "Land Area (units not specified in file)": 1.032,
    "Lease Term": 30,
    "Annual Lease Fee": 0.02,
    "Land Use Premium": null,
    "Number Of Local Employees": 168,
    "Number Of Foreign Employees": 12,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.1, YUAN SHAN BEI ROAD, CHANG PING, DONGGUAN CITY, GUANGDONG PROVINCE, REPUBLIC OF CHINA",
    "Organization Address":
      "UNIT 1111, 11/F, TRENDY CENTRE, 682/684 CASTLE PEAK ROAD, KOWLOON, HONG KONG",
    "Investment Permitted Address":
      "PLOT NO. 210, MYAY TAING BLOCK NO. 25, SHWE LIN BAN SETHMU MYO, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 518,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Xu Huajie",
    "Name of Principal Organization": "Ningbo Seduno Holding Co.,Ltd",
    "Place of Incorporation": "Peoples' Republic of China",
    "Company Name In Myanmar": "Seduno ( Myanmar) Fashion Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "899",
    "Permit Date": "2015-02-04T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.08,
    "Total Amount Of Capital (in Millions)": 2.08,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Tin Tun @ U YeAmain",
    "Land Area (units not specified in file)": 2.341,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 526,
    "Number Of Foreign Employees": 13,
    Status: "Submitted",
    "Investor Address":
      "Room 702, No.13, Lane 175, Nanyanwu Street, Jiangdong District, Ningbo City , Zhejiang Province, China",
    "Organization Address":
      "Guxi Road, Gulin Town, Yinzhou District, Ningbo City, Zhejiang Province , China",
    "Investment Permitted Address":
      "Plot No.K-7, Myay Taing Block No.20, Anawyahta Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 524,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "DAW SU WAI HNIN",
    "Name of Principal Organization":
      "SU MYAT MINGALAR TRADING COMPANY LIMITED",
    "Place of Incorporation": "MYANMAR",
    "Company Name In Myanmar": "SKP INTERFOOD COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1181/ 2016",
    "Permit Date": "2016-10-24T00:00:00Z",
    "Meeting Number": "18/2016",
    "Meeting Date": "2016-09-23T09:26:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF CORM SNACK, PRAWN SNACK AND ASSORTED SNACKS",
    "Amount Of Foreign Capital USD (in Millions)": 0.768,
    "Total Amount Of Capital (in Millions)": 1.397,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "DAW KYI KYI SEIN",
    "Land Area (units not specified in file)": 0.509,
    "Lease Term": 30,
    "Annual Lease Fee": 0.010299,
    "Land Use Premium": null,
    "Number Of Local Employees": 200,
    "Number Of Foreign Employees": 7,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. C 6, MAYKHAWADI STREET, MAYKHA GARDEN HOUSING, THINGANGYUN TOWNSHIP, YANGON",
    "Organization Address":
      "NO.214, SEIKKAN THAR STREET, MIDDLE BLOCK, WARD NO.7, KYAUKTADA TOWNSHIP, YANGON REGION",
    "Investment Permitted Address":
      "PLOT NO -205+208, MYAY TAING BLOCK NO. 144, SOUTH DAGON INDUSTRIAL ZONE , DAGON MYOTHIT (SOUTH) TOWNSHIP, YANGON REGION",
  },
  {
    ID: 527,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. SONG, BO ",
    "Name of Principal Organization":
      "RICHLAND (HONG KONG) INTERNATIONAL CO. LTD.",
    "Place of Incorporation": "HONG KONG",
    "Company Name In Myanmar":
      "DONG YUAN RICHLAND FASHION (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1216/2017",
    "Permit Date": "2017-01-11T00:00:00Z",
    "Meeting Number": "1/2017",
    "Meeting Date": "2017-01-06T04:41:23Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 3.87,
    "Total Amount Of Capital (in Millions)": 3.87,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW ARR KYI @ DAW PYONE NWE",
    "Land Area (units not specified in file)": 5,
    "Lease Term": 30,
    "Annual Lease Fee": 0.101,
    "Land Use Premium": null,
    "Number Of Local Employees": 1000,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address":
      "UNIT A (RM 9) , 3/F CHENG SUN TOWER, 116-118 WING LOK STR. SHEUNG WAN, HONG KONG",
    "Organization Address":
      "UNIT A (RM 9), 3/F CHENG SUN TOWER, 116-118 WING LOK STR, SHEUNG WAN , HONG KONG",
    "Investment Permitted Address":
      "HOLDING NO. 53/GA, 1002 MI CHAUNG AING KWIN, KYAUKKADIN VILLAGE TRACT, HLEGU TOWNSHIP, YANGON REGION",
  },
  {
    ID: 528,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zahir, Wahab",
    "Name of Principal Organization": "Newmann Engineering PVT Ltd. ",
    "Place of Incorporation": "India",
    "Company Name In Myanmar": "Myanmar Smelting & Refining Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "956/2015",
    "Permit Date": "2015-05-22T00:00:00Z",
    "Meeting Number": "8/2015",
    "Meeting Date": "2015-05-08T08:24:09Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Lead and Alloys, Plastic Chips or Granules From Smelting and Refining of All Non-Ferrous Metals &raw Material (Waste Acid Lean, Batteries, Lead Scrap, Aluminium Scrap, Etc)",
    "Amount Of Foreign Capital USD (in Millions)": 2.563,
    "Total Amount Of Capital (in Millions)": 2.563,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "India",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Lin",
    "Land Area (units not specified in file)": 2.383,
    "Lease Term": 10,
    "Annual Lease Fee": 0.048,
    "Land Use Premium": null,
    "Number Of Local Employees": 81,
    "Number Of Foreign Employees": 8,
    Status: "Monitoring Approved",
    "Investor Address":
      "Brindaban Garden, A4 2 nd Floor, 98 Chirstopher Road, Kolkata-46, Republic of India",
    "Organization Address":
      "NO. 1, A.J.C BOSE ROAD, 4TH FLOOR, KOLKATA-700020,  WEST   \tBENGAL, REPUBLIC OF INDIA",
    "Investment Permitted Address":
      "Plot No.(200), Myaungtakar Industerial Zone., Mawbi, YANGON",
  },
  {
    ID: 536,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Moe San Aung ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Marga Landmark Development Co., Ltd ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "684/2014",
    "Permit Date": "2014-12-03T00:00:00Z",
    "Meeting Number": "684/2014",
    "Meeting Date": "2014-12-01T09:02:52Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Hotet, Residence, Service Apartment , Office, Retail  B.O.T ",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 0,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Ministry of Defend ",
    "Land Area (units not specified in file)": 22.032,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 319,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "May Taing No(61), No(1), Mawtawyin Tatyin , Kabar Aye Road ",
  },
  {
    ID: 540,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Khin Soe",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Apex Airline Public Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "MaNaTha-1003/2014",
    "Permit Date": "2014-10-31T00:00:00Z",
    "Meeting Number": "24/2014",
    "Meeting Date": "2014-10-17T09:11:03Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "ပြည်တွင်း၊ ပြည်ပ လေကြောင်းသယ်ယူပို့ဆောင်ရေးလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 147.76,
    "Total Amount Of Capital (in Millions)": 147841.04,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Transport and Communications",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 219,
    "Number Of Foreign Employees": 41,
    Status: "Submitted",
    "Investor Address":
      "အမှတ် (၂၁၃) ၊ ဓမ္မစေတီလမ်း၊ ရွှေတောင်ကြား(၂) ရပ်ကွက်၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Season of Yangon, Ground Floor, Yangon International Airport Hotel ,International Airport, , Mingalardon Township, YANGON",
  },
  {
    ID: 541,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Aye Mon Khin",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Mora International Company Limited (မိုရာ အင်တာနေရှင်နယ် ကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1103/2015",
    "Permit Date": "2015-11-19T00:00:00Z",
    "Meeting Number": "20/2015",
    "Meeting Date": "2015-11-13T05:29:14Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် ဆံပင်တုထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 108.846,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Sein Tun , Daw Aye Aye",
    "Land Area (units not specified in file)": 0.965,
    "Lease Term": 10,
    "Annual Lease Fee": 96,
    "Land Use Premium": null,
    "Number Of Local Employees": 174,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် (၅၇၇)၊ ငုဝါလမ်း၊ ကစင်ရပ်ကွက်၊ ရွှေလင်ပန်းကျေးရွာ၊ လှိုင်သာယာမြို့နယ်၊ ရန်ုကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၅၂)၊ မြေတိုင်းရပ်ကွက်အမှတ် အပိုင်း(၅), လှိုင်သာယာစက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 545,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. ONG CHU TEK ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "CMI ENGINEERING COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1234/2017",
    "Permit Date": "2017-01-27T00:00:00Z",
    "Meeting Number": "2/2017",
    "Meeting Date": "2017-01-21T07:28:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND SALE OF SWITCHBOARD, ELECTRICAL CONTROL BOX, SHEET METAL PARTS & STEEL RECIEVER",
    "Amount Of Foreign Capital USD (in Millions)": 3.39,
    "Total Amount Of Capital (in Millions)": 4.24,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "K & M CAPITAL CO., LTD.",
    "Land Area (units not specified in file)": 0.751,
    "Lease Term": 50,
    "Annual Lease Fee": 0.01,
    "Land Use Premium": null,
    "Number Of Local Employees": 46,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address": "109 CHUN TIN ROAD, SINGAPORE 599682",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 8, MYAY TAING BLOCK NO. 143/1, DAGON MYO THIT (SOUTH) TOWNSHIP, YANGON REGION",
  },
  {
    ID: 546,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Liu Yung-Lung ",
    "Name of Principal Organization":
      "Circle Tech Industrial  Enterprise Co., Ltd ",
    "Place of Incorporation": "Brunei Darussalam",
    "Company Name In Myanmar":
      "Circle Tech Industrial Enterprise Company Limited ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "854/2014",
    "Permit Date": "2014-12-18T00:00:00Z",
    "Meeting Number": "25/2014",
    "Meeting Date": "2014-10-25T05:18:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Assembling, Packing and Manufacturing of Mobile Phones ",
    "Amount Of Foreign Capital USD (in Millions)": 2.678,
    "Total Amount Of Capital (in Millions)": 2.678,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 4,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Brunei Darussalam",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaw Myint, Daw Ti Yaw Wah ",
    "Land Area (units not specified in file)": 0.256,
    "Lease Term": 20,
    "Annual Lease Fee": 12,
    "Land Use Premium": null,
    "Number Of Local Employees": 218,
    "Number Of Foreign Employees": 6,
    Status: "Approved",
    "Investor Address":
      "7 F, NO.11, LN 39, YONGZHEN ROAD, YONGHE  DISTRICT, NEW TAIPEI CITY 234, TAIWAN ",
    "Organization Address":
      "RM. 51, 5th  FLOOR, BRITANNIA HOUSE, JALAN CATOR BANDAR SERI BEGAWAN BS8811, NEGARA BRUNEI DARUSSALAM",
    "Investment Permitted Address":
      "PLOT NO.39/40/41/42, MYAY TAING BLOCK NO. 19/1, SHWE PAUKKAN INDUSTRIAL ZONE, NORTH OKKALAPA TOWNSHIP,  YANGON REGION",
  },
  {
    ID: 548,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Aung Myo Thant",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "DELTA YOMA Trading Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "MaNaTha-1237/2017",
    "Permit Date": "2017-04-11T00:00:00Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T04:51:53Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": " Hotel ",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 1459.2,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT",
    "Land Owner":
      "U Bo Bo Myo Thant, U Aung Aung Myo Thant, Daw Mon Mon Myo Thant",
    "Land Area (units not specified in file)": 0.072,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 45,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address": "No.4,Samone  Road, Dagon Township, Yangon",
    "Organization Address": "-",
    "Investment Permitted Address": "No.4,Samone  Road, Dagon Township, Yangon",
  },
  {
    ID: 550,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw Toe Nandar Tin",
    "Name of Principal Organization":
      "Anawa Devi fishing and General Trading Cooperative Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Anawa Devi Daiichi Joint Ventrue Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1046/2015",
    "Permit Date": "2015-11-19T00:00:00Z",
    "Meeting Number": "18/2015",
    "Meeting Date": "2015-10-23T05:29:51Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Fish fillet and Value Added Fishery Products By Normal System and Contract Processing System",
    "Amount Of Foreign Capital USD (in Millions)": 0.48,
    "Total Amount Of Capital (in Millions)": 0.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "Anawa Devi Fishing and Genereal Trading Co-operative Ltd.",
    "Land Area (units not specified in file)": 0.434,
    "Lease Term": 30,
    "Annual Lease Fee": 40000,
    "Land Use Premium": null,
    "Number Of Local Employees": 113,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.554, Ma Ma Oo Lane, Baho Street, West Gyogone, Insein Township, Yangon",
    "Organization Address":
      "Plot No. 136/A1, Myay Taing Block No 6E, Thin Baw Gyin Ward, Dawbone Township, Yangon Region",
    "Investment Permitted Address":
      "Plot No. 136/A1, Myay Tiang Block No. 6E. Thin Baw Gyin Ward, Dawbone Township, Yangon Region",
  },
  {
    ID: 559,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lim Chap Huat ",
    "Name of Principal Organization": "SB( Northpoint) Investment PTE . LTD ",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar": "Rose Hill Soilbuild Co., Ltd ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "799/2014",
    "Permit Date": "2014-09-18T00:00:00Z",
    "Meeting Number": "21/2014",
    "Meeting Date": "2014-08-15T02:02:18Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      " Construction and Operation of 24 Storey Luxury High Rise Building ",
    "Amount Of Foreign Capital USD (in Millions)": 40.65,
    "Total Amount Of Capital (in Millions)": 67.75,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Rose Hill Co., Ltd ",
    "Land Area (units not specified in file)": 45984,
    "Lease Term": 50,
    "Annual Lease Fee": 27.1,
    "Land Use Premium": null,
    "Number Of Local Employees": 583,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address": "53 Wilkinson Road,",
    "Organization Address": "25,Changi South Street 1, SB Building ",
    "Investment Permitted Address":
      "Plot No.59 D2/G1, 59D2/G3,59D2/I,59D2/G2,59D2/C,  Myay Taing Quarter No. 35 E4",
  },
  {
    ID: 560,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. DEJ  PATHANSETHPONG ",
    "Name of Principal Organization":
      "THONG  THAI  TEXTILE ( MYANARMR)CO., LTD.",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "THONG  THAI  TEXTILE ( MYANARMR)CO., LTD.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "676/2014",
    "Permit Date": "2014-12-03T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing  of  Garment   on  CMP  basis",
    "Amount Of Foreign Capital USD (in Millions)": 3.394,
    "Total Amount Of Capital (in Millions)": 3.394,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Thailand",
    "Form Of Investment": "FDII",
    "Land Owner": "Chu   International  Co.,  Ltd ",
    "Land Area (units not specified in file)": 1.061,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 642,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address": "36/42-43, SOI  KASAWMSAN 1, WANGMAI  ",
    "Organization Address":
      "PLOT  NO. 175, PANBE   KAUNG   MG   KHET   STREET, ",
    "Investment Permitted Address":
      "PLOT  NO. 175, PANBE   KAUNG   MG   KHET   STREET, ",
  },
  {
    ID: 561,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Robert Michael Jones ",
    "Name of Principal Organization": "Puma Energy Irrawaddy PTE. LTD ",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar": "Puma Energy Asia Sun Co., Ltd ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "748/2014",
    "Permit Date": "2014-07-24T00:00:00Z",
    "Meeting Number": "16/2014",
    "Meeting Date": "2014-06-13T04:28:35Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Construction of Jetty Facilities And Storage Tanks Providing Storage for Bitumen And Petroleum Products",
    "Amount Of Foreign Capital USD (in Millions)": 83,
    "Total Amount Of Capital (in Millions)": 86.4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Myanma Port Authority , Ministry of Transport",
    "Land Area (units not specified in file)": 37.06,
    "Lease Term": 50,
    "Annual Lease Fee": 0.36,
    "Land Use Premium": 1000000,
    "Number Of Local Employees": 41,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address": "25 Oriole Cres, Singapore 288618",
    "Organization Address": "1, Mrina Boulevard, # 28-00, Singapore 018989",
    "Investment Permitted Address": "Plot 3, Thilawa Port, ",
  },
  {
    ID: 563,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Thaung Htike Min ",
    "Name of Principal Organization": "Flying Tiger Engineering CO., Ltd ",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Prime Residence Company Limited ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "783/2014",
    "Permit Date": "2014-08-23T00:00:00Z",
    "Meeting Number": "20/2014",
    "Meeting Date": "2014-08-01T07:38:18Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Five Star Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": 96,
    "Total Amount Of Capital (in Millions)": 120,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Yangon Regional Department ",
    "Land Area (units not specified in file)": 3.028,
    "Lease Term": 50,
    "Annual Lease Fee": 400,
    "Land Use Premium": 14400000,
    "Number Of Local Employees": 166,
    "Number Of Foreign Employees": 7,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.62/E, Shwe Hin Thar Street, 11Th Ward, Hlaing Township, Yangon Myanmar",
    "Organization Address":
      "Olympic Tower, Room No.508, National Swimming Pool Compound , U Wisara Road ",
    "Investment Permitted Address":
      "Survey-Block No.14 (E),Strand Road., Kyauktada Township, YANGON",
  },
  {
    ID: 565,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဇေယျသူရမွန်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar Central Power Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "934/2013",
    "Permit Date": "2013-09-09T00:00:00Z",
    "Meeting Number": "20/2013",
    "Meeting Date": "2013-08-07T08:15:11Z",
    Sector: "Power",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် ၅၀ မဂ္ဂါဝပ် သဘာဝ ဓါတ်ငွေ သုံး စက်ရုံ တည်ဆောက်၍ လျှပ်စစ်ဓါတ်အား ဖြန့် ဖြူးရောင်းချခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 37.51,
    "Total Amount Of Capital (in Millions)": 44251.26,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner":
      "လျှပ်စစ်စွမ်းအား ဝန်ကြီးဌာန၊ မြန်မာ့ လျှပ်စစ် ဓါတ်အား လုပ်ငန်း",
    "Land Area (units not specified in file)": 6.2,
    "Lease Term": 30,
    "Annual Lease Fee": 25083.82,
    "Land Use Premium": 0,
    "Number Of Local Employees": 30,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်-၂၁/၁၆၊ ဦးဝိစာရအိမ်ယာ၊ ဦးဝိစာရလမ်း",
    "Organization Address": "-",
    "Investment Permitted Address": "လှော်ကားကြိုးဝိုင်းရှိ မြေ ၆.၂ ဧကခန့်၊ ",
  },
  {
    ID: 567,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. ZHANG CHUNWEI",
    "Name of Principal Organization": "SUNNY WORLD INT'L CORP.,",
    "Place of Incorporation": "British Virgin Islands",
    "Company Name In Myanmar": "EASTERN TERRANCE MANUFACTURE COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1164/2016",
    "Permit Date": "2016-09-19T00:00:00Z",
    "Meeting Number": "17/2016",
    "Meeting Date": "2016-09-09T08:38:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF VARIOUS KINDS OF BAGS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.85,
    "Total Amount Of Capital (in Millions)": 1.85,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Brunei Darussalam",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW MYINT MYINT KHIN",
    "Land Area (units not specified in file)": 2,
    "Lease Term": 50,
    "Annual Lease Fee": 0.008,
    "Land Use Premium": null,
    "Number Of Local Employees": 714,
    "Number Of Foreign Employees": 22,
    Status: "Amend",
    "Investor Address":
      "RM 51, 5th FLOOR, BRITANNIA HOUSE, JALAN CATOR, BANDAR SERI BEGAWAN BS 8811, NEGARA BRUNEI DARUSSALAM",
    "Organization Address":
      "P.O Box 957, Offshore Incorporations Center, Road Town, Tortola, British Virgin Islands",
    "Investment Permitted Address":
      "HOLDING NO. (48/1), KWIN NO. 115(KA), PAUKTAW KWIN, PAUKTAW VILLAGE TRACT, TWANTE TOWNSHIP, SOUTH YANGON DISTRICT, YANGON REGION",
  },
  {
    ID: 568,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. DING, CAIBIN",
    "Name of Principal Organization":
      "JIANGSU GUOTAI INTERNATIONAL GROUP GUOHUA CORP., LTD.",
    "Place of Incorporation": "CHINA",
    "Company Name In Myanmar": "GUOTAI GUOHUA GARMENT MYANMAR LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1177/2016",
    "Permit Date": "2016-10-21T00:00:00Z",
    "Meeting Number": "19/2016",
    "Meeting Date": "2016-10-07T05:49:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.21,
    "Total Amount Of Capital (in Millions)": 1.21,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Wai Wai Kyaw",
    "Land Area (units not specified in file)": 2.273,
    "Lease Term": 10,
    "Annual Lease Fee": 0.051,
    "Land Use Premium": null,
    "Number Of Local Employees": 950,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 2, YONG XIN, ZHEN CHANG, XIANTAO CITY, HUBEI PROVINCE, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address":
      "15-17F, GUOTAI BUILDING, MIDDLE RENMIN ROAD, YANGSHE, PEOPLE'S REPUBLIC OF CHINA",
    "Investment Permitted Address":
      "PLOT NO. 48, MYAY TAING BLOCK NO. 24, NGWE PIN LAL INDUSTRIAL ZONE, HLAING THAR YAR TONWSHIP, YANGON REGION",
  },
  {
    ID: 571,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. ZHANG, BUZHONG",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "JIA LONG PLASITC PRODUCTS (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1232/2017",
    "Permit Date": "2017-01-27T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF PLOY BAG AND RELATED PRODUCTS SUCH AS ELASITC BAND",
    "Amount Of Foreign Capital USD (in Millions)": 3.06,
    "Total Amount Of Capital (in Millions)": 3.06,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "DAW MARYI AR YA KYUN",
    "Land Area (units not specified in file)": 1.345,
    "Lease Term": 10,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 60,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "GROUP ONE OF FENG VILLAGE, ZUXI TWON OF KAI XIAN, CHONG QING CITY, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 256, MYAY TAING BLOCK NO. 25, SHWE LIN BAN STEHMU MYO, HLAING THARYAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 573,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဟိန်းမင်းခန့်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "True Faith Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "854/2012",
    "Permit Date": "2012-07-18T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အထည် အမျိုးမျိုး ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 189.33,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address": "အမှတ်-၁၇၂၊ သုဓမ္မာ-၁၀ လမ်း၊ သုမင်္ဂလာအိမ်ယာ ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၅၈၊ ၅၉၊ ၆၀၊ ၇၃၊ ၇၄၊ ၇၅၊ မြေတိုင်းရပ်ကွက်အမှတ်-၁၈၊ ရေွှပေါက်ကံ စက်မှုဇုန်",
  },
  {
    ID: 575,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LAN, XIAOYONG",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "TIAN CHENG PEN JIAO MIAN (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1255/2017",
    "Permit Date": "2017-04-11T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND SALES OF SYNTHETIC RESIN FOR CLOTHING SUCH AS JACKET AND WARM COAT",
    "Amount Of Foreign Capital USD (in Millions)": 1.97,
    "Total Amount Of Capital (in Millions)": 1.97,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "U MAUNG WIN @ YO EIT PHE",
    "Land Area (units not specified in file)": 1.001,
    "Lease Term": 10,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 118,
    "Number Of Foreign Employees": 12,
    Status: "Submitted",
    "Investor Address":
      "LIAO NING SHENG, DA LIAN SHI, ZHON SHAN QU, AHONG NAN LU, ZHONG JING YUAN , NO. FOUR 1-4-4, PEIOPLE'S REPUBLIC OF CHINA",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 34, MYAY TAING BLOCK NO. PART-4, INDUSTRIAL ZONE, HLAING THARYAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 577,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Tam Chi Wah Terry",
    "Name of Principal Organization":
      "i-Land Industrial Park Holding Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "i-Land Park Myanmar Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1028/2015",
    "Permit Date": "2015-11-11T06:01:40Z",
    "Meeting Number": "17/2015",
    "Meeting Date": "2015-09-28T02:41:17Z",
    Sector: "Industrial Estate",
    "Type Of Investment Business": "Development of Industrial Estate",
    "Amount Of Foreign Capital USD (in Millions)": 8,
    "Total Amount Of Capital (in Millions)": 10,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner":
      "Managing Director Daw Tawe Tawe Kyi of  Worldwide Infinity Myanmar Co., Ltd,  ",
    "Land Area (units not specified in file)": 182,
    "Lease Term": 50,
    "Annual Lease Fee": 0.021,
    "Land Use Premium": null,
    "Number Of Local Employees": 69,
    "Number Of Foreign Employees": 4,
    Status: "Amend",
    "Investor Address": "61 Pasir Ris Grove, No.09-04",
    "Organization Address": "20 sin Ming Lane, 06-68 Midview City",
    "Investment Permitted Address":
      " No-72. Room-406, Conner of Chindwin street and U Weizarya street, 11 Ward, Kamaryut Township, Yangon.",
  },
  {
    ID: 578,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးသိန်းထွန်း",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Gloden Myanmar Airlines Public Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "877/2013",
    "Permit Date": "2013-01-09T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Other Services",
    "Type Of Investment Business":
      "လေကြောင်းသယ်ယူပို့ ဆော​င် ရေး လုပ်ငန်းဆိုင်ရာ ဝန်ဆောင်မှု လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.31,
    "Total Amount Of Capital (in Millions)": 21250,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address": "အမှတ်-၅၂/ခ၊  ရေွှ တောင်ကြားရပ်ကွက်",
    "Organization Address": "-",
    "Investment Permitted Address":
      "ရန်ကုန်အပြည်ပြည်ဆိုင်ရာလေဆိပ်နှင့် မန္တလေး အပြည်ပြည်ဆိုင်ရာလေဆိပ်",
  },
  {
    ID: 582,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Managing Director , Public  WOrks ",
    "Name of Principal Organization": "Public  WOrks",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Chiyoda& Public  WOrks Co., Ltd ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "640/2013",
    "Permit Date": "2013-06-12T00:00:00Z",
    "Meeting Number": "640/2013",
    "Meeting Date": "2013-06-01T06:04:38Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Office Rental Services ",
    "Amount Of Foreign Capital USD (in Millions)": 6.5,
    "Total Amount Of Capital (in Millions)": 6.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 49,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address": "Office Building(11), ",
    "Organization Address": "Office Building No(11)",
    "Investment Permitted Address": "No(60), Shwe Dagon  Pagoda  Road ",
  },
  {
    ID: 585,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Myin",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Aurea Hotel & Services Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "Ma Na Tha-1226/2016",
    "Permit Date": "2016-12-20T00:00:00Z",
    "Meeting Number": "23/2016",
    "Meeting Date": "2016-12-17T02:04:27Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "BOT System  Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 1200,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT",
    "Land Owner": "Directorate of Hotels & Tourism",
    "Land Area (units not specified in file)": 3.938,
    "Lease Term": 50,
    "Annual Lease Fee": 72,
    "Land Use Premium": 21,
    "Number Of Local Employees": 82,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "No.(12-X), Pathain Road,  Mya Kan Thar Garden Housing,  No.14 Quarter, Hlaing Township, Yangon",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No.(12-X), Pathain Road,  Mya Kan Thar Garden Housing,  No.14 Quarter, Hlaing Township, Yangon",
  },
  {
    ID: 586,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Yan Min",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Dynamic Prosperity Plastic Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "MaNaTha-1011/2014",
    "Permit Date": "2014-11-06T00:00:00Z",
    "Meeting Number": "23/2014",
    "Meeting Date": "2014-10-10T08:52:59Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ Plastic Shopping Bags များထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 5.31,
    "Total Amount Of Capital (in Millions)": 5095.76,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "First Top Co.,Ltd.",
    "Land Area (units not specified in file)": 4.029,
    "Lease Term": 20,
    "Annual Lease Fee": 15000000,
    "Land Use Premium": null,
    "Number Of Local Employees": 300,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၇၉၀)၊ အခန်း (၃၀၃) ၊ ( ၉) ရပ်ကွက် ၊ ဗိုလ်ချုပ်လမ်း၊ လမ်းမတော်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "-",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ လှိုင်သာယာမြို့နယ်၊ လှိုင်သာယာ စက်မှုဇုန် (၄) ၊ မြေကွက်အမှတ် (၅၀၊၅၁) ရှိမြေဧရိယာ ၄.၀၂၉ ဧက",
  },
  {
    ID: 587,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ooi Wee Tat",
    "Name of Principal Organization": "AA Corporation ",
    "Place of Incorporation": "Vietnam",
    "Company Name In Myanmar": "AA Interiors Myanmar Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1039/2015",
    "Permit Date": "2015-11-11T00:00:00Z",
    "Meeting Number": "18/2015",
    "Meeting Date": "2015-10-23T04:57:03Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Modern Household Wooden Furnitures  and Wooden Interior House Decorations",
    "Amount Of Foreign Capital USD (in Millions)": 0.664,
    "Total Amount Of Capital (in Millions)": 0.664,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Vietnam",
    "Form Of Investment": "FDII",
    "Land Owner": "Mermaid Smile Co., Ltd.",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 0,
    "Annual Lease Fee": 0.072,
    "Land Use Premium": null,
    "Number Of Local Employees": 130,
    "Number Of Foreign Employees": 25,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.123B, Room No. 1402, Estella Building, HA Noi Highway an Phu Ward, District 02",
    "Organization Address":
      "15-Nguyen Duy Hieu Street, Thao Dien Ward  District 02",
    "Investment Permitted Address":
      "No.20,U Phoe Hlaing Street,Industrial Zone(1)., Dagon(seikkan), YANGON",
  },
  {
    ID: 588,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U HTAY WIN @ U HOTE",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "SONHA MYANMAR INTERNATIONAL LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1178/2016",
    "Permit Date": "2016-10-21T00:00:00Z",
    "Meeting Number": "19/2016",
    "Meeting Date": "2016-10-07T05:04:23Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF STEEL TANK AND PLASTIC TANK ",
    "Amount Of Foreign Capital USD (in Millions)": 1.52,
    "Total Amount Of Capital (in Millions)": 1.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 24,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Vietnam",
    "Form Of Investment": "JV",
    "Land Owner": "U HTAY WIN @ U HOTE",
    "Land Area (units not specified in file)": 0.33,
    "Lease Term": 40,
    "Annual Lease Fee": 0.04,
    "Land Use Premium": null,
    "Number Of Local Employees": 72,
    "Number Of Foreign Employees": 7,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 33/B, DAMARYONE STREET, WARD NO. 15, BAUKHTAW, YANKIN TOWNSHIP, YANGON",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 266, 267, MYAY TAING BLOCK NO. 23, INDUSTRIAL ZONE (1), DAGON MYO THIT (SOUTH) TOWNSHIP, YANGON REGION",
  },
  {
    ID: 594,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U MYINT HTAY WIN",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "MJ PARKVIEW HEALTHCARE LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1244/2017",
    "Permit Date": "2017-04-11T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "2017-03-13T09:22:27Z",
    Sector: "Other Services",
    "Type Of Investment Business": "PRIVATE HOSPITAL SERVICES",
    "Amount Of Foreign Capital USD (in Millions)": 104.663,
    "Total Amount Of Capital (in Millions)": 149.519,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "DAW MOE MOE ",
    "Land Area (units not specified in file)": 2.3,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 451,
    "Number Of Foreign Employees": 9,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 126 (A), KABARAYE PAGODA ROAD, BAHAN TOWNSHIP, YANGON",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 7(D1)+ 1+ 2(B)+ 3+4+9+10(B)+11+17(A2)+22(B2), MYAY TAING BLOCK NO. (30,31), HLAING TOWNSHIP, YANGON REGION",
  },
  {
    ID: 595,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Ramya Sanath Amaraweera Wickramasingha",
    "Name of Principal Organization": "Ceylon Biscults Limited",
    "Place of Incorporation": "Sri Lanka",
    "Company Name In Myanmar": "CBL Myanmar Private Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "846/2014",
    "Permit Date": "2014-10-31T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Processing And Packaging of Fruit Products  Including Coconut Products",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1.25,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 24,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Sri Lanka",
    "Form Of Investment": "JV",
    "Land Owner": "U Thein Win @ Kyar Pauak",
    "Land Area (units not specified in file)": 2.438,
    "Lease Term": 5,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 92,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address": "11, Arthurs Place, Dehiwala, Sri Lanka",
    "Organization Address":
      " P.O . Box. 3, High Level Road, Makumbura, Pannipitiya, Sri Lanka",
    "Investment Permitted Address":
      "Plot No.4, Myay Taing Block No.25, Shwe Lin Pan Industrial Zone, Hlaing Thar Yar Township , Yangon Region",
  },
  {
    ID: 602,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Maung Maung",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Universal Cold Store (Yangon) Industrial Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "MaNaTha-1127/2016",
    "Permit Date": "2016-02-20T00:00:00Z",
    "Meeting Number": "Ma Na Tha-1127/2016",
    "Meeting Date": "2016-02-01T04:04:55Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business": "Contract Processing system",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 827.25,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Maung Maung",
    "Land Area (units not specified in file)": 1.869,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 83,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address":
      "No-(244/266),Room-(601), 6- Floor, Bo Aung Kyaw Tower, Bo Aung Kyaw Road, BotaHtaung Township,Yangon",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Yangon, Hlaing Thar Yar Township, Silver Sea Industrial Zone, Myay Taing Blocth No.(24), Myay Kwat No.(38) Myay Area (1.869) Acres",
  },
  {
    ID: 609,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. TEO CHENG SIM ",
    "Name of Principal Organization": "PROPERTIES OUTSHINE PTE., LTD. ",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar": "NEW STRAND DEVELOPMENT COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1118/2016",
    "Permit Date": "2016-03-29T00:00:00Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T03:25:15Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "CONSTRUCTION, LEASING AND MANAGEMENT OF COMMERCIAL OFFICE/ RETAIL AND HOTEL/ SERVICED APARTMENT",
    "Amount Of Foreign Capital USD (in Millions)": 98.7,
    "Total Amount Of Capital (in Millions)": 105,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "MYANMAR ECONOMIC CORPORATION (MEC)",
    "Land Area (units not specified in file)": 1.366,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 504,
    "Number Of Foreign Employees": 14,
    Status: "Approved",
    "Investor Address": "361 HOUGANG AVENUE 5 ~ 04-308 SINGAPORE 530361",
    "Organization Address": "9 LOYANG WAY ~ 05-01 KRISLITE BUILDING, SINGAPORE",
    "Investment Permitted Address":
      "NO.1, AHLONE INTERNATIONAL PORT, CARGO TERMINAL PORT, AHLONE TOWNSHIP, YANGON REGION",
  },
  {
    ID: 610,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yuttana Srimahajariyaphone",
    "Name of Principal Organization":
      "The Concrete Products and Aggregate Co., Ltd.",
    "Place of Incorporation": "Thailand",
    "Company Name In Myanmar": "SCG Myanmar Concrete and Aggregate Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "987/2015",
    "Permit Date": "2015-08-06T00:00:00Z",
    "Meeting Number": "13/2015",
    "Meeting Date": "2015-07-17T10:03:10Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production and Marketing of Concrete, Ready-Mixed Concrete, Precast Concrete, Reinforced Concrete, Pre-Stressed Concrete and Post Tensioned Product (SCG Brand)",
    "Amount Of Foreign Capital USD (in Millions)": 4.66,
    "Total Amount Of Capital (in Millions)": 5.83,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "U Sein Win",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 10,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 241,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address":
      "72/338  MOO 8,  BANG KRASO,  MUANG  NONTHABURI,  \tNONTHABURI,  THAILAND",
    "Organization Address":
      "1516 PRACHARAT 1 ROAD,  BANGSUE,  BANGKOK 10800, THAILAND",
    "Investment Permitted Address":
      "PLOT  NO. 42,   MYAY  TAING \tBLOCK  24, NGWE  PIN  LAE  INDUSTRIAL  ZONE , HLAING  THARYAR  \tTOWNSHIP, YANGON   REGION",
  },
  {
    ID: 611,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Ok Kar",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "OYC Asia Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "MaNaTha-1193/2016",
    "Permit Date": "2016-07-06T00:00:00Z",
    "Meeting Number": "12/2016",
    "Meeting Date": "2016-06-27T03:20:36Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.049,
    "Total Amount Of Capital (in Millions)": 141.179,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Aung Myint",
    "Land Area (units not specified in file)": 0.183,
    "Lease Term": 10,
    "Annual Lease Fee": 24,
    "Land Use Premium": null,
    "Number Of Local Employees": 203,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "No-161, Mahar Swe (2) Road, 42 Quarter, Dagon( North) Township, Yangon",
    "Organization Address": "-",
    "Investment Permitted Address":
      " Plot No. 2973, Myay Taing Block No 63/Extend, Industrial Zone, Dagon Myothit (South)  Township, Yangon Region ",
  },
  {
    ID: 612,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ajay Kumar Dhar",
    "Name of Principal Organization": "Woodcraft International Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Global Woodcraft Industries Ltd,",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1048/2015",
    "Permit Date": "2015-11-19T00:00:00Z",
    "Meeting Number": "20/2015",
    "Meeting Date": "2015-11-13T04:14:37Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Hardwood Veneer and Teak Veneer",
    "Amount Of Foreign Capital USD (in Millions)": 3.75,
    "Total Amount Of Capital (in Millions)": 7.51,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Department of Urban and Housing Development",
    "Land Area (units not specified in file)": 3.501,
    "Lease Term": 30,
    "Annual Lease Fee": 0.085,
    "Land Use Premium": null,
    "Number Of Local Employees": 277,
    "Number Of Foreign Employees": 25,
    Status: "Terminated",
    "Investor Address": "55 Merryn Road ",
    "Organization Address": "143, Cecil Steet, #07-00 GB Building ",
    "Investment Permitted Address":
      "Plot No. 50(B), & 51, Myay Taing Block No. Part -3, Hlanig Tharyar Industrial Zone",
  },
  {
    ID: 613,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Luo Xindong ",
    "Name of Principal Organization":
      "Toener International  (Hong Kong) Investrment Group Ltd.",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Golden Thitsar Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1062/2016",
    "Permit Date": "2016-01-19T00:00:00Z",
    "Meeting Number": "23/2015",
    "Meeting Date": "2016-12-28T04:10:17Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Construction, Leasing and Management of Shop and residential Buildings",
    "Amount Of Foreign Capital USD (in Millions)": 36.89,
    "Total Amount Of Capital (in Millions)": 64.72,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Than Than Kyi ",
    "Land Area (units not specified in file)": 2.209,
    "Lease Term": 50,
    "Annual Lease Fee": 0.446,
    "Land Use Premium": 0,
    "Number Of Local Employees": 48,
    "Number Of Foreign Employees": 7,
    Status: "Monitoring Approved",
    "Investor Address":
      "2-7-301, Yin Du garden, No.8, Xinguang Road, chengdu, Sichuan Province, China",
    "Organization Address":
      "Room 2807,28/F, PaulY Center, 51 Hung To Road, kwun Tong, Gowloon, Hong Kong",
    "Investment Permitted Address":
      "Myay Taing Block No .37 Plod No.8,9,10,13, No.28, Kanbe Butayone Road",
  },
  {
    ID: 615,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. YAN, FENG",
    "Name of Principal Organization": "ETERNAL EASE DEVELOPMENT LIMITED",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "ETERNAL EASE (MYANMAR) GARMENT LIMITED ",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1161/2016",
    "Permit Date": "2016-09-19T00:00:00Z",
    "Meeting Number": "17/2016",
    "Meeting Date": "2016-09-09T09:22:51Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENTS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 4.55,
    "Total Amount Of Capital (in Millions)": 4.55,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U NYO WIN",
    "Land Area (units not specified in file)": 2.841,
    "Lease Term": 50,
    "Annual Lease Fee": 0.06,
    "Land Use Premium": null,
    "Number Of Local Employees": 1119,
    "Number Of Foreign Employees": 19,
    Status: "Monitoring Approved",
    "Investor Address":
      "11F, AXA CENTRE, 151 GLOUCESTER ROAD, WANCHAI, HONG KONG",
    "Organization Address":
      "11F, AXA CENTRE, 151 GLOUCESTER ROAD, WANCHAI, HONG KONG",
    "Investment Permitted Address":
      "PLOT NO. 133, MYAY TAING BLOCK NO. 51, THARDUKAN INDUSTRIAL ZONE, SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 616,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. MOHAMAD KHALED EL HAFFAR EL HABBAL ",
    "Name of Principal Organization": "LINFRA SOUTH EAST ASIA (HOLDING) SAL",
    "Place of Incorporation": "LEBANON",
    "Company Name In Myanmar": "LINFRA LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1201/2016",
    "Permit Date": "2016-12-11T03:57:28Z",
    "Meeting Number": "22/2016",
    "Meeting Date": "2016-12-01T08:53:37Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "POWER SYSTEM INSTALLATION AND MAINTENANCE OF TELECOMMUNICATION EQUIPMENT SERVICE",
    "Amount Of Foreign Capital USD (in Millions)": 12.98,
    "Total Amount Of Capital (in Millions)": 12.98,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Lebanon",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Khin Khin Lay",
    "Land Area (units not specified in file)": 1.989,
    "Lease Term": 3,
    "Annual Lease Fee": 1224,
    "Land Use Premium": null,
    "Number Of Local Employees": 265,
    "Number Of Foreign Employees": 49,
    Status: "Amend",
    "Investor Address":
      "OMAR DAOUK ST., MINA EI HOSN, DAOUK BUILDING, 1st FLOOR, P.O. BOX 113-5300, BEIRUT CENTRAL DISTRICT, REPUBLIC OF LEBANON",
    "Organization Address":
      "OMAR DAOUK  ST, MINA EI HOSN, DAOUK BUILDING, 1st FLOOR, P. O. BOX 113-5300, BEIRUT CENTRAL DISTRICT, LEBANON",
    "Investment Permitted Address":
      "PLOT NO. 26, MYAY TAING BLOCK NO. ZONE(1) HLAING THAR YAR TOWNSHIP, YANGON",
  },
  {
    ID: 624,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. SUNDDARARAMAN  CHANDRASHEKAR",
    "Name of Principal Organization": "GOLDEN LOTUS SERVICES (S) PTE LTD.,",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar": "PIONEER ASIAN SPECIALTY CLINICS LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1245/2017",
    "Permit Date": "2017-04-11T00:00:00Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T04:29:54Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "EYE CARE CLINIC INCLUDING EYE CARE TREATMENT & OTHER RELATED SERVICES",
    "Amount Of Foreign Capital USD (in Millions)": 1.125,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "U THEIN LWIN",
    "Land Area (units not specified in file)": null,
    "Lease Term": 50,
    "Annual Lease Fee": 0.042,
    "Land Use Premium": null,
    "Number Of Local Employees": 23,
    "Number Of Foreign Employees": 17,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 9, AGASTHIAR EAST STREET, AMBASAMUDRAM(PO), TIRUNEVELI (DT) TAMILNADU, INDIA -627401",
    "Organization Address":
      "654C JURONG WEST, STREET 61, #08-476, SINGAPORE (643654)",
    "Investment Permitted Address":
      "NO. 95, GROUND FLOOR ROOM NO. 001, 002, 003, 004, FIRST FLOOR ROOM NO. 101, 102, 103, 104, CORNER OF 52nd STREET AND ANAWRAHTA ROAD, WARD (1), PAZUNADAUNG TOWNSHIP, YANGON REGION",
  },
  {
    ID: 630,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Hajime Okano",
    "Name of Principal Organization": "Singapore Panatex Trading Co., Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Yangon Panatex Apparel Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1095/2016",
    "Permit Date": "2016-02-29T00:00:00Z",
    "Meeting Number": "6/2016",
    "Meeting Date": "2016-02-22T09:25:52Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.5,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "Parimala Devi (a) Nilar Aung ",
    "Land Area (units not specified in file)": 0.96,
    "Lease Term": 5,
    "Annual Lease Fee": 240,
    "Land Use Premium": null,
    "Number Of Local Employees": 102,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address": "No.1459, Xinjinqiao Road, Pudong ",
    "Organization Address":
      "SINGAPORE  PANATEX TRADING CO., PTE. LTD., NO.80, RAFFLES PLACE, #33-00 UOB PLAZA, SINGAPORE 048624",
    "Investment Permitted Address":
      "PLOT NO. 4, MYAY TAING BLOCK NO. NGA 12, THARDUKAN   INDUSTRIAL   ZONE,  SHWE PYI THAR   TOWNSHIP, YANGON REGION",
  },
  {
    ID: 631,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Jai Prakash Bhartia ",
    "Name of Principal Organization": "B.S  Progressive PVT LTD.",
    "Place of Incorporation": "India",
    "Company Name In Myanmar": "Austinply Myanmar Private Limited ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "648/2013",
    "Permit Date": "2013-12-27T00:00:00Z",
    "Meeting Number": "30/2013",
    "Meeting Date": "2013-11-26T09:26:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing  and  Marketing  of  Veneer and Plywood",
    "Amount Of Foreign Capital USD (in Millions)": 4,
    "Total Amount Of Capital (in Millions)": 4765,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 30,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "U  Win Zaw oo ",
    "Land Area (units not specified in file)": 8,
    "Lease Term": 30,
    "Annual Lease Fee": 172608,
    "Land Use Premium": null,
    "Number Of Local Employees": 275,
    "Number Of Foreign Employees": 32,
    Status: "Terminated",
    "Investor Address":
      "20,Mandeville Garden, Flat No.3-D,Kolkata-700019, India ",
    "Organization Address":
      "3A, Pollock Street, 1 st Floor, Kolkata-700019, India  ",
    "Investment Permitted Address":
      "Plot No.60,61,62,69,70&71, Dagon Seik Kan Industrial Zone (2), Dagon Seik Kan Township, Yangon ",
  },
  {
    ID: 633,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Thein Han Kyi",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar Yi Jin Steel Structure Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1058/2016",
    "Permit Date": "2016-01-20T00:00:00Z",
    "Meeting Number": "22/2015",
    "Meeting Date": "2015-12-11T03:10:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Steel Structure Products",
    "Amount Of Foreign Capital USD (in Millions)": 1.68,
    "Total Amount Of Capital (in Millions)": 3.31,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner":
      "U Thein Han Kyi, U Sein Kyaw, U Yan Myint Shein, Daw Mait Shwin, Daw Wan Li Show (ka) Daw Khin Kyi ",
    "Land Area (units not specified in file)": 9.95,
    "Lease Term": 30,
    "Annual Lease Fee": 0.125,
    "Land Use Premium": null,
    "Number Of Local Employees": 96,
    "Number Of Foreign Employees": 14,
    Status: "Monitoring Approved",
    "Investor Address": "No.47, Bonyarna Street, Mayangone Township, Yangon",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No. K-3, and K-4, Myay Taing Block No.20, Anawrahtar Industrial Zone, ",
  },
  {
    ID: 634,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်မြင့်မြင့်ဝင်း",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Global Alliance Industrial And Production Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "851/2012",
    "Permit Date": "2012-07-11T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "စီးကရက်ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.62,
    "Total Amount Of Capital (in Millions)": 6682.47,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address": "အမှတ်-၁၂၆A၊ လမ်း ၂၀၊ ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၆၄၊ မြေတိုင်းရပ်ကွက်အမှတ်-၁၄၊ ရေွှသံလွင် စက်မှုဇုန်",
  },
  {
    ID: 635,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Shyam Daga",
    "Name of Principal Organization": "Archidply Industries Ltd.",
    "Place of Incorporation": "India",
    "Company Name In Myanmar": "Wartayar Veneer Industries Private Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "994/2015",
    "Permit Date": "2015-08-06T00:00:00Z",
    "Meeting Number": "12/2015",
    "Meeting Date": "2015-07-03T10:16:21Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Commercial face Veneer, Core Veneer, Sawn Timber, Teak Veneer & plywood",
    "Amount Of Foreign Capital USD (in Millions)": 2.96,
    "Total Amount Of Capital (in Millions)": 2.96,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "India",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Aye Aye Thwin",
    "Land Area (units not specified in file)": 4.018,
    "Lease Term": 30,
    "Annual Lease Fee": 0.011,
    "Land Use Premium": null,
    "Number Of Local Employees": 343,
    "Number Of Foreign Employees": 25,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.6/1, Flat No.315, Mangalaya Residencies, Benson Cross Road, Benson Town, Bangalore",
    "Organization Address":
      "No.29/2, G.K, Manor, 1st Floor, Nehru Nagar Circle Sheshadripuram, bangalore",
    "Investment Permitted Address":
      "Block No.(49),Plot No.(322/323), Corner of Than Din Street and Bo Taik Chun Street, WarTayar Industrial Zone., Shwepyithar, YANGON",
  },
  {
    ID: 638,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Aung Moe Kyaw ",
    "Name of Principal Organization": "APB Alliance Brewery Co., Ltd ",
    "Place of Incorporation": "The Republice of Union Of Myanmar",
    "Company Name In Myanmar": "Myanmar Alcobev LTD",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "773/2014",
    "Permit Date": "2017-07-18T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Distribution and Logistics of Beer and related products from APB Alliance Co., ltd",
    "Amount Of Foreign Capital USD (in Millions)": 3.45,
    "Total Amount Of Capital (in Millions)": 3.45,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "A&A International Co., Ltd ",
    "Land Area (units not specified in file)": 0.884,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 29,
    "Number Of Foreign Employees": 1,
    Status: "Draft",
    "Investor Address":
      "No.1, Aung Mingalar Street, Aung Theikdi Road, \n 3 Ward, ",
    "Organization Address": "R-18,S-19, Sittaung Street, Pyinnyawaddy Avenue",
    "Investment Permitted Address":
      "Plot No.66, Hlaing Thar Yar Industrial Zone (1)",
  },
  {
    ID: 641,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. DANIEL JOHN KINGHORN",
    "Name of Principal Organization": "BAYON GARMENT FACTORY CO., LTD.",
    "Place of Incorporation": "KINGDOM OF CAMBODIA",
    "Company Name In Myanmar": "MAR-TEX COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1217/2017",
    "Permit Date": "2017-01-11T00:00:00Z",
    "Meeting Number": "1/2017",
    "Meeting Date": "2017-01-06T04:04:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.905,
    "Total Amount Of Capital (in Millions)": 0.905,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Cambodia",
    "Form Of Investment": "FDII",
    "Land Owner": "U TUN LIN",
    "Land Area (units not specified in file)": 2.312,
    "Lease Term": 3,
    "Annual Lease Fee": 186,
    "Land Use Premium": null,
    "Number Of Local Employees": 1806,
    "Number Of Foreign Employees": 5,
    Status: "Approved",
    "Investor Address":
      "SKYLINE APARTMENT RM 205, NO. 1 (B), ST 21 SANGKAT TONLE BASSAC CHAMKARMORN. PHONM PENH, KINGDOM OF CAMBODIA",
    "Organization Address":
      "PHUM TOULKORK, SANGKAT TOULSANGKE, KHAN RUSSEYKEO, PHNOM PENH CITY, KINGDOM OF CAMBODIA",
    "Investment Permitted Address":
      "PLOT NO. 17, MYAY TAING BLOCK NO. (144) SOUTH DAGON TOWNSHIP, YANGON REGION",
  },
  {
    ID: 643,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Hla Wai",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Myat Min Company Limited (မြတ်မင်းကုမ္ပဏီလီမိတက်) ",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "Manatha 1112/2015",
    "Permit Date": "2015-12-31T00:00:00Z",
    "Meeting Number": "22/2015",
    "Meeting Date": "2015-12-11T06:42:52Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "၁၂ ထပ်ခွဲ Myat Min Tower တည်ဆောက်၍ ရုံးခန်းများ ငှားရမ်းခြင်း ဝန်ဆောင်မှု လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 12.65,
    "Total Amount Of Capital (in Millions)": 22000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Myat Min Co., Ltd.",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 36,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "အမှတ်-၅၆၊ ကမ္ဘာအေးဘုရားလမ်း၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No.(31), Shwe Hintha Road,(6 1/2)Miles, Hlaing, YANGON\n",
  },
  {
    ID: 644,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Jungho Jun",
    "Name of Principal Organization": "Toya INC ",
    "Place of Incorporation": "Korea",
    "Company Name In Myanmar": "Toyamyanmar Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1088/2016",
    "Permit Date": "2016-02-17T00:00:00Z",
    "Meeting Number": "4/2016",
    "Meeting Date": "2016-02-05T04:20:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.12,
    "Total Amount Of Capital (in Millions)": 1.12,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Nyunt Nyunt Htay",
    "Land Area (units not specified in file)": 2.19,
    "Lease Term": 10,
    "Annual Lease Fee": 0.047,
    "Land Use Premium": null,
    "Number Of Local Employees": 1021,
    "Number Of Foreign Employees": 15,
    Status: "Terminated",
    "Investor Address":
      "158-483 Kwang Meyong-Dong Kwang Meyong-SI,Gyonggi-Do, Korea",
    "Organization Address":
      "(Sindang-Don, Shinyong 703),  69, Dasan-Ro, Jung Gu ,Seoul , Korea",
    "Investment Permitted Address":
      "Holding No.65/2+66/Kha-1, Kwin No-664, Kywe Kya Kwin, Nyaung Kone Village Tract, Hmawbi Township, Yangon Region",
  },
  {
    ID: 645,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးရာဂျစ်ကူးမာရ်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Real Daimond Star Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "903/2013",
    "Permit Date": "2013-03-31T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် Internet Cable ၏ အပေါ်/အောက် ကာဘာနှင့် စတီးကြိုးများကို သီးခြားစီး ခွဲခြား၍ ဖြတ်တောက်စိတ်ပိုင်းပြီး ထုတ်ပိုးသည့် လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.003,
    "Total Amount Of Capital (in Millions)": 25,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address": "အမှတ်-၁၆၃/၂၁၀၊ နဝဒေးလမ်း၊ ၅-ရပ်ကွက်",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၄၁၊ မြေတိုင်းရပ်ကွက်အမှတ်-၁၈၊ တိုးချဲ့ စက်မှုဇုံ၊ ",
  },
  {
    ID: 649,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. NG WEE HIAN",
    "Name of Principal Organization": "BIESSIE CREATION PTE LTD.",
    "Place of Incorporation": "REPUBLIC OF SINGAPORE",
    "Company Name In Myanmar": "ARECA COLLECTION (MYANMAR) LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1249/2017",
    "Permit Date": "2017-04-11T00:00:00Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T04:26:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF FURNITURE & FIXTURE",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "GREAT SHWE TAUNG DEVELOPMENT CO., LTD.",
    "Land Area (units not specified in file)": 2.933,
    "Lease Term": 10,
    "Annual Lease Fee": 0.15,
    "Land Use Premium": null,
    "Number Of Local Employees": 72,
    "Number Of Foreign Employees": 8,
    Status: "Monitoring Approved",
    "Investor Address":
      "259, BUKIT PANJANG RING ROAD, # 10-22, S671259, SINGAPORE",
    "Organization Address":
      "45 JALAN KELULUT, SELETAR HILLS ESTATE, SINGAPORE 809062",
    "Investment Permitted Address":
      "No.C/3, Mya Khattar Street, Mya Sein Yaung Industroal Park, Hlaingtharyar, YANGON",
  },
  {
    ID: 652,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Kyw Tun Win",
    "Name of Principal Organization": "Agarwin Diamond Family Group Co.,Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Agarwin Keystone Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "887/2015",
    "Permit Date": "2015-01-06T00:00:00Z",
    "Meeting Number": "0/2014",
    "Meeting Date": "2014-08-17T05:51:39Z",
    Sector: "Agriculture",
    "Type Of Investment Business": "Plantation  And Production of Agarwood Oil",
    "Amount Of Foreign Capital USD (in Millions)": 1.2,
    "Total Amount Of Capital (in Millions)": 2.041,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 18,
    "Investing Country": "United States of America",
    "Form Of Investment": "JV",
    "Land Owner": "U Kyaw Tun Win and U Ohn Win",
    "Land Area (units not specified in file)": 20,
    "Lease Term": 0,
    "Annual Lease Fee": 1,
    "Land Use Premium": null,
    "Number Of Local Employees": 95,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address": "No.258, Bagayar Road , Sanchaung Township, Yangon",
    "Organization Address": "No.258, Bagayar Road , Sanchaung Township, Yangon",
    "Investment Permitted Address":
      "No.(258)Bagayar Road,Sanchaung Township,Yangon., Sanchaung, YANGON",
  },
  {
    ID: 654,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U SAI HTWE SEIN",
    "Name of Principal Organization": "SHS GLOBAL NETWORK CO., LTD.",
    "Place of Incorporation": "MYANMAR",
    "Company Name In Myanmar": "GLOBAL PAPER HOLDING COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1205/2016",
    "Permit Date": "2016-12-23T00:00:00Z",
    "Meeting Number": "23/2016",
    "Meeting Date": "2016-12-17T04:45:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF ALL KINDS OF PAPER ROLL",
    "Amount Of Foreign Capital USD (in Millions)": 3.93,
    "Total Amount Of Capital (in Millions)": 3.93,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "U SAI HTWE SEIN",
    "Land Area (units not specified in file)": 9.67,
    "Lease Term": 30,
    "Annual Lease Fee": 0.206,
    "Land Use Premium": null,
    "Number Of Local Employees": 254,
    "Number Of Foreign Employees": 15,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 1/ 30-A, TAW WIN YEIK THAR, TAWWIN STREET, QUARTER 4, MAYANGONE TOWNSHIP, YANGON",
    "Organization Address":
      "NO.71, 2nd STREET, YANGON INDUSTRIAL ZONE, MINGALADON GARDEN CITY, MINGALADON TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "HOLDING NO. 25, KWIN NO. 151 KYEE PIN KWIN, KYWE KU TRACT, HTANTAPIN TOWNSHIP, YANGON REGION",
  },
  {
    ID: 660,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Anshul Jain ",
    "Name of Principal Organization": "Swastik, Panels Private Limited ",
    "Place of Incorporation": "India",
    "Company Name In Myanmar": "Swastik Myanmar Industries Limited ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "871/2014",
    "Permit Date": "2014-12-15T00:00:00Z",
    "Meeting Number": "27/2014",
    "Meeting Date": "2014-11-28T08:27:27Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      " Manufacturing and Marketing of Veneer,Plywood, Teak Veneer and Sawn Timber ",
    "Amount Of Foreign Capital USD (in Millions)": 4.73,
    "Total Amount Of Capital (in Millions)": 4.73,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "India",
    "Form Of Investment": "FDII",
    "Land Owner": "U Toe Phyo,U Nar Da Yar Jan(a) U Hla Shwe",
    "Land Area (units not specified in file)": 3.163,
    "Lease Term": 25,
    "Annual Lease Fee": 0.0672,
    "Land Use Premium": null,
    "Number Of Local Employees": 220,
    "Number Of Foreign Employees": 1,
    Status: "Approved",
    "Investor Address":
      "A-107 Rico Industrial Area, N.H 11. Agra Road Bassi (Jaipur),",
    "Organization Address":
      "A-107 Rico Industrial Area, N.H 11. Agra Road Bassi (Jaipur),",
    "Investment Permitted Address":
      "PPlot No.(136+137+138),Matkhayar Min Thar Gyi Street, Industrial Zone (2), Dagon (Seik Kan) Township, Yangon., Dagon, YANGON",
  },
  {
    ID: 661,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Mark  Gerald  Eman ",
    "Name of Principal Organization": "Japafa Myanmar JV PTE. LTD",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar": "Japfa Comfeed Myanmar PTE., LTD. ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "642/2013",
    "Permit Date": "2013-12-03T00:00:00Z",
    "Meeting Number": "27/2013",
    "Meeting Date": "2013-10-24T09:18:40Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "Manufacturing  and Marketing of Animal  Feed, Poultry Breeder  Farm, Hatchery Farm and Contract Farming ",
    "Amount Of Foreign Capital USD (in Millions)": 9.775,
    "Total Amount Of Capital (in Millions)": 9.775,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Best  Livestock  Limited ",
    "Land Area (units not specified in file)": 35.11,
    "Lease Term": 30,
    "Annual Lease Fee": 319348.77,
    "Land Use Premium": null,
    "Number Of Local Employees": 1160,
    "Number Of Foreign Employees": 13,
    Status: "Monitoring Approved",
    "Investor Address":
      "Agung Raya II # 31 A, Lenteng Agung , Jakata Selatan,Indonesia, 12610.",
    "Organization Address":
      "391 B  Orchard  Road, # 18-08, Ngee Ann City , Tower  B, Singapore 238874",
    "Investment Permitted Address":
      " Kalar Kone Village, Myaung Dagar Industrial Zone, Hmawbi Township, Yangon Region",
  },
  {
    ID: 668,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Tomohira Ono",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "ONO Purse & Wallet Myanmar Co., Ltd. ",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "936/2015",
    "Permit Date": "2015-04-24T00:00:00Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2015-03-20T04:36:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Variety of Wallet and Purse on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.329,
    "Total Amount Of Capital (in Millions)": 0.329,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "U Than Naing",
    "Land Area (units not specified in file)": 1.084,
    "Lease Term": 50,
    "Annual Lease Fee": 0.061,
    "Land Use Premium": null,
    "Number Of Local Employees": 126,
    "Number Of Foreign Employees": 11,
    Status: "Monitoring Approved",
    "Investor Address":
      "ROOM 303, 49-9, DENEN CHOFU-HONCHO, OTA-KU, TOKYO, \tJAPAN ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No. 194, Myay Taing Block No.25, Shwe Lin Ban Industrial Zone",
  },
  {
    ID: 673,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Khin Thi Nwe",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "ABM Company Limited (အေဘီအမ် ကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "Ma Na Tha 1114/2016",
    "Permit Date": "2016-01-05T00:00:00Z",
    "Meeting Number": "21/2015",
    "Meeting Date": "2015-11-27T03:48:09Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 1049.2,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Environment and Forestry",
    "Land Area (units not specified in file)": 1.9,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 95,
    "Number Of Foreign Employees": 3,
    Status: "Approved",
    "Investor Address": "72 U Wisara Road, Room (203), , Kamayut, YANGON",
    "Organization Address": "-",
    "Investment Permitted Address":
      "72 U Wisara Road, Room (203), , Kamayut, YANGON",
  },
  {
    ID: 676,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yongqi Piao",
    "Name of Principal Organization": "changzhou Tooku Garments Co., Ltd.",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Roo Hsing Garment Manufacturing Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1091/2016",
    "Permit Date": "2016-02-29T00:00:00Z",
    "Meeting Number": "5/2016",
    "Meeting Date": "2016-02-15T09:39:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 10.75,
    "Total Amount Of Capital (in Millions)": 10.75,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Yin Yin (a) Daw Mya Yee ",
    "Land Area (units not specified in file)": 2.426,
    "Lease Term": 10,
    "Annual Lease Fee": 0.052,
    "Land Use Premium": null,
    "Number Of Local Employees": 1645,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 2-1, GUANG HUA ROAD, CHANGZHOU JIANGSU, PEOPLE’S REPUBLIC OF CHINA     ",
    "Organization Address":
      "NO. 2-1, GUANG HUA ROAD, CHANGZHOU JIANGSU, PEOPLE’S REPUBLIC OF CHINA   ",
    "Investment Permitted Address":
      "PLOT NO. 2,  MYAY TAING BLOCK NO. 3, INDUSTRIAL ZONE, HLAING THARYAR TOWNSHIP, YANGON REGION  ",
  },
  {
    ID: 679,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung San",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Yangon Aircraft Engineering Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "MaNaTha-1007/2014",
    "Permit Date": "2014-10-31T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Other Services",
    "Type Of Investment Business": "လေယာဉ်ပြုပြင်ထိန်းသိမ်းခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 4.41,
    "Total Amount Of Capital (in Millions)": 4194.94,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address":
      "အမှတ် (၁၃၈၉) ၊ ဆရာသိန်းလမ်း ၊ (၄၂) ရပ်ကွက် ၊ ဒဂုံမြို့သစ် ( မြောက်ပိုင်း) မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "-",
    "Investment Permitted Address":
      "ပို့ဆောင်ရေးဝန်ကြီးဌာန၊ လေကြောင်းပို့ဆောင်ရေးညွှန်ကြားမှုဦးစီးဌာနပိုင် ၊ ရန်ကုန်အပြည်ပြည်ဆိုင်ရာလေဆိပ်ရှိ Air Bagan လေယာဉ်ရုံ",
  },
  {
    ID: 681,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမြဟန်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "New Day Energy Services Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "954/2014",
    "Permit Date": "2014-02-07T00:00:00Z",
    "Meeting Number": "1/2014",
    "Meeting Date": "2014-01-08T04:32:47Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် မြေငှားရမ်း၍ စက်သုံးဆီတင်/ချ ဆိပ်ခံတံတားနှင့် စက်သုံးဆီ သို​လှောင်ကန်များ တည်ဆောက်ကာ စက်သုံးဆီ သိုလှောင်သည့် ဝန်ဆောင်မှု လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 12.05,
    "Total Amount Of Capital (in Millions)": 17525.68,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "မြန်မာ့ဆိပ်ကမ်းအာဏာပိုင်",
    "Land Area (units not specified in file)": 37.06,
    "Lease Term": 30,
    "Annual Lease Fee": 288.389,
    "Land Use Premium": 555.9,
    "Number Of Local Employees": 110,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "အမှတ်-၁၁/၁၂၊ ဗဟိုစည်အိမ်ယာ၊လမ်းမတော်မြို့နယ်၊ ရန်ကုန်တိုင်း",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြန်မာ့ဆိပ်ကမ်းအာဏာပိုင် မြေ ၃၇.၀၆ ဧက၊ အကွက်အမှတ်-၁၉ ရှိ ပို့ ဆောင်ရေးဝန်ကြီးဌာန၊ သီလဝါဆိပ်ကမ်းဒေသ၊ သန်လျင်-ေကျာက်တန်မြို့နယ်၊ ရန်ကုန်တိုင်း",
  },
  {
    ID: 683,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Myint Myint Win",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Shwe Than Lwin Media Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1118/2016",
    "Permit Date": "2016-01-14T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Other Services",
    "Type Of Investment Business":
      "CONSTRUCTION, LEASING AND MANAGEMENT OF COMMERCIAL OFFICE/ RETAIL AND HOTEL/ SERVICED APARTMENT",
    "Amount Of Foreign Capital USD (in Millions)": 581.294,
    "Total Amount Of Capital (in Millions)": 908183.2,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Than Sein",
    "Land Area (units not specified in file)": 1.683,
    "Lease Term": 10,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 756,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "အမှတ်- ၁၂၆ (အေ) ၊ လမ်း (၂၀) ၊ လသာ မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "အမှတ်- 139 -A + 171 A/20, 21, 22, 23, 24, 25, 26, 27, မေယုအိမ်ယာ၊ မြေတိုင်းရပ်ကွက် အမှတ် - 9 N, 9N1, အောက် ပုဇွန်တောင်လမ်း၊ ဗိုလ်တစ်ထောင်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 684,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.KUOK MENG WEI",
    "Name of Principal Organization": "Wilmar Sugar (Myanmar) PTE., LTD",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar": "GREAT  WALL -WILLMAR  HOLDINGS  LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "798/2014",
    "Permit Date": "2014-09-16T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Sugar, Fertilizer and Ethanol",
    "Amount Of Foreign Capital USD (in Millions)": 22.173,
    "Total Amount Of Capital (in Millions)": 22.173,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Great Wall Food Stuff Industry Co., Ltd ",
    "Land Area (units not specified in file)": 19.33,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address": "56 Neil Road,",
    "Organization Address": "56 NEIL Road",
    "Investment Permitted Address":
      "Kyauk Sayit Kong(North), Mandalay Township, Shwe Kyet Yet Village, Amarapura Township, Mandalay Region and Htee Chaint Township, Katrahar Township, Sagaing Region ",
  },
  {
    ID: 694,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Theingi Lin",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Terabit Wave Company Limited (သန်းချီလှိုင်း ကုမ္ပဏီ လီမိတက်)",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1093/2015",
    "Permit Date": "2015-10-14T00:00:00Z",
    "Meeting Number": "17/2015",
    "Meeting Date": "2015-09-28T08:46:20Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "ဆက်သွယ်ရေး ကွန်ယက် အထောက်အကူပြု ဝန်ဆောင်မှု လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 11840,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Yan Win",
    "Land Area (units not specified in file)": 0.55,
    "Lease Term": 10,
    "Annual Lease Fee": 12,
    "Land Use Premium": 0,
    "Number Of Local Employees": 57,
    "Number Of Foreign Employees": 5,
    Status: "Approved",
    "Investor Address":
      "အမှတ်-၄၁/အေ၊ ရွှေတောင်ကြားလမ်း၊ ရွှေတောင်ကြား (၂) ရပ်ကွက်၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "-\tရန်ကုန်တိုင်းဒေသကြီး၊ ‌မင်္ဂလာဒုံမြို့နယ်၊ သန္ဓေပင်ကျေး ရွာအုပ်စု၊ သဲဖြူအရှေ့ကွင်း၊ ကွင်းအမှတ် - ၅၆၄၊ ဦးပိုင် အမှတ်-၁၂/၁+၁၃/၁ ",
  },
  {
    ID: 698,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. ZHAO, BINGXUE ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "SINOPROUD (MYANMAR) GARMENT COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1261/2017",
    "Permit Date": "2017-04-11T00:00:00Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T08:39:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENTS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner":
      "DAW MYA THAN KYI @ DAW KHIN HTAY WIN AND U KAUNG PAW @ u AUNG HTUN WIN ",
    "Land Area (units not specified in file)": 2.438,
    "Lease Term": 30,
    "Annual Lease Fee": 78,
    "Land Use Premium": null,
    "Number Of Local Employees": 665,
    "Number Of Foreign Employees": 8,
    Status: "Monitoring Approved",
    "Investor Address":
      "89th Street, Shin Phu Street, Nan Hwun Ward, Chan Kyan Town, People's Republic of China",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 5, MYAY TAING BLOCK NO. YALAPA-25, HLAING THARYAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 708,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Yasunori Takahashi",
    "Name of Principal Organization":
      "Nippon Express ( South Asia & Oceania) Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Nippon Express ( Myanmar) Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "850/2014",
    "Permit Date": "2014-11-10T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Logistic Services ( Freight Forwarding, Transport By Air, Sea, Rad, Rail, Moving Services , Etc.)",
    "Amount Of Foreign Capital USD (in Millions)": 0.86,
    "Total Amount Of Capital (in Millions)": 1.23,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 14,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner":
      "Kosan Trading Co.,Ltd.\nDagon Seikkan International Logistics Services Co.,Ltd.",
    "Land Area (units not specified in file)": 1.385,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 10,
    "Number Of Foreign Employees": 2,
    Status: "Draft",
    "Investor Address":
      "40 Alps Avenue, Nippon Express Singapore Bulding, Singapore 498781",
    "Organization Address":
      "5C Toh Guan Road East, Nippon Exp Global Logistics Ctr, Singapore 608828",
    "Investment Permitted Address":
      "#2A, Second Floor, United Tower, No.141/145, Bo Aung Kyaw Street, Kyauktada Township , Yangon",
  },
  {
    ID: 711,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U WIN SWE",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Win & Win Company Limted",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1123/2016",
    "Permit Date": "2016-01-29T00:00:00Z",
    "Meeting Number": "1/2016",
    "Meeting Date": "2016-01-15T05:36:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်ပါးလွှာနှင့် အထပ်သားထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.54,
    "Total Amount Of Capital (in Millions)": 2028.16,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Win Swe",
    "Land Area (units not specified in file)": 15,
    "Lease Term": 30,
    "Annual Lease Fee": 13.33,
    "Land Use Premium": null,
    "Number Of Local Employees": 330,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်-၄၀၀၊ ကမ်းနားလမ်း၊ လသာမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No.(6), (6)Mile,Pyay Road, , Hlaing, YANGON",
  },
  {
    ID: 714,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦး​ကျော်မြင့် (ခ) Tan Yin Hwat ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Kaung Htet (Myanmar) Manufacturing & Distribution Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "Ma Na Tha- 885/2013",
    "Permit Date": "2013-02-11T00:00:00Z",
    "Meeting Number": "6/2013",
    "Meeting Date": "2013-02-06T04:19:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အချိုရည်စက်ရုံ တည်ထောင်၍ Pokka အမှတ် တံဆိပ်နှင့် ပြည်တွင်း အချိုရည် မျိုးစုံး ထုတ်လုပ်ခြင်း လုပ်ငန်",
    "Amount Of Foreign Capital USD (in Millions)": 0.08,
    "Total Amount Of Capital (in Millions)": 1800,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Kyi Soe",
    "Land Area (units not specified in file)": 3.181,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address": "အမှတ်-၆၁၊ ပထမထပ် ၊လမ်းမတော်လမ်း၊",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၅၁၊ မြေတိုင်းရပ်ကွက်အမှတ်-၅၁၊ သာဓုကန်စက်မှုဇုန် အပိုင်း-၁၊ ",
  },
  {
    ID: 717,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Ko Ko Gyi @ U Soe Naing",
    "Name of Principal Organization": "Lluvia Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Liuvia Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "939/2015",
    "Permit Date": "2015-04-27T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Distribution of Wheat Flour",
    "Amount Of Foreign Capital USD (in Millions)": 1.564,
    "Total Amount Of Capital (in Millions)": 10.426,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "PAK Link Trading Limited",
    "Land Area (units not specified in file)": 2.25,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 291,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address": "No. 34, University Avenue Raod",
    "Organization Address": "No.126/A, Kabaraye Pagoda Road",
    "Investment Permitted Address":
      "Plot No. 50, Myay Taing Block No. 113, Industrial Zone, ",
  },
  {
    ID: 719,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Chow Yun Kit",
    "Name of Principal Organization": "Marga One Investment Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Marga Landmark Development Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1090/2016",
    "Permit Date": "2016-02-16T00:00:00Z",
    "Meeting Number": "4/2016",
    "Meeting Date": "2016-02-05T02:33:07Z",
    Sector: "Real Estate",
    "Type Of Investment Business": "Real Estate Development",
    "Amount Of Foreign Capital USD (in Millions)": 173.73,
    "Total Amount Of Capital (in Millions)": 218.18,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV,BOT",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": 17.7,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": 35.4,
    "Number Of Local Employees": 489,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address": "g/F, Block 4, No .8, Fuk Shun Street, Yuen Long, ",
    "Organization Address": "1 Raffles Place 39-01, One raffles Place",
    "Investment Permitted Address":
      "Corner of Kaba Aye Pagoda Road and Kanbe Road, Myay Taing Boclk No 85-Kanbe, Part of Plot No 7 & 8, ",
  },
  {
    ID: 724,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Khin Myint Lwin",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "U Ni & Daw Phyu Family Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "855/2012",
    "Permit Date": "2012-07-24T00:00:00Z",
    "Meeting Number": "21/2012",
    "Meeting Date": "2012-07-18T08:32:53Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "ငါး၊ ပုစွန် ပြုပြင်အေးခဲ ထုတ်လုပ်ခြင်းလုပ်ငန်း နှင့် ရေထွက် ပစ္စည်း လက်ခစားစနစ် (Contract Processing) ဖြင့် ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.37,
    "Total Amount Of Capital (in Millions)": 1200,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအောင်ဝင်း",
    "Land Area (units not specified in file)": 1.947,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 234,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်-၆၆၀၊ သန္တာ-၆ လမ်း၊ စ ရပ်ကွက်၊ ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၆၅)၊ မြေတိုင်းရပ်ကွက်အမှတ်(၆၄)၊ စက်မှုဇုန်အပိုင်း(၃)၊  ရေွှပြည်သာမြို့နယ်",
  },
  {
    ID: 726,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. L I KIN LEONG",
    "Name of Principal Organization": "WISECHAMP ELECTRONIC CO., LTD. ",
    "Place of Incorporation": "HONG KONG",
    "Company Name In Myanmar": "WISECHAMP ELECTRONIC (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1241/2017",
    "Permit Date": "2017-04-11T00:00:00Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T05:27:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF CABLE HARNESS & CONNECTOR SUCH AS USB, HDMI & MINI DP ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.7,
    "Total Amount Of Capital (in Millions)": 1.7,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U SOE MOE",
    "Land Area (units not specified in file)": 1.72,
    "Lease Term": 10,
    "Annual Lease Fee": 144,
    "Land Use Premium": null,
    "Number Of Local Employees": 118,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address":
      "FLAT B, 1/F, BLOCK 7, THE PARAMONUNT , TAI OP, N, T, HONG KONG",
    "Organization Address":
      "FLAT F, 6/F, VALIANT INDUSTRIAL CENTRE, 12 AU PUI WAN STREET, FOTAN, N. T., HONG KONG",
    "Investment Permitted Address":
      "PLOT NO. 192, MYAY TAING BLOCK NO. 113, INDUSTRIAL ZONE PART-1, DAGON MYOTHIT (EAST) TOWNSHIP, YANGON REGION",
  },
  {
    ID: 731,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. CHENGRUI  KANG\t",
    "Name of Principal Organization": "East-West International B.V ",
    "Place of Incorporation": "The Netherlands",
    "Company Name In Myanmar": "East-West Seed (Myanmar) Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1107/2016",
    "Permit Date": "2016-03-26T00:00:00Z",
    "Meeting Number": "9/2016",
    "Meeting Date": "2016-03-11T09:20:02Z",
    Sector: "Agriculture",
    "Type Of Investment Business":
      "Seeds Production and Processing, Research and Development, Marketing of Vegetable and Fruit Seeds",
    "Amount Of Foreign Capital USD (in Millions)": 6,
    "Total Amount Of Capital (in Millions)": 6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Thailand",
    "Form Of Investment": "FDII",
    "Land Owner": "U Htein Win ",
    "Land Area (units not specified in file)": 5,
    "Lease Term": 30,
    "Annual Lease Fee": 0.023,
    "Land Use Premium": null,
    "Number Of Local Employees": 84,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "BUILDING 6, KEYUAN ROAD, NO.99, WUHUA DISTRICT, KUNMING, YUNNAN, CHINA ",
    "Organization Address": "Heiligeweg 18, 1601 PN, Enkhuizen, ",
    "Investment Permitted Address":
      "No.(10 /B -1), Thukhu Waddy Street., Yankin, YANGON",
  },
  {
    ID: 732,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Luo, Muzhen",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Yoo Win Manufacturing Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1076/2016",
    "Permit Date": "2016-02-04T00:00:00Z",
    "Meeting Number": "2/2016",
    "Meeting Date": "2016-01-22T04:40:59Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.773,
    "Total Amount Of Capital (in Millions)": 0.773,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 9,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Glory Victory Industries Limited",
    "Land Area (units not specified in file)": 1.815,
    "Lease Term": 10,
    "Annual Lease Fee": 60,
    "Land Use Premium": null,
    "Number Of Local Employees": 775,
    "Number Of Foreign Employees": 16,
    Status: "Approved",
    "Investor Address":
      "NO. 291, #2 DONGFENG VILLAGE, DUCHENG TOWN, DUCHENG COUNTY, JIANGXI PROVINCE,  PEOPLE’S REPUBLIC OF CHINA     ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 17, HLAING THAR YAR INDUSTRIAL ZONE 2, HLAING THAR YAR TOWNSHIP, YANGON REGION  ",
  },
  {
    ID: 734,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw Sandar Htun",
    "Name of Principal Organization":
      "Shwe Taung  Junction City Development Co.,Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "City Square Hotel  Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "758/2014",
    "Permit Date": "2014-08-06T00:00:00Z",
    "Meeting Number": "18/2014",
    "Meeting Date": "2014-07-09T04:43:42Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business":
      "Construction, Developing and Operationg Five-Star Hotel and Its Related Business",
    "Amount Of Foreign Capital USD (in Millions)": 67.68,
    "Total Amount Of Capital (in Millions)": 116.69,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Yangon City Development Committee",
    "Land Area (units not specified in file)": 6.36,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 304,
    "Number Of Foreign Employees": 5,
    Status: "Submitted",
    "Investor Address":
      "Ahlone Tower , River view Garden Housing , Strand Road, Ahlone Township, Yangon",
    "Organization Address": "No.584, Strand Road , Lanmadaw Township, Yangon",
    "Investment Permitted Address":
      "River View Garden Housing Alone Tower ,Strand Road ,Alone Township,Yangon. ",
  },
  {
    ID: 741,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wu, Jun",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Bao Ma Knitting (Myanmar) Co.,Ltd. ",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1238/2017",
    "Permit Date": "2017-04-11T00:00:00Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T06:15:32Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF KNITTED GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.79,
    "Total Amount Of Capital (in Millions)": 1.79,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U TIN SEIN, U MIN MIN",
    "Land Area (units not specified in file)": 0.8,
    "Lease Term": 10,
    "Annual Lease Fee": 0.069,
    "Land Use Premium": null,
    "Number Of Local Employees": 139,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "Unit 1002, 10/F, 88 High fat Street, Causeway Bay, Hong Kong.",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 353, MYAY TAING BLOCK NO,. 25, SHWE LIN PAN SETHMU MYO, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 743,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ramesh Kumar Sawarthia",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Lotus Wood Indusry Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "962/2015",
    "Permit Date": "2015-06-10T00:00:00Z",
    "Meeting Number": "9/2015",
    "Meeting Date": "2015-05-18T03:41:14Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Veneer, Plywood, Teak Veneer and Sawn Timber",
    "Amount Of Foreign Capital USD (in Millions)": 6.77,
    "Total Amount Of Capital (in Millions)": 7.53,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "U San Jay Kumar  and  U Ar Khi Lit @  Micky",
    "Land Area (units not specified in file)": 13.22,
    "Lease Term": 50,
    "Annual Lease Fee": 0.134,
    "Land Use Premium": null,
    "Number Of Local Employees": 200,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address": "Office NO 1208, 12/F, Tower 2, 30 Canton Road TST",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No(1103),Central Tower,Corner Of 39th Street & Anawrahta Road, Kyauktatar, YANGON",
  },
  {
    ID: 751,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Aung Myint",
    "Name of Principal Organization":
      "Asia Myanmar Consortium Development Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "Asia Myanmar Shining Star Investment Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "882/2014",
    "Permit Date": "2014-12-30T00:00:00Z",
    "Meeting Number": "28/2014",
    "Meeting Date": "2014-12-12T03:55:43Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Construction & Operation of Consortium Tower ( Service Apartment -B , Office Tower , Hotel Tower)",
    "Amount Of Foreign Capital USD (in Millions)": 102.4554,
    "Total Amount Of Capital (in Millions)": 157.6254,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "Yangon City Development Committee",
    "Land Area (units not specified in file)": 3.35,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 383,
    "Number Of Foreign Employees": 4,
    Status: "Submitted",
    "Investor Address":
      "No. 31(A ), Anegar Street,  15 Quarter , Yankin Township, Yangon",
    "Organization Address":
      "No.384 , Corner of Latha Street & Strand Road, Latha Township, Yangon",
    "Investment Permitted Address": "No.49, Komin Kochin Road, , Bahan, YANGON",
  },
  {
    ID: 756,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Seiro  Tokunaga ",
    "Name of Principal Organization":
      "OJI   GS  Packaging ( Yangon) Company  Limited ",
    "Place of Incorporation": "Malaysia ",
    "Company Name In Myanmar":
      "OJI   GS  Packaging ( Yangon) Company  Limited ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "687/2014",
    "Permit Date": "2017-07-10T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Marketing  of  corrugated  Carton  Box  and  Sheet ",
    "Amount Of Foreign Capital USD (in Millions)": 17.325,
    "Total Amount Of Capital (in Millions)": 17.325,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 35,
    "Investing Country": "Malaysia",
    "Form Of Investment": "JV",
    "Land Owner": "Ministry  of  Home  Affairs ",
    "Land Area (units not specified in file)": 6.178,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 58,
    "Number Of Foreign Employees": 4,
    Status: "Draft",
    "Investor Address": "6-54-205, Tsutsujigaoka, Aoba-Ku, ",
    "Organization Address":
      "GS  paper &  Packaging  SDN . BHD  LOT . 7090 ,  MUKIM  Tanjung  12   Daerahm , ",
    "Investment Permitted Address":
      "Plot  No. B-4-2, Corner  of  No.3,  Highway  Road  and  Khayebin Road, Mingalardond  Industrial  Park ",
  },
  {
    ID: 759,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Thandar Naywin",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Ngapali Bay Villas & Spa Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "MaNaTha-1200/2016",
    "Permit Date": "2016-07-18T00:00:00Z",
    "Meeting Number": "13/2016",
    "Meeting Date": "2016-07-01T06:42:42Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Ngapali Bay Villas & Spa  Hotel Service",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 7590.89,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Defence. Quarter Master General Office ",
    "Land Area (units not specified in file)": 4.34,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 131,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "No.7 ,Kote kaing Avenue Road, Shwe Taung gyar (2) Quarter,,Bahan Township, Yangon",
    "Organization Address": "-",
    "Investment Permitted Address":
      "-No(388/398), Coner Of Kannar and Sinmin Street , Ahlone, YANGON",
  },
  {
    ID: 761,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wichian Chaisathaporn",
    "Name of Principal Organization": "Thai Faster Products Co.,Ltd.",
    "Place of Incorporation": "Thailand",
    "Company Name In Myanmar": "Thai Faster Products And M.K Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "878/2015",
    "Permit Date": "2015-01-02T00:00:00Z",
    "Meeting Number": "28/2014",
    "Meeting Date": "2014-12-12T03:22:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing And Distribution of Various Types of Jellies",
    "Amount Of Foreign Capital USD (in Millions)": 1.8,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "U Phyae Phyoe",
    "Land Area (units not specified in file)": 2.036,
    "Lease Term": 5,
    "Annual Lease Fee": 0.0414,
    "Land Use Premium": null,
    "Number Of Local Employees": 356,
    "Number Of Foreign Employees": 8,
    Status: "Monitoring Approved",
    "Investor Address":
      "99/99 Moo.4, Aomnoy Sub- District, Kratungban District, Samutsakorn Province, Thailand",
    "Organization Address":
      "99/99 Moo.4, Aomnoy Sub- District, Kratungban District, Samutsakorn Province, Thailand",
    "Investment Permitted Address":
      "Plot No.467/KA, Myay Taing Block No.25, Kanaung Min Thar Gyi Street, Shwe Lin Pan Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 766,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးခွန်နောင်မြင့်​ေ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Wa Minn Properties Development Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "892/2013",
    "Permit Date": "2013-03-13T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Other Services",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် ငှားရမ်း၍ လူနေအိမ်ခန်း ရုံးခန်းနှင့် စီးပွားရေး ဆိုင်ရာ အဆောက်အဦများတည်​ဆောက်၍ ငှားရမ်းခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 60.34,
    "Total Amount Of Capital (in Millions)": 76000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT",
    "Land Owner": "ကာကွယ်ရေးဝန်ကြီးဌာန၊ စစ်ထောက်ချုပ်ပိုင်",
    "Land Area (units not specified in file)": 2.414,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": 6.64,
    "Number Of Local Employees": 122,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address": "အမှတ်-၆၆၉/စီ၊ မြကန်သာလမ်း၊ ပြည်လမ်းမကြီး၊",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မနော်မရီရှိမြေ (၂.၄၁၄) ဧက၊ အမှတ်-၄၅၊ အလုံလမ်း၊ ကာကွယ်ရေး ဝန်ကြီးဌာန၊ စစ်ထောက်ချုပ်ရုံးပိုင်",
  },
  {
    ID: 768,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. TAN LENG AUN",
    "Name of Principal Organization": "LOSCAM ASIA PRIVATE LIMITED, ",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar": "LOSCAM MYANMAR LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1132/2016",
    "Permit Date": "2016-07-13T00:00:00Z",
    "Meeting Number": "12/2016",
    "Meeting Date": "2016-06-27T09:50:16Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Providing Pallet and Other Supply Chain Equipment Rental and Pooling Solutions Services",
    "Amount Of Foreign Capital USD (in Millions)": 0.5,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW TIN TIN OO @ DAW NU NU WIN ",
    "Land Area (units not specified in file)": 2.009,
    "Lease Term": 5,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 2,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address": "37 JOO KOON CIRCLE, JURONG, 629062 SINGAPORE",
    "Organization Address": "8 MARINA BAY FINANCIAL CENTRE, SINGAPORE 018981",
    "Investment Permitted Address":
      "PLOT NO. 5, MYAY TAING BLOCK NO. 64, (SETHMU), INDUSTRIAL ZONE (3), SHWE PYI TAHR TOWNSHIP, YANGON REGEION",
  },
  {
    ID: 772,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးတင်ထွန်းအောင်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "YOUTH FORCE HOTEL COMPANY LIMITED",
    "Financial Year From": 2011,
    "Financial Year To": 2012,
    "Permit Number": "Ma Na Tha 820/2011",
    "Permit Date": "2011-11-15T00:00:00Z",
    "Meeting Number": "23/2011",
    "Meeting Date": "2011-11-09T02:27:05Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် June XI Business Centre & Services Apartment လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 5000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "ဆောက်လုပ်ရေးဝန်ကြီးဌာန(ယခင်နိုင်ငံခြားရေးဝန်ကြီးရုံးနေရာ)",
    "Land Area (units not specified in file)": 1.711,
    "Lease Term": 30,
    "Annual Lease Fee": 0.125,
    "Land Use Premium": 2104530000,
    "Number Of Local Employees": 208,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "အမှတ်-၆၄/ဈ၊ ဇေယျာ  ခေ မာ လမ်းသွယ်၁၊ ကျိုက်ဝိုင်းဘုရားလမ်း၊ ၆ ရပ်ကွက်၊ ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "အမှတ်-၃၆၊ သံတမန်လမ်း၊ ယခင်နိုင်ငံခြားရေးဝန်ကြီးဌာနရုံး၊ ဒဂုံမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 773,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Nan Khin Yee Myint",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Jade King & Queen Gems & Jewwellery  Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "MaNaTha-1209/2016",
    "Permit Date": "2016-09-20T00:00:00Z",
    "Meeting Number": "17/2016",
    "Meeting Date": "2016-09-09T05:14:22Z",
    Sector: "Agriculture",
    "Type Of Investment Business":
      "ရာဘာအစေးလှီးခြင်း၊ ထိန်းသိမ်းခြင်း၊ ပြန်လည်စိုက်ပျိုးခြင်းနှင့် မှိုင်းခံရာဘာပြား ထုတ်လုပ်ရောင်းချခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.37,
    "Total Amount Of Capital (in Millions)": 919,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Industry",
    "Land Area (units not specified in file)": 1505.61,
    "Lease Term": 25,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 18,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "No.53/54, Sat Sayar U Tun Road, Shwe PyiThar  Industrial Zone (4), Insein Township, Yangon",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No. 53/54, Sat Sayar U Tun Street, Shwepyithar Industrial Zone 4, , Insein, YANGON",
  },
  {
    ID: 776,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. CHO SEUNG HEE",
    "Name of Principal Organization": "DAVIMODE CO., LTD., ",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "MYANMODE COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1166/2016",
    "Permit Date": "2016-10-13T00:00:00Z",
    "Meeting Number": "18/2016",
    "Meeting Date": "2016-09-23T10:18:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW KYI KYI NYUNT AND Daw KYI KYI MYINT",
    "Land Area (units not specified in file)": 2.119,
    "Lease Term": 10,
    "Annual Lease Fee": 0.009,
    "Land Use Premium": null,
    "Number Of Local Employees": 2078,
    "Number Of Foreign Employees": 17,
    Status: "Monitoring Approved",
    "Investor Address":
      "1-304, 94, DEOKJEONG-GIL, YANGJU-SI, GYEONGGIDO, 11450, Republic of KOREA",
    "Organization Address":
      "# 507 (GASAN-DONG, NEW- T CASTEL) 108 GASAN DIGITAL 2-RO, GEUMCHEON-GU, SEOUL, Republic of KOREA",
    "Investment Permitted Address":
      "PLOT NO. 504, MYAY TAING BLOCK NO. Ya La Pa (25), HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 785,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Lae Ye Soe ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Anawmar Art Group Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "MaNaTha-1020/2014",
    "Permit Date": "2014-12-29T00:00:00Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T05:39:49Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "ဝန်ကြီးရုံးများအား B.O.Tစနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီ ပြတိုက်အပါအဝင်အခြား ဝန်ဆောင်မှုလုပ်ငန်းများ",
    "Amount Of Foreign Capital USD (in Millions)": 11.48,
    "Total Amount Of Capital (in Millions)": 58671.76,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "Yangon Region Government",
    "Land Area (units not specified in file)": 15.963,
    "Lease Term": 50,
    "Annual Lease Fee": 300,
    "Land Use Premium": null,
    "Number Of Local Employees": 91,
    "Number Of Foreign Employees": 14,
    Status: "Approved",
    "Investor Address":
      "N0- 46-E, (2)Shwetaungkywar  Street, Bahan Township, Yangon.  ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "အမှတ်(၇)၊ ကုန်းမြင့်ရိပ်သာလမ်း၊ ၇ မိုင်ခွဲ၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်မြို့။\n",
  },
  {
    ID: 796,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Zar Ni Maung Maung ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Shwe Kaba Maung Maung Marine Peoducts Co.,Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "Ma Na Tha-985/2014",
    "Permit Date": "2014-07-02T00:00:00Z",
    "Meeting Number": "15/2014",
    "Meeting Date": "2014-05-31T07:21:02Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင်မီ အအေးခန်းစက်ရုံတည်ဆောင်၍ အေးခဲပြီး ငါး/ပုစွန်များ ပြည်ပသို့ တင်ပို့ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.025,
    "Total Amount Of Capital (in Millions)": 588.31,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 2.039,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 196,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် (၈၃/၈၅) ၊ ရွှေဘုံသာလမ်း ၊ အမှတ်(၃) ရပ်ကွက် ၊ ပန်းဘဲတန်းမြို့နယ် ၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၁၃၂) ၊ မြေတိုင်းရပ်ကွက်အမှတ် (၆၅) ၊ ဆိပ်ကမ်းသာလမ်း နှင့် ဒီပဲရင်းဝန်ထောက်ဦးမြဲလမ်းထောင့် ၊ ရွှေပြည်သာ စက်မှုဇုန် (၄) ၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး ရှိ မြေဧရိယာ (၂.၀၃၉) ဧက",
  },
  {
    ID: 797,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.KUOK MENG WEI",
    "Name of Principal Organization": "Wilmar Investment Holdings PTE., LTD.",
    "Place of Incorporation": "Republic  of Singapore",
    "Company Name In Myanmar":
      "Wilmar Myanmar Port Terminals (Thilawa) Limited ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "729/2014",
    "Permit Date": "2014-12-18T00:00:00Z",
    "Meeting Number": "274/2014",
    "Meeting Date": "2014-11-28T06:16:28Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Building and Operating a modern Multi-Purpose International Wharf and Development of the Leased Land Under A BOT Contract for Sub-Lease To Investors for carrying out production and commercial activities( fertilizer, wheat flour, Oilseeds crushing, Processing of Grains inculding rice, edible oils, specialty fats , sugar, cogeneration of poswer ",
    "Amount Of Foreign Capital USD (in Millions)": 79.689,
    "Total Amount Of Capital (in Millions)": 79.689,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII,BOT",
    "Land Owner": "Ministry of Transport ",
    "Land Area (units not specified in file)": 100.13,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": 4052293.48,
    "Number Of Local Employees": 507,
    "Number Of Foreign Employees": 6,
    Status: "Approved",
    "Investor Address": "56 Neil Road, Singapore 088830",
    "Organization Address": "56 Neil Road, Singapore 088830",
    "Investment Permitted Address":
      "\nPlot No.20 & 21, Thilawa Port Development Zone., Kyauktan, YANGON",
  },
  {
    ID: 798,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Aye Thandar",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Rice Trading co.,Ltd",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "MaNaTha-940/2013",
    "Permit Date": "2013-10-23T00:00:00Z",
    "Meeting Number": "26/2013",
    "Meeting Date": "2013-10-02T03:07:29Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်ပါး လွှာ(veneer)၊ အထပ်သား (plywood)နှင့် သစ်အ​ေ ခြခံပစ္စည်းအ မျိုးမျိုးတို့အား ကုန် ​ေ ချာထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 12332.75,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Myanmar Rice Trading Co.,ltd",
    "Land Area (units not specified in file)": 20.189,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 350,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address": "အဆောက်အဦးအမှတ်(၁၃၆/၁၃၈)၊အမှတ်(၃၂၀)၊ ၃၉လမ်း၊",
    "Organization Address": "",
    "Investment Permitted Address":
      "​ေ မြကွက်အမှတ်-၈၂၊၈၃၊၈၄၊၈၅၊၈၆၊၈၇၊၈၈၊​ေ မြတိုင်းရပ်ကွက်အမှတ်-၄၉၊ ဝါးတစ်ရာစက်မှုဇုန်၊ ",
  },
  {
    ID: 799,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Hong Seog Cheol",
    "Name of Principal Organization": "J-Land Korea Co., Ltd.",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "J-Land Myanmar Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "966/2015",
    "Permit Date": "2015-06-18T00:00:00Z",
    "Meeting Number": "10/2015",
    "Meeting Date": "2015-06-05T06:50:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.082,
    "Total Amount Of Capital (in Millions)": 4.082,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Khin Htwe and Daw Myint Myint Yee",
    "Land Area (units not specified in file)": 4.471,
    "Lease Term": 10,
    "Annual Lease Fee": 0.11,
    "Land Use Premium": null,
    "Number Of Local Employees": 1510,
    "Number Of Foreign Employees": 12,
    Status: "Monitoring Approved",
    "Investor Address":
      "104-1401 (hyun Dai home Town, Guinma Eul), 314 Pyungchon, Donganh-Gu, An Yang-City, Gyunggi, Republic of Kores",
    "Organization Address":
      "(Guro-Dong, Rm 801/2 Digital Tower Villant 2CHA 801) 31, digital-RO 30-Gil, Guro-Gu, Seoul, Republic of Korea",
    "Investment Permitted Address":
      "Plot No. 8, Myay Taing Block No. 49, Wartayar Industrial Zone, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 801,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MRS. JIN  YINGSHU",
    "Name of Principal Organization": "MYANMAR  HUAYI CO., LTD",
    "Place of Incorporation": "PEOPLE'S  REPUBLIC  OF  CHINA",
    "Company Name In Myanmar": "MYANMAR  HUAYI  CO., Ltd",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "669/2014",
    "Permit Date": "2014-03-03T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing  of  Garment   on  CMP  basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.1,
    "Total Amount Of Capital (in Millions)": 2.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "Daw  Tin Shin",
    "Land Area (units not specified in file)": 9866.24,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 1400,
    "Number Of Foreign Employees": 14,
    Status: "Draft",
    "Investor Address":
      "22nd FLOOR, NO 88, AHONGSHAN ROAD, ZHONGSHAN DISTRICT , DALIAN  CITY , PEOPLE'S  REPUBLIC  OF  CHINA",
    "Organization Address":
      "MYAY  TAING  NO.25,PLOT  NO.40,MINTHEIKDI  KYAW  SWAR  ROAD, SHWE  LINPAN  INDUSTRIAL  ZONE, HLAING  THAR  YAR  TOWNSHIP, YANGON REGION ",
    "Investment Permitted Address":
      "MYAY  TAING  NO.25,PLOT  NO.40,MINTHEIKDI  KYAW  SWAR  ROAD, SHWE  LINPAN  INDUSTRIAL  ZONE, HLAING  THAR  YAR  TOWNSHIP, YANGON REGION ",
  },
  {
    ID: 802,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MRS. ZHANG, RONG",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "NAN TONG GREAT ONE MYANMAR COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1259/2017",
    "Permit Date": "2017-04-11T00:00:00Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T08:53:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENTS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.21,
    "Total Amount Of Capital (in Millions)": 1.21,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW THAN THAN WIN",
    "Land Area (units not specified in file)": 1.608,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 1665,
    "Number Of Foreign Employees": 11,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.31, HOU KOU STREET, XUAN GANG TOWN, YUAN PING CITY, SHAN XI PROVINCE, PROPLE'S REPUBLIC OF CHINA ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 70, INDUSTRIAL ZONE (2), HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 807,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. KANICHI MINAMI",
    "Name of Principal Organization": "WORLD LAB INC.",
    "Place of Incorporation": "JAPAN",
    "Company Name In Myanmar": "WORLD LAB MYANMAR COMPANY LIMITED.",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1138/2016",
    "Permit Date": "2016-07-23T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Other Services",
    "Type Of Investment Business": "DENTAL RESTORATIONS",
    "Amount Of Foreign Capital USD (in Millions)": 0.841,
    "Total Amount Of Capital (in Millions)": 0.841,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "DAW WIN WIN HTAY",
    "Land Area (units not specified in file)": 0.126,
    "Lease Term": 10,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 47,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address":
      "HORINOUCHI-CHO 1-6 MANIN STAGE KAWASAKI 305, KAWASAKI KU, KAWASAKI-SHI, JAPAN",
    "Organization Address": " 3-2-25 MIYUKI-CHOU, AKIHA-KU, NIGATA, JAPAN",
    "Investment Permitted Address":
      "PLOT NO.1/SA KA.W MYAY TAING BLOCK NO-394, NO. 130 (A), PYAY ROAD, 10 MILES, INSEIN TOWNSHIP, YANGON REGION",
  },
  {
    ID: 812,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Horikawa  Masaki",
    "Name of Principal Organization": "NTT  Data Myanmar Co., Ltd",
    "Place of Incorporation": "S",
    "Company Name In Myanmar": "NTT  Data  Myanmar  CO.,  Ltd",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "499/2012",
    "Permit Date": "2017-07-07T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Other Services",
    "Type Of Investment Business": "Services",
    "Amount Of Foreign Capital USD (in Millions)": 3.3,
    "Total Amount Of Capital (in Millions)": 0,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 10,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "Mr. Horikawa  Masaki ",
    "Land Area (units not specified in file)": 2,
    "Lease Term": 3,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 123,
    "Number Of Foreign Employees": 123,
    Status: "Draft",
    "Investor Address": "11-17, Seijo  5-chome, Setagaya-ku, Toko, Japan",
    "Organization Address":
      "NTT  Data  Asia  Pacific  Pte  Ltd.,  20  Cecil  Street, # 06-02  Equity   Plaza, Singaport 047.5",
    "Investment Permitted Address":
      "MICT  Park , Room  no(8), First  Floor, \nHlaing  Compusm",
  },
  {
    ID: 820,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Tsang Wing Kwan ",
    "Name of Principal Organization": "Kamsberg Ltd.",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "KBL Fashion Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1078/2016",
    "Permit Date": "2016-02-04T00:00:00Z",
    "Meeting Number": "2/2016",
    "Meeting Date": "2016-01-21T04:42:11Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Wedding Dress for Bride on CMP Basis (Factory-2)",
    "Amount Of Foreign Capital USD (in Millions)": 0.61,
    "Total Amount Of Capital (in Millions)": 0.61,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Khine Wah",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 10,
    "Annual Lease Fee": 0.21,
    "Land Use Premium": null,
    "Number Of Local Employees": 247,
    "Number Of Foreign Employees": 7,
    Status: "Monitoring Approved",
    "Investor Address":
      "FLAT  K,  26/F,  BLOCK  2,  AFFLUENCE  GARDEN,  TUEN  MUN,  N.T., \t\tHONG   KONG",
    "Organization Address":
      "UNIT 1506,15/F1, ONE HARBOURFRONT, 18 TAK FUNG STREET, HUNG HOM, KOWLOON, HONG KONG ",
    "Investment Permitted Address":
      "PLOT  NO.19,  MYAY TAING  BLOCK  PART(4) ,HLAING  THAR  YAR  INDUSTRIAL  ZONE, HLAING THAR YAR TOWNSHIP, YANGON  REGION",
  },
  {
    ID: 822,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Nyein Aung ",
    "Name of Principal Organization":
      "Myanmar Integarated Communication Trading CO., Ltd ",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "K-Won&MICC Company Limitd ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "805/204",
    "Permit Date": "2014-10-13T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing  of  Garment   on  CMP  basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.6,
    "Total Amount Of Capital (in Millions)": 1.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "JV",
    "Land Owner": "Ministry of Industry ",
    "Land Area (units not specified in file)": 3.48,
    "Lease Term": 10,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 1265,
    "Number Of Foreign Employees": 8,
    Status: "Draft",
    "Investor Address": "No.405, Merchant Roadm Thayettaw ( South) Ward",
    "Organization Address": "No.405, Merchant Roadm Thayettaw ( South) Ward",
    "Investment Permitted Address":
      "Insein Blanket Factory No. 20(Branch) ( Former YGM), Insein-Mingalardon Road, Aung San Myo ",
  },
  {
    ID: 823,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Doctor Sai San Tun",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Grate Myanmar Construction Co.,Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "Ma Na Tha-978/2014",
    "Permit Date": "2014-05-09T00:00:00Z",
    "Meeting Number": "12/2014",
    "Meeting Date": "2014-04-10T07:38:03Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "B.O.T စနစ်ဖြင့် Service Apartment များငှားရမ်းခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 18592,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "စက်မှုဝန်ကြီးဌာန ၊ ဆေးဝါးနှင့် စားသောက်ကုန်လုပ်ငန်း",
    "Land Area (units not specified in file)": 0.547,
    "Lease Term": 30,
    "Annual Lease Fee": 0.19,
    "Land Use Premium": 0.54,
    "Number Of Local Employees": 38,
    "Number Of Foreign Employees": 0,
    Status: "Submitted",
    "Investor Address":
      "အမှတ် (၆၃/ ဒီ) ၊ ဦးထွန်းငြိမ်းလမ်း၊ မရမ်းကုန်းမြို့နယ် ၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "-",
    "Investment Permitted Address":
      " အမှတ်(၁၁၇ ) ၊ ဝါးတန်းလမ်း ၊ လမ်းမတော်မြို့နယ်၊ ရန်ကုန်တိုင်း ဒေသကြီး။",
  },
  {
    ID: 828,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Soe Moe Thu",
    "Name of Principal Organization": "Premium Distrubution Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Premium Sojitz Logistics Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1018/2015",
    "Permit Date": "2015-09-25T00:00:00Z",
    "Meeting Number": "16/2015",
    "Meeting Date": "2015-09-11T10:51:19Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Logistics & Warehouse Services Including Cold Chain Logistics, Supply Chain Logistics, Storage Service and IT Solution Service",
    "Amount Of Foreign Capital USD (in Millions)": 7,
    "Total Amount Of Capital (in Millions)": 10,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Win Win Tin",
    "Land Area (units not specified in file)": 0.754,
    "Lease Term": 0,
    "Annual Lease Fee": 0.28,
    "Land Use Premium": null,
    "Number Of Local Employees": 138,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.59 University Avenue Road, Shwe Thung Kyar Ward, No. 1",
    "Organization Address":
      "Unit No. 1-3, Aung San Stadium (North Wing) Gyo Phyu Road",
    "Investment Permitted Address":
      "Myay Taing Block No .27/9, Plot No. 39(B-1), Shwe Pin Lon Housing ",
  },
  {
    ID: 831,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Phee Cheng Koon",
    "Name of Principal Organization": "Phee Central Properties Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Phee Central Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1052/2015",
    "Permit Date": "2015-12-10T00:00:00Z",
    "Meeting Number": "18/2015",
    "Meeting Date": "2015-10-23T10:42:38Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Leasing Space for Warehouse Assembly Plant and Its Related Services",
    "Amount Of Foreign Capital USD (in Millions)": 7.448,
    "Total Amount Of Capital (in Millions)": 10.64,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Myanmar Total Logistic Ltd.",
    "Land Area (units not specified in file)": 3.232,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 270,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address": "18, Marina Boulevard, 20-10 Marina Bay Residences ",
    "Organization Address": "120 Lower Delta Road, 14-11 Chendex Centre ",
    "Investment Permitted Address":
      "Plot No. 42,43, Myay Taing Block No.Industrial Zone-2",
  },
  {
    ID: 840,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. PHICHET  SIVASRI",
    "Name of Principal Organization": "Thana Holding Co., Ltd ",
    "Place of Incorporation": "Thailand",
    "Company Name In Myanmar": "Myanmar CP Livestock CO., Ltd ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "673/2014",
    "Permit Date": "2014-03-06T00:00:00Z",
    "Meeting Number": "6/2014",
    "Meeting Date": "2014-02-13T08:19:46Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing  and  Marketing  of  Animal  Feed",
    "Amount Of Foreign Capital USD (in Millions)": 60,
    "Total Amount Of Capital (in Millions)": 60,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Thailand",
    "Form Of Investment": "FDII",
    "Land Owner": "Ministry of Livestock Beeding and Veterinary ",
    "Land Area (units not specified in file)": 27.31,
    "Lease Term": 50,
    "Annual Lease Fee": 497332,
    "Land Use Premium": 0.53,
    "Number Of Local Employees": 271,
    "Number Of Foreign Employees": 6,
    Status: "Approved",
    "Investor Address":
      "8SOI Patthanakarn 65 Yark 2, Pravet, Bangkok\n10250, THAILAND.",
    "Organization Address":
      "313, CP Tower Building, Silom Road , Kwaeng Silom Road, KWAENGSILOM, KHET Bangrak,\nBANGKOK, THAILAND.\n",
    "Investment Permitted Address":
      "PLOT NO. 529/B, PYIN MA BIN, MINGAlARDON TOWNSHIP, YANGON REGION.",
  },
  {
    ID: 843,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Huang , Yu -Chieh",
    "Name of Principal Organization": "Ultimate Champion Limited",
    "Place of Incorporation": "Samoa",
    "Company Name In Myanmar": "Jim Brother's Yangon Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "830/2014",
    "Permit Date": "2014-10-31T00:00:00Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T09:48:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Varieties of Shoes on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.134,
    "Total Amount Of Capital (in Millions)": 1.134,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Samoa",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Nwe Nwe Aung , Daw Cho Cho Win",
    "Land Area (units not specified in file)": 1.8,
    "Lease Term": 10,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 1500,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address":
      "13F-6, No.65, Sanhe Street, Nantun District, Taichung City , Taiwan, Republic of China",
    "Organization Address": "Offshore Chambers P.O. Box 217,APIA, Samoa",
    "Investment Permitted Address":
      "Plot No.10 of 9+10+11, Myay Taing Block No.25, ShweLin Pan Industrial Zone, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 847,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Sandar Win",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Mybaco Manufacturing Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "893/2013",
    "Permit Date": "2013-03-13T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ကိတ်မုန့်၊ ပေါင်မုန့် နှင့် ဘီစကွတ်မုန့်အမျိုးမျိုးထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.18,
    "Total Amount Of Capital (in Millions)": 1400,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 2.119,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 249,
    "Number Of Foreign Employees": 10,
    Status: "Submitted",
    "Investor Address": "အမှတ်-၁၂၊ (၂) လမ်း၊ (၃) ရပ်ကွက်၊",
    "Organization Address": "-",
    "Investment Permitted Address": "​Plot No. 4, Myay Taing Block No. 112, ",
  },
  {
    ID: 854,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးတင်မောင်​ထွေး",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Kaung Myanmar Aung Shipping Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "863/2012",
    "Permit Date": "2012-10-18T00:00:00Z",
    "Meeting Number": "863/2012",
    "Meeting Date": "2012-10-01T08:04:06Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် ခေတ်မီ ကုန် သေတ္တာတင်သင်္ဘောဆိပ်ကမ်း တည်​ဆောက်၍ ဆိပ်ကမ်းဝန်ဆောင်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 32.54,
    "Total Amount Of Capital (in Millions)": 58539.84,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address": "အမှတ်-၃၅၊ ဖိုးစိန်လမ်း၊ ဗိုလ်ချို(၂) ရပ်ကွက်၊ ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "ပို့   ဆော​င်ရေးဝန်ကြီးဌာန မြန်မာ့ ဆိပ်ကမ်းအာဏာပိုင် မှ ပိုင်ဆိုင်သော ဗိုလ်တထောင်ဘုရားနှင့် ဗိုလ်အောင်ကျော်ဆိပ် ခံတံတား ​အကြားဒေသ  ရှိ ခန့်မှန်း​မြေ  ၂၄ ဧက",
  },
  {
    ID: 856,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Somsavath  Khemsuuyajack ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Green  Drink  Company   Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "679/2014",
    "Permit Date": "2014-12-03T00:00:00Z",
    "Meeting Number": "5/2014",
    "Meeting Date": "2014-02-05T05:22:19Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing  of  Soft   Drink ",
    "Amount Of Foreign Capital USD (in Millions)": 0.839,
    "Total Amount Of Capital (in Millions)": 0.883,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 24,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Lao People's Democratic Republic",
    "Form Of Investment": "JV",
    "Land Owner": "U  Kyaw Swa  Aung ",
    "Land Area (units not specified in file)": 0.413,
    "Lease Term": 10,
    "Annual Lease Fee": 24,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "No.41, UNIT  04, Hongkaikeo  Village, ",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot  No. 88/89, Myay  Taing  Block  No 144,  Tapin  Shwehtee  Road ,  Dagonmyothit  Industial  Zone , Dagon Myothit (South) Township, Yangon Region. ",
  },
  {
    ID: 859,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Simon Mark Arnold",
    "Name of Principal Organization":
      "Jardine Restaurant Group Myanmar Pte Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Jardine CM Restaurant Group Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1003/2015",
    "Permit Date": "2015-09-05T00:00:00Z",
    "Meeting Number": "15/2015",
    "Meeting Date": "2015-08-21T08:40:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Preparation, Marketing, Services and Delivery of Food and Beverages Under The Pizza Hut Brand (Including Dine-In and Delivery Services for all Twelve Outlets)",
    "Amount Of Foreign Capital USD (in Millions)": 1.5,
    "Total Amount Of Capital (in Millions)": 3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner":
      "Yangon City Development Committee ျမို့ျပ စီမံကိန္း နွင့္  ​ေ ျမစီမံခန့္ မှု ဌာနမွ Daw Tin Tin Khin and Daw Win Win Tint ",
    "Land Area (units not specified in file)": 0.1,
    "Lease Term": 3,
    "Annual Lease Fee": 90,
    "Land Use Premium": null,
    "Number Of Local Employees": 144,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address": "239, Alexandra Road,",
    "Organization Address": "239, Alexandra Road,",
    "Investment Permitted Address":
      "Plot No.403, A/19, Block No. 30-B, Corner of Dhamazedi road and Shwe Taung Kyar Street",
  },
  {
    ID: 863,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Hla Wai",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myat Min Co..,Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "Ma Na Tha-979/2014",
    "Permit Date": "2014-05-26T00:00:00Z",
    "Meeting Number": "24/2013",
    "Meeting Date": "2013-09-11T03:34:16Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ ဟိုတယ်ဝန်ဆောင်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 9000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "ပတ်ဝန်ကျင်ထိန်းသိမ်းရေးနှင့် သစ်တောရေးရာဝန်ကြီးဌာန၊ သစ်တောဦးစီးဌာန",
    "Land Area (units not specified in file)": 9.7,
    "Lease Term": 50,
    "Annual Lease Fee": 1.94,
    "Land Use Premium": 0.48,
    "Number Of Local Employees": 171,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "အမှတ် (၃၁) ၊ ရွှေဟင်္သာလမ်း၊ ၆ မိုင်ခွဲ၊ လှိုင်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "-",
    "Investment Permitted Address":
      "အမှတ် (၃၁) ၊ ရွှေဟင်္သာလမ်း၊ ၆ မိုင်ခွဲ၊ လှိုင်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 864,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U TIN MAUNG WIN ",
    "Name of Principal Organization": "MAZE COMPANY LIMITED ",
    "Place of Incorporation": "MYANMAR",
    "Company Name In Myanmar": "PARADISO CINEMAS COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1224/2017",
    "Permit Date": "2017-01-15T00:00:00Z",
    "Meeting Number": "1/2017",
    "Meeting Date": "2017-01-06T05:12:05Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "CONSTRUCTIONS OF CINEMAS AND OPERATION OF MOVIES SHOW",
    "Amount Of Foreign Capital USD (in Millions)": 0.2,
    "Total Amount Of Capital (in Millions)": 0.51,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "U KHIN MAUNG THAN",
    "Land Area (units not specified in file)": 0.92,
    "Lease Term": 10,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 54,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "NO. 33, BADAMYAR STREET, MYANMA GON YAUNG HOUSING COMPLEX, THANTHUMAR TOADK, TAMWE TOWNSHIP, YANGON",
    "Organization Address":
      "NO. 20, PEARL ROAD, GOLDEN VALLEY QUARTER, BAHAN TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "HOLDING NO. 6/3, PLOT NO. 584, YWAR THIT KWIN, TAUT GYI KONE VILLAGE TRACT, HMAWBI TOWNSHIP, YANGON REGION",
  },
  {
    ID: 866,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Sein Oo @ U Law Yain Kyit",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Known-You Seed Myanmar Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1082/2016",
    "Permit Date": "2016-02-17T00:00:00Z",
    "Meeting Number": "3/2016",
    "Meeting Date": "2016-01-30T09:15:41Z",
    Sector: "Agriculture",
    "Type Of Investment Business": "Sowing, Production and Sales of Seeds",
    "Amount Of Foreign Capital USD (in Millions)": 0.96,
    "Total Amount Of Capital (in Millions)": 1.18,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "JV",
    "Land Owner": "U Win Aung (Mandalay)U Zarni Aung Aung (Magway)",
    "Land Area (units not specified in file)": 31.83,
    "Lease Term": 50,
    "Annual Lease Fee": 0.056,
    "Land Use Premium": null,
    "Number Of Local Employees": 89,
    "Number Of Foreign Employees": 1,
    Status: "Approved",
    "Investor Address": "No.92/94, 3rd Floor Bogalay zay Street, Ward No.8, ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No.1/B,(103-104A/B), Yadana Condominium, Pyay Road,(9)Miles, Mayangone Township,Yangon, Mayangone, YANGON",
  },
  {
    ID: 869,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Charbel Michel Abou-Jaoude ",
    "Name of Principal Organization": "Irrawaddy Towers Asset Holding PTE LTD.",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar": "Irrawaddy Green Towers Limited ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "776/2014",
    "Permit Date": "2014-08-14T00:00:00Z",
    "Meeting Number": "18/2014",
    "Meeting Date": "2014-07-09T16:12:03Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Providing Tower sites and power solutions to be used by Telecommunication Operators",
    "Amount Of Foreign Capital USD (in Millions)": 160.794,
    "Total Amount Of Capital (in Millions)": 160.794,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "U Htay Yin (For Office Room) ",
    "Land Area (units not specified in file)": 5000,
    "Lease Term": 15,
    "Annual Lease Fee": 18058.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 142,
    "Number Of Foreign Employees": 69,
    Status: "Approved",
    "Investor Address": "Villa Zuheir Bakhit, Street 47 A, Barsha 2, ",
    "Organization Address": "80 Robinson RD # 02-00 ",
    "Investment Permitted Address": "Nay Pyi Taw, Manadalay, ",
  },
  {
    ID: 871,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဘုန်းမြင့် အောင် (ခ) ဦးမြင့်နိုင်ဦး",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar Tokiwa Corporation Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "850/2012",
    "Permit Date": "2012-07-10T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ခဲတံအမျိုးမျိုးနှင့် အလှကုန်ပစ္စည်းများ ထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 2160.47,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address": "အမှတ်-၂၂၇၊ အောင်ဇေယျလမ်း၊ အောင်ချမ်းသာရပ်",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၄၄/ခ၊ အမှတ်-၃ လမ်းမကြီး၊ ပျဉ်းမပင် စက်မှုနယ်မြေ၊ နှင့် အမှတ်-၁၀၃၊ သစ်စက်ဝင်း ",
  },
  {
    ID: 875,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Quangu Du ",
    "Name of Principal Organization": "China National Fisheries Corp",
    "Place of Incorporation": "PEOPLE'S  REPUBLIC  OF  CHINA",
    "Company Name In Myanmar": "Myanmar CNFC Company Limited ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "806/2014",
    "Permit Date": "2014-10-13T00:00:00Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T04:09:49Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "Processing, Production, Freezing and Exporting of Salt-Water Fish ",
    "Amount Of Foreign Capital USD (in Millions)": 0.5,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Hoke Sein(a) U Aye Sein ",
    "Land Area (units not specified in file)": 2.011,
    "Lease Term": 10,
    "Annual Lease Fee": 41397,
    "Land Use Premium": null,
    "Number Of Local Employees": 175,
    "Number Of Foreign Employees": 6,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.31, Minfeng Hutong, Xidan of Xicheng District, Beijing City",
    "Organization Address":
      "No.31, Minfeng Hutong, Xidan of Xicheng District, Beijing City",
    "Investment Permitted Address":
      "Plot No.32, Hlaing Tharyar Industrial Zone(3), Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 876,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Hans-Henrik Baark ",
    "Name of Principal Organization":
      "ALliance One International Singapore PTE.LTD",
    "Place of Incorporation": "Republic  of Singapore",
    "Company Name In Myanmar": "Alliance One Myanmar Company Limited ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "808/2014",
    "Permit Date": "2014-10-15T00:00:00Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T05:54:46Z",
    Sector: "Agriculture",
    "Type Of Investment Business": "Tobacco Plantaion and Production",
    "Amount Of Foreign Capital USD (in Millions)": 9.75,
    "Total Amount Of Capital (in Millions)": 13,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 4,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Contract farming with 10 farmer",
    "Land Area (units not specified in file)": 12,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 898,
    "Number Of Foreign Employees": 7,
    Status: "Approved",
    "Investor Address": "11 Sunset Drive ",
    "Organization Address": "78 Shenton Way 28-01,",
    "Investment Permitted Address":
      " No.33,6 1 /2 Miles ,Pyay Road., Yankin, YANGON",
  },
  {
    ID: 877,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမော​င်ကျေး",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Virtue Lamd Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "888/2013",
    "Permit Date": "2013-02-13T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Other Services",
    "Type Of Investment Business":
      "B.O.T စနစ်ဖြင့် လမ်းပြုပြင်ဖောက်လုပ်၍ လမ်းအသုံးပြုခ ကောက်ခံခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 4.677,
    "Total Amount Of Capital (in Millions)": 19578.037,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address":
      "အမှတ်-စီ-၄၊ မွန်မြတ်မေတ္တာလုံးခြင်း အိမ်ယာ၊ ပင်ရေွှညောင်လမ်း ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "ဗားဂရာ ကမ်းနားဒေသမှ ဗို​လ်တထောင် ကမ်းနားဒေသထိ (၅.၀၆၉) မိုင်၊ ရန်ကုန်ကမ်းနားလမ်းသစ် လမ်းအပိုင်း ကြည့်မြင်တိုင်",
  },
  {
    ID: 878,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor":
      "Managing Director, Myanma Petroleum Products Enterprise, Ministry of Energy",
    "Name of Principal Organization": "Ministry of Energy",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "National Energy Puma Aviation Services Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1017/2016",
    "Permit Date": "2016-03-26T00:00:00Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T04:54:36Z",
    Sector: "Oil and Gas",
    "Type Of Investment Business":
      "Management and Marketing of Jet Fuel Products, Providing Service Including Importation Storage, Distribution, Transportation and Intoplane Fueling",
    "Amount Of Foreign Capital USD (in Millions)": 80,
    "Total Amount Of Capital (in Millions)": 106.02,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 8,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Myanmar Petroleum Products Enterprise(MPPE)",
    "Land Area (units not specified in file)": 19628,
    "Lease Term": 30,
    "Annual Lease Fee": 0.02,
    "Land Use Premium": null,
    "Number Of Local Employees": 96,
    "Number Of Foreign Employees": 1,
    Status: "Approved",
    "Investor Address": "Building No. 6 Nay Pyi Taw",
    "Organization Address": "Building No. 6 Nay Pyi Taw",
    "Investment Permitted Address":
      "No. 1, Refinery (Thanlyin) (Storage Tank Area) , Thanlyin Township, Yangon",
  },
  {
    ID: 880,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Seog Chaung Son",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "The Republish of Korea",
    "Company Name In Myanmar":
      "Innio International Development Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "921/2015",
    "Permit Date": "2015-04-07T00:00:00Z",
    "Meeting Number": "921/2015",
    "Meeting Date": "2015-04-01T07:45:16Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Construction And Operation of Services Apartment, Hotel , Office Bulding And Shopping Mall",
    "Amount Of Foreign Capital USD (in Millions)": 98,
    "Total Amount Of Capital (in Millions)": 100,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "JV",
    "Land Owner": "Miniatry of Defence",
    "Land Area (units not specified in file)": 6.18,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 385,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "539-1, Sang-Dong, Wonmi-Gu, Bucheon-Si, Gyeonggi-Do,Korea",
    "Organization Address":
      "239,Songnae-Daero, Wonmi-Gu, Bucheon-Si, Gyeonggi-Do,Korea",
    "Investment Permitted Address":
      "Shwe Man Thu Bus Compound, Corner of Wayzanyantar Road & Parimi Road, Plot No-(148,149,150) ,Myay Taing Block No-(4+5 Kaytu Malar), South Okkalapa Township, Yangon Region",
  },
  {
    ID: 882,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကျော်ဇင်လတ်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Dynamic Industry Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "847/2012",
    "Permit Date": "2012-05-31T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "မော်တော်ယာဉ် ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 4.16,
    "Total Amount Of Capital (in Millions)": 3771.39,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address": "အမှတ်-၁၆၂-၁၆၄၊ မြေညီထပ်",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၅၂၊ ၇၉) ဒဂုံဆိပ်ကမ်းစက်မှုဇုန်",
  },
  {
    ID: 883,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Maung Maung Khin",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Great Timber World Company Limited (ဂရိတ်(ထ်) တင်း(မ်)ဘားဝါး(လ်ဒ်) ကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1100/2015",
    "Permit Date": "2015-11-11T00:00:00Z",
    "Meeting Number": "19/2015",
    "Meeting Date": "2015-10-30T05:18:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အရည်အသွေးမြင့် သစ်ခွဲသားမျိုးစုံ ထုတ်လုပ်၍ ပြည်ပတင်ပို့ခြင်းနှင့် ပြည်တွင်းရောင်းချခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.352,
    "Total Amount Of Capital (in Millions)": 702,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 1.812,
    "Lease Term": 10,
    "Annual Lease Fee": 12,
    "Land Use Premium": null,
    "Number Of Local Employees": 69,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် (၈၇)၊ (၃၈) လမ်း၊ (၆) ရပ်ကွက်၊ ကျောက်တံတားမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No.198/16, Corner of U Pho Hlaing Street & Thamardi Street, Dagon Seikkan Industrial Zone(1), Dagon(seikkan), YANGON",
  },
  {
    ID: 886,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ချိန်ယုရင်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Sampar Oo Industires Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "868/2012",
    "Permit Date": "2012-11-19T00:00:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "အချိုရည်မျိုးစုံထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 5.44,
    "Total Amount Of Capital (in Millions)": 7389.81,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 0,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address": "အမှတ်-၂၃၇၊ ၃၄ လမ်း၊ ၈၄ လမ်းနှင့် ၈၅ လမ်းကြား ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "အမှတ်-၁၁၃၊ စက်မှုဇုန် အပိုင်း-၄၊ ၆၅ စက်မှု ၊ ဘုရင့် နောင်လမ်း၊",
  },
  {
    ID: 888,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Shigeru Sugimura",
    "Name of Principal Organization": "Itsumiya Company Limited",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Itsumiya Myanmar Company Limited.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "954/2015",
    "Permit Date": "2015-05-13T00:00:00Z",
    "Meeting Number": "7/2015",
    "Meeting Date": "2015-04-28T04:31:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Sales of Japanese Food and Confectionery",
    "Amount Of Foreign Capital USD (in Millions)": 1.6,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "U Kyi Lwin",
    "Land Area (units not specified in file)": 2.032,
    "Lease Term": 40,
    "Annual Lease Fee": 0.0411,
    "Land Use Premium": null,
    "Number Of Local Employees": 178,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address": "13-10 Tenjincho",
    "Organization Address": "4-21-17, Kokubo",
    "Investment Permitted Address":
      "Plot No-369, Myay Taing Block No-49, Wartaya Industrial Zone",
  },
  {
    ID: 894,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Tin Tun Oo",
    "Name of Principal Organization": "Yoma Agriculture Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Myfood Industries Myanmar Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "013/2017",
    "Permit Date": "2017-07-23T17:30:00Z",
    "Meeting Number": "10/2017",
    "Meeting Date": "2017-07-10T17:30:00Z",
    Sector: "Agriculture",
    "Type Of Investment Business":
      "Cultivation, Manufacturing and Canning of Grown Fruit and Vegetable Products ",
    "Amount Of Foreign Capital USD (in Millions)": 4.159,
    "Total Amount Of Capital (in Millions)": 10.398,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 4,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Germany",
    "Form Of Investment": "JV",
    "Land Owner": "Yoma Agriculture Company Limited",
    "Land Area (units not specified in file)": 100,
    "Lease Term": 50,
    "Annual Lease Fee": 0.011,
    "Land Use Premium": null,
    "Number Of Local Employees": 170,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 53, Ground Floor, Lower Block, Lanmadaw Street, Lanmadaw Township",
    "Organization Address":
      "FMI Centre, Level 10 & 11, No.380, Bagyoke Aung San Road, ",
    "Investment Permitted Address":
      "The Campus, 1 Office Park, Rain Tree Drive, Pun Hlaing Estate., Hlaingtharyar, YANGON",
  },
  {
    ID: 896,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Sai Myo Win",
    "Name of Principal Organization":
      "Jade king& Queen Gems & Jewellery Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Global Agriculture Joint Venture Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "022/2017",
    "Permit Date": "2017-09-24T17:30:00Z",
    "Meeting Number": "12/2017",
    "Meeting Date": "2017-08-28T17:30:00Z",
    Sector: "Agriculture",
    "Type Of Investment Business": "Plantation, Production and Sales of Teak",
    "Amount Of Foreign Capital USD (in Millions)": 103.5,
    "Total Amount Of Capital (in Millions)": 115,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Virgin Islands (British)",
    "Form Of Investment": "JV",
    "Land Owner":
      "Forest Department (Jade king& Queen Gems & Jewellery Co., Ltd.)",
    "Land Area (units not specified in file)": 10000,
    "Lease Term": 32,
    "Annual Lease Fee": 0.359,
    "Land Use Premium": 0,
    "Number Of Local Employees": 536,
    "Number Of Foreign Employees": 14,
    Status: "Approved",
    "Investor Address": "No.34, Shwe Taung Kyar Street, Ward-2",
    "Organization Address":
      "No.53/54, Setsayar U Tun Street, Shwe Pyi Thar Industrial Zone-4",
    "Investment Permitted Address":
      "No. 5 (A) 10th Ward Pyay Road ., Hlaing, YANGON",
  },
  {
    ID: 897,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw Khine Lin",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "G A C (Myanmar) Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1304/2017",
    "Permit Date": "2017-06-21T17:30:01Z",
    "Meeting Number": "8/2017",
    "Meeting Date": "2017-05-18T17:30:00Z",
    Sector: "Agriculture",
    "Type Of Investment Business":
      "Sowing, Production and Marketing of Coffee Bean (Arabica) and Vegetable Seeds",
    "Amount Of Foreign Capital USD (in Millions)": 0.8,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Ohnmar Hein",
    "Land Area (units not specified in file)": 46.86,
    "Lease Term": 30,
    "Annual Lease Fee": 0.004,
    "Land Use Premium": null,
    "Number Of Local Employees": 18,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address": "No.24, May Li  Kha Street, Ward No-7",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Room No. 703, 7th Floor, Kandawgyi Tower, Tamwe Township, Yangon., Tamwe, YANGON",
  },
  {
    ID: 898,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Zaw Win",
    "Name of Principal Organization": "Nay Wun Myat Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Timberland Plantation Investment Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1289/2017",
    "Permit Date": "2017-05-30T17:30:00Z",
    "Meeting Number": "7/2017",
    "Meeting Date": "2017-04-27T17:30:01Z",
    Sector: "Agriculture",
    "Type Of Investment Business":
      "Plantation, Production and Marketing of Acacia ((Mangium), Acacia (Auriculforms) and Yemane",
    "Amount Of Foreign Capital USD (in Millions)": 2.476,
    "Total Amount Of Capital (in Millions)": 3.809,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 4,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner":
      "သစ်တောဦးစီးဌာန၊ သယံဇာတနှင့် သဘာဝပတ်ဝန်းကျင် ထိန်းသိမ်းရေး ဝန်ကြီးဌာန",
    "Land Area (units not specified in file)": 5010,
    "Lease Term": 30,
    "Annual Lease Fee": 20.04,
    "Land Use Premium": 150.3,
    "Number Of Local Employees": 287,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address": "No.42, Pyin Nyar Tan  Saung Road, Ward No.43",
    "Organization Address":
      "No.8-A, Khabaung Street, Martin Avenue, 6 Mile, Pyay Road",
    "Investment Permitted Address":
      "No.(282-F1), Mahar Thukhitar 7th Street (North) East Gyogone, Insein , Insein, YANGON",
  },
  {
    ID: 905,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. TAN GHEE KIAT",
    "Name of Principal Organization": "Prestige Platform Sdn, Bhd",
    "Place of Incorporation": "kuala lumpur",
    "Company Name In Myanmar": "Myanmar Royal Prestige Plantation Co., Ltd.",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "456/2011",
    "Permit Date": "2011-02-04T05:28:10Z",
    "Meeting Number": "1/2011(ကုန်သွယ်မှုမူဝါဒကောင်စီအစည်းအဝေး)",
    "Meeting Date": "2011-01-16T05:31:21Z",
    Sector: "Agriculture",
    "Type Of Investment Business": "Palm oil plantation and palm oil mill",
    "Amount Of Foreign Capital USD (in Millions)": 40,
    "Total Amount Of Capital (in Millions)": 40,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 30,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Malaysia",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": 30000,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 200,
    "Number Of Foreign Employees": 9,
    Status: "Approved",
    "Investor Address":
      "No.7, LORONG TEMPINIS, KANAN DUA LUCKY GARDEN BANGSAR, 59100",
    "Organization Address":
      "Suite16-08, Level 16, Wisma Uoa II, 21, Jalan Pinang 50450",
    "Investment Permitted Address":
      "No 30 A Room No .9 ,Yaw Min Gyi Street Yaw Min Gyi Ward., Dagon, YANGON, Myanmar\n",
  },
  {
    ID: 909,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Wu Tin Yin",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "City-Glass Technology Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1310/2017",
    "Permit Date": "2017-08-09T17:30:00Z",
    "Meeting Number": "10/2017",
    "Meeting Date": "2017-07-10T17:30:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Fabrication, Processing And Seles of Varieties of Glasses",
    "Amount Of Foreign Capital USD (in Millions)": 0.75,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "U Wu Tin Yin ",
    "Land Area (units not specified in file)": 0.8,
    "Lease Term": 30,
    "Annual Lease Fee": 0.013,
    "Land Use Premium": null,
    "Number Of Local Employees": 56,
    "Number Of Foreign Employees": 2,
    Status: "Approved",
    "Investor Address": "Building No .22, Room Nno .1-A, Bo Yar Nyunt Street",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No.15, Hlaing Tharyar Indutrial Zone-4, ",
  },
  {
    ID: 910,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.PRADEEP GANEDIWAL",
    "Name of Principal Organization": "Blue Ocean Global Private Ltd",
    "Place of Incorporation": "MP (INDIA)",
    "Company Name In Myanmar": "Blue Ocean Myanmar Ltd",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "493/2012",
    "Permit Date": "2012-07-31T06:22:32Z",
    "Meeting Number": "19/2012",
    "Meeting Date": "2012-07-04T06:36:49Z",
    Sector: "Agriculture",
    "Type Of Investment Business":
      "၀ါမျိုးစေ့များထုတ်လုပ်ရောင်းချခြင်း၊ ၀ါကြိတ်စက်နှင့် ၀ါစေ့ဆီကြိတ်စက်များ အဆင့်မြှင့်တင်၍ Lint, Edible Oil, De-Oiled Cake များ ထုတ်လုပ်ခြင်း နှင့် ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 4.5,
    "Total Amount Of Capital (in Millions)": 4.5,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner":
      "လယ်ယာစိုက်ပျိုးရေးနှင့် ဆည်မြောင်းဝန်ကြီးဌာန၊ စက်မှု သီးနှံဖွံ့ဖြိုးရေး ဦးစီးဌာန",
    "Land Area (units not specified in file)": 20.88,
    "Lease Term": 5,
    "Annual Lease Fee": 0.05,
    "Land Use Premium": null,
    "Number Of Local Employees": 535,
    "Number Of Foreign Employees": 9,
    Status: "Approved",
    "Investor Address":
      "401 Princess Centre, 6/3 New Palasia Indore. M.P (INDIA)",
    "Organization Address":
      "401, Princess Centre, 6/3 New Palasia Indore.M.P (INDIA)",
    "Investment Permitted Address":
      "No.277,Asia Plaza(5th Floor),Room No.528,Corner of Bogyoke Aung San Street & 38th Street, Kyauktadar Township, Yangon, Kyauktatar, YANGON",
  },
  {
    ID: 912,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U MYO CHO",
    "Name of Principal Organization": "MCGRO International Co.,Ltd",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "SRISUBAN MYANMAR COMPANY",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "662/2014",
    "Permit Date": "2014-01-31T07:31:48Z",
    "Meeting Number": "1/2014",
    "Meeting Date": "2014-01-08T07:40:45Z",
    Sector: "Agriculture",
    "Type Of Investment Business": "Oil Palm Plantation and Production",
    "Amount Of Foreign Capital USD (in Millions)": 10,
    "Total Amount Of Capital (in Millions)": 11520,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner":
      "မြေလွတ်၊ မြေလတ် နှင့် မြေရိုင်းများစီမံခန့်ခွဲရေး ဗဟိုကော်မတီ",
    "Land Area (units not specified in file)": 5000,
    "Lease Term": null,
    "Annual Lease Fee": 15,
    "Land Use Premium": 50,
    "Number Of Local Employees": 1561,
    "Number Of Foreign Employees": 6,
    Status: "Approved",
    "Investor Address":
      "No.48A, Thanlwin Street, Shwe Taung Kyar Ward (2), Bahan Township, Yangon.",
    "Organization Address":
      "No.48A, Thanlwin Street, Shwe Taung Kyar Ward (2), Bahan Township, Yangon.",
    "Investment Permitted Address":
      "No. 48(A), Thanlwin Road, Golden Valley Ward, Bahan Township, Yangon, , Bahan, YANGON",
  },
  {
    ID: 916,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Soe Moe Thu",
    "Name of Principal Organization": "City Mart Holding Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "CM Japan Agri Myanmar Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "618/2013",
    "Permit Date": "2013-09-08T17:30:01Z",
    "Meeting Number": "22/2013",
    "Meeting Date": "2013-08-20T17:30:00Z",
    Sector: "Agriculture",
    "Type Of Investment Business":
      "Plantation Processing and Packauging of Asparagus, Carrots, Cauliflower Lettuce and Strawberries",
    "Amount Of Foreign Capital USD (in Millions)": 0.5,
    "Total Amount Of Capital (in Millions)": 1.25,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "ဦးညိုတုတ်",
    "Land Area (units not specified in file)": 5.5,
    "Lease Term": 0,
    "Annual Lease Fee": 0.03,
    "Land Use Premium": 0.1,
    "Number Of Local Employees": 22,
    "Number Of Foreign Employees": 4,
    Status: "Approved",
    "Investor Address": "Room No. 647/8-D, Mya Kan Tha(1) Street, ",
    "Organization Address":
      "No.1-11, Padonmar Stadium (East Wing), Bargayar Street",
    "Investment Permitted Address":
      "1-11, Padonmar Stadium (East Wing), Bargayar Street, Sanchaung Township, Yangon., Sanchaung, YANGON",
  },
  {
    ID: 921,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Tang Jun",
    "Name of Principal Organization": "China Unicom (Hong Kong) Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "China Unicom (MYA) Operations Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1317/2017",
    "Permit Date": "2017-08-08T17:30:01Z",
    "Meeting Number": "10/2017",
    "Meeting Date": "2017-07-10T17:30:01Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business": "Communication Technology Related Services",
    "Amount Of Foreign Capital USD (in Millions)": 37.12,
    "Total Amount Of Capital (in Millions)": 37.12,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "Exe Sakura (Myanmar) Co., Ltd.",
    "Land Area (units not specified in file)": 137.6,
    "Lease Term": 1,
    "Annual Lease Fee": 0.082,
    "Land Use Premium": null,
    "Number Of Local Employees": 17,
    "Number Of Foreign Employees": 10,
    Status: "Approved",
    "Investor Address": "No.29, Yu Zhou Road, Jiu Long Po District, ",
    "Organization Address": "75 th Floor, The Center 99 Queen's Road Central",
    "Investment Permitted Address":
      "အခန်းအမှတ်-၁၇၀၆, ၁၇ လွှာ၊ ဆာကူရာတာဝါ-၃၃၉, ဗိုလ်ချုပ်အောင်ဆန်းလမ်း",
  },
  {
    ID: 923,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Patrick Michael Dick",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Silamas (Myanmar) Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1315/2017",
    "Permit Date": "2017-08-08T17:30:01Z",
    "Meeting Number": "10/2017",
    "Meeting Date": "2017-07-10T17:30:00Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Conductiong Services, Studies, Engineering, Lifting And Relocation of Infrastructure Components",
    "Amount Of Foreign Capital USD (in Millions)": 4.5,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "Daw San San Htay",
    "Land Area (units not specified in file)": 155,
    "Lease Term": 10,
    "Annual Lease Fee": 2,
    "Land Use Premium": 0.1,
    "Number Of Local Employees": 23,
    "Number Of Foreign Employees": 4,
    Status: "Submitted",
    "Investor Address":
      "Building No.21, Room No.01, Shwe Ohn Pin Housing Complex,Yan Shin Street",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Holding No.20/KHA, 21/KA, Kwin No.668, Moe Kaung Kwin, Nyaung Ton Pin Village Tract, Thanlyin Township",
  },
  {
    ID: 924,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Abdul Hafiz @ U Aung Naing",
    "Name of Principal Organization": "May Yu Marine Products Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Nutrifood Products Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1308/2017",
    "Permit Date": "2017-07-13T17:30:01Z",
    "Meeting Number": "9/2017",
    "Meeting Date": "2017-06-15T17:30:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Distrubution of Preserved and Canned Fish, Fruits and Various Kinds of Beans",
    "Amount Of Foreign Capital USD (in Millions)": 1.184,
    "Total Amount Of Capital (in Millions)": 2.96,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "May Yu Marine Products Co., Ltd.",
    "Land Area (units not specified in file)": 5.326,
    "Lease Term": 50,
    "Annual Lease Fee": 0.02,
    "Land Use Premium": 0.1,
    "Number Of Local Employees": 240,
    "Number Of Foreign Employees": 8,
    Status: "Monitoring Approved",
    "Investor Address": "No.79/80, Mya Yamon Housing Complex, Ward No.26, ",
    "Organization Address": "Plot No.525, Block No.23, Industiral Zone -1",
    "Investment Permitted Address":
      "Plot No.525, Myay Taing Block No.23, Industrial Zone-1",
  },
  {
    ID: 925,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Zaw Min Oo",
    "Name of Principal Organization": "Myanmar Tochnology Gateway Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "MTG- Numix Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1301/2017",
    "Permit Date": "2017-07-13T17:30:00Z",
    "Meeting Number": "9/2017",
    "Meeting Date": "2017-06-15T17:30:00Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Develop and Operate Satellite Teleport and Its Related Services",
    "Amount Of Foreign Capital USD (in Millions)": 1.54,
    "Total Amount Of Capital (in Millions)": 3.15,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Malaysia",
    "Form Of Investment": "JV",
    "Land Owner": "Myanmar Technology Gateway Co., Ltd.",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 15,
    "Annual Lease Fee": 0.017,
    "Land Use Premium": 0,
    "Number Of Local Employees": 27,
    "Number Of Foreign Employees": 6,
    Status: "Approved",
    "Investor Address":
      "no.C/7, Kabar Aye Villa, Kabar Aye Pagoda Road, Ward No.5, Mayangone Township, Yangon",
    "Organization Address":
      "No.8, Ground Floor, Pan Chan Tower, Dhama ZediRoad",
    "Investment Permitted Address":
      "No.505, Building No. 11, MICT Park, Hlaing Township, Yangon.",
  },
  {
    ID: 928,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR KWANG HO JEONG",
    "Name of Principal Organization": "CJ GLOBAL HOLDINGS LIMITED ",
    "Place of Incorporation": "HONGKONG",
    "Company Name In Myanmar": "CJ FEED MYANMAR",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "047/2017",
    "Permit Date": "2017-12-30T03:56:29Z",
    "Meeting Number": "17/2017",
    "Meeting Date": "2017-12-22T03:57:14Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "poultry breeder farm and sale of hatching eggs",
    "Amount Of Foreign Capital USD (in Millions)": 2.1,
    "Total Amount Of Capital (in Millions)": 2.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Thein and Daw Kyi Kyi Than",
    "Land Area (units not specified in file)": 10,
    "Lease Term": 50,
    "Annual Lease Fee": 3500000,
    "Land Use Premium": null,
    "Number Of Local Employees": 41,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "401 HO, BAIKJE GOBUN RO 9 GIL 22 (JAMSIL DONG) SONG PA GU, SEOUL , REPUBLIC OF KOREA",
    "Organization Address":
      "SUITE 3003, 30/F CENTRAL PLAZA , 18 HARBOUR ROAD, WANCHAI, HONGKONG",
    "Investment Permitted Address": "Bldg 18, 1st Flr to 4th Flr, MICT Park,",
  },
  {
    ID: 929,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Xu, Jianjun",
    "Name of Principal Organization":
      "Da Hua Envioronmental Sci-Tech (HK) Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "DA HUA (Myanmar) Company LImited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "057/2018",
    "Permit Date": "2018-02-14T04:23:41Z",
    "Meeting Number": "2/2018",
    "Meeting Date": "2018-02-02T04:24:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Polyester Staple Fibre on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.15,
    "Total Amount Of Capital (in Millions)": 5.19,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Room No.27-401, Yunngguang, Huating, Tonglu, Hangzhou City, Zhejiang, Peop;e's Republic of China",
    "Organization Address":
      "Flat 2, 7/F BLK A Hung Hong Court Hung Hom Bay CTR 92 Baker St, KLN, Hong Kong",
    "Investment Permitted Address":
      "Plot No 209,238 Myaung Ta Gar Steel Industrial Zone., Hlegu, YANGON",
  },
  {
    ID: 930,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Chit Khing (@) U Jaw NI",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Wiseland Investment (Myanmar) Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "052/2018",
    "Permit Date": "2018-01-30T04:19:16Z",
    "Meeting Number": "1/2018",
    "Meeting Date": "2018-01-15T04:20:28Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Service",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 72800,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "Ministry of Hotel and Tourism, Department of Hotel and Tourism",
    "Land Area (units not specified in file)": 4.227,
    "Lease Term": 50,
    "Annual Lease Fee": 0.462,
    "Land Use Premium": null,
    "Number Of Local Employees": 268,
    "Number Of Foreign Employees": 6,
    Status: "Approved",
    "Investor Address": "No. 100/F, Inyar Street, 9 Quarter",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No.1, Kaba Aye Pagoda Road, No.(6)Ward, Yankin Township, Yangon., Yankin, YANGON",
  },
  {
    ID: 933,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Mya Han",
    "Name of Principal Organization": "Fortune International Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Saturn And Fortune Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "054/2018",
    "Permit Date": "2018-02-14T05:37:51Z",
    "Meeting Number": "2/2018",
    "Meeting Date": "2018-02-02T05:38:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and marketing of bathroom products and accessories",
    "Amount Of Foreign Capital USD (in Millions)": 2.75,
    "Total Amount Of Capital (in Millions)": 5.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Democratic People's Republic of)",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Khin Sabai Kyi",
    "Land Area (units not specified in file)": 1.988,
    "Lease Term": 20,
    "Annual Lease Fee": 0.1,
    "Land Use Premium": null,
    "Number Of Local Employees": 80,
    "Number Of Foreign Employees": 3,
    Status: "Amend",
    "Investor Address": "No.615-D, Pyay Road, ",
    "Organization Address":
      "Building No.12, MICT Park, Hlaing University Compound ,Hlaing Township, Yangon",
    "Investment Permitted Address":
      "Plot No. (85), Block No. Industrial Zone (1), Hlaing Thar Yar Township, Yangon., Hlaingtharyar, YANGON",
  },
  {
    ID: 936,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Huo Changxin",
    "Name of Principal Organization":
      "Benxi Changfeng Real Estate Development Co., Ltd.",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Yangon Golden River Investment Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "050/2018",
    "Permit Date": "2018-01-30T05:45:44Z",
    "Meeting Number": "1/2018",
    "Meeting Date": "2018-01-15T05:47:06Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Construction, Selling, Leasing and Management of Commercial and Residential Buildings",
    "Amount Of Foreign Capital USD (in Millions)": 57.6,
    "Total Amount Of Capital (in Millions)": 72,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Su Hnin Wai and Daw Swe Thazin",
    "Land Area (units not specified in file)": 3.18,
    "Lease Term": 50,
    "Annual Lease Fee": 64365,
    "Land Use Premium": null,
    "Number Of Local Employees": 61,
    "Number Of Foreign Employees": 10,
    Status: "Submitted",
    "Investor Address":
      "No. 2-3-2, Buildings, Fenghua Street, Pingshan District, Benxi, Liaoning, China",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No 61,62,63,64,65,66,67,68,69,70,71 And 78 ,Mya Khwar Nyo Apartment Project Survey Block No(8)., Tharkayta, YANGON",
  },
  {
    ID: 937,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "High Tech Concrete Company Limited",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "High Tech Concrete Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "077/2018",
    "Permit Date": "2018-01-30T06:06:46Z",
    "Meeting Number": "1/2018",
    "Meeting Date": "2018-01-15T06:06:57Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Distribution of Ready-Mixed Concrete",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 14922.961,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 49,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Shwe Taung Cement and Construction Matreial Co., Ltd.",
    "Land Area (units not specified in file)": 7.993,
    "Lease Term": 49,
    "Annual Lease Fee": 85.44,
    "Land Use Premium": null,
    "Number Of Local Employees": 734,
    "Number Of Foreign Employees": 1,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၁ ဘီ ရန်ကြီးအောင်လမ်း သာကေတစက်မှုဇုန် သာကေတမြို့နယ် ရန်ကုန်",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၄၂ ၄၃ ၄၄ ၄၅ ၄၆ မြေတိုင်းရပ်ကွက်အမှတ် ၃၉ (စက်မှု) ရွှေပြည်သာမြို့နယ် မြေကွက်အမှတ် ၂၅၂ မြမာလာလမ်း သာကေတမြို့နယ် မြေကွက်အမှတ် −၁ ဘီ ရန်ကြီးအောင်လမ်း သာကေတမြို့နယ်နှင့် မြေကွက်အမှတ်−၁ မြမာလာလမ်း သာကောတမြို့နယ် ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 938,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyaw Nay Win",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Omni Focus General Services Public Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "049/2018",
    "Permit Date": "2018-01-12T07:47:48Z",
    "Meeting Number": "-",
    "Meeting Date": "2018-01-15T07:59:00Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Transport Services within Yangon",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 11094.7,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 1,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No. 29, Maykha Street, 7 Ward, Mayangone Township, Yangon, Myanmar",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No.257,Insein Street, Hlaing Township, YANGON",
  },
  {
    ID: 939,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. NGUYEN THE HUNG",
    "Name of Principal Organization": "NIL",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ALPHAVINA   CONSTRUCTION   COMPANY    LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "063/2017",
    "Permit Date": "2017-10-18T03:59:27Z",
    "Meeting Number": "14/2017",
    "Meeting Date": "2017-10-10T03:59:37Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and marketing for concrete pole, pile and pipe products",
    "Amount Of Foreign Capital USD (in Millions)": 0.9,
    "Total Amount Of Capital (in Millions)": 0.9,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Vietnam",
    "Form Of Investment": "FDII",
    "Land Owner": "U Soe Nwe ",
    "Land Area (units not specified in file)": 1.84,
    "Lease Term": 5,
    "Annual Lease Fee": 12,
    "Land Use Premium": null,
    "Number Of Local Employees": 68,
    "Number Of Foreign Employees": 6,
    Status: "Monitoring Approved",
    "Investor Address":
      "P 202, T 8, CT 18, DT VIET HUNG LOING BIEN, HANOI, VIETNAM",
    "Organization Address": "NIL",
    "Investment Permitted Address":
      "No 147, Set Hmu Street 3 Myittar Nyunt Quarter., Tamwe, YANGON",
  },
  {
    ID: 940,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw Nan Mouk Laung Seing",
    "Name of Principal Organization": "Shwe Than Lwin Media Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Dream Vision Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "061/2018",
    "Permit Date": "2018-02-14T04:04:50Z",
    "Meeting Number": "2/2018",
    "Meeting Date": "2018-02-02T04:05:13Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Media Content Production and Distribution",
    "Amount Of Foreign Capital USD (in Millions)": 61,
    "Total Amount Of Capital (in Millions)": 77.72,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "Shwe Than Lwin Trading Co., Ltd.",
    "Land Area (units not specified in file)": 28313,
    "Lease Term": 50,
    "Annual Lease Fee": 288,
    "Land Use Premium": null,
    "Number Of Local Employees": 212,
    "Number Of Foreign Employees": 8,
    Status: "Monitoring Approved",
    "Investor Address": "No. I-10, Sabai Street, Sanchaung Township, Yangon",
    "Organization Address":
      "No. 262, Yarzardiyit Housing Compound, Lower Pazun Daung Road, Botahtaung Township, Yangon",
    "Investment Permitted Address":
      "no.51, Block No.43 (D), Corner of Malar Nwe Street and Pin Shwe Nyaung Street, Tamwe Lay Ward, Tamwe Township, Yangon",
  },
  {
    ID: 943,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lin, Chun-Sheng",
    "Name of Principal Organization": "NIL",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Taieasy Textile (MTT) Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "064/2017",
    "Permit Date": "2017-10-18T04:30:12Z",
    "Meeting Number": "14/2017",
    "Meeting Date": "2017-10-10T04:30:19Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of garment on CMP Basis ",
    "Amount Of Foreign Capital USD (in Millions)": 7.5,
    "Total Amount Of Capital (in Millions)": 7.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Min Min Thwe ",
    "Land Area (units not specified in file)": 6.56,
    "Lease Term": 20,
    "Annual Lease Fee": 220.416,
    "Land Use Premium": null,
    "Number Of Local Employees": 1485,
    "Number Of Foreign Employees": 15,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 11F, JIHU ROAD, NEIHU DISTRICT, TAIPEI CITY, 114, TAIWAN, REPUBLIC OF CHINA",
    "Organization Address": "NIL",
    "Investment Permitted Address":
      "No.(342,3/344)(88+89), Myay Taing Block No- Yangon Industrial Zone, Mingalardon Township, Yangon., Mingalardon, YANGON.\n",
  },
  {
    ID: 944,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "MAHA NYI AHKO COMPANY LIMITED",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MAHA NYI AHKYO COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "073/2017",
    "Permit Date": "2017-12-12T04:41:25Z",
    "Meeting Number": "16/2017",
    "Meeting Date": "2017-11-30T04:42:09Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP နှင့် Normal စနစ်(၂) မျိုးဖြင့် သီဟိုဠ်စေ့၊ ငရုတ်၊ မြေပဲ၊ နှမ်းနှင့် ပဲအမျိုးမျိုးသန့်စင်ခြင်း၊ ကြိတ်ခွဲခြင်း၊ ထုတ်ပိုးခြင်းနှင့် ရောင်းချခြင်းလုပ်ငန်း\n",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 3450,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 1,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "not required",
    "Land Area (units not specified in file)": 1.5,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.(Nya/3), Apthawka Street, Bayint Naung Pwe Yone Tann, Mayangone, YANGON",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.(Nya/3), Apthawka Street, Bayint Naung Pwe Yone Tann, Mayangone, YANGON",
  },
  {
    ID: 947,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U MAUNG MYINNT",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "BRIGHT LIGHT COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "065/2017",
    "Permit Date": "2017-11-24T05:19:06Z",
    "Meeting Number": "15/2017",
    "Meeting Date": "2017-11-10T05:19:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ပဲအမျိုးမျိုး သန့်စင်ခြင်း၊ ကြိတ်ခွဲခြင်းနှင့် ထုတ်လုပ် ရောင်းချခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 3600,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 1,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Bright Light Company Limited",
    "Land Area (units not specified in file)": 2.334,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 39,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "NO.403, 9 LEVEL, MAWTIN TOWER, NEW STREET",
    "Organization Address": "",
    "Investment Permitted Address":
      "Block (18), Plot No(24), Ngwe Pin Lae Industrial Zone, Hlaingtharyar Township, YANGON",
  },
  {
    ID: 948,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.HUANG , SIWEI",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "HAIZHIYUANN AQUATIC PRODUCTS(YANGON) COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "072/2017",
    "Permit Date": "2017-12-12T05:32:51Z",
    "Meeting Number": "16/2107",
    "Meeting Date": "2017-11-30T05:33:57Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "Processing, Freezing, Packing and Marketing of Aquatic Products (such as all kind of sea fish and shrimp) Under Normal System",
    "Amount Of Foreign Capital USD (in Millions)": 0.3,
    "Total Amount Of Capital (in Millions)": 0.3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Wan Min Kyu",
    "Land Area (units not specified in file)": 2.534,
    "Lease Term": 30,
    "Annual Lease Fee": 0.0358,
    "Land Use Premium": null,
    "Number Of Local Employees": 107,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address": "NO.36, ZHENGSHU ROAD, ZHENGXIANG",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.141, Block No, Industrial Zone (2), Industrial Zone Dagon Myothit (Seikkan) Township, Yangon., Dagon(seikkan), YANGON",
  },
  {
    ID: 950,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ဟောက်ဇနွမ်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ဟန်ကီအင်တာနေရှင်နယ် ကုမ္ပဏီလီမိတက်  (Hanki International Company Limited)",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "016/2017",
    "Permit Date": "2017-07-14T07:10:32Z",
    "Meeting Number": "9/2017",
    "Meeting Date": "2017-06-16T07:10:55Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် ထီး ထုတ်လုပ်သည့်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 418.15,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်သန္တာထွန်း",
    "Land Area (units not specified in file)": 0.142,
    "Lease Term": 10,
    "Annual Lease Fee": 0,
    "Land Use Premium": null,
    "Number Of Local Employees": 101,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address":
      "တိုက်-၂၉၊ အခန်း-၀၀၁၊ မြမင်္ဂလာလမ်း၊ စစ်တောင်းရိပ်မွန်၊ ၉၂ ရပ်ကွက်၊ \tယုဇနဥယျာဉ်မြို့တော်၊ ဒဂုံ(ဆိပ်ကမ်း) မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.243/244, Maga Street, Bogone, Hinnthargone Quarter, Bago Ddivision., Bago, BAGO",
  },
  {
    ID: 954,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်သီတာဦး",
    "Name of Principal Organization": "NIL",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ရန်ကုန်စပွန်ချ် ကုမ္ပဏီလီမိတက်    (Yangon Sponge Company Limited)",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "030/2017",
    "Permit Date": "2017-07-24T07:54:43Z",
    "Meeting Number": "10/2017",
    "Meeting Date": "2017-07-11T07:55:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "ဖော့ရေမြှုပ်ထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1350,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးဟောင်တင်ချိန် (ခ) ဦးညွှန့်စိန်",
    "Land Area (units not specified in file)": 4.467,
    "Lease Term": 5,
    "Annual Lease Fee": 151.2,
    "Land Use Premium": null,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": 15,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၃၀၅(၇+၁ ဒီ)၊ပါရမီကွန်ဒို၊ ဦးသင်းဖေလမ်း၊ ၁၆ ရပ်ကွက်၊ လှိုင်မြို့နယ်၊ ရန်ကုန်မြို့၊ ရန်ကုန်တိုင်းဒေသကြီး။",
    "Organization Address": "NIL",
    "Investment Permitted Address":
      "No(53),Myakhatta Street,MyaSeinyound Industrial, Hlaing, YANGON",
  },
  {
    ID: 956,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mrs. Naree Wongmanee ",
    "Name of Principal Organization": "BASF (THAI) LTD",
    "Place of Incorporation": "Thailand",
    "Company Name In Myanmar": "BASF Myanmar Manufacturing Company  Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "025/2017",
    "Permit Date": "2017-10-03T08:22:48Z",
    "Meeting Number": "13/2017",
    "Meeting Date": "2017-09-25T08:22:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and sales of construction chemicals",
    "Amount Of Foreign Capital USD (in Millions)": 1.155,
    "Total Amount Of Capital (in Millions)": 1.155,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Thailand",
    "Form Of Investment": "FDII",
    "Land Owner": "U Ohn Kywe Soe",
    "Land Area (units not specified in file)": 1.505,
    "Lease Term": 5,
    "Annual Lease Fee": 0.114,
    "Land Use Premium": null,
    "Number Of Local Employees": 20,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address":
      "1/3 MOO 10, LAM LUK KA SUB-DISTRICT, LAM LUK KA DISTRICT, PATHUM THANI 12150, THAILAND",
    "Organization Address":
      "622 ROOM 1-6 EMPORIUM TOWER, 23rd FLOOR, SUKHUMVIT 24 ROAD, KLONGTON  SUB-DISTRICT, KLONGTOEY DISTRICT, BANGKOK, THAILAND",
    "Investment Permitted Address":
      "Myanmar Center Tower 1, Floor 07 , Unit 08, No.192, Kaba Aye Pagoda Road., Bahan, YANGON",
  },
  {
    ID: 957,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U KYAW NAING SOE",
    "Name of Principal Organization": "SHWE TAUNG CEMENT COMPANY   LIMITED",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Shwe Taung Cement Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "017/2017",
    "Permit Date": "2017-08-10T08:45:21Z",
    "Meeting Number": "10/2017",
    "Meeting Date": "2017-07-11T08:46:40Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing and marketing of cement ",
    "Amount Of Foreign Capital USD (in Millions)": 75,
    "Total Amount Of Capital (in Millions)": 110,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "United States of America",
    "Form Of Investment": "JV",
    "Land Owner": "Forest Department",
    "Land Area (units not specified in file)": 455,
    "Lease Term": 50,
    "Annual Lease Fee": 45.5,
    "Land Use Premium": null,
    "Number Of Local Employees": 344,
    "Number Of Foreign Employees": 8,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 234, SHWE BONE THAR STREET, PABEDAN TOWNSHIP, YANGON",
    "Organization Address":
      "NO.94,  BUILDING   A,   NAT  MAUK   STREET,      BO CHO QUARTER, BAHAN TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "No.(94), UBC Building (A), Natmount Street, Bo Cho Ward, , Bahan, YANGON",
  },
  {
    ID: 966,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kevin Stuart Burrell ",
    "Name of Principal Organization": "Deutsche Post International B.V",
    "Place of Incorporation": "The Netherlands",
    "Company Name In Myanmar": "DHL Supply Chain Myanmar Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1290/2017",
    "Permit Date": "2017-06-20T17:30:00Z",
    "Meeting Number": "8/2017",
    "Meeting Date": "2017-05-18T17:30:01Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Supply Chain Management, Logistics and Warehousing Services",
    "Amount Of Foreign Capital USD (in Millions)": 113.93,
    "Total Amount Of Capital (in Millions)": 113.93,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 10,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Netherlands",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Aye Aye Myint",
    "Land Area (units not specified in file)": 4.79,
    "Lease Term": 3,
    "Annual Lease Fee": 0.771,
    "Land Use Premium": 0,
    "Number Of Local Employees": 61,
    "Number Of Foreign Employees": 3,
    Status: "Submitted",
    "Investor Address":
      "209 K Tower A 11th, 18th Fioor Sukhumwit, 21 Road (Asoke). Klongtoey-Nua, Wattana",
    "Organization Address": "Pierre De Coubertinweg 7 N, 6225 XT Maastricht",
    "Investment Permitted Address":
      "PLOT NO 359,  YANGON  INDUSTRIAL  ZONE,  MINGALARDON  TOWNSHIP, YANGON  REGION",
  },
  {
    ID: 969,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Soh Puay Khong",
    "Name of Principal Organization": "VIZ Branz Pte. Ltd",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Myanmar VB Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1306/2017",
    "Permit Date": "2017-06-21T17:30:01Z",
    "Meeting Number": "8/2017",
    "Meeting Date": "2017-05-18T17:30:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Distribution of Instant Cereal Mix, Instant Coffee Mix, Instant Tea Mix, Cereal Bars and Cereal Flakes",
    "Amount Of Foreign Capital USD (in Millions)": 12.4,
    "Total Amount Of Capital (in Millions)": 15.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "U Aung Zaw Win, U San Lwin",
    "Land Area (units not specified in file)": 4.593,
    "Lease Term": 30,
    "Annual Lease Fee": 0.396,
    "Land Use Premium": 0,
    "Number Of Local Employees": 676,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address": "BLK 348, Hougang Avenue-7",
    "Organization Address": "50 Raffles Place, ",
    "Investment Permitted Address": "Plot No. 11 and 12, Industrial Zone-2, ",
  },
  {
    ID: 970,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Chen, Ya-Wen",
    "Name of Principal Organization": "Easy Bonanza Int'l Ltd.",
    "Place of Incorporation": "Negara Bruniei Darussalam",
    "Company Name In Myanmar": "MIZI BAGS Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1298/2017",
    "Permit Date": "2017-06-20T17:30:01Z",
    "Meeting Number": "8/2017",
    "Meeting Date": "2017-05-18T17:30:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.03,
    "Total Amount Of Capital (in Millions)": 2.03,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Brunei Darussalam",
    "Form Of Investment": "FDII",
    "Land Owner":
      "U Kyin Wan @ U Kyin Win, Daw Aye, Daw Khin Lay @ Daw Khin Khin Lay , U Kyin Soe & Daw Khin Htay @ Daw Su Su Win",
    "Land Area (units not specified in file)": 0.367,
    "Lease Term": 50,
    "Annual Lease Fee": 0.015,
    "Land Use Premium": null,
    "Number Of Local Employees": 1085,
    "Number Of Foreign Employees": 20,
    Status: "Approved",
    "Investor Address":
      "No.8, Jinhua Road, North district,Taichung City -404,Taiwan",
    "Organization Address":
      "RM.51, 5th floor, Britannia House, Jalan Cator Bandar Seri, Begawan BS 8811,Negara Bruniei Darussalam",
    "Investment Permitted Address":
      "Holding No.2,3,4,5,24- Sethmu, Kwin No.1037(A), Paike Gyi Wae (6/2), Village Tract, Hlegu Township, Yangon Region",
  },
  {
    ID: 971,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Tang, Qun",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Newtop Lotus Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1297/2017",
    "Permit Date": "2017-06-20T17:30:00Z",
    "Meeting Number": "8/2017",
    "Meeting Date": "2017-05-18T17:30:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.95,
    "Total Amount Of Capital (in Millions)": 1.97,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Lay Po",
    "Land Area (units not specified in file)": 1.473,
    "Lease Term": 10,
    "Annual Lease Fee": 0.12,
    "Land Use Premium": 0,
    "Number Of Local Employees": 925,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address": "No.502, Block No .58, Titan an Garden, Nantong",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No.109, Myay Taing Block No.Industrial Zone-2, ",
  },
  {
    ID: 972,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mrs. Ye, Fanghong",
    "Name of Principal Organization":
      "Xiang Rui International Trading Co., Ltd.",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Myanmar Xiang Rui Fashion Co.,Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1293/2017",
    "Permit Date": "2017-06-20T17:30:00Z",
    "Meeting Number": "8/2017",
    "Meeting Date": "2017-05-18T17:30:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 9.97,
    "Total Amount Of Capital (in Millions)": 9.97,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Tin Tun",
    "Land Area (units not specified in file)": 7.528,
    "Lease Term": 50,
    "Annual Lease Fee": 0.153,
    "Land Use Premium": 0,
    "Number Of Local Employees": 757,
    "Number Of Foreign Employees": 13,
    Status: "Amend",
    "Investor Address":
      "Nan Feng Village, Xiao Zhi Township, Lin Hai City, Zhenjiang Province, China",
    "Organization Address":
      "Room 1104, 11/F, Shanghai Industrial Investment Bldg 48-62 Hennessy RD",
    "Investment Permitted Address":
      "152, Oak Tha Pha Yar St., Thar Du Kan Industrial Zone,, Shwe Pyi Thar township, Yangon Region",
  },
  {
    ID: 973,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Kyaw Khin",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Myanmar DECO-TBSP Special Products Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1299/2017",
    "Permit Date": "2017-06-20T17:30:00Z",
    "Meeting Number": "8/2017",
    "Meeting Date": "2017-05-18T17:30:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Various Printed Documents Such as Passbook (Saving Book) and Cheque Book",
    "Amount Of Foreign Capital USD (in Millions)": 0.76,
    "Total Amount Of Capital (in Millions)": 1.55,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "U Kyaw Khin, Daw Aye Nan",
    "Land Area (units not specified in file)": 2.011,
    "Lease Term": 30,
    "Annual Lease Fee": 0.043,
    "Land Use Premium": 0,
    "Number Of Local Employees": 242,
    "Number Of Foreign Employees": 8,
    Status: "Rejected",
    "Investor Address":
      "No.3C, Ward No.9, U Tun Nyo Street, Industrial Zone.66, ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No. 61, Hlaing Tharyar Industrial Zone-3",
  },
  {
    ID: 977,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chen, Liang",
    "Name of Principal Organization": "",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "China Palette Garment Myanmar Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1271/2017",
    "Permit Date": "2017-05-08T17:30:00Z",
    "Meeting Number": "6/2017",
    "Meeting Date": "2017-04-04T17:30:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3.64,
    "Total Amount Of Capital (in Millions)": 3.64,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Zaw Myo Htet",
    "Land Area (units not specified in file)": 2.547,
    "Lease Term": 10,
    "Annual Lease Fee": 0.057,
    "Land Use Premium": 0,
    "Number Of Local Employees": 502,
    "Number Of Foreign Employees": 24,
    Status: "Monitoring Approved",
    "Investor Address":
      "Chang Qing Shi, Yu Bei Qu, Bao Sheng Dong Lu, 54 Hao 1-2, China",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 142,  MYAY TAING BLOCK NO. 49, WARTAYAR INDUSTRIAL ZONE, SHWE PYI THAR TOWNSHIP,   YANGON REGION   ",
  },
  {
    ID: 979,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Chen Juan",
    "Name of Principal Organization":
      "Online Fashion International Trading Co., Ltd.",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Maisha (Myanmar) Garment Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1267/2017",
    "Permit Date": "2017-05-08T17:30:00Z",
    "Meeting Number": "6/2017",
    "Meeting Date": "2017-04-04T17:30:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4,
    "Total Amount Of Capital (in Millions)": 4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Than Linn (a) U Mon Linn and U Kyaw Linn",
    "Land Area (units not specified in file)": 4.139,
    "Lease Term": 10,
    "Annual Lease Fee": 0.07,
    "Land Use Premium": 0.02,
    "Number Of Local Employees": 1612,
    "Number Of Foreign Employees": 30,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.18, Building, Shouchuang International Airport Center, No.6, Changcheng Nan Road, Chengyang District, Qingdao City",
    "Organization Address": "Room C21/f, Central 88.88 DES Voeux Road",
    "Investment Permitted Address":
      "Plot No.19 & 20, Myay Taing Block No.112 (Industrial Zone), ",
  },
  {
    ID: 980,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Han Jianfeng",
    "Name of Principal Organization":
      "JIANGSU GUOTAI OVERSEAS TECHNICAL SERVICE CO., LTD.",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "GTIG HUBO Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1272/2017",
    "Permit Date": "2017-05-08T17:30:00Z",
    "Meeting Number": "6/2017",
    "Meeting Date": "2017-04-04T17:30:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.64,
    "Total Amount Of Capital (in Millions)": 2.64,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Kyauk Chi Phone ",
    "Land Area (units not specified in file)": 4.47,
    "Lease Term": 30,
    "Annual Lease Fee": 0.02,
    "Land Use Premium": null,
    "Number Of Local Employees": 614,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 101, BUILDING 6, DONGDU HUAYUAN, ZHANGJIAGANG, JIANGSU, PEOPLE’S REPUBLIC OF CHINA        ",
    "Organization Address":
      "ROOM 308, JINBI MANSION, BEIJING ROAD, ZHANGJIAGANG FREE TRADE ZONE, PEOPLE’S REPUBLIC OF CHINA        ",
    "Investment Permitted Address":
      "PLOT NO. 147, 154,  MYAY TAING BLOCK NO. 49, WARTAYAR INDUSTRIAL ZONE, SHWE PYI THAR TOWNSHIP,  YANGON REGION   ",
  },
  {
    ID: 981,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Han Jianfeng",
    "Name of Principal Organization":
      "Jiangsu Guotai Overseas Technical Services Co., Ltd.",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "GTIG Eastar Garment (Myanmar) Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1274/2017",
    "Permit Date": "2017-05-08T17:30:00Z",
    "Meeting Number": "6/2017",
    "Meeting Date": "2017-04-04T17:30:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.24,
    "Total Amount Of Capital (in Millions)": 1.24,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Kyauk Chi Phone",
    "Land Area (units not specified in file)": 4.588,
    "Lease Term": 30,
    "Annual Lease Fee": 0.02,
    "Land Use Premium": null,
    "Number Of Local Employees": 757,
    "Number Of Foreign Employees": 11,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 101, BUILDING 6, DONGDU HUAYUAN, ZHANGJIAGANG, JIANGSU, PEOPLE’S REPUBLIC OF CHINA",
    "Organization Address":
      "Room 308, Jinbi Mansion, Beijing Road, Zhangjiagang Free Trade Zone",
    "Investment Permitted Address":
      "Plot No.148 & 153, Myay Taing Block No.49, Wartayar Industrial Zone",
  },
  {
    ID: 982,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Han Jianfeng",
    "Name of Principal Organization":
      "Jiangsu Guotai Overseas Technical Service Co., Ltd.",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Guohua Glory Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1278/2017",
    "Permit Date": "2017-05-08T17:30:01Z",
    "Meeting Number": "6/2017",
    "Meeting Date": "2017-04-04T17:30:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.04,
    "Total Amount Of Capital (in Millions)": 2.04,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Wai Wai Htwe",
    "Land Area (units not specified in file)": 3.54,
    "Lease Term": 30,
    "Annual Lease Fee": 0.016,
    "Land Use Premium": null,
    "Number Of Local Employees": 1935,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.101, Building  6, Dongdu Huayuan Zhangjiagang, Jiangsu, Peoples's Republic of China",
    "Organization Address":
      "Room 308, Jinbi Mansion Beijing Road, Zhangjiagang Free Trade Zone",
    "Investment Permitted Address":
      "Plot No.138, Myay Taing Block No.49, Wartayar Industrial Zone",
  },
  {
    ID: 983,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Han Jianfeng",
    "Name of Principal Organization":
      "Jiangsu Guotai Overseas Technical Services Co., Ltd.",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "GTIG Huasheng  (Myanmar) Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1269/2017",
    "Permit Date": "2017-05-08T17:30:01Z",
    "Meeting Number": "6/2017",
    "Meeting Date": "2017-04-04T17:30:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.44,
    "Total Amount Of Capital (in Millions)": 1.44,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Wai Wai Htwe",
    "Land Area (units not specified in file)": 3.59,
    "Lease Term": 30,
    "Annual Lease Fee": 0.015,
    "Land Use Premium": null,
    "Number Of Local Employees": 541,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.101, Building 6, Dongdu Huayuan Zhangjiagang, Jiangsu, Peoples Republic of China. ",
    "Organization Address":
      "Room 308, Jinbi Mansion Beijing Road, Zhangjiagang Free Trade Zone, Republic of China .",
    "Investment Permitted Address":
      "Plot No. 139, Myay Taing Block No.49, Wartayar Industrial Zone, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 984,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Han Jianfeng",
    "Name of Principal Organization":
      "Jiangsu Guotai Overseas Technical Service Co., Ltd.",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "U & G (Myanmar) Fashion Co. Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1268/2017",
    "Permit Date": "2017-05-08T17:30:01Z",
    "Meeting Number": "6/2017",
    "Meeting Date": "2017-04-04T17:30:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.64,
    "Total Amount Of Capital (in Millions)": 2.64,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Wai Wai Htwe",
    "Land Area (units not specified in file)": 4.35,
    "Lease Term": 30,
    "Annual Lease Fee": 0.019,
    "Land Use Premium": null,
    "Number Of Local Employees": 900,
    "Number Of Foreign Employees": 30,
    Status: "Monitoring Approved",
    "Investor Address": "No.101, Building 6, dongdu Huayuan, Zhanhjiagang ",
    "Organization Address":
      "Room 308, Jinbi Mansion Beijing Road Zhangjiagang Free Trade Zone",
    "Investment Permitted Address":
      "Plot No.140, Myay Taing Block No.49, Wartayar Industrial Zone",
  },
  {
    ID: 985,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhang, Youjian",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Ming Da Polyester Wadding (Myanmar) CO., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1270/2017",
    "Permit Date": "2017-05-08T17:30:01Z",
    "Meeting Number": "6/2017",
    "Meeting Date": "2017-04-04T17:30:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Sales of Spraying Collodion Polyester, Imitation Silk Polyester Eiderdown Polyester, Needle-Punched Polyester, Vertical Polyester, Non-Woven Fabric Lining Cloth and Quilting For various Kinds of Garment",
    "Amount Of Foreign Capital USD (in Millions)": 1.04,
    "Total Amount Of Capital (in Millions)": 1.04,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "ဦးအုံးလွင်(ခ) ဦးဌေးငြိမ်း၊ ဦးအောင်တင့်၊ ဦးသက်လွင်",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 20,
    "Annual Lease Fee": 0.021,
    "Land Use Premium": null,
    "Number Of Local Employees": 70,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "Liao Ning Sheng, Da Lian Shi Zhong Shan Qu Hai Le Jie 17 HAO",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No. 48, Hlaing Thar Yar Industrial Zoen-1,\n",
  },
  {
    ID: 986,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Carl Albert M. Destrooper",
    "Name of Principal Organization": "BDH AZIE B.V ",
    "Place of Incorporation": "Netherlands",
    "Company Name In Myanmar": "Bel Ga Myanmar Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1275/2017",
    "Permit Date": "2017-05-08T17:30:01Z",
    "Meeting Number": "6/2017",
    "Meeting Date": "2017-04-04T17:30:01Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "Production, Distribution and Sales of Day Old Chickes (Doc)",
    "Amount Of Foreign Capital USD (in Millions)": 4.177,
    "Total Amount Of Capital (in Millions)": 4.177,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Netherlands",
    "Form Of Investment": "FDII",
    "Land Owner": "ဦးငေါ်စိုးမြင့်",
    "Land Area (units not specified in file)": 5.51,
    "Lease Term": 50,
    "Annual Lease Fee": 0.111,
    "Land Use Premium": null,
    "Number Of Local Employees": 17,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address": "Steenweg Op Hoogstraten 145, 2330 Merksplas, ",
    "Organization Address": "6717 VE Ede Dld,",
    "Investment Permitted Address":
      "Plot No.312, 313 and 314, Myaung Dakar Steel Industrial Zone ",
  },
  {
    ID: 991,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyaw Naing Oo",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Hotel Sule Square Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "085/2018",
    "Permit Date": "2018-03-07T03:16:26Z",
    "Meeting Number": "3/2018",
    "Meeting Date": "2018-02-27T02:56:41Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business":
      "Courtyard  Marriott Hotel Yangon Hotel Service ",
    "Amount Of Foreign Capital USD (in Millions)": 33.33,
    "Total Amount Of Capital (in Millions)": 97730.6,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Zaw Naing Oo and U Thet Naing Oo",
    "Land Area (units not specified in file)": 0.24,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 250,
    "Number Of Foreign Employees": 4,
    Status: "Approved",
    "Investor Address":
      "No.229, Anayahtar Road, 12-ward, Kyauktatar Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.229, Anayahtar Road, 12-ward, Kyauktatar Township, Yangon",
  },
  {
    ID: 992,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U HTAY OO",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "U KYU FAMILY COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "063/2018",
    "Permit Date": "2018-03-08T05:58:31Z",
    "Meeting Number": "3/2018",
    "Meeting Date": "2018-02-27T05:57:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ဂျံ ု မှုန့် ထုတ်လုပ်ဖြန့်ဖြူခြင်းနှင့် ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 11583,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးကြူမိသားစုသီးနှံနှင့် ထုတ်လုပ်ရေးကုမ္ပဏီလီမိတက်",
    "Land Area (units not specified in file)": 7.219,
    "Lease Term": 50,
    "Annual Lease Fee": 158.4,
    "Land Use Premium": null,
    "Number Of Local Employees": 112,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၁၂၇)၊ေမြညီထပ်၊ (၁၅)လမ်း၊ အမှတ်(၇) ရပ်ကွက်၊ လမ်းမတော်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "NO.(127), Ground Floor, 7 Ward,Lanmadaw, YANGON",
  },
  {
    ID: 993,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.SABBIR AHMED KHAN",
    "Name of Principal Organization": "CRYSTAL FUTURE VENTURE LTD",
    "Place of Incorporation":
      "NO. 272/B, DHAMAYONE STREET, WARD 13, YANKIN TOWNSHIP, YANGON DIVISION.",
    "Company Name In Myanmar": "CRYSTAL FUTURE VENTURE MYANMAR CO., LTD",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1248/2017",
    "Permit Date": "2017-04-11T04:04:51Z",
    "Meeting Number": "MIC 5/2017",
    "Meeting Date": "2017-03-13T04:06:42Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "TELECOM NETWORK SURVEY, DESIGN AND PLANNING OF TELECOM NETWORK, INSTALLATION AND COMMISSIONING OF TELECOM NETWORKING EQUIPMENT, REGULAR MAINTENANCE, OPTIMIZATION AND UP-GRADATION OF NETWORK SERVICES",
    "Amount Of Foreign Capital USD (in Millions)": 1.077,
    "Total Amount Of Capital (in Millions)": 1.076896,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 2,
    "Investing Country": "Bangladesh",
    "Form Of Investment": "FDII",
    "Land Owner": "U WIN KYAW AND D SOE SOE AUNG",
    "Land Area (units not specified in file)": 0.08,
    "Lease Term": 2,
    "Annual Lease Fee": 36000000,
    "Land Use Premium": null,
    "Number Of Local Employees": 140,
    "Number Of Foreign Employees": 20,
    Status: "Approved",
    "Investor Address":
      "HOUSE # 21, ROAD# 8/A, NIKUNJA 1, (SOUTH), KHILKHET, DHAKA, PEOPLE'S REPUBLIC OF BANGLADESH",
    "Organization Address":
      "NO. 272/B, DHAMAYONE STREET, WARD 13, YANKIN TOWNSHIP, YANGON DIVISION.",
    "Investment Permitted Address":
      "NO. 272/B, DHAMAYONE STREET, WARD 13, YANKIN TOWNSHIP, YANGON DIVISION.",
  },
  {
    ID: 994,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Mya Han",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Fortune Telecom Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "062/2018",
    "Permit Date": "2018-03-06T04:12:38Z",
    "Meeting Number": "3/2018",
    "Meeting Date": "2018-02-27T04:12:57Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Fixed & Wireless Broadband Service Provider using Fiber Infrastructure and 2600 MHz LTE Spectrum ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 74892.061,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 136,
    "Number Of Foreign Employees": 10,
    Status: "Approved",
    "Investor Address":
      "No.12/B, Khapaung Street, Ward No. 10, Hlaing Township, Yangon.",
    "Organization Address": "",
    "Investment Permitted Address":
      "NO. 12, MICT Park, Hlaning Campus , Hlaing Townshop, Yangon.",
  },
  {
    ID: 995,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Randolph Post Eddy III",
    "Name of Principal Organization": "Four Rivers Real Estatte Pte. Ltd. ",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Four Rivers Inya Office Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1280/2017",
    "Permit Date": "2017-05-09T04:23:47Z",
    "Meeting Number": "6/2017",
    "Meeting Date": "2017-04-04T04:25:40Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Construction of  Office Tower, Leasing and Management of  Office Space\n",
    "Amount Of Foreign Capital USD (in Millions)": 41.447,
    "Total Amount Of Capital (in Millions)": 41.447,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Than Than Htut ",
    "Land Area (units not specified in file)": 0.48,
    "Lease Term": 40,
    "Annual Lease Fee": 0.63,
    "Land Use Premium": null,
    "Number Of Local Employees": 51,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "2 Ashton Drive, Greenwich CT 06831, Washington County, New York, United States. ",
    "Organization Address":
      "77 Robison Road, # 16-00 Robinson 77, Singapore  068896",
    "Investment Permitted Address":
      "No. 20,  Survey block No. 85/  kanbe,  Plot No. 5-A/1,A/2,  Kabar  Aye Pagoda   Road,  Yankin Township , Yangon Region\n",
  },
  {
    ID: 996,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "DAW KHIN MYA OO",
    "Name of Principal Organization": "YANGON",
    "Place of Incorporation": "YANGON",
    "Company Name In Myanmar": "FORWARD MAY CO., LTD",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1245/2017",
    "Permit Date": "2017-05-24T04:18:52Z",
    "Meeting Number": "MIC 7/2017",
    "Meeting Date": "2017-04-28T04:19:53Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "HOTEL SERVICE",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 2159.72,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Khin Mya Oo",
    "Land Area (units not specified in file)": 2.51,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 70,
    "Number Of Foreign Employees": 1,
    Status: "Approved",
    "Investor Address":
      "A/4, KABAAYE VILLA, KABAAYE PAGODA STREET, MAYANGONE TOWNSHIP",
    "Organization Address": "NO. 10/A, ZIWAKA STREET, DAGON TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "NO. 10/A, ZIWAKA STREET, DAGON TOWNSHIP, YANGON",
  },
  {
    ID: 997,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. WU, SONGBO",
    "Name of Principal Organization":
      "SHANGHAI YANGDON INVESTMENT AND DEVELOPMENT CO., LTD",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "MAUBIN UNITED DEVELOPMENT COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "032/2017",
    "Permit Date": "2017-11-24T05:46:55Z",
    "Meeting Number": "15/2017",
    "Meeting Date": "2017-11-10T03:54:28Z",
    Sector: "Industrial Estate",
    "Type Of Investment Business":
      "CONSTRUCTION, OPERATION AND LEASING OF MAUBIN INDUSTRIAL PARK",
    "Amount Of Foreign Capital USD (in Millions)": 15.788,
    "Total Amount Of Capital (in Millions)": 28.706,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "Maubin Development Public Company Limited ",
    "Land Area (units not specified in file)": 249.48,
    "Lease Term": 50,
    "Annual Lease Fee": 33.43,
    "Land Use Premium": null,
    "Number Of Local Employees": 72,
    "Number Of Foreign Employees": 8,
    Status: "Approved",
    "Investor Address":
      "ROOM 614, 6/F, NO.26, JIAFENG ROAD, CHINA (SHANGHAI) PILOT FREE TRADE ZONE, CHINA ",
    "Organization Address":
      "ROOM 614, 6/F, NO.26, JIAFENG ROAD, CHINA (SHANGHAI) PILOT FREE TRADE ZONE,CHINA",
    "Investment Permitted Address":
      "No.1008, Shwe Hnin Si Street, Ward No.5, Mayangone Township, Yangon.",
  },
  {
    ID: 998,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U NYAN MIN HTUT   ",
    "Name of Principal Organization":
      "GREEN VISION CONSTRUCTION COMPANY LIMITED",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "YANGON PROPERTY  MANAGEMENT COMPANY LIMITED ",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "047/2017",
    "Permit Date": "2017-08-20T06:04:04Z",
    "Meeting Number": "11/2017",
    "Meeting Date": "2017-08-07T06:04:30Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "RENOVATION, OPERATION AND LEASING OF OFFICE BUILDING",
    "Amount Of Foreign Capital USD (in Millions)": 1.84,
    "Total Amount Of Capital (in Millions)": 2.3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 11,
    "Investing Country": "France",
    "Form Of Investment": "JV",
    "Land Owner":
      "U Poe Sein, Daw Khin Lay Nwe, U Phone Naing, U Aung Naing, U Soe Naing ",
    "Land Area (units not specified in file)": 0.154,
    "Lease Term": 15,
    "Annual Lease Fee": 408,
    "Land Use Premium": null,
    "Number Of Local Employees": 39,
    "Number Of Foreign Employees": 1,
    Status: "Draft",
    "Investor Address":
      "NO. 16(A), THUKHA WADI STREET, (6) WARD, YANKIN TOWNSHIP, YANGON",
    "Organization Address":
      "NO. 16(A), THUKHA WADI STREET, (6) WARD, YANKIN TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "NO. 16(A), THUKHA WADI STREET, (6) WARD, YANKIN TOWNSHIP, YANGON",
  },
  {
    ID: 999,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U YE MYINT",
    "Name of Principal Organization": "OLYMPIC CO., LTD",
    "Place of Incorporation": "YANGON",
    "Company Name In Myanmar": "HI STAR CO., LTD",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1263/2017",
    "Permit Date": "2017-08-09T06:04:32Z",
    "Meeting Number": "MIC 10/2017",
    "Meeting Date": "2017-07-11T06:07:05Z",
    Sector: "Real Estate",
    "Type Of Investment Business": "CONSTRUCTION OF ECONOMIC BUILDING SERVICES",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1500,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "MYANMAR RAIL WAY",
    "Land Area (units not specified in file)": 0.682,
    "Lease Term": 30,
    "Annual Lease Fee": 300,
    "Land Use Premium": 2250,
    "Number Of Local Employees": 104,
    "Number Of Foreign Employees": 0,
    Status: "Submitted",
    "Investor Address":
      "NO. 2, DAGON LWIN STREET, TARMWAE LAY WARD, TARMWAE TOWNSHIP, YANGON DIVISION",
    "Organization Address":
      "OLYMIC TOWER II, RIVER VIEW GARDEN HOUSING, (2nd floor, strand Road, Ahlone Tsp, YANGON",
    "Investment Permitted Address":
      "AHLONE TOWER, THIRD FLOOR, STRAND ROAD, AHLONE TOWNSHIP, YANGON DIVISION ",
  },
  {
    ID: 1000,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yoshio Saeki",
    "Name of Principal Organization": "Yangon Museum Development Pte. Ldt.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Y Complex Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "001/2017",
    "Permit Date": "2017-05-30T06:07:55Z",
    "Meeting Number": "8/2017",
    "Meeting Date": "2017-05-19T06:11:13Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Hotel, Office and Shopping \t\tComplex    Project  ",
    "Amount Of Foreign Capital USD (in Millions)": 284.8,
    "Total Amount Of Capital (in Millions)": 320,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 47,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Quartermaster General Office",
    "Land Area (units not specified in file)": 3.955,
    "Lease Term": 47,
    "Annual Lease Fee": 500000,
    "Land Use Premium": 60000000,
    "Number Of Local Employees": 527,
    "Number Of Foreign Employees": 14,
    Status: "Monitoring Approved",
    "Investor Address":
      "209,Cosomo, Nilzashiki, 1-7-38 Owada Niiza City, Saitama Pref, Japan",
    "Organization Address": "3 Shenton Way, # 25-01 A, Singapore",
    "Investment Permitted Address":
      "La Pyayt Wun Plaza, No.  37, Alanpya Pagoda Road,Room No. 612, 6th Floor, Dagon Tsp, Yangon Yangon",
  },
  {
    ID: 1001,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U MAUNG MAUNG MYINT",
    "Name of Principal Organization": "LOI SENG KHAM CO., LTD",
    "Place of Incorporation": "BAHAN TSP, YANGON DIVISION",
    "Company Name In Myanmar": "LOI SENG KHAM CO., LTD",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1250/2017",
    "Permit Date": "2017-05-24T06:51:33Z",
    "Meeting Number": "MIC 7/2017",
    "Meeting Date": "2017-04-28T06:52:12Z",
    Sector: "Real Estate",
    "Type Of Investment Business": "SERVICES OF RENTAL BUSINESS ROOMS",
    "Amount Of Foreign Capital USD (in Millions)": 6.391,
    "Total Amount Of Capital (in Millions)": 15000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U MAUNG MAUNG MYINT",
    "Land Area (units not specified in file)": 0.568,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 34,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "NO. 271, SHWE GON DAING STREET, MIDDLE OF SHWE GON DAING WARD, BAHAN TSP, YANGON DIVISION",
    "Organization Address":
      "NO. 271, SHWE GON DAING STREET, MIDDLE OF SHWE GON DAING WARD, BAHAN TSP, YANGON DIVISION",
    "Investment Permitted Address":
      "NO. 271, SHWE GON DAING STREET, MIDDLE OF SHWE GON DAING WARD, BAHAN TSP, YANGON DIVISION",
  },
  {
    ID: 1003,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr.Lim Thiam Chye",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "SOUTHLAND MYANMAR RUBBER COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "053/2017",
    "Permit Date": "2017-09-14T05:46:30Z",
    "Meeting Number": "12/2017",
    "Meeting Date": "2017-08-29T05:47:13Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF MIXTURE RUBBER AND RE-GRADING FOR NATURAL RUBBER",
    "Amount Of Foreign Capital USD (in Millions)": 4,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner":
      "U WONG LAW SEIN (a) U HLA THEIN & DAW KOE KYIN HOON (a) DAW KHIN KHIN YEE",
    "Land Area (units not specified in file)": 3.728,
    "Lease Term": 30,
    "Annual Lease Fee": 36000,
    "Land Use Premium": null,
    "Number Of Local Employees": 69,
    "Number Of Foreign Employees": 2,
    Status: "Approved",
    "Investor Address": "20 PENSHURST PLACE , SINGAPORE 556435",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 15,16, Thilawar Industrial Zone, Thanlyin-Kyauktan Township, Yangon region",
  },
  {
    ID: 1005,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Aye Sandar Lwin",
    "Name of Principal Organization": "LIUVIA Limited",
    "Place of Incorporation": "Yangon",
    "Company Name In Myanmar":
      "International Bulk Terminal (Thilawa) Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "029/2017",
    "Permit Date": "2017-10-18T08:33:28Z",
    "Meeting Number": "14/2017",
    "Meeting Date": "2017-10-10T08:34:09Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "construction and operation of a river port terminal and related warehouse, silo and other logistics facilities",
    "Amount Of Foreign Capital USD (in Millions)": 38.86,
    "Total Amount Of Capital (in Millions)": 65.44,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 48,
    "Investing Country": "Japan",
    "Form Of Investment": "JV,BOT",
    "Land Owner": "Myanma Port Authority ",
    "Land Area (units not specified in file)": 20,
    "Lease Term": 48,
    "Annual Lease Fee": 6,
    "Land Use Premium": 30000000,
    "Number Of Local Employees": 148,
    "Number Of Foreign Employees": 4,
    Status: "Approved",
    "Investor Address":
      "No.383, Thunadar 9th, G Quarter, North Okkalapa Township, Yangon",
    "Organization Address":
      "No. 126/A, Kabar Aye Pagoda Road, Bahan Township, Yangon",
    "Investment Permitted Address":
      "No .126/A, Kabaraye Pagoda Road, Sayar San Ward., Bahan, YANGON",
  },
  {
    ID: 1006,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. ANKIT GOEL",
    "Name of Principal Organization": "SPACE TELIINFRA PVT LIMITED",
    "Place of Incorporation":
      "NO. 139, TARUN ENCLAVE, PITAMPURA, DELHI-110034, INDIA",
    "Company Name In Myanmar": "SPACE WORLD TELEINFRA MYANMAR CO., LTD",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1291/2017",
    "Permit Date": "2017-06-21T10:50:17Z",
    "Meeting Number": "MIC 8/2017",
    "Meeting Date": "2017-05-19T10:51:34Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "TELECOM AND POWER INSTALLATION AND MAINTENANCE SERVICES",
    "Amount Of Foreign Capital USD (in Millions)": 5.225,
    "Total Amount Of Capital (in Millions)": 5.225,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "India",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW PAN EI PHYU",
    "Land Area (units not specified in file)": 0.057,
    "Lease Term": 10,
    "Annual Lease Fee": 18000,
    "Land Use Premium": null,
    "Number Of Local Employees": 120,
    "Number Of Foreign Employees": 9,
    Status: "Approved",
    "Investor Address":
      "NO. 139, GROUND FLOOR, TARUN ENCLAVE, PITAMPURA, DELHI-110034, INDIA",
    "Organization Address":
      "NO. 139, TARUN ENCLAVE, PITAMPURA, DELHI-110034, INDIA",
    "Investment Permitted Address":
      "NO.19, MINYE KYAWSWAR STREET, 14 WARD, YANKIN TOWNSHIP, YANGON DIVISION",
  },
  {
    ID: 1008,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U KHIN MAUNG MIN",
    "Name of Principal Organization": "ANNAWA (SINGPORE) PTE. LTD",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar": "NAUTICAL ACE CO., LTD",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "050/2017",
    "Permit Date": "2017-09-14T03:07:42Z",
    "Meeting Number": "MIC 12/2017",
    "Meeting Date": "2017-08-29T03:08:52Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "DEVELOPMENT & OPERATION OF HOTEL BUSINESS",
    "Amount Of Foreign Capital USD (in Millions)": 35,
    "Total Amount Of Capital (in Millions)": 35,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner":
      "D KHIN SAW AYE, U KHIN MG LINN, D YI YI OO, U ZAW THANT,D KHIN HTAY AYE, D KHIN PHYU AYE",
    "Land Area (units not specified in file)": 0.419,
    "Lease Term": 50,
    "Annual Lease Fee": 60000,
    "Land Use Premium": null,
    "Number Of Local Employees": 106,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address": "NO.3, TANJONG RHU ROAD # 18-02 S436881, SINGAPORE ",
    "Organization Address":
      "NO.1, KIM SENG PROMENADE, ROOM 12-02, GREAT WORLD CITY, SINGAPORE 237994",
    "Investment Permitted Address":
      "NO.22/D, MALIKHA STREET (OFF PARAMI ROAD) MAYANGONE TOWNSHIP, YANGON DIVISION",
  },
  {
    ID: 1009,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Nay Myo Kyaw @Thein Win",
    "Name of Principal Organization": "Unilever Alser B.V.",
    "Place of Incorporation": "Netherlands",
    "Company Name In Myanmar": "UNILEVER EAC MYANMAR COMPANY LIMITED\t",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1285/2017",
    "Permit Date": "2017-05-25T03:39:33Z",
    "Meeting Number": "7/2017",
    "Meeting Date": "2017-04-28T03:39:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing, Marketing and Distribution of Home Care and Personal Care Products",
    "Amount Of Foreign Capital USD (in Millions)": 77,
    "Total Amount Of Capital (in Millions)": 154,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Netherlands",
    "Form Of Investment": "JV",
    "Land Owner": "Europe & Asia Commercial Co., Ltd.  , ",
    "Land Area (units not specified in file)": 4.04,
    "Lease Term": 50,
    "Annual Lease Fee": 0.009,
    "Land Use Premium": null,
    "Number Of Local Employees": 232,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.106,Between 34th x 35th and 85th x 86th street, Chan Aye Thar Zan Township, Mandalay Region",
    "Organization Address": "WEENA 455, 3013 AL ROTTERDAM, THE NETHERLANDS",
    "Investment Permitted Address":
      "Lot No.31,Industry Zone 3, Hlaing Thar Yar Township,Yagon., Hlaingtharyar, YANGON",
  },
  {
    ID: 1010,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Win Aung",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Agro Exchange Public Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "013/2017",
    "Permit Date": "2017-08-09T03:46:27Z",
    "Meeting Number": "10/2017",
    "Meeting Date": "2017-07-11T03:47:15Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Establishing the Infrastructure for Whole-sale Market for Agricultural Products",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 46682,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Yangon City Development Committee",
    "Land Area (units not specified in file)": 82.78,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": 500,
    "Number Of Local Employees": 47,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No.105,University Avenue Street, 10 quarter, Kamaryut Township, Yangon.",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.262-264,Pyay Road,Dagon Centre(1),Block(A),4th floor, Sanchaung Township, Yangon. ",
  },
  {
    ID: 1011,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. GIRISH WADHWA",
    "Name of Principal Organization": "MEGA LIFESCIENCES PTY LTD",
    "Place of Incorporation": "THAILAND",
    "Company Name In Myanmar": "MAXXCARE LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1144/2016",
    "Permit Date": "2016-08-30T06:36:39Z",
    "Meeting Number": "MIC 15/2016",
    "Meeting Date": "2016-08-19T06:37:50Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "SPECIALIZED WAREHOUSING, LOGISTICS, DISTRIBUTION SERVICES AND MATERIAL HANDLING SERVICES",
    "Amount Of Foreign Capital USD (in Millions)": 21.667,
    "Total Amount Of Capital (in Millions)": 21.667,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Thailand",
    "Form Of Investment": "FDII",
    "Land Owner": "MYANMAR GOLDEN STAR CO., LTD ",
    "Land Area (units not specified in file)": 11,
    "Lease Term": 50,
    "Annual Lease Fee": 103.4,
    "Land Use Premium": null,
    "Number Of Local Employees": 465,
    "Number Of Foreign Employees": 7,
    Status: "Submitted",
    "Investor Address":
      "B 116, SHIVALIK ENCLAVE, MALVIYA NAGAR, DELHI-110017, INDIA",
    "Organization Address":
      "NO.909, AMPLE TOWER BUILDING, 9th FOLLR, BANGNA-TRAD ROAD, BANGNA SUB DISTRICT, BANGNA DISTRICT, BANGKOK, THAILAND",
    "Investment Permitted Address": "YANGON INDUSTRY ZONE, MINGALADON, YANGON",
  },
  {
    ID: 1012,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.THOMAS JOSEPH LIM KIM GUAN(LIN QINYUAN)",
    "Name of Principal Organization": "WILMAR-HWAYUAN PTE.LTD.",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar": "WILMAR MYANMAR EDIBLE OILS LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "015/2017",
    "Permit Date": "2017-08-20T04:51:17Z",
    "Meeting Number": "11/2017",
    "Meeting Date": "2017-08-07T04:52:20Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "PRODUCTION, SALE AND DISTRIBUTION OF BOTTLED AND PACKED EDIBLE OILS",
    "Amount Of Foreign Capital USD (in Millions)": 3.804,
    "Total Amount Of Capital (in Millions)": 15.85,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 24,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Myanmar Port Authority",
    "Land Area (units not specified in file)": 7.412,
    "Lease Term": 50,
    "Annual Lease Fee": 150000,
    "Land Use Premium": null,
    "Number Of Local Employees": 81,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address": "C/O 56 NEIL ROAD,SINGAPORE 088830",
    "Organization Address": "56 NEIL ROAD,SINGAPORE 088830",
    "Investment Permitted Address":
      "PLOT.NO.20,21AND THE PARCEL OF LAND ADJOINING PLOT NO 21 AND 22, THILAWA PORT DEVELOPMENT ZONE, KYAUKTAN TOWNSHIP, YANGON ",
  },
  {
    ID: 1013,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.He, Geng-Yan",
    "Name of Principal Organization": "HOPEFUL ENTERPRISE INC",
    "Place of Incorporation": "BRUNEI DARUSSALAM",
    "Company Name In Myanmar": "GOLDEN SEAFOOD PRODUCTION COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "010/2017",
    "Permit Date": "2017-07-24T08:31:19Z",
    "Meeting Number": "10/2017",
    "Meeting Date": "2017-07-11T08:31:57Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "PRODUCTION, DISTRIBUTION AND MARKETING OF VALUE ADDED PRODUCTS SUCH AS SHRIMP AND SOFT SHELL CRAB",
    "Amount Of Foreign Capital USD (in Millions)": 1.44,
    "Total Amount Of Capital (in Millions)": 1.8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Brunei Darussalam",
    "Form Of Investment": "JV",
    "Land Owner": "U MIN THEIN",
    "Land Area (units not specified in file)": 1.114,
    "Lease Term": 50,
    "Annual Lease Fee": 24000,
    "Land Use Premium": null,
    "Number Of Local Employees": 330,
    "Number Of Foreign Employees": 15,
    Status: "Amended",
    "Investor Address":
      "8F, No.5, LN 404, JHONG' AN ROAD, SIAOGANG DISTINCT, KAOHSIUNG CITY 812, TAIWAN, REPUBLIC OF CHINA",
    "Organization Address":
      "RM-51, 5TH FLOOR, BRITANNIA HOUSE, JALAN CATOR BANDAR SERI BEGAWAN BS 8811, NEGARA BRUNEI DARUSSALAM",
    "Investment Permitted Address":
      "Plot No(7), Industrial Zone(2),Min Gyi Ma Har Min Gaung Street., Hlaingtharyar, YANGON",
  },
  {
    ID: 1014,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yanis Michel Boudjouher",
    "Name of Principal Organization": "Infraco Myanmar Aqua Feed PTE. LTD. ",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Infraco Myanmar Aqua Feed Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "009/2017",
    "Permit Date": "2017-07-14T08:52:37Z",
    "Meeting Number": "9/2017",
    "Meeting Date": "2017-06-16T08:53:59Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business": "PROCESSING AND DISTRIBUTION OF FISH FEED",
    "Amount Of Foreign Capital USD (in Millions)": 3.8,
    "Total Amount Of Capital (in Millions)": 4.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 24,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "U Zaw Zaw Win",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 50,
    "Annual Lease Fee": 10000,
    "Land Use Premium": null,
    "Number Of Local Employees": 34,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address": "51 Jervois Road# 03-01 Dormer Park, Singapore 249045",
    "Organization Address":
      "10 Collyer Quay, # 10-01 Ocean Financial Centre, Singapore 043915",
    "Investment Permitted Address":
      "No.62B, Kan Yeik Thar Street., Mayangone, YANGON",
  },
  {
    ID: 1015,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Khin Mg Toe (or)Khin Mg Lwin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Hantharwady Development Public Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "MaNaTha-1269/2017",
    "Permit Date": "2017-08-20T03:18:15Z",
    "Meeting Number": "11/2017",
    "Meeting Date": "2017-08-07T03:19:05Z",
    Sector: "Industrial Estate",
    "Type Of Investment Business": "Development and Lease of Industrial Park",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 222545.45,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Hantharwady Development Public Company Limited",
    "Land Area (units not specified in file)": 2454.98,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 67,
    "Number Of Foreign Employees": null,
    Status: "Amend",
    "Investor Address": "No.346, Aung Thitsar Road, 29 Quarter, ",
    "Organization Address": "",
    "Investment Permitted Address":
      "5 floor, sayarsan palaza, corner of new university avenue, Bahan Township",
  },
  {
    ID: 1016,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Than Win Swe",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Amara Communications Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "MaNaTha-1255/2017",
    "Permit Date": "2017-05-24T04:34:39Z",
    "Meeting Number": "7/2017",
    "Meeting Date": "2017-04-28T04:35:25Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "To provide internet data and communication services and network facilities services",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 182000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "International Group of Entrepreneur Co., Ltd.",
    "Land Area (units not specified in file)": null,
    "Lease Term": 3,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 302,
    "Number Of Foreign Employees": 10,
    Status: "Approved",
    "Investor Address": "Number 10, Room 103 , AungMyayTharSi Housing, ",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.520 (A-5), Pyae Wa Condo, Kabaaye Pagoda Road, Shwegonedine ",
  },
  {
    ID: 1018,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ian Tu",
    "Name of Principal Organization": "Inya Capital Pte Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Japan Inya Investment Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1318/2017",
    "Permit Date": "2017-08-10T02:01:08Z",
    "Meeting Number": "10/2017",
    "Meeting Date": "2017-07-11T02:02:18Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Developing and Leasing of Office Space and Service Apartment",
    "Amount Of Foreign Capital USD (in Millions)": 27.33,
    "Total Amount Of Capital (in Millions)": 35.43,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 4,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Ma' Cee Myanmar Company Limited",
    "Land Area (units not specified in file)": 0.501,
    "Lease Term": 50,
    "Annual Lease Fee": 0.116,
    "Land Use Premium": null,
    "Number Of Local Employees": 73,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "303 Pine Crest, 4-20-1 Todoroki, Setagaya Ku, Tokyo, Japan ",
    "Organization Address":
      "6 Temasek Boulevard, # 29-00 Suntec Tower Four, Singapore 038986",
    "Investment Permitted Address":
      "No, 9, Kan Yeik  Thar Street, Ward No. 10, Myanmar Township, angon Region",
  },
  {
    ID: 1019,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Khin Mg Toe(or)U Khin Mg Lwin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Hantharwady Development Public Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "MaNaTha-1270-2017",
    "Permit Date": "2017-08-20T04:57:19Z",
    "Meeting Number": "11/2017",
    "Meeting Date": "2017-08-07T04:58:00Z",
    Sector: "Real Estate",
    "Type Of Investment Business": "Development and Leasing of Rental Estate",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 27826.37,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Hantharwady Development Public Company Limited",
    "Land Area (units not specified in file)": 266.75,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 74,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "Number 346, Aung Thitsar Street, 29 Quarter ",
    "Organization Address": "",
    "Investment Permitted Address":
      "5 floor, sayarsan palaza, corner of new university avenue ",
  },
  {
    ID: 1020,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Keisuke Koshijima",
    "Name of Principal Organization": "Kajima Myanmar Holding Pte Ltd.",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Kajima Yankin PPP Company Limited ",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1319/2017",
    "Permit Date": "2018-08-09T06:07:34Z",
    "Meeting Number": "10/2017",
    "Meeting Date": "2017-07-11T06:08:11Z",
    Sector: "Real Estate",
    "Type Of Investment Business": "Real Estate Development, Phase I",
    "Amount Of Foreign Capital USD (in Millions)": 280.76,
    "Total Amount Of Capital (in Millions)": 280.76,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 4,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "BOT",
    "Land Owner":
      "Ministry of Construction, Department of Urban and  Housing Development ",
    "Land Area (units not specified in file)": 6.708,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": 16770000,
    "Number Of Local Employees": 69,
    "Number Of Foreign Employees": 17,
    Status: "Monitoring Approved",
    "Investor Address": "4-3-16, Setagaya-ku, Tokyo, Japan",
    "Organization Address":
      "80 Marine Parade Road, # 19-05, Parkway Parade, Singapore",
    "Investment Permitted Address":
      "Unit 406, Strand Square, No. 53 Strand Road, Pabedan, Yangon Myanmar",
  },
  {
    ID: 1022,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Tun Tun Win @ Vinokuma",
    "Name of Principal Organization": "Delicious Food Limited ",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Delicious Food Limites ",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1271/2017",
    "Permit Date": "2017-09-14T06:47:57Z",
    "Meeting Number": "12/2017",
    "Meeting Date": "2017-08-29T06:49:34Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Production and Sales of Foodstuff and Consumer Goods ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 6210,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 47,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT",
    "Land Owner":
      "Ministry of Construction, Department of Urban and Housing Developemnt",
    "Land Area (units not specified in file)": 98.21,
    "Lease Term": 47,
    "Annual Lease Fee": 3.046,
    "Land Use Premium": null,
    "Number Of Local Employees": 131,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No. 715, Second Floor, Marchant Road, Pabedan  Township, Yangon \n",
    "Organization Address":
      "No. 185/190, Room No. 902, Pansodan Tower, Pansodan Street, Kyaukdata Township",
    "Investment Permitted Address":
      "No. 185/190, Room No. 902, Pansodan Tower, Pansodan Street, Kyaukdata Township",
  },
  {
    ID: 1024,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Yone One@ U Aung Thein",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Smooth Way Developments Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "051/2017",
    "Permit Date": "2017-09-14T08:15:10Z",
    "Meeting Number": "12/2017",
    "Meeting Date": "2017-08-29T08:17:20Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel",
    "Amount Of Foreign Capital USD (in Millions)": 7.4,
    "Total Amount Of Capital (in Millions)": 12,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "U Yone One@U Aung Thein",
    "Land Area (units not specified in file)": 0.103,
    "Lease Term": 50,
    "Annual Lease Fee": 4000000,
    "Land Use Premium": null,
    "Number Of Local Employees": 152,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address":
      "No(5), Sakawar Street, Aye Yeikmon Housing, (4) Quarter , Hlaing Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address": "",
  },
  {
    ID: 1026,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Ye Win",
    "Name of Principal Organization": "Yadanar Su Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Yadanar Su Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "026/2017",
    "Permit Date": "2017-10-03T02:08:10Z",
    "Meeting Number": "13/2017",
    "Meeting Date": "2017-09-18T02:08:46Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Production, Distribution and Sales of Liquefied Petroleum Gas  ",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 3000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "Myanma Petroleum Enterprise,Ministry of Electricity and Energy",
    "Land Area (units not specified in file)": null,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 236,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No.1, Thiri(3) street, Ward (2), Hlaing Township, Yangon.",
    "Organization Address":
      "No.1, Thiri(3) street, Ward (2), Hlaing Township, Yangon.",
    "Investment Permitted Address":
      "Nyaung Don Liquefied Petroleum Gas Plant , Ayayawaddy Region and  four existing filling stations (Ahlone , Insein , North Dagon and Hmawbi)",
  },
  {
    ID: 1027,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Denko Trading Company Limited",
    "Name of Principal Organization": "Denko Trading Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Denko Trading Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "030/2017",
    "Permit Date": "2017-11-24T02:55:28Z",
    "Meeting Number": "15/2017",
    "Meeting Date": "2017-11-10T02:56:47Z",
    Sector: "Other Services",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 5952,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Denko Trading Company Limited",
    "Land Area (units not specified in file)": 7,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 150,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No.1, Kanaung Min Thar Gyi Road, Shwe Lin Pan Industrial Zone, Hlaing Thar Yar Township, Yangon",
    "Organization Address":
      "No.1, Kanaung Min Thar Gyi Road, Shwe Lin Pan Industrial Zone, Hlaing Thar Yar Township, Yangon, ",
    "Investment Permitted Address":
      "No.1, Kanaung Min Thar Gyi Road, Shwe Lin Pan Industrial Zone, Hlaing Thar Yar Township, Yangon, Myay Taing Ward No.15, Block No. 1, 7 acres",
  },
  {
    ID: 1028,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. He, Chao",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Xianglong Building Materials Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "067/2017",
    "Permit Date": "2017-11-24T03:07:17Z",
    "Meeting Number": "15/2017",
    "Meeting Date": "2017-11-10T03:08:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and selling of varieties of color steel composite board",
    "Amount Of Foreign Capital USD (in Millions)": 1.35,
    "Total Amount Of Capital (in Millions)": 1.35,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Nwe Nwe Win",
    "Land Area (units not specified in file)": 1.012,
    "Lease Term": 5,
    "Annual Lease Fee": 0.02,
    "Land Use Premium": null,
    "Number Of Local Employees": 16,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 05/234, Shuidian Lane, Bei Ba Township, Shi San Town, Mianyang City, Sichuan Province, People's Republic of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 111, Myay Taing Block No. Part(4), Industrial Zone, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 1029,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U THAUNG HTIKE MIN",
    "Name of Principal Organization": "THU KHA YADANAR COMPANY LIMITED ,",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "RED ROOF INVESTMENT DEVELOPMENT COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1292/2017",
    "Permit Date": "2017-06-21T03:28:08Z",
    "Meeting Number": "8/2017",
    "Meeting Date": "2017-05-19T03:31:24Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "CONSTRUCTION , OPERATION AND LEASING OF RESIDENCE",
    "Amount Of Foreign Capital USD (in Millions)": 42.7,
    "Total Amount Of Capital (in Millions)": 70,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 49,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner":
      "Department of Urban and Housing Development, Ministry of Construction",
    "Land Area (units not specified in file)": 4.98,
    "Lease Term": 50,
    "Annual Lease Fee": 0.819,
    "Land Use Premium": 9.96,
    "Number Of Local Employees": 37,
    "Number Of Foreign Employees": 16,
    Status: "Submitted",
    "Investor Address":
      "NO. 62-E,SHWE HIN THAR STREET, WARD NO(11), HLAING TOWNSHIP, YANGON",
    "Organization Address":
      "ROOM NO.B, BUSINESS CENTER, CITY  GOLF RESORT HOTEL , THIRIMINGALAR ROAD, YWARMA(EAST)WARD, INSEIN TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "ROOM NO.B, BUSINESS CENTER, CITY  GOLF RESORT HOTEL , THIRIMINGALAR ROAD, YWARMA(EAST)WARD, INSEIN TOWNSHIP, YANGON",
  },
  {
    ID: 1030,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Huang Ling",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar Li bao Handbag Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1277/2017",
    "Permit Date": "2017-05-08T17:30:01Z",
    "Meeting Number": "6/2017",
    "Meeting Date": "2017-04-04T17:30:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of All Kinds of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.5,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "ဒေါ်ကျော့စိန်",
    "Land Area (units not specified in file)": 2.002,
    "Lease Term": 20,
    "Annual Lease Fee": 0.036,
    "Land Use Premium": 0,
    "Number Of Local Employees": 854,
    "Number Of Foreign Employees": 9,
    Status: "Submitted",
    "Investor Address": "No.116, Xi Xi Street",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No.80, Myay Taing Block No.Industrial  Zone-1",
  },
  {
    ID: 1031,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Nay Myo Kyaw @Thein Win",
    "Name of Principal Organization": "UNILEVER ALSER B.V.",
    "Place of Incorporation": "Netherlands",
    "Company Name In Myanmar": "UNILEVER EAC MYANMAR COMPANY LIMITED\t",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1284/2017",
    "Permit Date": "2017-05-25T04:47:06Z",
    "Meeting Number": "7/2017",
    "Meeting Date": "2017-04-28T04:47:25Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing, Marketing and Distribution of Home Care and Personal Care Products",
    "Amount Of Foreign Capital USD (in Millions)": 169,
    "Total Amount Of Capital (in Millions)": 246,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Netherlands",
    "Form Of Investment": "JV",
    "Land Owner": "E-Lan Company Limited , U Sein Myint ",
    "Land Area (units not specified in file)": 6.033,
    "Lease Term": 50,
    "Annual Lease Fee": 0.01,
    "Land Use Premium": null,
    "Number Of Local Employees": 508,
    "Number Of Foreign Employees": 13,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.106,Between 34th x 35th and 85th x 86th street, Chan Aye Thar Zan Township, Mandalay Region",
    "Organization Address": "WEENA 455, 3013 AL ROTTERDAM, THE NETHERLANDS",
    "Investment Permitted Address":
      "Lot No.31,Industry Zone 3, Hlaing Thar Yar Township,Yagon, Hlaingtharyar, YANGON",
  },
  {
    ID: 1032,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chen Xiongjun",
    "Name of Principal Organization": "Zhejiang Lily Underwear Co., Ltd.",
    "Place of Incorporation": "People's Republic of China",
    "Company Name In Myanmar": "Asdet (Myanmar) Garment Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "029/2017",
    "Permit Date": "2017-07-24T04:46:38Z",
    "Meeting Number": "10/2017",
    "Meeting Date": "2017-07-11T04:49:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.036,
    "Total Amount Of Capital (in Millions)": 2.036,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Win Tin and Daw Aye Nyein",
    "Land Area (units not specified in file)": 3.76,
    "Lease Term": 10,
    "Annual Lease Fee": 0.28,
    "Land Use Premium": null,
    "Number Of Local Employees": 1270,
    "Number Of Foreign Employees": 20,
    Status: "Approved",
    "Investor Address":
      "No.292, Shi Men Village, Chang Shan Xiang, Wu Cheng District, Jia Hua Township, Zhejiang Province, People's Republic of China",
    "Organization Address":
      "No.358, Wenxi Street, Qiubin Sub-district, Wucheng District, Jinhua City, Zhejiang Province, People's Republic of China",
    "Investment Permitted Address":
      "Plot No. 458, Shwe Lin Pan Industiral Zone., Hlaingtharyar, Yangon.",
  },
  {
    ID: 1033,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Mya Han",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Fortune International Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1264/2017",
    "Permit Date": "2017-08-09T07:03:58Z",
    "Meeting Number": "10/2017",
    "Meeting Date": "2017-07-11T07:04:51Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Construction , Operation and Leasing of Apartment, Apartment Villa, Office & Shopping Complex  ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 81200,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT",
    "Land Owner": "Ministry of Defence",
    "Land Area (units not specified in file)": 6.99,
    "Lease Term": 50,
    "Annual Lease Fee": 2243.92,
    "Land Use Premium": 22920700,
    "Number Of Local Employees": 51,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "No.65-D, Pyay Road, 2 Ward, Kamaryut , Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.12, MICT Park, Hlaing Campus, Hlaing Township , Yangon.",
  },
  {
    ID: 1034,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Paul Polyvios Nikitopoulos ",
    "Name of Principal Organization": "Pti Ltd. ",
    "Place of Incorporation": "Marshall Islands",
    "Company Name In Myanmar": "Commercial Plastics Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1276/2017",
    "Permit Date": "2017-05-08T17:30:01Z",
    "Meeting Number": "6/2017",
    "Meeting Date": "2017-04-04T17:30:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Sales of Plastics Recycling Products",
    "Amount Of Foreign Capital USD (in Millions)": 0.9,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "United Kingdom of Great Britain and Northern Ireland",
    "Form Of Investment": "JV",
    "Land Owner": "ဦးကျော်ဝေ(ခ) စန်းဝေဟွာ",
    "Land Area (units not specified in file)": 0.996,
    "Lease Term": 30,
    "Annual Lease Fee": 0.022,
    "Land Use Premium": 0,
    "Number Of Local Employees": 30,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.238, Pine St, Lowell MA 01851, United States of America",
    "Organization Address":
      "Trust Company Complex, Ajeltake Road, Ajeltake Island, Majuro, Republic of The Marshall Islands MH 96960",
    "Investment Permitted Address":
      "Plot No.119,120,121, Myay Taing Block No.14, Shwe Thanlwin Industrial Zone",
  },
  {
    ID: 1036,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Soe Naing",
    "Name of Principal Organization": "Diamond Star Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Lluvia Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1287/2017",
    "Permit Date": "2017-05-30T17:30:00Z",
    "Meeting Number": "7/2017",
    "Meeting Date": "2017-04-27T17:30:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Distribution of Flour Based Food Products Such as Biscuits, Crackers, Sandwich and Cookies",
    "Amount Of Foreign Capital USD (in Millions)": 3.175,
    "Total Amount Of Capital (in Millions)": 21.17,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Daw San Kyu",
    "Land Area (units not specified in file)": 4,
    "Lease Term": 50,
    "Annual Lease Fee": 0.036,
    "Land Use Premium": 0,
    "Number Of Local Employees": 230,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address": "No.34, University Avenue Road",
    "Organization Address":
      "No.277/285, Room-2, Ground Floor, Bo aung Kyaw Street",
    "Investment Permitted Address":
      "Plot No.165, 166, North Okkalapa,Yangon Industrial Zone, Yangon Region",
  },
  {
    ID: 1038,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Yan Min",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "PLADCO Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "054/2017",
    "Permit Date": "2017-09-14T09:13:58Z",
    "Meeting Number": "12/2017",
    "Meeting Date": "2018-08-29T09:17:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing & Marketing of Plastic Products",
    "Amount Of Foreign Capital USD (in Millions)": 3.663,
    "Total Amount Of Capital (in Millions)": 5200,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.151,Tower A, 9 Floor, Myawaddy Residence, Coner of Wartan Road & Bogyoke Road, Lanmataw Township, Yangon ",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 59, Zone (1), Hlaing Thar Yar Township, Yangon",
  },
  {
    ID: 1039,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. XU, JIAN",
    "Name of Principal Organization": "SINGAPORE KELUOSI INDUSTRY PTE. LTD.",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar": "YOUNG CLOTHING LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "E038/2017",
    "Permit Date": "2017-08-20T09:23:27Z",
    "Meeting Number": "11/2017",
    "Meeting Date": "2017-08-07T09:23:50Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF GARMENTS ON CMP BASIS (FACTORY-2)",
    "Amount Of Foreign Capital USD (in Millions)": 1.89,
    "Total Amount Of Capital (in Millions)": 1.89,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Mya Mya Aye ",
    "Land Area (units not specified in file)": 1.381,
    "Lease Term": 50,
    "Annual Lease Fee": 72,
    "Land Use Premium": null,
    "Number Of Local Employees": 1201,
    "Number Of Foreign Employees": 15,
    Status: "Monitoring Approved",
    "Investor Address":
      "ROOM 13, BUILDING NO. 175, HONGSHAN ROAD, XUANWU DISTRICT, NANJING,  PEOPLE’S  REPUBLIC OF CHINA",
    "Organization Address":
      "10 ANSON ROAD INTERNATIONAL PLAZA # 19-01 SINGAPORE 079903                     ",
    "Investment Permitted Address":
      "PLOT NO. 125, MYAY TAING BLOCK NO. 51, THAR DU KAN INDUSTRIAL ZONE, SHWE PYI THAR TOWNSHIP, YANGON REGION ",
  },
  {
    ID: 1040,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lim Soo Koon",
    "Name of Principal Organization":
      "Diabochi Fiexibles Sdn. Bhd, Kompleks Daibochi Plastic ",
    "Place of Incorporation": "Malaysia",
    "Company Name In Myanmar": "Daibochi Packaging (Myanmar) Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1283/2017",
    "Permit Date": "2017-05-24T17:30:01Z",
    "Meeting Number": "7/2017",
    "Meeting Date": "2017-04-27T17:30:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Flexible Packaging Materials",
    "Amount Of Foreign Capital USD (in Millions)": 8.12,
    "Total Amount Of Capital (in Millions)": 13.54,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Malaysia",
    "Form Of Investment": "JV",
    "Land Owner": "U Sein Myint",
    "Land Area (units not specified in file)": 0.861,
    "Lease Term": 5,
    "Annual Lease Fee": 0.217,
    "Land Use Premium": 0,
    "Number Of Local Employees": 153,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address": "19-F, Lorong BachanG-2",
    "Organization Address": "Lot.3 & 7, Air Keroh Industrial Estate, Phase IV",
    "Investment Permitted Address": "Plot No.250/NGA, Satmumyo Part-2, ",
  },
  {
    ID: 1043,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Khin Htwe",
    "Name of Principal Organization": "Airport Avenue Co., Ltd",
    "Place of Incorporation":
      "No. 11, Shin Saw Pu Street, Home Street ward, Sanchaung Township, Yangon Region",
    "Company Name In Myanmar": "Airport Avenue Co., Ltd",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1236/2017",
    "Permit Date": "2017-04-11T02:00:27Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T02:01:05Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": 0.333,
    "Total Amount Of Capital (in Millions)": 7203.6,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Khin Htwe and Daw Myint Myint Yee",
    "Land Area (units not specified in file)": 0.69,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 40,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "No. 56, Shwe Hintha Street, 12 ward, Hlaing Township, Yangon Region",
    "Organization Address":
      "No. 11, Shin Saw Pu Street, Home Street ward, Sanchaung Township, Yangon Region",
    "Investment Permitted Address":
      "Plot No.106/d, 106/c, 106/i, Maytine No.395, Insein Township, Yangon Region",
  },
  {
    ID: 1047,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Hlaing Oo",
    "Name of Principal Organization":
      "Myanmar Chemical and Machinery Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Myanmar Chemical and Machinery Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "020/2017",
    "Permit Date": "2017-08-20T03:40:58Z",
    "Meeting Number": "11/2017",
    "Meeting Date": "2017-08-07T03:42:35Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Construct and Operate Offshore Supply Base ",
    "Amount Of Foreign Capital USD (in Millions)": 72.72,
    "Total Amount Of Capital (in Millions)": 130842,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Aung Hlaing Oo",
    "Land Area (units not specified in file)": 146.7,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 135,
    "Number Of Foreign Employees": 5,
    Status: "Approved",
    "Investor Address":
      "1120/1121, Thumingalar St, 16/4 Quarter, Thingangyun Township, Yangon     ",
    "Organization Address":
      "1120/1121, Thumingalar St, 16/4 Quarter, Thingangyun  Township, Yangon     ",
    "Investment Permitted Address":
      "Rakhine State, Kyauk Phyu Township, Madae island Village Tract, Kwin No-508, Ywa ma Kwin, Holding No. 137+145, 111+105, 44.84 acres and Kwin No-508, Ywa Ma Kwin, 95.5 acres and  Holding No. N83 and N141 6.36 acres total land area 146.7",
  },
  {
    ID: 1049,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. MENG, JIANYU",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "PENG SHENG WOOD CHINA COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "988/2015",
    "Permit Date": "2015-08-06T04:18:39Z",
    "Meeting Number": "13/2015",
    "Meeting Date": "2015-07-17T04:21:33Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF WOOD BASED PRODUCTS SUCH AS SQUARE, SCANTLING AND SWAN TIMBER ",
    "Amount Of Foreign Capital USD (in Millions)": 1.07,
    "Total Amount Of Capital (in Millions)": 1.07,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U YE MYINT SOE",
    "Land Area (units not specified in file)": 1.5,
    "Lease Term": 50,
    "Annual Lease Fee": 3.098,
    "Land Use Premium": null,
    "Number Of Local Employees": 78,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "BUILDING .13, NO.1, ROOM.401, YOJING JIANG SHAN, NO.230, YANG CHUN ROAD, GAO PING DISTRICT, NANCHONG CITY, SICHUAN PROVINCE, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.172, Pan Padauk Street, Kayebin Yeik Mon Housing., Mingalardon, YANGON",
  },
  {
    ID: 1051,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Toe Naing Mann",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Thanlwin Education Services Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "MaNaTha-1244/2017",
    "Permit Date": "2017-05-09T04:29:39Z",
    "Meeting Number": "6/2017",
    "Meeting Date": "2017-04-05T04:30:56Z",
    Sector: "Other Services",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 19501.77,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးတိုးနိုင္မန္း",
    "Land Area (units not specified in file)": 11.771,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 212,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "အမွတ္ဘီ(၂)၊ထန္းဥယ်ဥ္ရိပ္မြန္၊မင္းဓမ္မလမ္း၊မရမ္းကုန္းျမိဳ့နယ္၊ရန္ကုန္ျမိဳ့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန္ကုန္တုိင္းေဒသျကီး၊မဂၤလာဒံုျမိဳ့နယ္၊ကံံ့ေကာ္ရိပ္သာ-၂ရပ္ကြက္၊ေျမတုိင္းရပ္ကြက္အမွတ္-၃၊ေျမကြက္အမွတ္၁၈၃မွ၂၀၂ရွိေျမဧရိယာ၂.၄၀၄ဧကႏွင့္ ေျမကြက္အမွတ္ ၂၀၃မွ၂၄၂၊၂၄၃ရွိေျမဧရိယာ၉.၃၄ဧက၊စုစုေပါင္းေျမဧရိယာ၁၁.၇၇၄ဧက",
  },
  {
    ID: 1053,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Henry Cleeve Cox",
    "Name of Principal Organization": "RASPBERRY  PIPIA VENTURES PTE. LTD.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "MYANMAR RECYCLES COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "028/2017",
    "Permit Date": "2017-07-24T06:03:37Z",
    "Meeting Number": "10/2017",
    "Meeting Date": "2017-07-11T06:04:20Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND SALES OF WASTE RECYCLED PRODUCTS ",
    "Amount Of Foreign Capital USD (in Millions)": 0.75,
    "Total Amount Of Capital (in Millions)": 0.75,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Nilar Myint",
    "Land Area (units not specified in file)": 1.513,
    "Lease Term": 10,
    "Annual Lease Fee": 108,
    "Land Use Premium": null,
    "Number Of Local Employees": 115,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 23, NEW INDUSTRIAL ROAD, # 07-04, SOLSTICE BUSINESS CENTER, SINGAPORE 536209",
    "Organization Address":
      "NO. 23, NEW INDUSTRIAL ROAD, # 07-04, SOLSTICE  BUSINESS CENTER, SINGAPORE 536209 ",
    "Investment Permitted Address":
      "PLOT NO. 16, MYAUNGDAGAR INDUSTRIAL ZONE, HMAWBI  TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1054,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Tint Tint Lwin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Tint Tint Myanmar Group of Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "019/2017",
    "Permit Date": "2017-08-20T06:33:17Z",
    "Meeting Number": "(11/2017)",
    "Meeting Date": "2017-08-07T06:34:52Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Inland Water Transport ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 20717.15,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "No.B-6, Room No 401,Shwe Gabar Road No.4, ward No 3,",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.4 Botataung (Lower)  Jetty, Nanthidar Jetty, Lanthit   Jetty &  Zaygyi Jetty.                                                                                                                                                                                   ",
  },
  {
    ID: 1055,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U THAN HTAIK LWIN",
    "Name of Principal Organization": "PROVEN TECHNOLOGY INDUSTRY CO., LTD.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "PROVEN  POLYWORLD  COMPANY  LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "E014/2017",
    "Permit Date": "2017-07-14T07:15:17Z",
    "Meeting Number": "9/2017",
    "Meeting Date": "2017-06-16T07:16:09Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND SALES OF AUTOMOTIVE BATTERY CASING AND RELATED OTHER MATERIALS",
    "Amount Of Foreign Capital USD (in Millions)": 0.96,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 43,
    "Investing Country": "Malaysia",
    "Form Of Investment": "JV",
    "Land Owner": "Proven Technology Industry Co., Ltd.",
    "Land Area (units not specified in file)": 1.182,
    "Lease Term": 40,
    "Annual Lease Fee": 0.0129,
    "Land Use Premium": null,
    "Number Of Local Employees": 85,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. (2), MINGALAR STREET, NANTHAR KONE WARD, INSEIN TWONSHIP, YANGON",
    "Organization Address":
      "NO. F/S 14, BAYINT NAUNG ROAD, SHWE SABAI YEIK MON, KAMAYUT TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "PLOT NO. 114, MYAY TAING BLOCK NO. 42 SETMU, SHWE PYI THAR  TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1056,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor":
      "ဒေါ်မွန်မွန်မျိုးသန့် (အဘ-ဦးမျိုးသန့် (ခ) ဦးမြင့်လွင်) ",
    "Name of Principal Organization": "DELTA YOMA TRADING COMPANY LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "DELTA YOMA TRADING COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "MaNaTha-1256/2017",
    "Permit Date": "2017-05-25T07:38:16Z",
    "Meeting Number": "7/2017",
    "Meeting Date": "2017-04-28T07:42:05Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ပြည်တွင်းမှ ချည်ပေါင်းသားများကို ကုန်ကြမ်းအဖြစ် အသုံးပြုပြီး ခေတ်ပေါ် Design မျိုးစုံ စက်ပန်းထိုး၍ ထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.827,
    "Total Amount Of Capital (in Millions)": 1285.4,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 24,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးမျိုးသန့် (ခ) ဦးမြင့်လွင်",
    "Land Area (units not specified in file)": 0.245,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 102,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "         အမှတ်(၄)၊ စမုံလမ်း၊ ဒဂုံမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address": "No.(4), Samon Street, Dagon, YANGON",
  },
  {
    ID: 1057,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Nyan Win",
    "Name of Principal Organization": "Horizon Telecom International Co., Ltd",
    "Place of Incorporation": "Yangon",
    "Company Name In Myanmar": "Horizon Telecom International Co., Ltd",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1211/2016",
    "Permit Date": "2016-09-16T07:31:01Z",
    "Meeting Number": "17/2016",
    "Meeting Date": "2016-09-09T07:33:29Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Carrier Grade Wi-Fi Internet System Services",
    "Amount Of Foreign Capital USD (in Millions)": 12.59,
    "Total Amount Of Capital (in Millions)": 17257.07,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Nyan Win",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 57,
    "Number Of Foreign Employees": 3,
    Status: "Approved",
    "Investor Address":
      "No. 3/3, Mya Sapel Ave Street, 9 ward, Ma Yan Gone Township, Yangon Region",
    "Organization Address":
      "No.531, Room 206, Yetakhon Tower, under Kyimyindine Street, Kyeemyindaing Township, Yangon Region",
    "Investment Permitted Address": "within Yangon Area",
  },
  {
    ID: 1058,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Eikhdi Hla",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Eager Communications  Group Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "Manatha 1223/2016",
    "Permit Date": "2016-11-21T08:01:37Z",
    "Meeting Number": "21/2016",
    "Meeting Date": "2016-11-12T08:02:01Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "National Backbone fiber Network , except Yangon Region, Metropolitan Fiber Network",
    "Amount Of Foreign Capital USD (in Millions)": 269.51,
    "Total Amount Of Capital (in Millions)": 323869.65,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Mandalay City Developement Committee",
    "Land Area (units not specified in file)": 0.218,
    "Lease Term": 33,
    "Annual Lease Fee": 180,
    "Land Use Premium": null,
    "Number Of Local Employees": 73,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No. 13, Parami Street, lawkanat Housing, 12 Ward, Hlaing Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No, Airport Avenue Lane, Insein Township, Yangon",
  },
  {
    ID: 1059,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LIU, ZHAOYUN   ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "DONG YU GARMENT COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "059/2017",
    "Permit Date": "2017-10-03T08:37:39Z",
    "Meeting Number": "13/2017",
    "Meeting Date": "2017-09-25T08:38:23Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS ",
    "Amount Of Foreign Capital USD (in Millions)": 1.706,
    "Total Amount Of Capital (in Millions)": 1.706,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Win Tin and Daw Aye Nyein ",
    "Land Area (units not specified in file)": 2.286,
    "Lease Term": 10,
    "Annual Lease Fee": 0.113,
    "Land Use Premium": null,
    "Number Of Local Employees": 455,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address":
      "BAI ER ZHONG BLOCK, ZHENG BAI VILLAGE, SAN JIA CITY, LIAN YUAN DISTRICT, HU NAN PROVINCE, PEOPLE’S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.459, MYAY TAING BLOCK NO. 25, SHWE LIN BAN SETHMU MYO, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1064,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Htay Aung ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Htun Myat Aung  Co., Ltd",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "Manatha 1195/2016",
    "Permit Date": "2016-07-09T09:13:26Z",
    "Meeting Number": "12/2016",
    "Meeting Date": "2016-06-27T09:14:56Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Services Apartment and Office   SELLING and LEASING ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 12000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "No(23-B)8, Thukhawaddy Street, Ward No.6,",
    "Organization Address": "",
    "Investment Permitted Address":
      "Shop No(5&6), Shwe Kaneary Shop House, Lay Daung Kang Street, , Thingangyun, YANGON",
  },
  {
    ID: 1065,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. ZHAO, NIANLANG",
    "Name of Principal Organization": "YI WO LIMITED",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "MYANMAR KONG HUA COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1282/2017",
    "Permit Date": "2017-05-25T09:54:20Z",
    "Meeting Number": "7/2017",
    "Meeting Date": "2017-04-28T09:57:05Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business": "International Port Services",
    "Amount Of Foreign Capital USD (in Millions)": 22.08,
    "Total Amount Of Capital (in Millions)": 23,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "Myanmar Economic Corporation (MEC) ",
    "Land Area (units not specified in file)": 23,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 95,
    "Number Of Foreign Employees": 25,
    Status: "Monitoring Approved",
    "Investor Address":
      "ROOM 1502, 15/F, 101 KING’S ROAD, NORTH POINT, HONG KONG",
    "Organization Address":
      "ROOM 1502, 15/F, 101 KING’S ROAD, NORTH POINT, HONG KONG",
    "Investment Permitted Address":
      "No.5/41, Thiri Gone Housing, 16/2 Quarter., Thingangyun, YANGON",
  },
  {
    ID: 1071,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Jonathan Paul Nichols",
    "Name of Principal Organization": "H & Co Real Estate Holding Limited ",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Mya Bay H & Co Platinum Pathein Co., Ltd. ",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1122/2016",
    "Permit Date": "2016-03-29T02:30:24Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T02:31:25Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services ",
    "Amount Of Foreign Capital USD (in Millions)": 12.83,
    "Total Amount Of Capital (in Millions)": 16.03,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Win Win Khine",
    "Land Area (units not specified in file)": 15.28,
    "Lease Term": 50,
    "Annual Lease Fee": 0.061829,
    "Land Use Premium": null,
    "Number Of Local Employees": 92,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "No. 29, Smith Road, Manly. Sydney. Australia 2095 ",
    "Organization Address":
      "Unit -5 & 6, 16 floor, Global Trade Square , Wong Chuk Hang , Hong Kong ",
    "Investment Permitted Address":
      "No. 34/H,Alanpya Pagoda Road, Mingalartaungnyunt Township, Yangon",
  },
  {
    ID: 1072,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Theim Wai @ Mr. Sergepun",
    "Name of Principal Organization": "Peninsula Yangon Holdings Pte. Ltd.",
    "Place of Incorporation": "Republic of Singapore",
    "Company Name In Myanmar": "Peninsula Yangon Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1209/2017",
    "Permit Date": "2017-01-15T03:15:48Z",
    "Meeting Number": "1/2017",
    "Meeting Date": "2017-01-06T03:16:36Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Five Star Luxury Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": 144,
    "Total Amount Of Capital (in Millions)": 144,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 4,
    "Validity Of Investment Permit (in Years)": 32,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner":
      "Myanmar Railways of the Ministry of Transport and Communications",
    "Land Area (units not specified in file)": 3.32,
    "Lease Term": 50,
    "Annual Lease Fee": 0.323712,
    "Land Use Premium": 9,
    "Number Of Local Employees": 210,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address": "No.17, Jasmine Garden , Pun Hlaing Estate ",
    "Organization Address":
      "Number 9 , Battery Road, 15-01 Straits Trading Building , Singapore",
    "Investment Permitted Address":
      "FMI centre, Level 5 , Room 503, No 380 , Bogyoke Aung San Road, Pabedan Township, Yangon",
  },
  {
    ID: 1074,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Nguyen Thanh Nam",
    "Name of Principal Organization":
      "Viettel Global Investment Joint Stock Company  ",
    "Place of Incorporation": "Vietnam ",
    "Company Name In Myanmar":
      "Myanmar National Tele & Communications Company Limited ",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1235/2017",
    "Permit Date": "2017-02-04T03:20:23Z",
    "Meeting Number": "2/2017",
    "Meeting Date": "2017-01-21T03:21:00Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "National Telecommunications Network and Services ",
    "Amount Of Foreign Capital USD (in Millions)": 1072.05,
    "Total Amount Of Capital (in Millions)": 1384,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 48,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Vietnam",
    "Form Of Investment": "JV",
    "Land Owner": "Star High Company Limited",
    "Land Area (units not specified in file)": 0.938,
    "Lease Term": 15,
    "Annual Lease Fee": 10000000,
    "Land Use Premium": null,
    "Number Of Local Employees": 2493,
    "Number Of Foreign Employees": 594,
    Status: "Approved",
    "Investor Address":
      "No. 6 C 15, My Dinh I Villa Area, Aau Dien Ward, nam Tu Liem District , hanoi, Socialist Republic of Vietnam ",
    "Organization Address":
      "39-40 Keanam Hanoi  Landmark Tower, Lot 6, Cau Giay New Urban Area, Me Tri Ward, Nam Tu Liem District, Hannoi, Socialist Republic of Vietnam ",
    "Investment Permitted Address":
      "Room 4, Building 4, MICT Park, Haling Campus, Hlaing Township, Yangon ",
  },
  {
    ID: 1080,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Theim Wai @ Mr. Serge Pun",
    "Name of Principal Organization": "Meeyahta International Hotel Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Meeyahta Development Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1210/2017",
    "Permit Date": "2017-01-15T08:50:06Z",
    "Meeting Number": "1/2017",
    "Meeting Date": "2017-01-06T08:50:45Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Construction, Management and Leasing of Retail Podium, Branded Residences(Tower-1), Hotel and Serviced Residences (Tower-2), Office Towers ( Tower 3 and 4)",
    "Amount Of Foreign Capital USD (in Millions)": 545.39,
    "Total Amount Of Capital (in Millions)": 574.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 4,
    "Validity Of Investment Permit (in Years)": 32,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner":
      "Myanma Railways of the Ministry of Transport and Communications",
    "Land Area (units not specified in file)": 6.36,
    "Lease Term": 50,
    "Annual Lease Fee": 0.616536,
    "Land Use Premium": 9,
    "Number Of Local Employees": 396,
    "Number Of Foreign Employees": 11,
    Status: "Monitoring Approved",
    "Investor Address":
      "Number-7, Jasmine Garden, Pun Hlaing Estate, Hlaing Thar Yar Township. ",
    "Organization Address": "No.372, BogyokeAungSan Road, Pabedan Township, ",
    "Investment Permitted Address":
      "FMI Centre, Level 5, Room 503, No-380, Bogyoke Aung San Road, Pabedan Township",
  },
  {
    ID: 1082,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Kledchai BenJaa Thonsirikul",
    "Name of Principal Organization": "KLN (Singapore)Pte. Ltd.",
    "Place of Incorporation": "Singapore ",
    "Company Name In Myanmar": "KM Terminal and Logistics Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1246/2017",
    "Permit Date": "2017-04-11T09:32:02Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T09:44:29Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business": "Dry Port Services",
    "Amount Of Foreign Capital USD (in Millions)": 37.411,
    "Total Amount Of Capital (in Millions)": 37.411,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "BOT,FDII",
    "Land Owner": "Myanma Railways, Ministry of Transport and Communications",
    "Land Area (units not specified in file)": 40,
    "Lease Term": 50,
    "Annual Lease Fee": 0.22,
    "Land Use Premium": 1049907,
    "Number Of Local Employees": 137,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "No- 51/60, SOI Sukhumvit 23 Klong Toey Nue Wattana , Bangkok",
    "Organization Address":
      "Kerry Logistics Centre ( Tampines),Building 19 , Greenwich Drive , Level 7 (s) Singapore 534021",
    "Investment Permitted Address":
      "No-44, TheinPhyu Road, Puzundaung Township, Yangon",
  },
  {
    ID: 1084,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Myat",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Mother Trading Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1072/2015",
    "Permit Date": "2015-07-14T05:51:57Z",
    "Meeting Number": "11/2015",
    "Meeting Date": "2015-06-19T05:55:51Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်အခေ ျာထည်၊ သစ်သားတံခါးအမျိုးမျိုး၊ ပါကေး၊ လျှာထိုး၊ ဘီတင်ထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.06,
    "Total Amount Of Capital (in Millions)": 1000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Industry",
    "Land Area (units not specified in file)": 2.102,
    "Lease Term": 50,
    "Annual Lease Fee": 24,
    "Land Use Premium": null,
    "Number Of Local Employees": 78,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.37,Wezayatar Road, 9 Quarter, South Okkalapa Township, Yangon Region",
    "Organization Address": "",
    "Investment Permitted Address":
      "No. 44/46, (2) Street, Ward No (1), Lanmadaw, YANGON",
  },
  {
    ID: 1085,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Swe Lin",
    "Name of Principal Organization": "Kaung Myanmar Shipping Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "KMA Siam Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "065/2018",
    "Permit Date": "2018-03-08T10:17:08Z",
    "Meeting Number": "3/2018",
    "Meeting Date": "2018-02-27T10:17:25Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Construction of the bulk LPG terminal and bottling plant, importation, storage, distribution and sales of LPG",
    "Amount Of Foreign Capital USD (in Millions)": 9.8,
    "Total Amount Of Capital (in Millions)": 15.077,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Myanmar Port Authority",
    "Land Area (units not specified in file)": 7.5,
    "Lease Term": 30,
    "Annual Lease Fee": 5.277,
    "Land Use Premium": null,
    "Number Of Local Employees": 60,
    "Number Of Foreign Employees": 6,
    Status: "Amend",
    "Investor Address":
      "NV.RV-7, River View Garden, 27th Ward, North Dagon Township, Yangon",
    "Organization Address":
      "Olympic Tower, Room No. (304/305/306)3rd Floor,  Corner of Maha Bandoola & Bo Aung Kyaw Street, Kyauktada Township, Yangon",
    "Investment Permitted Address":
      "Plot No-(31/32)C, Thilawa Port Area, Thanlyin-kyauktan Area, Thanlyin Township, Yangon Region.",
  },
  {
    ID: 1087,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Zaw Win",
    "Name of Principal Organization": "New Dawn Co., Ltd",
    "Place of Incorporation": "Mandalay",
    "Company Name In Myanmar": "New Dawn Co., Ltd",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1133/2016",
    "Permit Date": "2016-03-15T11:18:58Z",
    "Meeting Number": "4/2016",
    "Meeting Date": "2016-03-15T11:19:09Z",
    Sector: "Real Estate",
    "Type Of Investment Business": "International Office Construction Services",
    "Amount Of Foreign Capital USD (in Millions)": 0.35,
    "Total Amount Of Capital (in Millions)": 859,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "Ministry of Industry, Myanmar Medicine Enterprise",
    "Land Area (units not specified in file)": 0.925,
    "Lease Term": 50,
    "Annual Lease Fee": 153,
    "Land Use Premium": 150,
    "Number Of Local Employees": 14,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address":
      "No. 76, Pye Gyi Yanlon ward, Aung Mye Thar Zan Township, Mandalay",
    "Organization Address": "",
    "Investment Permitted Address": "Plot No. 7",
  },
  {
    ID: 1089,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. NAOMI UMENAI",
    "Name of Principal Organization": "SOCIAL MEDICAL CORPORATION SANSHIKAI",
    "Place of Incorporation": "JAPAN",
    "Company Name In Myanmar":
      "NIPPON SANSHIKAI MEDICAL SERVICES CENTER CO.,LTD.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "",
    "Permit Date": "2017-05-25T02:58:37Z",
    "Meeting Number": "7/2017",
    "Meeting Date": "2017-04-28T02:58:57Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "PRIVATE MEDICAL CLINIC AND DIAGNOSIS SERVICES",
    "Amount Of Foreign Capital USD (in Millions)": 1.002,
    "Total Amount Of Capital (in Millions)": 1.253,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "U Kyi Soe",
    "Land Area (units not specified in file)": 0.135,
    "Lease Term": 10,
    "Annual Lease Fee": 0.066,
    "Land Use Premium": null,
    "Number Of Local Employees": 47,
    "Number Of Foreign Employees": 5,
    Status: "Submitted",
    "Investor Address": "NO.232, FUNAKO, ATSUGI-SHI,KANAGAWA, JAPAN",
    "Organization Address": "NO.232, FUNAKO, ATSUGI-SHI,KANAGAWA, JAPAN",
    "Investment Permitted Address":
      "PLOT NO.2, MYAY TAING BLOCK NO.35/B, NO.E-2, UNIVERSITY AVENUE 2ND ROAD, BAHAN TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1091,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Naing Oo",
    "Name of Principal Organization": "Saung Hnin Cherry",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Saung Hnin Cherry",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1068/2015",
    "Permit Date": "2015-07-14T04:00:51Z",
    "Meeting Number": "11/2015",
    "Meeting Date": "2015-06-19T04:02:57Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်အ​ေ ခြခံပစ္စည်းများ ထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 3342,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Aung Than",
    "Land Area (units not specified in file)": 1.434,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 219,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 66, Min Kyaw Sar Road, Industrial Zone-3, HlaingTharyaTowship, Yangon Region",
    "Organization Address":
      "No. 66, Min Kyaw Sar Road, Industrial Zone-3, HlaingtharyaTowship, Yangon Region",
    "Investment Permitted Address":
      "No.(247/D), Corner Of Seik Kan Thar Street & U Chain Street,Industrial Zone.(2), Hlaingtharyar, YANGON\n",
  },
  {
    ID: 1092,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U ABDUL BASIT",
    "Name of Principal Organization":
      "MYO ZIN ZAR INTERNATIONAL COMPANY LIMITED",
    "Place of Incorporation": "MYANMAR",
    "Company Name In Myanmar": "HABRAS-MZZ PLANTATION MYANMAR COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "00/2018",
    "Permit Date": "2018-03-16T03:18:52Z",
    "Meeting Number": "4/2018",
    "Meeting Date": "2018-03-20T03:18:55Z",
    Sector: "Agriculture",
    "Type Of Investment Business":
      "PLANTATION OF EUCALYPTUS, ACACIA, AND SALES OF CHIPS",
    "Amount Of Foreign Capital USD (in Millions)": 6.93,
    "Total Amount Of Capital (in Millions)": 12.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 13,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Forest Department",
    "Land Area (units not specified in file)": 12501,
    "Lease Term": 30,
    "Annual Lease Fee": 18.752,
    "Land Use Premium": 375.03,
    "Number Of Local Employees": 301,
    "Number Of Foreign Employees": 9,
    Status: "Draft",
    "Investor Address":
      "NO.901, CHANTHAR GONE YAUNG HOUSING COMPLEX, TAMWE TOWNSHIP, YANGON",
    "Organization Address":
      "NO.(23/D), SAWMAHAR STREET, BO CHO(2) WARD, BAHAN TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "NO.(23/D), SAWMAHAR STREET, BO CHO(2) WARD, BAHAN TOWNSHIP, YANGON",
  },
  {
    ID: 1093,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. KIM SEOKKYUN",
    "Name of Principal Organization": "KH T&L   COMPANY  LIMITED",
    "Place of Incorporation": "Korea (Republic of)",
    "Company Name In Myanmar": "KMB MYANMAR COMPANY LIMITED             ",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1136/2016",
    "Permit Date": "2016-07-23T05:21:19Z",
    "Meeting Number": "13/2016",
    "Meeting Date": "2016-07-08T05:22:33Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING  AND MARKETING  OF CONCRETE  ADMIXTURE",
    "Amount Of Foreign Capital USD (in Millions)": 1.42,
    "Total Amount Of Capital (in Millions)": 1.42,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Kyi Kyi Tin ",
    "Land Area (units not specified in file)": 0.165,
    "Lease Term": 30,
    "Annual Lease Fee": 2.5,
    "Land Use Premium": null,
    "Number Of Local Employees": 54,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Amend",
    "Investor Address":
      "JUNG-DONG, WONMI-GU, BUCHEON-SI, GYEONGGI-DO,    REPUBLIC  OF  KOREA",
    "Organization Address":
      "19, SEOKCHEON-RO 170 BEON-GIL, WONMI-GY, BUCHEON-SI, GYEONGGI-DO,  REPUBLIC  OF  KOREA",
    "Investment Permitted Address":
      "PLOT  NO. 435, MYAY  TAING  BLOCK NO. 23, INDUSTRIAL  ZONE,  DAGON  MYO  THIT  (SOUTH)  TOWNSHIP, YANGON  REGION",
  },
  {
    ID: 1095,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Win Aung",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Amata International Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1135/2016",
    "Permit Date": "2016-03-21T03:15:51Z",
    "Meeting Number": "23/2015",
    "Meeting Date": "2015-12-28T03:15:38Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 10500,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "Regional Government of Tanintharye Division",
    "Land Area (units not specified in file)": 200,
    "Lease Term": 50,
    "Annual Lease Fee": 0.725,
    "Land Use Premium": 20,
    "Number Of Local Employees": 80,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address":
      "Number 7/A, Kanyeikthar Road, Mayangone Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Number 10, Inya Yeikthar Road, Mayangone Township, Yangon",
  },
  {
    ID: 1096,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "DAW THAWDA AUNG",
    "Name of Principal Organization": "APEX GAS AND OIL PUBLIC CO., LTD.",
    "Place of Incorporation": "Myanmar ",
    "Company Name In Myanmar": "APEX  UNION GAS  COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "064/2018",
    "Permit Date": "2018-03-08T04:37:46Z",
    "Meeting Number": "3/2018",
    "Meeting Date": "2018-02-27T04:38:19Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "CONSTRUCTION OF THE BULK LPG TERMINAL AND BOTTLING PLANT, IMPORTATION, STORAGE, DISTRIBUTION AND SALES OF LPG",
    "Amount Of Foreign Capital USD (in Millions)": 8.67,
    "Total Amount Of Capital (in Millions)": 14.45,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 27,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner":
      "Sub-lease from APEX GAS AND OIL PUBLIC CO., LTD.( Original landowner Myr Port Authoirty)",
    "Land Area (units not specified in file)": 6.876,
    "Lease Term": 27,
    "Annual Lease Fee": 0.214,
    "Land Use Premium": null,
    "Number Of Local Employees": 70,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.F-54, SHWE SABEI 4th STREET, FMI CITY, HLAING THARYAR TOWNSHIP, YANGON",
    "Organization Address":
      "NO.51, SHWE HINTHAR CONDO(A), 10th FLOOR, ROOM NO.(1003), 6 MILE, PYAY ROAD, HLAING TOWNSHIP, YANGON ",
    "Investment Permitted Address":
      "PLOT NO-(1/2)B, THILAWA PORT AREA, THANLYIN-KYAUKTAN AREA, THANLYIN TOWNSHIP, YANGON  REGION",
  },
  {
    ID: 1097,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Thaung Htike Min",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Thu Kha Yadanar Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1139/2016",
    "Permit Date": "2016-03-16T04:56:50Z",
    "Meeting Number": "8/2016",
    "Meeting Date": "2016-03-04T04:57:37Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "7 building of Residences and Club House Building with international standard by BOT system ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 82896,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner":
      "Ministry of Construction, Department of Urban and Housing Development",
    "Land Area (units not specified in file)": 4.98,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": 9.96,
    "Number Of Local Employees": 37,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Number 62-E, Shwehinthar Road, 11 ward, Hlaing Township, Yangon ",
    "Organization Address": "",
    "Investment Permitted Address":
      "Room B, Business Center, City Golf Resort Hotel, Thirimingalar Road, Ywarma , Insein, Yangon",
  },
  {
    ID: 1098,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U THAR KHIN",
    "Name of Principal Organization": "PHYO PYAE SONE CO., LTD",
    "Place of Incorporation": "MYANMAR",
    "Company Name In Myanmar": "PHYO PYAE SONE CO., LTD",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "MaNaTha-1141/2016",
    "Permit Date": "2016-03-26T06:42:49Z",
    "Meeting Number": "10/2016",
    "Meeting Date": "2016-03-18T06:43:22Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "SERVICE AND CONSTRUCTION OF OFFICE AND APARTMENT",
    "Amount Of Foreign Capital USD (in Millions)": 9.5,
    "Total Amount Of Capital (in Millions)": 24000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U THAR KHIN",
    "Land Area (units not specified in file)": 1.11,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 102,
    "Number Of Foreign Employees": 0,
    Status: "Submitted",
    "Investor Address":
      "NO. 133/135, KYONE KYI STREET, 2 WARD, LATHA TOWNSHIP, YANGON",
    "Organization Address":
      "NO. 133/135, KYONE KYI STREET, 2 WARD, LATHA TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "NO. 69A, PLOT NO. 2-i(2) AND 2-o(1), MAY TING NO. 29, THA MINE WARD, MAYANGGONE TOWNSHIP, YANGON",
  },
  {
    ID: 1099,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw Myint Myint WIn",
    "Name of Principal Organization":
      "Than Lwin Aye Yar Industrial Production & Construction Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Emerald Brewery Myanmar Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "071/2018",
    "Permit Date": "2018-03-27T04:16:36Z",
    "Meeting Number": "4/2018",
    "Meeting Date": "2018-03-20T04:16:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing and Distribution of Beer",
    "Amount Of Foreign Capital USD (in Millions)": 31.85,
    "Total Amount Of Capital (in Millions)": 65,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "U Aung Thu",
    "Land Area (units not specified in file)": 32.84,
    "Lease Term": 50,
    "Annual Lease Fee": 0.247,
    "Land Use Premium": null,
    "Number Of Local Employees": 145,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address": "No. I-2, Sabai Street, Sanchaung Township, Yangon",
    "Organization Address":
      "No. 269/271, Yarzardiyit Housing Complex, Lower Pazundaung Road, Botahtaung Township, Yangon",
    "Investment Permitted Address":
      "Holding No.(2/1+2/2+2/4+N-2), Kwin Ta La Baun (East), Kwin No.498, Yay Ta La Baun Village Tract, Hlegu Township, Yangon Region",
  },
  {
    ID: 1100,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Thi Ha",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Htoo Trading Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1185/2016",
    "Permit Date": "2016-03-26T04:45:27Z",
    "Meeting Number": "10/2016",
    "Meeting Date": "2016-03-18T04:45:47Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business":
      " Hotel Services with International Standard by BOT system",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 6311.8,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "Ministry of Defense",
    "Land Area (units not specified in file)": 5.54,
    "Lease Term": 50,
    "Annual Lease Fee": 22700000,
    "Land Use Premium": 1385000000,
    "Number Of Local Employees": 98,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "Number 29, Yaesat Road, Mayangone Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Number 5, Pyay Road, Hlaing Township, Yangon",
  },
  {
    ID: 1101,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. JONATHAN MYO KYAW THAUNG",
    "Name of Principal Organization": "KT PEGU DEVELOPMENT PTE LTD.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "KT CLUB DEVELOPMENT PROJECT COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1307/2017",
    "Permit Date": "2017-07-15T07:29:49Z",
    "Meeting Number": "9/2017",
    "Meeting Date": "2017-06-16T07:30:26Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "RENOVATION OF EXISTING (5) BUILDINGS, CONSTRUCTION, OPERATION AND LEASING OF HOTEL AND SERVICE RESIDENCE OF PEGU CLUB",
    "Amount Of Foreign Capital USD (in Millions)": 77.12,
    "Total Amount Of Capital (in Millions)": 96.4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Ministry of Defence ",
    "Land Area (units not specified in file)": 6.422,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 313,
    "Number Of Foreign Employees": 7,
    Status: "Submitted",
    "Investor Address":
      "NO. 91(I), THAN LWIN STREET, GOLDEN VALLEY WARD NO.1, BAHAN TOWNSHIP, YANGON",
    "Organization Address":
      "28 LEONIE HILL, # 6-28, LEONIE TOWERS, SINGAPORE 239227",
    "Investment Permitted Address":
      "A-4/A-5 ,  Ahnawrahtar Housing,  Pyay Road, Ward 2, Kamaryut Township, Yangon ",
  },
  {
    ID: 1103,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. WEI, LIANG",
    "Name of Principal Organization":
      "ZHEJIANG SPRINGAIR IMPORT & EXPORT CORP. LTD.,",
    "Place of Incorporation": "PEOPLE’S REPUBLIC OF CHINA",
    "Company Name In Myanmar": "SPRINGAIR  ACE  COMPANY  LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1239/2017",
    "Permit Date": "2017-04-11T03:36:08Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T03:36:42Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF GARMENTS AND VARIOUS DESIGNS OF KNITTED PERSONAL UTENSILS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 4.88,
    "Total Amount Of Capital (in Millions)": 4.88,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Paw Kyin",
    "Land Area (units not specified in file)": 3.997,
    "Lease Term": 10,
    "Annual Lease Fee": 0.0384,
    "Land Use Premium": null,
    "Number Of Local Employees": 1000,
    "Number Of Foreign Employees": 25,
    Status: "Monitoring Approved",
    "Investor Address":
      "#4-1502, DONGHE GARDEN, JIANGUO NORTH ROAD, HANGZHOU CITY, ZHEJIANG PROVINCE, PEOPLE’S REPUBLIC OF CHINA",
    "Organization Address":
      "RROOM 902, 5th FLOOR, #188  BINKANG ROAD, BINJIANG DISTRICT, HANGZHOU CITY, ZHEJIANG PROVINCE, PEOPLE’S REPUBLIC OF CHINA",
    "Investment Permitted Address":
      "Plot No.97 &  98,   Yangon Industrial Zone, North Okkalapa Township, Yangon Region",
  },
  {
    ID: 1104,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Sarthayar",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Yadanar Taung Company limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "MaNaTha-1262/2017",
    "Permit Date": "2017-07-14T04:59:39Z",
    "Meeting Number": "9/2017",
    "Meeting Date": "2017-06-16T05:00:06Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Colour Roofing Sheets, Decking Sheet and C- Purlin",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 983.65,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Sarthayar",
    "Land Area (units not specified in file)": 1.136,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 71,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Building No. 65, U Thet Tin Street, Ward No. 7, Thonekhar Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 157, Myay Taing Block No. 51, Thardukan Industrial Zone, Shwe Pyi Thar Township, Yangon",
  },
  {
    ID: 1105,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U MYINT OO",
    "Name of Principal Organization": "MYANMAR AHLA GON CO., LTD.",
    "Place of Incorporation": "MYANMAR",
    "Company Name In Myanmar": "I.M.B.M. MYANMAR COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1262/2017",
    "Permit Date": "2017-04-11T07:14:19Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T07:14:51Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING AND SALES OF COSMETICS    ",
    "Amount Of Foreign Capital USD (in Millions)": 3.75,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 4,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "Myanmar Ahla Gon Co., Ltd. ",
    "Land Area (units not specified in file)": 4.327,
    "Lease Term": 50,
    "Annual Lease Fee": 0.12,
    "Land Use Premium": null,
    "Number Of Local Employees": 104,
    "Number Of Foreign Employees": 8,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 50, YANKIN STREET, MYAYNIGONE WARD, SANCHAUNG TOWNSHIP, YANGON      ",
    "Organization Address":
      "PLOT NO. 16, PHAN CHAT WUN OO SHWE OHE STREET, INDUSTRIAL ZONE 2, HLAING THAR YAR TOWNSHIP, YANGON   ",
    "Investment Permitted Address":
      "PLOT NO. 244, YANGON INDUSTRIAL ZONE, MINGALARDON TOWNSHIP, YANGON REGION  ",
  },
  {
    ID: 1106,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS. HUYNH MY PHUONG",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "HAI NAM SWITCHBOARD MANUFACTURE COMPANY LIMITED\t",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1281/2017",
    "Permit Date": "2017-05-25T08:10:33Z",
    "Meeting Number": "7/2017",
    "Meeting Date": "2017-04-28T08:11:41Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND SALES OF ELECTRICAL SWITCHGEARS    ",
    "Amount Of Foreign Capital USD (in Millions)": 13.07,
    "Total Amount Of Capital (in Millions)": 13.07,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Vietnam",
    "Form Of Investment": "FDII",
    "Land Owner":
      "U Aung Myint, U Sein Lwin Lay, U Kyaw Tun Naing, U Nay Lin Aung,U Mg Mg Aye, U Aung Win ",
    "Land Area (units not specified in file)": 9.53,
    "Lease Term": 30,
    "Annual Lease Fee": 0.54,
    "Land Use Premium": null,
    "Number Of Local Employees": 32,
    "Number Of Foreign Employees": 5,
    Status: "Approved",
    "Investor Address":
      "101/58 LE VAN LUONG STREET, NHA BE DISTRICT, HCM CITY, VIETNAM   ",
    "Organization Address": "",
    "Investment Permitted Address":
      "HOLDING NO. 48/D, KWIN NO. 671, KYAUNG KAN ASHAE KWIN, PHAYAR KONE VILLAGE TRACT, THANLYIN TOWNSHIP, YANGON REGION  ",
  },
  {
    ID: 1108,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. HE WENFENG",
    "Name of Principal Organization": "TREND RICH ENTERPRISE LIMITED",
    "Place of Incorporation": "Belize",
    "Company Name In Myanmar": "JOIN-PROFIT (MYANMAR) GARMENT COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1219/2017",
    "Permit Date": "2017-01-11T08:43:25Z",
    "Meeting Number": "1/2017",
    "Meeting Date": "2017-01-06T08:47:46Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING  OF GARMENT ON CMP BASIS   ",
    "Amount Of Foreign Capital USD (in Millions)": 0.81,
    "Total Amount Of Capital (in Millions)": 0.81,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Belize",
    "Form Of Investment": "FDII",
    "Land Owner": "U Htay Oo, U Myo Oo, U Tin Oo",
    "Land Area (units not specified in file)": 1.999,
    "Lease Term": 10,
    "Annual Lease Fee": 0.222,
    "Land Use Premium": null,
    "Number Of Local Employees": 815,
    "Number Of Foreign Employees": 8,
    Status: "Monitoring Approved",
    "Investor Address":
      "ROOM. 201, NO. 110, HONGWENYI LI, SIMING DISTRICT, XIAMEN CITY, FUJIAN PROVINCE, PEOPLE’S REPUBLIC OF CHINA        ",
    "Organization Address":
      "SUITE 2,3 FLOOR, NO. 10 EVE STREET, BELIZE CITY, BELIZE       ",
    "Investment Permitted Address":
      "PLOT NO. 106,  MYAY TAING BLOCK NO. 3, HLAING THAR YAR TOWNSHIP, YANGON REGION   ",
  },
  {
    ID: 1109,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Nay Nay Hlwam Moe",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Ayeyarwaddy Development Public Co., Ltd.",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "Manatha 1149/2016",
    "Permit Date": "2016-03-24T02:22:29Z",
    "Meeting Number": "8/2016",
    "Meeting Date": "2016-03-04T02:23:04Z",
    Sector: "Industrial Estate",
    "Type Of Investment Business":
      "Construction , Operation , Leasing of Industrial Estate",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 83858.61,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ayeyarwaddy Devlelopment Public Co., Ltd.",
    "Land Area (units not specified in file)": 1251.18,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 47,
    "Number Of Foreign Employees": 4,
    Status: "Approved",
    "Investor Address":
      "No.6, Room.16,  Lanthit  Yeikthar, 11 Ward, Landmadaw, Yangon.",
    "Organization Address": "",
    "Investment Permitted Address":
      "Room-1106, Yetagon Tower, No.531 , Lower Kyeemyindaing Road, Kyeemyindaing  Township, Yangon.",
  },
  {
    ID: 1112,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U MYAING THAN TOE OO",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "M   HOSPITALITY   MANAGEMENT   COMPANY   L IMITED\t\t\t ",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1194/2016",
    "Permit Date": "2016-11-24T02:26:25Z",
    "Meeting Number": "21/2016",
    "Meeting Date": "2016-11-21T02:26:08Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "HOTEL   SERVICES ",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Ah Mar Ni ",
    "Land Area (units not specified in file)": 0.576,
    "Lease Term": 20,
    "Annual Lease Fee": 120000000,
    "Land Use Premium": null,
    "Number Of Local Employees": 72,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. (135), THEIN PHYU ROAD, MINGALAR TAUNGNYUNT TOWNSHIP, YANGON",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 113 H /3,Block No. 36 J, Bahan Tsp, Yangon, Myanmar ",
  },
  {
    ID: 1113,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Win Aung",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Mandalay Golden Wing Construction Ltd.",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1225/2016",
    "Permit Date": "2016-12-11T06:46:44Z",
    "Meeting Number": "14/2016",
    "Meeting Date": "2016-07-31T06:47:03Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Construction and Leasing of Office Space  under the name of Yangon Business Centre (Parami)",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 66033,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 1.023,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 59,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No-101, Thanlwin Street, Ward No(10), Kamayut Township,Yangon",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No.4(B) and 4(C), Plot No 20 Ka/4, Myay Taing Block No -56 (Thamine), Parami Road,Mayangone T/s,Yangon Region.",
  },
  {
    ID: 1115,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw Cho Yee Lwin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "M Tower Co., Ltd.",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1202/2016",
    "Permit Date": "2016-12-11T07:22:04Z",
    "Meeting Number": "14/2016",
    "Meeting Date": "2016-07-31T07:21:32Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Construction and Leasing of Commercial and Office Buildings",
    "Amount Of Foreign Capital USD (in Millions)": 29.4,
    "Total Amount Of Capital (in Millions)": 60,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "U Yang Ho and Daw Shout Si ",
    "Land Area (units not specified in file)": 0.931,
    "Lease Term": 50,
    "Annual Lease Fee": 0.5,
    "Land Use Premium": null,
    "Number Of Local Employees": 145,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "Building No. B(4), Room No. B(3), Yangon- Insein Road, Ward No(3) , Mayangone , Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 6B-1/Gagyi,  6B-1/Nga, 6C-1, 6C-2, Myaytaing Block No- 81, Pyay Road, Kamayut T/S, Yangon Region",
  },
  {
    ID: 1116,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyaw Moe Naing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Lighting Specialist ",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "Manatha-1165/2016",
    "Permit Date": "2016-03-26T08:15:31Z",
    "Meeting Number": "10/2016",
    "Meeting Date": "2016-03-18T08:16:31Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Service",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 21304.18,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT",
    "Land Owner": "own of Ministry of Hotel & Tourism ",
    "Land Area (units not specified in file)": 6.635,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": 50000000,
    "Number Of Local Employees": 77,
    "Number Of Foreign Employees": 12,
    Status: "Approved",
    "Investor Address": "No.203,Yankin Center,YCDC, Sayar San Road,",
    "Organization Address": "",
    "Investment Permitted Address": "No(3), Kanbe Road ,",
  },
  {
    ID: 1117,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyaw Kyaw",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Hlaine Tet Group Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1247/2017",
    "Permit Date": "2017-05-25T08:29:15Z",
    "Meeting Number": "7/2017",
    "Meeting Date": "2017-04-28T08:29:51Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 6095.45,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 0.198,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "N0 Q.12, Myakanthar(2)Street, Ward No(4), Hlaing T/S, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No -83, First Floor, Damazedi Road,Sanchaung T/s, Yangon Region ",
  },
  {
    ID: 1120,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Seok Ki Hong",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MyNet Korea Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1154/2016",
    "Permit Date": "2016-09-19T08:49:34Z",
    "Meeting Number": "17/2016",
    "Meeting Date": "2016-09-09T08:50:33Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF VARIOUS KIND OF NETS (SUCH AS SAFETY NETS FOR BUILDING CONSTRUCTION, SHADING NETS FOR AGRICULTURE AND FENCING NETS)",
    "Amount Of Foreign Capital USD (in Millions)": 1.2,
    "Total Amount Of Capital (in Millions)": 1.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "JV",
    "Land Owner": "U Thet Lwin",
    "Land Area (units not specified in file)": 1.85,
    "Lease Term": 20,
    "Annual Lease Fee": 0.015,
    "Land Use Premium": null,
    "Number Of Local Employees": 115,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Amend",
    "Investor Address":
      "303-535, CHEONG RA BANDO, YOU BO RA APT., 10 BUSINESS ROAD, SEO GU, INCHEON, REPUBLIC OF KOREA",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 3d4, Myay Taing Block No.9, Hlaing Thar Yar Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 1123,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Tun Tun Win ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Taung Pyar Dan",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "Manatha-1192/2016",
    "Permit Date": "2016-03-29T04:50:26Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T04:51:21Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "လယ္ယာထြက္ကုန္နွင့္ စိုက္ပ်ိုးေရးနွင့္ဆက္စပ္ေသာ စားေသာက္ကုန္ပစၤစည္းမ်ား နွင့္လူသံုးကုန္ပစၤစည္းမ်ားအေရာင္းျပခန္း ဖြင့္လွစ္ ေရာင္းခ်ျခင္းလုပ္ငန္း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 3200,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Own of Ministry of Agriculture ",
    "Land Area (units not specified in file)": 3.999,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 70,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "No.715, Second Floor, Merchant road. ",
    "Organization Address": "",
    "Investment Permitted Address": "No.184(B), Thein Byu Road, ",
  },
  {
    ID: 1124,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhen, Hai",
    "Name of Principal Organization": "COBES INDUSTRIES COMPANY LIMIETD",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "COBES INDUSTRIES (MYANMAR) CO., LTD.",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1159/2016",
    "Permit Date": "2016-09-19T05:02:26Z",
    "Meeting Number": "17/2016",
    "Meeting Date": "2016-09-09T05:02:57Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF NON-STERILIZED DISPOSABLE SURGICAL-SCRUBS AND RELATED KIND OF CLINICAL WEARS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.95,
    "Total Amount Of Capital (in Millions)": 0.95,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Nyi Nyi Lwin , Daw Mi Mi Aung @ Tan Be Be",
    "Land Area (units not specified in file)": 2.386,
    "Lease Term": 10,
    "Annual Lease Fee": 0.36,
    "Land Use Premium": null,
    "Number Of Local Employees": 491,
    "Number Of Foreign Employees": 17,
    Status: "Monitoring Approved",
    "Investor Address":
      "FLAT/RM 2503-2505, 25/F, C.C WU BUILDING, 302-308 HENNESSY ROAD, WAN CHAI, HONG KONG",
    "Organization Address":
      "FLAT/RM 2503-2505, 25/F, C.C WU BUILDING, 302-308 HENNESSY ROAD, WAN CHAI, HONG KONG",
    "Investment Permitted Address":
      "PLOT NO. 109, MYAY TAING BLOCK NO.14, SHWE THAN LWIN INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1125,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MRS. LIN HONGYING ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "YANGON STRONG  PRINTING CO., LTD.",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1160/2016",
    "Permit Date": "2016-09-19T07:00:26Z",
    "Meeting Number": "17/2016",
    "Meeting Date": "2016-09-09T07:00:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND SALES  OF DESIGN PRINTING PRODUCT ",
    "Amount Of Foreign Capital USD (in Millions)": 5.84,
    "Total Amount Of Capital (in Millions)": 5.84,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 24,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Khin Kyu Kyu",
    "Land Area (units not specified in file)": 0.144,
    "Lease Term": 10,
    "Annual Lease Fee": 36,
    "Land Use Premium": null,
    "Number Of Local Employees": 69,
    "Number Of Foreign Employees": 12,
    Status: "Monitoring Approved",
    "Investor Address":
      "ROOM 1504, UNIT 1, DAGUAN JIAHUA GARDEN, KUNMING CITY, YUNNAN PROVINCE., PEOPLE’S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT  NO. 142/KHA, MYAY  TAING BLOCK NO. NGA/INDUSTRIAL ZONE, NORTH OKKALAPA TOWNSHIP, YANGON  REGION",
  },
  {
    ID: 1126,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Tayza Saw Oo",
    "Name of Principal Organization": "Thukha Saytanar Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Victoria Premiere Angioplasty Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "005/2017",
    "Permit Date": "2017-06-22T07:05:01Z",
    "Meeting Number": "8/2017",
    "Meeting Date": "2017-05-19T07:05:25Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Heart And Vascular Center",
    "Amount Of Foreign Capital USD (in Millions)": 0.934,
    "Total Amount Of Capital (in Millions)": 1.831,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "India",
    "Form Of Investment": "JV",
    "Land Owner": "Thukha Saytanar Co., Ltd.",
    "Land Area (units not specified in file)": 4800,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 39,
    "Number Of Foreign Employees": 2,
    Status: "Submitted",
    "Investor Address":
      "No.4/11, Aung Theikdi 3rd Street, Ward No.(3), Mayangone Townsip, Yangon",
    "Organization Address":
      "No. 68, Taw Win Street, 9 Mile, Mayangone Township, Yangon Region",
    "Investment Permitted Address":
      "No. 68, Taw Win Street, 9 Mile, Mayangone Township, Yangon Region",
  },
  {
    ID: 1128,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Dream Aesthetics Co., Ltd.",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Dream Aesthetics Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "068/2017",
    "Permit Date": "2017-11-24T08:34:12Z",
    "Meeting Number": "15/2017",
    "Meeting Date": "2017-11-10T08:34:35Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      " Medical And Non-Medical Aesthetics Business, Including Facial, Body And Other Treatments",
    "Amount Of Foreign Capital USD (in Millions)": 0.4,
    "Total Amount Of Capital (in Millions)": 0.4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": " U Soe Win",
    "Land Area (units not specified in file)": null,
    "Lease Term": 10,
    "Annual Lease Fee": 38880,
    "Land Use Premium": null,
    "Number Of Local Employees": 10,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 456-A, 456-B, 11 &12, Shop No.(8), Level 1 And Unit C-5, Level 2, BLock B, Golden Link Condominium, Link Street, East Shwegonedaing Ward, Bahan Township, Yangon Region",
    "Organization Address": "",
    "Investment Permitted Address":
      "No. 456-A, 456-B, 11 &12, Shop No.(8), Level 1 And Unit C-5, Level 2, BLock B, Golden Link Condominium, Link Street, East Shwegonedaing Ward, Bahan Township, Yangon Region",
  },
  {
    ID: 1129,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kwang Ho Jeong",
    "Name of Principal Organization": "CJ Global Holding Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "CJ Feed Myanmar Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "056/2018",
    "Permit Date": "2018-02-14T08:16:53Z",
    "Meeting Number": "2/2018",
    "Meeting Date": "2018-02-02T08:12:41Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "Production of Hatchery and Sale of Day Old Chicken",
    "Amount Of Foreign Capital USD (in Millions)": 1.4,
    "Total Amount Of Capital (in Millions)": 1.4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Thein Lwin",
    "Land Area (units not specified in file)": 2.061,
    "Lease Term": 50,
    "Annual Lease Fee": 839.27,
    "Land Use Premium": null,
    "Number Of Local Employees": 16,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "401 Ho, Balkje Gobun Ro 9, Gil 22, (Jamsil Dong), Song Pa Gu, Seoul, Republic of Korea",
    "Organization Address":
      "Suite 3003, 30/F, Central Plaza, 18 Harbour Road, Wanchai, Hong kong",
    "Investment Permitted Address":
      "Plot No(192,193,194,195,196,197),Myaung Dagar Thanmani Industrial Zone., Mawbi, YANGON",
  },
  {
    ID: 1131,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Tun Lwin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Myanmar Agricultural and General Developemnt Public Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "Ma Na Tha 1153/2016",
    "Permit Date": "2017-03-24T08:50:27Z",
    "Meeting Number": "6/2016",
    "Meeting Date": "2017-02-22T08:50:48Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Building and Operating a Multi-Purpose International Wharf and Leasing Relatives Building ",
    "Amount Of Foreign Capital USD (in Millions)": 28.4342,
    "Total Amount Of Capital (in Millions)": 54452.73,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Myanmar Port Authority",
    "Land Area (units not specified in file)": 37.06,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": 555.9,
    "Number Of Local Employees": 78,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No. 758-787, 11 Floor, 13th Street, Mahabandula Road, Lanmadaw, Yangon ",
    "Organization Address": "",
    "Investment Permitted Address":
      "UMFCCI Tower, No 29, Room No. 803, Min Ye Kyaw Swar Street, Lanmadaw, Yangon",
  },
  {
    ID: 1132,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Aryu International Health Care Co., Ltd.",
    "Name of Principal Organization": "",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Aryu International Health Care Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "008/2017",
    "Permit Date": "2017-07-14T03:13:07Z",
    "Meeting Number": "9/2017",
    "Meeting Date": "2017-06-16T03:16:45Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Health Care Services And Operation of Hospital Business",
    "Amount Of Foreign Capital USD (in Millions)": 40,
    "Total Amount Of Capital (in Millions)": 70,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "Ga Mone Pwint Co., Ltd.",
    "Land Area (units not specified in file)": 2.527,
    "Lease Term": 50,
    "Annual Lease Fee": 600000,
    "Land Use Premium": null,
    "Number Of Local Employees": 295,
    "Number Of Foreign Employees": 14,
    Status: "Submitted",
    "Investor Address":
      "Plot No. (51F3, 51D5, 51D6), Myay Taing Block No.34/D, Kyaikkasan Road, Tamwe Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. (51F3, 51D5, 51D6), Myay Taing Block No.34/D, Kyaikkasan Road, Tamwe Township, Yangon",
  },
  {
    ID: 1134,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Pyone Maung Maung",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "SOUTHEASTASIANET TECHNOLOGIES MYANMAR COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1179/2016",
    "Permit Date": "2016-10-23T17:30:00Z",
    "Meeting Number": "19/2016",
    "Meeting Date": "2016-10-07T05:52:36Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "PROVIDING THE CONNECTIVITY, INTERNET, CONTENT DELIVERY & APPLICATION SERVICES WITH VSAT SYSTEM ",
    "Amount Of Foreign Capital USD (in Millions)": 4.72,
    "Total Amount Of Capital (in Millions)": 9.652,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 24,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Malaysia",
    "Form Of Investment": "JV",
    "Land Owner": "Yatanarpon Teleport Public Co., Ltd. ",
    "Land Area (units not specified in file)": 300,
    "Lease Term": 5,
    "Annual Lease Fee": 3400,
    "Land Use Premium": null,
    "Number Of Local Employees": 181,
    "Number Of Foreign Employees": 19,
    Status: "Approved",
    "Investor Address":
      "NO.149, THIRIMINGALAR  LANE, 8 MILE, MAYANGONE TOWNSHIP, YANGON ",
    "Organization Address": "",
    "Investment Permitted Address":
      "MYAYTAING BLOCK NO. 25, PLOT NO. 9/G2, HLAING UNIVERSITY CAMPUS, HLAING TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1135,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Thein Han ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Myanmar Edible Oil Industrial Public Corporation (MEICO) Limited ",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1188/2016",
    "Permit Date": "2016-03-26T06:06:35Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T06:17:29Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Building and Operating a Multi-Purpose International Wharf and Leasing Relatives Building ",
    "Amount Of Foreign Capital USD (in Millions)": 23.1,
    "Total Amount Of Capital (in Millions)": 51026.3,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "Myanmar Port Authority",
    "Land Area (units not specified in file)": 37.06,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": 555900000,
    "Number Of Local Employees": 84,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "A 67, Second Floor, Bahosi Housing, Ward No. 10, Lamadaw Tsp, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No. 81/82, Kankaw Road, Bayinnaung, Market, Mayangone, Yangon ",
  },
  {
    ID: 1137,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. CHEUNG ANTONY HOI KIT",
    "Name of Principal Organization": "MYANMAR TELETECH PTE. LTD",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Marga Global Telecom Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1139/2016",
    "Permit Date": "2016-08-11T07:19:25Z",
    "Meeting Number": "14/2016",
    "Meeting Date": "2017-07-31T07:20:21Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "DAT ACENTRE, WIRELESS INTERNET AND INTERNET SERVICE ",
    "Amount Of Foreign Capital USD (in Millions)": 24.28,
    "Total Amount Of Capital (in Millions)": 26.03,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 15,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Daw May Thandar ",
    "Land Area (units not specified in file)": 222.57,
    "Lease Term": 10,
    "Annual Lease Fee": 58758.48,
    "Land Use Premium": null,
    "Number Of Local Employees": 35,
    "Number Of Foreign Employees": 3,
    Status: "Approved",
    "Investor Address": "8 MORAY ROAD, KOWLOON TONG, HONG KONG  ",
    "Organization Address":
      "6 TEMASEK BOULEVARD, # 29-00, SUNTEC TOWER FOUR, SINGAPORE,  038986",
    "Investment Permitted Address":
      "MYAYTAING BLOCK NO. 130, PLOT NO. 915, DAGON MYOTHIT (EAST) TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1142,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. ZHANG LI MAN",
    "Name of Principal Organization": "HUAWEI TECHNOLOGIES CORPORATIEF U.A",
    "Place of Incorporation": "Netherlands",
    "Company Name In Myanmar": "HUAWEI TECHNOLOGIES (YANGON) COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1189/2016",
    "Permit Date": "2016-11-11T05:15:21Z",
    "Meeting Number": "20/2016",
    "Meeting Date": "2016-10-28T05:16:10Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "providing communication and information technologies related services and equipment, products to customers including the market development and commercial promotion services of the telecommunication equipment, products and devices",
    "Amount Of Foreign Capital USD (in Millions)": 5,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Netherlands",
    "Form Of Investment": "FDII",
    "Land Owner": "Exe Sakura (Myanmar) Co., Ltd. ",
    "Land Area (units not specified in file)": null,
    "Lease Term": 1,
    "Annual Lease Fee": 429264,
    "Land Use Premium": null,
    "Number Of Local Employees": 215,
    "Number Of Foreign Employees": 170,
    Status: "Approved",
    "Investor Address":
      "A 9, HUAWEI INDUSTRIAL BASE, BANTIAN, LONGGANG DISTRICT, SHENZHEN, PEOPLE REPUBLIC’S OF CHINA",
    "Organization Address":
      "KARSPELDREEF 4, 1101 CJ, AMSTERDAM, ZUIDOOST, NETHERLANDS",
    "Investment Permitted Address":
      "UNIT 0902 AND 1807, SAKURA TOWER, NO 339, BOGYOKE AUNG SAN ROAD, KYAUKTADA TOWNSHIP, YANGON REGION ",
  },
  {
    ID: 1143,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR MITSUHIRO TOKUDA    ",
    "Name of Principal Organization": "OPERATING PARTNERS COMPANY LIMITED",
    "Place of Incorporation": " JAPAN ",
    "Company Name In Myanmar":
      "OPERATING PARTNERS MYANMAR COMPANY   LIMITED\t\t",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "048/2017",
    "Permit Date": "2017-08-20T06:51:41Z",
    "Meeting Number": "11/2017",
    "Meeting Date": "2017-08-07T06:52:21Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": 0.72,
    "Total Amount Of Capital (in Millions)": 0.72,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Tin Shin ",
    "Land Area (units not specified in file)": 0.047,
    "Lease Term": 50,
    "Annual Lease Fee": 46800,
    "Land Use Premium": null,
    "Number Of Local Employees": 30,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address": "3-11-5, HIMONYA, MEGURO-KU, TOKYO, JAPAN ",
    "Organization Address": "4-8-5, TAITO, TAITO-KU, TOKYO, JAPAN ",
    "Investment Permitted Address":
      "NO.154/156, 51st STREET, WARD NO.10, PAZUNTAUNG TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1144,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Khin Hla Hla",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Kaytumadi Development Public Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "Manatha 1175/2016",
    "Permit Date": "2016-05-26T08:32:23Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-05-25T08:32:33Z",
    Sector: "Industrial Estate",
    "Type Of Investment Business":
      "Construction, Operation and Leasing of Industrial Estate ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 10440.14,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Kaytumadi Development Public Co., Ltd.",
    "Land Area (units not specified in file)": 1311,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 139,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No-57, Mya Yamone Street, San Yeik Myaing Housing, Lay Dauk Kan Road, Dagon Myothit (south) Township, Yangon.",
    "Organization Address": "",
    "Investment Permitted Address":
      "5 th Floor, Sayar San Palazar, Conner of Sayar San Road and University Yeik Thar Road, Bahan Township, Yangon.",
  },
  {
    ID: 1145,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kaw Thu Ya",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "New City Development Public Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "Manatha 1177/2016",
    "Permit Date": "2016-05-26T08:55:38Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-05-25T08:55:45Z",
    Sector: "Industrial Estate",
    "Type Of Investment Business":
      "Construction , Operation and Leasing of Industrial Estate",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 44393.83,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "New City Development Public Co., Ltd.",
    "Land Area (units not specified in file)": 400,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 72,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "N0-18, U Ba Han Street, Yan Aung Ward, Thingangyun, Yangon.",
    "Organization Address": "",
    "Investment Permitted Address":
      "5 th Floor, Sayar San Palazar, Conner of Sayar San Road and University Yeik Thar Road, Bahan Township, Yangon",
  },
  {
    ID: 1146,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. MO ZHIHUI  ",
    "Name of Principal Organization":
      "HUNAN DONGYI  INDUSTRIAL & TRADING CO., LTD.",
    "Place of Incorporation": "PEOPLE’S REPUBLIC OF CHINA",
    "Company Name In Myanmar": "DONGYI (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1183/2016",
    "Permit Date": "2016-11-11T08:33:29Z",
    "Meeting Number": "20/2016",
    "Meeting Date": "2016-10-28T08:34:27Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 2.39,
    "Total Amount Of Capital (in Millions)": 2.39,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner":
      "U Tin Maung Thein,              U Tin Maung Zaw, U Tin Maung Myint and Wong Fong Long @ U Ohn Maung ",
    "Land Area (units not specified in file)": 2.61,
    "Lease Term": 10,
    "Annual Lease Fee": 0.058,
    "Land Use Premium": null,
    "Number Of Local Employees": 1094,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "ROOM 703, BUILDING 12th , NO.68, CHILING ROAD, CHANGSHA, HUNAN PROVINCE, PEOPLE’S REPUBLIC OF CHINA",
    "Organization Address":
      "10F, BUILDING 1st, NO. 108, 2nd SECTION OF EAST XIANGFU ROAD, CHANGSHA, HUNAN PROVINCE, PEOPLE’S REPUBLIC OF CHINA",
    "Investment Permitted Address":
      "PLOT NO. 130, MYAY TAING BLOCK NO. 51, THAR DU KAN INDUSTRIAL ZONE, SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1147,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Than Myint",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Nyi Naung Oo Co., Ltd. ",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "Manatha-1049/2015",
    "Permit Date": "2015-04-07T09:12:57Z",
    "Meeting Number": "5/2015",
    "Meeting Date": "2015-03-20T09:13:36Z",
    Sector: "Industrial Estate",
    "Type Of Investment Business":
      "Construction , Operation and Leasing of Myawaddy Economic Zone",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 5335,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Kayin State Government",
    "Land Area (units not specified in file)": 201,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 30,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No-D-423, Thiri Yethar Condo, Pyi Road, No-4 ward, Mayangone Township, Yangon.",
    "Organization Address": "",
    "Investment Permitted Address":
      "N0-1, Room N0-108, Compound of Hotel Yangon, 8 Mile, Pyi Road, Mayangone Township , Yangon.",
  },
  {
    ID: 1149,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. YANG, DAIJUN",
    "Name of Principal Organization":
      "JIANGSU GUOTAI LITIAN ENTERPRISES CO., LTD.",
    "Place of Incorporation": "PEOPLE’S REPUBLIC OF CHINA  ",
    "Company Name In Myanmar": "G & U (MYANMAR) FASHION COMPANY LIMITED\t",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1230/2017",
    "Permit Date": "2017-01-27T09:38:02Z",
    "Meeting Number": "2/2017",
    "Meeting Date": "2017-01-21T09:38:41Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING  OF GARMENT ON CMP BASIS   ",
    "Amount Of Foreign Capital USD (in Millions)": 2.058,
    "Total Amount Of Capital (in Millions)": 2.058,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Luthuamalar Than ",
    "Land Area (units not specified in file)": 2,
    "Lease Term": 10,
    "Annual Lease Fee": 102,
    "Land Use Premium": null,
    "Number Of Local Employees": 600,
    "Number Of Foreign Employees": 30,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 1-902, 7 BLDG SHUXIANGYUAN (3), SHANHEKON DISTRICT, DALIAN, LIAONING, PEOPLE’S REPUBLIC OF CHINA        ",
    "Organization Address":
      "NO.15-23F, GUOTAI BUILDING, MIDDLE RENMIN ROAD, YANGSHE TOWN, ZHANGJIAGANG CITY, PEOPLE’S REPUBLIC OF CHINA        ",
    "Investment Permitted Address":
      "PLOT NO. 292,  YANGON INDUSTRIAL ZONE, MINGALADON TOWNSHIP,  YANGON REGION   ",
  },
  {
    ID: 1152,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Nyi Nyi Aung",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Kyaw Htet Kyaw Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "Manatha 1159/2016",
    "Permit Date": "2016-03-26T10:22:31Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T10:22:41Z",
    Sector: "Real Estate",
    "Type Of Investment Business": "Agriculture Industrial\nHub ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 50571.2,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Department of Agriculture",
    "Land Area (units not specified in file)": 152.22,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 289,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No-591A, Seik Ta Thu Kha street, 16/4 Ward, Thingangyun Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "N0-A-4/5, Anawrahta Housing Complex, Ward N0-2, Kamaryut Township, Yangon.",
  },
  {
    ID: 1153,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Myo Nanda",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Asia Green Travels and Tours Co., Ltd. ",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1047/2015",
    "Permit Date": "2015-04-07T10:46:39Z",
    "Meeting Number": "5/2015",
    "Meeting Date": "2015-03-20T10:47:00Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 6088.94,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Natural Resources & Environmental Conversation",
    "Land Area (units not specified in file)": 5.8,
    "Lease Term": 50,
    "Annual Lease Fee": 1.45,
    "Land Use Premium": 290000,
    "Number Of Local Employees": 158,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "No.12(A), Bawdi Yeik Thar, Thanlwin Street, Bahan Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.1105,1108, Ngwelayaung Tower, Shwe Hinthar Housing, 6 1/2mile, Hlaing Township, Yangon ",
  },
  {
    ID: 1154,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Myo Nandar",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Asia Green Travels and Tours Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1048/2015",
    "Permit Date": "2015-04-07T03:24:50Z",
    "Meeting Number": "5/2015",
    "Meeting Date": "2015-03-20T03:25:28Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 6309.47,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "Ministry of Natural Resources and Environmental Conservation",
    "Land Area (units not specified in file)": 4.11,
    "Lease Term": 50,
    "Annual Lease Fee": 1.027,
    "Land Use Premium": 205500,
    "Number Of Local Employees": 149,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No.12(A), Bawdi yeikthar, Thanlwin Street, Bahan T/S, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No 1105,1108, Shwe Hinnthar Housing, Ngwelayaung Tower, 6  1/2 mile , Hlaing T/S, Yangon",
  },
  {
    ID: 1155,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. JINKOOK BANG",
    "Name of Principal Organization": "DONGWON M HOUSE COMPANY LIMITED",
    "Place of Incorporation": "Korea (Republic of)",
    "Company Name In Myanmar": "DONGWON M HOUSE COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1231/2017",
    "Permit Date": "2017-01-27T04:14:39Z",
    "Meeting Number": "2/2017",
    "Meeting Date": "2017-01-21T04:15:10Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING  OF UPPER PART OF SHOES ON CMP BASIS   ",
    "Amount Of Foreign Capital USD (in Millions)": 0.511,
    "Total Amount Of Capital (in Millions)": 0.511,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Win Thar @ Lin Phu Gwan ",
    "Land Area (units not specified in file)": 1.232,
    "Lease Term": 10,
    "Annual Lease Fee": 0.025,
    "Land Use Premium": null,
    "Number Of Local Employees": 298,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 10, 1302 STREET, NACDONG ROAD, SA SANGGU, BUSAN CITY, REPUBLIC OF KOREA        ",
    "Organization Address":
      "NO.10, 1302 STREET, NACDONG ROAD, SA SANGGU, BUSAN CITY, REPUBLIC OF KOREA         ",
    "Investment Permitted Address":
      "PLOT NO. 128,  MYAY TAING BLOCK NO. 2, SETHMU MYO, HLAING THAR YAR TOWNSHIP,   YANGON REGION   ",
  },
  {
    ID: 1156,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. MA, XUEMING  ",
    "Name of Principal Organization":
      "HAIYAN HAO RUI TECHNOLOGY DEVELOPMENT CO., LTD.",
    "Place of Incorporation": "PEOPLE’S REPUBLIC OF CHINA ",
    "Company Name In Myanmar": "RUI-NING (MYANMAR) GARMENT CO., LTD.",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1184/2016",
    "Permit Date": "2016-11-11T05:07:30Z",
    "Meeting Number": "20/2016",
    "Meeting Date": "2016-10-28T05:08:14Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENTS ON CMP  BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 2.1,
    "Total Amount Of Capital (in Millions)": 2.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myint Htun ",
    "Land Area (units not specified in file)": 2.128,
    "Lease Term": 20,
    "Annual Lease Fee": 0.18,
    "Land Use Premium": null,
    "Number Of Local Employees": 1300,
    "Number Of Foreign Employees": 18,
    Status: "Monitoring Approved",
    "Investor Address":
      "TONGYUAN TOWN INDUSTRIAL PARK, HAIYAN COUNTY, JIANXING CITY, ZHEJIANG PROVINCE, PEOPLE’S REPUBLIC OF CHINA",
    "Organization Address":
      "TONGYUAN TOWN INDUSTRIAL PARK, HAIYAN COUNTY, JIANXING CITY, ZHEJIANG PROVINCE, PEOPLE’S REPUBLIC OF CHINA ",
    "Investment Permitted Address":
      "PLOT NO. 37, MYAY TAING BLOCK NO. 24, NGWE PIN LAE INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1158,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Zay Htet",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "GEO-PSI DRILLING COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "004/2017",
    "Permit Date": "2017-06-22T04:12:16Z",
    "Meeting Number": "8/2017",
    "Meeting Date": "2017-05-19T04:12:51Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Drilling Services",
    "Amount Of Foreign Capital USD (in Millions)": 6.96,
    "Total Amount Of Capital (in Millions)": 9.28,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Indonesia",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "NO. 64 Yadanar Street, pauk taw ward, insein township, yangon.",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. (89-A) Ward No.19 (Mwe Zone) Hlaing Tharyar Township, Yangon Region.",
  },
  {
    ID: 1160,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. L I XIAOYUN",
    "Name of Principal Organization": "KINGSRICH (H.K) LIMITED",
    "Place of Incorporation": "HONG KONG",
    "Company Name In Myanmar": "KINGSRICH (MYANMAR) FASHION LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1199/2016",
    "Permit Date": "2016-12-11T08:39:16Z",
    "Meeting Number": "22/2016",
    "Meeting Date": "2016-12-01T08:39:47Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 2.5,
    "Total Amount Of Capital (in Millions)": 2.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Ohn Saing and Daw Tin Tin Win",
    "Land Area (units not specified in file)": 3.015,
    "Lease Term": 10,
    "Annual Lease Fee": 0.1,
    "Land Use Premium": null,
    "Number Of Local Employees": 1741,
    "Number Of Foreign Employees": 23,
    Status: "Monitoring Approved",
    "Investor Address":
      "WARD 11, LIAN ER TANG VILLAGE, XI SHUI COUNTY, HUBEI, PEOPLE’S REPUBLIC OF CHINA",
    "Organization Address":
      "ROOM 1507, EMPEROR GROUP CENTRE, 288 HENNESSY ROAD, WANCHAI, HONG KONG",
    "Investment Permitted Address":
      "PLOT NO. 1,2,3, MYAY TAING BLOCK NO. 39 (SETHMU), SHWE PYI THAR INDUSTRIAL ZONE, SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1161,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "VINOD KUMAR @ U TUN TUN WIN",
    "Name of Principal Organization": "TAUNG PYAR DAN CO., LTD.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "CROWN BEVERAGE CANS MYANMAR LTD.",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1200/2016",
    "Permit Date": "2016-12-11T09:06:00Z",
    "Meeting Number": "22/2016",
    "Meeting Date": "2016-12-01T09:06:41Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing , Distribution And Marketing Of Metal Can & Ends",
    "Amount Of Foreign Capital USD (in Millions)": 49,
    "Total Amount Of Capital (in Millions)": 61.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 36,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "U Tun Tun Win & U Maung Maung Oo",
    "Land Area (units not specified in file)": 8.81,
    "Lease Term": 50,
    "Annual Lease Fee": 0.1,
    "Land Use Premium": null,
    "Number Of Local Employees": 211,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.10, MINGALAR STREET, WARD NO. 16, YANKIN TOWNSHIP, YANGON",
    "Organization Address":
      "NO. 184/B, THEIN PHYU ROAD, BOTATAUNG TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "Plot No. 221, 222, 224, 225, 226, 227, Yangon Industrial Zone, Mingalardon Township, Yangon Region",
  },
  {
    ID: 1164,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chen, Chang-Nan",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Ceres Enterprise Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "041/2017",
    "Permit Date": "2017-08-20T04:08:18Z",
    "Meeting Number": "11/2017",
    "Meeting Date": "2017-08-07T04:08:41Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 6.91,
    "Total Amount Of Capital (in Millions)": 6.91,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Department of Urban and Housing Development",
    "Land Area (units not specified in file)": 3.58,
    "Lease Term": 10,
    "Annual Lease Fee": 96000,
    "Land Use Premium": null,
    "Number Of Local Employees": 2350,
    "Number Of Foreign Employees": 74,
    Status: "Monitoring Approved",
    "Investor Address":
      "10F-3,No.2, LN.258,Ruiguang RD, Neihu Dist, Taipei City 114, Taiwan , Republic of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. D-10, Mingalardon Industrial Park, Mingalardon Township, Yangon Region",
  },
  {
    ID: 1165,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kim Won Sok",
    "Name of Principal Organization": "Delta Mate Limited, ",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Delta Mate Myanmar Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "070/2017",
    "Permit Date": "2017-12-12T05:36:07Z",
    "Meeting Number": "16/2017",
    "Meeting Date": "2017-11-30T05:36:42Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 7.951,
    "Total Amount Of Capital (in Millions)": 7.951,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Phyo Hla Myint",
    "Land Area (units not specified in file)": 5,
    "Lease Term": 30,
    "Annual Lease Fee": 0.04,
    "Land Use Premium": null,
    "Number Of Local Employees": 2451,
    "Number Of Foreign Employees": 33,
    Status: "Monitoring Approved",
    "Investor Address":
      "Room-1406, Beverly House, 93-107 Lockhart Road , Wanchai , Hong Kong",
    "Organization Address":
      "Room 1406, Beverly House, 93-107, Lockhart Road, Wanchai, Hong Kong",
    "Investment Permitted Address":
      "Holding NO -1/Ka, Plot No.7,21,22,23,28,29,Block No.998A , Ma Kyi Kan Kwin, Ka Li Htaw (East) Village Tract, Hlegu Township, Yangon Region",
  },
  {
    ID: 1166,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Zaw Htun Aung",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Dong Htun Zin Steel Industrial Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "055/2017",
    "Permit Date": "2017-09-14T08:14:08Z",
    "Meeting Number": "12/2017",
    "Meeting Date": "2017-08-29T08:14:37Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Sales of Construction Used Steel Products",
    "Amount Of Foreign Capital USD (in Millions)": 7.79,
    "Total Amount Of Capital (in Millions)": 14.16,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Shi Kai",
    "Land Area (units not specified in file)": 2,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 81,
    "Number Of Foreign Employees": 15,
    Status: "Approved",
    "Investor Address":
      "No. FG-140, Thit Khwa Street, FMI City, Hlaing Tharyar , Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No .89, Yangon Industrial Zone, Mingalardon Township, Yangon Region",
  },
  {
    ID: 1168,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yu Yuankai",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Modern Era Handbags Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "062/2017",
    "Permit Date": "2017-10-18T04:01:41Z",
    "Meeting Number": "14/2017",
    "Meeting Date": "2017-10-10T04:02:13Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.499,
    "Total Amount Of Capital (in Millions)": 1.499,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myint Shwe and Daw Khin San Kyu",
    "Land Area (units not specified in file)": 1.378,
    "Lease Term": 10,
    "Annual Lease Fee": 0.072,
    "Land Use Premium": null,
    "Number Of Local Employees": 585,
    "Number Of Foreign Employees": 21,
    Status: "Monitoring Approved",
    "Investor Address":
      "RM-1104, UNITE-2, BLOCK-10, XIANGZHANGHUAYUAN, NEIGHBORHOOD, SANGYUAN, ROAD, TONGJUN STREET, TONGLU  COUNTY, ZHEJIANG  PROVINCE, CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "Myay Taing Block No.42, (Inudstrial Zone) Plot No.45/ka,45/kha, Shwepyithar Township, Yangon Region",
  },
  {
    ID: 1169,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhou, Xin",
    "Name of Principal Organization":
      "Anhui Xinlin Import and Export Trade (Group) Co., Ltd.",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "New Forest Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "015/2017",
    "Permit Date": "2017-07-14T05:46:36Z",
    "Meeting Number": "9/2017",
    "Meeting Date": "2017-06-16T05:46:59Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.33,
    "Total Amount Of Capital (in Millions)": 4.33,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Poe Myint  @ San San",
    "Land Area (units not specified in file)": 1.51,
    "Lease Term": 7,
    "Annual Lease Fee": 0.036,
    "Land Use Premium": null,
    "Number Of Local Employees": 950,
    "Number Of Foreign Employees": 30,
    Status: "Amend",
    "Investor Address":
      "Room No. (101), Flat 2,Yanyuan, Chongchun District, Nantong City, Jaingsu Province, People's Republic of China",
    "Organization Address":
      "No. 14-3, Jiadachangzhi Logistics Park,, Suma Park, Suzhou City, Anhui Province People's Republic of China",
    "Investment Permitted Address":
      "Plot No. 378, Myay Taing Block No. Yalapa-25, Shwe Lin Ban Industrial Zone, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 1170,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yuan Bojiang ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Hong Ri (Myanmar) Company Limited ",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "060/2017 (3-10-207)",
    "Permit Date": "2017-10-03T07:52:23Z",
    "Meeting Number": "12/2017",
    "Meeting Date": "2017-08-29T07:51:56Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF HANDBAGS ON CMP BASIS  ",
    "Amount Of Foreign Capital USD (in Millions)": 1.6,
    "Total Amount Of Capital (in Millions)": 1.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Khin Thandar Oo ",
    "Land Area (units not specified in file)": 1.669,
    "Lease Term": 5,
    "Annual Lease Fee": 26667,
    "Land Use Premium": null,
    "Number Of Local Employees": 845,
    "Number Of Foreign Employees": 18,
    Status: "Monitoring Approved",
    "Investor Address":
      "DONG GUAN TOWNSHIP, WANG NIU DUN TOWN, WANG LIAN VILLAGE, WU FANG LU DUANG, GUANG DONG CITY, CHINA  ",
    "Organization Address": "",
    "Investment Permitted Address":
      " PLOT NO. 134, MYAY TAING BLOCK NO.25, SHWE LIN BAN SETHMU MYO, HLAING THAR YAR TOWNSHIP,YANGON REGION ",
  },
  {
    ID: 1171,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.  Lin, Bo",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "AIT (Myanmar) Manufacturing Company Limited ",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "061/2017",
    "Permit Date": "2017-10-18T08:47:43Z",
    "Meeting Number": "14/2017",
    "Meeting Date": "2017-10-10T08:48:21Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF KNITTED WEAR ON CMP BASIS  ",
    "Amount Of Foreign Capital USD (in Millions)": 5.29,
    "Total Amount Of Capital (in Millions)": 5.29,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Khin Maung Hein   ",
    "Land Area (units not specified in file)": 2.507,
    "Lease Term": 12,
    "Annual Lease Fee": 0.046,
    "Land Use Premium": null,
    "Number Of Local Employees": 1500,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address": "BLOCK-3, 1218 WEST WENYI ROAD, HANGZHOU, CHINA 311121",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 46, MYAY TAING BLOCK \tNO.112, SETHMU, DAGON MYO THIT (EAST) TOWNSHIP, YANGON REGION ",
  },
  {
    ID: 1174,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. ZHOU JIANSHU  ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "MYANMAR  FEI  LONG  ELECTRIC WIRE  FACTORY  LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1131/2016",
    "Permit Date": "2016-07-06T07:14:20Z",
    "Meeting Number": "12/2016",
    "Meeting Date": "2016-06-27T07:14:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF ELECTRIC WIRE",
    "Amount Of Foreign Capital USD (in Millions)": 0.756,
    "Total Amount Of Capital (in Millions)": 0.756,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U San Lwin, U Myat Htin,  U Mya Lwin, U Ye Lwin ",
    "Land Area (units not specified in file)": 1.005,
    "Lease Term": 20,
    "Annual Lease Fee": 0.021,
    "Land Use Premium": null,
    "Number Of Local Employees": 81,
    "Number Of Foreign Employees": 9,
    Status: "Monitoring Approved",
    "Investor Address":
      "ZHE JIANG SHENG, DONG QING SHI, HUANG HUA ZHEN, HUA XI CUN, PEOPLE ‘S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 50, INDUSTRIAL ZONE (1), HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1175,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Maung Maung Myint",
    "Name of Principal Organization":
      "No.6, Ayathidi Road, KyaukMyay,ThaMay Township, Yangon Division",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Kaung Myat Co.,Ltd.",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "MaNaTha-1241/2017",
    "Permit Date": "2017-04-11T03:13:53Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T03:26:05Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်ပါးလွှာ၊ အထပ်သားနှင့်သစ်အခေ ျာထည်များ ထုတ်လုပ်ခြင်းနှင့်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 2.09,
    "Total Amount Of Capital (in Millions)": 2750,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Mg Mg Myint",
    "Land Area (units not specified in file)": 2.761,
    "Lease Term": 50,
    "Annual Lease Fee": 18,
    "Land Use Premium": null,
    "Number Of Local Employees": 230,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.6, Ayathidi Road, KyaukMyay,ThaMay Township, Yangon Division",
    "Organization Address":
      "No.6, Ayathidi Road, KyaukMyay,ThaMay Township, Yangon Division",
    "Investment Permitted Address":
      "No.131, Panthinwun U Shwe Bin Street, , Dagon(east), YANGON",
  },
  {
    ID: 1177,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Tin Myint Ni",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "CO2 Solutions Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "MaNaTha-1194/2016",
    "Permit Date": "2016-07-26T04:34:26Z",
    "Meeting Number": "12/2016",
    "Meeting Date": "2016-06-27T04:41:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အရည်အသေ ွးမြင့် သစ်ပါးလွှာနှင့် အထပ်သားအရွယ်စုံ ထုတ်လုပ်ခြင်းနှင့် ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.125,
    "Total Amount Of Capital (in Millions)": 4000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Mg Mg Lay",
    "Land Area (units not specified in file)": 2.85,
    "Lease Term": 20,
    "Annual Lease Fee": 31.5,
    "Land Use Premium": null,
    "Number Of Local Employees": 69,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.216, ANoryethar Road, Panbedan Township, Yangon Division",
    "Organization Address": "-",
    "Investment Permitted Address":
      " No.(160), U Tayoke Kyee Street, Industrial Zone(2), Dagon(seikkan), YANGON",
  },
  {
    ID: 1178,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Win Swe",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Win & Win Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1090/2015",
    "Permit Date": "2015-09-25T07:42:41Z",
    "Meeting Number": "16/2015",
    "Meeting Date": "2015-09-11T07:43:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "သစ်ပါးလွှာထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.89,
    "Total Amount Of Capital (in Millions)": 1057.25,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "စက်မှုဝန်ကြီးဌာန၊ အမှတ် ၃ အကြီးစားစက်မှုလုပ်ငန်း (ယခင် စက္ကူနှင့် အိမ် သုံးပစ္စည်းလုပ်ငန်း)",
    "Land Area (units not specified in file)": 15.26,
    "Lease Term": 50,
    "Annual Lease Fee": 52.98,
    "Land Use Premium": null,
    "Number Of Local Employees": 330,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "No.400, Cannar Road, Lathar Township, Yangon Division",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.(6), (6)Mile,Pyay Road, , Hlaing, YANGON",
  },
  {
    ID: 1179,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Xiao, Hongkai",
    "Name of Principal Organization":
      "SHANTOU  CITY  KAIXI  LINGERIE  INDUSTRIAL   COMPANY  LIMITED",
    "Place of Incorporation": "China",
    "Company Name In Myanmar":
      "Kaixi (Myanmar) Lingerie Industrial Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1253/2017",
    "Permit Date": "2017-04-11T03:19:35Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T03:20:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of  Brassieres And Briefs on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3.5,
    "Total Amount Of Capital (in Millions)": 3.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myo Thant ",
    "Land Area (units not specified in file)": 2.247,
    "Lease Term": 10,
    "Annual Lease Fee": 0.05,
    "Land Use Premium": null,
    "Number Of Local Employees": 1328,
    "Number Of Foreign Employees": 22,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.93 DONGFENG 2nd ROAD, CHENDIAN TOWN,  CHAONAN  DISTRICT,  SHANTOU CITY,  GUANGDONG  PROVINCE,  PEOPLE’S REPUBLIC OF  CHINA",
    "Organization Address":
      "3 F, BUILDING 1, 3-02A XIASHAN  TECHNOLOGY  PARK, CHAONAN  DISTRICT,  SHANTOU  CITY, PEOPLE’S REPUBLIC OF CHINA",
    "Investment Permitted Address":
      "Plot No 58, Myay Taing Block No.24, Ngwe Pin Lal Industrial Zone, Haing Tharyar Township, Yangon Region",
  },
  {
    ID: 1181,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Misa Koizumi",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Green Wings International Comapany Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1226/2017",
    "Permit Date": "2017-01-15T03:57:45Z",
    "Meeting Number": "1/2017",
    "Meeting Date": "2017-01-06T03:58:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Shoes (Foot Wears) on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.55,
    "Total Amount Of Capital (in Millions)": 1.55,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Nwe Nwe Aung  and Daw Cho Cho Win ",
    "Land Area (units not specified in file)": 1.5,
    "Lease Term": 30,
    "Annual Lease Fee": 0.048,
    "Land Use Premium": null,
    "Number Of Local Employees": 498,
    "Number Of Foreign Employees": 11,
    Status: "Monitoring Approved",
    "Investor Address":
      "1-24-15 , IMAJUKU, ASAHIKU, YOKOHAMA, KANAGAWA,     JAPAN",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 9,10,11, MYAY  TAING  BLOCK  NO. 25, SHWE  LIN BAN SETHMU MYO,  HLAING THARYAR  TOWNSHIP, YANGON  REGION",
  },
  {
    ID: 1183,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.KAMOL BORRISUTTANAKUL",
    "Name of Principal Organization": "TPBI  INTERNATIONAL  COMPANY  LIMITED",
    "Place of Incorporation": "Thailand",
    "Company Name In Myanmar": "TPBI & MYANMAR STAR  COMPANY  LIMITED ",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "E-074/2017",
    "Permit Date": "2017-12-30T04:56:11Z",
    "Meeting Number": "17/2017",
    "Meeting Date": "2017-12-22T04:57:11Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF ALL KINDS OF PLASTIC BAGS    ",
    "Amount Of Foreign Capital USD (in Millions)": 3.825,
    "Total Amount Of Capital (in Millions)": 5.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "U Eike San @ U Myint Maung ",
    "Land Area (units not specified in file)": 4.946,
    "Lease Term": 5,
    "Annual Lease Fee": 360,
    "Land Use Premium": null,
    "Number Of Local Employees": 235,
    "Number Of Foreign Employees": 11,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.42/174,MU 5, SOI SRI SATHIAN NIWET,RAI KHING SUB-DISTRICT,SAM PHRAN DISTRICT, NAKHON PATHOM PROVINCE,THAILAND   ",
    "Organization Address":
      "NO.42/174, MU 5, SOI SRI SATHIAN NIWET, RAI KHING SUB-DISTRICT, SAM PHRAN DISTRICT, NAKHON PATHOM PROVINCE,THAILAND   \t           ",
    "Investment Permitted Address":
      "PLOT NO. 57, 58, MYAY TAING BLOCK NO.113, DAGON (EAST) INDUSTRIAL ZONE, DAGON (EAST) TOWNSHIP, YANGON REGION ",
  },
  {
    ID: 1185,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhang , Buzhong",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Jia Long Plastic Products (Myanmar) Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "P 1232/2017",
    "Permit Date": "2017-01-27T05:20:30Z",
    "Meeting Number": "2/2017",
    "Meeting Date": "2017-01-21T05:20:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING  AND  MARKETING  OF  POLYBAG  AND  RELATED  PRODUCTS  SUCH AS  ELASTIC  BAND",
    "Amount Of Foreign Capital USD (in Millions)": 3.06,
    "Total Amount Of Capital (in Millions)": 3.22,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Maryi Ar Ya Kyun ",
    "Land Area (units not specified in file)": 1.345,
    "Lease Term": 5,
    "Annual Lease Fee": 0.028,
    "Land Use Premium": null,
    "Number Of Local Employees": 60,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Amend",
    "Investor Address":
      "GROUP ONE OF FENG  VILLAGE, ZUXI  TWON  OF KAI  XIAN,  CHONG  QING  CITY,  PEOPLE’S  REPUBLIC  OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 256, MYAY  TAING  BLOCK  NO. 25, SHWE  LIN BAN SETHMU MYO,  HLAING THARYAR  TOWNSHIP, YANGON  REGION",
  },
  {
    ID: 1186,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. QIAN FEI",
    "Name of Principal Organization": "ROO HSING CO.,LTD.",
    "Place of Incorporation": "Taiwan, Province of China",
    "Company Name In Myanmar": "S.H. UNITED COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "E-075/2017",
    "Permit Date": "2017-12-30T05:29:45Z",
    "Meeting Number": "17/2017",
    "Meeting Date": "2017-12-22T05:31:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING   OF GARMENT ON CMP BASIS  ",
    "Amount Of Foreign Capital USD (in Millions)": 5.21,
    "Total Amount Of Capital (in Millions)": 5.21,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Phon Swee May ",
    "Land Area (units not specified in file)": 5.016,
    "Lease Term": 10,
    "Annual Lease Fee": 0.082,
    "Land Use Premium": null,
    "Number Of Local Employees": 2000,
    "Number Of Foreign Employees": 40,
    Status: "Monitoring Approved",
    "Investor Address":
      "13F-4, NO.57, FUXING N.ROAD, SONGSHAN \t\t\t\tDISTRICT,TAIPEI CITY 105, TAIWAN, R.O.C",
    "Organization Address":
      "13F-4, NO.57, FUXING N.ROAD, SONGSHAN DISTRICT, TAIPEI CITY 105, TAIWAN, R.O.C\t",
    "Investment Permitted Address":
      "PLOT NO. 72,73, 104,105, MYAY TAING \tBLOCK NO.ZONE-2, HLAING THAR YAR INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP,YANGON REGION ",
  },
  {
    ID: 1187,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyaw Thet Lwin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Maha Nadi Maritime Service Co.,Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1078/2015",
    "Permit Date": "2015-08-20T06:23:34Z",
    "Meeting Number": "14/2015",
    "Meeting Date": "2015-08-07T06:24:21Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်ခွဲသားနှင့် ကြမ်းခင်းပစ္စည်းအမျိုးမျိုး ထုတ်လုပ်ဖြန့်ဖြူးရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.566,
    "Total Amount Of Capital (in Millions)": 1638.97,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Moe Hlaing and Mi Mi Khin",
    "Land Area (units not specified in file)": 1.731,
    "Lease Term": 10,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 62,
    "Number Of Foreign Employees": 8,
    Status: "Monitoring Approved",
    "Investor Address":
      "No,120, Frist Floor,  42 Road, 8 Quarter, Botataung Township, Yangon Region",
    "Organization Address": "",
    "Investment Permitted Address":
      "Room No.(803), (8th)Floor,Block (B), Pearl Condominium, Corner Of Ga Ba Aye Pagoda Road And Sayasan Road, Bahan, YANGON",
  },
  {
    ID: 1188,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lan, Xiaoyong",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "TIAN  CHENG  PEN  JIAO  MIAN  (MYANMAR)  COMPANY  LIMITED\t    ",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "P 1255/2017",
    "Permit Date": "2017-04-11T07:47:31Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T07:47:57Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING  AND  SALE  OF SYNTHETIC RESIN  FOR  CLOTHING SUCH AS JACKET AND WARM  COAT",
    "Amount Of Foreign Capital USD (in Millions)": 1.97,
    "Total Amount Of Capital (in Millions)": 2.08,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "U Maung Win (a) Yo Eit Phe ",
    "Land Area (units not specified in file)": 1.001,
    "Lease Term": 50,
    "Annual Lease Fee": 0.021,
    "Land Use Premium": null,
    "Number Of Local Employees": 118,
    "Number Of Foreign Employees": 12,
    Status: "Monitoring Amend",
    "Investor Address":
      "LIAO  NING  SHENG, DA LIAN  SHI,  ZHONG SHAN QU, ZHONG  NAN  LU,  ZHONG  JING  YUAN, NO.  FOUR 1-4-4, PEOPLE’S  REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 34, MYAY  TAING  BLOCK NO.  PART-4, INDUSTRIAL  ZONE,  HLAING THARYAR  TOWNSHIP, YANGON  REGION",
  },
  {
    ID: 1189,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Zaw Win",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Asia Win Manufacturing Co.,Ltd",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "MaNatha-1018/2014",
    "Permit Date": "2014-12-23T07:54:33Z",
    "Meeting Number": "27/2014",
    "Meeting Date": "2014-11-28T07:56:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်ခွဲသားနှင့် သစ်အခေ ျာထည်ထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.946,
    "Total Amount Of Capital (in Millions)": 948.7,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Zaw Win",
    "Land Area (units not specified in file)": 1.919,
    "Lease Term": 30,
    "Annual Lease Fee": 12,
    "Land Use Premium": null,
    "Number Of Local Employees": 150,
    "Number Of Foreign Employees": 7,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.129, Bo Min Yang  Road, Mingalar Tang Nyunt Township, Yangon Region",
    "Organization Address": "",
    "Investment Permitted Address":
      " No.(129), Bo Min Yaung Street, Mingalartaungnyunt, YANGON",
  },
  {
    ID: 1190,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mrs. Jing, Aimei",
    "Name of Principal Organization":
      "Jiangsu Solamoda Garments Group Company Limited",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Myanmar Solamoda Garments Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": " 1187/2016",
    "Permit Date": "2016-11-11T09:05:21Z",
    "Meeting Number": "20/2016",
    "Meeting Date": "2016-10-28T09:05:51Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Garment on CMP Basis (factory-2)",
    "Amount Of Foreign Capital USD (in Millions)": 2.38,
    "Total Amount Of Capital (in Millions)": 2.38,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Bushido Trading Company Limited",
    "Land Area (units not specified in file)": 3.027,
    "Lease Term": 20,
    "Annual Lease Fee": 0.067,
    "Land Use Premium": null,
    "Number Of Local Employees": 1480,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address":
      "16-101,Dongsheng Garden Chong Chuan District, Jiangsunantong, People's Republic of China",
    "Organization Address":
      "496# Yonghe Road, Gangzha District, Nantong City, Jiangsu Province People's Republic of ChIna",
    "Investment Permitted Address":
      "Plot No. 11,12,13, Myay Taing Block No. 39(Sethmu), Shwe Pyithar Township, Yangon Township",
  },
  {
    ID: 1191,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. HYUN BAEK KIM",
    "Name of Principal Organization": "VITABIO  COMPANY  LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "VITABIO MYANMAR   \tCOMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "090/2018",
    "Permit Date": "2018-03-27T08:25:39Z",
    "Meeting Number": "4/2018",
    "Meeting Date": "2018-03-20T08:26:17Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business": "BREEDER FARM AND SALES OF PIG",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Lwin Oo",
    "Land Area (units not specified in file)": 5,
    "Lease Term": 30,
    "Annual Lease Fee": 2467,
    "Land Use Premium": null,
    "Number Of Local Employees": 24,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "102 DONG, 702 HO, 67, GEONDEUNG – RO, GEONDEUNG – RI,MUNMAK – EUP, WONJU – SI, GANGWON – DO, REPUBLIC OF KOREA",
    "Organization Address":
      "501 HO, 21-3, YONGJEON-DONG, DONG-GU, DAEJEON, KOREA       ",
    "Investment Permitted Address":
      "No. 140 /A, Than Lwin Road., Mayangone, YANGON",
  },
  {
    ID: 1192,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Fong Son Kin",
    "Name of Principal Organization": "FU SON  GARMENT  FACTORY  LIMITED",
    "Place of Incorporation": " MACAO",
    "Company Name In Myanmar":
      "FU  SON  GARMENT  FACTORY (MYANMAR)  LIMITED\t               ",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": " 1273/2017",
    "Permit Date": "2017-05-09T02:38:06Z",
    "Meeting Number": "6/2017",
    "Meeting Date": "2017-04-05T02:39:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING  OF  GARMENT      ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 3.64,
    "Total Amount Of Capital (in Millions)": 3.64,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Great Shwe Taung Development Co., Ltd.",
    "Land Area (units not specified in file)": 2.374,
    "Lease Term": 10,
    "Annual Lease Fee": 0.048,
    "Land Use Premium": null,
    "Number Of Local Employees": 852,
    "Number Of Foreign Employees": 20,
    Status: "Approved",
    "Investor Address":
      "NO-9-11, RUA  ABREU  NUNES, 11-A, MACAO, S.A.R, PEOPLE’S REPUBLIC  OF  CHINA ",
    "Organization Address":
      "NO.123  AVENIDA  ALMIRANTE  LACERDA, ‘HIP  WA’ INDUSTRIAL BLDG.7B  FLOOR,  MACAO, S.A.R,  PEOPLE’S  REPUBLIC OF  CHINA",
    "Investment Permitted Address":
      "PLOT NO. 60, MYAY  TAING  BLOCK  NO. 21, MYA  SEIN YAUNG INDUSTRIAL  ZONE,  HLAING THARYAR  TOWNSHIP, YANGON  REGION",
  },
  {
    ID: 1193,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Li, Qiuyan",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Futeli Garment (Myanmar) Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": " 1188/2016",
    "Permit Date": "2016-11-11T03:04:20Z",
    "Meeting Number": "20/2016",
    "Meeting Date": "2016-10-28T03:04:42Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.38,
    "Total Amount Of Capital (in Millions)": 1.38,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Soe Win ",
    "Land Area (units not specified in file)": 2.266,
    "Lease Term": 20,
    "Annual Lease Fee": 0.05,
    "Land Use Premium": null,
    "Number Of Local Employees": 1180,
    "Number Of Foreign Employees": 25,
    Status: "Monitoring Approved",
    "Investor Address":
      "RM 405, Building #3, Jiyanghu Haungguan, Jiyanghu Street, Zhangjiagang City, Jiangsu Province, People's Republic of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 116, Myay Taing Block No. 14,( Shwe Than Lwin), Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 1194,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Tian Liangming",
    "Name of Principal Organization": "East Southern Enterprises Ltd.",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Spring River Knitting (Myanmar) Co.,Ltd.",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1151/2016",
    "Permit Date": "2016-09-19T03:47:01Z",
    "Meeting Number": "17/2016",
    "Meeting Date": "2016-09-09T03:47:36Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Knitting Products on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.64,
    "Total Amount Of Capital (in Millions)": 1.64,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myat Soe, U Tun Tun Win",
    "Land Area (units not specified in file)": 2.6,
    "Lease Term": 20,
    "Annual Lease Fee": 0.054,
    "Land Use Premium": null,
    "Number Of Local Employees": 671,
    "Number Of Foreign Employees": 35,
    Status: "Monitoring Approved",
    "Investor Address":
      "Rm 904 Harvest Bldg 29-35 Wing Kut St, Central, Hong Kong ",
    "Organization Address":
      "FLAT 27/F  BLOCK  A HUNG  HOM  BAY  CENTRE  KL ,  HONG KONG",
    "Investment Permitted Address":
      "PLOT  NO. 148+149, MYAY  TAING  BLOCK NO. 25, SHWE LIN BAN  INDUSTRIAL  ZONE,  HLAING THARYAR  TOWNSHIP, YANGON  REGION",
  },
  {
    ID: 1195,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Mg Mg Ohn",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myint Myat Kyaww Group of Companies Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "MaNaTha 1258/2017",
    "Permit Date": "2017-05-19T17:30:00Z",
    "Meeting Number": "8/2017",
    "Meeting Date": "2017-05-20T09:22:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Selling of Construction Materials Used by Steel  & H Bean",
    "Amount Of Foreign Capital USD (in Millions)": 25.43,
    "Total Amount Of Capital (in Millions)": 49950,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 247,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.527/529, Under Pazhuntaung Road, PaZhuntaung Township, Yangon Region",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.561,Holding No.10+11+13+14, Hlawkar Village Tract, Shwi Pyi Thar Township, Yangon Region",
  },
  {
    ID: 1196,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kim Sungho",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Sung Bo International Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "003/2017",
    "Permit Date": "2017-06-21T07:22:43Z",
    "Meeting Number": "8/2017",
    "Meeting Date": "2017-05-19T07:23:56Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.31,
    "Total Amount Of Capital (in Millions)": 1.31,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Than Sein",
    "Land Area (units not specified in file)": 0.96,
    "Lease Term": 10,
    "Annual Lease Fee": 0.045,
    "Land Use Premium": null,
    "Number Of Local Employees": 1507,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address":
      "KYUNG  KI  DO. KIM  PO  SHI,  HAN  GANG  7 RO, 22-22  HILSTEITE, A.P.T  503  DONG 202 HO,  REPUBLIC OF  KOREA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 160, MYAY TAING  BLOCK NO. ZONE-5, HLAING THARYAR TOWNSHIP , YANGON REGION",
  },
  {
    ID: 1197,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyaw Soe Lwin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myat Noe Thu Co.,Ltd",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "MaNaTha-1013/2014",
    "Permit Date": "2014-11-22T07:19:46Z",
    "Meeting Number": "26/2014",
    "Meeting Date": "2014-11-07T07:22:57Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်ပါးလွှာ၊ အထပ်သားနှင့် တန်ဖိုးမြှင့်သစ်အခေ ျာထည်ပစ္စည်းများ ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 4.33,
    "Total Amount Of Capital (in Millions)": 14236.74,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Kyaw Soe Lwin",
    "Land Area (units not specified in file)": 11.03,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 650,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address":
      "7/B, KanYeikTha Road, 10 Quarter, MaYangone Township, Yangon Region",
    "Organization Address": "",
    "Investment Permitted Address":
      "Building No.(A-1), Room(508),Shwe Gon Thu Housing, Lower Kyee Myin Dine Road, , Kyimyindaing, YANGON",
  },
  {
    ID: 1198,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Li Dahong",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Xing Jia (Myanmar) Shoes Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "058/2017",
    "Permit Date": "2017-10-03T07:34:16Z",
    "Meeting Number": "13/2017",
    "Meeting Date": "2017-09-15T07:34:51Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Varieties of shoes on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Samoa",
    "Form Of Investment": "FDII",
    "Land Owner": "Shinning Moon Co., Ltd.",
    "Land Area (units not specified in file)": 2.001,
    "Lease Term": 8,
    "Annual Lease Fee": 0.048,
    "Land Use Premium": null,
    "Number Of Local Employees": 489,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "Villagers Group, General Bridge Village, Dingcheng District, Changde City, Hunan Province, China",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No.54, Industrial Zone (1), Hlaing Thar Yar Township, Yangon",
  },
  {
    ID: 1200,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Naw Se Khu Htoo",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Maijiang International Building Material Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1257/2017",
    "Permit Date": "2017-06-21T08:50:41Z",
    "Meeting Number": "8/2017",
    "Meeting Date": "2017-05-19T08:51:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Electric Wire",
    "Amount Of Foreign Capital USD (in Millions)": 0.018,
    "Total Amount Of Capital (in Millions)": 0.018,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 5,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Ohn Lwin",
    "Land Area (units not specified in file)": 1.554,
    "Lease Term": 5,
    "Annual Lease Fee": 48,
    "Land Use Premium": null,
    "Number Of Local Employees": 40,
    "Number Of Foreign Employees": 5,
    Status: "Approved",
    "Investor Address":
      "No. O-7, Orchid Road, F.M.I City, Hlaingtharya Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 41-B, Myay Taing Block No. 25, Shwe Linban Sethmu Myot, Hlaingtharya Township, Yangon",
  },
  {
    ID: 1203,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်စိန်(အဘ-ဦး‌ရောင်ဝမ်ချင်)",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "အောင်ကမ္ဘာမော်တာဝန်ဆောင်မှုကုမ္ပဏီလီမိတက်",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1267/2017",
    "Permit Date": "2017-08-20T06:50:14Z",
    "Meeting Number": "11/2017",
    "Meeting Date": "2017-08-07T06:50:50Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "မော်တော်ယာဉ်တပ်ဆင်ထုတ်လုပ် ရောင်းချခြင်းနှင့်ပြုပြင်ထိန်းသိမ်းခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.62,
    "Total Amount Of Capital (in Millions)": 2863.62,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "ဦးအောင်စိန်၊ဦးမြင်သိန်း၊ ဒေါ်အိမျိုးမျိုးခိုင်၊ဒေါ်သန္တာစိုး   ",
    "Land Area (units not specified in file)": 18.64,
    "Lease Term": 30,
    "Annual Lease Fee": 48,
    "Land Use Premium": null,
    "Number Of Local Employees": 132,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၄၀(အေ)၊ ဖိုးစိန်လမ်း၊ နတ်မောက်ရပ်ကွက်၊ တာမွေမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ဦးပိုင်အမှတ်(၅၆/၂/က+၅၆/၂/ခ+ ၅၆/၂/ဃ+ ၅၇/၂)၊ ကွင်းအမှတ်-( ၁၀၈၂က)၊ ဆားတလင်းကွင်း၊ ဆားတလင်းကျေးရွာအုပ်စု၊ လှည်းကူးမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1204,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Qiao, Liang",
    "Name of Principal Organization": "MAXVIS  INTERNATIONAL  TRADING  LIMITED",
    "Place of Incorporation": "United Kingdom",
    "Company Name In Myanmar": "Handa (Yangon) Garment Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1156/2016",
    "Permit Date": "2016-09-19T05:05:18Z",
    "Meeting Number": "17/2016",
    "Meeting Date": "2016-09-09T05:05:50Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3.01,
    "Total Amount Of Capital (in Millions)": 3.01,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "United Kingdom of Great Britain and Northern Ireland",
    "Form Of Investment": "FDII",
    "Land Owner":
      "U Kyaw Myint (a) Kyaung Main,U Myint Swe (a) Si Paung and U Aye Thaung",
    "Land Area (units not specified in file)": 2.438,
    "Lease Term": 20,
    "Annual Lease Fee": 0.15,
    "Land Use Premium": null,
    "Number Of Local Employees": 1676,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.49, QIAN  GIECO QUARTER, JIANG  SU  STATE, XU  XI  CITY, BEI  JIE  ZHAN, TAO  XIN  CHUN  CHINA, HUI SHAN  T/S, PEOPLE’S REPUBLIC  OF  CHINA",
    "Organization Address":
      "RM B,1F., L . A BLDG.66 CORPORATION ROAD  GRANGE  TOWN  CARDIFF, UNITED  KINGDOM",
    "Investment Permitted Address":
      "PLOT NO. 13,14,15, MYAY  TAING  BLOCK  NO. 25, SHWE  LIN BAN INDUSTRIAL  ZONE,  HLAING THARYAR  TOWNSHIP, YANGON  REGION",
  },
  {
    ID: 1205,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lee Chun Fai",
    "Name of Principal Organization": "Whale Fun International Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Myanmar Jiale Fashion Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1155/2016",
    "Permit Date": "2016-09-19T05:45:55Z",
    "Meeting Number": "17/2016",
    "Meeting Date": "2016-09-09T05:46:29Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING  OF  GARMENT ON CMP BASIS (FACTORY-2)",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Thein Naing @ Wah Win",
    "Land Area (units not specified in file)": 1.969,
    "Lease Term": 10,
    "Annual Lease Fee": 0.002,
    "Land Use Premium": null,
    "Number Of Local Employees": 502,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      " FLAT A, 68TH  FLOOR,  TOWER 3, HARBOURFRONT  LANDMARK, 11 WAN  HOI  STREET,  HUNG HOM,  KOWLOON,  HONG KONG",
    "Organization Address":
      "UNIT 1-2,12/F  WING  LEE  IND.  BLDG 54-58  TONG  MEI  ROAD, KOWLOON,  HONG  KONG",
    "Investment Permitted Address":
      "PLOT  NO. 44, MYAY  TAING  BLOCK NO. YA  LA PA - 25, HLAING THARYAR  TOWNSHIP, YANGON  REGION",
  },
  {
    ID: 1206,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lin Wen",
    "Name of Principal Organization":
      "Jingsu Golden Island International Co., Ltd. ",
    "Place of Incorporation": "People Republic of China",
    "Company Name In Myanmar": "KGG Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "E-020/2017",
    "Permit Date": "2017-07-14T06:04:05Z",
    "Meeting Number": "9/2017",
    "Meeting Date": "2017-06-16T07:16:37Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.59,
    "Total Amount Of Capital (in Millions)": 2.59,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aik Kyi @ U Soe Han, Daw Moe Moe Aung and Daw Cho Cho Win",
    "Land Area (units not specified in file)": 6.028,
    "Lease Term": 10,
    "Annual Lease Fee": 488,
    "Land Use Premium": null,
    "Number Of Local Employees": 1407,
    "Number Of Foreign Employees": 30,
    Status: "Monitoring Approved",
    "Investor Address":
      "Textile Industrial Park, Jiangning District Economic and Technical Development Zone,  Nanjing City.",
    "Organization Address": "2F, No.293-2, Zhongshan East Road",
    "Investment Permitted Address":
      "Plot No.1/A,1/D,1/E, Industrial Zone(2), Dagon Myo Thit (Seikkan) Township, Yangon",
  },
  {
    ID: 1207,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. OH  JUNG  GEUN",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MYANMAR  QUN  SAN COMPANY  LIMITED\t\t",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1254/2017",
    "Permit Date": "2017-04-11T07:40:18Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T07:40:57Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING  OF  GARMENT   ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 2.47,
    "Total Amount Of Capital (in Millions)": 2.47,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Hain Shang (a) Hla Myint and Daw Khin Khin Thein",
    "Land Area (units not specified in file)": 1.291,
    "Lease Term": 10,
    "Annual Lease Fee": 0.03,
    "Land Use Premium": null,
    "Number Of Local Employees": 500,
    "Number Of Foreign Employees": 9,
    Status: "Approved",
    "Investor Address":
      "ZHONGCUN,  CHENGYANG  STREET, CHENGYANG  DISTRICT, QINGDAO, SHANDONG, PEOPLE’S REPUBLIC OF CHINA 266109 ",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 64, MYAY  TAING  BLOCK  NO. 25, SHWE  LIN BAN SETHMU MYO,  HLAING THARYAR  TOWNSHIP, YANGON  REGION",
  },
  {
    ID: 1208,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Bai, Hong",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Sincerece Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "E-002/2017",
    "Permit Date": "2017-06-21T08:28:46Z",
    "Meeting Number": "8/2017",
    "Meeting Date": "2017-05-19T08:32:23Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment on CMP  Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.14,
    "Total Amount Of Capital (in Millions)": 2.14,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Soe Hlaing",
    "Land Area (units not specified in file)": 2.782,
    "Lease Term": 5,
    "Annual Lease Fee": 0.06,
    "Land Use Premium": null,
    "Number Of Local Employees": 1407,
    "Number Of Foreign Employees": 30,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.7, Gangwan Street, Dalian, Peoples Republic of China.",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No. 70, Myay Taing Block No. 14, Shwe Than Lwin Industrial Zone, Hlaingthayar Township, Yangon Region",
  },
  {
    ID: 1209,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Min Gaung Oo",
    "Name of Principal Organization": "Myanmar Synergy Garment Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Myanmar Synergy Garment Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "E-001/2017",
    "Permit Date": "2017-06-21T10:01:50Z",
    "Meeting Number": "8/2017",
    "Meeting Date": "2017-05-19T10:02:41Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENTS ON CMP BASIS ",
    "Amount Of Foreign Capital USD (in Millions)": 1.138,
    "Total Amount Of Capital (in Millions)": 2.276,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "U Eike Shan",
    "Land Area (units not specified in file)": 3.619,
    "Lease Term": 10,
    "Annual Lease Fee": 120,
    "Land Use Premium": null,
    "Number Of Local Employees": 2080,
    "Number Of Foreign Employees": 30,
    Status: "Approved",
    "Investor Address":
      "No.35/B, Shwe Taung Gyar Street, Shwe Taung Gyar (2) Quarter, Bahan Township, Yangon Region",
    "Organization Address":
      "PLOT NO. 18 & 19, MAY TAING  BLOCK NO. INDUSTRIAL ZONE (2), HLAING THAR YAR TOWNSHIP, YANGON REGION",
    "Investment Permitted Address":
      "PLOT NO. 18 & 19, MAY TAING  BLOCK NO. INDUSTRIAL ZONE (2), HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1210,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ma Sicheng",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "JABP JAIWEI MYANMAR GARMENTS LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "E039/2017",
    "Permit Date": "2017-08-20T10:26:08Z",
    "Meeting Number": "11/2017",
    "Meeting Date": "2017-08-07T10:30:25Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING  OF  GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.993,
    "Total Amount Of Capital (in Millions)": 1.993,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Khote Min @ U Maung Maung Myint",
    "Land Area (units not specified in file)": 3.004,
    "Lease Term": 20,
    "Annual Lease Fee": 0.06,
    "Land Use Premium": null,
    "Number Of Local Employees": 1100,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address":
      "Nan Jing Shi, Zhong Hua Lu 50 Hao, Guo Mao Da Xia 1012 Shi, China",
    "Organization Address": "-",
    "Investment Permitted Address":
      "\nPlot No(92/93)Matkhayar Minthargyi Maung Pyoe Street,Hlaing Thar Yar Industrial Zone 2., Hlaingtharyar, YANGON",
  },
  {
    ID: 1211,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kim Taeyong",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Kim So Young Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "E-043/2017",
    "Permit Date": "2017-08-20T11:02:56Z",
    "Meeting Number": "11/2017",
    "Meeting Date": "2017-08-07T11:03:26Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENTS ",
    "Amount Of Foreign Capital USD (in Millions)": 0.5,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 5,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaw Win, U Saw Win,  U Soe Win and Daw Ni Lar Aye",
    "Land Area (units not specified in file)": 2,
    "Lease Term": 5,
    "Annual Lease Fee": 0.11,
    "Land Use Premium": null,
    "Number Of Local Employees": 380,
    "Number Of Foreign Employees": 3,
    Status: "Approved",
    "Investor Address":
      "10, Singi-Gil, 57 Beon-Gil, Nam-Gu, Incheon , Republic of Korea",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 182/5, 182/7 , MYAY TAING BLOCK NO. 25, SHWE LIN BAN SETHMU MYO, HLAING THAR YAR TOWNSHIP, YANGON REGION ",
  },
  {
    ID: 1212,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Li Zhongqiu",
    "Name of Principal Organization":
      "Inner Mongolia Eerduosi Resources Co., Ltd.",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "ERDOS (MYANMAR) KNITWEAR COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "E-018/2017",
    "Permit Date": "2017-07-14T11:39:17Z",
    "Meeting Number": "9/2017",
    "Meeting Date": "2017-06-16T11:39:41Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.118,
    "Total Amount Of Capital (in Millions)": 4.118,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Pyae Sone Win Aung Services Co., Ltd.",
    "Land Area (units not specified in file)": 3.3,
    "Lease Term": 10,
    "Annual Lease Fee": 0.032,
    "Land Use Premium": null,
    "Number Of Local Employees": 900,
    "Number Of Foreign Employees": 15,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.1, Qingfang St, Hantal, Dongsheng District City, Inner Mongolia, People's Republic of China",
    "Organization Address":
      "No.1, Qingfang St, Hantal, Dongsheng District City, Inner Mongolia, People's Republic of China",
    "Investment Permitted Address":
      "\nNo(458), Meethat kan Street, Shwe Lin pan Industrial Zone , Hlaingv Tharyar Township, Yangon., Hlaingtharyar, YANGON",
  },
  {
    ID: 1213,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yang Wei",
    "Name of Principal Organization":
      "Serendipity International Trading Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Suzhou Silk Fashion (Myanmar) Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1067/2016",
    "Permit Date": "2016-01-26T03:19:51Z",
    "Meeting Number": "1/2016",
    "Meeting Date": "2016-01-15T03:21:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.93,
    "Total Amount Of Capital (in Millions)": 1.93,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Fu Chan @ Sann Maung",
    "Land Area (units not specified in file)": 2.121,
    "Lease Term": 20,
    "Annual Lease Fee": 0.047,
    "Land Use Premium": null,
    "Number Of Local Employees": 1152,
    "Number Of Foreign Employees": 18,
    Status: "Monitoring Approved",
    "Investor Address":
      "Room 402, No. 86, Guihua Xincun, Zhuhui Road, Suzhou, Jiangsu, China",
    "Organization Address":
      "1503,15/F,Kwan Chart Tower, No.6 Tonnchy Road, Wan Chi, Hong Kong",
    "Investment Permitted Address":
      "Plot No. 501, Myay Taing Block No. Yalapa 25, Shwe Linn Ban Industrial Zone, Haling Tharyar Township, Yangon Region",
  },
  {
    ID: 1214,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Hachiya Akira",
    "Name of Principal Organization": "Hachiya Company Limited",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Myanmar Hachiya Paper Box Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1167/2016",
    "Permit Date": "2016-10-13T03:54:57Z",
    "Meeting Number": "18/2016",
    "Meeting Date": "2016-09-23T03:55:26Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Corrugated Carton Box and Beautification of Corrugated  Carton Box",
    "Amount Of Foreign Capital USD (in Millions)": 1.05,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Aye Wai",
    "Land Area (units not specified in file)": 1.643,
    "Lease Term": 10,
    "Annual Lease Fee": 0.027,
    "Land Use Premium": null,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address":
      "FUKUOKA, PREFECTURE  TAGAWA  OAZA  NATSUYOSHI 395-1, JAPAN",
    "Organization Address":
      "FUKUOKA, PREFECTURE TAGAWA OAZA NATSUYOSHI 395-1, JAPAN ",
    "Investment Permitted Address":
      "Plot No.98, Hlaing Thayar Industrial Zone-2, Hlaing Thayar Township , Yangon Region",
  },
  {
    ID: 1216,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Win Lwin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myat Mi Ba Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1145/2016",
    "Permit Date": "2016-03-24T03:49:18Z",
    "Meeting Number": "9/2016",
    "Meeting Date": "2016-03-11T03:49:39Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing and Marketing of Umbrella",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 2737,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "No. 3 Heavy Industry",
    "Land Area (units not specified in file)": 2.336,
    "Lease Term": 20,
    "Annual Lease Fee": 49.778,
    "Land Use Premium": null,
    "Number Of Local Employees": 43,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.98, Ground Floor, 50th Street, Puzuntaung Township, Yangon ",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 10/ka, 11/ka, 12,13, 17/ka-1, 22/kha-1, Myay Taing Block No. 31, Hlaing Township, Yangon Region (No.111 Myanmar Umbrella Industry ",
  },
  {
    ID: 1217,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Hu Xianzhong",
    "Name of Principal Organization": "ASAHI FAN (H.K) TRADING CO.,LTD.,",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "ASAHI FAN GARMENT (MYANMAR) COMPANY LIMITED\t",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "E-019/2017",
    "Permit Date": "2017-07-14T04:35:00Z",
    "Meeting Number": "9/12017",
    "Meeting Date": "2017-06-16T04:35:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.5,
    "Total Amount Of Capital (in Millions)": 2.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Khaing Yadanar Oo",
    "Land Area (units not specified in file)": null,
    "Lease Term": 10,
    "Annual Lease Fee": 0.05,
    "Land Use Premium": null,
    "Number Of Local Employees": 501,
    "Number Of Foreign Employees": 14,
    Status: "Monitoring Approved",
    "Investor Address":
      "1004 ROOM, 4 BUILDING, NO.35 MEILIN STREET, YUHUA DISTRICT, CHANG SHA CITY, HU NAN PROVINCE, PEOPLE’S REPUBLIC OF CHINA",
    "Organization Address":
      "UNIT A 5/F WING CHEONG COMMERCIAL BUILDING 19-25 JERVOIS STREET CENTRAL",
    "Investment Permitted Address":
      "Land No.24, Myay Taing Block No.112, East Dagon Industrial Zone, Dagon(east), YANGON",
  },
  {
    ID: 1218,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Moe Kyi",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Graceful Bamar Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "Ma Na Tha-1050/2015",
    "Permit Date": "2015-04-24T05:55:47Z",
    "Meeting Number": "6/2015",
    "Meeting Date": "2015-04-03T05:59:40Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 2033.32,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Aung Moe Kyi (Investor)",
    "Land Area (units not specified in file)": 3.672,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 89,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Building . 41(A), Room No.304, Sabai Street, Tharyar Gone Quarter, Mingalartaungnyunt Township, YANGON",
    "Organization Address": "",
    "Investment Permitted Address":
      "Building . 41(A), Room No.304, Sabai Street, Tharyar Gone Quarter, Mingalartaungnyunt Township, YANGON",
  },
  {
    ID: 1220,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Ko Ko Gyi @ U Soe Naing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Diamond Star Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1059/2015",
    "Permit Date": "2015-05-29T06:48:25Z",
    "Meeting Number": "9/2015",
    "Meeting Date": "2015-05-18T06:50:50Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      " the Development of the lease land under a BOT Contract for sub-lease to investors for carrying out production and commercial activities (Fertilizer, Wheat flour, Oilseeds crushing, processing of grains including rice, edible oils, specialty fats, suger, cogeneration of power)",
    "Amount Of Foreign Capital USD (in Millions)": 12.489,
    "Total Amount Of Capital (in Millions)": 37052.87,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "Myanma Port Authority ",
    "Land Area (units not specified in file)": 41.77,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": 626550000,
    "Number Of Local Employees": 111,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No. 126-a, Kabaraye Pagoda Road, Bahan Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No. 30 and 31, Thilawa Port Area, Kyout Tan Township, Yangon.",
  },
  {
    ID: 1222,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Tsai, Chung-Ming",
    "Name of Principal Organization":
      "Xiamen Smile Garment Industrial Co., Ltd.",
    "Place of Incorporation": "Republic of Seychelles",
    "Company Name In Myanmar": "Sewell Garment (Myanmar) Industrial Co., Ltd.",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1140/2016",
    "Permit Date": "2016-08-11T07:50:46Z",
    "Meeting Number": "14/2016",
    "Meeting Date": "2016-07-31T07:51:10Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.98,
    "Total Amount Of Capital (in Millions)": 2.98,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Seychelles",
    "Form Of Investment": "FDII",
    "Land Owner": "U Tha Toe Hein",
    "Land Area (units not specified in file)": 2.404,
    "Lease Term": 20,
    "Annual Lease Fee": 0.05,
    "Land Use Premium": null,
    "Number Of Local Employees": 1763,
    "Number Of Foreign Employees": 25,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.24, LN. 117, TIANMU   W  RD., BEITOU  DIST., TAIPEI  CITY  112,  TAIWAN",
    "Organization Address":
      "No.24, Lasperance, Providence Industrial Estate, Mahe Seychelles",
    "Investment Permitted Address":
      "Plot NO.17, Myay Taing Block No. 24, Ngwe Pin Lae Industrial Zone, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 1223,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw Win Ei Khine",
    "Name of Principal Organization": "Maple Trading Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Belle Maison Maple Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1314/2017",
    "Permit Date": "2017-08-10T08:01:37Z",
    "Meeting Number": "10/2017",
    "Meeting Date": "2017-07-11T08:02:03Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.29,
    "Total Amount Of Capital (in Millions)": 2.63,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "U Nan Win",
    "Land Area (units not specified in file)": 1.35,
    "Lease Term": 20,
    "Annual Lease Fee": 0.06,
    "Land Use Premium": null,
    "Number Of Local Employees": 1248,
    "Number Of Foreign Employees": 20,
    Status: "Approved",
    "Investor Address": "No. 210, U Wisara Road, Bahan Township, Yangon",
    "Organization Address": "No. 210, U Wisara Road, Bahan Township, Yangon",
    "Investment Permitted Address":
      "U Paing No.59, Kwin No. 1186, Tharyar Gone Kwin, Tharyar Gone Village Tract, Bago Township, Bago Region",
  },
  {
    ID: 1225,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Assaf Ben Rephael",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Noatex Starry Myanmar Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "E-044/2017",
    "Permit Date": "2017-08-20T08:38:41Z",
    "Meeting Number": "11/2017",
    "Meeting Date": "2017-08-07T08:39:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF SEWN PRODUCT ON CMP BASIS ",
    "Amount Of Foreign Capital USD (in Millions)": 1.76,
    "Total Amount Of Capital (in Millions)": 1.76,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myint Soe & U Kyaw Oo",
    "Land Area (units not specified in file)": 3.78,
    "Lease Term": 20,
    "Annual Lease Fee": 0.043,
    "Land Use Premium": null,
    "Number Of Local Employees": 405,
    "Number Of Foreign Employees": 13,
    Status: "Monitoring Approved",
    "Investor Address": "4 A, 12 SHIPYARD LANE, QUARRY BAY, Hong Kong",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 165, 181, MYAY TAING BLOCK NO. 25, SHWE LIN BAN SETHMU MYO, HLAING THAR YAR TOWNSHIP, YANGON REGION ",
  },
  {
    ID: 1227,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Thado Hein",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Heritage Property Development Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1077/2015",
    "Permit Date": "2015-08-31T09:07:47Z",
    "Meeting Number": "10/2015",
    "Meeting Date": "2015-06-06T09:08:23Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Construction & Leasing of Office and commercial buildings",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 18617,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Soe Marlar",
    "Land Area (units not specified in file)": 0.584,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 176,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "65-A, University Avenue Road, Shwe Taunggya(1) Ward, Bahan T/s, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No 95-A, Plot No 2/Nga 1 and 2/ Sa 1, Survey Plot No 31(Thamine). Kyeikwine Pagoda Road, Mayangone T/s,Yangon. ",
  },
  {
    ID: 1228,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Han Jianfeng",
    "Name of Principal Organization":
      "JIANGSU GUOTAI OVERSEAS TECHNICAL SERVICE CO.,LTD., ",
    "Place of Incorporation": "china",
    "Company Name In Myanmar": "U & G (Myanmar) Fashion Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1368/2017",
    "Permit Date": "2017-05-09T09:30:32Z",
    "Meeting Number": "6/2017",
    "Meeting Date": "2017-04-05T09:40:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.64,
    "Total Amount Of Capital (in Millions)": 2.64,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Wai Wai Htwe",
    "Land Area (units not specified in file)": 4.35,
    "Lease Term": 50,
    "Annual Lease Fee": 0.019,
    "Land Use Premium": null,
    "Number Of Local Employees": 900,
    "Number Of Foreign Employees": 30,
    Status: "Submitted",
    "Investor Address":
      "NO.101, BUILDING 6, DONGDU HUAYUAN, ZHANHJIAGANG JIANGSU, PEOPLE’S REPUBLIC OF CHINA",
    "Organization Address":
      "ROOM 308, JINBI MANSION, BEIJING  ROAD, ZHANGJIAGANG FREE TRADE ZONE, PEOPLE’S REPUBLIC OF CHINA           ",
    "Investment Permitted Address":
      "PLOT NO. 140,  MYAY TAING BLOCK NO.49, WARTAYAR INDUSTRIAL ZONE, SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1229,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyaw Lwin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Grand Andaman Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1062/2015",
    "Permit Date": "2015-06-28T10:47:11Z",
    "Meeting Number": "10/2015",
    "Meeting Date": "2015-06-05T10:47:49Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 25000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "Ministry of Hotel and Tourism",
    "Land Area (units not specified in file)": 1800,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 125,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.280, Padout Street, Anawar Quarter, Kawthoung Township, Tanintharyee Region, Myanmar",
    "Organization Address": "",
    "Investment Permitted Address":
      "Thahtay Island (Pulolu Island), Kawthoung Township, Taintharyee Region.",
  },
  {
    ID: 1230,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Myint Myint Aye",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Above & Beyond Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "017/2017",
    "Permit Date": "2017-07-14T03:11:51Z",
    "Meeting Number": "9/2017",
    "Meeting Date": "2017-06-16T03:12:26Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.58,
    "Total Amount Of Capital (in Millions)": 863.22,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Htay Oo, U Tin Oo & U Myo Oo",
    "Land Area (units not specified in file)": null,
    "Lease Term": 10,
    "Annual Lease Fee": 60,
    "Land Use Premium": null,
    "Number Of Local Employees": 335,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 127, Third Floor, 7 Award, Lan Ma Daw Township, Yangon ",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 116/A, 116/B, Myay Taing Block No.42, Sett Hmu Area, Shwepyithar Township, Yangon Region.",
  },
  {
    ID: 1233,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Zhou, Yanping ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Jiu Sheng (Myanmar) Knitted Wear Co., Ltd.",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1137/2016",
    "Permit Date": "2016-07-23T03:44:23Z",
    "Meeting Number": "13/2016",
    "Meeting Date": "2016-07-08T03:44:46Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Knitted  Wear on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 8,
    "Total Amount Of Capital (in Millions)": 8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Tin Latt Min",
    "Land Area (units not specified in file)": 2.689,
    "Lease Term": 20,
    "Annual Lease Fee": 0.056,
    "Land Use Premium": null,
    "Number Of Local Employees": 1550,
    "Number Of Foreign Employees": 23,
    Status: "Monitoring Approved",
    "Investor Address":
      "Suite 103, NO.10, Lane 59, Xincun Road, Pudong New District, Shanghai City, Poeple's Republic of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.5+72+ 72, Myay Taing Block No.24, Ngwe Pin Lae Industrial Zone, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 1234,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကျော်ဝင်းအောင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ဒိုင်းမွန်းဒရက်ဂွန် ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "077/2018",
    "Permit Date": "2018-04-29T03:46:29Z",
    "Meeting Number": "5/2018",
    "Meeting Date": "2018-04-20T03:45:32Z",
    Sector: "Industrial Estate",
    "Type Of Investment Business": "မြန်မာနိုင်ငံသားရင်းနှီးမြှုပ်နှံမှု",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 34234.06,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒိုင်းမွန်းဒရက်ဂွန်ကုမ္ပဏီလီမိတက်",
    "Land Area (units not specified in file)": 0.826,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 166,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် (၈၉) ၊ ၅၀ လမ်း၊ အမှတ် (၁) ရပ်ကွက်၊ ပုဇွန်တောင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်- (၁၉၀/က)၊ မြေတိုင်းရပ်ကွက်အမှတ်-၂၃၊(စက်မှုဇုန်)၊ ဒဂုံမြို့သစ်တောင်ပိုင်းမြို့နယ်၊ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1235,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Tint Naing Htun",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Meik Ta  Aung Co., Ltd.",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1229/2016",
    "Permit Date": "2016-12-23T04:17:03Z",
    "Meeting Number": "23/2016",
    "Meeting Date": "2016-12-17T04:17:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1116.17,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Tint Naing Htun and Daw Aye Myat Myat Khaing",
    "Land Area (units not specified in file)": 2.341,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 500,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 5, Room No. 10, Third\nFloor, Hnin Si Street,\nTharyargone Ward, Mingalar\nTaungnyunt Township, Yangon\nRegion.",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No 53 , Myay Taing Block No.144, Industrial Zone, South Dagon Myothit  Township, Yangon Region",
  },
  {
    ID: 1237,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဖူရှင်းတိုးဘက်ကိုးအင်ဒပ်စထရီယယ်(လ်) လီမိတက်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": " ဖူရှင်း တိုဘက်ကိုး အင်ဒပ်စထရီယယ်(လ်) လီမိတက်",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "E095/2018",
    "Permit Date": "2018-04-29T06:32:35Z",
    "Meeting Number": "5/2018",
    "Meeting Date": "2018-04-20T06:32:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "စီးကရက်ထုတ်လုပ်တင်ပို့ရောင်းချခြင်းလုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": 4.076,
    "Total Amount Of Capital (in Millions)": 12985.9,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအိုင်ထွန်းနှင့် ဒေါ်နန်းခင်ညွန့်",
    "Land Area (units not specified in file)": 2.898,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 79,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၁၃၊ ဗိုလ်အောင်ကျော်လမ်း၊ လှိုင်သာယာစက်မှုဇုန် ၄၊ လှိုင်သာယာ မြို့နယ်၊ ရန်ကုန်မြို့       ",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ် ၁၃၊ ဗိုလ်အောင်ကျော်လမ်း၊ လှိုင်သာယာစက်မှုဇုန် ၄၊ လှိုင်သာယာ မြို့နယ်၊ ရန်ကုန်မြို့       ",
  },
  {
    ID: 1240,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS. ZHANG, ZUWEI ",
    "Name of Principal Organization": "VETEMENTS LLC",
    "Place of Incorporation": "Cook Islands",
    "Company Name In Myanmar": "AMBER  STONE  COMPANY  LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1065/2016",
    "Permit Date": "2016-01-26T08:10:05Z",
    "Meeting Number": "1/2016",
    "Meeting Date": "2016-01-15T08:10:29Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF GARMENTS (COSTUMES FOR CARTOON ACTORS/ ACTRESSES AND SPORTING CHARACTERS) ON CMP BASIS ",
    "Amount Of Foreign Capital USD (in Millions)": 1.15,
    "Total Amount Of Capital (in Millions)": 1.15,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Cook Islands",
    "Form Of Investment": "FDII",
    "Land Owner": "U Soe Myint and U Myint Thein",
    "Land Area (units not specified in file)": 1.481,
    "Lease Term": 10,
    "Annual Lease Fee": 0.0314,
    "Land Use Premium": null,
    "Number Of Local Employees": 515,
    "Number Of Foreign Employees": 16,
    Status: "Monitoring Approved",
    "Investor Address":
      "18D, ZIYUN BLDG, LANE 800, ZHONGSHAN WEST ROAD, CHANGNING, SHANHAI, CHINA",
    "Organization Address":
      "FIRST FLOOR, BCI HOUSE, AVARUA, RAROTONGA, COOK ISLANDS",
    "Investment Permitted Address":
      "PLOT NO. 48, HLAING THAR YAR INDUSTRIAL ZONE (2), HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1241,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr Hiroyuki Matsumoto",
    "Name of Principal Organization": "Mirait Technologies Corporation ",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Mirait Technologies Myanmar Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "070/2018",
    "Permit Date": "2018-03-27T09:14:22Z",
    "Meeting Number": "4/2018",
    "Meeting Date": "2018-03-20T09:14:55Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Telecom engineering services of telecommunication \tsystem  including design, construction and  maintenance of \tcommunication solutions ",
    "Amount Of Foreign Capital USD (in Millions)": 157.44,
    "Total Amount Of Capital (in Millions)": 157.44,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 39,
    "Number Of Foreign Employees": 17,
    Status: "Monitoring Approved",
    "Investor Address": "4-13-4, Shimorenjaku, Mitaka, Tokyo, 181-0013, Japan",
    "Organization Address": "3-3-15, Edobori, Nishi-ku, Osaka City, Japan",
    "Investment Permitted Address":
      "225, Room 201, Bo Aung Kyaw Road, Olampic Tower",
  },
  {
    ID: 1242,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. HSUEH,  CHUNG-KUN  ",
    "Name of Principal Organization": "LEGEND  TEAM INC ",
    "Place of Incorporation": "REPUBLIC OF SEYCHELLES ",
    "Company Name In Myanmar": "EMERALD FOOTWEAR MFG COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1064/2016",
    "Permit Date": "2016-01-26T09:23:51Z",
    "Meeting Number": "1/2016",
    "Meeting Date": "2016-01-15T09:24:52Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF ALL KINDS OF FOOTWEAR AND SEMI FOOTWEAR PRODUCTS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.32,
    "Total Amount Of Capital (in Millions)": 1.32,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Seychelles",
    "Form Of Investment": "FDII",
    "Land Owner": "U Maung Maung Hlaing",
    "Land Area (units not specified in file)": 1.137,
    "Lease Term": 10,
    "Annual Lease Fee": 0.029,
    "Land Use Premium": null,
    "Number Of Local Employees": 1067,
    "Number Of Foreign Employees": 35,
    Status: "Approved",
    "Investor Address":
      "B AREA OF RATTAN FACTORY, NO.22, BAN ZHANG LANE 1, BAO TUN DISTRICT, HOU JIE TOWN, DONG GUAN CITY, GUANGDONG PROVINCE, CHINA",
    "Organization Address":
      "1ST FLOOR, # 5 DEKK HOUSE, DE ZIPPORA STREET, PROVIDENCE INDUSTRIAL ESTATE, MAHE, REPUBLIC OF SEYCHELLES ",
    "Investment Permitted Address":
      "PLOT NO. 37, MYAY TAING BLOCK NO. 144, INDUSTRIAL ZONE, DAGON MYOTHIT (SOUTH) TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1243,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Managing Directior, Myanma Port Authory",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Sule Terminal Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1089/2015",
    "Permit Date": "2015-09-25T08:24:44Z",
    "Meeting Number": "16/2015",
    "Meeting Date": "2015-09-11T08:26:50Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business": "International Port",
    "Amount Of Foreign Capital USD (in Millions)": 77.66,
    "Total Amount Of Capital (in Millions)": 78438,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV,MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": 1.33,
    "Land Use Premium": null,
    "Number Of Local Employees": 144,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "NO.10, Pansodan Street, Kyauktada Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "NO.10, Pansodan Street, Kyauktada Township, Yangon",
  },
  {
    ID: 1244,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Min",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Global Mart Development Co., Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "074/2018",
    "Permit Date": "2018-04-29T10:00:58Z",
    "Meeting Number": "5/2018",
    "Meeting Date": "2018-04-20T10:01:14Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel service ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 10924.5,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "MEC",
    "Land Area (units not specified in file)": 0.704,
    "Lease Term": 20,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 146,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address":
      "No 3, Tosta Advenue, Thumingalar Housing, Thumingalar Street, Thingangyun T/s Yangon",
    "Organization Address": "",
    "Investment Permitted Address": "No.38, No 3 Street, Lanmadaw T/S, Yangon",
  },
  {
    ID: 1245,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyaw Win Aung",
    "Name of Principal Organization": "Diamond Dragon Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Diamond Dragon Co., Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "076/2018",
    "Permit Date": "2018-04-29T10:32:42Z",
    "Meeting Number": "5/2018",
    "Meeting Date": "2018-04-20T10:33:02Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of plastic products ",
    "Amount Of Foreign Capital USD (in Millions)": 2.94,
    "Total Amount Of Capital (in Millions)": 16773.98,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Diamond Dragon Co., Ltd.",
    "Land Area (units not specified in file)": 0.992,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 344,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 89, 50 Street, Ward No. 1, Pazundaung Township, Yangon.",
    "Organization Address":
      "Nga/34, Yaytamar Street, Bayintnaung, Mayangone Township, Yangon",
    "Investment Permitted Address":
      "Plot No. 192, 193, 194, 200, 201, 202, Myay Taing Block No. 23 Industrial Zone, Dagon Myothit (South), Yangon",
  },
  {
    ID: 1246,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Jonathan Myo Kyaw Thaung",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "KT Services & Logistics Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1152/2016",
    "Permit Date": "2016-03-24T03:31:51Z",
    "Meeting Number": "9/2016",
    "Meeting Date": "2016-03-11T04:13:06Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Port Services, management and related services",
    "Amount Of Foreign Capital USD (in Millions)": 52.6,
    "Total Amount Of Capital (in Millions)": 67245.47,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "Myanma Economic Holdings Company Limited",
    "Land Area (units not specified in file)": 10.452,
    "Lease Term": 50,
    "Annual Lease Fee": 3,
    "Land Use Premium": 1000000,
    "Number Of Local Employees": 443,
    "Number Of Foreign Employees": 4,
    Status: "Approved",
    "Investor Address":
      "No.91(I), Thanlwin Street, Shwetaungkyar (1)Quarter, Bahan Township, Yangon.",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.(A/4-A/5), Anawrahta Housing Complex, Pyay Road, Ward No.(2), Kamayut, YANGON",
  },
  {
    ID: 1248,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Managing Director, Myanma Textile Industries",
    "Name of Principal Organization": "Myanma Textile Industries",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Prime Industrial Limited",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "133/1995",
    "Permit Date": "1995-03-28T05:16:02Z",
    "Meeting Number": "3/95",
    "Meeting Date": "1995-02-27T05:16:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Garment Manufacturing",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 13.334,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 90,
    "Validity Of Investment Permit (in Years)": 5,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "Myanma Textile Industries",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "192, Kaba Aye Pagoda Road, Bahan Township, Yangon",
    "Organization Address": "192, Kaba Aye Pagoda Road, Bahan Township, Yangon",
    "Investment Permitted Address":
      "Garment Factory (1), Branch (2),  Thirimingalar Road, Insein Township, Yangon",
  },
  {
    ID: 1249,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Chief Executive, MNA",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar National Airlines Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1142/2016",
    "Permit Date": "2016-03-16T06:11:49Z",
    "Meeting Number": "6/2016",
    "Meeting Date": "2016-02-22T06:14:07Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Domestic and International Airline Services",
    "Amount Of Foreign Capital USD (in Millions)": 690.367,
    "Total Amount Of Capital (in Millions)": 813279.73,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Transport and Communications",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 1039,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No.104, Strand Road, Kyauktada Township, Yangon, Myanmar",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.104, Strand Road, Kyauktada Township, Yangon, Myanmar",
  },
  {
    ID: 1250,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Ye Min Aung",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Myanmar Agribusiness Public Corporation (MAPCO) Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1154/2016",
    "Permit Date": "2016-03-26T08:09:03Z",
    "Meeting Number": "10/2016",
    "Meeting Date": "2016-03-18T08:09:24Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Building and Operating a Multi-Purpose international wharf and Leasing relatives buildings with BOT System",
    "Amount Of Foreign Capital USD (in Millions)": 48.76,
    "Total Amount Of Capital (in Millions)": 93261.41,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "Myanma Port Authority",
    "Land Area (units not specified in file)": null,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 189,
    "Number Of Foreign Employees": 20,
    Status: "Approved",
    "Investor Address":
      "No.17, Mya Khwar Nyo 1st Street, Thaketa Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "NO(100), Wardan Street and Kan Nar Street , Beside the Concrete Express way , Wardan Port Area , Seikkan, YANGON",
  },
  {
    ID: 1251,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Khin Hla Hla",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "KAYTUMADI DEVELOPMENT PUBLIC COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1176/2016",
    "Permit Date": "2016-03-26T10:56:36Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T10:57:04Z",
    Sector: "Industrial Estate",
    "Type Of Investment Business": "Development  and Lease of Industrial Park ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 22753.18,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "KAYTUMADI DEVELOPMENT PUBLIC COMPANY LIMITED",
    "Land Area (units not specified in file)": 235.54,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 52,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No.57, Mya Yamone Street, San Yeikmyaing Housing, Lay Dount Kan Road, Dagon Myothit (South) Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "5th Floor, Sayarsan Plaza, Corner of New University Avenue & Sayarsan Street, Bahan, YANGON",
  },
  {
    ID: 1252,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Gu. Xuefeng ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Timbermar (Myanmar) Apparel Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1172/2016",
    "Permit Date": "2016-10-13T06:19:34Z",
    "Meeting Number": "18/2016",
    "Meeting Date": "2016-09-23T06:19:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.91,
    "Total Amount Of Capital (in Millions)": 0.91,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Khin Tun and Daw Yin Yin Htay",
    "Land Area (units not specified in file)": 2.304,
    "Lease Term": 10,
    "Annual Lease Fee": 0.156,
    "Land Use Premium": null,
    "Number Of Local Employees": 497,
    "Number Of Foreign Employees": 31,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 32, Zhixin Road, Chengdong Industry Park, Xiangshan Chan Ye Zone, Xiangshan Ningbo, Zhejiang, People's Republic of China",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No.274/275, Mingyi Maha Min Khaung Street, Shwe Lin Ban Industrial Zone, Hlaingtharyar  Township, Yangon Region",
  },
  {
    ID: 1253,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhang, Shizhe",
    "Name of Principal Organization": "Weihai Dishang Aihua Apparel Limited",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Dishang Fashion (Myanmar) Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1186/2016",
    "Permit Date": "2016-11-11T07:33:10Z",
    "Meeting Number": "20/2016",
    "Meeting Date": "2016-10-28T07:33:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.64,
    "Total Amount Of Capital (in Millions)": 1.64,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner":
      "Chaw Chaing (a) U Kyaw Tint and Tan Swan Ke (a) Maung Aung Tun",
    "Land Area (units not specified in file)": 2.286,
    "Lease Term": 20,
    "Annual Lease Fee": 0.05,
    "Land Use Premium": null,
    "Number Of Local Employees": 1110,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address":
      "5 A, Building 1.6, Tian Fa Tower, Tian An Cyber Park, Futian, Shenzhen City, Guangdong Province, People's Republic of China",
    "Organization Address":
      "No.220-3, Huoju Road, High Tech Zone, Weihai City, People's Republic of China",
    "Investment Permitted Address":
      "Plot No.95+96/ Kha, Myay Taing Block No.14, Mingyi Mahar Min Kaung Street, Shwe Thanlwin Industrial Zone, Hlaing Tharyar Township, Yangon, Hlaingtharyar, Yangon.",
  },
  {
    ID: 1254,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Myat Thu",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "GA MONE PWINT COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "MaNaTha-1235/2017",
    "Permit Date": "2017-02-04T07:50:26Z",
    "Meeting Number": "2/2017",
    "Meeting Date": "2017-01-21T07:51:04Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Leasing of Shopping Mall, Office Towers and Hotel on BOT System ",
    "Amount Of Foreign Capital USD (in Millions)": 19.728,
    "Total Amount Of Capital (in Millions)": 142985.384,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "Yangon City Development Committee",
    "Land Area (units not specified in file)": 8.518,
    "Lease Term": 50,
    "Annual Lease Fee": 3.14172,
    "Land Use Premium": 10221600,
    "Number Of Local Employees": 233,
    "Number Of Foreign Employees": 2,
    Status: "Approved",
    "Investor Address":
      "Room 308, No.25, Damazadi Street, Sanchaung Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "245,Bargayar Road, Myaynigone, , Sanchaung, YANGON",
  },
  {
    ID: 1255,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. MARC PETER RUDOLF VON ROHR",
    "Name of Principal Organization": "FRONTIER PACKAGING LIMITED  ",
    "Place of Incorporation": "Marshall Islands",
    "Company Name In Myanmar": "MM INTERPLAST COMPANY LIMITED\t",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "890/2015",
    "Permit Date": "2015-01-21T07:53:47Z",
    "Meeting Number": "1/2015",
    "Meeting Date": "2015-01-16T07:54:47Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING  OF PET PREFORMS PRODUCTS    ",
    "Amount Of Foreign Capital USD (in Millions)": 2.249,
    "Total Amount Of Capital (in Millions)": 4.499,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Marshall Islands",
    "Form Of Investment": "JV",
    "Land Owner": "U Kyaw Wai @ San Wai Hwar",
    "Land Area (units not specified in file)": 4.001,
    "Lease Term": 30,
    "Annual Lease Fee": 0.016,
    "Land Use Premium": null,
    "Number Of Local Employees": 74,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address": "PUNTESTRASSE 15, 8104 WEININGEN, SWITZERLAND   ",
    "Organization Address":
      "TRUST COMPANY COMPLEX, AJELTAKE ROAD, AJELTAKE ISLAND, MAJURO, REPUBLIC OF THE MARSHALL ISLAND MH 96960",
    "Investment Permitted Address":
      "PLOT NO 120,121,  MYAY TAIANG BLOCK NO 14 , SHWE THANLWIN INDUSTRIAL ZONE, HLAING THARYAR TOWNSHIP, YANGON REGION        ",
  },
  {
    ID: 1256,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Lin Chunyan",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar Allin Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1175/2016",
    "Permit Date": "2016-10-24T08:02:52Z",
    "Meeting Number": "19/2016",
    "Meeting Date": "2016-10-07T08:03:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of knitted and cut pieces knitted wear on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.26,
    "Total Amount Of Capital (in Millions)": 1.26,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Chaw Chaing (a) U Kyaw Tint and Tan Swan Ke (a) U  Aung Tun",
    "Land Area (units not specified in file)": 1.299,
    "Lease Term": 20,
    "Annual Lease Fee": 0.029,
    "Land Use Premium": null,
    "Number Of Local Employees": 919,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address":
      "RM 1001, Haigang Building, No. 9th North of Haibin Road, Weihai, People's Republic of China.",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No.95+96/Ka, Myay Taing Bock No.14, Mingyi Mahar Mingaung Street, Shwe Thanlwin Industrial Zone ,Hlaing Thar Yar Township, Yangon., Hlaingtharyar, Yangon Region.",
  },
  {
    ID: 1258,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhang, Shizhe",
    "Name of Principal Organization": "Weihai Dishang Aihua Apparel Limited",
    "Place of Incorporation": "People's Republic of China",
    "Company Name In Myanmar":
      "Dishang Kenny (Myanmar) Garment Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1174/2016",
    "Permit Date": "2016-10-21T08:22:29Z",
    "Meeting Number": "19/2016",
    "Meeting Date": "2016-10-07T08:23:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.75,
    "Total Amount Of Capital (in Millions)": 0.75,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Chaw Chaing (a) U Kyaw Tint and Tan Swan Ke (a) U Aung Tun",
    "Land Area (units not specified in file)": 1.299,
    "Lease Term": 20,
    "Annual Lease Fee": 0.029,
    "Land Use Premium": null,
    "Number Of Local Employees": 653,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 122, Jianshe Street, Huancui District, Weihai City, Shandong Province, People's Republic of China.",
    "Organization Address":
      "No.220-3, Huoju Road, High Tech Zone, Weihai City, People's Republic of China",
    "Investment Permitted Address":
      "Plot No.95+96/ Ka, Myay Taing Block No.14, Mingyi Mahar Min Kaung Street, Shwe Thanlwin Industrial Zone, Hlaing Tharyar Township, Yangon, Hlaingtharyar, Yangon.",
  },
  {
    ID: 1259,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhang, Ke",
    "Name of Principal Organization": "Jiansu Holly Corporation",
    "Place of Incorporation": "People's Republic of China",
    "Company Name In Myanmar":
      "Jiangsu Holly (Myanmar) Industry Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1176/2016",
    "Permit Date": "2016-10-24T08:48:53Z",
    "Meeting Number": "19/2016",
    "Meeting Date": "2016-10-07T08:49:03Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.98,
    "Total Amount Of Capital (in Millions)": 2.98,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 12,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Gan Soon Sein @ Maung Win Myint",
    "Land Area (units not specified in file)": 3.073,
    "Lease Term": 12,
    "Annual Lease Fee": 0.007,
    "Land Use Premium": null,
    "Number Of Local Employees": 1500,
    "Number Of Foreign Employees": 30,
    Status: "Monitoring Approved",
    "Investor Address":
      "Room 402, BLD, 16, 1st Gongjiao Garden Xuan Wu District, Nanjin City, Jiangsu, People's Republic of China.",
    "Organization Address":
      "12 F, Holly Building, 50 Zhonghua Road, Nanjing, People's Republic of China.",
    "Investment Permitted Address":
      "Plot No. 26, Myay Taing Block No. 51, Thardu Kan Industrial Zone, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 1260,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U NAY HTUN MIN",
    "Name of Principal Organization": "TWO TRIANGLE CO.,LTD",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "NAWARAT  ADVANCE PREFAB  MYANMAR COMPANY  LIMITED\t",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1258/2017",
    "Permit Date": "2017-04-11T09:22:44Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T09:23:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "PRODUCTION AND SALE OF PREFAB CONCRETE",
    "Amount Of Foreign Capital USD (in Millions)": 1.4,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "U Kyin Sheik ",
    "Land Area (units not specified in file)": 1.914,
    "Lease Term": 30,
    "Annual Lease Fee": 0.035,
    "Land Use Premium": null,
    "Number Of Local Employees": 57,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.25/19, U WISARA HOUSING COMPLEX, DAGON TOWNSHIP, YANGON",
    "Organization Address":
      "NO.607, MAHABANDOOLA STREET, WARD NO.36, DAGON MYOTHIT (NORTH)  TOWNSHIP, YANGON REGION",
    "Investment Permitted Address":
      "PLOT NO. 50, INDUSTRIAL ZONE 1, DAGON (SEIK KAN) TOWNSHIP, YANGON  REGION",
  },
  {
    ID: 1262,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Maung Kyee @ Ti Kar Kyae",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Resources Group Logistics Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "MaNaTha-1238/2017",
    "Permit Date": "2017-04-11T09:21:26Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-04-11T09:21:46Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business": "Dry Port Services",
    "Amount Of Foreign Capital USD (in Millions)": 5.549,
    "Total Amount Of Capital (in Millions)": 32757.294,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "Myanma Railways, Ministry of Transport and Communications",
    "Land Area (units not specified in file)": 40,
    "Lease Term": 50,
    "Annual Lease Fee": 0.22,
    "Land Use Premium": 1049907,
    "Number Of Local Employees": 126,
    "Number Of Foreign Employees": 3,
    Status: "Approved",
    "Investor Address":
      "No. C4, Mon Myat Myattar Housing, Pin Shwe Naung Street, Tamwe Kalay Quarter, Tamwe Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.(36), Thein Phyu Road, Pazuntaung Township, YANGON",
  },
  {
    ID: 1263,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyaw Win",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "KMI Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1166/2016",
    "Permit Date": "2016-03-26T04:06:48Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T04:08:28Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်အခေ ျာထည်၊ သစ်ခွဲသားအမျိုးမျိုး၊ သစ်ပါးလွှာအမျိုးမျိုး၊ သစ်သားတံခါးအမျိုးမျိုးနှင့် လျှာထိုး ထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 8.57,
    "Total Amount Of Capital (in Millions)": 13315.42,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Kyaw Win",
    "Land Area (units not specified in file)": 2.101,
    "Lease Term": 30,
    "Annual Lease Fee": 6,
    "Land Use Premium": null,
    "Number Of Local Employees": 191,
    "Number Of Foreign Employees": 11,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၂၃)၊ ခေမာသီ(၁)လမ်း၊ မိကေ ျာင်းကန်အပိုင်း(၃)ရပ်ကွက်၊ သင်္ကန်းကျွန်းမြို့နယ်",
    "Organization Address": "",
    "Investment Permitted Address":
      "No(185), Pan Tin Wun U Shwe Bin Street, Industrial Part (1), Dagon East Industrial Zone, , Dagon(east), YANGON",
  },
  {
    ID: 1264,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Maung Kyee@ Ti Kar Kyae",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "RESOURCES GROUP LOGISTICS COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "MaNaTha-1239/2017",
    "Permit Date": "2017-04-11T06:10:02Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T06:10:15Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business": "Dry Port Services",
    "Amount Of Foreign Capital USD (in Millions)": 3.996,
    "Total Amount Of Capital (in Millions)": 33417.935,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "Myanma Railways, Ministry of Transport and Communications",
    "Land Area (units not specified in file)": 32.426,
    "Lease Term": 50,
    "Annual Lease Fee": 0.178,
    "Land Use Premium": 851106.95,
    "Number Of Local Employees": 123,
    "Number Of Foreign Employees": 2,
    Status: "Approved",
    "Investor Address":
      "No.C4, Mon Myat Myattar Housing, Pin Shwe Naung Street, Tamwe Kalay, Tamwe Township, Yangon.",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.(36), Thein Phyu Road, Pazuntaung Township, YANGON",
  },
  {
    ID: 1265,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Brighter Energy Company Limited",
    "Name of Principal Organization": "Brighter Energy Company Limited",
    "Place of Incorporation": "Myanmar ",
    "Company Name In Myanmar": "Brighter Energy Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "079/2018",
    "Permit Date": "2018-04-29T06:30:46Z",
    "Meeting Number": "5/2018",
    "Meeting Date": "2018-04-20T06:30:26Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Importation, Storage, Distribution and Sales of LPG, Gasoline and Diesel",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 200310,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "Myanma Economic Corporation (MEC)",
    "Land Area (units not specified in file)": 168.5,
    "Lease Term": 50,
    "Annual Lease Fee": 808800,
    "Land Use Premium": 1685000,
    "Number Of Local Employees": 79,
    "Number Of Foreign Employees": null,
    Status: "Amend",
    "Investor Address":
      "no. 64, Bayin Naung Road, Thiri Mon Housing, Ward 15, Hlaing Township, Yangon.",
    "Organization Address":
      "no. 64, Bayin Naung Road, Thiri Mon Housing, Ward 15, Hlaing Township, Yangon.",
    "Investment Permitted Address":
      "Thinbaw Phyat Plant(Thilawa),\nThidar Myaing Ward, Kyauk Tan Township, Yangon \n",
  },
  {
    ID: 1266,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. CHATPON ATSAWAPRASERTSRI ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "MITRON    MM     COMPANY      LIMITED\t",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "927/2015",
    "Permit Date": "2015-04-24T07:42:15Z",
    "Meeting Number": "5/2015",
    "Meeting Date": "2015-03-20T07:42:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "PRODUCTION  AND  SALES   OF   CD,  DVD,  BLU - RAY   DICS  ",
    "Amount Of Foreign Capital USD (in Millions)": 0.454,
    "Total Amount Of Capital (in Millions)": 0.567,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Dwam Sauk Lyin, Daw Yan Hasing Phine ",
    "Land Area (units not specified in file)": 2,
    "Lease Term": 5,
    "Annual Lease Fee": 48,
    "Land Use Premium": null,
    "Number Of Local Employees": 19,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "10    SOI    THAKHAM    28    YEAK,  4-4    SAMDAM, BANGKHUNTHIAN,  BANGKOK  10150,  THAILAND",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No. 470 (A-1), Block 23, Industrial Zone 1, Dagon(south), Yangon",
  },
  {
    ID: 1267,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. AEK  LOKITIYAKUL ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "GEO   ELECTRIC   (MYANMAR)   COMPANY    LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "943/2015",
    "Permit Date": "2015-05-07T08:05:30Z",
    "Meeting Number": "6/2015",
    "Meeting Date": "2015-04-03T08:05:39Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Electric Fans",
    "Amount Of Foreign Capital USD (in Millions)": 0.5,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Thailand",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myint Shwe & Daw Khin San Kyu ",
    "Land Area (units not specified in file)": 0.86,
    "Lease Term": 10,
    "Annual Lease Fee": 0.096,
    "Land Use Premium": null,
    "Number Of Local Employees": 19,
    "Number Of Foreign Employees": 6,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.  916/279   RAMA   3   ROAD, BANG PHONG PANG,  YANNAWA,  BANGKOK 10120,  THAILAND",
    "Organization Address": "-",
    "Investment Permitted Address":
      "\nNo(81), U Phoe Hlaing Street & Industrial Region Corner,Shwe Pyi Thar Industrial Zone (2), Yangon, Shwepyithar, Yangon.",
  },
  {
    ID: 1268,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. WU Chung Kong",
    "Name of Principal Organization": "Full Reward Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar":
      "GREAT LUCKY STAR GARMENT MANUFACTURING COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "960/2015",
    "Permit Date": "2015-05-29T09:15:03Z",
    "Meeting Number": "9/2015",
    "Meeting Date": "2015-05-18T09:15:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Gloves on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.656,
    "Total Amount Of Capital (in Millions)": 0.95,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Kyaing",
    "Land Area (units not specified in file)": 0.491,
    "Lease Term": 30,
    "Annual Lease Fee": 0.038,
    "Land Use Premium": null,
    "Number Of Local Employees": 290,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address":
      "Flat F.26/F, Block 3, Grand Horizon, Tsing Yi, N.T, Hong Kong",
    "Organization Address":
      "Room No.110-112, 1st Floor, Hewlett Centre, No.54 Hoi Yuen Road, Kwun Tong, Kowloon, Hong Kong.",
    "Investment Permitted Address":
      "\nPlot No.(24+25),Myay Taing No.24, Set Mu Road, Shwe Pyi Thar Industrial Zone (1), Shwe Pyi Thar Township, Yangon, Shwepyithar, Yangon. ",
  },
  {
    ID: 1270,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Zarni Maung",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Regal  Hotel Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "MaNaTha-966/2014",
    "Permit Date": "2014-02-17T03:41:50Z",
    "Meeting Number": "4/2014",
    "Meeting Date": "2014-01-31T03:41:34Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 2603.97,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Regal Hotel Co., Ltd.",
    "Land Area (units not specified in file)": 0.31,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 199,
    "Number Of Foreign Employees": 7,
    Status: "Approved",
    "Investor Address":
      "No-35 , Tharthanarthyeathar Street, Bahan Township, Yangon.",
    "Organization Address": "",
    "Investment Permitted Address":
      "No-116 D , Thirimingalar Street, Pyay Road, Mayangone Township, Yangon.",
  },
  {
    ID: 1272,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhang Wujun",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Yangon City Red Sun Co.,Ltd ",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1101/2016",
    "Permit Date": "2016-03-26T05:20:41Z",
    "Meeting Number": "9/2016",
    "Meeting Date": "2016-03-11T05:21:24Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Various Kinds of Steamed Wood Products",
    "Amount Of Foreign Capital USD (in Millions)": 2.6,
    "Total Amount Of Capital (in Millions)": 2.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw San San Aye",
    "Land Area (units not specified in file)": 2.324,
    "Lease Term": 50,
    "Annual Lease Fee": 0.047,
    "Land Use Premium": null,
    "Number Of Local Employees": 35,
    "Number Of Foreign Employees": 6,
    Status: "Monitoring Approved",
    "Investor Address":
      "Henan Xing Yang City Wang Cwe, Zhen Wang Cwe, People's Republic of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "No (TH-1),Malikha Housing,Nguwar(4)Street., Thingangyun, YANGON",
  },
  {
    ID: 1273,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw Su Su Tin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Yangon Excelsior Co., Ltd. ",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1092/2016",
    "Permit Date": "2016-02-29T05:38:52Z",
    "Meeting Number": "4/2016",
    "Meeting Date": "2016-02-05T05:32:57Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Service",
    "Amount Of Foreign Capital USD (in Millions)": 7.98,
    "Total Amount Of Capital (in Millions)": 11.4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Yangon Region Government ",
    "Land Area (units not specified in file)": null,
    "Lease Term": 50,
    "Annual Lease Fee": 0.4,
    "Land Use Premium": 1300000,
    "Number Of Local Employees": 199,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address": "12, Nagayone Pagoda Road, Mayangone T/S, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "FOUR - STOREY BUILDING  NO. (19/43), BOSONPAT STREET, PABEDAN TOWNSHIP , YANGON REGION ",
  },
  {
    ID: 1274,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw Khin Mya Swe",
    "Name of Principal Organization": "Y N J Engineering Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "First Fortune International Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "006/2017",
    "Permit Date": "2017-07-17T04:05:39Z",
    "Meeting Number": "9/2017",
    "Meeting Date": "2017-06-16T04:06:13Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "fabricating, installation and marketing of value added steel products and wire mesh products  ",
    "Amount Of Foreign Capital USD (in Millions)": 18.153,
    "Total Amount Of Capital (in Millions)": 22.692,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 11,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Khin Mya Swe, Daw Naw Lar May War, U Min Zayya  ",
    "Land Area (units not specified in file)": 7.24,
    "Lease Term": 50,
    "Annual Lease Fee": 0.13,
    "Land Use Premium": null,
    "Number Of Local Employees": 119,
    "Number Of Foreign Employees": 1,
    Status: "Submitted",
    "Investor Address":
      "Room No. 36, Building No. 5, Punhlaing Avenue, Kyimyindaing Township, Yangon",
    "Organization Address":
      "No. 26/27,6 th street, Mingalardon Industrial Zone, Extension (1), Mingalardon Township, Yangon",
    "Investment Permitted Address":
      "No. (187/188/194), Pantinwun U Phoe Thin Street, Industrial Zone Part (1) 113, Dagon Myothit (Eastern) Township, Yangon Region, Myanmar. , Dagon(east), YANGON",
  },
  {
    ID: 1278,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Tun Lwin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "MYANMA AGRICULTURAL & GENERAL DEVELOPMENT PUBLIC LIMITED.(MAGDPL)",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1153/2016",
    "Permit Date": "2016-03-26T08:13:07Z",
    "Meeting Number": "6/2016",
    "Meeting Date": "2016-02-22T08:13:51Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Building and Operating a Multi-Purpose international wharf and Leasing relatives buildings.  ",
    "Amount Of Foreign Capital USD (in Millions)": 28.4342,
    "Total Amount Of Capital (in Millions)": 54452.73,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "Myanma Port Authority",
    "Land Area (units not specified in file)": 37.06,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": 555900000,
    "Number Of Local Employees": 78,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No. 758,787, 11th floor, Between 13rd Street and Maharbandula Road, Lammadaw Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Shwe Zabu River View Complex,23 G-1,No.3B(Tower A-C),Ground Floor,Strand Road, Ahlone Township, YANGON",
  },
  {
    ID: 1279,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးသန်းညွန့်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Aung Oo Wood Industry Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1151/2016",
    "Permit Date": "2016-03-26T08:33:22Z",
    "Meeting Number": "9/2016",
    "Meeting Date": "2016-03-11T08:34:39Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ရာဘာပင်အိုသစ်များအား လေးဘက်ချောသစ်အဖြစ် ထုတ်လုပ်ခြင်းနှင့် ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.51,
    "Total Amount Of Capital (in Millions)": 1106.805,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးသန်းညွန့်",
    "Land Area (units not specified in file)": 3.03,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 69,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၃၇၊ ပထမထပ်၊ (၈)လမ်း၊ (၃) ရပ်ကွက်၊ လမ်းမတော်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "No. Za Kwe/357, Thudamar Street, Za Kwe Ward, , Lanmadaw, YANGON",
  },
  {
    ID: 1280,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်မေလင်းပိုင်(အဘ-ဦးထွန်းစိန်)",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ယူနိုက်တက်ပရီဆိုက်စ် ကုမ္ပဏီလီမိတက်(United Precise Company Limited)\t",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "၁၂၂၁/၂၀၁၆",
    "Permit Date": "2016-11-11T08:54:03Z",
    "Meeting Number": "၂၀/၂၀၁၆",
    "Meeting Date": "2016-10-28T08:55:04Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် Post Bar နှင့် Signboard  Frame ပုံစံအရွယ်အစားမျိုးစုံထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.061,
    "Total Amount Of Capital (in Millions)": 117,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "ဦးအင်စေပါ့ခ်(ခ)ဦးမောင်စိန်၊ လင်(မ်)တိုက်ဟောင်(ခ)တိတ်ဟောင်၊ လူငန်ဟိန်(ခ)မခင်ဝင်း ",
    "Land Area (units not specified in file)": 0.178,
    "Lease Term": 10,
    "Annual Lease Fee": 9.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 41,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၄၇၄)၊ အင်းတော်လမ်း၊ ၆၄ရပ်ကွက်၊ ဒဂုံမြို့သစ်(တောင်ပိုင်း) မြို့နယ်၊ ရန်ကုန်မြို့ ",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ ဒဂုံမြို့သစ် (တောင်ပိုင်း)မြို့နယ်၊  စက်မှုဇုန်၊ မြေတိုင်းရပ်ကွက် အမှတ် - ၆၄ ၊ မြေကွက်အမှတ် - ၁၀၂၊ ၁၀၃၊ ၁၀၄ ရှိ မြေဧရိယာ ၀.၁၇၈ ဧက ",
  },
  {
    ID: 1281,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Myint Myat Thu",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Jade Marina Resort Hotel Co., Ltd.",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1140/2016",
    "Permit Date": "2016-03-21T09:30:02Z",
    "Meeting Number": "7/2016",
    "Meeting Date": "2016-02-26T09:31:52Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Service",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 7169,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 87,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address": "39(a), 7 1/2 mile, Pyay Road, Mayangone, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "39(a), 7 1/2 mile, Pyay Road, Mayangone, Yangon",
  },
  {
    ID: 1282,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Hla Wai",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myat Min Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "MaNaTha-981/2014",
    "Permit Date": "2014-04-28T09:41:23Z",
    "Meeting Number": "13/2014",
    "Meeting Date": "2016-04-26T09:41:02Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": 4.66,
    "Total Amount Of Capital (in Millions)": 12000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT",
    "Land Owner":
      "1.\tMinistry of Natural Resources and Environmental Conservation ",
    "Land Area (units not specified in file)": 11.58,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 159,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Number 31, Shwehinthar Road, 6 1/2 Miles,Hlaing Township",
    "Organization Address": "",
    "Investment Permitted Address":
      "Number 31, Shwehinthar Road, 6-Miles,Hlaing Township",
  },
  {
    ID: 1285,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်နန်းသန်းထွေး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Shwe Kanbawza Company Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "MaNaTha- 1043/2015",
    "Permit Date": "2015-03-17T04:12:16Z",
    "Meeting Number": "3/2015",
    "Meeting Date": "2015-02-27T04:12:55Z",
    Sector: "Agriculture",
    "Type Of Investment Business":
      "ဆီအုန်း စိုက်ပျိုးခြင်းနှင့် ဆီကြမ်း၊ ဆီချောထုတ်လုပ် ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 49.38,
    "Total Amount Of Capital (in Millions)": 48776.49,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 27682,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 148,
    "Number Of Foreign Employees": 10,
    Status: "Approved",
    "Investor Address": "အမှတ်-၆၁၅/၂၊ ပြည်လမ်း၊ ကမာရွက်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "No (193), Avenue 1st Street, Waizayantar Garden Housing, Migyaungkan Ward (1) , Thingangyun, YANGON",
  },
  {
    ID: 1286,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "ဦးမြင့်သိန်း",
    "Name of Principal Organization":
      "ထွန်းမြင့်ထွန်း ကုမ္ပဏီလီမိတက်၊ အမှတ်-၅၃၊  ယောအတွင်းဝန် ဦးဖိုးလှိုင်လမ်း၊ ဒဂုံစက်မှုဇုန်၊ ဒဂုံအရှေ့ပိုင်းမြို့နယ်၊ ရန်ကုန်မြို့ ",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Lucky Tokyo Noodle Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1279/2017",
    "Permit Date": "2017-05-09T04:00:33Z",
    "Meeting Number": "6/2017",
    "Meeting Date": "2017-04-05T04:04:42Z",
    Sector: "",
    "Type Of Investment Business":
      "အသင့်စားခေါက်ဆွဲ ထုတ်လုပ်ဖြန့်ဖြူး ရောင်းချခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 4.37,
    "Total Amount Of Capital (in Millions)": 8.74,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "ဦးမြင့်သိန်း",
    "Land Area (units not specified in file)": 0.435,
    "Lease Term": 30,
    "Annual Lease Fee": 8775,
    "Land Use Premium": null,
    "Number Of Local Employees": 237,
    "Number Of Foreign Employees": 8,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် -၁၅/A၊ မင်းကျောင်းလမ်း၊ ဒဂုံမြို့နယ်၊ ရန်ကုန်မြို့ ",
    "Organization Address":
      " ယောအတွင်းဝန် ဦးဖိုးလှိုင်လမ်း၊ ဒဂုံစက်မှုဇုန်၊ ဒဂုံအရှေ့ပိုင်းမြို့နယ်၊ ရန်ကုန်မြို့ ",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၅၃၊ မြေတိုင်းရပ်ကွက်အမှတ်-၁၀၉၊  ဒဂုံစက်မှုဇုန်၊ ဒဂုံအရှေ့ပိုင်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး ",
  },
  {
    ID: 1288,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw Nan Yin",
    "Name of Principal Organization": "Vantage Co.,Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Myanmar Thai Rubber Joint Corporation Ltd",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "705/2014",
    "Permit Date": "2014-04-08T05:26:43Z",
    "Meeting Number": "10/2014",
    "Meeting Date": "2014-03-19T05:28:04Z",
    Sector: "Agriculture",
    "Type Of Investment Business":
      "Rubber Plantation, Processing Air Dried Sheet, Concentrated Latex and Other Value Added Products",
    "Amount Of Foreign Capital USD (in Millions)": 3.96,
    "Total Amount Of Capital (in Millions)": 5.625,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "Vantage Co.,Ltd.",
    "Land Area (units not specified in file)": 776.75,
    "Lease Term": 50,
    "Annual Lease Fee": 0.036,
    "Land Use Premium": null,
    "Number Of Local Employees": 171,
    "Number Of Foreign Employees": 12,
    Status: "Approved",
    "Investor Address": "No,80, Ground Floor, 50 Street, ",
    "Organization Address":
      "No.96(c), Lanthit Road, Nanthagone Quarter, Insein Township, Yangon",
    "Investment Permitted Address":
      "No.37,Bogyoke Road,(3)Ward., Mayangone, YANGON\n",
  },
  {
    ID: 1289,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Mehm Zayar Thaung",
    "Name of Principal Organization": "Integrated Technical Systems Co.,Ltd",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Veneer International Myanmar Co.,Ltd",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "915/2015",
    "Permit Date": "2015-03-19T06:35:29Z",
    "Meeting Number": "3/2015",
    "Meeting Date": "2015-02-27T06:38:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Veneer Products",
    "Amount Of Foreign Capital USD (in Millions)": 1.87,
    "Total Amount Of Capital (in Millions)": 2.87,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "ဦးအောင်ညွန့်+ ဦးဝင်းသန်းအောင်",
    "Land Area (units not specified in file)": 3.501,
    "Lease Term": 10,
    "Annual Lease Fee": 153960,
    "Land Use Premium": 10.86,
    "Number Of Local Employees": 87,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 221/223, 3 Floor(Left), Bo Aung Kyaw Street, Kyauktada Township, Yangon",
    "Organization Address":
      "8-A Khapaung Street, Martin Avenue, Hlaing Township, Yangon",
    "Investment Permitted Address":
      "Plot No.16, Corner of Thu Khi Thar Street and Mya Aye Yar Street, Dagon Seik Kan Industrial Zone (11), Dagon Myo Thit (Seikkan), Yangon",
  },
  {
    ID: 1290,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aye Tun ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Golden Han Tha Waddy Co., Ltd. ",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "Manatha 1128/2016",
    "Permit Date": "2016-03-05T07:29:53Z",
    "Meeting Number": "14/2015",
    "Meeting Date": "2015-08-07T07:17:15Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Airport Hotel with BOT System ",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 3359.09,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "Department of Civil Aviation ",
    "Land Area (units not specified in file)": 6,
    "Lease Term": 25,
    "Annual Lease Fee": null,
    "Land Use Premium": 3000000000,
    "Number Of Local Employees": 88,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 172, Pansoden (Up), Kan (North) quarter, Mingalar Taung Nyunt Tsp, Yangon ",
    "Organization Address": "",
    "Investment Permitted Address": "No.402, Strand Road., Latha, YANGON",
  },
  {
    ID: 1291,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Mr. Soe Moe Aye",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Cocoon Hotel Co., Ltd. ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "MaNaTha-1021/2015",
    "Permit Date": "2015-01-12T09:12:00Z",
    "Meeting Number": "29/2014",
    "Meeting Date": "2014-12-26T09:12:39Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 5067.38,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT",
    "Land Owner": "တနင်္သာရီတိုင်းဒေသကြီးအစိုးရအဖွဲ့",
    "Land Area (units not specified in file)": 17,
    "Lease Term": 50,
    "Annual Lease Fee": 68782,
    "Land Use Premium": 170000,
    "Number Of Local Employees": 60,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Number -22, Thityarpin Road, 23 Yard, Thuwanna , Thingandyun Township, Yangon.",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ် ၁၈ ၊ ဗောဓိရိပ်သာလမ်း၊ ရွှေတောင်ကြား (၂)ရပ်ကွက်၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်",
  },
  {
    ID: 1292,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Gerard Van Arendonk",
    "Name of Principal Organization":
      "Societe Industrielle Agricole ET Commerciale D' Outre Mer",
    "Place of Incorporation": "France",
    "Company Name In Myanmar": "Shwe Zabar Co.,Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "624/2013",
    "Permit Date": "2013-09-18T08:55:58Z",
    "Meeting Number": "17/2013",
    "Meeting Date": "2013-06-29T08:57:27Z",
    Sector: "Agriculture",
    "Type Of Investment Business":
      "Rice Milling and Processing including parboiling, polishing and sorting Rice plant and other Agriculture business",
    "Amount Of Foreign Capital USD (in Millions)": 4.74,
    "Total Amount Of Capital (in Millions)": 4962.889,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 30,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "ဦးတင်အောင်လတ်၊ ဦးတင်အောင်လေးနှင့် ဦးကျော်ဦး",
    "Land Area (units not specified in file)": 12.01,
    "Lease Term": 50,
    "Annual Lease Fee": 0.129,
    "Land Use Premium": null,
    "Number Of Local Employees": 68,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address": "Laie Aux Faucons 7, 1300 Waver Belgium",
    "Organization Address":
      " Zone Industrielle No.1 97420 Le Port/La Reunion, France",
    "Investment Permitted Address":
      "Nawarat Center, Room 402, No.186,52nd Street, Pazuntaung, YANGON",
  },
  {
    ID: 1293,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MRS. HSU, HUA-CHEN",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "TOUGH WAY GARMENT MANUFACTURING COMPANY LIMITED\t",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "941/2015",
    "Permit Date": "2015-05-07T03:06:12Z",
    "Meeting Number": "7/2015",
    "Meeting Date": "2015-04-28T03:06:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING  OF GARMENTS ON CMP BASIS   ",
    "Amount Of Foreign Capital USD (in Millions)": 0.4579,
    "Total Amount Of Capital (in Millions)": 0.5724,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "JV",
    "Land Owner": "U Myo Win and Daw Polly",
    "Land Area (units not specified in file)": 1.376,
    "Lease Term": 30,
    "Annual Lease Fee": 0.03,
    "Land Use Premium": null,
    "Number Of Local Employees": 520,
    "Number Of Foreign Employees": 15,
    Status: "Approved",
    "Investor Address":
      "NO. 5, ALY.2, LN.2, HUAGUANG RD, LUZHU DIST, KAOHSIUNG CITY 821, TAIWAN, REPUBLIC OF CHINA    ",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 52/KA, 52/KHA ,  MYAY TAING BLOCK NO. 42, KANAUNG MIN THAR GYI STREET, SHWE PYI THAR INDUSTRIAL ZONE, SHWE PYI THAR TOWNSHIP, YANGON REGION       ",
  },
  {
    ID: 1294,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. DONG HOON LEE",
    "Name of Principal Organization": "MUSUNG  CO., LTD., ",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "MUSUNG    GARMENT    COMPANY       LIMITED\t",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "978/2015",
    "Permit Date": "2015-07-10T03:05:40Z",
    "Meeting Number": "11/2015",
    "Meeting Date": "2015-06-19T03:05:56Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.16,
    "Total Amount Of Capital (in Millions)": 2.16,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Yan Win and U Kyaw Tint  ",
    "Land Area (units not specified in file)": 4.183,
    "Lease Term": 30,
    "Annual Lease Fee": 0.096,
    "Land Use Premium": null,
    "Number Of Local Employees": 1275,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address":
      "309-201, 177 MIGEUM-RO, BUNDANG-GU, GYEONGGI-GU, REPUBLIC OF  KOREA",
    "Organization Address":
      "4TH FLOOR, 2030-1 DAEHWA-DONG, ILSAN-GU, GOYANG-SI, KYUNGKI-DO, REPUBLIC OF  KOREA",
    "Investment Permitted Address":
      "No. 18, Bo Tay Za Street, Yangon Industrial Zone., Mingalardon, Yangon.",
  },
  {
    ID: 1295,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ramesh Kumar Malpani",
    "Name of Principal Organization": "Greenply Industries Ltd.",
    "Place of Incorporation": "India",
    "Company Name In Myanmar": "Greenply Industries (Myanmar) PVT LTD",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "589/2013",
    "Permit Date": "2013-06-24T03:07:18Z",
    "Meeting Number": "16/2013",
    "Meeting Date": "2013-06-12T03:08:27Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Commercial Face Veneer, Sawn Timber, Teak Veneer & Plywood",
    "Amount Of Foreign Capital USD (in Millions)": 9.6,
    "Total Amount Of Capital (in Millions)": 9.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "India",
    "Form Of Investment": "FDII",
    "Land Owner": "U Maung Maung Ohn , Daw Nilar Myint and U Soe Maung",
    "Land Area (units not specified in file)": 7.64,
    "Lease Term": 30,
    "Annual Lease Fee": 324696,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Flat 7 L, Tower lll, City High Apartment 85, Prince Anwar Saha Road, Kolkata-700033",
    "Organization Address":
      "16 A, Shakespeare Sarani New BK Market, 2 Floor, Kolkata-700071",
    "Investment Permitted Address":
      "No.6&7, Dagon Seik Kan Industrial Zone(2), Dagon Seik Kan Township, Yangon Region",
  },
  {
    ID: 1296,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. CAI JIANMING",
    "Name of Principal Organization": "YUE WING    CHEONG MANUFACTORY LIMITED",
    "Place of Incorporation": "British Virgin Islands",
    "Company Name In Myanmar":
      "YUE WING   CHEONG  (MYANMAR)  MANUFACTORY  LIMITED\t",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1102/2016",
    "Permit Date": "2016-03-26T03:28:47Z",
    "Meeting Number": "10/2016",
    "Meeting Date": "2016-03-18T03:29:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags and Wallets on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.57,
    "Total Amount Of Capital (in Millions)": 1.57,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Virgin Islands (British)",
    "Form Of Investment": "FDII",
    "Land Owner": "Lin Hoke Son@ U Khin Maung Yee ",
    "Land Area (units not specified in file)": 1.57,
    "Lease Term": 10,
    "Annual Lease Fee": 0.048,
    "Land Use Premium": null,
    "Number Of Local Employees": 829,
    "Number Of Foreign Employees": 9,
    Status: "Monitoring Approved",
    "Investor Address": "FTD 5/F, WINNER BLDG, 36 MAN YUE STREET, HONG KONG",
    "Organization Address":
      "P.O BOX 3444, ROAD TOWN, TORTOLA, BRITISH VIRGIN ISLANDS",
    "Investment Permitted Address":
      "No.123,Myay Taing Block No(14),Min Ayeyar Street,Shwe Than Lwin Industrial Zone,Hlaing Thar Yar Township,Yangon.",
  },
  {
    ID: 1297,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Myint Than ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Thazin Garden International Trading Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "MaNaTha-999/2014",
    "Permit Date": "2014-10-24T04:25:26Z",
    "Meeting Number": "23/2014",
    "Meeting Date": "2014-10-10T04:26:57Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel service",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 6500,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Department of Forestry",
    "Land Area (units not specified in file)": 9.73,
    "Lease Term": 50,
    "Annual Lease Fee": 1.95,
    "Land Use Premium": 486500,
    "Number Of Local Employees": 249,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address": "No.10(a), Khapaung Road, Hlaing T/S, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.10(a), Khapaung Road, Hlaing T/S, Yangon",
  },
  {
    ID: 1298,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. YEUNG KA HUNG",
    "Name of Principal Organization": "WISE   PEARL   PTE. LIMITED",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "WISE PEARL MYANMAR LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1059/2016",
    "Permit Date": "2016-01-14T04:56:11Z",
    "Meeting Number": "23/2015",
    "Meeting Date": "2015-12-28T04:56:26Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Sewn and Welded Products on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3.6,
    "Total Amount Of Capital (in Millions)": 3.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "U Thein Su ",
    "Land Area (units not specified in file)": 2.784,
    "Lease Term": 10,
    "Annual Lease Fee": 0.063,
    "Land Use Premium": null,
    "Number Of Local Employees": 1247,
    "Number Of Foreign Employees": 22,
    Status: "Monitoring Approved",
    "Investor Address": "4 A, 12 SHIPYARD LANE, QUARRY BAY, HONG KONG",
    "Organization Address":
      "175   BENCOOLEN   STREET, # 12-11   BURLINGTON   SQUARE,     SINGAPORE 189649                      ",
    "Investment Permitted Address":
      "Plote No.8, Block No.24, Ngwe Pin Lal Industrial Zone, Hlaing Tharyar Township, Yangon.",
  },
  {
    ID: 1299,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. RAJENDRA KUMAR DASWANI",
    "Name of Principal Organization": "LEO GROUP PTE LTD. ",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "PAPILLON INDUSTRY LIMITED\t",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "835/2014",
    "Permit Date": "2014-10-31T06:16:17Z",
    "Meeting Number": "23/2014",
    "Meeting Date": "2014-10-10T06:16:40Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING  OF PLASTIC PACKAGING CONTAINERS, HOUSEHOLD GOODS AND FURNITURE   ",
    "Amount Of Foreign Capital USD (in Millions)": 3.457,
    "Total Amount Of Capital (in Millions)": 4.321,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "U Thu Lwin Swe",
    "Land Area (units not specified in file)": 2.534,
    "Lease Term": 47,
    "Annual Lease Fee": 0.051,
    "Land Use Premium": null,
    "Number Of Local Employees": 150,
    "Number Of Foreign Employees": 30,
    Status: "Monitoring Approved",
    "Investor Address":
      "99 MEYER ROAD, # 27-02, THE SOVERIEGN, SINGAPORE 437920 ",
    "Organization Address":
      "1 NORTH BRIDGE ROAD, # 12-06, HIGH STREET, CENTRE, SINGAPORE 179094  ",
    "Investment Permitted Address":
      "PLOT NO - 141,  INDUSTRIAL ZONE (2), DAGON MYO THIT (DAGON SEIK KAN) TOWNSHIP, YANGON REGION. ",
  },
  {
    ID: 1300,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wong Lun Po",
    "Name of Principal Organization": "UNITED REALITY COMPANY LIMITED",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": " Myanmar Toppy Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1056/2016",
    "Permit Date": "2016-01-11T06:17:35Z",
    "Meeting Number": "23/2015",
    "Meeting Date": "2015-12-28T06:21:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.21,
    "Total Amount Of Capital (in Millions)": 1.21,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaw Win and U Sein Win",
    "Land Area (units not specified in file)": 1.484,
    "Lease Term": 10,
    "Annual Lease Fee": 0.034,
    "Land Use Premium": null,
    "Number Of Local Employees": 655,
    "Number Of Foreign Employees": 6,
    Status: "Monitoring Approved",
    "Investor Address":
      "8/F , Marple Court, 41 Broadcast Drive, Kowloon, Hongkong.",
    "Organization Address":
      "45-51  KWOK  SHUI  ROAD,  KWAI  CHUNG,  NEW  TERRITORIES,   HONG KONG                                                ",
    "Investment Permitted Address":
      "Plot No. 278/8, Myay Taing Block No. 25, Shwe Lin Ban Industrial Zone, Hlaing Thar Yar Township, Yangon.",
  },
  {
    ID: 1301,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Zay Zin Latt",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Zaykabar Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "MaNaTha-925/2013",
    "Permit Date": "2013-08-21T06:49:30Z",
    "Meeting Number": "19/2013",
    "Meeting Date": "2013-07-27T06:49:09Z",
    Sector: "Construction",
    "Type Of Investment Business": "BOT Road ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 9429.69,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 65,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "77, University Advenue Road, Bahan T/S, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "77, University Advenue Road, Bahan T/S, Yangon",
  },
  {
    ID: 1302,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "DAW  THEINGI  LIN",
    "Name of Principal Organization": "YADANARBON FIBRE CO., LTD.",
    "Place of Incorporation": "Yangon",
    "Company Name In Myanmar": "YOFC-YADANARBON FIBRE COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1084/2016",
    "Permit Date": "2016-02-17T07:25:33Z",
    "Meeting Number": "3/2016",
    "Meeting Date": "2016-01-30T07:48:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Sales of Fibre Optical Cable",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "Yadanarbon Fibre Co., Ltd. ",
    "Land Area (units not specified in file)": 4.01,
    "Lease Term": 30,
    "Annual Lease Fee": 0.264,
    "Land Use Premium": null,
    "Number Of Local Employees": 111,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.41 A, SHWE TAUNG KYAR STREET, SHWE TAUNG KYAR WARD 2, BAHAN TOWNSHIP, YANGON",
    "Organization Address":
      "HOTEL YANGON, BUILDING NO1, ROOM NO. 101, CORNER OF \tKABA AYE PAGODA ROAD AND PYI ROAD, MAYANGONE TOWNSHIP, \t\t\tYANGON.",
    "Investment Permitted Address":
      "No .208,Thihathu Street,11 Ward,Myathida Housing., Southokkalarpa, Yangon.",
  },
  {
    ID: 1303,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U  Win Soe",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Nadi shwe war Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "manatha 1033/2015",
    "Permit Date": "2015-02-13T07:39:51Z",
    "Meeting Number": "27/2014",
    "Meeting Date": "2014-11-28T07:42:12Z",
    Sector: "Construction",
    "Type Of Investment Business": "BOT Road",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 19304.77,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 95,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address": "617(C), Marlar lane, Pyay Road,Yangon ",
    "Organization Address": "",
    "Investment Permitted Address": "617(C), Marlar lane, Pyay Road,Yangon ",
  },
  {
    ID: 1306,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U kyaw Htay",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Su Htu Pan Construction Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "MaNaTha-860/2012",
    "Permit Date": "2012-09-05T08:07:35Z",
    "Meeting Number": "27/2012",
    "Meeting Date": "2012-08-28T08:07:53Z",
    Sector: "Construction",
    "Type Of Investment Business": "BOT Road ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 10500,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 9,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address": "No-3,4, Parami Housing, Hlaing T/S, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.2, Ward no 10, Yadana Road, Thaketa T/S ",
  },
  {
    ID: 1308,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LIN, CHIH-WEI",
    "Name of Principal Organization": "LITTLE  SEA  GLOBAL CO., LTD.",
    "Place of Incorporation": "BRUNEI DARUSSALAM",
    "Company Name In Myanmar": "VINCE (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1033/2015",
    "Permit Date": "2015-11-11T08:27:31Z",
    "Meeting Number": "18/2015",
    "Meeting Date": "2015-10-23T08:28:06Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING  OF ALL KINDS OF FOOTWEAR PRODUCTS ON CMP BASIS ",
    "Amount Of Foreign Capital USD (in Millions)": 1.957,
    "Total Amount Of Capital (in Millions)": 1.957,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Brunei Darussalam",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aye Thaung and Dr. Daw Khin San",
    "Land Area (units not specified in file)": 2.222,
    "Lease Term": 10,
    "Annual Lease Fee": 0.06,
    "Land Use Premium": null,
    "Number Of Local Employees": 1417,
    "Number Of Foreign Employees": 35,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.116.LN.800, ZHONG SHAN EAST RD. YANG MEI DIST, TAO YUAN, TAIWAN  ",
    "Organization Address":
      "RM 51, 5TH FLOOR, BRITANNIA HOUSE, JALAN CATOR BANDAR SERI BEGAWAN, BS 8811, NEGARA BRUNEI DARUSSALAM",
    "Investment Permitted Address":
      "PLOT  NO. 2,  MYAY TAING  BLOCK  NO. 166, SOUTH DAGON TOWNSHIP, YANGON  REGION",
  },
  {
    ID: 1309,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw Sanda Htun",
    "Name of Principal Organization":
      "Shwe Taung Janction City Development Co., Ltd.",
    "Place of Incorporation": "Yangon",
    "Company Name In Myanmar": "City Square Tower Co., Ltd",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "759/2014",
    "Permit Date": "2014-08-06T08:57:23Z",
    "Meeting Number": "18/2014",
    "Meeting Date": "2014-07-09T08:58:31Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Construction, Developing ,Operation and short-term and long term Renting of High End Service Apartment ",
    "Amount Of Foreign Capital USD (in Millions)": 77.94,
    "Total Amount Of Capital (in Millions)": 143,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 4,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "YCDC",
    "Land Area (units not specified in file)": 50253,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 132,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "Alone Tower, River View Garden Housing, Kanna Road, Ahlone T/S,",
    "Organization Address": "584, Kanna Road, Lanmadaw T/S, Yangon",
    "Investment Permitted Address": "Ahlone Tower, Kanna Road, Ahlone T/S",
  },
  {
    ID: 1310,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Toe Kian Seng",
    "Name of Principal Organization":
      "L&M CONFECTIONERY PTE LTD., NO. 7 TUAS BAYWALK, SINGAPORE 637756 ",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "L&M  MAYSON COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1305/2017",
    "Permit Date": "2017-06-22T03:46:07Z",
    "Meeting Number": "9/2017",
    "Meeting Date": "2017-06-15T17:30:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ဂျုံအခြေခံစားသောက်ကုန်များ ထုတ်လုပ်ခြင်းနှင့်် ဖြန့်ဖြူးရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 6.758,
    "Total Amount Of Capital (in Millions)": 19.588,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "Myanmar Mayson Industries Co.,Ltd.",
    "Land Area (units not specified in file)": 12.17,
    "Lease Term": 50,
    "Annual Lease Fee": 3,
    "Land Use Premium": null,
    "Number Of Local Employees": 1985,
    "Number Of Foreign Employees": 4,
    Status: "Approved",
    "Investor Address": "61 YUNNAN DRIVE 3, SINGAPORE 637951",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၉၈/C၊ ၉၈/D၊ ၉၈/E၊ မြေတိုင်းရပ်ကွက် အမှတ်-၁၄၊ ရွှေသံလွင်စက်မှုဇုန်၊ မြေကွက်အမှတ်-၆၂၊  စက်မှုဇုန်-၁၊ မြေကွက်အမှတ်- ၁၊ စက်မှုဇုန်-၄၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1311,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Mr. Than Htut Oo",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Dawei Development Public Company Limited. ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "MaNaTha-1042/2015",
    "Permit Date": "2015-03-10T04:03:19Z",
    "Meeting Number": "3/2015",
    "Meeting Date": "2015-02-27T04:04:58Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Shopping Center Building (၁)လုံး၊  Multi Purpose Hall Building (၁)လုံး ၊ Shop House (၂၂)လုံး တည်ဆောက်ပြီး DDPC Shopping Center အမည်ဖြင့် ဝန်ဆောင်မှုလုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 5614,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Mr. U Sein",
    "Land Area (units not specified in file)": 15.53,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 50,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Number 22/A, First Floor, Kattar Road, Sanchaung Township, Yangon ",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ် (၈၂၈)၊ မြေညီထပ်၊ မဟာဗန္ဓုလလမ်း၊ ၉ လမ်းနှင့် ၁၀ လမ်းကြား၊ လမ်းမတော်မြို့နယ်၊ ရန်ကုန်",
  },
  {
    ID: 1312,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Ehadi Hla",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Eager Communications Group Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "MaNaTha-1022/2015",
    "Permit Date": "2015-01-02T04:35:00Z",
    "Meeting Number": "29/2014",
    "Meeting Date": "2014-12-26T04:35:37Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Traffic Management & Security Syatem and Yangon City Metropolitan Fiber Network",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 34141.35,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 89,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No.13, Parmari Road, Lawkanat Housing, 12 Quarter, Hlaing Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "B/16, RM (202), Shwe Gabar Housing, Mayangone Township, Yangon Region",
  },
  {
    ID: 1313,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw Sandar Htun ",
    "Name of Principal Organization": "Shwe Taung  junction City Co., Ltd. ",
    "Place of Incorporation": "Yangon ",
    "Company Name In Myanmar": "City Square Office Company Limited ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "Na 760/2014",
    "Permit Date": "2014-08-06T04:49:59Z",
    "Meeting Number": "18/2014",
    "Meeting Date": "2014-07-09T04:51:50Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Construction, Development, Operation and Short-Term & Long- Term Renting of High End Office ",
    "Amount Of Foreign Capital USD (in Millions)": 46.31,
    "Total Amount Of Capital (in Millions)": 84.98,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV,BOT",
    "Land Owner": "Yangon City Development Committee (YCDC)",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 106,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "Alone Tower, River View Garden Housing, Strand Road, Ahlone Tsp, Yangon ",
    "Organization Address": "No. 584, Strand Road, Lanmadaw Tsp, Yangon ",
    "Investment Permitted Address":
      "Corner of Bo Gyoke Aung San Road and Shwe Dagon Pagoda Road, Pabedan Tsp, Yangon ",
  },
  {
    ID: 1314,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Mr. Kyi Win",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Aviation Academy Co., Ltd. ",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "MaNaTha-883/2103",
    "Permit Date": "2013-01-21T07:57:34Z",
    "Meeting Number": "37/2012",
    "Meeting Date": "2012-12-12T07:58:19Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "နိုင်ငံတကာ အဆင့်မီ အပြည်ပြည်ဆိုင်ရာ အသိအမှတ်ပြု လေယာဥ်မောင်းသင်တန်း နှင့် လေကြောင်းဆိုင်ရာ သင်တန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 7252.6,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT",
    "Land Owner": "လေကြောင်းပို့ဆောင်ရေးညွှန်ကြားမှု ဦးစီးဌာန",
    "Land Area (units not specified in file)": 4,
    "Lease Term": 30,
    "Annual Lease Fee": 16192,
    "Land Use Premium": 28,
    "Number Of Local Employees": 82,
    "Number Of Foreign Employees": 5,
    Status: "Approved",
    "Investor Address":
      "Number 41 , Shwetaungkyar Road, Shwetaungtan , Bahan Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Number 41 , Shwetaungkyar Road, Shwetaungtan , Bahan Township, Yangon",
  },
  {
    ID: 1315,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Hitoshi Tani ",
    "Name of Principal Organization": "EXE Sakura (Myanmar) Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "EXE SAKURA (MYANMAR) COMPANY LIMITED ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "Na 883/2015",
    "Permit Date": "2015-02-25T02:54:13Z",
    "Meeting Number": "28/2014",
    "Meeting Date": "2014-12-12T02:58:06Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Leasing Business For Car Park Space ",
    "Amount Of Foreign Capital USD (in Millions)": 4,
    "Total Amount Of Capital (in Millions)": 4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII,BOT",
    "Land Owner": "Department of Urban Development ",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 20,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Mejiro Garden Heights, # 608, 1-38-12, Takada, Toshimaku, Tokyo, 171-0033, Japan ",
    "Organization Address":
      "# 0505,5 FL, Sakura Tower, N0. 339, Bo Gyoke Aung San Road, Kyaunktada  Tsp, Yangon ",
    "Investment Permitted Address":
      "# 0505,5 FL, Sakura Tower, N0. 339, Bo Gyoke Aung San Road, Kyaunktada  Tsp, Yangon ",
  },
  {
    ID: 1316,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Mr. Thiha",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Ayeyarwaddy Resorts And Lodges Co., Ltd. ",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "MaNaTha-905/2013",
    "Permit Date": "2013-03-29T03:24:52Z",
    "Meeting Number": "11/2013",
    "Meeting Date": "2013-03-29T03:25:16Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် မြေငှားရမ်း၍ နိုင်ငံတကာ အဆင့်မီ Hotel , Shopping Mall , Office Tower, Services Apartment စသည်တို့ ပါဝင်သည့် Residential and Commercial Complex တည်ဆောက်၍ ငှားရမ်းခြင်း လုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 115022.17,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "ကာကွယ်ရေး ဝန်ကြီးဌာန၊ စစ်ထောက်ချုပ်ရုံး ပိုင် မြေ ",
    "Land Area (units not specified in file)": 21.9,
    "Lease Term": 50,
    "Annual Lease Fee": 2241,
    "Land Use Premium": 43.8,
    "Number Of Local Employees": 166,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "Number (29), Yaesat Road, Mayangone Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.11(A), Khapaung Street, Hlaing Township, Yangon",
  },
  {
    ID: 1317,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Mr. Zaw Zaw",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Max Myanmar Hotel Co., Ltd. ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "MaNaTha-939/2013",
    "Permit Date": "2013-10-04T04:24:31Z",
    "Meeting Number": "25/2013",
    "Meeting Date": "2013-09-18T04:24:52Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 56900,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 3.295,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 451,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.(19)C, Kokine Yeiktha Street,Golden Valley , No-2 ward , Bahan , Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Number (123), Alanpya Pagoda Road, Dagon Township, Yangon",
  },
  {
    ID: 1318,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LEE, YUAN-JIUN",
    "Name of Principal Organization": "ASCEND HOLDING    CO., LTD.",
    "Place of Incorporation": "BRUNEI DARUSSALAM        ",
    "Company Name In Myanmar": "KING  LEAD    IND    COMPANY      LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1015/2015",
    "Permit Date": "2015-09-21T03:08:24Z",
    "Meeting Number": "16/2015",
    "Meeting Date": "2015-09-11T03:09:32Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of  All Kinds of Footwear and Semi Footwear Products on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.903,
    "Total Amount Of Capital (in Millions)": 4.903,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Brunei Darussalam",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Nan Li ",
    "Land Area (units not specified in file)": 4.836,
    "Lease Term": 10,
    "Annual Lease Fee": 0.098,
    "Land Use Premium": null,
    "Number Of Local Employees": 952,
    "Number Of Foreign Employees": 9,
    Status: "Monitoring Approved",
    "Investor Address":
      "RM-51, 5th FLOOR, BRITANNIA HOUSE, JALAN CATOR BANDAR SERI BEGAWAN BS 8811, NEGARA  BRUNEI  DARUSSALAM",
    "Organization Address":
      "RM-51, 5th FLOOR, BRITANNIA HOUSE, JALAN CATOR BANDAR SERI  BEGAWAN BS 8811, NEGARA  BRUNEI DARUSSALAM            ",
    "Investment Permitted Address":
      "No(1,2)Block No(144)Industrial Zone, South Dagon Township,Yangon.",
  },
  {
    ID: 1319,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Mr. Htun Htun Win",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Hla Hla Pa Pa Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "MaNaTha-951/2013",
    "Permit Date": "2013-12-27T04:44:20Z",
    "Meeting Number": "32/3013",
    "Meeting Date": "2013-12-19T04:50:48Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "ရေပေါ် ဟိုတယ် ဝန်ဆောင်မှု လုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 4274,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Transport and Communication ",
    "Land Area (units not specified in file)": null,
    "Lease Term": 5,
    "Annual Lease Fee": 102,
    "Land Use Premium": null,
    "Number Of Local Employees": 190,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "Number 10 , Mingalar Road, BaukTaw Pyi Thar Yar, Yankin Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No. 02-04, Banyadala Road, Mingalar Taung Nyunt Township, Yangon ",
  },
  {
    ID: 1320,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. YONG SING HSIEN",
    "Name of Principal Organization": "SML (FAR EAST) PTE.LTD.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar":
      "Simon Labels(SML) Myanmar Manufacturing Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1103/2015",
    "Permit Date": "2015-09-21T05:41:09Z",
    "Meeting Number": "16/2015",
    "Meeting Date": "2015-09-11T05:43:06Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing  and Marketing of Labels and Trims for Garments",
    "Amount Of Foreign Capital USD (in Millions)": 1.012,
    "Total Amount Of Capital (in Millions)": 1.012,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Set Yin",
    "Land Area (units not specified in file)": 0.546,
    "Lease Term": 5,
    "Annual Lease Fee": 0.054,
    "Land Use Premium": null,
    "Number Of Local Employees": 45,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "809, FRENCH ROAD, #05-164 KITCHENER COMPLEX, SINGAPORE,  200809 ",
    "Organization Address":
      "138, CECIL STREET, #06-01 CECIL COURT, SINGAPORE,   069538",
    "Investment Permitted Address":
      "No.83, Daw Phwar Shin Street, Hlaing Thar Yar Zone(1), Hlaingtharyar, Yangon.",
  },
  {
    ID: 1322,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LIN, CHANG YUNG",
    "Name of Principal Organization": "POLO INTERNATIONAL HOLDING LIMITED",
    "Place of Incorporation": "SAMOA",
    "Company Name In Myanmar": "TSANG YIH COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "833/2014",
    "Permit Date": "2014-10-31T06:17:27Z",
    "Meeting Number": "23/2014",
    "Meeting Date": "2014-10-10T06:18:13Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING  OF  SHOES ON CMP BASIS ",
    "Amount Of Foreign Capital USD (in Millions)": 25.88,
    "Total Amount Of Capital (in Millions)": 25.88,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Samoa",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Hla Kay Khaing",
    "Land Area (units not specified in file)": 16.703,
    "Lease Term": 30,
    "Annual Lease Fee": 0.338,
    "Land Use Premium": null,
    "Number Of Local Employees": 773,
    "Number Of Foreign Employees": 95,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO-896, SEC.2, NANTUN ROAD, NANTUN DIST., TAICHUNG CITY 40868, TAIWAN, REPUBLIC OF CHINA ",
    "Organization Address":
      "LEVEL 2, LOTEMAU CENTRE, VAEA STREET, APIA, SAMOA.    ",
    "Investment Permitted Address":
      "PLOT NO - X3/X4/X5/X6,  MYAY TAING BLOCK NO.20, ANAWYAHTAR INDUSTRIAL ZONE, HLAING THARYAR TOWNSHIP,  YANGON REGION",
  },
  {
    ID: 1323,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr Jin Feng",
    "Name of Principal Organization": "Crown Wire Engineering Pte. Ltd.",
    "Place of Incorporation": "Singapore ",
    "Company Name In Myanmar": "Crown Advanced Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1087/2016",
    "Permit Date": "2016-01-27T06:24:04Z",
    "Meeting Number": "15/2016",
    "Meeting Date": "2016-01-15T06:24:30Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Construction, Leasing and Management of Hotel and Commercial Buildings",
    "Amount Of Foreign Capital USD (in Millions)": 27.45,
    "Total Amount Of Capital (in Millions)": 30.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Yangon City Development Committee",
    "Land Area (units not specified in file)": 1.92,
    "Lease Term": 0,
    "Annual Lease Fee": 0,
    "Land Use Premium": 0,
    "Number Of Local Employees": 430,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.13, Jin Quan Road, Ruili City,Yunnan Province, China",
    "Organization Address":
      "1014, Geylang East Avenue 3 # 04-176, Singapore 389729",
    "Investment Permitted Address":
      "No.157(B), Twin Thinn Taik Wun U Tun Nyo Street, Industrial Zone(3), Shwe Pyi Thar Township, Yangon",
  },
  {
    ID: 1324,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဗိုလ်မှူးကြီး ရဲအောင် (ငြိမ်း)",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Pyi Nyein Thu Construction Co., Ltd. ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "MaNaTha-960/2014",
    "Permit Date": "2014-02-11T06:31:09Z",
    "Meeting Number": "4/2014",
    "Meeting Date": "2014-01-30T06:31:49Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် အဆင့်မြင့် ၈ ထပ်ခွဲ အဆောက်အအုံ တည်ဆောက်၍ ရုံးခန်းများ ငှားရမ်းခြင်း လုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1500,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "မြို့ရွာနှင့်အိုးအိမ်ဖွံ့ဖြိုးရေးဦးစီးဌာန ",
    "Land Area (units not specified in file)": 0.143,
    "Lease Term": 50,
    "Annual Lease Fee": 0.044,
    "Land Use Premium": 0.21,
    "Number Of Local Employees": 72,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် (၁၅၄)၊ သုနန္ဒာလမ်း ၊ ရတနာကျွန်းရိပ်သာ၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်(၃)၊ အောင်ချမ်းသာ (၅)လမ်း၊ အောင်မြေသာစည်အိမ်ရာ ၊ ကမာရွတ်မြို့နယ်၊ ရန်ကုန် ",
  },
  {
    ID: 1326,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr Michael Schwarz",
    "Name of Principal Organization":
      "NOKIA SIEMENS NETWORKS SINGAPORE PTE. LTD",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "NOKIA SIEMENS NETWORKS MYANMAR LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "718/2014",
    "Permit Date": "2014-04-29T07:31:33Z",
    "Meeting Number": "11/2014",
    "Meeting Date": "2014-03-29T07:31:57Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "PROVIDING TECHNICAL CONSULTANCY SERVICES AND IMPLEMENTATION OF SOLUTIONS IN RELATION TO TELECOMMUNICATION AND OTHER ELECTRONICS INDUSTRY SERVICES TO LICENSED OPERATORS",
    "Amount Of Foreign Capital USD (in Millions)": 8,
    "Total Amount Of Capital (in Millions)": 8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "LP Holding Co., LTD.",
    "Land Area (units not specified in file)": 298,
    "Lease Term": 1,
    "Annual Lease Fee": 0.268,
    "Land Use Premium": 0,
    "Number Of Local Employees": 106,
    "Number Of Foreign Employees": 10,
    Status: "Approved",
    "Investor Address": "THE LOFT # 04-15,22 NASSIM HILL, SINGAPORE 258468",
    "Organization Address":
      "438B ALEXANDRA ROAD, # 08-07 / 10 , ALEXANDRA TECHNOPARK, SINGAPORE 119968",
    "Investment Permitted Address":
      "CENTREPOINT TOWERS, LEVEL 17, UNIT 17C, NO. 65 CORNER OF SULE PAGODA RD. AND MERCHANT ST., KYAUKTADA TOWNSHIP, YANGON REGION.",
  },
  {
    ID: 1327,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms Nina Maria Macpherson",
    "Name of Principal Organization": "Telefonaktiebolaget, LM Ericsson,",
    "Place of Incorporation": "Sweden",
    "Company Name In Myanmar": "Ericsson Myanmar Company Limited ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "720/2014",
    "Permit Date": "2014-04-29T07:50:20Z",
    "Meeting Number": "11/2014",
    "Meeting Date": "2014-03-29T07:50:42Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Provision of Communications and Information Technology Related Services and Equipment to Licensed Operators in Myanmar",
    "Amount Of Foreign Capital USD (in Millions)": 2.05,
    "Total Amount Of Capital (in Millions)": 2.05,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Sweden",
    "Form Of Investment": "FDII",
    "Land Owner": "Myanmar Computer Federation (MCF)",
    "Land Area (units not specified in file)": 7920,
    "Lease Term": 1,
    "Annual Lease Fee": 0.237,
    "Land Use Premium": 0,
    "Number Of Local Employees": 125,
    "Number Of Foreign Employees": 25,
    Status: "Approved",
    "Investor Address": " Torshamnsgatan 21-23, 16483 Stockholm, Sweden.",
    "Organization Address": "Torshamnsgatan 21-23, 16483 Stockholm, Sweden.",
    "Investment Permitted Address":
      "Bldg no.9 , 1st Flr, MICT Hlaing Township, Yangon",
  },
  {
    ID: 1328,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Yan Naing ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Nay Min Yaung Construction Co., Ltd. ",
    "Financial Year From": 2011,
    "Financial Year To": 2012,
    "Permit Number": "MaNaTha-807/2011",
    "Permit Date": "2011-07-22T08:19:21Z",
    "Meeting Number": "15/2011",
    "Meeting Date": "2011-07-21T08:23:50Z",
    Sector: "Construction",
    "Type Of Investment Business":
      "BOTစနစ်ဖြင့် လမ်းပြုပြင် ဖောက်လုပ်၍ လမ်း၊ တံတား အသုံးပြုခများ ကောက်ခံခြင်း လုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 6145.38,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "ဆောက်လုပ်ရေးဝန်ကြီးဌာန၊ ပြည်သူ့ဆောက်လုပ်ရေးလုပ်ငန်း ",
    "Land Area (units not specified in file)": 73,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 130,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Number 52-B, Innyar Road, 10 yard, Kamaryut Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Number 52-B, Innyar Road, 10 yard, Kamaryut Township, Yangon",
  },
  {
    ID: 1329,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Scott William Weenink",
    "Name of Principal Organization": "Ooredoo Asian Investments Pte.Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Ooredoo Myanmar Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "621/2014",
    "Permit Date": "2014-01-27T08:22:00Z",
    "Meeting Number": "1/2014",
    "Meeting Date": "2014-01-08T08:23:02Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Mobile and Fixed Line Telecommunication Service",
    "Amount Of Foreign Capital USD (in Millions)": 3830.5,
    "Total Amount Of Capital (in Millions)": 3830.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "New Zealand",
    "Form Of Investment": "FDII",
    "Land Owner": "0",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": 0,
    "Land Use Premium": 0,
    "Number Of Local Employees": 7380,
    "Number Of Foreign Employees": 10,
    Status: "Approved",
    "Investor Address": "147 Mount Pleasant Road, Singapore 068898",
    "Organization Address": "80 Robinson Road, # 02-00, Singapore 068898",
    "Investment Permitted Address":
      "No.0502, 5 Floor, Sarkura Tower, Bogyuk Aung San Road, Kyauktada Township, Yangon\n\n",
  },
  {
    ID: 1330,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်ခိုင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Khine Industries Co.,Ltd.",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "MaNaTha-331/2000",
    "Permit Date": "2000-02-09T03:36:02Z",
    "Meeting Number": "23/1999",
    "Meeting Date": "1999-11-19T03:36:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်အခြေခံတဝက်တပျက်နှင့် အချောထည် ပရိဘောဂများ၊ ကြမ်းခင်းတုံးများ ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 103.3,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Moe Win Maung",
    "Land Area (units not specified in file)": 2.011,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 144,
    "Number Of Foreign Employees": 6,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်-၆၁၅(ဒီ) ပြည်လမ်း၊ ကမာရွတ်မြို့နယ်၊ ရန်ကုန်",
    "Organization Address": "",
    "Investment Permitted Address":
      "No(169)(F), Pyay Road,(9)Mile, Mayangone, YANGON",
  },
  {
    ID: 1331,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Win Aung ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Amata International Company Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "MaNaTha-996/2014",
    "Permit Date": "2014-10-13T03:37:30Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T03:38:03Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Service ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 14400,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "",
    "Land Area (units not specified in file)": 17.48,
    "Lease Term": 50,
    "Annual Lease Fee": 3496000,
    "Land Use Premium": 874000,
    "Number Of Local Employees": 80,
    "Number Of Foreign Employees": 4,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၇/က၊ ကန်ရိပ်သာလမ်း၊ မရမ်းကုန်းမြို့နယ်၊  ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "No. 10, Inya Avenue Street, Mayangone Tsp, Yangon ",
  },
  {
    ID: 1332,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Mr. Moe Myint ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myint & Associates Construction Co., Ltd. ",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "MaNaTha-864/2012",
    "Permit Date": "2012-10-26T04:17:39Z",
    "Meeting Number": "32/2012",
    "Meeting Date": "2012-10-24T04:18:10Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "အဆင့်မြင့် အဆောက်အအုံ ဆောက်လုပ်ခြင်း လုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 32500,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Mr. Moe Myint ",
    "Land Area (units not specified in file)": 0.69,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 80,
    "Number Of Foreign Employees": 10,
    Status: "Approved",
    "Investor Address":
      "Number 132, New University Avenue Road, Bahan Township, Yangon ",
    "Organization Address": "",
    "Investment Permitted Address":
      "Number 623, Pyay Road, University Post Office, Kamaryut Township , Yangon",
  },
  {
    ID: 1333,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်မျိုးမင်းဒင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Adventure Myanmar Tours & Incentives Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "Manatha 968/2014",
    "Permit Date": "2014-03-13T04:59:40Z",
    "Meeting Number": "7/2014",
    "Meeting Date": "2014-02-19T04:59:13Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business":
      "မန္တလေးဘူတာကြီး၏ စတုတ္ထထပ်မှ သတ္တမထပ်(ခေါင်မိုးပြင်)အထိ BOT စနစ်ဖြင့် ငှားရမ်း၍ အဆင့်မြင့် ဟိုတယ်ဝန်ဆောင်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 3600,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT",
    "Land Owner": "ရထားပို့ဆောင်ရေးဝန်ကြီးဌာန၊ မြန်မာ့မီးရထားပိုင်",
    "Land Area (units not specified in file)": 106948,
    "Lease Term": 15,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 569,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "အမှတ်(၉၉/အို)၊ သံလွင်လမ်း၊ ကမာရွတ်မြို့နယ်၊",
    "Organization Address": "",
    "Investment Permitted Address": "No.(27), Inya Myaing Road, Bahan, YANGON",
  },
  {
    ID: 1334,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမျိုးမြင့်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Zambu Yadana Co.,Ltd.",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "MaNaTha-322/99",
    "Permit Date": "1999-12-24T04:52:17Z",
    "Meeting Number": "20/1999",
    "Meeting Date": "1999-10-29T04:56:03Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်အခြေခံတန်ဖိုးမြှင့် ပစ္စည်းများ ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 78.05,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Myo Myint",
    "Land Area (units not specified in file)": 2.746,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 101,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address": "No.520/B, TanThuMar Road, Thingangyun, Yangon ",
    "Organization Address": "",
    "Investment Permitted Address":
      "No,521,Moekoat Street, Industry Zone(1), Dagon(south), YANGON",
  },
  {
    ID: 1335,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Miss Nan Htan @ Miss May Moe Myint ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Paramount Inle Resort Co., Ltd. ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "MaNaTha-936/2013",
    "Permit Date": "2013-09-19T06:08:43Z",
    "Meeting Number": "20/2013",
    "Meeting Date": "2013-08-07T06:10:35Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီ Hotel , Retail & Office Twin Tower ဝန်ဆောင်မှုလုပ်ငန်း အဆင့်-၁ အကောင်အထည်ဖော်ဆောင်ရွက်ခြင်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 7597.34,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "ကာကွယ်ရေးဝန်ကြီးဌာန၊ စစ်ထောက်ချုပ်ရုံးပိုင် မြေ ",
    "Land Area (units not specified in file)": 1.869,
    "Lease Term": 50,
    "Annual Lease Fee": 675.6,
    "Land Use Premium": 3.27,
    "Number Of Local Employees": 144,
    "Number Of Foreign Employees": null,
    Status: "Amend",
    "Investor Address":
      "Number (30/L-2), Innyar Road, 10 Yard, Kamaryut Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No-27, Inya Myaing Road, Bahan Township, Yangon",
  },
  {
    ID: 1336,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr Charles Oliver Coughlan",
    "Name of Principal Organization": "Digicel Asian Holdings Pte.Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Etodco Myanmr Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "698/2014",
    "Permit Date": "2014-03-31T06:20:00Z",
    "Meeting Number": "8/2014",
    "Meeting Date": "2014-03-05T06:20:28Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Building, Installing, Operating, the Telecommunications Network Infrastructure and Facilities (including Telecommunications Towers) and renting space on thee Telecommunications Network Infrastructure and Facilities",
    "Amount Of Foreign Capital USD (in Millions)": 119,
    "Total Amount Of Capital (in Millions)": 119,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "0",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": 0,
    "Land Use Premium": 0,
    "Number Of Local Employees": 178,
    "Number Of Foreign Employees": 2,
    Status: "Approved",
    "Investor Address": "Hybrasil, french's Walk Cobh, County Cork, Ireland.",
    "Organization Address":
      "15A  Change Business Park Central 1, # 01-05 Eightriem @ Changi Business Park, Singapore 486035",
    "Investment Permitted Address":
      "No. 0301, 3rd Floor, Pearl Condominium, Block D, Kabar Aye Pagoda Road, , Bahan, YANGON",
  },
  {
    ID: 1337,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr Godfrey Tan",
    "Name of Principal Organization": "Frontiir Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Frontiir company Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "583/2013",
    "Permit Date": "2013-05-14T06:54:51Z",
    "Meeting Number": "14/2013",
    "Meeting Date": "2013-05-10T06:58:47Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business": "IT and Software Services",
    "Amount Of Foreign Capital USD (in Millions)": 18,
    "Total Amount Of Capital (in Millions)": 18,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": 0.028,
    "Land Use Premium": 0,
    "Number Of Local Employees": 40,
    "Number Of Foreign Employees": 3,
    Status: "Approved",
    "Investor Address": "1586 Parkview AVE # 3 San Jose, CA 95130",
    "Organization Address": "51 Goldhill Plaza # 07-10/11, Singapore 308900",
    "Investment Permitted Address":
      "No.5, Byint Naung Road, Hlaing Township, Yangon",
  },
  {
    ID: 1338,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lau Ching Kong",
    "Name of Principal Organization": "GiGi Leather Goods Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar":
      "Myanmar GiGi Leather Goods Manufactory  Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1146/2016",
    "Permit Date": "2016-09-14T07:23:44Z",
    "Meeting Number": "15/2016",
    "Meeting Date": "2016-08-19T07:24:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Handbags and Accessories on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.91,
    "Total Amount Of Capital (in Millions)": 0.91,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Sai Lon @ U Htay Win & U Tun Tun @ U Sai San",
    "Land Area (units not specified in file)": 1.87,
    "Lease Term": 10,
    "Annual Lease Fee": 0.04,
    "Land Use Premium": null,
    "Number Of Local Employees": 284,
    "Number Of Foreign Employees": 16,
    Status: "Monitoring Approved",
    "Investor Address": "12 Golden Bamboo Road E, Fairview Park, Yuen Long, NT",
    "Organization Address":
      "Unit 1101, Join-In Hang Sing Centre, 71-75 Container Port Road, Kwai Chung, NT",
    "Investment Permitted Address":
      "Plot No. 96, Myay Taing Block No.51, Thardu Kan Industrial Zone, Shwe Pyi Thar Township",
  },
  {
    ID: 1339,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ခင်စန္ဒာဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Sanda Hotel Company Limited ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "MaNaTha-919/2013",
    "Permit Date": "2013-07-11T07:44:10Z",
    "Meeting Number": "17/2013",
    "Meeting Date": "2013-06-29T07:44:50Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business":
      "ဘီအိုတီစနစ်ဖြင့် ငှားရမ်း၍ အခန်း ၁၀၀ ပါ နိုင်င်ငံတကာအဆင့်မီ ဟိုတယ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 5,
    "Total Amount Of Capital (in Millions)": 6250,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အခန်း ၄၀၄၊ ၄ လွှာ၊ ရွိုင်ရယ်ယောမင်းကြီးကွန်ုဒို, အမှတ် ၅၂၊ ယောမင်းကြီးလမ်း၊ ဒဂုံမြို့နယ်၊ ရန်ကုန်",
    "Organization Address": "",
    "Investment Permitted Address":
      "အခန်း ၄၀၄၊ ၄ လွှာ၊ ရွိုင်ရယ်ယောမင်းကြီးကွန်ုဒို, အမှတ် ၅၂၊ ယောမင်းကြီးလမ်း၊ ဒဂုံမြို့နယ်၊ ရန်ကုန်",
  },
  {
    ID: 1340,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Khin Than Nu",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Nan Htike Thu Co. ,Ltd.",
    "Financial Year From": 2011,
    "Financial Year To": 2012,
    "Permit Number": "manatha 831/2011",
    "Permit Date": "2011-12-13T08:19:17Z",
    "Meeting Number": "27/2011",
    "Meeting Date": "2011-12-07T08:20:02Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel service",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 389.13,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 2.48,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 57,
    "Number Of Foreign Employees": 2,
    Status: "Approved",
    "Investor Address":
      "No.2/4, Room.3/ a,, b, third Floor, Shin Saw Pu Pagoda Road, Sanchaung T/S.",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.2/4, Room.3/ a,, b, third Floor, Shin Saw Pu Pagoda Road, Sanchaung T/S.",
  },
  {
    ID: 1341,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS. YAO GUILAN ",
    "Name of Principal Organization":
      "NANTONG   SAIHUI INTERNATIONAL TRADE CO., LTD.,",
    "Place of Incorporation": "PEOPLE’S REPUBLIC OF CHINA",
    "Company Name In Myanmar":
      "SAIFORM INTERNATIONAL GARMENT (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1066/2016",
    "Permit Date": "2016-01-26T08:36:58Z",
    "Meeting Number": "1/2016",
    "Meeting Date": "2016-01-15T08:37:26Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 2.34,
    "Total Amount Of Capital (in Millions)": 2.34,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Than Than Win",
    "Land Area (units not specified in file)": 3.373,
    "Lease Term": 20,
    "Annual Lease Fee": 0.07,
    "Land Use Premium": null,
    "Number Of Local Employees": 1300,
    "Number Of Foreign Employees": 19,
    Status: "Monitoring Approved",
    "Investor Address":
      "ROOM 602, BUILDING 11, GUANGMING WEST VILLAGE, CHONGCHUAN DISTRICT, NANTONG CITY, JIANGSU PROVINCE, CHINA",
    "Organization Address":
      "ROOM 0501 HUAL I  MANSION,  NO. 6, GONGNONG ROAD, NANTONG CITY, CHINA",
    "Investment Permitted Address":
      "PLOT NO. 37 & 41, MYAY TAING BLOCK NO.14, SHWE THAN LWIN INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1342,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Deng, Junshan",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "TRI-WIN LEATHER MYANMAR COMPANY LIMITED   ",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1163/2016",
    "Permit Date": "2016-09-19T08:55:08Z",
    "Meeting Number": "17/2016",
    "Meeting Date": "2016-09-09T08:55:33Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF VARIOUS KINDS OF  BAGS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 2.3,
    "Total Amount Of Capital (in Millions)": 2.3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Khaing & Daw Ohn Han",
    "Land Area (units not specified in file)": 2.6,
    "Lease Term": 10,
    "Annual Lease Fee": 0.06,
    "Land Use Premium": null,
    "Number Of Local Employees": 1236,
    "Number Of Foreign Employees": 60,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.(22), NANHE SECOND STREET, NANFANG INDUSTRIAL ZONE, SHILING TOWN, HUADU DISTRICT, GUANGZHOU CITY",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 91, MYAY TAING BLOCK NO. 14 (SHWE THAN LWIN), HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1344,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Tang, Shih-Hui",
    "Name of Principal Organization": "VIGOUR STAR CORPORATION",
    "Place of Incorporation": "NEGARA BRUNEI DARUSSALAM",
    "Company Name In Myanmar":
      "CONSTANT HARVEST (MYANMAR) STEEL & ALUMINUM COMPANY LIMITED\t ",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1152/2016",
    "Permit Date": "2016-09-19T09:27:49Z",
    "Meeting Number": "17/2016",
    "Meeting Date": "2016-09-09T09:28:16Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF IRON & ALUMINUM PRODUCTS (SUCH AS EXTRUSIONS, PROCESSING, ANODIZE AND BATHROOM ACCESSORIES)  ",
    "Amount Of Foreign Capital USD (in Millions)": 5.43,
    "Total Amount Of Capital (in Millions)": 5.43,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Brunei Darussalam",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Myint Myint Yi",
    "Land Area (units not specified in file)": 4,
    "Lease Term": 30,
    "Annual Lease Fee": 0.08,
    "Land Use Premium": null,
    "Number Of Local Employees": 167,
    "Number Of Foreign Employees": 30,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.19, LN.204, ZHONGXING, N.ST.SAN CHONG DIST, NEW TAIPEI CITY, REPUBLIC OF CHINA",
    "Organization Address":
      "No.24, Lesperance Complex, Providence Industrial Estate, Mahe, Seychelles",
    "Investment Permitted Address":
      "PLOT NO. 354, 355, MYAUNG  DAKAR STEEL INDUSTRIAL ZONE, HMAWBI TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1347,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kwan Tiak Teong ",
    "Name of Principal Organization": " ASCENT RETURNS SDN.BHD",
    "Place of Incorporation": "Malaysia",
    "Company Name In Myanmar": "Uptown Regalia(M) Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "714/2014",
    "Permit Date": "2014-04-22T09:27:59Z",
    "Meeting Number": "10/2014",
    "Meeting Date": "2014-03-19T09:28:12Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": 3.136,
    "Total Amount Of Capital (in Millions)": 3.316,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Malaysia",
    "Form Of Investment": "FDII",
    "Land Owner": "U Htein Lin",
    "Land Area (units not specified in file)": 0.166,
    "Lease Term": 30,
    "Annual Lease Fee": 0.24,
    "Land Use Premium": null,
    "Number Of Local Employees": 58,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "No-22, Jalan Villa -3, Anggerik Villa, Off Jalan, Semenyin, 43000 Kajang, Selangor, Malaysia.",
    "Organization Address":
      "No-22, Jalan Villa -3, Anggerik Villa, Off Jalan, Semenyin, 43000 Kajang, Selangor, Malaysia",
    "Investment Permitted Address":
      "No-852D, 852E, Shu Khin  Thar Main Road, 4/South Quarter, Thaketa Township, Yangon.",
  },
  {
    ID: 1349,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Sai Myo Win",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "First Golden Dragon Construction Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "MANATHA 902/2013",
    "Permit Date": "2013-03-29T09:51:49Z",
    "Meeting Number": "11/2013",
    "Meeting Date": "2013-03-20T09:52:18Z",
    Sector: "Construction",
    "Type Of Investment Business": "BOT Road ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 30020.7,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 108,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "No.53/54, Satsaya U Htun Road, Shwe pyi tha industrial zone(4),Insein T/S, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.53/54, Satsaya U Htun Road, Shwe pyi tha industrial zone(4),Insein T/S, Yangon",
  },
  {
    ID: 1350,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chen, Chung-Sen",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "PRO CAP COMPANY LIMITED\t                                                                           ",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1162/2016",
    "Permit Date": "2016-09-19T10:04:57Z",
    "Meeting Number": "17/2016",
    "Meeting Date": "2016-09-09T10:05:13Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF VARIOUS KINDS OF HATS AND CAPS ON CMP BASIS ",
    "Amount Of Foreign Capital USD (in Millions)": 1.71,
    "Total Amount Of Capital (in Millions)": 1.71,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Lin Kyin Po @ Ma Kyin Po",
    "Land Area (units not specified in file)": 1.093,
    "Lease Term": 10,
    "Annual Lease Fee": 0.02,
    "Land Use Premium": null,
    "Number Of Local Employees": 852,
    "Number Of Foreign Employees": 30,
    Status: "Approved",
    "Investor Address":
      "NO.155, MINXIANG 5TH STREET, QINGSHUI DISTRICT, TAICHUNG CITY 436, TAIWAN, REPUBLIC OF CHINA",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 162, MYAY TAING BLOCK NO- ZONE(2), SETMHU ZONE, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1351,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyaw Soe Lwin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myat Noe Thu Construction Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "982/2014",
    "Permit Date": "2014-05-28T10:12:29Z",
    "Meeting Number": "13/2014",
    "Meeting Date": "2014-04-26T10:12:56Z",
    Sector: "Construction",
    "Type Of Investment Business": "BOT Road ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 23346.19,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 38,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.647, between 87x 37 street, haymamarlar(North), Mahaaungmyay T/S.",
    "Organization Address": "",
    "Investment Permitted Address":
      "Building A(1), Room 508,Shwegong Thu Housing, Lower kyeemyindaing Road, kyeemyindaingT/S, Yangon",
  },
  {
    ID: 1352,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Wuitye htwe",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Taw Win Family Construction Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "943/2013",
    "Permit Date": "2013-12-03T10:41:03Z",
    "Meeting Number": "24/2013",
    "Meeting Date": "2013-09-11T10:41:27Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel service",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 35950,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 2.432,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 604,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.31, Mahamyine Road, Kyuntaw Ale Ward, Sanchaung T/S, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.355, U Wisaya Road, Sanchaung T/S, Yangon",
  },
  {
    ID: 1353,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Moe Moe ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Capital Development Limited ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "Manatha 991/2014",
    "Permit Date": "2014-08-07T02:45:54Z",
    "Meeting Number": "18/2014",
    "Meeting Date": "2014-07-09T02:46:33Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Shopping Centre (၅) ထပ်အပါအဝင် Apartment (၂၇) ထပ် နှင့် Office  (၂၁)ထပ် Residence (၃၁) ထပ်ပါ အဆောက်အဦ (၁)လုံးနှင့် (၂၁) ထပ်ပါ  Condo (၄) လုံး တည်ဆောက်ပြီး အခန်းများ ငှားရမ်းခြင်းနှင့် ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 41.27,
    "Total Amount Of Capital (in Millions)": 421757.47,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 60,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Moe Moe ",
    "Land Area (units not specified in file)": 9.718,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 179,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "No. 126 A, Kabaaye Pagoda  Road, Bahan Tsp, Yangon ",
    "Organization Address": "",
    "Investment Permitted Address":
      "No. 256/260, Sula Pagoda Road, Kyauktada Tsp, Yangon ",
  },
  {
    ID: 1354,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mrs. Shen Jingyi",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "GMT GARMENT FACTORY COMPANY LIMITED\t                                                                           ",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1203/2016",
    "Permit Date": "2016-12-23T02:52:36Z",
    "Meeting Number": "23/2016",
    "Meeting Date": "2016-12-17T02:52:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS ",
    "Amount Of Foreign Capital USD (in Millions)": 0.4,
    "Total Amount Of Capital (in Millions)": 0.58,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Ei Phyu Khaing & U Min Sithu",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 20,
    "Annual Lease Fee": 0.022,
    "Land Use Premium": null,
    "Number Of Local Employees": 502,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "104 NATIONAL ROAD, HUANGZHUANG ECONOMIC ZONE, WUQING DISTRICT, TIANJIN, PEOPLE’S  REPUBLIC OF CHINA           ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 11, MYAY TAING BLOCK NO.64, INDUSTRIAL ZONE-3, SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1356,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဆန်သူ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Kai Phyo Comstruction Co.,Ltd.",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "MaNaTha-307/99",
    "Permit Date": "1999-11-19T03:01:03Z",
    "Meeting Number": "15/99",
    "Meeting Date": "1999-09-03T03:04:55Z",
    Sector: "Agriculture",
    "Type Of Investment Business":
      "လုံးရယ်သီးများ စိုက်ပျိုးထုတ်လုပ်ရောင်းချခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 51.2,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "မွေးမြူရေးနှင့် ရေလုပ်ငန်းဝန်ကြီးဌာန၊ မွေးမြူရေးနှင့် ကုသရေးဦးစီးဌာန",
    "Land Area (units not specified in file)": 289,
    "Lease Term": null,
    "Annual Lease Fee": 0.578,
    "Land Use Premium": 1,
    "Number Of Local Employees": 60,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No.68, 166 Road. Tar Maye, (B) Quarter, Tar Maye Township, Yangon ",
    "Organization Address": "",
    "Investment Permitted Address":
      "No(216/22), Room No (C/D),Ground Floor, Bo Myat Htun Housing, Mahabandoola Street, , Pazuntaung, YANGON",
  },
  {
    ID: 1357,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS. SOK VICHIRAVINY   ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "AN & BROTHERS MANUFACTURING COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1204/2016",
    "Permit Date": "2016-12-23T03:24:03Z",
    "Meeting Number": "23/2016",
    "Meeting Date": "2016-12-17T03:24:19Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS ",
    "Amount Of Foreign Capital USD (in Millions)": 0.77,
    "Total Amount Of Capital (in Millions)": 0.77,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Cambodia",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Win Win Maw",
    "Land Area (units not specified in file)": 1.85,
    "Lease Term": 20,
    "Annual Lease Fee": 0.041,
    "Land Use Premium": null,
    "Number Of Local Employees": 569,
    "Number Of Foreign Employees": 11,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.73 B, 97 STREET, GROUP 31 VILLAGE, 5-CENTER, PHSAR DEUM THKOV, CHAMKA MON, PHNOM PENH CITY, KINGDOM OF CAMBODIA           ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 360, MYAY TAING BLOCK NO.49 (WARTAYAR SETHMU), SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1358,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Mr. Ar Yu",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Yangon Technical & Trading Co., Ltd. ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "MaNaTha-933/2013",
    "Permit Date": "2013-09-05T03:22:03Z",
    "Meeting Number": "20/2013",
    "Meeting Date": "2013-08-07T03:24:10Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီ Hotel , Office and Shopping Complex Project တည်ဆောက်ခြင်းနှင့် ငှားရမ်းခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 74202.49,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "ကာကွယ်ရေးဝန်ကြီးဌာ၊ စစ်ထောက်ချုပ်ရုံး ",
    "Land Area (units not specified in file)": 9.028,
    "Lease Term": 50,
    "Annual Lease Fee": 103.38,
    "Land Use Premium": 22.57,
    "Number Of Local Employees": 340,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Building 6 , Room -16, Lanthit Guesthouse, 11 yard, Lanmadaw Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Number 531, Lower Kyeemyindine Road, Room Number (1104), Yetagon Tower, Kyeemyindine Township, Yangon ",
  },
  {
    ID: 1359,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမောင်ကျေး(ခ)တီကာကွေး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ORIENTAL HIGHWAY COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "Manatha 1178/2016",
    "Permit Date": "2016-03-26T03:45:25Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T03:45:33Z",
    Sector: "Construction",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် လမ်း-တံတားအသုံးပြုခ ကောက်ခံခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.84,
    "Total Amount Of Capital (in Millions)": 20761.99,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 45,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 25,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်(စီ-၄)၊ မွန်မြတ်မေတ္တာလုံးခြင်းအိမ်ရာ၊ ပင်ရွှေညောင်လမ်း",
    "Organization Address": "",
    "Investment Permitted Address":
      "No. (36), Thein Phyu Road, , Pazuntaung, YANGON",
  },
  {
    ID: 1360,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်နန်းလိုင်းခမ်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Kanbawza Office Complex Limited ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "Manatha 995/2014",
    "Permit Date": "2014-09-16T03:40:36Z",
    "Meeting Number": "21/2014",
    "Meeting Date": "2014-08-15T03:40:50Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "BOT နစ် Office Complex တည်ဆောက်၍ နိုင်ငံတကာ အဆင့်မီ ရုံးခန်းများ ပြုပြင် တည်ဆောက်ငှားရမ်းခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 26.2,
    "Total Amount Of Capital (in Millions)": 28000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "မြန်မာ့စီးပွားရေးဦးပိုင်လီမိတက် ",
    "Land Area (units not specified in file)": 1.645,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 42,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၆၁၅/၁၊ ပြည်လမ်း၊ အမှတ် ၂ ရပ်ကွက်၊ ကမာရွတ်မြို့နယ်",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ် ၅၃၊ ကမ်းနားလမ်း၊ အမှတ် ၃ ရပ်ကွက်၊  ပန်းဘဲတန်းမြို့နယ်၊ ရန်ကုန်တိုင်း",
  },
  {
    ID: 1361,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. YU LIANG   ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "TWINKLE  LIGHT FASHION COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1214/2017",
    "Permit Date": "2017-01-11T03:59:11Z",
    "Meeting Number": "1/2017",
    "Meeting Date": "2017-01-06T03:59:40Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS ",
    "Amount Of Foreign Capital USD (in Millions)": 1.49,
    "Total Amount Of Capital (in Millions)": 1.49,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaw Win, U Saw Win, U Soe Win & Daw Nilar Aye",
    "Land Area (units not specified in file)": 1.92,
    "Lease Term": 20,
    "Annual Lease Fee": 0.027,
    "Land Use Premium": null,
    "Number Of Local Employees": 750,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address":
      "AN HUI, FU YANG SHI, YING QUAN, XING LIU ZHEN, LIU HE XING ZHENG CUN, PEOPLE’S  REPUBLIC OF CHINA           ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 182/5, MYAY TAING BLOCK NO.25, HLAING  THAR YAR  TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1362,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Mr. Ko Ko Htoo",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanma Annawa Swan:A: Shin Group(s)Co., Ltd. ",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "MaNaTha-856/2012",
    "Permit Date": "2012-07-24T04:32:30Z",
    "Meeting Number": "19/2012",
    "Meeting Date": "2012-07-04T04:33:03Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "မြန်မာ့စက်မှုဆိပ်ကမ်း အမှတ်(၃)(၄) နှင့် (၅) ဆိပ်ခံတံတားနှင့် ကုန်သေတ္တာလွင်ပြင် သိုလှောင်စခန်း တည်ဆောက်ပြီး ဆိပ်ကမ်းဝန်ဆောင်မှု လုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 92000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "ပို့ဆောင်ရေးဝန်ကြီးဌာန ၊ မြန်မာ့ဆိပ်ကမ်းအာဏာပိုင် ",
    "Land Area (units not specified in file)": 48.071,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": 336.5,
    "Number Of Local Employees": 831,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Number 1 , Kanbawza Guest Road, Bahan Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.7/2(B), Strand Road, Ahlone Township, Yangon",
  },
  {
    ID: 1363,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကိုချင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Yaung Ni Oo Co.,Ltd.",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "MaNaTha-168/98",
    "Permit Date": "1998-09-04T04:53:04Z",
    "Meeting Number": "13/1998",
    "Meeting Date": "1998-07-31T04:53:50Z",
    Sector: "Agriculture",
    "Type Of Investment Business":
      "စိုက်ပျိုးရေး၊ တိရစ္ဆာန် မွေးမြူရေးနှင့် ငါးမွေးမြူရေးလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 99.07,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "မွေးမြူရေးနှင့် ရေလုပ်ငန်းဝန်ကြီးဌာန၊ မွေးမြူရေးအစားအစာနှင့် နို့ထွက်ပစ္စည်းလုပ်ငန်းပိုင်",
    "Land Area (units not specified in file)": 1133.82,
    "Lease Term": 20,
    "Annual Lease Fee": null,
    "Land Use Premium": 2.83,
    "Number Of Local Employees": 275,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "No.33(B), Yadanar Road, 7 Mile, Ma Yaung Gone, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "ငါးဆူတောင်ကျေးရွာ၊ လှည်းကူးမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1364,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Kyaw Lin Tun ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "ADACHI GLOBAL INDUSTRIES  COMPANY LIMITED\t",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1251/2017",
    "Permit Date": "2017-04-11T05:33:16Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T05:33:37Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND  MARKETING OF AIR FILTER AND OIL FILTER",
    "Amount Of Foreign Capital USD (in Millions)": 0.253,
    "Total Amount Of Capital (in Millions)": 0.506,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Malaysia",
    "Form Of Investment": "JV",
    "Land Owner": "U Zaw Lin",
    "Land Area (units not specified in file)": 0.114,
    "Lease Term": 3,
    "Annual Lease Fee": 3.4452,
    "Land Use Premium": null,
    "Number Of Local Employees": 50,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.138, Mahuyar Street, Shin Saw Pu Ward 3,   kyaikmayaw Township, Mon State. ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 305 & 306, MYAY TAING BLOCK NO.19/1, SHWE PAUK KAN SETHMU, NORTH OKKALAPA TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1365,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Ko Ko Gyi @ U Soe Naing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "SNG MYANMAR LIMITED.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "MaNaTha-1254/2017",
    "Permit Date": "2017-05-25T05:46:57Z",
    "Meeting Number": "7/2017",
    "Meeting Date": "2017-04-28T05:47:10Z",
    Sector: "Real Estate",
    "Type Of Investment Business": "Real Estate Development Services. ",
    "Amount Of Foreign Capital USD (in Millions)": 3.38,
    "Total Amount Of Capital (in Millions)": 31357,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Soe Naing and Daw San Qu",
    "Land Area (units not specified in file)": 0.848,
    "Lease Term": 50,
    "Annual Lease Fee": 200,
    "Land Use Premium": null,
    "Number Of Local Employees": 82,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No.(9/C-2), Yawmingyi Road, Yawmingyi Ward, , Dagon Township, YANGON",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.(9/C-2), Yawmingyi Road, Yawmingyi Ward, , Dagon Township, YANGON",
  },
  {
    ID: 1366,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LIN, YUAN-CHEN   ",
    "Name of Principal Organization": "WALTER CO.,LTD.,  ",
    "Place of Incorporation": "United Kingdom",
    "Company Name In Myanmar":
      "YEO YI (MYANMAR) FOOTWEAR MANUFACTURING COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1252/2017",
    "Permit Date": "2017-04-11T06:26:20Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T06:26:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF VARIETIES OF SHOES ON CMP BASIS ",
    "Amount Of Foreign Capital USD (in Millions)": 6.89,
    "Total Amount Of Capital (in Millions)": 6.89,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "United Kingdom of Great Britain and Northern Ireland",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Mi Mi Nge",
    "Land Area (units not specified in file)": 3.093,
    "Lease Term": 50,
    "Annual Lease Fee": 0.065,
    "Land Use Premium": null,
    "Number Of Local Employees": 1351,
    "Number Of Foreign Employees": 30,
    Status: "Approved",
    "Investor Address":
      "NO.355, SEC.3, MINSHENG ROAD, DAYA DISTRICT, TAICHUNG CITY 428, TAIWAN         ",
    "Organization Address":
      "BABROW BUILDING, THE VALLEY, ANGUILLA, BRITISH WEST INDIES, BRITISH VIRGIN ISLANDS, UNITED KINGDOM          ",
    "Investment Permitted Address":
      "PLOT NO. 183, 184, 185, 186, MYAY TAING BLOCK NO.PART(5), INDUSTRIAL ZONE, HLAING  THAR YAR  TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1367,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Thein Oo",
    "Name of Principal Organization": "ACE Data Systems Limited ",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "DIR-ACE Technology Limited",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "562/2013",
    "Permit Date": "2013-02-21T06:44:38Z",
    "Meeting Number": "8/2013",
    "Meeting Date": "2013-02-20T06:03:30Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Service relating to Software Development, System Maintenance and Operation, IT Solution, Research and Consulting, Business Associated with such services.",
    "Amount Of Foreign Capital USD (in Millions)": 0.75,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "ACE Data Systems Limited",
    "Land Area (units not specified in file)": null,
    "Lease Term": 10,
    "Annual Lease Fee": 140,
    "Land Use Premium": 0,
    "Number Of Local Employees": 108,
    "Number Of Foreign Employees": 3,
    Status: "Submitted",
    "Investor Address":
      "No.66, Thunandar Street, Thumingalar Housing, Thingangyun, Yangon.",
    "Organization Address":
      "Block 2, Room 2-4, Myanmar INFO-Tech, Hlaing Township, Yangon.",
    "Investment Permitted Address":
      "Floor 4, Phase 3, Myanmar Info-Tech., Hlaing, YANGON",
  },
  {
    ID: 1368,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. KONG, XIZHONG",
    "Name of Principal Organization":
      "SHANGHAI TALENT IMPORT & EXPORT CO., LTD. ",
    "Place of Incorporation": "CHINA",
    "Company Name In Myanmar": "TAI HONG GARMENT COMPANY LIMITED\t",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "816/2014",
    "Permit Date": "2014-10-24T07:04:34Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T07:04:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING  OF GARMENTS ON CMP BASIS  ",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Naing Soe",
    "Land Area (units not specified in file)": 2.148,
    "Lease Term": 10,
    "Annual Lease Fee": 0.047,
    "Land Use Premium": null,
    "Number Of Local Employees": 905,
    "Number Of Foreign Employees": 16,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO-15 XING CHUAN LU, FANG KO CITY, MA JIAN TOWN, ZHEJIANG ZHUJI. ",
    "Organization Address":
      "ROOM- 1204, NO.1016, DINGXI ROAD, CHANGING DISTRICT, SHANGHAI",
    "Investment Permitted Address":
      "PLOT NO - 254,  BLOCK   NO - 49, WATAYAR INDUSTRIAL ZONE, SHWE PYITHAR TOWNSHIP,  YANGON REGION.",
  },
  {
    ID: 1369,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LIU, GONG   ",
    "Name of Principal Organization":
      "GAINWAY INTERNATIONAL (HONG KONG) COMPANY LIMITED",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar":
      "GAINWAY INTERNATIONAL (MYANMAR) GARMENT COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1147/2016",
    "Permit Date": "2016-09-14T07:28:03Z",
    "Meeting Number": "16/2016",
    "Meeting Date": "2016-08-26T07:28:26Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS ",
    "Amount Of Foreign Capital USD (in Millions)": 2.61,
    "Total Amount Of Capital (in Millions)": 2.61,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Saing Win Aung & U Saing Win Tun",
    "Land Area (units not specified in file)": null,
    "Lease Term": 10,
    "Annual Lease Fee": 0.1,
    "Land Use Premium": null,
    "Number Of Local Employees": 1426,
    "Number Of Foreign Employees": 37,
    Status: "Monitoring Approved",
    "Investor Address":
      "5A, BUILDING 1.6, TIAN FA TOWER, TIAN AN CYBER PARK, FUTIAN, SHENZHEN CITY, GUANGDONG PROVINCE, PEOPLE’S REPUBLIC OF CHINA ",
    "Organization Address":
      "FLAT/RM 1210 12/F CHEVALIER COMMERCIAL CENTRE  8 WANG HOI ROAD KOWLOON BAY, HONG KONG             ",
    "Investment Permitted Address":
      "PLOT NO. 97, 98, MYAY TAING BLOCK NO-51, THARDU KAN INDUSTRIAL ZONE, SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1370,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr Horikawa Masaki",
    "Name of Principal Organization": "NTT Data Asia Pacific Pte Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "NTT  Data Myanmar Company Limited",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "499/2012",
    "Permit Date": "2012-09-23T07:35:34Z",
    "Meeting Number": "28/2012",
    "Meeting Date": "2012-09-05T06:10:38Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "IT Services လုပ်ငန်း( မြန်မာ အိုင်တီ သက်မွေးလုပ်ငန်းဆိုင်ရာ ကျွမ်းကျင်မှု အရည်အသွေးတိုးတက်မြင့်မားရေးအတွက် သင်တန်း အစီအစဉ်များနှင့် ပညာသင်ဆုများ ရွေးချယ်ချီးမြှင့်မည့် IT Services Company Limited)\n\n\n\n",
    "Amount Of Foreign Capital USD (in Millions)": 1.016,
    "Total Amount Of Capital (in Millions)": 1.006,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Zaw Myint",
    "Land Area (units not specified in file)": 8640,
    "Lease Term": 14,
    "Annual Lease Fee": 0.6,
    "Land Use Premium": 0,
    "Number Of Local Employees": 165,
    "Number Of Foreign Employees": 2,
    Status: "Submitted",
    "Investor Address": "11-17, Seijo 5-chome, Setagaya-ku, Tokyo, Japan",
    "Organization Address":
      "20 Cecil Street, # 06-02 Equity Plaza, Singapore 049705",
    "Investment Permitted Address":
      "Building No.8,1st Floor,MICT Park, University Campus., Hlaing, YANGON",
  },
  {
    ID: 1372,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. KIM SOOHUN",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "GOLDENBERG MYANMAR INTERNATIONAL  COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "885/2015",
    "Permit Date": "2015-01-06T07:47:24Z",
    "Meeting Number": "29/2014",
    "Meeting Date": "2014-12-26T07:47:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING  OF BAGS ON CMP BASIS   ",
    "Amount Of Foreign Capital USD (in Millions)": 0.503,
    "Total Amount Of Capital (in Millions)": 0.503,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "U Saw Aung",
    "Land Area (units not specified in file)": 0.716,
    "Lease Term": 30,
    "Annual Lease Fee": 0.014,
    "Land Use Premium": null,
    "Number Of Local Employees": 380,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "1-13-12-3F, BAKURO-CHO, NIHONBASHI, CHUO-KU, TOKYO. 103-0002 JAPAN",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 277,284,285 ,  MYAY TAING BLOCK NO. 42 , SET HMU (6) STREET, SHWE PYI THAR TOWNSHIP, YANGON REGION. ",
  },
  {
    ID: 1373,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ခင်ခင်ချို",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Stellar Star \tCompany Limited  ",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1084/2015",
    "Permit Date": "2015-09-21T08:02:35Z",
    "Meeting Number": "16/2015",
    "Meeting Date": "2015-09-11T08:02:46Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Contract Manufacturing   Process (CMP) စနစ်ဖြင့် ပလတ်စတစ်အိတ် အမျိုးမျိုးထုတ်လုပ်ခြင်းလုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": 0.085,
    "Total Amount Of Capital (in Millions)": 500,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးစိုးမြင့်",
    "Land Area (units not specified in file)": 1.364,
    "Lease Term": 3,
    "Annual Lease Fee": 27.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 41,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၅၁၊ ရွှေွှတောင်တန်းလမ်း၊ လမ်းမတော်မြို့နယ် ၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No(56), Myay Taing Block No(42), Corner of Sat Hmu(2)Street and Ingyin Myaing Street, Shwe Pyi Thar Industrial Zone(1) , Shwepyithar, Yangon",
  },
  {
    ID: 1374,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. KIM HYUN JUN   ",
    "Name of Principal Organization": "YOUNG IN ENGINEERING CO.,LTD.",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "MYD INTERNATIONAL  COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1197/2016",
    "Permit Date": "2016-11-13T08:19:35Z",
    "Meeting Number": "21/2016",
    "Meeting Date": "2016-11-12T08:19:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING, INSTALLATION AND MARKETING OF ELECTRIC CONTROL PANEL AND SWITCHGEAR PANEL",
    "Amount Of Foreign Capital USD (in Millions)": 4.05,
    "Total Amount Of Capital (in Millions)": 4.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Shwe Wah Oo & Daw Su Phyo Aung",
    "Land Area (units not specified in file)": 3.972,
    "Lease Term": 50,
    "Annual Lease Fee": 0.09,
    "Land Use Premium": null,
    "Number Of Local Employees": 34,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "NAMSAN DONGIL HIGHVILLE, 103-1202, 22 YEOMBAT-RO, CHUNGJU-SI CHUNGCHEONGBUK-DO, REPUBLIC OF KOREA",
    "Organization Address":
      "#113, SUNTECHCITY 513-15, SANGDEAWON-DONG, JUNGWON-GU, SEONGNAM, GYEONGGI, REPUBLIC OF  KOREA                      ",
    "Investment Permitted Address":
      "PLOT NO. 26 & 28, MYAY TAING BLOCK NO.24, NGWE PIN LEL INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1376,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးသတိုးဟိန်း",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": " MYANMA AWBA GROUP COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1111/2015",
    "Permit Date": "2015-12-19T03:08:41Z",
    "Meeting Number": "22/2015",
    "Meeting Date": "2015-12-11T03:08:55Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "ဓာတ်မြေသြဇာ ထုတ်လုပ်ရောင်းချခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.879,
    "Total Amount Of Capital (in Millions)": 6373.67,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "စိုက်ပျိုးရေး ဦးစီးဌာန၊ လယ်ယာစိုက်ပျိုးရေးနှင့် ဆည်မြောင်းဝန်ကြီးဌာန",
    "Land Area (units not specified in file)": 7.4,
    "Lease Term": 10,
    "Annual Lease Fee": 25,
    "Land Use Premium": null,
    "Number Of Local Employees": 226,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၆၅/အေ၊ တက္ကသိုလ်ရိပ်သာလမ်း၊ ရွှေတောင်ကြား (၁) ရပ်ကွက်၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No.(95-A), Kyaik Wine Pagoda Road,(8th)Miles, Mayangone, YANGON",
  },
  {
    ID: 1377,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. KIM JANGSUB",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "WHITE CRANE TEXTILE COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "836/2014",
    "Permit Date": "2014-10-31T03:54:09Z",
    "Meeting Number": "23/2014",
    "Meeting Date": "2014-10-10T03:54:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "PRODUCTION OF GARMENT ON CMP BASIS  ",
    "Amount Of Foreign Capital USD (in Millions)": 0.642,
    "Total Amount Of Capital (in Millions)": 0.642,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Tun @ U Maung Khwe",
    "Land Area (units not specified in file)": 0.913,
    "Lease Term": 30,
    "Annual Lease Fee": 0.02,
    "Land Use Premium": null,
    "Number Of Local Employees": 453,
    "Number Of Foreign Employees": 16,
    Status: "Monitoring Approved",
    "Investor Address":
      "DONGHO 38B/D. 3F, 385-3, SHINDANG 2 – DONG, CHUNG- GU, SEOUL , KOREA. ",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.92, KANAUNG MINTHARGYI STREET, HLAING THARYAR INDUSTRIAL ZONE (1), HLAING THARYAR TOWNSHIP,  YANGON REGION",
  },
  {
    ID: 1379,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Htay Aung",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "C.D Industries & Construction Co.,Ltd. ",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "MaNaTha-054/97",
    "Permit Date": "1997-01-03T03:31:09Z",
    "Meeting Number": "19/96",
    "Meeting Date": "1996-12-20T03:32:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Wood Basic Industry",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 67.3,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "C.D Industres& Construction Co.,Ltd.",
    "Land Area (units not specified in file)": 5.264,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": 26.32,
    "Number Of Local Employees": 200,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.-23(B/8), ThuKhaWaddy Road, YanKin Township, Yangon\n ",
    "Organization Address": "",
    "Investment Permitted Address":
      "No. 105(B), Parami Rd, Chawtwingone, Mayangone, YANGON",
  },
  {
    ID: 1380,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဆောင်ညွှန်ကြားရေးမှူး၊ မြန်မာ့သင်ဘောကျင်းလုပ်ငန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MS Woodwork Co.,Ltd.",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "MaNaTha-040/96",
    "Permit Date": "1996-09-30T04:45:17Z",
    "Meeting Number": "13/96",
    "Meeting Date": "1996-08-23T04:50:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်ကုန်ခေ ျာပစ္စည်းများထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 22.67,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "မြန်မာ့သင်္ဘောကျင်းလုပ်ငန်း",
    "Land Area (units not specified in file)": 2.25,
    "Lease Term": 15,
    "Annual Lease Fee": 0.946,
    "Land Use Premium": null,
    "Number Of Local Employees": 106,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "Sinmalike Quarter, KamarYut Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Sinmalike Quarter, KamarYut Township, Yangon",
  },
  {
    ID: 1381,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. NGO KIEN CUONG  ",
    "Name of Principal Organization": "BA AN JOINT STOCK COMPANY",
    "Place of Incorporation": "Vietnam",
    "Company Name In Myanmar": "Ba An Myanmar Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "975/2015",
    "Permit Date": "2015-07-02T06:29:26Z",
    "Meeting Number": "11/2015",
    "Meeting Date": "2015-06-19T06:29:46Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF  PLASTIC PIPE AND RESIN",
    "Amount Of Foreign Capital USD (in Millions)": 1.184,
    "Total Amount Of Capital (in Millions)": 2.322,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 18,
    "Investing Country": "Vietnam",
    "Form Of Investment": "JV",
    "Land Owner": "U Hla Shwe",
    "Land Area (units not specified in file)": 1.783,
    "Lease Term": 18,
    "Annual Lease Fee": 0.036,
    "Land Use Premium": null,
    "Number Of Local Employees": 82,
    "Number Of Foreign Employees": 15,
    Status: "Monitoring Approved",
    "Investor Address":
      "THANH CHAU WARD, PHU LY CITY, HA NAM PROVINCE, VIETNAM",
    "Organization Address":
      "NO.68, QUAN NHAN STREET, NHAN CHINH WARD, THANH XUAN DISTRICT, HANOI CITY, VIETNAM              ",
    "Investment Permitted Address":
      "PLOT NO. 59, MYAUNG  DAKAR STEEL INDUSTRIAL ZONE, HMAWBI TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1382,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ngo Kien Cuong",
    "Name of Principal Organization": "BA AN JOINT STOCK COMPANY",
    "Place of Incorporation": "Vietnam",
    "Company Name In Myanmar": "BA AN TECHNOLOGY LIMITED\t",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1114/2016",
    "Permit Date": "2016-03-26T07:24:58Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T07:25:14Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF HOT DIP GALVANIZED PRODUCTS (SUCH AS FRAMES, BOLTS AND NUTS, LADDERS, GUARD RAIL, GALVANIZED STEEL POLE, CONCRETE MIXER AND WHEELBARROW) AND INSTALLATION  ",
    "Amount Of Foreign Capital USD (in Millions)": 1.69,
    "Total Amount Of Capital (in Millions)": 1.69,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Vietnam",
    "Form Of Investment": "FDII",
    "Land Owner": "U Hla Shwe",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 10,
    "Annual Lease Fee": 0.02,
    "Land Use Premium": null,
    "Number Of Local Employees": 102,
    "Number Of Foreign Employees": 15,
    Status: "Monitoring Approved",
    "Investor Address":
      "THANH CHAU WARD, PHU LY CITY, HA NAM PROVINCE, VIETNAM",
    "Organization Address":
      "NO.68, QUAN NHAN STREET, NHAN CHINH WARD, THANH XUAN DISTRICT, HANOI CITY, VIETNAM              ",
    "Investment Permitted Address":
      "PLOT NO. 59, MYAUNG  DAKAR STEEL INDUSTRIAL ZONE, HMAWBI TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1383,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Zaw Zaw",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Max Myanmar Hotel Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1037/2015",
    "Permit Date": "2015-03-17T07:41:28Z",
    "Meeting Number": "43/2014",
    "Meeting Date": "2014-11-03T07:44:00Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Service",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 51143.25,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 122,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 172,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "No-19(c), kokkaing yeiktha Road, Golden Valley Ward No(2), Bahan T/S, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.123, Alanpya Pagoda Road, Dagon T/S, Yangon",
  },
  {
    ID: 1384,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kun Naung Myint Wai",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Wa Minn Properties Development Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "manatha 892/2013",
    "Permit Date": "2013-03-13T08:15:36Z",
    "Meeting Number": "10/2013",
    "Meeting Date": "2013-03-13T08:16:41Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "construction & Leasing of residence, office & commercial building",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 76000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Defence",
    "Land Area (units not specified in file)": 2.414,
    "Lease Term": 50,
    "Annual Lease Fee": 0.98,
    "Land Use Premium": 6640000,
    "Number Of Local Employees": 122,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "No-669(c), Myakantha Street, Pyay Road, Kamayut T/S, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.45, Manawhari ,  Ahlone Road , Dagon T/S, Yangon",
  },
  {
    ID: 1385,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကျော်ဇင်လင်း ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Han Htay Aung Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "၁၀၆၁/၂၀၁၅",
    "Permit Date": "2015-08-06T08:27:51Z",
    "Meeting Number": "၁၃/၂၀၁၅",
    "Meeting Date": "2015-07-17T08:28:23Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "စက်မှုကုန်ကြမ်းများ (Na2CO3 , NH4Cl နှင့်  HCl )   ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.47,
    "Total Amount Of Capital (in Millions)": 1175,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Han Htay Aung Co., Ltd. ",
    "Land Area (units not specified in file)": 3.594,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 74,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(အေ-၅၁)၊ ကန့်ကော်လမ်း၊ (၁)ရပ်ကွက်၊ မရမ်းကုန်းမြို့နယ်၊  ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ မှော်ဘီမြို့နယ်၊ မြောင်းတကာ စက်မှု ဇုန်၊ မြေကွက်အမှတ်(၂၅၁၊၂၅၂၊၂၉၃)  ",
  },
  {
    ID: 1386,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. XU, HAIQUAN",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Landson (Myanmar) Garment Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1115/2016",
    "Permit Date": "2016-03-26T08:29:52Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T08:30:14Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.37,
    "Total Amount Of Capital (in Millions)": 2.37,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner":
      "U Tin Maung Thein, Daw Than Than Aye, U Tin Maung Zaw & U Tin Maung Myint",
    "Land Area (units not specified in file)": 2.75,
    "Lease Term": 20,
    "Annual Lease Fee": 0.058,
    "Land Use Premium": null,
    "Number Of Local Employees": 1072,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "Building No.16, Room 401, Shanghai Road, No.5, Weihai City, Shandong Province, People's Republic Of China",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No.131, Myay Taing Block No.51, Thardu kan Industrial Zone, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 1387,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးရုန်းစံ (အဘ-ဦးလီရှင်းကျီ)",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Best Four Company Limited [ဘက်စ်တ်ဖိုး ကုမ္ပဏီလီမိတက်] ",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1075/2015",
    "Permit Date": "2015-08-20T09:40:47Z",
    "Meeting Number": "14/2015",
    "Meeting Date": "2015-08-07T09:41:45Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP  စနစ်ဖြင့်Jacket, Blouse, Skirt, Shirt, Vests နှင့် Pants စသည့် အဝတ်အထည်မျိုးစုံချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.406,
    "Total Amount Of Capital (in Millions)": 629.57,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးပွေဝမ်း၊ ဦးကျော်စိုးမိုး ",
    "Land Area (units not specified in file)": 0.57,
    "Lease Term": 10,
    "Annual Lease Fee": 26,
    "Land Use Premium": null,
    "Number Of Local Employees": 500,
    "Number Of Foreign Employees": 5,
    Status: "Approved",
    "Investor Address":
      "အကွက်(ဆဆ-၁၁)၊ ဦးပိုင်(၁၀)၊ အောင်ပင်လယ်ရပ်၊ ချမ်းမြသာစည် မြို့နယ်၊ မန္တလေးမြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက် အမှတ်(၄)၊ မြေတိုင်းရပ်ကွက် အ‌မှတ်(၂၄)၊ ငွေပင်လယ်စက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်း ဒေသကြီး",
  },
  {
    ID: 1388,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Dong Jixian",
    "Name of Principal Organization": "Qingdao Handsome Garments Co., Ltd.",
    "Place of Incorporation": "People's Republic of China",
    "Company Name In Myanmar": "Myanmar Dongtai Garments Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1001/2015",
    "Permit Date": "2015-08-20T03:51:13Z",
    "Meeting Number": "14/2015",
    "Meeting Date": "2015-08-07T03:51:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.7638,
    "Total Amount Of Capital (in Millions)": 0.7638,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Aye Kwal",
    "Land Area (units not specified in file)": 2.219,
    "Lease Term": 30,
    "Annual Lease Fee": 0.049,
    "Land Use Premium": null,
    "Number Of Local Employees": 514,
    "Number Of Foreign Employees": 12,
    Status: "Monitoring Approved",
    "Investor Address":
      "1-2-402 No. 85, Wenhua Road, Jiaonan, Qingdao, People's Republic of China",
    "Organization Address":
      "No.89, Langyatai South Road, Jiaonan City, Qingdao, People's Republic of China",
    "Investment Permitted Address":
      "Plot No. 18, Myay Taing Block No.143/1, Kyan Sitthar Yeik Mon Inudustrial Zone-1, Dagon Myothit (South) Township, Yangon Region",
  },
  {
    ID: 1389,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Naung Kun Myint Wai",
    "Name of Principal Organization": "Wa Minn Group of Companies Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": " WM QUAN DAT COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1196/2016",
    "Permit Date": "2016-11-13T04:06:58Z",
    "Meeting Number": "21/2016",
    "Meeting Date": "2016-11-12T04:07:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing, Fabricating, Installation and sales of Aluminium, Glass and Facade",
    "Amount Of Foreign Capital USD (in Millions)": 0.3,
    "Total Amount Of Capital (in Millions)": 0.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Vietnam",
    "Form Of Investment": "JV",
    "Land Owner": "U Win Myint",
    "Land Area (units not specified in file)": 1.119,
    "Lease Term": 10,
    "Annual Lease Fee": 0.086,
    "Land Use Premium": null,
    "Number Of Local Employees": 50,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 669/C, Myakanthar Road, Ward No.2, Kamayut Township, Yangon.",
    "Organization Address":
      "No. 116, Thamine Station Road, Quarter 2, Mayangone Township,  Yangon",
    "Investment Permitted Address":
      "No. (116), Thamine Station Road, (2) Ward, Mayangone Township, Yangon.",
  },
  {
    ID: 1390,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. WONHO  SEO  ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "SEO HO INTERNATIONAL COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1111/2016",
    "Permit Date": "2016-03-26T04:23:54Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T04:24:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENTS ON CMP  BASIS   ",
    "Amount Of Foreign Capital USD (in Millions)": 0.51,
    "Total Amount Of Capital (in Millions)": 0.51,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Hlaing Myint  Oo",
    "Land Area (units not specified in file)": 0.69,
    "Lease Term": 20,
    "Annual Lease Fee": 0.015,
    "Land Use Premium": null,
    "Number Of Local Employees": 1042,
    "Number Of Foreign Employees": 12,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 401-3, DUK KOK, DONG, SONG-TAN CITY, KYUNG KI-DO, REPUBLIC OF  KOREA",
    "Organization Address": "",
    "Investment Permitted Address":
      "ဦးပိုင်အမှတ်-၂၁+အာ+ အနောက် ၇+ အနောက် အက်စ်+ ƒ၊ ကွင်းအမှတ်-၆/၂၊ ပြည်တော်သာကျေးရွာအုပ်စု၊ လှည်းကူးမြို့နယ်၊ ရန်ကုန်မြောက်ပိုင်းခရိုင်၊ ရန်ကုန်တိုင်းဒေသကြီး။",
  },
  {
    ID: 1391,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "   ဦးသက်ဦး ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "သိဒ္ဓိထက်ရောင်းဝယ်ရေး ကုမ္ပဏီ လီမိတက် ",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "၁၀၅၃/၂၀၁၅",
    "Permit Date": "2015-05-07T04:24:18Z",
    "Meeting Number": "၆/၂၀၁၅",
    "Meeting Date": "2015-04-03T04:23:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အမျိုးသား၊ အမျိုးသမီး၊ ကလေးနှင့် လူကြီးစီး Shoes၊ Slipper နှင်‌့ Sandals ဖိနပ်များ ထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း  ",
    "Amount Of Foreign Capital USD (in Millions)": 0.413,
    "Total Amount Of Capital (in Millions)": 2000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "စက်မှုဝန်ကြီးဌာန၊ အမှတ်(၃)အကြီးစားစက်မှုလုပ်ငန်း (ယခင်စက္ကူနှင့်အိမ်သုံးပစ္စည်းလုပ်ငန်း)",
    "Land Area (units not specified in file)": 7.819,
    "Lease Term": 50,
    "Annual Lease Fee": 36,
    "Land Use Premium": null,
    "Number Of Local Employees": 237,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၅)၊ (၁၅)လမ်း၊ (၇)ရပ်ကွက်၊ လမ်းမတော်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ လှိုင်မြို့နယ်၊      ၁၄ ရပ်ကွက် ၊ အုတ်ကျင်းဘူတာရုံလမ်း၊ ကြွေရည်စိမ်ပစ္စည်းစက်ရုံခွဲ(လှိုင်)",
  },
  {
    ID: 1392,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးသတိုးဟိန်း",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Myanma Awba Group Company Limited (မြန်မာ့သြဘာအုပ်စုကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1105/2015",
    "Permit Date": "2015-12-01T04:49:16Z",
    "Meeting Number": "20/2015",
    "Meeting Date": "2015-11-13T04:49:27Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "စိုက်ပျိုးရေးသုံးဆေးများ ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 6.45,
    "Total Amount Of Capital (in Millions)": 17291.5,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "လယ်ယာစိုက်ပျိုးရေးနှင့် ဆည်မြောင်းဝန်ကြီးဌာန၊ စိုက်ပျိုးရေး ဦးစီးဌာန",
    "Land Area (units not specified in file)": 126.13,
    "Lease Term": 10,
    "Annual Lease Fee": 0.126,
    "Land Use Premium": null,
    "Number Of Local Employees": 2002,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၆၅/အေ)၊ တက္ကသိုလ်ရိပ်သာလမ်း၊ ရွှေတောင်ကြား (၁) ရပ်ကွက်၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No.(95-A), Kyaik Wine Pagoda Road,(8th)Miles, Mayangone, YANGON",
  },
  {
    ID: 1394,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်လင်ပေါခင် (ခ) ဒေါ်သန်းသန်းအေး(ခ)ဒေါ်သော်တာဇင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "အီဗွာ စတီး(လ်) ကုမ္ပဏီလီမိတက််",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1080/2015",
    "Permit Date": "2015-09-05T07:37:34Z",
    "Meeting Number": "15/2015",
    "Meeting Date": "2015-08-21T07:38:40Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အလူဇင့်ရောင်စုံအမိုးသွပ်ပြားနှင့် စီနှင့်ဇက်မျှားတန်း ထုတ်လုပ်ခြင်းလုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": 3.001,
    "Total Amount Of Capital (in Millions)": 3200,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်လင်ပေါခင် (ခ) ဒေါ်သန်းသန်းအေး(ခ)ဒေါ်သော်တာဇင်",
    "Land Area (units not specified in file)": 2.011,
    "Lease Term": 15,
    "Annual Lease Fee": 78,
    "Land Use Premium": null,
    "Number Of Local Employees": 91,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၅၈)၊ ကလောလမ်း၊ (၁၄)ရပ်ကွက်၊ လှိုင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၂၂)၊ လှိုင်သာယာ စက်မှုဇုန်အပိုင်း(၃)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1395,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ecterra Pyay Pte.  Ltd.",
    "Name of Principal Organization": "Ecterra Pyay Pte. Ltd.",
    "Place of Incorporation": "Republic of Singapore",
    "Company Name In Myanmar": "Ecterra Agriculture Co.,Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "082/2018",
    "Permit Date": "2018-05-17T07:20:24Z",
    "Meeting Number": "6/2018",
    "Meeting Date": "2018-05-12T07:21:19Z",
    Sector: "Agriculture",
    "Type Of Investment Business":
      "Cultivation, Production and Sales of Agriculture Commodities including Rice, Corn, Beans & Pulses, Sugar Cane, Oilseed crops and other cash crops",
    "Amount Of Foreign Capital USD (in Millions)": 5.15,
    "Total Amount Of Capital (in Millions)": 5.65,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "U Aung Moe Kyaw, U Win Sein, U Myint Shwe",
    "Land Area (units not specified in file)": 3995.62,
    "Lease Term": 50,
    "Annual Lease Fee": 10000,
    "Land Use Premium": null,
    "Number Of Local Employees": 40,
    "Number Of Foreign Employees": 3,
    Status: "Approved",
    "Investor Address":
      "190 Middle Road# 16-01, Fortune Centre, Singapore 188979",
    "Organization Address": "190 Middle Road# 16-01",
    "Investment Permitted Address":
      "No.33,6,1/2 Mile, Pyay Road, Hlaing Township, Yangon",
  },
  {
    ID: 1397,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. PHONGTRON KA VANNA",
    "Name of Principal Organization": "MYANMAR C.P LIVESTOCK CO., LTD",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "MYANMAR C P LIVESTOCK COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "080/2018",
    "Permit Date": "2018-02-14T07:40:35Z",
    "Meeting Number": "2/2018",
    "Meeting Date": "2018-02-02T07:55:40Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business": "LAYER FARM AND SALES OF CHICKEN",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 606.15,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung San Oo",
    "Land Area (units not specified in file)": 5.19,
    "Lease Term": 20,
    "Annual Lease Fee": 5460000,
    "Land Use Premium": null,
    "Number Of Local Employees": 10,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "69/94, MOO10WATCHANMUANG PITSANUL OK  65000, THAILAND ",
    "Organization Address":
      "135, PYAY ROAD, 81/2 MILE, MAYANGONE TOWNSHIP, YANGON ",
    "Investment Permitted Address":
      "135, Pyay Road, 8 1/2 Mile., Mayangone, YANGON",
  },
  {
    ID: 1399,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yau Biu Fu",
    "Name of Principal Organization": "Yuen Hung International Co., Ltd.",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Yuan Hong Garment Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1116/2016",
    "Permit Date": "2016-03-26T03:48:08Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T03:48:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 5.02,
    "Total Amount Of Capital (in Millions)": 5.02,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner":
      "U Aung Phyo @ U Myint Thu @ U Sai Lone & Ma Schu Lone @ Daw Aye Aye Win",
    "Land Area (units not specified in file)": 2.342,
    "Lease Term": 10,
    "Annual Lease Fee": 0.15,
    "Land Use Premium": null,
    "Number Of Local Employees": 483,
    "Number Of Foreign Employees": 8,
    Status: "Monitoring Approved",
    "Investor Address":
      "Flat D16/F, Blk 38 Laguna City, Kwun Tong Kowloon District, Hong Kong.",
    "Organization Address":
      "Flat J, 2/F BLK 2 Golden Dragon Industrial Centre 162-170 Tai Lin Pai Road, Kwai Chung, Hong Kong",
    "Investment Permitted Address":
      "Plot No. 94+95, Myay Taing Block No. 25, ShweLinBan Setmhu Myo, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 1400,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw Lway Lway",
    "Name of Principal Organization":
      "Yangon Crown Wire And Electric Cable Product Factory Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Yangon Crown Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1022/2015",
    "Permit Date": "2015-12-10T04:04:29Z",
    "Meeting Number": "17/2015",
    "Meeting Date": "2015-09-18T04:05:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Distribution of Mild Steel Road",
    "Amount Of Foreign Capital USD (in Millions)": 1.7,
    "Total Amount Of Capital (in Millions)": 3.4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Lway Lway",
    "Land Area (units not specified in file)": 20.487,
    "Lease Term": 50,
    "Annual Lease Fee": 0.422,
    "Land Use Premium": null,
    "Number Of Local Employees": 873,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 1066,Pan Hlaing  Street, Yetakhon Tower, Say/Nyein Ward, Kyimyindine Township, Yangon Township",
    "Organization Address":
      "No.66, Pantinwun U Shwe Bin Street, Shwe Pyi Thar Industrial  Zone-3, Shwe Pyi Thar Township, Yangon Region",
    "Investment Permitted Address":
      "Plot No. 211,212,213,214,215,216,232,233,234,235,236, Myaung Takar Steel Industrial Zone, Hmawbi Township, Yangon Region",
  },
  {
    ID: 1401,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Sunwoo Dongchul",
    "Name of Principal Organization": "Sundo Apparel Co., Ltd.",
    "Place of Incorporation": "Korea",
    "Company Name In Myanmar": "Best A Garment Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1117/2016",
    "Permit Date": "2016-03-26T04:24:16Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T04:24:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3.55,
    "Total Amount Of Capital (in Millions)": 3.55,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Sai Win Tun",
    "Land Area (units not specified in file)": 2.155,
    "Lease Term": 10,
    "Annual Lease Fee": 0.045,
    "Land Use Premium": null,
    "Number Of Local Employees": 1032,
    "Number Of Foreign Employees": 16,
    Status: "Monitoring Approved",
    "Investor Address":
      "402-306 Sae BUL APT, Bundangdong Bundangku Kyungkido, Republic of Korea",
    "Organization Address":
      "# 101, Dong-E Building, 725-34, Yeoksam-Dong, Gangnam- GU, Seoul, Republic of Korea",
    "Investment Permitted Address":
      "Plot No. 403, Myay Taing Block No. 25, ShweLinBan Setmhu Myo, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 1402,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhao Xuefu",
    "Name of Principal Organization": "Suzhou Wanli Knitting Co., Ltd.",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Wan He Garment Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "947/2015",
    "Permit Date": "2015-05-07T03:12:22Z",
    "Meeting Number": "6/2015",
    "Meeting Date": "2015-04-03T03:12:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Designs of Knitted Wear On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 8.839,
    "Total Amount Of Capital (in Millions)": 8.839,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Htay Yin, Daw Hnin Myat Htwe",
    "Land Area (units not specified in file)": 11.26,
    "Lease Term": 50,
    "Annual Lease Fee": 0.236,
    "Land Use Premium": null,
    "Number Of Local Employees": 4125,
    "Number Of Foreign Employees": 50,
    Status: "Monitoring Approved",
    "Investor Address":
      "Ducun, Linhu Town, Wuzhong District, Suzhou City, Peples' Republic of China",
    "Organization Address":
      "Ducun, Linhu Town, Wuzhong District, Suzhou City, Peples' Republic of China",
    "Investment Permitted Address":
      "No. 630 HLE Ngoke Chaung Kwin, Plot No. 56+57+58, HLE Ngoke Chaung Village Tract, Hmawbi Township, Yangon Region",
  },
  {
    ID: 1403,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Naing Win Aung",
    "Name of Principal Organization": "Tek Nay Wunn Ni Manufacturing Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Tek Nay Wunn Ni Manufacturing Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1005/2015",
    "Permit Date": "2015-09-05T07:53:07Z",
    "Meeting Number": "15/2015",
    "Meeting Date": "2015-08-21T07:53:27Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.449,
    "Total Amount Of Capital (in Millions)": 0.642,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "U Myo Kyi & Daw Tin Tin Myint",
    "Land Area (units not specified in file)": 2.204,
    "Lease Term": 10,
    "Annual Lease Fee": 0.047,
    "Land Use Premium": null,
    "Number Of Local Employees": 488,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.45, 4TH Floor (Right), Thamardeihti Street, Htay Kywe (KA) Ward, Tamwe Township, Yangon",
    "Organization Address":
      "Plot No. 55, Myay Taing Block No. 25, Shwe Lin Ban Industrial City, Hlaing Thar Yar Township, Yangon Region",
    "Investment Permitted Address":
      "Plot No. 55, Myay Taing Block No. 25, Shwe Lin Ban Industrial City, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 1404,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Akio Wada",
    "Name of Principal Organization": "Watz Co., Ltd.",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Yangon Fukuyama Apparel Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1006/2015",
    "Permit Date": "2015-09-05T09:03:16Z",
    "Meeting Number": "15/2015",
    "Meeting Date": "2015-08-21T09:03:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.842,
    "Total Amount Of Capital (in Millions)": 0.842,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myo Oo, U Htay Oo & U Tin Oo",
    "Land Area (units not specified in file)": 1.201,
    "Lease Term": 10,
    "Annual Lease Fee": 0.108,
    "Land Use Premium": null,
    "Number Of Local Employees": 940,
    "Number Of Foreign Employees": 16,
    Status: "Monitoring Approved",
    "Investor Address": "3-27-3, Narita-Higashi, Suginami, Tokyo, Japan",
    "Organization Address":
      "3-12-5 Kusado-Cho, Fukuyama City, Hiroshima, Japan",
    "Investment Permitted Address":
      "Plot No. 19/1, 349, Kanaung Min Thar Gyi St., Shwe Pauk Kan Industrial Zone,Yangon Region",
  },
  {
    ID: 1405,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kim Hyuk Kee",
    "Name of Principal Organization": "Seinus Company Limited",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "Seinus Cliq Fashion Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "948/2015",
    "Permit Date": "2015-05-07T09:51:39Z",
    "Meeting Number": "6/2015",
    "Meeting Date": "2015-04-03T09:51:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.8,
    "Total Amount Of Capital (in Millions)": 0.8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Myint Myint Htay",
    "Land Area (units not specified in file)": 0.87,
    "Lease Term": 30,
    "Annual Lease Fee": 0.024,
    "Land Use Premium": null,
    "Number Of Local Employees": 800,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "5 FL, Hyonduk B/D, 790-18, Yeoksam-Dong, Kangnam-Gu, Seoul, 135 080 Republic of Korea",
    "Organization Address":
      "(Yeoksam-Dong, 5FL, Hyonduk B/D) 20, Nonhyeon-RO 71-GIL, GAngnam-Gu, Seoul, Republic of Korea",
    "Investment Permitted Address":
      "Plot No. 21, Yangon Industrial Zone, North Okkalapa Township, Yangon Region",
  },
  {
    ID: 1406,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Win Swe",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Win & WIn Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "MaNaTha-921/2013",
    "Permit Date": "2013-07-31T07:03:24Z",
    "Meeting Number": "18/2013",
    "Meeting Date": "2013-07-10T07:03:45Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် ဟိုတယ်တည်ဆောက်ခြင်းနှင့် ဟိုတယ်ဝန်ဆောင်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 3091.43,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 60,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "Ministry of Industry",
    "Land Area (units not specified in file)": 17.17,
    "Lease Term": 30,
    "Annual Lease Fee": 18,
    "Land Use Premium": 150,
    "Number Of Local Employees": 74,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Number 6 , 6 miles, Pyay Road, Hlaing Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Number 19, 7 miles, Pyay Road, Mayangone Township",
  },
  {
    ID: 1407,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Bo Bo Lin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Hnin Thazin Construction Co., Ltd.",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "MaNaTha-805/2011",
    "Permit Date": "2011-03-28T03:58:21Z",
    "Meeting Number": "8/2011",
    "Meeting Date": "2011-02-25T04:00:07Z",
    Sector: "Construction",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် လမ်းပြုပြင်ဖောက်လုပ်၍ လမ်းတံတား အသုံးပြုခ ကောက်ခံခြင်း လုပ်ငန်း (ဂွေးချို-ချောက်-ဆိပ်ဖြူ-ပခုက္ကူ လမ်းအပိုင်း)",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 4100,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 36,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Number 31, 7 Miles., Pyay Road, Mayangone Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Number B-5, Shwegantgaw Road, Shwemalar Residence , Kamaryut Township, Yangon",
  },
  {
    ID: 1408,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. IMAI  MOTOKAZU  ",
    "Name of Principal Organization": "REEBLUE INTERNATIONAL LIMITED",
    "Place of Incorporation": "THE  UNITED  KINGDOM",
    "Company Name In Myanmar": "REEBLUE  MYANMAR  LIMITED\t ",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "957/2015",
    "Permit Date": "2015-05-29T04:29:23Z",
    "Meeting Number": "9/2015",
    "Meeting Date": "2015-05-18T04:29:51Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENTS ON CMP  BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "United Kingdom of Great Britain and Northern Ireland",
    "Form Of Investment": "FDII",
    "Land Owner": "U Shwe Min",
    "Land Area (units not specified in file)": 1.99,
    "Lease Term": 50,
    "Annual Lease Fee": 0.168,
    "Land Use Premium": null,
    "Number Of Local Employees": 359,
    "Number Of Foreign Employees": 7,
    Status: "Monitoring Approved",
    "Investor Address": "517-1 NAKAGAWA-CHO,  HIGASHI-KU, OKAYAMA-CITY, JAPAN",
    "Organization Address":
      "CHASE BUSSINESS CENTRE 39-41, CHASE SIDE LONDON, ENGLAND,  N 14 5BP",
    "Investment Permitted Address":
      "PLOT NO. 24, MYAY TAING BLOCK NO.65, SHWE PYI THAR INDUSTRIAL ZONE (4), SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1409,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ယာယာ (ခ) ဦးသန်းလွင်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "မန်စာအိုင်းရင်းအင်(န်) စတီးဖယ်ဘရီကေးရှင်းအင်(န်) မန်နျူဖက်ချားရင်ကုမ္ပဏီလီမိတက် (Mansa Iron and Steel Fabrication & Manufacturing Co., Ltd.)",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "မနသ-၁၁၆၀/၂၀၁၆",
    "Permit Date": "2016-03-26T07:54:21Z",
    "Meeting Number": "၁၀/၂၀၁၆",
    "Meeting Date": "2016-03-18T04:32:37Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သံနှင့်သံမဏိပစ္စည်းအမျိုးမျိုး ပြုပြင်ထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 29.225,
    "Total Amount Of Capital (in Millions)": 30225,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ယာယာ (ခ)ဦးသန်းလွင်",
    "Land Area (units not specified in file)": 4.704,
    "Lease Term": 45,
    "Annual Lease Fee": 0.126,
    "Land Use Premium": null,
    "Number Of Local Employees": 200,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်-၃၂၊ နတ်မောက်လမ်း၊ တာမွေမြိုနယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ တောင်ဒဂုံမြို့နယ်၊ စက်မှုဇုန်၊ မြေတိုင်းရပ်ကွက်အမှတ်-၂၃၊ မြေကွက်အမှတ်-၅၂၉/၃၊ ၅၂၉/၄ ",
  },
  {
    ID: 1410,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyaw Htay",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Su Htu Pan Construction Co., Ltd.",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "MaNaTha-757/2010",
    "Permit Date": "2010-08-05T05:34:15Z",
    "Meeting Number": "19/2010",
    "Meeting Date": "2010-06-30T05:35:14Z",
    Sector: "Construction",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် လမ်းပြုပြင်ဖောက်လုပ်၍ လမ်းတံတား အသုံးပြုခ ကောက်ခံခြင်း လုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 7499.8,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 24,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Number 3 and 4, Parami Housing, Hlaing Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Number 2, 10 Yard, Yadanar Road, Thaketa Township, Yangon",
  },
  {
    ID: 1415,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးခွန်နောင်မြင့်ဝေ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "Wa Minn Group of Companies Co., Ltd. (ဝမင်းကုမ္ပဏီများအုပ်စု ကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "မနသ-၁၀၄၄/၂၀၁၅",
    "Permit Date": "2015-04-07T08:07:44Z",
    "Meeting Number": "၃/၂၀၁၅",
    "Meeting Date": "2015-02-27T08:08:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ကြွေရည်စိမ်မီးဖိုချောင်သုံးနှင့် လူသုံးကုန်ပစ္စည်း ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 200,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "စက်မှုဝန်ကြီးဌာန၊ စက္ကူနှင့် အိမ်သုံးပစ္စည်းလုပ်ငန်း",
    "Land Area (units not specified in file)": 0.81,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 150,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-(၆၆၉/စီ)၊ မြကန်သာလမ်း၊ ကမာရွတ်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "-",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ မရမ်းကုန်းမြို့နယ်၊ အမှတ်(၂)ရပ်ကွက်၊ သမိုင်းဘူတာရုံလမ်း၊ ကြွေရည်စိမ်ပစ္စည်းစက်ရုံ",
  },
  {
    ID: 1416,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Fan Qing Fu",
    "Name of Principal Organization": "Purple Mountain Apparel, INC.",
    "Place of Incorporation": "United States of America",
    "Company Name In Myanmar": "Natural Garment Manufacturing Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "896/2015",
    "Permit Date": "2015-02-04T08:41:07Z",
    "Meeting Number": "1/2015",
    "Meeting Date": "2015-01-16T08:41:47Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.61,
    "Total Amount Of Capital (in Millions)": 2.61,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "United States of America",
    "Form Of Investment": "FDII",
    "Land Owner": "U Soe Hlaing",
    "Land Area (units not specified in file)": 3.427,
    "Lease Term": 10,
    "Annual Lease Fee": 0.33,
    "Land Use Premium": null,
    "Number Of Local Employees": 986,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address":
      "11 Evergreen Way Glen Head, Ny 11545, United States of America",
    "Organization Address":
      "241 West,37th Street, Suite 1202,New York,NY 10018, United States of America",
    "Investment Permitted Address":
      "Plot No. 507,508, Myay Taing Block No. 25, Shwe Lin Ban Industrial Zone , Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 1417,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Managing Director, Myanma Perennial Crop Enterprise",
    "Name of Principal Organization": "Myanma Perennial Crop Enterprise",
    "Place of Incorporation": "Yangon",
    "Company Name In Myanmar": "Myanmar Singapore Plantation Limited",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "288/1997",
    "Permit Date": "1997-11-04T10:12:59Z",
    "Meeting Number": "15/1997",
    "Meeting Date": "1997-09-12T10:14:08Z",
    Sector: "Agriculture",
    "Type Of Investment Business":
      "Establishing Cashew Plantation & Marketing ",
    "Amount Of Foreign Capital USD (in Millions)": 5.67,
    "Total Amount Of Capital (in Millions)": 40.52,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 10,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": 25,
    "Annual Lease Fee": 8,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "Thiriminglar Avenue, Off Kaba Aye Pagoda Road,Yankin , Yangon",
    "Organization Address":
      "Thiriminglar Avenue, Off Kaba Aye Pagoda Road,Yankin , Yangon",
    "Investment Permitted Address":
      "Minye Dam Site and Schwellong Village, Oktwin Township, Taunggoo District, Bago Division",
  },
  {
    ID: 1419,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chen, Qinghua ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Fu Bai Hong Industrial Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "001/2017",
    "Permit Date": "2017-09-18T17:30:01Z",
    "Meeting Number": "2/2017",
    "Meeting Date": "2017-09-12T17:30:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.18,
    "Total Amount Of Capital (in Millions)": 1.18,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaw Soe, U Tin Soe",
    "Land Area (units not specified in file)": 1.391,
    "Lease Term": 10,
    "Annual Lease Fee": 0.035,
    "Land Use Premium": 0,
    "Number Of Local Employees": 730,
    "Number Of Foreign Employees": 20,
    Status: "Draft",
    "Investor Address":
      "No. 504, Yan Ping Block, Xin Hua 2 nd Road, 32 Street, Nan Ping City",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 4, Myay Taing Block No-113, Industrial Zone",
  },
  {
    ID: 1420,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kim Yongman",
    "Name of Principal Organization": "Kanaan Co., Ltd.",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "Kanaan International Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "863/2014",
    "Permit Date": "2014-12-09T05:30:36Z",
    "Meeting Number": "27/2014",
    "Meeting Date": "2014-11-28T05:31:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Variety of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 10,
    "Total Amount Of Capital (in Millions)": 10,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Khay Mar Kyi",
    "Land Area (units not specified in file)": 3.115,
    "Lease Term": 30,
    "Annual Lease Fee": 0.07,
    "Land Use Premium": null,
    "Number Of Local Employees": 1117,
    "Number Of Foreign Employees": 31,
    Status: "Monitoring Approved",
    "Investor Address":
      "(Jangwi-Dong, Jinhantown)18, Jangwi-Ro 49-Gil, Seongbuk-Gu, Seoul, Republic of Korea",
    "Organization Address":
      "(Geumgok-Dong) 316, Hongyureung-Ro, Namyangju-Si, Gyeonggi-Do, Korea",
    "Investment Permitted Address":
      "Plot No. 235, Myay Taing Quarter No. 49, Wartayar Industrial Zone, Shwe Pyi Tahr Township, Yangon Region",
  },
  {
    ID: 1421,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw Nyo Mie Swe Myint ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Aizawa Myanmar Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "002/2017",
    "Permit Date": "2017-09-18T17:30:00Z",
    "Meeting Number": "2/2017",
    "Meeting Date": "2017-09-12T17:30:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Precast Readymade Concrete and Production of Pile",
    "Amount Of Foreign Capital USD (in Millions)": 0.775,
    "Total Amount Of Capital (in Millions)": 1.55,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Khin Khin Su (a) Daw Khin Su",
    "Land Area (units not specified in file)": 2.002,
    "Lease Term": 30,
    "Annual Lease Fee": 0.042,
    "Land Use Premium": 0,
    "Number Of Local Employees": 20,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address": "No.16, Station Road, Quarter 5, Bauk Htaw",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 374, Myay Taing Block No.49, Watayar Industrial Zone ",
  },
  {
    ID: 1422,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "   ဦးမြင့်သိန်း(ခ)ကြုံလင် ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ရီးဗားကုမ္ပဏီလီမိတက် (REVA COMPANY LIMITED)",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "၁၁၁၅/၂၀၁၆",
    "Permit Date": "2016-01-14T05:55:04Z",
    "Meeting Number": "၂၃/၂၀၁၅",
    "Meeting Date": "2015-12-28T05:55:46Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ အမျိုးသားနှင့် အမျိုးသမီးစီးဖိနပ်များ ထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း(အင်းစိန်ဖော့ကန်စက်ရုံ-၂)",
    "Amount Of Foreign Capital USD (in Millions)": 0.57,
    "Total Amount Of Capital (in Millions)": 8897.01,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "စက်မှုဝန်ကြီးဌာန၊ အမှတ်(၃)အကြီးစား စက်မှုလုပ်ငန်း(ယခင်စက္ကူနှင့်အိမ်သုံးပစ္စည်းလုပ်ငန်း)",
    "Land Area (units not specified in file)": 8.355,
    "Lease Term": 50,
    "Annual Lease Fee": 60,
    "Land Use Premium": null,
    "Number Of Local Employees": 324,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အခန်းအမှတ်(၂၀၃)၊ လိပ်ကန်တာဝါ၊ ဦးရွှေဂွန်းလမ်း၊ ပုဇွန်တောင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "စက်မှုဝန်ကြီးဌာန၊ အမှတ်(၃)အကြီးစား စက်မှုလုပ်ငန်း(ယခင်စက္ကူနှင့်အိမ်သုံးပစ္စည်းလုပ်ငန်း)ပိုင်ရန်ကုန်တိုင်းဒေသကြီး၊ မြောက်ပိုင်း ခရိုင်၊ အင်းစိန်မြို့နယ်၊ ဖော့ကန်ရပ်ကွက်၊ အောက်မင်္ဂလာဒုံလမ်းမကြီး၊ မြေကွက်အမှတ်       ၄၊ ၄၂၊ ၄၃၊ ၅၆ ရှိ ဖိနပ်စက်ရုံခွဲ(ဖော့ကန်) ",
  },
  {
    ID: 1423,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kim Sang Pyo",
    "Name of Principal Organization": "Unitedtex Limited And Texbank Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Unitedtex Overseas Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "862/2014",
    "Permit Date": "2014-12-15T05:51:43Z",
    "Meeting Number": "27/2014",
    "Meeting Date": "2014-11-28T06:00:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.7,
    "Total Amount Of Capital (in Millions)": 0.7,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Best Maker Co., Ltd.",
    "Land Area (units not specified in file)": 1.213,
    "Lease Term": 30,
    "Annual Lease Fee": 0.029,
    "Land Use Premium": null,
    "Number Of Local Employees": 730,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.28 Xingming Road, Suzhou Industrial Park, Suzhou, Jiangsu, Peoples Republic of China",
    "Organization Address":
      "Unit 1308-10 13 F Col Tower Wharf T&T Square, 123 Hoi Bun Road Kwun Tong KL",
    "Investment Permitted Address":
      "Plot No.177, Hlaing Tharyar Industrial Zone-1, Hlaing  Tharyar Township, Yangon Region",
  },
  {
    ID: 1425,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wang Rui",
    "Name of Principal Organization": "Wuxi Richang Apparel Co., Ltd.",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Myanmar Yangon Richang Apparel Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "834/2014",
    "Permit Date": "2014-10-31T06:51:09Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T06:52:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.5,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Nita Devi @ Daw Cherry",
    "Land Area (units not specified in file)": 0.36,
    "Lease Term": 10,
    "Annual Lease Fee": 0.019,
    "Land Use Premium": null,
    "Number Of Local Employees": 557,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "518-7, Zhonghui Road, Huishang District Wuxi, Jiangsu, Republic of China",
    "Organization Address":
      "Wu Xi Hui Shan Economic Development Zone Industrial Park, Standard Factory Building  B District 5, People's Republic of China",
    "Investment Permitted Address":
      "Plot No. 230, Myay Taing Block No.25, Shwe Lin Pan Industrial Zone, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 1426,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Heinrich Engelbert Morsbach",
    "Name of Principal Organization": "Myanmar Veneyard Management Co.,Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Myanmar Vineyard Estate Co.,Ltd",
    "Financial Year From": 2006,
    "Financial Year To": 2007,
    "Permit Number": "424/2007",
    "Permit Date": "2007-10-10T07:53:44Z",
    "Meeting Number": "10/2007",
    "Meeting Date": "2007-03-20T07:54:43Z",
    Sector: "Agriculture",
    "Type Of Investment Business":
      "Making Wine & Grappa, Cultivation of Nursery Vine Plant and Related Marketing and Promoting Activitles",
    "Amount Of Foreign Capital USD (in Millions)": 2.5,
    "Total Amount Of Capital (in Millions)": 2.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Myanmar Agriculture Service",
    "Land Area (units not specified in file)": 3,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": 1000,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "106, SOI Prasarnmitr, Sukhumvit RD, 23/2, Bangkok, Thiland",
    "Organization Address":
      "No.38(G), Myitzu Street, Parami Avenue, MayangoneTsp, Yangon",
    "Investment Permitted Address":
      "No.38(G), Myitzu Street, Parami Avenue, MayangoneTsp, Yangon",
  },
  {
    ID: 1427,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yeh Fu-Yu",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Very Impressive Prospect Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "976/2015",
    "Permit Date": "2015-07-02T08:39:24Z",
    "Meeting Number": "11/2015",
    "Meeting Date": "2015-06-19T08:39:41Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Carbon Composite Sports Equipment Such as Tennis Rackets, Hockey, Sport Bike Frame and Components and Sport Bike Carbon Wheel on Contract Manufacturing Process (CMP) Basis",
    "Amount Of Foreign Capital USD (in Millions)": 5.66,
    "Total Amount Of Capital (in Millions)": 5.66,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Tin Maung Zaw & U Tin Maung Myint",
    "Land Area (units not specified in file)": 2.311,
    "Lease Term": 10,
    "Annual Lease Fee": 0.055,
    "Land Use Premium": null,
    "Number Of Local Employees": 170,
    "Number Of Foreign Employees": 16,
    Status: "Monitoring Approved",
    "Investor Address": "8F-2, 631, SEC.1, Chung De Road, Taichung, Taiwan",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No. 147/148, Myay Taing Block No. 64 (Industry), Shwe Pyi Thar Industrial Zone (3), Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 1428,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ရင်လီရင့်(ခ)ဒေါ်လီလီစမ်း",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Panda Textile Co., Ltd. (ပန်ဒါအထည်လုပ်ငန်း ကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "မနသ-၁၁၃၇/၂၀၁၆",
    "Permit Date": "2016-03-09T09:08:09Z",
    "Meeting Number": "၇/၂၀၁၆",
    "Meeting Date": "2016-02-26T09:08:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ချည်၊ ပိတ်ညို၊ ပိတ်ချောနှင့် ဆေးဆိုးပန်းရိုက်ထည်များ ထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.373,
    "Total Amount Of Capital (in Millions)": 1730,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "စက်မှုဝန်ကြီးဌာန၊ အမှတ်(၃)အကြီးစားစက်မှုလုပ်ငန်း(ယခင် အထည်အလိပ်လုပ်ငန်း)",
    "Land Area (units not specified in file)": 641.75,
    "Lease Term": 50,
    "Annual Lease Fee": 360,
    "Land Use Premium": null,
    "Number Of Local Employees": 1061,
    "Number Of Foreign Employees": 15,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်-၇၅၊ မနော်ဟရီလမ်း၊ ဒဂုံမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "စက်မှုဝန်ကြီးဌာန၊ အမှတ်(၃)အကြီးစားစက်မှုလုပ်ငန်း (ယခင်အထည်အလိပ်လုပ်ငန်း) ပိုင် မန္တလေးတိုင်းဒေသကြီး၊ စဉ့်ကိုင်မြို့နယ်၊ ပလိပ်မြို့၊ အမှတ်(၂)အထည်စက်ရုံ (ပလိပ်)",
  },
  {
    ID: 1429,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမြင့်ရွှေ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "စံကောင်းဘက်မန်နျူဖက်ချားရင်းကုမ္ပဏီလီမိတက်",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "မနသ-၁၀၆၅/၂၀၁၅",
    "Permit Date": "2015-07-10T09:43:51Z",
    "Meeting Number": "၁၁/၂၀၁၅",
    "Meeting Date": "2015-06-19T09:44:36Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ဘိလပ်မြေထည့်သော ပလတ်စတစ်အိတ်အမျိုးမျိုး ထုတ်လုပ်ဖြန့်ဖြူးရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 3.157,
    "Total Amount Of Capital (in Millions)": 4165.774,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးမြင့်ရွှေ၊ ဦးဆိတ်ကီး (ခ) ဦးဝင်းလှိုင်၊ ဒေါ်ကျင်ကျင်",
    "Land Area (units not specified in file)": 8.038,
    "Lease Term": 50,
    "Annual Lease Fee": 97.587,
    "Land Use Premium": null,
    "Number Of Local Employees": 800,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၁၅၄ (အေ)၊ မေယု (၅) လမ်း၊ မြောက်ဥက္ကလာပ မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၀၊ ၁၂၊ ၁၄၊ မြေတိုင်းရပ်ကွက်အမှတ် ၂၄၊ ငွေပင်လယ်စက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန် တိုင်းဒေသကြီး",
  },
  {
    ID: 1430,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးသန်းမြင့် (ခ)ခေါ်တင်အိန်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Oriental Highway Co., Ltd.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "MaNaTha-367/2000",
    "Permit Date": "2000-04-20T04:02:38Z",
    "Meeting Number": "2/2000",
    "Meeting Date": "2000-01-28T04:07:50Z",
    Sector: "Construction",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် လမ်းတံတား ပြုပြင်ဖောက်လုပ်၍ လမ်းအသုံးပြုခကောက်ခံခြင်း လုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 660,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 1601,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Number 45/A, Pyay Road, 11 Yard, Hlaing Township, Yangon.",
    "Organization Address": "",
    "Investment Permitted Address":
      "Number 61-62, Bahosi Development, Wadan Street, Lanmadaw Township, Yangon",
  },
  {
    ID: 1431,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Than Oo",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MANN YADANARPON AIRLINES COMPANY LIMITED",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "Ma Na Tha 953/2014",
    "Permit Date": "2014-01-27T07:10:05Z",
    "Meeting Number": "1/2014",
    "Meeting Date": "2014-01-08T07:11:48Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Domestic and International Air Transport Services",
    "Amount Of Foreign Capital USD (in Millions)": 60.11,
    "Total Amount Of Capital (in Millions)": 60414.56,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Transport and Communications",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 156,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "No. 123, 38th Street, Kyautada Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No. 3, Thalarwaddy Street,7 Miles, , Mayangone Township, YANGON",
  },
  {
    ID: 1432,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aye Ko",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Family Aye Ko Construction Co., Ltd. ",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "MaNaTha-736/2010",
    "Permit Date": "2010-02-19T07:22:59Z",
    "Meeting Number": "44/2009",
    "Meeting Date": "2009-12-15T07:23:13Z",
    Sector: "Construction",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် လမ်းပြုပြင်ဖောက်လုပ်၍ လမ်း၊ တံတား အသုံးပြုခ ကောက်ခံခြင်း လုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 7560.06,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 35,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် (၁၀၀/ဇ)၊ လမ်းသာယာလမ်း၊ ( ရ.က.က)ရပ်ကွက်၊ ပြင်ဦးလွင်မြို့နယ်၊ မန္တလေးမြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "No-38, Zizawar Garden Housing, Than Thumar Road, Ward 15, South Okkalapa Township, Yangon",
  },
  {
    ID: 1434,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Ko Win",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Air Kanbawza Co.,Ltd.",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "Ma Na Tha 773/2011",
    "Permit Date": "2011-06-12T05:41:58Z",
    "Meeting Number": "36/2010",
    "Meeting Date": "2010-10-28T05:42:56Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Domestic and International Air Transport Services",
    "Amount Of Foreign Capital USD (in Millions)": 19.3,
    "Total Amount Of Capital (in Millions)": 2270,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Transport and Communications",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 102,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "No. (615/2), Pyi Street, Mayangone Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.147, Ward No(5) ,Pyay Raod, , Mayangone Township, YANGON",
  },
  {
    ID: 1436,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးစိုးမင်းသန့် ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "မိသားစု စုစည်းစွမ်းအားကုမ္ပဏီလီမိတက်(Family United Power Co., Ltd.)",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "၁၁၄၇/၂၀၁၆",
    "Permit Date": "2016-03-24T06:12:20Z",
    "Meeting Number": "၉/၂၀၁၆",
    "Meeting Date": "2016-03-11T06:14:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အထည်အလိပ်ထုတ်လုပ်ရောင်းချခြင်း လုပ်ငန်းနှင့် နဝလီ(လက်ခစား)ရယူ၍ဆောင်ရွက်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.22,
    "Total Amount Of Capital (in Millions)": 3200,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 35,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "စက်မှုဝန်ကြီးဌာန၊ အမှတ်(၃) အကြီးစား စက်မှုလုပ်ငန်း(ယခင်အထည်အလိပ်လုပ်ငန်း)",
    "Land Area (units not specified in file)": 4.52,
    "Lease Term": 25,
    "Annual Lease Fee": 112,
    "Land Use Premium": 5000000,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အခန်းအမှတ်(၂)၊ အမှတ်(၉)၊ ၁၄လမ်း၊ ၆ရပ်ကွက်၊ လမ်းမတော်မြို့နယ်၊   ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "စက်မှုဝန်ကြီးဌာန၊ အမှတ်(၃) အကြီးစား စက်မှုလုပ်ငန်း(ယခင်အထည်အလိပ်လုပ်ငန်း)ပိုင် ရန်ကုန်တိုင်းဒေသကြီး၊ မရမ်းကုန်းမြို့နယ်၊ ကျိုက်ဝိုင်းဘုရားလမ်း၊ အမှတ် (၈၂/က)၊ မရမ်းကုန်းအထည် စက်ရုံအမှတ်(၁)",
  },
  {
    ID: 1439,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမောင်ကျေး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "VIRTUE LAND COMPANY LIMITED",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "Manatha-888/2013",
    "Permit Date": "2013-02-13T08:51:39Z",
    "Meeting Number": "7/2013",
    "Meeting Date": "2013-02-13T08:52:26Z",
    Sector: "Construction",
    "Type Of Investment Business":
      "BOT  စနစ်ဖြင့် လမ်းပြုပြင်ဖောက်လုပ်၍ လမ်းအသုံးပြုခ ကောက်ခံခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 4.677,
    "Total Amount Of Capital (in Millions)": 19578.037,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 25,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "အမှတ်(စီ-၄)၊ မွန်မြတ်မေတ္တာလုံးခြင်းအိမ်ယာ၊ ပင်ရွှေညောင်လမ်း၊ တာမွေမြို့နယ်",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.(36),Thein Phyu Road, Corner Of Thein Phyu Road and Bogyoke Aung San Road, , Lanmadaw, YANGON",
  },
  {
    ID: 1440,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကျော်စိုးလွင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MYAT NOE THU CONSTRUCTION COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "Manatha 982/2014",
    "Permit Date": "2014-05-28T09:40:03Z",
    "Meeting Number": "13/2014",
    "Meeting Date": "2014-04-26T09:39:25Z",
    Sector: "Construction",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် လမ်းအဆင့်မြှင့်တင်တိုးချဲ့တည်ဆောက်၍ လမ်းအသုံးပြုခ ကောက်ခံခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 8.21,
    "Total Amount Of Capital (in Millions)": 23346.19,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Rejected",
    "Investor Address":
      "အမှတ်(၆၄၇)၊(၈၇) လမ်းနှင့် (၃၇)လမ်းကြား၊ ဟေမမာလာ(မြောက်)၊",
    "Organization Address": "",
    "Investment Permitted Address":
      "Building A1,Room 508,Shwe Gon Thu Housing,Lower Kyee Myin Daing Road, Kyimyindaing, YANGON",
  },
  {
    ID: 1441,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Aung Kyaw ",
    "Name of Principal Organization": "Myanmar WPG Company Limited",
    "Place of Incorporation": "Myanmar ",
    "Company Name In Myanmar": "Myanmar WPG Hotel Company Limited ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "713/2014",
    "Permit Date": "2014-04-09T10:38:50Z",
    "Meeting Number": "10/2014",
    "Meeting Date": "2014-03-19T10:40:37Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel & Tourism ",
    "Amount Of Foreign Capital USD (in Millions)": 9,
    "Total Amount Of Capital (in Millions)": 9,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 16,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV,BOT",
    "Land Owner": "Nay Pyi Taw Development ",
    "Land Area (units not specified in file)": null,
    "Lease Term": 30,
    "Annual Lease Fee": 1.35,
    "Land Use Premium": null,
    "Number Of Local Employees": 108,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 2, Gant Gaw Myaing Street, Ward No. 8, Yankin Township, Yangon ",
    "Organization Address":
      "No. 2,  Gant Gaw Myaing Street, Ward No. 8, Yankin Tsp, Yangon ",
    "Investment Permitted Address":
      "No. 2,  Gant Gaw Myaing Street, Ward No. 8, Yankin Tsp, Yangon ",
  },
  {
    ID: 1442,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Soe Naing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Aye Aye Khaing Construction Co., Ltd.",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "manatha 729/2010",
    "Permit Date": "2010-01-21T11:06:48Z",
    "Meeting Number": "39/2009",
    "Meeting Date": "2009-10-27T11:07:24Z",
    Sector: "Construction",
    "Type Of Investment Business": "BOT Road ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 5807.6,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 75,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address": "No-289, Daewun East Road, Maharaungmyay T/S, Mandalay",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.301, Corner of Kabaaye Pagoda Road & War Yar Latt 2 Street , Ward No 9, Mayangone T/S, Yangon",
  },
  {
    ID: 1443,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wu Ying Hong",
    "Name of Principal Organization": "JOC International Co., Ltd.",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "JOC Myanmar Garments Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "965/2015",
    "Permit Date": "2015-06-18T03:19:19Z",
    "Meeting Number": "10/2015",
    "Meeting Date": "2015-06-05T03:19:39Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments onf CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.782,
    "Total Amount Of Capital (in Millions)": 2.782,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Eain Chunn & Daw Sandar",
    "Land Area (units not specified in file)": 2,
    "Lease Term": 30,
    "Annual Lease Fee": 0.028,
    "Land Use Premium": null,
    "Number Of Local Employees": 723,
    "Number Of Foreign Employees": 12,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 8, South Li Yuan Road, Nanjing City, Jiangsu, Peoples's Republic of china",
    "Organization Address":
      "No. 8, South Li Yuan Road, Jiangning Development Zone Nanjing, Peoples's Republic of china",
    "Investment Permitted Address":
      "Plot No. 5, Myay Taing Block No. E-12, Thar Du Kan Industrial Zone, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 1444,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Maung Kyay",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Asia World Co., Ltd.",
    "Financial Year From": 2011,
    "Financial Year To": 2012,
    "Permit Number": "MaNaTha-814/2011",
    "Permit Date": "2011-11-03T04:04:30Z",
    "Meeting Number": "21/2011",
    "Meeting Date": "2011-10-28T04:05:01Z",
    Sector: "Construction",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် လမ်းပြုပြင်ဖောက်လုပ်၍ လမ်း တံတား အသုံးပြုခများ ကောက်ခံခြင်း လုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 4287.22,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 35,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်(စီ-၄), မွန်မြတ်မေတ္တာလုံးချင်းအိမ်ရာ, ပင်ရွှေညောင်လမ်း၊ တာမွေမြို့နယ်၊ ရန်ကုန်",
    "Organization Address": "",
    "Investment Permitted Address":
      "Number (61-62), Bahosi Development, Wadan Street, Lanmadaw Township, Yangon",
  },
  {
    ID: 1445,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Htun Myint Naing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Asia world Co., Ltd.",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "manatha 711/2009",
    "Permit Date": "2009-11-02T04:12:01Z",
    "Meeting Number": "22/2009",
    "Meeting Date": "2009-06-26T04:13:04Z",
    Sector: "Construction",
    "Type Of Investment Business": "BOT Road",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 22109.3,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 386,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "No.127, between Pannita Road & Insein Road, Ward No 8/9, Hlaing T/S, Yangon ",
    "Organization Address": "",
    "Investment Permitted Address":
      "No 61/62. Bahosi Development, Waden Street, Lanmadaw T/S, Yangon",
  },
  {
    ID: 1446,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Nan Than Htwe",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Kanbawza Pathfinder Industries Ltd. ",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "MaNaTha-709/2009",
    "Permit Date": "2009-11-02T04:31:37Z",
    "Meeting Number": "28/2009",
    "Meeting Date": "2009-08-07T04:31:26Z",
    Sector: "Construction",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် လမ်းပြုပြင်ဖောက်လုပ်၍ လမ်းတံတား အသုံးပြုခ ကောက်ခံခြင်း လုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 27107.62,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 245,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "Number 615/2, Pyay Road, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No. S/S(38), 5th floor, Shwe Tharaphi Yeikmon, Bayint Naung Road, Kamaryut Township, Yangon",
  },
  {
    ID: 1447,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Ye Myint",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Hi Star Co., Ltd.",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "manatha 708/2009",
    "Permit Date": "2009-11-02T04:47:07Z",
    "Meeting Number": "29/2009",
    "Meeting Date": "2009-09-23T04:47:38Z",
    Sector: "Construction",
    "Type Of Investment Business": "BOT Road ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 11402.7,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 109,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "Olampic Tower, 2nd Floor, Strand Road, Ahlone T/S, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Olampic Tower, 2nd Floor, Strand Road, Ahlone T/S, Yangon",
  },
  {
    ID: 1448,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Htun Myint Naing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Asia World Co., Ltd. ",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "MaNaTha-710/2009",
    "Permit Date": "2009-11-02T05:01:34Z",
    "Meeting Number": "22/2009",
    "Meeting Date": "2009-06-26T05:02:05Z",
    Sector: "Construction",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် လမ်းပြုပြင်ဖောက်လုပ်၍ လမ်း တံတား အသုံးပြုခ ကောက်ခံခြင်း လုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 20697.3,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 314,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၁၂၄၊ ပဏ္ဎိတလမ်းနှင့် အင်းစိန် လမ်းထောင့်၊ (၈/၉)ရပ်ကွက်၊ လှိုင်မြို့နယ် ၊ ရန်ကုန်",
    "Organization Address": "",
    "Investment Permitted Address":
      "Number 61-62, Bahosi Development, Wadan Street, Lanmadaw Township, Yangon",
  },
  {
    ID: 1449,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Khon Naung Myint Wai",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Yangon Triple Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1150/2016",
    "Permit Date": "2016-03-24T06:09:25Z",
    "Meeting Number": "9/2016",
    "Meeting Date": "2016-03-11T06:09:47Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Yangon River View Complex (Office, Hotel and Apartment)",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 154880,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "Myanmar Economic Corporation",
    "Land Area (units not specified in file)": 3.169,
    "Lease Term": 50,
    "Annual Lease Fee": 1610070,
    "Land Use Premium": 11.3,
    "Number Of Local Employees": 124,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address": "No.669 (C), Myakanthar Street, Pyay Road, Kamaryut.",
    "Organization Address": "",
    "Investment Permitted Address":
      "Myaytaing No. 23(G), 23(G-1), Plot No. 2 (B), 2(I), Conner of Ahlone street &  Kanar Street, Ahlone Township, Yangon. ",
  },
  {
    ID: 1450,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Ko Win",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MYANMAR AIRWAYS INTERNATIONAL COMPANY LIMITED",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "Ma Na Tha 841/2012",
    "Permit Date": "2012-04-02T06:40:43Z",
    "Meeting Number": "10/2012",
    "Meeting Date": "2012-03-28T06:41:16Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Domestic and International Airline Transports Services",
    "Amount Of Foreign Capital USD (in Millions)": 26,
    "Total Amount Of Capital (in Millions)": 26,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Transport and Communications",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 419,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "No.(147), Room (301), Airport View Tower, Pyay Road,8 1/2 Mile, Mayangone Township, YANGON",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.(147), Room (301), Airport View Tower, Pyay Road,8 1/2 Mile, Mayangone Township, YANGON",
  },
  {
    ID: 1451,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Htun Myint Naing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Asia World Co., Ltd.",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "MaNaTha-253/1999",
    "Permit Date": "1999-05-21T06:55:53Z",
    "Meeting Number": "7/1999",
    "Meeting Date": "1999-04-23T06:56:07Z",
    Sector: "Construction",
    "Type Of Investment Business":
      "သိန္ဒီ-ကွမ်းလုံံ-ချင်းရွှေဟော် လမ်းအပိုင်း ပြုပြင်ဖောက်လုပ်၍ လမ်းတံတား အသုံးပြုခများ ကောက်ခံခြင်း လုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1276,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 1921,
    "Number Of Foreign Employees": null,
    Status: "Amended",
    "Investor Address":
      "အမှတ် ၂၀-၂၃, မစိုးရိမ်ကျောင်းလမ်း၊ ၅ ရပ်ကွက်၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်",
    "Organization Address": "",
    "Investment Permitted Address":
      "Number 61-62, Bahosi Development, Wadan Street, Lanmadaw Township, Yangon",
  },
  {
    ID: 1452,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Thein Tun",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "GOLDEN MYANMAR AIRLINES PUBLIC COMPANY LIMITED",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "Ma Na Tha 877/2013",
    "Permit Date": "2013-01-09T07:47:35Z",
    "Meeting Number": "2/2013",
    "Meeting Date": "2013-01-09T07:50:45Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "လေကြောင်းသယ်ယူပို့ဆောင်ရေး လုပ်ငန်းဆိုင်ရာ ဝန်ဆောင်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.31,
    "Total Amount Of Capital (in Millions)": 21250,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Transport and Communications",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 169,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "No. 52/B, Shwe Taung Gyar 2 Quarter, Bahan Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "3-Floor, Sayarsan Palaza , Corner of New University Avenue , Bahan Township, YANGON",
  },
  {
    ID: 1453,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aye Ko",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Family Aye Ko Construction Co., Ltd.",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "MaNaTha-798/2011",
    "Permit Date": "2011-03-14T08:06:32Z",
    "Meeting Number": "38/2010",
    "Meeting Date": "2011-11-09T08:06:57Z",
    Sector: "Construction",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် လမ်းပြုပြင်ဖောက်လုပ်၍ လမ်း၊တံတား အသုံးပြုခ ကောက်ခံခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1248.4,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 16,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်(၁၀၀/ဇ))၊ လမ်းသာယာလမ်း၊ ရ.က.က ရပ်ကွက်၊ ပြင်ဦးလွင်မြို့နယ်၊ မန္တလေးတိုင်းဒေသကြီး ",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.38, Zizawar Housing Estate, Thanthumar Road, South Okkalapa Township. Yangon",
  },
  {
    ID: 1454,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Khin Maung Myint ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Hong Pang Construction Co., Ltd. ",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "MaNaTha-402/2000",
    "Permit Date": "2000-07-12T08:23:38Z",
    "Meeting Number": "13/2000",
    "Meeting Date": "2000-04-23T17:30:00Z",
    Sector: "Construction",
    "Type Of Investment Business":
      "ကျိုင်းတုံ-တာချီလိတ် ကားလမ်းအား တည်ဆောက်ပြုပြင်ဖောက်လုပ်၍ လမ်းအသုံးပြုခ ကောက်ခံခြင်းလုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 3180,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 265,
    "Number Of Foreign Employees": 5,
    Status: "Approved",
    "Investor Address": "Number 525, Strand Road, Kyauktada Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Number 525, Strand Road, Kyauktada Township, Yangon",
  },
  {
    ID: 1455,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Kyi Soe",
    "Name of Principal Organization":
      "Myanmar Shipyards, Ministry of Transport",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Myanma Shipyards-Dong A Joint Venture Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "848/2014",
    "Permit Date": "2014-12-23T08:28:02Z",
    "Meeting Number": "24/2014",
    "Meeting Date": "2014-10-25T08:32:35Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Building and Repairing of Ships, Operating of Shipyards",
    "Amount Of Foreign Capital USD (in Millions)": 85.9,
    "Total Amount Of Capital (in Millions)": 175.4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 4,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Vietnam",
    "Form Of Investment": "JV",
    "Land Owner": "Myanma Shipyards, Ministry of Transport and Communications",
    "Land Area (units not specified in file)": 368277,
    "Lease Term": 50,
    "Annual Lease Fee": 1.66,
    "Land Use Premium": null,
    "Number Of Local Employees": 427,
    "Number Of Foreign Employees": 12,
    Status: "Approved",
    "Investor Address":
      "Myanmar Shipyards, Ministry of Transport, Bayintanung Road, Ward (4), Kamayut Township, Yangon",
    "Organization Address":
      "Myanmar Shipyards, Ministry of Transport, Bayintanung Road, Ward (4), Kamayut Township, Yangon",
    "Investment Permitted Address":
      "Myanmar Shipyards, Ministry of Transport, Bayintanung Road, Ward (4), Kamayut Township, Yangon",
  },
  {
    ID: 1457,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung San",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "YANGON AIRCRAFT ENGINEERING COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "Ma Na Tha 1007/2014",
    "Permit Date": "2014-10-31T09:18:01Z",
    "Meeting Number": "24/2014",
    "Meeting Date": "2014-10-17T09:18:28Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Airplane Maintenance Services",
    "Amount Of Foreign Capital USD (in Millions)": 4.41,
    "Total Amount Of Capital (in Millions)": 4194.94,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "Air Bagon Hanger,  Department of Civil Aviation, Ministry of Transport and Communications",
    "Land Area (units not specified in file)": 47812,
    "Lease Term": 15,
    "Annual Lease Fee": 240000,
    "Land Use Premium": null,
    "Number Of Local Employees": 203,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၁၃၈၉၊ ဆရာသိန်းလမ်း၊ ၄၂ ရပ်ကွက်၊ ဒဂုံမြို့သစ် (မြောက်ပိုင်း) မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "oom No(202), FcF building, Yangon International Airpot Street, Mingalardon, YANGON",
  },
  {
    ID: 1459,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "General Win Than",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "T he Union of Myanmar Economic Holdings Ltd.",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "Manatha-761-2010",
    "Permit Date": "2010-10-22T04:50:06Z",
    "Meeting Number": "20/2010",
    "Meeting Date": "2010-06-18T04:50:50Z",
    Sector: "Construction",
    "Type Of Investment Business":
      "ရန်ကုန်-ပြည်-မကွေး လမ်းအပိုင်း ၊ ကိုးပင်-စမ်းမကြီး- သစ်ရာ ကောက်လမ်း၊ ပြည်မြို့ရှောင်လမ်း နှင့် အမှတ်(၄)လမ်းမကြီး (စုစုပေါင်း ၃၄၀ မိုင်၊ ၂ ၁/၂ ဖာလုံ)",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 65512.1,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 818,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "အမှတ်(၇၉)၊ မဟာဗောဓိရပ်ကွက်၊ ကမ်းနားလမ်း၊ မအူပင်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "No-189/191 Mahabandoola Road Botahtaung  Township.Yangon.",
  },
  {
    ID: 1460,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Tun Myaint Naing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Asia World Co., Ltd",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "Manatha-035/1996",
    "Permit Date": "1996-07-22T05:09:52Z",
    "Meeting Number": "10/1996",
    "Meeting Date": "1996-07-05T05:10:57Z",
    Sector: "Construction",
    "Type Of Investment Business":
      "မန္တလေး-လားရှိုး-မူဆယ် ပြည်ထောင်စုလမ်းမကြီး(လားရှိုး-        \n မူဆယ် လမ်းအပိုင်း) မိုင်တိုင် ၁၇၂/၀ မှ ၂၇၄/၃ အထိ) ရှမ်းပြည်နယ် မြောက်ပိုင်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 982,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 678,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်_၂၀/၂၃၊ မစိုးရိမ်ကျောင်းလမ်း၊ (၅)ရပ်ကွက်၊ မရမ်းကုန်း မြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "No-61-62, Bahosi Compound, Wardan Street, Lanmadaw Township, Yangon.",
  },
  {
    ID: 1465,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. TEMMA TAKEUCHI  ",
    "Name of Principal Organization": "KOUWA INDUSTRY COMPANY LIMITED",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "KOUWA  MYANMAR  COMPANY  LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "996/2015",
    "Permit Date": "2015-08-20T04:04:03Z",
    "Meeting Number": "14/2015",
    "Meeting Date": "2015-08-07T04:04:25Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF BAGS ON CMP  BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.586,
    "Total Amount Of Capital (in Millions)": 0.586,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaw Win ",
    "Land Area (units not specified in file)": 1.5,
    "Lease Term": 30,
    "Annual Lease Fee": 64.8,
    "Land Use Premium": null,
    "Number Of Local Employees": 202,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "1-4-7-1102, HIRANOMACHI, CHUO-KU, OSAKA, JAPAN 540-0037",
    "Organization Address": "7-20, TEMMA, KITA-KU, OSAKA, JAPAN 530-0043",
    "Investment Permitted Address":
      "PLOT NO. 182/8, MYAY TAING BLOCK NO. 25, SHWE LIN PAN NDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1467,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးညီညီထွန်း",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "မြန်မာအဆင့်မြင့်ရွေးချယ်မှုကုမ္ပဏီလီမိတက်",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "မနသ-၁၀၆၄/၂၀၁၅",
    "Permit Date": "2015-07-10T04:30:34Z",
    "Meeting Number": "၁၁/၂၀၁၅",
    "Meeting Date": "2015-06-19T04:31:29Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 152.125,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးညီညီထွန်း",
    "Land Area (units not specified in file)": 0.846,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 520,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "တိုက်အမှတ် ၁၁၉၊ အခန်းအမှတ် ၈၊ ရန်နိုင်လမ်းသွယ် (၁) လမ်း၊ (၄) ရပ်ကွက်၊ ရန်ကင်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၀၁၊ ၁၀၅ နှင့် ၁၀၆၊ မြေတိုင်း ရပ်ကွက် အမှတ် ၁၄၄၊ တပင်ရွှေထီးလမ်းနှင့် ဝက်မစွတ်ဝန်ထောက် လမ်းထောင့်၊ တောင်ဒဂုံ စက်မှုဇုန်၊ ဒဂုံမြိုသစ် (တောင်ပိုင်း) မြို့နယ်၊ ရန်ကုန်တိုင်း ဒေသကြီး",
  },
  {
    ID: 1468,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mrs. Jung Euisook",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "World Jin Garment Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "819/2014",
    "Permit Date": "2014-10-21T06:06:56Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T06:07:39Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.773,
    "Total Amount Of Capital (in Millions)": 1.773,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myint Thein @ Valu Sami",
    "Land Area (units not specified in file)": 2.892,
    "Lease Term": 30,
    "Annual Lease Fee": 0.07,
    "Land Use Premium": null,
    "Number Of Local Employees": 1220,
    "Number Of Foreign Employees": 8,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.14-4, Dong Sun Dong 3 GA, Sung Buk Gu, Seoul, Republic of Korea",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No.136, Myay Taing Quarter No.51, Thardukan Inudstrial Zone-2, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 1470,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဝင်းဆွေ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Win & Win Company  Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1076/2015",
    "Permit Date": "2015-09-18T06:05:46Z",
    "Meeting Number": "16/2015",
    "Meeting Date": "2015-09-11T06:06:24Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ဆေးရုံသုံး သံထည် ကုတင်နှင့် ပရိဘောဂ ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 221.76,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "စက်မှုဝန်ကြီးဌာန၊ အမှတ်(၃)အကြီးစားစက်မှုလုပ်ငန်း (ယခင်စက္ကူနှင့်အိမ်သုံးပစ္စည်း လုပ်ငန်း)",
    "Land Area (units not specified in file)": 12.39,
    "Lease Term": 50,
    "Annual Lease Fee": 43.02,
    "Land Use Premium": null,
    "Number Of Local Employees": 390,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၄၀၀) ကမ်းနားလမ်း၊ လသာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No.(6), (6)Mile,Pyay Road, , Hlaing, YANGON",
  },
  {
    ID: 1471,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Bao Jianxin",
    "Name of Principal Organization":
      "Jiangyin Xinfeng Clothes-Manufacturing Co., Ltd.",
    "Place of Incorporation": "People's Republic of China",
    "Company Name In Myanmar": "Suntime JCK Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "818",
    "Permit Date": "2014-10-21T06:27:17Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T06:27:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.017,
    "Total Amount Of Capital (in Millions)": 2.017,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Tin Aye @ Chun Kyone",
    "Land Area (units not specified in file)": 4.795,
    "Lease Term": 30,
    "Annual Lease Fee": 0.116,
    "Land Use Premium": null,
    "Number Of Local Employees": 1700,
    "Number Of Foreign Employees": 13,
    Status: "Submitted",
    "Investor Address":
      "No.8 Renmin Road, Zhutang Town, Jiangyin City, People's Republic of China",
    "Organization Address":
      "No.8 Renmin Road, Zhutang Town, Jiangyin City, People's Republic of China",
    "Investment Permitted Address":
      "Plot No.88,90, Myay Taing Quarter No.39, Shwe Pyi Thar Industrial Zone, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 1473,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Okuda Takehiko",
    "Name of Principal Organization": "Okuda Sewing Co., Ltd.",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Asia Vista Manufacturing Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "990/2015",
    "Permit Date": "2015-08-06T07:10:10Z",
    "Meeting Number": "13/2015",
    "Meeting Date": "2015-07-17T07:10:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENTS ON CMP  BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.844,
    "Total Amount Of Capital (in Millions)": 1.055,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "U Sai Khin Aung",
    "Land Area (units not specified in file)": 2.307,
    "Lease Term": 30,
    "Annual Lease Fee": 0.056,
    "Land Use Premium": null,
    "Number Of Local Employees": 272,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address": "2-54, Higashi Kawate, Gifu Japan",
    "Organization Address": "2-54, Higashi Kawate, Gifu Japan",
    "Investment Permitted Address":
      "Plot No.51, Myay Taing Block No. 109, Sethmu Myo(Extension), East Dagon Township, Yangon Region.",
  },
  {
    ID: 1475,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr Charles Woodworth",
    "Name of Principal Organization":
      "Telenor South East Asia Investment Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Telenor Myanmar Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "620/2014",
    "Permit Date": "2014-01-27T08:58:37Z",
    "Meeting Number": "1/2014",
    "Meeting Date": "2014-01-08T08:59:01Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business": "Mobile Telecommunications Service",
    "Amount Of Foreign Capital USD (in Millions)": 900,
    "Total Amount Of Capital (in Millions)": 900,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "0",
    "Land Area (units not specified in file)": 0,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": 0,
    "Number Of Local Employees": 10000,
    "Number Of Foreign Employees": 50,
    Status: "Approved",
    "Investor Address": "25 Jakan Pokok Serunai, Singapore 468162",
    "Organization Address": "51 Goldhill Plaza, #21-07 Singapore 308900",
    "Investment Permitted Address":
      "- Myanmar Nation Wide\n- Suite 117, Inya Lake Hotel 37, Kaba Aye Pagoda Road, , Mayangone, YANGON",
  },
  {
    ID: 1476,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Tin Soe",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "YANGON AIRWAYS LIMITED",
    "Financial Year From": 2008,
    "Financial Year To": 2009,
    "Permit Number": "Ma Na Tha 695/2008",
    "Permit Date": "2008-12-19T03:22:08Z",
    "Meeting Number": "37/2008",
    "Meeting Date": "2008-12-03T03:23:36Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business": "Domestic Airline Transport Services",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 6,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Transport and Communications",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 172,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "No. 27 (C), Innyar Myaing Street, No,1 Shwe Taung Gyar, Bahan Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.(166), MMB Tower,Level-5, \n Upper Pansondan Street, , Mingalartaungnyunt Township, YANGON",
  },
  {
    ID: 1477,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဖိုးဇော်(ခ)ဦးဇော်ဇော်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MAX (MYANMAR) CONSTRUCTION COMPANY LIMITED",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "Manatha 706/2009",
    "Permit Date": "2009-11-02T03:55:34Z",
    "Meeting Number": "25/2009",
    "Meeting Date": "2009-07-17T03:55:11Z",
    Sector: "Construction",
    "Type Of Investment Business":
      "BOT  စနစ်ဖြင့် လမ်းပြုပြင်ဖောက်လုပ်၍ လမ်းတံတား အသုံးပြုခကောက်ခံခြင်း လုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 11318.51,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 121,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "အမှတ်(၁၉)၊ ကုက္ကိုင်းရိပ်သာလလမ်း၊ ဗဟန်းမြို့နယ်",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.(123), Alanpya Pagoda Road, , Dagon, YANGON",
  },
  {
    ID: 1479,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအေးကို",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "FAMILY AYE KO CONSTRUCTION COMPANY LIMITED",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "Manatha 799/2011",
    "Permit Date": "2011-03-14T04:41:46Z",
    "Meeting Number": "38/2010",
    "Meeting Date": "2010-11-19T04:41:22Z",
    Sector: "Construction",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် လမ်းပြုပြင်ဖောက်လုပ်၍ လမ်းတံတားအသုံးပြုခကောက်ခံခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 3166.77,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 24,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "အမှတ်(၁၀၀/ဇ)၊လမ်းသာယာလမ်း၊(ရ.က.က)ရပ်ကွက်",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.(38), Zizawar Housing Estate,Thanthumar Street, Southokkalarpa, YANGON",
  },
  {
    ID: 1480,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. JANG  MAENG  DUK  ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "THE K-WORLD  COMPANY  LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "983/2015",
    "Permit Date": "2015-07-24T05:12:22Z",
    "Meeting Number": "12/2015",
    "Meeting Date": "2015-06-03T05:12:47Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENTS ON CMP  BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.806,
    "Total Amount Of Capital (in Millions)": 0.806,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myint Thu",
    "Land Area (units not specified in file)": 1.871,
    "Lease Term": 10,
    "Annual Lease Fee": 0.084,
    "Land Use Premium": null,
    "Number Of Local Employees": 1082,
    "Number Of Foreign Employees": 6,
    Status: "Monitoring Approved",
    "Investor Address":
      "130 HO, 104 DONG, KOLON APT., SEOKGWAN-DONG, SEONGBUK- GU, SEOUL, REPUBLIC  OF  KOREA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 120, MYAY TAING BLOCK NO. 7, WARD NO. 14 ZAT SAIT, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1481,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Maung Kyway",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "PIONEER AERODROME SERVICES COMPANY LIMITED",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "Ma Na Tha 806/2011",
    "Permit Date": "2011-03-28T05:16:53Z",
    "Meeting Number": "42/2010",
    "Meeting Date": "2010-12-17T05:17:36Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် အပြည်ပြည်ဆိုင်ရာ လေဆိပ်တည်ဆောက်ခြင်းနှင့် လေဆိပ် ဝန်ဆောင်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 300.7,
    "Total Amount Of Capital (in Millions)": 75700.2,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner":
      "Ministry of Transport and Communications, Department of Civil Aviation",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 348,
    "Number Of Foreign Employees": 8,
    Status: "Submitted",
    "Investor Address":
      "No. C-4, Mon Myat Myattar Housing Complex, Pin Shwe Naung Street, Tamwe Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.(203/204), Thiri Mingalar Housing ,Strand Road, Ahlone Township, YANGON",
  },
  {
    ID: 1482,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ryan Lee Yuee Shyang",
    "Name of Principal Organization": "Spirolite (M) Sendirian Berhad",
    "Place of Incorporation": "Malaysia",
    "Company Name In Myanmar": "Spirolite (Myanmar) Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "935/2015",
    "Permit Date": "2015-04-24T05:25:46Z",
    "Meeting Number": "5/2015",
    "Meeting Date": "2015-03-20T05:26:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Polyethylene(PE) Pipes, Fittings and tanks Related Fluid Conveyance Products",
    "Amount Of Foreign Capital USD (in Millions)": 3.571,
    "Total Amount Of Capital (in Millions)": 3.571,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Malaysia",
    "Form Of Investment": "FDII",
    "Land Owner": "U Sai Win Aung",
    "Land Area (units not specified in file)": 1.528,
    "Lease Term": 5,
    "Annual Lease Fee": 15,
    "Land Use Premium": null,
    "Number Of Local Employees": 25,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "Lot 4, Jalan P/2A, Kawasan Perindustrian, 43650 Bandar Baru Bangi, Selangor Darul Ehsan, Malaysia",
    "Organization Address":
      "Level 18, The Gardens North Tower, Mid Valley City, Lingkaran Syed Putra, 59200 Kuala Lumpur, Malaysia",
    "Investment Permitted Address":
      "Plot No. 396, Myay Taing Block No. 25, Shwelinban Industrial Zone, HlaingTharYar Township, Yangon Region",
  },
  {
    ID: 1483,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS. LEUNG  MIU  PO  ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "J & J (MYANMAR) GARMENT  FACTORY  LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1034/2015",
    "Permit Date": "2015-11-11T05:54:13Z",
    "Meeting Number": "18/2015",
    "Meeting Date": "2015-10-23T05:54:36Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENTS ON CMP  BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.6669,
    "Total Amount Of Capital (in Millions)": 1.6669,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Ahr Kham, U Yone Arm",
    "Land Area (units not specified in file)": 1.855,
    "Lease Term": 20,
    "Annual Lease Fee": 0.041,
    "Land Use Premium": null,
    "Number Of Local Employees": 556,
    "Number Of Foreign Employees": 13,
    Status: "Monitoring Approved",
    "Investor Address":
      "6C 2 DUKE STREET, MONGKOK, KOWLOON, HONG KONG YUEN LONG N.T, HONG KONG",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 143, MYAY TAING BLOCK NO. 4, HLAING THAR YAR INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1485,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဝင်းလွင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "မြတ်မိဘကုမ္ပဏီလီမိတက်",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "မနသ-၁၁၄၆/၂၀၁၆",
    "Permit Date": "2016-03-24T06:05:15Z",
    "Meeting Number": "9/2016",
    "Meeting Date": "2016-03-11T06:06:02Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "စက္ကူထုပ်ပိုးပစ္စည်းအမျိုးမျိုး ထုတ်လုပ်ရောင်းချခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.18,
    "Total Amount Of Capital (in Millions)": 8656.24,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "စက်မှုဝန်ကြီးဌာန၊ အမှတ် (၃) အကြီးစားစက်မှုလုပ်ငန်း",
    "Land Area (units not specified in file)": 60.24,
    "Lease Term": 20,
    "Annual Lease Fee": 100,
    "Land Use Premium": null,
    "Number Of Local Employees": 124,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၉၈၊ မြေညီထပ်၊ လမ်း(၅၀)၊ ပုဇွန်တောင်မြို့နဘ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ကွင်းအမှတ် ၆၅၉-A/ အလွမ်းဆွတ် ရွာမကွင်းနှင့် ၆၅၉-B /အလွမ်းဆွတ်တောင်ကွင်း၊ အလွမ်းဆွတ် ကျေးရွာအုပ်စု၊ သန်လျင်မြို့နယ်၊ ရန်ကုန်တိုင်း ဒေသကြီး ",
  },
  {
    ID: 1487,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. MUNISH KUMAR MARWARI  ",
    "Name of Principal Organization": "LEO GROUP PTE LTD.",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar": "LEOPLAST  INDUSTRY  LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1047/2015",
    "Permit Date": "2015-11-19T06:46:00Z",
    "Meeting Number": "20/2015",
    "Meeting Date": "2015-11-13T06:46:23Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF PLASTIC PACKAGING CONTAINERS, HOUSEHOLD GOODS AND FURNITURE",
    "Amount Of Foreign Capital USD (in Millions)": 6.93,
    "Total Amount Of Capital (in Millions)": 7,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Min Pa Pa Nwai",
    "Land Area (units not specified in file)": 3.58,
    "Lease Term": 15,
    "Annual Lease Fee": 84,
    "Land Use Premium": null,
    "Number Of Local Employees": 150,
    "Number Of Foreign Employees": 34,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.34 BAYSHORE ROAD, THE BAYSHORE, 04-07, TOWER 2 B, SINGAPORE 469976",
    "Organization Address":
      "NO.1 NORTH BRIDGE ROAD, # 12-06, HIGH STREET CENTRE, SINGAPORE 179094",
    "Investment Permitted Address":
      "PLOT NO. 9, MYAY TAING BLOCK NO. 112, INDUSTRIAL ZONE, DAGON MYOT THIT (EAST) TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1489,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. TAO,  SEN  ",
    "Name of Principal Organization":
      "VENT D’EST INTERNATIONAL CORP. (DAL IAN) LTD.",
    "Place of Incorporation": "People's Republic of China",
    "Company Name In Myanmar": "VENT D’EST (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1050/2015",
    "Permit Date": "2015-12-16T07:35:54Z",
    "Meeting Number": "21/2015",
    "Meeting Date": "2015-11-27T07:36:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENTS ON CMP  BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 2.34,
    "Total Amount Of Capital (in Millions)": 2.34,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myo Aung",
    "Land Area (units not specified in file)": 3.185,
    "Lease Term": 10,
    "Annual Lease Fee": 0.15,
    "Land Use Premium": null,
    "Number Of Local Employees": 1600,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 45, GONG JIAN STREET, ZHONGSHAN DISTRICT, DAL IAN CITY, LIAONING PROVINCE, CHINA",
    "Organization Address":
      "NO.10, CHUNHE STREET, ZHONGSHAN DISTRICT, DAL IAN CITY, LIAONING PROVINCE, CHINA",
    "Investment Permitted Address":
      "PLOT NO. 44, MYAY TAING BLOCK NO. 50, THARDUKAN INDUSTRIAL ZONE, SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1491,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. DONG  GIL  SHIN ",
    "Name of Principal Organization": "HA HAE CORPORATION, ",
    "Place of Incorporation": "REPUBLIC OF KOREA ",
    "Company Name In Myanmar": "ARAO  COMPANY  LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1035/2015",
    "Permit Date": "2015-11-11T08:15:52Z",
    "Meeting Number": "18/2015",
    "Meeting Date": "2015-10-23T08:16:20Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENTS ON CMP  BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 6,
    "Total Amount Of Capital (in Millions)": 6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "Khine Myanmar Win Enterprise Co., Ltd.",
    "Land Area (units not specified in file)": 3.18,
    "Lease Term": 50,
    "Annual Lease Fee": 0.064,
    "Land Use Premium": null,
    "Number Of Local Employees": 1000,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "MOK-DONG APARTMENT 536-105, 350 MOKDONGDONG-RO, YANGCHEON-GU, SEOUL , REPUBLIC OF KOREA",
    "Organization Address":
      "173, DIGITAL-RO, GEUMCHEON-GU, SEOUL , REPUBLIC OF KOREA ",
    "Investment Permitted Address":
      "PLOT NO. A-6, KYI SU INDUSTRIAL ZONE, DAGON SEIKKAN TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1494,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Ho, Chi Ying",
    "Name of Principal Organization": "Victory  Beam Far East Limited ",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "JEWEL PAK INTERNATIONAL (MYANMAR) CO., LTD.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "942/2015",
    "Permit Date": "2015-05-07T09:10:32Z",
    "Meeting Number": "6/2015",
    "Meeting Date": "2015-04-30T09:10:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Jewellery Packaging Products on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.571,
    "Total Amount Of Capital (in Millions)": 0.571,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Lwin",
    "Land Area (units not specified in file)": 2.137,
    "Lease Term": 30,
    "Annual Lease Fee": 0.045,
    "Land Use Premium": null,
    "Number Of Local Employees": 419,
    "Number Of Foreign Employees": 8,
    Status: "Monitoring Approved",
    "Investor Address":
      "FLAT B, 23/F, BLOCK 9, PARC  PALAIS, 18 WYLIE ROAD, KOWLOON, HONG KONG",
    "Organization Address":
      "Room 3, 23/F, King Palace Plaza, 52A Sha Tsui Road, Tsuen Wan, N.T., Hong Kong",
    "Investment Permitted Address":
      "Plot No. 498, Myay Taing Block No. 25, Shwe Lin Pan Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 1495,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Xu Jiping",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Mianyi Manufacturing Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "003/2017",
    "Permit Date": "2017-10-10T17:30:00Z",
    "Meeting Number": "3/2017",
    "Meeting Date": "2017-09-26T17:30:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.7,
    "Total Amount Of Capital (in Millions)": 0.7,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "National Pride Industry Limited",
    "Land Area (units not specified in file)": 1.89,
    "Lease Term": 6,
    "Annual Lease Fee": 105549.3,
    "Land Use Premium": 0,
    "Number Of Local Employees": 330,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address":
      "No.3, Machong, Dianshang Village, Loupai Town, Guichi Distict,Chizhou City,Anhui, People Republic's of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 66, Myaytaing Block No. 3, Industrial zone (3) , Min Theikdi Kyaw Swar Road, Hlaing Thar Yar Township, Yangon",
  },
  {
    ID: 1496,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw Yu Yu Win",
    "Name of Principal Organization": "Great Merits Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Super Gathergates Electric Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "004/2017",
    "Permit Date": "2017-10-10T17:30:01Z",
    "Meeting Number": "3/2017",
    "Meeting Date": "2017-09-26T17:30:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Electrical Switch Board and Related Accessories",
    "Amount Of Foreign Capital USD (in Millions)": 1.55,
    "Total Amount Of Capital (in Millions)": 3.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Yu Yu Win (Grate Merits Co., Ltd.)",
    "Land Area (units not specified in file)": 2.492,
    "Lease Term": 45,
    "Annual Lease Fee": 0.144,
    "Land Use Premium": null,
    "Number Of Local Employees": 68,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address": "No.115, Dhamazedi Road, Ward No 10, ",
    "Organization Address": "no.7, Yadanar Mon-2, street, No-4, Ward, ",
    "Investment Permitted Address":
      "Plot No.96, Myay Taing Blcok no -113, Industry Zone ",
  },
  {
    ID: 1497,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Tak Wai Siu",
    "Name of Principal Organization":
      "MX CATERERS (ASIA) , PTE.LTD.9, BATTERY, 15-01, MYP CENTRE, SINGAPORE (049910)",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar": "COFFEE CONCEPTS (MYANMAR) LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "098/2018",
    "Permit Date": "2018-05-17T10:16:57Z",
    "Meeting Number": "6/2018",
    "Meeting Date": "2018-05-12T10:17:23Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Catering and sales of Starbucks food and beverages, sales of Starbucks brand products, operating of Starbucks stores ( up to twenty outlets)",
    "Amount Of Foreign Capital USD (in Millions)": 6,
    "Total Amount Of Capital (in Millions)": 6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner":
      "The Quarter Master General Office ,Traders Square Company Limite ( Head Lease)",
    "Land Area (units not specified in file)": 310,
    "Lease Term": 5,
    "Annual Lease Fee": 0.112,
    "Land Use Premium": null,
    "Number Of Local Employees": 40,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.(38), BEL-AIR Avenue , Residence Bel-Air Phase 2, Tower 1, 33/F Flat B, Pok Fu Lam, Hong Kong",
    "Organization Address":
      "9, BATTERY ROAD, 15-01, MYP CENTRE, SINGAPORE (049910)",
    "Investment Permitted Address":
      "NO.221, SULE SQUARE, 1 WARD, SULE PAGODA ROAD, KYUAKTADA TOWNSHIP, YANGON",
  },
  {
    ID: 1498,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. PARK JEUNG HOW AN",
    "Name of Principal Organization": "JOIN CO., LTD",
    "Place of Incorporation": "REPUBLIC OF KOREA",
    "Company Name In Myanmar": "JOIN GLOBAL MYANMAR COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "040/2017",
    "Permit Date": "2017-12-30T10:42:03Z",
    "Meeting Number": "17/2017",
    "Meeting Date": "2017-12-21T17:30:00Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business": "POULTRY BREEDER FARM AND HATCHERY  ",
    "Amount Of Foreign Capital USD (in Millions)": 5,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Thein Zaw",
    "Land Area (units not specified in file)": 18.1,
    "Lease Term": 50,
    "Annual Lease Fee": 7640000,
    "Land Use Premium": null,
    "Number Of Local Employees": 51,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address":
      "203-102, 30 PANGYO-RO, BUNDAUNG-GU, SEONGNAM-SI, GYEONGGI-DO, REPUBLIC OF KOREA\n",
    "Organization Address":
      "132, CHEONGO-RO, OSEONG-MYEON, PYEONGTAEK-SI, GYEONGGI-DO, REPUBLIC OF KOREA",
    "Investment Permitted Address":
      "NO.006, Ground Floor, Bayintnaung Tower (1), Kamaryut Township, Yangon., Kamayut, YANGON",
  },
  {
    ID: 1499,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Huang Lijun",
    "Name of Principal Organization": "Guangzhou Paparazi Leather Co., Ltd.",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "P & S Union Group Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "005/2017",
    "Permit Date": "2017-10-10T17:30:00Z",
    "Meeting Number": "3/2017",
    "Meeting Date": "2017-09-26T17:30:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Handbags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.133,
    "Total Amount Of Capital (in Millions)": 2.133,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Sai Win Aung",
    "Land Area (units not specified in file)": 1.528,
    "Lease Term": 5,
    "Annual Lease Fee": 0.36,
    "Land Use Premium": null,
    "Number Of Local Employees": 889,
    "Number Of Foreign Employees": 20,
    Status: "Draft",
    "Investor Address":
      "No. B-10, A-103 A -B106, Clud E-Tower Ind. Area,3 Jiangxia North Rd.2, Baiyun District ",
    "Organization Address": "2F-3F, No.28, East Jinshi Avenue, ",
    "Investment Permitted Address":
      "Plot No.396, Myay Taing Block No.YA LA PA -25, Shwe Lin Pan Industiral Zone",
  },
  {
    ID: 1500,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Hung chi Wai",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Wide Garment Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "006/2017",
    "Permit Date": "2017-10-10T17:30:01Z",
    "Meeting Number": "4/2017",
    "Meeting Date": "2017-10-10T17:30:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Shirt on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.345,
    "Total Amount Of Capital (in Millions)": 0.767,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Yin Lee yint @ Li Li Sna ",
    "Land Area (units not specified in file)": 1.39,
    "Lease Term": 10,
    "Annual Lease Fee": 0.017,
    "Land Use Premium": null,
    "Number Of Local Employees": 1002,
    "Number Of Foreign Employees": 9,
    Status: "Draft",
    "Investor Address":
      "Room A 1202, 12/F, Wing Cheung Industrial Building, 58-70 Kwai Cheong Road",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.36, and 81/A, Myay Taing Block No.521A, Koe Lone Kwin, Thandaybin Village",
  },
  {
    ID: 1501,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wang Lindong",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Sanhe Tissue Papaer Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "007/2017",
    "Permit Date": "2017-11-07T17:30:01Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-09-24T17:30:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing and Marketing tissue Paper",
    "Amount Of Foreign Capital USD (in Millions)": 2.359,
    "Total Amount Of Capital (in Millions)": 2.359,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Win Aung",
    "Land Area (units not specified in file)": 1.882,
    "Lease Term": 30,
    "Annual Lease Fee": 27.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 30,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address":
      "No.2, Yun Cheng Shi Yan Hu Qu, Xi Meng Wai Nan yi Xiang, ",
    "Organization Address": "",
    "Investment Permitted Address": "Plot No 361, Myaung Takar Industrial Zone",
  },
  {
    ID: 1502,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yan Guanghai",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Haisheng Fashion Clohes Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "008/2017",
    "Permit Date": "2017-11-07T17:30:00Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-10-24T17:30:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.917,
    "Total Amount Of Capital (in Millions)": 1.917,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Naing",
    "Land Area (units not specified in file)": 1.452,
    "Lease Term": 10,
    "Annual Lease Fee": 0.047,
    "Land Use Premium": null,
    "Number Of Local Employees": 1637,
    "Number Of Foreign Employees": 20,
    Status: "Draft",
    "Investor Address":
      "Room 2003, Building 2, Lantingfang 30, Science and Technology Road",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.143, Myat Taing Block No.64, Industrial Zone-3,",
  },
  {
    ID: 1503,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lu, Wen-Chi",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "South Honour Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "009/2017",
    "Permit Date": "2017-11-07T17:30:01Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-10-24T17:30:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.306,
    "Total Amount Of Capital (in Millions)": 0.306,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Tin Tin Shwe",
    "Land Area (units not specified in file)": 1.034,
    "Lease Term": 10,
    "Annual Lease Fee": 0.02,
    "Land Use Premium": null,
    "Number Of Local Employees": 287,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "No.22-2, LN-22, Dayuan Road, Taoyuan District",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No-222, Hlaing Thar Yar Industrial Zone-2",
  },
  {
    ID: 1504,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်မြတ်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "“Mother” Industrial Company  Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1071/2015",
    "Permit Date": "2015-07-24T04:35:52Z",
    "Meeting Number": "8/2015",
    "Meeting Date": "2015-05-08T04:36:11Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အဆင့်မြင့် မီးခံအုတ် အမျိုးမျိုး ထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း\t\t",
    "Amount Of Foreign Capital USD (in Millions)": 3,
    "Total Amount Of Capital (in Millions)": 3500,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "အမှတ်(၂)အကြီးစား စက်မှုလုပ်ငန်း (ယခင် အမှတ် ၃ အကြီးစား စက်မှုလုပ်ငန်း) ၊ စက်မှုဝန်ကြီးဌာန",
    "Land Area (units not specified in file)": 5.557,
    "Lease Term": 50,
    "Annual Lease Fee": 390,
    "Land Use Premium": null,
    "Number Of Local Employees": 117,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၃၇)၊ ဝေဇယန္တာလမ်း၊ အမှတ်(၉)ရပ်ကွက်၊ \nတောင်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No.(44/46),(2nd) Street,(1) Quarter, Lanmadaw, Yangon",
  },
  {
    ID: 1505,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kim Yong Han",
    "Name of Principal Organization": "INNO Block Co., Ltd.",
    "Place of Incorporation": "Korea",
    "Company Name In Myanmar": "INNO Brick Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "010/2017",
    "Permit Date": "2017-11-07T17:30:01Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-10-24T17:30:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufactruing and Marketing of Concrete Bricks & Blcoks",
    "Amount Of Foreign Capital USD (in Millions)": 1.5,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Tin Latt",
    "Land Area (units not specified in file)": 3.775,
    "Lease Term": 9,
    "Annual Lease Fee": 142.05,
    "Land Use Premium": null,
    "Number Of Local Employees": 50,
    "Number Of Foreign Employees": 2,
    Status: "Draft",
    "Investor Address": "239, Songnae-Daero, Bucheon-Si,",
    "Organization Address": "239, Songnae-Daero, Bucheon-Si",
    "Investment Permitted Address":
      "Plot No.2 and 3, Myay Taing Block No.108 B, Industrial Zone",
  },
  {
    ID: 1506,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kim Yong Han ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Inno diamond Concrete Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "011/2017",
    "Permit Date": "2017-11-07T17:30:00Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-10-24T17:30:00Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Service Only Processing and Marketing of Ready Mixed Concretes and Other Construction ",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "JV",
    "Land Owner": "ဒေါ်ခတီဂျာဘီဘီ",
    "Land Area (units not specified in file)": 4.01,
    "Lease Term": 10,
    "Annual Lease Fee": 228,
    "Land Use Premium": null,
    "Number Of Local Employees": 64,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address": "4th Floor, 239 Songanaedae-Ro, Bucheon city",
    "Organization Address": "",
    "Investment Permitted Address": "Plot No.5-C, Myat Taing Block No-144,",
  },
  {
    ID: 1507,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်မြတ်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "New General Industry Co., Ltd. (သစ်လွင်အထွေထွေ စက်မှုလုပ်ငန်းကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1162/2016",
    "Permit Date": "2016-03-28T05:07:22Z",
    "Meeting Number": "8/2016",
    "Meeting Date": "2016-03-04T05:07:33Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ   Plastic Shopping Bag  အမျိုးမျိုး  ထုတ်လုပ်ဖြန့်ဖြူးရောင်းချခြင်း  လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 5.46,
    "Total Amount Of Capital (in Millions)": 33000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 35,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "မြန်မာ့ဆေးဝါးလုပ်ငန်း၊ စက်မှုဝန်ကြီးဌာန",
    "Land Area (units not specified in file)": 9.83,
    "Lease Term": 25,
    "Annual Lease Fee": 183.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 140,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၃၇၊ ဝေဇယန္တာလမ်း၊ ၉ ရပ်ကွက်၊ တောင်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "o.151, 9th floor, Tower(A), Corner Bogyoke Aung San Street & Wardan Street, 8-Wards, , Lanmadaw, YANGON",
  },
  {
    ID: 1508,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်မြတ်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "New General Industry Co., Ltd. (သစ်လွင်အထွေထွေ စက်မှုလုပ်ငန်းကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1163/2016",
    "Permit Date": "2016-03-26T05:22:29Z",
    "Meeting Number": "8/2016",
    "Meeting Date": "2016-03-04T05:22:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "PVC Pipe အမျိုးမျိုး  ထုတ်လုပ် ဖြန့်ဖြူးရောင်းချခြင်း  လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 620,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "မြန်မာ့ဆေးဝါးလုပ်ငန်း၊ စက်မှုဝန်ကြီးဌာန",
    "Land Area (units not specified in file)": 1.18,
    "Lease Term": 25,
    "Annual Lease Fee": 61.2,
    "Land Use Premium": null,
    "Number Of Local Employees": 60,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၃၇၊ ဝေဇယန္တာလမ်း၊ ၉ ရပ်ကွက်၊ တောင်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No.151, 9th floor, Tower(A), Corer Bogyoke Aung San Street & Wardan Street, 8-Wards, , Lanmadaw, Yangon",
  },
  {
    ID: 1509,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kai Tai Lau",
    "Name of Principal Organization": "Sky Legend Development Ltd.",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Sky Legend Garment Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "815/2014",
    "Permit Date": "2014-10-21T05:26:25Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T05:26:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.988,
    "Total Amount Of Capital (in Millions)": 2.988,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Ohn Sai",
    "Land Area (units not specified in file)": 2.279,
    "Lease Term": 30,
    "Annual Lease Fee": 0.051,
    "Land Use Premium": null,
    "Number Of Local Employees": 1797,
    "Number Of Foreign Employees": 24,
    Status: "Monitoring Approved",
    "Investor Address":
      "Flat B, 15 F, Block 3, Sunny Villa , 218 Castle Peak Road, Tsuen Wan, Hong Kong",
    "Organization Address":
      "Unit B-6, 28/F, TML Tower, 3 Hoi Shing Road, Tsuen Wan, Hong Kong",
    "Investment Permitted Address":
      "Plot No. 105, Myay Taing Quarter No. 65 ( SETMU), ShwePyi Thar Industrial Zone 4, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 1510,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw Yin Lee Yint @ Li Li San",
    "Name of Principal Organization": "Panda Textile Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Wedge Garment Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "829/2014",
    "Permit Date": "2014-10-28T05:58:02Z",
    "Meeting Number": "24/2014",
    "Meeting Date": "2014-10-17T05:58:25Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.35,
    "Total Amount Of Capital (in Millions)": 0.7,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "Ministry of Industry",
    "Land Area (units not specified in file)": 2.3,
    "Lease Term": 10,
    "Annual Lease Fee": 51.74,
    "Land Use Premium": null,
    "Number Of Local Employees": 700,
    "Number Of Foreign Employees": 15,
    Status: "Monitoring Approved",
    "Investor Address": "No.75, Manawhari Street, Dagon Township, Yangon",
    "Organization Address":
      "No.18/A, Room 3/4, 1st Floor, Boyarnyunt Street, Dagon Township, Yangon Region",
    "Investment Permitted Address":
      "No.11, Textile Factory, Sin Ngyu Ward, Insein Township, Yangon Region",
  },
  {
    ID: 1511,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်မြတ်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "New General Industry Co., Ltd. (သစ်လွင်အထွေထွေ စက်မှုလုပ်ငန်းကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1164/2016",
    "Permit Date": "2016-03-26T06:13:14Z",
    "Meeting Number": "8/2016",
    "Meeting Date": "2016-03-04T06:13:25Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ   Plastic Shoppig Bag  အမျိုးမျိုး  ထုတ်လုပ် ဖြန့်ဖြူးရောင်းချခြင်း  လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 2.51,
    "Total Amount Of Capital (in Millions)": 3600,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 35,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": " မြန်မာ့ဆေးဝါးလုပ်ငန်း၊ စက်မှုဝန်ကြီးဌာန",
    "Land Area (units not specified in file)": 81.57,
    "Lease Term": 25,
    "Annual Lease Fee": 51,
    "Land Use Premium": null,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၃၇၊ ဝေဇယန္တာလမ်း၊ ၉ ရပ်ကွက်၊ တောင်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "\nNo.151, 9th floor, Tower(A), Corer Bogyoke Aung San Street & Wardan Street, 8-Wards, , Lanmadaw, Yangon",
  },
  {
    ID: 1512,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Kyaw Kyaw Win",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Kayser Myanmar Manufacturing Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "914/2015",
    "Permit Date": "2015-03-09T06:58:49Z",
    "Meeting Number": "3/2015",
    "Meeting Date": "2015-02-27T06:59:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Electromechanical Goods on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.5613,
    "Total Amount Of Capital (in Millions)": 0.7484,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "U Khin Hla",
    "Land Area (units not specified in file)": 2.127,
    "Lease Term": 30,
    "Annual Lease Fee": 0.043,
    "Land Use Premium": null,
    "Number Of Local Employees": 173,
    "Number Of Foreign Employees": 6,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.294, East Day Won, 88th Street, Between 36th x 37th Street, Mahar Aung Myay Township, Mandalay Region",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No.259, Myay Taing Block No. 25, Shwe Linn Ban Industrial Zone, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 1513,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဖိုးဇော် (ခ) ဦးဇော်ဇော် ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Max (Myanmar) Construction Co., Ltd. ",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "Ma na tha - 755/2010",
    "Permit Date": "2010-08-05T05:12:13Z",
    "Meeting Number": "17/2010",
    "Meeting Date": "2010-05-21T05:12:27Z",
    Sector: "Construction",
    "Type Of Investment Business":
      "ဘီအိုတီ စနစ်ဖြင့် လမ်းပြုပြင်ဖောက်လုပ်၍ လမ်းတံတားအသုံးပြုခ ကောက်ခံခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 4.765,
    "Total Amount Of Capital (in Millions)": 9175,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၁၉၊ ကုက္ကိုင်းရိပ်သာလမ်း၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ် ၁၊  ရွာမကွေ့၊ ဘုရင့်နောင်လမ်း၊ အမှတ် ၂ ရပ်ကွက်၊ လှိုင်မြို့နယ်",
  },
  {
    ID: 1514,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကျော်ဌေး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Su Htu Pan Construction Co., Ltd.",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "Mana tha - 756/2010",
    "Permit Date": "2010-08-05T06:18:07Z",
    "Meeting Number": "19/2010",
    "Meeting Date": "2010-06-03T06:18:54Z",
    Sector: "Construction",
    "Type Of Investment Business":
      "ဘီအိုတီ စနစ်ဖြင့် ပြုပြင်လမ်းဖောက်၍ လမ်းတံတား အသုံးပြခကောက်ခံခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": 4.78,
    "Total Amount Of Capital (in Millions)": 3400,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "ဆောက်လုပ်ရေးဝန်ကြီးဌာန၊ ပြည်သူ့ဆောက်လုပ်ရေးလုပ်ငန်း",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 270,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "အမှတ် (၃)၊ (၄)၊ ပါရမီအိမ်ရာ၊ လှိုင်မြို့နယ်",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ် (၂) ၊ ၁၀ ရပ်ကွက်၊  ရတနာလမ်း၊ သာကေတမြို့နယ်၊ ရန်ကုန်တိုင်း",
  },
  {
    ID: 1517,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Thet Hnin Soe ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Ayeyar Apex Construction Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "073/2018",
    "Permit Date": "2018-04-29T08:04:25Z",
    "Meeting Number": "5/2018",
    "Meeting Date": "2018-04-20T08:04:41Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Residence နှင့် Service Apartment များ တည်ဆောက်၍ ငှားရမ်းခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 26.436,
    "Total Amount Of Capital (in Millions)": 170000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Zaw Zaw ",
    "Land Area (units not specified in file)": 2.272,
    "Lease Term": 50,
    "Annual Lease Fee": 783.33,
    "Land Use Premium": null,
    "Number Of Local Employees": 136,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "No-4, Kanbawza Yeiktha Street, Shwe Taung Kyar 1st Quarter, Bahan Township, Yangon. ",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်(၅၂၈) ၊ ရာကျော်လမ်း၊ မြို့သစ်(၈)ရပ်ကွက်၊ အင်းစိန် မြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 1518,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyaw Thu Ya",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "New City Development Public Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "069/2018",
    "Permit Date": "2018-03-27T09:31:55Z",
    "Meeting Number": "4/2018",
    "Meeting Date": "2018-03-20T09:32:25Z",
    Sector: "Industrial Estate",
    "Type Of Investment Business":
      "Construction , Operation and Leasing of Light Industrial Park ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 65052.66,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "New City Development Public Co., Ltd.",
    "Land Area (units not specified in file)": 665.81,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 102,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No-57, Myayamone Sun Yeik Myaing Housing, Lay Dauk Kan Road, Dagon Myothit (South), Yangon.",
    "Organization Address": "",
    "Investment Permitted Address":
      "3rd Floor, Saya San Palaza, New University Avenue Road, Bahan Town Ship, Yangon.",
  },
  {
    ID: 1519,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Zaw Win Tun ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Shwe Than Lwin Highway Co., Ltd. ",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "Manatha-707/2009",
    "Permit Date": "2009-11-02T02:28:07Z",
    "Meeting Number": "25/2009",
    "Meeting Date": "2009-07-17T02:28:50Z",
    Sector: "Construction",
    "Type Of Investment Business":
      "ဘီအိုတီ စနစ်ဖြင့် လမ်းပြုပြင်ဖောက်လုပ်၍ လမ်းတံတားအသုံးပြုခကောက်ခံခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 13502.31,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "ေဆာက္လုပ္ေရး၀န္ျကီးဌာန ျပည္သူ့ေဆာက္လုပ္ေရးလုပ္ငန္း",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 489,
    "Number Of Foreign Employees": 3,
    Status: "Approved",
    "Investor Address":
      "W-66, Ba Yint Naung Road, Thi Ri Mon Complex, Hlaing Tsp",
    "Organization Address": "",
    "Investment Permitted Address":
      "No. 1950, Yangon- Pathein Road, Hlaingtharya, Yangon ",
  },
  {
    ID: 1520,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Myo Nyunt",
    "Name of Principal Organization":
      "General Food Technology Industry Co.,Ltd",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Golden Bay Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "012/2017",
    "Permit Date": "2017-08-09T03:24:27Z",
    "Meeting Number": "10/2017",
    "Meeting Date": "2017-07-11T03:23:20Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Value-Added Fish, Mollusc And Shellfish such as Prawn and Crab",
    "Amount Of Foreign Capital USD (in Millions)": 0.8,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Malaysia",
    "Form Of Investment": "JV",
    "Land Owner":
      "Department of Fisheries, Ministry of Agriculture, Livestock and Irrigation",
    "Land Area (units not specified in file)": 6151.22,
    "Lease Term": 10,
    "Annual Lease Fee": 0.06152,
    "Land Use Premium": null,
    "Number Of Local Employees": 257,
    "Number Of Foreign Employees": 6,
    Status: "Amended",
    "Investor Address":
      "No.36, Inya Myaing Road, Shwe Taung Kyar (1) Ward, Bahan Township, Yangon",
    "Organization Address":
      "No.(2/2), Department of Fisheries Compound, Bayintnaung Road, West Gyogone, Insein Township, Yangon Region",
    "Investment Permitted Address":
      "No.(2/2), Department of Fisheries Compound, Bayintnaung Road, West Gyogone, Insein Township, Yangon Region",
  },
  {
    ID: 1521,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyi Sein",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Teak Wood Industries Co.,Ltd",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "MaNaTha-937/2013",
    "Permit Date": "2013-09-19T03:58:29Z",
    "Meeting Number": "23/2013",
    "Meeting Date": "2013-09-04T03:59:40Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်ပါးလွှာ၊ အထပ်သားနှင့် သစ်အခြေခံပစ္စည်းအမျိုးမျိုးတိုးအားကုန်ချောထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 9883.7,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးကြည်စိန်",
    "Land Area (units not specified in file)": 15.682,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "တိုက်(၃၈)၊ဝါးတန်းလမ်း၊လမ်းမတော်မြို့နယ်",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်-၁၇၁၊ စက်မှုဇုန်-၂၊ ကမ်းနားလမ်း၊ ဒဂုံဆိပ်ကမ်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1522,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Tan Aik Cheong ",
    "Name of Principal Organization":
      "Greenfield Development Pte. Ltd. . 230 Victoria Street, # 06-09 Bugis Junction Towres, Singapore ",
    "Place of Incorporation": "Singapore ",
    "Company Name In Myanmar": "Straits Greenfield Limited ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "Na -084/1993",
    "Permit Date": "2013-05-02T03:58:14Z",
    "Meeting Number": "12/2013",
    "Meeting Date": "2013-04-05T03:59:10Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel and Related Services ",
    "Amount Of Foreign Capital USD (in Millions)": 183.27,
    "Total Amount Of Capital (in Millions)": 183.27,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII,BOT",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 96,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address": "52, Happy Avenue, North Singapore 369786",
    "Organization Address":
      "230 Victoria Street, # 06-09 Bugis Junction Towres, Singapore ",
    "Investment Permitted Address":
      "Corner of Kaebaaye Pagoda road and No. (1) Industry Road, Yankin Tsp, Yangon ",
  },
  {
    ID: 1523,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS. WONG SHERMAN KELLY",
    "Name of Principal Organization": "DOUBLE  PACKING  MANUFACTURER LIMITED",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "DOUBLE PACKING (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "997/2015",
    "Permit Date": "2015-08-20T05:27:34Z",
    "Meeting Number": "14/2015",
    "Meeting Date": "2015-08-07T05:28:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF ALL KINDS OF PLASTIC BAGS ON CONTRACT MANUFACTURING  PROCESS (CMP) BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 12.738,
    "Total Amount Of Capital (in Millions)": 13.408,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "U Tin Htun",
    "Land Area (units not specified in file)": 9.512,
    "Lease Term": 10,
    "Annual Lease Fee": 0.19,
    "Land Use Premium": null,
    "Number Of Local Employees": 1066,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address":
      "FLAT  A, 5/F., SPEEDY INDUSTRIAL  BUILDING , 114 HOW MING STREET, KWUN TONG, KOWLOON, HONG KONG",
    "Organization Address":
      "FLAT A, 5/F., SPEEDY INDUSTRIAL BUILDING, 114 HOW MING STREET, KWUN TONG, KOWLOON, HONG KONG",
    "Investment Permitted Address":
      "PLOT NO. D-4,D-5, D-11, D-12 ,  MYAY TAING BLOCK NO. 20, ANAWRAHTAR  INDUSTRIAL ZONE, HLAING THAR YAR  TOWNSHIP, YANGON REGION ",
  },
  {
    ID: 1525,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Myint Myint Win",
    "Name of Principal Organization": "",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Shwe Than Lwin Media Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1060/2015",
    "Permit Date": "2015-07-24T06:50:32Z",
    "Meeting Number": "12/2015",
    "Meeting Date": "2015-07-03T07:25:09Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Construction of Satellite Earth Station and Satellite Base Communication Services (Excluding the International Gateway)",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 13865,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Shwe Than Lwin Trading Co., Ltd.",
    "Land Area (units not specified in file)": 10,
    "Lease Term": 10,
    "Annual Lease Fee": 360,
    "Land Use Premium": null,
    "Number Of Local Employees": 80,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "no. 126 A , 20 Street, Latha Township, Yangon",
    "Organization Address":
      "Yangon Region, Tamwe Township, Corner of Malar Nwe Road and Pin Shwe Nyaung Road, Plot No- 51B2, Myay Taing Block-34D, 10 Acres of Land",
    "Investment Permitted Address":
      "Yangon Region, Tamwe Township, Corner of Malar Nwe Road and Pin Shwe Nyaung Road, Plot No- 51B2, Myay Taing Block-34D, 10 Acres of Land",
  },
  {
    ID: 1527,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Pallippakkam Sivaraman Somasekharan",
    "Name of Principal Organization": "Concorde Commodities Pte, Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Concorde Industries Limited",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "579/2013",
    "Permit Date": "2013-03-29T08:22:29Z",
    "Meeting Number": "11/2013",
    "Meeting Date": "2013-03-29T08:29:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of All Kinds of Wood Products",
    "Amount Of Foreign Capital USD (in Millions)": 6,
    "Total Amount Of Capital (in Millions)": 6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Myanma timberEnterprise",
    "Land Area (units not specified in file)": 3.426,
    "Lease Term": 15,
    "Annual Lease Fee": 41593.59,
    "Land Use Premium": 415935.9,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "19 Amber Gardens # 12-13, Singapore 439962",
    "Organization Address":
      "101 Cecil Street, # 20-11 Tong Eng Building , Singapore 069533",
    "Investment Permitted Address":
      "No.4 Quarter, Bayint Naung Road, Hlaing Township, Yangon",
  },
  {
    ID: 1528,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. Hitoshi Tani",
    "Name of Principal Organization":
      "EXE- SAKURA Residence Development Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Exe Design (MYANMAR) Co., Ltd,",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "Na-555/2013",
    "Permit Date": "2013-08-28T02:37:27Z",
    "Meeting Number": "21/2013",
    "Meeting Date": "2013-08-15T02:38:25Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Construction and Operation of Serviced Apartment Complex ",
    "Amount Of Foreign Capital USD (in Millions)": 25,
    "Total Amount Of Capital (in Millions)": 25,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner":
      "Department of Human Settlement and Housing Development, Ministry of Construction",
    "Land Area (units not specified in file)": 13620,
    "Lease Term": 50,
    "Annual Lease Fee": 196128,
    "Land Use Premium": 3105000,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "Mejiro Garden Heights # 608, 1-38-12 Takada, Toshima-ku, Tokyo 171-0033, Japan",
    "Organization Address": "30, Robinson Road, # 15-000 City House, Singapore",
    "Investment Permitted Address":
      "Plot 5, Block No. 29 A, Panwar Street, Kamayut Township, Yangon ",
  },
  {
    ID: 1530,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Htay Myint",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Yuzana Construction Co., Ltd.",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "manatha 712/2009",
    "Permit Date": "2009-11-02T07:16:24Z",
    "Meeting Number": "33/2009",
    "Meeting Date": "2009-09-15T07:16:44Z",
    Sector: "Construction",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 21600,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 300,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "No-130, Shwegonetaing Road, Yuzana Center, Bahan T/S, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No-130, Shwegonetaing Road, Yuzana Center, Bahan T/S, Yangon",
  },
  {
    ID: 1531,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.KIM SUNBAL",
    "Name of Principal Organization":
      "lvmc Holding (HM)  Singapore PTE.LTD., 80 Robinson Road,#02-00,SIngapore (068898)",
    "Place of Incorporation": " SINGAPORE  ",
    "Company Name In Myanmar": "SHWE  DAEHAN  MOTORS CO., LTD.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "084/2018",
    "Permit Date": "2018-05-31T07:53:16Z",
    "Meeting Number": "7/2018",
    "Meeting Date": "2018-05-29T07:53:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING, SALES AND AFTER SALES SERVICE OF MOTOR VEHICLES AND MOTORCYCLES",
    "Amount Of Foreign Capital USD (in Millions)": 9.82,
    "Total Amount Of Capital (in Millions)": 9.82,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "Chain Family Asset Co.,Ltd.",
    "Land Area (units not specified in file)": 6.371,
    "Lease Term": 50,
    "Annual Lease Fee": 0.297,
    "Land Use Premium": null,
    "Number Of Local Employees": 1003,
    "Number Of Foreign Employees": 7,
    Status: "Monitoring Amended",
    "Investor Address":
      "SIN HYUN-RO, OPO-EUP,103-802, E-PYUNHAN SESANG APARTMENT,KWANGJU-SI,KYUNGGI-DO,REPUBLIC OF KOREA   ",
    "Organization Address": "80 ROBINSON  ROAD, #02-00, SINGAPORE (068898)",
    "Investment Permitted Address":
      "PLOT NO.69,70, MYAY TAING BLOCK NO.50, THAR DU KAN INDUSTRIAL ZONE, SHWE PYI  THAR  TOWNSHIP, YANGON REGION\t",
  },
  {
    ID: 1532,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.LIN QUAN YI ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "XIANG YI INDUSTRIAL MANUFACTORY COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1021/2015",
    "Permit Date": "2015-10-02T07:51:43Z",
    "Meeting Number": "17/2015",
    "Meeting Date": "2015-09-28T08:01:06Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF BAGS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.754,
    "Total Amount Of Capital (in Millions)": 1.754,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaw Soe & Daw Khin Aye Aye Than",
    "Land Area (units not specified in file)": 0.677,
    "Lease Term": 30,
    "Annual Lease Fee": 0.08,
    "Land Use Premium": null,
    "Number Of Local Employees": 277,
    "Number Of Foreign Employees": 102,
    Status: "Monitoring Approved",
    "Investor Address": "FLAT 8(A), TUNG LOK WAN HILL ROAD, SHATIN, HONG KONG",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.488 , MYAY TAING BLOCK NO.25, SHWE LINN BAN INDUSTRIAL ZONE, HLAING THAR YAR  TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1533,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Htin Lin Naing",
    "Name of Principal Organization":
      "AYEYAR HINTHAR CONSTRUCTION COMPANY LIMITED",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "MYANMAR SAFETY GLASS COMPANY LIMITED\t",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1032/2015",
    "Permit Date": "2015-11-11T08:48:11Z",
    "Meeting Number": "18/2015",
    "Meeting Date": "2015-10-23T08:48:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "FABRICATION, PROCESSING AND SALE OF VARIETIES OF GLASSES  ",
    "Amount Of Foreign Capital USD (in Millions)": 0.96,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "U Zaw Win Shein",
    "Land Area (units not specified in file)": 1.2,
    "Lease Term": 10,
    "Annual Lease Fee": 156,
    "Land Use Premium": null,
    "Number Of Local Employees": 47,
    "Number Of Foreign Employees": 8,
    Status: "Monitoring Approved",
    "Investor Address":
      "ROOM No.6, NO.79, MINDIN STREET, WARD NO.29, THINGANGYUN TOWNSHIP, YANGON ",
    "Organization Address":
      "ROOM NO.104, NO.531, YE TA KHON TOWER, LOWER KYEE MYIN DAING ROAD, KYEE MYIN DAING TOWNSHIP, YANGON ",
    "Investment Permitted Address":
      "PLOT NO.G-3, MYAY TAING BLOCK NO. 20, AHNAWYAHTAR INDUSTRIAL ZONE , HLAING THAR YAR  TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1534,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Ne Win Kyaw",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Thaw Tar Win Construction Co., Ltd.",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "manatha 713/2009",
    "Permit Date": "2009-11-02T07:35:55Z",
    "Meeting Number": "25/2009",
    "Meeting Date": "2009-07-17T10:05:11Z",
    Sector: "Construction",
    "Type Of Investment Business": "BOT Road ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 55775,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 300,
    "Number Of Foreign Employees": 9,
    Status: "Approved",
    "Investor Address":
      "No.3, Room 302, Corner of Kabaaye Pagoda Road & Pyay Road, Mayangone T/S, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.3, Room 302, Corner of Kabaaye Pagoda Road & Pyay Road, Mayangone T/S, Yangon",
  },
  {
    ID: 1535,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. NG SUN HO",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": 'HOTEL "M" MANAGEMENT COMPANY LIMITED',
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "685/2014",
    "Permit Date": "2013-03-13T10:27:35Z",
    "Meeting Number": "7/2014",
    "Meeting Date": "2014-02-19T10:27:58Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": 1.575,
    "Total Amount Of Capital (in Millions)": 2.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Tin Tin Sein",
    "Land Area (units not specified in file)": 0.222,
    "Lease Term": 15,
    "Annual Lease Fee": 0.06,
    "Land Use Premium": null,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "12, SLGLAP PLAIN, SINGAPORE 456001",
    "Organization Address": "",
    "Investment Permitted Address":
      "No(29), Kanbaeza Yiek Tha Street, Golden Valley, No (1) Ward., Bahan Township, YANGON",
  },
  {
    ID: 1536,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yong Yung Kiong",
    "Name of Principal Organization": "BIG TREE CO., LTD> ",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "BIG TREE CO., LTD> ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "Na-599/2013",
    "Permit Date": "2013-08-21T02:32:40Z",
    "Meeting Number": "17/2013",
    "Meeting Date": "2013-06-29T02:34:19Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Service ",
    "Amount Of Foreign Capital USD (in Millions)": 4.2,
    "Total Amount Of Capital (in Millions)": 4.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Nant Hninn Thiri Kyaw ",
    "Land Area (units not specified in file)": 0.28,
    "Lease Term": 50,
    "Annual Lease Fee": 0.03,
    "Land Use Premium": null,
    "Number Of Local Employees": 117,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address": "6 Mimosa Vale, Singapore 807929",
    "Organization Address": "6 Mimosa Vale, Singapore 807929",
    "Investment Permitted Address":
      "No. 67-71, Yae tar Shae Lanthit Street, Bahan Township, Yangon ",
  },
  {
    ID: 1537,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kittayos Suchitt",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Pack Express Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": " 864/2015",
    "Permit Date": "2015-01-21T03:35:04Z",
    "Meeting Number": "29/2014",
    "Meeting Date": "2014-12-26T03:36:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Carton Boxes",
    "Amount Of Foreign Capital USD (in Millions)": 0.4,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "U Lin Kun Sein @ U Khin Sein and U Win Myint",
    "Land Area (units not specified in file)": 1.2,
    "Lease Term": 50,
    "Annual Lease Fee": 0.025,
    "Land Use Premium": null,
    "Number Of Local Employees": 32,
    "Number Of Foreign Employees": 4,
    Status: "Approved",
    "Investor Address":
      "87/32 Tesbalsongkroa Road, Ladyao, Chatujak, Bangkok 10900, Thailand",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No. 356, Myay Taing Block No.25, Shwe Linban Industrial Zone, Haling Thar Yar Township, Yangon Region",
  },
  {
    ID: 1538,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Dr Zaw Min Aung",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Green Alliance Energy Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1155/2016",
    "Permit Date": "2016-03-26T04:00:59Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T04:02:21Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Construction of LPG Tank and Jetty and LPG Importation distribution and Sales services",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 55550.602,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Transport",
    "Land Area (units not specified in file)": 150000,
    "Lease Term": 50,
    "Annual Lease Fee": 360,
    "Land Use Premium": null,
    "Number Of Local Employees": 28,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No-2027, Sint Kuu  Road, Yadanar Theikdi Ward, Ottarathiri Township, Nay Pyi Taw ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Yangon Region, Thanlyin-Kyauktan, Thilawa Port, Plot \n No-22, Land area 37.06 acres",
  },
  {
    ID: 1539,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw Lway Lway",
    "Name of Principal Organization":
      "Yangon Crown Wire and Electric Cable Product Factory Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Yangon Crown Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "898/2015",
    "Permit Date": "2015-02-04T04:09:58Z",
    "Meeting Number": "1/2015",
    "Meeting Date": "2015-01-16T04:10:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Electrical Wire",
    "Amount Of Foreign Capital USD (in Millions)": 1.11,
    "Total Amount Of Capital (in Millions)": 2.22,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Sho Kyin Min and Daw Nan Mya Han",
    "Land Area (units not specified in file)": 2.17,
    "Lease Term": 50,
    "Annual Lease Fee": 0.052,
    "Land Use Premium": null,
    "Number Of Local Employees": 977,
    "Number Of Foreign Employees": 3,
    Status: "Approved",
    "Investor Address":
      "No.1006,Pan Hlaing Street, Yetakho Tower Say/Nyein Ward, Kyimyindine Township, Yangon",
    "Organization Address":
      "No.66, Pintinwun U Shwe Bin Street, Shwe Pyi Thar Industrial Zone-3, Shwe Pyi Thar Township, Yangon Region",
    "Investment Permitted Address":
      "Plot No.66,157/A, Myay Taing Block No.64, Shwe Pyi Thar Industrial Zone-3, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 1540,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Somchai Lotharukpong",
    "Name of Principal Organization": "VT Garment Co., Ltd.",
    "Place of Incorporation": "Thailang",
    "Company Name In Myanmar": "Sawbwa VT Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "817/2014",
    "Permit Date": "2014-10-21T04:40:12Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T04:40:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.65,
    "Total Amount Of Capital (in Millions)": 2.8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "KK Co., Ltd.",
    "Land Area (units not specified in file)": 2.012,
    "Lease Term": 40,
    "Annual Lease Fee": 0.049,
    "Land Use Premium": null,
    "Number Of Local Employees": 933,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "30 Sukhumuit 49/14, Klinetonnua Wattana, Bangkok 10110, Thailang",
    "Organization Address":
      "602/50 Soi Sathupradit 48, Sathupradit Road, Bangepongpang, Yannawa, Bangkok 10120, Thailand",
    "Investment Permitted Address":
      "No.131, Yangon Industry Zone, Mingalardon Garden Ctiy, Mingalardon Township, Yangon Region",
  },
  {
    ID: 1541,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. WU MING HUNG  ",
    "Name of Principal Organization":
      "GLOBAL UNITED TRADING AND SOURCING PTE. LTD.",
    "Place of Incorporation": "SINGAPORE ",
    "Company Name In Myanmar":
      "GLOBAL  APPAREL TEXTILE (MYANMAR) MANUFACTURING COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1041/2015",
    "Permit Date": "2015-11-11T04:53:10Z",
    "Meeting Number": "19/2015",
    "Meeting Date": "2015-10-30T04:53:37Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENTS ON CMP  BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 3.121,
    "Total Amount Of Capital (in Millions)": 3.121,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myint Maung @ Eike  San",
    "Land Area (units not specified in file)": 1.8,
    "Lease Term": 10,
    "Annual Lease Fee": 0.05,
    "Land Use Premium": null,
    "Number Of Local Employees": 499,
    "Number Of Foreign Employees": 18,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 159, KAMPONG AMPAT ROAD, #06-04, KA PLACE, SINGAPORE 368328",
    "Organization Address":
      "NO. 159, KAMPONG AMPAT ROAD, #06-04, KA PLACE, SINGAPORE 368328 ",
    "Investment Permitted Address":
      "PLOT NO. 42, MYAY TAING BLOCK NO. 143/1, KYANSITTHAR YEIKMON INDUSTRIAL ZONE, DAGON MYOTHIT (SOUTH) TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1542,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Sudhir Kumar Singh",
    "Name of Principal Organization": "Century Plyboards (India) Limited",
    "Place of Incorporation": "India",
    "Company Name In Myanmar": "Centuryply Myanmar Pirvate Limited",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "495/2012",
    "Permit Date": "2012-07-30T05:46:59Z",
    "Meeting Number": "21/2012",
    "Meeting Date": "2012-07-18T05:48:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Veneer and Plywood",
    "Amount Of Foreign Capital USD (in Millions)": 7,
    "Total Amount Of Capital (in Millions)": 7,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "India",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": 30,
    "Annual Lease Fee": 26000,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Flower Valley Block C-5, Flat No-303, 493B, GT Road South Shibpur, Howrah Pin-7111102 WB",
    "Organization Address": "6, Lyons Range, Kolkata-700001, India",
    "Investment Permitted Address":
      "Block No.(109), Plot No.(24, 25, 26 & 27), East Dagon Industry Zone, East Dagon Township, Yangon",
  },
  {
    ID: 1544,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Lwin Moe",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ASIAN WINGS AIRWAYS LIMITED",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "Ma Na Tha 774/2011",
    "Permit Date": "2011-01-12T06:48:35Z",
    "Meeting Number": "41/2010",
    "Meeting Date": "2010-12-10T06:48:55Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Domestic and International Airline Services",
    "Amount Of Foreign Capital USD (in Millions)": 5,
    "Total Amount Of Capital (in Millions)": 140,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Transport and Communcations",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 150,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "No. 32-a, Pyi Thaung Su Street, Bahan Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No(41), Shwe Taung Gyar Street, , Bahan Township, YANGON",
  },
  {
    ID: 1545,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Toh Cheng Wan",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Green Tech Industries Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "547/2013",
    "Permit Date": "2013-01-31T07:08:09Z",
    "Meeting Number": "5/2013",
    "Meeting Date": "2013-01-30T07:09:14Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production and Marketing of Wood Substituted Products(Wood Plastic Composite Resins, Extrusion ECO Wood Profile, Ecoplas Injection Products)",
    "Amount Of Foreign Capital USD (in Millions)": 0.563,
    "Total Amount Of Capital (in Millions)": 0.563,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "BLK 420, Bedok North Road,# 05-124, Singapore 460420",
    "Organization Address": "",
    "Investment Permitted Address":
      "No. 60, Daw Phwa Shin Street, Hlaing Thar Yar Industrial Zone(1), Hlaing Thar Yar Township, Yangon",
  },
  {
    ID: 1546,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Win Ho @ U Win Aung",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Thein Wa Garment Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "1026/2015",
    "Permit Date": "2015-02-13T07:32:32Z",
    "Meeting Number": "1/2015",
    "Meeting Date": "2015-01-16T07:32:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Garment on CMP Basis (Jacket, Shirt, Sportswear and Pants, etc.)",
    "Amount Of Foreign Capital USD (in Millions)": 0.22,
    "Total Amount Of Capital (in Millions)": 287.84,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Khin Si",
    "Land Area (units not specified in file)": 0.119,
    "Lease Term": 10,
    "Annual Lease Fee": 1.5,
    "Land Use Premium": null,
    "Number Of Local Employees": 400,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Building No. 3, Room No. 302, Hlaing Thiri Housing, Insein Road, 9 Ward, Hlaing Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 3, Myay Taing Block No. Nga, Padonmar Street, North Okkalapa Industrial Zone, North Okkalapa Township, Yangon",
  },
  {
    ID: 1549,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Tun Myint Naing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ASIA WORLD PORT MANAGEMENT LIMITED",
    "Financial Year From": 2006,
    "Financial Year To": 2007,
    "Permit Number": "Ma Na Tha 670/2006",
    "Permit Date": "2006-10-12T03:48:56Z",
    "Meeting Number": "1/2006",
    "Meeting Date": "2006-01-03T03:50:22Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် အမှတ် ၄ အလုံဆိပ်ခံတံတားတည်ဆောက်၍ အထွေထွေ ကုန်ပစ္စည်းနှင့်ကုန်သေတ္တာများဆိုက်ကပ်၍ ကုန်တင်ကုန်ချဆိပ်ကမ်း ဝန်ဆောင်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.5,
    "Total Amount Of Capital (in Millions)": 10009,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "Myanma Port Authority",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": 96080000,
    "Number Of Local Employees": 191,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "Corner of Insein Street and Pan Ni Ta Street, 8/9 Quarter, Hlaing Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      " No.(61/62), Bahosi Development, Wardan Street, , Lanmadaw Township, YANGON",
  },
  {
    ID: 1550,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Zaw Win Oo",
    "Name of Principal Organization": "Fibrelink Myanmar Holdings Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Fibrelink Myanmar Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1190/2016",
    "Permit Date": "2016-11-11T03:52:30Z",
    "Meeting Number": "20/2016",
    "Meeting Date": "2016-10-28T03:52:52Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Fibre Infrastructure related Internet and Telecommunication Services",
    "Amount Of Foreign Capital USD (in Millions)": 858.87,
    "Total Amount Of Capital (in Millions)": 858.87,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 4,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myo Thein",
    "Land Area (units not specified in file)": 2278.5,
    "Lease Term": 1,
    "Annual Lease Fee": 24,
    "Land Use Premium": 0,
    "Number Of Local Employees": 272,
    "Number Of Foreign Employees": 51,
    Status: "Approved",
    "Investor Address":
      "No.3 (A), Pyitawaye Avenue, Ward No. 7, Yankin Township, Yangon.",
    "Organization Address":
      "10 Anson Road, # 31-10, International Plaza, Singapore 079903",
    "Investment Permitted Address":
      "No.203, 2 Floor, Dana Thiha Tower, No.790, Corner of Bogyoke Aung San Road and War Tan Street., Lanmadaw, YANGON",
  },
  {
    ID: 1551,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Tun Myint Naing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ASIA WORLD PORT MANAGEMENT LIMITED",
    "Financial Year From": 2001,
    "Financial Year To": 2002,
    "Permit Number": "Ma Na Tha 514/2001",
    "Permit Date": "2001-08-14T05:07:40Z",
    "Meeting Number": "14/2001",
    "Meeting Date": "2001-05-11T05:11:28Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "အမှတ် ၃ အလုံ ဆိပ်ခံတံတားတည်ဆောက်၍ အထွေထွေကုန်ပစ္စည်းနှင့် ကုန်သေတ္တာများ ကုန်တင်ကုန်ချခြင်းလုပ်ငန်း၊ ဆိပ်ကမ်းဝန်ဆောင်မှုလုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1528,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "Myanma Port Authority, Ministry of Transport and Communications",
    "Land Area (units not specified in file)": 1.959,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": 9800000,
    "Number Of Local Employees": 155,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Corner of Insein Street and Pan Ti Ta Street, 18/9 Quarter, Hlaing Township, Yangon.",
    "Organization Address": "",
    "Investment Permitted Address":
      " No.(61/62), Bahosi Development, Wardan Street, , Lanmadaw Twonship, YANGON",
  },
  {
    ID: 1552,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr Naohiko Ota",
    "Name of Principal Organization": "KDDI Summit Global Singapore Pte. Ltd.",
    "Place of Incorporation": "Singapore ",
    "Company Name In Myanmar": "KDDI Summit Global Myanmar Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "766/2014",
    "Permit Date": "2014-08-08T05:20:36Z",
    "Meeting Number": "19/2014",
    "Meeting Date": "2014-07-18T05:21:07Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Telecommunications Services and related activities",
    "Amount Of Foreign Capital USD (in Millions)": 715,
    "Total Amount Of Capital (in Millions)": 715,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 84,
    "Number Of Foreign Employees": 100,
    Status: "Approved",
    "Investor Address": "8 Scotts Road, # 30-1 Scotts Square, Singapore 228238",
    "Organization Address":
      "195 Cecil Street, # 13-01,Octagon, Singapore 069534 ",
    "Investment Permitted Address":
      "No. 43, Bo Aung Kyaw Street, , Kyauktada, YANGON",
  },
  {
    ID: 1553,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr Andrew George Shepherd",
    "Name of Principal Organization": "Infrastructure Group Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "TPR Myanmar Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "Na 1053/2015",
    "Permit Date": "2015-12-16T06:11:28Z",
    "Meeting Number": "20/2015",
    "Meeting Date": "2015-11-13T06:11:51Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Construction of Telecom Towers and Lease of  ",
    "Amount Of Foreign Capital USD (in Millions)": 46.5,
    "Total Amount Of Capital (in Millions)": 46.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 30,
    "Number Of Foreign Employees": 8,
    Status: "Monitoring Approved",
    "Investor Address":
      "6 Marina Boulevard, # 60-18, The Sail @ Marina Bay, Singapore 018985",
    "Organization Address":
      "80 Raffles Place # 22-20, UOB Plaza, Singapore 048624",
    "Investment Permitted Address":
      "No(68)1-A,U Maung Maung Chan Street, Hlaing Township, Yangon., Hlaing, YANGON",
  },
  {
    ID: 1554,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Tun Myint Naing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ASIA WORLD PORT MANAGEMENT LIMITED",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "Ma Na Tha 178/1998",
    "Permit Date": "1998-10-02T06:12:19Z",
    "Meeting Number": "15/1998",
    "Meeting Date": "1998-08-28T06:30:33Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "ဆိပ်ခံတံတားတည်ဆောက်၍ အထွေထွေကုန်ပစ္စည်းနှင့် ကုန်သေတ္တာများ ကုန်တင်ကုန်ချခြင်းလုပ်ငန်း၊ ဆိပ်ကမ်းဝန်ဆောင်မှုလုပ်ငန်း (အမှတ် ၁ အလုံ ဆိပ်ခံတံတား)",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1377,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "Myanma Port Authority, Ministry of Transport and Communications",
    "Land Area (units not specified in file)": 4.606,
    "Lease Term": 25,
    "Annual Lease Fee": null,
    "Land Use Premium": 23030000,
    "Number Of Local Employees": 109,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No. 20,23, Ma Soe Yain Kyoung Street, 5 Quarter, Mayangone Township, Yangon.",
    "Organization Address": "",
    "Investment Permitted Address":
      " No.(61/62), Bahosi Development, Wardan Street, , Lanmadaw Township, YANGON",
  },
  {
    ID: 1555,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. KENJI  SUGIMOTO  ",
    "Name of Principal Organization": "MATSUYA R & D COMPANY LIMITED",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "MATSUYA R & D (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "905/2015",
    "Permit Date": "2015-02-13T05:01:56Z",
    "Meeting Number": "2/2015",
    "Meeting Date": "2015-01-31T05:02:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF CUFFS FOR SPHYGMOMANOMETERS ON CMP  BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.5,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner":
      "Department of Ubran and Housing Development & Mingalardon Industrial Park Co., Ltd.",
    "Land Area (units not specified in file)": 1.975,
    "Lease Term": 34,
    "Annual Lease Fee": 0.0023,
    "Land Use Premium": 463594,
    "Number Of Local Employees": 50,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address": "60-12-2  SHINOOCHO,  FUKUI  CITY,  FUKUI , JAPAN",
    "Organization Address": "3-19, MOTOMACHI, ONO CITY, FUKUI , JAPAN ",
    "Investment Permitted Address":
      "PLOT NO. A7-2, MINGALADON INDUSTRIAL PARK, MINGALADON TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1556,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.  Jong Hyuck LEE",
    "Name of Principal Organization": "Kido Industrial Co.,Ltd.",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "Kido Yangon Co.,Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "989/2015",
    "Permit Date": "2015-08-06T06:10:28Z",
    "Meeting Number": "13/2015",
    "Meeting Date": "2015-07-17T06:10:47Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF GARMENTS ON CMP  BASIS FOR GARMENT FACTORY NO. (2)",
    "Amount Of Foreign Capital USD (in Millions)": 2.06,
    "Total Amount Of Capital (in Millions)": 2.289,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Chit Su Khine",
    "Land Area (units not specified in file)": 1.01,
    "Lease Term": 10,
    "Annual Lease Fee": 0.02,
    "Land Use Premium": null,
    "Number Of Local Employees": 804,
    "Number Of Foreign Employees": 6,
    Status: "Monitoring Approved",
    "Investor Address":
      "1603 HO, Mansu Hanguk ApT,102 Dong .23,Dambang-RO 21 Beon-Gil, Namdong, Incheon, Republic of Korea",
    "Organization Address":
      "Deunchone-Dong 395,Gonghang-Daero,Gangseo-Gu,Seoul, Korea",
    "Investment Permitted Address":
      "HOLDING  NO. 16 KA-2, KWIN NO. 518 A, SATTHWARDAW WEST KWIN, SATTHWARDAW VILLAGE TRACT, HMAWBI TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1557,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wang, Jun ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "PWR Fashion Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1077/2016",
    "Permit Date": "2016-02-04T03:07:03Z",
    "Meeting Number": "2/2016",
    "Meeting Date": "2016-01-22T03:07:25Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.3,
    "Total Amount Of Capital (in Millions)": 1.3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Shi Yoe Chen @ U Kyaw Sein Lin ",
    "Land Area (units not specified in file)": 2.03,
    "Lease Term": 10,
    "Annual Lease Fee": 0.049,
    "Land Use Premium": null,
    "Number Of Local Employees": 1175,
    "Number Of Foreign Employees": 18,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.203,3-3-36 Liao Ning Sheng, Pu Lan Dian Shi Shang Yedajie, China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.287/C & 287/D, Myay Taing Block No. C-13, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 1558,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Myo Swe",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Sein Hinn Co., Ltd. ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "MaNaTha-1040/2015",
    "Permit Date": "2015-03-10T03:52:51Z",
    "Meeting Number": "12/2014",
    "Meeting Date": "2014-04-10T03:52:38Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business":
      "B.O.T  စနစ်ဖြင့် မြေနှင့်အဆောက်အဦ ငှားရမ်း၍ ဟိုတယ်ဝန်ဆောင်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1441,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "ပြည်ထဲရေးဝန်ကြီးဌာန",
    "Land Area (units not specified in file)": 0.874,
    "Lease Term": 30,
    "Annual Lease Fee": 3.6,
    "Land Use Premium": 3,
    "Number Of Local Employees": 40,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "တိုက်အမှတ်(၃၆)၊ အခန်းအမှတ်(၅/၆)၊ ကျောက်စိမ်းလမ်း၊ စော်ဘွားကြီးကုန်း၊ အင်းစိန်မြို့နယ်၊ ရန်ကုန်",
    "Organization Address": "",
    "Investment Permitted Address":
      "တိုက်အမှတ်(၃၆)၊ အခန်းအမှတ်(၅/၆)၊ ကျောက်စိမ်းလမ်း၊ စော်ဘွားကြီးကုန်း၊ အင်းစိန်မြို့နယ်၊ ရန်ကုန်",
  },
  {
    ID: 1559,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. YANG JIANPING",
    "Name of Principal Organization":
      "SHANGHAI NEW UNION TEXTRA IMPORT & EXPORT CO., LTD., ",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "XIN TIANDI (MYANMAR) APPAREL COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1068/2016",
    "Permit Date": "2016-01-26T05:00:49Z",
    "Meeting Number": "1/2016",
    "Meeting Date": "2016-01-15T05:01:21Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.5,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Nay Win (a) U Tin Sein ",
    "Land Area (units not specified in file)": 2.176,
    "Lease Term": 15,
    "Annual Lease Fee": 4.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 294,
    "Number Of Foreign Employees": 6,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.47, YANGMUQIAO, YANGMUQIAO VILLAGE, GUCUN TOWN, BAOSHAN DISTRICT, SHANGHAI, CHINA ",
    "Organization Address": "NO.1341, YU YUAN ROAD, SHANHAI  200050, CHINA",
    "Investment Permitted Address":
      "PLOT NO.1 , MYAY TAING BLOCK NO.25, SHWE LINN BAN SETHMU MYO, HLAING THARYAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1560,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. ZHOU JIN",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MYANMAR CAIFENG COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "991/2016",
    "Permit Date": "2016-01-11T05:17:25Z",
    "Meeting Number": "23/2015",
    "Meeting Date": "2015-12-28T05:18:58Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "PRODUCTION AND MARKETING OF PRINTING INK",
    "Amount Of Foreign Capital USD (in Millions)": 3,
    "Total Amount Of Capital (in Millions)": 3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 24,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw San San Myint ",
    "Land Area (units not specified in file)": 1.001,
    "Lease Term": 10,
    "Annual Lease Fee": 0.033,
    "Land Use Premium": null,
    "Number Of Local Employees": 153,
    "Number Of Foreign Employees": 12,
    Status: "Monitoring Approved",
    "Investor Address":
      "23-13, CHONGYI STREET, ZHAOYANG DISTRICT, ZHAOTONG CITY,YUNNAN PROVINCE, PEOPLE’S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 89 ,  MYAY TAING BLOCK NO. PART(4), HLAING THAR YAR INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON REGION                                                                                                                                ",
  },
  {
    ID: 1562,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Than Win Swe",
    "Name of Principal Organization": "Daewoo Global Development Pte.Ltd. ",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Daewoo Amara Co., Ltd. ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "612/2013",
    "Permit Date": "2013-10-30T07:32:19Z",
    "Meeting Number": "20/2013",
    "Meeting Date": "2013-08-07T07:33:02Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Business",
    "Amount Of Foreign Capital USD (in Millions)": 190.71,
    "Total Amount Of Capital (in Millions)": 198.21,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,JV",
    "Land Owner": "Ministry of Defence",
    "Land Area (units not specified in file)": 5.045,
    "Lease Term": 50,
    "Annual Lease Fee": 1.874,
    "Land Use Premium": 13.51,
    "Number Of Local Employees": 771,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address":
      "Building (10), Room(103),Aung Myay Tharsi Housing, Kamayut Township. ",
    "Organization Address":
      "989 Bukit Timah Road, # 02-04 Maplewoods, Singapore",
    "Investment Permitted Address":
      "Bld No.8, Ground Floor, Myanmar Info-Tech(Phase 3), University's Hlaing Campus, Hlaing Township, Yangon",
  },
  {
    ID: 1563,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U YE MIN AUNG",
    "Name of Principal Organization":
      "MYANMAT AGRIBUSINESS PUBLIC CORPORATION (MAPCO) LIMITED",
    "Place of Incorporation": "MYANMAR",
    "Company Name In Myanmar": "MYANMAR JAPAN RICE INDUSTRY COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "937/2015",
    "Permit Date": "2015-04-27T08:11:33Z",
    "Meeting Number": "5/2015",
    "Meeting Date": "2015-03-20T08:14:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "PRODUCTION AND MARKETING OF RICE AND RICE PRODUCTS",
    "Amount Of Foreign Capital USD (in Millions)": 29.4,
    "Total Amount Of Capital (in Millions)": 60,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "MYANMAR AGRIBUSINESS PUBLIC CORPORATION LIMITED",
    "Land Area (units not specified in file)": 27.49,
    "Lease Term": 30,
    "Annual Lease Fee": 0.05,
    "Land Use Premium": null,
    "Number Of Local Employees": 50,
    "Number Of Foreign Employees": 6,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.17, MYA KHWAR NYO 1ST STREET, 7 WEST WARD, THATKETA TOWNSHIP, YANGON",
    "Organization Address":
      "NO.100, CORNER OF WARDEN AND KANNAR STREET, WARDEN PORT AREA, SEIK KAN (PORT) TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "PLOT NO.1/4, 122-C KAN PATT YOE KWIN, PHAYAR NGOTETO (MA) VILLAGE TRACT,YANGON REGION",
  },
  {
    ID: 1564,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. KUMAR  AKSHAY  DALMIA",
    "Name of Principal Organization": "EMDEES  IMPORT AND  EXPORT PTE. LTD",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "EMDEES MARINE PRODUCTS MYANMAR  LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "049/2017",
    "Permit Date": "2017-08-20T08:52:29Z",
    "Meeting Number": "11/2017",
    "Meeting Date": "2017-08-07T08:53:07Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "manufacturing, processing and marketing of various fish and shrimps",
    "Amount Of Foreign Capital USD (in Millions)": 3,
    "Total Amount Of Capital (in Millions)": 3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 4,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Soe Naing",
    "Land Area (units not specified in file)": 2.559,
    "Lease Term": 30,
    "Annual Lease Fee": 51779.57,
    "Land Use Premium": null,
    "Number Of Local Employees": 213,
    "Number Of Foreign Employees": 6,
    Status: "Monitoring Approved",
    "Investor Address":
      "2/85, VIJAI KHAND, GOMTI NAGAR, LUCKNOW , 226010, INDIA ",
    "Organization Address":
      "171, TRAS STREET , # 09-177, UNION BUILDING , SINGAPORE 079025",
    "Investment Permitted Address":
      "Block No. (21), Plot No. (C-4), Mya Sein Yaung Industrial Zone, Hlaing Thar Yar Township, Yangon., Hlaingtharyar, YANGON",
  },
  {
    ID: 1565,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. TRAN NGOC CHI ",
    "Name of Principal Organization": "GREENFEED VIET NAM CORPORATION",
    "Place of Incorporation": "VIETNAM",
    "Company Name In Myanmar": "GREENFEED VIETNAM COMPANY  LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "035/2017",
    "Permit Date": "2017-08-20T09:56:40Z",
    "Meeting Number": "11/2017",
    "Meeting Date": "2017-08-07T09:57:32Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND DISTRIBUTION OF ANIMAL FEEDS",
    "Amount Of Foreign Capital USD (in Millions)": 5,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner":
      "U Kyauk Gyi Kyon @ U Kyaw Myint and Daw Ai Ain @ Daw Tin Tin Maw",
    "Land Area (units not specified in file)": 3,
    "Lease Term": 10,
    "Annual Lease Fee": 345994104,
    "Land Use Premium": null,
    "Number Of Local Employees": 82,
    "Number Of Foreign Employees": 8,
    Status: "Approved",
    "Investor Address":
      "207/ 20/ 17 NGUYEN VAN DAU STREET, WARD 11, BINH THANH DISTRICT, HO CHI MINH CITY, VIETNAM",
    "Organization Address":
      "NHUT CHANH COMMUNE, BEN LUC DISTRICT, LONG AN PROVINCE, VIETNAM",
    "Investment Permitted Address":
      "Plot No(11/A & 11/B-1), Myay Taing Block No(552-C), Thar Du Kan Industrial Zone, ",
  },
  {
    ID: 1566,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Tun Myint Naing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ASIA WORLD PORT MANAGEMENT LIMITED",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "Ma Na Tha 016/1996",
    "Permit Date": "1996-04-24T03:20:08Z",
    "Meeting Number": "5/1996",
    "Meeting Date": "1996-03-21T03:21:43Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "ဆိပ်ခံတံတားတည်ဆောက်၍ ကုန်တင်ကုန်ချခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 297,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "Myanma Port Authority, Ministry of Transport and Communications",
    "Land Area (units not specified in file)": 1.32,
    "Lease Term": 25,
    "Annual Lease Fee": null,
    "Land Use Premium": 6500000,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No.20/23, Masoeyein Kyaung Street, 5 Quarter, Mayangone Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      " No.(61/62), Bahosi Development, Wardan Street, , Lanmadaw Township, YANGON",
  },
  {
    ID: 1567,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U SOE MIN THANT",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Q PAK COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1112/2016",
    "Permit Date": "2016-03-26T03:36:37Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T03:37:04Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND SALES OF PET AND HDPE BOTTLE AND CAP",
    "Amount Of Foreign Capital USD (in Millions)": 0.718,
    "Total Amount Of Capital (in Millions)": 1.437,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 45,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "U Thadoe Hein  ",
    "Land Area (units not specified in file)": 1.995,
    "Lease Term": 45,
    "Annual Lease Fee": 0.044,
    "Land Use Premium": null,
    "Number Of Local Employees": 44,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.148/P, MYA WUTT YI LANE, A-1  COMPOUND, MAYANGONE TOWNSHIP, YANGON ",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.140, YANGON INDUSTRIAL ZONE ,  NORTH OKKALAPA TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1568,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Aye Aye Khaing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Crown Advanced Construction Company   Limited   (သရဖူ ခေတ်မီ တိုးတက်သောဆောက်လုပ်ရေး ကုမ္ပဏီ လီမိတက်)",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha 1125/2016",
    "Permit Date": "2016-02-17T03:53:16Z",
    "Meeting Number": "1/2016",
    "Meeting Date": "2016-01-15T03:53:37Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "အဆင့်မြင့်အဆောက်အအုံများ တည်ဆောက်၍ ငှားရမ်းရောင်းချခြင်းလုပ်ငန်း     ",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 92800,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ရန်ကုန်မြို့တော်စည်ပင်သာယာရေးကော်မတီ",
    "Land Area (units not specified in file)": 8.863,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 34,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "အမှတ်-၁၇၊  ရှားဆေးဘိုလမ်း၊ ရှားဆေးဘိုရပ်ကွက်၊  ဇေယျာသီရိမြို့နယ်၊ နေပြည်တော်။",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်-၁၉/၂၀၊ ဦးမှိုလမ်း၊ ဒဂုံအရှေ့စက်မှုဇုန်၊ ဒဂုံမြို့သစ်(အရှေ့)မြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 1570,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Hnin Wai Soe",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Golden Cashew Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "MaNaTha-1261/2017",
    "Permit Date": "2017-06-22T04:01:14Z",
    "Meeting Number": "8/2017",
    "Meeting Date": "2017-05-19T04:03:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သီ ဟိုဠ ေစ့မ ်ား အ ေ၇ာင္ န င္ အ ရ့ႀ္ အစား ခြဲချားႈ ထုတ္လုပ္  ချင္း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 824.383,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Soe Maung, Daw Kyin Sein",
    "Land Area (units not specified in file)": 0.33,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 146,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.81, Ground Floor, 11st Street, Lan Ma Taw Township, Yangon",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No.H/20,Paduck Street,Ward No.1,Bayinnaung, Mayangone, YANGON",
  },
  {
    ID: 1571,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyaw Min Htet",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Skyrun International Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1124/2016",
    "Permit Date": "2016-01-26T04:29:09Z",
    "Meeting Number": "1/2016",
    "Meeting Date": "2016-01-15T04:29:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.21,
    "Total Amount Of Capital (in Millions)": 617.47,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Tin Hla & Daw Tin Tin Hla",
    "Land Area (units not specified in file)": 1.995,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 527,
    "Number Of Foreign Employees": 9,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 376, Ground Floor, Kann Nar Street, 5 Ward , La Thar Township , Yangon Region.",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 64, Myay Taing Block No. 64 (SettHmu) , Shwe Pyi Thar Township , Yangon Region.",
  },
  {
    ID: 1573,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Sai Myint Thein",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Yangon Poly Bag \t\tCo., Ltd. ",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1057/2015",
    "Permit Date": "2015-05-29T05:13:18Z",
    "Meeting Number": "9/2015",
    "Meeting Date": "2015-05-18T05:13:41Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing  of  Plastic Bag Products on Contract Manufacturing Process (CMP) ",
    "Amount Of Foreign Capital USD (in Millions)": 3.169,
    "Total Amount Of Capital (in Millions)": 4226.225,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Asia World Co., Ltd",
    "Land Area (units not specified in file)": 3.62,
    "Lease Term": 30,
    "Annual Lease Fee": 30,
    "Land Use Premium": null,
    "Number Of Local Employees": 298,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.496/500, Third Floor, 6 Ward, Kann Nar Street, Lan Ma Taw Township, Yangon Region",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 247/B, Myay Taing Block No. 23, South Dagon Industrial Zone, South Dagon  Township, Yangon Region",
  },
  {
    ID: 1574,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U MYO NYUNT",
    "Name of Principal Organization":
      "GENERAL FOOD TECHNOLOGY INDUSTRY CO., LTD",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "GOLDEN  BAY  LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "012/2017",
    "Permit Date": "2017-08-09T05:09:31Z",
    "Meeting Number": "10/2017",
    "Meeting Date": "2017-07-11T05:10:13Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF VALUE-ADDED FISH, MOLLUSC AND SHELLFISH SUCH AS PRAWN AND CRAB",
    "Amount Of Foreign Capital USD (in Millions)": 0.8,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner":
      "Department of Fisheries, Ministry of Agriculture, Livestock and Irrigation",
    "Land Area (units not specified in file)": 1.52,
    "Lease Term": 10,
    "Annual Lease Fee": 61512,
    "Land Use Premium": null,
    "Number Of Local Employees": 257,
    "Number Of Foreign Employees": 6,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.36, INYA MYAING ROAD, SHWE TAUNG KYAR(1) WARD, BAHAN TOWNSHIP, YANGON ",
    "Organization Address":
      "NO (2/2), DEPARTMENT OF FISHERIES COMPOUND, BAYINTNAUNG ROAD, WEST GYOGONE, INSEIN TOWNSHIP, YANGON REGION",
    "Investment Permitted Address":
      "No.2 /2, Department of Fisheries Compound, Bayint Naung Road, West Gyogone., Insein, YANGON",
  },
  {
    ID: 1577,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS. Yu Zifen",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Jia Mei Garment Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "967/2015",
    "Permit Date": "2015-06-18T08:31:09Z",
    "Meeting Number": "10/2015",
    "Meeting Date": "2015-06-05T08:31:29Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.606,
    "Total Amount Of Capital (in Millions)": 0.606,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Kyaw Than (a) U Tin Sein",
    "Land Area (units not specified in file)": 0.698,
    "Lease Term": 30,
    "Annual Lease Fee": 0.016,
    "Land Use Premium": null,
    "Number Of Local Employees": 725,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address": "1# 2101, He Fei, Quan Jiao, Bei Lu, China.",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot.(103-KA), Myay Taing  Block No.42, Ka Naung Min Thar Gyi Street, , Shwepyithar Industrial Zone, Shwepyithar Township, Yangon",
  },
  {
    ID: 1578,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aye Lwin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Minn Wun Industries Co.,Ltd.",
    "Financial Year From": 2001,
    "Financial Year To": 2002,
    "Permit Number": "MaNaTha-487/2001",
    "Permit Date": "2001-05-05T09:53:55Z",
    "Meeting Number": "39/2000",
    "Meeting Date": "2000-12-01T09:55:28Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Wood Based and Furniture Industry",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 83,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Aye Lwin",
    "Land Area (units not specified in file)": 2.4,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 150,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address": "No,(188), BoKyoke Aung San Road. Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Block No.21, Industries Zone(1), Dagon Seikkan Township, Yangon",
  },
  {
    ID: 1579,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. MARK GERALD EMAN",
    "Name of Principal Organization": "JAPFA MYANMAR JV PTE. LTD",
    "Place of Incorporation": "SINGAPORE ",
    "Company Name In Myanmar": "JAPFA COMFEED MYANMAR PTE. LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "005/2017",
    "Permit Date": "2017-07-14T10:30:15Z",
    "Meeting Number": "9/2017",
    "Meeting Date": "2017-06-16T10:31:38Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business": "POULTRY BREEDER FARM AND HATCHERY ",
    "Amount Of Foreign Capital USD (in Millions)": 7,
    "Total Amount Of Capital (in Millions)": 7.071,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "Mandalay Myotha Industrial Development Public Co., Ltd. ",
    "Land Area (units not specified in file)": 54.2,
    "Lease Term": 50,
    "Annual Lease Fee": 109673.7,
    "Land Use Premium": null,
    "Number Of Local Employees": 93,
    "Number Of Foreign Employees": 6,
    Status: "Monitoring Approved",
    "Investor Address":
      "AGUNG RAYA II # 31A, LENTENG AGUNG, JAKATA SELATAN, INDONESIA, 12610.",
    "Organization Address":
      "391B ORCHARD ROAD, # 18-08 NGEE ANN CITY, TOWER B, SINGAPORE 238874   ",
    "Investment Permitted Address":
      "NO. 264 6th Street , Yangon Industrial Zone ., Mingaladon, YANGON",
  },
  {
    ID: 1581,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Lu Maw Myint Maung",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Shwe Wah Yaung Agriculture Production Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "MaNaTha-1182/2016",
    "Permit Date": "2016-03-26T06:25:25Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T06:25:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Value-Added Paddy/Rice ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1573.76,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Lu Maw Myint Maung, Daw Maw Maw Tint",
    "Land Area (units not specified in file)": 2.12,
    "Lease Term": 50,
    "Annual Lease Fee": 54,
    "Land Use Premium": null,
    "Number Of Local Employees": 55,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.(Nya/73), Yuzana Road, BayintNaung (1) Ward, Mayangone Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Myay Taing Block No. (25), No(465-A), Yaw A Twin Win U Phoe Hlaing Road, Shwe Lin Pan Industrial Zone, Hlaing Thar Yar Township, Yangon",
  },
  {
    ID: 1582,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးခင်မောင်မြင့်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "CNM Garment \tIndustrial  Limited  ",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1207/2016",
    "Permit Date": "2016-09-14T08:16:26Z",
    "Meeting Number": "16/2016",
    "Meeting Date": "2016-08-26T08:16:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ် လုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": 0.484,
    "Total Amount Of Capital (in Millions)": 704.733,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်စံနှင်းခိုင်",
    "Land Area (units not specified in file)": 1.91,
    "Lease Term": 5,
    "Annual Lease Fee": 3.5,
    "Land Use Premium": null,
    "Number Of Local Employees": 251,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် (၂၂/က)၊ ၂ လမ်း၊ ပြန်လည်နေရာချထားရေးရပ်ကွက်၊ အိမ်ခြေ (၃၀) ၊  မင်္ဂလာဒုံမြို့နယ် ၊ ရန်ကုန််မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ဦးပိုင်အမှတ် (၃/၉)၊ (၃/၁၀)၊ (၃/၂ + N-၃၆)၊ အောက်ဝါးနက်ချောင်းကျေးရွာ အုပ်စု၊ ဝါးနက်ချောင်းကွင်းအမှတ် (၅၉၄ A)၊ မှော်ဘီ မြို့နယ်၊ရန်ကုန်တိုင်းဒေသကြီး၊",
  },
  {
    ID: 1583,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Hla Myint Shwe",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "UNITED PACIFIC COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1187/2016",
    "Permit Date": "2016-03-26T09:04:26Z",
    "Meeting Number": "7/2016",
    "Meeting Date": "2016-02-26T09:04:50Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာ အဆင့်မီ နည်းပညာဖြင့် အမျိုးသမီးကျန်းမာရေးသုံးပစ္စည်း ထုတ်လုပ်ဖြန့်ဖြူးရောင်းချခြင်း လုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": 0.054,
    "Total Amount Of Capital (in Millions)": 865.68,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "အမှတ်(၃) အကြီးစားစက်မှုလုပ်ငန်း (ယခင်အထည်အလိပ် လုပ်ငန်း)၊ စက်မှုဝန်ကြီးဌာန",
    "Land Area (units not specified in file)": 6.95,
    "Lease Term": 50,
    "Annual Lease Fee": 460.4,
    "Land Use Premium": 5,
    "Number Of Local Employees": 204,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၅၉၃)၊ ပြည်လမ်း၊ ၂ ရပ်ကွက်၊ ကမာရွတ်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "စက်မှုဝန်ကြီးဌာန၊အမှတ်(၃)အကြီးစား စက်မှုလုပ်ငန်း (ယခင်အထည်အလိပ်လုပ်ငန်း)ပိုင် (၁) အထည်စက်ရုံခွဲ (မရမ်းကုန်း)၊ ၃ ရပ်ကွက်၊၇ မိုင် ၇ ဖာလုံ၊ အင်းစိန်လမ်း၊ မရမ်းကုန်းမြို့နယ်၊ရန်ကုန်တိုင်းဒေသကြီး၊ \n",
  },
  {
    ID: 1584,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Ei Mon Htoo",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "YANGON AIRPORT GROUP COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "037/2017",
    "Permit Date": "2017-12-12T03:02:40Z",
    "Meeting Number": "16/2017",
    "Meeting Date": "2017-09-30T03:02:59Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "လေယာဉ်မြေပြင်ဝန်ဆောင်မှုလုပ်ငန်း (Ground Handling Services) ",
    "Amount Of Foreign Capital USD (in Millions)": 1.449,
    "Total Amount Of Capital (in Millions)": 5206.3,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 24,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Htwe Htwe WIn",
    "Land Area (units not specified in file)": 1.35,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 561,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No. 33D, Yatanar Lane Thwe, 7 Miles, Pyay Street, Mayangone Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.(186), Airport Street,(5) Quarter, , Mayangone Township, YANGON",
  },
  {
    ID: 1585,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Min Zayar Hlaing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MYANMAR MILLENNIUM GROUP COMPANY LIMITED",
    "Financial Year From": 2001,
    "Financial Year To": 2002,
    "Permit Number": "Ma Na Tha 528/2002",
    "Permit Date": "2002-01-25T04:32:50Z",
    "Meeting Number": "32/2001",
    "Meeting Date": "2001-09-13T04:33:41Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "ငါးတင်ချ ဆိပ်ခံကွန်ကရစ်တံတား တည်ဆောက်လုပ်ကိုင်ဆောင်ရွက်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 115,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner":
      "Myanma Port Authority, Ministry of Transport and Communications",
    "Land Area (units not specified in file)": 2229.6,
    "Lease Term": 25,
    "Annual Lease Fee": 3.35,
    "Land Use Premium": null,
    "Number Of Local Employees": 88,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Kone Myint Thar, 7 Quarter, Mayangone Township, Yangon.",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.(4/D), Myayningone Plaza, Sanchaung Township, YANGON",
  },
  {
    ID: 1586,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Sit Nyein",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Steller (Myanmar) Company Limited",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "Ma Na Tha 058/1997",
    "Permit Date": "1997-01-17T05:09:23Z",
    "Meeting Number": "1/1997",
    "Meeting Date": "1997-01-03T05:10:03Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "ဆိပ်ကမ်း၊ ဆိပ်ခံဘောတံတားနှင့် ပတ်သက်သော ဝန်ဆောင်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 562.9,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner":
      "Department of Urban and Housing Department, Ministry of Construction",
    "Land Area (units not specified in file)": 5.993,
    "Lease Term": 25,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 81,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No. 15, Room 27, U Wizarya Housing, Dagon Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No. 15, Room 27, U Wizarya Housing, Dagon Township, Yangon",
  },
  {
    ID: 1587,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Aye Aye Thet",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ROYAL SWIFTLET COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1181/2016",
    "Permit Date": "2016-03-26T03:47:04Z",
    "Meeting Number": "10/2016",
    "Meeting Date": "2016-03-18T03:48:47Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "REFINING OF BIRD NEST BY CONTRACT MANUFACTURING",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 200,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "DAW AYE AYE THET",
    "Land Area (units not specified in file)": 0.126,
    "Lease Term": 30,
    "Annual Lease Fee": 12.5,
    "Land Use Premium": null,
    "Number Of Local Employees": 110,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO-84, WARD-67(B), YADANAR A SINT MYINT HOUSING, DAGON SEIKAN TOWNSHIP, YANGON",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.127, THANCHAT WIN U MYU ROAD, DAGON SEIKKAN INDUSTRIAL ZONE, DAGON SEIKKAN TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1588,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဆောင်ညွှန်ကြားရေးမှူး၊ ပြည်သူ့ဆောက်လုပ်ရေးလုပ်ငန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "PW & GG Joint Venture Co.,Ltd.",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "MaNaTha-078/97",
    "Permit Date": "1997-07-08T04:22:55Z",
    "Meeting Number": "6/97",
    "Meeting Date": "1997-04-25T04:47:42Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်အ​ေ ခြခံစက်မှုလုပ်ငန်း(သစ်ေ ချာထည်များထုတ်လုပ်ဖြန့်ဖြူးခြင်း)",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 109.76,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ပြည်သူ့ဆောက်လုပ်ရေးလုပ်ငန်း",
    "Land Area (units not specified in file)": 6.992,
    "Lease Term": 30,
    "Annual Lease Fee": 3.3,
    "Land Use Premium": null,
    "Number Of Local Employees": 108,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "No.60, Shwedagon Road, Dagon Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်မြို့၊ တောင်ဥက္ကလာပမြို့နယ်၊ ​ေ မြတိုင်းရပ်ကွက်အမှတ်(၁၄)၊ ​ေ မြကွက်အမှတ်(၁ဆ/၄၀)",
  },
  {
    ID: 1589,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U MYO LWIN",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ARKAR OO COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "MANATHA-1038/2015",
    "Permit Date": "2015-03-17T04:37:47Z",
    "Meeting Number": "3/2015",
    "Meeting Date": "2015-02-27T04:39:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "GRINDING AND REFINING OF VARIOUS KINDS OF PULSES",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 4600,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ARKAROO COMPANY LIMITED",
    "Land Area (units not specified in file)": 2.006,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 85,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. (NYA/39), ARTHAW KA ROAD, BAYINTNAUNG PWE YONE TAN , MAYANGONE TOWNSHIP, YANGON",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.(124), Wetmasutt Wun Htaut Street, Industrial Zone -4, Hlaingtharyar, YANGON ",
  },
  {
    ID: 1590,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR THAN WIN",
    "Name of Principal Organization": "TYTC WASTE EQUIPMENT PTY LTD.",
    "Place of Incorporation": "AUSTRALIA",
    "Company Name In Myanmar": "TYTC SERVICES COMPANY LIMITED\t\t\t",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1223/2017",
    "Permit Date": "2017-01-15T08:05:14Z",
    "Meeting Number": "1/2017",
    "Meeting Date": "2017-01-06T08:05:55Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "COLLECTION AND TRANSPORTATION OF INDUSTRIAL WASTE",
    "Amount Of Foreign Capital USD (in Millions)": 11.22,
    "Total Amount Of Capital (in Millions)": 16.29,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Austria",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Aye Myint @ Daw Lay Pyin",
    "Land Area (units not specified in file)": 1.51,
    "Lease Term": 10,
    "Annual Lease Fee": 30,
    "Land Use Premium": null,
    "Number Of Local Employees": 215,
    "Number Of Foreign Employees": 22,
    Status: "Amended",
    "Investor Address":
      "NO. 20, RITCHIE STREET,  ROSEHILL, NSW 2142, AUSTRALIA",
    "Organization Address":
      "PO BOX 465 GRANVILLE NSW 2142 AUSTRALIA, NO.20-22 PLASSER CRESCENT, NORTH ST MARYS, NSW 2760, AUSTRALIA",
    "Investment Permitted Address":
      "PLOT NO. 381, MYAY TAING BLOCK NO-25, SHWE LIN PAN INDUSTRIAL ZONE, HLAING THARYAR  TOWNSHIP, YANGON  REGION ",
  },
  {
    ID: 1591,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. YONGBING  WANG  ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MASTER   ROLLER (MYANMAR) COMPANY  LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "782/2015",
    "Permit Date": "2015-08-06T08:51:29Z",
    "Meeting Number": "7/2015",
    "Meeting Date": "2015-04-28T08:51:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF PRINTING PLATES AND BLOCKS",
    "Amount Of Foreign Capital USD (in Millions)": 1.401,
    "Total Amount Of Capital (in Millions)": 1.401,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Kyauk Chi Phone",
    "Land Area (units not specified in file)": 1.015,
    "Lease Term": 30,
    "Annual Lease Fee": 0.021,
    "Land Use Premium": null,
    "Number Of Local Employees": 86,
    "Number Of Foreign Employees": 15,
    Status: "Monitoring Approved",
    "Investor Address":
      "ROOM NO. 301, 10TH FLOOR, YIHEYUAN RESIDENTIAL, YINXINGDONG  STREET, YONGJI CITY, SHANXI  PROVINCE, PEOPLE’S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 493, MYAY TAING BLOCK NO. 25, SHWE LIN PAN INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1592,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS. WU  OI  MING  ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ABLE  GLAD  MYANMAR  COMPANY  LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1014/2015",
    "Permit Date": "2015-09-21T09:01:37Z",
    "Meeting Number": "16/2015",
    "Meeting Date": "2015-09-11T09:01:56Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF  GARMENTS ON CMP  BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.932,
    "Total Amount Of Capital (in Millions)": 0.932,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Zaw Min Oo",
    "Land Area (units not specified in file)": 0.945,
    "Lease Term": 10,
    "Annual Lease Fee": 0.092,
    "Land Use Premium": null,
    "Number Of Local Employees": 182,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address":
      "FLAT D, 2/F, BLOCK 9, RICHLAND GARDEN, KOWLOON BAY, KOWLOON, HONG KONG",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 53/A, MYAY TAING BLOCK NO. 42, SHWE PYI THAR INDUSTRIAL ZONE, SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1593,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. YANG, LIANFENG",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "FULLY HAPPINESS GARMENT COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "034/2017",
    "Permit Date": "2017-08-20T07:26:08Z",
    "Meeting Number": "11/2017",
    "Meeting Date": "2017-08-07T07:26:58Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.959,
    "Total Amount Of Capital (in Millions)": 0.959,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW KHIN MAY THIN",
    "Land Area (units not specified in file)": 1.121,
    "Lease Term": 10,
    "Annual Lease Fee": 0.045,
    "Land Use Premium": null,
    "Number Of Local Employees": 1354,
    "Number Of Foreign Employees": 9,
    Status: "Monitoring Approved",
    "Investor Address":
      "HOUSE 4028* GROUP 3 XU PU CHUN TING LIN TOWN, JIN SHAN SHANGHAI, PEOPLE’S REPUBLIC OF CHINA ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO.135, MYAY TAING QUARTER NO. 51, THARDUKAN INDUSTRIAL ZONE, SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1595,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. GAUHAR SIRAJ JAMIL",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "TRINITY APPAREALS LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1043/2015",
    "Permit Date": "2015-11-11T08:38:47Z",
    "Meeting Number": "19/2015",
    "Meeting Date": "2015-10-30T08:39:11Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF CLOTHING AND VARIOUS KINDS OF UNDERWEAR ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 2.356,
    "Total Amount Of Capital (in Millions)": 2.356,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Bangladesh",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW PHYU PHYU WIN",
    "Land Area (units not specified in file)": 1.139,
    "Lease Term": 30,
    "Annual Lease Fee": 0.024,
    "Land Use Premium": null,
    "Number Of Local Employees": 952,
    "Number Of Foreign Employees": 25,
    Status: "Approved",
    "Investor Address":
      "FLAT#5 (A&F), UREKA APARTMENT 83, S.S KHALED ROAD, CHAWKBAZAR, KOTOWALI, CHITTAGONG, BANGLADESH",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 169, MYAY TAING BLOCK NO.4, HLAING THAYAR INDUSTRIAL ZONE, HLAING THAYAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1596,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. KWANG HO JEONG",
    "Name of Principal Organization": "CJ GLOBAL HOLDINGS LIMITED",
    "Place of Incorporation": "HONG KONG",
    "Company Name In Myanmar": "CJ FEED MYANMAR COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "004/2017",
    "Permit Date": "2017-07-14T09:11:10Z",
    "Meeting Number": "9/2017",
    "Meeting Date": "2017-06-16T09:12:06Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "PRODUCTION AND SALES OF ANIMAL FEED",
    "Amount Of Foreign Capital USD (in Millions)": 16.7,
    "Total Amount Of Capital (in Millions)": 16.7,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Thein Lwin",
    "Land Area (units not specified in file)": 12.366,
    "Lease Term": 50,
    "Annual Lease Fee": 42000000,
    "Land Use Premium": null,
    "Number Of Local Employees": 127,
    "Number Of Foreign Employees": 5,
    Status: "Approved",
    "Investor Address":
      "401 HO, BAIKJE GOBUN RO 9, GIL 22, (JAMSIL  DONG), SONG PA GU, SEOUL, REPUBLIC OF KOREA",
    "Organization Address":
      "SUITE 3003, 30/F, CENTRAL PLAZA, 18 HARBOUR ROAD, WANCHAI, HONG KONG",
    "Investment Permitted Address":
      "Plot No(192,193,194,195,196,197),Myaung Dagar Thanmani Industrial Zone., HMawbi, YANGON",
  },
  {
    ID: 1597,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကျော်ဇော်ထွန်း",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "ရန်ကုန်ကွန်ကရစ်ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1058/2015",
    "Permit Date": "2018-05-29T09:15:54Z",
    "Meeting Number": "8/5/2015",
    "Meeting Date": "2015-05-08T09:28:45Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Ready Mixed Concrete, Pile, Concrete Block, Drain Cover နှင့် Fencing Column တို့ ထုတ်လုပ်ဖြန့်ဖြူးရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 2.68,
    "Total Amount Of Capital (in Millions)": 5000.78,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးစိုင်းအောင်ထွန်း",
    "Land Area (units not specified in file)": 2.5,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 236,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်(၂၂၉) မြဧရာလမ်း၊ သင်္ဃန်းကျွန်း",
    "Organization Address": "-",
    "Investment Permitted Address":
      "အမှတ်(၂၂၄) စက်မှုဇုန်(၁)၊ ဒဂုံဆိပ်ကမ်းမြို့နယ်ရန်ကုန်",
  },
  {
    ID: 1598,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါက်တာခင်မောင်လွင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "FAME Pharmaceuticals Industry Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1126/2016",
    "Permit Date": "2016-02-17T09:00:48Z",
    "Meeting Number": "4/2016",
    "Meeting Date": "2016-02-05T09:59:59Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သဘာဝကို အ‌ြေခခံသည့် (အပင်ကို အခြေခံသည့်) နိုင်ငံတကာအဆင့်မီ ဆေးဝါးများ ထုတ်လုပ်ခြင်းလုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 5425.77,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 363,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် - ၂၊ ကန်သာယာ - ၃လမ်း၊ ငွေကြာယံရိပ်သာ၊ တောင်ဥက္ကလာပ မြို့နယ်၊  ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      " မြေကွက်အမှတ်  ၁၉-ခ နှင့် ၂၀၊ မြေတိုင်းရပ်ကွက်အမှတ်  (အပိုင်း ၃)၊ စက်မှုဇုန်၊\nလှိုင်သာယာ မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး၊",
  },
  {
    ID: 1600,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. VICHAI SAKSURIYA",
    "Name of Principal Organization":
      "DELTA ENERGY SYSTEMS (SINGAPORE) PTE. LTD., ",
    "Place of Incorporation": "SINGAPORE ",
    "Company Name In Myanmar": "DELTA ELECTRONICS (MYANMAR) COMPANY LIMITED\t",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1069/2016",
    "Permit Date": "2016-01-29T10:47:20Z",
    "Meeting Number": "1/2016",
    "Meeting Date": "2016-01-15T10:48:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF ELECTRONICS COMPONENTS (SUCH AS CHOKE, FILTER, SMD INDUCTOR & TRANSFORMER) UNDER CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.5,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "U Lai Haung Eain @ U Myo Aung & U Lin Hlaung Yone@U Shein",
    "Land Area (units not specified in file)": 2.732,
    "Lease Term": 3,
    "Annual Lease Fee": 0.216,
    "Land Use Premium": null,
    "Number Of Local Employees": 495,
    "Number Of Foreign Employees": 30,
    Status: "Monitoring Approved",
    "Investor Address":
      "909 SOI 9, MOO 4, BANGPOO INDUSTRIAL ESTATE (E.P.Z) PATTANA 1 ROAD, T.PHRAKSA, A. MUANG, SAMUTPRAKARN 10280, THAILAND",
    "Organization Address": "4 KAKI BUKIT AVENUE 1#05-04, SINGAPORE 417939",
    "Investment Permitted Address":
      "PLOT NO. 91 & 92, MYAY TAING BLOCK NO. 25, SHWE LIN BAN INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1601,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U AUNG KYAW MOE",
    "Name of Principal Organization":
      "MIN DHAMA HEAVY INDUSTRIAL COMPANY LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "MIN  DHAMA  STEEL  STRUCTURES  COMPANY  LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "992/2015",
    "Permit Date": "2015-09-25T11:14:11Z",
    "Meeting Number": "16/2015",
    "Meeting Date": "2015-09-11T11:14:57Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF  CONSTRUCTION MATERIALS (HIGH RISE BUILDING, WAREHOUSE AND BRIDGES) ",
    "Amount Of Foreign Capital USD (in Millions)": 24.956,
    "Total Amount Of Capital (in Millions)": 62.39,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "U Yang Ho, Daw Shout Si ",
    "Land Area (units not specified in file)": 13.332,
    "Lease Term": 30,
    "Annual Lease Fee": 0.44,
    "Land Use Premium": null,
    "Number Of Local Employees": 790,
    "Number Of Foreign Employees": 15,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.16, 8th STREET, SHWE KABAR HOUSING, WARD NO.3, MAYANGON TOWNSHIP, YANGON ",
    "Organization Address":
      "PLOT NO. 74, 75, 76, 77, 78, 91, KANAUNG MIN THAR GYI STREET, INDUSTRIAL ZONE 4, SHWE PYI THAR TOWNSHIP, YANGON REGION",
    "Investment Permitted Address":
      "PLOT NO. 74, 75, 76, 77, 78, 91, KANAUNG MIN THAR GYI STREET, INDUSTRIAL ZONE 4, SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1602,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Sukkapon Lapmahapaisarn",
    "Name of Principal Organization":
      "THE NAWAPLASTIC INDUSTRIES (SARABURI) CO., LTD. ",
    "Place of Incorporation": "THAILAND",
    "Company Name In Myanmar": "GRAND NAWAPLASTIC MYANMAR COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1099/2016",
    "Permit Date": "2016-03-24T02:58:22Z",
    "Meeting Number": "9/2016",
    "Meeting Date": "2016-03-11T02:58:55Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING, SALES AND DISTRIBUTION OF PIPES, FITTINGS, VALVES, TUBING AND RAIN GUTTERS",
    "Amount Of Foreign Capital USD (in Millions)": 3.88,
    "Total Amount Of Capital (in Millions)": 6.8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner":
      "U AIK NAM, U SAI WIN AUNG, U KYAW MIN TUN, U KAW KHINE, U Nyein Aung,U TIN YEE ANN",
    "Land Area (units not specified in file)": 6.198,
    "Lease Term": 10,
    "Annual Lease Fee": 384,
    "Land Use Premium": null,
    "Number Of Local Employees": 208,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address":
      "No.90/1, Sukhumvit 56, Bangjark, Phra Ka-Nhong District, Bangkok, Thailand.",
    "Organization Address":
      "1 SIAM CEMENT ROAD, BANGSUE, BANGKOK 10800, THAILAND",
    "Investment Permitted Address": "No",
  },
  {
    ID: 1603,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Chan Wai Zhong",
    "Name of Principal Organization": "RMA Holdings Singapore Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Capital Motors Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1061/2016",
    "Permit Date": "2016-01-19T04:39:25Z",
    "Meeting Number": "23/2015",
    "Meeting Date": "2015-12-28T04:39:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production and Sale of Motor Vehicles and Providing  After Sales and Warranty Services",
    "Amount Of Foreign Capital USD (in Millions)": 22.566,
    "Total Amount Of Capital (in Millions)": 45.132,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 30,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Moe Moe",
    "Land Area (units not specified in file)": 3.25,
    "Lease Term": 50,
    "Annual Lease Fee": 3.25,
    "Land Use Premium": null,
    "Number Of Local Employees": 76,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address":
      "391/21 Moo.12, Tambon Nongprue, Amphoe Banglamung, Chonburi 20150, Thailand",
    "Organization Address": "158 Cecil Street # 11-01 Singapore 069545",
    "Investment Permitted Address":
      "Plot No. 162,163, Myay Taing Block No. 113, Dagon Myothit (East)  Industrial Zone, Dagon Myothit (East) Township, Yangon Region",
  },
  {
    ID: 1606,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U KYAW MIN HTUN",
    "Name of Principal Organization":
      "SOE ELECTRIC & MACHINERY COMPANY LIMITED",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "HITACHI  SOE  ELECTRIC & MACHINERY  COMPANY  LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1011/2015",
    "Permit Date": "2015-09-25T05:12:39Z",
    "Meeting Number": "16/2015",
    "Meeting Date": "2015-09-11T05:13:05Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING, INSTALLATION, LEASING, MAINTENANCE, REPAIR AND SALES OF POWER TRANSFORMERS, DISTRIBUTION TRANSFORMERS, SWITCHGEARS AND RELATED ACCESSORIES ",
    "Amount Of Foreign Capital USD (in Millions)": 14.4,
    "Total Amount Of Capital (in Millions)": 48,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "U Soe Tint & U Kyaw Min Htun",
    "Land Area (units not specified in file)": 11.748,
    "Lease Term": 30,
    "Annual Lease Fee": 0.7,
    "Land Use Premium": null,
    "Number Of Local Employees": 425,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address": "NO.58, PHOE SEIN ROAD, TAMWE TOWNSHIP, YANGON ",
    "Organization Address":
      "BUILDING NO.1, AUNG CHAN THAR HOUSING ESTATE, EAST SHWEGONDINE ROAD, BAHAN TOWNSHIP, YANGON ",
    "Investment Permitted Address":
      "PLOT NO. 472/A AND 472/B(1), MYAY TAING BLOCK NO. 23, INDUSTRIAL ZONE 1, SOUTH DAGON TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1607,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mrs. Michele Danielle Andree Sioen",
    "Name of Principal Organization": "Sioen Asia Pacific Pte. Ltd. ",
    "Place of Incorporation": "Singapore ",
    "Company Name In Myanmar": "Sioen Myanmar Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1074/2016",
    "Permit Date": "2016-01-26T05:35:38Z",
    "Meeting Number": "1/2016",
    "Meeting Date": "2016-01-15T05:36:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production of Technical Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.296,
    "Total Amount Of Capital (in Millions)": 2.296,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 36,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaw Linn @ Kyon Shu Hgawt",
    "Land Area (units not specified in file)": 2.508,
    "Lease Term": 10,
    "Annual Lease Fee": 0.259,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "8300 Knokke-Heist, Astridlaan, 14, Belgium",
    "Organization Address":
      "4 Battery Road, # 25-01, Bank of China Building Singapore 049908",
    "Investment Permitted Address":
      "Plot No. 75, U Chain Street and Plot No. 102, Mah Kha Yar Min Thar Gyi Mg Pyoe Street,  Hlaing Thar Yar Industrial Zone (2), Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 1608,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးသာဌေး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "အော်ရီဂျင်နယ်ဂရု(ပ်)ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "မနသ-၁၁၄၈/၂၀၁၆",
    "Permit Date": "2016-03-24T05:56:43Z",
    "Meeting Number": "၉/၂၀၁၆",
    "Meeting Date": "2016-03-11T05:57:09Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Precast Concrete Product ထုတ်လုပ်ရောင်းချ ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 3.27,
    "Total Amount Of Capital (in Millions)": 7866,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ကိုယ်ပိုင်မြေ",
    "Land Area (units not specified in file)": 11.885,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 221,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် (၁၈/စီ)၊ အင်းယားမြိုင်လမ်း၊ ရွှေတောင်ကြား (၁) ရပ်ကွက်၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၈၊ ၉၊ မြေတိုင်းရပ်ကွက်အမှတ် ၇၅၊ ၉၃ ရပ်ကွက်၊ ဒဂုံဆိပ်ကမ်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသ ကြီး",
  },
  {
    ID: 1609,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Gong, Songlin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Zhejiang Tongli Clothing (Myanmar) Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1024/2015",
    "Permit Date": "2015-10-14T06:23:04Z",
    "Meeting Number": "17/2015",
    "Meeting Date": "2015-09-28T06:23:21Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.322,
    "Total Amount Of Capital (in Millions)": 2.322,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Yan Chin Sein",
    "Land Area (units not specified in file)": 2.713,
    "Lease Term": 10,
    "Annual Lease Fee": 0.067,
    "Land Use Premium": null,
    "Number Of Local Employees": 1305,
    "Number Of Foreign Employees": 8,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 82, Ai Goo Road, Dong Yang City, Zhejiang Province, People's Republic of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 301, Myay Taing Block No. 25, Shwe Lin Pan Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 1610,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lee Nyan Fatt",
    "Name of Principal Organization": "SG Corporation Pte. Ltd.",
    "Place of Incorporation": "Singapore ",
    "Company Name In Myanmar": "SG Pann Ayeyar Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "945/2015",
    "Permit Date": "2015-05-07T06:48:24Z",
    "Meeting Number": "6/2015",
    "Meeting Date": "2015-04-03T07:08:13Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing, Sales and Services of Ready-mixed Concrete",
    "Amount Of Foreign Capital USD (in Millions)": 1.34,
    "Total Amount Of Capital (in Millions)": 2.68,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 120,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "U Win Hlaing",
    "Land Area (units not specified in file)": 0.954,
    "Lease Term": 10,
    "Annual Lease Fee": 78,
    "Land Use Premium": null,
    "Number Of Local Employees": 53,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address": "No. 137, Bishan St. 12, # 05-414, Singapore 570137",
    "Organization Address": "No. 90, Geylangbahru # 01- 2748 Singapore 339698",
    "Investment Permitted Address":
      "Plot No. 227/Kha, 228, Mya Khwar Nyo Road, Industrial Block, Tharkayta Township, Yangon Region",
  },
  {
    ID: 1611,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Lee Swee Hoon",
    "Name of Principal Organization": "SC Auto Industries (s) Pte. Ltd. ",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "SC Auto (Myanmar) Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "979/2015",
    "Permit Date": "2015-07-01T07:52:45Z",
    "Meeting Number": "11/2015",
    "Meeting Date": "2015-06-19T07:52:59Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing, Assembling and Sales of Buses/ Coaches, Repair and Maintenance Services",
    "Amount Of Foreign Capital USD (in Millions)": 10.901,
    "Total Amount Of Capital (in Millions)": 10.901,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "SCAI Yangon Limited",
    "Land Area (units not specified in file)": 4,
    "Lease Term": 10,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 170,
    "Number Of Foreign Employees": 18,
    Status: "Monitoring Approved",
    "Investor Address": "96 Jalan Kemuning, Singapore 769813",
    "Organization Address": "No. 51, Senoko Road, Singapore 758133",
    "Investment Permitted Address":
      "Plot No. 188 & 189, Yangon Industrial Zone, Mingalardon Township, Yangon",
  },
  {
    ID: 1612,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Tojuro Nishi",
    "Name of Principal Organization": "IHI Asia Pacific Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "I & H Engineering Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1080/2016",
    "Permit Date": "2016-02-04T08:53:16Z",
    "Meeting Number": "22/2015",
    "Meeting Date": "2015-12-11T08:53:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Supply of Concrete Structures (including Design and Instlation\n",
    "Amount Of Foreign Capital USD (in Millions)": 9.413,
    "Total Amount Of Capital (in Millions)": 15.688,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Department of Highways, Ministry of Construction",
    "Land Area (units not specified in file)": 16,
    "Lease Term": 15,
    "Annual Lease Fee": 4.895,
    "Land Use Premium": null,
    "Number Of Local Employees": 62,
    "Number Of Foreign Employees": 6,
    Status: "Monitoring Amend",
    "Investor Address": "6-2-4, Takahama, Mihama-KU, Chiba Cityk, Chiba, Japan",
    "Organization Address":
      "77 Robinson Road, # 14-03 Robinson 77, Singapore 068896",
    "Investment Permitted Address":
      "Plot No, 3, Kalakone village, Myaungdagar Steel Industrial Zone",
  },
  {
    ID: 1613,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ခင်သန်းအေး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Progress Biochem Company Limited ",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1097/2015",
    "Permit Date": "2015-11-11T09:10:08Z",
    "Meeting Number": "18/2015",
    "Meeting Date": "2015-10-23T09:10:56Z",
    Sector: "",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 728.64,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 1.08,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 80,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမ်အေစီတာဝါ(၂)၊ အမှတ်(၇၉၇)၊ အခန်းအမှတ်-ဘီ(၁၀၁)၊     ဗိုလ်ချုပ်အောင်ဆန်းလမ်းနှင့် ဝါးတန်းလမ်းထောင့်၊ လမ်းမတော်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်-၁၄၅(ခ)နှင့် ၁၄၆(က) ၊ ပန်းတဉ်းဝန်ဦးရွှေဘင်လမ်း၊ အပိုင်း(၁)၊ စက်မှုမြို့၊လှိုင်သာယာ မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး၊ ",
  },
  {
    ID: 1615,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Aung Nyunt Thaung",
    "Name of Principal Organization": "Hnin Thazin Oo Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Kansai Paint Myanmar Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "986/2015",
    "Permit Date": "2015-07-14T09:17:54Z",
    "Meeting Number": "11/2015",
    "Meeting Date": "2015-06-19T09:18:37Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Various Kinds of Paint",
    "Amount Of Foreign Capital USD (in Millions)": 2.55,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "U Tayza Saw Oo",
    "Land Area (units not specified in file)": 4.356,
    "Lease Term": 10,
    "Annual Lease Fee": 0.18,
    "Land Use Premium": null,
    "Number Of Local Employees": 222,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 27, Ayeyarwady Street, Htarnar Ward, Ahlone Township, Yangon Region",
    "Organization Address":
      "No.211, Lanthit Street, Insein Township, Yangon Region",
    "Investment Permitted Address":
      "Plot No. 120, 121, Myay Taing Block No .65 (Sethmu), Shwe Pyi Thar Industrial Zone-4, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 1617,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Wan Yone Shin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "The Kyu Industrial Co.,Ltd.",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "MaNaTha-149/98",
    "Permit Date": "1998-07-15T10:10:41Z",
    "Meeting Number": "9/98",
    "Meeting Date": "1998-05-28T10:12:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "ဖော်မီကာအထပ်သားများထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 23.6,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 1,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "အမှတ်-၁၃၇၊ ပထမထပ်၊ ၂၉လမ်း၊ပန်းပဲတန်းမြို့နယ်",
    "Organization Address": "",
    "Investment Permitted Address":
      "အကွက်အမှတ်-၂၁၃၊ ​ေ မြတိုင်းရပ်ကွက်အမှတ်ဇုန်(၂)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 1618,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Myo Myint Hla",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Boe Myanmar Co., Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "101/2018",
    "Permit Date": "2018-06-23T05:36:17Z",
    "Meeting Number": "8/2018",
    "Meeting Date": "2018-06-22T05:36:23Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Private Hospital Services",
    "Amount Of Foreign Capital USD (in Millions)": 11.33,
    "Total Amount Of Capital (in Millions)": 55.9,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "United States of America",
    "Form Of Investment": "JV",
    "Land Owner": "U Myo Mint Hla, Daw San San Aye",
    "Land Area (units not specified in file)": 2.846,
    "Lease Term": 50,
    "Annual Lease Fee": 49.2,
    "Land Use Premium": null,
    "Number Of Local Employees": 249,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "No.45, Tay Nuyin Road, Mayangone Township, Yangon",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No.45, Tay Nuyin Road, Mayangone Township, Yangon",
  },
  {
    ID: 1620,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw WIn Lai Aye",
    "Name of Principal Organization":
      "Energetic Alliance Petroleum Products Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "Energetic Alliance Petroleum Products Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "E 082/2018",
    "Permit Date": "2018-02-14T06:42:14Z",
    "Meeting Number": "2/2018",
    "Meeting Date": "2018-02-02T06:42:33Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing and Sales of Lubricant",
    "Amount Of Foreign Capital USD (in Millions)": 2.94,
    "Total Amount Of Capital (in Millions)": 6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "U Aye Tun",
    "Land Area (units not specified in file)": 0.902,
    "Lease Term": 10,
    "Annual Lease Fee": 0.22,
    "Land Use Premium": null,
    "Number Of Local Employees": 22,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "No.39-A, U Mg Mg Soe Road, Mayangone Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.96(A), Myay Taing Block No. Part (4), Hlaing Tharyar Industrial Zone, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 1623,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Khaing Oo",
    "Name of Principal Organization":
      "Neo Energy Oasis Development Company Limited စွမ်းအားသစ်အိုအေစစ် ဖွံ့ဖြိုး တိုးတက်မှု ကုမ္ပဏီလီမိတက်",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "Neo Energy Oasis Development Company Limited စွမ်းအားသစ်အိုအေစစ် ဖွံ့ဖြိုး တိုးတက်မှု ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "784/2011",
    "Permit Date": "2011-02-03T07:20:12Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Power",
    "Type Of Investment Business":
      "အထက်ဘီလူးချောင်း ရေအားလျှပ်စစ် စီမံကိန်းကို BOT စနစ်ဖြင့် ဆောင်ရွက်၍ လျှပ်စစ် ဓါတ်အား ထုတ်လုပ်ဖြန့်ဖြူး ရောင်းချခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 22.67,
    "Total Amount Of Capital (in Millions)": 20353.58,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 60,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.24, Mya Kan Thar (2) Street, Hlaing Township, Yangon",
    "Organization Address":
      "No 12, Kay Mar Thi Street, Mi Chaung Kan Part (3), Thingangyun Township, Yangon",
    "Investment Permitted Address":
      "ရှမ်းပြည်တောင်ပိုင်း၊ ညောင်ရွှေမြို့နယ်အနောက် တောင်ဘက် (၁၄.၄)မိုင်ခန့် အကွာရှိ ဘီလူးချောင်း။",
  },
  {
    ID: 1624,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Lin, Chi-Chuan",
    "Name of Principal Organization": "Upper Well Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Pretty Fashion (Myanmar) Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1002/2015",
    "Permit Date": "2015-08-20T05:14:47Z",
    "Meeting Number": "14/2015",
    "Meeting Date": "2015-08-07T05:15:03Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Bridal Dress, Fabric and Garment Accessories on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Hla Hla Yin",
    "Land Area (units not specified in file)": 1.423,
    "Lease Term": 30,
    "Annual Lease Fee": 0.029,
    "Land Use Premium": null,
    "Number Of Local Employees": 800,
    "Number Of Foreign Employees": 26,
    Status: "Monitoring Approved",
    "Investor Address": "GF No. 88 SEC-1 Nei Hu Road, Taipei, Taiwan",
    "Organization Address":
      "Room 909 A, 9/F, Century Centre, 44-46 Hung To Road, Kwun Tong, Kowloon, Hong Kong",
    "Investment Permitted Address":
      "Plot No. 9, Phan Chat Won U Shwe O Street, HLaing Thar Yar Industrial Zone-2, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 1625,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Qin, Yang",
    "Name of Principal Organization": "Unique International Trading Co., Ltd.",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "WeiJie (Myanmar) Clothing Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1071/2016",
    "Permit Date": "2016-01-26T05:48:27Z",
    "Meeting Number": "1/2016",
    "Meeting Date": "2016-01-15T05:48:45Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.745,
    "Total Amount Of Capital (in Millions)": 1.745,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Yi Yi Lwin",
    "Land Area (units not specified in file)": 2.497,
    "Lease Term": 20,
    "Annual Lease Fee": 0.056,
    "Land Use Premium": null,
    "Number Of Local Employees": 1096,
    "Number Of Foreign Employees": 16,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.56-1, Bia Xia Street, Building No. 5, Room 306, Nan Jing City, China",
    "Organization Address":
      "No.56-1, Bia Xia Street, Building No. 5, Room 306, Nan Jing City, China",
    "Investment Permitted Address":
      "Plot No.406, Myay Taing Block No. YaLaPa 25, Shwe Linn Ban Industrial Zone, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 1626,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Xinghong Liu",
    "Name of Principal Organization": "HongKong Ytaro Development Co., Ltd.",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar":
      "Myanmar Uniview Optical International Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1096/2016",
    "Permit Date": "2016-03-09T06:14:28Z",
    "Meeting Number": "7/2016",
    "Meeting Date": "2016-02-26T06:14:36Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of all kinds of Optical Lens on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.5,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myint Zaw",
    "Land Area (units not specified in file)": 1.223,
    "Lease Term": 10,
    "Annual Lease Fee": 0.028,
    "Land Use Premium": null,
    "Number Of Local Employees": 321,
    "Number Of Foreign Employees": 6,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.9 4-4. Zouxin Village, Jiulongpo District, Chongqing City, People's Republic of China",
    "Organization Address":
      "Room 503, 5/F, Wayson Commercial Building, 28 Connaught Road, West Sheung Wan, Hong Kong",
    "Investment Permitted Address":
      "Plot No. 115, Myay Taing  Quarter No. 4, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 1627,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.  PARK  HYUNG  BAE",
    "Name of Principal Organization": "MPI  KOREA CO., LTD.",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "KOREA  SIN  HWA GARMENT  CO., LTD.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "706/2014",
    "Permit Date": "2014-04-09T08:26:39Z",
    "Meeting Number": "10/2014",
    "Meeting Date": "2014-03-19T08:27:21Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF  GARMENTS  ON  CMP  BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.7587,
    "Total Amount Of Capital (in Millions)": 0.7587,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myint Thein @ Balluee Swar Mi",
    "Land Area (units not specified in file)": 1.639,
    "Lease Term": 30,
    "Annual Lease Fee": 0.0365,
    "Land Use Premium": null,
    "Number Of Local Employees": 780,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "139, JUNGCHI-RI,  TANCHEON-MYEON, GONGJU-CITY, CHUNGCHEONGNAM-DO, KOREA",
    "Organization Address":
      "SILLIM-DONG, 3F, 3 JOWON-RO 18-GIL, GWANAK-GU, SEOUL, KOREA ",
    "Investment Permitted Address":
      "MYAY TAING  BLOCK    NO. 51, PLOT NO. 137, THARDUKAN  INDUSTRIAL ZONE, SHWE PYI  THAR TOWNSHIP, YANGON  REGION",
  },
  {
    ID: 1628,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.  KIM  SUNG  HWAN",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ACE  APPAREL INT’L CO., LTD.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "733/2014",
    "Permit Date": "2014-05-28T09:15:23Z",
    "Meeting Number": "13/2014",
    "Meeting Date": "2014-04-26T09:15:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF  GARMENTS  ON  CMP  BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.123,
    "Total Amount Of Capital (in Millions)": 1.123,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Nay Win Swe",
    "Land Area (units not specified in file)": 0.528,
    "Lease Term": 30,
    "Annual Lease Fee": 0.012,
    "Land Use Premium": null,
    "Number Of Local Employees": 725,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address": "NO. 768-3, HANNAN-DONG, YONG SAN GU, SEOUL, KOREA",
    "Organization Address": "",
    "Investment Permitted Address":
      "MYAY TAING  BLOCK NO. 109, PLOT NO. 55/3,  EAST-DAGON INDUSTRIAL  ZONE,                      EAST- DAGON  TOWNSHIP, YANGON  REGION",
  },
  {
    ID: 1629,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kim Chul Soo",
    "Name of Principal Organization": "Shinsung Tongsang Co., Ltd.",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "Shinsung Tongsang International Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "754/2014",
    "Permit Date": "2014-08-08T02:41:09Z",
    "Meeting Number": "17/2014",
    "Meeting Date": "2014-06-20T02:41:32Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 5.2,
    "Total Amount Of Capital (in Millions)": 5.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "Department of Human Settlement and Housing Development",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 50,
    "Annual Lease Fee": 0.02,
    "Land Use Premium": null,
    "Number Of Local Employees": 468,
    "Number Of Foreign Employees": 8,
    Status: "Monitoring Approved",
    "Investor Address":
      "Rm 501, Han Sol Building No. 415-11, Gildong, Seoul, Republic of Korea",
    "Organization Address":
      "# 444, Dunchon-dong, Gangdong-Gu, Seoul, Republic of Korea",
    "Investment Permitted Address":
      "No. 5/A, Yangon Industrial Zone, Mingalardon Township, Yangon Region",
  },
  {
    ID: 1631,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးစဝ်ခွန်စံအောင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Crystal Diamond Livestock Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "1045/2015",
    "Permit Date": "2015-03-19T05:33:16Z",
    "Meeting Number": "4/2015",
    "Meeting Date": "2015-03-06T05:33:36Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "မွေးမြူရေးအစာတောင့် ထုတ်လုပ်ခြင်းနှင့် ဖြန်ဖြူးရောင်းချခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 27269,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Crystal Diamond Livestock Company Limited",
    "Land Area (units not specified in file)": 10.757,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 200,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address":
      "ရန်ကုန်တိုင်းဒေသကြီး ကမာရွတ်မြို့နယ်၊ (၁၀)ရပ်ကွက်၊ အင်းလျားလမ်း၊ အမှတ်-(၆၂/အေ)",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး လှိုင်သာယာမြို့နယ်၊ ရွှေသံလွင် စက်မှုဇုန်၊ မြေတိုင်းရပ်ကွက်အမှတ်(၁၄)၊ မြေကွက်အမှတ် (၄၇/၄၈/၅၃) ",
  },
  {
    ID: 1633,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. OU,  CHIN-NAN ",
    "Name of Principal Organization": "PRECIOUS   FULL  INVESTMENTS  LIMITED",
    "Place of Incorporation": "British Virgin Islands",
    "Company Name In Myanmar": "MYANMAR  POU CHEN  COMPANY\tLIMITED ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "803/2014",
    "Permit Date": "2014-10-13T07:06:09Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T07:06:38Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF SHOES ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 74.7647,
    "Total Amount Of Capital (in Millions)": 74.7647,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Virgin Islands (British)",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Yin Yin",
    "Land Area (units not specified in file)": 39.998,
    "Lease Term": 30,
    "Annual Lease Fee": 0.0125,
    "Land Use Premium": null,
    "Number Of Local Employees": 2400,
    "Number Of Foreign Employees": 64,
    Status: "Monitoring Approved",
    "Investor Address":
      "NANNY  CAY, P. O. BOX 362,  ROAD  TOWN,  TORTOLA, BRITISH VIRGIN ISLANDS",
    "Organization Address":
      "NANNY  CAY, P. O. BOX 362,  ROAD  TOWN,  TORTOLA, BRITISH VIRGIN ISLANDS",
    "Investment Permitted Address":
      "PLOT NO. 112, 113, 114 , 115, 116, 117, 118, 119, 120, 121, MYAY TAING BLOCK NO. 50, NO.4 HIGH WAY ROAD, THARDU KAN INDUSTRIAL ZONE, SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1636,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MRS.  LIN, CHIU-CHUN ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ESLITE  GARMENT  COMPANY   LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "774/2014",
    "Permit Date": "2014-08-14T03:50:42Z",
    "Meeting Number": "16/2014",
    "Meeting Date": "2014-06-13T03:51:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF  GARMENTS  ON  CMP  BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.2536,
    "Total Amount Of Capital (in Millions)": 1.2536,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Mg Mg Khin & U Win Maung",
    "Land Area (units not specified in file)": 1.431,
    "Lease Term": 30,
    "Annual Lease Fee": 0.0315,
    "Land Use Premium": null,
    "Number Of Local Employees": 2008,
    "Number Of Foreign Employees": 17,
    Status: "Monitoring Approved",
    "Investor Address":
      "11F, NO.95, LEQUN 2nd  RD, ZHONGSHAM DIST,  TAIPEI CITY 10462, TAIWAN, REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "MYAY TAING  QUARTER NO.25, PLOT NO. 177, SHWE LIN BAN INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1637,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ken, Shun-Nan",
    "Name of Principal Organization": "Lion King International Corporation",
    "Place of Incorporation": "Brunei Darussalam",
    "Company Name In Myanmar": "Worldwide Value Manufacture Company Limited ",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "875/2014",
    "Permit Date": "2014-12-23T04:27:34Z",
    "Meeting Number": "28/2014",
    "Meeting Date": "2014-12-12T04:28:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of bags with CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.5,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Brunei Darussalam",
    "Form Of Investment": "FDII",
    "Land Owner": "U Khin Maung Oo ",
    "Land Area (units not specified in file)": 1.15,
    "Lease Term": 10,
    "Annual Lease Fee": 24,
    "Land Use Premium": null,
    "Number Of Local Employees": 710,
    "Number Of Foreign Employees": 22,
    Status: "Monitoring Approved",
    "Investor Address":
      "7F,No.44, Alley 11, Kuang Fu N. Road., Taipei City, Taiwan, Republic of China.",
    "Organization Address":
      "51, 5F, Britannia, Jalan Cator, BS 8811, BSB, Brunei Darussalam",
    "Investment Permitted Address":
      "Plot No.174, Pan Be Kaung Mg Khet Street,\nHlaing Thar Yar Industrial Zone (1), Hlaing Thar Yar Township\nYangon Region.\n",
  },
  {
    ID: 1638,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.LI, XIANG",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "TIANJIN FASHION ORIGIN COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "013/2017",
    "Permit Date": "2017-11-21T17:30:00Z",
    "Meeting Number": "YRIC-1/E-013/2017(094)",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.3,
    "Total Amount Of Capital (in Millions)": 0.3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U NAY MYO AUNG",
    "Land Area (units not specified in file)": 0.65,
    "Lease Term": 7,
    "Annual Lease Fee": 0.028,
    "Land Use Premium": null,
    "Number Of Local Employees": 174,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address":
      "NO.4/401,RIFANGLI, WUMA ROAD , HEBEI DISTRICT, TIANJIN CITY, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.509, MYAY TAING BLOCK NO. 25 SHWE LIN PAN INDUSTRIAL ZONE, HIAING THAR YAR TOWNSHIP YANGON REGION",
  },
  {
    ID: 1640,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS. NI HUIYUN",
    "Name of Principal Organization": "TIAN YU INTERNATIONAL TRADING CO., LTD.",
    "Place of Incorporation": "BRUNEI DARUSSALAM",
    "Company Name In Myanmar": "TIAN YU INTERNATIONAL CO., LTD.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "704/2014",
    "Permit Date": "2014-04-03T05:05:55Z",
    "Meeting Number": "9/2014",
    "Meeting Date": "2014-03-12T05:06:19Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF VARIETY OF SHOES ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 2.2581,
    "Total Amount Of Capital (in Millions)": 2.2581,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Brunei Darussalam",
    "Form Of Investment": "FDII",
    "Land Owner": "MYANMAR BRILLIANT SKY INDUSTRY CO., LTD.",
    "Land Area (units not specified in file)": 2.5,
    "Lease Term": 30,
    "Annual Lease Fee": 0.05,
    "Land Use Premium": null,
    "Number Of Local Employees": 1530,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "RM.51, 5 FLOOR, BRITANNIA HOUSE, JALAN CATOR, BANDAR SERI BEGAWAN BS 8811, NEGARA BRUNEI DARUSSALAM",
    "Organization Address":
      "RM.51, 5 FLOOR, BRITANNIA HOUSE, JALAN CATOR, BANDAR SERI BEGAWAN BS 8811, NEGARA BRUNEI DARUSSALAM",
    "Investment Permitted Address":
      "MYAY TAING BLOCK NO. 25, PLOT NO. 494, SHWE LIN PAN INDUSTRIAL ZONE, HLAING THARYAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1641,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS CHEN YING",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "NAY SHWE WIN COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "020/2018",
    "Permit Date": "2018-01-02T17:30:00Z",
    "Meeting Number": "9/2017",
    "Meeting Date": "2017-12-19T17:30:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.859,
    "Total Amount Of Capital (in Millions)": 1.859,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U MAUNG MAUNG KHIN",
    "Land Area (units not specified in file)": 2.398,
    "Lease Term": 9,
    "Annual Lease Fee": 0.053,
    "Land Use Premium": null,
    "Number Of Local Employees": 1161,
    "Number Of Foreign Employees": 16,
    Status: "Draft",
    "Investor Address":
      "NO.98,ANSHAN 1st RD,SHIBEI,QINGDAO,SHAN DONG PROVINCE,PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.7,MYAY TAING BLOCK NO.49,WARTAYAR INDUSTRIAL ZONE,SHWE PYI THAR TOWNSHIP,YANGON REGION",
  },
  {
    ID: 1642,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. YANG, CHIH - HUA",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "JIULIN TECHNOLOGY CO., LTD.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "709/2014",
    "Permit Date": "2014-04-08T05:41:28Z",
    "Meeting Number": "8/2014",
    "Meeting Date": "2014-03-05T05:41:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF ELECTRONIC SIREN AND ELECTRICAL GOODS",
    "Amount Of Foreign Capital USD (in Millions)": 0.8265,
    "Total Amount Of Capital (in Millions)": 0.87,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "JV",
    "Land Owner": "DAW THAN MYINT, DAW SWE SWE MYINT",
    "Land Area (units not specified in file)": 0.249,
    "Lease Term": 5,
    "Annual Lease Fee": 0.007,
    "Land Use Premium": null,
    "Number Of Local Employees": 103,
    "Number Of Foreign Employees": 4,
    Status: "Approved",
    "Investor Address": "NO.4, LANE 149, HU LIN STREET, HSIN CHU CITY, TAIWAN",
    "Organization Address": "",
    "Investment Permitted Address":
      "MYAY TAING BLOCK NO. THA KA MA-18, PLOT NO. 519/520, HLATING THAR YAR INDUSTRIAL ZONE 5, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1643,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LIM ANG MENG",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "LMH GARMENT HANGERS AND ACCESSORIES COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "014/2017",
    "Permit Date": "2017-12-03T17:30:00Z",
    "Meeting Number": "7/2017",
    "Meeting Date": "2017-11-21T17:30:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF HANGERS AND ACCESSORIES ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.69,
    "Total Amount Of Capital (in Millions)": 1.69,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Malaysia",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW YONE CHWAY",
    "Land Area (units not specified in file)": 0.811,
    "Lease Term": 10,
    "Annual Lease Fee": 0.06,
    "Land Use Premium": null,
    "Number Of Local Employees": 59,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address":
      "NO.44, JALAN PINGGIRAN 2, GOLF EAST, HORIZON HILLS, 79100 NUSAJAYA, JOHOR MALAYSIA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.79,MYAY TAING BLOCK NO.25, SHWE LIN PAN INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP",
  },
  {
    ID: 1644,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. CHARAN NARULA",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "NARULA INDUSTRIES COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "752/2014",
    "Permit Date": "2014-08-06T06:12:59Z",
    "Meeting Number": "17/2014",
    "Meeting Date": "2014-06-20T06:13:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF SLIPPER ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.442,
    "Total Amount Of Capital (in Millions)": 1.457,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "U CHIT THEIN",
    "Land Area (units not specified in file)": 2.41,
    "Lease Term": 20,
    "Annual Lease Fee": 6.1,
    "Land Use Premium": null,
    "Number Of Local Employees": 209,
    "Number Of Foreign Employees": 14,
    Status: "Monitoring Approved",
    "Investor Address":
      "888/116 SOI YINGCHAROEN BANGPLEE-TAMRU ROAD, BANGPLEEYAI BANGPLEE, SAMUTPRAKARN, 10540 THAILAND",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 137, MYAY TAING BLOCK NO.14, MIN AYEYAR STREET, SHWE THAN LWIN INDUSTRIAL ZONE, HLAING THARYAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1645,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wang, Ming-Yang",
    "Name of Principal Organization": "Arno Corporation, ",
    "Place of Incorporation": "Taiwan",
    "Company Name In Myanmar": "Arno (Myanmar) Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "876/2014",
    "Permit Date": "2014-12-23T07:05:56Z",
    "Meeting Number": "27/2014",
    "Meeting Date": "2014-11-28T07:06:19Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF FOOT PUMP, HAND PUMP, INFLATOR AND VACUUM CLEANER ON CMP BASIS ",
    "Amount Of Foreign Capital USD (in Millions)": 9.009,
    "Total Amount Of Capital (in Millions)": 9.009,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Mauritius",
    "Form Of Investment": "FDII",
    "Land Owner": "U Soe Hlaing & U Hok Thik",
    "Land Area (units not specified in file)": 3.5,
    "Lease Term": 3,
    "Annual Lease Fee": 0.288,
    "Land Use Premium": null,
    "Number Of Local Employees": 185,
    "Number Of Foreign Employees": 23,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 84, Zhuanzuing, Madou District, Tainan City 72157, Taiwan",
    "Organization Address":
      "No. 84, Zhuanzuing, Madou District, Tainan City 72157, Taiwan",
    "Investment Permitted Address":
      "PLOT NO. 198/19, KANAUNG MIN THARGYI ROAD, INDUSTRIAL ZONE 1, DAGON SEIKAN TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1646,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. NAOKI  SAKAMURA",
    "Name of Principal Organization": "SUMITOMO CORPORATION ",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "SUMMIT SPA MOTORS LIMITED ",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "087/2018",
    "Permit Date": "2018-06-23T07:07:17Z",
    "Meeting Number": "8/2018",
    "Meeting Date": "2018-06-22T07:06:51Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ASSEMBLING, MANUFACTURING  AND  SALES  OF  CONTAINER BOXES",
    "Amount Of Foreign Capital USD (in Millions)": 2.4,
    "Total Amount Of Capital (in Millions)": 3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "Yoma Development Group Limited ",
    "Land Area (units not specified in file)": 1.5,
    "Lease Term": 5,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 35,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "6-25-8, HATANODAI, SHINAGAWA-KU, TOKYO, JAPAN          ",
    "Organization Address": " 8-11, HARUMI 1-CHOME, CHUO-KU, TOKYO, JAPAN ",
    "Investment Permitted Address":
      "HOLDING NO.19/4, KWIN NO.505, UPPER TAGONDINE EAST, YAY TALA POUNG VILLAGE TRACT, HLEGU TOWNSHIP, YANGON REGION ",
  },
  {
    ID: 1647,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MRS. WEI, CHIU-YEN",
    "Name of Principal Organization": "WEDTEX INDUSTRIAL (HK) CO., LTD., ",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "WILLIAM (MYANMAR) INDUSTRIAL COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "730/2014",
    "Permit Date": "2014-05-28T07:28:16Z",
    "Meeting Number": "13/2014",
    "Meeting Date": "2014-04-26T07:28:47Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING    OF EMBROIDERY, BRIDAL DRESS AND ACCESSORIES ON CMP BASIS   ",
    "Amount Of Foreign Capital USD (in Millions)": 5,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 34,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Mingaladon Industrial Park Co., Ltd.",
    "Land Area (units not specified in file)": 2.502,
    "Lease Term": 34,
    "Annual Lease Fee": 0.003,
    "Land Use Premium": 0.59,
    "Number Of Local Employees": 610,
    "Number Of Foreign Employees": 13,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.42, ALY, 161, HEXING LANE, PITOU TOWNSHIP, CHANGHUA COUNTY 523, TAIWAN",
    "Organization Address":
      "UNIT 1111, 11/F., TRENDY CENTRE, 682-684 CASTLE PEAK ROAD, KOWLOON, HONG KONG",
    "Investment Permitted Address":
      "PLOT NO.A-8, MINGALADON INDUSTRIAL PARK, MINGALADON TOWNSHIP, YANGON REGION ",
  },
  {
    ID: 1648,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Aung Thi Ha, ",
    "Name of Principal Organization": "ZILLION ZEST COMPANY LIMITED",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "OIL  TECH  (MYANMAR)  LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "825/2014",
    "Permit Date": "2014-10-24T07:25:27Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T07:25:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "PRODUCTION AND REPAIRING OF OIL COUNTRY TUBULAR GOODS",
    "Amount Of Foreign Capital USD (in Millions)": 1.895,
    "Total Amount Of Capital (in Millions)": 2.369,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "U Ye Htoo Aung",
    "Land Area (units not specified in file)": 2.74,
    "Lease Term": 20,
    "Annual Lease Fee": 0.072,
    "Land Use Premium": null,
    "Number Of Local Employees": 22,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.2, R-105, Ward-26, Aung Zeya Housing , South Dagon Township, Yangon ",
    "Organization Address":
      "BUILDING-A, # 09-02, PEARL  CONDO, KABARAYE PAGODA ROAD, BAHAN TOWNSHIP, YANGON ",
    "Investment Permitted Address":
      "PLOT NO. 183, MAKA YAR MIN THAR GYI ROAD, INDUSTRIAL ZONE (1), DAGON MYOTHIT (SEIKKAN) TOWNSHIP, YANGON  REGION ",
  },
  {
    ID: 1649,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. HIMENO YUICHI",
    "Name of Principal Organization": "HIMENO PRECISION WORKS, INC",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "MYANMAR SUN BELL CO., LTD.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "711/2014",
    "Permit Date": "2014-04-08T07:39:12Z",
    "Meeting Number": "9/2014",
    "Meeting Date": "2014-03-12T07:39:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF MACHINE KEY & PIN ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.4,
    "Total Amount Of Capital (in Millions)": 1.4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "U HLA SHWE",
    "Land Area (units not specified in file)": 2.646,
    "Lease Term": 30,
    "Annual Lease Fee": 0.042,
    "Land Use Premium": null,
    "Number Of Local Employees": 106,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address": "118-1 KURAKAWA HIMI-CITY, TOYAMA, JAPAN",
    "Organization Address": "25/21 SAIWAICHO, HIMI-CITY, TOYAMA, JAPAN",
    "Investment Permitted Address":
      "PLOT NO.18, MYAUNG TAGAR STEEL INDUSTRIAL ZONE, HMAWBI TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1650,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. ANDREW MERCADIER SHEPARD",
    "Name of Principal Organization": "COLGATE-PALMOLIVE (THAILAND) LIMITED",
    "Place of Incorporation": "THAILAND",
    "Company Name In Myanmar": "COLGATE-PALMOLIVE (MYANMAR) LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "751/2014",
    "Permit Date": "2014-07-22T07:55:07Z",
    "Meeting Number": "16/2014",
    "Meeting Date": "2014-06-13T07:55:47Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF ORAL CARE PRODUCTS AND PERSONAL CARE PRODUCTS",
    "Amount Of Foreign Capital USD (in Millions)": 89.5,
    "Total Amount Of Capital (in Millions)": 89.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 42,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Thailand",
    "Form Of Investment": "FDII",
    "Land Owner": "U NYAN WIN, DAW SAN MYINT",
    "Land Area (units not specified in file)": 2.784,
    "Lease Term": 43,
    "Annual Lease Fee": 0.132,
    "Land Use Premium": null,
    "Number Of Local Employees": 217,
    "Number Of Foreign Employees": 7,
    Status: "Monitoring Approved",
    "Investor Address":
      "19 OFF NA-RANONG ROAD, SUNTHOMKOSA ROAD, KLONGTOEY, BANGKOK 10110, THAILAND",
    "Organization Address":
      "19 OFF NA-RANONG ROAD, SUNTHOMKOSA ROAD, KLONGTOEY, BANGKOK 10110, THAILAND",
    "Investment Permitted Address":
      "PLOT NO. 97 AND 101, LOT 42 SHWE PYITHAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1651,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. CLAUS SUDHOFF",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "SEIN SANDAR INTERNATIONAL COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "715/2014",
    "Permit Date": "2014-07-03T07:56:57Z",
    "Meeting Number": "9/2014",
    "Meeting Date": "2014-03-12T07:57:13Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS \n",
    "Amount Of Foreign Capital USD (in Millions)": 0.506,
    "Total Amount Of Capital (in Millions)": 0.506,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 4,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Philippines",
    "Form Of Investment": "FDII",
    "Land Owner": "U Law Yain Kyit",
    "Land Area (units not specified in file)": 1.701,
    "Lease Term": 30,
    "Annual Lease Fee": 0.084,
    "Land Use Premium": null,
    "Number Of Local Employees": 515,
    "Number Of Foreign Employees": 2,
    Status: "Approved",
    "Investor Address":
      "NO. 105, IPIL-IPIL STREET, AYALA ALABANG VILLAGE, 1780 MUNTINLUPA CITY, METRO MANILA, PHILIPPINES",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 104, SEIK KAN THA STREET, HLAING THARYAR INDUSTRIAL ZONE 3 EXTENSION, HLAING THARYAR  TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1653,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဇာယာဒ်ရော်မံ(ခ)ဦးဌေးဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "YWIN SEA FOOD LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1251/2017",
    "Permit Date": "2017-05-25T08:38:19Z",
    "Meeting Number": "7/2017",
    "Meeting Date": "2017-04-28T08:39:00Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "Contract Processing  နှင့် Normal System စနစ် (၂)မျိုးဖြင့် ရေချို၊ ရေငန် ငါး၊ ပုစွန် ပြုပြင် ထုတ်လုပ်ခြင်းနှင့် ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 3568.75,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးဇာယာဒ်ရော်မံ(ခ)ဦးဌေးဝင်း",
    "Land Area (units not specified in file)": 5.559,
    "Lease Term": 50,
    "Annual Lease Fee": 70.301,
    "Land Use Premium": null,
    "Number Of Local Employees": 400,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၃၄/က၊ နတ်မောက်လမ်းသွယ်(၁)၊ ဗိုလ်ချို(၂)လမ်း၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ လှိုင်သာယာမြို့နယ်၊ ငွေပင်လယ် စက်မှုဇုန်၊ မြေတိုင်းရပ်ကွက် အမှတ်-၂၄၊ မြေကွက်အမှတ်-၇၃၊ ၇၅",
  },
  {
    ID: 1654,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. TAKASHI MISHIMA ",
    "Name of Principal Organization": "DENSO INDUSTRY ASIA COMPANY LIMITED",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "DENSO INDUSTRY  YANGON  LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "807/2014",
    "Permit Date": "2014-10-21T09:03:40Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T09:04:13Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF ELECTRONIC  WIRE  HARNESS ",
    "Amount Of Foreign Capital USD (in Millions)": 0.8,
    "Total Amount Of Capital (in Millions)": 0.8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": " Daw Kyin Than",
    "Land Area (units not specified in file)": 0.294,
    "Lease Term": 4,
    "Annual Lease Fee": 45.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 61,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "FLAT 10, 15F, SHATIN GALLERIA, 18-24 SHAN MEI  STREET, FOTAN, SHATIN, N. T. HONGKONG",
    "Organization Address":
      "FLAT 10, 15F, SHATIN GALLERIA, 18-24 SHAN MEI  STREET, FOTAN, SHATIN, N. T. HONGKONG       ",
    "Investment Permitted Address":
      "PLOT NO. 240, MYAY TAING BLOCK NO. 25, DEPEYIN WUN HTAUK U MYAE STREET, SHWE LIN BAN INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON  REGION",
  },
  {
    ID: 1655,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. SHIN, HEY-YONG",
    "Name of Principal Organization": "SANMARU CO.",
    "Place of Incorporation": "REPUBLIC OF KOREA",
    "Company Name In Myanmar": "MYANMAR D SYSTEM CO., LTD.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "712/2014",
    "Permit Date": "2014-04-24T09:06:23Z",
    "Meeting Number": "10/2014",
    "Meeting Date": "2014-03-19T09:06:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.953,
    "Total Amount Of Capital (in Millions)": 0.953,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW NYUNT NYUNT HTAY",
    "Land Area (units not specified in file)": 1.4,
    "Lease Term": 30,
    "Annual Lease Fee": 0.028,
    "Land Use Premium": null,
    "Number Of Local Employees": 1514,
    "Number Of Foreign Employees": 8,
    Status: "Monitoring Approved",
    "Investor Address":
      "20-305, JINHEUNG APT., ANYANG 1-DONG, ANAYANG-CITY, KYEONGKI-DO, REPUBLIC OF KOREA",
    "Organization Address":
      "364, HAAN-RO, GWANGMYEONG-CITY, GYEONGGI-DO, REPUBLIC OF KOREA",
    "Investment Permitted Address":
      "KWIN NO. 520, PLOT NO. 47/5, 47/6, 49/4, KYET PHYU KAN (EAST), THANDAPIN VILLAGE TRACT, MHAWBI TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1656,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ding Weilin",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Da Wai Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "888/2015",
    "Permit Date": "2015-01-21T09:07:30Z",
    "Meeting Number": "1/2015",
    "Meeting Date": "2015-01-16T09:07:46Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF POLY BAG, PRINTED LABEL, WOBEN LABEL, PAPER STICKER AND PAPER HANTAG",
    "Amount Of Foreign Capital USD (in Millions)": 2.717,
    "Total Amount Of Capital (in Millions)": 2.717,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Htay Oo & Daw Khin Htar Yee",
    "Land Area (units not specified in file)": 2.008,
    "Lease Term": 30,
    "Annual Lease Fee": 0.045,
    "Land Use Premium": null,
    "Number Of Local Employees": 72,
    "Number Of Foreign Employees": 12,
    Status: "Monitoring Amend",
    "Investor Address":
      "No. 8 Xing Min Road, Zhou Zhaung Town, Kun Shan City, Jiang Su Province, People's Republic of China",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No. 109, Myay Taing Block No. 14, Industrial Zone (7), Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 1658,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LIM  YOUNG  CHUL ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "M.DAEYOUNG  ELECTRONIC  COMPANY  LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "826/2014",
    "Permit Date": "2014-10-28T09:50:25Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T09:50:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF ELECTRONIC  GOODS  (SUCH AS SPEAKERS AND  VOICE  COIL) ON CMP  BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.584,
    "Total Amount Of Capital (in Millions)": 0.584,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Zaw Linn",
    "Land Area (units not specified in file)": 1.899,
    "Lease Term": 30,
    "Annual Lease Fee": 0.065,
    "Land Use Premium": null,
    "Number Of Local Employees": 268,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "C-902, MAPOTRPALACE,  DOHWA-DONG, MAPO-GO, SEOUL,  KOREA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 21, MYAY TAING BLOCK NO. 112, EAST DAGON INDUSTRIAL ZONE, DAGON (EAST)  TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1659,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ေဒါ်တုံကျိုဇီ(ခ)ဒေါ်ကြူကြူ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Success Time International Company Limited [ ဆပ်(က်) ဆက်(စ်) တုိင်း(မ်) အင်တာနေရှင်နယ် ကုမ္ပဏီလီမိတက်]",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "1012/2014",
    "Permit Date": "2018-11-21T10:02:00Z",
    "Meeting Number": "26/2014",
    "Meeting Date": "2018-11-07T10:02:47Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP  စနစ်ဖြင့် ဖိနပ်အမျိုးမျိုး  ထုတ်လုပ််ခြင်းလုပ်ငန်း\t\t",
    "Amount Of Foreign Capital USD (in Millions)": 1.0825,
    "Total Amount Of Capital (in Millions)": 1033.435,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "ေဒါ်တုံကျိုဇီ(ခ)ဒေါ်ကြူကြူ(ကိုယ်ပိုင်မြေပေါ်တွင်ဆောင်ရွက်ခြင်းဖြစ်သည်)",
    "Land Area (units not specified in file)": 1.033,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 972,
    "Number Of Foreign Employees": 13,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၃၂/၁၀၁၊ အောင်သပြေလမ်း၊ သာယာကုန်းရပ်ကွက်၊ မင်္ဂလာ တောင်ညွန့်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်၂၄၆-N2a ၊၂၄၆-N2b ၊ ၂၄၆-N2c၊၂၄၆-N2d၊ ဦးအောင်သူလမ်းနှင့်ဦးထွန်းညိုလမ်းထောင့်၊လှိုင်သာယာစက်မှုဇုန် (၂)၊ လှိုင်သာယာ မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1660,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wang Jen Hao",
    "Name of Principal Organization": "Spring Moon Co., Ltd.,",
    "Place of Incorporation": "Brunei Darussalam",
    "Company Name In Myanmar": "Spring Moon Garment Manufacturing Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "873/2014",
    "Permit Date": "2014-12-15T10:09:56Z",
    "Meeting Number": "28/2014",
    "Meeting Date": "2014-12-12T10:10:19Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.12,
    "Total Amount Of Capital (in Millions)": 1.12,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 24,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Brunei Darussalam",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaw Khin & Daw Wai Wai Yee",
    "Land Area (units not specified in file)": 1.952,
    "Lease Term": 30,
    "Annual Lease Fee": 0.048,
    "Land Use Premium": null,
    "Number Of Local Employees": 700,
    "Number Of Foreign Employees": 6,
    Status: "Monitoring Approved",
    "Investor Address": "9F, No. 67, SEC.1, Nanchang Road, Taipei, Taiwan 100",
    "Organization Address":
      "Room 51, 5TH Floor, Britannia House, Jalan Cator, Bandar Seri Begawan BS 8811, Negara Brunei Darussalam",
    "Investment Permitted Address":
      "Plot No. 123, Myay Taing Block No. 4, Industrial Zone (4), Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 1661,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MRS. LI  YUAN ",
    "Name of Principal Organization":
      "SHANGHAI  STYLE  FASHION ACCESSORIES COMPANY LIMITED",
    "Place of Incorporation": "The People's Republic of China",
    "Company Name In Myanmar":
      "STYLE  FASHION  ACCESSORIES (MYANMAR)  COMPANY  LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "827/2014",
    "Permit Date": "2014-10-28T10:11:21Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T10:13:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF KNITTED WEAR  ON CMP  BASIS (SUCH AS WOVEN CAP, KNITTED HAT, KNITTED SCARF AND KNITTED GLOVES)",
    "Amount Of Foreign Capital USD (in Millions)": 1.9186,
    "Total Amount Of Capital (in Millions)": 1.9186,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Than Htay",
    "Land Area (units not specified in file)": 2,
    "Lease Term": 20,
    "Annual Lease Fee": 0.0485,
    "Land Use Premium": null,
    "Number Of Local Employees": 1167,
    "Number Of Foreign Employees": 30,
    Status: "Monitoring Approved",
    "Investor Address":
      "ROOM 602, NO. 9, LANE 855, SONGHONG ROAD, SHANGHAI, CHINA",
    "Organization Address":
      "ROOM 908, NO. 30A, TIAN SHAN ROAD, CHANGNING DISTRICT, SHANGHAI      ",
    "Investment Permitted Address":
      "PLOT NO. 182/13, MYAY TAING QUARTER NO. 25, SHWE LIN BAN INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1663,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. KIM YOUNGIL",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "EHWA METAL COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "015/2017",
    "Permit Date": "2017-12-03T17:30:01Z",
    "Meeting Number": "7/2017",
    "Meeting Date": "2017-11-22T03:23:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF STEEL PRODUCTS FOR INTERIOR DECORATION",
    "Amount Of Foreign Capital USD (in Millions)": 1.985,
    "Total Amount Of Capital (in Millions)": 1.985,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U TIN WIN",
    "Land Area (units not specified in file)": 1.8,
    "Lease Term": 10,
    "Annual Lease Fee": 0.022,
    "Land Use Premium": null,
    "Number Of Local Employees": 39,
    "Number Of Foreign Employees": 1,
    Status: "Draft",
    "Investor Address":
      "404 DONG HAK, 14 GEUMDANG-RO, 146 BEONO-GIL, GUNPO-SI, GYENOGGI-DO, REPUOBLIC OF KOREA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.48, MYAUNG TAKAR INDUSTRIAL ZONE , HMAWBI TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1664,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. TEMMA TAKEUCHI",
    "Name of Principal Organization": "KOUWA INDUSTRY COMPANY LIMITED",
    "Place of Incorporation": "JAPAN",
    "Company Name In Myanmar": "KOUWA MYANMAR COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "016/2017",
    "Permit Date": "2017-12-04T06:32:36Z",
    "Meeting Number": "7/2017",
    "Meeting Date": "2017-11-22T06:33:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.64,
    "Total Amount Of Capital (in Millions)": 0.64,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "U SAI WIN TUN",
    "Land Area (units not specified in file)": 2.132,
    "Lease Term": 30,
    "Annual Lease Fee": 90,
    "Land Use Premium": null,
    "Number Of Local Employees": 279,
    "Number Of Foreign Employees": 12,
    Status: "Draft",
    "Investor Address":
      "NO.1-4-7-1102, HIRANOMACHI, CHUO-KU, OSAKA, JAPAN 540-0037",
    "Organization Address": "NO.7-20, TEMMAI, KITA-KU, OSAKA, JAPAN 530-0043",
    "Investment Permitted Address":
      "PLOT NO. 404, MYAY TAING BLOCK NO.25 SHWE LIN PAN SETHMU MYO, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1665,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. HUANG TIANSHU",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "JIANGSU SOHO (MYANMAR) INDUSTRY COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "021/2018",
    "Permit Date": "2018-01-03T09:36:07Z",
    "Meeting Number": "9/2017",
    "Meeting Date": "2017-12-20T09:37:06Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.195,
    "Total Amount Of Capital (in Millions)": 1.195,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U AUNG PHYO @ U MYINT THU @ U SAI LON",
    "Land Area (units not specified in file)": 2,
    "Lease Term": 10,
    "Annual Lease Fee": 0.175,
    "Land Use Premium": null,
    "Number Of Local Employees": 945,
    "Number Of Foreign Employees": 30,
    Status: "Draft",
    "Investor Address":
      "NO.48, RUAN JIN ROAD, YU HUA, NAN JING, JIANGSU PROVINCE, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.95, MYAY TAING BLOCK NO.25, SHWE LIN PAN SETHMU MYO, HLAING THAR YAR TOWNSHIOP, YANGON REGION",
  },
  {
    ID: 1666,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. YANG, QINHAO",
    "Name of Principal Organization":
      "SANFENG IMPORT & EXPORT TRADING CO., LTD",
    "Place of Incorporation": "PEOPLE'S REPUBLIC OF CHINA",
    "Company Name In Myanmar": "SHUANGXI (MYANMAR) GARMENT COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "022/2018",
    "Permit Date": "2018-01-03T10:08:14Z",
    "Meeting Number": "9/2017",
    "Meeting Date": "2017-12-20T10:08:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.86,
    "Total Amount Of Capital (in Millions)": 0.86,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U KYAW SEIN",
    "Land Area (units not specified in file)": 2.5,
    "Lease Term": 10,
    "Annual Lease Fee": 0.024,
    "Land Use Premium": null,
    "Number Of Local Employees": 380,
    "Number Of Foreign Employees": 24,
    Status: "Draft",
    "Investor Address":
      "NO.180, WANAN RD, LUOYANG INDUSTRIAL AREA, TAIWANESE INVESTMENT ZONE, QUANZHOU,FUJIAN PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address":
      "180, WANAN RD, LUOYANG INDUSTRIAL AREA, TAIWANESE INVESTMENT ZONE, QUANZHOU, FUJIAN, PEOPLE'S REPUBLIC OF CHINA",
    "Investment Permitted Address":
      "PLOT NO. 76 AND 101, MYAY TAING BLOCK NO ZONE-2, HLAING THAR YAR INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1667,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MRS. WANG, TING",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "SANHE PLASTIC COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "024/2018",
    "Permit Date": "2018-01-03T10:54:05Z",
    "Meeting Number": "9/2017",
    "Meeting Date": "2017-12-20T10:55:09Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF PLASTIC SHEET ",
    "Amount Of Foreign Capital USD (in Millions)": 1.867,
    "Total Amount Of Capital (in Millions)": 2.334,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "U Myo Win Zaw",
    "Land Area (units not specified in file)": 1.141,
    "Lease Term": 30,
    "Annual Lease Fee": 32.4,
    "Land Use Premium": null,
    "Number Of Local Employees": 58,
    "Number Of Foreign Employees": 3,
    Status: "Submitted",
    "Investor Address":
      "NO.2, YUN CHENG SHI, YAN HU QU, XI MENG WAI NAN YI XIANG, SHAN XI SHEN, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.49, MYAY TAING BLOCK NO.24, NGWE PIN LAL INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1668,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. WANG, YIQIANG",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "MYANMAR FULL WIN SAFETY PRODUCTS COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "023/2018",
    "Permit Date": "2018-01-03T02:48:15Z",
    "Meeting Number": "9/2017",
    "Meeting Date": "2017-12-20T02:48:37Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF PROTECTIVE SAFETY CLOTHING ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.908,
    "Total Amount Of Capital (in Millions)": 0.908,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW THAN MYINT ",
    "Land Area (units not specified in file)": 1.67,
    "Lease Term": 5,
    "Annual Lease Fee": 0.124,
    "Land Use Premium": null,
    "Number Of Local Employees": 500,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "ROOM NO.308, UNIT 4, YUNXIA COURT 14, HAIZHUN STREET, LILLY NEW CITY, ZHEJIANG  PROVINCE, HAINING CITY , PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 76, MYAY TAING BLOCK NO.25, SHWE LIN PAN SETHMU MYO, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1669,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. CHOI  YOUNG  JOO  ",
    "Name of Principal Organization": "PANKO CORPORATION",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "PANKO MYANMAR  COMPANY  LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "841/2014",
    "Permit Date": "2014-10-31T03:36:20Z",
    "Meeting Number": "23/2014",
    "Meeting Date": "2014-10-10T03:36:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENTS ON CMP  BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 2.52,
    "Total Amount Of Capital (in Millions)": 2.52,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Khin Zaw",
    "Land Area (units not specified in file)": 4.4,
    "Lease Term": 10,
    "Annual Lease Fee": 0.756,
    "Land Use Premium": null,
    "Number Of Local Employees": 1450,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 396, GANGSEO-RO, GANGSEO-GU, SEOUL, REPUBLIC OF KOREA",
    "Organization Address":
      "NO. 396, GANGSEO-RO, GANGSEO-GU, SEOUL, REPUBLIC OF KOREA",
    "Investment Permitted Address":
      "PLOT NO. 75/KHA & 76/KHA, HLAWGAR ROAD, MYAY TAING BLOCK NO. 561, SHWE PYI THAR  TOWNSHIP, YANGON  REGION",
  },
  {
    ID: 1670,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. JIANG ZONGBIAO",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ZONG HONG (MYANMAR) GARMENT COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "025/2018",
    "Permit Date": "2018-01-24T03:38:58Z",
    "Meeting Number": "1/2018",
    "Meeting Date": "2018-01-03T03:39:36Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 2.091,
    "Total Amount Of Capital (in Millions)": 2.091,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U YIN MAUNG THEIN, DAW YONE INN @ DAW MYINT KYI",
    "Land Area (units not specified in file)": 3.285,
    "Lease Term": 10,
    "Annual Lease Fee": 0.133,
    "Land Use Premium": null,
    "Number Of Local Employees": 1015,
    "Number Of Foreign Employees": 20,
    Status: "Draft",
    "Investor Address":
      "ROOM NO.106M BUILDING 14, GONGYUAN XINCUN, YANGSHE TOWN, ZHANGJIAGANG CITY, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.A3, MYAY TAING BLOCK NO. 21, MYA SEIN YAUNG INDUSTRIAL ZONE , HLAING THAR YAR TOWNSHIP , YANGON REGION",
  },
  {
    ID: 1671,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. CHAN FUN KWONG",
    "Name of Principal Organization": "CHEUNG HING INTERNATIONAL LIMITED",
    "Place of Incorporation": "HONG KONG",
    "Company Name In Myanmar": "CHEUNG HING MYANMAR LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "746/2014",
    "Permit Date": "2014-07-08T03:47:30Z",
    "Meeting Number": "15/2014",
    "Meeting Date": "2014-05-31T03:47:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 21.576,
    "Total Amount Of Capital (in Millions)": 21.576,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW THAN THAN",
    "Land Area (units not specified in file)": 10.07,
    "Lease Term": 10,
    "Annual Lease Fee": 0.204,
    "Land Use Premium": null,
    "Number Of Local Employees": 1333,
    "Number Of Foreign Employees": 30,
    Status: "Monitoring Approved",
    "Investor Address":
      "94 HONG LOK WEST ROAD, HONG LOK YUEN, TAI PO, NEW TERRITORIES, HONG KONG",
    "Organization Address":
      "2/F, EVERWIN CENTRE, 72 HUNG TO ROAD, KWUN TONG, KOWLOON, HONG KONG",
    "Investment Permitted Address":
      "PLOT NO. 204, 205, 212, 213 AND 214, BLOCK NO. 49, NGA MOE YEIK STREET, WATAYAR INDUSTRIAL ZONE, SHWE PYITHAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1672,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LIU  XIANMIN ",
    "Name of Principal Organization": "DJF INTERNATIONAL  TRADE LIMITED",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "UNITED KNITTING (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "842/2014",
    "Permit Date": "2014-10-31T03:57:18Z",
    "Meeting Number": "24/2014",
    "Meeting Date": "2014-10-17T03:57:37Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF GARMENTS  ON CMP  BASIS (SUCH AS ACCESSORIES, SOCKS, HOSIERY AND LEGWEAR)",
    "Amount Of Foreign Capital USD (in Millions)": 2.2,
    "Total Amount Of Capital (in Millions)": 2.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner":
      "U Myint Lwin @ Vimal Kumar, Daw Thida Win @ Daw Indira Kumari",
    "Land Area (units not specified in file)": 2.011,
    "Lease Term": 10,
    "Annual Lease Fee": 0.048,
    "Land Use Premium": null,
    "Number Of Local Employees": 478,
    "Number Of Foreign Employees": 14,
    Status: "Monitoring Approved",
    "Investor Address":
      "RM 404, BUILDING 3, AUSHENG  GARDEN,  HAINING  CITY, ZHEJIANG  PROVINCE, CHINA",
    "Organization Address":
      "FLAT/RM 905, WORKINGBERG COMM. BLDG, 41-47 MARBLE ROAD, HONG KONG         ",
    "Investment Permitted Address":
      "PLOT NO. 43, BAMAW  AHTWINWUN STREET, INDUSTRIAL ZONE (3), HLAING THARYAR   TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1673,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. FANG, CHONGDUO",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "XIN FA (MYANMAR) TEXTILE COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "026/2018",
    "Permit Date": "2018-01-24T03:58:22Z",
    "Meeting Number": "1/2018",
    "Meeting Date": "2018-01-03T03:58:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF COTTON YARN ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 2.965,
    "Total Amount Of Capital (in Millions)": 2.965,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW NU NU YEE",
    "Land Area (units not specified in file)": 1.836,
    "Lease Term": 10,
    "Annual Lease Fee": 0.124,
    "Land Use Premium": null,
    "Number Of Local Employees": 80,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "ROOM NO.422, C-D DISTRICT, WENZHOU CITY TWO GIFTS, LONGGANG TOWN, CANGNAN COUNTRY, WENZHOU CITY, ZHEJIANG PROVINCE, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.60, MYAY TAING BLOCK NO. THILAWA INDUSTRIAL ZONE, THANLYIN KYAUKTAN TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1674,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MRS. ELIZA YUKIKO WONG ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ENVIRO A ONE INDUSTRIAL COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "027/2018",
    "Permit Date": "2018-01-24T04:25:21Z",
    "Meeting Number": "1/2018",
    "Meeting Date": "2018-01-03T04:25:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "SEPARATING, SORTING, PACKAGING AND EXPORT OF THE RECYCLE PRODUCTS (SUCH AS PAPER)",
    "Amount Of Foreign Capital USD (in Millions)": 0.5,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW KHIN SEIN",
    "Land Area (units not specified in file)": 2.595,
    "Lease Term": 5,
    "Annual Lease Fee": 30,
    "Land Use Premium": null,
    "Number Of Local Employees": 29,
    "Number Of Foreign Employees": 2,
    Status: "Draft",
    "Investor Address": "BLK 465 A, FERNVALE LINK, #23-501, SINGAPORE 791467",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 4, MYAY TAING BLOCK NO. 109, SETHMU, EAST DAGON TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1675,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U R YUDH",
    "Name of Principal Organization": "AYEYAR HINTHAR TRADING CO., LTD.",
    "Place of Incorporation": "MYANMAR",
    "Company Name In Myanmar": "AYEYAR PLASTIC CENTRE COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "665/2014",
    "Permit Date": "2014-08-19T05:47:50Z",
    "Meeting Number": "7/2014",
    "Meeting Date": "2014-02-19T05:48:10Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF PLASTIC BOTTLE",
    "Amount Of Foreign Capital USD (in Millions)": 0.755,
    "Total Amount Of Capital (in Millions)": 1.888,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Malaysia",
    "Form Of Investment": "JV",
    "Land Owner": "U ZAW WIN SHEIN",
    "Land Area (units not specified in file)": 5.6,
    "Lease Term": 30,
    "Annual Lease Fee": 0.136,
    "Land Use Premium": null,
    "Number Of Local Employees": 51,
    "Number Of Foreign Employees": 9,
    Status: "Approved",
    "Investor Address":
      "BUILDING NO.6, ROOM NO. 16, WARD NO. 11, LANMADAW TOWNSHIP, YANGON",
    "Organization Address":
      "NO.531, ROOM NO. 1104, YETAGON TOWER LOWER KYEEMYINDINE STREET, KYEEMYINDINE TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "PLOT NO. F8, MYAY TAING BLOCK NO. 20, AHNAWYAHTAR INDUSTRIAL ZONE, YANGON-NYAUNG TONE ROAD, HLAING THARYAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1676,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. CHINTADI SHEKHAR RAO",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "FE FOODS & BEVERAGES MYANMAR COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "028/2018",
    "Permit Date": "2018-02-13T17:30:01Z",
    "Meeting Number": "2/2018",
    "Meeting Date": "2018-01-23T17:30:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING, MARKETING, & DISTRIBUTION OF PACKAGED FOODS & BEVERAGES",
    "Amount Of Foreign Capital USD (in Millions)": 0.4,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "India",
    "Form Of Investment": "JV",
    "Land Owner": "U SOE MYINT @ KI SAI BIN @ KAIN CHON",
    "Land Area (units not specified in file)": 2.518,
    "Lease Term": 50,
    "Annual Lease Fee": 199.32,
    "Land Use Premium": null,
    "Number Of Local Employees": 215,
    "Number Of Foreign Employees": 2,
    Status: "Draft",
    "Investor Address":
      "A-2/3, NAGARKOT FLATS, KADMA JAMSHEDPUR 831 005, INDIA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.109, MYAY TAING BLOCK NO. 65 (SETHMU), SETHMU ZONE BLOCK 4, SHWEPYITHAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1678,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ရွှေဇင်နွယ်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ရွှေပုလဲသွယ်အထွေထွေရောင်းဝယ်ရေးကုမ္ပဏီလီမိတက်",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "မနသ-၁၀၂၇/၂၀၁၅",
    "Permit Date": "2015-02-04T07:02:55Z",
    "Meeting Number": "၁/၂၀၁၅",
    "Meeting Date": "2015-01-09T07:03:20Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် ဂျပန်ရိုးရာလက်မှုပညာဖြစ်သည့် ပိုးကြိုးမျာားဖြင့် ကံကောင်းစေသော ဂျပန်ရိုးရာ အဆောင်ပစ္စည်း ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.01,
    "Total Amount Of Capital (in Millions)": 140,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်ဌေးဌေးဝင်း",
    "Land Area (units not specified in file)": 0.055,
    "Lease Term": 10,
    "Annual Lease Fee": 6.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 158,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၁၆၁၊ ဦးချစ်မောင်လမ်း၊ ဆရာစံ (အနောက်/ မြောက်) ရပ်ကွက်၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်တိုင်း ဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (စီ-၆)၊ မြေတိုင်းရပ်ကွက်အမှတ် (၃၄-တိုးချဲ့)၊ ဒဂုံမြို့သစ်(မြောက်ပိုင်း) မြို့နယ်၊ ရန်ကုန်တိုင်း ဒေသကြီး",
  },
  {
    ID: 1679,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. YOUNGJAE YOO",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Y.J COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "765/2014",
    "Permit Date": "2014-08-07T07:11:52Z",
    "Meeting Number": "17/2014",
    "Meeting Date": "2014-06-20T07:12:09Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.5,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW TIN TIN SWE",
    "Land Area (units not specified in file)": 15539.94,
    "Lease Term": 10,
    "Annual Lease Fee": 0.09,
    "Land Use Premium": null,
    "Number Of Local Employees": 634,
    "Number Of Foreign Employees": 6,
    Status: "Approved",
    "Investor Address":
      "102-604, 285, YONGMASANRO, JUNGNANG-GU, SEOUL, THE REPUBLIC OF KOREA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 5, MYAY TAING BLOCK-3, HLAING THAR YAR INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1680,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U KYAW ZIN",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "CHAMPION WINNER INDUSTRY COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "012/2017",
    "Permit Date": "2017-11-09T07:23:07Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-10-25T07:23:45Z",
    Sector: "Other Services",
    "Type Of Investment Business": "PRINTING AND DESIGN ON FABRICS AND CLOTHES",
    "Amount Of Foreign Capital USD (in Millions)": 0.48,
    "Total Amount Of Capital (in Millions)": 0.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "U AUNG KYAW OO",
    "Land Area (units not specified in file)": 2.159,
    "Lease Term": 30,
    "Annual Lease Fee": 0.0122,
    "Land Use Premium": null,
    "Number Of Local Employees": 175,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "NO.78, KAN TAW STREET, LAY DAUNT KAN QUARTER, THINGANGYUN TOWNSHIP, YANGON",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 255, MYAY TAING BLOCK NO. 49, WARTAYAR INDUSTRIAL ZONE, SHWE PYI THAR TOWNSHIP , YANGON REGION",
  },
  {
    ID: 1681,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Hiromi Deguchi",
    "Name of Principal Organization": "Izumicreation Inc., ",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Dream Seed Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "859/2014",
    "Permit Date": "2014-12-09T07:27:41Z",
    "Meeting Number": "27/2014",
    "Meeting Date": "2014-11-28T07:28:03Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Toy and Accessories with Fabric on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.577,
    "Total Amount Of Capital (in Millions)": 0.577,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "U Maung Tin, U Sein Win & U Tint Wai",
    "Land Area (units not specified in file)": 0.245,
    "Lease Term": 30,
    "Annual Lease Fee": 0.006,
    "Land Use Premium": null,
    "Number Of Local Employees": 130,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address": "2605-3 Obucho, Kishiwada City, Osaka, Japan",
    "Organization Address": "2-1260 Obucho, Kishiwada City, Osaka, Japan ",
    "Investment Permitted Address":
      "Plot No. 251, Myay Taing Block No. 42, Industrial Zone, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 1684,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhang Weimin",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar Liang Yi Da Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "853/2014",
    "Permit Date": "2014-11-21T08:23:11Z",
    "Meeting Number": "26/2014",
    "Meeting Date": "2014-11-07T08:23:27Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.3,
    "Total Amount Of Capital (in Millions)": 1.3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Khin Maung Yi @ Lin Hou Sun",
    "Land Area (units not specified in file)": 2.263,
    "Lease Term": 50,
    "Annual Lease Fee": 0.092,
    "Land Use Premium": null,
    "Number Of Local Employees": 1151,
    "Number Of Foreign Employees": 18,
    Status: "Monitoring Approved",
    "Investor Address":
      "17-3-1 Kai Ming Lane, Zhong Shan District, Dalian, China 116001",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No. 74, Myay Taing Block No. 14, Shwe Than Lwin Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 1685,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr Jun Takashima",
    "Name of Principal Organization": "Leosports Pte Ltd.,",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Takashima Sports Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "820/2014",
    "Permit Date": "2014-10-20T08:36:14Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-09T08:36:32Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Sporting Gloves Mainly Composed of Leather and Fabric on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.544,
    "Total Amount Of Capital (in Millions)": 0.545,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "U Aye Min Soe, U Myat Min Thaw, U Dway Min Yan",
    "Land Area (units not specified in file)": 1.745,
    "Lease Term": 10,
    "Annual Lease Fee": 0.191,
    "Land Use Premium": null,
    "Number Of Local Employees": 109,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "58-2, Shirotori, Higashi-Kagawa City, Kagawa Pref, Japan 769027",
    "Organization Address":
      "No. 100, Jalan Sutlan, #03-45, Sultan Plaza, Singapore 199001",
    "Investment Permitted Address":
      "Plot No. 80, Myay Taing Block No. 14, Ayeyarwaddy Street, Shwe Than Lwin Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 1686,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. CHANG, YU-PIN",
    "Name of Principal Organization": "DATUM PACIFIC INC PTE. LTD",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar": "YAMANI FAR EAST  COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "030/2018",
    "Permit Date": "2018-02-14T08:49:49Z",
    "Meeting Number": "2/2018",
    "Meeting Date": "2018-01-24T08:50:14Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF HANDBAGS AND RELATED PRODUCTS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 3,
    "Total Amount Of Capital (in Millions)": 3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW MYINT MYINT AND DAW MYINT MYINT KHAING",
    "Land Area (units not specified in file)": 1.9,
    "Lease Term": 5,
    "Annual Lease Fee": 208.8,
    "Land Use Premium": null,
    "Number Of Local Employees": 141,
    "Number Of Foreign Employees": 20,
    Status: "Draft",
    "Investor Address":
      "24F,NO. 386, SHIZHENG RD, XITUN DIST., TAICHUNG CITY 407, TAIWAN, REPUBLIC OF CHINA",
    "Organization Address":
      "150 ORCHARD ROAD #06-16 ORCHARD PLAZA SINGAPORE (238841)",
    "Investment Permitted Address":
      "PLOT NO. 212, MYAY TAING BLOCK NO. INDUSTRY(1) , DAGON SEIK KAN TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1687,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Carlos Olivares Nava",
    "Name of Principal Organization":
      "United Indochina Holdings (Private) Limited",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "United Beauty Palace Myanmar Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "895/2015",
    "Permit Date": "2015-02-04T05:37:16Z",
    "Meeting Number": "1/2015",
    "Meeting Date": "2015-01-16T05:37:37Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Oral Care Products and skin care products.",
    "Amount Of Foreign Capital USD (in Millions)": 2.1,
    "Total Amount Of Capital (in Millions)": 3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "U Myo Aung and U Win Shein",
    "Land Area (units not specified in file)": 1.517,
    "Lease Term": 3,
    "Annual Lease Fee": 132,
    "Land Use Premium": null,
    "Number Of Local Employees": 332,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address": "66 United St, Mandaluyong City, Philippines 1550",
    "Organization Address":
      "152 Beach Road, #10-03/04 Gateway East, Singapore 189721",
    "Investment Permitted Address":
      "Plot No. 179, Twin Thin Tite Won U Tun Nyo Street, Hlaing Thar Yar Industrial Zone 2, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 1688,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. SANTOSH KUMAR BANTHIA",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ORIENT UMBRELLA (MYANMAR) LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "710/2014",
    "Permit Date": "2014-04-08T09:04:54Z",
    "Meeting Number": "9/2014",
    "Meeting Date": "2014-03-12T09:05:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF UMBRELLAS & PANELS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.9064,
    "Total Amount Of Capital (in Millions)": 0.9064,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "India",
    "Form Of Investment": "FDII",
    "Land Owner": "U KHIN MAUNG SANN",
    "Land Area (units not specified in file)": 0.749,
    "Lease Term": 30,
    "Annual Lease Fee": 0.017,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "147, MAHATMA GANDHI ROAD, KOLKATA-700007, INDIA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 246-M, HLAING THARYAR INDUSTRIAL ZONE NO. 2 , HLAING THARYAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1689,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. XIA , ZONGNAN",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "GUANG MING GARMENT (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "033/2018",
    "Permit Date": "2018-03-07T09:09:15Z",
    "Meeting Number": "3/2018",
    "Meeting Date": "2018-02-14T09:09:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.56,
    "Total Amount Of Capital (in Millions)": 0.56,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 26,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U TI WIN AND U MAUNG MAUNG CHEIN",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 6,
    "Annual Lease Fee": 0.053,
    "Land Use Premium": null,
    "Number Of Local Employees": 659,
    "Number Of Foreign Employees": 20,
    Status: "Draft",
    "Investor Address":
      "ROOM NO.1401 , BUILDING NO.8 , XINYI HOME, BAODI DISTRICT , TIANJIN, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 138, MYAY TAING BLOCK NO.25, SHWE LIN PAN SETHMU MYO, HLAING THAR YAR TOWNSHIP , YANGON REGION",
  },
  {
    ID: 1690,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Jacobus Johannes de Heus",
    "Name of Principal Organization": "De Heus Animal Nutrition B.V",
    "Place of Incorporation": "The Netherlands",
    "Company Name In Myanmar": "DE HEUS MYANMAR LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1044/2015",
    "Permit Date": "2015-11-19T09:10:15Z",
    "Meeting Number": "18/2015",
    "Meeting Date": "2015-10-23T09:10:38Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production and Distribution of Animal Nutrition Productions",
    "Amount Of Foreign Capital USD (in Millions)": 7.575,
    "Total Amount Of Capital (in Millions)": 7.575,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Netherlands",
    "Form Of Investment": "FDII",
    "Land Owner": " ဦးရဲအောင်",
    "Land Area (units not specified in file)": 5.51,
    "Lease Term": 3,
    "Annual Lease Fee": 111480,
    "Land Use Premium": null,
    "Number Of Local Employees": 103,
    "Number Of Foreign Employees": 1,
    Status: "Approved",
    "Investor Address": "Hertog Hendrinklaan 13a, 374DL Baarn, The Netherlands",
    "Organization Address": "Rubensstraat 175, 6717 VE EDE, The Netherlands",
    "Investment Permitted Address":
      "Plot No. 306,307,308, Myaung Dakar Steel Industrial Zone, Hmawbi Township, Yangon Region",
  },
  {
    ID: 1691,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mrs. Ka Man Lee",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Golden Precise Embroidery & Garment Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "736/2014",
    "Permit Date": "2014-06-09T09:18:34Z",
    "Meeting Number": "14/2014",
    "Meeting Date": "2014-05-14T09:18:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Embroidery and Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.494,
    "Total Amount Of Capital (in Millions)": 1.494,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Khin Htay",
    "Land Area (units not specified in file)": 1.66,
    "Lease Term": 10,
    "Annual Lease Fee": 0.038,
    "Land Use Premium": null,
    "Number Of Local Employees": 638,
    "Number Of Foreign Employees": 9,
    Status: "Monitoring Approved",
    "Investor Address":
      "House 293 Seasons Monarch 183 Kam Tin Road, Yuen Long N.T. Hong Kong",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Myay Taing Block No. 25, Plot No. 8, Shwe Lin Pan Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 1692,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Jianlin Fei",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Holly Myanmar Garments Co., Ltd.,",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "724/2014",
    "Permit Date": "2014-05-28T09:29:01Z",
    "Meeting Number": "11/2014",
    "Meeting Date": "2014-03-29T09:29:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.6,
    "Total Amount Of Capital (in Millions)": 788,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "U Lin Soe Linn @ U Soe Linn",
    "Land Area (units not specified in file)": 1.69,
    "Lease Term": 10,
    "Annual Lease Fee": 76800000,
    "Land Use Premium": null,
    "Number Of Local Employees": 354,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "1-F, Room 1806, Jianghi Ming Yuan Chongchuan District, Nantong, China",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No. 133, Myay Taing Block No. 25, Shwe Lin Pan Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 1693,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. CHEUNG KWOK ON",
    "Name of Principal Organization":
      "ORIENTIAL PEAK INDUSTRIAL COMPANY LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ORIENTAL PEAK INDUSTRIAL COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "034/2018",
    "Permit Date": "2018-03-07T09:22:18Z",
    "Meeting Number": "3/2018",
    "Meeting Date": "2018-02-14T09:22:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF BAGS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U KHIN MAUNG WIN",
    "Land Area (units not specified in file)": 2.39,
    "Lease Term": 10,
    "Annual Lease Fee": 0.068,
    "Land Use Premium": null,
    "Number Of Local Employees": 267,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address":
      "G/F., DD19 LOT 207SA, TONG MIN T TONG MIN TSUEN, LAM TSUEN, NEW TERRITORIES, HONG KONG",
    "Organization Address":
      "G/F., DD19 LOT 207SA, TONG MIN T TONG MIN TSUEN , LAM TSUEN , NEW TERRITORIES, HONG KONG",
    "Investment Permitted Address":
      "PLOT NO. D 4,  MYAY TAING BLOCK NO. 21, MYA SEIN YAUNG INDUSTRIAL ZONE , HLAING THAR YAR   TOWNSHIP, YANGON REGION   ",
  },
  {
    ID: 1694,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဉာဏ်လင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ရှမ်းမောမြေကုန်ထုတ်လုပ်ငန်းကုမ္ပဏီလီမိတက်",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "မနသ-၁၀၂၉/၂၀၁၅",
    "Permit Date": "2015-02-02T09:18:09Z",
    "Meeting Number": "1/2015",
    "Meeting Date": "2015-01-16T09:18:50Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီ စက္ကူပန်း၊ စက္ကူ ကြိုးဖြင့် စာအိတ်အလှဆင်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 309.31,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအောင်ဇေယျ",
    "Land Area (units not specified in file)": 0.238,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၉၃၊ (၇) လွှာ၊ ဗိုလ်ချုပ်လမ်း၊ ပုဇွန်တောင်မြို့ နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၂၂၉၊ မြေတိုင်းရပ်ကွက်အမှတ် ၄၂၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1695,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. ZHANG , YE",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "IMPAK GEAR MYANMAR LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "035/2018",
    "Permit Date": "2018-03-07T09:38:56Z",
    "Meeting Number": "3/2018",
    "Meeting Date": "2018-02-14T09:39:23Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF HANDBAGS & LUGGAGE ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.511,
    "Total Amount Of Capital (in Millions)": 0.511,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U AYE THAUNG",
    "Land Area (units not specified in file)": 4.028,
    "Lease Term": 5,
    "Annual Lease Fee": 0.14,
    "Land Use Premium": null,
    "Number Of Local Employees": 659,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address":
      "ROOM 1202, LANE 600 MARTIAL ARTS HOUSE 2, ZHONGSHAN ROAD , HANGZHOU, ZHEJIANG PROVINCE, PEOPLE'S REPUBLIC OF CHINA ",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO, (203+215), MYAY TAING BLOCK NO. 49, WARTAYAR INDUSTRIAL ZONE, SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1696,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw Khin Thuzar Htun",
    "Name of Principal Organization": "CK FROZEN FISH & FOOD  COMPANY LIMITED",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "CK FROZEN FOODS YANGON COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1098/2016",
    "Permit Date": "2016-03-24T09:43:43Z",
    "Meeting Number": "8/2016",
    "Meeting Date": "2016-03-04T09:44:13Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "Manufacturing of Preserving, Freezing, Packaging and selling Fish, Prawn and Dried Fish Through Normal System and  Fish Through Contract Processing System  (Normalစနစ်ဖြင့် ငါး၊ ပုစွန်နှင့် ငါးခြောက်တို့ ကို လည်းကောင်း၊ Contract Processing စနစ်ဖြင့် ငါးကို လည်းကောင်း ပြုပြင်အေးခဲ ထုတ်ပိုးပြီး ရောင်းချခြင်း လုပ်ငန်း)",
    "Amount Of Foreign Capital USD (in Millions)": 5,
    "Total Amount Of Capital (in Millions)": 6.25,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Khin Thuzar Tun",
    "Land Area (units not specified in file)": 2.492,
    "Lease Term": 15,
    "Annual Lease Fee": 21600000,
    "Land Use Premium": null,
    "Number Of Local Employees": 155,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "Building No. 94, Room No. 3,5th Meedon Lane, Thuwunna, Thingangyun township, Yangon",
    "Organization Address":
      "No. 3/D/1, U Tun Nyo Street, Industrial Zone (6), Hlaing Tharyar Township, Yangon Region",
    "Investment Permitted Address":
      "Plot No. 181, Myay Taging Block No. Industrial Zone (1)113, Dagon Myothit (East)Township, Yangon Region",
  },
  {
    ID: 1697,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဇော်ဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ကွာလတီအပရယ်လ် ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "မနသ-၁၀၀၄/၂၀၁၄",
    "Permit Date": "2014-10-31T09:49:56Z",
    "Meeting Number": "၂၄/၂၀၁၄",
    "Meeting Date": "2014-10-17T09:50:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 100,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးနေဝင်း (ခ) ဦးတင်စိန်",
    "Land Area (units not specified in file)": 2.176,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၂၂၊ ဒုတိယထပ်၊ (၁၈) လမ်း၊ လသာမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၊ မြေတိုင်းရပ်ကွက်အမှတ် ၂၅၊ ပန်း တဉ်းဝန်ဦးရွှေဘင်လမ်း၊ ရွှေလင်ပန်းစက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1698,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U  KHIN MAUNG  AYE  ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "LEADER ONE  (MYANMAR)  LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "913/2015",
    "Permit Date": "2015-03-10T04:33:12Z",
    "Meeting Number": "3/2015",
    "Meeting Date": "2015-02-27T04:33:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENTS ON CMP  BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 4.5,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "Textile Enterprise, Ministry of Industry",
    "Land Area (units not specified in file)": 15.84,
    "Lease Term": 30,
    "Annual Lease Fee": 0.33,
    "Land Use Premium": null,
    "Number Of Local Employees": 3125,
    "Number Of Foreign Employees": 30,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.96, HNIN SI GONE STREET, SAW YAN PAING EAST WARD, AHLONE TOWNSHIP, YANGON",
    "Organization Address": "",
    "Investment Permitted Address":
      "FORMER THANLYIN TILE FACTORY, ALWANSOOT VILLAGE, PAYAKONE VILLAGE TRACT, THANLYIN TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1699,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမြင့်ဌေး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ယူအမ်(မ်) အိချ် ကုမ္ပဏီလီမီတက် (UMH COMPANY LIMITED)",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "017/2017",
    "Permit Date": "2017-12-04T04:25:22Z",
    "Meeting Number": "7/2017",
    "Meeting Date": "2017-11-22T04:25:59Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "UPVC တံခါးကျည်းဘောင်ထုတ်လုပ်ရောင်းချခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 5796.34,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးမြင့်ဌေး",
    "Land Area (units not specified in file)": 1.099,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 71,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "အမှတ်(၃၇/အယ်လ်)၊ စည်ပင်သာယာလမ်းသွယ်၊ မြစံပယ်ရိပ်သာ၊ ပါရမီလမ်း၊ မရန်းကုန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၂၈/ခ၊ မြေတိုင်းရပ်ကွက် အမှတ်၅၃၈/က၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1700,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "DAW KHAINE ZAW",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "EARTH INDUSTRIAL (MYANMAR) CO., LTD.",
    "Financial Year From": 97,
    "Financial Year To": 98,
    "Permit Number": "093/97",
    "Permit Date": "1997-10-20T04:51:27Z",
    "Meeting Number": "15/97",
    "Meeting Date": "1997-09-12T04:52:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF ELECTRONIC AND ELECTRICAL COMPONENTS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 52.34,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "NO. 40, INYA ROAD, KAMARYUT TOWNSHIP, YANGON",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 475, MYAY TAING BLOCK NO. 23, INDUSTRIAL ZONE, DAGON MYOTHIT (SOUTH), YANGON REGION",
  },
  {
    ID: 1701,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS. HSIUNG, HUI-CHUAN",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "LINDA & JOE'S INTERNATIONAL COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "036/2018",
    "Permit Date": "2018-03-21T04:53:48Z",
    "Meeting Number": "4/2018",
    "Meeting Date": "2018-03-07T04:54:29Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.784,
    "Total Amount Of Capital (in Millions)": 0.784,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 23,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "FDII",
    "Land Owner": "U KHIN @ U KYAW KHIN ",
    "Land Area (units not specified in file)": 0.333,
    "Lease Term": 3,
    "Annual Lease Fee": 0.022,
    "Land Use Premium": null,
    "Number Of Local Employees": 303,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "NO.2 OF 3rd FLOOR, NO.5 OF LANE 142, TAIDE ROAD, BADE DISTRICT, TAOYUAN CITY, TAIWAN, REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 44, MYAY TAING BLOCK NO. 19/2, SHWE PAUK KAN SETHMU, NORTH OKKALAPA TOWNSHIP , YANGON REGION",
  },
  {
    ID: 1703,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Khin Maung Htwe",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "L & Z MARINE PRODUCTS LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1253/2017",
    "Permit Date": "2017-05-25T05:29:06Z",
    "Meeting Number": "7/2017",
    "Meeting Date": "2017-04-28T05:29:22Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "Contract Processing နှင့် Normal System (၂)မျိုးဖြင့် ရေချို၊ ရေငန် ငါး၊ ပုစွန် ပြုပြင်ထုတ်လုပ်ခြင်းနှင့် ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 3453.163,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Myint Myint Saw and U Myint Kyaw Oo",
    "Land Area (units not specified in file)": 2.631,
    "Lease Term": 50,
    "Annual Lease Fee": 47.661,
    "Land Use Premium": null,
    "Number Of Local Employees": 255,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "No. 448/450,7 Floor, Merchant Road, 8 Ward, ",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 203,206, Industrial Zone (1), Dagon Seikkan Township, Yangon Region",
  },
  {
    ID: 1704,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U MIN MIN ZAW",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Shan International Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "1252/2017",
    "Permit Date": "2017-05-25T06:31:22Z",
    "Meeting Number": "7/2017",
    "Meeting Date": "2017-04-28T06:31:39Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "Normal System ဖြင့် တန်ဘိုးမြှင့် ရေချို၊ ရေငန် ငါး၊ ပုစွန် ပြုပြင် ထုတ်လုပ်ခြင်းနှင့် ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 3553.113,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Min Min Zaw",
    "Land Area (units not specified in file)": 1.9,
    "Lease Term": 50,
    "Annual Lease Fee": 23.067,
    "Land Use Premium": null,
    "Number Of Local Employees": 220,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "No. 482, 5th Floor, Thein Phyu Road, Phoe Myay Ward, ",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plto No. 413, Myay Taing Block No. YaLaPa-25, Shwe Lin Ban Industrial Zone, Hlaingtharya Township, Yangon",
  },
  {
    ID: 1708,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Moe Win",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "TV  Apparel Co., Ltd. (တီဗွီအဖဲရို ကုမ္ပဏီ လီမိတက်)",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "MaNaTha-986/2014",
    "Permit Date": "2014-07-01T07:02:56Z",
    "Meeting Number": "16/2014",
    "Meeting Date": "2014-06-13T07:03:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.32,
    "Total Amount Of Capital (in Millions)": 521.01,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Than Than Htay",
    "Land Area (units not specified in file)": 1.665,
    "Lease Term": 10,
    "Annual Lease Fee": 6,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် (၃၀၄/ခ) ၊ အမှတ် (၄) လမ်းမကြီး၊ ရွှေပြည်သာမြို့နယ် ၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး ၊ မြောက်ပိုင်းခရိုင်၊ ရွှေပြည်သာမြို့နယ် ၊ မြေတိုင်းရပ်ကွက်မှတ်-၄၂(စက်မှုဇုန်)၊ မြေကွက်အမှတ် (၃၀၄/ခ) ရှိမြေ (၁.၆၆၅) ဧက",
  },
  {
    ID: 1709,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Qiao Liang",
    "Name of Principal Organization": "Handa Industries Limited",
    "Place of Incorporation": "United Kingdom",
    "Company Name In Myanmar": "HANDA  (YANGON)  GARMENT  COMPANY  LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "891/2015",
    "Permit Date": "2015-02-04T07:05:44Z",
    "Meeting Number": "1/2015",
    "Meeting Date": "2015-01-16T07:06:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENTS ON CMP  BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.0296,
    "Total Amount Of Capital (in Millions)": 1.0296,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "United Kingdom of Great Britain and Northern Ireland",
    "Form Of Investment": "FDII",
    "Land Owner": "U Pyae Phyo Kyaw",
    "Land Area (units not specified in file)": 1.704,
    "Lease Term": 20,
    "Annual Lease Fee": 0.0601,
    "Land Use Premium": null,
    "Number Of Local Employees": 1356,
    "Number Of Foreign Employees": 44,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.49, Qian Gieco Quarter, Jiang Su State, Xu Xi City, Bei Jie Zhan, Tao Xin Chun China, Hui Shan T/S, People Republic of China",
    "Organization Address":
      "Flat/RM 703, 7/F Dannies House 20, Luard Road, Wanchai, Hongkong.",
    "Investment Permitted Address":
      "PLOT NO. 288, MYAY TAING BLOCK NO. 25, SHWE LIN PAN INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON  REGION",
  },
  {
    ID: 1710,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "DAW YI YI TUN",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Kaung Wai & Sister Manufacturing Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "869/2012",
    "Permit Date": "2012-11-23T07:11:44Z",
    "Meeting Number": "24/2012",
    "Meeting Date": "2012-08-08T07:12:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ဆောက်လုပ်ရေးလုပ်ငန်းသုံးဓါတုဗေဒဆေးပစ္စည်းများ ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.517,
    "Total Amount Of Capital (in Millions)": 500,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်ချွင်းရင်",
    "Land Area (units not specified in file)": 0.277,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၇၈/၈၂၊ အခန်း (၅၀၁)၊ ၅ လွှာ၊ ဗိုလ်တထောင်စျေးလမ်း၊ ဗိုလ်တထောင်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေတိုင်းရပ်ကွက်အမှတ်-၁၈၊ မြေကွက်အမှတ် - ၁၂၉၊ ၁၃၉၊ ၁၄၀၊ ရွှေပေါက်ကံစက်မှုဇုန်၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1711,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဟန်ရုံရှန်း",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Myanmar Typical Production Co., Ltd. (မြန်မာ စံနမူနာပြု ထုတ်လုပ်ရေး ကုမ္ပဏီ လီမိတက်)",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "Ma Na Tha-974/2014",
    "Permit Date": "2014-06-25T08:02:26Z",
    "Meeting Number": "15/2014",
    "Meeting Date": "2014-05-31T08:02:42Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ဆောက်လုပ်ရေးလုပ်ငန်းသုံး သံမဏိချောင်းများ နှင့် Angle Iron များထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 3.81,
    "Total Amount Of Capital (in Millions)": 4300,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 6.992,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Amend",
    "Investor Address":
      "အမှတ်(၁၅၈) ၊ သစ္စာလမ်၊ (၁၂) ရပ်ကွက်၊ ရန်ကင်းမြို့နယ် ၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "-",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး ၊မှော်ဘီမြို့နယ် ၊ မြောင်းတကာ သံမဏိစက်မှုဇုန် ၊ မြေကွက်အမှတ် (၅၀၊ ၅၁၊၆၀) ရှိမြေ ဧရိယာ (၆.၉၉၂) ဧက",
  },
  {
    ID: 1712,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. HING  MAN  TSE  ",
    "Name of Principal Organization": "TAI LIANG INDUSTRIES LIMITED",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "SUNAN  HUNG  TAK  APPAREL  LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "874/2014",
    "Permit Date": "2014-12-15T08:08:46Z",
    "Meeting Number": "28/2014",
    "Meeting Date": "2014-12-12T08:09:06Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENTS ON CMP  BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 2.19,
    "Total Amount Of Capital (in Millions)": 2.19,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Yin Maung Thein, Daw Yone Ann @ Myint Kyi",
    "Land Area (units not specified in file)": 2.438,
    "Lease Term": 30,
    "Annual Lease Fee": 0.06575,
    "Land Use Premium": null,
    "Number Of Local Employees": 865,
    "Number Of Foreign Employees": 21,
    Status: "Monitoring Approved",
    "Investor Address":
      "FLAT E, 7/F, BLOCK 2, SCENERY COURT, SHA TIN, N.T., HONG KONG",
    "Organization Address":
      "ROOM B, 1/F, WING CHEONG FACTORY BUILDING, 121 KING LAM STREET, CHEUNG SHA WAN, KOWLOON, HONG KONG",
    "Investment Permitted Address":
      "PLOT NO. 37, MYAY TAING BLOCK NO. 25, SHWE LIN PAN INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON  REGION",
  },
  {
    ID: 1715,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U  NYEIN  AUNG ",
    "Name of Principal Organization":
      "MYANMAR  INTEGRATED  COMMUNICATION  TRADING  CO., LTD.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "K-WON  &   MICC  COMPANY  LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "805/2014",
    "Permit Date": "2014-10-13T09:49:12Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T09:49:51Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENTS  ON CMP  BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.6,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "JV",
    "Land Owner": "Textile Enterprise, Ministry of Industry",
    "Land Area (units not specified in file)": 3.48,
    "Lease Term": 10,
    "Annual Lease Fee": 44,
    "Land Use Premium": null,
    "Number Of Local Employees": 1265,
    "Number Of Foreign Employees": 8,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 405,  MERCHANT  ROAD,  THAYETTAW (SOUTH)  WARD, KYEEMYINDAING  TOWNSHIP, YANGON",
    "Organization Address":
      "NO. 405,  MERCHANT  ROAD,  THAYETTAW (SOUTH) WARD, KYEEMYINDAING  TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "INSEIN  BLANKET  FACTORY NO. 20 (BRANCH) (FORMER YGM), INSEIN-MINGALARDON ROAD, AUNG  SAN  MYO,  INSEIN  TOWNSHIP,  YANGON  REGION",
  },
  {
    ID: 1717,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. CHIO KUAI CHENG",
    "Name of Principal Organization": "LUCKY STAR  KNITTING FACTORY LIMITED, ",
    "Place of Incorporation": "Macao",
    "Company Name In Myanmar": "STAR TEAM MANUFACTURING COMPANY  LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "845/2014",
    "Permit Date": "2014-10-31T10:31:54Z",
    "Meeting Number": "24/2014",
    "Meeting Date": "2014-10-17T10:32:24Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF KNITTED SWEATERS ON CMP BASIS ",
    "Amount Of Foreign Capital USD (in Millions)": 5.473,
    "Total Amount Of Capital (in Millions)": 5.473,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Macao",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myo Khine ",
    "Land Area (units not specified in file)": 1.129,
    "Lease Term": 30,
    "Annual Lease Fee": 0.036,
    "Land Use Premium": null,
    "Number Of Local Employees": 671,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address": "RUG NAM KENG, FLOWER CITY, LEI-MOU 11 AA, MACAU ",
    "Organization Address": " NOS.181-187, JARDIM BRILHANTISMO B9, MACAU",
    "Investment Permitted Address":
      "PLOT NO. 4, U SHWE MYU STREET, HLAING THAR YAR INDUSTRIAL ZONE(1), HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1718,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးထွန်းထွန်းဝင်း (ခ) ဗီနိုကူးမား",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Shwe Ayer Nadi Ltd. (ရွှေဧရာနဒီ လီမိတက်)",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "Ma Na Tha-980/2014 ",
    "Permit Date": "2014-05-28T04:09:29Z",
    "Meeting Number": "12/2014",
    "Meeting Date": "2014-04-10T04:09:51Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ခေါင်းလျှော်ရည် နှင့် ဆပ်ပြာ အမျိုးမျိုးထုတ်လုပ်ရောင်းချခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": 4.12,
    "Total Amount Of Capital (in Millions)": 4614,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 20,
    "Annual Lease Fee": 28.8,
    "Land Use Premium": null,
    "Number Of Local Employees": 200,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် (၇၁၅)၊ ဒုတိယအထပ်၊ ကုန်သည်လမ်း၊ ပန်းဘဲတန်းမြို့နယ်၊ ရန်ကုန်",
    "Organization Address": "-",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး ၊ ရွှေပြည်သာမြို့နယ်၊ စက်မှုဇုန် ၊ မြေတိုင်းရပ်ကကွက်အမှတ်(၄၂) ၊ မြေကွက်အမှတ် ၁၁၆/A/3 ရှိ မြေ( ၄.၆၈၂) ဧကအနက် (၁.၀၀) ဧက",
  },
  {
    ID: 1719,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS.  Wu- I, Shih",
    "Name of Principal Organization": "EASY BONANZA  INT’L LTD.",
    "Place of Incorporation": "BRUNEI DARUSSALAM",
    "Company Name In Myanmar": "MILA GARDEN COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "775/20014",
    "Permit Date": "2014-08-14T04:38:01Z",
    "Meeting Number": "17/2014",
    "Meeting Date": "2014-06-20T04:39:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF FOOTWEAR PRODUCTS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 4.1,
    "Total Amount Of Capital (in Millions)": 4.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Brunei Darussalam",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Win May",
    "Land Area (units not specified in file)": 3.77,
    "Lease Term": 10,
    "Annual Lease Fee": 0.076,
    "Land Use Premium": null,
    "Number Of Local Employees": 1626,
    "Number Of Foreign Employees": 30,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 8, JINHUA ROAD, NORTH DIST, TAICHUNG CITY 404, TAIWAN",
    "Organization Address":
      "ROOM 51, 5th FLOOR, BRITANNIA, JALAN CATOR BANDAR SERI BEGAWAN BS 8811 NEGARA BRUNEI DARUSSALAM",
    "Investment Permitted Address":
      "KWIN NO.1038, PLOT NO.14/1,14/2,14/3,14/4,14/5,39/6, HNGETPYAWTAW KWIN, PYITAWTHAR VILLAGE, HLEGU TOWNSHIP,YANGON REGION ",
  },
  {
    ID: 1721,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်လွင်လွင်ပြုံး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "အမ်ဘီကေကုမ္ပဏီလီမီတက် (MBK COMPANY LIMITED)",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "018/2017",
    "Permit Date": "2017-12-04T05:56:22Z",
    "Meeting Number": "7/2017",
    "Meeting Date": "2017-11-22T05:56:36Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "သွပ်အမျိုးမျိူး ထုတ်လုပ်ရောင်းချခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1626.99,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်လွင်လွင်ပြုံး",
    "Land Area (units not specified in file)": 2.292,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 65,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "အမှတ် ဃ-၂၃၊ ကြံခိုင်ရေးလမ်း၊ နယ်မြေ-၁၂၊ ပြည်တော်သာရပ်ကွက်၊ တောင်ကြီးမြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၂၄၁/၂၊ မြေတိုင်းရပ်ကွက် အမှတ်- ရန်ကုန်စက်မှုဇုန်၊ မင်္ဂလာဒုံမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1722,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးခန့်နိုင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ဂိုးဒင်း(န်) ကေတီကေကုမ္ပဏီလီမီတက် (GOLDEN KTK COMPANY LIMITED)",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "019/2017",
    "Permit Date": "2017-12-20T06:23:09Z",
    "Meeting Number": "8/2017",
    "Meeting Date": "2017-12-04T06:23:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMPစနစ်ဖြင့်အ၀တ်အထည်အမျိုးမျိုးချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1295.89,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးခန့်နိုင်+ဒေါ်ခိုင်သင်းကြည်",
    "Land Area (units not specified in file)": 0.516,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 224,
    "Number Of Foreign Employees": 1,
    Status: "Draft",
    "Investor Address":
      "အမှတ်(၈၆) နှင်းဆီလမ်း၊ ၃၀ရပ်ကွက်၊ သု၀ဏ္ဏ၊သင်္ဃန်းကျွန်းမြို့နယ် ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် -၁၈၀၊၁၈၁၊ မြေတိုင်းရပ်ကွက်အမှတ် ၁၄၄ စက်မှုဇုန်၊ဒဂုံမြို့သစ်တောင်ပိုင်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1725,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. CAO, RENHUI",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MEIER GLOBAL MYANMAR COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "029/2018",
    "Permit Date": "2018-02-14T08:23:24Z",
    "Meeting Number": "2/2018",
    "Meeting Date": "2017-01-24T08:23:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.36,
    "Total Amount Of Capital (in Millions)": 1.36,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U THAN SOE , U ZAW WIN @ KHINE ZAW AND U KHIN MAUNG",
    "Land Area (units not specified in file)": 2.032,
    "Lease Term": 10,
    "Annual Lease Fee": 0.047,
    "Land Use Premium": null,
    "Number Of Local Employees": 1459,
    "Number Of Foreign Employees": 23,
    Status: "Draft",
    "Investor Address":
      "NO.163, WANGJIATUN, DENGSHAHE, JINZHOU DISTRICT, DALIAN, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 126,  MYAY TAING BLOCK NO. 65 INDUSTRIAL 4, SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1726,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Yasunobu Miyanaga",
    "Name of Principal Organization": "HTR Management Ltd",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "HTS Myanmar Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "964/2015",
    "Permit Date": "2015-06-10T08:07:45Z",
    "Meeting Number": "7/2015",
    "Meeting Date": "2015-04-28T08:07:59Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Automobile Maintenance and Repair Services",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "U Aung Moe Kyaw",
    "Land Area (units not specified in file)": 0.175,
    "Lease Term": 10,
    "Annual Lease Fee": 12,
    "Land Use Premium": null,
    "Number Of Local Employees": 28,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address": "Kawarai-cho, Kuki City, Saitama Perfecture",
    "Organization Address": "Kawarai-cho, Kuki City, Saitama Perfecture",
    "Investment Permitted Address":
      "No.5, Thirimon 10th Street, Thirimon 1 Quarter, Mayangone Township, Yangon",
  },
  {
    ID: 1727,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.  KWAN  WAI  HUNG",
    "Name of Principal Organization": "PIONEER  EMBROIDERY FACTORY",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "PIONEER  RWT  MANUFACTURING  CO.,  LTD.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "694/2014",
    "Permit Date": "2014-03-28T08:16:47Z",
    "Meeting Number": "7/2014",
    "Meeting Date": "2014-02-19T08:17:09Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING  OF  GARMENTS  AND EMBROIDERY  ON  CMP  BASIS ",
    "Amount Of Foreign Capital USD (in Millions)": 5.72,
    "Total Amount Of Capital (in Millions)": 8.8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Myint Myint Win @ Chan Wu Lin",
    "Land Area (units not specified in file)": 1.318,
    "Lease Term": 10,
    "Annual Lease Fee": 0.024,
    "Land Use Premium": null,
    "Number Of Local Employees": 220,
    "Number Of Foreign Employees": 3,
    Status: "Approved",
    "Investor Address":
      "HOUSE 293, SEASONS MONARD, 183 KAM TIM ROAD, YUAN LONG N.T, HONG  KONG",
    "Organization Address":
      "FLAT/ RM 02, 12/F, YUEN  SHING IND BLDG, 1033 YEE KUK WEST ST, KOWLOON, HONG  KONG      ",
    "Investment Permitted Address":
      "MYAY  TAING  BLOCK NO. 25, PLOT  NO. 159,  MIN GYI MAHAR MIN GAUNG  STREET,  SHWE  LIN PAN   INDUSTRIAL  ZONE  , HLAING  THAR  YAR TOWNSHIP,  YANGON  REGION",
  },
  {
    ID: 1728,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးစောနိုင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ယန်းယူနိုက်တက်ဂရုပ် ကုမ္ပဏီလီမီတက် (YANG UNITED GROUP COMPANY LIMITED)",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "031/2018",
    "Permit Date": "2018-02-14T09:06:06Z",
    "Meeting Number": "2/2018",
    "Meeting Date": "2018-01-23T09:06:44Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "ဟိုတယ်၀န်ဆောင်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 3000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးစောနိုင်",
    "Land Area (units not specified in file)": 0.161,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 220,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "အမှတ်(၆၈/၇၀)၊ ဗဟိုလမ်း၊စမ်းချောင်း/တောင်ရပ်ကွက်၊စမ်းချောင်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၂၉၊ မြေတိုင်းရပ်ကွက်အမှတ်-၂၇-စီ-၃၊ စမ်းချောင်းမြို့နယ်, ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1729,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Thaung Su Nyein ",
    "Name of Principal Organization": "Information Matrix Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "IM Ringier Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1081/2016",
    "Permit Date": "2016-02-04T09:11:10Z",
    "Meeting Number": "2/2016",
    "Meeting Date": "2016-01-22T09:11:25Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Web Portal",
    "Amount Of Foreign Capital USD (in Millions)": 0.681,
    "Total Amount Of Capital (in Millions)": 1.695,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Switzerland",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Than Than Nwet",
    "Land Area (units not specified in file)": 500,
    "Lease Term": 10,
    "Annual Lease Fee": 18,
    "Land Use Premium": null,
    "Number Of Local Employees": 12,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.520 C/6A, Kabaraye Pagoda Road, Koemin Koechin Ward, Bahan Township, Yangon",
    "Organization Address":
      "Building E ,1st Floor, Diamond Condo, No.497, Pyay Road, Kamaryut Township, Yangon Region",
    "Investment Permitted Address":
      "Building E ,1st Floor, Diamond Condo, No.497, Pyay Road, Kamaryut Township, Yangon Region",
  },
  {
    ID: 1730,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS. YANG, HUI-CHING",
    "Name of Principal Organization": "DREAMSTAR GLOBAL LIMITED",
    "Place of Incorporation": "BRITISH VIRGIN ISLAND",
    "Company Name In Myanmar": "MYANMAR KAI SHING FOOD COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "032/2018",
    "Permit Date": "2018-03-07T09:22:51Z",
    "Meeting Number": "3/2018",
    "Meeting Date": "2018-02-14T09:23:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "PRODUCTION AND DISTRIBUTION OF SOY BEAN & RELATED PRODUCTS FOR ANIMALS FEED",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "FDII",
    "Land Owner": "U HOKE HUA@ U AUNG KYAW OO",
    "Land Area (units not specified in file)": 4.277,
    "Lease Term": 50,
    "Annual Lease Fee": 18.391,
    "Land Use Premium": null,
    "Number Of Local Employees": 49,
    "Number Of Foreign Employees": 3,
    Status: "Amend",
    "Investor Address":
      "3F-2, NO.3, IN.9, LUOYANG RD, DOULIU CITY, YUNLIN COUNTRY 640,TAIWAN",
    "Organization Address":
      "P.O BOX 438, ROAD TOWN, TORTOLA, BRITISH VIRGIN ISLANDS ",
    "Investment Permitted Address":
      "PLOT NO. 117, MYAY TAING BLOCK NO. 49, WARTAYAR INDUSTRIAL ZONE, SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1731,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr, Yeh, Wei-Chao",
    "Name of Principal Organization": "Merryearn International Ltd.",
    "Place of Incorporation": "British Virgin Islands ",
    "Company Name In Myanmar": "Joylink International Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "707/2014",
    "Permit Date": "2014-05-28T09:33:43Z",
    "Meeting Number": "10/2014",
    "Meeting Date": "2014-03-19T09:34:04Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Horse Riding and Relative Fabric Dress and Accessories on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.89,
    "Total Amount Of Capital (in Millions)": 1.89,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Virgin Islands (British)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myat Lin",
    "Land Area (units not specified in file)": 0.99,
    "Lease Term": 50,
    "Annual Lease Fee": 0.02,
    "Land Use Premium": null,
    "Number Of Local Employees": 866,
    "Number Of Foreign Employees": 8,
    Status: "Approved",
    "Investor Address":
      "3F, No. 106-3, Lane 26, Sec 1, Jhangsin Rd., Changhua City, Changhua County 50053, Taiwan, Republic of China",
    "Organization Address":
      "P.O.Box 957, Offshore Incorporations Centre, Road Town, Tortola, British Virgin Islands ",
    "Investment Permitted Address":
      "Plot No. 5/2, 5/3, 5/7, 594-A, Wa Net Chaung Village Tract, Hmawbi Township, Yangon Region",
  },
  {
    ID: 1732,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Michael Bui Phin",
    "Name of Principal Organization": "Valentis Group Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Titeline Valentis Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1086",
    "Permit Date": "2016-02-17T09:46:49Z",
    "Meeting Number": "3/2016",
    "Meeting Date": "2016-01-30T09:47:17Z",
    Sector: "Mining",
    "Type Of Investment Business":
      "Providing of Drilling Services to the Mining Industry",
    "Amount Of Foreign Capital USD (in Millions)": 26.74,
    "Total Amount Of Capital (in Millions)": 26.74,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 10,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Australia",
    "Form Of Investment": "FDII",
    "Land Owner": "U La Min Win",
    "Land Area (units not specified in file)": 0.425,
    "Lease Term": 10,
    "Annual Lease Fee": 7.8,
    "Land Use Premium": null,
    "Number Of Local Employees": 46,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "6 Yangalla Street, Marsfield Sydney NSW 2122, Australia",
    "Organization Address":
      "Plot No. C4, Thazin (1) Street, Hlaing Yadanar Housing, Hlaing Township, Yangon",
    "Investment Permitted Address":
      "Plot No. C4, Thazin (1) Street, Hlaing Yadanar Housing, Hlaing Township, Yangon Region and Plot No. 3, Myay Taing Block No. A-1-Ka, Kankauk Quarter, Chanayetharzan Township, Mandalay Region",
  },
  {
    ID: 1733,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yoshihiko Hismatsu",
    "Name of Principal Organization": "Goshu Kohsan Co., Ltd.",
    "Place of Incorporation": "Thailand",
    "Company Name In Myanmar": "Goshu-A1 ECO Business Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "934",
    "Permit Date": "2015-05-15T10:49:15Z",
    "Meeting Number": "7/2015",
    "Meeting Date": "2015-04-28T10:49:34Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Laboratory Testing, Consulting, Supply and Installation of Machinery and Equipment and Maintenance Services for Water and Waste Water Treatment Plant",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "U Yan Win, U Kyaw Tint",
    "Land Area (units not specified in file)": 1.2,
    "Lease Term": 30,
    "Annual Lease Fee": 0.0245,
    "Land Use Premium": null,
    "Number Of Local Employees": 10,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address":
      "374, 7- Chome, Nishi- Gotanda, Shinagawa-Ku, Tokyo, Japan",
    "Organization Address":
      "70 MOO 5 Kingkaew Road, Rachatheva, Bangphli, Samutprakarn 10540, Thailand",
    "Investment Permitted Address":
      "Plot No. 19, Yangon Industrial Zone, North Okkalapa Township, Yangon Region",
  },
  {
    ID: 1734,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. ZHANG ACHAO",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "HUAXIN TIMES TEXTILE AND CLOTHING  COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "050/2018",
    "Permit Date": "2018-05-23T03:47:03Z",
    "Meeting Number": "7/2018",
    "Meeting Date": "2018-05-23T03:47:22Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS ",
    "Amount Of Foreign Capital USD (in Millions)": 1.569,
    "Total Amount Of Capital (in Millions)": 1.569,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U KHIN HTWAY",
    "Land Area (units not specified in file)": 1.211,
    "Lease Term": 10,
    "Annual Lease Fee": 0.072,
    "Land Use Premium": null,
    "Number Of Local Employees": 500,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address":
      "BUILDING 96 B1 FLOOR, MAJIAPYU ROAD BEIJING FENGTAI DISTRICT, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.116, MYAY TAING BLOCK NO. 4, INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP , YANGON REGION",
  },
  {
    ID: 1735,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. ZENG, CHUIJUN",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "HANSON GARMENT MANUFACTURING COMPANY LIMITED ",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "038/2018",
    "Permit Date": "2018-03-21T04:01:41Z",
    "Meeting Number": "4/2018",
    "Meeting Date": "2018-03-07T04:02:05Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.488,
    "Total Amount Of Capital (in Millions)": 0.488,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U PHYO WAI WIN",
    "Land Area (units not specified in file)": 1.562,
    "Lease Term": 10,
    "Annual Lease Fee": 0.055,
    "Land Use Premium": null,
    "Number Of Local Employees": 604,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "FENGKOU FORMATION, YANSHAN VILLAGE, YANSHAN TOWNSHIP, DONGKOU COUNTRY, HUNAN PROVINCE, PEOPLE'S OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.339, MYAY TAING BLOCK NO. YA LA PA- 25, SHWE LIN PAN INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP , YANGON REGION",
  },
  {
    ID: 1736,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS. HUANG LIJUN",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "GLOBAL WEALTH INTERNATIONAL LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "039/2018",
    "Permit Date": "2018-03-21T04:18:12Z",
    "Meeting Number": "4/2018",
    "Meeting Date": "2018-03-07T04:21:11Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF BAGS, HANDBAGS AND WALLETS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.202,
    "Total Amount Of Capital (in Millions)": 1.202,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW SAN SAN WIN @ DAW SAN WIN",
    "Land Area (units not specified in file)": 2.656,
    "Lease Term": 10,
    "Annual Lease Fee": 0.054,
    "Land Use Premium": null,
    "Number Of Local Employees": 581,
    "Number Of Foreign Employees": 20,
    Status: "Draft",
    "Investor Address":
      "NO.28, GROUP 4, TIAN GONE ESTATE, CHENGJIA TOWN, GONGJIN  DISTRICT, ZIGONG CITY, SI CHUAN , PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 39, MYAY TAING BLOCK NO. 50, THAR DU KAN INDUSTRIAL ZONE, SHWE PYI THAR TOWNSHIP ,YANGON REGION",
  },
  {
    ID: 1737,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. JIN ZHIJANG",
    "Name of Principal Organization":
      "JIANGSU GUOTAI HUASHENG INDUSTRIAL CO.LTD",
    "Place of Incorporation": "PEOPLE'S REPUBLIC OF CHINA",
    "Company Name In Myanmar": "MYANMAR FORTUNE FASHION COMPANY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "040/2018",
    "Permit Date": "2018-03-21T04:41:00Z",
    "Meeting Number": "4/2018",
    "Meeting Date": "2018-03-07T04:41:27Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U SAI WIN TUN AND U SAI WIN AUNG",
    "Land Area (units not specified in file)": 1.74,
    "Lease Term": 10,
    "Annual Lease Fee": 0.035,
    "Land Use Premium": null,
    "Number Of Local Employees": 900,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "NO.8738, WANHONG RESIDENTIAL QUARTER, ZHANGJIAGANG CITY, JIANGSU, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address":
      "7-8,16-22/F, GUOTAI CENTURY PLAZA, MIDDLE RENMIN ROAD, ZHANGJIAGANG CITY, JIANGSU, PEOPLE'S REPUBLIC OF CHINA",
    "Investment Permitted Address":
      "PLOT NO.81, MYAY TAING BLOCK NO.14, SHWE THAN LWIN, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1738,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးတင်အောင်ခိုင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "၀င်း၀င်းမြိုင်မိသားစု ကုမ္ပဏီလီမီတက်( WIN WIN MYANIG FAMILY COMPANY LIMITED)",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "042/2018",
    "Permit Date": "2018-03-21T05:08:49Z",
    "Meeting Number": "4/2018",
    "Meeting Date": "2018-03-07T05:09:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ကော်စေ့နှင့်ပလပ်စတစ်အပ်ချည်မျှင် ထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1324.416,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးကစ္စနား (ခ) စိန်မြင့်",
    "Land Area (units not specified in file)": 1.448,
    "Lease Term": 5,
    "Annual Lease Fee": 108,
    "Land Use Premium": null,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "အမှတ်၄/ဒီ၊ အင်းယားမြိုင်လမ်း၊ ရွှေတောင်ကြား(၂)ရပ်ကွက်၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၃၉၄၊ မြေတိုင်းရပ်ကွက်အမှတ်-၄၉ ၀ါးတစ်ရာစက်မှု၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1739,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. WU GANG",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "MYANMAR AUTUMN & CHAMPAGNE GARMENTS & TEXTILE COMPAMY LIMITED",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "037/2018",
    "Permit Date": "2018-03-21T05:31:06Z",
    "Meeting Number": "4/2018",
    "Meeting Date": "2018-03-07T05:31:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 5,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW ESTHER",
    "Land Area (units not specified in file)": 7.352,
    "Lease Term": 50,
    "Annual Lease Fee": 0.06,
    "Land Use Premium": null,
    "Number Of Local Employees": 2026,
    "Number Of Foreign Employees": 45,
    Status: "Draft",
    "Investor Address":
      "4-1903, NO.189, FENG QI DONG ROAD, JIANG GAN DISTRICT , HANGZHOU, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.367+368,369, MYAUNG TAKAR INDUSTRIAL ZONE, HMAWBI TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1740,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးသီဟစိုး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "အေးရှားကင်းပါ၀ါ ကုမ္ပဏီလီမီတက် (ASIA KING POWER COMPANY LIMITED)",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "041/2018",
    "Permit Date": "2018-03-21T05:43:21Z",
    "Meeting Number": "4/2018",
    "Meeting Date": "2018-03-07T05:43:41Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နောက်တွဲယာဥ်ထုတ်လုပ်ခြင်းနှင့်ဖြန့်ဖြူးရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 700,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်စန်းညွန့်ခိုင်",
    "Land Area (units not specified in file)": 0.125,
    "Lease Term": 10,
    "Annual Lease Fee": 12,
    "Land Use Premium": null,
    "Number Of Local Employees": 28,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "အမှတ်-၂၄၃(ခ)၊ ဦးဥတ္တမလမ်း၊ ၃၈ရပ်ကွက် ဒဂုံမြို့သစ်(မြောက်ပိုင်း)မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၀၅.အေ ၊ မြေတိုင်းရပ်ကွက်အမှတ် စက်မှုလက်မှု၊ သာကေတမြို့နယ် ၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1741,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးတင်၀င်းအောင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "အစိမ်းရောင်သဘာ၀ထုတ်လုပ်မှု ကုမ္ပဏီလီမီတက် (GREEN NATURE MANUFACTURING COMPANY LIMITED)",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "043/2018",
    "Permit Date": "2018-04-11T06:15:58Z",
    "Meeting Number": "5/2018",
    "Meeting Date": "2018-03-21T06:16:23Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMPစနစ်ဖြင့်အ၀တ်အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1500,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးတင်၀င်းအောင်",
    "Land Area (units not specified in file)": 4.855,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 750,
    "Number Of Foreign Employees": 4,
    Status: "Draft",
    "Investor Address":
      "အမှတ်(၈၁)၊ ရိပ်သာ၅လမ်း၊ ၀ေဇယန္တာဥယာဥ်အိမ်ရာ ၊ မိချောင်းအပိုင်း(၁)ရပ်ကွက်၊ သင်္ဃန်းကျွန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၂၉+၃၀၊ မြေတိုင်းရပ်ကွက်အမှတ်၇လပ ၂၅၊ လှိုင်သာယာမြို့နယ်၊ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1742,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးနေစိုးထိုက်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "စိမ်းလန်းသောနယ်မြေသစ်ကုမ္ပဏီလီမီတက် (NEW GREEN LAND COMPANY LIMITED)",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "044/2018",
    "Permit Date": "2018-04-11T06:59:03Z",
    "Meeting Number": "5/2018",
    "Meeting Date": "2018-03-21T06:59:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMPစနစ်ဖြင့်အ၀တ်အထည်အမျိုးမျိုးချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 2000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "မြန်မာ့စီးပွားရေးဦးပိုင်လီမီတက်",
    "Land Area (units not specified in file)": 9.037,
    "Lease Term": 30,
    "Annual Lease Fee": 129.03,
    "Land Use Premium": null,
    "Number Of Local Employees": 1168,
    "Number Of Foreign Employees": 7,
    Status: "Draft",
    "Investor Address":
      "အမှတ်(၉၈)၊ ခရေပင်ရိပ်မွန်(၁)လမ်း၊ ချစ်တီးကုန်း၊မင်္ဂလာဒုံမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၄၄-အေ၊ အမှတ်(၃)လမ်း၊ ပျဥ်းမပင်စက်မှုနယ်မြေ၊ မင်္ဂလာဒုံမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1743,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်အေးအေးမြတ်လွင်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Tip Top International Manufacturing Co., Ltd. (ထိပ်ဆုံးအပြည်ပြည်ဆိုင်ရာစက်မှု ထုတ်လုပ်မှုကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 2011,
    "Financial Year To": 2012,
    "Permit Number": "Ma Na Tha- 826/2011",
    "Permit Date": "2011-11-24T07:02:20Z",
    "Meeting Number": "25/2011",
    "Meeting Date": "2011-11-23T07:07:36Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် စက်မှုလုပ်ငန်းသုံးရာဘာ အပိုပစ္စည်းများ ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.05,
    "Total Amount Of Capital (in Millions)": 27.98,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": 1.271,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 70,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် (၁၀)၊ စိတ္တသုခလမ်း၊ စမ်းချောင်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၆၉၊ မက္ခရာမင်းသားလမ်း၊ မြေတိုင်းရပ်ကွက်အမှတ်-၂၅၊ ရေွှလင်ပန်း စက်မှုဇုန်",
  },
  {
    ID: 1744,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. SONGLIN GONG",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "POLLY HK (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "045/2018",
    "Permit Date": "2018-04-11T07:21:52Z",
    "Meeting Number": "5/2018",
    "Meeting Date": "2018-03-21T07:23:11Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "LAUNDRY SERVICE FOR VARIOUS TYPE OF CLOTHES AND WEARS",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U YAN CHIN SEIN",
    "Land Area (units not specified in file)": 2.713,
    "Lease Term": 30,
    "Annual Lease Fee": 0.0713,
    "Land Use Premium": null,
    "Number Of Local Employees": 200,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address":
      "82AI GOO DONG YANG CITY, ZHEJIANG PROVINCE, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 301, MYAY TAING BLOCK NO. 25, SHWE LIN PAN INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP ,YANGON REGION",
  },
  {
    ID: 1746,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. ATSUSHI YAZAKI",
    "Name of Principal Organization": "KYOEI CO., LTD., ",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "KYOEI JAPAN COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "772/2014",
    "Permit Date": "2014-08-14T09:18:06Z",
    "Meeting Number": "18/2014",
    "Meeting Date": "2014-07-09T09:18:27Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING  \n   \tOF GARMENTS ON CMP BASIS \n",
    "Amount Of Foreign Capital USD (in Millions)": 1.712,
    "Total Amount Of Capital (in Millions)": 1.712,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "U Tin Hla, U Mar Har Mak Ei Li Yit ",
    "Land Area (units not specified in file)": 1.143,
    "Lease Term": 30,
    "Annual Lease Fee": 0.025,
    "Land Use Premium": null,
    "Number Of Local Employees": 630,
    "Number Of Foreign Employees": 20,
    Status: "Approved",
    "Investor Address":
      "615-1, AZAMACHIDA, OOAZA-HORAI, NISHI-KU, SAITAMA-CITY, SAITAMA PERFECTURE, JAPAN",
    "Organization Address":
      " 615-1, AZAMACHIDA, OOAZA-HORAI, NISHI-KU, SAITAMA-CITY, SAITAMA PREFECTURE, JAPAN",
    "Investment Permitted Address":
      "PLOT NO. 168, SAYAR SAN STREET, INDUSTRIAL ZONE (2), HLAING THARYAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1748,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. YANG, YING -TANG",
    "Name of Principal Organization": "COTECK CHEMICAL INDUSTRY CO., LTD.,",
    "Place of Incorporation": "TAIWAN",
    "Company Name In Myanmar": "COTECK (MYANMAR) INDUSTRY COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "727/2014",
    "Permit Date": "2014-04-29T09:46:09Z",
    "Meeting Number": "11/2014",
    "Meeting Date": "2014-03-29T09:46:33Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING  \n     \t AND MARKETING OF POLYURETHANE DECORATIVE MATERIALS\n",
    "Amount Of Foreign Capital USD (in Millions)": 0.9,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 24,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Nu Nu Lwin ",
    "Land Area (units not specified in file)": 2.003,
    "Lease Term": null,
    "Annual Lease Fee": 0.048,
    "Land Use Premium": null,
    "Number Of Local Employees": 142,
    "Number Of Foreign Employees": 13,
    Status: "Monitoring Approved",
    "Investor Address":
      "6, 3/F, 43 MINGSHENGDI STREET, 17 ADJACENT SHANJIAOLI, CAOTUN TOWN, NANTOU COUNTY, TAIWAN",
    "Organization Address":
      "12/F, NO.124, SEC.3, MIN QUAN EAST ROAD, SONGSHAN DISTRICT, TAIPEI CITY, TAIWAN",
    "Investment Permitted Address":
      "PLOT NO. 152, MYAY TAING BLOCK NO.113, DAGON MYOTHIT (EAST) INDUSTRIAL ZONE (1), DAGON MYOTHIT (EAST) TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1749,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Han Soe Kyaw",
    "Name of Principal Organization": "Two Elephant Trading Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Two Elephant Asia Group Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "963",
    "Permit Date": "2015-06-12T03:27:20Z",
    "Meeting Number": "10/2015",
    "Meeting Date": "2015-06-05T03:27:33Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Rental Services of Heavy Crane",
    "Amount Of Foreign Capital USD (in Millions)": 1.877,
    "Total Amount Of Capital (in Millions)": 3.61,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "U Kyaw Pe",
    "Land Area (units not specified in file)": 2.502,
    "Lease Term": 15,
    "Annual Lease Fee": 0.06,
    "Land Use Premium": null,
    "Number Of Local Employees": 126,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.11, Manawhari Street, Pyay West Quarter, Dagon Township, Yangon",
    "Organization Address":
      "Plot No. 116, Myay Taing Block No. 65, Corner of Peral Road & Depel Yin Won Htout Oo Mye Road, Shwe Pyi Thar Industrial Zone (4), Yangon",
    "Investment Permitted Address":
      "Plot No. 116, Myay Taing Block No. 65, Corner of Peral Road & Depel Yin Won Htout Oo Mye Road, Shwe Pyi Thar Industrial Zone (4), Yangon",
  },
  {
    ID: 1750,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yoji Taguchi",
    "Name of Principal Organization": "Mitsubishi Corporation ",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Diamond Rental Myanmar Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1075",
    "Permit Date": "2016-01-29T04:14:48Z",
    "Meeting Number": "1/2016",
    "Meeting Date": "2016-01-15T04:15:14Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Rental Services for Construction Related Equipments",
    "Amount Of Foreign Capital USD (in Millions)": 5.6,
    "Total Amount Of Capital (in Millions)": 8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Nyi Nyi Aye, Daw Nu Nu Khin",
    "Land Area (units not specified in file)": 6.285,
    "Lease Term": 7,
    "Annual Lease Fee": 0.038,
    "Land Use Premium": null,
    "Number Of Local Employees": 24,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.2-43-10, Sangenjaya, Setagaya-Ku, Tokyo 154-0024, Japan",
    "Organization Address":
      "No.3-1, Marunouchi 2-Chome, Chiyoda-Ku, Tokyo, 100-8086, Japan",
    "Investment Permitted Address":
      "Plot No.6, Thilawa Industrial Zone, Thanlyin-Kyauk Tan Township, Yangon, Plot No. 242/243, Myay Taing BLock No. 25, Dipeyinn Wun Htauk U Mye Street, Shwe Lin Ban Industrial Zone , Hlaing Thar Yar Township, Yangon",
  },
  {
    ID: 1752,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Num Tanthuwanit",
    "Name of Principal Organization": "Bumrungrad Health Network Co., Ltd.",
    "Place of Incorporation": "Thailand",
    "Company Name In Myanmar": "Bumrungrad Myanmar Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1016",
    "Permit Date": "2015-09-25T05:05:10Z",
    "Meeting Number": "16/2015",
    "Meeting Date": "2015-09-11T05:05:22Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Private Clinic and Diagnostic Seervices",
    "Amount Of Foreign Capital USD (in Millions)": 4.24,
    "Total Amount Of Capital (in Millions)": 5.3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "U Hla Win, Daw Hla Hla Mu",
    "Land Area (units not specified in file)": 0.238,
    "Lease Term": 50,
    "Annual Lease Fee": 0.18,
    "Land Use Premium": null,
    "Number Of Local Employees": 10,
    "Number Of Foreign Employees": 8,
    Status: "Monitoring Approved",
    "Investor Address": "61 Sukhumvit Soi 19, Wattana, Bangkok 10110 Thailand",
    "Organization Address":
      "33 Sukhumvit 3 Alley (Nana Nua), Skhumvit Road, Khlong Toei Nua Sub-District, Vadhana District, Bangkok Metropolis",
    "Investment Permitted Address":
      "No. 77, Pyidaungsu Yeiktha Street, Dagon Township, Yangon ",
  },
  {
    ID: 1753,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Liaw Yit Ming",
    "Name of Principal Organization": "Parkway Helthcare Indo-China Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Andaman Alliance Healthcare Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1045",
    "Permit Date": "2016-01-29T05:39:21Z",
    "Meeting Number": "1/2016",
    "Meeting Date": "2015-01-15T05:39:33Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Private Hospital Services",
    "Amount Of Foreign Capital USD (in Millions)": 54.44,
    "Total Amount Of Capital (in Millions)": 87.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 7,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Ministry of Health",
    "Land Area (units not specified in file)": 4.3,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": 2000000,
    "Number Of Local Employees": 314,
    "Number Of Foreign Employees": 36,
    Status: "Monitoring Approved",
    "Investor Address": "6 Keng Chin Road, # 05-05 Cyan, Singapore 258709",
    "Organization Address":
      "111 Somerset Road, # 15-01 Tripleone Somerset Singapore 238164",
    "Investment Permitted Address":
      "လူမှုဝန်ထမ်းဦးစီးဌာန၊ လူမှုဝန်ထမ်းကယ်ဆယ်ရေးနှင့် ပြန်လည်နေရာချထားရေးဝန်ကြီးဌာနပိုင် အမှတ် ၆၅၊ (၆)ရပ်ကွက်၊ ကျိုက်ဝိုင်းဘုရားလမ်း၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1756,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MRS. LIU, TZU-HSIEN",
    "Name of Principal Organization": "GRAND INVESTMENT LIMITED, ",
    "Place of Incorporation": "Samoa",
    "Company Name In Myanmar": "GRAND ENTERPRISES GARMENT COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "822/2014",
    "Permit Date": "2014-10-28T06:45:30Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T06:45:55Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF GARMENTS ON      CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.556,
    "Total Amount Of Capital (in Millions)": 1.556,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Brunei Darussalam",
    "Form Of Investment": "FDII",
    "Land Owner": "U Mamed Esoof ",
    "Land Area (units not specified in file)": 4.414,
    "Lease Term": 50,
    "Annual Lease Fee": 0.098,
    "Land Use Premium": null,
    "Number Of Local Employees": 1954,
    "Number Of Foreign Employees": 30,
    Status: "Monitoring Approved",
    "Investor Address":
      "3F, NO.42, ALY.30,LIN.9, WENHUA ROAD., YANGHE DISTRICT, NEW TAIPEI CITY 234, TAIWAN, REPUBLIC OF CHINA",
    "Organization Address":
      "Le Sanalele Complex, Gold in Chambers, Vaea Street, Apia, Samoa.",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၃၂+၃၃+၆၁+၆၂+၆၆၊ မြေတိုင်း ရပ်ကွက်အမှတ် - ၁၁၃၊ ဒဂုံအရှေ့စက်မှုဇုန်၊ ဒဂုံ မြို့သစ် (အရှေ့ပိုင်း)မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1757,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်မြင့်မြင့်ဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Shwe Than Lwin Media Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1060",
    "Permit Date": "2015-07-24T06:52:44Z",
    "Meeting Number": "12/2015",
    "Meeting Date": "2015-07-03T06:53:21Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Satellite Earth Station တည်ဆောက်ပြီး ဂြိုလ်တုအခြေပြု ဆက်သွယ်ရေးဝန်ဆောင်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 13865,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 60,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ရွှေသံလွင်ထရေးဒင်းကုမ္ပဏီလီမိတက်",
    "Land Area (units not specified in file)": 10,
    "Lease Term": 10,
    "Annual Lease Fee": 360,
    "Land Use Premium": null,
    "Number Of Local Employees": 55,
    "Number Of Foreign Employees": 25,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ် ၁၂၆ အေ၊ လမ်း ၂၀ ၊ လသာမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ တာမွေမြို့နယ်၊ မာလာနွယ်လမ်းနှင့် ပင်ရွှေညောင်လမ်းထောင့်၊ မြေကွက်အမှတ် ၅၁ B ၂၊ မြေတိုင်းရပ်ကွက်အမှတ် ၃၄ ဒီ ရှိ မြေ ၁၀ ဧက",
  },
  {
    ID: 1758,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "DAW YIN YIN HTWE",
    "Name of Principal Organization": "KITTENISH KNITTING CO.,LTD.,",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "KITTENISH KNITTING CO.,LTD.,",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "810/2014",
    "Permit Date": "2014-10-15T07:05:40Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T07:21:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF GARMENT ON CMP BASIS FOR FACTORY (2)",
    "Amount Of Foreign Capital USD (in Millions)": 0.15,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Khin May Lin",
    "Land Area (units not specified in file)": 2,
    "Lease Term": 10,
    "Annual Lease Fee": 0.031727,
    "Land Use Premium": null,
    "Number Of Local Employees": 534,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.404,NANTHAR MYAING 1ST STREET, NANTHAR GONE QUARTER, INSEIN TOWNSHIP, YANGON REGION",
    "Organization Address":
      "PLOT NO-66, BLOCK NO. 39 (SETMU), SHWE PYITHAR TOWNSHIP, YANGON REGION",
    "Investment Permitted Address":
      "Plot No.73, Block No. 65, Shwe Pyithar Insdustrial Zone 4, SHWE PYITHAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1761,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "DAW YIN YIN HTWE",
    "Name of Principal Organization": "KITTENISH  KNITTING CO., LTD., ",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Myanmar Knitting Co.,Ltd",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "809/2014",
    "Permit Date": "2014-10-15T07:36:06Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T07:36:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.15,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "U Myint San ",
    "Land Area (units not specified in file)": 1.041,
    "Lease Term": 10,
    "Annual Lease Fee": 0.018881,
    "Land Use Premium": null,
    "Number Of Local Employees": 653,
    "Number Of Foreign Employees": 4,
    Status: "Approved",
    "Investor Address":
      "NO.404, NANTHAR MYAING 1st STREET, NANTHAR GONE QUARTER, INSEIN TOWNSHIP, YANGON REGION",
    "Organization Address":
      "PLOT NO.66, BLOCK NO. 39 (SETMU), SHWE PYITHAR TOWNSHIP,     YANGON REGION",
    "Investment Permitted Address":
      "PLOT NO.66, BLOCK NO. 39 (SETMU), SHWE PYITHAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1762,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်အေးနန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Yadanar Theingi Industrial Co., Ltd.",
    "Financial Year From": 2001,
    "Financial Year To": 2002,
    "Permit Number": "527/2001",
    "Permit Date": "2001-12-27T05:20:48Z",
    "Meeting Number": "49/2001",
    "Meeting Date": "2001-12-20T05:26:09Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "ရေထွက်ပစ္စည်းပြုပြင်အေးခဲခြင်းနှင့် ရေခဲစက်ရုံလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 80,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Yadanar Theingi Industrial Co., Ltd.",
    "Land Area (units not specified in file)": 1.677,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 303,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် (က)၊  ပြည်လမ်း (၆)မိုင်ခွဲ၊ လှိုင်မြို့နယ်၊ ရန်ကုန်",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၂၃)၊ မြေတိုင်းရက်ကွက်အမှတ် (၃၉)၊ ရွှေပြည်သာစက်မှုဇုန်၊ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1763,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်မြင့်မြင့်ဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Shwe Than Lwin Media Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": " မနသ-၁၁၁၈/၂၀၁၆",
    "Permit Date": "2016-01-14T08:20:36Z",
    "Meeting Number": "၂၃/၂၀၁၅",
    "Meeting Date": "2015-12-28T08:21:02Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "ရုပ်မြင်သံကြားရိုက်ကူး၊ ထုတ်လုပ်၊ ထုတ်လွှင့်ခြင်းနှင့် ဆက်စပ်သော ဝန်ဆောင်မှုလုပ်ငန်း (စီမံကိန်းအဆင့် ၂)",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 908183.2,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Than Sein",
    "Land Area (units not specified in file)": 1.683,
    "Lease Term": 10,
    "Annual Lease Fee": 11400,
    "Land Use Premium": null,
    "Number Of Local Employees": 756,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "အမှတ် ၁၂၆ (အေ)၊ လမ်း  (၂)၊ လသာမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ် 139 (A)+ 171 A/20, 21,22, 23,24, 25, 26, 27 မေယုအိမ်ရာ၊ မြေတိုင်းရပ်ကွက် အမှတ် 9 N, 9 N, အောက်ပုဇွန်တောင်လမ်း၊ ဗိုလ်တစ်ထောင်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1764,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါက်တာဇော်မင်းအောင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Green Allliance Energy Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "မနသ-၁၁၅၅/၂၀၁၆",
    "Permit Date": "2016-03-26T08:53:20Z",
    "Meeting Number": "၁၁/၂၀၁၆",
    "Meeting Date": "2015-03-25T08:53:44Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် မြေငှားရမ်း၍ ရေနံသဘာဝဓာတ်ငွေ့ရည် တင်ချဆိပ်ခံတံတားနှင့် ရေနံသဘောဝဓာတ်ငွေ့ရည် သိုလှောင်ကန်များ တည်ဆောက်၍ ရေနံသဘာဝဓာတ်ငွေ့ရည် သိုလှောင်ခြင်း ဝန်ဆောင်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 55550.602,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Green Alliance Energy Co., Ltd.",
    "Land Area (units not specified in file)": 7,
    "Lease Term": 2,
    "Annual Lease Fee": 12,
    "Land Use Premium": null,
    "Number Of Local Employees": 38,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "အမှတ် ၂၁၂၇၊ စဉ့်ကူလမ်း၊ ရတနာသိဒ္ဓိရပ်ကွက်၊ ဥတ္တရသီရိမြို့နယ်၊ နေပြည်တော်",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ သန်လျင်-ကျောက်တန်းနယ်မြေ၊ သီလဝါဆိပ်ကမ်း၊ မြေကွက်အမှတ်-၂၂ ရှိ မြေ ၃၇.၀၆ ဧက",
  },
  {
    ID: 1766,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်ဇော်နိုင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Botahtaung Health Care Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "မနသ-၁၁၆၉/၂၀၁၆",
    "Permit Date": "2016-03-26T09:35:06Z",
    "Meeting Number": "၁၁/၂၀၁၆",
    "Meeting Date": "2016-03-25T09:35:29Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Hospital, Hospital Suites, Hospital Service Apartment Retail (Health & Lifestyle) ဝန်ဆောင်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 99440.1,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ရထားပို့ဆောင်ရေးဝန်ကြီးဌာန",
    "Land Area (units not specified in file)": 1.931,
    "Lease Term": 50,
    "Annual Lease Fee": 0.7,
    "Land Use Premium": 7.02,
    "Number Of Local Employees": 1054,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၂၅၊ ရှင်စောပုလမ်း၊ ဝင်ဆာဥယျာဉ်၊ စမ်းချောင်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ ဗိုလ်တစ်ထောင်မြို့နယ်၊ ကုန်သည်လမ်း၊ အမှတ် ၃၅၁-၃၆၁၊ မြန်မာ့မီးရထားရုံးချုပ်မြေနေရာ ၃.၅၁ ဧက အနက်မှ ၁.၉၃၁ ဧက",
  },
  {
    ID: 1778,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. FUNG CHI PUI NELSON",
    "Name of Principal Organization":
      "CHOGQING MCSLOCO ELECTRIC AND OPTICAL CO., LTD",
    "Place of Incorporation": "PEOPLE'S REPUBLIC OF CHINA",
    "Company Name In Myanmar": "MCSLCO (YANGON) LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "046/2018",
    "Permit Date": "2018-04-11T03:50:15Z",
    "Meeting Number": "5/2018",
    "Meeting Date": "2018-03-21T03:51:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF BINOCULARS, SPOTTING SCOPES, PRISM & LENS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.26,
    "Total Amount Of Capital (in Millions)": 1.26,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U KYAW MOE NAING",
    "Land Area (units not specified in file)": 2.755,
    "Lease Term": 5,
    "Annual Lease Fee": 0.09,
    "Land Use Premium": null,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": 7,
    Status: "Draft",
    "Investor Address":
      "NO.231, QING GANG ROAD, BISHAN AREA, CHONGQING CITY, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address":
      "NO.3-24, LANHUJUNXIAN, YUBKI DISTRICT, CHONGQING, PEOPLE'S REPUBLIC OF CHINA",
    "Investment Permitted Address":
      "PLOT NO. 129, MYAY TAING BLOCK NO.113, SETHMUNYO, EAST DAGON TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1779,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကျော်မြင့်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "သူ့ထက်သာရောင်း၀ယ်ရေးကုမ္ပဏီလီမီတက်",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "047/2018",
    "Permit Date": "2018-04-11T04:34:14Z",
    "Meeting Number": "5/2018",
    "Meeting Date": "2018-03-21T04:34:20Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CONTRACT MANUFACTURING PROCESS(CMP)  စနစ်ဖြင့်ကျွဲနွားဆားနယ်အစာအိမ်(OMASUM/TRIPE)တင်သွင်း၍ ထုတ်ပိုးပြီးပြန်လည်တင်ပို့ရောင်းချခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 5816.964,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်လဲ့လဲ့အေး",
    "Land Area (units not specified in file)": 0.902,
    "Lease Term": 10,
    "Annual Lease Fee": 24,
    "Land Use Premium": null,
    "Number Of Local Employees": 60,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "အမှတ်(၃၅/၃၇)၊ အခန်းအမှတ်(၁)၊ ဟင်္သာတလမ်း၊ကျွန်း(မြောက်) ရပ်ကွက်၊ စမ်းချောင်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်၇၀၊မြေတိုင်းရပ်ကွက်အမှတ်(၁၇၂)၊ ဒဂုံမြို့သစ်(ဆိပ်ကမ်း)မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1780,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအိုက်သီ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Yadanar Theingi  Co., Ltd.",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "MaNaTha-637/2003",
    "Permit Date": "2003-09-17T04:21:47Z",
    "Meeting Number": "30/2003",
    "Meeting Date": "2003-09-04T05:24:07Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "တန် (၁၀၀)ဆန့် အအေးခန်း စက်မှုလုပ်ငန်း (ငါး၊ ပုစွန် ပြုပြင်ခြင်း အေးခဲခြင်းနှင့်ထုတ်ပိုးခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 134.25,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "အမှတ်(၁) စက်မှုဝန်ကြီးဌာန၊ မြန်မာ့ဆေးဝါးနှင့် အိမ်သုံးပစ္စည်းလုပ်ငန်း",
    "Land Area (units not specified in file)": 0.76,
    "Lease Term": 5,
    "Annual Lease Fee": 1.4,
    "Land Use Premium": null,
    "Number Of Local Employees": 75,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၇၇)၊ ဈေးတန်းရပ်၊ နမ့်ခမ်းမြို့နယ်၊ ရှမ်းပြည်(မြောက်ပိုင်း)",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်(၁) စက်မှုဝန်ကြီးဌာန၊ မြန်မာ့ဆေးဝါးနှင့် အိမ်သုံးပစ္စည်းလုပ်ငန်းပိုင် မြေ၊ အမှတ် ((၁၀၅/၁၁၁))၊ အမရာလမ်း၊ စက်မှုလက်မှုရပ်ကွက်၊ မြောက် ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1781,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. YU, LIANG",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ASIA FASHION COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "066/2018",
    "Permit Date": "2018-07-04T04:49:43Z",
    "Meeting Number": "8/2018",
    "Meeting Date": "2018-06-13T04:50:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.85,
    "Total Amount Of Capital (in Millions)": 0.85,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW KHIN KHIN SHAN",
    "Land Area (units not specified in file)": 1.079,
    "Lease Term": 20,
    "Annual Lease Fee": 17466.24,
    "Land Use Premium": null,
    "Number Of Local Employees": 900,
    "Number Of Foreign Employees": 39,
    Status: "Draft",
    "Investor Address":
      "AN HUI, FU YANG SHI, YING QUAN, XING LIU ZHEN, LIU HE XING ZHENG CUN, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.(11,12/KA,15/KHA,16), MYAY TAING BLOCK NO.5, INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1782,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. DING YUNSHENG ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "SHENG JIE (MYANMAR) CLOTHING COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "065/2018",
    "Permit Date": "2018-07-04T05:05:03Z",
    "Meeting Number": "8/2018",
    "Meeting Date": "2018-06-13T05:05:09Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.978,
    "Total Amount Of Capital (in Millions)": 1.978,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U KYAW MIN TUN",
    "Land Area (units not specified in file)": 2.138,
    "Lease Term": 10,
    "Annual Lease Fee": 229.799,
    "Land Use Premium": null,
    "Number Of Local Employees": 1406,
    "Number Of Foreign Employees": 30,
    Status: "Draft",
    "Investor Address":
      "ROOM 1402, UNIT 2,7 TONG BUILDING, BLUE CONSTELLATION GARDEN, 101 LONG SOUTH ROAD, QINHUAI DISTRICT, NANJING, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.296,297, MYAY TAING BLOCK NO-25, SHWE LIN PAN INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP ,YANGON REGION",
  },
  {
    ID: 1783,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor":
      "Mr.Toshohiro Kobayashi ( WITH INTERNATIONAL COMPANY LIMITED ( MYANMAR BRANCH)",
    "Name of Principal Organization": "WITH INTERNATIONAL COMPANY LIMITED ",
    "Place of Incorporation":
      "3-11-23 CHIYODA, AOI-KU , SHIZUOKA CITY, 420-0803, JAPAN",
    "Company Name In Myanmar":
      "WITH INTERNATIONAL COMPANY LIMITED ( MYANMAR BRANCH)",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "064/2018",
    "Permit Date": "2018-07-04T05:18:48Z",
    "Meeting Number": "8/2018",
    "Meeting Date": "2018-06-13T05:18:55Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "HOTEL SERVICE",
    "Amount Of Foreign Capital USD (in Millions)": 4.63,
    "Total Amount Of Capital (in Millions)": 4.63,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW THUZAR MYO NYUNT",
    "Land Area (units not specified in file)": 0.25,
    "Lease Term": 30,
    "Annual Lease Fee": 0.646,
    "Land Use Premium": null,
    "Number Of Local Employees": 18,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "ROOM 303, OFFICE TOWER, NOVOTEL YANGON MAX, 459, PYAYROAD, KAMAYUT TOWNSHIP, YANGON",
    "Organization Address":
      "3-11-23 CHIYODA, AOI-KU , SHIZUOKA CITY, 420-0803, JAPAN",
    "Investment Permitted Address":
      "PLOT NO.113/E/3, MYAY TAING BLOCK NO.36J, BAHAN TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1784,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. KIM TAEKYUN",
    "Name of Principal Organization": "ACE UNIFORM COMPANY LIMITED",
    "Place of Incorporation": "REPUBLIC OF KOREA",
    "Company Name In Myanmar": "GLOBAL ACE UNIFORM COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "063/2018",
    "Permit Date": "2018-07-04T05:40:36Z",
    "Meeting Number": "8/2018",
    "Meeting Date": "2018-06-13T05:40:39Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF GARMENT AND SAFETY CLOTHING ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.829,
    "Total Amount Of Capital (in Millions)": 0.829,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U KYAW ZAW??? (U KHIN MAUNG HTUN????)",
    "Land Area (units not specified in file)": 1.273,
    "Lease Term": 10,
    "Annual Lease Fee": 0.099,
    "Land Use Premium": null,
    "Number Of Local Employees": 600,
    "Number Of Foreign Employees": 20,
    Status: "Draft",
    "Investor Address":
      "NO.101-1801 80, SAJIK-RO, DONGNAE-GU, BUSAN, REPUBLIC OF KOREA",
    "Organization Address":
      "(JEONPO-DONG) 30 JUNGANGDAE-RO, 848BEON-GIL,BUSANJIN-GU,BUSAN, REPUBLIC OF KOREA",
    "Investment Permitted Address":
      "PLOT NO.12/2, MYAY TAING BLOCK NO.109, INDUSTRIAL ZONE, EAST DAGON TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1785,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. JI DEBAO",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "SUNME (MYANMAR) INDUSTRIAL LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "062/2018",
    "Permit Date": "2018-07-04T06:00:49Z",
    "Meeting Number": "8/2018",
    "Meeting Date": "2018-06-13T06:00:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.317,
    "Total Amount Of Capital (in Millions)": 1.317,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U MYINT ZAW",
    "Land Area (units not specified in file)": 1.826,
    "Lease Term": 10,
    "Annual Lease Fee": 168888,
    "Land Use Premium": null,
    "Number Of Local Employees": 801,
    "Number Of Foreign Employees": 30,
    Status: "Draft",
    "Investor Address":
      "ROOM 1802,UNIT 1 BUILDING 5, NO.9 MOCHOU LAKE EAST ROAD, JIANYE DISTRICT, NANJING, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 106, MYAY TAING BLOCK NO.14, SHWE THANLWIN INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP , YANGON REGION",
  },
  {
    ID: 1786,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. FU, HSU-HANG",
    "Name of Principal Organization": "SMART RISE LTD",
    "Place of Incorporation": "REPUBLIC OF SEYCHELLES",
    "Company Name In Myanmar": "V-TOP INDUSTRIES MYANMAR LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "061/2018",
    "Permit Date": "2018-07-04T06:37:41Z",
    "Meeting Number": "8/2018",
    "Meeting Date": "2018-06-13T06:37:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF ELECTRIC TOYS, PLASTIC TOYS AND ASSOCIATED ACCESSORIES ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 4.05,
    "Total Amount Of Capital (in Millions)": 4.05,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Seychelles",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW MYINT YI YI",
    "Land Area (units not specified in file)": 1.83,
    "Lease Term": 30,
    "Annual Lease Fee": 0.037,
    "Land Use Premium": null,
    "Number Of Local Employees": 301,
    "Number Of Foreign Employees": 32,
    Status: "Draft",
    "Investor Address":
      "11E-7, NO68, SEC 4,ROOSEVELT ROAD, ZHONGZHENG DISTRICT, TAIPEI CITY,100, TAIWAN",
    "Organization Address":
      "SERTUS CAMBERS, SECOND FLOOR, THE QUADRANT, MANGLIER STREET, VICTORIA, MAHE, REPUBLIC OF SEYCHELLES",
    "Investment Permitted Address":
      "PLOT NO.353, MYAY TAING BLICK NO. MYAUNG TAKAR INDUSTRIAL ZONE, HMAWBI TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1787,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. GU ABO",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "TMR (MYANMAR) APPAREL COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "060/2018",
    "Permit Date": "2018-06-13T06:56:50Z",
    "Meeting Number": "8/2018",
    "Meeting Date": "2018-06-13T06:57:02Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF APPAREL ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 3.378,
    "Total Amount Of Capital (in Millions)": 3.378,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U AUNG TIN@ AH BAT KHAN AND U KYAW MYINT @ KA RIM",
    "Land Area (units not specified in file)": 1.83,
    "Lease Term": 10,
    "Annual Lease Fee": 0.185,
    "Land Use Premium": null,
    "Number Of Local Employees": 947,
    "Number Of Foreign Employees": 31,
    Status: "Draft",
    "Investor Address":
      "NO.26, CHUANGYE ROAD, INDUSTRY ZONE, XIANGSHAN, INNGBO, ZHEJIANG, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 278/12, MYAY TAING BLOCK NO,25 SHWE LIN PAN SERHMU MYO, HLAING THAR YAR TOWNSHIP , YANGON REGION",
  },
  {
    ID: 1788,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမြင့်သိန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Phoenix Manufacturing Co., Ltd. ",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "MaNaTha-724/2009",
    "Permit Date": "2009-12-14T07:24:51Z",
    "Meeting Number": "45/2009",
    "Meeting Date": "2009-12-03T07:08:50Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် မြေငှားရမ်း၍ တန် (၁၀၀၀)ဆန့် အအေးခန်းစက်ရုံ၊ တန် (၁၀၀)ကျ ရေခဲစက်ရုံ နှင့် ငါးပုစွန် တင်ချနိုင်ရန် ဆိပ်ခံတံတား တည်ဆောက်ကာ ရေခဲ ငါး၊ ပုစွန်များထုတ်လုပ် ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 987.6,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": " ငါးလုပ်ငန်းဦးစီးဌာနပိုင်",
    "Land Area (units not specified in file)": 5.07,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 264,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် (၉၀/အေ) ၊ အောက်ကြည့်မြင်တိုင်\nလမ်မကြီး၊ စောရန်ပိုင် အရှေ့ရပ်ကွက်၊ အလုံမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ အင်းစိန်မြို့နယ်၊ အနောက်ကြို့ကုန်း ရပ်ကွက်၊ မြေတိုင်းရပ်ကွက်အမှတ် (၂/၂)ရှိ ငါးလုပ်ငန်း ဦးစီးဌာနပိုင် မြေ",
  },
  {
    ID: 1789,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "အောင်ကျွန်းသာ ကုမ္ပဏီလီမီတက်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "အောင်ကျွန်းသာကုမ္ပဏီလီမီတက် (AUNG KYUN THAR COMPANY LIMITED)",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "059/2018",
    "Permit Date": "2018-06-13T07:25:33Z",
    "Meeting Number": "7/2018",
    "Meeting Date": "2018-05-23T07:25:37Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CONTRACT MANUFACTURING PROGRESS(CMP) ပြည်ပမှနှမ်း၀ယ်ယူပြီးတန်ဖိုးမြှင့်ပို့ကုန်နှမ်းလှော်မှုန့်ပြုလုပ်၍ ပြည်ပသို့ပြန်လည်တင်ပို့ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 504.537,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "AUNG KYUN THAR",
    "Land Area (units not specified in file)": 2.514,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 77,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "အမှတ် (၁၃၈/၁၄၂)၊ အခန်းအမှတ်-၈ ဘီ/စီ၊ သိမ်ဖြူကွန်ဒို၊ သိမ်ဖြူလမ်း၊ဗိုလ်တစ်ထောင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၉၄နှင့်၉၅)၊ မြေတိုင်းရပ်ကွက်အမှတ် ၆၄(စက်မှု) ရွှေပြည်သာမြို့နယ် ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1792,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LIU, ZEWEI",
    "Name of Principal Organization": "EMILY HONG KONG LTD.,",
    "Place of Incorporation": "HONG KONG",
    "Company Name In Myanmar": "BOLLY (HONG KONG) COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "058/2018",
    "Permit Date": "2018-06-13T07:57:09Z",
    "Meeting Number": "7/2018",
    "Meeting Date": "2018-05-23T07:54:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF VARIOUS SHOES ON CMP",
    "Amount Of Foreign Capital USD (in Millions)": 4.514,
    "Total Amount Of Capital (in Millions)": 4.514,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "EMILY MYANMAR CO.,LTD",
    "Land Area (units not specified in file)": 2.06,
    "Lease Term": 50,
    "Annual Lease Fee": 0.043,
    "Land Use Premium": null,
    "Number Of Local Employees": 1631,
    "Number Of Foreign Employees": 20,
    Status: "Draft",
    "Investor Address":
      "FLAT/RM-E,9/F, LEAHANDER CENTER, NO.28-34 WANG WO TSAI STREET, TSUEN WAN, N.T., HONG KONG",
    "Organization Address":
      "FLAT/RM-E,9/F, LEAHANDER CENTER, NO.28-34 WANG WO TSAI STREET, TSUEN WAN, N.T., HONG KONG",
    "Investment Permitted Address":
      "HOLDING NO-26,28/KA-1, KWIN NO.560 LIP POK TAW VILLAGE TRACT, HMAWBI TOWNSHIP , YANGON REGION",
  },
  {
    ID: 1794,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. XUAN TAO",
    "Name of Principal Organization": "FUXIN FUYI INDUSTRY COMPANY LIMITED",
    "Place of Incorporation": " PEOPLE'S REPUBLIC OF CHINA",
    "Company Name In Myanmar": "FUXIN FUYI INDUSTRY COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "057/2018",
    "Permit Date": "2018-06-13T08:29:19Z",
    "Meeting Number": "7/2018",
    "Meeting Date": "2018-05-23T08:29:24Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.35,
    "Total Amount Of Capital (in Millions)": 0.7,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "U AUNG KYAW THAN",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 30,
    "Annual Lease Fee": 0.063,
    "Land Use Premium": null,
    "Number Of Local Employees": 300,
    "Number Of Foreign Employees": 2,
    Status: "Draft",
    "Investor Address":
      "\nCHANGQING ROAD, NO.17-4-132, XIHE DISTRICT , FUXIN CITY, LIAONING PROVINCE, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address":
      "\nCHANGQING ROAD, NO.17-4-132, XIHE DISTRICT , FUXIN CITY, LIAONING PROVINCE, PEOPLE'S REPUBLIC OF CHINA",
    "Investment Permitted Address":
      "PLOT NO. 29, MYAY TAING BLOCK NO.112, INDUSTRIAL ZONE, DAGON ( EAST) TOWNSHIP , YANGON REGION",
  },
  {
    ID: 1795,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. BUI VIET VUONG",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "GLOBAL HANGER COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "056/2018",
    "Permit Date": "2018-06-13T08:39:52Z",
    "Meeting Number": "7/2018",
    "Meeting Date": "2018-05-23T08:40:22Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF HANGERS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.554,
    "Total Amount Of Capital (in Millions)": 1.554,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Vietnam",
    "Form Of Investment": "FDII",
    "Land Owner": "U PYAE PHO THU",
    "Land Area (units not specified in file)": 2.517,
    "Lease Term": 5,
    "Annual Lease Fee": 0.088,
    "Land Use Premium": null,
    "Number Of Local Employees": 66,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address":
      "GROUP 8, NO.15/12, NGUYEN QUOC HIEU ROAD, TRAN HUNG DAO WARD, PHU LY CITY, HA NAM PROVINCE, VIETNAM",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.108, MYAY TAING BLOCK NO. THILAWA INDUSTRIAL ZONE, THANLYIN KYAUK- TAN TOWNSHIP , YANGON REGION",
  },
  {
    ID: 1796,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးစိုင်းမုန့်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Forever Padauk Trading Co., Ltd. ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "949/2013",
    "Permit Date": "2013-12-27T08:49:30Z",
    "Meeting Number": "31/2013",
    "Meeting Date": "2013-12-04T08:50:04Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ကွန်ကရစ်တိုင်နှင့် (AAC) ကွန်ကရစ်ဘလောက်တုံးများ ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 2.41,
    "Total Amount Of Capital (in Millions)": 2500,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးစိုင်းမုန့်",
    "Land Area (units not specified in file)": 6.988,
    "Lease Term": 10,
    "Annual Lease Fee": 1200,
    "Land Use Premium": null,
    "Number Of Local Employees": 120,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်- ၃၃၁၊ အောက်ကြည့်မြင်တိုင်လမ်း၊ ဌာနရပ်ကွက်၊ အလုံမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ ဒဂုံဆိပ်ကမ်းမြို့နယ်၊ စက်မှုဇုန်(၁) တိုးချဲ့၊ မြေကွက်အမှတ် (၂၀၀)ရှိ မြေ (၆.၉၈၈)ဧက",
  },
  {
    ID: 1797,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်၀င်း၀င်း(ခ) ဒေါ်ကြူကြူ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ဖြောင့်မတ်အောင်မြင်လီမီတက်(STRAIGHT SUCCESS LIMITED)",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "055/2018",
    "Permit Date": "2018-06-13T08:52:45Z",
    "Meeting Number": "7/2018",
    "Meeting Date": "2018-05-23T08:52:50Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF BAGES ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 506,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U THET HTAY @LO KIN KOUT @ LO KIN HTOE",
    "Land Area (units not specified in file)": 1.519,
    "Lease Term": 5,
    "Annual Lease Fee": 120,
    "Land Use Premium": null,
    "Number Of Local Employees": 300,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address":
      "အမှတ်၂၇(ဘီ)၊ အင်းယားရိပ်သာ၊ ၁၀ရပ်ကွက်၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်၂၀၊ မြေတိုင်းရပ်ကွက်အမှတ်၆၄(စက်မှု)၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1798,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကျော်ခိုင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ထိုက်ထိုက်ကုမ္ပဏီလီမီတက်(HTIKE HTIKE  COMPANY LIMITED)",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "054/2018",
    "Permit Date": "2018-06-13T09:05:04Z",
    "Meeting Number": "7/2018",
    "Meeting Date": "2018-05-23T09:05:11Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 853.009,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U KYAW KHING",
    "Land Area (units not specified in file)": 0.505,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 175,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "အမှတ်(၃၀) သစ္စာလမ်း၊ တောင်ဥက္ကလာပမြို့နယ်၊ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၃၈၉၊၃၉၀၊၃၉၁ မြေတိုင်းရပ်ကွက်အမှတ်-၂၃၊ စက်မှုလက်မှု၊ ဒဂုံမြို့သစ်တောင်ပိုင်းမြို့နယ် ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1799,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးနန္ဒ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "အောင်မြင်စွမ်းအားအပြည်ပြည်ဆိုင်ရာ ကုမ္ပဏီလီမီတက် (WINNER POWER INTERNATIONAL COMPANY LIMITED)",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "053/2018",
    "Permit Date": "2018-06-13T09:14:50Z",
    "Meeting Number": "7/2018",
    "Meeting Date": "2018-05-16T09:14:56Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF BREAKERS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 500,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "U TUN NAING , U NANDA , U MIN SOE PAING AND U AYEYAR KYI PHYO",
    "Land Area (units not specified in file)": 0.055,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 17,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "အမှတ်(၂)၊ ရတနာလမ်း၊ဆရာစံ(တောင်)ရပ်ကွက်၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(အေ-၂၃)၊ မြေတိုင်းရပ်ကွက်အမှတ် (၃၄)တိုးချဲ့၊ ဦး၀ိစာရလမ်း၊ဒဂုံမြို့သစ်(မြောက်ပိုင်း)မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1800,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.XIAOYIN WANG",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "HENGRUN GARMENT COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "052/2018",
    "Permit Date": "2018-06-13T09:26:04Z",
    "Meeting Number": "7/2018",
    "Meeting Date": "2018-05-23T09:26:33Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING  OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.55,
    "Total Amount Of Capital (in Millions)": 0.55,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW KHIIN MYA MYA",
    "Land Area (units not specified in file)": 3.66,
    "Lease Term": 10,
    "Annual Lease Fee": 0.06,
    "Land Use Premium": null,
    "Number Of Local Employees": 841,
    "Number Of Foreign Employees": 13,
    Status: "Draft",
    "Investor Address":
      "ROOM 401,BUILDING NO-3,ZIYU VILLA, NO.1-89,HUAYUAN ROAD, NANJING CITY, JIANGSU PROVINCE, PEOPLE;S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.(278/11+14), MYAY TAING BLOCK NO. 25, SHWE LIN PAN SETHMU MYO, HLAING THAR YAR TOWNSHIP , YANGON REGION",
  },
  {
    ID: 1801,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးစိုးစိုးသန်း(ခ)စိုးစိုး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ဒဂုံအားမာန်သစ်ကုမ္ပဏီလီမီတက်(DAGON ARR MAHN THIT COMPANY LIMITED)",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "051/2018",
    "Permit Date": "2018-05-23T09:34:10Z",
    "Meeting Number": "7/2018",
    "Meeting Date": "2018-05-23T09:34:28Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "မော်တော်ယာဥ်အမျိုးမျိုးကိုစနစ်ဖြင့်တပ်ဆင်ခြင်း၊ ထုတ်လုပ်ခြင်းနှင့်ဖြန်းဖြူးရောင်းချခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 5830.356,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U WIN ZAW OO",
    "Land Area (units not specified in file)": 2.173,
    "Lease Term": 30,
    "Annual Lease Fee": 42,
    "Land Use Premium": null,
    "Number Of Local Employees": 178,
    "Number Of Foreign Employees": 20,
    Status: "Draft",
    "Investor Address":
      "အမှတ်၂၇၊ လှိုင်မြင့်မိုရ်၄လမ်း၊၁၀ရပ်ကွက်၊ လှိုင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၆၁+၆၂)၊ မြေတိုင်းရပ်ကွက် အမှတ်စက်မှုဇုန်(၂)၊ဒဂုံဆိပ်ကမ်းမြို့နယ် ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1802,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS.WWANG, QIUFEN",
    "Name of Principal Organization": "LIKUN(HK) CO.,LTD",
    "Place of Incorporation": "PEOPLE'S REPUBLIC OF CHINA",
    "Company Name In Myanmar": "MYANMAR HUA YUE GARMENT LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "049/2018",
    "Permit Date": "2018-04-30T09:42:25Z",
    "Meeting Number": "6/2018",
    "Meeting Date": "2018-04-11T09:42:40Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 2.692,
    "Total Amount Of Capital (in Millions)": 2.692,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW MYINT SHWE @ THEIN SHI KYU",
    "Land Area (units not specified in file)": 2.9,
    "Lease Term": 30,
    "Annual Lease Fee": 0.025,
    "Land Use Premium": null,
    "Number Of Local Employees": 1070,
    "Number Of Foreign Employees": 24,
    Status: "Draft",
    "Investor Address":
      "BUILDING NO.44-45, NO.777,YUYANG ROAD, KUNSHAN CITY, JIANGSU PROVINCE, PEOPLE;S REPUBLIC OF CHINA",
    "Organization Address":
      "BUILDING NO.44-45, NO.777,YUYANG ROAD, KUNSHAN CITY, JIANGSU PROVINCE, PEOPLE'S REPUBLIC OF CHINA",
    "Investment Permitted Address":
      "HOILDING NO-1/2 B, KWIN NO.632,ZIN PYUNN KONE KWIN, KALARKONE VILLAGE TRACT, HMAWBI TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1803,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမောင်မောင်အုန်း",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myint Myat Kyaww Group of Companies Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "945/2013",
    "Permit Date": "2013-11-19T10:03:36Z",
    "Meeting Number": "28/2013",
    "Meeting Date": "2013-10-30T10:03:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "တည်ဆောက်ရေးလုင်ငန်းသုံး ကော်လံ၊ ယက်မ၊ ဒိုင်း၊ မျှားတန်း၊ ကြမ်းခင်းစသော ဆောက်လုပ်ရေးသံထည်ပစ္စည်းများ (Steel Structure) နှင့် ခေတ်မီအမိုးပြားမျိုးစုံ ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 2.22,
    "Total Amount Of Capital (in Millions)": 3500,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်နီလာမြင့်",
    "Land Area (units not specified in file)": 1.96,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 98,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.527/529, Under Pazhuntaung Road, PaZhuntaung Township, Yangon Region",
    "Organization Address": "-",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ ဒဂုံဆိပ်ကမ်းမြို့နယ်၊ စက်မှုဇုန်(၂)၊ ဦးဖိုးလှိုင်လမ်း၊ မြေကွက် အမှတ်(၈၀)ရှိမြေ (၁.၉၆)ဧက",
  },
  {
    ID: 1804,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.WONG NGIE TECK",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "SOONLINMAS WOOD PANEL COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "048/2018",
    "Permit Date": "2018-04-11T12:20:48Z",
    "Meeting Number": "5/2018",
    "Meeting Date": "2018-03-21T12:21:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND DISTRIBUTION OF VENEER AND PLYWOOD BY USING RUBBER WOOD",
    "Amount Of Foreign Capital USD (in Millions)": 0.25,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Malaysia",
    "Form Of Investment": "JV",
    "Land Owner": "U AUNG KO OO",
    "Land Area (units not specified in file)": 3.6,
    "Lease Term": 50,
    "Annual Lease Fee": 12.48,
    "Land Use Premium": null,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": 6,
    Status: "Draft",
    "Investor Address":
      "NO.194, CHIN LEE GARDEN, 97000 BINTULU SARAWAK ,MALAYSIA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.181,MYAY TAING BLOCK NO.MYAUNG TAKAR INDUSTRIAL ZONE,HMAWBI TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1805,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဝင်းမြင့်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "High Win International Co., Ltd.",
    "Financial Year From": 2001,
    "Financial Year To": 2002,
    "Permit Number": "Ma Na Tha-523/2001",
    "Permit Date": "2001-11-18T03:48:25Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "ရေခဲစက်နှင့်အအေးခန်း စက်ရုံတည်\nဆောက်၍ ငါး ပုစွန်ပြုပြင် အေးခဲခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 116.68,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "High Win International Co., Ltd",
    "Land Area (units not specified in file)": 2.798,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် (၈၆)၊ ၄၉ လမ်း၊ ပုဇွန်တောင်မြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ရွှေပြည်သာမြို့နယ်၊ရပ်ကွက်အမှတ် -၃၉ (စက်မှု)၊ မြေကွက်အမှတ် - ၁၀၇၊ ၁၁၀",
  },
  {
    ID: 1806,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. SO, KAI SING",
    "Name of Principal Organization": "YUE WING CHEONG MANUFACTORY LTD.",
    "Place of Incorporation": "BRITISH VIRGIN ISLANDS",
    "Company Name In Myanmar": "MYANMAR YUE WING CHEONG MANUFACTORY LTD.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "717/2014",
    "Permit Date": "2014-04-11T04:08:50Z",
    "Meeting Number": "11/2014",
    "Meeting Date": "2014-03-29T04:09:14Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF ALL KINDS OF BAG ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.85,
    "Total Amount Of Capital (in Millions)": 0.85,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Virgin Islands (British)",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW NU NU YEE",
    "Land Area (units not specified in file)": 1.74,
    "Lease Term": null,
    "Annual Lease Fee": 0.08,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "FTD 5/F, WINNER BLDG, 36 MAN YUE STREET, HONG KONG",
    "Organization Address":
      "P.O BOX 3444, ROAD TOWN, TORTOLA, BRITISH VIRGIN ISLANDS",
    "Investment Permitted Address":
      "PLOT NO.84, MYAY TAING BLOCK NO.14, MIN AYEYAR STREET, SHWE THAN LWIN INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1807,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": " ဦးကျင်စိန် (ခ) လင်ကရန်စိန်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Great Lucky Star Garment Manufacturing Co., Ltd. (ကြီးမြတ်ကံကောင်းသော ကြယ်ပွင့်အထည်ချုပ်ထုတ်လုပ်မှုကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 2011,
    "Financial Year To": 2012,
    "Permit Number": "827/2011",
    "Permit Date": "2011-11-24T04:29:37Z",
    "Meeting Number": "25/2011",
    "Meeting Date": "2011-11-23T04:29:58Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် လက်အိတ် အမျိုးမျိုး ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.09,
    "Total Amount Of Capital (in Millions)": 22.92,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်ကြိုင်",
    "Land Area (units not specified in file)": 0.491,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 160,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၅-အေ/ဘီ၊ ဝင်ကမ္ဘာလမ်း၊ ဗိုလ်ချိုရပ်ကွက်၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၂၄+၂၅၊ မြေတိုင်းရပ်ကွက်အမှတ်-၄၂၊ စက်မှုလမ်းမကြီး၊ ရေွှပြည်သာစက်မှုဇုန်-၁၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1808,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမြင့်စိုး",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Shwe Sakar Co., Ltd. (ရွှေစကားကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 2011,
    "Financial Year To": 2012,
    "Permit Number": "830/2011",
    "Permit Date": "2011-12-13T04:59:05Z",
    "Meeting Number": "27/2011",
    "Meeting Date": "2011-12-07T04:59:28Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အထည်အမျိုးမျိုး ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.1,
    "Total Amount Of Capital (in Millions)": 50,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်မြတ်မြတ်မော်",
    "Land Area (units not specified in file)": 3.005,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 473,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၆၃၊ ၆လမ်း၊ ၂-ရပ်ကွက်၊ လမ်းမတော်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "-",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ သန်လျင်မြို့နယ်၊ အလွမ်းဆွတ်ကျေးရွာ၊ သံလျင်-သီလဝါလမ်း၊ အထည်ချုပ်စက်ရုံအမှတ် 18 နှင့် 19။",
  },
  {
    ID: 1809,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ဖြူဖြူလှိုင်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "First Image Garment Manufacturing Co., Ltd. (ပထမပုံရိပ် အထည်ထုတ်လုပ်မှု ကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 2011,
    "Financial Year To": 2012,
    "Permit Number": "833/2012",
    "Permit Date": "2012-01-17T05:37:41Z",
    "Meeting Number": "1/2012",
    "Meeting Date": "2012-01-03T05:38:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 223.52,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်ဖြူဖြူလှိုင်",
    "Land Area (units not specified in file)": 0.655,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 783,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၃၈၇၊ အခန်းအမှတ်-၁၊ စက်မှု-၁လမ်း၊ ဆရာစံရပ်ကွက်၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၅/၁၆၊ ကျန်စစ်သားလမ်းနှင့် အမရာလမ်းထောင့်၊ မြောက်ဥက္ကလာပစက်မှုဇုန်၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1810,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Bingxue Zhao",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Lian Cheng Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "801/2014",
    "Permit Date": "2014-09-18T07:18:32Z",
    "Meeting Number": "21/2014",
    "Meeting Date": "2014-08-15T06:11:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.504,
    "Total Amount Of Capital (in Millions)": 0.504,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Maung Maung Khaing",
    "Land Area (units not specified in file)": 1.102,
    "Lease Term": 10,
    "Annual Lease Fee": 0.025,
    "Land Use Premium": null,
    "Number Of Local Employees": 744,
    "Number Of Foreign Employees": 8,
    Status: "Monitoring Approved",
    "Investor Address":
      "Lane Thwe-89 Street, Shin Phu Street, Nan Hwun Ward, Chan KYan Twon, People's Republic of China",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLot No. 149, Hlaing Tharyar Industrial  Zone, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 1811,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mrs. Wei Chiu-Yen",
    "Name of Principal Organization": "Mingtex Fashion Co., Ltd.",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "JCK (Myanmar) International Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "745/2014",
    "Permit Date": "2014-07-08T08:09:19Z",
    "Meeting Number": "15/2014",
    "Meeting Date": "2014-05-31T08:11:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garements on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 5,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 34,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Mingaladon Industrial Park Co., Ltd.",
    "Land Area (units not specified in file)": 2.472,
    "Lease Term": 34,
    "Annual Lease Fee": 0.003,
    "Land Use Premium": 580232,
    "Number Of Local Employees": 839,
    "Number Of Foreign Employees": 14,
    Status: "Approved",
    "Investor Address":
      "No.42, Aly 161, Hexing Ln, Pitou Township, Changhua Country 523, Republic of China",
    "Organization Address":
      "Unit 1110, 11/F, Trendy Centre, 682-684 Castle Peak Road, Kowloon, Hong Kong",
    "Investment Permitted Address":
      "Plot No. A-5, Mingaladon Industrial Park, Mingaladon Township, Yangon Region",
  },
  {
    ID: 1812,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Cho Kwong Wong",
    "Name of Principal Organization": "Smart Fair Investments Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Dagon Talent Garment Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "700/2014",
    "Permit Date": "2014-04-02T08:42:49Z",
    "Meeting Number": "9/2014",
    "Meeting Date": "2014-03-12T08:43:16Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Thein Zan",
    "Land Area (units not specified in file)": 2.465,
    "Lease Term": 10,
    "Annual Lease Fee": 0.059,
    "Land Use Premium": null,
    "Number Of Local Employees": 603,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 22, Tai Yau Street, San Po Kong Kowloon, Hong Kong",
    "Organization Address":
      "No. 22, Tai Yau Street, San Po Kong Kowloon, Hong Kong",
    "Investment Permitted Address":
      "Plot No. 17, Myay Taing Block No. 143/1, Kyansitthar Yeik Mon Industrial Zone, South Dagon Myothit Township, Yangon Region",
  },
  {
    ID: 1813,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Hsu, Wei-Cheng",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Polar North Garment Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "753/2014",
    "Permit Date": "2014-08-08T08:44:10Z",
    "Meeting Number": "16/2014",
    "Meeting Date": "2014-06-13T08:44:55Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.0229,
    "Total Amount Of Capital (in Millions)": 1.0229,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Khin Thandar Thet",
    "Land Area (units not specified in file)": 1.003,
    "Lease Term": 30,
    "Annual Lease Fee": 0.02,
    "Land Use Premium": null,
    "Number Of Local Employees": 1510,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.4, Lane 232 Pao Chiao Road, Hsin-Tien (231),Taipei Taiwan, Republic of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Myay Taing Block No.18, Plot No.5(KA)+234(KA), Innwa Street, Shwe Paukkan Industrial Zone, North Okkalapa Township, Yangon Region",
  },
  {
    ID: 1815,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lee Kwok Sun, Thomas",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ZKG Asia Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "794/2014",
    "Permit Date": "2014-08-23T09:06:08Z",
    "Meeting Number": "20/2014",
    "Meeting Date": "2014-08-01T09:06:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.8264,
    "Total Amount Of Capital (in Millions)": 1.8264,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Soe Soe @ Soe Soe Than",
    "Land Area (units not specified in file)": 2.01,
    "Lease Term": 12,
    "Annual Lease Fee": 0.37,
    "Land Use Premium": null,
    "Number Of Local Employees": 1329,
    "Number Of Foreign Employees": 9,
    Status: "Monitoring Approved",
    "Investor Address":
      "RM-3708, Asia Trade Centre, 79 Lei Muk Road, Kwai Chung, NT, Hong Kong",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.50, Shwe Myodaw Zaydi Road, Yangon Industrial Zone, Mingalardon Garden City, Yangon Region",
  },
  {
    ID: 1816,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်သန်းသန်းဝင်း",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "All Super Manufacturing Co., Ltd. (အားလုံးအကောင်းဆုံး ထုတ်လုပ်မှုကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "957/2014",
    "Permit Date": "2014-02-10T09:09:42Z",
    "Meeting Number": "3/2014",
    "Meeting Date": "2014-01-24T09:10:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.2,
    "Total Amount Of Capital (in Millions)": 231.43,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 1.492,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 880,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "မြေကွက်အမှတ်-၃၂၄၊ မြေတိုင်းရပ်ကွက်အမှတ်-၁၉/၁၊ မက္ခရာမင်းသားကြီးလမ်း၊ ရွှေပေါက္ကံစက်မှုဇုန်၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၃၂၄၊ မြေတိုင်းရပ်ကွက်အမှတ်-၁၉/၁၊ မက္ခရာမင်းသားကြီးလမ်း၊ ရွှေပေါက္ကံစက်မှုဇုန်၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်",
  },
  {
    ID: 1817,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Nie Jun",
    "Name of Principal Organization":
      "Ningbo Yinzhou Daocheng Garment Company Limited",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Peach Garden Garments Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "849/2014",
    "Permit Date": "2014-10-31T09:12:23Z",
    "Meeting Number": "23/2014",
    "Meeting Date": "2014-10-10T09:12:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.36,
    "Total Amount Of Capital (in Millions)": 0.36,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw In Po",
    "Land Area (units not specified in file)": 1.591,
    "Lease Term": 15,
    "Annual Lease Fee": 66,
    "Land Use Premium": null,
    "Number Of Local Employees": 294,
    "Number Of Foreign Employees": 6,
    Status: "Monitoring Approved",
    "Investor Address":
      "114, Daping West Road, Fancheng District, Xiangfan City, Hubei Province, China",
    "Organization Address":
      "No.47, Wenwei Road, Guling Town, Yinzhou District, Ningbo City, Zhejiang Province, China",
    "Investment Permitted Address":
      "Plot No. 131, Myay Taing Block No 64 (Set Hmu), Min Gyi Mahar Minguaung Street, Shwe Pyi Thar Industrial Zone (3), Shwe Pyi Thar Township, Yangon",
  },
  {
    ID: 1820,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. HUANG, YEN-LIU @ MR. IAN LIOU  HUANG",
    "Name of Principal Organization": "LARGE GOLD INTERNATIONAL  CO., LTD.",
    "Place of Incorporation": "Samoa",
    "Company Name In Myanmar": "SHYANG JHUO YUE CO., LTD.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "702/2014",
    "Permit Date": "2014-04-03T09:36:22Z",
    "Meeting Number": "9/2014",
    "Meeting Date": "2014-03-12T09:36:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Shoes on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3.2,
    "Total Amount Of Capital (in Millions)": 3.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Samoa",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myint Soe and Daw Than Than Su ",
    "Land Area (units not specified in file)": 2.651,
    "Lease Term": 10,
    "Annual Lease Fee": 0.11,
    "Land Use Premium": null,
    "Number Of Local Employees": 387,
    "Number Of Foreign Employees": 13,
    Status: "Monitoring Approved",
    "Investor Address": "NO.147, RENHE ROAD, NANTOU CITY, NANTOU, TAIWAN",
    "Organization Address": "LEVEL 2, LOTEMAU CENTRE, VAEA STREET, APIA, SAMOA",
    "Investment Permitted Address":
      "Myay Taing Block No. 20, Plot No. K-9, Anawyahtar Industiral Zone, Hlaing Thar Yar Township, Yangon Region.",
  },
  {
    ID: 1822,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Myaing Than Toe Oo",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "THL Foundation Equipment (Myanmar) Company Limited",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1158/2016",
    "Permit Date": "2016-09-19T10:04:42Z",
    "Meeting Number": "17/2016",
    "Meeting Date": "2016-09-09T10:04:51Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Rental Services for Foundation Equipment",
    "Amount Of Foreign Capital USD (in Millions)": 2.8,
    "Total Amount Of Capital (in Millions)": 3.03,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "U Aye Naing + U Myaing Than Toe Oo",
    "Land Area (units not specified in file)": 0.41,
    "Lease Term": 20,
    "Annual Lease Fee": 0.01,
    "Land Use Premium": null,
    "Number Of Local Employees": 28,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "Room No.004, Building 8, 154 th Street, Tamwe Gyi (A+C) Quarter, Tamwe Township, Yangon. ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No. A-77, Myay Taing Block No. 66, Innwa Housing, South Dagon Township, Plot No. 1839/1840, Myay Taing Block No.61, Yadanar Street, Dagon Myothit (Seik Kan) Township, Yangon.",
  },
  {
    ID: 1823,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. He Wei",
    "Name of Principal Organization":
      "Haoyang  International Trading Co., Ltd.",
    "Place of Incorporation": "British Virgin Islands(BVI)",
    "Company Name In Myanmar": "Haoyang International Garment Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "800/2014",
    "Permit Date": "2014-09-18T10:11:25Z",
    "Meeting Number": "21/2014",
    "Meeting Date": "2014-08-15T10:12:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.8128,
    "Total Amount Of Capital (in Millions)": 0.8128,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Virgin Islands (British)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Tin Win and U Tin Oo",
    "Land Area (units not specified in file)": 2.117,
    "Lease Term": 30,
    "Annual Lease Fee": 0.043,
    "Land Use Premium": null,
    "Number Of Local Employees": 383,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "Room.1202, No.32, WuWu Road, Zhongshan District, Dalian T 116001,Padauk Street, Shwe Lin Pan Industrial Zone, Hlaing Tharyar Township, Yangon Region",
    "Organization Address":
      "1-25-1, No.15 Section C1, Xinghai Square, Shahekou District, Dalian City, People's Republic of China",
    "Investment Permitted Address":
      "Plot No.497, Myay Taing Quarter No.25 Padauk Street, Shwe Lin Pan Industrial  Zone, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 1824,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U THET LWIN@LIN HTIKE HOKE",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "TM WINDMILL COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "741/2014",
    "Permit Date": "2014-07-08T04:23:30Z",
    "Meeting Number": "15/2014",
    "Meeting Date": "2014-05-31T04:23:51Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF GARMENT AND\nCLOTHINGS ON CMP BASIS\n",
    "Amount Of Foreign Capital USD (in Millions)": 1.2642,
    "Total Amount Of Capital (in Millions)": 1.6856,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "U Thet Lwin @ Lin Htike Hoke",
    "Land Area (units not specified in file)": 2.128,
    "Lease Term": 30,
    "Annual Lease Fee": 0.047,
    "Land Use Premium": null,
    "Number Of Local Employees": 520,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. (55), 6th FLOOR, LANTHIT STREET, WARD NO. (3),  LANMADAW TOWNSHIP, YANGON REGION",
    "Organization Address": "-",
    "Investment Permitted Address":
      "MYAY TAING BLOCK NO. (ZONE 2) , PLOT NO. (2), INDUSTRIAL ZONE NO.(2), DAGON SEIKKAN TOWNSHIP, YANGON REGION ",
  },
  {
    ID: 1825,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Lin Lin Zhang",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Chinadawn Garment Myanmar Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "740/2014",
    "Permit Date": "2014-07-08T04:53:43Z",
    "Meeting Number": "15/2014",
    "Meeting Date": "2014-05-31T04:53:50Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.907,
    "Total Amount Of Capital (in Millions)": 0.907,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myo Nyunt, U Ye Lwin, U Nay Linn, U Kyaw Htoo",
    "Land Area (units not specified in file)": 2.007,
    "Lease Term": 10,
    "Annual Lease Fee": 0.049,
    "Land Use Premium": null,
    "Number Of Local Employees": 456,
    "Number Of Foreign Employees": 8,
    Status: "Monitoring Approved",
    "Investor Address":
      "4-3-3-1, Hongye Square, Zhongshan District, Dalian, People's Republic of China",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Myay Taing Block No. 65 (Set Mu), Plot No. 40, Shwe Pyi Thar Industrial Zone 4, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 1826,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Mr Ho Chi Meng",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Ford Glory (Myanmar) Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "781/2014",
    "Permit Date": "2014-08-14T05:08:48Z",
    "Meeting Number": "18/2014",
    "Meeting Date": "2014-07-09T05:23:56Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.6364,
    "Total Amount Of Capital (in Millions)": 0.6364,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaw Lin (a) Chong Siao Ngaw",
    "Land Area (units not specified in file)": 1.525,
    "Lease Term": 30,
    "Annual Lease Fee": 0.037,
    "Land Use Premium": null,
    "Number Of Local Employees": 980,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "EST Marginal Hipodromo S/N, EDF Wan Keng Blo-1, 28-And-C, Macau, China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Myay Taing Quarter No 42, Plot No. 132, Set Hmu 7th Street, Shwe Pyi Thar Industrial Zone (1), Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 1827,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Tseng, Chen - Chuan    ",
    "Name of Principal Organization": "Shantou City Betterway Inc",
    "Place of Incorporation": "The People's Republic of China",
    "Company Name In Myanmar": "Xiamen Morning (Myanmar) Co,Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "779/2014",
    "Permit Date": "2014-08-14T08:38:46Z",
    "Meeting Number": "18/2014",
    "Meeting Date": "2014-07-09T08:38:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of clothing and various kinds of underwear on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.1,
    "Total Amount Of Capital (in Millions)": 2.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Lin",
    "Land Area (units not specified in file)": 1.51,
    "Lease Term": 30,
    "Annual Lease Fee": 0.032,
    "Land Use Premium": null,
    "Number Of Local Employees": 1165,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address":
      "3-5, West Economic Development Area, (Yi-Ying Industrial), Xlashan, Chaonan District, Shantou, Guangdong, The People's Republic of China",
    "Organization Address":
      "3-5, West Economic Development Area, (Yi-Ying Industrial), Xlashan, Chaonan District, Shantou, Guangdong, The People's Republic of China",
    "Investment Permitted Address":
      "Plot No.(373), MyayTaing Quarter No. (25),\nDaw Phwar Shin Street, ShweLin Ban Industrial Zone, Hlaing Thar Yar Township,\nYangon Region\n",
  },
  {
    ID: 1828,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kong Kyin Fu",
    "Name of Principal Organization":
      "Agencia Comercial Wai Yuen Company Limited",
    "Place of Incorporation": "Macao",
    "Company Name In Myanmar": "Fu Yuen Garment Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "771/2014",
    "Permit Date": "2014-08-13T03:17:25Z",
    "Meeting Number": "16/2014",
    "Meeting Date": "2014-06-13T03:17:39Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.9006,
    "Total Amount Of Capital (in Millions)": 1.9006,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Kyauk Chi Phone",
    "Land Area (units not specified in file)": 6.002,
    "Lease Term": 30,
    "Annual Lease Fee": 0.127,
    "Land Use Premium": null,
    "Number Of Local Employees": 1635,
    "Number Of Foreign Employees": 50,
    Status: "Monitoring Approved",
    "Investor Address":
      "Estrada Lou Lim Ieok No. 711-789, ED. Jade Garden, 5 Andar Da. Taipa Macau",
    "Organization Address":
      "Avenida De Venceslau De Morais No. 221, Nam Fong Kong IP Tai Ha, Bloco 1, 5 Andar B, EM Macau",
    "Investment Permitted Address":
      "Plot No 198/1, Kanaung Min Thar Gyi Road, Industrial Zone (1), Dagon Seik Kan Township, Yangon Region",
  },
  {
    ID: 1829,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhou Jun",
    "Name of Principal Organization": "Hangzhou Yongan Garment Co.,Ltd",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "YONGAN  (MYANMAR) FASHION  CO.,LTD",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "902/2015",
    "Permit Date": "2015-02-13T03:38:16Z",
    "Meeting Number": "2/2015",
    "Meeting Date": "2015-01-31T03:38:25Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.6963,
    "Total Amount Of Capital (in Millions)": 1.6963,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyinn Maung",
    "Land Area (units not specified in file)": 9599.15,
    "Lease Term": 20,
    "Annual Lease Fee": 0.053,
    "Land Use Premium": null,
    "Number Of Local Employees": 1051,
    "Number Of Foreign Employees": 36,
    Status: "Monitoring Approved",
    "Investor Address":
      "RM - 1-402, Flat Zhoung Jiang Garden Hangzhou Ching, Peoples' Republic of China",
    "Organization Address":
      "Floor 4, Building 2, No.11 Hongpubei \nRoad, Qiaosi Subdistrict, Yuhang\n District, Hangzhou City, China.\n",
    "Investment Permitted Address":
      "Plot  No.409, Myay Taing Quarter  No.25, U Phoe Hlaing  Street, Shwe  Lin Ban Industrial Zone, Hlaing \tTharyar  Township, Yangon Region.",
  },
  {
    ID: 1830,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးရဲအောင်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Pyinsa Thondaye Co., Ltd. (ပဥ္စသုန္ဒရီကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 2011,
    "Financial Year To": 2012,
    "Permit Number": "823/2011",
    "Permit Date": "2011-11-23T04:08:28Z",
    "Meeting Number": "24/2011",
    "Meeting Date": "2011-11-16T04:08:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 289.01,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးရဲအောင်",
    "Land Area (units not specified in file)": 0.518,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၅၇/ဘီ၊ ဝေဠုဝန်လမ်း၊ ဝေဠုဝန် (တောင်ပိုင်း)ရပ်ကွက်၊ စမ်းချောင်းမြို့နယ်၊ ရန်ကုန်",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၆၈/၆၉၊ မြေတိုင်းရပ်ကွက်အမှတ်-၁၈၊ ဗိုလ်တေဇလမ်း၊ ရေွှပေါက်ကံစက်မှုဇုန်၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်",
  },
  {
    ID: 1831,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chen, Tsung-Tse",
    "Name of Principal Organization": "Great Ambitious Trading Ltd.",
    "Place of Incorporation": "Brunei Darussalam",
    "Company Name In Myanmar": "Gold Empire (Myanmar) Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "780/2014",
    "Permit Date": "2014-09-16T04:05:09Z",
    "Meeting Number": "18/2014",
    "Meeting Date": "2014-07-09T04:05:28Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Optical Electronic Instruments",
    "Amount Of Foreign Capital USD (in Millions)": 5.209,
    "Total Amount Of Capital (in Millions)": 5.209,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 5,
    "Investing Country": "Brunei Darussalam",
    "Form Of Investment": "FDII",
    "Land Owner": "U Khin Htwe",
    "Land Area (units not specified in file)": 6.43,
    "Lease Term": 5,
    "Annual Lease Fee": 0.1,
    "Land Use Premium": null,
    "Number Of Local Employees": 634,
    "Number Of Foreign Employees": 30,
    Status: "Approved",
    "Investor Address":
      "4 F, No. 187, Sec.1, Zhongshan Road, Banqlao Dist, New Taipei City, The People's Republic of China",
    "Organization Address":
      "Room 51, 5th Fl, Britannia House, Jalan Cator, Bandar Seri Begawan BS 8811, Negara Brunei Darussalam",
    "Investment Permitted Address":
      "Plot No.33/1+33/Ka/1+33/Ka/2+34Ka/1, Block No.560, Lakepoot Taw Village. , Hmawbi, YANGON",
  },
  {
    ID: 1832,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဆောင်ညွှန်ကြားရေးမှူး",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Global New Light of Myanmar Co., Ltd. (ဂလိုဘယ်နယူးလိုက်အော့ဖ် မြန်မာကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "971/2014",
    "Permit Date": "2014-03-24T04:21:27Z",
    "Meeting Number": "8/2014",
    "Meeting Date": "2014-03-05T04:21:51Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သတင်းစာ ထုတ်ဝေဖြန့်ချိရောင်းချခြင်းလုပ်ငန်း၊ ၎င်းနှင့်ဆက်စပ်သည့် ကြော်ငြာလုပ်ငန်း နှင့် ပြင်ပပုံနှိပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 4.92,
    "Total Amount Of Capital (in Millions)": 12825,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ပြန်ကြားရေးဝန်ကြီးဌာန၊ သတင်းစာနှင့် စာနယ်ဇင်းလုပ်ငန်း",
    "Land Area (units not specified in file)": 0.9,
    "Lease Term": 30,
    "Annual Lease Fee": 216,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "သတင်းစာနှင့်စာနယ်ဇင်းလုပ်ငန်း၊ ရုံးအမှတ်-၇၊ ပြန်ကြားရေးဝန်ကြီးဌာန၊ နေပြည်တော်",
    "Organization Address": "-",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ ဗဟန်းမြို့နယ်၊ ငါးထပ်ကြီးဘုရားလမ်း၊ အမှတ် (၁၅၀)၊ မြေကွက်အမှတ် (၄၇၃/အေ၄)၊ မြေတိုင်းရပ်ကွက်အမှတ်(၂/ဂျီ၁) ရှိ မြေ (၀.၉၁)ဧက",
  },
  {
    ID: 1833,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်နုနုလွင်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Global Footwear Manufacturing Co., Ltd. (ကမ္ဘာ့ဖိနပ် စက်မှုထုတ်လုပ်မှုကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 2011,
    "Financial Year To": 2012,
    "Permit Number": "832/2011",
    "Permit Date": "2011-12-19T04:44:30Z",
    "Meeting Number": "26/2011",
    "Meeting Date": "2011-11-30T04:44:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် ဖိနပ်ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်နုနုလွင်",
    "Land Area (units not specified in file)": 1.5,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၄၅)၊ အခန်းအမှတ်(၂)၊ သမိန်ဗရမ်းလမ်း၊ နတ်ချောင်းရပ်ကွက်၊ တာမွေမြို့နယ်၊ ရန်ကုန်",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၈၁/၁၈၂)၊ ငုဝါလမ်း၊ အနော်ရထာလမ်းမကြီး၊ လှိုင်သာယာစက်မှုဇုန် အပိုင်း(၅)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်",
  },
  {
    ID: 1834,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမြတ်သူ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Paragon Printing Manufacturing Co., Ltd. (စံပုံနှိပ်ခြင်းထုတ်လုပ်မှုကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 2011,
    "Financial Year To": 2012,
    "Permit Number": "825/2011",
    "Permit Date": "2011-11-13T05:18:14Z",
    "Meeting Number": "24/2011",
    "Meeting Date": "2011-11-16T05:20:20Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် နိုင်ငံတကာ အဆင့်မီ အထည်ပန်း ရိုက်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.66,
    "Total Amount Of Capital (in Millions)": 475.77,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "ဦးချစ်စု(ခ)ဦးသိန်းဟန်၊ ဒေါ်နန်းအေးဖြင့်၊ ဒေါ်နန်းဟွမ်နှင့် ဦးစိုင်းလုံ(ခ)ဦးအိုက်လုံ",
    "Land Area (units not specified in file)": 5.4,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၁-ဘီ/၆၊ ယုဇနလမ်း၊ သာယာကုန်းရပ်ကွက်၊ မင်္ဂလာတောင်ညွန့်မြို့နယ်၊ ရန်ကုန်",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၀၄/ခ၊ စက်မှုဇုန်-၁၊ ဒဂုံမြို့သစ်ဆိပ်ကမ်းမြို့နယ်၊ ရန်ကုန်",
  },
  {
    ID: 1835,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chukiat Hutasuwan",
    "Name of Principal Organization": "Theparerg Company Limited",
    "Place of Incorporation": "Thailand",
    "Company Name In Myanmar": "Golden Therparerg Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "892/2015",
    "Permit Date": "2015-02-04T04:38:43Z",
    "Meeting Number": "1/2015",
    "Meeting Date": "2015-01-16T04:46:10Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 6.076,
    "Total Amount Of Capital (in Millions)": 6.26,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "No.2, Heavy Industries Enterprise",
    "Land Area (units not specified in file)": null,
    "Lease Term": 25,
    "Annual Lease Fee": 225,
    "Land Use Premium": null,
    "Number Of Local Employees": 1532,
    "Number Of Foreign Employees": 24,
    Status: "Monitoring Approved",
    "Investor Address":
      "45 Soi 21 Puttamonthol Sai 2 Road, Sala Thammasop, Taweewattana, Bangkok, Thailand 10170",
    "Organization Address":
      "66/2-6 Moo 4, Khok-Krabue, Muaung Samutsakorn, Samutsakorn 74000 Thailand",
    "Investment Permitted Address":
      "No (476),Mogoke Street, 23-Ward,Industrial Zone 1., Dagon Myo Thit Township, Yangon",
  },
  {
    ID: 1837,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်သက်ထားဆွေ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Hallmark Manufacturing Co., Ltd. (ရွှေခဲ၊ ငွေခဲ မှန်ကြောင်း လက္ခဏာ ထုတ်လုပ်မှုကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 2011,
    "Financial Year To": 2012,
    "Permit Number": "824/2011",
    "Permit Date": "2011-11-23T07:41:38Z",
    "Meeting Number": "24/2011",
    "Meeting Date": "2011-11-16T07:42:19Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 50,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးမောင်မောင်လွင် + မတင်စန်း",
    "Land Area (units not specified in file)": 0.94,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၂၃/၁၂၊ အင်းယားမြိုင်လမ်း၊ ရေွှတောင်ကြားရပ်ကွက်၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၅၂-က၊ မြတောင်ဝန်ကြီးဦးမှိုလမ်း၊ စက်မှုဇုန်-၁၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်",
  },
  {
    ID: 1838,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမြင့်ဝေ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Wa Minn MIning Co., Ltd. (ဝမင်းသတ္တုတူးဖော်ရေးလုပ်ငန်း ကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 2011,
    "Financial Year To": 2012,
    "Permit Number": "822/2011",
    "Permit Date": "2011-11-23T07:54:33Z",
    "Meeting Number": "24/2011",
    "Meeting Date": "2011-11-16T07:54:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 127.5,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးမောင်ရင်",
    "Land Area (units not specified in file)": 1.05,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၆၆၉-စီ၊ မြကန်သာလမ်း၊ ပြည်လမ်း၊ ကမာရွတ်မြို့နယ်၊ ရန်ကုန်",
    "Organization Address": "-",
    "Investment Permitted Address":
      "အမှတ်-၁၁၆၊ သမိုင်းလမ်းဆုံ(၂)ရပ်ကွက်၊ ကြွေရည်စိမ်ပစ္စည်းစက်ရုံ၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး။",
  },
  {
    ID: 1840,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်သန်း",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "National Pride Industry Ltd.",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "229/99",
    "Permit Date": "1999-02-26T08:27:50Z",
    "Meeting Number": "3/99",
    "Meeting Date": "1999-01-29T08:28:24Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "ပလတ်စတစ်ပီနန်အိတ်များထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 110,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 1.89,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၃၅၊ ညောင်တန်းစျေးလမ်း၊ ပုဇွန်တောင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၆၆၊ စက်မှုဇုန်(၃)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်",
  },
  {
    ID: 1841,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်အေးအေးဟန်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Shweyi-Zabe Garment Manufacturing Co., Ltd.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "404/2000",
    "Permit Date": "2000-07-12T08:40:38Z",
    "Meeting Number": "15/2000",
    "Meeting Date": "2000-05-26T08:42:02Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အထည်အမျိုးမျိုး ချုပ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 71.8,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်အေးအေးဟန်",
    "Land Area (units not specified in file)": 0.957,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်-၁၀၉၊ ရှမ်းလမ်း၊ အလုံမြို့နယ်၊ ရန်ကုန်",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၂၅၊ စက်မှုဒေသ၊ မြေတိုင်းရပ်ကွက်အမှတ်-၆၄(စက်မှုဇုန်)၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်",
  },
  {
    ID: 1842,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးရှန်မုန်း",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Tycoon International Co., Ltd. (အပြည်ပြည်ဆိုင်ရာ လုပ်ငန်းရှင်ကြီး ကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "418/2000",
    "Permit Date": "2000-08-18T08:50:43Z",
    "Meeting Number": "20/2000",
    "Meeting Date": "2000-06-23T08:51:09Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အသင့်ချုပ်ပြီး အထည်များ ထုတ်လုပ်သည့် လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 59.8,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးရှန်မုန်း",
    "Land Area (units not specified in file)": 0.992,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အကွက်အမှတ်-၁၂၂ ဖန်ချက်ဝန်ဦးမြူးလမ်း၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၂၂၊ ဖန်ချက်ဝန်ဦးမြူးလမ်း၊ စက်မှုဇုန်(၁)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန် ",
  },
  {
    ID: 1843,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yang Chang Ho",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar Dabee Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "703/2014",
    "Permit Date": "2014-04-02T05:13:48Z",
    "Meeting Number": "10/2014",
    "Meeting Date": "2014-03-19T05:14:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.59,
    "Total Amount Of Capital (in Millions)": 0.59,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Toe Toe Myint",
    "Land Area (units not specified in file)": 2.246,
    "Lease Term": 50,
    "Annual Lease Fee": 0.051,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 202, Kingsbill Town, 22-11, Backhon-Dong, Kyeyang-gu, Incheon, Korea.",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No. (153), Myay Taing Block No-18,  Hlaing Thar Yar Industrial Zone (5) Extension, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 1844,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Khin  Maung Win",
    "Name of Principal Organization": "Super Mega Engineers Group Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Futami Mega Engineering  Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "870/2014",
    "Permit Date": "2014-12-09T06:14:23Z",
    "Meeting Number": "27/2014",
    "Meeting Date": "2014-11-21T06:14:52Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing, Fabrication and Galvanizing of Steel Products",
    "Amount Of Foreign Capital USD (in Millions)": 1.7156,
    "Total Amount Of Capital (in Millions)": 3.4312,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "U Khin Maung Win",
    "Land Area (units not specified in file)": 1.358,
    "Lease Term": 50,
    "Annual Lease Fee": 0.028,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.6/601, Yuzana Tower, Ko Min Ko Chin Street, West Shwegon Daing Ward, Bahan Township, Yangon",
    "Organization Address":
      "Plot No.193/197, Shu Khin Thar Street, North Okkalapa Industrial Zone, North Okkalapa Township, Yangon",
    "Investment Permitted Address":
      "Plot No.94, Setmu Road, Myaung Dagar Inudstrial Zone, Hmawbi Township, Yangon Region",
  },
  {
    ID: 1847,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Tian Liangming",
    "Name of Principal Organization": "East Southern Enterprises Limited",
    "Place of Incorporation": "People's Republic of China",
    "Company Name In Myanmar": "Jinli Knitting & Spinning Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "844/2014",
    "Permit Date": "2014-10-31T07:04:26Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T07:04:57Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Knitwear on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.7,
    "Total Amount Of Capital (in Millions)": 1.7,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Myint Myint Yi and U Aung Myint",
    "Land Area (units not specified in file)": 3.99,
    "Lease Term": 30,
    "Annual Lease Fee": 0.084,
    "Land Use Premium": null,
    "Number Of Local Employees": 1220,
    "Number Of Foreign Employees": 50,
    Status: "Monitoring Approved",
    "Investor Address":
      "Group 3, Miaoxia, Dongnan Village, Hengcun Town, Tonglu County, Zhejiang Province, People's Republic of China",
    "Organization Address":
      "115 Cheng Shan Road, Nabtong City, Jian Su , China",
    "Investment Permitted Address":
      "Plot No.263,264,265, Myay Taing Block No.25, Shwe Lin Ban Industrial Zone, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 1848,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Huang Peng",
    "Name of Principal Organization":
      "York Fashion Manufacture Co., (Qingdao) Ltd.",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Myanmar York Fashion Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "701/2014",
    "Permit Date": "2014-04-02T07:27:52Z",
    "Meeting Number": "9/2014",
    "Meeting Date": "2014-03-12T07:28:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 6.55,
    "Total Amount Of Capital (in Millions)": 6.55,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner":
      "U Yan Kyi Oo (a) U Tun Sein, Daw Phyu Phyu Win (a) Daw Shaung Chin ",
    "Land Area (units not specified in file)": 3.056,
    "Lease Term": 10,
    "Annual Lease Fee": 0.216,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "41/Floor, No.9, Danghaixi Road, Qingdao, The People's Republic of China",
    "Organization Address":
      "No. 398, Huashansan Road, Jimo City, Qingdao, he People's Republic of China",
    "Investment Permitted Address":
      "Plot No. 168, Kyansitthar Street, Industrial Zone 4, HLaing Tharyar Township, Yangon Region",
  },
  {
    ID: 1849,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Kyaw Soe Han",
    "Name of Principal Organization": "Shwe Taung Development Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Fosroc Myanmar Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "843/2014",
    "Permit Date": "2014-10-31T07:28:08Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T07:28:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Additives for Concrete and Cement",
    "Amount Of Foreign Capital USD (in Millions)": 1.184,
    "Total Amount Of Capital (in Millions)": 1.692,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "United Arab Emirates",
    "Form Of Investment": "JV",
    "Land Owner": "Great Shwe Taung Co., Ltd.",
    "Land Area (units not specified in file)": 2.041,
    "Lease Term": 50,
    "Annual Lease Fee": 72,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "67(A), Bahosi Housing, Wardan Street, Lanmadaw Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot B-2, Myay Taing Blcok No.21, Mya Sein Yaung Industrial Zone-3, Hlaing Tharyar Township,Yangon Region",
  },
  {
    ID: 1850,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Shupeng Xie",
    "Name of Principal Organization": "KAMSBERG      LIMITED",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "                  KBL     FASHION      LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "861/2014",
    "Permit Date": "2014-12-09T07:38:49Z",
    "Meeting Number": "27/2014",
    "Meeting Date": "2014-11-28T07:40:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Business         MANUFACTURING    OF    GARMENT     ON CMP   BASIS   ",
    "Amount Of Foreign Capital USD (in Millions)": 0.5,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Sein Thaung Oo ",
    "Land Area (units not specified in file)": 0.792,
    "Lease Term": 10,
    "Annual Lease Fee": 0.016,
    "Land Use Premium": null,
    "Number Of Local Employees": 236,
    "Number Of Foreign Employees": 7,
    Status: "Monitoring Approved",
    "Investor Address":
      "Room 401, 4/F, Block 4, Yi Jing Ju, Chao Zhou Da Dao, Xiang Qiao Qu, Chao Zhou Shi, Guang Dong, China.",
    "Organization Address":
      "UNIT 1506 15/F1, ONE   HARBOURFRONT, 18 TAK FUNG  STREET,  HUNG    HOM,  KOWLOON, HONG  KONG",
    "Investment Permitted Address":
      "PLOT NO. 172, BLOCK   NO. EXTENSION - 5, HLAING THAR YAR INDUSTRIAL ZONE, HLAING THARYAR TOWNSHIP,   YANGON     REGION",
  },
  {
    ID: 1851,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးသန်းထွန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "တူရိယာသံစဉ်ထုတ်လုပ်မှုကုမ္ပဏီလီမိတက် (Sonata Manufacturing Company Limited)",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "မနသ-၁၀၃၅/၂၀၁၅",
    "Permit Date": "2015-02-13T07:49:25Z",
    "Meeting Number": "၂/၂၀၁၅",
    "Meeting Date": "2015-01-31T07:49:50Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် ထီးမျိုးစုံထုတ်လုပ်တပ်ဆင် ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.102,
    "Total Amount Of Capital (in Millions)": 780,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 555,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် (၁၀၁/၁၀၆)၊ မက္ခရာမင်းသားကြီးလမ်း၊ စက်မှုဇုန် (၂)၊ ဒဂုံမြို့သစ် (ဆိပ်ကမ်း)မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၀၅ နှင့် ၁၀၆၊ ဒဂုံစက်မှုဇုန် (၂)၊ ဒဂုံမြို့သစ် (ဆိပ်ကမ်း) မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသ ကြီး",
  },
  {
    ID: 1852,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yeo Meng Huat",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "FTE Corporation (Myanmar) Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "840/2014",
    "Permit Date": "2014-10-31T07:52:51Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T07:54:22Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and marketing of mini transformer with surface mount technology, coils, antenna, smt assembly, EMI line filter, swithching transformer for medical equipment, automotive and related products",
    "Amount Of Foreign Capital USD (in Millions)": 3.16,
    "Total Amount Of Capital (in Millions)": 3.16,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "U Shan Paw",
    "Land Area (units not specified in file)": 1.198,
    "Lease Term": 5,
    "Annual Lease Fee": 6.5,
    "Land Use Premium": null,
    "Number Of Local Employees": 436,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "10 Mugliston Road, Singpore 437721",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No. 151, Myinwun U Aung Thu Street, Industrial Zone 2, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 1854,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Philipp Hoffmann",
    "Name of Principal Organization": "JJ-PUN(S) PTE LTD.           ",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "JJ-PUN TIOSTONE COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "699/2014",
    "Permit Date": "2014-04-02T08:26:42Z",
    "Meeting Number": "6/2014",
    "Meeting Date": "2014-02-13T08:27:03Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING  AND MARKETING OF HIGH QUALITY CONCRETE BLOCKS \n",
    "Amount Of Foreign Capital USD (in Millions)": 1.08,
    "Total Amount Of Capital (in Millions)": 1.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Ah Mar Kyu ",
    "Land Area (units not specified in file)": 2.24,
    "Lease Term": 10,
    "Annual Lease Fee": 0.045,
    "Land Use Premium": null,
    "Number Of Local Employees": 68,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address": "SPERBERWEG 37, 21244 BUCHHOLZ, GERMANY",
    "Organization Address":
      "2 CORPORATION ROAD # 03 - 06 CORPORATION PLACE (MAIN LOBBY)     SINGAPORE. 618494",
    "Investment Permitted Address":
      "PLOT NO. 57, U SHWE BIN      STREET, DAGON SEIKKAN INDUSTRIAL ZONE (1), DAGON SEIKKAN  TOWNSHIP , YANGON  REGION",
  },
  {
    ID: 1855,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. NG YIU KWOK RINGO",
    "Name of Principal Organization": "SILVER SPRING ENTERPRISES LTD.",
    "Place of Incorporation": "BRITISH VIRGIN ISLANDS",
    "Company Name In Myanmar": "MYANMAR SILVER SPRING ENTERPRISES LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "723/2014",
    "Permit Date": "2014-04-29T09:37:50Z",
    "Meeting Number": "10/2014",
    "Meeting Date": "2014-03-19T09:38:19Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF GARMENTS AND CLOTHINGS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 8.5608,
    "Total Amount Of Capital (in Millions)": 8.5608,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Virgin Islands (British)",
    "Form Of Investment": "",
    "Land Owner": "PERFECT GEAR LIMITED",
    "Land Area (units not specified in file)": 6.75,
    "Lease Term": 30,
    "Annual Lease Fee": 0.143,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "18/F, BLOCK E, CLIFFVIEW MANSION, 25 CONDUIT ROAD, CENTRAL, MID-LEVEL, HONG KONG",
    "Organization Address":
      "19/F, ADP PENTAGON CENTRE, 98 TEXACO ROAD, TSUEN WAN, HONG KONG",
    "Investment Permitted Address":
      "PLOT NO. 114, 115 & 141, MYAY TAING BLOCK NO. 113, PANTEWUN U SHWE BIN STREET, EAST DAGON INDUSTRIAL ZONE, DAGON MYO THIT (EASTERN) , TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1856,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ချမ်းမြေ့သီတာ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Chan Mye Thida Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "988/2014",
    "Permit Date": "2014-07-04T09:51:50Z",
    "Meeting Number": "17/2014",
    "Meeting Date": "2014-06-20T09:52:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Jewellery & Gift Boxes များ ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.3,
    "Total Amount Of Capital (in Millions)": 578.98,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U SAI SOE TIN WIN",
    "Land Area (units not specified in file)": 0.072,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်- အိုင်/၂၂၊ ငုဝါလမ်း၊ ၄ ရပ်ကွက်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ လှိုင်သာယာမြို့နယ်၊ မြေတိုင်းရပ်ကွက်အမှတ်-၁၊ မြေကွက်အမှတ် (၁/ယ) ရှိ မြေ ၀.၀၇၂ ဧက",
  },
  {
    ID: 1857,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U MIN BANYAR SANN",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "MAN SUM (MYANMAR) GARMENT TEXTILES MFG. CO., LTD.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "767/2014",
    "Permit Date": "2014-08-08T09:58:11Z",
    "Meeting Number": "17/2014",
    "Meeting Date": "2014-06-20T09:58:29Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.27,
    "Total Amount Of Capital (in Millions)": 1.411,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "U MOE TIN ",
    "Land Area (units not specified in file)": 1.826,
    "Lease Term": 10,
    "Annual Lease Fee": 0.043,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 77/D, SHIN SAW PU STREET, AUNG CHAN THAR QUARTER, SANCHAUNG TOWNSHIP, YANGON REGION",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 20, BLOCK NO.2, PART 2, SETMU QUARTER, HLAING THAR YAR TOWNSHIP, YANGON",
  },
  {
    ID: 1858,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးရန်အောင်ဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Jing Ying International Building Materials Development Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "987/2014",
    "Permit Date": "2014-07-02T10:06:05Z",
    "Meeting Number": "16/2014",
    "Meeting Date": "2014-06-13T10:06:21Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Gypsum Board များ ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 2.56,
    "Total Amount Of Capital (in Millions)": 5103.07,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးရန်အောင်ဝင်း",
    "Land Area (units not specified in file)": 3.188,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် (၁၄၈-ဂျီ)၊ အေဝမ်းခြံလမ်း၊ ၅ ရပ်ကွက်၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ ရွှေပြည်သာမြို့နယ်၊ သာဓုကန်စက်မှုဇုန်၊ မြေတိုင်းရပ်ကွက်အမှတ်-၅၀၊ မြေကွက်အမှတ်-၄၂ ရှိ မြေ ၃.၁၈၈ ဧက",
  },
  {
    ID: 1859,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမောင်ဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "KK Finishing Net Factory Co., Ltd.",
    "Financial Year From": 0,
    "Financial Year To": 0,
    "Permit Number": "မနသ-၈၉၁/၂၀၁၃",
    "Permit Date": "2013-03-13T10:11:49Z",
    "Meeting Number": "၉/၂၀၁၃",
    "Meeting Date": "2013-02-27T10:12:17Z",
    Sector: "",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 0,
    "Currency Of Total Amount": "",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "",
    "Form Of Investment": "",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "အမှတ် ၁၇၂၊ ပထမထပ်၊ ကျုံးကြီးလမ်း၊ (၇) ရပ်ကွက်၊ လမ်းမတော်မြို့နယ်၊ ရန်ကုန်တိုင်း ဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ် ၁၂၄၊ ၁၂၅၊ ဆိပ်ကမ်းသာလမ်းနှင့် ဦးမြူး လမ်းထောင့့်၊ စက်မှုဇုန် (၁)၊ လှိုင်သာယာစက်မှု ဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1862,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LAU CHU",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "PROSPERITY KNITWEAR LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "811/2014",
    "Permit Date": "2014-10-15T04:09:51Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T04:10:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF KNITWEAR ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 2.85,
    "Total Amount Of Capital (in Millions)": 2.85,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW WAH WAH AUNG ",
    "Land Area (units not specified in file)": 1.836,
    "Lease Term": 10,
    "Annual Lease Fee": 180,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "UNIT A 30/F, CENTURY TOWER I, 1 TREGUNTER PATH, HONG KONG ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 40,41,42 KANAUNG MINTHAGYI STREET, THILAWA INDUSTRIAL ZONE, THANLYIN- KYAUKTAN TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1863,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Fang, Chen-Kuang",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "First Smart (Myanmar) Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "770/2014",
    "Permit Date": "2014-08-25T04:21:52Z",
    "Meeting Number": "16/2014",
    "Meeting Date": "2014-06-13T04:22:23Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF SLEEPING BAGS, RUCKSACKS, TENTS & OUTDOOR APPARELS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 2.3657,
    "Total Amount Of Capital (in Millions)": 2.3657,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U TIN MG SOE, U TIN OO & DAW CHO CHO WIN ",
    "Land Area (units not specified in file)": 2.038,
    "Lease Term": 30,
    "Annual Lease Fee": 0.049,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "15 FL, No.200, Wen Shen Street, Panchiao, New Taipei City, Taiwan, Republic of China",
    "Organization Address": "-",
    "Investment Permitted Address":
      "MYAY TAING BLOCK NO.25, PLOT NO. 202, KANAUNG MINTHAR GYI STREET, SHWE LINPAN INDUSTRIAL ZONE, HLAING THARYAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1864,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U SAI HLA HTWE",
    "Name of Principal Organization": "EARTH INDUSTRIAL (MYANMAR) CO., LTD.",
    "Place of Incorporation": "MYANMAR",
    "Company Name In Myanmar":
      "EARTH TAMURA ELECTRONIC (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "812/2014",
    "Permit Date": "2014-10-15T04:34:22Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T04:34:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF THERMAL CUTOFFS, THERMAL LINK, TRANSFORMER, CHOKE COIL & SWITCH ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.03,
    "Total Amount Of Capital (in Millions)": 1.716,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "DAW KHINE ZAW ",
    "Land Area (units not specified in file)": 2.998,
    "Lease Term": 30,
    "Annual Lease Fee": 0.627,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "NO. 30/G, INYA ROAD, KAMAYUT TOWNSHIP, YANGON REGION ",
    "Organization Address":
      "NO.475/KA, YAUK KAW STREET, BLOCK NO. 23, INDUSTRIAL ZONE 1 , SOUTHDAGON TOWNSHIP, YANGON REGION",
    "Investment Permitted Address":
      "PLOT NO.475/KA,  BLOCK NO. 23, YAUKKAW STREET, INDUSTRIAL ZONE (1) , SOUTHDAGON TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1865,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Bao Jianxin",
    "Name of Principal Organization":
      "Jiangyin Xinfeng Clothes-Manufacturing Co., Ltd.",
    "Place of Incorporation": "People's Republic of China",
    "Company Name In Myanmar": "Suntime JCK Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "818/2014",
    "Permit Date": "2014-10-21T06:34:23Z",
    "Meeting Number": "22/2014",
    "Meeting Date": "2014-09-19T06:34:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.017,
    "Total Amount Of Capital (in Millions)": 2.017,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Tin Aye @ Chun Kyone",
    "Land Area (units not specified in file)": 4.795,
    "Lease Term": 30,
    "Annual Lease Fee": 0.116,
    "Land Use Premium": null,
    "Number Of Local Employees": 1700,
    "Number Of Foreign Employees": 13,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.8 Renmin Road, Zhutang Town, Jiangyin City, People's Republic of China",
    "Organization Address":
      "No.8, Renmin Road, Zhutang Town, Jiangyin City, People's Republic of China",
    "Investment Permitted Address":
      "Plot No. 88 & 90, Myay Taing Quarter No.39, Shwe Pyi Thar Industrial Zone, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 1866,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kim Chul Soo",
    "Name of Principal Organization": "Shinsung Tongsang Co., Ltd.",
    "Place of Incorporation": "Republic  of Korea",
    "Company Name In Myanmar": "Shinsung Tongsang International Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "903/2015",
    "Permit Date": "2015-02-06T03:41:46Z",
    "Meeting Number": "2/2015",
    "Meeting Date": "2015-01-31T03:42:22Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 5,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner":
      "U Myint Shwe & Khin San Kyu and Geo Electric (Myanmar) Co., Ltd.",
    "Land Area (units not specified in file)": 2,
    "Lease Term": 50,
    "Annual Lease Fee": 0.048,
    "Land Use Premium": 0.04,
    "Number Of Local Employees": 822,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "Room-501, Han Sol Building, No. 415-11, Gildong, Seoul, Republic of Korea",
    "Organization Address":
      "No.444,Dunchon-dong, Gangdong-gu, Seoul, Republic of Korea",
    "Investment Permitted Address":
      "Plot No.365, Myay Taing Block No.25, Shwe Lin Ban Industrial Zone, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 1867,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. YOON MANKI",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "PIONEER SPECIAL POLY BAG INDUSTRIAL COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "900/2015",
    "Permit Date": "2015-02-02T03:35:07Z",
    "Meeting Number": "1/2015",
    "Meeting Date": "2015-01-16T03:35:26Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF PLASTIC BAGS AND  PLASTIC PRINTING ",
    "Amount Of Foreign Capital USD (in Millions)": 1.042,
    "Total Amount Of Capital (in Millions)": 1.303,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "JV",
    "Land Owner": "DEPARTMENT OF HUMAN SETTLEMENT AND HOUSING DEVELOPMENT ",
    "Land Area (units not specified in file)": 2.004,
    "Lease Term": 30,
    "Annual Lease Fee": 0.044,
    "Land Use Premium": 0.02,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Amend",
    "Investor Address": "603-4 JAYANGDONG KWANG JIN GU, SEOUL, KOREA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 50(A), INDUSTRIAL ZONE (3), HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1868,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MRS. YU MI KAN",
    "Name of Principal Organization": "SIKA AG, ZUGERSTRASSE",
    "Place of Incorporation": "SWITZERLAND ",
    "Company Name In Myanmar": "SIKA MYANMAR LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "911/2015",
    "Permit Date": "2015-03-09T04:33:02Z",
    "Meeting Number": "2/2015",
    "Meeting Date": "2015-01-31T04:33:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF SPECIALTY CHEMICALS FOR THE CONSTRUCTION INDUSTRY",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Switzerland",
    "Form Of Investment": "FDII",
    "Land Owner": "U NAY MYO LWIN",
    "Land Area (units not specified in file)": 2.037,
    "Lease Term": 5,
    "Annual Lease Fee": 108,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "NHON TRACH 1 INDUSTRIAL ZONE, DONG NAI PROVINCE, VIETNAM ",
    "Organization Address": "50. 6341 BAAR, SWITZERLAND ",
    "Investment Permitted Address":
      "PLOT NO. 31, MYAY TAING BLOCK NO. 143/1, KYANSITTHAR YEIKMON INDUSTRIAL ZONE, DAGON MYOTHIT (SOUTH) TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1869,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Leung Moon Chuen Thomas",
    "Name of Principal Organization": "Perfect Gains Garments Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Perfect Gains Garments Manufacturing Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1009/2015",
    "Permit Date": "2015-09-05T05:03:48Z",
    "Meeting Number": "15/2015",
    "Meeting Date": "2015-08-21T05:04:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Underwear and Accessories on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.636,
    "Total Amount Of Capital (in Millions)": 0.636,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Wai Wai Kyaw",
    "Land Area (units not specified in file)": 2.273,
    "Lease Term": 10,
    "Annual Lease Fee": 0.051,
    "Land Use Premium": null,
    "Number Of Local Employees": 436,
    "Number Of Foreign Employees": 11,
    Status: "Monitoring Approved",
    "Investor Address":
      "1501 Delta House, 3 On Yiu Street,Shatin, New Territories, Kowloon, Hong Kong",
    "Organization Address":
      "Unit 1501, 15th Floor, Delta House, 3 On Yiu Street, Shatin New Territories, Hong Kong",
    "Investment Permitted Address":
      "Plot No.44, Myay Taing Block No.24 Ngwe Pin Lal Industrial Zone, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 1870,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Kyi Kyi Nwe",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "CREATIVE GARMENT MANUFACTURING CO., LTD. ",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "MaNaTha-166/98",
    "Permit Date": "1998-08-19T05:46:32Z",
    "Meeting Number": "12/98",
    "Meeting Date": "1998-07-10T05:47:59Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "အသင့်ချုပ်ပြီးအထည်များ ထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 29,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "KHA/11, BAYINT NAUNG ROAD, MAYAN GONE TOWNSHIP, YANGON REGION",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.6/NGA, 7/ Q, NO.29, INSEIN TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1871,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mrs. Chen, Fen ",
    "Name of Principal Organization": "Ningbo Seduno Holding Co., Ltd.",
    "Place of Incorporation": "People Republic of China",
    "Company Name In Myanmar": "Myanmar Hong Tai Fashion Co,,Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "899/2015",
    "Permit Date": "2015-02-04T03:55:33Z",
    "Meeting Number": "1/2015",
    "Meeting Date": "2015-01-16T03:56:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.08,
    "Total Amount Of Capital (in Millions)": 2.08,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Tin Tun @ Yee Ah Mein",
    "Land Area (units not specified in file)": 2.341,
    "Lease Term": 30,
    "Annual Lease Fee": 0.047,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.25, Hou Xin Village, Qiu Ai Township, Yin Zhou District, Ningbo City, Zhejiang Province, China.",
    "Organization Address":
      "Guxi Road, Gulin Town, Yinzhou District, Ningbo City, Zhejiang Province, China",
    "Investment Permitted Address":
      "Plot No.K-7, Myay Taing Block No.20, Anawyahta Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 1872,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Tin Maung Nyunt @ Ho Chi Linn",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Khin Maung Nyunt Steel Products & Galvanizing Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "091/2018",
    "Permit Date": "2018-06-23T02:49:17Z",
    "Meeting Number": "8/2018",
    "Meeting Date": "2018-06-22T02:49:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 3.518,
    "Total Amount Of Capital (in Millions)": 4.691,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Vietnam",
    "Form Of Investment": "JV",
    "Land Owner": "U Tin Maung Nyunt",
    "Land Area (units not specified in file)": 7.391,
    "Lease Term": 50,
    "Annual Lease Fee": 0.023,
    "Land Use Premium": null,
    "Number Of Local Employees": 54,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.6, Myawaddy Street, Ward-16, Yankin Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.247,248,249,250,Myaung Da Gar Industrial Zone, Hmawbi Township, Yangon Region",
  },
  {
    ID: 1873,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ram Chander Singh Narayan Singh",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Yangon J.R Family Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "093/2018",
    "Permit Date": "2018-07-07T03:29:39Z",
    "Meeting Number": "9/2018",
    "Meeting Date": "2018-07-07T03:30:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 4.95,
    "Total Amount Of Capital (in Millions)": 4.95,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "India",
    "Form Of Investment": "FDII",
    "Land Owner": "U Satthi Wail",
    "Land Area (units not specified in file)": 10.977,
    "Lease Term": 50,
    "Annual Lease Fee": 0.019,
    "Land Use Premium": null,
    "Number Of Local Employees": 353,
    "Number Of Foreign Employees": 5,
    Status: "Approved",
    "Investor Address":
      "No.85/1,TH Road, Kaladipet, Chennai-600019 Tamilnadu, India",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 338,339,340,343,344,345, Myaung Da Gar Steel Industrial Zone, Hmawbi Township, Yangon Region",
  },
  {
    ID: 1875,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးညိုမင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Min Zar Ni Co., Ltd.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "MaNaTha-342/2000",
    "Permit Date": "2000-02-29T08:32:03Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "အအေးခန်းစက်ရုံတည်ဆောက်၍ ငါး၊ ပုဇွန်များ ပြုပြင်ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 200,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "မင်းဇာနည်ကုမ္ပဏီလီမိတက်",
    "Land Area (units not specified in file)": 2.564,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၃၉/က၊ ရှင်စောပုလမ်း၊ စမ်းချောင်းမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်း၊ လှိုင်သာယာစက်မှုဇုန်-၁ ၊မြေတိုင်းရပ်ကွကက်အမှတ်-၉၊မြေကွက်အမှတ်-၄/ခ-၁၊ လှိုင်မြစ်ကမ်းဘေး၊",
  },
  {
    ID: 1876,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Guangzhou Tri-Win Leather Company Limited",
    "Name of Principal Organization":
      "Guangzhou Tri-Win Leather Company Limited",
    "Place of Incorporation": "People's Republic of China",
    "Company Name In Myanmar": "Hesheng Myanmar Leather Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "070/2018",
    "Permit Date": "2018-07-25T08:43:31Z",
    "Meeting Number": "9/2018",
    "Meeting Date": "2018-07-04T08:44:14Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of Various Kinds Of Bags On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3.637,
    "Total Amount Of Capital (in Millions)": 3.637,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyi Min and U Han Min",
    "Land Area (units not specified in file)": 2.43,
    "Lease Term": 10,
    "Annual Lease Fee": 0.06,
    "Land Use Premium": null,
    "Number Of Local Employees": 1546,
    "Number Of Foreign Employees": 100,
    Status: "Draft",
    "Investor Address":
      "No.(22), Nanhe Second Street, Nanfang Industrial Zone, Shiling Town, Huadu District, Guangzhou City, People's Republic of China",
    "Organization Address":
      "No.(22), Nanhe Second Street, Nanfang Industrial Zone, Shiling Town, Huadu District, Guangzhou City, People's Republic of China",
    "Investment Permitted Address":
      "Plot No. 37/38, Myay Taing Block No. 64 ( Sethmu), Shwepyithar Township, Yangon Region",
  },
  {
    ID: 1877,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဇော်လေး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ငါးလုပ်ငန်းနှင့်ပင်လယ်ထွက်ကုန်များ၂၀၀၀ လီမိတက်",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "MaNaTha-462/2001",
    "Permit Date": "2001-01-10T09:14:47Z",
    "Meeting Number": "24/2001",
    "Meeting Date": "2001-06-21T04:07:58Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "ရေခဲစက်ငါးပုဇွန်များ၊ပြုပြင်ထုတ်လုပ်ရောင်းချခြင်းနှင့်ငါးစည်သွပ်ဘူးထုတ်လုပ်ရောင်း\nခြင်းလုပ်ငန်း၊ ဆပ်ခံတံတားနှင့် လွန်းကျင်း တည်ဆောက်၍  ငါးကုန်တင်ကုန်ချနှင့် ငါးဖမ်း သင်္ဘော ပြုပြင်ထိန်းသိမ်းခြင်းလုပ်ငန်း။",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 365.37,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ငါးလုပ်ငန်းဦးစီးဌာနပိုင်မြေ",
    "Land Area (units not specified in file)": 10.79,
    "Lease Term": 20,
    "Annual Lease Fee": 19.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 111,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "တိုက်အမှတ်-၂၁၆/၂၂၂၊ အခန်းမှတ်-၆ဃ၊ ၄၉-လမ်း၊ ဗိုလ်မြတ်ထွန်းအိမ်ယာ၊ ပုဇွန်တောင်မြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေတိုင်းရပ်ကွက်အမှတ်-၂/၂၊ အနောက်ကြို့ကုန်းရပ်ကွက်၊  အင်းစိန်မြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 1878,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးရဲမြင့်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Eastern Power Intetnational Limited",
    "Financial Year From": 2001,
    "Financial Year To": 2002,
    "Permit Number": "MaNaTha-492/2001",
    "Permit Date": "2001-05-15T09:59:15Z",
    "Meeting Number": "18/2001",
    "Meeting Date": "2001-05-10T09:33:36Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "တန်(၃၀၀)ဆန်အအေးခန်းစက်ရုံတည်\nဆောက်သန့်ရှင်းလတ်ဆတ်သောငါးပုဇွန်များပြုပြင်ထုတ်လုပ်ခြင်း လုပ်ငန်း၊ တန်(၁၀၀) ရေခဲစက်တည်ဆောက်၍ရေခဲထုတ်လုပ်ခြင်းလုပ်ငန်း/ငါးပုဇွန် ကုန်တင်ကုန်ချ လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 249.98,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ငါးလုပ်ငန်းဦးစီးပိုင်မြေ",
    "Land Area (units not specified in file)": 2.97,
    "Lease Term": 20,
    "Annual Lease Fee": 5.41,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၅၂၊ ဗိုလ်ချုပ်အောင်ဆန်းလမ်း၊ ၁၀-ရပ်ကွက်၊ ပုဇွန်တောင်မြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address": "အမှတ်-၂/၂၊ ကြို့ကုန်း (အနောက်) ရပ်ကွက်၊",
  },
  {
    ID: 1879,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chi Minkoo",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Esung Myanmar Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "072/2018",
    "Permit Date": "2018-07-25T03:04:02Z",
    "Meeting Number": "9/2018",
    "Meeting Date": "2018-07-04T03:04:28Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of Garments And Protected Cover For Vehicles On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.411,
    "Total Amount Of Capital (in Millions)": 0.411,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myint Soe",
    "Land Area (units not specified in file)": 0.657,
    "Lease Term": 30,
    "Annual Lease Fee": 0.013,
    "Land Use Premium": null,
    "Number Of Local Employees": 263,
    "Number Of Foreign Employees": 6,
    Status: "Draft",
    "Investor Address":
      "207- 2302 ( Central Xi 2 Block) 13, Sangseojae-Ro, 4-Gil, Pyeongtaek-Si, Gyeonggi-Do, Republic of Korea",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 520, Myay Taing Block No. 23, Industrial Zone, South Dagon Township, Yangon Region",
  },
  {
    ID: 1881,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Pang Xiyong",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Honor Apparel Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "067/2018",
    "Permit Date": "2018-07-25T03:29:52Z",
    "Meeting Number": "9/2018",
    "Meeting Date": "2018-07-04T03:30:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garments On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4,
    "Total Amount Of Capital (in Millions)": 4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 9,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Thin Thin Wai",
    "Land Area (units not specified in file)": 1.875,
    "Lease Term": 9,
    "Annual Lease Fee": 0.05,
    "Land Use Premium": null,
    "Number Of Local Employees": 1323,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address":
      "Room 3205, Building 8, Junlinxincheng Garden, Zhangjiangang City, Jiangsu Province, People's \nRepublic of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.113-B, Myay Taing Block No. 64, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 1882,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Sin Dong Joon",
    "Name of Principal Organization": "Sanmaru Company Limited",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "Sanmaru Taikkyi Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "073/2018",
    "Permit Date": "2018-07-25T03:45:25Z",
    "Meeting Number": "9/2018",
    "Meeting Date": "2018-07-04T03:45:38Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.851,
    "Total Amount Of Capital (in Millions)": 2.057,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Ye Ye Myint, U Zaw Win",
    "Land Area (units not specified in file)": 9.32,
    "Lease Term": 50,
    "Annual Lease Fee": 0.045,
    "Land Use Premium": null,
    "Number Of Local Employees": 665,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address":
      "No.808, Halla Sigma Vally, 53, Gasan Digital 2-Ro, Geumcheon-Gu, Seoul, Republic of Korea",
    "Organization Address":
      "No.808, Halla Sigma Vally, 53, Gasan Digital 2-Ro, Geumcheon-Gu, Seoul, Republic of Korea",
    "Investment Permitted Address":
      "Holding No-25/1,27/1,28/1,28/2, Kwin No.691, Kantwatkan Kwin, Mingalar Quarter, Taikkyi Township, Yangon Region",
  },
  {
    ID: 1883,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးခင်ကျော်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar King fish Ltd.",
    "Financial Year From": 2001,
    "Financial Year To": 2002,
    "Permit Number": "MaNaTha-494/2001",
    "Permit Date": "2001-04-05T03:53:42Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "မြေတိုင်းရပ်ကွက်အမှတ်-၆၄၊ မြေကွက်အမှတ်-၄၊ စက်မှုဒေသ၊  ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 70.4,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "မြန်မာငါးဘုရင်လီမိတက်",
    "Land Area (units not specified in file)": 1.69,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်-၇၇၊ ငုဝါလမ်း၊",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေတိုင်းရပ်ကွက်အမှတ်-၆၄၊ မြေကွက်အမှတ်-၄၊ ရွှေပြည်သာစက်မှုဇုန်အပိုင်း-၃၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1884,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးတင်အေး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Yati Oo Co., Ltd",
    "Financial Year From": 2001,
    "Financial Year To": 2002,
    "Permit Number": "MaNaTha-497/2001",
    "Permit Date": "2001-06-11T04:15:41Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business": "အအေးခန်းစက်ရုံလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 142,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "မြို့ရွာနှင့်အိုးအိမ်ဖွံ့ဖြိုးရေးဦးစီးဌာန",
    "Land Area (units not specified in file)": 1.965,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "အမှတ်-၃၃၃/၃၃၅၊ အောက်ပုဇွန်တောင်လမ်း၊",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၇၄/ခ၊ စက်မှုဇုန်-၄ တိုးချဲ့၊ ",
  },
  {
    ID: 1886,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမောင်မောင်တာ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myint Myat Hein Co., Ltd",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "MaNaTha-641/2004",
    "Permit Date": "2003-01-15T04:52:32Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "အအေးခန်းတွင် ပြန်လည်သုံးစွဲမည့် တစ်နေ့လျှင် (၂၀)ကျ ရေခဲမုန့်လုပ်ငန်းနှင့် ငါး၊ ပုဇွန် ပြုပြင်အေး ခဲသည့် တန်(၃၀၀)ဆန့် အအေးခန်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 100,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "မွေးမြူရေးနှင့် ရေလုပ်ငန်းဦးစီးဌာန၊ ငါးလုပ်ငန်းဦးစီးဌာနပိုင်မြေ",
    "Land Area (units not specified in file)": 2,
    "Lease Term": 15,
    "Annual Lease Fee": 3.65,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်-၁၈၊ မဉ္ဇူလမ်း၊ ၈-ရပ်ကွက်၊ ပါရမီရိပ်သာ၊",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေတိုင်းရပ်ကွက်-၂/၂၊ မြေကွက်-၁၈၊ အနောက်ကြို့ကုန်းရပ်ကွက်၊",
  },
  {
    ID: 1889,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lee, Wen-Jia",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Top Direction Industry Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1073/2016",
    "Permit Date": "2016-01-26T07:32:17Z",
    "Meeting Number": "1/2016",
    "Meeting Date": "2016-01-15T07:32:46Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production and Dying For All Kinds of Cotton Yarns",
    "Amount Of Foreign Capital USD (in Millions)": 1.113,
    "Total Amount Of Capital (in Millions)": 1.113,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 36,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Arr Kyi @ Pyone Nwe",
    "Land Area (units not specified in file)": 1.25,
    "Lease Term": 20,
    "Annual Lease Fee": 0.032,
    "Land Use Premium": null,
    "Number Of Local Employees": 153,
    "Number Of Foreign Employees": 11,
    Status: "Monitoring Approved",
    "Investor Address":
      "663,SEC.5, Chung Hsin Road, San Chung District, New Taipei City, Taiwan, Republic of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.92, Industrial Zone-Part-4, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 1893,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Managing Director, Public Work",
    "Name of Principal Organization": "Public Work",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "J & M Steel Solutions Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "633/2013",
    "Permit Date": "2013-10-18T07:17:14Z",
    "Meeting Number": "25/2013",
    "Meeting Date": "2013-09-18T07:17:40Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Structural Steel Components for Bridges and Guardrail",
    "Amount Of Foreign Capital USD (in Millions)": 10.284,
    "Total Amount Of Capital (in Millions)": 15.141,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "Public Works",
    "Land Area (units not specified in file)": 16,
    "Lease Term": 15,
    "Annual Lease Fee": 0.323,
    "Land Use Premium": null,
    "Number Of Local Employees": 203,
    "Number Of Foreign Employees": 9,
    Status: "Monitoring Approved",
    "Investor Address": "Office Building (11), Nay Pyi Taw",
    "Organization Address": "Office Building (11), Nay Pyi Taw",
    "Investment Permitted Address":
      "Block No. 10, Thaketa Township, Yangon Region",
  },
  {
    ID: 1894,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. chen Ken Chien Yu",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Great Glowing Investment Company Limited",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "570/2013",
    "Permit Date": "2013-03-13T05:20:24Z",
    "Meeting Number": "10/2013",
    "Meeting Date": "2013-03-13T05:20:51Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.092,
    "Total Amount Of Capital (in Millions)": 1.092,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Canada",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Tin Tin Oo",
    "Land Area (units not specified in file)": 8,
    "Lease Term": 30,
    "Annual Lease Fee": 0.172,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 1319 West, 47 Avenue, Vancouver, BC V6M 2 L 7, Canada",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No. 340, 341, Yangon Industrial Zone, Mingaladon Garden City, Mingaladon Township, Yangon Region",
  },
  {
    ID: 1895,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Sao Khun San Aung",
    "Name of Principal Organization": "IMU Enterprise Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "British American Tobacco Myanmar Limited",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "556/2013",
    "Permit Date": "2013-01-31T05:27:52Z",
    "Meeting Number": "5/2013",
    "Meeting Date": "2013-01-30T05:28:20Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Plantation, Processing & Sales of Tobacco, Manufacturing and marketing of Cigarettes",
    "Amount Of Foreign Capital USD (in Millions)": 14.5,
    "Total Amount Of Capital (in Millions)": 28.4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "IMU Enterprise Limited",
    "Land Area (units not specified in file)": 18182.75,
    "Lease Term": 30,
    "Annual Lease Fee": 9.204,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 68, Innya Road, 10 Ward, Ka Mar Yut Township, Yangon.",
    "Organization Address": "15/16, Bahosi Complex, Lanmadaw Township, Yangon",
    "Investment Permitted Address":
      "55/56, Shwe Thanlwin Industrial Zone, Hlaing Thar Yar Township, Yangon, Myanmar",
  },
  {
    ID: 1896,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Keiichi Asano",
    "Name of Principal Organization": "Suzuki Motor Corporation ",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Suzuki (Myanmar) Motor Company Limited",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "553/2013",
    "Permit Date": "2013-01-31T05:37:39Z",
    "Meeting Number": "5/2013",
    "Meeting Date": "2013-01-30T05:38:02Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and sales of Brand New Suzuki Brand Four Wheel Automobiles",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 7,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 3,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "No.1, Heavy Industries Enterprise",
    "Land Area (units not specified in file)": 56505,
    "Lease Term": 3,
    "Annual Lease Fee": 0.272,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "2-44-12, Hirosawa, NaKa-Ku, Hamamatsu City, Shizuoka-Prefecture, Japan",
    "Organization Address":
      "300, Takatsuka-Cho, Minami-Ku, Hamamatsu City, Shizuoka-Prefecture, Japan",
    "Investment Permitted Address":
      "Plot No. 476 (C), Block NO. 23, Mogoke Street, South Dagon Industrial Zone, South Dagon Township, Yangon",
  },
  {
    ID: 1897,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Gun Choon,Lee",
    "Name of Principal Organization": "Samgong Industrial Co.,Ltd.",
    "Place of Incorporation": "Korean",
    "Company Name In Myanmar": "Myanmar Samgong Industrial Co.,Ltd.",
    "Financial Year From": 96,
    "Financial Year To": 97,
    "Permit Number": "248/1997",
    "Permit Date": "1997-02-21T06:33:46Z",
    "Meeting Number": "3/1997",
    "Meeting Date": "1997-01-31T06:35:22Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Production  and Marketing of Inflatable Rubber Boats & Assorted Rubber Products",
    "Amount Of Foreign Capital USD (in Millions)": 3,
    "Total Amount Of Capital (in Millions)": 3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "The Union of Myanmar Economie Holdings Ltd.",
    "Land Area (units not specified in file)": null,
    "Lease Term": 20,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Woosung APT 28-601, Jamsil-7 Dong, Songpa-Ku,Seoul ,Korea",
    "Organization Address": "956-Dogok-Dong, Kangnam-Ku,Seoul,Korea",
    "Investment Permitted Address":
      "Pyinmabin Industrial Estate,Mingaladon Township,",
  },
  {
    ID: 1898,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Lee Min @ U Hla Oo",
    "Name of Principal Organization": "Good Brothers' Co.,Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Yangon Wuling Diesel Engine Co.,Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "692/2014",
    "Permit Date": "2014-03-24T08:21:25Z",
    "Meeting Number": "8/2014",
    "Meeting Date": "2014-03-05T08:22:24Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Single Cylinder Diesel Engines, Tractors Tiller and Other Agricultural Machinery",
    "Amount Of Foreign Capital USD (in Millions)": 1.28,
    "Total Amount Of Capital (in Millions)": 3.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "Yangon Wuling Diesel Engine Co.,Ltd.",
    "Land Area (units not specified in file)": null,
    "Lease Term": 1,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.49, Phone Gyi Street, Ward No.5,Lanmadaw Township,Yangon",
    "Organization Address":
      "No.22, Bayint Naung Road, Thirimon Housing,Hlaing Township,Yangon",
    "Investment Permitted Address":
      "Myay Taing Block No.153, No.3, Farm Machinery Factory,Ywarthargyi , Dagon Myothit (South)Township,Yangon",
  },
  {
    ID: 1899,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw Nan Lin Lin Tun",
    "Name of Principal Organization": "MYINT INVESTMENT LIVESTOCK CO., LTD.",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MYINT  DACHAN  COMPANY  LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "104/2018",
    "Permit Date": "2018-08-10T09:45:17Z",
    "Meeting Number": "10/2018",
    "Meeting Date": "2018-08-10T09:45:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "PRODUCTION AND SALES OF ANIMAL FEED ",
    "Amount Of Foreign Capital USD (in Millions)": 6.17,
    "Total Amount Of Capital (in Millions)": 24.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Virgin Islands (British)",
    "Form Of Investment": "JV",
    "Land Owner": "DAW NAN LIN LIN TUN",
    "Land Area (units not specified in file)": 11.478,
    "Lease Term": 50,
    "Annual Lease Fee": 32400,
    "Land Use Premium": null,
    "Number Of Local Employees": 140,
    "Number Of Foreign Employees": 10,
    Status: "Amend",
    "Investor Address":
      "NO. 299, SHWEDAGON PAGODA ROAD, PHAYARGYI  QUARTER,  DAGON  TOWNSHIP, YANGON",
    "Organization Address":
      "NO.297, SHWEDAGON PAGODA ROAD, PHAYARGYI  QUARTER,  DAGON  TOWNSHIP, YANGON ",
    "Investment Permitted Address":
      "PLOT NO. (370, 371, 372, 373, 374),  MYAUNG DAGAR THANMANI INDUSTRIAL ZONE, HMAWBI TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1900,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. HWANG CHAI FONG",
    "Name of Principal Organization": "LIGHT STAR DEVELOPMENT CO., LTD. ",
    "Place of Incorporation": "HONH KONG",
    "Company Name In Myanmar": "STARTEX MANUFACTURING CO., LTD.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "352/2000",
    "Permit Date": "2000-11-30T03:28:12Z",
    "Meeting Number": "33/2000",
    "Meeting Date": "2000-10-02T03:28:45Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF KNITWEARS  AND GARMENTS ON CMP BASIS ",
    "Amount Of Foreign Capital USD (in Millions)": 1.2,
    "Total Amount Of Capital (in Millions)": 1.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "DEPARTMENT OF HUMAN SETTLEMENT AND HOUSING DEVELOPMENT",
    "Land Area (units not specified in file)": 1.5,
    "Lease Term": 15,
    "Annual Lease Fee": 0.018,
    "Land Use Premium": 30000,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "FLAT/ROOM401-3, PROSPEROUS BLDG 48 DES VOEUX ROAD, CENTRAL, HONG KONG",
    "Organization Address":
      "FLAT/ROOM401-3, PROSPEROUS BLDG 48 DES VOEUX ROAD, CENTRAL, HONG KONG",
    "Investment Permitted Address":
      "SURVEY BLOCK NO.39, PLOT NO.50, SHWE PYI THAR INDUSTRIAL ZONE, SHWE PYI THAR TOWNSHIP, YANGON",
  },
  {
    ID: 1901,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Binder Volker Franz Josef",
    "Name of Principal Organization":
      "Anita International Dr Helbing GMBH & Co KG,",
    "Place of Incorporation": "Austria",
    "Company Name In Myanmar": "Anita-Asia Ltd.",
    "Financial Year From": 96,
    "Financial Year To": 97,
    "Permit Number": "249/1997",
    "Permit Date": "1997-02-21T03:43:44Z",
    "Meeting Number": "4/1997",
    "Meeting Date": "1997-02-14T03:46:26Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Textile Products(Corsetry and Brassiers)",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Austria",
    "Form Of Investment": "FDII",
    "Land Owner": "The Cottage Industries Department ",
    "Land Area (units not specified in file)": null,
    "Lease Term": 15,
    "Annual Lease Fee": 14,
    "Land Use Premium": 0.14,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "70 Mortimer Court Abbey Road, St.John's Wood,London NW8, 9AD United Kingdom",
    "Organization Address": "A 6330 Kufstein, Endach 40, Austria",
    "Investment Permitted Address": "North Okkalapa Township, Yangon",
  },
  {
    ID: 1902,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Craig Brian Beedell ",
    "Name of Principal Organization": "Oceanic Communications Limited",
    "Place of Incorporation": "New Zeland",
    "Company Name In Myanmar": "Oceanic Communications (Asia) Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1127/2016",
    "Permit Date": "2016-03-26T04:42:29Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T04:42:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production, Warehousing and Distribution of Vouchers",
    "Amount Of Foreign Capital USD (in Millions)": 6.95,
    "Total Amount Of Capital (in Millions)": 6.95,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 10,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "New Zealand",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Myo, U Lin Young Wee @Maung Aye and Daw Mya Htay",
    "Land Area (units not specified in file)": 2.398,
    "Lease Term": 30,
    "Annual Lease Fee": 0.19,
    "Land Use Premium": null,
    "Number Of Local Employees": 175,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address": "15 Perth Street,Ngaio ,Wellington  ,New Zealand 6035",
    "Organization Address":
      "Level 10, 50 Manners Street, Wellington 6011, New Zealand",
    "Investment Permitted Address":
      "Plot No. 146, Myay Taing Block No. 14, Shwe Thanlwin Industrial Zone, Hlaing Tharyar Township, Yangon Township",
  },
  {
    ID: 1903,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Kyaw Zin",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Hana Co.,Ltd.",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "254/1997",
    "Permit Date": "1997-03-19T04:48:11Z",
    "Meeting Number": "4/1997",
    "Meeting Date": "1979-02-14T04:52:27Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 25,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Indonesia",
    "Form Of Investment": "JV",
    "Land Owner": "Department of Human Settlement and Housing Development",
    "Land Area (units not specified in file)": null,
    "Lease Term": 15,
    "Annual Lease Fee": 0.025,
    "Land Use Premium": 0.25,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "No.37, Yuzana Lane, Kamar Kyi Street, Ward No.(30), Thuwana Thingangyun Township, Yangon",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No.(75), Hlaing Thar Yar Industrial Zone Part (3), Hlaing Thar Yar Industrial Zone Part (3), Hlaing Thar Yar Township, Yangon",
  },
  {
    ID: 1904,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. HIDEKAZU FUJLL",
    "Name of Principal Organization": "THAI PARFUN CO., LTD.",
    "Place of Incorporation": "THAILAND",
    "Company Name In Myanmar": "MYANMAR PARFUN COMPANY LIMITED",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "588/2013",
    "Permit Date": "2013-06-24T05:24:55Z",
    "Meeting Number": "16/2013",
    "Meeting Date": "2013-06-12T05:25:22Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 4.35,
    "Total Amount Of Capital (in Millions)": 4.35,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Thailand",
    "Form Of Investment": "FDII",
    "Land Owner": "U KHIN TUN, DAW YIN YIN HTAY",
    "Land Area (units not specified in file)": 2.29,
    "Lease Term": 50,
    "Annual Lease Fee": 3.36,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "3-40-2 AOYAMADAI SUIT ASHI OSAKAFU, JAPAN",
    "Organization Address":
      "NO. 242, VILLAGE NO.7, INDUSTRIAL ESTATE 304, THATOOM SUBDISTRICT SRIMAHAPHO DISTRICT, PRACHINBURI PROVINCE, THAILAND",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၈၂/၁၊ ၁၈၂/၁၂၊ မြေတိုင်းရပ်ကွက် အမှတ်-၂၅၊ ရွှေလင်ပန်းစက်မှုမြို့၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1905,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. CHEN BAOCHENG",
    "Name of Principal Organization":
      "NANNING JIELING SANITARY ARTICLE CO., LTD.",
    "Place of Incorporation": "CHINA",
    "Company Name In Myanmar":
      "DEAR FREEDON INTERNATIONAL GROUP COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "858/2015",
    "Permit Date": "2015-02-13T05:43:02Z",
    "Meeting Number": "2/2015",
    "Meeting Date": "2015-01-31T05:43:23Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF SANITARY PRODUCTS",
    "Amount Of Foreign Capital USD (in Millions)": 0.778,
    "Total Amount Of Capital (in Millions)": 0.778,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U AUNG THEIN",
    "Land Area (units not specified in file)": null,
    "Lease Term": 30,
    "Annual Lease Fee": 0.024,
    "Land Use Premium": null,
    "Number Of Local Employees": 311,
    "Number Of Foreign Employees": 15,
    Status: "Approved",
    "Investor Address":
      "ROOM 1508, T2 BUILDING, NO 63-1, MINZU AVENUE, QINGXIU DISTRICT, NANNING, GUANGXI, CHINA",
    "Organization Address":
      "NO.21-7, YOUYI ROAD, JIANGNAN DISTRICT, NANNING, GUANGXI, CHINA",
    "Investment Permitted Address":
      "PLOT NO.33, CORNER OF MINGYI MAHAR MINKHAUNG STREET & MYAWADDY MINGYI STREET, HLAING THAR YAR INDUSTRIAL ZONE 4, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1908,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "The Union of Myanmar Economic Holdings Ltd.",
    "Name of Principal Organization": "The Union of Myanmar Economic Holdings",
    "Place of Incorporation": "Yangon",
    "Company Name In Myanmar": "Myram Co.,L:td",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "255/1997",
    "Permit Date": "1997-04-30T06:54:16Z",
    "Meeting Number": "20/1997",
    "Meeting Date": "1997-11-28T06:55:26Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Gems and Jewelleries of International Standard",
    "Amount Of Foreign Capital USD (in Millions)": 2.4,
    "Total Amount Of Capital (in Millions)": 24,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No.72/74, Shwedagon Pagoda Road, Dagon Township, Yangon",
    "Organization Address":
      "No.72/74, Shwe Dagon Pagoda Road, Dagon Township, Yangon",
    "Investment Permitted Address":
      "Block No.34(D), Thingangyun Road,Tamwe Township",
  },
  {
    ID: 1909,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Han Sang Seob",
    "Name of Principal Organization": "Yes Trading Co.,Ltd ",
    "Place of Incorporation": "Korea",
    "Company Name In Myanmar": "Myanmar Yes Box Co.,Ltd.",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "256/1997",
    "Permit Date": "1997-04-30T05:28:46Z",
    "Meeting Number": "5/1997",
    "Meeting Date": "1997-03-28T05:31:22Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Paper Boxes",
    "Amount Of Foreign Capital USD (in Millions)": 1.2,
    "Total Amount Of Capital (in Millions)": 1.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "Yes Trading Co.,Ltd.",
    "Land Area (units not specified in file)": null,
    "Lease Term": 5,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Hall Apartment 103-105,67-5 Woo Myun-Dong ,Seocho-Ku Seoul ,Korea",
    "Organization Address":
      "Central Royal Officetel Room#1702,1355-8, Seocho-Dong, Seocho-Ku,Seoul, Korea",
    "Investment Permitted Address":
      "Plot No.(64), Industrial Zone Part (3), Hlaingtharyar Township,Yangon",
  },
  {
    ID: 1910,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Skylark Feeds Private Limited",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Skylark Sunline Company Limmited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "069/2018",
    "Permit Date": "2018-07-25T07:42:25Z",
    "Meeting Number": "9/2018",
    "Meeting Date": "2018-07-04T07:42:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Production And Marketing Of Animals Feed",
    "Amount Of Foreign Capital USD (in Millions)": 2.923,
    "Total Amount Of Capital (in Millions)": 2.923,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "India",
    "Form Of Investment": "FDII",
    "Land Owner": "U Than Aung",
    "Land Area (units not specified in file)": 6.86,
    "Lease Term": 30,
    "Annual Lease Fee": 92771,
    "Land Use Premium": null,
    "Number Of Local Employees": 59,
    "Number Of Foreign Employees": 13,
    Status: "Draft",
    "Investor Address":
      "Village Khera Khemawati, Tehsil Safidon, Disst. Jind-126112 Haryana, India",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.294+295+296, Myay Taing BLock No. Myaung Takar Industrial Zone, Hmawbi Township , Yangon Region",
  },
  {
    ID: 1911,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Xu Pengcheng",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Myanmar Lucky Phoenix International Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "071/2018",
    "Permit Date": "2018-07-25T08:49:44Z",
    "Meeting Number": "9/2018",
    "Meeting Date": "2018-07-04T08:51:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.304,
    "Total Amount Of Capital (in Millions)": 1.304,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myint Naing Oo1.695",
    "Land Area (units not specified in file)": 1.695,
    "Lease Term": 10,
    "Annual Lease Fee": 0.136,
    "Land Use Premium": null,
    "Number Of Local Employees": 604,
    "Number Of Foreign Employees": 16,
    Status: "Monitoring Approved",
    "Investor Address":
      "Room 403, No 20, Headlines Lane, Baixia District, Nanjing, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 145, Myay Taing Block No. 64 (Sethmu), Shwepyithar Township, Yangon Region",
  },
  {
    ID: 1912,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "The Union of Myanmar Economic Holding Ltd.",
    "Name of Principal Organization":
      "The Union of Myanmar Economic Holding Ltd.",
    "Place of Incorporation": "Yangon",
    "Company Name In Myanmar": "The First Automotive Co.,Ltd.",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "262/1997",
    "Permit Date": "1997-08-11T04:08:52Z",
    "Meeting Number": "21/1998",
    "Meeting Date": "1998-11-27T04:09:33Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Assembling , Manufacturing and Distribution of Isuzu Vehicles and Isuzu Components",
    "Amount Of Foreign Capital USD (in Millions)": 4.76,
    "Total Amount Of Capital (in Millions)": 36.976,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "",
    "Land Owner": "-",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "No.72/74, Shwedagon Pagoda Road,Dagon Township,Yangon",
    "Organization Address":
      "No.72/74, Shwedagon Pagoda Road, Dagon Township, Yangon.",
    "Investment Permitted Address":
      "Pyinmabin Industrial Estate,Mingaladon Township, Yangon",
  },
  {
    ID: 1914,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Than Htaik Soe",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Crown Roofing Co., Ltd.",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "105/97",
    "Permit Date": "1997-12-16T06:39:15Z",
    "Meeting Number": "18/97",
    "Meeting Date": "1997-11-07T06:40:03Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "အိမ်မိုးသွပ်ပြားထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 41,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "သီဟရာဇာကုမ္ပဏီလီမိတက်",
    "Land Area (units not specified in file)": 8.617,
    "Lease Term": 30,
    "Annual Lease Fee": 1.2,
    "Land Use Premium": null,
    "Number Of Local Employees": 180,
    "Number Of Foreign Employees": 3,
    Status: "Submitted",
    "Investor Address": "No. 32, 13th Street, Lanmataw Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် - ၁၀၊ ၁၁၊ ၁၂၊ ၁၃၊ ၁၄၊ မြေတိုင်းရပ်ကွက်အမှတ် ဇုန် (၁)၊ စက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1915,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်အိရွှေစင်အေး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "International Falcon Industry Ltd.",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "318/99",
    "Permit Date": "1999-12-13T07:11:18Z",
    "Meeting Number": "17/99",
    "Meeting Date": "1999-10-01T07:12:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အသင့်ချုပ်ပြီးအထည်များထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 28.55,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးစိန်ဦး (ခ) လောရိန်ကြစ်",
    "Land Area (units not specified in file)": 0.245,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 432,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "အမှတ် ၄၉၆၊ ရွာသစ်ကွင်းအပိုင်း၊ တပ်ကြီးကုန်း၊ မှော်ဘီမြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ ရွှေပြည်သာမြို့နယ်၊ စက်မှုဇုန်၊ မြေတိုင်းရပ်ကွက်အမှတ်-၄၂၊ မြေကွက်အမှတ် ၁၆",
  },
  {
    ID: 1916,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. UTHAI TANTIPIMOLPHAN",
    "Name of Principal Organization": "MYANMAR C.P LIVESTOCK CO., LTD. ",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "MYANMAR C.P LIVESTOCK COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "095/2018",
    "Permit Date": "2018-07-30T07:46:06Z",
    "Meeting Number": "10/2018",
    "Meeting Date": "2018-07-26T07:47:40Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 10.514,
    "Total Amount Of Capital (in Millions)": 10.514,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Khun Tar Fa, U Yin Htwe and U Than Htay",
    "Land Area (units not specified in file)": 40,
    "Lease Term": 30,
    "Annual Lease Fee": 165000000,
    "Land Use Premium": null,
    "Number Of Local Employees": 122,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 99/160 MOO 5, BANGLUCKNOI, MUANG NONTHABURI, NONTHABURI 11000 THAILAND",
    "Organization Address":
      "135, PYAY ROAD, 8 1/2  MILE, MAYANGONE TOWNSHIP, YANGON ",
    "Investment Permitted Address":
      "PLOT NO. 43, 44, SPECIAL ZONE (2) EXTENSION, PLOT NO. 266, 267, SPECIAL ZONE (2), PLOT NO. 38, 39, SPECIAL ZONE (1), NYAUNG NAPIN VILLAGE TRACT, HMAWBI TOWNSHIP AND PLOT NO. 75, 76, VEGETABLE PRODUCTION AND CHICKEN/FISH LIVESTOCK SPECIAL ZONE (3), KYAR INN TRACT, HLEGU TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1917,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Nan Mya",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "GOLDEN  EMPIRE (NM) COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "110/2018",
    "Permit Date": "2018-08-10T03:37:34Z",
    "Meeting Number": "12/2018",
    "Meeting Date": "2018-08-10T03:37:24Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "HOTEL SERVICES ",
    "Amount Of Foreign Capital USD (in Millions)": 1.58,
    "Total Amount Of Capital (in Millions)": 49782.26,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "DAW NAN MYA    ",
    "Land Area (units not specified in file)": 2.22,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 231,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.(5/62), THIRIGONE  HOUSING, WAIZAYANTAR ROAD, WARD NO.(16/2),  ",
    "Organization Address": "",
    "Investment Permitted Address":
      "NO. (1,2,3,4,5,16,17,18,19,20 A1), MYAY TAING BLOCK NO.14/1, CORNER OF MYITTA ROAD AND THAKHIN PHO HLA GYI ROAD, SOUTH OKKALAPA TOWNSHIP, YANGON REGION ",
  },
  {
    ID: 1919,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Anthony David Cole",
    "Name of Principal Organization": "Cole & Win International Ltd.",
    "Place of Incorporation": "British Virgin Islands",
    "Company Name In Myanmar": "Myanmar Cole & Win Co.,Ltd",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "264/1997",
    "Permit Date": "1997-06-24T04:00:10Z",
    "Meeting Number": "8/1997",
    "Meeting Date": "1997-05-29T04:09:27Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Teepol Brand Soaps and Detergents and Other Personal and Housing Goods",
    "Amount Of Foreign Capital USD (in Millions)": 0.54,
    "Total Amount Of Capital (in Millions)": 3.97,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Virgin Islands (British)",
    "Form Of Investment": "JV",
    "Land Owner": "Mr Anthony David Cole and Daw Soe Soe Win",
    "Land Area (units not specified in file)": null,
    "Lease Term": 5,
    "Annual Lease Fee": 14435151,
    "Land Use Premium": 0.01,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "Oaklands Marsh Lane , Somerleyton , Lowestoft, Suffolk, United Kingdom",
    "Organization Address": "British Virgin Islands",
    "Investment Permitted Address": "Hlaing Tharyar Industrial Zone Part (3),",
  },
  {
    ID: 1920,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Thein Tun",
    "Name of Principal Organization": "Myanmar Golden Star Co.,Ltd.",
    "Place of Incorporation": "Yangon",
    "Company Name In Myanmar": "Myanmar Pet Container Co.,Ltd.",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "269/1997",
    "Permit Date": "1997-07-11T08:22:11Z",
    "Meeting Number": "9/1997",
    "Meeting Date": "1997-06-13T08:23:00Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Production and Marketing of Plastic (PET)Bottles",
    "Amount Of Foreign Capital USD (in Millions)": 3.82,
    "Total Amount Of Capital (in Millions)": 4.42,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "No.292, Ahlone Road, Dagon Township,Yangon",
    "Organization Address":
      "(MGS), 7/8, Bahosi Yeiktha, Bogyoke Aung San Street, Lanmadaw Township, Yangon",
    "Investment Permitted Address":
      "Plot No.529/A, Block No.3, Pyinmabin, Mingaladon Township, Yangon,",
  },
  {
    ID: 1921,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U  Than Soe",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Hlaing Thit Garment Manufacturing Co.,Ltd.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "476/2001",
    "Permit Date": "2001-03-08T03:15:37Z",
    "Meeting Number": "41/2000",
    "Meeting Date": "2000-12-15T04:48:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနှစ်ဖြင့်အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 60.77,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "No.140(B), Dhamasaydi Road, Bahan Township, Yangon",
    "Organization Address": "-",
    "Investment Permitted Address":
      "အမှတ်(၁၅၀-ခ)၊ မြေတိုင်းရပ်ကွက်၊ အမှတ်(၂၃)၊ ဒဂုံမြို့သစ်တောင်ပိုင်းစက်မှုဇုံ(၁)၊ ဒဂုံသစ်တောင်ပိုင်းမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 1923,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyaw Naing",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Golden Rainbow Industries Co.,Ltd.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "482/2001",
    "Permit Date": "2001-03-18T04:28:08Z",
    "Meeting Number": "2/2001",
    "Meeting Date": "2001-01-11T03:59:41Z",
    Sector: "",
    "Type Of Investment Business": "CMP စနှစ်ဖြင့် အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 12.25,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်(၂၉၂/ဘီ)၊ အခန်း(ဂ)၊ ရွှေတိဂုံဘုရားလမ်း၊ ဒဂုံမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၂၇-က)၊ စက်မှုလက်မှုဇုန်(၁)၊လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 1924,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "DAW NAN LIN LIN TUN",
    "Name of Principal Organization": "MYINT INVESTMENT LIVESTOCK CO., LTD.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "MYINT  DACHAN COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "103/2018",
    "Permit Date": "2018-08-10T05:12:36Z",
    "Meeting Number": "12/2018",
    "Meeting Date": "2018-08-10T05:13:55Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 1.48,
    "Total Amount Of Capital (in Millions)": 5.9,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Aye Aye ",
    "Land Area (units not specified in file)": 10,
    "Lease Term": 50,
    "Annual Lease Fee": 10000000,
    "Land Use Premium": null,
    "Number Of Local Employees": 44,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 299, SHWEDAGON PAGODA ROAD, PHAYARGYI QUARTER, DAGON TOWNSHIP, YANGON",
    "Organization Address":
      "NO. 297, SHWEDAGON PAGODA ROAD, PHAYARGYI QUARTER, DAGON TOWNSHIP, YANGON ",
    "Investment Permitted Address":
      "PLOT NO. 24, 25, NYAUNG NAPIN VEGETABLE PRODUCTION AND CHICKEN/FISH LIVESTOCK SPECIAL ZONE (3), NYAUNG NAPIN VILLAGE TRACT, HMAWBI TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1925,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Myo Aung",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Yoma Top Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "109/2018",
    "Permit Date": "2018-08-10T09:10:21Z",
    "Meeting Number": "12/2018",
    "Meeting Date": "2018-08-10T09:10:41Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 6500,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Shwe Sin",
    "Land Area (units not specified in file)": 0.11,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 65,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 17/C, Tharyarwadi Street, Sayarsan Ward, Bahan Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No. 571, Plot No. 2/2Sa2, Myay Taing Block No. 45 (Kanbae), Ward 8, Kabaraye Pagoda Road, Mayangone Township, Yangon Region",
  },
  {
    ID: 1926,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kao, You-Fen",
    "Name of Principal Organization": "Wise Unicorn Industrial Limited.",
    "Place of Incorporation": "Republic Of China",
    "Company Name In Myanmar": "Charis Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "076/2018",
    "Permit Date": "2018-08-10T04:46:16Z",
    "Meeting Number": "10/2018",
    "Meeting Date": "2018-07-25T04:46:23Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of High Quality Poly Resin Product, Cold Cast Bronze, Pewter And Porcelain Figurines And Collectibles By Using High Quality Poly Resin On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.375,
    "Total Amount Of Capital (in Millions)": 1.375,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 23,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Yinn Maung Thein",
    "Land Area (units not specified in file)": 2.106,
    "Lease Term": 23,
    "Annual Lease Fee": 0.142,
    "Land Use Premium": null,
    "Number Of Local Employees": 500,
    "Number Of Foreign Employees": 6,
    Status: "Draft",
    "Investor Address":
      "Unit 403A 4/F, Skyway House, No.3, Sham Mong Road, Tai Kok Tsui, Kowloon, Hong Kong , Republic Of China",
    "Organization Address":
      "Unit 403A 4/F, Skyway House, No.3, Sham Mong Road, Tai Kok Tsui, Kowloon, Hong Kong , Republic Of China",
    "Investment Permitted Address":
      "Plot No. 103, Myay Taing Block No. 14, Shwe Thanlwin Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 1927,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Gong, Songlin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Tongying Hk (Myanmar) Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "075/2018",
    "Permit Date": "2018-08-10T05:10:58Z",
    "Meeting Number": "10/2018",
    "Meeting Date": "2018-07-25T05:11:03Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.647,
    "Total Amount Of Capital (in Millions)": 4.647,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Khin Moe Swe",
    "Land Area (units not specified in file)": 3.765,
    "Lease Term": 5,
    "Annual Lease Fee": 0.03,
    "Land Use Premium": null,
    "Number Of Local Employees": 1186,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address":
      "No. 82, Ai Goo Dong Road Yang City, Zhejiang Province, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 359+360, Myay Taing Block No. Myaung Takar Industrial Zone, Hmawbi Township, Yangon Region",
  },
  {
    ID: 1928,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chongguan Jiang",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Sen Kuan Myanmar Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "074/2018",
    "Permit Date": "2018-08-10T05:47:43Z",
    "Meeting Number": "10/2018",
    "Meeting Date": "2018-07-25T05:47:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production, Marketing And Selling Of Polyster Padding, Rib And Quilting For Garment Enterprises",
    "Amount Of Foreign Capital USD (in Millions)": 2.1,
    "Total Amount Of Capital (in Millions)": 2.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Thu Thu Ei Han",
    "Land Area (units not specified in file)": 1.909,
    "Lease Term": 10,
    "Annual Lease Fee": 0.082,
    "Land Use Premium": null,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "No. 169, Ren He Road, Shan Dong Province, Qing Dao City, Jimo Region, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 3 C5, Myay Taing Block No.6, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 1929,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Mint Mint Aye",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Shwe Fof Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "077/2018",
    "Permit Date": "2018-08-10T06:19:43Z",
    "Meeting Number": "10/2018",
    "Meeting Date": "2018-07-25T06:19:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production, Marketing And Selling Of Padding And Quilting For Garment Enterprises",
    "Amount Of Foreign Capital USD (in Millions)": 1.8,
    "Total Amount Of Capital (in Millions)": 1.8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "U Zaw Zaw Naing",
    "Land Area (units not specified in file)": 0.587,
    "Lease Term": 10,
    "Annual Lease Fee": 66,
    "Land Use Premium": null,
    "Number Of Local Employees": 73,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "No. 35, 22nd Street, Ward (2), Pyin Oo Lwin Township, Mandalay Region",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.28, Myay Taing Block No.109, Industrial Zone, Dagon (East) Township, Yangon Region",
  },
  {
    ID: 1930,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမိုဟာမက်မူဆာ (ခ) နေ၀င်းလေး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "မဟာအရည်အသွေး စက်မှုလက်မှုလုပ်ငန်း ကုမ္ပဏီလီမီတက်(Great Quality Industrial Company Limited)",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "078/2018",
    "Permit Date": "2018-08-10T06:44:52Z",
    "Meeting Number": "10/2018",
    "Meeting Date": "2018-07-25T06:45:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing And Production Of C-Purlin, Decking Sheet, Colour Roofing Sheet, C-Channel, Second Bar ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 6000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးမိုဟာမက်ရှရမ်",
    "Land Area (units not specified in file)": 0.253,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 71,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address":
      "အမှတ် ၉၈/၁၀၀၊ အခန်းအမှတ်(၂)၊ ရွှေတိဂုံဘုရားလမ်း၊ ပန်းပဲတန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၈၅၄/၁၊ မြေတိုင်းရပ်ကွက် အမှတ် ၂၆၊ စက်မှုဇုန်၊ ဒဂုံမြို့သစ်(တောင်ပိုင်း)မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1931,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Eikhidi Hla ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Eager Comminications Group Company limited  ",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1223/2018",
    "Permit Date": "2016-11-21T05:50:58Z",
    "Meeting Number": "12/2016",
    "Meeting Date": "2016-11-12T05:51:23Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "National Backbone Fiber Network and Metropolitan Network (except Yangon region)",
    "Amount Of Foreign Capital USD (in Millions)": 269.51,
    "Total Amount Of Capital (in Millions)": 323869.65,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Mandalay City Development Committee",
    "Land Area (units not specified in file)": null,
    "Lease Term": 30,
    "Annual Lease Fee": 18,
    "Land Use Premium": null,
    "Number Of Local Employees": 93,
    "Number Of Foreign Employees": null,
    Status: "Amend",
    "Investor Address":
      "No.13, Parami Street, Lawkanut Housing, Ward 12, Hlaing Tsp, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No 25, Airport Avenue Lane, insein Tsp, Yangon ",
  },
  {
    ID: 1935,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyaw Minn Htet",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "GOLDEN TROGON INDUSTRIAL CO., LTD.",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "MANATHA-604/2003",
    "Permit Date": "2003-03-28T08:37:38Z",
    "Meeting Number": "4/2003",
    "Meeting Date": "2003-02-06T08:38:27Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 13.82,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "YCDC & SHWE GABAR ENTERPRISES LIMITED",
    "Land Area (units not specified in file)": 1.889,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 180,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address": "NO.75/2-KHA, INSEIN ROAD, KYEEMYINDAING, YANGON",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်(၄၂/၉၉)၊ ၆ လမ်းနှင့် ကနောင်မင်းသားကြီးလမ်းထောင့်၊ စက်မှုဇုံ(၁)၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး။",
  },
  {
    ID: 1936,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်သိင်္ဂီဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "White Crane Textile Co., Ltd.",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "MANATHA-613/2003",
    "Permit Date": "2003-04-26T09:21:38Z",
    "Meeting Number": "6/2003",
    "Meeting Date": "2003-02-21T09:22:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 10400,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးမောင်စိန်",
    "Land Area (units not specified in file)": 0.104,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၄၂၊ မာလာမြိုင် ၃ လမ်း၊  အုတ်ကျင်းဘူတာရုံလမ်း၊ လှိုင်မြို့နယ်၊ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 1-HA2, BLOCK NO. 18/A, HLAING TOWNSHIP, YANGON",
  },
  {
    ID: 1937,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U SOE TINT",
    "Name of Principal Organization": "GIANT MOTOR MYANMAR CO., LTD., ",
    "Place of Incorporation": "Myanm ar",
    "Company Name In Myanmar": "Go Excellent (Myanmar) Co.,Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "102/2018",
    "Permit Date": "2018-08-10T09:33:55Z",
    "Meeting Number": "12/2018",
    "Meeting Date": "2018-08-10T09:28:03Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ASSEMBLING, MANUFACTURING AND  SALES OF MOTOR VEHICLES",
    "Amount Of Foreign Capital USD (in Millions)": 2.36,
    "Total Amount Of Capital (in Millions)": 7.34,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Malaysia",
    "Form Of Investment": "JV",
    "Land Owner": "ဒေါ်လှလှအေး",
    "Land Area (units not specified in file)": 3.254,
    "Lease Term": 50,
    "Annual Lease Fee": 72426.64,
    "Land Use Premium": null,
    "Number Of Local Employees": 110,
    "Number Of Foreign Employees": 13,
    Status: "Monitoring Approved",
    "Investor Address":
      "PLOT NO.32, U AUNG MIN STREET,                          2nd  WARD, MAYANGONE TOWNSHIP, YANGON.",
    "Organization Address":
      "PLOT NO.278/4, 278/5, MYAY TAING BLOCK NO.25,  SHWE LIN BAN SETHMU MYOT, HLAING THAR YAR TOWNSHIP, YANGON ",
    "Investment Permitted Address":
      "PLOT NO.278/4,278/5, \t\tMYAY  TAING   BLOCK   NO. 25, SHWE  LIN  BAN  SETHMU  \t\t\tMYOT, HLAING THAR YAR TOWNSHIP,YANGON REGION ",
  },
  {
    ID: 1938,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U KYAW KYAW AUNG",
    "Name of Principal Organization": "MYANMAR TRADE CENTER CO.,LTD., ",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "DAEWOO BUS MYANMAR COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "107/2018",
    "Permit Date": "2018-08-27T07:58:37Z",
    "Meeting Number": "13/2018",
    "Meeting Date": "2018-08-25T08:03:27Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ASSEMBLING, MANUFACTURING,SALES  OF  BUSES AND REPAIR SERVICES ",
    "Amount Of Foreign Capital USD (in Millions)": 2.887,
    "Total Amount Of Capital (in Millions)": 4.687,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "JV",
    "Land Owner": "စက်မှုဝန်ကြီးဌာန၊ အမှတ်(၁) အကြီးစား စက်မှုလုပ်ငန်း",
    "Land Area (units not specified in file)": 14,
    "Lease Term": 25,
    "Annual Lease Fee": 100,
    "Land Use Premium": null,
    "Number Of Local Employees": 215,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "  NO.J/101,AHNAWRAHTA HOUSING, HLEDAN, KAMAYUT TOWNSHIP,YANGON",
    "Organization Address":
      "NO.12/A,KAYMAR STREET, THIRI KAYMAR QUARTER, \t\t\tSAN CHAUNG  TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "PLOT NO.9, \tMYAY TAING   BLOCK  NO. 525/GA, YE SU AHNAUK TAW WARD,  HTAUK  KYANT, MINGALARDON   TOWNSHIP,  YANGON   REGION",
  },
  {
    ID: 1939,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Zaw",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Myanma Arr Marn Fish-Shrimp Feed Production Company Limited",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "Manatha-574/2003",
    "Permit Date": "2003-01-16T07:02:35Z",
    "Meeting Number": "31/2002",
    "Meeting Date": "2002-12-12T07:47:42Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 376.63,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Zaw Tun (Director)  and Shwe Ayeyar Co., Ltd.",
    "Land Area (units not specified in file)": 205.492,
    "Lease Term": 10,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 120,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 7, Second Floor, Shwe Malar Avenue, Yeik Mon, Ba Yint Naung Road, Kamaryut Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Aqua Feed Factory, Plot No. 96, Dagon Myothit (East) Industry Township,  Shrimp Farming Lake, Chaung Wa Village,   Kyauk Tan Township,  Yangon Region. ",
  },
  {
    ID: 1941,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Zaw Lay",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Fisheries and Marine Products 2000 Ltd.",
    "Financial Year From": 2001,
    "Financial Year To": 2002,
    "Permit Number": "Manatha-508/2001",
    "Permit Date": "2001-07-04T08:09:01Z",
    "Meeting Number": "24/2001",
    "Meeting Date": "2001-06-21T05:02:50Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "တန် ၂၀၀၀ ဆန့် အအေးခန်းသိုလှောင်ရုံနှင့် လုပ်ငန်းသုံး ရန်  ၁၀ တန်ကျ ရေခဲစက်တည်ဆောက်၍ သန့်ရှင်းလတ်ဆတ်သော ငါး၊ ပုစွန်များ ပြုပြင်ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 51.84,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Department of Fisheries",
    "Land Area (units not specified in file)": null,
    "Lease Term": 10,
    "Annual Lease Fee": 924750,
    "Land Use Premium": null,
    "Number Of Local Employees": 111,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Building No. (216, 222), Room No. 6(C), 49 Road, Bo Myat Tun Housing, Pazuntaung Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Ministry of Livestock & Fisheries, Department of Fisheries, Ahlone cold storage (north) building, Sinmin Road, Ahlone Township, Yangon Region",
  },
  {
    ID: 1942,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Hla Thein @ Wong Law Sein",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Vivo Power Myanmar Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "068/2018",
    "Permit Date": "2018-07-25T06:53:33Z",
    "Meeting Number": "9/2018",
    "Meeting Date": "2018-07-04T06:53:45Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing And Marketing Of Transformers",
    "Amount Of Foreign Capital USD (in Millions)": 1.544,
    "Total Amount Of Capital (in Millions)": 2.059,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "ဦး၀ေါင်လောရှင် (ခ) ဦးလှသိန်း၊ ဒေါ်ခင်ခင်ရီ(ခ) ကိုးကျင်ဟွန်း",
    "Land Area (units not specified in file)": 2.756,
    "Lease Term": 30,
    "Annual Lease Fee": 0.1,
    "Land Use Premium": null,
    "Number Of Local Employees": 50,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "No.131, Second floor, Lanmadaw Street, & 7-Ward, Lanmadaw Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. (39,48), Myay Taing Block No(Industrial Zone-2), Dagon Myothit Seik kan Township, Yangon Region",
  },
  {
    ID: 1945,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ဇမီရမ်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Shwe Myinn Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "Manatha-1088/2015",
    "Permit Date": "2015-09-25T09:18:01Z",
    "Meeting Number": "16/2015",
    "Meeting Date": "2015-09-11T09:18:54Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "Contract Processing စနစ်ဖြင့် ငါး၊ ပုစွန် ပြုပြအေးခဲထုတ်လုပ်ခြင်းနှင့် အရည်အသွေး မြင့်မားသည့် တန်ဘိုးမြင့် ငါး၊ ပုစွန် ကုန်ချောများထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 743.124,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်ယုမေ (ဒါရိုက်တာ)",
    "Land Area (units not specified in file)": 2.17,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 178,
    "Number Of Foreign Employees": null,
    Status: "Terminated",
    "Investor Address":
      "အမှတ် (၇၃/၈၃)၊ အခန်းအမှတ် (၄၀၇)၊ ၄-လွှာ၊ ဗိုလ်တထောင် ဈေးလမ်း၊ ဗိုလ်တထောင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုဒေသကြီး၊ လှိုင်သာယာ မြို့နယ်၊ ရွှေလင်ပန်းစက်မှုဇုန်၊ မြေတိုင်းရပ်ကွက်အမှတ် (၂၅)၊ မြေကွက်အမှတ် (၃၀၄)",
  },
  {
    ID: 1947,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Thu",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "NAY BROTHERS COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "114/2018",
    "Permit Date": "2018-09-07T04:23:19Z",
    "Meeting Number": "14/2018",
    "Meeting Date": "2018-09-07T04:23:23Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 6070,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "No.(43/B), Parami Road, Ward No.(8), ",
    "Organization Address": "",
    "Investment Permitted Address": "No.43, Parami Road , 8 Ward,",
  },
  {
    ID: 1949,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. HUANG BO",
    "Name of Principal Organization":
      "SINGAPORE GOLDEN PARAGON INVESTMENT PTE. LTD",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar":
      "YANGON GOLDEN PARAGON INVESTMENT COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "108/2018",
    "Permit Date": "2018-08-27T07:14:09Z",
    "Meeting Number": "13/2018",
    "Meeting Date": "2018-08-25T07:14:55Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "CONSTRUCTION, OPERATION AND LEASING OF RESIDENCE AND COMMERCIAL AREA",
    "Amount Of Foreign Capital USD (in Millions)": 119.14,
    "Total Amount Of Capital (in Millions)": 170.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "U Shein Win",
    "Land Area (units not specified in file)": 27.909,
    "Lease Term": 50,
    "Annual Lease Fee": 51.06,
    "Land Use Premium": null,
    "Number Of Local Employees": 2022,
    "Number Of Foreign Employees": 232,
    Status: "Monitoring Approved",
    "Investor Address":
      "ROOM 801, NO 17 JIANG HUA ROAD, TIAMHE DISTRICT, GUANGZHOU CITY, CHINA",
    "Organization Address":
      "NO.60, PAYA LEBAR ROAD # 08-55, PAYA LEBAR SQUARE, SINGAPORE 409051",
    "Investment Permitted Address":
      "PLOT NO. 15 AND 17, SHUKHIN THAR WARD, SHUKHIN THAR ROAD, THAKETA TOWNSHIP, YANGON REGION",
  },
  {
    ID: 1951,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw Nan Mouk Laung Seing ",
    "Name of Principal Organization": "Golden Sky World Company Limited",
    "Place of Incorporation": "Myanmar ",
    "Company Name In Myanmar": "Asian Blue Aviation Company Limited ",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1121/2016",
    "Permit Date": "2016-03-26T10:29:04Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T10:31:35Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business": "International Air Transport Service ",
    "Amount Of Foreign Capital USD (in Millions)": 34.73,
    "Total Amount Of Capital (in Millions)": 70.87,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "No. 152/154/2/3, Floor, 19th Street, Ward No. 4, Latha Township, Yangon ",
    "Organization Address":
      "W-63, Thirimon Estate, Bayintnaung Road, Hlaing Tsp, Yangon ",
    "Investment Permitted Address":
      "W-63, Thirimon Estate, Bayintnaung Road, Hlaing Tsp, Yangon ",
  },
  {
    ID: 1952,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Min Zayar Hlaing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Myanmar Millennium Group Production Company Limited",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "Manatha-628/2003",
    "Permit Date": "2003-05-17T05:03:06Z",
    "Meeting Number": "Cab 9/2003",
    "Meeting Date": "2003-05-08T05:03:45Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business": "တစ်နေ့ တန် (၁၀၀)ကျ ရေခဲစက်ရုံလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 129.54,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "မြန်မာ့သစ်လုပ်ငန်း",
    "Land Area (units not specified in file)": 0.45,
    "Lease Term": 15,
    "Annual Lease Fee": 0.546,
    "Land Use Premium": null,
    "Number Of Local Employees": 50,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၄ (ဒီ)၊ မြေနီကုန်းပလာဇာ၊ စမ်းချောင်းမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ ကြည့်မြင်တိုင်မြို့နယ်၊ မြန်မာ့ သစ်လုပ်ငန်း ပိုင်အမှတ် (၁) သစ်စက်ဝင်း",
  },
  {
    ID: 1954,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးခင်စိုး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Anawar Hlwan Co., Ltd",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "Manata-360/2000",
    "Permit Date": "2000-04-18T05:32:18Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "အအေးခန်းစက်ရုံ၊ ရေခဲစက်ရုံနှင့် ဆိပ်ခံတံတား တည်ဆောက်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 355.7,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးခင်စိုး",
    "Land Area (units not specified in file)": 6.532,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်-၁၁၃၊ ၅၂-လမ်း၊",
    "Organization Address": "",
    "Investment Permitted Address": "မြေကွက်အမှတ်-၅၈၄၊ မြေတိုင်းရပ်ကွက်-၁၀၊",
  },
  {
    ID: 1955,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Xue Wennan",
    "Name of Principal Organization": "Proton Textiles CC",
    "Place of Incorporation": "South Africa",
    "Company Name In Myanmar": "Proton Myanmar Textile Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "952/2015",
    "Permit Date": "2015-05-13T04:57:13Z",
    "Meeting Number": "7/2015",
    "Meeting Date": "2015-04-28T04:57:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.309,
    "Total Amount Of Capital (in Millions)": 1.309,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "South Africa",
    "Form Of Investment": "FDII",
    "Land Owner": "Ngwe Kantkaw Industry Co., Ltd.",
    "Land Area (units not specified in file)": 1.47,
    "Lease Term": 50,
    "Annual Lease Fee": 0.029,
    "Land Use Premium": null,
    "Number Of Local Employees": 560,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.16, Room No.401, Block 6, 9 Street, Shanghai Pudong Dist, Zhuo Qiao Province, People Republic of China",
    "Organization Address":
      "1st Floor, Block A, The Offices of Hyde Park, Strouthos Place, Hyde Park, 2196, Republic of  South Africa",
    "Investment Permitted Address":
      "Plot No.161+162, Myay Taing Block No.5, Industrial  Zone-5 (Extend), Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 1956,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Ng Say Hoke",
    "Name of Principal Organization":
      "Royal Nay Nan Taw Business Group Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Textile Palace Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "953/2015",
    "Permit Date": "2015-05-07T05:31:54Z",
    "Meeting Number": "7/2015",
    "Meeting Date": "2015-04-28T05:32:22Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ငန်းနှင့် ဆက်စပ် သည့် ဇာထိုးပန်းထိုးနှင့်ပုံနှိပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.84,
    "Total Amount Of Capital (in Millions)": 4.59,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "U Than Aung",
    "Land Area (units not specified in file)": 2.522,
    "Lease Term": 30,
    "Annual Lease Fee": 0.053,
    "Land Use Premium": null,
    "Number Of Local Employees": 575,
    "Number Of Foreign Employees": 18,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.118, Ground Floor, 52nd Street, Ward No.1, Pazundaung Township, Yangon",
    "Organization Address":
      "Room No. (503/504), Yangon International Hotel, Ahlone Road, Ahlone Township, Yangon",
    "Investment Permitted Address":
      "327/329, Set Hmu Rd., Myaung Ta Kar Industrial Zone,, Hmaw Bi township, Yangon Region",
  },
  {
    ID: 1958,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhong Xian Wen",
    "Name of Principal Organization": "Hingtex Trading Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Fook Hing (Shwe Kha Yu) Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "944/2015",
    "Permit Date": "2015-05-07T08:05:25Z",
    "Meeting Number": "6/2015",
    "Meeting Date": "2015-04-03T08:05:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Clothing and Various Kinds of Underwear on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 6.553,
    "Total Amount Of Capital (in Millions)": 6.553,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Myint Myint",
    "Land Area (units not specified in file)": 2.917,
    "Lease Term": 50,
    "Annual Lease Fee": 0.061,
    "Land Use Premium": null,
    "Number Of Local Employees": 1250,
    "Number Of Foreign Employees": 12,
    Status: "Monitoring Approved",
    "Investor Address":
      "Flat 611,6/F, Tower-1, Cheung Sha Plaza, 833 cheung Sha Wun Road, Cheung Sha Wan, Kowloon, Hong Khong",
    "Organization Address":
      "Flat 611,6/F, Tower-1, Cheung Sha Plaza, 833 Cheung Sha Wan Road, Cheung Sha Wan, Kowloon, Hong Kong",
    "Investment Permitted Address":
      "Plot No.45, Myay Taing Block No.14, Shwe Than Lwin Industrial Zone, Hlaing Thar yar Township, Yangon Region",
  },
  {
    ID: 1959,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wang Jianghong",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Yun Cheng Plate Making Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "747/2015",
    "Permit Date": "2015-08-06T08:36:53Z",
    "Meeting Number": "7/2015",
    "Meeting Date": "2015-04-28T08:37:26Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Printing Plates and Blocks",
    "Amount Of Foreign Capital USD (in Millions)": 2.271,
    "Total Amount Of Capital (in Millions)": 2.271,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Multi Pack World Industry Co., Ltd.",
    "Land Area (units not specified in file)": 2.636,
    "Lease Term": 30,
    "Annual Lease Fee": 0.056,
    "Land Use Premium": null,
    "Number Of Local Employees": 200,
    "Number Of Foreign Employees": 12,
    Status: "Monitoring Approved",
    "Investor Address":
      "Room No-402, Unit-6, Building-15, International Garden Residential District, Middle Haiyuan Road, Wuhua District, Kunming City, Yunnan Province, People's Republic of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.162,163, Myay Taing Block No.25, Shwe Lin Pan Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 1960,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Khin Soe",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Kamax Group Myanmar Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "985/2015",
    "Permit Date": "2015-07-24T03:01:40Z",
    "Meeting Number": "12/2015",
    "Meeting Date": "2015-07-03T03:03:05Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Assembling Manufacturing and Sales of Tri Motor Cycle",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "U Khin Soe",
    "Land Area (units not specified in file)": 0.358,
    "Lease Term": 10,
    "Annual Lease Fee": 0.024,
    "Land Use Premium": null,
    "Number Of Local Employees": 50,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.B-1/A, Hanthar Yeik Mon Avenue, Mingalar Thukha Street, Ward 5,Kamayut Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "U Paing No. 244, Kwin No. 117/ Taung Yin, Sint Kaing Township, Mandalay Region. ",
  },
  {
    ID: 1961,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Thant Zin",
    "Name of Principal Organization": "Han Sein Thant Trading Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Zenner han Sein Thant  Co., Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "904/2015",
    "Permit Date": "2015-02-10T03:35:57Z",
    "Meeting Number": "2/2015",
    "Meeting Date": "2015-01-31T03:36:42Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Assembling and Manufacturing of Water Meters",
    "Amount Of Foreign Capital USD (in Millions)": 0.22,
    "Total Amount Of Capital (in Millions)": 0.4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Luxembourg",
    "Form Of Investment": "JV",
    "Land Owner": "U Thant Zin",
    "Land Area (units not specified in file)": 103.92,
    "Lease Term": 10,
    "Annual Lease Fee": 0.012,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "91-H(1), Than Lwin Street, Bahan Twonship, Yangon Region",
    "Organization Address":
      "Building No.112, Room-28,29,3rd Floor, Pyay Road, 8 Mile, Mayangone Township, Yangon Region",
    "Investment Permitted Address":
      "Plto No.88,89,90, Myay Taing Block.42/Ka, Zeegone, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 1962,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Peng, Hao",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "LP (Myanmar) Industrial Manufacturing Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "079/2018",
    "Permit Date": "2018-08-30T09:26:29Z",
    "Meeting Number": "11/2018",
    "Meeting Date": "2018-08-10T09:27:32Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing And Export Of Rubber Wood Swen Timber By Using Local Rubber Wood On Contract Manufacturing Process (CMP) Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.922,
    "Total Amount Of Capital (in Millions)": 0.922,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 35,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Ye Aung ",
    "Land Area (units not specified in file)": 3.191,
    "Lease Term": 15,
    "Annual Lease Fee": 0.062,
    "Land Use Premium": null,
    "Number Of Local Employees": 75,
    "Number Of Foreign Employees": 9,
    Status: "Draft",
    "Investor Address":
      "No.11,2nd  Floor, Unit 1, Building 28, No.330, Section 1, North Ring Road, Jinniu District, Chengdu City, Sichuan Province,People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.41, Myay Taing Block No.50, Thardu Kan Industrial Zone, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 1963,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦး၀င်းအောင် (ခ) ဦး၀င်းဟို",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Thein Wa Company Limited (သိန်း၀ ကုမ္ပဏီလီမီတက်)",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "080/2018",
    "Permit Date": "2018-09-26T09:58:20Z",
    "Meeting Number": "12/2018",
    "Meeting Date": "2018-09-05T08:12:52Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 423.985,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးဇော်ဇော်အောင်",
    "Land Area (units not specified in file)": 2.227,
    "Lease Term": 10,
    "Annual Lease Fee": 60,
    "Land Use Premium": null,
    "Number Of Local Employees": 400,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "တိုက်(၃)၊ အခန်း(၂)၊ အင်းစိန်လမ်း၊  လှိုင်သီရိအိမ်ရာ၊ (၉)ရပ်ကွက်၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၅၉၊ မြေတိုင်းရပ်ကွက်အမှတ် ၁၁၄၊ စက်မှုဇုန်၊ ဒဂုံမြို့သစ်(တောင်ပိုင်း)မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး။",
  },
  {
    ID: 1964,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦး၀င်းဌေး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Gandamar Shwe Pyi Company Limited (ဂန္ဓမာရွှေပြည်ကုမ္ပဏီလီမီတက်)",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "081/2018",
    "Permit Date": "2018-09-26T10:32:41Z",
    "Meeting Number": "12/2018",
    "Meeting Date": "2018-09-05T08:15:58Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Logistic And Warehousing Services",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးကျော်ဇော",
    "Land Area (units not specified in file)": null,
    "Lease Term": 1,
    "Annual Lease Fee": 38.61,
    "Land Use Premium": null,
    "Number Of Local Employees": 53,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "အမှတ်(၂၃/စီ)၊ ရှမ်းရိပ်သာလမ်း၊ ဟုတ်လမ်းဘူတာရပ်ကွက်၊ စမ်းချောင်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၅၉၊ မြေတိုင်းရပ်ကွက်အမှတ် ၁၄၃/၁၊ ကျန်စစ်သားရိပ်မွန်စက်မှုဇုန်၊ ဒဂုံမြို့သစ်(တောင်ပိုင်း)မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1965,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်ချိုထွေး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "San Mya Thaw Tar Manufacturing Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "082/2018                      ",
    "Permit Date": "2018-09-26T03:28:26Z",
    "Meeting Number": "12/2018",
    "Meeting Date": "2018-09-05T08:18:52Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1106.686,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးကျော်ကျော်နိုင်၊ ဒေါ်ယဥ်ယဥ်မြ",
    "Land Area (units not specified in file)": 0.616,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 231,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "အမှတ်(၁၃)၊ ၂-လမ်း၊(၂)ရပ်ကွက်၊ မြောင်းမြမြို့၊ ဧရာ၀တီတိုင်းဒေသကြီး ။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၁၂၊ မြေတိုင်းရပ်ကွက်အမှတ် စက်မှုဇုန်၊ သာကေတမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး ။",
  },
  {
    ID: 1966,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Woorie Shirts Corporation",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Woorie MJ Shirts Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "083/2018",
    "Permit Date": "2018-09-26T04:03:55Z",
    "Meeting Number": "12/2018",
    "Meeting Date": "2018-09-05T08:17:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMPစနစ်ဖြင့်အမျိုးသား၀တ် ရှပ်အင်္ကျီ၊ အမျိုးသမီး၀တ်ရှပ်အင်္ကျီနှင့် ကလေး၀တ်အင်္ကျီအမျိုးမျိုးချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "ဦးကျော်ဇော၊ ဦးကျော်၀င်း",
    "Land Area (units not specified in file)": 2.05,
    "Lease Term": 10,
    "Annual Lease Fee": 147.935,
    "Land Use Premium": null,
    "Number Of Local Employees": 287,
    "Number Of Foreign Employees": 7,
    Status: "Draft",
    "Investor Address":
      "7F, 48 Booldang 14-Ro, Seobuk-Gu, Cheonan-City, Choongcheongnam-Do, 31169 , Republic Of Korea",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေတိုင်းရပ်ကွက် အမှတ်(၁၄၃/၁)၊ မြေကွက်အမှတ်(၅၆/၅၉)၊ ကျန်စစ်သားရိပ်မွန်စက်မှုဇုန်၊ ဒဂုံမြို့သစ်(တောင်ပိုင်း)မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး။",
  },
  {
    ID: 1967,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Luo Guoyun",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Guanghe Industry Myanmar Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "084/2018",
    "Permit Date": "2018-09-26T06:28:00Z",
    "Meeting Number": "12/2018",
    "Meeting Date": "2018-09-05T08:26:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "သောက်ရေသန့်ထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း1",
    "Amount Of Foreign Capital USD (in Millions)": 4,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Nyunt Nyunt Htay",
    "Land Area (units not specified in file)": 2.67,
    "Lease Term": 30,
    "Annual Lease Fee": 0.05,
    "Land Use Premium": null,
    "Number Of Local Employees": 77,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "9-100#Hilltops   99-101 Carinhill Circle, Singapore",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.1/2,2/4, Myay Taing Block No.521/A, Mingalardon Township, Yangon Region",
  },
  {
    ID: 1968,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chen, Maoxin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Yangon XieHui Shoes Industry Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "085/2018",
    "Permit Date": "2018-09-26T07:04:30Z",
    "Meeting Number": "12/2018",
    "Meeting Date": "2018-09-05T08:29:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Shoes In CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.62,
    "Total Amount Of Capital (in Millions)": 0.62,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 70,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "ဦးစိုးလှိုင်၊ ဦးဟုတ်တိတ်",
    "Land Area (units not specified in file)": null,
    "Lease Term": 6,
    "Annual Lease Fee": 0.073,
    "Land Use Premium": null,
    "Number Of Local Employees": 206,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "Room 613, Building 1, No.526, Xinhua North Road, Licheng District, Quanzhou, Fujian People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.198/19, Myay Taing Block No. Satmhuzone 1, Dagon Myothit Seikkan Township, Yangon Region",
  },
  {
    ID: 1969,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ding Yue",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Guotai Fuhua Garment (Myanmar) Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "086/2018",
    "Permit Date": "2018-09-26T07:57:57Z",
    "Meeting Number": "12/2018",
    "Meeting Date": "2018-09-05T08:34:52Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.5,
    "Total Amount Of Capital (in Millions)": 4.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 70,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Wai Wai Kyaw",
    "Land Area (units not specified in file)": 2.273,
    "Lease Term": 25,
    "Annual Lease Fee": 0.036,
    "Land Use Premium": null,
    "Number Of Local Employees": 1936,
    "Number Of Foreign Employees": 20,
    Status: "Draft",
    "Investor Address":
      "Suite 606, Building 68, Shagong Yangshe Town, Zhangjiagang City, Jiangsu Province, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.46, Myay Taing Block No.24, Nway Pin Lal Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 1970,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမျိုးဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Fong Chi Co.,Ltd.",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "MaNaTha-213/98",
    "Permit Date": "1998-12-24T06:17:51Z",
    "Meeting Number": "18/98",
    "Meeting Date": "1998-10-09T06:18:56Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "သစ်အခြေခံပစ္စည်းများ ထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 43,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးမျိုးဝင်း",
    "Land Area (units not specified in file)": 0.688,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": 6,
    "Number Of Local Employees": 71,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၁၄၉)၊ ၃၇ လမ်း၊ ကျောက်တံတားမြို့နယ်၊       \n  ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-(၅၂/က)၊ မြေတိုင်းရပ်ကွက်အမှတ်(၄၂)၊ စက်မှုဇုန်၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 1971,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဝင်းသိန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ဇီဇဝါကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "MaNaTha-029/96",
    "Permit Date": "1996-07-22T03:07:44Z",
    "Meeting Number": "7/96",
    "Meeting Date": "1996-05-10T03:11:10Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်အခြေခံကုန်ချောများ ထုတ်လုပ်ဖြန့်ဖြူးခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 12.5,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဇီဇဝါကုမ္ပဏီလီမိတက်",
    "Land Area (units not specified in file)": 2.54,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 35,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်(၄၁)၊ မြောင်းမြလမ်း၊ စမ်းချောင်းမြို့နယ်၊          ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ဦးပိုင်အမှတ်၊ ၈၅/၁၃၊ ၈၆၊ ၈၈၊ ကွင်းအမှတ်-၅၈၄၊ ရွာသစ်ကွင်း၊ တပ်ကြီးကုန်းကျေးရွာအုပ်စု၊ မှော်ဘီမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 1972,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ဝမ်လီရင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Yangon Fishery Development CO., Ltd",
    "Financial Year From": 2001,
    "Financial Year To": 2002,
    "Permit Number": "Manatha-516/2001",
    "Permit Date": "2001-08-24T03:23:10Z",
    "Meeting Number": "32/2001",
    "Meeting Date": "2001-08-16T06:39:18Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "ငါးဖမ်းခြင်း၊ရေခဲစက်ရုံနှင့်အအေးခန်းတည်ဆောက်၍ရေခဲ၊ငါး၊ပုစွန်များပြုပြင်ထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 74.404,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "မွေးမြူရေးနှင့် ရေလုပ်ငန်း ဝန်ကြီးဌာန",
    "Land Area (units not specified in file)": 2.24,
    "Lease Term": 20,
    "Annual Lease Fee": 4.079,
    "Land Use Premium": null,
    "Number Of Local Employees": 258,
    "Number Of Foreign Employees": 16,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်-၂၄၃၊ စရည်းပင်လမ်း၊ သုဝဏ္ဏ၊",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေတိုင်းအမှတ်-၂/၂၊ အနောက်ကြို့ကုန်းရပ်ကွက်၊",
  },
  {
    ID: 1975,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမျိုးညွန့်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "General Food Technology Industry Co., Ltd",
    "Financial Year From": 2007,
    "Financial Year To": 2008,
    "Permit Number": "Manatha-676/2007",
    "Permit Date": "2007-03-28T04:45:15Z",
    "Meeting Number": "9/2007",
    "Meeting Date": "2007-03-15T04:53:34Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "တန်(၂၀၀)ဆန့် အအေးခန်းစက်ရုံ တည်ဆောက်၍ သန့်ရှင်းလတ်ဆတ်သောငါး၊ ပုစွန်များ ပြုပြင်ထုတ်လုပ်ခြင်း\nလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 80.62,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "မွေးမြူရေးနှင့် ရေလုပ်ငန်းဝန်ကြီးဌာန၊ ငါးလုပ်ငန်းဦးစီးပိုင်မြေ",
    "Land Area (units not specified in file)": 3.56,
    "Lease Term": 10,
    "Annual Lease Fee": 6.5,
    "Land Use Premium": 6.5,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်-၃၆၊ အင်းယားမြိုင်လမ်း။",
    "Organization Address": "",
    "Investment Permitted Address": "မြေတိုင်း-၂/၂၊ အနောက်ကြို့ကုန်းရပ်ကွက်၊",
  },
  {
    ID: 1978,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ရှုရှု",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Chein Kaung Manufacturing Co., Ltd",
    "Financial Year From": 2008,
    "Financial Year To": 2009,
    "Permit Number": "MaNaTha-696/2008",
    "Permit Date": "2008-12-19T03:57:09Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "တန်(၃၀၀)ဆံ၊ အအေးခန်းစက်ရုံတည်ဆောက်ပြီး သန့်ရှင်း လတ်ဆတ်သော ငါး၊ ပုစွန်များ ပြုပြင် ထုတ်လုပ်ခြင်း လုပ်ငန်း။",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 840.95,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "မွေးမြူရေးနှင့် ရေလုပ်ငန်း ဝန်ကြီးဌာန၊ ငါးလုပ်ငန်းဦးစီးဌာနပိုင်မြေ",
    "Land Area (units not specified in file)": 2.75,
    "Lease Term": 20,
    "Annual Lease Fee": 450,
    "Land Use Premium": 5,
    "Number Of Local Employees": 206,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်-၁၂၆၊ ပထမထပ်၊ ဘိုကလေးဈေးလမ်း၊",
    "Organization Address": "",
    "Investment Permitted Address":
      "မွေးမြူရေးနှင့် ရေလုပ်ငန်း ဝန်ကြီးဌာနပိုင်မြေတိုင်းရပ်ကွက်၊ အမှတ်-၂/၂၊ အနောက်ကြို့ကုန်းရပ်ကွက်၊",
  },
  {
    ID: 1981,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Adirek Sripratak",
    "Name of Principal Organization":
      "Bangkok Livestock Processing Company Limited",
    "Place of Incorporation": "Bangkok, Thailand",
    "Company Name In Myanmar": "Myanmar C.P Livestock Company Limited",
    "Financial Year From": 1995,
    "Financial Year To": 1996,
    "Permit Number": "238/1996",
    "Permit Date": "1996-12-18T04:27:23Z",
    "Meeting Number": "18/1996",
    "Meeting Date": "1996-11-29T04:28:13Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "Feedmill, Breeder Farm, Hatchery Farm and Contract Farming ",
    "Amount Of Foreign Capital USD (in Millions)": 9.492,
    "Total Amount Of Capital (in Millions)": 9.492,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 24,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Thailand",
    "Form Of Investment": "FDII",
    "Land Owner": "Livestock Feedstuff and Milk Product Enterprise",
    "Land Area (units not specified in file)": 65,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "3133/27 Sukhumvit 101/2, Bang-Nga, Prakhanong, Bangkok, thailand",
    "Organization Address":
      "528/2-11 Sukhumvit 22, Klongton, Klongtoey, Bangkok 10110, Thailand",
    "Investment Permitted Address":
      "Ngasutaung (Hlegyu Township) and Pyin Ma Bin (Mingalardon Township), Yangon Division",
  },
  {
    ID: 1982,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးစိန်မင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ရွှေဇလပ်စက်မှုကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "MaNaTha-317/99",
    "Permit Date": "1999-12-13T07:01:16Z",
    "Meeting Number": "21/99",
    "Meeting Date": "1999-11-05T07:02:25Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်ခွဲသားအမျိုးမျိုးနှင့် သစ်အခြေခံတန်ဖိုးမြှင့်ပစ္စည်းများထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 80.39,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "S.S Brother International Co.,Ltd.",
    "Land Area (units not specified in file)": 3.708,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 150,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်(၂၂၇)၊ ဗညားဒလလမ်း၊ တာမွေမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်မြို့၊ ဒဂံ ုမြို့သစ်တောင်ပိုင်းမြို့နယ်၊ စက်မှုဇုံ၊ ​ေ မြတိုင်းရပ်ကွက် ၂၃(တိုးချဲ့)၊ အကွက်အမှတ်(၄၉၈၊ ၄၉၉၊ ၅၀၀၊ ၅၀၁၊ ၅၀၂ နှင့် ၅၀၃)",
  },
  {
    ID: 1983,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးစိန်မြင့်(ခ)အိုက်ဘော",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "I.S Garment Co.,Ltd.",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "217/1999",
    "Permit Date": "1999-01-12T08:05:12Z",
    "Meeting Number": "22/98",
    "Meeting Date": "1998-12-11T08:06:13Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "C.M.P စနှစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.35,
    "Total Amount Of Capital (in Millions)": 27.1,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်ခင်သန်းဌေး",
    "Land Area (units not specified in file)": 0.055,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 188,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်(၆၄၄)၊ ကုန်သည်လမ်း၊ ပန်းဘဲတန်းမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၄၁)၊ လှိုင်သာယာစက်မှုဇုန်(၂)၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 1984,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်နန်းနွယ်ဖေ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Megatrend Manufacturing Co.,Ltd.",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "218/1999",
    "Permit Date": "1999-01-12T08:38:55Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "C.M.P စနှစ်ဖြင့် အသင့်ချုပ်ပြီး အထည်များ ထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.956,
    "Total Amount Of Capital (in Millions)": 16.736,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 305,
    "Number Of Foreign Employees": 2,
    Status: "Approved",
    "Investor Address":
      "အမှတ်(၁၈)၊ ကန်မြောက်(၂)လမ်း၊ ကန်တော်ကလေး၊ မင်္ဂလာတောင်ညွှန့်မြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၅၄)၊ ပဒင်းဝန်ဦးရွှေဘင်လမ်း၊ လှိုင်သာယာစက်မှုဇုန်(၁)၊ရန်ကုန်တိုင်း။",
  },
  {
    ID: 1985,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးတက်တိုး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Winner Brothers International Ltd.",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "Manathe 132/1998",
    "Permit Date": "1998-04-30T10:09:17Z",
    "Meeting Number": "14/98",
    "Meeting Date": "1998-04-06T06:34:11Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 25.8,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးတက်တိုး (Winner Brothers International Ltd.)",
    "Land Area (units not specified in file)": 90.96,
    "Lease Term": 10,
    "Annual Lease Fee": 5000,
    "Land Use Premium": null,
    "Number Of Local Employees": 79,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 126, Ground Floor, 18 Road, Latha Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Kwin No. 479, Ka thet Kwin, Wett Kite Village, Kungyangon Township, Yangon Region",
  },
  {
    ID: 1986,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Zaw Minn ",
    "Name of Principal Organization": "STREAM NET COMPANY LIMITED",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "ELITE TELECOM PUBLIC COMPANY LIMITED ",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "112/2018",
    "Permit Date": "2018-09-15T02:34:18Z",
    "Meeting Number": "15/2018",
    "Meeting Date": "2018-09-15T02:35:05Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Telecommunications Service : (DWDM Backbone, Metro Transmission, Domestic Bandwidth wholesale, Mobile Backhaul Network, , ISP Service, Wireless Broadband, FTTx, VOIP, Domain Registration, Web Design, Hosting Duct, Trenches, Poles and Dark Fiber and Satellite Broadband Internet Service လုပ်ငန်း)",
    "Amount Of Foreign Capital USD (in Millions)": 29.55,
    "Total Amount Of Capital (in Millions)": 44.11,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 13,
    "Investing Country": "Vietnam",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.8, BAWDI YEIK THAR STREET, SHWE TAUNG GYAR WARD (2), BAHAN TOWNSHIP, YANGON ",
    "Organization Address":
      "NO.A/9, MINDAMA STREET, MAYANGONE   TOWNSHIP,  YANGON    ",
    "Investment Permitted Address":
      "No. A/9, 7th Floor, (left-Right), Shwe Kanbar Housing Complex, Mayangone Tsp, Yangon ",
  },
  {
    ID: 1987,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yan Xiaoming",
    "Name of Principal Organization": "Jiangsu Best Fashion Dress Co., Ltd.",
    "Place of Incorporation": "People's Republic of China",
    "Company Name In Myanmar": "Best Hubo Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "901/2015",
    "Permit Date": "2015-02-04T03:08:45Z",
    "Meeting Number": "1/2015",
    "Meeting Date": "2015-01-16T03:09:14Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.1204,
    "Total Amount Of Capital (in Millions)": 1.1204,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Green Light Company Limited",
    "Land Area (units not specified in file)": 3.374,
    "Lease Term": 20,
    "Annual Lease Fee": 0.081,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.81, Taing Su State, Taing Ying City, Zhu Tang Township, People's Republic of China",
    "Organization Address":
      "No.88, Huaxi Road, Zhutang Town, Jiangyin, Jiangsu, People's Republic of China",
    "Investment Permitted Address":
      "Plot No.7,8, U Myuu Street, Myay Taing Block No.65(Settmu), Shwe Pyithar Industrial Zone-4, Shwe Pyithar Township, Yangon Region",
  },
  {
    ID: 1988,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမျိုးခင်(ခ) ဦးမျိုးဟိန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Khaing Su Thu Industrial Co.,Ltd.",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "MaNaTha-311/1999",
    "Permit Date": "1999-12-13T03:17:31Z",
    "Meeting Number": "17/99",
    "Meeting Date": "1999-10-01T03:18:50Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်အချောထည်နှင့် ပရိဘောဂပစ္စည်းများထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 75,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးမျိုးခင်၊ ဒေါ်သူဇာမင်း၊ ဦးတင်အောင်ဝင်း",
    "Land Area (units not specified in file)": 1.912,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 165,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၃၄၊/၃၉၊ ရွှေဘုံသာလမ်း၊ ပန်းဘဲတန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "အကွက်အမှတ်(၂၀၅)၊ ​ေ မြတိုင်းရပ်ကွက်အမှတ်(၂)၊ စက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 1989,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. YOICHI ENOMOTO ",
    "Name of Principal Organization":
      "Organization    NSKRE   SINGAPORE   PTE. LTD",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar":
      "NSKRE    RESIDENCE (MYANMAR)  COMPANY  LIMITED ",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "113/2018",
    "Permit Date": "2018-09-24T03:29:51Z",
    "Meeting Number": "14/2018",
    "Meeting Date": "2018-08-24T03:30:17Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "CONSTRUCTION, LEASING AND MANAGEMENT OF SERVICE APARTMENT ",
    "Amount Of Foreign Capital USD (in Millions)": 79.6,
    "Total Amount Of Capital (in Millions)": 80,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner":
      "Myanma Pharmaceutical Industrial Enterprise, Ministry of Industry",
    "Land Area (units not specified in file)": 1.48,
    "Lease Term": 50,
    "Annual Lease Fee": 270764,
    "Land Use Premium": 1480000,
    "Number Of Local Employees": 135,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 3-45-A-403, KASAMA, SAKAE KU, YOKOHAMA, KANAGAWA, 247-0006, JAPAN ",
    "Organization Address":
      "., ,10  ANSON  ROAD  # 14-06,  INTERNATIONAL PLAZA,  SINGAPORE  079903   ",
    "Investment Permitted Address":
      "NO. 77, 77 A, MYAY TAING  BLOCK NO 34 C 1, THARYARSHWEPYI STREET, TAMWE LAY WARD, TAMWE TOWNSHIP, YANGON   REGION ",
  },
  {
    ID: 1990,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်ခိုင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ခရစ်စတယ်လ်ဂါးမင့်အင်န်နစ်တင်းအင်ဒက်စ်တရီကုမ္ပဏီလီမိတက် (Krystal Garment & Knitting Industry Co., Ltd.)",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "မနသ-၁၀၈/၉၇",
    "Permit Date": "1997-12-26T05:12:25Z",
    "Meeting Number": "၂၀/၉၇",
    "Meeting Date": "1997-12-05T05:13:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "စီအမ်ပီစနစ်အရ အထည်ချုပ်နှင့် သိုးမွှေး ထည်ယက်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 41,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအောင်ခိုင်နှင့် ဦးမိုးဝင်းမောင်",
    "Land Area (units not specified in file)": 2.011,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၆၁၅ (ဒီ)၊ ပြည်လမ်း၊ ကမာရွတ်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၄၂၊ မြေတိုင်းရပ်ကွက်အမှတ် ဇုန်-၃၊ စက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 1991,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်နန်းနွယ်ဖေ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar Megatrend Manufacturing Co.,Ltd.",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "218/",
    "Permit Date": "1998-11-27T05:21:43Z",
    "Meeting Number": "21/1998",
    "Meeting Date": "1999-11-27T05:17:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "C.M.P စနှစ်ဖြင့် အသင့်ချုပ်ပြီး အထည်များ ထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 16.736,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "အမှတ်(၁၈)၊ ကန်မြောက်(၂)လမ်း၊ ကန်တော်ကလေး၊မင်္ဂလာတောင်ညွှန့်မြို့နယ်၊ရန်ကုန်မြို့။",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေအကွက်အမှတ်(၅၄)၊ပဒင်းဝန် ဦးရွှေဘင်လမ်း၊ လှိုင်သာယာစက်မှုဇုန်(၁)၊ရန်ကုန်မြို့။",
  },
  {
    ID: 1992,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးသန်းလွင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ဟိန်းမြန်မာကုမ္ပဏီလီမိတက် (Hein Myanmar Co., Ltd.)",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "မနသ-၁၀၉/၉၇",
    "Permit Date": "1997-12-26T06:58:21Z",
    "Meeting Number": "၂၀/၉၇",
    "Meeting Date": "1997-12-05T06:59:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Eagle  နှင့် Noriko အမှတ်တံဆိပ်တို့ဖြင့် ထီးထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 48,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးသန်းလွင်နှင့် ဒေါ်နန်းခင်မွှေး",
    "Land Area (units not specified in file)": 3.72,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 350,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၅၅၊ မြေညီထပ်၊ ၂-လမ်း၊ လမ်းမတော် မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ဦးပိုင်အမှတ် (စက်မှု-၁၉၊ ၂၀၊ ၂၁၊ ၅၀၊ ၅၁၊ ၅၅၂)၊ အကွက်အမှတ် (၁) ကံကြီးကုန်းကွင်း၊ အမှတ် (၄) ရပ်ကွက်၊ ထန်းတပင်မြို့နယ်၊ ရန်ကုန်မြောက်ပိုင်း ခရိုင်",
  },
  {
    ID: 1993,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ခင်မြတ်သူ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar Embroidery Center Ltd.",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "221/1999",
    "Permit Date": "1999-01-28T07:06:17Z",
    "Meeting Number": "1/1999",
    "Meeting Date": "1999-01-01T07:07:57Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "ဇာပန်းထိုးစက်ရုံလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 18.7,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 0.429,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 94,
    "Number Of Foreign Employees": 4,
    Status: "Submitted",
    "Investor Address":
      "တိုက်(၆)၊ အခန်း(၄၀၅)၊ ပုဇွန်တောင်ဥယျာဉ်အိမ်ရာ စီမံကိန်း၊ပုဇွန်တောင်လမ်း၊ ပုဇွန်တောင်မြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၅၀)၊ ဆရာရှမ်းလမ်း၊ စက်မှုဇုန်(၁)၊ လှိုင်သာယာမြို့နယ်၊ရန်ကုန်မြို့။",
  },
  {
    ID: 1994,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်သန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "National Pride Industry Ltd.",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "229/1999",
    "Permit Date": "1999-02-26T03:55:06Z",
    "Meeting Number": "3/1999",
    "Meeting Date": "1999-01-29T03:57:57Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "ပလပ်စတစ်ပီနန်အိတ်များထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 110,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 1.89,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "အမှတ်(၃၅)၊ ညောင်တုန်းစျေးလမ်း၊ ပုဇွန်တောင်မြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၆၆)၊ စက်မှုဇုန်(၃)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 1995,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်သက်သက်မွန်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Tai Yar Garment Industry Co.,Ltd.",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "233/1999",
    "Permit Date": "1999-03-23T05:15:22Z",
    "Meeting Number": "3/1999",
    "Meeting Date": "1999-01-29T05:16:24Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "C.M.P စနှစ်ဖြင့်အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.93,
    "Total Amount Of Capital (in Millions)": 55.59,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအင်စိုး",
    "Land Area (units not specified in file)": 1.033,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 787,
    "Number Of Foreign Employees": 6,
    Status: "Approved",
    "Investor Address":
      "အမှတ်(၄၂/က)၊ ပထမထပ်၊ ၄- လမ်း၊ လမ်းမတော်မြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၆၅)၊ စက်မှုဇုန်(၄)၊လှိုင်သာယာ၊ရန်ကုန်မြို့",
  },
  {
    ID: 1996,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးစိုးမြင်‌့သိန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ယူနီဂရိုးကုမ္ပဏီလီမိတက်(Unigrow Co., Ltd.)",
    "Financial Year From": 98,
    "Financial Year To": 99,
    "Permit Number": "မနသ-၁၅၃/၉၈",
    "Permit Date": "1998-07-15T06:09:00Z",
    "Meeting Number": "၁၀/၉၈",
    "Meeting Date": "1998-06-12T06:09:57Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "အသင့်ချုပ်ပြီးအထည်များထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 16.35,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ယူနီဂရိုးကုမ္ပဏီလီမိတက်",
    "Land Area (units not specified in file)": 0.244,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 93,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်-၂၄၂၊မြေညီထပ်၊ဆိပ်ကမ်းသာလမ်း၊ကျောက်တံတားမြိုနယ်၊ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေတိုင်းရပ်ကွက်အမှတ်-၄၂၊မြေကွက်အမှတ်-၁၇၃၊စက်မှုဒေသ၊ရွှေပြည်သာမြို့နယ်၊ရန်ကုန်တိုင်း",
  },
  {
    ID: 1997,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်သော်တာဇင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "အီဗွာဆောက်လုပ်ရေးကုမ္ပဏီလီမိတက် (Eva Construction Co., Ltd.)",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "မနသ-၁၁၅/၉၈",
    "Permit Date": "1998-02-09T06:45:20Z",
    "Meeting Number": "၁/၉၈",
    "Meeting Date": "1998-01-09T06:48:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ ပလတ်စတစ်ပိုက်များ ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 40.6,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်အေးအေးသန်း (ခ) သော်တာဇင်(ခ) လင်ပေါခင်",
    "Land Area (units not specified in file)": 2.011,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 49,
    "Number Of Foreign Employees": 4,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၂၁၆/၂၂၂ (၈-လွှာ)၊ မဟာဗန္ဓုလလမ်း၊ ပုစွန် တောင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၂၃၊ စက်မှုဇုန်အပိုင်း (၃)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်း",
  },
  {
    ID: 1998,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ရင်လီရင့်(ခ)မမိုးဝါ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ပန်ဒါအထည်လုပ်ငန်းကုမ္ပဏီလီမိတက်(Penda Textile Co., Ltd.)",
    "Financial Year From": 98,
    "Financial Year To": 99,
    "Permit Number": "မနသ/၁၅၀",
    "Permit Date": "1998-07-15T07:45:09Z",
    "Meeting Number": "၉/၉၈",
    "Meeting Date": "1998-05-28T07:46:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အထည်ရက်လုပ်ခြင်းနှင့်ဆေးဆိုးပန်းရိုက်ခြင်း(Panda Textile Co., Ltd.)",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1730,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address": "အမှတ်-၇၅၊မနော်ဟရီလမ်း၊ဒဂုံမြို့နယ်၊ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၈၊၁၃၊မြေတိုင်းရပ်ကွက်အမှတ်အပိုင်း-၃၊စက်မှုဇုန်၊လှိုင်သာယာမြို့နယ်၊ရန်ကုန်မြို့",
  },
  {
    ID: 1999,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်မြမြ(ခ)စောမြမြ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ကျုံးလိအင်ဒတ်(စ်)ထရီ(စ်)ကုမ္ပဏီလီမိတက်(Jong Lih Industries Co., Ltd.)",
    "Financial Year From": 98,
    "Financial Year To": 99,
    "Permit Number": "မနသ/၁၅၇/၉၈",
    "Permit Date": "1998-07-17T03:09:58Z",
    "Meeting Number": "၉/၉၈",
    "Meeting Date": "1998-05-28T03:10:46Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အသင့်ချုပ်ပြီးခရီးဆောင်အိတ်အမျိုးမျိုးထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 92.62,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်မြမြ(ခ)စောမြမြ",
    "Land Area (units not specified in file)": 3.056,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 590,
    "Number Of Foreign Employees": 590,
    Status: "Approved",
    "Investor Address":
      "အမှတ်၃၀၁၊ဗိုလ်ဆွန်ပတ်လမ်း၊ပန်းဘဲတမ်းမြို့နယ်၊ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၆၈၊မြေတိုင်းရပ်ကွက်အမှတ်-၄၊လှိုင်သာယာစက်မှုဇုန်၊ရန်ကုန်တိုင်း",
  },
  {
    ID: 2000,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်မိုးမိုးအေး",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Winner World Garment Manufacturing Co.,Ltd.",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "235/1999",
    "Permit Date": "1999-03-23T03:54:11Z",
    "Meeting Number": "4/1999",
    "Meeting Date": "1999-02-11T03:55:38Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနှစ်ဖြင့် အသင့်ချုပ်ပြီး အထည်များ ထုတ်လုပ်သည့် လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.302,
    "Total Amount Of Capital (in Millions)": 33.81,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးစိုးတင့်",
    "Land Area (units not specified in file)": 0.66,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 301,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၁၁၀၈)၊ သုမင်္ဂလာလမ်း၊ ၁၆/၄ ရပ်ကွက်၊သင်္ဃန်းကျွန်းမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေတိုင်းရပ်ကွက်(၂၃)၊ မြေအမှတ်(၅၊၆ နှင့် ၈) ၊ဒဂုံမြို့သစ်တောင်ပိုင်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး။",
  },
  {
    ID: 2002,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဉာဏ်ဝေ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ပထမထိပ်တန်းကုန်ထုတ်သမဝါယမအသင်းကုမ္ပဏီလီမိတက်(Pahtama Hteik Tan Production Co-operative Ltd.)",
    "Financial Year From": 98,
    "Financial Year To": 99,
    "Permit Number": "မနသ/၁၇၃/၉၈",
    "Permit Date": "1998-09-14T05:19:24Z",
    "Meeting Number": "၁၄/၉၈",
    "Meeting Date": "1998-08-14T05:20:14Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "ဆပ်ပြာထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 34.79,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "First Top Co., Ltd.",
    "Land Area (units not specified in file)": 1.058,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 83,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်-၆၂၊မင်ဂလာလမ်း၊စမ်းချောင်းမြို့နယ်၊ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်-၅၈၊မြတောင်ဝန်ကြီးဦးမှိုလမ်း၊လှိုင်သာယာမြို့နယ်၊လှိုင်သာယာစက်မှုဇုန်အပိုင်း-၁၊ရန်ကုန်မြို့",
  },
  {
    ID: 2003,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U HAN THEIN LWIN",
    "Name of Principal Organization":
      "HIGH TECH CONCRETE (TECHNOLOGY) CO., LTD.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "HIGH TECH PRECAST COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1070/2016",
    "Permit Date": "2016-01-29T05:36:39Z",
    "Meeting Number": "1/2016",
    "Meeting Date": "2016-01-15T05:36:59Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of High Technology Prefabricate Building Materials (Precast)",
    "Amount Of Foreign Capital USD (in Millions)": 3.302,
    "Total Amount Of Capital (in Millions)": 7.337,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Shwe Taung Development Co., Ltd.",
    "Land Area (units not specified in file)": 4,
    "Lease Term": 50,
    "Annual Lease Fee": 0.019,
    "Land Use Premium": null,
    "Number Of Local Employees": 56,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.81, PADAUK STREET, AYE YEIK MON HOUSING, HLAING TOWNSHIP, YANGON ",
    "Organization Address":
      "NO.584, CORNER OF 7th STREET & STRAND ROAD, LANMADAW TOWNSHIP, YANGON ",
    "Investment Permitted Address":
      "Corner of 7th Street & Strand Road\nNo. 584\nLanmadaw Township, Yangon, Myanmar",
  },
  {
    ID: 2004,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးလှဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "လူကြိုက်များသောအပြည်ပြည်ဆိုင်ရာအထည်ထုတ်လုပ်မှုကုမ္ပဏီလီမိတက်(Popular International Garment Manufacturing Co., Ltd.)",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "မနသ/၃၉၅/၂၀၀၀",
    "Permit Date": "2000-05-27T05:56:18Z",
    "Meeting Number": "၁၀/၂၀၀၀",
    "Meeting Date": "2000-03-23T05:56:58Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့်အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 15.6,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအာဇမ်(ခ)အောင်မြင့်",
    "Land Area (units not specified in file)": 1.549,
    "Lease Term": 10,
    "Annual Lease Fee": 3.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 919,
    "Number Of Foreign Employees": 15,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၃၁/၃၃၊၄ထပ်၊ရွှေတီဂုံဘုရားလမ်း၊လသာမြို့နယ်၊ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်း၊လှိုင်သာယာမြို့နယ်၊စက်မှုဇုန်အပိုင်း၃၊ဗန်မော်အတွင်းဝန်လမ်း၊မြေကွက်အမှတ်-၂၉",
  },
  {
    ID: 2005,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်နန်းလီ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Beroi International Co.,Ltd.",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "247/1999",
    "Permit Date": "1999-05-11T04:45:06Z",
    "Meeting Number": "6/1999",
    "Meeting Date": "1999-03-26T06:30:51Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "လူသုံးကုန်ပစ္စည်းများထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 16,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးကောင်းပေါ်(ခေါ်)ဦးအောင်ထွန်းဝင်း",
    "Land Area (units not specified in file)": 0.909,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်(၂၈)၊ မိုင်းဖုန်း ခ ရပ်ကွက်၊ဝှေလေလံရွာ၊ တာချီလိတ်မြို့။",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၂၀၈)၊ မြို့ဝန်ဦးအောင်သူလမ်း၊ စက်မှုဇုန်(၂)၊ လှိုင်သာယာမြို့နယ်၊",
  },
  {
    ID: 2006,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်မြင့်မြင့်မော်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "မြန်မာကျုံးဝေးအင်ဒတ်(စ်)ထရီရယ်ကုမ္ပဏီလီမိတက်(Myanmar Jong Way Industrial Co., Ltd.)",
    "Financial Year From": 98,
    "Financial Year To": 99,
    "Permit Number": "မနသ/၁၄၆/၉၈",
    "Permit Date": "1998-07-03T06:33:30Z",
    "Meeting Number": "၉/၉၈",
    "Meeting Date": "1998-05-28T06:34:16Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အသင့်ချုပ်ပြီးအိတ်အမျိုးမျိုးထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 38.55,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးမြင့်သိန်း၊ဒေါ်မြင့်မြင့်သန်း",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "အမှတ်-၄၊မန္တလေးလမ်း၊မြို့မရပ်၊ညောင်လေးပင်မြို့နယ်၊ပဲခူးတိုင်း",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်-၁၄၅၊မြတောင်ဝန်ကြီးဦးမှိုလမ်း၊လှိုင်သာယာစက်မှုဇုန်အပိုင်း-၂၊လှိုင်သာယာမြို့နယ်၊ရန်ကုန်မြို့",
  },
  {
    ID: 2007,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ရင်လီရင့်(ခ)မိုးဝါ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ပန်ဒါအထည်လုပ်ငန်းကုမ္ပဏီလီမိတက်(Panda Textile Co., Ltd.)",
    "Financial Year From": 98,
    "Financial Year To": 99,
    "Permit Number": "မနသ/၁၅၀/၉၈",
    "Permit Date": "1998-07-15T06:44:04Z",
    "Meeting Number": "၉/၉၈",
    "Meeting Date": "1998-05-28T06:44:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အထည်ရက်လုပ်ခြင်းနှင့်ဆေးဆိုးပန်းရိုက်ခြင်း(Weaving Dyeing and Printing)",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 94,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်ရင်လီရင့်(ခ)မိုးဝါ",
    "Land Area (units not specified in file)": 3.776,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "အမှတ်၇၅၊မနော်ဟရီလမ်း၊ဒဂုံမြို့နယ်၊ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၈၊၁၃၊မြေတိုင်းရပ်ကွက်အမှတ်အပိုင်း ၃၊စက်မှုဇုန်၊လှိုင်သာယာမြို့နယ်၊ရန်ကုန်တိုင်း",
  },
  {
    ID: 2008,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "WU SAUNG PIN @ U KHING MAUNG WIN",
    "Name of Principal Organization":
      "HEIN   MIN  THU  TRADING COMPANY    LIMITED",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "LEADER    STEEL   (MYANMAR)  COMPANY    LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1113/2016",
    "Permit Date": "2016-03-26T06:55:26Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T06:55:46Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Size of Mild Steel Hollow Pipe for Furniture use",
    "Amount Of Foreign Capital USD (in Millions)": 1.71,
    "Total Amount Of Capital (in Millions)": 3.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Malaysia",
    "Form Of Investment": "JV",
    "Land Owner": "Wu Saung Pin @ U Khin Maung Win and Daw Myint Myint Khaing",
    "Land Area (units not specified in file)": 1.5,
    "Lease Term": 30,
    "Annual Lease Fee": 0.046,
    "Land Use Premium": null,
    "Number Of Local Employees": 300,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.6B, SAGAING   STREET, WARD 14,    HLAING   TOWNSHIP, YANGON",
    "Organization Address":
      "NO.9,   THUYEIN    AVENUE, YWAMA   CORNER, BAYINTNAUNG   ROAD, HLAING   TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "5th Street, Strand Road\nNo.69\nNgwe Pin Lel Industrial Zone, Hlaing Thar Yar Township, Yangon, Myanmar",
  },
  {
    ID: 2010,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.CHAN KAM CHEONG ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "ONGOING  BLISS (MYANMAR) LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1029/2015",
    "Permit Date": "2015-11-11T07:14:30Z",
    "Meeting Number": "18/2015",
    "Meeting Date": "2015-10-23T07:21:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.792,
    "Total Amount Of Capital (in Millions)": 0.792,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Khin Htwe ",
    "Land Area (units not specified in file)": 1.211,
    "Lease Term": 10,
    "Annual Lease Fee": 0.028,
    "Land Use Premium": null,
    "Number Of Local Employees": 389,
    "Number Of Foreign Employees": 10,
    Status: "Approved",
    "Investor Address":
      "FLAT 1, SECOND FLOOR, APARTMENTE, SUNDERLAND \t\tESTATE, 1 HEREFORD ROAD, KOWLOON TONG, KOWLOON,         \t\tHONG  KONG ",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT  NO.116, MYAY TAING  BLOCK  NO.4 ,HLAING  THAR  YAR  INDUSTRIAL  ZONE, HLAING THAR YAR TOWNSHIP, YANGON  REGION.",
  },
  {
    ID: 2011,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမျိုးဝင်း",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Silk Garment Industrial Co.,Ltd.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "456/2000",
    "Permit Date": "2000-12-29T07:51:01Z",
    "Meeting Number": "36/2000",
    "Meeting Date": "2000-11-02T07:51:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 20,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်မို့မို့ကျော်",
    "Land Area (units not specified in file)": 1.306,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၁၄၉)၊ ၃၇ လမ်း၊ ကျောက်တံတားမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၄၇၃က/၂/၁)၊ မြေတိုင်းရပ်ကွက်အမှတ်(၂၃)၊ စက်မှုဇုန်၊ဒဂုံမြို့နယ်၊ရန်ကုန်မြို့။",
  },
  {
    ID: 2012,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ရင်လီရင့်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Cotton World Garment Co.,Ltd.",
    "Financial Year From": 2001,
    "Financial Year To": 2002,
    "Permit Number": "474/2001",
    "Permit Date": "2001-01-29T09:03:12Z",
    "Meeting Number": "40/2000",
    "Meeting Date": "2000-12-07T09:04:11Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနှစ်ဖြင့်အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 49.34,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးရင်ရီဘော်",
    "Land Area (units not specified in file)": 1.885,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 752,
    "Number Of Foreign Employees": 5,
    Status: "Approved",
    "Investor Address": "အမှတ်(၇၅)၊ မနော်ဟရီလမ်း၊ ဒဂုံမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၄)၊ မြေတိုင်းရပ်ကွက်အမှတ်အပိုင်း(၃)၊စက်မှုဇုန်၊လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2013,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးစိန်ဝမ်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Royal Green Manufacturing Ltd.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "မနသ-၄၂၆/၂၀၀၀",
    "Permit Date": "2000-09-06T09:04:12Z",
    "Meeting Number": "၂၃/၂၀၀၀",
    "Meeting Date": "2000-07-14T09:04:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "မီးချောင်းနှင့် မီးချောင်းအပိုပစ္စည်းများ ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 229.47,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 2.554,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 107,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၁၀၀၊ အင်းယားလမ်း၊  ကမာရွတ်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်း၊ ရွှေပြည်သာမြို့နယ်၊ စက်မှုဇုန်(၃)၊ မြေတိုင်းရပ်ကွက်အမှတ်-၆၄၊ မြေကွက်အမှတ်-၆၈ နှင့် ၆၉",
  },
  {
    ID: 2014,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဝင်းတင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ချယ်ရီသင်းထုတ်လုပ်မှုကုမ္ပဏီလီမိတက် (Cherry Thin Manufacturing Co., Ltd.)",
    "Financial Year From": 98,
    "Financial Year To": 99,
    "Permit Number": "မနသ/၁၅၆/၉၈",
    "Permit Date": "1998-07-15T03:18:58Z",
    "Meeting Number": "၁၀/၉၈",
    "Meeting Date": "1998-06-12T03:19:52Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "အသင့်ချုပ်ပြီးအထည်များချုပ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 21.71,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 1.093,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၁၈၄၊ဓမ္မသုခကျောင်းလမ်း၊၇ ရပ်ကွက်၊လှိုင်မြို့နယ်၊ရန်ကုန်တိုင်း",
    "Organization Address": "",
    "Investment Permitted Address":
      "အကွက်အမှတ်-၁၆၃၊မြင်းဝန်ဦးအောင်သူလမ်း၊လှိုင်သာယာစက်မှုဇုန်-၂၊ရန်ကုန်တိုင်း",
  },
  {
    ID: 2015,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမြသောင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ပိုလာ(ရန်ကုန်)အင်အာပရိုက်(စ်)ကုမ္ပဏီလီမိတက်(Polar (Yangon) Enterprise Co., Ltd.)",
    "Financial Year From": 98,
    "Financial Year To": 99,
    "Permit Number": "မနသ-၁၆၃/၉၈",
    "Permit Date": "1998-08-07T03:35:16Z",
    "Meeting Number": "၁၁/၉၈",
    "Meeting Date": "1998-06-26T03:36:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီအထည်အမျိုးမျိုးချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 41.58,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးမြသောင်း နှင့် ဦးဝင်းမောင်",
    "Land Area (units not specified in file)": 1.198,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Amend",
    "Investor Address":
      "အမှတ်-၃၉၊သုမနလမ်း၊ရပ်ကွက်-၃၊သာကေတမြို့နယ်၊ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၄၆၊လှိုင်သာယာမြို့နယ်၊စက်မှုဇုန်-၂၊ရန်ကုန်တိုင်း",
  },
  {
    ID: 2016,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဌေးနိုင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "လူသုံးကုန်ပစ္စည်း ထုတ်လုပ်ရေးကုမ္ပဏီလီမိတက် (Consumer Goods Manufacturing Co., Ltd.)",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "မနသ-၄၂၁/၂၀၀၀",
    "Permit Date": "2000-08-31T04:31:37Z",
    "Meeting Number": "၂၀/၂၀၀၀",
    "Meeting Date": "2000-06-23T04:32:52Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီဓါတ်ခဲအမျိုးမျိုး ထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 69.4,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်ခင်ရီနှင့် ဦးနိုင်ဖြိုးကျော်",
    "Land Area (units not specified in file)": 1.423,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 75,
    "Number Of Foreign Employees": 15,
    Status: "Approved",
    "Investor Address": "၁၅၆/၁၆၀၊ ၃၆-လမ်း၊ ကျောက်တံတားမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၆၅)၊ မြေတိုင်းရပ်ကွက်(၄၂)၊ စက်မှုဇုန်၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်း",
  },
  {
    ID: 2017,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်နန်းအေးလူ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "မြန်မာသတ္တုကုမ္ပဏီလီမိတက် (Myanmar Metal Co., Ltd.)",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "မနသ-၄၁၅/၂၀၀၀",
    "Permit Date": "2000-08-10T04:55:08Z",
    "Meeting Number": "၁၈/၂၀၀၀",
    "Meeting Date": "2000-06-02T04:55:38Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အလူမီနီယံဖြင့် ပြုလုပ်သည့် အိမ်သုံးပစ္စည်းများထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 178.49,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "မြို့ပြနှင့်အိမ်ရာဖွံ့ဖြိုးရေးဦးစီးဌာန",
    "Land Area (units not specified in file)": 0.825,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 78,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "၁၂၉/၁၃၀၊ မြစ်ကြီးနားလမ်း၊ ၂၃-ရပ်ကွက်၊ စက်မှုဇုန်(၁)၊ ဒဂုံမြို့သစ်တောင်ပိုင်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်း၊ ဒဂုံမြို့သစ်တောင်ပိုင်းမြို့နယ်၊ စက်မှုဇုန်(၁)၊ မြေတိုင်းရပ်ကွက် အမှတ်-၂၃၊ မြေကွက်အမှတ်(၂၂၊ ၂၃၊ ၃၅၊ ၃၆၊၃၇)",
  },
  {
    ID: 2018,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအိုက်ရှန်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Pok Yan Industry Co.,Ltd.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "457/2000",
    "Permit Date": "2000-12-29T05:01:52Z",
    "Meeting Number": "36/2000",
    "Meeting Date": "2000-11-02T05:03:11Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနှစ်ဖြင့်အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 25,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအိုက်ရှန်",
    "Land Area (units not specified in file)": 3.619,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်(၅၆၀)၊ ၈၀ လမ်း၊ ၃၃ -၃၄ လမ်းကြား၊ချမ်းအေးသာဇံမြို့နယ်၊ မန္တလေးတိုင်းဒေသကြီး။",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၈/၁၉)၊ စက်မှုဇုန်(၂)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး။",
  },
  {
    ID: 2019,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်နိုင်ဦး",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Lucky Crown Industrial Co.,Ltd.",
    "Financial Year From": 2001,
    "Financial Year To": 2002,
    "Permit Number": "477/2001",
    "Permit Date": "2001-03-08T07:00:21Z",
    "Meeting Number": "41/2000",
    "Meeting Date": "2000-12-15T07:01:26Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အသင့်ချုပ်ပြီးအထည်များ ထုတ်လုပ်သည့်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.22,
    "Total Amount Of Capital (in Millions)": 46.37,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်မြင့်မြင့်သန်း",
    "Land Area (units not specified in file)": 0.499,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 350,
    "Number Of Foreign Employees": 4,
    Status: "Approved",
    "Investor Address":
      "အမှတ်-စ/၃၁၊ ငုဝါလမ်း၊ ဘုရင့်နောင်ပွဲရုံ၊မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၆၈(ခ)၊ ဒီပဲရင်းဝန်ထောက်ဦးမြဲလမ်းနှင့် ပြည်စည်မင်းသားကြီးလမ်းထောင့်၊ စက်မှုဇုံ(၄)၊လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2020,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးထွန်းလှိုင်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Morning Sun Garment Co.,Ltd.",
    "Financial Year From": 2001,
    "Financial Year To": 2002,
    "Permit Number": "501/2001",
    "Permit Date": "2001-06-27T09:17:23Z",
    "Meeting Number": "12/2001",
    "Meeting Date": "2001-04-26T09:18:36Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့်အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.54,
    "Total Amount Of Capital (in Millions)": 42.34,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်လေးပို",
    "Land Area (units not specified in file)": 0.737,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 590,
    "Number Of Foreign Employees": 5,
    Status: "Approved",
    "Investor Address":
      "အမှတ်-၂၉(က)၊ ၆၀ လမ်း၊ ၇ ရပ်ကွက်၊ လှိုင်မြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၀၉)၊ မက္ခရာမင်းသားကြီး၊ မောင်ပျိုးလမ်း၊ စက်မှုဇုန်(၂)၊ လှိုင်သာယာမြို့နယ်၊ရန်ကုန်မြို့။",
  },
  {
    ID: 2021,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးရဲစိန်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Shwe Mingalar Co.,Ltd.",
    "Financial Year From": 2001,
    "Financial Year To": 2002,
    "Permit Number": "505/2001",
    "Permit Date": "2001-06-27T05:00:02Z",
    "Meeting Number": "12/2001",
    "Meeting Date": "2001-04-26T05:02:32Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီ အဝက်အထည်အမျိုးမျိုးချုပ်လုပ်သည့်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.248,
    "Total Amount Of Capital (in Millions)": 46.49,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးရဲစိန်",
    "Land Area (units not specified in file)": 2.264,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "မြေကွက်အမှတ်(၂၅)၊ ရန်ကုန်စက်မှုဇုန်မြောက်ဥက္ကလာမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၂၅၊၂၆)၊ စက်မှုဇုန်(၄)လမ်း၊  ရန်ကုန်စက်မှုဇုန်၊ မင်္ဂလာဒုံမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး။",
  },
  {
    ID: 2022,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်သော်တာဇင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "အီဗွာဆောက်လုပ်ရေးကုမ္ပဏီလီမိတက် (Eva Construction Co., Ltd.)",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "မနသ-၁၁၆/၉၈",
    "Permit Date": "1998-02-09T05:56:11Z",
    "Meeting Number": "၁/၉၈",
    "Meeting Date": "1998-01-09T05:56:50Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီသင်္ဘောဆေး (Paint) ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 30.7,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်သန်းသန်းအေး (ခ) သော်တာဇင် (ခ) လင်ပေါခင်",
    "Land Area (units not specified in file)": 2.011,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၂၁၆/၂၂၂ (၈ လွှာ)၊ မဟာဗန္ဓူလလမ်း၊ ပုစွန် တောင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၂၃။ စက်မှုဇုန်အပိုင်း (၃)၊ လှိုင်သာ ယာမြို့နယ်၊ ရန်ကုန်တိုင်း",
  },
  {
    ID: 2023,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်မြအေး (ခ) လင်ကာစွမ်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "စိန်နှင်းဆီကုမ္ပဏီလီမိတက် (Diamond Rose Co., Ltd.)",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "မနသ-၁၄၅/၉၈",
    "Permit Date": "1998-07-03T06:14:54Z",
    "Meeting Number": "၉/၉၈",
    "Meeting Date": "1998-05-28T06:15:33Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 3.2,
    "Total Amount Of Capital (in Millions)": 35.2,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအောင်ဆွေ",
    "Land Area (units not specified in file)": 0.278,
    "Lease Term": 30,
    "Annual Lease Fee": 1.2,
    "Land Use Premium": null,
    "Number Of Local Employees": 272,
    "Number Of Foreign Employees": 5,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၁၁၉ (အေ)၊ သံလွင်လမ်း၊ ကမာရွတ်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၄၁၊ မြေတိုင်းရပ်ကွက်အမှတ် (င)၊ စက်မှုဒေသ၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန် တိုင်း",
  },
  {
    ID: 2024,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဖေဝင်း (ခ) ဟုန်ဖေဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "စထရောင်းမင်နျူဖက်ချားရင်းကုမ္ပဏီလီမိတက် (Strong Manufacturing Co., Ltd.)",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "မနသ-၁၂၃/၉၈",
    "Permit Date": "1998-02-27T04:49:24Z",
    "Meeting Number": "၂/၉၈",
    "Meeting Date": "1998-01-23T04:49:56Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "အိမ်မိုးသွပ်ပြားထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 40.8,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးဖေဝင်းနှင့် ဦးထွန်းသိန်း",
    "Land Area (units not specified in file)": 1.129,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၅၃၊ ၈၁ လမ်း၊ ၁၂ လမ်းနှင့် ၁၃ လမ်းကြား၊ အောင်မြေသာဇံမြို့နယ်၊ မန္တလေးမြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၈၄)၊ မြေတိုင်းရပ်ကွက်အမှတ် အပိုင်း (၄)၊ စက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန် တိုင်း",
  },
  {
    ID: 2026,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်နီနီချို",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "သိန်းငှက်စွမ်းအားကုမ္ပဏီလီမိတက် (Eagle Power Co., Ltd.)",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "မနသ-၁၃၉/၉၈",
    "Permit Date": "1998-06-05T05:38:50Z",
    "Meeting Number": "၈/၉၈",
    "Meeting Date": "1998-05-15T05:40:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီ အနွေးထည် (Jacket) ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 15.72,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအောင်ကျော်သန်း",
    "Land Area (units not specified in file)": 0.245,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၂၇၄၊ ကျုံးကြီးလမ်း၊ လမ်းမတော်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၂၅၈၊ မြေတိုင်းရပ်ကွက်အမှတ် ၄၂၊ စက်မှုဇုန်၊ ကနောင်မင်းသားကြီးလမ်း၊ ရွှေပြည်သာ မြို့နယ်၊ ရန်ကုန်တိုင်း",
  },
  {
    ID: 2027,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးသိမ်းဝေ(ခ)",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Marigold Garment Co.,Ltd.",
    "Financial Year From": 2001,
    "Financial Year To": 2002,
    "Permit Number": "548/2002",
    "Permit Date": "2002-06-27T05:31:24Z",
    "Meeting Number": "15/2002",
    "Meeting Date": "2002-05-10T05:33:25Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMPစနစ်ဖြင့်နိုင်ငံတကာအဆင့်မီအထည်အမျိုးမျိုး ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.64,
    "Total Amount Of Capital (in Millions)": 61.6,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးစစ်ရှိန်",
    "Land Area (units not specified in file)": 0.53,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 480,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်(၁)၊ ကွမ်းခြံလမ်း၊ မင်္ဂလာတောင်ညွှန့်မြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "-",
    "Investment Permitted Address":
      "အမှတ်(၃၄)၊ မင်းကြီးမဟာမင်းခေါင်လမ်း၊ စက်မှုဇုန်(၄)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2028,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U ZAW MYNN   ",
    "Name of Principal Organization":
      "ELITE      TELECOM     PUBLIC COMPANY LIMITED",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "STREAM   NET   COMPANY  LIMITED ",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "112/2018",
    "Permit Date": "2018-09-15T09:09:10Z",
    "Meeting Number": "15/2018",
    "Meeting Date": "2018-09-15T09:09:41Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "DWDM backbone, metro transmission, domestic bandwidth wholesales, mobile backhaul network, ISP service, wireless broadband, FTTx, VOIP, domain registration, web design, hosting duct, trenches, poles and dark fibre and satellite broadband internet service",
    "Amount Of Foreign Capital USD (in Millions)": 29.55,
    "Total Amount Of Capital (in Millions)": 44.11,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 13,
    "Investing Country": "Vietnam",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "NO.8, BAWDI YEIK THAR STREET, SHWE TAUNG GYAR WARD (2), BAHAN TOWNSHIP, YANGON ",
    "Organization Address":
      "NO.A/9, MINDAMA STREET, MAYANGONE   TOWNSHIP,  YANGON    ",
    "Investment Permitted Address":
      "NO. A/9, 1ST FLOOR, SHWEGABAR HOUSING COMPLEX,  MINDAMA STREET, MAYANGONE TOWNSHIP, YANGON   REGION ",
  },
  {
    ID: 2029,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကျော်မိုးဝင်း",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "K & N Trading Co.,Ltd.",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "623/2003",
    "Permit Date": "2003-05-06T07:01:04Z",
    "Meeting Number": "8/2003",
    "Meeting Date": "2003-03-07T07:02:57Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP  စနစ်ဖြင့် ကင်ဒိုအားကစားဝတ်စုံချုပ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 10.4,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်နွဲ့နွဲ့ကြည်",
    "Land Area (units not specified in file)": 0.055,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 106,
    "Number Of Foreign Employees": 1,
    Status: "Approved",
    "Investor Address":
      "အခန်း(၆)၊ တိုက်(၃)၊ဖဆပလ ရပ်ကွက်၊ မင်္ဂလာတောင်ညွှန့်မြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "-",
    "Investment Permitted Address":
      "အမှတ်(၂၆)၊ ပုဂံလမ်း၊ (၂၁)ရပ်ကွက်၊ ရွှေပေါက်ကံမြို့သစ်၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2030,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်လွင်ဦး",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Radiant Manufacturing Co.,Ltd.",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "624/2003",
    "Permit Date": "2003-05-06T04:43:10Z",
    "Meeting Number": "9/2003",
    "Meeting Date": "2003-03-14T04:45:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့်အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 34.88,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်အင်န်အာမာလ်",
    "Land Area (units not specified in file)": 0.65,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "အမှတ်(၂၀)၊ သမာဒိဓ္ဓိလမ်း၊တာမွေမြို့နယ်၊ရန်ကုန်မြို့။",
    "Organization Address": "-",
    "Investment Permitted Address":
      "အမှတ်(၄၆၈)၊ မေဃဝတီကျောင်းလမ်း၊ ဆ/ခ ရပ်ကွက်၊ သင်္ဃန်းကျွန်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး။",
  },
  {
    ID: 2031,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးစိုးလှိုင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ရွှေရွက်လှ ထုတ်လုပ်မှု ကုမ္ပဏီလီမိတက် (Shwe Ywet Hla Manufacturing Co., Ltd.)",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "မနသ-၆၁၅/၂၀၀၃",
    "Permit Date": "2003-05-06T04:49:59Z",
    "Meeting Number": "၄/၂၀၀၃",
    "Meeting Date": "2003-02-06T04:50:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP  စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီ အဝတ်အထည်အမျိုးမျိုးချုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 10.75,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "စစ်မှုထမ်းဟောင်းအဖွဲပိုင်မြေ",
    "Land Area (units not specified in file)": 0.632,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 365,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၁၆၅)၊ ပြည်ထောင်စုရပ်ကွက်၊ ပဲခူးမြို့၊ ပဲခူးတိုင်း",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၂/က၂)၊ မြေတိုင်းရပ်ကွက်အမှတ်-၁၇၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်တိုင်း",
  },
  {
    ID: 2032,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ခင်မူယာအောင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "အထည်လက်ရာ ကုမ္ပဏီလီမိတက် (Textile Handiworks Co., Ltd.)",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "မနသ-၆၁၄/၂၀၀၃",
    "Permit Date": "2003-05-08T05:38:11Z",
    "Meeting Number": "၅/၂၀၀၃",
    "Meeting Date": "2002-12-27T05:39:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 52.21,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအောင်ဇော်ဦး နှင့် ဦးအောင်ဇော်လတ်",
    "Land Area (units not specified in file)": 1.423,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 450,
    "Number Of Foreign Employees": 3,
    Status: "Approved",
    "Investor Address":
      "အမှတ်(၁၂၇)၊ ဝက်မစွပ်ဝန်တောက်လမ်း၊ လှိုင်သာယာစက်မှုဇုန် (၄)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၉)၊ ဖန်ချက်ဝန်ဦးရွှေအိုးလမ်း၊ လှိုင်သာယာစက်မှုဇုန် အပိုင်း (၂)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်း",
  },
  {
    ID: 2033,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်သီသီဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "မြန်မာ ဧရာဝတီထုတ်လုပ်မှုကုမ္ပဏီလီမိတက် (Myanmar Ayeyarwaddy Manufacturing Co., Ltd.)",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "မနသ-၆၁၁/၂၀၀၃",
    "Permit Date": "2003-04-26T06:24:08Z",
    "Meeting Number": "၄/၂၀၀၃",
    "Meeting Date": "2003-02-06T06:24:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 19.64,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးတင်ကြိုင်၊ ဒေါ်ညွန့်ကြည်",
    "Land Area (units not specified in file)": 0.31,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 330,
    "Number Of Foreign Employees": 2,
    Status: "Approved",
    "Investor Address":
      "အမှတ်-၅၊ မိုးမခလမ်း၊ ၄၆ ရပ်ကွက်၊ ဒဂုံမြို့သစ် (မြောက်ပိုင်း)မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်(၁၄၉/၁၅၀)၊ ဦးတရုတ်ကြီးလမ်း၊ စက်မှုဇုန်(၄)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်း",
  },
  {
    ID: 2034,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဇော်လင်းလတ်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "နီလာဝင်းကုမ္ပဏီလီမိတက် (Nilar Win Co., Ltd.)",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "မနသ-၆၀၅/၂၀၀၃",
    "Permit Date": "2003-03-28T06:55:02Z",
    "Meeting Number": "၄/၂၀၀၃",
    "Meeting Date": "2003-02-06T06:55:29Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 40.66,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်ခင်ဝင်း",
    "Land Area (units not specified in file)": 0.471,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 150,
    "Number Of Foreign Employees": 1,
    Status: "Approved",
    "Investor Address":
      "အခန်း(ဒီ)၊ တိုက်အမှတ်-၅၊ ပြည်ထောင်စုရိပ်သာလမ်း၊ ဒဂုံမြို့သစ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ် ၂၂၇/၂၂၈၊ ဗိုလ်တေဇလမ်း၊ ရွှေပေါက်ကံစက်မှုဇုန်၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်တိုင်း",
  },
  {
    ID: 2035,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်မိုး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ဂိုးလ်ဒင်းဘလူး(မ်) အင်ဒတ်စထရီကုမ္ပဏီလီမိတက် (Golden Bloom Industry Co., Ltd.)",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "မနသ-၁၉၉/၉၈",
    "Permit Date": "1998-11-09T07:22:17Z",
    "Meeting Number": "၁၈/၉၈",
    "Meeting Date": "1998-10-09T07:22:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ဆပ်ပြ၊ ခေါင်းလျှော်ရည်၊ သွားတိုက်ဆေးနှင့် ယင်းတို့နှင့် ဆက်စပ်နေသည့် ပစ္စည်းများထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 11.42,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးသန်းထွန်း၊ ဦးသန်းလွင်နှင့် ဒေါ်အေးရင်",
    "Land Area (units not specified in file)": 0.33,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 75,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "တိုက်(၆)၊ အခန်း-၃၀၁၊ ခ ပေါင်းရိပ်သာ၊ လှိုင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၇၃ နှင့် ၇၅၊ မြေတိုင်းရပ်ကွက်အမှတ်-၂၃၊ ဒဂုံတောင်စက်မှုဇုန်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 2036,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးခွမ်အိုက်စိုင်း",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "ရန်ကုန်သိုးမွှေးထည် စက်မှုလက်မှု ကုမ္ပဏီ လီမိတက်(Yangon Knitters Industry Co.,Ltd)",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "မနသ-၆၂၅",
    "Permit Date": "2003-05-06T03:44:15Z",
    "Meeting Number": "8/2003",
    "Meeting Date": "2003-03-07T03:44:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့်စက်ထိုးထည်ထုတ်လုပ်သည့်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 42.71,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်ဇူးမိန်",
    "Land Area (units not specified in file)": 2,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 400,
    "Number Of Foreign Employees": 3,
    Status: "Approved",
    "Investor Address":
      "အမှတ်(၆၀)၊စဉ့်ရွှေကုန်လမ်း၊အလုံမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၇၄)၊ မင်္ဂလာဒုံဥယျာဉ်မြို့တော်၊ရန်ကုန်စက်မှုဇုန်၊ မြောက်ဥက္ကလာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2037,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. YONGQING ZHANG",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "GREAT  WALL  BUILDING  MATERIALS  COMPANY  LIMITED",
    "Financial Year From": 15,
    "Financial Year To": 16,
    "Permit Number": "974/2015",
    "Permit Date": "2015-06-28T04:01:11Z",
    "Meeting Number": "11/2015",
    "Meeting Date": "2015-06-19T04:01:32Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF  CONCRETE BRICKS, LIGHT WEIGHT COMPOSITE BRICKS AND OTHER BUILDING MATERIALS",
    "Amount Of Foreign Capital USD (in Millions)": 1.2,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": 10,
    "Annual Lease Fee": 0.042,
    "Land Use Premium": null,
    "Number Of Local Employees": 150,
    "Number Of Foreign Employees": 15,
    Status: "Monitoring Approved",
    "Investor Address":
      "PU JIANG SHIQUKOU, JINHUA, ZHEJIANG PROVINCE, PEOPLE’S REPUBLIC OF CHINA",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO. 212, MYAY TAING BLOCK NO 98, INDUSTRIAL ZONE 1, DAGON MYOTHIT (SEIKKANN) TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2038,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမောင်ထွေး(ခ)တန်ကောက်ဝေ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "စူပါဖရင်း(န်)ရှစ်(ပ်)ထုတ်လုပ်မှု ကုမ္ပဏီ လီမိတက်(Super Friendship Manufacturing Co.,Ltd)",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "မနသ-၆၂၆/၂၀၀၃",
    "Permit Date": "2003-05-07T04:49:28Z",
    "Meeting Number": "၉/၂၀၀၃",
    "Meeting Date": "2003-03-14T04:49:52Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMPစနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 16.36,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "ဦးဝင်းတင်၊ ဦးဝင်းဌေး၊ဦးအေးနိုင်၊ ဦးဝင်းသိန်း၊ ဒေါ်သန်းသန်းနှင့် ဒေါ်ခင်ခင်ဝင်း",
    "Land Area (units not specified in file)": 1.093,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 123,
    "Number Of Foreign Employees": 2,
    Status: "Approved",
    "Investor Address":
      "အမှတ်(၂၂၃)၊ (ဒုတိယထပ်)၃၇ လမ်း၊ ကျောက်တံတားမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၆၃)၊ မြင်းဝန်ဦးအောင်သူလမ်း၊ စက်မှုဇုန်(၂)၊လှိုင်သာယာမြို့နယ်၊ရန်ကုန်မြို့။",
  },
  {
    ID: 2039,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Liu, Sheng",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Jian Da (Myanmar) Shoes Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "087/2018",
    "Permit Date": "2018-10-10T08:35:38Z",
    "Meeting Number": "13/2018",
    "Meeting Date": "2018-09-26T08:36:06Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and marketing of various soles for CMP basic shoes factories",
    "Amount Of Foreign Capital USD (in Millions)": 0.585,
    "Total Amount Of Capital (in Millions)": 0.585,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "ဦးမောင်မောင်လွင် (ခ) ကျိုဟွာ",
    "Land Area (units not specified in file)": 0.94,
    "Lease Term": 5,
    "Annual Lease Fee": 24,
    "Land Use Premium": null,
    "Number Of Local Employees": 98,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "No.19, Loufeng Village, Chipi City, Hupei Division, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 52-Ka, Industrial Zone(1), Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2040,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Francisco Javier Tora Mira",
    "Name of Principal Organization":
      "Elegant Supreme Ltd, No.77 Connaught Road Central 26/f, Suite 1397 Beautiful Group Tower, Hong Kong",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Myanmar Elegant Supreme Leather Goods Co., Ltd",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "088/2018",
    "Permit Date": "2018-10-10T09:08:20Z",
    "Meeting Number": "13/2018",
    "Meeting Date": "2018-09-26T09:08:42Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of handbags on CMP basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.602,
    "Total Amount Of Capital (in Millions)": 2.602,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "ဒေါ်အုန်းအုန်းမြင့်",
    "Land Area (units not specified in file)": 0.964,
    "Lease Term": 10,
    "Annual Lease Fee": 0.096,
    "Land Use Premium": null,
    "Number Of Local Employees": 824,
    "Number Of Foreign Employees": 7,
    Status: "Draft",
    "Investor Address":
      "No.10,Jinshi Avenue East, Shiling Town, Huadu District, Guangzhou City, Guang Dong Province, People's Republic Of China",
    "Organization Address":
      "No.77 Connaught Road Central 26/f, Suite 1397 Beautiful Group Tower, Hong Kong",
    "Investment Permitted Address":
      "Plot No. 149/1, Myay Taing Block No. 113, East Dagon Industrial Zone, East Dagon Township,Yangon Region",
  },
  {
    ID: 2041,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Li, Chi-Han",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Lien Fa (Myanmar) Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "089/2018",
    "Permit Date": "2018-10-10T09:39:58Z",
    "Meeting Number": "13/2018",
    "Meeting Date": "2018-09-26T09:40:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and distribution of construction materials1410",
    "Amount Of Foreign Capital USD (in Millions)": 0.405,
    "Total Amount Of Capital (in Millions)": 0.506,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 23,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "JV",
    "Land Owner": "ဦးဖေ၀င်း (ခ) ဟုန်ဖေ၀င်း",
    "Land Area (units not specified in file)": 1.794,
    "Lease Term": 5,
    "Annual Lease Fee": 0.1,
    "Land Use Premium": null,
    "Number Of Local Employees": 50,
    "Number Of Foreign Employees": 11,
    Status: "Draft",
    "Investor Address":
      "16 F-1, No.31, Qingnian 1st Rd, Lingya Dist, Kaohsiung City 802, Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.82, Myay Taing Block No.14, Shwe Than Lwin, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2042,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Kitajima Company Limited",
    "Name of Principal Organization":
      "Kitajima Sanso Co., Ltd. No-59,Dekijimacho Tokushima, Tokushima City, Japan",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Kitajima Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "090/2018",
    "Permit Date": "2018-10-10T10:12:12Z",
    "Meeting Number": "13/2018",
    "Meeting Date": "2018-09-26T10:12:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production and distribution of oxygen gas and its related services",
    "Amount Of Foreign Capital USD (in Millions)": 0.188,
    "Total Amount Of Capital (in Millions)": 0.188,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "U Kyaw Kyaw Tun",
    "Land Area (units not specified in file)": 0.172,
    "Lease Term": 5,
    "Annual Lease Fee": 1900,
    "Land Use Premium": null,
    "Number Of Local Employees": 34,
    "Number Of Foreign Employees": 2,
    Status: "Draft",
    "Investor Address":
      "No.(150-C), Myanin Hay Wun Street, Thaketa Industrial Zone, Thaketa Township, Yangon",
    "Organization Address":
      " No-59,Dekijimacho Tokushima, Tokushima City, Japan",
    "Investment Permitted Address":
      "No.(150-C), Myanin Hay Wun Street, Thaketa Industrial Zone, Thaketa Township, Yangon",
  },
  {
    ID: 2043,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Zhang, Yanjuan",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Xin Mei Ya Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "091/2018",
    "Permit Date": "2018-10-10T03:20:43Z",
    "Meeting Number": "13/2018",
    "Meeting Date": "2018-09-26T03:20:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment On CMP Basis1410",
    "Amount Of Foreign Capital USD (in Millions)": 0.479,
    "Total Amount Of Capital (in Millions)": 0.479,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myat Ko",
    "Land Area (units not specified in file)": 1.185,
    "Lease Term": 5,
    "Annual Lease Fee": 0.0266,
    "Land Use Premium": null,
    "Number Of Local Employees": 200,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "Economic Development Zone, Jimo District, Qingdao, Shandong Province, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.(28/KHA), Industrial Zone-1, Dagon Seik Kan Township, Yanngon Region",
  },
  {
    ID: 2044,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးတင်မောင်သီ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ရင်းနှီးမြှုပ်နှံမှုနှင့် ကူးသန်းရောင်း၀ယ်ရေးအင်ပါယာ ကုမ္ပဏီလီမီတက်(Investment And Commercial Empire Co., Ltd)",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "092/2018",
    "Permit Date": "2018-10-10T03:33:29Z",
    "Meeting Number": "13/2018",
    "Meeting Date": "2018-09-26T03:33:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "တန်ဖိုးမြှင့်ပဲအမျိုးမျိုး၊ နှမ်းအမျိုးမျိုး ထုတ်လုပ်၍ ပြည်ပသို့တင်ပို့ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 4536,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးတင်မောင်သီ",
    "Land Area (units not specified in file)": 2.75,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 110,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "အမှတ်(၁၆)၊ ဗောဓိရိပ်သာလမ်း၊ ရွှေတောင်ကြား(၂)ရပ်ကွက်၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၅၇-ဘီ)၊ မြေတိုင်းရပ်ကွက်အမှတ်(၅၁)၊ သာဓုကန်စက်မှုဇုန်၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2045,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Tze Wing Wah",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "LF Packaging (Myanmar) Ltd",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "093/2018",
    "Permit Date": "2018-11-08T03:57:35Z",
    "Meeting Number": "14/2018",
    "Meeting Date": "2018-10-10T03:51:57Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMPစနစ်ဖြင့်Logoတံဆိပ်ရိုက်နှိပ်ထားသောလက်၀တ်ရတနာထည့်သောဗူးနှင့် အိတ်အမျိုးမျိုးထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.5,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Khin Nyein Myint",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 10,
    "Annual Lease Fee": 0.0119,
    "Land Use Premium": null,
    "Number Of Local Employees": 128,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "Unit-A,1/F, China Fen Hin Building,5 Cheung Yue Street, Lai Chi Kok, Kowloon, Hong Kong Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.34, Myay Taing Block No. 144 Setmhu Zone, Dagon Myothit (south), Yangon Region",
  },
  {
    ID: 2046,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Tun Naing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Pacific High Technology International Company Limited(ပစိဖိတ် ဟိုင်းတက်ကနော်လော်ဂျီ အင်တာနေရှင်နယ် ကုမ္ပဏီလီမီတက်)",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "094/2018",
    "Permit Date": "2018-11-08T05:11:33Z",
    "Meeting Number": "14/2018",
    "Meeting Date": "2018-10-10T05:12:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "SKD-2စနစ်ဖြင့် မော်တော်ဆိုင်ကယ် ထုတ်လုပ်တပ်ဆင်ခြင်းနှင့် ဆက်စပ်သော၀န်ဆောင်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 792.25,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Tun Naing",
    "Land Area (units not specified in file)": 9.53,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 294,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "အမှတ် (၁၅)၊ ၃၃-လွှာ၊ ၆၈-လမ်းနှင့် ၆၉-လမ်းကြား၊ ပြည်ကြီးမြတ်ရှင်ရပ်ကွက်၊ချမ်းအေးသာဇံမြို့နယ်၊မန္တလေးတိုင်းဒေသကြီး။",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. D.6,D.7,D.13,D.14, Myay Taing Block No. 20,Anawyahtar Setmhu Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2047,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Soe Moe",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Yangon GlovesCompany Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "095/2018",
    "Permit Date": "2018-11-08T08:46:29Z",
    "Meeting Number": "14/2018",
    "Meeting Date": "2018-10-10T08:46:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMPစနစ်ဖြင့်အားကစားလက်အိတ်အမျိုးမျိုးချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 764.649,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 45,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Hla Win",
    "Land Area (units not specified in file)": 0.165,
    "Lease Term": 10,
    "Annual Lease Fee": 12,
    "Land Use Premium": null,
    "Number Of Local Employees": 101,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address":
      "အမှတ်(၁၂၈၂)၊ မြရတနာလမ်း၊ (၂၄)ရပ်ကွက်၊ ဒဂုံမြို့သစ်တောင်ပိုင်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.119, Myay Taing Block No.23,Setmhu Zone, Dagon Myothit (South),Yangon Region",
  },
  {
    ID: 2048,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Guo Zhengshui",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myantex Industrial Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "096/2018",
    "Permit Date": "2018-11-09T03:27:22Z",
    "Meeting Number": "14/2018",
    "Meeting Date": "2018-10-10T03:27:28Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.384,
    "Total Amount Of Capital (in Millions)": 1.384,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Phyu Phyu Sein",
    "Land Area (units not specified in file)": 1.409,
    "Lease Term": 10,
    "Annual Lease Fee": 0.074,
    "Land Use Premium": null,
    "Number Of Local Employees": 933,
    "Number Of Foreign Employees": 18,
    Status: "Draft",
    "Investor Address":
      "Shengtai Road 88, Molings Street Room 301, East Area 4th Jianging District, Nanjing People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.98, Myay Taing Block No. 64(setmhu), Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 2049,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်ဝင်း",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "ခရိုးကိုးဒိုင်းထရေးဒင်း ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1995,
    "Financial Year To": 1996,
    "Permit Number": "Manatha-007/1995",
    "Permit Date": "1995-09-20T03:56:48Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အသင့်ချုပ်ပြီးအထည်များ ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 30,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ် ၅၇၊ ၄၆ လမ်း၊ ဗိုလ်တထောင်မြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၂၄)နှင့် (၂၅)စက်မှုဒေသရွှေပြည်သာ။",
  },
  {
    ID: 2051,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": " ဦးဇော်မင်းဦး",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ခရိုးကိုးဒိုင်း ထရေးဒင်း ကုမ္ပဏီ လီမိတက်(Crocodile Trading Co.,Ltd)",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "မနသ-၆၂၉/၂၀၀၃",
    "Permit Date": "2003-06-03T05:20:39Z",
    "Meeting Number": "၃/၂၀၀၃",
    "Meeting Date": "2003-01-31T05:21:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီ အဝတ်အထည် အမျိုးမျိုး ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.21,
    "Total Amount Of Capital (in Millions)": 57.84,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 2.713,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 630,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "အမှတ်(၅၇)၊ ၄၆လမ်း၊ ဗိုလ်တထောင်မြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေတိုင်းရပ်ကွက်အမှတ်အပိုင်း(၁ )၊ မြို့တောင်ဝန်ကြီး ဦးမှိုလမ်း၊ မြေကွက်အမှတ်(၄၉)၊လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2052,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Daw Su Su Hlaing",
    "Name of Principal Organization": "Myanmar BAF Feed Farm Food Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Myanmar BAF Joint Venture Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "120/2018",
    "Permit Date": "2018-11-08T09:40:54Z",
    "Meeting Number": "18/2018",
    "Meeting Date": "2018-11-02T09:41:11Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "Pig Breeder Farm and Sales of Weaner and Fattener",
    "Amount Of Foreign Capital USD (in Millions)": 8.384,
    "Total Amount Of Capital (in Millions)": 10.18,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Vietnam",
    "Form Of Investment": "JV",
    "Land Owner": "U Khin Maung Oo and U Kyaw Myint",
    "Land Area (units not specified in file)": 40,
    "Lease Term": 15,
    "Annual Lease Fee": 40000000,
    "Land Use Premium": null,
    "Number Of Local Employees": 83,
    "Number Of Foreign Employees": 9,
    Status: "Monitoring Approved",
    "Investor Address":
      "NQ.4/I, Mya Kan Thar Garden Housing,\nMya Nandar Street,Home Garden, HlaingTownship,Yangon",
    "Organization Address":
      "No. 123, Seikkanthar Street, 7 Ward, Kyauktada Township, Yangon",
    "Investment Permitted Address":
      "Plot No. B 1,2,3,4,65,66,67,68, Kwin No. 551-Kha and 519-Ka, Nyaung Napin Tract, Vegetable Production and Chicken Livestock Special Zone (1), Hmawbi Township, Yangon",
  },
  {
    ID: 2053,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးထွန်းရီ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ပစိဖိတ်ဂါးမင့် မင်နယူဖတ်ချားရင်း ကုမ္ပဏီ လီမိတက်( Pacific Garment Manufacturing Co.,Ltd)",
    "Financial Year From": 2004,
    "Financial Year To": 2005,
    "Permit Number": "မနသ-၆၄၅/၂၀၀၄",
    "Permit Date": "2004-05-15T04:09:54Z",
    "Meeting Number": "၁၀/၂၀၀၄",
    "Meeting Date": "2004-03-06T04:10:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 13300,
    "Total Amount Of Capital (in Millions)": 32.63,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 0.351,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 285,
    "Number Of Foreign Employees": 1,
    Status: "Submitted",
    "Investor Address": "အမှတ်-၅၁(အေ)၊ ၇-လမ်း၊ လမ်းမတော်မြို့နယ်၊ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၂၇၇၃)၊ စက်မှုဇုန်(၂)၊ (၆၃)တိုးချဲ့ရပ်ကွက်၊ပဲခူးမြစ်လမ်း၊ ဒဂုံမြို့သစ်(တောင်ပိုင်)၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2055,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်မြမြ (ခ)စောမြမြ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ကျုံးလိအင်ဒတ်(စ်)ထရီ(စ်)ကုမ္ပဏီလီမိတက်( Jong Lih Industries Co., Ltd.)",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "မနသ-၁၅၇/၉၈",
    "Permit Date": "1998-07-17T02:57:34Z",
    "Meeting Number": "၉/၉၈",
    "Meeting Date": "1998-05-28T02:58:21Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အသင့်ချုပ်ပြီးခရီးဆောင်အိတ်အမျိုးမျိုးထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 92.62,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်မြမြ (ခ) စောမြမြ",
    "Land Area (units not specified in file)": 3.056,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 590,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "အမှတ် ၃၁၀၊ ဗိုလ်ဆွန်ပက်လမ်း၊ပန်းဘဲတန်းမြို့နယ်",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၆၈၊မြေတိုင်းရပ်ကွက်အမှတ် ၄၊ လှိုင်သာယာစက်မှုဇုန်၊ရန်ကုန်တိုင်း",
  },
  {
    ID: 2056,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်အေးအေးဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ချာတာအင်ဒတ်(စ်)ထရီရယ်(လ်)ကုမ္ပဏီလီမိတက်(Charter Industrial Co., Ltd.)",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "မနသ-၁၆၂/၉၈",
    "Permit Date": "1998-08-07T04:45:53Z",
    "Meeting Number": "၁၁/၉၈",
    "Meeting Date": "1998-06-26T04:46:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      " နိုင်ငံတကာအဆင့်မီအထည်အမျိုးမျိုးချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 29.2,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်ကြူကြူဝင်း",
    "Land Area (units not specified in file)": 2.001,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 264,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၃၀၊လှိုင်သာယာစက်မှုဇုန်-၃၊လှိုင်သာယာမြို့နယ်၊ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ် ၃၀၊လှိုသာယာစက်မှုဇုန်-၃၊ လှိုင်သာယာမြို့နယ်၊ရန်ကုန်မြို့",
  },
  {
    ID: 2057,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ခင်ခင်စိုး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ခိုင်သဇင်စိုးအထည်ချုပ်ကုမ္ပဏီလီမိတက်(Khine Thazin Soe Garment Co., Ltd.)",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "မနသ-၁၆၅/၉၈",
    "Permit Date": "1998-08-19T05:11:43Z",
    "Meeting Number": "၁၁/၉၈",
    "Meeting Date": "1998-06-26T05:12:26Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "အသင့်ချုပ်ပြီးအထည်များထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 22.73,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးထွန်းဝေနှင့် ဒေါ်ခင်ခင်စိုး",
    "Land Area (units not specified in file)": 0.75,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "အမှတ်-၅၇(ပထမထပ်)၊၁၁-လမ်း၊လမ်းမတော်မြို့နယ်၊ရန်ကုန်",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၃၃၊ပဒင်းဝန်ဦးရွှေဘင်လမ်း၊လှိုင်သာယာစက်မှုဇုန်-၁၊လှိုင်သာယာမြို့နယ်၊ရန်ကုန်တိုင်း",
  },
  {
    ID: 2058,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ကြည်ကြည်နွယ်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ခရိရေးတစ်ဂါးမန့်မန်နျူဖတ်ချားရင်းကုမ္ပဏီလီမိတက်(Creative Garment Manufacturing Co., Ltd.)",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "မနသ-၁၆၆/၉၈",
    "Permit Date": "1998-08-19T05:31:10Z",
    "Meeting Number": "၁၂/၉၈",
    "Meeting Date": "1998-07-10T05:32:03Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "အသင့်ချုပ်ပြီးအထည်များထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 29,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ရွှေလသာကုမ္ပဏီ",
    "Land Area (units not specified in file)": 2.748,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "ခ/၁၁၊ဘုရင့်နောင်လမ်း၊မရမ်းကုန်းမြို့နယ်၊ရန်ုကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်း၊အင်းစိန်မြို့နယ်၊သားသတ်ရုံအနောက်ကွက်အမှတ်-၂၉၊မြေကွက်အမှတ်-၆/င၊၇/စျ",
  },
  {
    ID: 2059,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးရွှေ(ခ)အင်ကီတပ်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ပစီဖိတ်ဇာပန်းထိုးသူများ ကုမ္ပဏီ လီမိတက်(Pacific Knitters Co.,Ltd.)",
    "Financial Year From": 2004,
    "Financial Year To": 2005,
    "Permit Number": "မနသ-၆၅၂/၂၀၀၄",
    "Permit Date": "2004-09-27T06:26:39Z",
    "Meeting Number": "၁၄/၂၀၀၄",
    "Meeting Date": "2004-04-23T06:27:24Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် စက်ထိုးထည်ထုတ်လုပ်သည့်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 68.765,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးစိန်သန်း၊ ဦးနီ၊ ဦးကြီးစိန်၊ ဦးဝင်းအောင်နှင့် ဦးရွှေ",
    "Land Area (units not specified in file)": 2.72,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 627,
    "Number Of Foreign Employees": 3,
    Status: "Submitted",
    "Investor Address": "အ မှတ်(၆၅)၊ လသာလမ်း၊ လသာမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၃၃/၄၀)၊ မြေတိုင်းရပ်ကွက်အမှတ်(၄၂)၊ အင်ကြင်းမြိုင်လမ်း၊ စက်မှုဇုန်(၁)၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2060,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးရာဂျစ်ကူးမာရ်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Real Diamond Star Co.,Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "မနသ-၉၀၃/၂၀၁၃",
    "Permit Date": "2013-03-31T07:35:06Z",
    "Meeting Number": "၁၁/၂၀၁၃",
    "Meeting Date": "2013-03-29T07:35:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် Internet Cable ၏ အပေါ်/အောက်ကာဘာနှင့် စတီးကြိုးများကို သီးခြားစီ ခွဲခြား၍ ဖြတ်တောက်စိတ်ပိုင်းပြီး ထုတ်ပိုးသည့် လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 3000,
    "Total Amount Of Capital (in Millions)": 25,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 1.377,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၁၆၃/၂၁၀)၊ နဝဒေးလမ်း၊ ၅-ရပ်ကွက်၊မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၄၁၊ မြေတိုင်းရပ်ကွက်၊ အမှတ်(၁၈)၊ တိုးချဲ့စက်မှုဇုံ၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2061,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဉာဏ်ဝေ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ပထမထိပ်တန်းကုန်ထုတ်သမဝါယမအသင်းလီမိတက်(Pahtama Hteik Tan Produciton Co-operation Ltd.)",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "မနသ-၁၇၃/၉၈",
    "Permit Date": "1998-09-14T09:08:52Z",
    "Meeting Number": "၁၄/၉၈",
    "Meeting Date": "1998-08-14T09:09:29Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "ဆပ်ပြာမှုန့်ထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 34.79,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "မြို့ရွာနှင့်အိုးအိမ်ဖွံ့ဖြိုးရေးဦးစီးဌာန",
    "Land Area (units not specified in file)": 1.058,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 83,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "အမှတ်-၆၂၊မင်္ဂလာလမ်း၊စမ်းချောင်းမြို့နယ်၊ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်-၅၈၊မြတောင်ဝန်ဦးမှိုလမ်း၊လှိုင်သာယာမြို့နယ်၊လှိုင်သာယာစက်မှုဇုန်အပိုင်း-၁၊ရန်ကုန်မြို့",
  },
  {
    ID: 2062,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ခင်စန်းမြင့်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "BGG Manufacturing Co.,Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "မနသ-၉၁၂/၂၀၁၃",
    "Permit Date": "2013-05-14T09:21:43Z",
    "Meeting Number": "၁၄/၂၀၁၃",
    "Meeting Date": "2013-05-10T09:22:16Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ သွပ်အမိုးပြားများထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.35,
    "Total Amount Of Capital (in Millions)": 500,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်ချိုချိုဝင်း",
    "Land Area (units not specified in file)": 1.271,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": 6,
    Status: "Amend",
    "Investor Address":
      "အမှတ်(၁၈)၊ ဇီဇဝါဥယျာဉ်အိမ်ရာ၊ သံသုမာလမ်း၊ ၁၅ ရပ်ကွက်၊တောင်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၆၉)၊ မြေတိုင်းရပ်ကွက်အမှတ်(၂၅)၊ ရွှေလင်ပန်းစက်မှုမြို့၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2064,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်ဝင်း(ခ)ဦးကွေကော့ဟွီး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ဂရင်းစပို့(စ်)အင်တာနေရှင်နယ်လီမိတက်(Grand Sports International Ltd.)",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "မနသ-၁၇၉/၉၈",
    "Permit Date": "1998-10-13T03:24:22Z",
    "Meeting Number": "၁၄/၉၈",
    "Meeting Date": "1998-08-14T03:24:45Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အသင့်ချုပ်ပြီးအထည်များထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 17.2,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးဇော်မင်းဦးနှင့်ဒေါ်တင်တင်ဆွေ",
    "Land Area (units not specified in file)": 0.459,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၅၇၊ အခန်း(၁)၊ (၄၆)လမ်း(အောက်)၊ (၉)ရပ်ကွက်၊ ဗိုလ်တထောင်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၅၃(ခ)၊မြေတိုင်းရပ်ကွက်အမှတ်-၄၂၊ရွှေပြည်သာမြို့နယ်၊ရန်ကုန်တိုင်း",
  },
  {
    ID: 2065,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးလှဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "လူကြိုက်များသောအပြည်ပြည်ဆိုင်ရာအထည်ထုတ်လုပ်မှုကုမ္ပဏီလီမိတက်(Popular International Garment Manufacturing Co., Ltd.)",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "မနသ-၁၉၅/၂၀၀၀",
    "Permit Date": "2000-05-27T03:59:38Z",
    "Meeting Number": "၁၀/၂၀၀၀",
    "Meeting Date": "2000-03-23T04:01:20Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့်အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 15.6,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအာဇမ်",
    "Land Area (units not specified in file)": 1.549,
    "Lease Term": null,
    "Annual Lease Fee": 3.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 919,
    "Number Of Foreign Employees": 15,
    Status: "Submitted",
    "Investor Address":
      "အမှတ်- ၃၁/၃၃၊၄ထပ်၊ရွှေတီဂုံဘုရားလမ်း၊လသာမြို့နယ်၊ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်း၊ရွှေပြည်သာစက်မှုဇုန်၊မြေတိုင်းရပ်ကွက်-၄၂၊မြေကွက်အမှတ်-၁၀၆",
  },
  {
    ID: 2066,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yu Liang",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "GLOBAL FASHION COMPANY  LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "128/2018",
    "Permit Date": "2018-11-19T05:54:21Z",
    "Meeting Number": "19/2018",
    "Meeting Date": "2018-11-19T05:55:33Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS ",
    "Amount Of Foreign Capital USD (in Millions)": 6,
    "Total Amount Of Capital (in Millions)": 6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Soe Tint Aung",
    "Land Area (units not specified in file)": 2.234,
    "Lease Term": 20,
    "Annual Lease Fee": 18077.76,
    "Land Use Premium": null,
    "Number Of Local Employees": 4000,
    "Number Of Foreign Employees": 50,
    Status: "Approved",
    "Investor Address":
      "AN HUI, FU YANG SHI, YING QUAN, XING LIU ZHEN, LIU HE XING ZHENG CUN, PEOPLE’S REPUBLIC OF CHINA       ",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 401, MYAY TAING BLOCK NO. 25, SHWE LIN BAN SET HMU MYO, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2068,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဇာနည်အောင်မျိုးထွေး(ခ)အောင်မျိုးဟိန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Authentic Production Co.,Ltd",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "မနသ-၉၁၃/၂၀၁၃",
    "Permit Date": "2013-05-14T07:27:32Z",
    "Meeting Number": "၁၄/၂၀၁၃",
    "Meeting Date": "2013-05-10T07:29:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ရေပေးဝေရေးပိုက်၊ ရေသိုလှောင်ကန်နှင့် အဆင်မြင့်မိလ္လာကန် ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 2.08,
    "Total Amount Of Capital (in Millions)": 2000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်နီနီတင်ထွန်း",
    "Land Area (units not specified in file)": 5.88,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(အက်ဖ်-၄)၊ ကမ္ဘာအေးဗီလာ၊ ကမ္ဘာအေးဘုရားလမ်း၊ (၅)ရပ်ကွက်၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေတိုင်းရပ်ကွက်အမှတ်(၅၃၂/အေ)၊ မြေကွက်အမှတ်(၂၁/စီ)၁-၂A    ရှိမြေ(၅.၈၈)ဧက၊ ဘိုခြံလမ်း၊ ပျဉ်းမပင်ကျေးရွာအုပ်စု၊ မင်္ဂလာဒုံမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2071,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဝင်းကိုလတ်(ခ)ဦးဇန်မိုင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Chan Yin Industries Co.,Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "မနသ-၉၁၄/၂၀၁၃",
    "Permit Date": "2013-05-30T05:29:34Z",
    "Meeting Number": "15/2013",
    "Meeting Date": "2013-05-22T06:55:50Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ဆောက်လုပ်ရေးပစ္စည်းအမျိုးမျိုး ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 3.55,
    "Total Amount Of Capital (in Millions)": 3592.85,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအိုက်ဆိုက်နှင့် ဒေါ်ရင်ရှင်းမေ",
    "Land Area (units not specified in file)": 2.2,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၂/စီ)၊ အေဝမ်းလမ်း၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၂၂၈၊ ၂၂၉၊ ၂၀၃ ၊၂၃၁ )ရှိမြေ၊၁၁ လမ်း၊ ရန်ကုန်စက်မှုဇုန်၊မင်္ဂလာဒုံမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2072,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဉာဏ်မင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "မန္တလေးမှန်ကုမ္ပဏီလီမိတက်(Mandalay Glass Co., Ltd.)",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "မနသ-၃၉၀/၂၀၀၀",
    "Permit Date": "2000-05-20T06:20:49Z",
    "Meeting Number": "၅/၂၀၀၀",
    "Meeting Date": "2000-02-18T06:21:20Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "မှန်ဖြင့်ပြုလုပ်သောအိမ်သုံးနှင့်ဆောက်လုပ်ရေးသုံးကုန်ပစ္စည်းများထုတ်လုပ်သည့် လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 58.71,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးဉာဏ်မင်း",
    "Land Area (units not specified in file)": 1.467,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်-၁၄၆၊ပြည်လမ်း၊မရမ်းကုန်းမြို့နယ်၊ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၃၀၊စက်မှုဇုန်-၂၊လှိုင်သာယာမြို့နယ်၊ရုန်ကုန်မြို့",
  },
  {
    ID: 2074,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဇော်ဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ဝင်းအထည်ထုတ်လုပ်မှုကုမ္ပဏီလီမိတက်(Win-Garment Manufacturing Co., Ltd.)",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "မနသ-၃၉၈/၂၀၀၀",
    "Permit Date": "2000-05-05T06:43:16Z",
    "Meeting Number": "12/2000",
    "Meeting Date": "2000-04-07T06:56:22Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ကုန်ကြမ်းဝယ်ယူ၍လုပ်ကိုင်သောစနစ်နှင့်လက်ခစားစနစ်အရအထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 52,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးလှဝင်း(ခ)ဂေါ်ဆစ်မား",
    "Land Area (units not specified in file)": 1.517,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 381,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်-၉၆၊၁၄လမ်း၊လမ်းမတော်မြို့နယ်၊ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၈၂၊မြေတိုင်းရပ်ကွက်အမှတ်-၂၊စက်မှုဇုန်၊လှိုင်သာယာမြို့နယ်၊ရန်ကုန်မြို့",
  },
  {
    ID: 2087,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Naing Thaung Htaik",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Victoria Uni Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "124/2018",
    "Permit Date": "2018-11-08T03:59:57Z",
    "Meeting Number": "18/2018",
    "Meeting Date": "2018-11-02T04:00:04Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Victoria University College",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 1410,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "-\tဦးအောင်ဟိန်း၊  ဒေါ်ခင်မာကြူ၊ ဒေါ်စန်းမြင့်ရီ၊ ဦးအောင်ကြည် နှင့် ဦးမန်းဘဟာဒူးရ် ",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 55,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "No. (299/301), third floor, Bo Anung Kyaw Street, Ward (9), Kyauktada Township, Yangon",
    "Organization Address": "-",
    "Investment Permitted Address": "Yangon Region and Mandalay Region",
  },
  {
    ID: 2088,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးခင်မောင်မြင့်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ရောဟဏီစက်မှုလက်မှုလုပ်ငန်းလီမိတက်(Rawhani Industry Ltd.)",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "မနသ-၄၂၇/၂၀၀၀",
    "Permit Date": "2000-09-06T04:38:45Z",
    "Meeting Number": "၂၅/၂၀၀၀",
    "Meeting Date": "2000-07-28T04:39:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့်အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 102.4,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးခင်မောင်မြင့်",
    "Land Area (units not specified in file)": 2.179,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "တိုက်အမှတ်-၁၆၇၊အခန်း-၂၊၄ရပ်ကွက်၊ရန်ကင်းမြို့နယ်၊ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၂၉၊ဝက်မစွပ်ဝန်ထောက်လမ်း၊စက်မှုဇုန်အမှတ်-၄၊လှိုင်သာယာမြို့နယ်၊ရန်ကုန်တိုင်း",
  },
  {
    ID: 2089,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးစိန်ဦး(ခ)လောရိန်ကြစ်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "စိန်စန္ဒာအပြည်ပြည်ဆိုင်ရာကုမ္ပဏီလီမိတက်(Sein Sanda International Co., Ltd.)",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "မနသ-၄၃၀/၂၀၀၀",
    "Permit Date": "2000-09-28T06:46:19Z",
    "Meeting Number": "၂၈/၂၀၀၀",
    "Meeting Date": "2000-08-18T06:42:03Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "လက်ခစားစနစ်ဖြင့်ယောက်ျားရှပ်အိင်္ကျီနှင့်အခြားအထည်အမျိုးမျိုးချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 63.57,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးလောရိန်ကြစ်(ခ)စိန်ဦး",
    "Land Area (units not specified in file)": 1.701,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်၉၄၊ဘိုကလေးစျေးလမ်း၊ဗိုလ်တစ်ထောင်မြို့နယ်၊ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၀၄၊မြေတိုင်းရပ်ကွက်အမှတ်အပိုင်း-၃ တိုးချဲ့၊စက်မှုမြို့၊လှိုင်သာယာမြို့နယ်၊ရန်ကုန်တိုင်း",
  },
  {
    ID: 2090,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးရဲမြင့်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "စုစည်းကမ္ဘာအထည်ချုပ်လုပ်ငန်းကုမ္ပဏီလီမိတက်(United World Garment Manufacturing Co., Ltd.)",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "မနသ-၄၃၂/၂၀၀၀",
    "Permit Date": "2000-09-28T06:56:40Z",
    "Meeting Number": "၂၉/၂၀၀၀",
    "Meeting Date": "2000-08-24T06:57:13Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့်အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 25.7,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်ခင်စန်းကြူ၊ဦးမြင့်ရွှေ",
    "Land Area (units not specified in file)": 1.378,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 702,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်-၂၊ဒဂုံလွင်လမ်း၊တာမွေမြို့နယ်၊ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၄၅ (က/ခ)၊မြေတိုင်းရပ်ကွက်အမှတ်-၄၂၊ရွှေပြည်သာစက်မှုဇုန်-၁၊ရွှေပြည်သာမြို့နယ်၊ရန်ကုန်တိုင်း",
  },
  {
    ID: 2092,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Abbobaker A.L. ADMAMI",
    "Name of Principal Organization": "Lucky Industries",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Lucky Industries Overseas Ltd.",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "134/95",
    "Permit Date": "1995-03-28T05:34:12Z",
    "Meeting Number": "3/95",
    "Meeting Date": "1995-02-27T05:35:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production and Marketing of Jackets and Ready Made Garments",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 5,
    "Investing Country": "Sri Lanka",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "Colombo, Sri Lanka",
    "Organization Address": "Colombo, Sri Lanka",
    "Investment Permitted Address":
      "Textile Factory-3, Branch-3, Shwe Kyee Road, Insein Township, Yangon",
  },
  {
    ID: 2095,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Choi Joon Sik",
    "Name of Principal Organization": "Shinsung Tongsang Intrnational Co.,Ltd.",
    "Place of Incorporation": "Korea",
    "Company Name In Myanmar": "Shinsung Tongsang Intrnational Co.,Ltd.",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "334/2000",
    "Permit Date": "2000-03-22T07:47:41Z",
    "Meeting Number": "27/1999",
    "Meeting Date": "1999-12-27T07:52:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Production of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.5,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "Human Settlement & Housing Development",
    "Land Area (units not specified in file)": 3.068,
    "Lease Term": 50,
    "Annual Lease Fee": 0.037,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Amend",
    "Investor Address": "1-13,Chang Jun Dong, Maiogu, Seoul, Korea",
    "Organization Address": "1-13, Chang Jun Dong, Mapogu, Seoul, Korea",
    "Investment Permitted Address":
      "Plot No.20,21,22,23,32,33,34,35 and 36 at Shwe Pauk Kan Industrial zone, North Okkalapa Township, Yangon",
  },
  {
    ID: 2096,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.  Bong Shik Suh",
    "Name of Principal Organization": "Sunny Incorporated",
    "Place of Incorporation": "Korea",
    "Company Name In Myanmar": "Myanmar Sunny Co., Ltd.",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "335/2000",
    "Permit Date": "2000-04-18T08:21:20Z",
    "Meeting Number": "4/2000",
    "Meeting Date": "2000-02-11T08:21:50Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Shoes and Its Parts",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "Department of Human Settlement and Housing Development",
    "Land Area (units not specified in file)": 3,
    "Lease Term": 20,
    "Annual Lease Fee": 0.036,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "86-1004 Hyundai apartment, Apkujung-Dong, Daeduk-Ku, Taejon, Korea",
    "Organization Address": "48-7,Moonpyong-Dong, Daeduk-Ku, Taejon, Korea",
    "Investment Permitted Address":
      "Plot No.247-B,Industrial Zone-2, Hlaing Tharyar Township, Yangon",
  },
  {
    ID: 2097,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Cheng Kin Ming",
    "Name of Principal Organization": "TEGO SDN BHD",
    "Place of Incorporation": "Malaysia",
    "Company Name In Myanmar": "Tefel Packaging Industries Co., Ltd.",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "336/2000",
    "Permit Date": "2000-04-27T08:33:45Z",
    "Meeting Number": "5/2000",
    "Meeting Date": "2000-02-18T08:34:19Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Packaging and Related Products",
    "Amount Of Foreign Capital USD (in Millions)": 7.032,
    "Total Amount Of Capital (in Millions)": 7.032,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Malaysia",
    "Form Of Investment": "FDII",
    "Land Owner": "Department of Human Settlement and Housing Development",
    "Land Area (units not specified in file)": 4.02,
    "Lease Term": null,
    "Annual Lease Fee": 0.048,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "306,Jalan RJ 1/7, Rasah Jaya 70300 Seremban, Negeri Sembilan, Malaysia",
    "Organization Address":
      "306,Jalan RJ 1/7, Rasah Jaya, 70300 Seremban, Negeri Sembilan, Malaysia",
    "Investment Permitted Address":
      "Plot No.248/247-A, Block No.23, Industrial Zone, South Dagon Township",
  },
  {
    ID: 2098,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအုန်းလွင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ပရိုဗင်(န်)တက်(ချ)နော် လော်ဂျီ အင်ဒတ်စ်ထရီ  ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "MaNaTha-031/1996",
    "Permit Date": "1996-07-22T06:21:12Z",
    "Meeting Number": "9/1996",
    "Meeting Date": "1999-06-21T06:21:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ယာဥ်စက်သုံးခဲအက်စစ် ဘက်ထရီအိုး  များ ထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 20.4,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 1.939,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၇၀၉၊ ကုန်သည်လမ်း၊ ပန်းဘဲတန်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(94က/ခ)၊ မြေတိုင်း ရပ်ကွက်(42)၊ စက်မှုဒေသ၊ ရွှေပြည်သာ မြို့နယ် ",
  },
  {
    ID: 2099,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးရုံဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Golden Triangle Garment Co., Ltd.",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "၀၃၃/၉၆",
    "Permit Date": "1996-07-24T06:39:14Z",
    "Meeting Number": "၁၀/၉၆",
    "Meeting Date": "1996-07-05T06:39:58Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "အသင့်ချုပ်ပြီးအထည်များ ထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 30,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်တင်တင်ဝင်း",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၁၂၊ အုတ်ကျင်းဘူတာရုံလမ်း၊ လှိုင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ် ၁၂၊ အုတ်ကျင်းဘူတာရုံလမ်း၊ လှိုင်မြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 2100,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကျော်ဇင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Opal International Co., Ltd.",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "MaNaTha-034/96",
    "Permit Date": "1996-07-24T06:46:02Z",
    "Meeting Number": "11/1996",
    "Meeting Date": "1996-06-28T06:46:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 107.2,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးကျော်ဇင်",
    "Land Area (units not specified in file)": 3.013,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်  ၃၇၊ ယုဇနယမ်းသွယ်၊ ကမာကြည်လမ်း၊ ၁၀ ရပ်ကွက်၊ သုဝဏ္ဏ၊ သင်္ဃန်းကျွန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၁၄)နှင့် (၁၅) စက်မှုဒေသဇုန်(၁)၊ လှိုင်သာယာ။",
  },
  {
    ID: 2101,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mrs. Jing Aimei",
    "Name of Principal Organization":
      "Jiangsu Solamota Garment Group Co., Ltd.",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Myanmar Sunview Garments Co.,Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "592/2013",
    "Permit Date": "2013-07-12T07:32:40Z",
    "Meeting Number": "17/2013",
    "Meeting Date": "2013-06-29T07:33:14Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.8,
    "Total Amount Of Capital (in Millions)": 1.8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Khin Aye Lwin",
    "Land Area (units not specified in file)": 2.527,
    "Lease Term": 10,
    "Annual Lease Fee": 0.049,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "16-101, Dongsheng Garden, Chongchuan District, Jiangsunantong, People's Republic of China",
    "Organization Address": "People's Republic of China",
    "Investment Permitted Address":
      "Plot No. 139, Min Ayeyar Road, Shwe Than Lwin Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2102,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးထွန်းမြင့်နိုင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Asia World Industries Limi ted",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "MaNaTha-050/1996",
    "Permit Date": "1996-11-22T07:27:28Z",
    "Meeting Number": "16/1996",
    "Meeting Date": "1996-10-25T07:28:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "စက္ကူကဒ်ထူနှင့် စက္ကူ ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 51.44,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 2.306,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၂၀/၂၃၊ မစိုးရိမ်ကျောင်းလမ်း၊ ၅ ရပ်ကွက်၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(125)၊ မြေတိုင်း အမှတ်(23)၊ စက်မှုဒေသ ဒဂုံမြို့သစ်တောင်ပိုင်းမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 2104,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Au King Lun, Paulina",
    "Name of Principal Organization": "Broad Ease Limited",
    "Place of Incorporation": "British Virgin Islands",
    "Company Name In Myanmar": "Tristate Myanmar Company Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "576/2013",
    "Permit Date": "2013-04-28T08:44:13Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.499,
    "Total Amount Of Capital (in Millions)": 2.499,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Virgin Islands (British)",
    "Form Of Investment": "FDII",
    "Land Owner": "Myanma Economic Holdings Limited",
    "Land Area (units not specified in file)": null,
    "Lease Term": 30,
    "Annual Lease Fee": 0.435,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Flat 4,24th Floor, Block B, Kam Kai House, Kam Ying Court, Ma On Shan, New Territories, Hong Kong",
    "Organization Address":
      "P.O. BOX 957, Offshore Incorporations Centre, Road Town, Tortola, British Virgin Islands",
    "Investment Permitted Address":
      "Plot No. 42, Pyin Ma Bin Industrial Park, Mingaladon Township, Yangon Region",
  },
  {
    ID: 2105,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးထွန်းမြင့်နိုင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "အေးရှားဝါး(လ်) အင်ဒတ်(စ်) ထရီလီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "MaNaTha-263/1999",
    "Permit Date": "1999-06-25T08:27:22Z",
    "Meeting Number": "8/1999",
    "Meeting Date": "1999-05-14T08:28:33Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Liminated Woven Bags ထုတ်လုပ် ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 275,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 3.142,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 440,
    "Number Of Foreign Employees": 12,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၂၀၊ ၂၃၊ မစိုးရိမ်ကျောင်းလမ်း၊ ၅ ရပ်ကွက်၊ မရမ်းကုန်းမြို့နယ်၊ ၇န်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(125)၊ မြေတိုင်း ရပ်ကွက် အပိုင်း(23)၊ ဒဂုံ မြို့သစ်တောင်ပိုင်းစက်မှုဇုံ",
  },
  {
    ID: 2106,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Yang Ho",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Prime Metal Company Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "577/2013",
    "Permit Date": "2013-05-14T09:10:38Z",
    "Meeting Number": "14/2013",
    "Meeting Date": "2013-05-10T05:13:20Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Construction Materials and Factory Utensils (Welded H.Beams and Pipes)",
    "Amount Of Foreign Capital USD (in Millions)": 16.8035,
    "Total Amount Of Capital (in Millions)": 28565.95,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "JV",
    "Land Owner": "U Yang Ho",
    "Land Area (units not specified in file)": 6.524,
    "Lease Term": 30,
    "Annual Lease Fee": 0.092,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 5ZA-2/2, Aung Mingalar Street, Ward No. 4, Mayangone Township, Yangon Region",
    "Organization Address": "",
    "Investment Permitted Address":
      "Block No. 1/2, Yangon Industrial Zone-Extension No. 1, Mingaladon Township, Yangon Region",
  },
  {
    ID: 2107,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Sung Tsung Hsu",
    "Name of Principal Organization": "Progetto Win Co., Ltd.",
    "Place of Incorporation": "Brunei Darussalam",
    "Company Name In Myanmar": "General Enterprises Garment Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "578/2013",
    "Permit Date": "2013-05-14T10:47:24Z",
    "Meeting Number": "14/2013",
    "Meeting Date": "2013-05-10T04:56:21Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.233,
    "Total Amount Of Capital (in Millions)": 1.233,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Brunei Darussalam",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaung Wai Phyo",
    "Land Area (units not specified in file)": 2.43,
    "Lease Term": 30,
    "Annual Lease Fee": 0.054,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "5 F, No. 26, Lane 583, REI-Kuang Road, Taipei, Taiwan",
    "Organization Address":
      "RM 51, 5th Floor, Britannia House, Jalan Cator, Bandar Seri Begawan BS 8811, Negara Brunei Darussalam",
    "Investment Permitted Address":
      "Plot No. 59, Myay Taing Quarter No. 113, Kanaung Minthargyi Street, East Dagon Myothit, Industrial Zone, East Dagon Myothit Township, Yangon Region",
  },
  {
    ID: 2108,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Tsai, Chen-Sheng",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Force Company Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "581/2013",
    "Permit Date": "2013-05-14T10:54:20Z",
    "Meeting Number": "14/2013",
    "Meeting Date": "2013-05-10T04:57:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Shoes on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.76,
    "Total Amount Of Capital (in Millions)": 0.76,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Khin Htwe, Daw Myint Myint Yee",
    "Land Area (units not specified in file)": 1.504,
    "Lease Term": 30,
    "Annual Lease Fee": 0.035,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.17, ALY 25, LN 456, 50 Fengzhou Road, Shengang Dist, Taichung City 429, Taiwan, Republic of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 170,171 (A), Myay Taing Quarter No. 25, Mingyi Mahar Min Khaung Road, Shwelinpan Industrial Zone, Hlaing Thayar Township, Yangon Region",
  },
  {
    ID: 2109,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Dai, Hung-Chuan",
    "Name of Principal Organization": "HC (Asia) Holdings Co., Ltd.",
    "Place of Incorporation": "Cayman Islands",
    "Company Name In Myanmar": "Hon Chuan (Myanmar) Co., Ltd. ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "582/2013",
    "Permit Date": "2013-05-14T11:00:37Z",
    "Meeting Number": "14/2013",
    "Meeting Date": "2013-05-10T05:00:05Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and marketing of all kinds of plastic bottles, PET bottle performs, plastic films labels and related materials",
    "Amount Of Foreign Capital USD (in Millions)": 34.615,
    "Total Amount Of Capital (in Millions)": 49.45,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 35,
    "Investing Country": "Cayman Islands",
    "Form Of Investment": "JV",
    "Land Owner": "Mingaladon Industrial Park",
    "Land Area (units not specified in file)": 7.439,
    "Lease Term": 35,
    "Annual Lease Fee": 0.009,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "1F, No.6, 2nd Road, Taichung Industrial Park, Taichung, Taiwan, Republic of China",
    "Organization Address":
      "Marquee Place, Suite 300, 430 West Bay Road, Grand Cayman, Cayman Islands",
    "Investment Permitted Address":
      "Plot No. B-5, Mingaladon Industrial Park, Mingaladon Township, Yangon Region",
  },
  {
    ID: 2111,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr. Wong Yuk Yin",
    "Name of Principal Organization": "Elite Enterprises Corporation Ltd. ",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "EMC Manufacturing Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "613/2013",
    "Permit Date": "2013-08-26T04:42:50Z",
    "Meeting Number": "21/2013",
    "Meeting Date": "2013-08-15T04:43:25Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Bags and Wallets on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 22.069,
    "Total Amount Of Capital (in Millions)": 22.069,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 36,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Mingalardon Industrial Park",
    "Land Area (units not specified in file)": 7.415,
    "Lease Term": 36,
    "Annual Lease Fee": 1.739,
    "Land Use Premium": null,
    "Number Of Local Employees": 3020,
    "Number Of Foreign Employees": null,
    Status: "Amend",
    "Investor Address":
      "Unit 618,6/F,Delta House, 3 on Yiu Street, Shek Mun, Shatin, N.T, Hong Kong",
    "Organization Address":
      "Unit 618,6/F,Delta House, 3 on Yiu Street, Shek Mun, Shatin, N.T, Hong Kong",
    "Investment Permitted Address":
      "Plot No.C-8, Mingalardon Industrial Park, Mingalardon Township, Yangon Region",
  },
  {
    ID: 2112,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kim Young Kwang",
    "Name of Principal Organization": "Packraft Corporation ",
    "Place of Incorporation": "Korea",
    "Company Name In Myanmar": "Packraft Myanmar Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "614/2013",
    "Permit Date": "2013-08-28T05:06:07Z",
    "Meeting Number": "21/2013",
    "Meeting Date": "2013-08-15T05:06:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.55,
    "Total Amount Of Capital (in Millions)": 1.55,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Hla Win Khaing",
    "Land Area (units not specified in file)": 5.752,
    "Lease Term": 50,
    "Annual Lease Fee": 7.56,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "698-2(1/25), Pungdeokcheon-Dong, Su Ji-Gu,Yongin-si, Gyeonggi-Do,Republic of Korea",
    "Organization Address":
      "232-8, Seoondong-Ri, chowol-Eup, Gwangju-Si, Gyeonggi-Do, Republic of Korea",
    "Investment Permitted Address":
      "Plot No.250-D, Industrial Zone, Block No-2, Hlaing Tharyar Township,Yangon Region",
  },
  {
    ID: 2113,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Fong Hiu Fung",
    "Name of Principal Organization": "Richest Time Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Designtime Myanmar Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "594/2013",
    "Permit Date": "2013-09-24T05:34:31Z",
    "Meeting Number": "17/2013",
    "Meeting Date": "2013-06-29T05:34:52Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Watch Components, Fashion Accessories and Components on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 8.9675,
    "Total Amount Of Capital (in Millions)": 8.967,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 36,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Mingaladon Industrial Park",
    "Land Area (units not specified in file)": 10.27,
    "Lease Term": 36,
    "Annual Lease Fee": 1.995,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "21/D, Poyang Mansion, Tsui Woo Terrace, 6 Tai Koo Shing Road, Quarry Bay, Hong Kong",
    "Organization Address":
      "Block B, 15/F, Tung Chong Factory Building, 655 King's Road, North Point, Hong Kong",
    "Investment Permitted Address":
      "Plot No.A-13, Mingaladon Industrial Park, Mingaladon Township, Yangon Region",
  },
  {
    ID: 2114,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးရန်ရှင်းနောင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "မိုးတောင်တန်းစက်မှု ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "MaNaTha-265/1999",
    "Permit Date": "1999-06-25T08:51:40Z",
    "Meeting Number": "9/99",
    "Meeting Date": "1999-06-04T08:52:27Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "နံရံသုတ် ပူတင်းများ ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 34.5,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 35,
    "Number Of Foreign Employees": 1,
    Status: "Approved",
    "Investor Address": "တိုက် ၅၅၊ ၂ လမ်း၊ လမ်းမတော်မြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "‌မြေကွက်အမှတ် (139/160)၊  စက်မှုဇုံ(2)၊  လှိုင်သာယာမြို့နယ်။",
  },
  {
    ID: 2115,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ခိုင်ဇော်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "အပ်(သ်)အင်ဒတ်(စ်) ထရီရယ်(လ်)မြန်မာ ကုမ္ပဏီလီမိတက် (Earth Industrial (Myanmar) Company Limited)",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "MaNaTha-266/1990",
    "Permit Date": "1999-06-25T09:03:09Z",
    "Meeting Number": "9/99",
    "Meeting Date": "1999-06-04T09:03:36Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် Thermal Cutoffs များ ထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 100,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်ခိုင်ဇော်",
    "Land Area (units not specified in file)": 3,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "အမှတ် ၄၀၊ အင်းလျားလမ်း၊ ကမာရွတ်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "CMP စနစ်ဖြင့် Thermal Cutoffs များ ထုတ်လုပ်ခြင်း",
  },
  {
    ID: 2116,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဝင်းသိန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "စုပေါင်းစွမ်းအား ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "MaNaTha-270/1999",
    "Permit Date": "1999-07-20T09:17:17Z",
    "Meeting Number": "9/99",
    "Meeting Date": "1999-06-04T09:17:32Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "စွပ်ကျယ်ပိတ်စ ယက်လုပ် ဆေးဆိုး ခြင်း နှင့် ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 24.8,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးဝင်းသိန်း + ၅ ဦး",
    "Land Area (units not specified in file)": 1.093,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၁၁၃၊ ရွှေတိဂုံဘုရားလမ်း၊ ၇ ရပ်ကွက်၊ လသာမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "‌မြေကွက်အမှတ် (163)၊ စက်မှုဇုံ (2)၊ မြင်းဝန် ဦးအောင်သူလမ်း၊   လှိုင်သာယာမြို့နယ်။",
  },
  {
    ID: 2117,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးသိန်းဟန်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "မြန်မာပိုက်များနှင့် အသုံးအ ဆောင်များကုမ္ပဏီလီမိတက် (Myanmar Pipe and Accessories Co., Ltd.)",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "MaNaTha-275/1999",
    "Permit Date": "1999-07-23T09:33:42Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ပိုက်အမျိုးမျိုးနှင့် ပလပ်စတစ် အသုံး အဆောင်ပစ္စည်းများ ထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 120.8,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "၁၀၅/၇၊ သံလွင်လမ်း၊ ကမာရွတ်မြို့နယ်၊ ရန်ကုန်တိုင်း",
    "Organization Address": "",
    "Investment Permitted Address":
      "‌မြေကွက်အမှတ် (6 က၊ 6 ခ)၊ စက်မှုဇုံ (1)၊လှိုင်သာယာမြို့နယ်။",
  },
  {
    ID: 2118,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဇော်ဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "နေမင်းအောင် အထည်ချုပ် ကုမ္ပဏီလီမိတက် (Nay Min Aung Garment Co., Ltd.)",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "MaNaTha-276/1999",
    "Permit Date": "1999-07-23T09:42:07Z",
    "Meeting Number": "10/99",
    "Meeting Date": "1999-06-25T09:42:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "လက်ခစားထုတ်လုပ်မှုစနစ် (CMP) ဖြင့် အထည်အမျိုးမျိုး ထုတ်လုပ် ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 35,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 0.617,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၁၁၂၊  အမရာလမ်း၊ င/ စက်မှုရပ်ကွက်၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၁၁၂)၊(၁၁၂ က)၊ မြေတိုင်း ရပ်ကွက် အမှတ် (င)၊ စက်မှု လက်မှု/ မြောက် ဥက္ကလာပ မြို့နယ်။",
  },
  {
    ID: 2119,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဇော်မိုးအောင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ကျားလေးဝတ်စုံကုမ္ပဏီလီမိတက် (Kyar Lay Apparel Company Limited)",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "MaNaTha-281/1999",
    "Permit Date": "1999-08-03T10:04:32Z",
    "Meeting Number": "11/99",
    "Meeting Date": "1999-07-09T10:05:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "လက်ခစားထုတ်လုပ်မှုစနစ်(CMP) ဖြင့် နိုင်ငံတကာအဆင့်မီအဝတ် အထည်အမျိုးမျိုးထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 62.72,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 2.243,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၅၅/အေ၊ မယ်ဇီကုန်းလမ်း၊ အကွက်အမှတ်(ဂ)၊ လှိုင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၆၄/၁၆၇)၊ လှိုင်သာယာစက်မှုဇုန်(၂)၊ ရန်ကုန်မြို့။\n(လက်ခစားထုတ်လုပ်မှုစနစ်(CMP) ဖြင့် နိုင်ငံတကာအဆင့်မီအဝတ် အထည်အမျိုးမျိုးထုတ်လုပ်ခြင်း လုပ်ငန်း)",
  },
  {
    ID: 2120,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးထွန်းလှိုင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "နံနက်ခင်းနေမင်း အထည်ချုပ် ကုမ္ပဏီလီမိတက် (Morning Sun Garment Co., Ltd.)",
    "Financial Year From": 2001,
    "Financial Year To": 2002,
    "Permit Number": "MaNaTha-501/2001",
    "Permit Date": "2001-06-27T10:35:51Z",
    "Meeting Number": "12/2001",
    "Meeting Date": "2001-04-26T10:36:20Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 42.34,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 0.737,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၂၉ (က)၊ ၆၀ လမ်း၊ ၇ ရပ်ကွက်၊ လှိုင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်(၁၀၉)၊ြေမကွက်အမှတ် (၁၀၉)၊ မက္ခရာမင်းသားကြီး မောင်ပျိုးလမ်း၊ စက်မှုဇုန် (၂)၊ လှိုင်သာယာ။",
  },
  {
    ID: 2121,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမောင်မောင်ဦး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "အာရှသမာဓိ  ကုမ္ပဏီလီမိတက် (Asian Just Company Limited)",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "MaNaTha-503/2001",
    "Permit Date": "2001-06-27T10:43:06Z",
    "Meeting Number": "12/2001",
    "Meeting Date": "2001-04-26T10:43:50Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 29.2,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၂၆၊ ဇောတိကလမ်း၊ စမ်းချောင်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေတိုင်းရပ်ကွက်အမှတ် ၄၂၊ မြေကွက်အမှတ် ၁၆၀၊ ရွှေပြည်သာစက်မှုဇုန်၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2122,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးရဲစိန်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ရွှေမင်္ဂလာ ကုမ္ပဏီလီမိတက် (Shwe Mingalar Company Limited)",
    "Financial Year From": 2001,
    "Financial Year To": 2002,
    "Permit Number": "MaNaTha-505/2001",
    "Permit Date": "2001-06-27T10:52:02Z",
    "Meeting Number": "12/2001",
    "Meeting Date": "2001-04-26T10:52:13Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် နိုင်ငံတကာ အဆင့် မီ အထည်အမျိုးမျိုး ချုပ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 46.49,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 2.264,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၅၂၅၊ ပထမထပ်၊ မဟာဗန္ဓုလလမ်း၊ ပန်းဘဲတန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "‌ေမြကွက်အမှတ် (၂၅၊၂၆)၊ စက်မှုဇုန်(၄)လမ်း၊  ရန်ကုန်စက်မှုဇုန်၊မင်္ဂလာဒုံမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး။",
  },
  {
    ID: 2124,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်စပယ်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "အာရှအထည်ချုပ်စက်မှု လီမိတက် (Asaian Garment Industry Ltd.)",
    "Financial Year From": 2005,
    "Financial Year To": 2006,
    "Permit Number": "MaNaTha-662/2005",
    "Permit Date": "2005-05-05T03:27:06Z",
    "Meeting Number": "8/2005",
    "Meeting Date": "2005-02-24T03:27:42Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ် ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 114.5,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 2.012,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၇၃၊ ၇၆၊ ဝေဇယန္တာလမ်း၊ သင်္ဃန်းကျွန်းမြို့နယ်၊  ရန်ကုန်တိုင်း",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်(၁၃၁)၊ ရန်ကုန်စက်မှုဇုံ၊ မင်္ဂလာဒုံ ဥယျာဥ် မြို့တော်၊ မြောက်ဥက္ကလာပမြို့နယ်။",
  },
  {
    ID: 2125,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lai Kin Ching",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "SDI Manufacturing Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "611/2013",
    "Permit Date": "2013-09-09T03:30:05Z",
    "Meeting Number": "22/2013",
    "Meeting Date": "2013-08-21T03:30:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.988,
    "Total Amount Of Capital (in Millions)": 0.988,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Myint",
    "Land Area (units not specified in file)": 2.275,
    "Lease Term": 30,
    "Annual Lease Fee": 0.055,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Unit 3,8/F, Yee Kuk Industrial Centre, 555 Yee Kuk ST, Kowloon, Hong Kong",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 40, Myay Taing Quarter No. 24, Ngwe Pin Lei Industrial Zone, Hlaing Thrar Yar Township, Yangon Region",
  },
  {
    ID: 2126,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဇော်ဝိတ်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "တီအေစီတက်ခနီကယ်(လ်) ကုမ္ပဏီလီမိတက် (TAC Technical Company Limited)",
    "Financial Year From": 2006,
    "Financial Year To": 2007,
    "Permit Number": "MaNaTha-665/2006 (29-3-2006)",
    "Permit Date": "2006-03-29T03:33:58Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာ အဆင့်မီ အိတ်ချိန်းစက် နှင့် လိုင်းကဒ်များ ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 600,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးဇော်ဝိတ် + ၃ ဦး",
    "Land Area (units not specified in file)": 3.06,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Rejected",
    "Investor Address":
      "‌မြေကွက်အမှတ် (33/34)၊ မြေတိုင်း ရပ်ကွက် အပိုင်း(25)၊ မက္ခရာ မင်းသား ကြီးလမ်း၊ ရွှေလင်ပန်းစက်မှုဇုံ၊ လှိုင်သာယာ မြို့နယ်။",
    "Organization Address": "",
    "Investment Permitted Address":
      "‌မြေကွက်အမှတ် (33/34)၊ မြေတိုင်း ရပ်ကွက် အပိုင်း(25)၊ မက္ခရာ မင်းသား ကြီးလမ်း၊ ရွှေလင်ပန်းစက်မှုဇုံ၊ လှိုင်သာယာ မြို့နယ်။",
  },
  {
    ID: 2127,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်နန့်သောင်းရင် (ခ) နန့်သဲမေ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "အထက်တန်းအတတ်ပညာ ကုမ္ပဏီလီမိတက် (High Art Company Limited)",
    "Financial Year From": 2006,
    "Financial Year To": 2007,
    "Permit Number": "MaNaTha-669/2006",
    "Permit Date": "2006-07-04T03:47:01Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အသင့်ချုပ်ပြီး ဆံပင်ပုံ ခေါင်းစွပ်(Wigs) အမျိုးမျိုး ထုတ်လုပ် သည့်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 51.99,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 1.211,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "မြေကွက်အမှတ် ၁၁၆၊ ဝက်မစွတ်ဝန်ထောက်လမ်း၊ စက်မှုဇုန် အပိုင်း ၄၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်း။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၁၆၊ ဝက်မစွတ်ဝန်ထောက်လမ်း၊ စက်မှုဇုန် အပိုင်း ၄၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်း။",
  },
  {
    ID: 2129,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor":
      "ညွှန်ကြားရေးမှူးချုပ်၊ စက်မှုကြီးကြပ်ရေးနှင့် စစ်ဆေးရေးဦးစီးဌာန",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "မိုနှင့်ဒိုင်စက်မှုလုပ်ငန်း ကုမ္ပဏီလီမိတက် (Mould & Die Industry Co., Ltd.)",
    "Financial Year From": 2006,
    "Financial Year To": 2007,
    "Permit Number": "MaNaTha-672/2006",
    "Permit Date": "2006-10-12T04:01:17Z",
    "Meeting Number": "22/2006",
    "Meeting Date": "2006-07-07T04:01:38Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "မိုနှင့်ဒိုင်ပုံစံအမျိုးမျိုး ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1285.714,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 1.868,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "၁၉၂၊ ကမ္ဘာအေးဘုရားလမ်း၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(126)၊ တွင်းသင်း တိုက်ဝန် ဦးထွန်းညို လမ်း၊ မြေတိုင်း အမှတ်(64)၊ စက်မှုဇုံ(3) ရွှေပြည်သာမြို့နယ်။ ",
  },
  {
    ID: 2130,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်မို့မို့ခင် (ခ) ဒေါ်ညွန့်ညွန့်ရီ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "‌မြန်မာဆံကေသာ ကုမ္ပဏီလီမိတက် (Myanmar Hair Company Limited)",
    "Financial Year From": 2007,
    "Financial Year To": 2008,
    "Permit Number": "MaNaTha-679/2007",
    "Permit Date": "2007-05-30T04:30:13Z",
    "Meeting Number": "6/2007",
    "Meeting Date": "2007-02-13T04:30:37Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် ဆံပင်တုများ ထုတ်လုပ် သည့်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 90,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 2.33,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၁၅ (အေ)၊ တောင်-မြင်းပြိုင်ကွင်းလမ်း၊ တာမွေမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "CMP စနစ်ဖြင့် ဆံပင်တုများ ထုတ်လုပ် သည့်လုပ်ငန်း",
  },
  {
    ID: 2131,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်သန်းသန်းနွယ်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ခေတ်ဆန်ခြင်း အထည်ချုပ် ကုမ္ပဏီလီမိတက် (Vogue Garment Company Limited)",
    "Financial Year From": 2007,
    "Financial Year To": 2008,
    "Permit Number": "MaNaTha-685/2008",
    "Permit Date": "2008-03-18T04:39:26Z",
    "Meeting Number": "37/2007",
    "Meeting Date": "2007-10-02T04:39:40Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 74,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးချစ်နိုင်၊ ဒေါ်ခင်ခင်အေး",
    "Land Area (units not specified in file)": 0.736,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ဘီ/၂၂၊ ပိတောက်ဝါ ၂ လမ်း၊ FMI City လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်း",
    "Organization Address": "",
    "Investment Permitted Address":
      "ေမြကွက်အမှတ်(၃၂)၊မြေတိုင်းရပ်ကွက်အမှတ်(၄၂)၊ စက်မှုဇုန်ဒေသ၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်း။",
  },
  {
    ID: 2132,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wu Lan",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "B & N Garment (Myanmar) Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "617/2013",
    "Permit Date": "2013-09-09T04:46:55Z",
    "Meeting Number": "22/2013",
    "Meeting Date": "2013-08-21T04:47:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment Under CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U San Gyi Kuu Mar and Daw Cho Cho",
    "Land Area (units not specified in file)": 1.625,
    "Lease Term": 30,
    "Annual Lease Fee": 0.048,
    "Land Use Premium": null,
    "Number Of Local Employees": 700,
    "Number Of Foreign Employees": 6,
    Status: "Monitoring Approved",
    "Investor Address":
      "House 27, Casa Marina Two, 1 Lo Pin Road, Taipo, NT, Hong Kong",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No-14, Ward No-39, Shwe Pyi Thar Industrial Zone-2, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 2133,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကျော်ကျော်စိန်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "အောင်ထက်မြက် ကုမ္ပဏီလီမိတက် (Aung Htet Myat Company Limited)",
    "Financial Year From": 2008,
    "Financial Year To": 2009,
    "Permit Number": "MaNaTha-687",
    "Permit Date": "2008-06-19T04:49:12Z",
    "Meeting Number": "10/2008",
    "Meeting Date": "2008-03-26T04:49:26Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Cycle Tyre နှင့် Car Flap များ၊ ထော်လာဂျီ တာယာများ(၁၄)နှင့် (၁၆) ထုတ်လုပ်ခြင်းလုပ်ငန်းနှင့် လယ်ထွန်စက် တာယာ၊ လယ်ထွန်စက် ရှေ့ဘီး တာယာနှင့် သုံးဘီးနောက်တာယာများ ထုတ်လုပ်ခြင်း လုပ်ငန်း\n\n",
    "Amount Of Foreign Capital USD (in Millions)": 0.21,
    "Total Amount Of Capital (in Millions)": 60,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးမောင်မောင်ဌေး",
    "Land Area (units not specified in file)": 5.089,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၂၉၉၊ ပထမထပ်၊ ပန်းဆိုးတန်းလမ်း၊ ကျောက်တံတားမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(36/37)၊ မြေတိုင်း အမှတ်(65)၊ စက်မှုဇုံ၊ ရွှေပြည်သာ မြို့နယ်။ ",
  },
  {
    ID: 2136,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yeh Chang -Ho",
    "Name of Principal Organization": "Slita PTE., Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Lita Myanmar Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "619/2013",
    "Permit Date": "2013-09-09T05:11:59Z",
    "Meeting Number": "22/2013",
    "Meeting Date": "2013-08-21T05:12:23Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.9,
    "Total Amount Of Capital (in Millions)": 1275,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "U Maung Maung Aye",
    "Land Area (units not specified in file)": 4.032,
    "Lease Term": 10,
    "Annual Lease Fee": 0.084,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 58 Keyuan Road, Ningbo Economic & Technical Development Zoen, Ningbo, Zhejiang, China",
    "Organization Address":
      "Room-8, Burn Road, # 04-04 Trivex, Singapore,369977",
    "Investment Permitted Address":
      "Plot No.51/52, Set Sayar U Tun Street, Shwe Pyi Thar Industrial Zone-4, Shwe Pyi Thar Township, Yangon",
  },
  {
    ID: 2138,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးလင်းကြည်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ကြယ်ညီနောင်စက်မှု ထုတ် လုပ်မှု ကုမ္ပဏီလီမိတက် (Twin Star Manufacturing Company Limited)",
    "Financial Year From": 2008,
    "Financial Year To": 2009,
    "Permit Number": "MaNaTha-698/2009",
    "Permit Date": "2009-01-05T05:28:49Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ဆောက်လုပ်ရေးလုပ်ငန်းသုံး အပေါ့ စား ယန္တရားများ ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.09,
    "Total Amount Of Capital (in Millions)": 95.55,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၁၉၊ ဗိုလ်မြတ်ထွန်းလမ်း၊ ဗိုလ်တထောင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(122 )စက်မှုဇုံ(2)၊ ဒဂုံမြို့သစ် ဆိပ်ကမ်းမြို့နယ်။",
  },
  {
    ID: 2139,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Hirotsugu Kano",
    "Name of Principal Organization": "Asmo Co., Lt.d",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Asmo Myanmar Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "623/2013",
    "Permit Date": "2013-09-16T05:32:05Z",
    "Meeting Number": "23/2013",
    "Meeting Date": "2013-09-04T05:32:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Assembly of Small Motor Parts Used for Automobile on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "U Maung Muung Khin and U Win Maung",
    "Land Area (units not specified in file)": 1.43,
    "Lease Term": 10,
    "Annual Lease Fee": 72,
    "Land Use Premium": null,
    "Number Of Local Employees": 183,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "# 406,4th Floor, Excel Treasure Tower,No.520, Kabaaye Pagoda Road, Bahan Township, Yangon",
    "Organization Address":
      "390 Umeda Kosai-City, Shizuoka-Prefecture 431-0493 Japan",
    "Investment Permitted Address":
      "No. 178, Maung Kyan Tee Street, Shwe Lin Ban Industrial Zone, Hlaing Thar Yar Township, Yangon",
  },
  {
    ID: 2140,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ဇာနည်ရွှေ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "စစ်မှန်သောကြယ် ထုတ်လုပ် ရေး ကုမ္ပဏီလီမိတက် (Real Star Manufacturing Company Limited)",
    "Financial Year From": 2008,
    "Financial Year To": 2009,
    "Permit Number": "MaNaTha-694/2008",
    "Permit Date": "2008-12-02T05:36:19Z",
    "Meeting Number": "17/2008",
    "Meeting Date": "2008-06-20T05:36:57Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 24.35,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 1.21,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "တိုက်အမှတ် ၁၄၊ ရတနာပုံလမ်း၊ လုံးချင်းအိမ်ရာ၊ ချင်းတွင်းရိပ်မွန်၊ ယုဇနဥယျာဉ်မြို့တော်၊ ဒဂုံမြို့သစ်ဆိပ်ကမ်းမြို့နယ်၊ ရန်ကုန်တိုင်း",
    "Organization Address": "",
    "Investment Permitted Address":
      "ေမြကွက်အမှတ်(၂၆)၊ ကနောင်မင်းသားကြီးလမ်း၊ စက်မှုဇုံ(၂)၊ ဒဂုံဆိပ်ကမ်းမြို့နယ်၊ ရန်ကုန်တိုင်း။",
  },
  {
    ID: 2141,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်သူထွန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ထွန်းအပြည်ပြည်ဆိုင်ရာ ထုတ်လုပ်ရေး ကုမ္ပဏီ လီမိတက် (Htun International Manufacturing Company Limited)",
    "Financial Year From": 2008,
    "Financial Year To": 2009,
    "Permit Number": "MaNaTha-697/2008",
    "Permit Date": "2008-12-19T05:43:28Z",
    "Meeting Number": "33/2008",
    "Meeting Date": "2008-10-31T05:43:38Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် နိုင်ငံတကာ အဆင့်မီ ဘိနပ်အမျိုးမျိုး ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.15,
    "Total Amount Of Capital (in Millions)": 11,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအေးသောင်း",
    "Land Area (units not specified in file)": 1.859,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "တိုက်အမှတ် ၃၊ အခန်းအမှတ် ၂၊ အေးရိပ်မွန် ၄ လမ်း၊ လှိုင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "‌ေမြကွက်အမှတ်(၁၉၀-ဘီ)၊ ဆိပ်ကမ်းသာလမ်း၊စက်မှုဇုံ(၁)၊ လှိုင်သာယာမြို့နယ်။",
  },
  {
    ID: 2142,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Jatuphat Tangkaravakoon",
    "Name of Principal Organization": "TOA Paint (Thailand) Co., Ltd.",
    "Place of Incorporation": "Thailand",
    "Company Name In Myanmar": "TOA Paint (Myanmar) Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "625/2013",
    "Permit Date": "2013-09-20T05:54:17Z",
    "Meeting Number": "23/2013",
    "Meeting Date": "2013-09-04T05:54:41Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of all Kinds of Paints",
    "Amount Of Foreign Capital USD (in Millions)": 0.889,
    "Total Amount Of Capital (in Millions)": 1.269,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "U Thant Zin Naing",
    "Land Area (units not specified in file)": 1.546,
    "Lease Term": 50,
    "Annual Lease Fee": 0.056,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "92/55 SOI Nuannoi Kongton-Nua, Wattana District, Bangkok, Thailand",
    "Organization Address":
      "31/2 MOO 3, Bangna-Trad RD. KM-23, Bangsaothong, Bangsaothong District, Samuthprakarn, 10540 Thailand",
    "Investment Permitted Address":
      "No.120, Mahawgani Street, Between Industrial 9th Street and 10th Street, Shwe Pyi Thar Industrial Zone-1, Shwe Pyi Thar, Yangon Region",
  },
  {
    ID: 2143,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးခိုင်ဇော်မြင့်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "လှပသောလှိုင်းများ ကုမ္ပဏီလီမိတက် (Beauty Waves Company Limited)",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "MaNaTha-699/2009",
    "Permit Date": "2009-03-16T06:04:26Z",
    "Meeting Number": "1/2009",
    "Meeting Date": "2009-03-16T06:04:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် ဆံပင်ပုံ ခေါင်းစွပ် (Wigs) အမျိုးမျိုး ထုတ်လုပ်သည့် လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 418,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးခင်ထွေး၊ ဒေါ်မြင့်မြင့်ရီ",
    "Land Area (units not specified in file)": 2.068,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "တိုက်အမှတ် ၇၅၃၊ ဟိုင်းဆင်းဒူးဝါး ၁ လမ်း၊ ၁၁ ရပ်ကွက်၊ ဒဂုံမြို့သစ်အရှေ့ပိုင်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ေမြကွက်အမှတ်(၁၇၆)၊ မြေတိုင်းအမှတ်(၂၅)၊ ‌ေမာင်ကျန်သီးလမ်း၊ ရွှေလင်ပန်း စက်မှုဇုံ၊  လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်း။",
  },
  {
    ID: 2144,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်လဲ့လဲ့ရည်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "အဝတ်တန်ဆာနှင့်တိုးတက် ခြင်းကမ္ဘာ ကုမ္ပဏီလီမိတက် (Garment and Process Global Company Limited)",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "MaNaTha-702/2009",
    "Permit Date": "2009-07-09T06:13:34Z",
    "Meeting Number": "13/2009",
    "Meeting Date": "2009-04-08T06:13:57Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 401.498,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအောင်ထွန်း",
    "Land Area (units not specified in file)": 0.716,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်-စျ၊ ၁၃၆၊ စက္ကဝက် ၅ လမ်း၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ေမြကွက်အမှတ်(၂၂၇/၂၈၄/၂၈၅)၊ မြေတိုင်းအမှတ်(၄၂)၊ ‌စက်မှုဇုံ (၆)လမ်း၊ ",
  },
  {
    ID: 2145,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Natthi Cholsaipant",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Polysack Myanmar Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "626/2013",
    "Permit Date": "2013-09-17T06:13:18Z",
    "Meeting Number": "23/2013",
    "Meeting Date": "2013-09-04T06:14:16Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Plastic Bag on CMP Base ",
    "Amount Of Foreign Capital USD (in Millions)": 2.255,
    "Total Amount Of Capital (in Millions)": 2.3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Nilar Myint ",
    "Land Area (units not specified in file)": 6.254,
    "Lease Term": 50,
    "Annual Lease Fee": 0.156,
    "Land Use Premium": null,
    "Number Of Local Employees": 351,
    "Number Of Foreign Employees": 6,
    Status: "Monitoring Approved",
    "Investor Address":
      "214/1-214/2 Pasicharoen Canal North Side Road, Nongkam, Bangkok 10160, Thailand",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.1, Corner of Kanaung Minthar Gyi Street and Thu Khithar Street, Dadon Seikkan Industrial Zone No.2, Dagon Sekkan Township, Yangon Region",
  },
  {
    ID: 2146,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ဖြူဖြူဝင်း (ခ) ဟုန်ဖေကျင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "မဟာပြည့်စုံအပြည်ပြည် ဆိုင်ရာ ကုမ္ပဏီလီမိတက်  (Great Well International Company Limited)",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "MaNaTha-703/2009",
    "Permit Date": "2009-09-01T06:20:54Z",
    "Meeting Number": "9/2009",
    "Meeting Date": "2009-03-13T06:21:14Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီ ဘိနပ်ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 52,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်ရွှေအိမ်",
    "Land Area (units not specified in file)": 1.516,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၈၈၇၊ ၃ လွှာ၊ ၂ လမ်း၊ ၁ ရပ်ကွက်၊ မရမ်းကုန်းမြို့နယ်၊ ",
    "Organization Address": "",
    "Investment Permitted Address":
      "ေမြကွက်အမှတ်(၉)၊ မြေတိုင်းအမှတ်(၂၅)၊ ရွှေလင်ပန်း စက်မှုဇုံ၊  ‌ပန်းတည်းဝန် ဦးရွှေဘင် လမ်း ၊  လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်း။",
  },
  {
    ID: 2147,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Duong Quy Nam",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Young Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "627/2013",
    "Permit Date": "2013-09-26T06:45:38Z",
    "Meeting Number": "24/2013",
    "Meeting Date": "2013-09-11T06:46:13Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.484,
    "Total Amount Of Capital (in Millions)": 1.484,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "United Kingdom of Great Britain and Northern Ireland",
    "Form Of Investment": "FDII",
    "Land Owner": "U Win Myint @ Gan Sune Sein",
    "Land Area (units not specified in file)": 2.901,
    "Lease Term": 50,
    "Annual Lease Fee": 60,
    "Land Use Premium": null,
    "Number Of Local Employees": 1311,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "Unit-1, Great Cambridge Industrial Estate, Lincoln Road Enfield, Middlesex, En1 1SH, London",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.182/2 & 182/11, Shwe Lin Pan Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2148,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Thanaset Lotharugpong",
    "Name of Principal Organization": "Northstar Manufacturing Co., Ltd.",
    "Place of Incorporation": "Thailand",
    "Company Name In Myanmar": "Sun Apparel Myanmar Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "628/2013",
    "Permit Date": "2013-09-26T07:10:20Z",
    "Meeting Number": "23/2013",
    "Meeting Date": "2013-09-11T07:10:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.8,
    "Total Amount Of Capital (in Millions)": 0.85,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "U Aye Lwin",
    "Land Area (units not specified in file)": 0.896,
    "Lease Term": 50,
    "Annual Lease Fee": 0.025,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.420, Village No.2, MAE TAO SUB-District, MAE SOT District, TAK Province 63110, Thailand",
    "Organization Address":
      "No.420, Village No.2, MAE TAO SUB-District, MAE SOT District, TAK Province 63110, Thailand",
    "Investment Permitted Address":
      "No.87, Hlaing Tharyar Industrial Zone-5, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 2149,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Leung Shiu Hong",
    "Name of Principal Organization": "Hydrodynamic Industrial Co., Ltd.",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar":
      "Hydrodynamic Industrial Industrial (Myanmar) Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "629/2013",
    "Permit Date": "2013-09-26T08:07:24Z",
    "Meeting Number": "24/2013",
    "Meeting Date": "2013-09-11T08:07:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of  Sportswear on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.5,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Khin Maung Tun @ Sae Rat Ahmet",
    "Land Area (units not specified in file)": 2.501,
    "Lease Term": 50,
    "Annual Lease Fee": 0.1,
    "Land Use Premium": null,
    "Number Of Local Employees": 690,
    "Number Of Foreign Employees": 9,
    Status: "Monitoring Approved",
    "Investor Address": "27 E, Block 9, Discovery Park, Tsuen Wan, Hong Kong",
    "Organization Address":
      "2/F, Kwong Fat Hong Building,2-6 Wing Lok Street, Sheung Wan, Hong Kong",
    "Investment Permitted Address":
      "Plot No. 464/B, Myay Taing Quarter No.25, Shwe Lin Ban Industrial Zone, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 2150,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Myat Naing ",
    "Name of Principal Organization": "DEKHINA MANUFACTURING LTD.",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MYANMAR MEGASTEEL INDUSTRIES  LIMITED",
    "Financial Year From": 96,
    "Financial Year To": 97,
    "Permit Number": "221/1996",
    "Permit Date": "1996-10-31T09:13:36Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "PRODUCTION ANS MARKETING OF GALVANIZED IRON SHEETS",
    "Amount Of Foreign Capital USD (in Millions)": 8.9447,
    "Total Amount Of Capital (in Millions)": 55.46,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Amended",
    "Investor Address": "5/1(A) HIGHLAND AVENUE, MAYANGONE TOWNSHIP, YANGON",
    "Organization Address":
      "B-3/ R-3 HTEETAN HOUSING ESTATE, KYEEMYINDINE TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "PLOT NO. 53, 54 & 55, HLAING THAR YAR INDUSTRIAL ZONE, YANGON REGION",
  },
  {
    ID: 2151,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wu, Shou-An",
    "Name of Principal Organization": "Ta Han Investment Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Ta Han Food Industrial Company Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "586/2013",
    "Permit Date": "2013-05-29T03:40:38Z",
    "Meeting Number": "15/2013",
    "Meeting Date": "2013-05-22T05:04:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Instant Noodles",
    "Amount Of Foreign Capital USD (in Millions)": 1.92,
    "Total Amount Of Capital (in Millions)": 2.4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Thanda Soe",
    "Land Area (units not specified in file)": null,
    "Lease Term": 30,
    "Annual Lease Fee": 0.106,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "3 Kismis Green, Singapore 596235",
    "Organization Address": "3 Kismis Green, Singapore 596235",
    "Investment Permitted Address":
      "Plot No. 6 & 7, Kyan Sit Thar Yeik Mon Industrial Zone, South Dagon Myo Thit, Yangon Region",
  },
  {
    ID: 2152,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Wiseman Hsu",
    "Name of Principal Organization":
      "Great China Investment Enterprise Holding Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Myanmar Asia Optical International Co.,Ltd.",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "432/2009",
    "Permit Date": "2009-07-28T03:32:53Z",
    "Meeting Number": "17/2009",
    "Meeting Date": "2009-05-20T04:01:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufactruing All Kinds of Lens, Lens Units ,Optical Apparatuses, Electronic Apparatuses and other Apparatuses on CMP Basis for Factory No.(2)",
    "Amount Of Foreign Capital USD (in Millions)": 6,
    "Total Amount Of Capital (in Millions)": 6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": 13751.83,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "605/99, City Village, Bangpoo Industry Zone , Samutprakarn,Thailand.",
    "Organization Address":
      "2/F Continental Electric Bldg,17, Wang Chiu Road, Kin Bay Kowloon ,Hong Kong.",
    "Investment Permitted Address":
      "Plot No.D-3, Mingaladon Industrial Park,Mingaladon Township, Yangon.",
  },
  {
    ID: 2154,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Khin Maung Latt",
    "Name of Principal Organization": "Myanma Economic Holdings Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Myanmar Inno International Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "575/2013",
    "Permit Date": "2013-07-12T04:42:14Z",
    "Meeting Number": "17/2013",
    "Meeting Date": "2013-06-29T04:43:10Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.5,
    "Total Amount Of Capital (in Millions)": 4.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "JV",
    "Land Owner": "Myanma Economic Holdings Limited",
    "Land Area (units not specified in file)": 11.298,
    "Lease Term": 30,
    "Annual Lease Fee": 0.228,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.189/191, Mahabandoola Road, Botataung Township, Yangon Region",
    "Organization Address":
      "No.189/191, Mahabandoola Road, Botataung Township, Yangon Region",
    "Investment Permitted Address":
      "19 1/2 Mile, Pyay Road, Pyinmabin Industrial Estate, Mingaladon Township, Yangon Region",
  },
  {
    ID: 2155,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lin, Chai-Hsiung",
    "Name of Principal Organization": "Yuyuan Trading Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Zuyuan EDenweiss Sanwa Industry Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "680/2014",
    "Permit Date": "2014-03-14T06:01:17Z",
    "Meeting Number": "6/2014",
    "Meeting Date": "2014-02-13T06:01:58Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Knitted Wear on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.5946,
    "Total Amount Of Capital (in Millions)": 2.5946,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Tin Zar Zar Oo and U Swe Myint",
    "Land Area (units not specified in file)": 1.1,
    "Lease Term": 30,
    "Annual Lease Fee": 0.024,
    "Land Use Premium": null,
    "Number Of Local Employees": 1000,
    "Number Of Foreign Employees": 12,
    Status: "Monitoring Approved",
    "Investor Address":
      "Room 905-906,9/F, Office Tower, Hutchison Logistics Centre, 18 Container Port Road South, Kwai Chung, N.T., Hong Kong",
    "Organization Address":
      "Room 905-906,9/F, Office Tower, Hutchison Logistics Centre, 18 Container Port Road South, Kwai Chung, N.T., Hong Kong",
    "Investment Permitted Address":
      "Plot No.83, De Pae Yinn Wun Htauk U Myel Street, Industrial Zone-2, Hlaing Tharyar Township, Yangon",
  },
  {
    ID: 2156,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Fong Wai Man",
    "Name of Principal Organization": "Oli-Tex Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Oli-Tex Myanmar Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "683/2014",
    "Permit Date": "2014-03-12T06:32:22Z",
    "Meeting Number": "6/2014",
    "Meeting Date": "2014-02-13T06:32:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် ထိုင်ခုံစွပ်၊ ကလေးအသုံးအဆောင် ထည့်သည့်အိတ်များ၊ ဂေါက်ရိုက်အိတ်များ၊ တောင် တက်အင်္ကျီ၊ ကိရိယာတန်ဆာပလာထည့်သည့်အိတ် နှင့် အိတ်အမျိုးမျိုး ချုပ်လုပ်တွဲစပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.768,
    "Total Amount Of Capital (in Millions)": 1.768,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Tin Maung Latt",
    "Land Area (units not specified in file)": 2.258,
    "Lease Term": 30,
    "Annual Lease Fee": 0.047,
    "Land Use Premium": null,
    "Number Of Local Employees": 300,
    "Number Of Foreign Employees": 15,
    Status: "Monitoring Approved",
    "Investor Address": "Flat 4B, 12 Shipyard Lane, Quarry Bay, Hong Kong",
    "Organization Address": "Flat 4B, 12 Shipyard Lane, Quarry Bay, Hong Kong",
    "Investment Permitted Address":
      "Plot No.48, Myay Taing Block No.65, Set Sayar U Tun Street, Shwe Pyithar Industrial Zone-4, Shwe Pyithar Township, Yangon Region",
  },
  {
    ID: 2157,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr. Markson Tang Wee Guan ",
    "Name of Principal Organization":
      "TIGER INFRASTRUCTURE PTE. LTD., , 64 SYED ALWI ROAD # 02-01, SINGAPORE  207643",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar":
      "TIGER  INFRASTRUCTURE   MYANMAR (TIM) COMPANY  LIMITED ",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "121/2018",
    "Permit Date": "2018-11-08T07:07:30Z",
    "Meeting Number": "18/2017",
    "Meeting Date": "2018-11-02T07:07:56Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Construction, leasing and maintenance of telecommunication towers, providing services and power system  ",
    "Amount Of Foreign Capital USD (in Millions)": 171,
    "Total Amount Of Capital (in Millions)": 171.79,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 14,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "221 QUEENSWAY # 04 - 01 VIZ HOLLAND SINGAPORE  276750",
    "Organization Address": " 64 SYED ALWI ROAD # 02-01, SINGAPORE  207643",
    "Investment Permitted Address":
      "Room No. 8/A, 7 Floor, No. 23/25m/27, Phone Gyi Street, Lanmadaw Tsp, Yangon ",
  },
  {
    ID: 2158,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Nobuyuki Miyazaki",
    "Name of Principal Organization": "Inflight Precision Industries Ltd.",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "IIDA Electronics (Myanmar) Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "686/2014",
    "Permit Date": "2014-03-13T07:53:13Z",
    "Meeting Number": "6/2014",
    "Meeting Date": "2014-02-13T07:53:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Electrical Components and PCB Units",
    "Amount Of Foreign Capital USD (in Millions)": 16.97,
    "Total Amount Of Capital (in Millions)": 16.97,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 36,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Mingaladon Industrial Park Co., Ltd.",
    "Land Area (units not specified in file)": 7.412,
    "Lease Term": 36,
    "Annual Lease Fee": 0.008,
    "Land Use Premium": null,
    "Number Of Local Employees": 34,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "Room 112,4-46-11, Ikebukuro Honmachi, Toshima Ku, Tokyo, Japan",
    "Organization Address":
      "Unit B,5/F, Goldlion Holdings Centre,13-15 Yuen, Shun Circuit, Shatin N.T, Hong Kong",
    "Investment Permitted Address":
      "Plot No.B-3, Mingaladon Industrial Park, Mingaladon Township, Yangon Region",
  },
  {
    ID: 2159,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U ZAW MYNN   ",
    "Name of Principal Organization":
      "ELITE      TELECOM     PUBLIC COMPANY LIMITED,NO.A/9, MINDAMA STREET, MAYANGONE   TOWNSHIP,  YANGON    ",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "STREAM   NET   COMPANY  LIMITED ",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "112/2018",
    "Permit Date": "2018-09-15T07:53:18Z",
    "Meeting Number": "15/2018",
    "Meeting Date": "2018-10-15T07:53:45Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "telecommunications  service (DWDM backbone, metro transmission, domestic bandwidth wholesales, mobile backhaul network, ISP service, wireless broadband, FTTx, VOIP, domain registration, web design, hosting duct, trenches, poles and dark fibre and satellite broadband internet service)",
    "Amount Of Foreign Capital USD (in Millions)": 29.55,
    "Total Amount Of Capital (in Millions)": 44.11,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 13,
    "Investing Country": "Vietnam",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Poe The",
    "Land Area (units not specified in file)": 255.48,
    "Lease Term": 5,
    "Annual Lease Fee": 0.012,
    "Land Use Premium": null,
    "Number Of Local Employees": 148,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "NO.8, BAWDI YEIK THAR STREET, SHWE TAUNG GYAR WARD (2), BAHAN TOWNSHIP, YANGON ",
    "Organization Address":
      "NO.A/9, MINDAMA STREET, MAYANGONE   TOWNSHIP,  YANGON    ",
    "Investment Permitted Address":
      "NO. A/9, 1ST FLOOR, SHWEGABAR HOUSING COMPLEX,  MINDAMA STREET, MAYANGONE TOWNSHIP, YANGON   REGION ",
  },
  {
    ID: 2162,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "WONG SEK ONN",
    "Name of Principal Organization": "AUSTRAL AMALGAMATED BERHAD ",
    "Place of Incorporation": "MALAYSIA",
    "Company Name In Myanmar": "MYANMAR MILLION QUEST PRIVATE LIMITED",
    "Financial Year From": 96,
    "Financial Year To": 97,
    "Permit Number": "222/96",
    "Permit Date": "1996-10-31T08:42:21Z",
    "Meeting Number": "15-1996",
    "Meeting Date": "1996-10-11T08:42:47Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "PRODUCTION AND MARKETING OF CHILDERN'S WEAR, CASUAL WEAR, JEANS",
    "Amount Of Foreign Capital USD (in Millions)": 5,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Malaysia",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "SUITE 24-01 WISMA CYCLECARRT 288 JALAN RAJA LAUT KUALA LUMPUR 50350, MALAYSIA",
    "Organization Address":
      "24-01 WISMA CYCLECARRT 288 JALAN RAJA LAUT KUALA LUMPUR 50350, MALAYSIA",
    "Investment Permitted Address":
      "PYIN MA BIN INDUSTRIAL COMPLEX, MINGALARDON TOWNSHIP",
  },
  {
    ID: 2163,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yasutaka Nishioka, ",
    "Name of Principal Organization":
      "SCIENCE AND TECHNOLOGY ADVISORY GROUP (MYANMAR) LTD.",
    "Place of Incorporation": "MYANMAR",
    "Company Name In Myanmar": "Mycare Unicharm Co.,Ltd.",
    "Financial Year From": 96,
    "Financial Year To": 97,
    "Permit Number": "225/96",
    "Permit Date": "1996-11-08T09:38:35Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF LADIES SANITARY NAPKINS, FACIAL ISSUES AND OTHER PAPER MADE TISSUES AS BABY DIAPERS IN CONTINENT PADS, TOWEL AND NAPKIN, TOILET TISSUES",
    "Amount Of Foreign Capital USD (in Millions)": 3.75,
    "Total Amount Of Capital (in Millions)": 30.2,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Amend",
    "Investor Address": "7C Leehouse 275,Thonglor 10 Sukhumvit 55 Bangkok",
    "Organization Address": "NO.4(A) PYAY ROAD, HLAING TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "PLOT NO. 2/45, HLAING THAR YAR INDUSTRIAL ZONE,  HLAING THAR YAR TOWNSHIP, YANGON",
  },
  {
    ID: 2164,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Cao Haidong",
    "Name of Principal Organization": "Dong Fang Star Garment Factory Ltd.",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Nexstar Garment Manufacturing Company Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "593/2013",
    "Permit Date": "2013-07-12T10:19:58Z",
    "Meeting Number": "17/2013",
    "Meeting Date": "2013-06-29T10:20:22Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing and Marketing of Garment",
    "Amount Of Foreign Capital USD (in Millions)": 1.5,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Thurein Aung",
    "Land Area (units not specified in file)": 1.991,
    "Lease Term": 20,
    "Annual Lease Fee": 0.105,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Amend",
    "Investor Address":
      "6-303, Yihe Garden, Nantong, Jiansu, People's Republic of China",
    "Organization Address":
      "No. 409, Changjiang Road, Nantong City, People's Republic of China",
    "Investment Permitted Address":
      "Plot No. 127/131, Than Chet Wun U Nyunt Road, Hlaing Thar Yar Industrial Zone (1), Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2165,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Dej Pathanasethpong",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Thong Thai Textile (Myanmar) Company Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "676/2014",
    "Permit Date": "2014-03-12T10:34:37Z",
    "Meeting Number": "5/2014",
    "Meeting Date": "2014-02-02T10:34:55Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3.394,
    "Total Amount Of Capital (in Millions)": 3.394,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Thailand",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": 20,
    "Annual Lease Fee": 0.12,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Rejected",
    "Investor Address":
      "36/42-43, Soi Kasaemsani, Wangmai Patumwan Bangkok, 10330 Thailand",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 175, Pan Be Kaung Mg Khet Street, Hlaing Thar Yar Industrial Zone 1, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2166,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Heo Junghoon",
    "Name of Principal Organization": "Icregem Corporation",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "Icregem International Company Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "677/2014",
    "Permit Date": "2014-03-03T10:41:09Z",
    "Meeting Number": "5/2014",
    "Meeting Date": "2014-02-05T10:41:36Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.6382,
    "Total Amount Of Capital (in Millions)": 0.6382,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaw Khin",
    "Land Area (units not specified in file)": 1.527,
    "Lease Term": 30,
    "Annual Lease Fee": 0.033,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "# 109-102, Seogang Ssangyong Yega APt., Changjeong- Dong, Mapo-Gu, Seoul, Republic of Korea",
    "Organization Address":
      "Sindang-Dong, 202, Oldies B/D, Sindang-Dong, 122, Cheonggu-Ro, Jung-Gu, Seoul, Republic of Korea",
    "Investment Permitted Address":
      "Plot No. F-5, Myay Taing Block No. 20, Anawrahta Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2167,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhou Boping",
    "Name of Principal Organization": "Nantong Mengsheng Shoes Co., Ltd. ",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Yuan Rong Shoes Company Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "587/2013",
    "Permit Date": "2013-06-24T10:50:06Z",
    "Meeting Number": "16/2013",
    "Meeting Date": "2013-06-12T10:50:25Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Indoor Shoes",
    "Amount Of Foreign Capital USD (in Millions)": 1.5,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Hla Thein",
    "Land Area (units not specified in file)": 1.68,
    "Lease Term": 20,
    "Annual Lease Fee": 0.105,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "Suite 4, 16 Li Dun Village, Tong Zhou, Nantong, Jiangsu, The People's Republic of China",
    "Organization Address":
      "Group 11, Haihong Village, Guanyinshan Town, The People's Republic of China",
    "Investment Permitted Address":
      "Plot No. 138, Hlaing Thar Yar Industrial Zone 2, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2168,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lim Byong Hong",
    "Name of Principal Organization": "MPI Korea Co., Ltd.",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar":
      "Myanmar Pyone Pan Tayar Industry Company Limited",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "498/2012",
    "Permit Date": "2012-08-31T10:57:05Z",
    "Meeting Number": "26/2012",
    "Meeting Date": "2012-08-22T10:57:22Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.514,
    "Total Amount Of Capital (in Millions)": 0.514,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": 0.826,
    "Lease Term": 30,
    "Annual Lease Fee": 0.021,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Han Sin Apartment 103, No. 304, Sosa Bon 3- Dong Sosa Gu Bunchun-Si Gyeong Gi-Do",
    "Organization Address":
      "4 F, 3, Jowon-Ro 18-Gil, Gwanak-Gu, Seoul, Republic of Korea",
    "Investment Permitted Address":
      "Plot No. 23, No.150(B), Industrial Zone, South Dagon Myothit Township, Yangon Region",
  },
  {
    ID: 2169,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Seung Ho Jung",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Bright Juan Company Limited",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "500/2012",
    "Permit Date": "2012-09-17T11:03:24Z",
    "Meeting Number": "28/2012",
    "Meeting Date": "2012-09-05T11:03:40Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.797,
    "Total Amount Of Capital (in Millions)": 0.797,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": 1.208,
    "Lease Term": 15,
    "Annual Lease Fee": 0.026,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Gae Jeung 1 Dong Han Saem Sanga # 402 Sahagu Pusan, Republic of Korea",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 494,495, Ward No. 23, Mogoke Street, ndustrial Zone 1, Dagon Myothit (South) Township, Yangon Region",
  },
  {
    ID: 2170,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Jong Kee Rhee",
    "Name of Principal Organization": "Sang Young & Co., Ltd.",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "Beauty Waves Company Limited",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "501/2012",
    "Permit Date": "2012-09-14T03:43:41Z",
    "Meeting Number": "28/2012",
    "Meeting Date": "2012-09-05T03:44:11Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production & Marketing of Wigs on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.512,
    "Total Amount Of Capital (in Millions)": 0.512,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Khin Htwe, Daw Myint Myint Yee",
    "Land Area (units not specified in file)": 2.068,
    "Lease Term": 30,
    "Annual Lease Fee": 0.041,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Hyundai Superville, B-2601, Seocho Dong 1446-11, Seocho-Gu, Seoul, Republic of Korea",
    "Organization Address":
      "Sang Young Bldg, Third Floor, 58-6 Panpo 4-Dong, Seocho-Gu, Seoul, Republic of Korea",
    "Investment Permitted Address":
      "Plot No. 176, Ward 25, Maung Kyan Thee Street, Shwe Lin Ban Industrial Zone, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 2171,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Chien, Chi-Jean",
    "Name of Principal Organization":
      "Rui Seng Optronic Technology (Shanghai) Co., Ltd.",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Luxen International Limited",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "502/2012",
    "Permit Date": "2012-09-23T04:02:41Z",
    "Meeting Number": "28/2012",
    "Meeting Date": "2012-09-05T04:02:58Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Fish-Hook on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.906,
    "Total Amount Of Capital (in Millions)": 2.906,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 36,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": 3.58,
    "Lease Term": 36,
    "Annual Lease Fee": 0.0043,
    "Land Use Premium": 463003.2,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No.9, Lane 369, Sec.3, Ta-Taung Road, Hsi-Chih, Taipei, Taiwan, People's Republic of China (PRC)",
    "Organization Address":
      "No. 2168, Xiangjiang Road, Huang Du, Jia Ding, Shanghai, PRC 2501804",
    "Investment Permitted Address":
      "Plot No. D-10, Mingaladon Industrial Park, Mingaladon Township, Yangon Region",
  },
  {
    ID: 2172,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kim Tae Hoon",
    "Name of Principal Organization": "C & N Apparel  Co., Ltd.",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "Myanmar C & N Company Limited",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "503/2012",
    "Permit Date": "2012-09-14T04:11:39Z",
    "Meeting Number": "29/2012",
    "Meeting Date": "2012-09-10T04:11:56Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Printed Apparel Production on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.662,
    "Total Amount Of Capital (in Millions)": 0.662,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Moe Win Maung",
    "Land Area (units not specified in file)": 1.374,
    "Lease Term": 30,
    "Annual Lease Fee": 0.03,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "#101-1204, Yangwoo Apartment, Yangji-Dong, Sungnam-City, Republic of Korea",
    "Organization Address":
      "566-25, Janghang-Dong, Ilsan-Gu, Goyang-Si, Gyeonggi-Do, Republic of Korea",
    "Investment Permitted Address":
      "No. 41-42, Shwe Yin Aye Kyaung Street, Industry Zone 5, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 2173,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Laurent Scheercousse",
    "Name of Principal Organization": "Red  INK Ltd.",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Myanmar Peltier Bois Ltd.",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "455/2011",
    "Permit Date": "2011-01-28T06:38:02Z",
    "Meeting Number": "28/2010",
    "Meeting Date": "2010-08-13T06:38:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production Maintenance , Major Repairs and Upgrading of Motor Boat , Sail Boat, Caravan and Bungalow, In Full or Spare Parts on CMP Basis For Factory No.(2).",
    "Amount Of Foreign Capital USD (in Millions)": 3,
    "Total Amount Of Capital (in Millions)": 3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 24,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Red Ink Ltd.",
    "Land Area (units not specified in file)": 500,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No.33(B), Thiri Mingalar Lane ,Kone Myint , Yeiktha, 7 Mils, Mayangone Township, Yangon ,",
    "Organization Address":
      "Suite 1.3-16th Floor, Kinwick Center -32 Hollywood Road, Hong Kong",
    "Investment Permitted Address":
      "Water Wood-Based Industrial Estate, Shwepyithar Township, Yangon",
  },
  {
    ID: 2174,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Lee Hae Ryong",
    "Name of Principal Organization": "Inlay Ltd.",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "Myanmar DYC Co.,Ltd",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "458/2011",
    "Permit Date": "2011-02-04T07:48:47Z",
    "Meeting Number": "43/2010",
    "Meeting Date": "2010-12-24T07:49:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Shoes and Its Parts on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 10,
    "Total Amount Of Capital (in Millions)": 10,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 37,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": 13502702,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Daedong APT # 507-604,1288,JWA -DONG, Haeundate-Gu,Busan, Republic of Korea",
    "Organization Address":
      "1486,Banyeo-Dong, Haeundae -Gu ,Busan, Republic of Korea",
    "Investment Permitted Address":
      "Plot No.C5, and C-6, Mingaladon Industrial Park, Mingaladon Township,Yangon",
  },
  {
    ID: 2175,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Jiang,Lu",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Green Start Energy Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "097/2018",
    "Permit Date": "2018-11-30T08:20:44Z",
    "Meeting Number": "15/2018",
    "Meeting Date": "2018-11-17T08:21:10Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of Solar Products On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.595,
    "Total Amount Of Capital (in Millions)": 0.595,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaw San Lwin",
    "Land Area (units not specified in file)": 2,
    "Lease Term": 5,
    "Annual Lease Fee": 42,
    "Land Use Premium": null,
    "Number Of Local Employees": 89,
    "Number Of Foreign Employees": 23,
    Status: "Draft",
    "Investor Address":
      "Dudu Motain No.1, No 1604, Office Building Guandu District, Kunming City, Yunnan Province, People Republic's Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.63, Myay Taing Block Zone(1), Dagon Seit Kan Township, Yangon Region",
  },
  {
    ID: 2176,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": " MANAGING DIRECTOR, MYANMA AGRICULTURE SERVICE",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MARS INTERNATIONAL CO., LTD.",
    "Financial Year From": 96,
    "Financial Year To": 97,
    "Permit Number": "227/96",
    "Permit Date": "1996-11-29T08:33:04Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Mosquito Coil and Household Insecticides",
    "Amount Of Foreign Capital USD (in Millions)": 1.08,
    "Total Amount Of Capital (in Millions)": 10.8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "AGRICULTURE LANE, KANBE, YANKIN TOWNSHIP, YANGON",
    "Organization Address": "",
    "Investment Permitted Address": "NWE GWAY, MINGALADON TOWNSHIP, YANGON",
  },
  {
    ID: 2177,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ooi Cheng Phoe",
    "Name of Principal Organization": "Foster Electric (S) Pte. Ltd. ",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Myanmar Foster Electric Company Limited",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "489/2012",
    "Permit Date": "2012-07-18T08:35:29Z",
    "Meeting Number": "18/2012",
    "Meeting Date": "2012-06-27T08:35:46Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Acoustic Devices on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 27.573,
    "Total Amount Of Capital (in Millions)": 27.573,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": 4.391,
    "Lease Term": 30,
    "Annual Lease Fee": 0.06,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "159, Kampong Ampat, # 03-01/02 KA Place, Singapore 368328",
    "Organization Address":
      "159, Kampong Ampat, # 03-01/02 KA Place, Singapore 368328",
    "Investment Permitted Address":
      "Plot No. 475/D, South Dagon Industrial Zone, South Dagon Township, Yangon Region",
  },
  {
    ID: 2178,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U THEIN TUN",
    "Name of Principal Organization": "MYANMA GOLDEN STAR CO., LTD.",
    "Place of Incorporation": "YANGON",
    "Company Name In Myanmar": "MYANMA STEEL INDUSTRIES CO., LTD.",
    "Financial Year From": 96,
    "Financial Year To": 97,
    "Permit Number": "228/96",
    "Permit Date": "1996-11-29T08:38:49Z",
    "Meeting Number": "16/96",
    "Meeting Date": "1996-10-25T08:45:41Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF GALVANISED IRON SHEETS AND RELATED PRODUCTS",
    "Amount Of Foreign Capital USD (in Millions)": 3.752,
    "Total Amount Of Capital (in Millions)": 30.391,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 15,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "LIVESTOCK, FEEDSTUFF AND MILK PRODUCTS ENTERPRISE",
    "Land Area (units not specified in file)": null,
    "Lease Term": 25,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "NO.292, AHLONE ROAD, DAGON TOWNSHIP, YANGON",
    "Organization Address":
      "BUILDING 7/8 BAHOSI YEIKTHA, BOGYOKE AUNG SAN STREET, LANMADAW TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "PLOT NO. 66, SHWE PYI THA TOWNSHIP, YANGON DIVISON",
  },
  {
    ID: 2179,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Shin Hyeong Subp",
    "Name of Principal Organization": "Daekwang International Co.,Ltd",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "Daekwang International Co.,Ltd.",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "459/2011",
    "Permit Date": "2011-02-04T08:40:02Z",
    "Meeting Number": "32/2010",
    "Meeting Date": "2010-09-24T08:40:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Production of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.111,
    "Total Amount Of Capital (in Millions)": 1.111,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "Department of Human Settlement and Housing Development",
    "Land Area (units not specified in file)": 1.429,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.201, 2F 134-1, Songpa-Dong, Songpa-Gu Seoul,Republic of Korea",
    "Organization Address":
      "No.201,2F 134-1 Songpa-Dong, Songpa-Gu Seoul , Pepublic of Korea",
    "Investment Permitted Address":
      "Plot No.213, 214,215,222,223,224, Shwe Paukkan Industrial Quarter,North Okkalapa Township,Yangon",
  },
  {
    ID: 2180,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Le Toan",
    "Name of Principal Organization":
      "Anh Sao Viet (ASV) Pharmaceutical Corporation",
    "Place of Incorporation": "Vietnam",
    "Company Name In Myanmar": "Anh Sao Viet(ASV) Pharma Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "490/2012",
    "Permit Date": "2012-07-31T08:43:41Z",
    "Meeting Number": "18/2012",
    "Meeting Date": "2012-06-27T08:43:57Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Medicine, Drugs, Pharmaceutical Supplement, Health and Personal Care Products",
    "Amount Of Foreign Capital USD (in Millions)": 20,
    "Total Amount Of Capital (in Millions)": 20,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Vietnam",
    "Form Of Investment": "JV",
    "Land Owner": "U Zay Thiha",
    "Land Area (units not specified in file)": null,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "2, Tran Cao Van Street, Dakao Ward District 1, Ho Chi Minh City, Vietnam",
    "Organization Address":
      "C4 Buu Long Street, Ward 15 District 10, Ho Chi Minh City, VIetnam",
    "Investment Permitted Address":
      "No.1, Mingaladon |Garden City, No.3 Highway, Yangon Industrial Park, Yangon Region",
  },
  {
    ID: 2181,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. KUNIO YOSHIKAWA",
    "Name of Principal Organization": "ARAGANTOYS (MALAYSIA) SDN.BHD.,",
    "Place of Incorporation": "MALAYSIA",
    "Company Name In Myanmar": "MYANMAR ARAGAN TOYS COMPANY LIMITED",
    "Financial Year From": 96,
    "Financial Year To": 97,
    "Permit Number": "235/96",
    "Permit Date": "1996-12-11T08:53:01Z",
    "Meeting Number": "18/96",
    "Meeting Date": "1996-11-29T08:57:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF STUFFED AND DOLLS",
    "Amount Of Foreign Capital USD (in Millions)": 0.6,
    "Total Amount Of Capital (in Millions)": 0.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Malaysia",
    "Form Of Investment": "FDII",
    "Land Owner": "PUBLIC WORDS ",
    "Land Area (units not specified in file)": null,
    "Lease Term": 10,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "6-17-9, HOGASHIOGU, ARAKAWA-KU, TOKYO, JAPAN",
    "Organization Address": "MALAYSIA",
    "Investment Permitted Address":
      "NO. 15, SOUTH OKKALAPA, PUBLIC WORKS COMPOUND",
  },
  {
    ID: 2182,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Sung Min Kim",
    "Name of Principal Organization": "Kevin House",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "S.M.K Garment Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "496/2012",
    "Permit Date": "2012-08-28T09:00:11Z",
    "Meeting Number": "26/2012",
    "Meeting Date": "2012-08-22T08:59:50Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.4,
    "Total Amount Of Capital (in Millions)": 1.4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": 2.102,
    "Lease Term": 30,
    "Annual Lease Fee": 0.035,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "302-122, Hannam The Hill, 810, Hannam-Dong Yongsan-Ku, Seoul, Republic of Korea",
    "Organization Address":
      " 363-16, Gwacheon-Dong, Gwacheon City, Gyonggi-Do, Republic of Korea",
    "Investment Permitted Address":
      "Plot No. 104, Mingyi Mahar Ming Gaung Street, Wrad No. 14,  Shwethanlwin Industiral Zone, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 2183,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kim Kee Sang",
    "Name of Principal Organization": "Woo Il Co., Ltd.",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "Universal Apparel Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "497/2012",
    "Permit Date": "2012-08-31T09:10:16Z",
    "Meeting Number": "26/2012",
    "Meeting Date": "2012-08-22T09:10:32Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.935,
    "Total Amount Of Capital (in Millions)": 1.935,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": 2.778,
    "Lease Term": 30,
    "Annual Lease Fee": 0.061,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Mok-Dong APT 306-704, 903 Mok-Dong, Yangchun-Ku, Seoul, Korea",
    "Organization Address":
      "Seho 402, 667-3, Deungchon-Dong, Gangseo-Gu, Seoul, Republic of Korea",
    "Investment Permitted Address":
      "Plot No. 24, No.6, Ngwe Pin Lae Marine Industrial Zone, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 2184,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U WIN AUNG",
    "Name of Principal Organization": "DAGON INTERNATIONAL LTD.",
    "Place of Incorporation": "MYANMAR",
    "Company Name In Myanmar": "DAGON STEEL LIMITED",
    "Financial Year From": 96,
    "Financial Year To": 97,
    "Permit Number": "237/96",
    "Permit Date": "1996-12-18T09:11:23Z",
    "Meeting Number": "18/96",
    "Meeting Date": "1996-11-29T09:11:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "PRODUCTION AND MARKETING OF GALVANIZED STEEL SHEETS ",
    "Amount Of Foreign Capital USD (in Millions)": 7.8,
    "Total Amount Of Capital (in Millions)": 54,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "DEPARTMENT OF HUMAN SETTLEMENT AND HOUSING DEVELOPMENT",
    "Land Area (units not specified in file)": null,
    "Lease Term": 25,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "121, F SULE PAGODA ROAD, KYAUKTADA TOWNSHIP, YANGON",
    "Organization Address":
      "121, F SULE PAGODA ROAD, KYAUKTADA TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "PLOT NO. 50 B, PLOT NO. 51, HLAING THAR YAR INDUSTRIAL ZONE PART-3, YANGON",
  },
  {
    ID: 2185,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Managing Director, Myanma Textile Industries",
    "Name of Principal Organization": "Myanma Textile Industries",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "Yangon Knit Garment Manufacturing Company Limited",
    "Financial Year From": 1992,
    "Financial Year To": 1993,
    "Permit Number": "065/93",
    "Permit Date": "1993-01-05T09:17:45Z",
    "Meeting Number": "19/97",
    "Meeting Date": "1997-11-21T06:37:14Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Knitted Garment and Other Garments",
    "Amount Of Foreign Capital USD (in Millions)": 0.85,
    "Total Amount Of Capital (in Millions)": 10.068,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 90,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "192, Kaba Aye Pagod Road, Bahan Township, Yangon",
    "Organization Address": "192, Kaba Aye Pagod Road, Bahan Township, Yangon",
    "Investment Permitted Address": "Insein Township, Yangon",
  },
  {
    ID: 2186,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Managing Director, Myanma Textile Industries",
    "Name of Principal Organization": "Myanma Textile Industries",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Myanmar Euroworld International Limited",
    "Financial Year From": 1992,
    "Financial Year To": 1993,
    "Permit Number": "092/93",
    "Permit Date": "1993-12-22T09:34:43Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production and Marketing of Knit Shirts, Jackets and Other Garments",
    "Amount Of Foreign Capital USD (in Millions)": 1.3,
    "Total Amount Of Capital (in Millions)": 15.86,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 90,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "192, Kaba Aye Pagoda Road, Bahan Township, Yangon",
    "Organization Address": "192, Kaba Aye Pagoda Road, Bahan Township, Yangon",
    "Investment Permitted Address": "Insein Township, Yangon Region",
  },
  {
    ID: 2187,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Dong Gil Shin",
    "Name of Principal Organization": "Global Yes Co., Ltd.",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "Myanmar Ha Hae Co., Ltd. ",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "295/97",
    "Permit Date": "1997-11-28T09:43:54Z",
    "Meeting Number": "18/97",
    "Meeting Date": "1997-11-07T09:44:29Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Textile Garments",
    "Amount Of Foreign Capital USD (in Millions)": 7,
    "Total Amount Of Capital (in Millions)": 44.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "104-606/58 Chul San-Dong, Kwang Myung City, Republic of Korea",
    "Organization Address": "Seoul, Korea",
    "Investment Permitted Address":
      "Plot No. 91, South Dagon Industrial Zone Part, Yangon Region",
  },
  {
    ID: 2188,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chang Ho Lee",
    "Name of Principal Organization": "Pan-Pacific Trading Co., Ltd.",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar":
      "Yangon Pan-Pacific International Company Limited",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "296/97",
    "Permit Date": "1997-11-28T09:52:54Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments",
    "Amount Of Foreign Capital USD (in Millions)": 3.2,
    "Total Amount Of Capital (in Millions)": 3.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Amend",
    "Investor Address":
      "Hyundai Apartment 11-704, Moon Jeong-Dong, Songpa-Ku, Seoul, Korea",
    "Organization Address": "1127-35, Kuro-Dong, Kuro-Kum, Seoul, Korea",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁/ခ၊ မြေတိုင်းရပ်ကွက်အမှတ်-၂၉၊ သု၀ဏ္ဏ၊ သင်္ဃန်းကျွန်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး။",
  },
  {
    ID: 2189,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yen Wen Hwa",
    "Name of Principal Organization": "New Toyo Corrugated Products Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "New Asia Industry (Yangon) Private Ltd.",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "297/97",
    "Permit Date": "1997-12-08T09:58:01Z",
    "Meeting Number": "18/97",
    "Meeting Date": "1997-11-07T09:58:52Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production of Corrugated Carton Boxes & Cement Bags",
    "Amount Of Foreign Capital USD (in Millions)": 5.3,
    "Total Amount Of Capital (in Millions)": 5.3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 10,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "32 Senoko Road, Singapore 758104",
    "Organization Address": "Singapore",
    "Investment Permitted Address":
      "Plot No. B-3, Mingaladon Industrial Park, Mingaladon Township, Yangon Region",
  },
  {
    ID: 2190,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Dr. Daw Khin Ma Ma",
    "Name of Principal Organization": "UMC International Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Myanmar Tokiwa Corporation",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "300/97",
    "Permit Date": "1997-12-08T10:18:46Z",
    "Meeting Number": "19/97",
    "Meeting Date": "1997-11-21T10:19:06Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Sales of Various Pencils and Make-Up",
    "Amount Of Foreign Capital USD (in Millions)": 6.924,
    "Total Amount Of Capital (in Millions)": 42.834,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No.7/9, Thiri Street, Parami Teiktha, Yankin Township, Yangon",
    "Organization Address":
      "No.7/9, Thiri Street, Parami Teiktha, Yankin Township, Yangon",
    "Investment Permitted Address":
      "No.103 Saw Mill Compound Mandalay and Industrial Estate in Pyinmabin, Yangon",
  },
  {
    ID: 2191,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Winfred Wai Wah Ho",
    "Name of Principal Organization": "Euro World Limited ",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Eastern World Limited",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "301/98",
    "Permit Date": "1998-01-29T10:26:52Z",
    "Meeting Number": "21/97",
    "Meeting Date": "1997-12-26T10:27:13Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production of Knit Shirts, Jackets and Other Garment Accessories",
    "Amount Of Foreign Capital USD (in Millions)": 10.78,
    "Total Amount Of Capital (in Millions)": 10.78,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "15, Kandoorie Avenue, Kowloon, Hong Kong",
    "Organization Address":
      "9 F, Summit Building , 30 Man Yue St. Hung Hom, Kowloon, Hong Kong",
    "Investment Permitted Address":
      "Plot No. 86/87/90/91 & 94, Hlaing Thar Yar Industrial Zone Part 3, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2192,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yukichi Kishi",
    "Name of Principal Organization": "Wakayama Kyodo Kenzai Co., Ltd.",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Japan Construction Material Co., Ltd.",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "304/98",
    "Permit Date": "1998-01-29T10:32:24Z",
    "Meeting Number": "1/98",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Production of Ready Mixed Concrete",
    "Amount Of Foreign Capital USD (in Millions)": 2.6,
    "Total Amount Of Capital (in Millions)": 2.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "Minato 1850 Wakayama City, Japan ",
    "Organization Address": "Minato 1850 Wakayama City, Japan ",
    "Investment Permitted Address":
      "At the Bank of Pazundaung Creek, Dawbon Township, Yangon Region",
  },
  {
    ID: 2193,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Director General, Department of Social Welfare",
    "Name of Principal Organization": "Department of Social Welfare",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Art & Deco Company Limited",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "305/98",
    "Permit Date": "1998-02-27T10:39:08Z",
    "Meeting Number": "2/98",
    "Meeting Date": "1998-01-23T10:39:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Handicrafts, Lacquar-Ware, Table Cloth, Curtains and Other Non-Precious Stone Products",
    "Amount Of Foreign Capital USD (in Millions)": 0.525,
    "Total Amount Of Capital (in Millions)": 4.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Virgin Islands (British)",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "No. 65, Kyaikwine Pagoda Road, Mayangone Township, Yangon",
    "Organization Address":
      "No. 64, Kabar Aye Pagoda Road, Mayangone Township, Yangon",
    "Investment Permitted Address":
      "No. 113, Thanlwin Road, Kamaryut Township, Yangon Region",
  },
  {
    ID: 2194,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chen Han-Jang",
    "Name of Principal Organization": "Tokyo T.S Limited",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Htet Pyae Phyo Company Limited",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "307/98",
    "Permit Date": "1998-03-19T10:45:37Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of all kinds of Lens and Lens Units, Optical Apparatuses, Electronic Apparatuses and Other Apparatuses on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 13.27,
    "Total Amount Of Capital (in Millions)": 13.27,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "7F, No. 27, Sheng Li 2nd Road Tan Zi, Taichung, Taiwan",
    "Organization Address":
      "Ikebukuro K-T Bulid 2-29-19, Nishi-Ikebukuro, Toshima-Ku, Tokyo, Japan",
    "Investment Permitted Address":
      "Plot C-1 and C-2, Mingaladon Industrial Park, Yangon Region",
  },
  {
    ID: 2195,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lee Kwang Woo",
    "Name of Principal Organization": "Jewoo Corporation",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "Jewoo Manufacturing Company Limited",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "310/98",
    "Permit Date": "1998-03-31T10:51:36Z",
    "Meeting Number": "23/98",
    "Meeting Date": "1998-12-24T10:52:03Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment",
    "Amount Of Foreign Capital USD (in Millions)": 3,
    "Total Amount Of Capital (in Millions)": 3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 24,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Amend",
    "Investor Address":
      "4F, Chilsung-Bldg, 170-11, Sansung Tong, Kangnan-Ku, Seoul, Korea",
    "Organization Address":
      "4F, Chilsung-Bldg, 170-11, Sansung Tong, Kangnan-Ku, Seoul, Korea",
    "Investment Permitted Address":
      "Plot No. 107/108,Mya Malar Street, Thaketa Industrial Zone, Thaketa Township, Yangon Region",
  },
  {
    ID: 2196,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Low Kim Yong",
    "Name of Principal Organization": "Golden Glory Company ",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Golden Glory Industries Limited",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "314/98",
    "Permit Date": "1998-07-17T10:59:08Z",
    "Meeting Number": "10/98",
    "Meeting Date": "1998-06-12T10:59:28Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Electrical Products under Semi Knock Down System (TV, VCR, Conditioners, Refrigerators, Washing Machine & Other Household Electrical Products)",
    "Amount Of Foreign Capital USD (in Millions)": 4,
    "Total Amount Of Capital (in Millions)": 4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 24,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "4, Derbyshire Road # 11-08 Singapore 309460",
    "Organization Address": "No. 74, Thomson Road, Singapore 1130",
    "Investment Permitted Address": "Mingaladon Industrial Park, Yangon Region",
  },
  {
    ID: 2197,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်မြင့်မြင့်ဌေး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ထိပ်တန်းဌေးကုမ္ပဏီလီမိတက် (Top Htay Company Limited)",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "Manatha- 730/2010",
    "Permit Date": "2010-02-02T03:14:39Z",
    "Meeting Number": "39/2009",
    "Meeting Date": "2009-10-27T03:15:02Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် ဇာပန်းထိုးပိတ်တွင် ပန်းကပ်ခြင်းနှင့် ကျောက်စီခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.004,
    "Total Amount Of Capital (in Millions)": 50,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်-၆/၁၂/၂၄၅ (အေ)၊ မလိခလမ်း၊ ၆ ရပ်ကွက်၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၂၁၊ ရန်ကုန်စက်မှုဇုန်၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 2198,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lu, Wenhong",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Brothers (Myanmar) Clothing Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "098/2018",
    "Permit Date": "2018-11-30T03:32:33Z",
    "Meeting Number": "15/2018",
    "Meeting Date": "2018-11-17T03:32:51Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.471,
    "Total Amount Of Capital (in Millions)": 1.471,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 26,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Phyu Hnin Lwin",
    "Land Area (units not specified in file)": 2,
    "Lease Term": 6,
    "Annual Lease Fee": 0.0504,
    "Land Use Premium": null,
    "Number Of Local Employees": 501,
    "Number Of Foreign Employees": 18,
    Status: "Draft",
    "Investor Address":
      "No.88,Jiuji, Hekou New District, Haishu Town, Changshu City, Jiangsu Province, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 21, Myay Taing Block No.24, Ngwe Pin Lae Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2199,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ဝင်းသန္တာစန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "သာလွန်အထည်ချုပ်ထုတ်လုပ်မှုကုမ္ပဏီလီမိတက် (Excel Garment Manufacturing Company Limited)",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "Manatha-731/2010",
    "Permit Date": "2010-02-02T03:37:39Z",
    "Meeting Number": "42/2009",
    "Meeting Date": "2009-12-01T03:38:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 161.375,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၂၆၆၊ ရွှေသရဖီလမ်း၊ ၄၁ ရပ်ကွက်၊ ဒဂုံမြို့သစ် (မြောက်ပိုင်း) မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၂၈-ဃ၊ မြေတိုင်းရပ်ကွက်အမှတ်- ၅၃၈-က၊ အမှတ် ၄ အဝေးပြေးလမ်းမကြီး၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2201,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chen Yan Hua",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Gado Sky Man Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "099/2018",
    "Permit Date": "2018-11-30T03:47:04Z",
    "Meeting Number": "15/2018",
    "Meeting Date": "2018-11-17T03:47:26Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of Products For Household and Personal Use On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.465,
    "Total Amount Of Capital (in Millions)": 0.581,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "U Myo Min Htut ",
    "Land Area (units not specified in file)": 8.573,
    "Lease Term": 50,
    "Annual Lease Fee": 2,
    "Land Use Premium": null,
    "Number Of Local Employees": 381,
    "Number Of Foreign Employees": 8,
    Status: "Draft",
    "Investor Address":
      "No.35, Xi Yuan Jun Huiting, Jianghai District, Jiangmen, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. (28,29,30,31) Myaung Takar Thanmani Industrial Zone, Hmawbi Township, Yangon Region",
  },
  {
    ID: 2203,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးခင်မောင်မြတ်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "အာရှအထွေထွေလျှပ်စစ်ကုမ္ပဏီလီမိတက် (Asia General Electric Company Limited)",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "Manatha-739/2010",
    "Permit Date": "2010-03-03T04:08:23Z",
    "Meeting Number": "21/2009",
    "Meeting Date": "2009-06-17T04:07:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Swith Gear များ၊ Panel များနှင့် ဆက်စပ်ပစ္စည်းများ ထုတ်လုပ်ဖြန့်ဖြူးရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 7.8,
    "Total Amount Of Capital (in Millions)": 500,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 17.56,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၇၃၊ ရွှေတိဂုံဘုရားလမ်း၊ လသာမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၈၉၊ လှိုင်သာယာစက်မှုဇုန်(၁)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2205,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Peng Zhiming",
    "Name of Principal Organization": "Global Cases Corporation Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Global Cases (Myanmar) Corporation Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "100/2018",
    "Permit Date": "2018-11-30T04:08:38Z",
    "Meeting Number": "15/2018",
    "Meeting Date": "2018-11-17T04:09:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of Luggage And Bags On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.435,
    "Total Amount Of Capital (in Millions)": 2.435,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Nwet(or) Lin Poe Kyu",
    "Land Area (units not specified in file)": 5.12,
    "Lease Term": 5,
    "Annual Lease Fee": 90,
    "Land Use Premium": null,
    "Number Of Local Employees": 1513,
    "Number Of Foreign Employees": 23,
    Status: "Draft",
    "Investor Address":
      "Chashan-Shan Tang Village, Tantun Town, Wanzha Country, Jiangxi Province, People's Republic Of China",
    "Organization Address":
      "Unit 826,8/F Ocean Ctr, Harbour City 5, Canton Rd Tst, Klm, Hong Kong",
    "Investment Permitted Address":
      "Plot No.(1 and 2), Myay Taing Block No. 109,Sethmu, East Dagon Township, Yangon Region",
  },
  {
    ID: 2206,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Chang Dong Yeon",
    "Name of Principal Organization": "Costec F.S Co.,Ltd",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "Costec International Co.,Ltd.",
    "Financial Year From": 2011,
    "Financial Year To": 2012,
    "Permit Number": "466/2012",
    "Permit Date": "2012-01-13T03:47:43Z",
    "Meeting Number": "1/2012",
    "Meeting Date": "2012-01-03T03:48:36Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.332,
    "Total Amount Of Capital (in Millions)": 1.332,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": 3.544,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "Suit 110-1802 Indukwon Maeul Samsung APT:1510-1 Gyeonggi-Dong ,Dongan-Gu Anyang-City,Gyeonggi-Do,Korea",
    "Organization Address": "2 F, Park Center, Yangjae-Dong,Seocho-Gu, Seoul",
    "Investment Permitted Address":
      "Plot No S 34 35 & 36 Mya Taung Wun Gyi U Mho Street Industrial Zone 3 ,Shwe Pyi Thar Township, Yangon",
  },
  {
    ID: 2207,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wong Chi Hung ",
    "Name of Principal Organization": "Source Of Ocean (Hong Kong) Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Jan Zipper(Myanmar) Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "101/2018",
    "Permit Date": "2018-11-30T04:51:02Z",
    "Meeting Number": "15/2018",
    "Meeting Date": "2018-11-17T04:51:06Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing And Marketing Of Various Zipper For CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.635,
    "Total Amount Of Capital (in Millions)": 0.635,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 28,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyi Lwin",
    "Land Area (units not specified in file)": 1.33,
    "Lease Term": 8,
    "Annual Lease Fee": 90,
    "Land Use Premium": null,
    "Number Of Local Employees": 203,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address":
      "Rm A6/F, Long To Bldg 654-656 Castle Peak Rd, Cheung Sha Wan Kln, Hong Kong",
    "Organization Address":
      "Rm A6/F, Long To Bldg 654-656 Castle Peak Rd, Cheung Sha Wan Kln, Hong Kong",
    "Investment Permitted Address":
      "Plot No.344,Myay Taing Block No.25, Shwe Lin Ban Sethmu Myoe, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2208,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. SANG HOON, LEE",
    "Name of Principal Organization": "PT UNGARAN INDAH BUSANA",
    "Place of Incorporation": "JAKARTA, INDONESIA",
    "Company Name In Myanmar": "MYANMAR UNGARAN INDAH BUSANA LIMITED",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "349/2000",
    "Permit Date": "2000-11-22T04:48:20Z",
    "Meeting Number": "33/2000",
    "Meeting Date": "2000-10-02T04:48:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENTS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.2,
    "Total Amount Of Capital (in Millions)": 1.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Indonesia",
    "Form Of Investment": "FDII",
    "Land Owner": "DEPARTMENT OF HUMAN SETTLEMENT AND HOUSING DEVELOPMENT",
    "Land Area (units not specified in file)": null,
    "Lease Term": 15,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "166/45 SHINKIL DONG YOUNG DONG PO-KU, SEOUL, KOREA",
    "Organization Address":
      "JL KELAPA NIAS RAYA, RUKAN BLOCK GN 5/3, KELAPA GADING, JAKARTA UTARA 14250, INDONESIA",
    "Investment Permitted Address":
      "PLOT NO. 122,124 INDUSTRIAL ZONE (3), SHWE PYI THAR TOWNSHIP, YANGON",
  },
  {
    ID: 2209,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Xiao Hongxi",
    "Name of Principal Organization":
      "Shantou Kai Xi Lingerie Industrial Co.,Ltd",
    "Place of Incorporation": "People's Republic Of China",
    "Company Name In Myanmar":
      "Jin Kaili (Myanmar) Lingerie Industrial Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "102/2018",
    "Permit Date": "2018-11-30T05:21:40Z",
    "Meeting Number": "15/2018",
    "Meeting Date": "2018-11-17T05:21:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of Brassieres, Underwears And It's Accessories On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3,
    "Total Amount Of Capital (in Millions)": 3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 28,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myo Thant",
    "Land Area (units not specified in file)": 2.275,
    "Lease Term": 8,
    "Annual Lease Fee": 0.08,
    "Land Use Premium": null,
    "Number Of Local Employees": 1212,
    "Number Of Foreign Employees": 23,
    Status: "Draft",
    "Investor Address":
      "No.93, Dongfeng 2nd Road, Chendian Town, Chaonan District, Shantou City, Guangdong Province, People's Republic Of China",
    "Organization Address":
      "No.3-02A,Xinshan Technology Park 3F,Building 1, Chaonan District, Shantou City, People's Republic Of China",
    "Investment Permitted Address":
      "Plot No.56, Myay Taing Block No.24, Ngwe Pin Lae Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2210,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Koji Nakata",
    "Name of Principal Organization": "Advan Co.,Ltd.",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Htun International Manufacturing Co.,Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "537/2012",
    "Permit Date": "2012-12-31T06:06:28Z",
    "Meeting Number": "39/2012",
    "Meeting Date": "2012-12-28T06:06:59Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Shoes on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.585,
    "Total Amount Of Capital (in Millions)": 0.585,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": 7523.11,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "13-23-608 Ta Tsumikita, Inkuno-Ku, Osaka City,Japan",
    "Organization Address": "3-14-6 Tatsumihigashi, Ikuno-Ku,Osaka City,Japan",
    "Investment Permitted Address":
      "Plot No.190/B, Seikkantha Street, Industrial Zone(1), Hlaing Thar Yar Township, Yangon",
  },
  {
    ID: 2213,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးသန်းထွန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ရမ္မာမော်တော်ယာဉ်ထုတ်လုပ်ရောင်းချရေးကုမ္ပဏီလီမိတက် (Rammar Automobile Manufacturing & Trading Company Limited) ",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "Manatha-744/2010",
    "Permit Date": "2010-04-05T07:01:49Z",
    "Meeting Number": "6/2010",
    "Meeting Date": "2010-02-16T07:01:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Micro Bus မော်တော်ယာဉ်များ ထုတ်လုပ်ခြင်းနှင့် ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 8000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးစိုင်းမျိုးဝင်း",
    "Land Area (units not specified in file)": 4.014,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၉၈၊ စံပယ်ဖြူလမ်း၊ ခရေပင်ရိပ်မွန်၊ မင်္ဂလာဒုံမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ် ၅၃/၅၄၊ စက်ဆရာဦးထွန်းလမ်း၊ ရွှေပြည်သာစက်မှုဇုန် (၄)၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2214,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကိုကိုကြီး (ခ) ဦးစိုးနိုင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "စိမ်းလဲ့မြေစားသောက်ကုန်လုပ်ငန်းလီမိတက် (Green Land Food Industries Limited)",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "Manatha-748/2010",
    "Permit Date": "2010-05-05T07:10:32Z",
    "Meeting Number": "45/2009",
    "Meeting Date": "2009-12-22T07:10:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ကုန်ပစ္စည်းထည့်သိုရန်အိတ်ကြီးများ (PP Bags) ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 2.3,
    "Total Amount Of Capital (in Millions)": 1000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ပက်(ခ်)လင့်(ခ်)ထရေးဒင်းလီမိတက်",
    "Land Area (units not specified in file)": 6.75,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၁၂၆ (အေ)၊ ကမ္ဘာအေးဘုရားလမ်း၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၄၇၊ ၄၈၊ ၄၉၊ ယောအတွင်းဝန်ဦးဖိုးလှိုင်လမ်း၊ မြေတိုင်းရပ်ကွက်အမှတ် ၁၁၃၊ အရှေ့ဒဂုံစက်မှုဇုန်၊ ဒဂုံမြို့သစ်အရှေ့ပိုင်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2215,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဗညားအောင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ပုဝါမင်းသမီးအထည်ချုပ်ထုတ်လုပ်မှုကုမ္ပဏီလီမိတက် (Pawar Min Tha Mee Garment Manufacturing Company Limited)",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "Manatha-749/2010",
    "Permit Date": "2010-05-19T07:18:51Z",
    "Meeting Number": "45/2009",
    "Meeting Date": "2009-12-22T07:18:16Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် သတို့သမီးဝတ်စုံအထည်အမျိုးမျိုး ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 56.33,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်ခင်လဲ့လဲ့နိုင်",
    "Land Area (units not specified in file)": 0.406,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၅၆၁၊ ရေနံချောင်းလမ်း၊ ၉ ရပ်ကွက်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၇၊ မြေတိုင်းရပ်ကွက်အမှတ် ၁၉/၂၊ ကနောင်မင်းသားကြီးလမ်း၊ ရွှေပေါက်ကံစက်မှုဇုန်၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2216,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ခင်မို့မို့မြိုင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "အာရှဆန်းကြယ်သောပစ္စည်းများကုမ္ပဏီလီမိတက် (Magic Material Asia Company Limited)",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "Manatha-750/2010",
    "Permit Date": "2010-05-19T07:25:40Z",
    "Meeting Number": "7/2010",
    "Meeting Date": "2010-02-23T07:25:13Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် Power Inductors နှင့် Lan Transformer များ ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 59.42,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးကွန်ဟုတ်ကင် (ခ) ဦးကျင်",
    "Land Area (units not specified in file)": 1.511,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၁၄၅၊ ရွှေနှင်းဆီလမ်းသွယ် (၆)၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၈၊ ဦးရွှေအိုးလမ်းသွယ် ၁၊ လှိုင်သာယာစက်မှုဇုန် ၂ ၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2218,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးသူရအောင်ဖြိုး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ဆံချည်တစ်မျှင် မြန်မာကုမ္ပဏီလီမိတက် (One Hair Myanmar Company Limited)",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "Manatha-759/2010",
    "Permit Date": "2010-09-30T07:38:33Z",
    "Meeting Number": "26/2010",
    "Meeting Date": "2010-07-29T07:37:56Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် ဆံပင်ပုံခေါင်းစွပ်များ ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 96.585,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးသူရအောင်ဖြိုး",
    "Land Area (units not specified in file)": 1.023,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၂၁၀၊ ဦးရေပေါလမ်းနှင့် ပြင်စည်မင်းသားကြီးလမ်းထောင့်၊ ရွှေလင်ပန်းစက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၂၁၀၊ မြေတိုင်းရပ်ကွက်အမှတ် ၂၅၊ ဦးရေပေါလမ်းနှင့် ပြင်စည်မင်းသားကြီးလမ်းထောင့်၊ ရွှေလင်ပန်းစက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2219,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးထွန်းအောင် (ခ) ဦးထွန်းထွန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "သမီးတော်စွမ်းအားစက်မှုထုတ်လုပ်မှုကုမ္ပဏီလီမိတက် (Princess Power Manufacturing Company Limited)",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "Manatha-764/2010",
    "Permit Date": "2010-11-18T07:45:21Z",
    "Meeting Number": "26/2010",
    "Meeting Date": "2010-07-29T07:44:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အထည်အမျိုးမျိုးချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 85,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအေးချို",
    "Land Area (units not specified in file)": 0.23,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၄၂၊ ပထမထပ်၊ ဗိုလ်အောင်ကျော်လမ်း၊ ဗိုလ်တထောင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၂၁၂၊ မြေတိုင်းရပ်ကွက်အမှတ် ၁၈၊ ကနောင်မင်းသားကြီးလမ်း၊ ရွှေပေါက်ကံစက်မှုဇုန်၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး\n\n",
  },
  {
    ID: 2220,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်မင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "မြဝတီနှင့် ရွှေတောင်ကုန်းအပြည်ပြည်ဆိုင်ရာလီမိတက် (Myawaddy and Golden Hill International Limited)",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "Manatha-772/2011",
    "Permit Date": "2011-01-12T07:52:39Z",
    "Meeting Number": "16/2010",
    "Meeting Date": "2010-05-14T07:51:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "စီးကရက်ထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.83,
    "Total Amount Of Capital (in Millions)": 12000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ပြည်ထောင်စုမြန်မာနိုင်ငံစီးပွားရေးဦးပိုင်လီမိတက်ပိုင်",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၁၀-ခ၊ အခန်း ၁၀၁၊ ရွှေကမ္ဘာအိမ်ရာစီမံကိန်း၊ မင်းဓမ္မလမ်း၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ် ၄၉၊ မယ်ဇီကုန်းလမ်း၊ လှိုင်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2221,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.In Ho Bang",
    "Name of Principal Organization": "Masters Sports Co.,Ltd.",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "Masters Sports (Myanmar) Co.,Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "538/2012",
    "Permit Date": "2012-12-31T07:57:30Z",
    "Meeting Number": "39/2012",
    "Meeting Date": "2012-12-28T07:58:24Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Golf Shoes, Hiking Boots ,Boston Bags and Golf Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.87,
    "Total Amount Of Capital (in Millions)": 0.87,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "Shinchon Village Force-Hometown 207-1202,1282,Bojeong-Dong , Gihueng-Gu, Yongin-Si, Gyenggi-Do,446598,Republic of Korea",
    "Organization Address":
      "388-146 Singal-Dong, Giheung-Gu, Yongin-Si,Gyeonggi-Do,446-598,Republic of Korea",
    "Investment Permitted Address":
      "No.63, Dipeyin Wundauk U Mye Street,Hlaing Thar Yar Industrial Zone(3), Hlaing Thar Yar Township, Yangon",
  },
  {
    ID: 2223,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်တင်နိုင်အေး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "တဟုန်တည်းရှေ့တိုးထုတ်လုပ်ခြင်းကုမ္ပဏီလီမိတက် (Onrush Manufacturing Company Limited)",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "Manatha-778/2011",
    "Permit Date": "2011-01-27T08:45:43Z",
    "Meeting Number": "35/2010",
    "Meeting Date": "2010-10-15T08:45:10Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 101.53,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 0.572,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် အေ/၅၂၊ အောင်ဓမ္မရိပ်သာလမ်း၊ ၁၂- ရပ်ကွက်၊ မရမ်းခြံ၊ လှိုင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၀၀၊ မြေတိုင်းရပ်ကွက်အမှတ် င၊ ဘောဂဗလလမ်း၊ စက်မှုလက်မှုရပ်ကွက်၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2225,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ရန်စီမြင့် (ခ) ဒေါ်ခင်မြင့်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ရေရှည်ကုန်ထုတ်လုပ်မှုကုမ္ပဏီလီမိတက် (Long Run Manufacturing Company Limited)",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "Manatha-541/2002",
    "Permit Date": "2002-05-27T11:00:16Z",
    "Meeting Number": "43/2001",
    "Meeting Date": "2001-12-24T10:59:42Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 36.07,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 1.484,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၅၀၁-အေ၊ တီစီစီရိပ်သာလမ်း၊ ကမာရွတ်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ပြန်ကြားရေးဝန်ကြီးဌာန၊ ပုံနှိပ်ရေးနှင့်စာအုပ်ထုတ်ဝေရေး လုပ်ငန်းပိုင် အောင်ဆန်းပုံနှိပ် စက်ရုံဝင်း၊ အောက်မင်္ဂလာဒုံလမ်း၊ အောင်ဆန်း၊ အင်းစိန်မြို့နယ်၊ ရန်ကုန်တိုင်း",
  },
  {
    ID: 2226,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမိုးဝင်းမောင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ရတနာနစ်(တ်)အင်(န်)ဂါးမန့်(တ်)မန်နူဖက်ချားရင်းကုမ္ပဏီလီမိတက် (Yandana Knit and Garment Manufacturing Company Limited)",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "Manatha-543/2002",
    "Permit Date": "2002-06-06T11:07:05Z",
    "Meeting Number": "13/2002",
    "Meeting Date": "2002-04-22T11:05:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီသိုးမွှေးထည်အမျိုးမျိုးချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 72,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 1.5,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၁၀၊ အနောက်မြို့ပတ်လမ်း၊ ဆရာစံ (အနောက်မြောက်) ရပ်ကွက်၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ လှိုင်သာယာမြို့နယ်၊ စက်မှုဇုန်အပိုင်း ၄၊ မြေကွက်အမှတ် ၁၇၃ (က)",
  },
  {
    ID: 2227,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wang, Weizhong",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Jiu Rui Plastics Products Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "103/2018",
    "Permit Date": "2018-11-30T04:48:00Z",
    "Meeting Number": "15/2018",
    "Meeting Date": "2018-11-17T04:48:14Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of Varities  Of Plastics Products Rope & Tape On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.809,
    "Total Amount Of Capital (in Millions)": 0.809,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Win Tin",
    "Land Area (units not specified in file)": 3.5,
    "Lease Term": 10,
    "Annual Lease Fee": 0.1632,
    "Land Use Premium": null,
    "Number Of Local Employees": 265,
    "Number Of Foreign Employees": 20,
    Status: "Draft",
    "Investor Address":
      "Minghua Road,No.128,Xinqiaoo Town, Songjiang District, Shanghai Province, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.75,Myay Taing Block No.49.War Tayar Industrial Zone, Shwe Pyi Thar Township,Yangon Region",
  },
  {
    ID: 2228,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wang Gang",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Lewar (Myanmar) Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "104/2018",
    "Permit Date": "2018-11-30T08:21:05Z",
    "Meeting Number": "15/2018",
    "Meeting Date": "2018-11-17T08:21:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing And Distribution Of Construction Materials On Hundred Percent Local Sale",
    "Amount Of Foreign Capital USD (in Millions)": 0.284,
    "Total Amount Of Capital (in Millions)": 0.284,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 27,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U  Kyaw Kyaw Naing",
    "Land Area (units not specified in file)": 0.541,
    "Lease Term": 7,
    "Annual Lease Fee": 18,
    "Land Use Premium": null,
    "Number Of Local Employees": 50,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "No.270, Yuwang Village, Xingfu Town, Boxing Country,Shandong Province,People's Republic Of  China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.54,Myay Taing Block No.27,Shwe Lin Ban Sethmu Myoe, Hlaing Thar Yar Township,Yangon Region",
  },
  {
    ID: 2229,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Norio Nakatani",
    "Name of Principal Organization": "Nakatani Gumi Co.,Ltd,",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Nakatani Gumi Myanmar Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "105/2018",
    "Permit Date": "2018-11-30T02:55:01Z",
    "Meeting Number": "15/2018",
    "Meeting Date": "2018-11-17T02:55:12Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Renting Service On Construction Machine",
    "Amount Of Foreign Capital USD (in Millions)": 4,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "U Ye Htut and Daw Ohnmar Soe",
    "Land Area (units not specified in file)": 0.459,
    "Lease Term": 10,
    "Annual Lease Fee": 0.01,
    "Land Use Premium": null,
    "Number Of Local Employees": 55,
    "Number Of Foreign Employees": 7,
    Status: "Draft",
    "Investor Address":
      "\nNo.4-23-8, Ishiyama-Tera, Ohtsu-Shi, Shiga-Ken,Japan,520-2102",
    "Organization Address": " 6-2-14 Oe Otsu-Shi, Shiga,Japan 520-2141",
    "Investment Permitted Address":
      "Plot No.Hsa, Shwe Naint Thar San Pya Quarter, Mingalardone Township,Yangon Region",
  },
  {
    ID: 2230,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Shigekazu Shiratsuchi",
    "Name of Principal Organization": "Idea Limited,#902",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Nedea Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "106/2018",
    "Permit Date": "2018-11-30T03:24:24Z",
    "Meeting Number": "15/2018",
    "Meeting Date": "2018-11-17T03:24:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Dolls On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.526,
    "Total Amount Of Capital (in Millions)": 0.526,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Thidar",
    "Land Area (units not specified in file)": 0.826,
    "Lease Term": 30,
    "Annual Lease Fee": 90,
    "Land Use Premium": null,
    "Number Of Local Employees": 59,
    "Number Of Foreign Employees": 1,
    Status: "Draft",
    "Investor Address":
      "Room (0705-C), Bo Myat Tun Tower, Ward(9), Botataung Township,Yangon",
    "Organization Address":
      " 3-5-5, Higashinihonbashi Tokyo Stage #902, Chuo-Ku,Tokyo ,Japan",
    "Investment Permitted Address":
      "Plot No. 150/Kha , Myay Taing Block No.23 Industrial Zone Dagon Myothit (South) Township, Yangon Region",
  },
  {
    ID: 2231,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Pei Quangen",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Shengmao Art (Myanmar) Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "107/2018",
    "Permit Date": "2018-11-30T03:38:46Z",
    "Meeting Number": "15/2018",
    "Meeting Date": "2018-11-17T03:38:56Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of Various Kind Of Ceramic On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.175,
    "Total Amount Of Capital (in Millions)": 0.218,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Than Than Win",
    "Land Area (units not specified in file)": 1.219,
    "Lease Term": 5,
    "Annual Lease Fee": 0.096,
    "Land Use Premium": null,
    "Number Of Local Employees": 501,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "Shengmao Gift Factory, Shenxiang Village, Qishi Town, Dongpu City, Guangdong Province, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.41, Myay Taing Block No.14, Shwe Than Lwin Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2232,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Song Yunxia",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "United Ascent Corporation Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "108/2018",
    "Permit Date": "2018-11-30T03:55:51Z",
    "Meeting Number": "15/2018",
    "Meeting Date": "2018-11-17T03:56:03Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of  Luggage And Bags On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.749,
    "Total Amount Of Capital (in Millions)": 1.749,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner":
      "U Tin Maung Thein, U Tin Maung Zaw, U Tin Maung Myint and Daw Than Than Aye",
    "Land Area (units not specified in file)": 4.5,
    "Lease Term": 5,
    "Annual Lease Fee": 96,
    "Land Use Premium": null,
    "Number Of Local Employees": 607,
    "Number Of Foreign Employees": 28,
    Status: "Draft",
    "Investor Address":
      "Room 202,Unit 3, Building 30, Jin Yuan, Xiacheng District, Hangzhou, People Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.(165,166), Myay Taing Block No.(49), Wartayar Industrial Zone, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 2233,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကျင်စု",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ပြည့်သားကောင်းသားရေ ထုတ်လုပ်မှု ကုမ္ပဏီလီမီတက် (Pyae Tharr Kaung Leather Production Co.,Ltd)",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "109/2018",
    "Permit Date": "2018-11-30T04:13:20Z",
    "Meeting Number": "15/2018",
    "Meeting Date": "2018-11-17T04:13:26Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMPစနစ်ဖြင့် သားရေအချောထည် ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 3080,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးကျင်စု",
    "Land Area (units not specified in file)": 2.755,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 56,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "အမှတ်(၅)၊ ရွာမကျောင်းလမ်း၊ (၁)ရပ်ကွက်၊ လှိုင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၂၂/၂၃)၊ မြေတိုင်းရပ်ကွက်အမှတ်(၁၉)၊ မွေးမြူရေးဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2234,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhang, Xuewen",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Vienna Business Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "110/2018",
    "Permit Date": "2018-11-30T04:29:27Z",
    "Meeting Number": "15/2018",
    "Meeting Date": "2018-11-17T04:29:42Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Service",
    "Amount Of Foreign Capital USD (in Millions)": 1.2,
    "Total Amount Of Capital (in Millions)": 1.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Thein Aung and Daw Tin Tin",
    "Land Area (units not specified in file)": 0.244,
    "Lease Term": 20,
    "Annual Lease Fee": 0.7528,
    "Land Use Premium": null,
    "Number Of Local Employees": 12,
    "Number Of Foreign Employees": 2,
    Status: "Draft",
    "Investor Address":
      "No.8, 401 Room, Licheng Street Garden Road, Guangdong Province, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Building No.(9/2+3), Plot No.(100+101), Myay Taing Block No.(15), Shwekantharyar Housing Inner Street, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2235,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးသိန်း၀င်းအောင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Htoo Myat Thu Company Limited (ထူးမြတ်သူကုမ္ပဏီလီမီတက်)",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "111/2018",
    "Permit Date": "2018-11-30T06:12:31Z",
    "Meeting Number": "15/2018",
    "Meeting Date": "2018-11-17T06:12:41Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMPစနစ်ဖြင့်အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 2250,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "ဦးတင်၀င်း၊ ဒေါ်ခင်ဆွေ၀င်း၊ ဦးတင်လင်း၊ ဦးတင်မောင်စိုး၊ဒေါ်ကျင်မြ",
    "Land Area (units not specified in file)": 2.08,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 500,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "အမှတ်(၁၆)အေ၊ အောင်မင်းဂေါင်(၃)လမ်း၊(၁၀)ရပ်ကွက်၊ ကမာရွတ်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၈၅၊ မြေတိုင်းရပ်ကွက်အမှတ် ၆၅၊ စက်မှု၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2236,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lien Chien Ping",
    "Name of Principal Organization": "Hydraknight Innovation Company Limited",
    "Place of Incorporation": "Republic Of China",
    "Company Name In Myanmar": "Hydraknight Myanmar Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "112/2018",
    "Permit Date": "2018-11-30T06:31:07Z",
    "Meeting Number": "15/2018",
    "Meeting Date": "2018-11-17T06:31:11Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of Various Kinds Of Water Proof Bags On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.2,
    "Total Amount Of Capital (in Millions)": 1.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Maung Maung Lay",
    "Land Area (units not specified in file)": 3.417,
    "Lease Term": 10,
    "Annual Lease Fee": 0.010144,
    "Land Use Premium": null,
    "Number Of Local Employees": 281,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "4F, No.6, Lalne 122, Sec 2, Kan-Yuan St, Shulin Dist, New Taipei City 23853, Taiwan, Republic Of China",
    "Organization Address":
      "4F, No.6, Lalne 122, Sec 2, Kan-Yuan St, Shulin Dist, New Taipei City 23853, Taiwan, Republic Of China",
    "Investment Permitted Address":
      "Plot No.(C-11), Myay Taing Block No.(175), Kyi Su Industrial Zone, Dagon Myothit Seikkan Township, Yangon Region",
  },
  {
    ID: 2237,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကျော်ကျော် (ခ) ရှောက်ကွေ့ရှင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "မြန်မာအဆင့်မြင့်သရဖူကုမ္ပဏီလီမိတက် (Myanmar Grand Crown Company Limited)",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "Manatha-551/2002",
    "Permit Date": "2002-08-01T05:02:22Z",
    "Meeting Number": "20/2002",
    "Meeting Date": "2002-06-28T05:02:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 68.4,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 1.952,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်- ၁၂၄၊ မြေညီထပ်၊ ၉၁ - လမ်း၊ မင်္ဂလာတောင်ညွန့်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၂၃၊ စက်မှုဇုန် ၄၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့\n\n",
  },
  {
    ID: 2239,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်စန်းစန်းဝင်း (ခ) စောကင်ဝှာ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ပလာစတာဂလပ်(စ်) စီးလင်းပရောဒတ်(စ်) လီမိတက်  (Plasterglass Ceiling Products Limited)",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "Manatha-073/97",
    "Permit Date": "1997-06-13T05:33:30Z",
    "Meeting Number": "8/97",
    "Meeting Date": "1997-05-29T05:33:58Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "မျက်နှာကျက်ကျောက်ပြားနှင့် ပလာစတာဂလပ်(စ်)အပြားထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 12.4,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 0.82,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၁၂၀၊ ဒုတိယထပ်၊ ၄၁ လမ်း၊ ဗိုလ်တထောင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ဦးပိုင်အမှတ် ၂၆၊ ကွင်းအမှတ် ၉၈၈ (ခ)၊ သာယာကုန်းကွင်း၊ ကျွန်းကလေးကျေးရွာအုပ်စု၊ လှည်းကူးမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2240,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးလှသိန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "မြန်မာဗျူးတက်ဂါးမင့်ဖက်ထရီလီမိတက် (Myanmar Beautex Garment Factory Limited)",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "Manatha-081/97",
    "Permit Date": "1997-07-28T07:33:28Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 12.5,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၁၁၁၊ လမ်းမတော်လမ်း၊ လမ်းမတော်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၀၇၊ စက်မှုဇုန် ၂၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2241,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Yuichi Momose",
    "Name of Principal Organization": "Tokyo In Co.,Ltd.",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Tokyo in Myanmar Co.,Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "541/2013",
    "Permit Date": "2013-01-02T03:52:31Z",
    "Meeting Number": "1/2013",
    "Meeting Date": "2013-01-02T03:53:03Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Garment on CMP Basis (Japan Traditional Wear and Swim Wear)",
    "Amount Of Foreign Capital USD (in Millions)": 1.423,
    "Total Amount Of Capital (in Millions)": 1.423,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 4,
    "Validity Of Investment Permit (in Years)": 36,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address": "1-29-202,Senju, Adachi-Ku, Tokyo,Japan",
    "Organization Address":
      "Himei Nihombashi Building 4F,12-3,NIhombashi -Kobuna-Cho ,Chuo-Ku,Tokyo ,Japan",
    "Investment Permitted Address":
      "Plot No (A-10), Mingaladon Industrial Park, Minagaladon Township,Yangon ,",
  },
  {
    ID: 2243,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "COL. Win Zaw Nyunt",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Yangon Garment Manufacturing Company Limited",
    "Financial Year From": 1989,
    "Financial Year To": 1990,
    "Permit Number": "013/1990",
    "Permit Date": "1990-01-05T04:30:21Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and marketing of ready-made garments",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 11.212,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 90,
    "Validity Of Investment Permit (in Years)": 5,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Terminated",
    "Investor Address": "192, Kaba Aye Pagoda Road, Bahan Township, Yangon",
    "Organization Address": "-",
    "Investment Permitted Address": "Yangon",
  },
  {
    ID: 2244,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor":
      "Managing Director, Myanma General and Maintenance Industries ",
    "Name of Principal Organization":
      "Myanma General and Maintenance Industries",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Myanmar - ACE Metal Industries Co., Ltd.",
    "Financial Year From": 1995,
    "Financial Year To": 1996,
    "Permit Number": "015/1990",
    "Permit Date": "1995-09-11T04:53:21Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production and Marketing of Steel  Products, Aluzinc Roofing Sheets, Galvanized Steel Sheets and roofing sheets, Fnamel Products and Steel Fabrication ",
    "Amount Of Foreign Capital USD (in Millions)": 0.106,
    "Total Amount Of Capital (in Millions)": 1.6,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 90,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Amend",
    "Investor Address": "192, Kaba Aye Paogoda Road, Bahan Township, Yangon",
    "Organization Address": "192, Kaba Aye Pagoda Road, Bahan Township, Yangon",
    "Investment Permitted Address": "Yangon",
  },
  {
    ID: 2245,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Aung Koe",
    "Name of Principal Organization":
      "The Union of Myanmar Economic Holdings Limited",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar Daewoo Electronics Co., Ltd.",
    "Financial Year From": 1990,
    "Financial Year To": 1991,
    "Permit Number": "039/1990",
    "Permit Date": "1990-10-12T04:57:58Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of all kinds of Garment and Apparel products ",
    "Amount Of Foreign Capital USD (in Millions)": 0.688,
    "Total Amount Of Capital (in Millions)": 30,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "Maw Kun Daik Road, Dagon P.O, Yangon",
    "Organization Address": "-",
    "Investment Permitted Address": "Pyinmabin , Yangon",
  },
  {
    ID: 2246,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. R.R. Locher",
    "Name of Principal Organization": "Zarembo Invest SA",
    "Place of Incorporation": "Panama",
    "Company Name In Myanmar": "Thilawa Cement and Building Materials Limited",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "286/1997",
    "Permit Date": "1997-09-30T05:12:39Z",
    "Meeting Number": "14/1997",
    "Meeting Date": "1997-08-29T05:19:45Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production and Distribution of Bagged Cement, Ready Mix Concrete and Pre Cast.",
    "Amount Of Foreign Capital USD (in Millions)": 30.526,
    "Total Amount Of Capital (in Millions)": 30.526,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Thanlyin-Kyauktan  Development Company Limited",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "Hoerndlirain 8, 6318 Watchwil, Switzerland",
    "Organization Address": "Panama",
    "Investment Permitted Address": "Thanlyin-Kyauktan Industrial Zone, Yangon",
  },
  {
    ID: 2247,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor":
      "Managing Director, The Union of Myanmar Economic Holdings Ltd.",
    "Name of Principal Organization":
      "The Union of Myanmar Economic Holdings Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Berger Paints Manufacturing Ltd.",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "287/1997",
    "Permit Date": "1997-11-04T06:19:08Z",
    "Meeting Number": "13/97",
    "Meeting Date": "1997-08-15T06:19:38Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 1.8,
    "Total Amount Of Capital (in Millions)": 18,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "The Union of Myanmar Economic Holdings Limited",
    "Land Area (units not specified in file)": 10265,
    "Lease Term": 20,
    "Annual Lease Fee": 0.3,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No. 72/74, Shwedagon Pagoda Road, Dagon Township, Yangon",
    "Organization Address":
      "No. 72/74, Shwedagon Pagoda Road, Dagon Township, Yangon",
    "Investment Permitted Address":
      "Pyinmabin Industrial Zone,  Mingaladon Township, Yangon.",
  },
  {
    ID: 2248,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lee Chee Fatt",
    "Name of Principal Organization": "National Industrial Gas Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Myanmar National Oxygen Ltd.",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "291/1997",
    "Permit Date": "1997-11-28T06:30:40Z",
    "Meeting Number": "16/97",
    "Meeting Date": "1997-10-17T06:31:06Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 0.913,
    "Total Amount Of Capital (in Millions)": 0.913,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "Department of Human Settlement and Housing Development",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": 205000,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "BLK 122, Jurong East St 13, # 11-37, Singapore 600122",
    "Organization Address": "1, Shipyard Road, Singapore 628128",
    "Investment Permitted Address":
      "Plot No. B-62, Thanlyin-Kyauktan Indusatrial Zone, Yangon.",
  },
  {
    ID: 2249,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wong Mong Hong",
    "Name of Principal Organization": "Far East Myanmar Packaging Pte Ltd. ",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Myanmar Far East Carton Ltd.",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "293/1997",
    "Permit Date": "1997-11-28T06:41:28Z",
    "Meeting Number": "18/1997",
    "Meeting Date": "1997-11-07T06:42:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Cardboard Cartons.",
    "Amount Of Foreign Capital USD (in Millions)": 10,
    "Total Amount Of Capital (in Millions)": 10,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "Department of Human Settlement and Housing Development",
    "Land Area (units not specified in file)": 8093.72,
    "Lease Term": 20,
    "Annual Lease Fee": 0.025,
    "Land Use Premium": 4046.86,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "18 Senoko Loop, Singapore 758152",
    "Organization Address": "Singapore",
    "Investment Permitted Address":
      "Plot No. 97, Hlaing Tharyar Industrial Zone, Yangon.",
  },
  {
    ID: 2250,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Shogunn Co., Ltd",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Li Li MyatOo Co, Ltd",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "124/2018",
    "Permit Date": "2018-12-21T05:27:57Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T05:28:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMPစနစ်ဖြင့်ထီးထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.15,
    "Total Amount Of Capital (in Millions)": 0.15,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "ဦးဂျမား",
    "Land Area (units not specified in file)": 0.275,
    "Lease Term": 10,
    "Annual Lease Fee": 0.0345,
    "Land Use Premium": null,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address":
      "Plot No.(16/B), Anaw Ya Htar Street, Yankin Township, Yangon Region ",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot  No.135, Myay Taing Block No.(144),Setmhu, Dagon Myothit(South) Township, Yangon Region",
  },
  {
    ID: 2251,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. KWANG OU, LEE",
    "Name of Principal Organization": "GLOWIN  CO., LTD",
    "Place of Incorporation":
      "481 DAEJUNG-LI SAMSUNG-MEON EUMSUNG-GUN, CHUNGCHONGBUK-DO, KOREA",
    "Company Name In Myanmar": "MYANMAR GLOWIN CO., LTD.",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "350/2000",
    "Permit Date": "2000-11-22T08:10:20Z",
    "Meeting Number": "33/2000",
    "Meeting Date": "2000-10-02T08:11:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "PRODUCTION OF PADDING, QUILTING & EMBROIDERY (FOR GARMENTS, SLEEPING BAG , COMFORTER, BAG, TENT, CLOTHES)",
    "Amount Of Foreign Capital USD (in Millions)": 4.5,
    "Total Amount Of Capital (in Millions)": 4.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "DEPARTMENT OF HUMAN SETTLEMENT AND HOUSINH DEVELOPMENT",
    "Land Area (units not specified in file)": 3.5,
    "Lease Term": 20,
    "Annual Lease Fee": 0.043,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "KYUNYOUNG APARTMENT 101-505,72-3, MOON-JUNG DONG, SONGPA-GU,SEOUL, KOREA",
    "Organization Address":
      "GLOWIN B/D 338-18, YANGJAE-DONG SECHO-KU, SEOUL, KOREA",
    "Investment Permitted Address":
      "PLOT NO. 19, SHWE PYI THAR INDUSTRIAL ZONE, SHWE PYI THAR TOWNSHIP, YANGON",
  },
  {
    ID: 2252,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wang Quicheng",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Sheng Feng Shi Ye Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "134/2018",
    "Permit Date": "2018-12-21T04:16:45Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T04:17:16Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အထည်ချုပ်လုပ်ငန်းများတွင်အသုံးပြုသော Polyester, Nonwoven fabric, Lining Cloth and Quilting များထုတ်လုပ်၍ ပြည်တွင်းရှိ CMPအထည်ချုပ်လုပ်ငန်းများသို့ ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.7,
    "Total Amount Of Capital (in Millions)": 0.7,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Saw Win",
    "Land Area (units not specified in file)": 10060.49,
    "Lease Term": 10,
    "Annual Lease Fee": 0.05,
    "Land Use Premium": null,
    "Number Of Local Employees": 90,
    "Number Of Foreign Employees": 11,
    Status: "Draft",
    "Investor Address":
      "Wantan Village Group-3, No.1-1, Hanchuan City, Wantan Township, Hubei Province, People Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၁၁၊မြေတိုင်းရပ်ကွက်အမှတ်(၃)၊ဗန်းမော်အတွင်း၀န်လမ်းနှင့် ဆိပ်ကမ်းသာလမ်းထောင့်၊ စက်မှုမြို့၊လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2253,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw San San Nwe",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Believe International Electric Company Limited (ဘီလိဖ် အင်တာနေရှင်နယ် အီလက်ထရစ်က် ကုမ္ပဏီလီမီတက်)",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "116/2018",
    "Permit Date": "2018-12-21T07:28:05Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T07:28:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMPစနစ်ဖြင့်တွင်ခုံနှင့်ဖောက်စပ်ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 155.968,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 29,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်ပဲ့နန်း",
    "Land Area (units not specified in file)": 2.366,
    "Lease Term": 9,
    "Annual Lease Fee": 36,
    "Land Use Premium": null,
    "Number Of Local Employees": 55,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "No.4, Highway Road, No-11/B, Hlawga Tarsone, Shwepyitar Township, Yangon, Myanmar",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.13/B, Myay Taing Block No.(561), Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 2254,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lu Xiaofeng",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Rongson (Myanmar) Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "133/2018",
    "Permit Date": "2018-12-21T07:54:22Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T07:54:37Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMPစနစ်ဖြင့်ပိုက်ဆံအိတ်အမျိုးမျိုးထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.458,
    "Total Amount Of Capital (in Millions)": 0.458,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myat Ko",
    "Land Area (units not specified in file)": 0.8,
    "Lease Term": 5,
    "Annual Lease Fee": 24,
    "Land Use Premium": null,
    "Number Of Local Employees": 500,
    "Number Of Foreign Employees": 12,
    Status: "Draft",
    "Investor Address":
      "No.115, Tianhe Road, Yuhang District , Hangzhou, Zhejiang, People Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 26, Myay Taing Block No. Industrial Zone 1, Dagon Seikkan Township, Yangon Region",
  },
  {
    ID: 2255,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Kyodo Techno Myanmar Co.,Ltd (Japan)",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Kyodo Techno Myanmar Co.,Ltd",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "123/2018",
    "Permit Date": "2018-12-21T08:17:43Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T08:17:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ဆောက်လုပ်ရေးလုပ်ငန်းသုံးပစ္စည်းများ ထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.9,
    "Total Amount Of Capital (in Millions)": 0.9,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 35,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "K&M Capital Co.,Ltd",
    "Land Area (units not specified in file)": 0.118,
    "Lease Term": 35,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 21,
    "Number Of Foreign Employees": 2,
    Status: "Draft",
    "Investor Address":
      "26-20 Minami-Otsuka, 2-chome, Toshima-ku, Tokyo, Japan",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.5, Myay Taing Block No.143/1, Dagon Myothit(South) Township, Yangon Region",
  },
  {
    ID: 2256,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Hsu Yaw- Yuan",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Mingdu (Myanmar) Ltd",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "125/2018",
    "Permit Date": "2018-12-21T08:58:43Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T08:58:52Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMPစနစ်ဖြင့် လေထိုးသွင်းနိုင်သော ပစ္စည်းအမျိုးမျိုး ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "FDII",
    "Land Owner": "ဒေါ်အေးမြင့် (ခ) ဒေါ်လေပြေ",
    "Land Area (units not specified in file)": 1.51,
    "Lease Term": 5,
    "Annual Lease Fee": 0.0533,
    "Land Use Premium": null,
    "Number Of Local Employees": 120,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address":
      "No.858, Xinyang Industrial Zone, Haicang District, Xiamen, Fujian, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.381, Myay Taing Block No.25, Shwe Lin Ban Industrial, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2257,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Tan, Zhen",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Hong Xi Technology (Myanmar) Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "120/2018",
    "Permit Date": "2018-12-21T09:35:20Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T09:35:25Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် ဆက်သွယ်ရေးလုပ်ငန်းသုံး Signal Cable အမျိုးမျိုးထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 3,
    "Total Amount Of Capital (in Millions)": 3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Moe",
    "Land Area (units not specified in file)": 2.35,
    "Lease Term": 10,
    "Annual Lease Fee": 258,
    "Land Use Premium": null,
    "Number Of Local Employees": 2500,
    "Number Of Foreign Employees": 37,
    Status: "Draft",
    "Investor Address":
      "No.2868, Puti East Road, Changshou District, Chongqing City, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.5-A, Myay Taing Block No.144, Industrial Zone, Dagon Myothit(South) Township, Yangon Region",
  },
  {
    ID: 2258,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Liu Yang ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Yangon Art Materials Incorporation Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "137/2018",
    "Permit Date": "2018-12-21T04:04:39Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T04:04:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMPစနစ်ဖြင့် ပန်းချီဆွဲပစ္စည်းအမျိုးမျိုးထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 2.041,
    "Total Amount Of Capital (in Millions)": 2.041,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaw Than",
    "Land Area (units not specified in file)": 3.645,
    "Lease Term": 10,
    "Annual Lease Fee": 180,
    "Land Use Premium": null,
    "Number Of Local Employees": 497,
    "Number Of Foreign Employees": 7,
    Status: "Draft",
    "Investor Address":
      "A1-102, Huifengziyuan, Shuyang County, Jiangsu, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.16, Myay Taing Block No.21, Mya Sein Yaung Industrial Zone 2, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2259,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Jeroen Herms",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "YLX Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "113/2018",
    "Permit Date": "2018-12-21T04:21:58Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T04:22:10Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMPစနစ်ဖြင့် အိတ်အမျိုးမျိုးထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.163,
    "Total Amount Of Capital (in Millions)": 1.163,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Netherlands",
    "Form Of Investment": "FDII",
    "Land Owner": "ဦးလှမြင့် (ခ)ဦးဟိန်ရှောင်",
    "Land Area (units not specified in file)": 1.824,
    "Lease Term": 10,
    "Annual Lease Fee": 60000,
    "Land Use Premium": null,
    "Number Of Local Employees": 475,
    "Number Of Foreign Employees": 12,
    Status: "Draft",
    "Investor Address":
      "Yabao Xin Cheng 1601F, Building Mingmen Guangzhou City, Huadu District, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.105, Myay Taing Block No. 14, Shwe Tan Lwin Industrial Zone, Hlaing Thar Yar Township,Yangon Region",
  },
  {
    ID: 2260,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Xue, Shubing ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Hunter Myanmar Apparel Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "122/2018",
    "Permit Date": "2018-12-21T05:06:52Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T05:07:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMPစနစ်ဖြင့် အ၀တ်အထည်၊ ပိတ်စဖြင့်ပြုလုပ်သော ဦးထုပ်နှင့် စျေး၀ယ်အိတ်အမျိုးမျိုး ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.563,
    "Total Amount Of Capital (in Millions)": 1.563,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner":
      "ဦးမျိုးညွန့်(ခ) မောင်ရှာဖွေတိတ်၊ ဦးရဲလွင်(ခ) တီကျင်၀ှက်၊ ဦးနေလင်း(ခ) မောင်ဘိုးထူး၊ ဦးကျော်ခင်(ခ) ဦးကျော်ထူး",
    "Land Area (units not specified in file)": 2.054,
    "Lease Term": 10,
    "Annual Lease Fee": 0.04458,
    "Land Use Premium": null,
    "Number Of Local Employees": 1000,
    "Number Of Foreign Employees": 18,
    Status: "Draft",
    "Investor Address":
      "No.38, Yuelong, Nantong Jiangsu, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 28&29, Myay Taing Block No.Industrial Zone(4), Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2261,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. XuPeixue",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Refine Lather Goods Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "132/2018",
    "Permit Date": "2018-12-21T05:24:19Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T05:24:27Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMPစနစ်ဖြင့် ခရီးဆောင်အိတ်နှင့် လက်ကိုင်အိတ်အမျိုးမျိုးထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.848,
    "Total Amount Of Capital (in Millions)": 0.848,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Kyaw Oo",
    "Land Area (units not specified in file)": 1.505,
    "Lease Term": 10,
    "Annual Lease Fee": 145.44,
    "Land Use Premium": null,
    "Number Of Local Employees": 800,
    "Number Of Foreign Employees": 20,
    Status: "Draft",
    "Investor Address":
      "No.19, Shendayuan 2nd District, Changshu City, Jiangsu Province, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 111, Industrial Zone-1, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2262,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Phyu Phyu Htwe",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Hsu Lett Toe Company Limited(ဆုလာဘ်တိုးကုမ္ပဏီလီမီတက်)",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "121/2018",
    "Permit Date": "2018-12-21T05:45:04Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T05:45:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMPစနစ်ဖြင့် Salted Sea Mustard Leaf, Steam Sliced, Waste and Chestnuts များကို ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 2250,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Khin Shwe",
    "Land Area (units not specified in file)": 0.074,
    "Lease Term": 5,
    "Annual Lease Fee": 54,
    "Land Use Premium": null,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "Plot No.5/6C, Aung Dama Condo, Aung Dama Yate Tar Street, 12 Ward, Hlaing Township, Yangon Region",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.(110,111),8 Ward, South Oak Ka Lar Pa Township, Yangon Region",
  },
  {
    ID: 2263,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chuang Ching Chia",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Innocook Grains Company Limited ",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "128/2018",
    "Permit Date": "2018-12-21T06:57:05Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T06:57:14Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ပြည်တွင်းမှ ကုန်ကြမ်းဖြင့် ခေါက်ဆွဲအမျိုးမျိုး ထုတ်လုပ်၍ ပြည်ပသို့တင်ပို့ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.173,
    "Total Amount Of Capital (in Millions)": 1.173,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Min Min Twal",
    "Land Area (units not specified in file)": 4.989,
    "Lease Term": 20,
    "Annual Lease Fee": 240,
    "Land Use Premium": null,
    "Number Of Local Employees": 48,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "No.5, Zhonghua Road, Shulin District, New Taipei City, Taiwan, Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.3/344, Myay Taing Block No. Sethmu Toe Chae(1), Mingalardone Township, Yangon Region",
  },
  {
    ID: 2264,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Naing Oo",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Standard Of Future Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "115/2018",
    "Permit Date": "2018-12-21T07:26:33Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T07:26:45Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMPစနစ်ဖြင့် ငါးတာရှည်ခံအောင် ပြုပြင်စည်သွပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 1087.678,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Kyu Kyu Thin",
    "Land Area (units not specified in file)": 1.033,
    "Lease Term": 20,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 209,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "Plot No.Q-11, Mya Kan Thar-2 Street, 4 Ward,Hlaing Township, Yangon Region",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.116, Industrial(5), Hlaing Thar Yar Township,Yangon",
  },
  {
    ID: 2265,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wu Weixin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Tong Fa Plastic Industry (Myanmar) Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "135/2018",
    "Permit Date": "2018-12-21T07:44:28Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T07:44:37Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "PET Granules ထုတ်လုပ်တင်ပို့ ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.909,
    "Total Amount Of Capital (in Millions)": 0.909,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Naing Naing Latt",
    "Land Area (units not specified in file)": 2.193,
    "Lease Term": 10,
    "Annual Lease Fee": 12.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 265,
    "Number Of Foreign Employees": 20,
    Status: "Draft",
    "Investor Address":
      "No.45, Xiaqiankeng, Xikeng Village, Yonghe Town, Jinjiang City, Fujian Province, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.143,144, Myay Taing Block No.113,Setmhu Myo, Dagon Myothit(East), Yangon Region",
  },
  {
    ID: 2266,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Zhang,Fan",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ZYZ Apparel Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "138/2018",
    "Permit Date": "2018-12-21T08:56:42Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T08:56:46Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMPစနစ်ဖြင့်အ၀တ်အထည်အမျိုးမျိုးထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": 2.604,
    "Total Amount Of Capital (in Millions)": 2.604,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "ဦးကွေးချိန်",
    "Land Area (units not specified in file)": 2.578,
    "Lease Term": 50,
    "Annual Lease Fee": 94.8,
    "Land Use Premium": null,
    "Number Of Local Employees": 500,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address":
      "No.29, Drufu Street, Wuhun, Caidian District, Wuhan, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.11, Myay Taing Block No.49, Shwe Pyi Thar Township,Yangon Region",
  },
  {
    ID: 2267,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ho Tik Wa",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Creative Sewing Garment Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "117/2018",
    "Permit Date": "2018-12-21T09:13:17Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T09:13:21Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.5,
    "Total Amount Of Capital (in Millions)": 2.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 70,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "ဒေါ်မြင့်မြင့်၀င်း(ခ) ချိန်၀ူလ်လင်း",
    "Land Area (units not specified in file)": 1.318,
    "Lease Term": 6,
    "Annual Lease Fee": 0.0304,
    "Land Use Premium": null,
    "Number Of Local Employees": 828,
    "Number Of Foreign Employees": 12,
    Status: "Draft",
    "Investor Address":
      "Flat Aa4,11/F, Hong Kong, Industrial Centre, 489-491, Castle Peak Road, Kowloom, Hong Kong",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.159, Myay Taing Block No.25, Shwe Lin Ban Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2268,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zuo Jia",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Xing Le Leather Goods Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "136/2018",
    "Permit Date": "2018-12-21T09:23:55Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T09:24:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Handbags On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.757,
    "Total Amount Of Capital (in Millions)": 0.757,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myint Tun",
    "Land Area (units not specified in file)": 1.71,
    "Lease Term": 5,
    "Annual Lease Fee": 60,
    "Land Use Premium": null,
    "Number Of Local Employees": 800,
    "Number Of Foreign Employees": 40,
    Status: "Draft",
    "Investor Address":
      "Dalong Stree, Xinqiao Village, Panyu District, Gaung Zuou City, Gaungdong Province,China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.346, Myay Taing Block No.49, War Ta Yar Industrial Zone, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 2269,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Yang Huizhen",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Jiahao Fashion Industrial Limited (Singapore)",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "114/2018",
    "Permit Date": "2018-12-21T09:37:50Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T09:38:06Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMPစနစ်ဖြင့် အိတ်အမျိုးမျိုးနှင့် ခါးပတ်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.508,
    "Total Amount Of Capital (in Millions)": 1.508,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "ဦးဟောင်တင်စိန် (ခ) ဦးညွန့်စိန်",
    "Land Area (units not specified in file)": 4.467,
    "Lease Term": 10,
    "Annual Lease Fee": 0.06,
    "Land Use Premium": null,
    "Number Of Local Employees": 475,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "5B Block 15 Sanqi Huayuancheng No.1078 Nanhai Avenue, Nanshan District ,Shenzhen City, Guangdong, China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.53,Myay Taing Block No.21, Mya Sein Yaung Industrial Zone, Hlaing Thar Yar Township,Yangon Region",
  },
  {
    ID: 2270,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Katsumi Aoki",
    "Name of Principal Organization": " GFT Enterprise",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Manufacturer GFT Enterprise Co., Ltd.",
    "Financial Year From": 2011,
    "Financial Year To": 2012,
    "Permit Number": "468/2012",
    "Permit Date": "2012-02-28T03:50:20Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.318,
    "Total Amount Of Capital (in Millions)": 1.318,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "4-28, Tokiwacho, Chigasaki- Shi, Kanagawa-Pref, Japan",
    "Organization Address": "204-2, Namazu, Mizuho-Shi, Gifu-Ken, Japan",
    "Investment Permitted Address":
      "Plot No. 26/1, Kwin No 691 (Katawkan Kwin), Mangalar Quarter, Taik Kyee Township, Northern Yangon Region",
  },
  {
    ID: 2271,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Franz Koller",
    "Name of Principal Organization": "Higson International Pte Ltd 6",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Eurogate Sportswear Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "477/2012",
    "Permit Date": "2012-05-03T03:59:58Z",
    "Meeting Number": "11/2012",
    "Meeting Date": "2012-04-04T04:01:10Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.5,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Silk Garment Industrial Company Limited",
    "Land Area (units not specified in file)": 0.955,
    "Lease Term": 30,
    "Annual Lease Fee": 0.5,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "6, Eu Tong Sen Street, # 07-15, The Central Soho 1 Office Tower, Singapore 059817",
    "Organization Address":
      " Eu Tong  Sen Street, # 07-15, The Central Soho 1, Office Tower, Singapore 059817",
    "Investment Permitted Address":
      "No. 473 (A-3), Mogoke Street Industrial Zone (1), South Dagon Township, Yangon Region",
  },
  {
    ID: 2272,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Hong In Pyo",
    "Name of Principal Organization": "Hi-Mo Inc",
    "Place of Incorporation": "Korea",
    "Company Name In Myanmar": "MacDo Company Limited",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "483/2012",
    "Permit Date": "2012-05-29T04:22:41Z",
    "Meeting Number": "13/2012",
    "Meeting Date": "2012-05-09T04:23:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production and sale of Wig, Toupee and related products",
    "Amount Of Foreign Capital USD (in Millions)": 11.316,
    "Total Amount Of Capital (in Millions)": 11.316,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 36,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "Mingaladon Industrial Park Company Limited",
    "Land Area (units not specified in file)": 39161.22,
    "Lease Term": 36,
    "Annual Lease Fee": 0.012,
    "Land Use Premium": 1233578.43,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "F3 Cheil Fire Insurance Building 1354-5 Seocho-Dongseocho-Gu, Seoul, Republic of Korea",
    "Organization Address": "Seoul, Republic of Korea",
    "Investment Permitted Address":
      "Plot No- A-13-1 & A-13-2, Mingaladon Industrial Park, Mingaladon Township, Yangon Region",
  },
  {
    ID: 2273,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kim Chul Soo",
    "Name of Principal Organization": "Sshinsung Tonsgsan Company Limited",
    "Place of Incorporation": "Korea",
    "Company Name In Myanmar": "Shinsung Tongsang International Co., Ltd. ",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "484/2012",
    "Permit Date": "2012-05-28T04:49:38Z",
    "Meeting Number": "14/2012",
    "Meeting Date": "2012-05-17T04:49:57Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and marketing of Bags (Back Pack, School Bag, Sport Bag) on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.5,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 18,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "Myanma Textile Industries",
    "Land Area (units not specified in file)": 3975.145,
    "Lease Term": 18,
    "Annual Lease Fee": 0.012,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Room No. 501, Han SOL Building, No.415-11, Glidong, Gangdong Gu, Seoul, Korea",
    "Organization Address":
      "#444 Dunchon-Dong, Shinsung Tongsang Building, Gang Dong-Gu, Seoul, Korea",
    "Investment Permitted Address":
      "Textile factory, Corner of Thiri Mingalar Road  & Lower Mingaladon Road, Insein Township, Yangon Region",
  },
  {
    ID: 2274,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr, Hirai Takao",
    "Name of Principal Organization": "THY Pte Ltd",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "THY Garment Co., Ltd. ",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "478/2012",
    "Permit Date": "2012-05-28T05:09:42Z",
    "Meeting Number": "12/2012",
    "Meeting Date": "2012-05-02T05:09:55Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.638,
    "Total Amount Of Capital (in Millions)": 0.638,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Zin Zin Tun",
    "Land Area (units not specified in file)": 0.398,
    "Lease Term": 5,
    "Annual Lease Fee": 0.013,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "1-11-34, Funabashi-City, Chiba, Japan",
    "Organization Address":
      "9 Penang Road #07-15, Park Mali, Singapore (238459)",
    "Investment Permitted Address":
      "Plot No. 19/381, Kanaung Min Thar Gyi Street, Shwe Paukkan Industrial Zone, Yangon Region",
  },
  {
    ID: 2275,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kang Young Jin",
    "Name of Principal Organization": "Cross World Inc.",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Korea Link Industrial  Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "485/2012",
    "Permit Date": "2012-05-28T07:00:19Z",
    "Meeting Number": "14/2012",
    "Meeting Date": "2012-05-17T07:01:23Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.72,
    "Total Amount Of Capital (in Millions)": 0.72,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "Myanmar Kind Link Company Limited",
    "Land Area (units not specified in file)": 0.964,
    "Lease Term": 30,
    "Annual Lease Fee": 0.014,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "2-7-3 Kasuga Bunkyo-Ku, Tokyo, Japan",
    "Organization Address":
      "Chmapion Tower Bldg. 1 F, 2-25-2, Hamacyo, Nihonnbashi, Cyuo-Ku, Tokyo, Japan",
    "Investment Permitted Address":
      "No. 68 Corner of Min Gyi Mahar Min Gaung Street and Min Theikdi Kyaw Swar Street, Hlaing Tharyar Industry Zone (3), Yangon Region",
  },
  {
    ID: 2276,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. CHANG BUM PARK",
    "Name of Principal Organization": "EUNSUNG CORPORATION",
    "Place of Incorporation": "REPUBLIC OF KOREA",
    "Company Name In Myanmar": "MYANMAR SILVER CASTLE COMPANY LIMITED",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "353/2000",
    "Permit Date": "2000-11-30T08:11:27Z",
    "Meeting Number": "33/2000",
    "Meeting Date": "2000-10-02T08:11:59Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF KNITWEARS AND GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "DEPARTMENT OF HUMAN SETTLEMENT AND HOUSING DEVELOPMENT ",
    "Land Area (units not specified in file)": 2.536,
    "Lease Term": 15,
    "Annual Lease Fee": 0.03,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "ROOM NO. 302, 764-16 SUCK-SU-DONG, AN-YANG SI, KYUNG-GI DO, REPUBLIC OF KOREA",
    "Organization Address":
      "ROOM NO. 604, SAEHAN VENTURE WORLD BUILDING 113-15, SHIHUNG DONG, KEMCHUN GU,  SEOUL, REPUBLIC OF KOREA",
    "Investment Permitted Address":
      "PLOT NO. 29, YANGON INDUSTRIAL PARK, NOTRH OKKALAPA TOWNSHIP, YANGON",
  },
  {
    ID: 2277,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "486/2012",
    "Name of Principal Organization": "Sun-Flower Lace (H.K) Company Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Sun-Flower Lace Company Limited",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "486/2012",
    "Permit Date": "2012-06-23T08:40:51Z",
    "Meeting Number": "15/2012",
    "Meeting Date": "2012-05-30T08:41:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and marketing of Ladies Garments & Embroidery on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3,
    "Total Amount Of Capital (in Millions)": 3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 36,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "FDII",
    "Land Owner": "Mingaladon Industrial Park Company Limited",
    "Land Area (units not specified in file)": 25872.46,
    "Lease Term": 36,
    "Annual Lease Fee": 0.008,
    "Land Use Premium": 831023.42,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 36, Aly.161, Hexing LN., Pitou Township, Changhua Country 523, Taiwan, The People's Republic of China",
    "Organization Address":
      "Unit 1111, 11/F, Trendy Centre, 682 Castle Peak Road, Kowloon, Hong Kong",
    "Investment Permitted Address":
      "Plot No. D-7, D-9, Mingaladon Industrial Park, Mingaladon Township, Yangon Region.",
  },
  {
    ID: 2278,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chen Ken Chien Yu",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "Canada",
    "Company Name In Myanmar": "Glowing & Win  Investment Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "488/2012",
    "Permit Date": "2012-07-02T09:10:14Z",
    "Meeting Number": "18/2012",
    "Meeting Date": "2012-06-28T09:10:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and marketing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.01,
    "Total Amount Of Capital (in Millions)": 1.01,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Canada",
    "Form Of Investment": "FDII",
    "Land Owner": "A dream of Kind Garment Factory Company Limited",
    "Land Area (units not specified in file)": 4.811,
    "Lease Term": 30,
    "Annual Lease Fee": 0.13,
    "Land Use Premium": null,
    "Number Of Local Employees": 1511,
    "Number Of Foreign Employees": 12,
    Status: "Monitoring Approved",
    "Investor Address": "1319 West 47 Avenue Vancouver BC V6M2L7 Canada",
    "Organization Address": "1319 West 47 Avenue Vancouver BC V6M2L7 Canada",
    "Investment Permitted Address":
      "Plot No. 272, 273, 276, 277, Yangon Industrial Zone, North Okkalapa Township, Yangon Region",
  },
  {
    ID: 2279,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. WU YUNSHENG",
    "Name of Principal Organization": "SHANGHAI WORLDBEST CO., LTD.",
    "Place of Incorporation": "SHANGHAI, CHINA",
    "Company Name In Myanmar": "SHANGHAI WORLDBEST  (YANGON) CO., LTD.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "354/2000",
    "Permit Date": "2000-12-16T08:28:58Z",
    "Meeting Number": "38/2000",
    "Meeting Date": "2000-11-24T08:29:28Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "SPINNING MILL FOR MANUFACTURING OF VARIOUS TYPES OF YARNS  ",
    "Amount Of Foreign Capital USD (in Millions)": 28.98,
    "Total Amount Of Capital (in Millions)": 28.98,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "ROOM 603, NO. 81, JIN HUI GARDEN, NO. 688 HONG JING ROAD, MIN HANG DISTRICT, SHANGHAI, CHINA ",
    "Organization Address":
      "31 F, CHINA MERCHANTS TOWER, NO. 161, LU JIA ZUI ROAD(E), PUDONG, SHANGHAI, CHINA ",
    "Investment Permitted Address":
      "PLOT NO. 35, 36, 37, 38, 39, 40,41, YANGON INDUSTRIAL PARK, NORTH OKKALAPA TOWNSHIP, YANGON",
  },
  {
    ID: 2280,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mrs. Jin Yingshu",
    "Name of Principal Organization": "Liaoning Huayi Apparel Company Limited",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Myanmar Huayi Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "669/2014",
    "Permit Date": "2014-03-03T09:57:22Z",
    "Meeting Number": "3/2014",
    "Meeting Date": "2014-01-24T09:59:03Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.1,
    "Total Amount Of Capital (in Millions)": 2.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Tin Shin",
    "Land Area (units not specified in file)": 2.438,
    "Lease Term": 50,
    "Annual Lease Fee": 0.069,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "22nd Floor, No.88, Zhongshan Road, Zhongshan District, Dalian City, People's Republic of China",
    "Organization Address":
      "22nd Floor, No.88, Zhongshan Road, Zhongshan District, Dalian City, People's Republic of China",
    "Investment Permitted Address":
      "Myay Taing No. 25, Plot No. 40, Mingtheikdi Kyaw Swar Road, Shwe Linpan Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2281,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Cho Jung Yule",
    "Name of Principal Organization": "Royal M&T Company Limited",
    "Place of Incorporation": "Korea",
    "Company Name In Myanmar": "Royal M & T Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "674/2014",
    "Permit Date": "2014-03-03T03:05:40Z",
    "Meeting Number": "4/2014",
    "Meeting Date": "2014-01-30T03:05:56Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Silver and brass fancy item  on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.495,
    "Total Amount Of Capital (in Millions)": 0.495,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Maung Maung Lay",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 15,
    "Annual Lease Fee": 21,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "# 509-406, Oquem Dong, Gumpo-Si, Kenaaido, Republic of Korea",
    "Organization Address":
      "# 401, 101 Yulkokro-10-Gil, Jongno-Gu, Seoul, Republic of Korea",
    "Investment Permitted Address":
      "Plot No. 70, Myay Taing Block No. 113, U Mhole Street, Dagon (East) Industrial Zone (1), Dagon (East) Township, Yangon Region",
  },
  {
    ID: 2282,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhang Yonghong",
    "Name of Principal Organization":
      "Hangzhou Hundred-Tex Garment Company Limited",
    "Place of Incorporation": "China",
    "Company Name In Myanmar":
      "Hangzhou Hundred-Tex Garment (Myanmar) Company Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "675/2014",
    "Permit Date": "2014-03-03T03:20:02Z",
    "Meeting Number": "5/2014",
    "Meeting Date": "2014-02-05T03:20:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 4,
    "Total Amount Of Capital (in Millions)": 4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Ke Soe Kuma @ U Khin Soe",
    "Land Area (units not specified in file)": 1.396,
    "Lease Term": 30,
    "Annual Lease Fee": 0.086,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "South of  Hongda Road/ East of Road, No. 13, Qiaonan District, Xiaoshan Economic & Technological Development Zone, Xiaoshan district, Hangzhou City, Zhejiang Province, People's Republic of China",
    "Organization Address":
      "South of  Hongda Road/ East of Road, No. 13, Qiaonan District, Xiaoshan Economic & Technological Development Zone, Xiaoshan district, Hangzhou City, Zhejiang Province, People's Republic of China",
    "Investment Permitted Address":
      "Plot No. 349, Myay Taing Block No. 25, Kin Wun Min Gyi Road, Shwe Lin Pan Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2283,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Jea Gab Ryu",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Chamzon Apparel Manufacturing Company Limited",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "549/2013",
    "Permit Date": "2013-01-28T03:32:25Z",
    "Meeting Number": "4/2013",
    "Meeting Date": "2013-01-23T03:32:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.501,
    "Total Amount Of Capital (in Millions)": 0.501,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Tun Wai & Kon Ah He @ Daw Khin Khin Soe",
    "Land Area (units not specified in file)": 5212.36,
    "Lease Term": 30,
    "Annual Lease Fee": 0.029,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "789-6, Yeaksam-Dong, Kangman-Ku, Seoul, Republic of Korea",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No. 33 (B), Pantiewon U Shwe Binn Street, Hlaing Tharyar Industrial Zone (1), Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 2284,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mrs. Tse Yuet Yu",
    "Name of Principal Organization": "Archid Garment Factory Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "AMG Factory Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "550/2013",
    "Permit Date": "2013-01-02T03:40:10Z",
    "Meeting Number": "4/2013",
    "Meeting Date": "2013-01-23T03:40:52Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.004,
    "Total Amount Of Capital (in Millions)": 1.004,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaw Myint @ U Kyaung Maing ",
    "Land Area (units not specified in file)": 2.372,
    "Lease Term": 30,
    "Annual Lease Fee": 0.053,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "P 9, San Simeon Avenue, Royal Palms, Yuen Long, Hong Kong",
    "Organization Address":
      "Flat RM/3, 15F, Po Yi Bldg, 60-70 Texaco Road, Tsuen Wan, N.T, Hong Kong",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၅၁-၅၂၊ မြေတိုင်းရပ်ကွက်အမှတ်-၂၅၊ ရွှေလင်ပန်းစက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန် တိုင်းဒေသကြီး",
  },
  {
    ID: 2285,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wang Genquan",
    "Name of Principal Organization": "Sunflower-Lace (HK) Company Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Linda Fashion (Myanmar) Company Limited",
    "Financial Year From": 12,
    "Financial Year To": 13,
    "Permit Number": "551/2013",
    "Permit Date": "2013-01-28T03:50:51Z",
    "Meeting Number": "4/2013",
    "Meeting Date": "2013-01-23T03:51:25Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and marketing of Garments, Garment's Accessories, Lace and Farbic under CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.6,
    "Total Amount Of Capital (in Millions)": 2.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 36,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Mingaladon Industrial Park Company Limited",
    "Land Area (units not specified in file)": 6.15,
    "Lease Term": 36,
    "Annual Lease Fee": 0.007,
    "Land Use Premium": 945136,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Amended",
    "Investor Address":
      "No. 487, Yao Chang Zhuang, XZi Qiao Cun, Yanshan Township, Bengbu , Bengshan, Anhui, Republic of China",
    "Organization Address":
      "Unit 1111, 11/F., Trendy Centre, 682-684 Castle peak Road, Kowloon, Hong Kong",
    "Investment Permitted Address":
      "Plot No. C-3, Mingaladon Industrial Park, Mingaladon Township, Yangon Region",
  },
  {
    ID: 2286,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Myo Min Htut",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Myanmar Jin Yuan Construction Materials Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "129/2018",
    "Permit Date": "2018-12-21T04:54:07Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T04:54:11Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ဆောက်လုပ်ရေးသုံးလုပ်ငန်းများထုတ်လုပ်ခြင်းနှင့် ဖြန့်ဖြူးရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 3.002,
    "Total Amount Of Capital (in Millions)": 3.597,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "U Shwe Htoo",
    "Land Area (units not specified in file)": 22.632,
    "Lease Term": 50,
    "Annual Lease Fee": 49.999,
    "Land Use Premium": null,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": 29,
    Status: "Draft",
    "Investor Address":
      "No.96,Room(1 to 5), Saw Bwar Gyi Gone, Insein Township,Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Myay Taing Block No ( Near Anant Zone) Da La Ban, Plot No. (2,3,4,5,6,7,8,9,10,11), Dagon Myothit (Seikkan) Township,Yangon Region ",
  },
  {
    ID: 2287,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Liu Gong",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Gaiwach (Myanmar) Garment Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "118/2018",
    "Permit Date": "2018-12-21T05:42:55Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T05:42:59Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.921,
    "Total Amount Of Capital (in Millions)": 1.921,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaw Zay Yar Lin",
    "Land Area (units not specified in file)": 2.98,
    "Lease Term": 15,
    "Annual Lease Fee": 0.0663,
    "Land Use Premium": null,
    "Number Of Local Employees": 883,
    "Number Of Foreign Employees": 20,
    Status: "Draft",
    "Investor Address":
      "5A, Building 1-6, Tian FA Tower, Tian An Cyber Park, Futian, Shenzhen City, Guangdong, Province , People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.87,88 , Myay Taing Block No.51, Thar Du Kan Industrial Zone, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 2288,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Li Aiping",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Haotian Luggage Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "126/2018",
    "Permit Date": "2018-12-21T06:46:28Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T06:46:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMPစနစ်ဖြင့် Hardside Luggage အမျိုးမျိုးထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.685,
    "Total Amount Of Capital (in Millions)": 0.685,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Myo",
    "Land Area (units not specified in file)": 2.762,
    "Lease Term": 5,
    "Annual Lease Fee": 198,
    "Land Use Premium": null,
    "Number Of Local Employees": 550,
    "Number Of Foreign Employees": 20,
    Status: "Draft",
    "Investor Address":
      "2-306, Jian Nan Apartment Jiaxing City, Nanhu District, Zhejiang Province, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.148, Myay Taing Block No.14, Shwe Than Lwin Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2289,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lau Wai Tak",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Hip Lik Enterprise Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "127/2018",
    "Permit Date": "2018-12-21T07:17:45Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T07:18:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMPစနစ်ဖြင့် ထုတ်ပိုးပစ္စည်းအမျိုးမျိုးထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 3.54,
    "Total Amount Of Capital (in Millions)": 3.54,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "တန်ရှုရင်(ခ) ဒေါ်မြင့်မြင့်ဦး၊ ဦးပြည့်ဖြိုးကျော်",
    "Land Area (units not specified in file)": 0.689,
    "Lease Term": 5,
    "Annual Lease Fee": 0.013941,
    "Land Use Premium": null,
    "Number Of Local Employees": 119,
    "Number Of Foreign Employees": 22,
    Status: "Draft",
    "Investor Address":
      "6/F CNT, Commercial Building, No.302 Queen's Road Central, Hong Kong",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 27,28, Myay Taing Block No.5, Hlaing Thar Yar Township ,Yangon Region",
  },
  {
    ID: 2290,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Minoru Senda",
    "Name of Principal Organization": "Atelier E & M Company Limtied",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Atelier E & M International Co.,Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "552/2013",
    "Permit Date": "2013-01-31T07:34:19Z",
    "Meeting Number": "5/2013",
    "Meeting Date": "2013-01-30T07:34:40Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of wedding dress on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.5,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Khin Lei Lei Naing",
    "Land Area (units not specified in file)": 0.406,
    "Lease Term": 0,
    "Annual Lease Fee": 0.012,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "11, Hmimemiya, Ryugasaki, Ibaraki, 301-0017, Japan",
    "Organization Address":
      "11, Hmimemiya, Ryugasaki, Ibaraki, 301-0017, Japan",
    "Investment Permitted Address":
      "Plot No.  7, Kanaung Min Thar Gyi Street, Shwe Pauk Kan Industrial Zone, North-Okkalapa Township, Yangon Region",
  },
  {
    ID: 2291,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhou Hexing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Hengda (Myanmar) Apparel Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "119/2018",
    "Permit Date": "2018-12-21T07:33:35Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T07:33:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3.09,
    "Total Amount Of Capital (in Millions)": 3.09,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Nan Khin Win Kyi (@) Su Thet Paing",
    "Land Area (units not specified in file)": 1.35,
    "Lease Term": 10,
    "Annual Lease Fee": 15.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 2500,
    "Number Of Foreign Employees": 30,
    Status: "Draft",
    "Investor Address":
      "No.134, Remin Road, Wenlin Zhutang Township, Jiangyin City, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "ဦးပိုင်အမှတ်(၁၅/၁) ၊ ကွင်းအမည် ၅၇၇-အင်းလျှက်၊ ဦးပိုင်အမှတ်(၁၆/၁)၊ ကွင်းအမည် ၅၇၇-ကျောက်ပုန်း၊ အင်းလျက်ကျေးရွာအုပ်စု၊ မှော်ဘီမြို့နယ်၊ မြောက်ပိုင်းခရိုင်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2292,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yu Jian Chen",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Khaing Khaing Sang Da Group Co.,Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "561/2013",
    "Permit Date": "2013-01-13T07:44:29Z",
    "Meeting Number": "7/2013",
    "Meeting Date": "2013-02-13T07:44:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and marketing of Motor Vehicles",
    "Amount Of Foreign Capital USD (in Millions)": 2.09,
    "Total Amount Of Capital (in Millions)": 2.16,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Lai Lai Khaing",
    "Land Area (units not specified in file)": 1.42,
    "Lease Term": 30,
    "Annual Lease Fee": 0.034,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "No. 8 , Fu Jian, People's Republic of China",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No. 79, Thardukan Industrial Zone (3/4), Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 2293,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Lin Hsiu Ying",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Ta Kung Garment Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "130/2018",
    "Permit Date": "2018-12-21T08:03:20Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T08:03:28Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.969,
    "Total Amount Of Capital (in Millions)": 0.969,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "FDII",
    "Land Owner": "ဦးထွန်းအောင်ကျော်",
    "Land Area (units not specified in file)": 1.826,
    "Lease Term": 10,
    "Annual Lease Fee": 6.234,
    "Land Use Premium": null,
    "Number Of Local Employees": 291,
    "Number Of Foreign Employees": 9,
    Status: "Draft",
    "Investor Address":
      "No.1, Ln.156, Sec-1, Lingyun Rd, Wugu Dist,New Taipei City, Taiwan, Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.119, Myay Taing Block No. Myaung Ta Kar Steel Industrial Zone, Hmawbi Township, Yangon Region",
  },
  {
    ID: 2294,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Choo Yan Ho",
    "Name of Principal Organization":
      "Stada Vietnam Joint Venture Company Limited",
    "Place of Incorporation": "Vietnam",
    "Company Name In Myanmar": "Stada Myanmar Joint Venture Co.,Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "563/2013",
    "Permit Date": "2013-02-22T07:54:51Z",
    "Meeting Number": "8/2013",
    "Meeting Date": "2013-02-20T07:55:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and marketing of pharmaceutical products",
    "Amount Of Foreign Capital USD (in Millions)": 9.39,
    "Total Amount Of Capital (in Millions)": 20,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Vietnam",
    "Form Of Investment": "JV",
    "Land Owner": "U Tun Kyaing (a) U Zaw Lay",
    "Land Area (units not specified in file)": 3.81,
    "Lease Term": 50,
    "Annual Lease Fee": 0.093,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No. 23 (A), Tower - 2 Subang Boulovard Subang Jaya, Malaysia",
    "Organization Address":
      "K 63/1 Nguyen Thi Soc, My Hoa 2 Hamlet, Xuan Thoi Dong Ward, Hoc Mon District, Ho Chi Minh City, Sr Vietnam",
    "Investment Permitted Address":
      "Land Ward No. 25, Plot No. 452, 453, Shwe Lin Pan-Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2295,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Myint Oo",
    "Name of Principal Organization": "M.K  Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Pattaya Myanmar Co.,Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "564/2013",
    "Permit Date": "2013-02-22T08:15:17Z",
    "Meeting Number": "8/2013",
    "Meeting Date": "2013-02-20T08:18:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and marketing for Ladies' underwear (Brassiere and underwear) and Nightwear on FOB Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.68,
    "Total Amount Of Capital (in Millions)": 0.8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 42,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "M.K Company Limited",
    "Land Area (units not specified in file)": 0.97,
    "Lease Term": 42,
    "Annual Lease Fee": 0.026,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No. 333, Pyay Road, Sanchaung Township, Yangon Region, Myanmar",
    "Organization Address":
      "No. 333, Pyay Road, Sanchaung Township, Yangon Region, Myanmar",
    "Investment Permitted Address":
      "Plot No. 16, Pancha Twun U Shwe Owe Road, Hlaing Tharyar Industrial Zone (2), Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2296,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Chang San Ping",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Rain Mart Enterprise Corporation Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "131/2018",
    "Permit Date": "2018-12-21T08:27:43Z",
    "Meeting Number": "16/2018",
    "Meeting Date": "2018-12-21T08:27:47Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.165,
    "Total Amount Of Capital (in Millions)": 2.165,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Khin Than Win @ Kaw Wai Chaing",
    "Land Area (units not specified in file)": 3.68,
    "Lease Term": 5,
    "Annual Lease Fee": 120,
    "Land Use Premium": null,
    "Number Of Local Employees": 524,
    "Number Of Foreign Employees": 16,
    Status: "Draft",
    "Investor Address":
      "Leli (3) Street, No.203(10F), Anle Dist, Keelung City, Taiwan, Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 17, Myay Taing Block No. Yangon Industrial Zone, North Oakkalapa Township, Yangon Region",
  },
  {
    ID: 2297,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wang Jianhong",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Kun Yun Plate Making Co.,Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "569/2013",
    "Permit Date": "2013-03-13T08:40:00Z",
    "Meeting Number": "9/2013",
    "Meeting Date": "2013-02-27T08:40:14Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and marketing of printing plates",
    "Amount Of Foreign Capital USD (in Millions)": 0.5,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw San San Myint",
    "Land Area (units not specified in file)": 1.001,
    "Lease Term": 10,
    "Annual Lease Fee": 0.046,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Room No. 406, Unit 6 , Building 15, International Garden Resiential District, Middle Haiyuan Road, Wuhua District, Kunming City, Yunnan Province, People's Republic of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 89, Survey Block 4, Kin Wun Min Gyi Street, Hlaing Thar Yar Industrial Zone 4, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2298,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Mok Cham Hung, Chadwick",
    "Name of Principal Organization": "E & E Magnetic Holdings Ltd.",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "E & E Magnetic Products Myanmar Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "571/2013",
    "Permit Date": "2013-03-13T08:50:52Z",
    "Meeting Number": "10/2013",
    "Meeting Date": "2013-03-13T08:51:02Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing for magnetic and electronic products on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3,
    "Total Amount Of Capital (in Millions)": 3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner":
      "U Than Maung, U Hla Thaung, Daw Myint Myint Win, Daw Khin Thein, Daw Khin Htar Yee, Daw Thein Thein Mya",
    "Land Area (units not specified in file)": 1.471,
    "Lease Term": 20,
    "Annual Lease Fee": 0.042,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "4 A, 20 Babinggon Path, Hong Kong",
    "Organization Address":
      "1/F, Harbour View 1, NO. 12, Science Park East Avenue, Phase II, Hong Kong Science Park, Shatin, New  Territories, Hong Kong",
    "Investment Permitted Address":
      "Plot  No. 240, Kanaung Min Thar Gyi Street, Hlaing Thar Yar Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2300,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Thanakorn Ruamrak",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar S.M.C Garment Company Limited",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "567/2013",
    "Permit Date": "2013-03-18T09:23:55Z",
    "Meeting Number": "9/2013",
    "Meeting Date": "2013-02-27T09:24:29Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.44,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Sanda Nyein",
    "Land Area (units not specified in file)": 0.263,
    "Lease Term": 10,
    "Annual Lease Fee": 0.01,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.1042, 44-46 Sukhumvit SOI 101, Prakanong Bangkok 10260, Thailand",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Block No. 574, Lot No. 2/3 Ka + 3/1 Kha+2/4 Ka, Kyunt Taw North Block, Satthwardaw Village, Hmawbi Township, Yangon Region",
  },
  {
    ID: 2301,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. CHANG KWON KIM",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "HARMONY MYANMAR COMPANY LIMITED",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "527/2012",
    "Permit Date": "2012-12-14T04:18:09Z",
    "Meeting Number": "36/2012",
    "Meeting Date": "2012-11-29T04:18:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF GARMENT UNDER CMP BASIS (INCLUDING PRINTING & EMBROIDERY)",
    "Amount Of Foreign Capital USD (in Millions)": 0.7,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "JV",
    "Land Owner": "-",
    "Land Area (units not specified in file)": 2.987,
    "Lease Term": 10,
    "Annual Lease Fee": 0.048,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "152-23, DONGCHEON-RI, JINWI-MYEON, PYEONGTAEKSI, GYEONGGI-DO, KOREA",
    "Organization Address": "-",
    "Investment Permitted Address":
      "NO.182/3,182/4, BAMAW AHTWIN WUN STREET, SHWE LINBAN INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2302,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Srikanth Srinivasamadhavn  ",
    "Name of Principal Organization": "UNILEVER ALSER B.V. ",
    "Place of Incorporation": "THE NETHERLANDS",
    "Company Name In Myanmar": "Unilever EAC Myanmar Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "528/2012",
    "Permit Date": "2012-12-18T04:43:13Z",
    "Meeting Number": "36/2012",
    "Meeting Date": "2012-11-29T04:43:42Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF HAIR CARE PRODUCTS (SHAMPOO, HAIR CONDITIONERS AND HAIR TREATMENTS)",
    "Amount Of Foreign Capital USD (in Millions)": 3.813,
    "Total Amount Of Capital (in Millions)": 3.813,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Netherlands",
    "Form Of Investment": "JV",
    "Land Owner": "U GAW KYOKE SWAN @ U NI",
    "Land Area (units not specified in file)": 3.004,
    "Lease Term": 5,
    "Annual Lease Fee": 0.102,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "6 SOI SUKHUMVIT 49/10, KLONGTON NUA, WATTANA, BANGKOK 10110, THAILAND",
    "Organization Address": "3013 AL, ROTTERDAM, WEENA 455, THE NETHERLANDS",
    "Investment Permitted Address":
      "PLOT NO. 40, 41,47, MIN THATE HTI KYAW SWAR ROAD, (39) WARD, SHWE PYI THAR INDUSTRIAL ZONE(2), SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2303,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Srikanth Srinivasama-dhavan",
    "Name of Principal Organization": "UNILEVER ALSER B.V",
    "Place of Incorporation": "THE NETHERLAND",
    "Company Name In Myanmar": "UNILEVER  MYANMAR LIMITED",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "529/2012",
    "Permit Date": "2012-12-18T05:05:07Z",
    "Meeting Number": "36/2012",
    "Meeting Date": "2012-11-29T05:06:05Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF FOOD PRODUCTS (RIDE PORRIDGE, SEASONING AND MEAL MAKER)",
    "Amount Of Foreign Capital USD (in Millions)": 6.488,
    "Total Amount Of Capital (in Millions)": 6.488,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Netherlands",
    "Form Of Investment": "FDII",
    "Land Owner": "U GAW KYOKE SWAN @ U NI",
    "Land Area (units not specified in file)": 3.004,
    "Lease Term": 5,
    "Annual Lease Fee": 0.102,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "2811 Kohinoor City, Phase III, Kurla West, Mumbai- 400070, India",
    "Organization Address": "3013 AL, ROTTERDAM, WEENA 455, THE NETHERLANDS",
    "Investment Permitted Address":
      "PLOT NO. 40,41, 47, MIN THATE HTI KYAW SWAR ROAD, (39) WARD, SHWE PYI THAR INDUSTRIAL ZONE(2), SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2304,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LEE KWOK SUN THOMAS",
    "Name of Principal Organization": "MOOREFIELD LIMITED",
    "Place of Incorporation": "HONG KONG",
    "Company Name In Myanmar": "ZKG (MYM) LIMITED",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "530/2012",
    "Permit Date": "2012-12-14T05:25:32Z",
    "Meeting Number": "36/2012",
    "Meeting Date": "2012-11-29T05:26:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENTS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.681,
    "Total Amount Of Capital (in Millions)": 0.681,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW LEI LEI AUNG ",
    "Land Area (units not specified in file)": 1.146,
    "Lease Term": 30,
    "Annual Lease Fee": 0.025,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "ROOM-3717, ASIA TRADE CENTRE, 79 LEI MUK ROAD, KWAI CHUNG, NEW TERRITORIES, HONG KONG",
    "Organization Address":
      "ROOM -3702, ASIA TRADE CENTRE, 79 LEI MUK ROAD, KWAI CHUNG, NEW TERRITORIES, HONG KONG",
    "Investment Permitted Address":
      "PLOT NO. 271, CORNER OF PANBE GAUNG MAUNG KHET STREET AND U TAYOKE STREET, WARD 25, SHWE LIN PAN INDUSTRIAL ZONE, HLAING THARYAR TOWNSHIP YANGON",
  },
  {
    ID: 2305,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. PARK CHUL JOO",
    "Name of Principal Organization": "BUWON ELECTRONIC INDUSTRY",
    "Place of Incorporation": "REPUBLIC OF KOREA",
    "Company Name In Myanmar": "M.BUWON ELECTRONIC COMPANY LIMITED",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "531/2012",
    "Permit Date": "2012-12-12T05:38:32Z",
    "Meeting Number": "36/2012",
    "Meeting Date": "2012-11-29T05:39:09Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF ELECTRONIC SPAREPARTS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.821,
    "Total Amount Of Capital (in Millions)": 0.821,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW OHN MAR MYINT",
    "Land Area (units not specified in file)": 5.014,
    "Lease Term": 30,
    "Annual Lease Fee": 0.115,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "117-1304, METRO CITY 84-1 YANGDUCK-DONG, MASANHEOWON -GU, CHANGWON CITY, KOREA",
    "Organization Address":
      "22/2, 981-1 JUNG-RI, NAESEO-EUP, MASAN - SI, GYEONGSANGNAM-DO, REPUBLIC OF KOREA",
    "Investment Permitted Address":
      "PLOT NO. 149/1, 149/2, EAST DAGON INDUSTRIAL ZONE(1), EAST DAGON TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2306,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. MASAYA SAITO",
    "Name of Principal Organization": "ROHTO PHARMACEUTICAL CO., LTD.",
    "Place of Incorporation": "JAPAN",
    "Company Name In Myanmar": "ROHTO-MENTHOLATUM (MYANMAR) CO., LTD.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "532/2012",
    "Permit Date": "2012-12-31T06:55:26Z",
    "Meeting Number": "36/2012",
    "Meeting Date": "2012-11-29T06:55:56Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF OTC MEDICINES & COSMECTICS",
    "Amount Of Foreign Capital USD (in Millions)": 12.438,
    "Total Amount Of Capital (in Millions)": 12.438,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 10,
    "Validity Of Investment Permit (in Years)": 36,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "MINGALARDON INDUSTRIAL PARK CO., LTD.",
    "Land Area (units not specified in file)": 2.472,
    "Lease Term": 36,
    "Annual Lease Fee": null,
    "Land Use Premium": 0.48,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "1-7-25-914, HIRANO-HIGASHI, HIRANO-KU, OSAKA, JAPAN",
    "Organization Address":
      "1-8-1, TATSUMI-NISHI, IKUNO-KU, OSAKA 544-8666, JAPAN",
    "Investment Permitted Address":
      "PLOT NO. D-5, MINGALARDON INDUSTRIAL PARK, MINGALARDON TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2307,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. SEONG JAE HO",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "GARMENT & PROCESS GLOBAL COMPANY LIMITED",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "533/2012",
    "Permit Date": "2012-12-18T07:32:31Z",
    "Meeting Number": "37/2012",
    "Meeting Date": "2012-12-12T07:33:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.524,
    "Total Amount Of Capital (in Millions)": 0.524,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": 1.549,
    "Lease Term": 30,
    "Annual Lease Fee": 0.034,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 24, 45TH ROAD, HUKKYORO, BOSOODONG 3 GA, JOONGGU BUSAN, REPUBLIC OF KOREA ",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 42/106, CHERRY STREET, SHWE PYI THAR INDUSTRIAL ZONE 1, SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2308,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. YANG HSIN",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "POPULAR INTERNATIONAL GARMENT MANUFACTURING CO., LTD.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "534/2012",
    "Permit Date": "2012-12-31T07:52:23Z",
    "Meeting Number": "37/2012",
    "Meeting Date": "2012-12-12T07:52:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.5,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U AUNG MYINT",
    "Land Area (units not specified in file)": 0.854,
    "Lease Term": 10,
    "Annual Lease Fee": 0.036,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "3F, NO. 112, SEC.2, KEELUNG ROAD, DA-AN DISTRICT, TAIPEI CITY, 10695, TAIWAN",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 29, BAMAW AHTWIN WUN STREET, HLAING THAR YAR INDUSTRIAL ZONE(3), HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2309,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wang Shaohua",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "WIN GLORY INTERNATIONAL MANUFACTURING CO., LTD.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "535/2012",
    "Permit Date": "2012-12-31T08:02:14Z",
    "Meeting Number": "37/2012",
    "Meeting Date": "2012-12-12T08:02:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.5,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U HTAY YIN",
    "Land Area (units not specified in file)": 0.551,
    "Lease Term": 10,
    "Annual Lease Fee": 0.03,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Flat/RMB 15/F 78 Hung To Road, Kwun Tong, Kowloon, Hong Kong.",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 42, BAMAW AHTWIN WUN STREET, HLAING THAR YAR INDUSTRIAL ZONE(3), HLAING THAR YAR TOWNSHIP, YANGON REGION.",
  },
  {
    ID: 2310,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS. LIM BEI BEI",
    "Name of Principal Organization": "ALLIANCE HOLDING CORPORATION",
    "Place of Incorporation": "RUNEI DARUSSALAM ",
    "Company Name In Myanmar": "ALLIANCE TRIMS COMPANY LIMITED ",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "536/2012",
    "Permit Date": "2012-12-31T08:17:39Z",
    "Meeting Number": "38/2012",
    "Meeting Date": "2012-12-19T08:18:05Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF GARMENT ACCESSORIES (ELASTIC WAISTBANDS, DRAWCORDS & STRINGS)",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Brunei Darussalam",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW KHIN WAH",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 10,
    "Annual Lease Fee": 0.022,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "2F, NO. 12, LANE 73, HEJIANG STREET, ZHONGSHAN DISTRICT, TAIPEI CITY 104, TAIWAN",
    "Organization Address":
      "ROOM 51, 5 TH FLOOR, BRITANNIA HOUSE, JALAN CATOR,  BANDAR SERI BEGAWAN BS 8811, NEGARA BRUNEI DARUSSALAM ",
    "Investment Permitted Address":
      "PLOT NO. 19, MYAWADDY MIN GYI STREET, INDUSTRIAL ZONE(4), HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2311,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Min Soo Chu (P.P No. 448048190) ",
    "Name of Principal Organization": "CMS Korea Global Inc.",
    "Place of Incorporation": "REPUBLIC OF KOREA",
    "Company Name In Myanmar": "CMS Apparel Yangon Company Limited ",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "517/2012",
    "Permit Date": "2012-11-16T09:25:47Z",
    "Meeting Number": "34/2012",
    "Meeting Date": "2012-11-14T09:26:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.649,
    "Total Amount Of Capital (in Millions)": 0.649,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U SOE AUNG ",
    "Land Area (units not specified in file)": 2.07,
    "Lease Term": 30,
    "Annual Lease Fee": 0.054,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "43, Springhouse Circle Manalapan NJ 07726 USA",
    "Organization Address":
      "802, Samseong-ro 430, Gangnam-gu, Seoul (Higlo Building, Daechi-dong)",
    "Investment Permitted Address":
      "PLOT NO. 84,65-SETMU U MYAE ROAD, SHWE PYI THAR INDUSTRIAL ZONE(4), SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2312,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LUYU HUANG ",
    "Name of Principal Organization":
      "JINGSU CENTURY LIAOYUAN KNITTED WEAR CO., LTD.",
    "Place of Incorporation": "PEOPLE'S REPUBLIC OF CHINA",
    "Company Name In Myanmar":
      "MYANMAR CENTURY LIAOYUAN KNITTED WEAR CO., LTD.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "635/2013",
    "Permit Date": "2013-11-19T09:37:24Z",
    "Meeting Number": "27/2013",
    "Meeting Date": "2013-10-24T09:37:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF KNITTED WEAR ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U MYO THANT",
    "Land Area (units not specified in file)": 2.275,
    "Lease Term": 30,
    "Annual Lease Fee": 0.109,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 18, FANGQUAN ROAD, JUEGANG TOWN, RUDONG COUNTRY, JINGSU PROVINCE, P.C-226400, THE PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address":
      "NO. 18, FANGQUAN ROAD, JUEGANG TOWN, RUDONG COUNTRY, JINGSU PROVINCE, P.C-226400, THE PEOPLE'S REPUBLIC OF CHINA",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၇၀)၊ မြေတိုင်းရပ်ကွက်အမှတ်(၂၄)၊ ငွေပင်လယ်စက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2313,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. SOMBOON YUPRAPAN",
    "Name of Principal Organization": "COMPLETE VICTORY LTD.",
    "Place of Incorporation": "BRITISH VIRGIN ISLANDS",
    "Company Name In Myanmar": "MINGALAR SUMBIRI GARMENT CO., LTD.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "636/2013",
    "Permit Date": "2013-11-19T09:56:27Z",
    "Meeting Number": "27/2013",
    "Meeting Date": "2013-10-24T09:57:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 3.6,
    "Total Amount Of Capital (in Millions)": 3.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Virgin Islands (British)",
    "Form Of Investment": "FDII",
    "Land Owner": "U TINT SHEIN ",
    "Land Area (units not specified in file)": 1.977,
    "Lease Term": 50,
    "Annual Lease Fee": 0.043,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "39 BLOCK B4/-02, JALAN TAMAN GOLF TIMUR, JAKATA, INDONESIA",
    "Organization Address":
      "P.O. BOX 957, OFFSHORE INCORPORATIONS CENTRE, ROAD TOWN, TORTOLA, BRITISH VIRGIN ISLANDS",
    "Investment Permitted Address":
      "PLOT NO. 27, YANGON INDUSTRY ZONE, NORTH OKKALARPA TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2314,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LEE CHUN FAI",
    "Name of Principal Organization": "WHALE FUN INTERNATIONAL LIMITED",
    "Place of Incorporation": "HONG KONG",
    "Company Name In Myanmar": "MYANMAR JIALE FASHION CO., LTD.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "637/2013",
    "Permit Date": "2013-11-19T10:08:16Z",
    "Meeting Number": "27/2013",
    "Meeting Date": "2013-10-24T10:09:03Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 2.519,
    "Total Amount Of Capital (in Millions)": 2.519,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U AH PA WU",
    "Land Area (units not specified in file)": 1.993,
    "Lease Term": 10,
    "Annual Lease Fee": 0.084,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "FLAT A,68 TH FLOOR, TOWER 3, HARBOURFRONT LANDMARK, 11 WAN HAI STREET, HUNG HOM, KOWLOON, HONG KONG",
    "Organization Address":
      " UNIT 1-2 12/F WING LEE INDUSTRIAL BUILDING, 54-58 TONG MEI ROAD, KOWLOON, HONG KONG",
    "Investment Permitted Address":
      "PLOT NO. 13, WARD NO.(14), SHWE THAN LWIN INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2315,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LIU ZEWEI",
    "Name of Principal Organization":
      "YI MEI FOOTWEAR PRODUCTS FACTORY CO., LTD.",
    "Place of Incorporation": "THE PEOPLE REPUBLIC'S OF CHINA",
    "Company Name In Myanmar": "YI MEI FOOTWEAR PRODUCTS FACTORY CO., LTD.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "638/2013",
    "Permit Date": "2013-11-19T10:29:29Z",
    "Meeting Number": "27/2013",
    "Meeting Date": "2013-10-24T10:30:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF ALL KINDS OF FOOTWEAR PRODUCTS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.514,
    "Total Amount Of Capital (in Millions)": 0.514,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U AUNG MOE @PHE YAW",
    "Land Area (units not specified in file)": 1.044,
    "Lease Term": 10,
    "Annual Lease Fee": 0.026,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.  144, LIZHUO VILLAGE,  SENGWEI CITY, GUANGDONG PROVINCE, THE PEOPLE REPUBLIC'S OF CHINA",
    "Organization Address":
      "GUANDI MOUNTAIN INDUSTRIAL AREA, HAICHENG TOWN, HAIFENG COUNTRY, THE PEOPLE REPUBLIC'S OF CHINA",
    "Investment Permitted Address":
      "PLOT NO. (10), U SHWE OH LANE (1), HLAING THAR YAR INDUSTRIAL ZONE (2), HLAING THAR YAR  TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2316,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. DOUGLAS EDWARD ZAPPELLI",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "GOLDEN JASMINE INTIMATES MANUFACTURING INTERNATIONAL CO., LTD.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "639/2013",
    "Permit Date": "2013-11-19T03:10:14Z",
    "Meeting Number": "27/2013",
    "Meeting Date": "2013-10-24T03:10:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.37,
    "Total Amount Of Capital (in Millions)": 0.53,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Australia",
    "Form Of Investment": "JV",
    "Land Owner": "U YIN MAUNG THEIN",
    "Land Area (units not specified in file)": 2.106,
    "Lease Term": 10,
    "Annual Lease Fee": 0.055,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Amend",
    "Investor Address":
      "63-67, sunshine rd, west fooscray, vic 3012, austrslia",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 103,WARD NO. 914), MINGYI MAHAR MIN KHAUNG ST., SHWE THAN LWIN INDUSTRIAL ZONE, HLAING THARYAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2317,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. HO KWONG KIN",
    "Name of Principal Organization": "NEW CENTURY INDUSTRIES CO., LTD.",
    "Place of Incorporation": "HONG KONG",
    "Company Name In Myanmar": "NEW CENTURY INDUSTRIES (MYANMAR) CO., LTD.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "641/2013",
    "Permit Date": "2013-12-06T03:34:15Z",
    "Meeting Number": "29/2013",
    "Meeting Date": "2013-11-06T03:35:58Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF VARIETIES OF PLASTIC PACKAGINGS AND GIFT BAGS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.9108,
    "Total Amount Of Capital (in Millions)": 1.9108,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U LIN TIKE HAUNG @U TIKE HAUNG, U TIKE CHAIN ",
    "Land Area (units not specified in file)": 2.011,
    "Lease Term": 30,
    "Annual Lease Fee": 0.044,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "ROOM 7, 7/F, FORTUNG COMMERCIAL BLDG, 362 SHA TSUI ROAD, TSUEN WAN, HONG KONG",
    "Organization Address":
      "ROOM 7, 7/F, FORTUNG COMMERCIAL BLDG, 362 SHA TSUI ROAD, TSUEN WAN, HONG KONG",
    "Investment Permitted Address":
      "NO. 85, MIN THEIKDI KYAW SWAR ROAD, HLAING THAR YAR INDUSTRIAL ZONE (3), HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2318,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Young Hwan, Ahn",
    "Name of Principal Organization": "Sam Young International Corporation",
    "Place of Incorporation": "Korea",
    "Company Name In Myanmar": "Myanmar Sam Young Company Limited",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "347/2000",
    "Permit Date": "2000-09-14T03:42:26Z",
    "Meeting Number": "19/2000",
    "Meeting Date": "2000-06-15T03:43:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Footwear (Sport & Trekking Shoes) Manufacturing on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.3,
    "Total Amount Of Capital (in Millions)": 4.3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "Department of Human Settlement and Housing Development",
    "Land Area (units not specified in file)": 5.453,
    "Lease Term": 20,
    "Annual Lease Fee": 0.066,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Terminated",
    "Investor Address":
      "# 1337,109-1902, Hyun Dae APT, Chwa-Dong Haeundae-Ku, Pusan, Korea",
    "Organization Address": "2F,223-3 Koje I Dong, Yon Je-Ku, Pusan, Korea",
    "Investment Permitted Address":
      "Plot No.247(A), Industrial Zone (2), Hlaing Thar Yar Township, Yangon",
  },
  {
    ID: 2319,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Beon, Lee",
    "Name of Principal Organization": "Esquire Co., Ltd.",
    "Place of Incorporation": "Korea",
    "Company Name In Myanmar": "Esquire International Co., Ltd.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "346/2000",
    "Permit Date": "2000-09-13T04:00:42Z",
    "Meeting Number": "22/2000",
    "Meeting Date": "2000-07-07T04:03:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Dress and Casual Shoes on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "Department of Human Settlement and Housing Development",
    "Land Area (units not specified in file)": 2,
    "Lease Term": 15,
    "Annual Lease Fee": 0.024,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "#24-1002,Walker-Hill APT,145-8, Kwang Jang - Dong, Kwang Jin-Ku, Seoul, Korea",
    "Organization Address":
      "656-75, Sung Su-Dong 1 Ka, Sungdong-Ku, Seoul , Korea",
    "Investment Permitted Address":
      "Plot No.247(C), Industrial Zone-2, Hlaing Thar Yar Township, Yangon",
  },
  {
    ID: 2320,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MRS. PAN, WEN-LING",
    "Name of Principal Organization": "JOURN TA BROTHERS LIMITED",
    "Place of Incorporation": "HONG KONG",
    "Company Name In Myanmar": "HUA TAI ENTERPRISE COMPANY LIMITED",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "644/2013",
    "Permit Date": "2013-12-10T04:04:59Z",
    "Meeting Number": "29/2013",
    "Meeting Date": "2013-11-06T04:05:29Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF ALL KINDS OF ALU-ZINC DIE CASTING PRODUCTS, ALL KINDS OF TOYS, BADGES, FANCY JEWELRY, KEY CHAINS, MEDALS AND TABLE FANCY PRODUCTIONS ON  CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 7.428,
    "Total Amount Of Capital (in Millions)": 7.428,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 35,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "",
    "Land Owner": "MINGALARDON INDUSTRIAL PARK",
    "Land Area (units not specified in file)": 6.376,
    "Lease Term": 35,
    "Annual Lease Fee": 0.007,
    "Land Use Premium": 1.16,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Amend",
    "Investor Address":
      "YU FONG ZONE, ZHANG MUTOU TOWN, DONGGUAN CITY, GUANG DONG PROVINCE, PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address":
      "UNIT   A, 11/F, CLEVELAND MANSION, 5-7 CLEVELAND STREET, CAUSEWAY BAY, HONG KONG",
    "Investment Permitted Address":
      "PLOT NO. C-7, CORNER OF NO. 3 HIGHWAY ROAD AND KHAYEBIN ROAD MINGALARDON INDUSTRIAL PARK, MINGALARDON TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2321,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chio Kuai Cheng",
    "Name of Principal Organization": "Lucky Star Knitting Factory Ltd.",
    "Place of Incorporation": "Macau",
    "Company Name In Myanmar": "Myanmar Lucky Star Manufacturing Co., Ltd.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "345/2000",
    "Permit Date": "2000-08-03T04:12:41Z",
    "Meeting Number": "4/2000",
    "Meeting Date": "2000-02-11T04:13:14Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Textile Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 13.33,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Macao",
    "Form Of Investment": "JV",
    "Land Owner": "Myanma Textile Industries",
    "Land Area (units not specified in file)": null,
    "Lease Term": 15,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      'Bairro Da Concordia EDF Industry "Vang Fu", 3rd Floor, BLK A-B-C',
    "Organization Address": "Macau",
    "Investment Permitted Address":
      "No.81/A, Plot No. 400/B, SINT-NGU-Twin, Lower Mingalardon Road, Yangon",
  },
  {
    ID: 2322,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LIAO, TAUNG- HUI",
    "Name of Principal Organization": "BROOKSTONE GLOBAL HOLDINGS LTD.",
    "Place of Incorporation": "BRITISH VIRGIN ISLANDS",
    "Company Name In Myanmar": "BROOKSTONE GLOBAL HOLDINGS (MYANMAR) LTD.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "645/2013",
    "Permit Date": "2013-12-13T04:30:51Z",
    "Meeting Number": "30/2013",
    "Meeting Date": "2013-11-26T04:31:41Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF VARIETIES OF SHOES ON CMP BASIS ",
    "Amount Of Foreign Capital USD (in Millions)": 1.293,
    "Total Amount Of Capital (in Millions)": 1.293,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Virgin Islands (British)",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW NU NU YI",
    "Land Area (units not specified in file)": 1.836,
    "Lease Term": 30,
    "Annual Lease Fee": 0.039,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "P.O BOX 438, ROAD TOWN, TORTOLA,  BRITISH VIRGIN ISLANDS",
    "Organization Address":
      "P.O BOX 438, ROAD TOWN, TORTOLA,  BRITISH VIRGIN ISLANDS",
    "Investment Permitted Address":
      "PLOT. NO. 28, THAN CHET WON U MYU STREET, DAGON EAST INDUSTRIAL ZONE, DAGON MYOTHIT (EASTERN) TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2323,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ang Beng Poh",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Weng Hong Hung Garment Manufacturing (Yangon) Co., Ltd.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "339/2000",
    "Permit Date": "2000-05-20T04:37:53Z",
    "Meeting Number": "11/2000",
    "Meeting Date": "2000-03-31T04:38:29Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Various Kinds of Garment",
    "Amount Of Foreign Capital USD (in Millions)": 2.8,
    "Total Amount Of Capital (in Millions)": 2.8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Malaysia",
    "Form Of Investment": "FDII",
    "Land Owner": "Department of Human Settlement and Housing Development",
    "Land Area (units not specified in file)": 2.079,
    "Lease Term": 20,
    "Annual Lease Fee": 0.025,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Lot 1361, MK 15, Jalan Rozhan, Alma, 14000 Bukit Mertajam, Malaysia",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 78, Industrial Zone (3), Haliang Thar Yar Township, Yangon",
  },
  {
    ID: 2324,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Keisuke Okamura",
    "Name of Principal Organization": "Postarion Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Myanmar Postarion Co., Ltd.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "338/2000",
    "Permit Date": "2000-05-20T04:51:20Z",
    "Meeting Number": "11/2000",
    "Meeting Date": "2000-03-31T04:51:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Garment (Children Wear and Baby Wear) Under CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.029,
    "Total Amount Of Capital (in Millions)": 2.029,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 48,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Mingaladon Industrial Park Co., Ltd.",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": 0.52,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Room 2302, 23rd Floor, Flat 02, Block N, Korn Hill, 14-16 Hong on Street, Quarry Bay, Hong Kong",
    "Organization Address":
      "Room 1401A, Star House, 3 Salisbury Road, Tsimshatsui, Kowloon, Hong Kong",
    "Investment Permitted Address":
      "Plot No.D-8, Mingalardon Industrial Park, Mingalardon Township, Yangon",
  },
  {
    ID: 2325,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Hwang Young Won",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Zenex Media Co., Ltd.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "337/2000",
    "Permit Date": "2000-05-20T05:05:26Z",
    "Meeting Number": "10/2000",
    "Meeting Date": "2000-03-23T05:06:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production of Cassette Tape and Cassette Disc",
    "Amount Of Foreign Capital USD (in Millions)": 2.11,
    "Total Amount Of Capital (in Millions)": 2.11,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "Department of Human Settlement of Housing Development",
    "Land Area (units not specified in file)": 0.498,
    "Lease Term": 15,
    "Annual Lease Fee": 0.006,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No.802, Chongno Officetel  58-1 Nacwon Dong, Chongno Gu Seoul, Korea",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.220,221 Shwepaukkan Industrial Zone, North Okkalapa Township, Yangon",
  },
  {
    ID: 2326,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LOU BAIJIN ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "KAMCAINE MANUFACTURING (MYANMAR) CO., LTD.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "650/2013",
    "Permit Date": "2013-12-31T05:00:36Z",
    "Meeting Number": "31/2013",
    "Meeting Date": "2013-12-04T05:01:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS ",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "India",
    "Form Of Investment": "FDII",
    "Land Owner": "U THAN SEIN",
    "Land Area (units not specified in file)": 8.3,
    "Lease Term": 15,
    "Annual Lease Fee": 0.168,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 168, BAISHI ROAD ,  SHAHE STREET , NANSHAN DISTRICT ,  SHENZHEN  GUANDONG PROVINCE, THE PEOPLE'S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 14 & 15. MYAY TAING BLOCK NO. 65, KIN WUN MIN GYI ROAD , SHWE PYI THAR INDUSTRIAL ZONE(4), SHWE PYI THAR TOWNSHIP , YANGON REGION",
  },
  {
    ID: 2327,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. CHANG , YU-HAO",
    "Name of Principal Organization": "URBAN ELITE INTERNATIONAL LTD.",
    "Place of Incorporation": "BRITISH VIRGIN ISLANDS",
    "Company Name In Myanmar": "UNITY SPORTS CO., LTD.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "654/2013",
    "Permit Date": "2013-12-31T05:28:03Z",
    "Meeting Number": "31/2013",
    "Meeting Date": "2013-12-04T05:28:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF SPORTING GOODS AND RELATED PRODUCTS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.1187,
    "Total Amount Of Capital (in Millions)": 1.1187,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Virgin Islands (British)",
    "Form Of Investment": "FDII",
    "Land Owner": "U YIN MIN",
    "Land Area (units not specified in file)": 1.5,
    "Lease Term": 30,
    "Annual Lease Fee": 0.031,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "OMC CHAMBERS, WICKHAMS CAT 1 ROAD TOWN, TORTOLA, BRITISH VIRGIN ISLANDS",
    "Organization Address":
      "OMC CHAMBERS, WICKHAMS CAT 1 ROAD TOWN, TORTOLA, BRITISH VIRGIN ISLANDS",
    "Investment Permitted Address":
      "MYAY TAING BLOCK NO. 25, PLOT NO. 397, MYA TAUNG WUN U HMO STREET,SHWELINBAN INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2328,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chu, Hsiung-Hsein",
    "Name of Principal Organization": "RAWHANI INDUSTRY LIMITED",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "MYANMAR UNIQUE GARMENTS MFG CO., LTD.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "655/2013",
    "Permit Date": "2013-12-31T05:52:13Z",
    "Meeting Number": "31/2013",
    "Meeting Date": "2013-12-04T05:52:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 1.8,
    "Total Amount Of Capital (in Millions)": 1900,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "SALOMON MYANMAR CO., LTD.",
    "Land Area (units not specified in file)": 2.179,
    "Lease Term": 50,
    "Annual Lease Fee": 0.044,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.47, 3rd Floor, 256 Street, Nanjin East Road, Taiwan.",
    "Organization Address":
      "NO. 129, INDUSTRIAL ZONE(4), WATMASUT WUNHTAUK ROAD, HLAING THARYAR  TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "PLOT NO. 129/KAGYI, AND 129/ KHA KWAY,  WATMASUT WUNHTAUK ROAD, INDUSTRIAL ZONE(4), HLAING THARYAR  TOWNSHIP, YANGON",
  },
  {
    ID: 2329,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U MYAT MIN",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "GRAND SPORTS INTERNATIONAL LTD.",
    "Financial Year From": 98,
    "Financial Year To": 99,
    "Permit Number": "MANATHA-179/98",
    "Permit Date": "1998-08-14T07:19:44Z",
    "Meeting Number": "14/98",
    "Meeting Date": "1998-08-14T09:47:26Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အသင့်ချုပ်ပြီးအထည်များ ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 17.2,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "မြို့ရွာနှင့်အိုးအိမ်ဖွံဖြိုးရေးဦးစီးဌာန",
    "Land Area (units not specified in file)": 0.459,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "NO.57, 46 STREET, BOTAHTAUNG TOWNSHIP, YANGON ",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.53/KHA KWAY, MYAY TAING BLOCK NO. 42, SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2330,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U MYO THEIN",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "THEIN CHERRY CO., LTD.",
    "Financial Year From": 98,
    "Financial Year To": 99,
    "Permit Number": "MANATHA 180/98",
    "Permit Date": "1998-10-13T07:29:18Z",
    "Meeting Number": "15/98",
    "Meeting Date": "1998-08-28T07:29:46Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ ဆပ်ပြာရည် ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 16.39,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "မြို့ရွာနှင့် အိုးအိမ်ဖွံ့ဖြိုးရေးဦးစီးဌာန",
    "Land Area (units not specified in file)": 1.347,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      " အမှတ် (၁၁၁)၊ ၂၈- လမ်း၊ ပန်းဘဲတန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 95, MYAY TAING BLOCK NO. 42, INDUSTRIAL ZONE, SHWE PYI THAR TOWNSHIP, YANGON",
  },
  {
    ID: 2331,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ju Koung Hoan",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Midas Industry Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "516/2012",
    "Permit Date": "2012-11-19T07:11:55Z",
    "Meeting Number": "34/2012",
    "Meeting Date": "2012-11-14T07:12:57Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.567,
    "Total Amount Of Capital (in Millions)": 0.567,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Zaw Win",
    "Land Area (units not specified in file)": 2.577,
    "Lease Term": 30,
    "Annual Lease Fee": 0.056,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "5F, 410-11 Kil 1-Dong-Gu, Seoul , Korea",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.236, Corner of Kanaung Min Thar Gyi ST., & Twin Thin Wun U Tun Nyo ST., Hlaing Tharyar, Industrial Zone-2, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 2333,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U MAUNG MAUNG AYE",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "East Growth Garment Co., Ltd.",
    "Financial Year From": 2011,
    "Financial Year To": 2012,
    "Permit Number": "809/2011",
    "Permit Date": "2011-09-27T08:44:37Z",
    "Meeting Number": "17/2011",
    "Meeting Date": "2011-09-21T08:45:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့်  အထည်ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 140,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Myint Zaw",
    "Land Area (units not specified in file)": 1.826,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      " အမှတ် ၇ (ဒီ)၊ စော မဟာလမ်း၊ ဗိုလ်ချို ၂ ရပ်ကွက်၊  ဗဟန်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၀၆၊ မြေတိုင်းရပ်ကွက်အမှတ် ၁၄၊ ရွှေသံလွင် စက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2339,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဉာဏ်မင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MANDALAY GLASS CO., LTD.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "MANATHA-390/2000",
    "Permit Date": "2000-05-20T03:38:33Z",
    "Meeting Number": "5/2000",
    "Meeting Date": "2000-02-18T03:39:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "မှန်ဖြင့် ပြုလုပ်သော အိမ်သုံးနှင့် ဆောက်လုပ်ရေးသုံး ကုန်ပစ္စည်းများ ထုတ်လုပ်သည့် လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 58.71,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးဉာဏ်မင်း",
    "Land Area (units not specified in file)": 1.467,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၁၄၆၊ ပြည်လမ်း၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက် အမှတ် ၃၀၊ စက်မှုဇုန် ၂၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2340,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအိန်ချွန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "BAW GA MAN DAING MANUFACTURING CO.,LTD.",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "588/2003",
    "Permit Date": "2003-02-12T03:48:50Z",
    "Meeting Number": "40/2002",
    "Meeting Date": "2002-12-20T03:49:33Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP  စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီ အဝတ်အထည် အမျိုးမျိုး ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 64.57,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအိန်ချွန်း နှင့် ဦးငေါ်တိုင်စိန်",
    "Land Area (units not specified in file)": 0.251,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၃၄/၄ ၊ ကမ္ဘာအေးဘုရားလမ်း၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၂၀၁၊ မြေတိုင်းရပ်ကွက်အမှတ် ၄၂၊ ကနောက်မင်းသားကြီးလမ်း၊ စက်မှုဇုန် ၁ ၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2341,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Dong Jixian",
    "Name of Principal Organization": "Qingdao Handsome Garments Co., Ltd.",
    "Place of Incorporation": "People's Republic of China",
    "Company Name In Myanmar": "Myanmar Handsome Garments Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "518/2012",
    "Permit Date": "2012-11-23T04:35:53Z",
    "Meeting Number": "34/2012",
    "Meeting Date": "2012-11-14T04:36:28Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.1,
    "Total Amount Of Capital (in Millions)": 1.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Kyin Yu",
    "Land Area (units not specified in file)": 0.988,
    "Lease Term": 15,
    "Annual Lease Fee": 0.04,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "1-2-402 No.85, Wenhua Road, Jiaonan Qingdao, People's Republic of China",
    "Organization Address":
      "No.89, Langyatai South Road, Jiaonan City, Qingdao, Shandong Province, People's Republic of China",
    "Investment Permitted Address":
      "Plot No.167, Ward 113, Dagon Myothit (East) Industrial Zone-1, Dagon Myothit (East) Township, Yangon Region",
  },
  {
    ID: 2344,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Yuan, Chin Huei",
    "Name of Principal Organization": "Ris-Tek (Shanghai) INC.",
    "Place of Incorporation": "People's Republic of China",
    "Company Name In Myanmar": "Unitec International Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "520/2012",
    "Permit Date": "2012-12-18T06:50:43Z",
    "Meeting Number": "34/2012",
    "Meeting Date": "2012-11-14T06:52:02Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Electrical & Electronic Goods and Television Cables Under CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3.98,
    "Total Amount Of Capital (in Millions)": 3.98,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 4,
    "Validity Of Investment Permit (in Years)": 36,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Mingaladon Industrial Park",
    "Land Area (units not specified in file)": 4.18,
    "Lease Term": 36,
    "Annual Lease Fee": 0.005,
    "Land Use Premium": 0.54,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.9, Lane 369, Section 3, TA-Tung Road, Shi-Ghih District, New Taipei City, Taiwan, Republic of China",
    "Organization Address":
      "Room 101, Building No.1, No.2168, Xiang Jiang Road, Huang Du, Jia Ding Shanghai",
    "Investment Permitted Address":
      "Plot No.D-11, Mingaladon Industrial Park, Mingaladon Township, Yangon Region",
  },
  {
    ID: 2346,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chung Fook Pui",
    "Name of Principal Organization": "Bogart Lingerie Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Bogart Lingerie (Yangon) Limited",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "521/2012",
    "Permit Date": "2012-11-26T07:35:29Z",
    "Meeting Number": "34/2012",
    "Meeting Date": "2012-11-26T07:36:02Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.43,
    "Total Amount Of Capital (in Millions)": 1.43,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Khin Htwe",
    "Land Area (units not specified in file)": 2.47,
    "Lease Term": 30,
    "Annual Lease Fee": 0.059,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "17 F, Flat A, Block 3A, Oceanaire, 18 Po Tai Street, MA on Shan N T, Hong Kong",
    "Organization Address":
      "16/F, Tower B, 223-231 Wai Yip Street, Kwun Tong , Kowloon, Hong Kong",
    "Investment Permitted Address":
      "Plot No. 149, 150,Hlaing Thar Yar  Industrial Zone (4), Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2347,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဝင်းကိုလတ် (ခ) ဦးဇန်မိုင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Chan Yin Industries Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "914/2013",
    "Permit Date": "2013-05-30T07:57:05Z",
    "Meeting Number": "15/2013",
    "Meeting Date": "2013-05-22T07:57:27Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ဆောက်လုပ်ရေးပစ္စည်းအမျိုးမျိုး ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 3592.85,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအိုက်ဆိုက်နှင့် ဒေါ်ရင်ရှင်းမေ",
    "Land Area (units not specified in file)": 2.2,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၂/စီ၊  အေဝမ်းလမ်း၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၂၂၈၊ ၂၂၉၊ ၂၃၀၊ ၂၃၁၊ ၁၁ လမ်း၊ ရန်ကုန်စက်မှုဇုန်၊ မင်္ဂလာဒုံမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2348,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kwak In Gyu",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "High Art Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "522/2012",
    "Permit Date": "2012-11-26T08:07:46Z",
    "Meeting Number": "34/2012",
    "Meeting Date": "2012-11-14T08:08:11Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Production of Wigs on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.516,
    "Total Amount Of Capital (in Millions)": 0.516,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Khin Htwe",
    "Land Area (units not specified in file)": 1.211,
    "Lease Term": 30,
    "Annual Lease Fee": 0.029,
    "Land Use Premium": null,
    "Number Of Local Employees": 1520,
    "Number Of Foreign Employees": 8,
    Status: "Approved",
    "Investor Address":
      "Sam ICK APT 105-1807 Bok Su-Dong Seo-Gu Dai Jeon, Republic of Korea",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.116, Industrial Zone-4, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2349,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်စိုးမိုးကို ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Semas Myanmar Manufacturing Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "916/2013",
    "Permit Date": "2013-06-15T08:17:20Z",
    "Meeting Number": "16/2013",
    "Meeting Date": "2013-06-12T08:18:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP  စနစ်ဖြင့် Fiber ဖြင့် ပြုလုပ်သည့် Pontoon  နှင့် အခြား Fiber Products များ ထုတ်လုပ်ခြင်း  လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 270,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ကေတုမတီ ကုမ္ပဏီ လီမိတက်",
    "Land Area (units not specified in file)": 1.011,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၃၈၊ အင်းဝလမ်း၊ ကျောက်မြောင်းကြီးရပ်ကွက်၊ တာမွေမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ် ၁၄၅/က၊ ကွင်းသင်းတိုက်ဝန် ဦးထွန်းညိုလမ်း၊ ဒဂုံဆိပ်ကမ်းစက်မှုဇုန် ၁၊ ဒဂုံဆိပ်ကမ်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2350,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ခိုင်ဇော်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Earth Industries (Myanmar) Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "920/2013",
    "Permit Date": "2013-07-11T08:34:52Z",
    "Meeting Number": "17/2013",
    "Meeting Date": "2013-06-29T05:15:32Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် TEMPERATURE SENSOR တပ်ဆင် ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 114.48,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Khaing Zaw ",
    "Land Area (units not specified in file)": 2.964,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၄၀၊ အင်းလျားလမ်း၊ ကမာရွတ်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၄၇၅/ခ၊ မြေတိုင်းရပ်ကွက်အမှတ်-၂၃၊ စက်မှုဇုန် ၁၊ ဒဂုံမြို့သစ် တောင်ပိုင်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2351,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်တင်စိုးဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "EVERLAST MARINE ENGINEERING CO., LTD.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "922/2013",
    "Permit Date": "2013-07-31T09:51:34Z",
    "Meeting Number": "17/2013",
    "Meeting Date": "2013-06-29T09:52:20Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် 15 METER ALUMINIUM ALLOY CREW/SUPPLY VESSEL များ တည်ဆောက်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 100,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 1,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၃/၁၀၊  သမိုင်းဘူတာရုံလမ်း၊ ၁ ရပ်ကွက်၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၄/အေ၊ မြေတိုင်းရပ်ကွက်အမှတ် ၂၇- စက်ကွက်၊ ရွာမအနောက်ရပ်ကွက်၊  အင်းစိန်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2352,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးစိုင်းမောင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "RISING WHITE TIGER MANUFACTURING CO., LTD.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "932/2013",
    "Permit Date": "2013-09-05T03:07:48Z",
    "Meeting Number": "21/2013",
    "Meeting Date": "2013-08-15T03:09:09Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP  စနစ်ဖြင့် အရည်အသွေး ကောင်းမွန်သည့် ဘောင်းဘီမျိုးစုံနှင့် အမျိုးသမီးဝတ် ဘလောက်(စ်) အင်္ကျီအမျိုးမျိုး ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 485,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Myint Myint Win",
    "Land Area (units not specified in file)": 1.318,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၁၂၊ သုခမြိုင်အိမ်ယာ၊ သဟာရလမ်း၊ ၉ ရပ်ကွက်၊ လှိုင်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၆၀၊ မြေတိုင်းရပ်ကွက်အမှတ် ၂၅၊ ရွှေလင်ပန်းစက်မှုမြို့၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2353,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်မျိုးဟိန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Unique  H T T Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "941/2013",
    "Permit Date": "2013-10-23T03:26:49Z",
    "Meeting Number": "26/2013",
    "Meeting Date": "2013-10-02T03:27:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အသင့်ချုပ်ပြီး အထည်အမျိုးမျိုး ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 741.85,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးကျော်မြင့် (ခ) ဦးကျောင်မိန် နှင့် ဦးမြင့်ဆွေ ",
    "Land Area (units not specified in file)": 2.438,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၉၃၊ တတိယထပ်၊ ၂၄ လမ်း ၊ ၈ ရပ်ကွက်၊ လသာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၃၊ မြေတိုင်းရပ်ကွက်အမှတ် ၂၅၊ ဦးရွှေစင်လမ်းနှင့် ဦးမြူးလမ်းထောင့်၊ ရွှေလင်ပန်းစက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2354,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးခင်ထွေး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "K.H. M Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "942/2013",
    "Permit Date": "2013-10-18T03:55:26Z",
    "Meeting Number": "23/2013",
    "Meeting Date": "2013-09-04T03:55:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အထည်အမျိုးမျိုး ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 2213,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Khin Htwe & Daw Myint Myint Yi ",
    "Land Area (units not specified in file)": 5.19,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၅၆၊  ရွှေဟင်္သာလမ်း၊ ၁၂ ရပ်ကွက်၊ လှိုင်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၅၇ (ဍ)/၁၄၆၊ ၅၇ (ဍ)/၁၄၇၊ မြေတိုင်းရပ်ကွက်အမှတ် ၅၆၃၊ မင်္ဂလာဒုံမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2355,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. AHSAN ALI",
    "Name of Principal Organization":
      "RAC HOLDING PTE. LTD. AND RAC HOLDING II PTE. LTD.",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar":
      "REXAM ASHMORE BEVERAGE CAN MYANMAR COMPANY LIMITED",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "690/2014",
    "Permit Date": "2014-03-24T04:27:26Z",
    "Meeting Number": "6/2014",
    "Meeting Date": "2014-02-13T04:27:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF BEVERAGE CANS ",
    "Amount Of Foreign Capital USD (in Millions)": 83,
    "Total Amount Of Capital (in Millions)": 83,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "U YE AUNG",
    "Land Area (units not specified in file)": 11.166,
    "Lease Term": 10,
    "Annual Lease Fee": 0.242,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "19 VAILLANT ROAD, WEYBRIDGE, SURREY, UK, KT 13 9 EP",
    "Organization Address": "80 ROBINSON ROAD # 02-00 SINGAPORE 068898",
    "Investment Permitted Address":
      "PLOT NO. 160, 161, 162, 163 & 164, MYAY TAING BLOCK NO. 49, WAR TAYAR INDUSTRIAL ZONE, SHWE PYITHAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2356,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS. FU CHING GINA ",
    "Name of Principal Organization": "HIGHWAY INTERNATIONAL(HK) LIMITED",
    "Place of Incorporation": "HONG KONG ",
    "Company Name In Myanmar": "FULLWAY MYANMAR CLOTHING COMPANY LIMITED",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "688/2014",
    "Permit Date": "2014-03-24T04:50:08Z",
    "Meeting Number": "6/2014",
    "Meeting Date": "2014-02-13T04:50:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.526,
    "Total Amount Of Capital (in Millions)": 0.526,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW NU NU YEE ",
    "Land Area (units not specified in file)": 1.74,
    "Lease Term": null,
    "Annual Lease Fee": 0.045,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Highway International (H.K)ltd., Workshop C5, 3/F, Block C, Hong Kong Industrial Centre, 489-491 Castle Peak Road, Kowloon, Hong Kong.",
    "Organization Address":
      "5/F , CHEUNG LEE BUILDING, 137-143 CHEUNG SHA WAN ROAD, KOWLOON, HONG KONG",
    "Investment Permitted Address":
      "PLOT NO. 83, MYAY TAING BLOCK NO.14, SHWE THAN LWIN INDUSTRIAL ZONE, HLAING THARYAR  TOWNSHIP, YANGON",
  },
  {
    ID: 2358,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်မိုး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Golden Bloom Industry Co., Ltd.",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "199/98",
    "Permit Date": "1998-11-09T07:30:33Z",
    "Meeting Number": "18/98",
    "Meeting Date": "1998-10-09T07:31:09Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ဆပ်ပြာ၊ ခေါင်းလျှော်ရည်၊ သွားတိုက်ဆေးနှင့် ယင်းတို့နှင့် ဆက်စပ်နေသည့် ပစ္စည်းများ ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 11.42,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးသန်းထွန်း၊ ဦးသန်းလွင် နှင့် ဒေါ်အေးရင်",
    "Land Area (units not specified in file)": 0.33,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "တိုက် ၆ ၊ အခန်း ၃၀၁၊ ခပေါင်းရိပ်သာ၊ လှိုင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၇၃ နှင့် ၇၅ ၊ မြေတိုင်းရပ်ကွက်အမှတ် -၂၃ ၊ ဒဂုံတောင်စက်မှုဇုန် ၊ ရန်ကုန်မြို့",
  },
  {
    ID: 2359,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဝင်းဆွေ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Win & Win Production Co.,Ltd.",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "200/98",
    "Permit Date": "1998-11-09T07:39:54Z",
    "Meeting Number": "18/98",
    "Meeting Date": "1998-10-09T07:59:06Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ကုန်ကြမ်းဝယ်ယူ၍ လုပ်ကိုင်သော စနစ်နှင့် CMP  အခစားစနစ်ဖြင့် လုပ်ကိုင်သော အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 36.6,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးဝင်းဆွေ",
    "Land Area (units not specified in file)": 2.227,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "အမှတ် ၄၀၀၊ ကမ်းနားလမ်း၊ လသာမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၇၊ မြေတိုင်းရပ်ကွက်အမှတ် အပိုင်း ၄ ၊ စက်မှုဇုန် ၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2360,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမြင့်သိန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Baw Ga Gyi Company Limited",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "202/98",
    "Permit Date": "1998-11-25T08:13:16Z",
    "Meeting Number": "19/98",
    "Meeting Date": "1998-10-23T08:13:42Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 45.66,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Myint Thein",
    "Land Area (units not specified in file)": 1.001,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၄၇ ၊ ဒုတိယထပ်ကိုင်းတန်းလမ်း၊ လမ်းမတော်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၇၇၊ လှိုင်သာယာစက်မှုဇုန်(၄)၊  လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2361,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးစန်းဝင်း (ခ) ဦးရုစန်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Oriental Star Material Stock Co., Ltd.",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "203/98",
    "Permit Date": "1998-11-25T08:20:59Z",
    "Meeting Number": "19/98",
    "Meeting Date": "1998-10-23T08:21:25Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "အိမ်ရိုက်သံများ ထုတ်လုပ်သည့် လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 15.75,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးဌေးငြိမ်း၊ ဦးအောင်တင့် နှင့် ဦးသက်လွင်",
    "Land Area (units not specified in file)": 0.863,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "ဆ-၅၂၊ ပိတောက်လမ်း၊ ဘုရင့်နောင်ပွဲရုံတန်း၊ မရမ်းကုန်းမြို့နယ် ၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၄၈၊ မြေတိုင်းရပ်ကွက်အမှတ် အပိုင်း(၁) ၊ စက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2362,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်ဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Win & Zin Garment  Limited",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "207/98",
    "Permit Date": "1998-11-25T08:29:16Z",
    "Meeting Number": "19/98",
    "Meeting Date": "1998-10-23T08:29:42Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ အထည်အမျိုးမျိုးချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 41,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်လှကျင်",
    "Land Area (units not specified in file)": 1.505,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "အမှတ် ၂၁၂၊ ဦးဝိစာရလမ်း၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ် ၂၉၊ ပြည်လမ်း၊ ၇ မိုင်၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 2363,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw San Dar@ Huang Yun Zhaung",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "YST Company Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "681/2014",
    "Permit Date": "2014-03-12T09:15:02Z",
    "Meeting Number": "6/2014",
    "Meeting Date": "2014-02-13T09:16:25Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.2414,
    "Total Amount Of Capital (in Millions)": 0.6898,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "U Kyaw Soe Aung",
    "Land Area (units not specified in file)": 1.676,
    "Lease Term": 30,
    "Annual Lease Fee": 0.041,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.(40),9th Floor, Baho Street, Aung Chanthar Quarter, Sanchaung Township,",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.(193), Myay Taing Block No.(25), Corner of Min Gyi Mahar Minkhaung Street And U Yaepaw Street, Shwe Lin Pan Industrial Zone, Hlaing Thar Yar Township, Yangon",
  },
  {
    ID: 2364,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးရဲမြင့်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "United World Garment Manufacturing Co., Ltd. ",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "432/2000",
    "Permit Date": "2000-09-28T10:00:04Z",
    "Meeting Number": "29/2000",
    "Meeting Date": "2000-08-24T10:00:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 25.7,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်ခင်စန်းကြူနှင့် ဦးမြင့်ရွှေ",
    "Land Area (units not specified in file)": 1.378,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": " အမှတ် -၂၊ ဒဂုံလွင်လမ်း၊ တာမွေမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၄၅(က/ခ)၊ မြေတိုင်းရပ်ကွက်အမှတ် ၄၂၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2365,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကျော်ချစ်ရှိန်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Mya Kyun Nyo Nyo Industry Co., Ltd.",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "603/2003",
    "Permit Date": "2003-03-28T10:10:02Z",
    "Meeting Number": "4/2003",
    "Meeting Date": "2003-02-06T10:10:24Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် နိုင်ငံတကာ အဆင့်မီ အဝတ်အထည်အမျိုးမျိုး ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 10.54,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 0.72,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၁၅၄ ဒုတိယထပ်/ဝဲဘက်၊ စမ်းချောင်းလမ်း၊ စမ်းချောင်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ် ၁၅၊ တပ်မြေဝင်း၊ တပ်မတော်မှတ်တမ်းရုံးဝန်း၊ ရန်းကင်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2366,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်သီသီဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Ayeyarwaddy Manufacturing Co., Ltd.",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "611/2003",
    "Permit Date": "2003-04-26T10:20:40Z",
    "Meeting Number": "4/2003",
    "Meeting Date": "2003-02-06T10:21:09Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 19.64,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးတင်ကြိုင်၊ ဒေါ်ညွှန့်ကြည်",
    "Land Area (units not specified in file)": 0.46,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၅၊ မိုးမခလမ်း၊ ၄၆ ရပ်ကွက်၊ ဒဂုံမြို့သစ်(မြောက်ပိုင်း)မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၉၊  မြေတိုင်းရပ်ကွက်အမှတ် (၄၀၀/ခ)၊ စဉ့်ငူရပ်ကွက်၊ အင်းစိန်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2367,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ခင်မူယာအောင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Textile Handiworks co., Ltd.",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "614/2003",
    "Permit Date": "2003-05-08T10:31:06Z",
    "Meeting Number": "41/2002",
    "Meeting Date": "2002-12-27T10:31:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 52.21,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအောင်ဇော်ဦး နှင့် ဦးအောင်ဇော်လတ်",
    "Land Area (units not specified in file)": 1.423,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၁၂၇၊ ဝက်မစွပ်ဝန်ထောက်လမ်း၊ လှိုင်သာယာ စက်မှုဇုန် (၄)၊  လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၉၊ ဖန်ချက်ဝန်ဦးရွှေအိုးလမ်း၊ လှိုင်သာယာစက်မှုဇုန် အပိုင်း ၂ ၊  လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2368,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးလှိုင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Shwe Ywet Hla Manufacturing Co., Ltd.",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "615/2003",
    "Permit Date": "2003-05-06T10:38:29Z",
    "Meeting Number": "4/2003",
    "Meeting Date": "2003-02-06T10:38:41Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP  စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီ အဝတ်အထည် အမျိုးမျိုးချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 10.75,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "မြန်မာနိုင်ငံစစ်မှုထမ်းဟောင်းအဖွဲ့",
    "Land Area (units not specified in file)": 0.632,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၁၆၅၊ မဟာဇေယျလမ်း၊ ပြည်ထောင်စုရပ်ကွက်၊ ပဲခူးမြို့နယ်၊ ပဲခူးတိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်(၈၆)၊ အောင်ဇေယျလမ်း၊ စက်မှုဇုန်(၇)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး။",
  },
  {
    ID: 2369,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမောင်ပြုံး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Winter Star Enterprise",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "616/2003",
    "Permit Date": "2003-05-07T10:50:02Z",
    "Meeting Number": "7/2003",
    "Meeting Date": "2003-02-28T10:50:26Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီ အဝတ်အထည်အမျိုးမျိုး ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 10.27,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ကာကွယ်ရေးဝန်ကြီးဌာန",
    "Land Area (units not specified in file)": 0.32,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၅၀၊ ဒုတိယထပ်၊ ၂၃ လမ်း၊ လသာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "တပ်မတော်အထည်ချုပ်စက်ရုံဝန်း၊ မင်္ဂလာဒုံမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2370,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးစိန်ဝမ်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Royal Green Manufacturing Ltd.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "426/2000",
    "Permit Date": "2000-09-06T10:57:50Z",
    "Meeting Number": "23/2000",
    "Meeting Date": "2000-07-14T10:58:19Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "မီးချောင်းနှင့် မီးချောင်းအပိုပစ္စည်းများ ထုတ်လုပ်မှု လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 229.47,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Royal Green Manufacturing Ltd.",
    "Land Area (units not specified in file)": 2.554,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၁၀၀၊ အင်းယားလမ်း ၊ ကမာရွတ်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၆၈ နှင့် ၆၉၊  မြေတိုင်းရပ်ကွက်အမှတ် ၆၄၊ စက်မှုဇုန် ၃ ၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2371,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးစန်းမောင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Soe San Win Manufacturing Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "857/2012",
    "Permit Date": "2012-07-31T11:05:55Z",
    "Meeting Number": "22/2012",
    "Meeting Date": "2012-07-25T11:06:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် ဖိနပ် အမျိုးမျိုး ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 116,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်လီဖိန်း",
    "Land Area (units not specified in file)": 5.546,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၁၀၈၊ ဘုံကျောင်းလမ်း၊ ကန်ရှေ့ရပ်ကွက်၊ တောင်ကြီးမြို့နယ်၊ ရှမ်းပြည်နယ်တောင်ပိုင်း",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ် ၂-၃၊  အမှတ် ၄ လမ်းမ၊ မြေတိုင်းရပ်ကွက် အမှတ် ၂၄ ၊ ငွေပင်လယ်စက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2372,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဝင်းကိုမျိုး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Kayser Myanmar Manufacturing Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "859/2012",
    "Permit Date": "2012-09-05T03:17:00Z",
    "Meeting Number": "27/2012",
    "Meeting Date": "2012-08-28T03:17:28Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      " CMP စနစ်ဖြင့် လျှပ်စစ်အပိုပစ္စည်းများ ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 399.25,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးခင်လှ",
    "Land Area (units not specified in file)": 2.127,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၉၂/၇၊ ဖက်ခင်းလမ်း၊ ကျိုက်မရောလမ်း၊ မော်လမြိုင်မြို့၊ မွန်ပြည်နယ်",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၂၅၉၊ မြေတိုင်းရပ်ကွက်အမှတ် ၂၅၊ မက္ခရာမင်းသားကြီးလမ်း၊ ရွှေလင်ပန်းစက်မှုဇုန်၊  လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2373,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Khaing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Krystal Garment & Khitting Industry Company Limited",
    "Financial Year From": 97,
    "Financial Year To": 98,
    "Permit Number": "108/97",
    "Permit Date": "1997-12-26T03:27:54Z",
    "Meeting Number": "20/97",
    "Meeting Date": "1997-12-05T03:28:25Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အထည်ချုပ်နှင့် သိုးမွှေးထည်ယက်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 41,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအောင်ခိုင်၊ ဦးမိုးဝင်းမောင်",
    "Land Area (units not specified in file)": 2.011,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "No.615(D),Pyay Road, Kamayut Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.(42), Zone (3), Hlaingtharyar Industry Zone, Hlaingtharyar Township,Yangon",
  },
  {
    ID: 2374,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "ilmar Investment Holdigs Pte. Ltd. ",
    "Name of Principal Organization": "WILMAR INTERNATIONAL LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Wilmar Myanmar Riceland Limited",
    "Financial Year From": 19,
    "Financial Year To": 20,
    "Permit Number": "134/2019",
    "Permit Date": "2019-01-14T03:20:11Z",
    "Meeting Number": "1/2019",
    "Meeting Date": "2019-01-11T03:20:22Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 25.44,
    "Total Amount Of Capital (in Millions)": 106,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "Wilmar Myanmar Port Terminal (Thilawa) Limited",
    "Land Area (units not specified in file)": 30,
    "Lease Term": 50,
    "Annual Lease Fee": 0.607,
    "Land Use Premium": null,
    "Number Of Local Employees": 190,
    "Number Of Foreign Employees": 26,
    Status: "Monitoring Approved",
    "Investor Address": "56 NEIL ROAD, SINGAPORE 088830",
    "Organization Address": "56 NEIL ROAD, SINGAPORE 088830",
    "Investment Permitted Address":
      "PLOT NO. 20 & 21 AND THE PARCEL OF LAND ADJOINING PLOT NO. 21& 22, THILAWA PORT AREA, , KYAUKTAN TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2375,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမင်းဂေါင်ဦး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Synergy Garment Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "872/2012",
    "Permit Date": "2012-12-21T03:33:16Z",
    "Meeting Number": "37/2012",
    "Meeting Date": "2012-12-12T03:33:41Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP  စနစ်ဖြင့် အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 550,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 3.619,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၃၅/ဘီ၊ ရွှေတောင်ကြားလမ်း၊ ရွှေတောင်ကြား ၂ ရပ်ကွက်၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ် ၁၈၊ ၁၉၊ ဒီပဲယင်းဝန်ထောက်ဦးမြဲလမ်း၊ စက်မှုဇုန် ၂ ၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2376,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်မိုးမိုးအေး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Three Cherry Blossoms Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "873/2013",
    "Permit Date": "2013-01-02T03:43:26Z",
    "Meeting Number": "39/2012",
    "Meeting Date": "2012-12-28T03:43:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP  စနစ်ဖြင့် Toilet Bags ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.002,
    "Total Amount Of Capital (in Millions)": 13.04,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးချစ်မြိုင် (ခ) ဦးတွိုင်ချာမင်း",
    "Land Area (units not specified in file)": 0.071,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၁၃၅၊ မင်းရဲကျော်စွာ ၁၂ လမ်း၊ ၃ ရပ်ကွက်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၆၀၆၊ မြေတိုင်းရပ်ကွက်အမှတ် ၆၄၊ အင်းလေး ၁ လမ်း၊ တောင်ဒဂုံစက်မှုဇုန် ၂၊  ဒဂုံမြို့သစ်တောင်ပိုင်း၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2377,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်မိုးမိုးအေး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Three Cherry Blossoms Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "874/2013",
    "Permit Date": "2013-01-02T03:55:44Z",
    "Meeting Number": "39/2012",
    "Meeting Date": "2012-12-28T03:56:04Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် Steel Wire Ring (စတီးဝါယာကြိုးကွင်း)များ ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 37.46,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးတင်မောင်ဝင်း (ခ) မူနီယမ်းဒီ ",
    "Land Area (units not specified in file)": 0.245,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၁၃၅၊ မင်းရဲကျော်စွာ ၁၂ လမ်း၊ ၃ ရပ်ကွက်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၅၃၃-၆၊ မြေတိုင်းရပ်ကွက်အမှတ်- ၂၃ တိုးချဲ့၊ တောင်ဒဂုံစက်မှုဇုန် ၁ ၊ ဒဂုံမြို့သစ်တောင်ပိုင်း၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2378,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်မြတ်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Mother Industries Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "875/2013",
    "Permit Date": "2013-01-02T04:11:39Z",
    "Meeting Number": "1/2013",
    "Meeting Date": "2013-01-02T04:11:59Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အပေါ့စား သဲကွန်ကရစ် အုတ်နှင့် ဖိအားမြင့်ခံ သဲကွန်ကရစ်အုတ် ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 20339.534,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "စက်မှုဝန်ကြီးဌာန",
    "Land Area (units not specified in file)": 260.919,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၃၇၊ ဝေဇယန္တာလမ်း၊ အမှတ် ၉ ရပ်ကွက်၊  တောင်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "စက်မှုဝန်ကြီးဌာနပိုင် ရန်ကုန်တိုင်းဒေသကြီး၊ အင်းစိန်မြို့နယ်၊ အောက်မင်္ဂလာဒုံလမ်း၊အကြီးစားစက်ရုံ ၃၄၊ လက်အောက်ခံအုတ်စက်ရုံ (တညင်းကုန်း)၊ အလုပ်ရုံခွဲ (၃) နှင့် အင်းစိန်မြို့နယ်၊ လှိုင်မြစ်ကမ်းဘေးရှိ ဖော့ကန်ဆိပ်ကမ်းမြေ",
  },
  {
    ID: 2380,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်သော်တာဇင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "EVA CONSTRUCTION COMPANY LIMITED",
    "Financial Year From": 97,
    "Financial Year To": 98,
    "Permit Number": "115/98",
    "Permit Date": "1998-02-09T04:37:09Z",
    "Meeting Number": "1/98",
    "Meeting Date": "1998-01-09T04:37:32Z",
    Sector: "",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ ပလပ်စတစ်ပိုက်များ ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 40.6,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "သန်းသန်းအေး(ခ)သော်တာဇင်(ခ)လင်ပေါခင်",
    "Land Area (units not specified in file)": 2.011,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်(၂၁၆/၂၂၂)၊ ၈-လွှာ၊ မဟာဗန္ဓုလလမ်း၊ ပုဇွန်တောင်မြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်(၂၁၆/၂၂၂)၊ ၈-လွှာ၊ မဟာဗန္ဓုလလမ်း၊ ပုဇွန်တောင်မြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2381,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်သန်းသန်းအေး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Last Star Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "898/2013",
    "Permit Date": "2013-03-29T04:39:33Z",
    "Meeting Number": "11/2013",
    "Meeting Date": "2013-03-29T04:39:50Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အထည်အမျိုးမျိုး ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 67.32,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 0.275,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၅၂၇၊ အောင်မြေသာလမ်း၊ ၂ ရပ်ကွက်၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၃၀၊ မြေတိုင်းရပ်ကွက်အမှတ် ၁၄၊ ကုန်းဘောင်လမ်း၊ လှိုင်သာယာစက်မှုဇုန် (၇)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2384,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်သူဇာဟန်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Lucid International Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "900/2013",
    "Permit Date": "2013-03-29T05:05:57Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP  စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီ အထည် အမျိုးမျိုး ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 427.89,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၉၈/က၊ ဘောဂဗလလမ်း၊ မြောက်ဥက္ကလာပစက်မှုဇုန်၊ င- ရပ်ကွက်၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ် ၇+ ၈၊ မြေတိုင်းရပ်ကွက် အမှတ် -၁၈၊ အင်းဝလမ်း၊ ရွေပေါက်ကံစက်မှုဇုန်၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2385,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Yap Ko Kyaing(a) U Than Aung ",
    "Name of Principal Organization": " - ",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "CECA Gold Co., Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "136/2019",
    "Permit Date": "2019-01-14T06:28:38Z",
    "Meeting Number": "1/2019",
    "Meeting Date": "2019-01-11T06:29:08Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Importation, Storage, Distribution and Sales of LPG by using pipeline jetty",
    "Amount Of Foreign Capital USD (in Millions)": 25.2,
    "Total Amount Of Capital (in Millions)": 36,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Myanma Economic Corporations",
    "Land Area (units not specified in file)": 8,
    "Lease Term": 50,
    "Annual Lease Fee": 4.5,
    "Land Use Premium": null,
    "Number Of Local Employees": 111,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "No-163, 5th Floor, 47 Street,Ward 10, Botahtaung Tsp, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Ship Breaking Yard(Thilawa), Plot No.607, Thidar Myaing Ward, Holding No.1(d), Gayan Kwin, Kyauktan Tsp, Yangon",
  },
  {
    ID: 2386,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးလှဦး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "GOOD BROTHERS MACHINERIES COMPANY LIMITED",
    "Financial Year From": 98,
    "Financial Year To": 99,
    "Permit Number": "138/98",
    "Permit Date": "1998-06-05T06:47:31Z",
    "Meeting Number": "8/98",
    "Meeting Date": "1998-05-15T06:48:06Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ယင်ဖုန်း(Yen Feng) တံဆိပ်ဘီးနှစ်ဘီးတပ်လုပ်ငန်းသုံးထရပ်တာ(Two Wheel Tractor) ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 122,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးလိကျန်(ခ)ဦးမောင်အေး",
    "Land Area (units not specified in file)": 2.02,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၂၂)၊ သီရိမွန်အိမ်ရာ၊ ဘုရင့်နောင်လမ်း၊ လှိုင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်(၂၂)၊ သီရိမွန်အိမ်ရာ၊ ဘုရင့်နောင်လမ်း၊ လှိုင်မြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2387,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကျော်သန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ငွေပင်လယ်လှိုင်းတွန့်စက္ကူဘူးထုတ်လုပ်ရေးကုမ္ပဏီလီမိတက်(Silver Sea Paper Carton Box Production Co., Ltd.)",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "မနသ-၁၀၉၂/၂၀၁၅",
    "Permit Date": "2015-12-08T06:44:52Z",
    "Meeting Number": "၁၇/၂၀၁၅",
    "Meeting Date": "2015-09-28T06:45:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "လှိုင်းတွန့်စက္ကူဘူးထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 2780,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Sein Win",
    "Land Area (units not specified in file)": 4.553,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၄၈၉/၁၉၁၊မဟာဗန္ဓုလလမ်း၊ဗိုလ်တစ်ထောင်မြို့နယ်၊ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊လှိုင်သာယာမြို့နယ်၊ငွေပင်လယ်စက်မှုဇုန်၊မြေတိုင်းရပ်ကွက်အမှတ်-၂၄၊မြေကွက်အမှတ်-၅၀၊၅၂",
  },
  {
    ID: 2388,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U KHIN MAUNG SAN",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MYANMAR BRILLIANCE AUTO COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "129/2018",
    "Permit Date": "2018-12-10T06:59:04Z",
    "Meeting Number": "20/2018",
    "Meeting Date": "2018-12-07T06:59:26Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ASSEMBLING, MANUFACTURING AND  SALES OF MOTOR VEHICLES",
    "Amount Of Foreign Capital USD (in Millions)": 0.549,
    "Total Amount Of Capital (in Millions)": 4177.939,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U KHIN MAUNG SAN",
    "Land Area (units not specified in file)": 2.42,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 219,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.18(A-1), THAR YAR WADDY STREET, BAHAN TOWNSHIP, YANGON ",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.246/M, MYAY TAING BLOCK- ZONE (2), SET HMU,  HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2389,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဝင်ဆွေ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ဝင်းနှင့်ဝင်းကုမ္ပဏီလီမိတက်(Win And Win Co., Ltd.)",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "မနသ-၁၀၉၅/၂၀၁၅",
    "Permit Date": "2015-11-11T07:04:52Z",
    "Meeting Number": "၁၈/၂၀၁၅",
    "Meeting Date": "2015-10-23T07:05:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့်အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 2326.26,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "အမှတ်-၃ အကြီးစားစက်မှုလုပ်ငန်း",
    "Land Area (units not specified in file)": 9.16,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်-၄၀၀၊ကမ်းနားလမ်း၊လသာမြို့နယ်၊ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊မင်္ဂလာတောင်ညွှန့်မြို့နယ်၊အထက်ပုဇွန်တောင်လမ်းမကြီး၊အမှတ်-၆၀၅ရှိ စက်ဘီးစက်ရုံ(ရန်ကုန်)",
  },
  {
    ID: 2390,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်နီနီချို",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "EAGLE POWER COMPANY LIMITED",
    "Financial Year From": 98,
    "Financial Year To": 99,
    "Permit Number": "139/98",
    "Permit Date": "1998-06-05T07:07:43Z",
    "Meeting Number": "8/98",
    "Meeting Date": "1998-05-15T07:08:10Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "C.M.P စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မှီ အနွေးထည်(Jacket) ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 15.72,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအောင်ကျော်သန်း",
    "Land Area (units not specified in file)": 0.245,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်(၂၇၄)၊ ကျုံးကြီးလမ်း၊ လမ်းမတော်မြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၂၅၈)၊ မြေတိုင်းရပ်ကွက်အမှတ်(၄၂ )၊ စက်မှုဇုန်၊ ကနောင်မင်းသားကြီးလမ်း၊ ရွှေပြည်သာမြို့နယ်, ရန်ကုန်မြို့။",
  },
  {
    ID: 2394,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Uthai Tantipimolphan",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar C.P. Livestock Company Limted",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "131/2019",
    "Permit Date": "2019-01-14T07:26:10Z",
    "Meeting Number": "1/2019",
    "Meeting Date": "2019-01-11T07:26:16Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "PROCESSING OF CHICKEN AND PORK, PRESERVING AND SALES OF MEAT",
    "Amount Of Foreign Capital USD (in Millions)": 10,
    "Total Amount Of Capital (in Millions)": 10,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Thailand",
    "Form Of Investment": "FDII",
    "Land Owner": "Yangon Region Government, Yangon City Development Committee",
    "Land Area (units not specified in file)": 58.048,
    "Lease Term": 50,
    "Annual Lease Fee": 540299.095,
    "Land Use Premium": 116096,
    "Number Of Local Employees": 790,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO. 99/160 MOO 5, BANGLUCKNOI, MUANG NONTHABURI, NONTHABURI 11000, THAILAND",
    "Organization Address": "",
    "Investment Permitted Address":
      "CORNER OF NO. 2 MAIN ROAD & NO. 7 MAIN ROAD, MASO AGRICULTURE AND LIVESTOCK  BREEDING FARM, DAGON MYO THIT (EAST) TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2395,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကျော်အောင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MYANMAR REGION INDUSTRIES COMPANY LIMTIED",
    "Financial Year From": 98,
    "Financial Year To": 99,
    "Permit Number": "141/98",
    "Permit Date": "1998-06-05T08:00:32Z",
    "Meeting Number": "8/98",
    "Meeting Date": "1998-05-15T08:00:56Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "အိမ်ရိုက်သံများထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 129.05,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးရန်မြင့်ချီ",
    "Land Area (units not specified in file)": 1.501,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "တိုက်အမှတ်(၁၇၁/၁၈၁)၊ အခန်းအမှတ်(၂/၃)၊ ၂၈-လမ်း၊ ပန်းဘဲတန်းမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "တိုက်အမှတ်(၁၇၁/၁၈၁)၊ အခန်းအမှတ်(၂/၃)၊ ၂၈-လမ်း၊ ပန်းဘဲတန်းမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2399,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးရန်အောင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "BEST MAKER COMPANY LIMITED",
    "Financial Year From": 98,
    "Financial Year To": 99,
    "Permit Number": "143/98",
    "Permit Date": "1998-06-05T08:46:12Z",
    "Meeting Number": "8/98",
    "Meeting Date": "1998-05-15T08:47:02Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "C.M.P စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မှီအထည်(Shirt) ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 33.04,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "M.G Company Limited",
    "Land Area (units not specified in file)": 1.117,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၂၈)၊ ရှမ်းကုန်းလမ်း၊ မြေနီကုန်း၊ စမ်းချောင်းမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၅၆)၊ လှိုင်သာယာစက်မှုဇုန်(၂)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2400,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမောင်ဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "KK Fishing Net Factory Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "891/2013",
    "Permit Date": "2013-03-13T08:53:48Z",
    "Meeting Number": "9/2013",
    "Meeting Date": "2013-02-27T08:54:19Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "ငါးဖမ်းပိုက် ထုတ်လုပ်မှု လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 2750,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးမောင်ဝင်း",
    "Land Area (units not specified in file)": 2.018,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၁၇၁၊ ပထမထပ်၊ ကျုံးကြီးလမ်း၊ ၇ ရပ်ကွက်၊ လမ်းမတော်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ် ၁၂၄၊ ၁၂၅၊ ဆိပ်ကမ်းသာလမ်းနှင့် ဦးမြူးလမ်းထောင့်၊ စက်မှုဇုန် (၁)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2401,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်မြအေး(ခ)လင်ကာစွမ်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "DIAMOND ROSE COMPANY LIMITED",
    "Financial Year From": 98,
    "Financial Year To": 99,
    "Permit Number": "145/98",
    "Permit Date": "1998-07-03T08:56:10Z",
    "Meeting Number": "9/98",
    "Meeting Date": "1998-05-28T08:56:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 35.2,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအောင်ဆွေ",
    "Land Area (units not specified in file)": 0.278,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၁၁၉/အေ)၊ သံလွင်လမ်း၊ ကမာရွတ်မြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၄၁)၊ မြေတိုင်းရပ်ကွက်အမှတ်(င)၊ စက်မှုဒေသ၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2403,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်နီလာသန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Lin Dagon Garment Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "894/2013",
    "Permit Date": "2013-03-13T09:01:16Z",
    "Meeting Number": "10/2013",
    "Meeting Date": "2013-03-13T09:01:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အထည်အမျိုးမျိုး ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1229.5,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်နီလာသန်း",
    "Land Area (units not specified in file)": 3.78,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၂၁၇၊ ပညာတန်ဆောင် ၂ လမ်း၊ ၄၃ ရပ်ကွက်၊ ဒဂုံမြို့သစ်မြောက်ပိုင်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ် ၁၄/၁၅၊ ဒဂုံ(အရှေ့) စက်မှုဇုန် အပိုင်း ၁ ၊ ဒဂုံမြို့သစ် (အရှေ့ပိုင်း) မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2406,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးခင်မောင်မြင့်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Rawhani Industry Ltd.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "427/2000",
    "Permit Date": "2000-09-06T10:54:31Z",
    "Meeting Number": "25/2000",
    "Meeting Date": "2000-07-28T10:55:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP  စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 102.4,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးခင်မောင်မြင့်",
    "Land Area (units not specified in file)": 2.179,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "တိုက်အမှတ် ၁၆၇၊ အခန်း ၂ ၊  ၄ ရပ်ကွက်၊  ရန်ကင်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၂၉၊ ဝက်မစွပ်ဝန်ထောက်လမ်း၊ စက်မှုဇုန် အမှတ် ၄ ၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2407,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးစိန်ဦး (ခ) ဦးလောရိန်ကြစ်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Sein Sanda International Co., Ltd.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "430/2000",
    "Permit Date": "2000-09-28T11:01:03Z",
    "Meeting Number": "28/2000",
    "Meeting Date": "2000-08-18T11:01:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "လက်ခစား စနစ်ဖြင့် ယောက်ျား ရှပ် အင်္ကျီနှင့် အခြား အထည်အမျိုးမျိုး ချုပ်လုပ်သည့် လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 63.57,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးစိန်ဦး (ခ) ဦးလောရိန်ကြစ်",
    "Land Area (units not specified in file)": 1.701,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      " အမှတ် ၉၄၊ ဘိုကလေးဈေးလမ်း၊ ဗိုလ်တထောင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၀၄၊ မြေတိုင်းရပ်ကွက်အမှတ် အပိုင်း ၃ တိုးချဲ့ ၊ စက်မှုမြို့၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2408,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Myint Aung",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Noble Co., Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "125/2018",
    "Permit Date": "2018-11-08T11:11:06Z",
    "Meeting Number": "18/2018",
    "Meeting Date": "2018-11-02T11:11:56Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Private Higher Education University",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 2335.49,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Bo Bo Maw, U Naing Ye Lin",
    "Land Area (units not specified in file)": 1.715,
    "Lease Term": 12,
    "Annual Lease Fee": 162000,
    "Land Use Premium": null,
    "Number Of Local Employees": 76,
    "Number Of Foreign Employees": 1,
    Status: "Submitted",
    "Investor Address":
      "Room No (1003), Tower Tosta, 9 th Floor, Laydahngkan Street, Than Gan Gyun Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.6/A, Plot No.3/Za, Myay Taing Block No.51, Kyoe Sett Yone Road, Ward-Kha, Thin Gan Gyun Township, Yangon Region",
  },
  {
    ID: 2409,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးရန်ဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "A-1 Garment Co., Ltd.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "437/2000",
    "Permit Date": "2000-10-06T03:08:14Z",
    "Meeting Number": "29/2000",
    "Meeting Date": "2000-08-24T03:08:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP  စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီ အထည်အမျိုးမျိုး ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 270,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးရန်ဝင်းနှင့် ဦးကျော်တင့်",
    "Land Area (units not specified in file)": 4.183,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      " ၃၃ - ခေမာလမ်း ၊ စမ်းချောင်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၈၊ ရန်ကုန်စက်မှုဇုန်၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2410,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "ဦးဌေးမြင့်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Yuzana Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "097/2018",
    "Permit Date": "2018-07-30T03:13:17Z",
    "Meeting Number": "10/2018",
    "Meeting Date": "2018-07-26T03:13:51Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ဆပ်ပြာအမျိုးမျိုးထုတ်လုပ်ဖြန့်ဖြူးရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 4.725,
    "Total Amount Of Capital (in Millions)": 9200,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးဌေးမြင့်",
    "Land Area (units not specified in file)": 3.52,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 119,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၁၃၀၊ ရွှေဂုံတိုင်လမ်း၊ ရေတာရှည်ရပ်ကွက်၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၄၁၄၊ မြေတိုင်းရပ်ကွက်အမှတ် ၂၅၊ ရွှေလင်ပန်းစက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2411,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးစိုးလှိုင် (ခ) ဦးရွှေယောင်ကူ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Taunggyi Garment & Industry Co., Ltd.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "440/2000",
    "Permit Date": "2000-10-21T03:17:10Z",
    "Meeting Number": "31/2000",
    "Meeting Date": "2000-09-07T03:17:46Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီ အထည်အမျိုးမျိုး ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 75,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးစိုးလှိုင် (ခ) ဦးရွှေယောင်ကူ",
    "Land Area (units not specified in file)": 1.608,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၄၄၊ မြိုင်ဟေဝန်အိမ်ယာ၊ ကျိုက်ဝိုင်းဘုရားလမ်း၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်တိုင်း",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက် အမှတ် ၇၀၊ လှိုင်သာယာစက်မှုဇုန် ၂ ၊  လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2412,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်သန္တာဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Excellent Garment Co., Ltd.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "442/2000",
    "Permit Date": "2000-10-21T03:26:37Z",
    "Meeting Number": "30/2000",
    "Meeting Date": "2000-09-01T03:27:02Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အသင့်ချုပ်ပြီးအထည်များ ထုတ်လုပ်သည့် လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 24.28,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးကျော်လွင်",
    "Land Area (units not specified in file)": 0.429,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ခ-ဂ စတုတ္ထထပ်၊ တက္ကသိုလ်ရိပ်သာလမ်း၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက် အမှတ် ၃၇၊ မြေတိုင်းရပ်ကွက်အမှတ် ၁၉/၂၊ ပုဂံလမ်း၊ ရွှေပေါက်ကံစက်မှုဇုန်၊ ရန်ကုန်တိုင်း",
  },
  {
    ID: 2414,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကောက်ရင်ခို (ခ) ဦးဆန်းဝင်း (ခ) ဦးသန်းဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Win Chan Tha Co., Ltd.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "443/2000",
    "Permit Date": "2000-11-05T04:03:59Z",
    "Meeting Number": "31/2000",
    "Meeting Date": "2000-09-07T04:04:24Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အခစား စနစ် (CMP) ဖြင့် အိတ်အမျိုးမျိုး ချုပ်လုပ်ခြင်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 31.2,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "ဦးကျော်ထွန်း၊ဒေါ်ခိုင်စပယ်နှင့်သားဖြစ်သူ မောင်ဖြိုးပြည့်ဟိန်း",
    "Land Area (units not specified in file)": 1.117,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် (ဂ)၊ မန္တလေး-လားရှိုးလမ်း၊ ပြင်ဦးလွင်မြို့နယ်၊ မန္တလေးတိုင်း",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၄၀၊ မြေတိုင်းရပ်ကွက်အမှတ် ဇုန် ၂၊  စက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2415,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးထွန်းကြည်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "High Fashion Co., Ltd.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "445/2000",
    "Permit Date": "2000-11-22T04:16:02Z",
    "Meeting Number": "32/2000",
    "Meeting Date": "2000-09-22T04:16:27Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 51.4,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးစောဝေ",
    "Land Area (units not specified in file)": 0.66,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      " အမှတ် ၂၆၇၊ ဗားကရာလမ်း၊ မြေနီကုန်း၊ စမ်းချောင်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်  ၁၀၃ ၊ ၁၀၄၊ မြေတိုင်းရပ်ကွက် (င/စက်မှု)၊ စက်မှုဇုန်၊         \nမြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2416,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒ​ေါ်သန်းသန်းဌေး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "NICE FASHION GARMENT INDUSTRY COMPANY LIMITED",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "343/2000",
    "Permit Date": "2000-02-29T04:12:08Z",
    "Meeting Number": "27/99",
    "Meeting Date": "1999-12-27T04:22:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ကုန်ကြမ်းဝယ်ယူလုပ်ကိုင်သောစနစ်နှင့် CMP အခစားစနစ်အရ အထည်ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 44.17,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်သန်းသန်းဌေး",
    "Land Area (units not specified in file)": 1.665,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၈၂)၊ မြေညီထပ်၊ ၃၂-လမ်း၊ ပန်းဘဲတန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေတိုင်းရပ်ကွက်အမှတ်(၄၂)၊ မြေကွက်အမှတ်-၃၀၄(ခ)၊ စက်မှုဒေသ၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2418,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးသန်းအောင် (ခ) ကွာတန်ရှု",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "East Bright Industry Ltd.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "449/2000",
    "Permit Date": "2000-12-01T04:30:05Z",
    "Meeting Number": "33/2000",
    "Meeting Date": "2000-10-02T04:30:27Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 26.3,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးသန်းအောင် (ခ) ကွာတန်ရှု နှင့် ဦးမျိုးညွှန့်(ခ) ဦးကျင်ဖု",
    "Land Area (units not specified in file)": 1.097,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "အမှတ် -၂၀/၄၊ လသာလမ်း၊ လသာမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၀၃၊ မြေတိုင်းရပ်ကွက်အမှတ် အပိုင်း ၄၊ စက်မှုမြို့၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2419,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဖွေသီ(ခ)ဦးအိယံှက်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "YANGON LOTUS GARMENT COMPANY LIMITED",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "366/2000",
    "Permit Date": "2000-04-20T04:38:12Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "C.M.P စနစ်ဖြင့် အသင့်ချုပ်ပီးသားအထည်များ ထုတ်လုပ်သည့်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 62.6,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်(၉၈/၁၀၀)၊ ၅၈-လမ်း၊ (၇) ရပ်ကွက်၊  လှိုင်မြို့နယ်, ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၀၉)၊ စက်မှုဇုန်(၂)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 2420,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်မြင့်မြင့်ရီ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ROYAL MOON STAR GARMENT MANUFACTURING COMPANY LIMITED",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "566/2003",
    "Permit Date": "2003-01-01T05:09:53Z",
    "Meeting Number": "21/2002",
    "Meeting Date": "2002-07-05T05:10:22Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "C.M.P စနစ်ဖြင့် ကင်ဒိုအားကစား ဝတ်စုံချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 12,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးမင်းဟန်",
    "Land Area (units not specified in file)": 0.055,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၆၀/အေ)၊ အာသာဝတီ(၃) လမ်း၊ (၂) ရပ်ကွက်, မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၄)၊ မြေတိုင်းရပ်ကွက်အမှတ်(၁၄)၊ ညောင်ရမ်းလမ်း၊ ရွှေပေါက္ကံမြို့သစ်, မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2421,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "MR. LOU, BAIJIN",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "XIN       MEI  \tMANUFACTURING (MYANMAR) COMPANY   LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "138/2019",
    "Permit Date": "2019-01-14T05:19:21Z",
    "Meeting Number": "1/2019",
    "Meeting Date": "2019-01-11T05:20:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of garment on CMP basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.324,
    "Total Amount Of Capital (in Millions)": 0.324,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 5,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Lin Hu Yan @ U Tin Tun ",
    "Land Area (units not specified in file)": 2.219,
    "Lease Term": 5,
    "Annual Lease Fee": 405.904,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "NO.1, JINTAI ROAD, SHANGWU 2nd INDUSTRIAL DISTRICT, SHIYAN TOWN, SHENZHEN, GUANGDONG, PEOPLE’S REPUBLIC OF CHINA",
    "Organization Address": "-",
    "Investment Permitted Address":
      "PLOT NO-122, MYAY TAING BLOCK NO-14, SHWE THAN LWIN  INDUSTRIAL ZONE, HLAING THARYAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2422,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr. Li Pingwen",
    "Name of Principal Organization": "YUNNAN XI’ERNAN FEED CO., LTD. ",
    "Place of Incorporation": "China",
    "Company Name In Myanmar":
      "MYANMAR GOLDEN   SOUTHWEST GROUP COMPANY  LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "133/2019",
    "Permit Date": "2019-01-14T05:46:52Z",
    "Meeting Number": "1/2019",
    "Meeting Date": "2019-01-11T05:47:26Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING  OF ANIMAL FEED",
    "Amount Of Foreign Capital USD (in Millions)": 4.771,
    "Total Amount Of Capital (in Millions)": 4.868,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "U Kyaw Mya Than and Daw Khin Ma Ma Myo ",
    "Land Area (units not specified in file)": 4.031,
    "Lease Term": 30,
    "Annual Lease Fee": 18811.33,
    "Land Use Premium": null,
    "Number Of Local Employees": 200,
    "Number Of Foreign Employees": 18,
    Status: "Approved",
    "Investor Address":
      "HUANGLONGSHAN, EASTERN SUBURBS, SANWA VILLAGE, A’LA TOWNSHIP, GUANDU DISTRICT, KUNMING CITY, YUNNAN PROVINCE, CHINA",
    "Organization Address":
      "HUANGLONGSHAN, EASTERN SUBURBS, SANWA VILLAGE, A’LA TOWNSHIP, GUANDU DISTRICT, KUNMING CITY, YUNNAN PROVINCE, PEOPLE’S REPUBLIC OF CHINA",
    "Investment Permitted Address":
      "PLOT NO. 114, 116, 117,   MYAUNG DAGAR THANMANI  INDUSTRIAL ZONE, HMAWBI TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2423,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်ဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MAPLE TRADING COMPANY LIMITED",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "585/2003",
    "Permit Date": "2003-02-12T06:22:28Z",
    "Meeting Number": "40/2002",
    "Meeting Date": "2002-12-20T06:22:45Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "C.M.P စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 31.5,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 1.5,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၂၁၂)၊ ဦးဝိစာရလမ်း၊ အနောက်ရွှေဂုံတိုင်ရပ်ကွက်၊ ဗဟန်းမြို့နယ်၊ (ဒဂုံစာတိုက်)၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်(၆က/၆ခ)၊ အင်ကြင်းလမ်း၊ဉာဏရပ်ကွက်၊ ပုလဲမြို့သစ်၊ မင်္ဂလာဒုံမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2424,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအိမ်ချွန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "BAW GA MAN DAING MANUFACTURING COMPANY LIMITED",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "588/03",
    "Permit Date": "2003-02-12T06:35:02Z",
    "Meeting Number": "40/2002",
    "Meeting Date": "2002-12-20T06:35:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "C.M.P စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မှီ အဝတ်အထည်အမျိုးမျိုးချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 64.57,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအိန်ချွန်းနှင့် ဦးငေါ်တိုင်စိန်",
    "Land Area (units not specified in file)": 0.251,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "အမှတ်(၃၄/၄)၊ ကမ္ဘာအေးဘုရားလမ်း၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၂၀၁)၊ မြေတိုင်းရပ်ကွက်အမှတ်(၄၂)၊ ကနောင်မင်းသားကြီးလမ်း၊ စက်မှုဇုန်(၁)၊ ရွှေပြည်သာမြို့နယ်, ရန်ကုန်မြို့။",
  },
  {
    ID: 2425,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးတီတီး(ခ) ဦးဝင်းထွန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "HERCULES GARMENT MANUFACTURING COMPANY LIMITED",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "586/2003",
    "Permit Date": "2003-02-12T06:57:45Z",
    "Meeting Number": "40/2002",
    "Meeting Date": "2002-12-20T06:58:11Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "C.M.P စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 100,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအောင်လှိုင်ဦး၊ ဦးအောင်ဇော်ဦး၊ ဦးအောင်မြင့်ဦးနှင့် ဦးတီတီး",
    "Land Area (units not specified in file)": 2,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၁၁၁၄/၁၁၁၅)၊ သုမင်္ဂလာလမ်း၊ (၁၆/၄) ရပ်ကွက်၊ သင်္ဃန်းကျွန်းမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "ဦးပိုင်အမှတ်-(၂+N-၁)၊ ကွင်းအမှတ်(၁၁၆၆)၊ လေးထောင့်ကန်ကျေးရွာ၊ ဒဂုံမြို့သစ်အရှေ့ပိုင်းမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2430,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးစောနေလင်းလွင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "UNIVERSAL APPAREL COMPANY LIMITED",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "795/2011",
    "Permit Date": "2011-03-04T09:13:16Z",
    "Meeting Number": "43/2010",
    "Meeting Date": "2010-01-25T09:13:40Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "C.M.P စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.4,
    "Total Amount Of Capital (in Millions)": 75.33,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်မြမြဝင်း",
    "Land Area (units not specified in file)": 2.778,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်-၁(အေ)၊ သပြေလမ်း၊ ၂(က) ရပ်ကွက်၊ ,မင်္ဂလာဒုံမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၆)၊ မြေတိုင်းရပ်ကွက်အမှတ်(၂၄)၊ ငွေပင်လယ်ရေလုပ်ငန်းစက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 2431,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးနိုင်ဝင်းအောင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "TEK NAY WUNN NI MANUFACTURING COMPANY LIMITED",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "804/2011",
    "Permit Date": "2011-03-28T09:58:58Z",
    "Meeting Number": "4/2011",
    "Meeting Date": "2011-01-28T09:59:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "C.M.P စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.09,
    "Total Amount Of Capital (in Millions)": 50.6,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးမျိုးကြည်၊ ဒေါ်တင်တင်မြင့်",
    "Land Area (units not specified in file)": 2.204,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်(၄၇)၊ ၄-လွှာ(ယာ)၊ ငမ္မာဒိဌိလမ်း၊ ဌေးကြွယ်(က) ရပ်ကွက်၊ တာမွေမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေတိုင်းရပ်ကွက်အမှတ်(၂၅)၊ မြေကွက်အမှတ်(၅၅)၊ မင်းကြီးမဟာမင်းခေါင်လမ်းနှင့် တွင်းသင်းတိုက်ဝန်ဦးထွန်းညိုလမ်းထောင့်၊ ရွှေလင်ပန်းစက်မှုဇုန်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2432,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "မိုဟာမက်အလီ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "မြန်မာတဲရီအင်န်တီး(စ်) ကုမ္ပဏီလီမိတက် (Myanmar Terry & Tee's Company Limited)",
    "Financial Year From": 97,
    "Financial Year To": 98,
    "Permit Number": "Manatha-100/97",
    "Permit Date": "1997-12-16T03:55:18Z",
    "Meeting Number": "19/97",
    "Meeting Date": "1997-11-21T03:55:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "မျက်နှာသုတ်ပဝါယက်လုပ်ခြင်းနှင့် တီရှပ်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 16,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးမောင်ဝင်း",
    "Land Area (units not specified in file)": 0.352,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၁၅၄၊ ကုန်စျေးတန်းလမ်း၊ ပန်းဘဲတန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၂၅၊ မြေတိုင်းရပ်ကွက်အမှတ် - ဂ၊ တောင်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 2434,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.lee Seng Nam @ Jose Li",
    "Name of Principal Organization": "CEDAR  MANUFACTURING COMPAN LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "CEDAR MYANMAR MANUFACTURING COMPANY LIMITED",
    "Financial Year From": 94,
    "Financial Year To": 95,
    "Permit Number": "104/1994",
    "Permit Date": "1994-04-05T05:01:24Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 3.6,
    "Total Amount Of Capital (in Millions)": 21.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No.(1039),Moo 3 Tumbol Taiban Ampure Murang, Samutprakarn, Thailand",
    "Organization Address":
      "No.(1039),Moo 3 Tumbol Taiban Ampure Murang, Samutprakarn, Thailand",
    "Investment Permitted Address": "yangon",
  },
  {
    ID: 2435,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Dr. Hlaing Chit Zaw",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "-",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "2018",
    "Permit Date": "2018-10-15T06:05:14Z",
    "Meeting Number": "17/2018",
    "Meeting Date": "2018-10-12T06:07:06Z",
    Sector: "Other Services",
    "Type Of Investment Business": "PRIVATE HIGH SCHOOL",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 6100,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Maung Aye",
    "Land Area (units not specified in file)": 1.228,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 108,
    "Number Of Foreign Employees": 0,
    Status: "Draft",
    "Investor Address":
      "PLOT NO. 29/8, 29/5, MYAY TAING  BLOCK NO. 538 (A), PLOT NO. 165, 83, 84, MYAY TAING BLOCK NO.31, SHWE PYI THAR TOWNSHIP, YANGON REGION",
    "Organization Address":
      "-NO.29/8, STREET NO.4, SHWE PYI THAR GWE, SHWE PYI THAR TOWNSHIP, YANGON ",
    "Investment Permitted Address":
      "PLOT NO. 29/8, 29/5, MYAY TAING  BLOCK NO. 538 (A), PLOT NO. 165, 83, 84, MYAY TAING BLOCK NO.31, SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2436,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyaw Htay",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Kyaw Htay & Associates Limited",
    "Financial Year From": 2006,
    "Financial Year To": 2007,
    "Permit Number": "667/2006",
    "Permit Date": "2006-05-10T05:24:41Z",
    "Meeting Number": "Cabinet 12/2006",
    "Meeting Date": "2006-04-12T06:37:59Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "ငါး၊ ပုစွန် ပြုပြင်ထုတ်လုပ်ခြင်းနှင့် တန်(၂၀၀၀ ) ဆန့် အအေးခန်း စက်ရံ လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 358.76,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Kyaw Htay",
    "Land Area (units not specified in file)": 2.02,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 320,
    "Number Of Foreign Employees": 2,
    Status: "Approved",
    "Investor Address": "No. 39, 11 Street, Lanmataw Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 3 D, Myay Taing Block No. 9, Industrial Zone 6, Hlaingtharya Township, Yangon",
  },
  {
    ID: 2437,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U HTIN KYAW    ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ETERNAL TECHNICAL SUPPORTING COMPANY LIMITED         ",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "118./2018",
    "Permit Date": "2018-10-15T06:59:09Z",
    "Meeting Number": "17/2018",
    "Meeting Date": "2018-10-12T06:59:29Z",
    Sector: "Other Services",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 0.000292,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "",
    "Land Owner": "U Toe Naing Mann",
    "Land Area (units not specified in file)": 2.087,
    "Lease Term": null,
    "Annual Lease Fee": 600,
    "Land Use Premium": null,
    "Number Of Local Employees": 102,
    "Number Of Foreign Employees": 40,
    Status: "Draft",
    "Investor Address":
      "NO.96/J, INYA ROAD, WARD NO. 9, KAMARYUT TOWNSHIP, YANGON ",
    "Organization Address": "",
    "Investment Permitted Address":
      "NO. 24, PLOT NO.8-/C1/1-A2 +      2A /B, MYAY TAING BLOCK NO. 83+ 84, SAE MYAUNG ROAD, WARD NO. 11, YANKIN TOWNSHIP, YANGON REGION ",
  },
  {
    ID: 2439,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "managing director, myanma heavy industries",
    "Name of Principal Organization": "MYANMA HEAVY INDUSTRIES",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MYANMAR SUZUKI MOTOR COMPANY LIMITED",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "317/1998",
    "Permit Date": "1998-09-29T07:36:14Z",
    "Meeting Number": "13/1998",
    "Meeting Date": "1998-07-31T07:37:39Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "manufacturing, Assembling, Distribution, Sale, Maintenance & repair of two wheelers and four wheelers",
    "Amount Of Foreign Capital USD (in Millions)": 4.69,
    "Total Amount Of Capital (in Millions)": 40.2,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 7,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "No.(56), Kaba Aye Pagoda Road, Yankin Township,Yangon",
    "Organization Address":
      "No.(56), Kaba Aye Pagoda Road, Yankin Township,Yangon",
    "Investment Permitted Address": "Industrial Zone in South Dagon Township,",
  },
  {
    ID: 2440,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.HU, Chiang-Ho",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MYANMAR TAH HSIN INDUSTRIAL COMPANY LIMITED",
    "Financial Year From": 97,
    "Financial Year To": 98,
    "Permit Number": "318/98",
    "Permit Date": "1998-09-29T08:04:35Z",
    "Meeting Number": "15/98",
    "Meeting Date": "1998-08-28T08:05:33Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing And Marketing of Garments and related products",
    "Amount Of Foreign Capital USD (in Millions)": 4,
    "Total Amount Of Capital (in Millions)": 4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Flat/Rm 502, 5/F, Hong Leong Ind, Complex, 4 Ward, Kwong Road, Kln Bay, Kl, Hongkong",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.(D-1), Mingaladon Industrial Park, Mingalardon Township,Yangon.",
  },
  {
    ID: 2441,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Managing Director, Myanma Heavy Industries",
    "Name of Principal Organization": "MYANMA HEAVY INDUSTRIES",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MYANMAR EKARAT TRANSFORMER COMPANY LIMITED",
    "Financial Year From": 97,
    "Financial Year To": 98,
    "Permit Number": "319/1998",
    "Permit Date": "1998-10-02T08:32:11Z",
    "Meeting Number": "15/98",
    "Meeting Date": "1998-08-28T08:32:58Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing & Marketing of Transformers and related Items for Export And Domestic Sale",
    "Amount Of Foreign Capital USD (in Millions)": 2.38,
    "Total Amount Of Capital (in Millions)": 20.52,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 9,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.(56), Kabar Aye Pagoda ROAD, Yankin Township, YANGON",
    "Organization Address":
      "No.(56), Kabaaye Pagoda Road, Yankin Township,YANGON",
    "Investment Permitted Address":
      "Block No.(23), South Dagon Industrial Zone, Yangon",
  },
  {
    ID: 2443,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.A.MAZUMDAR",
    "Name of Principal Organization": "TRACTOR INDIA LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MYANMAR TRACTORS AND EQUIPMENT COMPANY LIMITED",
    "Financial Year From": 98,
    "Financial Year To": 99,
    "Permit Number": "320/1999",
    "Permit Date": "1999-02-26T10:05:47Z",
    "Meeting Number": "1/99",
    "Meeting Date": "1999-01-01T10:06:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Rebuilding of caterpillar make earth-moving equipment, Construction Equipment, Diesel Genarator Sets, Maintenance & Rental of Caterpollar Equipment, Technical Trading to Customer",
    "Amount Of Foreign Capital USD (in Millions)": 4.5,
    "Total Amount Of Capital (in Millions)": 4.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 24,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "C/O Til Ltd, 1, Taratola Road, Calcutta-7000024",
    "Organization Address": "C/O Til Ltd, 1, Taratola Road, Calcutta-7000024",
    "Investment Permitted Address": "Dagon Seikkan Industrial Zone(1), Yangon.",
  },
  {
    ID: 2444,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor":
      "Managing Director, Myanma Machine Tools & Electrical Industries",
    "Name of Principal Organization":
      "myanma Machine Tools & Electrical Industries, ",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MYANMAR MATSUSHITA ELECTRIC WORKS LIMITED",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "322/1999",
    "Permit Date": "1999-05-31T03:53:27Z",
    "Meeting Number": "7/99",
    "Meeting Date": "1999-04-23T03:53:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing And Marketing of Wiring Devices And Other Electrical Construction Materials",
    "Amount Of Foreign Capital USD (in Millions)": 1.4458,
    "Total Amount Of Capital (in Millions)": 1.7083,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "Myanma Machine Tools & Electrical Industries",
    "Land Area (units not specified in file)": 5000,
    "Lease Term": 20,
    "Annual Lease Fee": 125000,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "Parami Road, 12th Block, Hlaing Township,YANGON",
    "Organization Address": "Parami Road, 12th Block, Hlaing Township,YANGON",
    "Investment Permitted Address":
      "Parami Road, 12th Block, Hlaing Township,YANGON",
  },
  {
    ID: 2447,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Johnlin Yuwono",
    "Name of Principal Organization": "PT HANIWELL MURNI COMPANY LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "JE JE CORPORATAMA  (YANGON) PTE LTD",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "324/1999",
    "Permit Date": "1999-06-30T04:08:25Z",
    "Meeting Number": "9/99",
    "Meeting Date": "1999-05-28T04:08:50Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production of Disposable Sanitary Products And Related Products",
    "Amount Of Foreign Capital USD (in Millions)": 1.3772,
    "Total Amount Of Capital (in Millions)": 1.3772,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Myanmar General And Maintenace Industries",
    "Land Area (units not specified in file)": 1394.26,
    "Lease Term": 15,
    "Annual Lease Fee": 30953,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Permata Hijau Blk 6/71, RT.019/010, Grogol Utara, Jakata Selatan , Indonesia",
    "Organization Address":
      "JL. Daan Mogot KM 19,  No.143 Kebon Besar Batu Ceper, Tangerang, Indonesia",
    "Investment Permitted Address":
      "Part of the land adjacent to corrugated carton factory, thanlyin Industrial Complex, Myanma General And Maintenance Industries, Thanlyin Township, Yangon",
  },
  {
    ID: 2448,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. Roh Hai Yong",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "D.H JIN SUNG MANUFACTURING COMPANY LIMITED",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "325/1999",
    "Permit Date": "1999-07-28T04:31:28Z",
    "Meeting Number": "10/99",
    "Meeting Date": "1999-06-25T04:31:59Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Production of Garment",
    "Amount Of Foreign Capital USD (in Millions)": 1.32,
    "Total Amount Of Capital (in Millions)": 8.34,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Deparment of Human Settlement and Housing Development",
    "Land Area (units not specified in file)": 1.429,
    "Lease Term": 15,
    "Annual Lease Fee": 17350,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "8-4, Yowol, Dong-01, Jong-Ku, Puchon-Shi Kyung-Gi, Do, South Korea",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.213,214,215,222,223, And 224, Shwe Pauk Kan Industrial Quarter, Northokkalapa Township,Yangon",
  },
  {
    ID: 2450,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးစိန်လွင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Diamond Mercury Wood Products Ltd",
    "Financial Year From": 98,
    "Financial Year To": 99,
    "Permit Number": "MaNaTha-137/98",
    "Permit Date": "1998-05-21T17:30:00Z",
    "Meeting Number": "4/98",
    "Meeting Date": "1998-02-23T05:09:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်အခြေခံပစ္စည်း ထုတ်လုပ်ဖြန့်ဖြူးရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 47.87,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Diamond Mercury Co,Ltd",
    "Land Area (units not specified in file)": 1.377,
    "Lease Term": null,
    "Annual Lease Fee": 11.77,
    "Land Use Premium": null,
    "Number Of Local Employees": 63,
    "Number Of Foreign Employees": 2,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်၁၇(ခ)၊ ဦးဘဟန်လမ်းသွယ်-၁၀ရပ်ကွက် မရမ်းကုန်းမြို့နယ် ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၉၈၊ မြေတိုင်းရပ်ကွက်အမှတ် အပိုင်း ၄၂၊ စက်မှုဒေသ၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်း",
  },
  {
    ID: 2451,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Kanji Matsutani",
    "Name of Principal Organization": "MANI INC",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MANI YANGON LIMITED",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "327/1999",
    "Permit Date": "1999-08-27T06:11:37Z",
    "Meeting Number": "13/1999",
    "Meeting Date": "1999-08-06T06:12:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 3.649,
    "Total Amount Of Capital (in Millions)": 3.649,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Myanma Pharmaceutical Industry",
    "Land Area (units not specified in file)": 1.23,
    "Lease Term": 20,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "721-3, Nakaakutsu, Takanezawa-Machi, Tochigiken, 329-1234, Japan",
    "Organization Address":
      "743-3, Nakaakutsu, Takanezawa-Machi, Tochigiken, 329-1234, Japan",
    "Investment Permitted Address":
      "Part of Pharmaceutical Raw Material Factory, Myanma Pharmaceutical Industry, Hmawbi Township,YANGON",
  },
  {
    ID: 2452,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Xiaoyin Wang",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Runningtex Co., Ltd.",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1145/2016",
    "Permit Date": "2016-09-14T06:18:38Z",
    "Meeting Number": "15/2016",
    "Meeting Date": "2016-08-19T06:18:56Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.5,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Cho Shu Choon ",
    "Land Area (units not specified in file)": 1.283,
    "Lease Term": 10,
    "Annual Lease Fee": 0.029,
    "Land Use Premium": null,
    "Number Of Local Employees": 781,
    "Number Of Foreign Employees": 13,
    Status: "Monitoring Approved",
    "Investor Address":
      "Room No.41, Building No.3, Ziyu Villa, No.1-89, Huayuan Road, Nanjing City, Jiangsu Province, China.",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 51, Myay Taing Block No. 24, Ngwe Pin Lae Industrial Zone, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 2453,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Lee Fung Tai",
    "Name of Principal Organization": "CHAPMAN DEVELOPMENT LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "YANGON MING HOI GARMENT MANUFACTURING  LIMITED",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "329/99",
    "Permit Date": "1999-10-29T06:32:24Z",
    "Meeting Number": "15/99",
    "Meeting Date": "1999-09-03T06:32:57Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garmnet(Knitwear)",
    "Amount Of Foreign Capital USD (in Millions)": 2.5,
    "Total Amount Of Capital (in Millions)": 2.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Myanma Textile Industries",
    "Land Area (units not specified in file)": 5.71,
    "Lease Term": 15,
    "Annual Lease Fee": 100000,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Unit-1, 6/F, Lee Sum Factory Building, 23-SZE Mei Street, Sanpokong, Kowloon, Hongkong",
    "Organization Address":
      "Unit-1, 6/F, Lee Sum Factory Building, 23-SZE Mei Street, Sanpokong, Kowloon, Hongkong",
    "Investment Permitted Address":
      "Garment Factory No.(3), Thanlyin Thilawa Road,  Thanlyin Township, Yangon",
  },
  {
    ID: 2454,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်မီမီစမ်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Asia General Transformer Co., Ltd. (အာရှအထွေထွေ ထရန်စဖော်မာ ကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "Ma Na Tha- 1210/2016",
    "Permit Date": "2016-09-19T06:47:45Z",
    "Meeting Number": "17/2016",
    "Meeting Date": "2016-09-09T06:48:10Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ ထရန်စဖော်မာ အမျိုးမျိုးထုတ်လုပ်ဖြန့်ဖြူးရောင်းချ ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 11.97,
    "Total Amount Of Capital (in Millions)": 14507,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Asia General Electric Holding Co.,Ltd.",
    "Land Area (units not specified in file)": 13.316,
    "Lease Term": 30,
    "Annual Lease Fee": 174.71,
    "Land Use Premium": null,
    "Number Of Local Employees": 433,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address": "No(14/C), Inya Road,  Kamayuat Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Yangon, Hlaing Tharyar Township, Shwe Than Lwin Industrial Zone, Myay Taing Block No(14) , Myay Kwat No(1,2,3,4,33,34,35)",
  },
  {
    ID: 2455,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.D.D.Gupta",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "MYANMAR TEXTILES AND PROCESSING INDUSTRY LIMITED",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "331/1999",
    "Permit Date": "1999-12-31T06:49:56Z",
    "Meeting Number": "18/99",
    "Meeting Date": "1999-10-08T06:50:29Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production of Plain Towels (Weaving, Cutting And Stitching On CMP Basis)",
    "Amount Of Foreign Capital USD (in Millions)": 0.565,
    "Total Amount Of Capital (in Millions)": 0.565,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Myanamar Textile Industries",
    "Land Area (units not specified in file)": 11529,
    "Lease Term": 10,
    "Annual Lease Fee": 42186.26,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "Mayer Road,  The Sovereign Singapore 437820",
    "Organization Address": "",
    "Investment Permitted Address":
      "Thingangyun Blanket Factory, No.(22), Lutlatyae Road, Thingangyun Township,Yangon.",
  },
  {
    ID: 2456,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Sung Min Kim",
    "Name of Principal Organization": "SMK INTERNATIONAL COMPANY LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "MYUE & SUE GARMENT MANUFACTURING COMPANY LIMITED",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "504/2012",
    "Permit Date": "2012-10-29T07:11:30Z",
    "Meeting Number": "31/2012",
    "Meeting Date": "2012-10-17T07:11:52Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.506,
    "Total Amount Of Capital (in Millions)": 0.506,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Chan Saie Thar, U Ohn Lwin, U Kyaw Nyunt, U Kyaw Kyaw",
    "Land Area (units not specified in file)": 3.186,
    "Lease Term": 30,
    "Annual Lease Fee": 70913.15,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "302-122, Hannam The Hill, 810 Hannam-Dong, Yongsan-Ku, Seoul, Republic Of Korea",
    "Organization Address":
      "302-122, Hannam The Hill, 810 Hannam-Dong, Yongsan-Ku, Seoul, Republic Of Korea",
    "Investment Permitted Address":
      "Plot No.64/65, Pyisi Minthargyi Road, Industrial Zone 4, Hlaingtharyar Township, Yangon",
  },
  {
    ID: 2457,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Yun Jong Seol",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MK Housing Company Limited",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "505/2012",
    "Permit Date": "2012-10-29T07:31:34Z",
    "Meeting Number": "31/2012",
    "Meeting Date": "2012-10-17T07:32:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing And Marketing Of Concrete Bricks & Blocks",
    "Amount Of Foreign Capital USD (in Millions)": 0.55,
    "Total Amount Of Capital (in Millions)": 0.55,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": 0.728,
    "Lease Term": 15,
    "Annual Lease Fee": 12000,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No.(101-601), Lotte, Apartment 72, Pyeong Chang-Dong, Jongro-Gu, Seoul, Korea",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.(298), Marlar Myaing Street, Industrial Zone, Thakata Township, Yangon",
  },
  {
    ID: 2458,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MRs.SU JUM BOON",
    "Name of Principal Organization": "BIKERSINC",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "FASHION FOUR SEASONS COMPANY LIMITED",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "506/2012",
    "Permit Date": "2012-10-29T08:31:15Z",
    "Meeting Number": "31/2012",
    "Meeting Date": "2012-10-17T08:31:55Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.603,
    "Total Amount Of Capital (in Millions)": 0.603,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Moe Kyaw Thu, U Moe Aung Thu",
    "Land Area (units not specified in file)": 0.753,
    "Lease Term": 30,
    "Annual Lease Fee": 12753.68,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "(1182) Nea Dea Gi Apartment 904-1903, Republic of Korea",
    "Organization Address":
      "Guro-Dong, Dong Nam, Gamasan-Ro, Guro-Gu, Seoul, Republic Of Korea",
    "Investment Permitted Address":
      "Plot No.321, Kanaung 7th Street, 19/1 Quarter, Shwe Paukkan Industrial Zone, North Okkalapa Township,YANGON",
  },
  {
    ID: 2459,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Park Chungyoul",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "WORLD APPAREL MANUFACTURING COMPANY LIMITED",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "508/2012",
    "Permit Date": "2012-10-29T09:21:58Z",
    "Meeting Number": "31/2012",
    "Meeting Date": "2012-10-17T09:22:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.5,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "U Kyaw Win",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.(201-407), Wolgye-2Cha, Hanil Apt Wolgyedong 927, Nowon-Gu, Seoul, Republic Of Korea",
    "Organization Address":
      "Room 501, Rose Plaza, 382-3,Yatap-Dong, Bundang-Gu Seongnam-City, Gyeonggi-Do, 463-827, Republic of Korea",
    "Investment Permitted Address":
      "Plot No.64, No.(139/149), Shwe Pyi Thar Bridge Road, Industrial Zone (3),Shwe Pyi Thar Township,YANGON.",
  },
  {
    ID: 2460,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Win Maw",
    "Name of Principal Organization": "Canal+Myanmar Holding Pte.Ld., ",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Canal+Myanmar Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "053/2018",
    "Permit Date": "2018-01-20T09:18:24Z",
    "Meeting Number": "17/2018",
    "Meeting Date": "2017-12-22T09:28:55Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Commercialization and Marketing of Pay -TV Services and Pay-TV Consumer Services",
    "Amount Of Foreign Capital USD (in Millions)": 34.6,
    "Total Amount Of Capital (in Millions)": 34.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 4,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Yangon Management Co.,Ltd.",
    "Land Area (units not specified in file)": 18646,
    "Lease Term": 3,
    "Annual Lease Fee": 22532.8,
    "Land Use Premium": null,
    "Number Of Local Employees": 95,
    "Number Of Foreign Employees": 6,
    Status: "Approved",
    "Investor Address":
      "1402-1403, Olympic Tower 1, Corner of Mahabandoola Road and Bo Aung Kyaw Street, Yangon",
    "Organization Address": "80 Raffles, # 32-01 UOB Plaza, Singapore 048624",
    "Investment Permitted Address":
      "No. 271-273 Bagayar Street, Parkside  One Building, Sanchaung Township, Yangon Region",
  },
  {
    ID: 2461,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Takashi Kaneko",
    "Name of Principal Organization": "SHOKOSHA COMPANY LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "SHOKOSHA MYANMAR COMPANY LIMITED",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "507/2012",
    "Permit Date": "2012-10-29T09:49:34Z",
    "Meeting Number": "31/2012",
    "Meeting Date": "2012-10-17T09:50:24Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Watch Dials On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 5.5,
    "Total Amount Of Capital (in Millions)": 7.007,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 36,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "311, Oyazawa Hidaka-Shi Saitama, Japan",
    "Organization Address": "9-10, Kamijujo 2-Chome, Kita-Ku, Tokyo, Japan",
    "Investment Permitted Address":
      "Plot No.(C-4), Mingalardon Industrial Park, Mingalardon Township, Yangon",
  },
  {
    ID: 2462,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Won Ho Seo",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "GOLDEN SHINE COMPANY LIMITED",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "509/2012",
    "Permit Date": "2012-10-29T03:55:30Z",
    "Meeting Number": "32/2012",
    "Meeting Date": "2012-10-24T03:56:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.84,
    "Total Amount Of Capital (in Millions)": 0.84,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": 4.011,
    "Lease Term": 30,
    "Annual Lease Fee": 81159.8,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.401-3, Duk-Kok, Dong, Song-Tan City, Kyung Ki-Do, Republic Of Korea",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.(73&74), Mingalardon Garden City, Yangon Industrial Zone, North Okkalapa Township, Yangon Region",
  },
  {
    ID: 2463,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Kachisuke Kurasaki",
    "Name of Principal Organization": "FLEX JAPAN COMPANY LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "WHITE OWL FASHING COMPANY LIMITED",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "510/2012",
    "Permit Date": "2012-10-29T04:45:19Z",
    "Meeting Number": "31/2012",
    "Meeting Date": "2012-10-17T04:45:42Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.66,
    "Total Amount Of Capital (in Millions)": 0.66,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": 2.007,
    "Lease Term": 10,
    "Annual Lease Fee": 36000,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Terminated",
    "Investor Address": "No.1243, Oshimada-Machi, Nagano-Shi Nagano-Ken, Japan",
    "Organization Address":
      "No.(2451), Oaza Yashiro, Chikuma City, Nagano Prefecture, Japan",
    "Investment Permitted Address":
      "Plot No.41, U Myu Street, Shwe Pyi Thar Industrial Zone(4), Shwe Pyi Thar Township,Yangon Region",
  },
  {
    ID: 2464,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Huagn Guo Qing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "MYANMAR HUALIAN PLASTIC MANUFACTURE COMPANY LIMITED",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "511/2012",
    "Permit Date": "2012-10-29T04:58:22Z",
    "Meeting Number": "31/2012",
    "Meeting Date": "2012-10-17T04:58:57Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing And Marketing Of All Types Of PVC, PE Pipe And Relevant Parts In Relation To Communication Engineering, Power Engineering, And Drainage Engineering",
    "Amount Of Foreign Capital USD (in Millions)": 0.949,
    "Total Amount Of Capital (in Millions)": 0.949,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 35,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Shwe",
    "Land Area (units not specified in file)": 1.3,
    "Lease Term": 35,
    "Annual Lease Fee": 0.0158,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Rejected",
    "Investor Address":
      "Room No.(502), Unit-7, Building No.(1), No.(81), Huangjingao Road, Tianhe District, Guangzhou, Guangdong Province, China",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.(147),  Shwe Lin Ban Industrial Zone, Mat Ka Yar Min Thar Gyi Road, Yanbgon Region",
  },
  {
    ID: 2465,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.Lau Siu Lam",
    "Name of Principal Organization": "DICKSON GARMENTS LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "EXCEL GARMENT MANUFACTURING COMPANY LIMITED",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "512/2012",
    "Permit Date": "2012-10-29T06:49:27Z",
    "Meeting Number": "30/2012",
    "Meeting Date": "2012-09-26T06:49:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.754,
    "Total Amount Of Capital (in Millions)": 0.754,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myint Htay",
    "Land Area (units not specified in file)": 2.908,
    "Lease Term": 30,
    "Annual Lease Fee": 64725.49,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Flat 9B, Block-1, Providen Center, Wharf Road, North Point, Hongkong",
    "Organization Address":
      "7th Floor, Block A, Tin On Industrial Building, 777-779 Cheung Sha Wan Road, Cheung Sha, Kowloon, Hongkong",
    "Investment Permitted Address":
      "Plot No.28(Gagyi), No 538(Ka), No.4 High Way Road, Shwe Pyithar Township,Yangon Region.",
  },
  {
    ID: 2466,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Byounghai Oh",
    "Name of Principal Organization": "SHIN HWA TRUNY COMPANY LIMTED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MST UNDERWEAR COMPANY LIMITED",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "513/2012",
    "Permit Date": "2012-10-29T07:23:50Z",
    "Meeting Number": "31/2012",
    "Meeting Date": "2012-10-17T07:24:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": 2.003,
    "Lease Term": 10,
    "Annual Lease Fee": 42000,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "311 Jung Am-Ri, Buknemyum Kyoungki-do Seoul, Korea",
    "Organization Address":
      "Room-511, Kolon Science Valley(1), Digital-Ro 34Gil, Seoul,152-729 Korea",
    "Investment Permitted Address":
      "Plot No.(447+447A), Seikkanthar Street, Shwe Lin Ban Industrial Zone, Hlaing Thar Yar Tonwship,Yangon Region",
  },
  {
    ID: 2467,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chen Zurong",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Jia Xi (Yangon) Garment Co., Ltd. ",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "595/2013",
    "Permit Date": "2013-07-12T08:54:52Z",
    "Meeting Number": "17/2013",
    "Meeting Date": "2013-06-29T08:55:16Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.035,
    "Total Amount Of Capital (in Millions)": 2.035,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Nan Huam",
    "Land Area (units not specified in file)": 1.482,
    "Lease Term": 30,
    "Annual Lease Fee": 0.0315,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Room-20107,Apecla 39, 49 Hoiyuen Road, Kwim ,Kowloon, Hong Kong ",
    "Organization Address":
      "Flat E,27/F, Block 2, Richland Garden, 138 Wu Chui Road, Tuen Mun, NT, Hong Kong.",
    "Investment Permitted Address":
      "Plot No.(511/A), Hakha Street, Industrial Zone (1), Dagon Myothit (Southern) Township, Yangon.",
  },
  {
    ID: 2468,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MRs. TSE YUET YU",
    "Name of Principal Organization": "ARCHID GARMENT FACTORY  LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "AMG FACTORY LIMITED",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "596/2013",
    "Permit Date": "2013-07-12T09:29:41Z",
    "Meeting Number": "17/2013",
    "Meeting Date": "2013-06-29T09:30:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Printing And Embroidery On Garment",
    "Amount Of Foreign Capital USD (in Millions)": 0.865,
    "Total Amount Of Capital (in Millions)": 0.865,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Wai Linn",
    "Land Area (units not specified in file)": 1.498,
    "Lease Term": 30,
    "Annual Lease Fee": 39404.3,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "P-9, San Simeon Avenue, Royal Palms, Yuen Long, Hong Kong.",
    "Organization Address":
      "Flat/RM 3, BLK B, 15/F, Po YIP Bldg, 60-70 Texaco Road, Tsuen Wan,N.T, HONGKONG",
    "Investment Permitted Address":
      "Plot No.(214), Myay Taing Quarter No.(25), Shwe Lin Ban Industrial Zone, Hlaing Thar Yar Township,Yangon",
  },
  {
    ID: 2469,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. WANG JUNG-HUA",
    "Name of Principal Organization": "SINOBEST (BROTHERS) LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "SINOBEST JEWELRY COMPANY LIMITED",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "597/2013",
    "Permit Date": "2013-07-12T04:28:18Z",
    "Meeting Number": "17/2013",
    "Meeting Date": "2013-06-29T04:28:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of All Kinds of Alu-Zinc Die Casting Products And Plastic Injection Products, All Kinds of Badges, Fancy Jewellery, Printing, Electric Plating, Key Chains, Medals, Buckles And Table Fancy Product under CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 7.979,
    "Total Amount Of Capital (in Millions)": 7.979,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 35,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "MINGALARDON INDUSTRIAL PARK COMPANY LIMITED",
    "Land Area (units not specified in file)": 7.461,
    "Lease Term": 35,
    "Annual Lease Fee": null,
    "Land Use Premium": 1.36,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Yu Fong Zone, Zhang Muton Town, Dongguan City, Guang Dong Province,People's  Republic of China",
    "Organization Address":
      "Unit A, 11/F, Cleveland Mansion, 5-7 Cleveland Street, Causeway Bay, Hong Kong.",
    "Investment Permitted Address":
      "Plot No.(C-8), Mingalardon Industrial Park, Mingalardon Township, Yangon Region",
  },
  {
    ID: 2470,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.YONGQI PIAO",
    "Name of Principal Organization":
      "NISHIKU MANUFACTURING CORPORATION LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "SOUTH BAY MANUFACTURING COMPANY LIMITED",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "600/2013",
    "Permit Date": "2013-08-26T05:06:29Z",
    "Meeting Number": "20/2013",
    "Meeting Date": "2013-08-07T05:07:45Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 10.966,
    "Total Amount Of Capital (in Millions)": 10.966,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Maung Maung",
    "Land Area (units not specified in file)": 2.493,
    "Lease Term": 30,
    "Annual Lease Fee": 55475,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "Unit 1305, 13/F, Prosperity Palace,  6 Shing Yip Street, Kwun Tong, Kowloon, Hongkong.",
    "Organization Address":
      "Unit 1305, 13/F, Prosperity Palace,  6 Shing Yip Street, Kwun Tong, Kowloon, Hongkong.",
    "Investment Permitted Address":
      "Plot No.(17), De Pae Yin Wun Dauk U Myae Street, Hlaing Thar Yar Industrial Zone (1), Hlaing Thar Yar Township, Yangon.",
  },
  {
    ID: 2471,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.PARK HONG KYU",
    "Name of Principal Organization": "KESAN TRADING COMPANY LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "HONG TEX COMPANY LIMITED",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "601/2013",
    "Permit Date": "2013-08-26T06:10:00Z",
    "Meeting Number": "20/2013",
    "Meeting Date": "2013-08-07T06:10:39Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.522,
    "Total Amount Of Capital (in Millions)": 0.522,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Tun Hla Win",
    "Land Area (units not specified in file)": 3.845,
    "Lease Term": 30,
    "Annual Lease Fee": 85580.99,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "A/2603, Daewoo Trumper World(2nd)48-1,Youido-Dong, Youngdeungpo-Gu, Seoul, Republic of Korea",
    "Organization Address":
      "17-1,Youido-Dong, Youngdeungpo-Gu, Seoul, Republic of Korea",
    "Investment Permitted Address":
      "Plot No.(457&460), Yaw Ah Twin Won U Poe Hlaing Street, Shwe Lin Pan Industrial Zone, Hlaing Thar Yar Township,Yangon Region",
  },
  {
    ID: 2472,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.KIM SANG YOO",
    "Name of Principal Organization": "INTERIDGE COMPANY LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "INTERIDGE COMPANY LIMITED",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "602/2013",
    "Permit Date": "2013-08-26T06:45:00Z",
    "Meeting Number": "20/2013",
    "Meeting Date": "2013-08-07T06:46:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of Hot-Fix Rhinestone on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3.414,
    "Total Amount Of Capital (in Millions)": 3.414,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Hla Hla Thein",
    "Land Area (units not specified in file)": 1.296,
    "Lease Term": 10,
    "Annual Lease Fee": 48,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Sam LG APT 101-502, Nan Mun Dong, Gang Neung City, Gang Won-Do, Republic of Korea",
    "Organization Address":
      "28-4, Nongonggdanji-Gil Jumunjin-Eup, Gang Neung-Si, Gang-Won-Do, Republic Of Korea",
    "Investment Permitted Address":
      "No.(195), Shwe Lin Pan Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2473,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Than Htut",
    "Name of Principal Organization":
      "MYANMAR ECONOMIC HOLDING COMPANY LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MYANMAR POSCO C&C COMPANY LIMITED",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "603/2013",
    "Permit Date": "2013-08-28T07:00:44Z",
    "Meeting Number": "20/2013",
    "Meeting Date": "2013-08-07T07:01:11Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing &  Marketing of Color Coated Steel, Roll Formed Color Sheet,(EPS) Panel, Urethane Panel, Glass Wool panel And Any other Similar Products",
    "Amount Of Foreign Capital USD (in Millions)": 12.187,
    "Total Amount Of Capital (in Millions)": 13.987,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "MYANMAR ECONMIC HOLDING COMPANY LIMITED",
    "Land Area (units not specified in file)": 4.942,
    "Lease Term": 30,
    "Annual Lease Fee": 1.8,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Rejected",
    "Investor Address":
      "Room No.(4), Building (10), Myawaddy Avenue, Mingalar Taung Nyunt Township,Yangon",
    "Organization Address":
      "No.(189/191), Mahabandoola Road, Botahtaung Township, Yangon",
    "Investment Permitted Address":
      "Plot No.(22), No.3, Trunk Road, Pyinmabin Industrial Complex, Mingalardon Township Yangon Region",
  },
  {
    ID: 2475,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.CHUNG FOOK PUI",
    "Name of Principal Organization": "BOGART LINGERIE LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "BOGART LINGERIE (YANGON) LIMITED",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "605/2013",
    "Permit Date": "2013-08-28T03:52:03Z",
    "Meeting Number": "21/2013",
    "Meeting Date": "2013-08-15T03:52:59Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Garment on CMP Basis  For Garment Factory No.(2)",
    "Amount Of Foreign Capital USD (in Millions)": 2.115,
    "Total Amount Of Capital (in Millions)": 2.115,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Tin Htay",
    "Land Area (units not specified in file)": 2.627,
    "Lease Term": 30,
    "Annual Lease Fee": 0.058471,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Terminated",
    "Investor Address":
      "17E, Flat A, Block 3A,Oceannaire, 18 Po Tai Street, Moan Shan NT, Hong Kong",
    "Organization Address":
      "16/F, Tower B, 223-231 Wai Yip Street,Kwun Tong, Kowloon, Hongkong",
    "Investment Permitted Address":
      "Plot No.(114), Myay Taing QR, 14, Shwe Than Lwin Industrial Zone, Hlaing Thar Yar Township,Yangon Region ",
  },
  {
    ID: 2476,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.TAMAYAMA KAZUO",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "HOPE ONE COMPANY LIMITED",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "606/2013",
    "Permit Date": "2013-08-28T04:24:25Z",
    "Meeting Number": "21/2013",
    "Meeting Date": "2013-08-15T04:24:56Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garments On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.6095,
    "Total Amount Of Capital (in Millions)": 0.6095,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Tin Tin Moe",
    "Land Area (units not specified in file)": 2.204,
    "Lease Term": 30,
    "Annual Lease Fee": 0.0535,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "35-33, Kawasaki Oku-Cho Inchinomiya City Aichi, Japan",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.(48), Myay Taing Quarter, No.(25), Twin Thinn Tike Wun U Tun Nyo  Street, Shwe Lin Pan Industrial Zone, Hlaing Thar Yar Township,Yangon Region.",
  },
  {
    ID: 2477,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Lam Wing Keung",
    "Name of Principal Organization": "GRAND ASIA CORPORATION LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "SUPREME ASIA GARMENT FACTORY LIMITED",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "607/2013",
    "Permit Date": "2013-08-28T04:48:12Z",
    "Meeting Number": "21/2013",
    "Meeting Date": "2013-08-15T04:48:36Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.971,
    "Total Amount Of Capital (in Millions)": 1.971,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "DAW SAN AYE",
    "Land Area (units not specified in file)": 1.352,
    "Lease Term": 30,
    "Annual Lease Fee": 0.0328,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Flat-G, 20th, Floor, Block 9, Park Island, Ma Wan,N.T. Hong Kong",
    "Organization Address":
      "Unit 702, 7-F, Tung Hip Commercial Building, 244 Des Voeux Road Central, Hong Kong",
    "Investment Permitted Address":
      "Plot No.(33), No.(42), Ingyin Myaing Street, Shwe Pyi Thar Industrial Zone (1), Shwe Pyi Thar Township, Yangon Region.",
  },
  {
    ID: 2478,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.WU XING HUA",
    "Name of Principal Organization":
      "SHANGHAI DONGLONG FEATHER MANUFACTURE COMPANY LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "DONG LONG (MYANMAR) GARMENT COMPANY LIMITED",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "608/2013",
    "Permit Date": "2013-08-28T05:02:55Z",
    "Meeting Number": "18/2013",
    "Meeting Date": "2013-07-10T05:03:55Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.526,
    "Total Amount Of Capital (in Millions)": 0.526,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Myint Myint Than",
    "Land Area (units not specified in file)": 0.499,
    "Lease Term": 30,
    "Annual Lease Fee": 0.0111,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.(310), Jinzhezhen Wangcun Wanggan, Qingpu District, Shanghai, China",
    "Organization Address":
      "No.288, Shang Zhou Road, Jinz Town(Shangta), Quinpu District, Shanghai, China",
    "Investment Permitted Address":
      "Plot No.68(Ka) Hlaingtharyar Industrial Zone, Yangon Region",
  },
  {
    ID: 2483,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "FLP Tharkayta Company Limited",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "FLP Tharkayta Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "100/2018",
    "Permit Date": "2018-06-23T08:50:23Z",
    "Meeting Number": "8/2018",
    "Meeting Date": "2018-06-22T08:50:54Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Development, leasing and management of warehouse and office",
    "Amount Of Foreign Capital USD (in Millions)": 6.76,
    "Total Amount Of Capital (in Millions)": 6.76,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 21,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Khin Htay Yee",
    "Land Area (units not specified in file)": 2.248,
    "Lease Term": 21,
    "Annual Lease Fee": 218292,
    "Land Use Premium": null,
    "Number Of Local Employees": 3,
    "Number Of Foreign Employees": 1,
    Status: "Approved",
    "Investor Address":
      "No. 53/62, Tharkayta Industrial Zone, Tharkayta Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No. 53/62, Tharkayta Industrial Zone, Tharkayta Township, Yangon",
  },
  {
    ID: 2484,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS.WU-I,SHIH",
    "Name of Principal Organization": "EAST BONANZA INT'L LIMITED",
    "Place of Incorporation": "Brunei Darussalam",
    "Company Name In Myanmar": "MILA GARDEN COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "775/2014",
    "Permit Date": "2014-08-14T03:19:26Z",
    "Meeting Number": "17/2014",
    "Meeting Date": "2014-06-20T03:19:58Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Footwear Products on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.1,
    "Total Amount Of Capital (in Millions)": 4.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Win May",
    "Land Area (units not specified in file)": 3.77,
    "Lease Term": 10,
    "Annual Lease Fee": 0.076,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.(8), Jinhua Road, North Dist, Taichung City 404, Taiwan",
    "Organization Address":
      "Room No.(51), 5th Floor, Britannia, Jalan Cator Bandar Seri Begawan BS 8811 Negara Brunei Darussalam",
    "Investment Permitted Address":
      "Kwin No.1038, Plot No.14/1,14/2,14/3,14/4,14/5,39/6, Hngetpyawtaw Kwin, Pyitawthar Village, Hlegu Township, Yangon Region.",
  },
  {
    ID: 2485,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Dr.Hlaing Chit Zaw",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Kaung Su San Pyin Nya Yeik Mon Co.,Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "120/2018",
    "Permit Date": "2018-10-15T03:46:41Z",
    "Meeting Number": "17/2018",
    "Meeting Date": "2018-10-12T03:46:10Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Private High School",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 6100,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Dr. Hlaing Chit Zaw and U Maung Aye",
    "Land Area (units not specified in file)": 1.228,
    "Lease Term": 10,
    "Annual Lease Fee": 42,
    "Land Use Premium": null,
    "Number Of Local Employees": 108,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "NO.29/8, STREET NO.4, SHWE PYI THAR GWE, SHWE PYI THAR TOWNSHIP, YANGON ",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 29/8, 29/5, MYAY TAING  BLOCK NO. 538 (A), PLOT NO. 165, 83, 84, MYAY TAING BLOCK NO.31, SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2486,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr.Li Pingwen",
    "Name of Principal Organization": "YUNNAN XI' ERNAN FEED CO., LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Golden Southwest Group Co., Ltd.",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "132/2019",
    "Permit Date": "2019-01-14T04:30:13Z",
    "Meeting Number": "1/2019",
    "Meeting Date": "2019-01-11T04:30:39Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "ကြက်သားပေါက် ထုတ်လုပ်ရောင်းချခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.309,
    "Total Amount Of Capital (in Millions)": 1.336,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "U Kyaw Mya Than ",
    "Land Area (units not specified in file)": 2.344,
    "Lease Term": 30,
    "Annual Lease Fee": 10938.67,
    "Land Use Premium": null,
    "Number Of Local Employees": 120,
    "Number Of Foreign Employees": 22,
    Status: "Monitoring Approved",
    "Investor Address":
      "Huanglongshan, Eastern Suburbs, Sanwa Village, A'La Township, Guandu District, Kuming City, Yunnan Province, China",
    "Organization Address":
      "Huanglongshan, Eastern Suburbs, Sanwa Village, A'La Township, Guandu District, Kuming City, Yunnan Province, China",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-115၊ မြောင်းတကာသံမဏိ စက်မှုဇုန်၊ မှော်ဘီမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2487,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်သော်တာဇင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "EVA CONSTRUCTION COMPANY LIMITED",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "116/98",
    "Permit Date": "1998-02-09T04:45:51Z",
    "Meeting Number": "1/98",
    "Meeting Date": "1998-01-09T04:46:39Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင်မီ သင်္ဘောဆေး(paint) ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 30.7,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်သန်းသန်းအေး(ခ) သော်တာဇင်(ခ) လင်ပေါခင်",
    "Land Area (units not specified in file)": 2.011,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "အမှတ်-၂၁၆/၂၂၂၊ ၈-လွှာ၊ မဟာဗန္ဓုလလမ်း၊ ပုဇွန်တောင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၂၃)၊ စက်မှုဇုန်အပိုင်း(၃)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2488,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U HTIN KYAW    ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ETERNAL TECHNICAL SUPPORTING COMPANY LIMITED         ",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "118/2018",
    "Permit Date": "2018-10-15T05:07:50Z",
    "Meeting Number": "17/2018",
    "Meeting Date": "2018-10-12T05:08:08Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Education Services",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 2917.41,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 2.087,
    "Lease Term": 5,
    "Annual Lease Fee": 600,
    "Land Use Premium": null,
    "Number Of Local Employees": 107,
    "Number Of Foreign Employees": 40,
    Status: "Submitted",
    "Investor Address":
      "NO.96/J, INYA ROAD, WARD NO. 9, KAMARYUT TOWNSHIP, YANGON ",
    "Organization Address": "",
    "Investment Permitted Address":
      "NO. 24, PLOT NO.8-/C1/1-A2 +      2A /B, MYAY TAING BLOCK NO. 83+ 84, SAE MYAUNG ROAD, WARD NO. 11, YANKIN TOWNSHIP, YANGON REGION ",
  },
  {
    ID: 2489,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Daw Thawda Aung",
    "Name of Principal Organization": "Apex Gas and Oil Public Co., Ltd.",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Apex Union Gas Company Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "064/2018",
    "Permit Date": "2018-03-08T06:24:29Z",
    "Meeting Number": "3/2018",
    "Meeting Date": "2018-02-27T06:24:50Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Construction of the Bulk LPG Terminal and Bottling Plant, Importation, Storage, Distribution and Sales of LPG",
    "Amount Of Foreign Capital USD (in Millions)": 8.67,
    "Total Amount Of Capital (in Millions)": 14.45,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 27,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner":
      "မြန်မာ့ဆိပ်ကမ်းအာဏာပိုင်၊ ပို့ဆောင်ရေးနှင့်ဆက်သွယ်ရေးဝန်ကြီးဌာန",
    "Land Area (units not specified in file)": 6.876,
    "Lease Term": 27,
    "Annual Lease Fee": 5.78,
    "Land Use Premium": null,
    "Number Of Local Employees": 70,
    "Number Of Foreign Employees": 4,
    Status: "Approved",
    "Investor Address": "No.F-54, Shwe Sabei 4th Street, FMI City, ",
    "Organization Address":
      "No.51, Shwe Hinthar Condo (A), 10th Floor, Room No.(1003), 6-Mile, Pyay Road, Hlaing Township.",
    "Investment Permitted Address":
      "Plot No.(1/2)B, Thilawa Port Area, Thanlyin-Kyauktan Area, ",
  },
  {
    ID: 2490,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဝင်းလွင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MYAT MI BA COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1146/2016",
    "Permit Date": "2016-03-24T07:52:25Z",
    "Meeting Number": "9/2016",
    "Meeting Date": "2016-03-11T07:53:42Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "စက္ကူထုတ်ပိုးပစ္စည်းအမျိုးမျိုးထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 8656.24,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "အမှတ်(၃) အကြီးစားစက်မှုလုပ်ငန်း",
    "Land Area (units not specified in file)": 60.24,
    "Lease Term": 20,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "အမှတ်(၉၈)၊ မြေညီလမ်း၊ လမ်း-၅၀၊ ပုဇွန်တောင်မြို့နယ်၊ ရန်ကုန်",
    "Organization Address": "",
    "Investment Permitted Address":
      "ကွင်းအမှတ်(၆၅၉-အေ)၊အလွမ်းဆွတ်ရွာမကွင်းနှင်‌့ ၆၅၉-ဘီ/အလွမ်းဆွတ်တောင်ကွင်း၊ အလွမ်းဆွတ်ကျေးရွာအုပ်စု၊ သန်လျင်မြို့နယ်၊ ရန်ကုန်",
  },
  {
    ID: 2491,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. CHAN KUM WENG",
    "Name of Principal Organization": "BATCH TECHNOLOGIES PTE LTD.",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar": "MYANMAR BATCH TECHNOLOGIES COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "922/2015",
    "Permit Date": "2015-03-19T08:52:09Z",
    "Meeting Number": "3/2015",
    "Meeting Date": "2015-02-27T08:52:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND INSTALLATION OF CONCRETE BATCHING PLANT AND ACCESSORIES",
    "Amount Of Foreign Capital USD (in Millions)": 1.281,
    "Total Amount Of Capital (in Millions)": 1.507,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "DAW KHIN THEIN WIN",
    "Land Area (units not specified in file)": 0.253,
    "Lease Term": 10,
    "Annual Lease Fee": 46.2,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "BLK 200LOYANG AVENUE # 01-01 SINGAPORE  509058",
    "Organization Address": "NO.52 SENOKO ROAD, SINGAPORE 758116",
    "Investment Permitted Address":
      "PLOT NO. 2742, MYAY TAING BLOCK NO. 63, PYI HTAUNG SU STREET, INDUSTRIAL ZONE 92), DAGON (SOUTH) TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2492,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Tin Maung Win",
    "Name of Principal Organization":
      "International Language & Business Centre (ILBC) Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "International Language & Business Centre (ILBC) Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "094/2018",
    "Permit Date": "2018-07-07T04:48:17Z",
    "Meeting Number": "9/2018",
    "Meeting Date": "2018-07-07T04:48:43Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Providing Private Education using National and International Curricula",
    "Amount Of Foreign Capital USD (in Millions)": 52.876,
    "Total Amount Of Capital (in Millions)": 52.876,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner":
      "Ingyin Lapyae, U Tin Maung Win, Myanmar Economic Holdings Limited, U Myint Tin, U Shan Ka YIn",
    "Land Area (units not specified in file)": null,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 2273,
    "Number Of Foreign Employees": 92,
    Status: "Monitoring Approved",
    "Investor Address":
      "No. 58/B, Inya Road, Ward No. 10, Kamayut Township, Yangon",
    "Organization Address":
      "No. 58/B, Inya Road, Ward No. 10, Kamayut Township, Yangon",
    "Investment Permitted Address":
      "Yangon Region, Mandalay Region, Naypyitaw Council, Kachin State, Sagaing Region, Shan Stae, Bago Region, Thanintharyi Region",
  },
  {
    ID: 2493,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်နန်းချမ်းမြေ့မွန်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Lucky Golden Dragon Trading Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1081/2015",
    "Permit Date": "2015-09-05T06:29:33Z",
    "Meeting Number": "15/2015",
    "Meeting Date": "2015-08-21T06:29:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Contract Manufacturing Process (CMP) စနစ်ဖြင့် ပလတ်စတစ် အိတ်အမျိုးမျိုး ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 4.291,
    "Total Amount Of Capital (in Millions)": 7546,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်နန်းချမ်းမြေ့မွန်",
    "Land Area (units not specified in file)": 2.417,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၂၀၊ အရှေ့မြင်းပြိုင်ကွင်းလမ်း၊ တာမွေမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ ဒဂုံမြို့သစ် (ဆိပ်ကမ်းမြို့နယ်)၊ စက်မှုဇုန် (၂)၊ မြေကွက်အမှတ် ၇၃",
  },
  {
    ID: 2495,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Aung Min Han",
    "Name of Principal Organization":
      "Ever Flow River Group of Companies (Public) Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "Hlaing Inland Terminal and Logistics Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "078/2018",
    "Permit Date": "2018-04-29T07:36:34Z",
    "Meeting Number": "5/2018",
    "Meeting Date": "2018-04-20T07:38:31Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "ထောက်ပံ့ပို့ဆောင်ရေး၊ ကုန်သေတ္တာသိုလှောင်ရေးစခန်းနှင့် Bonded Warehouse လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 62000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "လန်းပြီပင်လယ်ရေကြောင်းကုမ္ပဏီလီမိတက်၊ မြန်မာ့ဆိပ်ကမ်းအာဏာပိုင် (ဆိပ်ခံတံတားတည်ဆောက်ရန်)",
    "Land Area (units not specified in file)": 40,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 103,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "No.4, Ground Floor (B), Mya Marlar Street, Ward No. 3, Kamayut Township, Yangon",
    "Organization Address":
      "No.39, Alalpya Pagoda Street, United Condo (1), Fourth Floor,  Yaw Min Gyi Ward, Dagon Township, Yangon ",
    "Investment Permitted Address":
      "Myay Taing Block No. 15, Plot No. 1/B, Yaw Atwin Win U Phoe Hlaing Street, Shwe Lin Pan industrial Zone, Hlaing Tharyar Township, Yangon",
  },
  {
    ID: 2496,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးညာဏ်လင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Shan Maw Myae Manufacturing Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "MaNaTha-1029/2015",
    "Permit Date": "2015-02-02T08:06:08Z",
    "Meeting Number": "1/2015",
    "Meeting Date": "2015-01-16T08:06:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီ စက္ကူပန်း၊ စက္ကူကြိုးဖြင့် စာအိတ်အလှဆင်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 309.31,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးစမ်းရှိန် (ခ) ဦးစန်းရှိန်",
    "Land Area (units not specified in file)": 0.238,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၉၃၊ ၇ လွှာ၊ ဗိုလ်ချုပ်လမ်း၊ ပုဇွန်တောင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ တွံ့တေးမြို့နယ်၊ ရှမ်းစုကျေးရွာအုပ်စု၊ ကွင်းအမှတ်(80)၊ ရှမ်းစုကွင်းအတွင်းရှီ မြေဧရိယာ (0.29)ဧက",
  },
  {
    ID: 2497,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "MR.PRASANTHI NANDWANI KUMAR MOTI",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ROYAL BRITISH INTERNATIONAL COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "123/2018",
    "Permit Date": "2018-11-08T09:16:14Z",
    "Meeting Number": "18/2018",
    "Meeting Date": "2018-11-02T09:16:04Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Education Services",
    "Amount Of Foreign Capital USD (in Millions)": 0.28,
    "Total Amount Of Capital (in Millions)": 0.28,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Malaysia",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Htay Htay Myint",
    "Land Area (units not specified in file)": 0.112,
    "Lease Term": 10,
    "Annual Lease Fee": 60,
    "Land Use Premium": null,
    "Number Of Local Employees": 17,
    "Number Of Foreign Employees": 5,
    Status: "Approved",
    "Investor Address": "NO. (15), THUKHITAR STREET, YANKIN TOWNSHIP, YANGON ",
    "Organization Address": "",
    "Investment Permitted Address":
      "NO. 15, PLOT NO. 78, MYAY TAING BLOCK NO. 4(KANBAE), THUKHITAR STREET, KANBAE WARD, YANKIN TOWNSHIP, YANGON REGION ",
  },
  {
    ID: 2499,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Mya Han",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Fortune Broadcasting Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "117/2018",
    "Permit Date": "2018-08-15T09:55:53Z",
    "Meeting Number": "15/2018",
    "Meeting Date": "2018-09-15T09:55:38Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Fortune TV Channel Production and Broadcasting",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 5192,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "No. 12 (B), Khapuang Street, Ward 10, Hlaing Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Building No. 14, Ground Floor and First Floor, MICT Park, Hlaing Township, Yangon Region",
  },
  {
    ID: 2500,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "ISEC MYANMAR COMPANY LIMITED",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ISEC MYANMAR COMPANY LIMITED\t",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "121/2018",
    "Permit Date": "2018-11-08T09:59:08Z",
    "Meeting Number": "18/2018",
    "Meeting Date": "2018-11-02T09:59:56Z",
    Sector: "Other Services",
    "Type Of Investment Business": "International Eye Specialist Hospital",
    "Amount Of Foreign Capital USD (in Millions)": 0.77,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Yu Yu Win",
    "Land Area (units not specified in file)": null,
    "Lease Term": 30,
    "Annual Lease Fee": 144,
    "Land Use Premium": null,
    "Number Of Local Employees": 17,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      " BUILDING NO. 16#3-01, MYANMAR ICT PARK, UNIVERSITIES HLAING CAMPUS, HLAING TOWNSHIP, YANGON",
    "Organization Address": "",
    "Investment Permitted Address":
      "BUILDING NO.B, LEVEL 1 TO 5, MIN YE KYAW SWAR COMMERCIAL BUILDING, CORNER OF PYAY ROAD AND  MIN YE KYAW SWAR ROAD, LANMADAW TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2501,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးညီညီထွန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MYANMAR HIGH CHOICE COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1064/2015",
    "Permit Date": "2015-07-10T06:11:13Z",
    "Meeting Number": "11/2015",
    "Meeting Date": "2015-06-19T06:11:42Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 152.125,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 0.846,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "တိုက်အမှတ်(၁၁၉)၊ အခန်းအမှတ်(၈)၊ ရန်နိုင်လမ်းသွယ်(၁)  လမ်း၊ (၄) ရပ်ကွက်၊ ရန်ကင်းမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၀၁၊၁၀၅နှင့်၁၀၆၊ မြေတိုင်းရပ်ကွက်အမှတ်-၁၄၄၊ တပင်ရွှေထီးလမ်းနှင့် ဝက်မစွက်ဝန်ထောက်လမ်းထောင့်၊ တောင်ဒဂုန်စက်မှုဇုန်၊ ဒဂုံမြို့သစ်(တောင်ပိုင်း)မြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2502,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးသာဌေး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ORIGINAL GROUP COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1148/2016",
    "Permit Date": "2016-03-24T06:34:29Z",
    "Meeting Number": "9/2016",
    "Meeting Date": "2016-03-11T06:34:58Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Precast Concrete Product ထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 7866,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 11.885,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၁၈/စီ)၊ အင်းယားမြိုင်လမ်း၊ ရွှေတောင်ကြား(၁) ရပ်ကွက်၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ ဒဂုံဆိပ်ကမ်းမြို့နယ်၊ ၉၃-ရပ်ကွက်၊ မြေတိုင်းရပ်ကွက်အမှတ်(၇၅)၊ မြေကွက်အမှတ်(၈-၉)၊",
  },
  {
    ID: 2503,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမြင့်ရွှေ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "SAN KAUNG BAG MANUFACTURING COMPANY LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1065/2015",
    "Permit Date": "2015-07-10T07:16:35Z",
    "Meeting Number": "11/2015",
    "Meeting Date": "2015-06-19T07:17:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ဘိလပ်မြေထည့်သော ပလတ်စတစ်အိတ်အမျိုးမျိုးထုတ်လုပ်ဖြန့်ဖြူးရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 4165.775,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 8.038,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "အမှတ်(၁၅၄/အေ)၊ မေယု(၅) လမ်း၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၀၊၁၂၊ ၁၄)၊ မြေတိုင်းရပ်ကွက်အမှတ်(၂၄)၊ ငွေပင်လယ်စက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2504,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Li, Jian",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Kais Leather (Myanmar) Co., Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "134/2018",
    "Permit Date": "2018-12-10T02:55:18Z",
    "Meeting Number": "20/2018",
    "Meeting Date": "2018-12-07T03:00:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Bag on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 20,
    "Total Amount Of Capital (in Millions)": 20,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaw Soe Moe and Daw Thein Yin",
    "Land Area (units not specified in file)": 2.773,
    "Lease Term": 10,
    "Annual Lease Fee": 158.4,
    "Land Use Premium": null,
    "Number Of Local Employees": 700,
    "Number Of Foreign Employees": 20,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.18, Jinshi Road, Shiling Town, Huadu District, Guangzhou, People's Republic of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No-4, Myay Taing Block No.24,Ngwe Pin Le Industrial Zone, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 2506,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. yan Qingmiao",
    "Name of Principal Organization":
      "Hong Kong Yanshi Leather Company Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Myanmar Muse Leather Goods Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "139/2019",
    "Permit Date": "2019-01-21T04:34:54Z",
    "Meeting Number": "1/2019",
    "Meeting Date": "2019-01-21T04:37:11Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of Various Kinds Of Bags On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.794,
    "Total Amount Of Capital (in Millions)": 1.794,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 32,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Thandar Aung",
    "Land Area (units not specified in file)": 2.512,
    "Lease Term": 12,
    "Annual Lease Fee": 120,
    "Land Use Premium": null,
    "Number Of Local Employees": 498,
    "Number Of Foreign Employees": 16,
    Status: "Draft",
    "Investor Address":
      "No. 35, Zhenxing north Road, Shiling Town, Huadu District, Guangzhou, People's Republic Of China",
    "Organization Address":
      "RM 1205, 12/F Tai Sang Bank Bldg, 130-132 Des Voeux Rd, Central, Hong Kong",
    "Investment Permitted Address":
      "Plot No.(56-B+57), Myay Taing Block No. (109), Dagon Myothit East industrial Zone, Yangon Region",
  },
  {
    ID: 2507,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Watanabe Yuichiro",
    "Name of Principal Organization": "Hana Seimitsu Kogyo Company Limited",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Hana Yangon Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "140/2019",
    "Permit Date": "2019-01-21T04:52:54Z",
    "Meeting Number": "1/2019",
    "Meeting Date": "2019-01-21T04:55:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production and 100% Exporting Of Machinery And Equipment",
    "Amount Of Foreign Capital USD (in Millions)": 1.275,
    "Total Amount Of Capital (in Millions)": 1.275,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "U Than Zaw Myint",
    "Land Area (units not specified in file)": 0.537,
    "Lease Term": 10,
    "Annual Lease Fee": 0.010865,
    "Land Use Premium": null,
    "Number Of Local Employees": 59,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "1-14-13-105, Saiwaicho Saitama Prefecture, Kawaguchi-City, Japan",
    "Organization Address":
      "No.17, Motogo 3-Chome 23,Saitama Prefecture, kawaguchi-city, Japan",
    "Investment Permitted Address":
      "Plot No. (469), Myay Taing Block No. 25, Shwe Lin Ban Industrial Myo, Hlaing Thar Yar, Yangon Region",
  },
  {
    ID: 2508,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Shu Kean",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Yakeda Myanmar Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "141/2019",
    "Permit Date": "2019-01-21T05:31:05Z",
    "Meeting Number": "1/2019",
    "Meeting Date": "2019-01-21T05:34:59Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of Various Kinds Of Bags On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.358,
    "Total Amount Of Capital (in Millions)": 0.358,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 26,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Ye Tint Lwin, Daw Su SU Hlaing",
    "Land Area (units not specified in file)": 2.415,
    "Lease Term": 6,
    "Annual Lease Fee": 78,
    "Land Use Premium": null,
    "Number Of Local Employees": 610,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "Group 6 Of Zhongluo Village, Yanggang Town, Yangxin Country, Hubei Province, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.380, Myay Taing Block No.49, War Ta Yar Industrial Zone, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 2509,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Gao Peina",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Best Win (Myanmar) Garment Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "142/2019",
    "Permit Date": "2019-01-21T06:09:52Z",
    "Meeting Number": "2/2019",
    "Meeting Date": "2019-01-21T06:09:56Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3,
    "Total Amount Of Capital (in Millions)": 3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Aye Aye Myint",
    "Land Area (units not specified in file)": 3.188,
    "Lease Term": 5,
    "Annual Lease Fee": 433.65,
    "Land Use Premium": null,
    "Number Of Local Employees": 1052,
    "Number Of Foreign Employees": 21,
    Status: "Draft",
    "Investor Address":
      "No.88, Huanxi Road, Zhutang Town, Jiangyin City, Jiangsu Province, China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot NO.71, Myay Tainf Block No.50, Thar Du Kan Industrial Zone, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 2511,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Li Weixing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Enjoy Fashion Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "143/2019",
    "Permit Date": "2019-01-21T08:08:03Z",
    "Meeting Number": "2/2019",
    "Meeting Date": "2019-01-21T08:08:19Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.19,
    "Total Amount Of Capital (in Millions)": 1.19,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 35,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Soe Win",
    "Land Area (units not specified in file)": 1.867,
    "Lease Term": 15,
    "Annual Lease Fee": 66,
    "Land Use Premium": null,
    "Number Of Local Employees": 1300,
    "Number Of Foreign Employees": 30,
    Status: "Draft",
    "Investor Address":
      "Room 303, Xingfeng Yuan, Yangshe Town, Zhangiang City, JiangSu Province, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.101, Myay Taing Block No.14, Shwe Than Lwin, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2512,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ချိန်ယုရင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Sampar Oo Industries Co.,Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "မနသသ-၉၁၅/၂၀၁၃",
    "Permit Date": "2013-05-30T09:10:16Z",
    "Meeting Number": "15/2013",
    "Meeting Date": "2013-05-22T09:11:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အိမ်သုံးပလပ်စတစ်ပစ္စည်းမျိုးစုံ ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 152,
    "Total Amount Of Capital (in Millions)": 13396.34,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးကျော်ဝေ",
    "Land Area (units not specified in file)": 4.001,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 101,
    "Number Of Foreign Employees": 2,
    Status: "Draft",
    "Investor Address":
      "အမှတ်(၂၃၇)၊ ၃၄ လမ်း၊ ၈၄ လမ်းနှင့် ၈၅ လမ်းကြား၊ ချမ်းအေးသာဇံမြို့နယ်၊မန္တလေးတိုင်းဒေသကြီး။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၂၀)၊မြေတိုင်းရပ်ကွက်အမှတ်(၁၄)၊ မင်းဧရာလမ်း၊ ရွှေသသံလွင်စက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2513,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Phyu Thet Mar",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Euro World International Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "144/2019",
    "Permit Date": "2019-01-21T09:41:27Z",
    "Meeting Number": "2/2019",
    "Meeting Date": "2019-01-21T09:41:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 1059.866,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Myat Ko",
    "Land Area (units not specified in file)": 1.37,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 205,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address":
      "Plot No.2, Kwan Att Thar Min Thar Rd, Dagon Seikkan Industrial Zone, Dagon Seikkan Township, Yangon Region",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.(2+3), Myay Taing Block No. Industrial Zone(1), Dagon Seikkan Township, Yangon Region",
  },
  {
    ID: 2514,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhao Duo",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "General Textile (Myanmar) Apparel Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "145/2019",
    "Permit Date": "2019-01-21T10:01:43Z",
    "Meeting Number": "2/2019",
    "Meeting Date": "2019-01-21T10:01:47Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3.132,
    "Total Amount Of Capital (in Millions)": 3.132,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်နန်းခင်၀င်းကြည် (ခ) ဆုသက်ပိုင်",
    "Land Area (units not specified in file)": 1.35,
    "Lease Term": 10,
    "Annual Lease Fee": 15.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 2500,
    "Number Of Foreign Employees": 30,
    Status: "Draft",
    "Investor Address":
      "No.134, Remin Road, Wenlin Zhutang Township, Jiangyin City, People's Republic of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "ဦးပိုင်အမှတ်(၁၅/၁)၊ ကွင်းအမည် ၅၇၇-အင်းလျှက်၊ ဦးပိုင်အမှတ်(၁၆/၁)၊ ကွင်းအမည် ၅၇၇-ကျောက်ပုန်း၊ အင်းလျက်ကျေးရွာ၊ မှော်ဘီမြို့နယ်၊ မြောက်ပိုင်းခရိုင်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2515,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yang, Hongliang ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Hon Xiang Company Limited (ဟုန်ရှန် ကုမ္ပဏီလီမီတက်)",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "146/2019",
    "Permit Date": "2019-01-21T04:03:01Z",
    "Meeting Number": "2/2019",
    "Meeting Date": "2019-01-21T04:04:24Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Normal System နှင့် Contract Processing  System စနစ်(၂)မျိုးဖြင့် ရေချိုနှင့် ရေငံငါး၊ ပုစွန်များ အေးခဲ၍ ပြုပြင်ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 2.855,
    "Total Amount Of Capital (in Millions)": 2.855,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Nan Mya Mya Ohn",
    "Land Area (units not specified in file)": 2.742,
    "Lease Term": 30,
    "Annual Lease Fee": 0.038837,
    "Land Use Premium": null,
    "Number Of Local Employees": 292,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "Anxin Country Zhao Bei Kou Zhen Yangzhuang Zi Cun Road North No.2 Baoding City, Hebei Province, People Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 67, Industrial Zone (1), Dagon Seikkan Township, Yangon Region",
  },
  {
    ID: 2516,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lai Han Qing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Luckysky Bags Myanmar Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "147/2019",
    "Permit Date": "2019-01-21T04:34:58Z",
    "Meeting Number": "2/2019",
    "Meeting Date": "2019-01-21T04:35:19Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Bags On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.845,
    "Total Amount Of Capital (in Millions)": 1.845,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Than Zaw Htwe",
    "Land Area (units not specified in file)": 2.428,
    "Lease Term": 5,
    "Annual Lease Fee": 120,
    "Land Use Premium": null,
    "Number Of Local Employees": 700,
    "Number Of Foreign Employees": 30,
    Status: "Draft",
    "Investor Address":
      "Room 801, No.19, Jiayuan Street, Baiyun District, Yule Road, Guang Zhou, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.18, Myay Taing Block No. 21, Mya Sein Yaung Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2517,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yang Chih Chiang ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Mountain Top Global Limited ",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "148/2019",
    "Permit Date": "2019-01-21T04:57:28Z",
    "Meeting Number": "2/2019",
    "Meeting Date": "2019-01-21T04:57:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Shoes On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.921,
    "Total Amount Of Capital (in Millions)": 2.921,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Ti Ti Han",
    "Land Area (units not specified in file)": 2.752,
    "Lease Term": 30,
    "Annual Lease Fee": 0.033408,
    "Land Use Premium": null,
    "Number Of Local Employees": 500,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "No.52, Thin Shan Square, Houjie Town, Dong Guan, Guangdong, Taiwan People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.176, Myay Taing Block No.49, War Ta Yar Industrial   Zone, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 2518,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးသန်းလွင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "HEIN MYANMAR INDUSTRIAL COMPANY LIMITED",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "manatha-109/97",
    "Permit Date": "1997-12-26T05:05:03Z",
    "Meeting Number": "20/97",
    "Meeting Date": "1997-12-05T05:08:45Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် ထီးထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 48,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 3.72,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၅၅)၊ မြေညီထပ်၊ ၂-လမ်း၊ လမ်းမတော်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ တာမွေမြို့နယ်၊ စက်မှုဇုန်မေတ္တာညွန့်ရပ်ကွက်၊ စက်မှု(၃)လမ်း၊ အမှတ် (၁၆၇)",
  },
  {
    ID: 2519,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်သော်တာဇင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "EVA COMPANY LIMITED",
    "Financial Year From": 97,
    "Financial Year To": 98,
    "Permit Number": "127/98",
    "Permit Date": "1998-03-10T05:25:34Z",
    "Meeting Number": "3/98",
    "Meeting Date": "1998-02-06T05:26:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ သွပ်ပြားထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 25.6,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်သန်းသန်းအေး(ခ) သော်တာဇင်၉ခ) လင်ပေါခင်",
    "Land Area (units not specified in file)": 2.011,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၂၁၆/၂၂၂)၊(၈-လွှာ)၊ မဟာဗန္ဓုလလမ်း၊ ပုဇွန်တောင်မြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၂၃)၊ စက်မှုဇုန်အပိုင်း(၃)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 2520,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr. Lau Kim Fung",
    "Name of Principal Organization":
      "CHANGE  U EDUCATION ASIA PACIFIC HOLDING LIMITED",
    "Place of Incorporation": "Hong kong",
    "Company Name In Myanmar":
      "Myanmar   CHANGE U MYANMAR INTERNATIONAL COLLEGE COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "140/2019",
    "Permit Date": "2019-02-06T06:35:31Z",
    "Meeting Number": "4/2019",
    "Meeting Date": "2019-02-04T06:35:35Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "PROVIDING PRIVATE EDUCATION  SERVICES INCLUDING HIGHER EDUCATION ",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Khin Myo That",
    "Land Area (units not specified in file)": 3332,
    "Lease Term": 5,
    "Annual Lease Fee": 51000,
    "Land Use Premium": null,
    "Number Of Local Employees": 49,
    "Number Of Foreign Employees": 3,
    Status: "Approved",
    "Investor Address":
      "ROOM 803, UNIT # 1, BLOCK # 1, JADE CITY, PHASE 5, HUA RUN ROAD, JINJANG DISTRICT, CHENGDU, SICHUAN PROVINCE, CHINA",
    "Organization Address":
      "NO. 161, WAI YIP STREET, UNIT 1802, 18/F TAMSON PLAZA, KWUN TONG, KOWLOON, HONG KONG ",
    "Investment Permitted Address":
      "3rd AND 4th FLOOR, BUILDING NO.4, JUNCTION SQUARE, PYAY ROAD, KAMAYUT TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2521,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်သော်တာဇင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "EVA CONSTRUCTION COMPANY LIMITED",
    "Financial Year From": 98,
    "Financial Year To": 99,
    "Permit Number": "manatha-130/98",
    "Permit Date": "1998-04-03T06:22:36Z",
    "Meeting Number": "5/98",
    "Meeting Date": "1998-03-06T06:23:10Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ သံချောင်း(Iron Rods) ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 88.2,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်သန်းသန်းအေး(ခ) သော်တာဇင်(ခ) လင်ပေါခင်",
    "Land Area (units not specified in file)": 2.011,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၂၁၆/၂၂၂)၊ ၈-လွှာ၊ မဟာဗန္ဓုလလမ်း၊ ပုဇွန်တောင်မြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၂၂)၊စက်မှုဇုန်အပိုင်း(၃)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2522,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်သစ်သစ်အောင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "GLORY VICTORY INDUSTRIES LIMITED",
    "Financial Year From": 98,
    "Financial Year To": 99,
    "Permit Number": "manatha-135/98",
    "Permit Date": "1998-04-30T06:54:09Z",
    "Meeting Number": "6/98",
    "Meeting Date": "1998-04-26T06:58:42Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "C.M.P စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီ ဦးထုပ်(HAT) ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 30.78,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "GLORY VICTORY INDUSTRIES LIMITED",
    "Land Area (units not specified in file)": 1.815,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်(၂၇)၊ ဘောဂလမ်း၊၉-မိုင်၊ ၅-ရပ်ကွက်၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၇)၊ လှိုင်သာယာစက်မှုဇုန်(၂)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2523,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဖေဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "TAW WIN MYANMAR COMPANY LIMITED",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "manatha-570/2003",
    "Permit Date": "2003-01-07T07:15:03Z",
    "Meeting Number": "31/02",
    "Meeting Date": "2002-09-13T07:15:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "C.M.P စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 10.5,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးဖေဝင်း",
    "Land Area (units not specified in file)": 0.75,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အကွက်အမှတ်(၁၂၂)၊ ဖန်ချက်ဝန်ဦးမြူးလမ်း၊ လှိုင်သာယာမြို့နယ်၊ စက်မှုဇုန်(၁)၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၄၁)၊ ကနောင်မင်းသားကြီးလမ်း၊ စက်မှုဇုန်(၁)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2525,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Li Ming Cheng",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Sunway Shoes Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "149/2019",
    "Permit Date": "2019-01-21T07:39:13Z",
    "Meeting Number": "2/2019",
    "Meeting Date": "2019-01-21T07:39:20Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Shoes ON CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.541,
    "Total Amount Of Capital (in Millions)": 2.541,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Than Lin @ Mon Lin , U Kyaw Khin",
    "Land Area (units not specified in file)": 2.838,
    "Lease Term": 10,
    "Annual Lease Fee": 0.126,
    "Land Use Premium": null,
    "Number Of Local Employees": 2000,
    "Number Of Foreign Employees": 49,
    Status: "Draft",
    "Investor Address":
      "No.106,Lv Xianzhuang Village, Xuefang Town, Laiyang City, Shandong Province, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.11, Myay Taing Block No.143/1,Dagon Myothit South Township, Yangon Region",
  },
  {
    ID: 2526,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aye Myat Ko",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "PSB Company Limited (ပီအက်စ်ဘီကုမ္ပဏီလီမီတက် )",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "150/2019",
    "Permit Date": "2019-01-21T07:59:00Z",
    "Meeting Number": "2/2019",
    "Meeting Date": "2019-01-21T07:59:03Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "စက္ကူပုံးများထုတ်လုပ်၍ ပြည်တွင်း၌ရာနှုန်းပြည့်ဖြန့်ဖြူးရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 3780.335,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးဘိန်ဟင်း (ခ) ဦးခွေးလေး၊ ဒေါ်နန်းဖူး",
    "Land Area (units not specified in file)": 2,
    "Lease Term": 6,
    "Annual Lease Fee": 0.114,
    "Land Use Premium": null,
    "Number Of Local Employees": 89,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "Plot No.671/A, Mya Kan Thar 2 street, 2 Quator, Ka Mar Yut Township ,Yangon Region",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot NO.120,121, Myay Taing Block No.25, Shwe Lin Ban Industrial Myo, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2527,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Willow Oriental (Myanmar) Textile Company Limited",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Willow Oriental (Myanmar) Textile Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "151/2019",
    "Permit Date": "2019-01-21T08:11:50Z",
    "Meeting Number": "2/2019",
    "Meeting Date": "2019-01-21T08:11:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အိပ်ရာခင်းအသုံးအဆောင်များ ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 3.523,
    "Total Amount Of Capital (in Millions)": 3.523,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Zaw Win",
    "Land Area (units not specified in file)": 4.783,
    "Lease Term": 8,
    "Annual Lease Fee": 0.39988,
    "Land Use Premium": null,
    "Number Of Local Employees": 190,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "Room No. 1702,582-592 Nathan Road, Sino Centre, Mongkok, KIn, Hong Kong",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. B-7, Myay Taing Block NO.175, Dagon Seikkan Township, Yangon Region",
  },
  {
    ID: 2528,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်မျိုး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "INZALI THIDAR COMPANY LIMITED",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "manatha-571/2003",
    "Permit Date": "2003-01-07T08:55:14Z",
    "Meeting Number": "31/2002",
    "Meeting Date": "2002-09-13T08:55:51Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "C.M.P စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မှီ အဝတ်အထည်အမျိုးမျိုးချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 79,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအောင်မျိုး",
    "Land Area (units not specified in file)": 0.684,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(အီး-၉၂)၊ အက်(ဖ်)အမ် အိုင် စီးတီး၊ လှိုင်မြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၃၁၄/၃၁၅)၊ မြေတိုင်းရပ်ကွက်အမှတ်(၁၉/၁)၊ ရွှေပေါက်ကံစက်မှုဇုန်၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2529,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးတင့်လွင်(ခ)ချန်းချန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MYANMAR APPAREL COMPANY LIMITED",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "manatha-576/2003",
    "Permit Date": "2003-01-18T09:04:28Z",
    "Meeting Number": "38/2002",
    "Meeting Date": "2002-11-20T09:05:23Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "C.M.P စနစ်ဖြင့် အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 40.51,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးတင့်လွင်၊ ဦးရှီးဆွေ",
    "Land Area (units not specified in file)": 2.733,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၅၉(အေ)၊ ဗိုလ်ရာညွှန့်လမ်း၊ ဒဂုံမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်(၃၅/၃၆)အေ၊ ဗန်းမော်အတွင်းဝန်လမ်း၊ စက်မှုဇုန်(၃)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2531,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမြင့်ဌေး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "U.M.H COMPANY LIMITED",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "manatha-578/03",
    "Permit Date": "2003-01-16T03:48:01Z",
    "Meeting Number": "38/2002",
    "Meeting Date": "2002-11-20T03:48:46Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "C.M.P စနစ်ဖြင့် နိုင်ငံတကအဆင့်မီ အဝတ်အထည်အမျိုးမျိုး ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 48.6,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးသောင်းရွှေ",
    "Land Area (units not specified in file)": 3.25,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "တိုက်အမှတ်(၇)၊ အခန်းအမှတ်-၅/၆၊ ဇီဇဝါအဆင့်မြှင့်အိမ်ယာ၊ အမှတ်(၂)၊ မြင်သာ၊ သံသုမာလမ်း၊ တောင်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၂၈-င)၊ မြေတိုင်းရပ်ကွက်အမှတ် (၅၃၈-က)၊ အမှတ် (၄) အဝေးပြေးလမ်းမကြီး၊ ရွှေပြည်သာမြို့နယ် နှင့် အမှတ် (၄၄၁)၊ ပျဉ်းမပင်လမ်း၊ ထောက်ကြံ့၊ မင်္ဂလာဒုံမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2532,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးလှထွန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "RUBY GARMENT MANUFACTURING COMPANY LIMITED",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "manatha-579/03",
    "Permit Date": "2003-02-12T05:18:36Z",
    "Meeting Number": "39/2002",
    "Meeting Date": "2002-12-10T04:14:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "C.M.P စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 37.38,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအောင်သိန်း၊ ဒေါ်ခင်လင်းဦး",
    "Land Area (units not specified in file)": 1.484,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၄၄)၊ ဘုရားလမ်း(၄) ရပ်ကွက်၊ ဇီးကုန်းမြို့နယ်၊ ပဲခူးတိုင်း",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၂၃၅)၊ လှိုင်သာယာစက်မှုဇုန်(၂)၊ ကနောင်မင်းသားကြီးလမ်း၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2537,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်သန်းသန်းစု",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "IDEAL BUSINESS SUCCESS COMPANY LIMITED",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "manatha-800/2011",
    "Permit Date": "2011-03-18T03:49:05Z",
    "Meeting Number": "34/2010",
    "Meeting Date": "2010-10-08T03:49:51Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ အသင့်အသုံးပြုရောစပ်ပြီး ကွန်ကရစ်(Ready Mixed Concrete) နှင့် ကွန်ကရစ်အခြေခံ ဆောက်လုပ်ရေးလုပ်ငန်းသုံး ပစ္စည်းများထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 2300,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးမြင့်စိုး၊ ဒေါ်သန်းသန်းစု",
    "Land Area (units not specified in file)": 2.83,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "အမှတ်(၂၁-က)၊ ကမ္ဘောဇလမ်း၊ ရွှေတောင်ကြား(၂) ရပ်ကွက်၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေတိုင်းရပ်ကွက်အမှတ်(၂၄)၊ မြေကွက်အမှတ်(၇၉)၊ ငွေပင်လယ်စက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး၊",
  },
  {
    ID: 2538,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်သီတာတင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "HARMONY MYANMAR COMPANY LIMITED",
    "Financial Year From": 2011,
    "Financial Year To": 2012,
    "Permit Number": "manatha-810/2011",
    "Permit Date": "2011-09-27T04:14:45Z",
    "Meeting Number": "17/2011",
    "Meeting Date": "2011-09-21T04:15:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "C.M.P စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 189,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးကျော်ကျော်",
    "Land Area (units not specified in file)": 1.735,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၁၃၁)၊ လုံးသွယ်လမ်း၊ အမှတ်(၂၉) ရပ်ကွက်၊  သင်္ဃန်းကျွန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၈၂/၃)၊ (၁၈၂/၄)၊ ဗန်းမော်အတွင်းဝန်လမ်း၊ ရွှေလင်ပန်းစက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2539,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်ကျော်(ခ) ဦးဝူဝှဲရင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Southern Metal Industry Co.,Ltd.",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "MaNaTha-070/97",
    "Permit Date": "1997-05-12T04:16:03Z",
    "Meeting Number": "၁၉/၉၇",
    "Meeting Date": "1997-11-13T04:18:36Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "ခေတ်မီပရိဘောဂများထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 21.4,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်တင်တင်ဝင်း",
    "Land Area (units not specified in file)": 0.661,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 79,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "၃၆/၇၈၊ အမှတ်-၁၁၀၊ ၆၄၄ ရပ်ကွက်၊ မဟာအောင်မြေမြို့နယ်၊ မန္တလေးမြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၂၄၆(ခ)၊ မြေတိုင်းအမှတ်-(၂၃)၊ စက်မှုဇုန်၊ ဒဂုံမြို့သစ်တောင်ပိုင်း၊ ရန်ကုန်",
  },
  {
    ID: 2540,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr. Hsu, Wei-Jen ",
    "Name of Principal Organization": "HK Adele Accessories Limited ",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "HK Adele (Myanmar) Accessories Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "139/2019",
    "Permit Date": "2019-02-06T07:06:10Z",
    "Meeting Number": "2/2019",
    "Meeting Date": "2019-02-04T07:06:21Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of various kinds of bags and belts on CMP basis",
    "Amount Of Foreign Capital USD (in Millions)": 8.387,
    "Total Amount Of Capital (in Millions)": 8.387,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "H K A (Yangon) Property Limited ",
    "Land Area (units not specified in file)": 4,
    "Lease Term": 50,
    "Annual Lease Fee": 48.579,
    "Land Use Premium": null,
    "Number Of Local Employees": 2500,
    "Number Of Foreign Employees": 50,
    Status: "Approved",
    "Investor Address":
      "FLAT C, 20 F, FULL WIN, COMMERCIAL CENTRE, 573, NATHAN ROAD, YAU MA TEI, KOWLOON, HONG KONG ",
    "Organization Address":
      "FLAT C, 20 F, FULL WIN, COMMERCIAL CENTRE, 573, NATHAN ROAD, YAU MA TEI, KOWLOON, HONG KONG ",
    "Investment Permitted Address":
      "PLOT NO. 107, 108, 121, 122, YANGON INDUSTRIAL ZONE, NORTH OKKALAPA TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2542,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Kuan,Howard Huai-Chih",
    "Name of Principal Organization": "North Shore Group Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "North Shore Group Co.,Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "542/2013",
    "Permit Date": "2013-01-01T06:23:37Z",
    "Meeting Number": "39/2012",
    "Meeting Date": "2012-12-28T06:24:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.37,
    "Total Amount Of Capital (in Millions)": 1.37,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner":
      "Ma Ram Gay @ Daw Khin Pyone,U Shu Sein and North Shore Group Co.,Ltd",
    "Land Area (units not specified in file)": 12.311,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Terminated",
    "Investor Address":
      "No.110-112,1(F)Hewlett  Ctr,No.54 Hoi Yuen Road,Kln,Hong Kong.",
    "Organization Address":
      "No.110-112,1(F)Hewlett Ctr, No.54 Hoi Yuen Road,KLN , Hong Kong.",
    "Investment Permitted Address":
      "Plot No.16,17 & 18 Myawaddy Min Gyi Road, Industrial Zone (4),Hlaing Thar Yar Township, Yangon .",
  },
  {
    ID: 2543,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Song Jae Choon",
    "Name of Principal Organization": "Ewha Knit Co.,Ltd.",
    "Place of Incorporation": "Korea",
    "Company Name In Myanmar": "Ewha Knit Co.,Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "543/2013",
    "Permit Date": "2013-01-02T06:53:33Z",
    "Meeting Number": "1/2013",
    "Meeting Date": "2013-01-02T06:57:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.5,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Democratic People's Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "Ewha Knit Co.,Ltd.",
    "Land Area (units not specified in file)": 12.12,
    "Lease Term": null,
    "Annual Lease Fee": 0.1,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "301 Seogang Skyille The 2nd 116-17 Eungam-Dong,Eunpyeong-Gu , Seoul,Republic of Korea",
    "Organization Address":
      "3-18 Bukgajwa-Dong Seodaemun-Gu, Seoul, Republic of Korea",
    "Investment Permitted Address":
      "Survey Block No.25, Plot No.218 , Shwe Lin Ban Industrial Zone , Hlaing Thar Yar,Yangon",
  },
  {
    ID: 2544,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mrs.Wei,Chiu-Yen",
    "Name of Principal Organization": "Wedtex Industrial (HK)Co.,Ltd.",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Wedtex Fashion (Myanmar) Co.,Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "544/2013",
    "Permit Date": "2013-01-09T07:11:23Z",
    "Meeting Number": "2/2013",
    "Meeting Date": "2013-01-09T07:12:34Z",
    Sector: "",
    "Type Of Investment Business":
      "Manufacturing of Bridal Dress, Fabric and Garment Accessories on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 36,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Mingaladon Industrial Park Co.,Ltd.",
    "Land Area (units not specified in file)": 2.445,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No.42, Aly ,161,Hexing Lane, Pitou Township, Changhua Country 523, Taiwan ,Republic of China",
    "Organization Address":
      "Unit 1111,11/F, Trendy Center,682-684 Castle Peak Road, Kowloon , Hong Kong",
    "Investment Permitted Address":
      "Plot No.D-6, Mingaladon Industrial Park, Mingaladon Township, Yangon",
  },
  {
    ID: 2545,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Lee Yunwa",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar Hair Co.,Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "546/2013",
    "Permit Date": "2013-01-28T07:39:00Z",
    "Meeting Number": "4/2013",
    "Meeting Date": "2013-01-23T07:39:24Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Synthetic WIGS on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.5,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Moh Moh Khin",
    "Land Area (units not specified in file)": 2.33,
    "Lease Term": null,
    "Annual Lease Fee": 0.047,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No.484-136, Bulkwang-2, Dong Eunpyung-Gu,Seoul ,Republic of Korea",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No.37, Phan Chet Wun U Shwe Oh Street, Dagon (East) Dagon Township,Yangon",
  },
  {
    ID: 2546,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Kim Sun Choul",
    "Name of Principal Organization": "Modniye Dream Co.,Ltd.",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "Myanmar Ayeyarwaddy Manufactruing Co.,Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "523/2012",
    "Permit Date": "2012-12-12T03:27:32Z",
    "Meeting Number": "34/2012",
    "Meeting Date": "2012-11-14T03:27:59Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.816,
    "Total Amount Of Capital (in Millions)": 0.816,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Ei, Daw Sandar ",
    "Land Area (units not specified in file)": 2.4,
    "Lease Term": null,
    "Annual Lease Fee": 0.058,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "585-4,Sammi APT 509, Bang Hwa 2 Dong Kang , SE-KU , Seoul,Korea",
    "Organization Address":
      "2F ,181, Beonji, Sam Jeon-Dong, Songpa-Gu, Seoul , Korea",
    "Investment Permitted Address":
      "Plot No.(43/1), No.538-KA, No. 4 Road, Shwe Pyi Thar Township, Yangon",
  },
  {
    ID: 2547,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr. Koenraad Jacob De Heus",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "De Heus Myanmar Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "137/2019",
    "Permit Date": "2019-02-06T04:13:38Z",
    "Meeting Number": "2/2019",
    "Meeting Date": "2019-02-04T06:58:20Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "Production and Distribution of Aqua Feed Products",
    "Amount Of Foreign Capital USD (in Millions)": 14.726,
    "Total Amount Of Capital (in Millions)": 14.726,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 50,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Netherlands",
    "Form Of Investment": "FDII",
    "Land Owner": "ဦးအောင်ရွှေထွန်း",
    "Land Area (units not specified in file)": 22298,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": 12486.88,
    "Number Of Local Employees": 58,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "Ferdinand Huycklaan 9, 3743 Ak Baarn, The Netherlands",
    "Organization Address":
      "De Heus Myanmar B.V, Rubensstraat 175, 6717 VE, EDE, The Netherlands",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၃၀၉၊ ၃၁၀၊ ၃၁၁၊ မြောင်းတကာသံမဏိ စက်မှုဇုန်၊",
  },
  {
    ID: 2548,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Liao ,Chun- Jung",
    "Name of Principal Organization": "Joint Investors Ltd.",
    "Place of Incorporation": "British Virgin Islands",
    "Company Name In Myanmar": "Licjin Industry Co.,Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "651/2014",
    "Permit Date": "2014-01-31T04:23:29Z",
    "Meeting Number": "31/2013",
    "Meeting Date": "2013-12-04T04:25:46Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufactruing of Varieties of shoes on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.8191,
    "Total Amount Of Capital (in Millions)": 2.8191,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Virgin Islands (British)",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Zin Ma and Licjin Industry Co.,Ltd.",
    "Land Area (units not specified in file)": 2.584,
    "Lease Term": 30,
    "Annual Lease Fee": 0.057,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.111,Zhongming S.RD, West DIST,Taichung City 40361, Taiwan(R.O.C)",
    "Organization Address":
      "P.O Box 957, Offshore Incorporations Center, Road Town Tortola, British Virgin Islands.",
    "Investment Permitted Address":
      "Plot No.(184+187), Corner of Won Saung Hmu Street & Maung Kyan Thee Street , Shwe Lin Pann Industrial Zone, Hlaing Thar Yar Township, Yangon",
  },
  {
    ID: 2549,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Kachisuke Kurasaki",
    "Name of Principal Organization": "Flex Japan Co.,Ltd.",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "White Owl Fashion Co.,Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "656/2014",
    "Permit Date": "2014-01-17T04:48:01Z",
    "Meeting Number": "28/2013",
    "Meeting Date": "2013-10-30T04:48:29Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      " Manufacturing of Garment on CMP Basis for  Garment Factory No.(2),",
    "Amount Of Foreign Capital USD (in Millions)": 2.725,
    "Total Amount Of Capital (in Millions)": 2.725,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "U Soe Min Aung and White Owl Fashion Co.,Ltd.",
    "Land Area (units not specified in file)": 3.6,
    "Lease Term": null,
    "Annual Lease Fee": 0.072,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.1243, Oshimada-Machi, Nagano-Shi, Nagano-Ken, Japan",
    "Organization Address":
      "No.2451, Oaz Yashiro , Chikuma City , Nagano Preffcture , Japan",
    "Investment Permitted Address":
      "Plot No.62 & 63 , Myay Taing Quarter No.143/1, Kyansitthar Yeikmon, Industrial Zone 2, Dagon Myothit (South)Township, Yangon",
  },
  {
    ID: 2550,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Wang,Feng TE ",
    "Name of Principal Organization": "China Max Industrial Ltd.",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Mingtex (Myanmar) Industrial Co.,Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "657/2014",
    "Permit Date": "2014-01-13T06:36:45Z",
    "Meeting Number": "32/2013",
    "Meeting Date": "2013-12-19T07:02:38Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Garments and Embroidery on CMP Basis for Garment Factory No.(1)",
    "Amount Of Foreign Capital USD (in Millions)": 0.6373,
    "Total Amount Of Capital (in Millions)": 0.6373,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Hla Hla Win and Mingtex (Myanmar) Industrial Co.,Ltd.",
    "Land Area (units not specified in file)": 4.925,
    "Lease Term": null,
    "Annual Lease Fee": 0.109,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Unit 601-2,6/Floor, Wai Fung Plaza , 664 Nathan Road, Mongkok, Kowloon , Hong Kong",
    "Organization Address":
      "Unit 601-2,6/Floor, Wai Fung Plaza , 664 Nathan Road, Mongkok, Kowloon , Hong Kong",
    "Investment Permitted Address":
      "No.197, Ahnawrahta Street, Industrial Zone(5), Hlaing Thar Yar Township, Yangon",
  },
  {
    ID: 2551,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Eisuke Ejiri",
    "Name of Principal Organization": "Honeys Holding Co.,ltd.",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Honeys Garment Industry Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "658/2014",
    "Permit Date": "2014-01-17T07:20:18Z",
    "Meeting Number": "32/2013",
    "Meeting Date": "2013-12-19T07:20:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Garment on CMP Basis for Garment Factory  No.(2)",
    "Amount Of Foreign Capital USD (in Millions)": 17.5,
    "Total Amount Of Capital (in Millions)": 17.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 36,
    "Validity Of Investment Permit (in Years)": 35,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner":
      "Mingaladon Industrial Park Co.,Ltd and Honeys Garment Industry Ltd.",
    "Land Area (units not specified in file)": 7.4,
    "Lease Term": null,
    "Annual Lease Fee": 0.008,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "27-1, Shichihonmatsu Hashiriguma-Aza Kashima-Machi, Iwaki , Fukushima,971-8141 Japan",
    "Organization Address":
      "27-1,Shichihonmatsu Hashiriguma-Aza Kashima-Machi, iwaki, Fukushima, 971-8141 Japan.",
    "Investment Permitted Address":
      "Plot No. B-4, Mingaladon Industrial Park, Mingaladon Township, Yangon",
  },
  {
    ID: 2552,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Dong Hyun, Lee ",
    "Name of Principal Organization": "JK Industry Co.,Ltd.",
    "Place of Incorporation": "Korea",
    "Company Name In Myanmar": "JK Garments Co.,Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "660/2014",
    "Permit Date": "2014-01-27T08:19:56Z",
    "Meeting Number": "32/2013",
    "Meeting Date": "2013-12-19T08:20:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.7001,
    "Total Amount Of Capital (in Millions)": 0.7001,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner":
      "U Yoke Minn(a)U Myo Lwin , U Kyi Gwan, U Aung Zaw Win and U Par Pait (a)U Kyaw Hlaing and JK Garments Co.,Ltd.",
    "Land Area (units not specified in file)": 3.682,
    "Lease Term": null,
    "Annual Lease Fee": 0.081,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Woosung APT 101-509, Zamwon-Dong ,Secho-Gu , Seoul , Korea",
    "Organization Address":
      "5th Floor, Baeksan Bldg, 537-20, Bang Bae-Dong, Secho-Gu , Seoul , Korea,",
    "Investment Permitted Address":
      "Plot No.33 & 34 , Thilawa Industral Zone, Thanlyin Kyauktan Township, Yangon,",
  },
  {
    ID: 2559,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Eisuke Ihara",
    "Name of Principal Organization": "World Kaihatsu Kogyo Co.,Ltd.",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Asia Myanmar WKK JV Co.,Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "P-924/2015",
    "Permit Date": "2015-04-07T09:10:46Z",
    "Meeting Number": "3/2015",
    "Meeting Date": "2015-02-27T09:11:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Sales of Asphalt Concrete for construction and Road Paving Work",
    "Amount Of Foreign Capital USD (in Millions)": 8.633,
    "Total Amount Of Capital (in Millions)": 8.633,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": 50,
    "Annual Lease Fee": 0.06,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Amendment Rejected",
    "Investor Address":
      "No.1-32-19, Asahi-Cho, Fuchu-City, Tokyo, Japan 183-0003",
    "Organization Address":
      "No.7484 Watauchi, Wakaho, Nagano-City,Nagano Pref.381-0101, Japan",
    "Investment Permitted Address":
      "Plot No 155 & 156 ,Industrial Zone-2, Dagon Seikkan Township, Yangon Region",
  },
  {
    ID: 2562,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wong Peng",
    "Name of Principal Organization": "PEC LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "PECI (MYANGMAR) LIMITED",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "970/2015",
    "Permit Date": "2015-07-10T05:47:06Z",
    "Meeting Number": "10/2015",
    "Meeting Date": "2015-06-05T05:48:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Mechanical Fabrication And Related Services",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "Plant Engineering Design Company Limited",
    "Land Area (units not specified in file)": 3.807,
    "Lease Term": 50,
    "Annual Lease Fee": 0.077,
    "Land Use Premium": null,
    "Number Of Local Employees": 150,
    "Number Of Foreign Employees": 5,
    Status: "Approved",
    "Investor Address": "No.(55), Pavilion View, Singapore 658049",
    "Organization Address": "No.(21), Shipyard Road, Singapore 628144",
    "Investment Permitted Address":
      "Plot No.12,13, Thilawa Industrial Zone, Kyauktan Township, Yangon.",
  },
  {
    ID: 2563,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်မေလင်းပိုင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "UNITED PRECISE COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "manatha-1221/2016",
    "Permit Date": "2016-11-11T06:55:42Z",
    "Meeting Number": "20/2016",
    "Meeting Date": "2016-10-28T06:56:27Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "C.M.P စနစ်ဖြင့် Post Star နှင့်signboard Frame ပုံစံအရွယ်အစားမျိုးစုံထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.061,
    "Total Amount Of Capital (in Millions)": 117,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "ဦးအင်စေပါ့ခ်(ခ)ဦးမောင်စိန်၊ လင်(မ်)တိုင်ဟောင်(ခ)တိတ်ဟောင်၊ လူငန်ဟိန်(ခ)မခင်ဝင်း",
    "Land Area (units not specified in file)": 0.178,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၄၇၄)၊ အင်းတော်လမ်း၊ ၆၄-ရပ်ကွက်၊ ဒဂုံမြို့သစ်(တောင်ပိုင်း)မြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၀၂-၁၀၃-၁၀၄)၊ မြေတိုင်းရပ်ကွက်အမှတ်(၆၄)၊ စက်မှုဇုန်၊ ဒဂုံမြို့သစ်(တောင်ပိုင်း)မြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2569,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Wang ,Feng-Te ",
    "Name of Principal Organization": "China Max Industrial Ltd.",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Mingtex (Myanmar) Industrial Co.,Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "661/2014",
    "Permit Date": "2014-01-21T08:50:07Z",
    "Meeting Number": "32/2013",
    "Meeting Date": "2013-12-19T08:50:38Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Garment and Embroidery on CMP Basis for Garment Factory No.2",
    "Amount Of Foreign Capital USD (in Millions)": 0.4004,
    "Total Amount Of Capital (in Millions)": 0.4004,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner":
      "U Nyi Nyi Lwin , Daw Mi Min  @ Tan Be Be and Mingtex (Myanmar) Industrial Co.,Ltd.",
    "Land Area (units not specified in file)": 2.386,
    "Lease Term": 30,
    "Annual Lease Fee": 0.053,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "Unit 601-2,6/Floor, Wai Fung Plaza ,664 Nathan Road, Mongkok, Kowloon ,Hong Kong",
    "Organization Address":
      "Unit 601-2,6/Floor, Wai Fung Plaza,664 Nathan Road, Mongkok, Kowloon, Hong Kong",
    "Investment Permitted Address":
      "No.109, Bo Aung Kyaw Street, Shwe Than Lwin Industrial Zone, Hlaing Thar Yar Township, Yangon",
  },
  {
    ID: 2570,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Anusorn Srisuk",
    "Name of Principal Organization":
      "CHAN WANICH SECURITY PRINTING COMPANY LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "CHAN WINICH(MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "1257/2017",
    "Permit Date": "2017-04-11T09:29:28Z",
    "Meeting Number": "5/2017",
    "Meeting Date": "2017-03-13T09:29:47Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Processing Of Security Document Personalization/Authentication, Printing of Security And Non-Security Document.",
    "Amount Of Foreign Capital USD (in Millions)": 3,
    "Total Amount Of Capital (in Millions)": 3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Tin Soe, U Htun Htun Kyaw ",
    "Land Area (units not specified in file)": 1.5,
    "Lease Term": 50,
    "Annual Lease Fee": 0.042,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Amend",
    "Investor Address":
      "101/148 MOO3, Tumbon Samet, Samet, Aumphur Muang, Chonburi, Thailand",
    "Organization Address":
      "699 Kongboonma Building, Silom Road, Bangrak, Bangkok10500, Thailand.",
    "Investment Permitted Address":
      "Plot No.99, Myay Taing Block No.Industrial Zone-2, Dagon Myo Thit (Seik Kan) Township,Yangon.",
  },
  {
    ID: 2572,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Lau, Wai Shun Vincent",
    "Name of Principal Organization": "Sun Pleasure International Ltd.",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Sun Pleasure International (Myanmar) Co.,Ltd",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "664/2014",
    "Permit Date": "2014-01-21T04:32:18Z",
    "Meeting Number": "32/2013",
    "Meeting Date": "2013-12-19T04:32:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Inflatable Products on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.9,
    "Total Amount Of Capital (in Millions)": 1.9,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner":
      "U Myat Soe and U Tun Tun Win and Sun Pleasure International (Myanmar) Co.,Ltd.",
    "Land Area (units not specified in file)": 3.099,
    "Lease Term": 30,
    "Annual Lease Fee": 0.062,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Flat B.11/F, Tower 17(Phase 4 A), Laguna Grande No.8, Laguna Avenue, Avenue ,Hung Hom, Kowloon, Hong Kong",
    "Organization Address":
      "Units 2501-03,25th Floor,Stelux House ,698 Prince Edward Road East , San Po Kong, Kowloon, Hong Kong",
    "Investment Permitted Address":
      "Plot No.333 & 334, Kyan Sit Thar Street, Shwe Lin Pan Industrial Zone, Hlaing Tharyar Township, Yangon",
  },
  {
    ID: 2573,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Lau Chun Wai,Roger",
    "Name of Principal Organization": "Hang Kei Lingerie Factory Ltd.",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Hang Kei  Myanmar Garment Factory Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "666/2014",
    "Permit Date": "2014-02-02T06:17:05Z",
    "Meeting Number": "1/2014",
    "Meeting Date": "2014-01-08T06:17:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.002,
    "Total Amount Of Capital (in Millions)": 1.002,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner":
      "Daw Khine War , Daw Thin Thin Khine and Hang Kei Myanmar Garment Factory Ltd.",
    "Land Area (units not specified in file)": 0.519,
    "Lease Term": null,
    "Annual Lease Fee": 0.03,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "Flat B,28/F, Block 6, Phase 1 , Belair , Hong Kong",
    "Organization Address":
      "Flat 7, 7/F, Cheung Fat Ind,Bldg 64-76, Larch Street, Taikoktsui, Kowloon, Hong Kong",
    "Investment Permitted Address":
      "Plot No.56 and 57, Myay Taing No.25, Shwe Linban Industrial Zone, Hlaing Tharyar Township, Yangon ",
  },
  {
    ID: 2575,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Wai Phyo",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Cho Cho Industry Limited (ချိုချို စက်မှုလက်မှုလုပ်ငန်း လီမိတက်)",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "156/2019",
    "Permit Date": "2019-02-01T06:53:46Z",
    "Meeting Number": "3/2019",
    "Meeting Date": "2019-02-01T06:54:05Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ခေါက်ဆွဲ၊ကြာဇံစသည့်ပစ္စည်းများအား အသင့်စားသောက်ကုန်ခေါက်ဆွဲ၊ကြာဇံစသည့်ပစ္စည်းများအား အသင့်စားသောက်ကုန်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 4000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Wai Phyo",
    "Land Area (units not specified in file)": 2.15,
    "Lease Term": 10,
    "Annual Lease Fee": 6,
    "Land Use Premium": null,
    "Number Of Local Employees": 360,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "Plot No.118/C, Pyay Road, Oasis street, Mayangone Township,Yangon Region",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.104, Myay Taing Block No.528/B, Mingalardone Township, Yangon Region",
  },
  {
    ID: 2576,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Liao , Po-Wei",
    "Name of Principal Organization": "U-Known Industrial Ltd.",
    "Place of Incorporation": "Brunei Darussalam",
    "Company Name In Myanmar": "Myanmar U - Known Co.,Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "671/2014",
    "Permit Date": "2014-02-05T07:16:21Z",
    "Meeting Number": "1/2014",
    "Meeting Date": "2014-01-08T07:16:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Sport Equipments on CMP Basis(Such as Fishing Roads, Golf Shafts)",
    "Amount Of Foreign Capital USD (in Millions)": 1.04,
    "Total Amount Of Capital (in Millions)": 1.04,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Phyu Hnin Lwin  ",
    "Land Area (units not specified in file)": 3.049,
    "Lease Term": 30,
    "Annual Lease Fee": 0.0616,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.71, Shiqian St, Fengyuan Dist, Taichung City , 420, Taiwan",
    "Organization Address":
      "Room 51, 5th Floor, Britannia House, Japan Cator, Bandar Seri Begawan Bs 8811, Negara Brunei Darussalam,",
    "Investment Permitted Address":
      "Plot No.21 , Block No.24, Ngwe Pin Lae Marine Industrial Zone , Hlaing Thar Yar Township,",
  },
  {
    ID: 2577,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chan Chuen ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Fair Silver Fashion Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "157/2019",
    "Permit Date": "2019-02-01T07:25:33Z",
    "Meeting Number": "3/2019",
    "Meeting Date": "2019-02-01T07:25:36Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.208,
    "Total Amount Of Capital (in Millions)": 0.208,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaw Win @ U Kyaw Win Soe",
    "Land Area (units not specified in file)": 1.004,
    "Lease Term": 5,
    "Annual Lease Fee": 55.2,
    "Land Use Premium": null,
    "Number Of Local Employees": 160,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "Broadway 33A,9/F, Mei Foo Sun Chuen, Kowloon, Hong Kong",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 341(A), Myay Taing BLock No.25, Shwe Lin Ban Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2579,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Meng Guilian",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Loadstar (Myanmar) Apparel Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "158/2019",
    "Permit Date": "2019-02-21T04:21:47Z",
    "Meeting Number": "3/2019",
    "Meeting Date": "2019-02-13T04:22:02Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.819,
    "Total Amount Of Capital (in Millions)": 4.819,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Yin Mon Han",
    "Land Area (units not specified in file)": 4.338,
    "Lease Term": 5,
    "Annual Lease Fee": 78.084,
    "Land Use Premium": null,
    "Number Of Local Employees": 925,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "No.308,29 Building, Ruju Road, Jinjiuhua Apartment, Nantong District, Jiangsu State, People's Republic Of China ",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.(21+22), Myay Taing Block No.(143/1), Kyan Sit Thar Industrial Zone, Dagon Myothit (South) Township, Yangon Region",
  },
  {
    ID: 2580,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lee Byung ha",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Sunjin Livestock Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "159/2019",
    "Permit Date": "2019-02-01T08:22:21Z",
    "Meeting Number": "3/2019",
    "Meeting Date": "2019-02-01T08:22:24Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "မျိုး၀က်သားပေါက်များထုတ်လုပ်ခြင်း၊ ၀က်များကိုမွေးဘက်စနစ် (Contract Farming) ဖြင့် မွေးမြူထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.637,
    "Total Amount Of Capital (in Millions)": 1.723,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "JV",
    "Land Owner": "U Myint Thu",
    "Land Area (units not specified in file)": 5,
    "Lease Term": 30,
    "Annual Lease Fee": 0.007992,
    "Land Use Premium": null,
    "Number Of Local Employees": 402,
    "Number Of Foreign Employees": 1,
    Status: "",
    "Investor Address":
      "Dong Kwang-ro-18,401-1203, Bangbae 1- Park Apt., DongKwang-ro-3-18, Soule, Srocho.gu. Republic Of Korea",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၂၇)၊စီ-၈လမ်း၊ ညောင်နှစ်ပင် ဟင်းသီးဟင်းရွက်စိုက်ပျိုးထုတ်လုပ်ရေးနှင့် ကြက်/ငါး မွေးမြူရေးအထူးဇုန်(၃)၊ လှည်းကူးမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2581,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wu Yongjie",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Yangon Young Clothing Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "160/2019",
    "Permit Date": "2019-02-21T04:51:16Z",
    "Meeting Number": "3/2019",
    "Meeting Date": "2019-02-13T04:51:45Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3.422,
    "Total Amount Of Capital (in Millions)": 3.422,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 45,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Mya Mya Aye",
    "Land Area (units not specified in file)": 1.37,
    "Lease Term": 30,
    "Annual Lease Fee": 74.4,
    "Land Use Premium": null,
    "Number Of Local Employees": 1185,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address":
      "No.404, Hongfuyuan,, Block No.(4), Qinhuai District, Nanjiang City, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.126, Myay Taing block No.51, Thar Du Kan Industrial Zone, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 2582,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Je Jaemin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Y & S Myanmar Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "161/2019",
    "Permit Date": "2019-02-01T09:21:06Z",
    "Meeting Number": "3/2019",
    "Meeting Date": "2019-02-01T09:21:10Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMPစနစ်ဖြင့် အိမ်မွေးတိရစ္ဆာန်အသုံးအဆောင်အထည်များချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.418,
    "Total Amount Of Capital (in Millions)": 0.418,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "K & M Capital Co., Ltd",
    "Land Area (units not specified in file)": 0.43,
    "Lease Term": 5,
    "Annual Lease Fee": 0.0576,
    "Land Use Premium": null,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": 6,
    Status: "Draft",
    "Investor Address":
      "No.306-903, 265 Hasin Street, Town 3, Garak@ Saga-Gu, Busan-Si, Republic Of Korea",
    "Organization Address": "",
    "Investment Permitted Address":
      "Unit # B-100 and B-14, Skytech Industrial Park, Plot No.8, Myay Taing Block No 143/1,Dagon Myothit (South) Township, Yangon Region",
  },
  {
    ID: 2583,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lai Zhenjian",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ZhongZe Bags Industry Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "162/2019",
    "Permit Date": "2019-02-01T09:36:29Z",
    "Meeting Number": "3/2019",
    "Meeting Date": "2019-02-01T09:36:32Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Bags On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.672,
    "Total Amount Of Capital (in Millions)": 0.672,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 28,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Soe Naing, Daw May Thet Khaing @ Ma Pan Sein",
    "Land Area (units not specified in file)": 1.85,
    "Lease Term": 8,
    "Annual Lease Fee": 204,
    "Land Use Premium": null,
    "Number Of Local Employees": 419,
    "Number Of Foreign Employees": 12,
    Status: "Draft",
    "Investor Address": "Hong Kong",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.142, Myay Taing Block No. Industrial Zone 2, Dagon Myothit (Seikkan) Township, Yangon Region",
  },
  {
    ID: 2585,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Seok Hwan Park",
    "Name of Principal Organization":
      "Busan Central Bus Terminal Company Limited",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "BXT International Company Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1128/2016",
    "Permit Date": "2016-03-26T03:54:16Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T03:54:40Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Development of Landfill Reclamation",
    "Amount Of Foreign Capital USD (in Millions)": 9.253,
    "Total Amount Of Capital (in Millions)": 9.253,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 9,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "Rakhine State Government ",
    "Land Area (units not specified in file)": 92,
    "Lease Term": 9,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 212,
    "Number Of Foreign Employees": 5,
    Status: "Amend",
    "Investor Address": "133 Nopo-Dong, Kumjung-gu, Busan, South Korea",
    "Organization Address": "133 Nopo-Dong, Kumjung-gu, Busan, South Korea",
    "Investment Permitted Address":
      "Sae Myaung Street,No.1, Room no.4/B, Mayangone, Yangon Region, Myanmar",
  },
  {
    ID: 2587,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Gao, Peina",
    "Name of Principal Organization":
      "JIANGSU BEST FASHION DRESS COMPANY LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "BEST GARMENT(MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "099/2018",
    "Permit Date": "2018-05-17T06:42:50Z",
    "Meeting Number": "6/2018",
    "Meeting Date": "2018-05-12T06:43:10Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 40,
    "Total Amount Of Capital (in Millions)": 40,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "SANDHI BROTHERS TRADING COMPANY LIMITED",
    "Land Area (units not specified in file)": 40,
    "Lease Term": 32,
    "Annual Lease Fee": 0.0946,
    "Land Use Premium": null,
    "Number Of Local Employees": 4156,
    "Number Of Foreign Employees": 46,
    Status: "Rejected",
    "Investor Address":
      "Room 401, No.88, Huanxi Road, Zhutang Town, Jiangyin City, Jiangsu, People's Republic of China.",
    "Organization Address":
      "Room 401, No.88, Huanxi Road, Zhutang Town, Jiangyin City, Jiangsu, People's Republic of China.",
    "Investment Permitted Address":
      "Plot No.36KA,37KA,38KA,39KA, 40KA, Myay Taing Block No.561, Ward No.Kayin Chaung Kwin, Shwe Pyi Thar Township, Yangon Region.",
  },
  {
    ID: 2589,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Daraz Myanmar Company Limited",
    "Name of Principal Organization": "Daraz Singapore Private Limited",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Daraz Myanmar Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "144/2019",
    "Permit Date": "2019-02-20T10:51:27Z",
    "Meeting Number": "3/2019",
    "Meeting Date": "2019-02-20T10:51:32Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Retail and Warehouse",
    "Amount Of Foreign Capital USD (in Millions)": 5,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "Asia Express (Ygn) Co., Ltd.",
    "Land Area (units not specified in file)": 18248,
    "Lease Term": 1,
    "Annual Lease Fee": 0.271,
    "Land Use Premium": null,
    "Number Of Local Employees": 165,
    "Number Of Foreign Employees": 1,
    Status: "Submitted",
    "Investor Address":
      "NO.3 (A), JUNCTION CITY TOWER, UNIT 2  06-01/06-10 LEVEL (6), CORNER OF BOGYOKE AUNG SAN ROAD AND 27th STREET, PABEDAN TOWNSHIP,YANGON",
    "Organization Address":
      "8 SHENTON WAY # 45-01 AXA TOWER SINGAPORE (068811)",
    "Investment Permitted Address":
      "ROOM NO. G-04, G-05, G-06, BUILDING NO. D, ROOM NO.G-01, G-02, G-03, G-04, G-05, BUILDING NO. E, BO MYAT HTUN STREET, BETWEEN MAHABANDOOLA ROAD AND MERCHANT ROAD, BOTAHTAUNG TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2590,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Moe Kyaw",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Alliance Brewery Company Limited",
    "Financial Year From": 11,
    "Financial Year To": 12,
    "Permit Number": "821/2011",
    "Permit Date": "2011-11-15T07:24:03Z",
    "Meeting Number": "23/2011",
    "Meeting Date": "2011-11-09T07:23:39Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Myanmar Citizen Investment",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1585.88,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Aung Moe Kyaw",
    "Land Area (units not specified in file)": 24.86,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 163,
    "Number Of Foreign Employees": 30,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ် ၁၈-ဘီ၊ အင်းယားလမ်း၊",
    "Organization Address": "",
    "Investment Permitted Address":
      "ကွင်းအမှတတ် ၅၆၀-စီ၊ ဦးပိုင်အမှတ်-၇၂/၁၊ ၇၇၊ ၇၇/၁၊၇၈၊၃+၇၄/၂၊ လိပ္ပုတ်ကျေးရွာအုပ်စု၊ ",
  },
  {
    ID: 2591,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. PATRICK O.NG",
    "Name of Principal Organization": "URC (THIALAND) CO.,LTD",
    "Place of Incorporation": "BANGKOK,THAILAND",
    "Company Name In Myanmar": "URC (MYANMAR) CO.,LTD",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "572/2013",
    "Permit Date": "2013-04-05T07:31:27Z",
    "Meeting Number": "11/2013",
    "Meeting Date": "2013-03-29T07:32:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF FOOD PRODUCTS INCLUDING BISCUITS, WAFERS AND SNACKS",
    "Amount Of Foreign Capital USD (in Millions)": 31.3,
    "Total Amount Of Capital (in Millions)": 31,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 36,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "MINGALARDON INDUSTRIAL PARK",
    "Land Area (units not specified in file)": 58755.02,
    "Lease Term": 36,
    "Annual Lease Fee": 17626.51,
    "Land Use Premium": 2820240.96,
    "Number Of Local Employees": 85,
    "Number Of Foreign Employees": 11,
    Status: "Monitoring Approved",
    "Investor Address": "528 EAST COAST ROAD,# 20-04, SINGAPORE",
    "Organization Address":
      "44/46 RAJPATTANA ROAD, KHWANG SAPANSUNG, KHET SAPANSUNG, BANGKAPI, BANGKOK 10240, THAILAND",
    "Investment Permitted Address":
      "PLOT NO.B-6,B-7, MINGALADON INDUSTRIAL PARK, MINGALADON TOWNSHIP",
  },
  {
    ID: 2592,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Taemin Park",
    "Name of Principal Organization":
      "Asahi Group Hodings Southeast Asia Pte. Ltd. ",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Asahi Loi Hein Coi., Ltd.",
    "Financial Year From": 14,
    "Financial Year To": 15,
    "Permit Number": "695/2014",
    "Permit Date": "2014-05-28T09:14:37Z",
    "Meeting Number": "8/2014",
    "Meeting Date": "2014-03-05T09:15:03Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 23.46,
    "Total Amount Of Capital (in Millions)": 46,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "Dr. Sai Sam Htun ",
    "Land Area (units not specified in file)": 5.6,
    "Lease Term": 50,
    "Annual Lease Fee": 181299.17,
    "Land Use Premium": null,
    "Number Of Local Employees": 740,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address": "1 Devonshire Road, #31-02, 239896",
    "Organization Address": "80, Robinson Road, #02-00, 068898",
    "Investment Permitted Address":
      "Myay Taing Block No.65 (Industry), Plot no. 119, No.4, Industrial Zone,",
  },
  {
    ID: 2594,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.KYUNGSIG HWANG",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "KM  GROUND INDUSTRIES CO.,LTD",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "726/2014",
    "Permit Date": "2014-05-09T04:09:45Z",
    "Meeting Number": "12/2014",
    "Meeting Date": "2014-04-10T04:10:10Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF SESAME SEED POWDER AND EDIBLE OIL",
    "Amount Of Foreign Capital USD (in Millions)": 2.1,
    "Total Amount Of Capital (in Millions)": 3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "JV",
    "Land Owner": "DAW HTET HTET THI",
    "Land Area (units not specified in file)": 1.448,
    "Lease Term": 30,
    "Annual Lease Fee": 45000,
    "Land Use Premium": null,
    "Number Of Local Employees": 74,
    "Number Of Foreign Employees": 79,
    Status: "Monitoring Approved",
    "Investor Address":
      "304-1903, HYUNDAI APT 111, 31, DOSIN-RO YEUNGDEUNGPO-GU, SEOUL, REPUBLIC OF KOREA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.394, MYAY TAING BLOCK NO.49, WARTAYAR INDUSTRIAL ZONE, SHWEPYITHAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2595,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Ko Ko Aung",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Ayar Shwe War Co., Ltd. ဧရာရွှေဝါ ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 8,
    "Financial Year To": 9,
    "Permit Number": "688/2008",
    "Permit Date": "2008-06-19T04:16:35Z",
    "Meeting Number": "11/2008",
    "Meeting Date": "2008-04-02T04:19:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "တစ်နာရီ (၅) တန်ကျ ခေတ်မီ သန့်စင် ပဲခွဲသန့်စင် စက်ရုံ တည်ထောင်ပြီး ပဲအမျိုးမျိုး ထုတ်လုပ်ခြင်းလုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 773.6,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ayar Shwe Wah Co., Ltd.",
    "Land Area (units not specified in file)": 5.453,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 75,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၂၄၇ (အီး/အက်ဖ်) ဆိပ်ကမ်းသာလမ်း၊ စက်မှုဇုန် (၂)၊ ",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၂၄၇ (အေ)၊ တွင်းသင်းတိုက်ဝန် ဦးထွန်းညိုလမ်း၊ မြေတိုင်းရပ်ကွက်၊ အပိုင် (၂)၊ လှိုင်သာယာစက်မှုဇုန်၊",
  },
  {
    ID: 2596,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "MR. SHU, ZHONGBO ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ASIA GLORY INTERNATIONAL COMPANY LIMITED   ",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "138/2019",
    "Permit Date": "2019-02-06T05:48:19Z",
    "Meeting Number": "2/2019",
    "Meeting Date": "2019-02-04T05:48:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing and Sales of Paper Pulp",
    "Amount Of Foreign Capital USD (in Millions)": 4.035,
    "Total Amount Of Capital (in Millions)": 6.725,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "U Tin Win, U Maung Myint",
    "Land Area (units not specified in file)": 4.47,
    "Lease Term": 20,
    "Annual Lease Fee": 40,
    "Land Use Premium": null,
    "Number Of Local Employees": 63,
    "Number Of Foreign Employees": 15,
    Status: "Amend",
    "Investor Address":
      "HOUSE NO. 502, BUILDING NO. 19, 2727 QILIANSHAN S RD, PUTUO QU, SHANGHAI SHI, PEOPLE’S REPUBLIC OF CHINA, 200333   ",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 253,254,255, MYAUNG DAGAR STEEL INDUSTRIAL ZONE, HMAWBI TOWNSHIP, YANGON REGION ",
  },
  {
    ID: 2597,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဗိုလ်မှူးချုပ်သန့်ဆွေ(ငြိမ်း) ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Dagon Beverages Co.,Ltd.",
    "Financial Year From": 8,
    "Financial Year To": 9,
    "Permit Number": "Ma Na Tha- 700/2009",
    "Permit Date": "2009-03-25T07:31:27Z",
    "Meeting Number": "9/2009",
    "Meeting Date": "2009-03-13T07:32:09Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အဖျော်ယမကာအမျိုးမျိုးထုတ်လုပ်ခြင်းနှင့် ဖြန့်ဖြုးရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 6260.78,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "တပ်",
    "Land Area (units not specified in file)": 25,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 280,
    "Number Of Foreign Employees": 1,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၇၁၊ မြက်ခင်းရိပ်သာလမ်း၊ ၆ မိုင်ခွဲ၊ ပြည်လမ်း၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address": "အမှတ်-၅၅၅ (ခ)၊ အမှတ် (၄) လမ်းမကြီး",
  },
  {
    ID: 2598,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးစိန်ဝမ်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ပင်းယမန်နျူဖက်ချားရင်း ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "Manatha-072/97",
    "Permit Date": "1997-06-13T08:18:21Z",
    "Meeting Number": "8/97",
    "Meeting Date": "1997-05-29T08:22:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 45.01,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "PINYA INTERNATIONAL TRADING CO.,LTD",
    "Land Area (units not specified in file)": 2,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 126,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်-၁၀၀၊ အင်းယားလမ်း၊ ကမာရွတ်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ြေကွက်အမှတ်(၄၀)၊ စက်မှုဇုန် အပိုင်း(၄)၊  ိုင်သာယာမြို့နယ်၊ ရန်ကုန် မြို့",
  },
  {
    ID: 2599,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Toru Okuyama",
    "Name of Principal Organization": "Access Tarding Co.,Ltd.",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Shining Access Garment Manufacturing Co.,Ltd",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "672/2014",
    "Permit Date": "2014-02-17T04:36:28Z",
    "Meeting Number": "2/2014",
    "Meeting Date": "2014-01-15T04:36:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.5685,
    "Total Amount Of Capital (in Millions)": 1.5685,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "U Maung Maung Lay",
    "Land Area (units not specified in file)": 1.54,
    "Lease Term": 30,
    "Annual Lease Fee": 0.034,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "3-226-11, Takao, Minami-Ku, Sakai-Shi,Osaka, Japan",
    "Organization Address":
      "3-226-11, Takao, Minami-Ku, Sakai-Shi,Osaka, Japan",
    "Investment Permitted Address":
      "Plot No.159, Set HMU 2nd Street, Shwe Pyi Thar Industrial Zone, Shwe Pyithar,Yangon",
  },
  {
    ID: 2600,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Toshiyuki Takagi",
    "Name of Principal Organization": "Hong Kong GF Ltd.",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Myanmar GF Co.,Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "682/2014",
    "Permit Date": "2014-03-07T06:21:43Z",
    "Meeting Number": "31/2013",
    "Meeting Date": "2013-12-04T06:22:09Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Quality Controlling (Garment Inspection ) and Packing of Finished Product Items",
    "Amount Of Foreign Capital USD (in Millions)": 0.15,
    "Total Amount Of Capital (in Millions)": 0.3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "U Mg Mg Aye",
    "Land Area (units not specified in file)": 1.027,
    "Lease Term": 10,
    "Annual Lease Fee": 0.025,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "1-878, Wagou-Honmachi ,Ogaki-Shi, Gifu-Ken,Japan",
    "Organization Address":
      "No.10,12/F,Tower B, Hung Hom Commercial Center, No.37, Ma Tau Wai Road, Kowloon, Hong Kong",
    "Investment Permitted Address":
      "Plot No.153, Myay Taing Block No.42, Sethmu 3rd Street, Shwe Pyi Thar Industrial Zone(1),Shwe Pyi Thar Township,Yangon",
  },
  {
    ID: 2602,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Robatohiiro Mikami",
    "Name of Principal Organization": "Japan Kikaku Sekkei Co.,Ltd",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Japan Create Engineering Co.,Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "691/2014",
    "Permit Date": "2014-03-24T06:51:19Z",
    "Meeting Number": "5/2014",
    "Meeting Date": "2014-02-05T06:51:47Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Concrete Blocks",
    "Amount Of Foreign Capital USD (in Millions)": 0.07,
    "Total Amount Of Capital (in Millions)": 7.036,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "Myanmar Golden Star Co.,Ltd ",
    "Land Area (units not specified in file)": 5,
    "Lease Term": 40,
    "Annual Lease Fee": 0.104,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "1-1 D-1402, Oguru, Saiwai-Ku, Kawasaki Kanagawa, Japan",
    "Organization Address": "6-15-5, Kugahara Ota-Ku Tokyo , Japan",
    "Investment Permitted Address":
      "Plot No.249, Khayebin Road, Yangon Industrial Park, Mingaladon Township, Yangon",
  },
  {
    ID: 2603,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "ဦးဖေလှိုင်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "SLIVER SHINE INTERNATIONAL \tCOMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "083/2018",
    "Permit Date": "2018-06-04T04:06:09Z",
    "Meeting Number": "6/2018",
    "Meeting Date": "2018-05-12T04:11:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 1.83,
    "Total Amount Of Capital (in Millions)": 3360.45,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးဖေလှိုင်",
    "Land Area (units not specified in file)": 2.757,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 165,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၂၆၊  မဟာဇေယျလမ်း၊ ရေကျော်ရပ်ကွက်၊  ပုဇွန်တောင် မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်- ၂၄၊ ၂၈၊ ၂၉၊ ၃၀၊ ၃၁ အေ၊        ၃၁ ဘီ၊ မြေတိုင်းရပ်ကွက်အမှတ်- ၁၈၊ ကနောင်မင်းသားကြီးလမ်း၊ ရွှေပေါက်ကံ စက်မှုဇုန်၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2604,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. ZHANG, CHENGFANG ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MYANMAR SINOCHEM INDUSTRY COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "139/2019",
    "Permit Date": "2019-02-06T04:49:05Z",
    "Meeting Number": "2/2019",
    "Meeting Date": "2019-02-04T04:49:22Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 2.809,
    "Total Amount Of Capital (in Millions)": 2.809,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 7,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Thein Htun ",
    "Land Area (units not specified in file)": 1.969,
    "Lease Term": 7,
    "Annual Lease Fee": 0.027,
    "Land Use Premium": null,
    "Number Of Local Employees": 35,
    "Number Of Foreign Employees": 12,
    Status: "Monitoring Amend",
    "Investor Address":
      "NO. 9, XINGLONG PU STREET, HUIJI TSP, ZHENGZHOU CITY, HENAN PROVINCE, PEOPLE’S REPUBLIC OF CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "NO.127, MYAY TAING BLOCK NO. INDUSTRIAL ZONE, DAGON MYOTHIT SEIKKAN TOWNSHIP, YANGON REGION ",
  },
  {
    ID: 2606,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Soe Myint",
    "Name of Principal Organization": "Great Health Care Co.,Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "American Oncology Institute Myanmar Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "106/2018",
    "Permit Date": "2018-07-07T07:30:02Z",
    "Meeting Number": "9/2018",
    "Meeting Date": "2018-07-07T07:31:11Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Private Hospital (Health Care Services)",
    "Amount Of Foreign Capital USD (in Millions)": 6.42,
    "Total Amount Of Capital (in Millions)": 10.7,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "Great Health Care Co.,Ltd.",
    "Land Area (units not specified in file)": 0.946,
    "Lease Term": 50,
    "Annual Lease Fee": 34000,
    "Land Use Premium": null,
    "Number Of Local Employees": 142,
    "Number Of Foreign Employees": 23,
    Status: "Approved",
    "Investor Address":
      "No.56, Pho Sein Road, Natmauk Quater, Tamwe Township, Yangon.",
    "Organization Address":
      "No.115, Lutlatye Street, Ga-Neg Ward, Thingangyun Township, Yangon.",
    "Investment Permitted Address":
      "No.115,  Plot No.7/ZA, Myay Taing Block No.48, Lutlatye Street, Thingangyun Township, Yangon Region",
  },
  {
    ID: 2609,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမြင့်ဦး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "အမ်ကေကုမ္ပဏီလီမိတက် (M.K Co., Ltd.)",
    "Financial Year From": 97,
    "Financial Year To": 98,
    "Permit Number": "MaNaTha-107/97",
    "Permit Date": "1997-12-26T06:50:57Z",
    "Meeting Number": "20/97",
    "Meeting Date": "1997-12-05T06:52:04Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အသင့်ချုပ်ပြီး ရှပ်အင်္ကျီများ ထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 49.68,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "အမ်ကေကုမ္ပဏီလီမိတက် (M.K Co., Ltd.)",
    "Land Area (units not specified in file)": 1.991,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၃၃၃၊ ပြည်လမ်း၊ စမ်းချောင်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေတိုင်းရပ်ကွက်အမှတ်ဇုန် (၂)၊ စက်မှုဇုန်၊ မြေကွက်အမှတ် ၁၆၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်း",
  },
  {
    ID: 2610,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးညိုမင်းဦး",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Mercury Rays Manufacturing Co.,Ltd.",
    "Financial Year From": 2007,
    "Financial Year To": 2008,
    "Permit Number": "မနသ-၆၈၃/၂၀၀၈",
    "Permit Date": "2008-03-13T07:04:48Z",
    "Meeting Number": "၄၀/၂၀၀၇",
    "Meeting Date": "2007-10-24T07:05:21Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် မီးဖိုချောင်သုံးပစ္စည်းများ  (Kitchen Wares) ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 456.12,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "အမှတ်(၄၄)၊ ဗဟန်း(၂)လမ်း၊ မြို့မရပ်ကွက်၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "-",
    "Investment Permitted Address":
      "အကွက်အမှတ်(၃၉)၊ အမှတ်(၃)လမ်းမကြီး ၊ စက်မှုနယ်မြေ၊ ပျဉ်းမပင် ၊ မင်္ဂလာဒုံမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 2611,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကျော်ဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ပင်လယ်သုံးစင်းကုမ္ပဏီလီမိတက်  (Tri Sea Company Limited)",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "MaNaTha-302/99",
    "Permit Date": "1999-10-29T07:37:30Z",
    "Meeting Number": "16/99",
    "Meeting Date": "1999-10-10T07:38:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 50.01,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးကျော်ဝင်း၊ ဦးစိန်ဝင်း",
    "Land Area (units not specified in file)": 1,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၈၅-ခ၊ ရှင်စောပုလမ်း၊ စမ်းချောင်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၂၂၄၊ စက်မှုဇုန် ၂၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်း",
  },
  {
    ID: 2612,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကြည်စိုး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "စပယ်ရှယ်မန်နူဖက်ချားရင်းကုမ္ပဏီလီမိတက် (Special Manufacturing Company Limited)",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "MaNaTha- 095/97",
    "Permit Date": "1997-11-28T08:04:07Z",
    "Meeting Number": "16/97",
    "Meeting Date": "1997-10-17T08:04:32Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "စက္ကူလက်ကိုင်ပုဝါ (Tissue Paper) - အမျိုးမျိုး ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 34.24,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 1.998,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "အမှတ် ၁၁၅/၅၂ လမ်း၊ ပုဇွန်တောင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "လှိုင်သာယာမြို့နယ်၊ စက်မှုဇုန်၊ မြေတိုင်းရပ်ကွက်အမှတ် အပိုင်း ၄ ၊ မြေကွက်အမှတ် ၄၃ ",
  },
  {
    ID: 2613,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်ဝင်း(ခ) အင်အိန်တိုက်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ဆဲဗင်းဂိုးလ်ဒင်းလိုင်းယွန်း(စ) အင်တာပရိုက်(စ်)လီမိတက် (Seven Golden Lions Enterprise Limited)",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "Manatha 262/99",
    "Permit Date": "1999-06-25T08:26:44Z",
    "Meeting Number": "9/99",
    "Meeting Date": "1999-05-28T08:27:19Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing and sales of edible oil",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 258.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Seven Golden Lions Company Limited",
    "Land Area (units not specified in file)": 2.033,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 156,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်-၇၄၊ ၁၄လမ်း၊ လမ်းမတော်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ြေ ကွက်အမှတ်(၁၇)၊ ြေ တိုင်းရပ်ကွက်အမှတ် (၃)၊ စက်မှုဇုန်၊  ိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်း",
  },
  {
    ID: 2614,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးစိုးဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Yadanar Thinkha Industry Co., Ltd.",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "618/2003",
    "Permit Date": "2003-05-06T09:16:45Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 14.96,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်ဖြူပြာဝင်း",
    "Land Area (units not specified in file)": 0.33,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 180,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် (၆/ဘီ)၊ သီရိမွန်အိမ်ယာ၊ ဘုရင့်နောင်လမ်းမကြီး၊ လှိုင်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၃၉၀၊ ၃၉၁၊ မြေတိုင်းရပ်ကွက်အမှတ် ၂၃၊ စက်မှုဇုန်၊  ဒဂုံမြို့သစ်တောင်ပိုင်း၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2615,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်စပယ်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "SUJAH ENTERPRISE",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "MaNaTha- 553/2002",
    "Permit Date": "2002-08-29T08:12:49Z",
    "Meeting Number": "1/2002",
    "Meeting Date": "2002-01-11T08:13:19Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 50.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်စပယ်",
    "Land Area (units not specified in file)": 0.34,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၁၆/၁၇၊ ၈ မိုင်လမ်းဆုံ၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၇၄/၇၆၊ ဝေဇယန္တာစီမံကိန်း၊ သင်္ဃန်းကျွန်းမြို့နယ်၊ ရန်ကုန်တိုင်း\n\n",
  },
  {
    ID: 2616,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးသန်းနိုင်ဦး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ထိပ်တန်းပုံစံထုတ်ကုမ္ပဏီလီမိတက် (Lead Fashion Industry Company Limited)",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "MaNaTha-766/2010",
    "Permit Date": "2010-12-02T09:48:58Z",
    "Meeting Number": "34/2010",
    "Meeting Date": "2010-10-08T09:49:23Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အထည်အမျိုးမျိုးချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 37.89,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးသာခင်နှင့် ဦးတင်စိန်",
    "Land Area (units not specified in file)": 0.59,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "၅ ခန်းတွဲ၊ ၁ လမ်း၊ စဉ့်ငူရပ်ကွက်၊ အင်းစိန်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၃၂၄)၊ မြေတိုင်းရပ်ကွက်အမှတ် (၁၉/၁)၊ မက္ခရာမင်းသားကြီးလမ်း၊ ရွှေပေါက်ကံစက်မှုဇုန်၊ ရွှေပေါက်ကံမြို့သစ်၊ မြောက်ဉက္ကာလမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2617,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်မြင့်မြင့်ဦး(ခ)ဂေါ်ဆေးတုံ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ပွင့်ထုတ်လုပ်မှုကုမ္ပဏီလီမိတက်(Pwint Manufacturing Co., Ltd.)",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "မနသ-၄၁၉/၂၀၀၀",
    "Permit Date": "2000-08-18T09:41:22Z",
    "Meeting Number": "၂၁/၂၀၀၀",
    "Meeting Date": "2000-06-29T09:41:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့်အသင့်ချုပ်ပြီး အထည်များထုတ်လုပ်သည့်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 69.37,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "မြို့ရွာနှင့်အိုးအိမ်ဖွံ့ဖြိုးရေးဦးစီးဌာနပိုင်",
    "Land Area (units not specified in file)": 0.33,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်-၁၁၁၀/၁၁၁၁၊သုမင်္ဂလာလမ်း၊၁၆/၄ရပ်ကွက်၊သင်္ဃန်းကျွန်းမြို့နယ်၊ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်း၊ဒဂုံမြို့သစ်တောင်ပိုင်းမြို့နယ်၊စက်မှုဇုန်၊မြေတိုင်းရပ်ကွက်-၂၃၊မြေကွက်အမှတ်-၁၆၀၊၁၆၁",
  },
  {
    ID: 2618,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Sun Thet Tun",
    "Name of Principal Organization":
      "SHWE KATHAR ENGINEERING & MANUFACTURING COMPANY LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "SHWE KATHAR-SHINDO ENGINEERING & MANUFACTURING PRIVATE COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "851/2014",
    "Permit Date": "2014-11-06T03:19:54Z",
    "Meeting Number": "25/2014",
    "Meeting Date": "2014-10-25T03:20:33Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing & Assembling of tape automatic bonding products, chips on film, led substrates and other high end electronic parts on CMP Basis.",
    "Amount Of Foreign Capital USD (in Millions)": 3.03,
    "Total Amount Of Capital (in Millions)": 6.06,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "Shwe Ka thar engineering & manufacturing company Limited",
    "Land Area (units not specified in file)": 3.333,
    "Lease Term": 20,
    "Annual Lease Fee": 0.00032,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "L-7, Shwe Sabai Yeikmon, Bayint Naung Road, Kamayut Township,YANGON.",
    "Organization Address":
      "No.11-09, Ba Yint Naung Tower 2-B, Ba Yint Naung Road, Kamayut Township,YANGON.",
    "Investment Permitted Address":
      "No.(151), Yawgi Kyaung Street, 11-Ward, Hlaing Township,YANGON.",
  },
  {
    ID: 2619,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးရန်ကြာနိမ်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "တောက်ပသောအလင်းအထည်ထုတ်လုပ်ကုမ္ပဏီလီမိတက် (Bright Light Garment Manufacturing Company Limited)",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "MaNaTha554/2002",
    "Permit Date": "2002-08-29T03:26:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 40.6,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၅၄၇၊ လားရှိုးလုံးလမ်း၊ နယ်မြေ ၇၊ ရပ်ကွက် ၁၂၊ လားရှိုးမြို့နယ်၊ ရှမ်းပြည်နယ်",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၄၇၀/က၊ မြေတိုင်းရပ်ကွက်အမှတ် ၂၃၊ စက်မှုဇုန် ၁၊ ဒဂုံမြို့သစ် (တောင်ပိုင်း) မြို့နယ်၊ ရန်ကုန်တိုင်း",
  },
  {
    ID: 2620,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးစိုးဝေ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "တိုးမြတ်အောင်အထည်ချုပ်ကုမ္ပဏီလီမိတက် (Toe Myat Aung Garment Company Limited)",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "MaNaTha-768/2010",
    "Permit Date": "2010-12-02T03:48:26Z",
    "Meeting Number": "31/2010",
    "Meeting Date": "2010-09-17T03:48:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီ ဇာပန်းထိုး/ ဇာပန်းကပ်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 119.495,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးညီညီလွင်၊ ဒေါ်မိမိအောင် (ခ) တန်ဘိဘိ",
    "Land Area (units not specified in file)": 2.386,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "လျှပ်စစ်ဝင်း၊ ဗိုလ်ခြံ၊ ပျဉ်းမပင်၊ မင်္ဂလာဒုံမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၀၉၊ မြေတိုင်းရပ်ကွက်အမှတ် ၁၄၊ ဗိုလ်အောင်ကျော်လမ်း၊ ရွှေသံလွင်စက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2621,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်စုစုမော်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ဖက်ရှင်လေးရာသီကုမ္ပဏီလီမိတက် (Fashion Four Seasons Company Limited)",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "767/2010",
    "Permit Date": "2010-11-30T04:04:22Z",
    "Meeting Number": "34/2010",
    "Meeting Date": "2010-10-08T04:00:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 164.44,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးမိုးကျော်သူ၊ ဦးမိုးအောင်သူ",
    "Land Area (units not specified in file)": 0.573,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၂၄၊ ချယ်ရီလမ်း၊ ၁၄/၁ ရပ်ကွက်၊ တောင်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၃၂၁၊ မြေတိုင်းရပ်ကွက်အမှတ် ၁၉/၁၊ ကနောင် ၇ လမ်း၊ ရွှေပေါက်ကံစက်မှုဇုန်၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2622,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးစောကျော်လင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ပုလဲအထည်ချုပ်ကုမ္ပဏီလီမိတက် (Pearl Garment Company Limited)",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "MaNaTha-329/2000",
    "Permit Date": "2000-02-09T04:13:18Z",
    "Meeting Number": "22/99",
    "Meeting Date": "1999-11-12T04:13:58Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 89.66,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးရှီဆွေ",
    "Land Area (units not specified in file)": 0.982,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၅၁၉၊ သိမ်ဖြူလမ်း၊ မင်္ဂလာတောင်ညွန့်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ် ၃၆ (ခ)၊ ဗန်းမော်အတွင်းဝန်လမ်း၊ စက်မှုဇုံအမှတ် ၃၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 2623,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဒေးဗစ်လူဒလူး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ခေတ်မှီဇာပန်းထိုးဘုရင်လီမိတက်(Knitting Crochetting King Fashion Ltd.)",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "မနသ-၄၁၄/၂၀၀၀",
    "Permit Date": "2000-08-10T05:12:44Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့်အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 14.74,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "အမှတ်-၂၆၁၊ဗညားဒလလမ်း၊တာမွေမြို့နယ်၊ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၂၇၅၃၊မြေတိုင်းရပ်ကွက်အမှတ်-၆၃-တိုးချဲ့၊စက်မှုဇုန်၊ဒဂုံမြို့သစ်(တောင်ပိုင်း)မြို့နယ်၊ရန်ကုန်တိုင်း",
  },
  {
    ID: 2624,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ရွှေဇင်နွယ်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "SHWE PALE THWE GENERAL TRADING COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "manatha-1027/2015",
    "Permit Date": "2015-02-04T06:05:18Z",
    "Meeting Number": "1/2015",
    "Meeting Date": "2015-01-09T06:05:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် ဂျပန်ရိုးရာ လက်မှုပညာဖြစ်သည့် ပိုးကြိုးများဖြင့် ကံကောင်းစေသော ဂျပန်ရိုးရာအဆောင်ပစ္စည်းထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 140,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်ဌေးဌေးဝင်း",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "အမှတ်(၁၆၁)၊ ဦးချစ်မောင်လမ်း၊ ဆရာစံ(အနောက်/မြောက်) ရပ်ကွက်၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(စီ-၆)၊ မြေတိုင်းရပ်ကွက်အမှတ်(၃၄-တိုးချဲ့)၊ ဒဂုံမြို့သစ်မြောက်ပိုင်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး။",
  },
  {
    ID: 2625,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကျော်ကျော်လွင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "AYS Mfg Co., Lltd.",
    "Financial Year From": 13,
    "Financial Year To": 14,
    "Permit Number": "Ma Na Tha 931/2013",
    "Permit Date": "2013-08-26T06:55:08Z",
    "Meeting Number": "21/2013",
    "Meeting Date": "2013-08-15T06:55:42Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ခေတ်မီ ပဲခွဲ သန့်စင်စက်ရုံ တိုးချဲ့၍ သန့်စင်ပြီး ပဲအမျိုးမျိုး ထုတ်လုပ်ကာ ပြည်ပသို့ တင်ပို့ရောင်းချခြင်းလုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1649.8,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဥ◌ီးအောင်သက်မန်း",
    "Land Area (units not specified in file)": 0.064,
    "Lease Term": 30,
    "Annual Lease Fee": 6,
    "Land Use Premium": null,
    "Number Of Local Employees": 3,
    "Number Of Foreign Employees": 49,
    Status: "Monitoring Approved",
    "Investor Address": "အခန်းအမှတ် ၁၁၀၄၊ ရွှေဟင်္သာ ကွန်ဒို၊ ရွှေဟင်္သာလမ်း၊ ",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၂၄၇/အီး၊ တွင်းသင်းတိုက်ဝန် ဦးထွန်းညိုလမ်း၊ မြေတိုင်းရပ်ကွက် အပိုင်း ၂၊ လှိုင်သာယာစက်မှုဇုန်၊",
  },
  {
    ID: 2626,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်ဝင်းဝင်းမြိုင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "အောင်မြင်ကျော်စောထင်ရှားသော အပြည်ပြည်ဆိုင်ရာ ထုတ်လုပ်မှုကုမ္ပဏီလီမိတက်  (Win Glory International Manufacturing Company Limited)",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "MaNaTha- 771/2010",
    "Permit Date": "2010-12-31T08:50:15Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 125,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၂၆၊ ရွှေမဉ္ဇူဘုရားလမ်း၊ ဟိုပင်မြို့နယ်၊ ကချင်ပြည်နယ်",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၄၂၊ ဗန်းမော်အတွင်းဝန်လမ်း၊ စက်မှုဇုန် ၃၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်း ဒေသကြီး",
  },
  {
    ID: 2627,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဇော်ဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "QUALITY APPAREL COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "manatha-1004/2014",
    "Permit Date": "2014-10-31T03:21:59Z",
    "Meeting Number": "24/2014",
    "Meeting Date": "2014-10-17T03:23:23Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 100,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးနေဝင်း(ခ) ဦးတင်စိန်",
    "Land Area (units not specified in file)": 2.176,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်(၂၂)၊ဒုတိယထပ်၊ (၁၈) လမ်း၊ လသာမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်၁၁၂(က)၊ အမရာလမ်း၊ (င)ရပ်ကွက်၊ မြောက်ဥက္ကလာာပစက်မှုဇုန်၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး။",
  },
  {
    ID: 2628,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးညီနိုင်အောင်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar Alinkar Hotel Group Co.,Ltd.",
    "Financial Year From": 0,
    "Financial Year To": 0,
    "Permit Number": "မနသ-၉၁၇/၂၀၁၃",
    "Permit Date": "2013-01-28T03:26:19Z",
    "Meeting Number": "၁၄/၂၀၁၃",
    "Meeting Date": "2013-05-10T03:27:42Z",
    Sector: "",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 0,
    "Currency Of Total Amount": "",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "",
    "Form Of Investment": "",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "အမှတ်(၃၂/အေ)၊ မင်္ဂလာလမ်း၊ နံ့သာကုန်းရပ်ကွက်၊ အင်းစိန်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "-",
    "Investment Permitted Address":
      "အမှတ်(၃၄၁)၊ ပြည်လမ်း၊ မုန့်လုပ်ဆောင်းကုန်း(တောင်)ရပ်ကွက်၊ မြေတိုင်းရပ်ကွက်အမှတ် -၂၈- ဘီ၊ မြေအကွက်အမှတ် -၇၂/ ဘီ/၁ ၊စမ်းချောင်းမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 2629,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးတင်ဖေ",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Top Direction Industry Co.,Ltd. ( မြင့်မြတ်မဏ္ဍိုင်စက်မှု၊ လက်မှုလုပ်ငန်း ကုမ္ပဏီ လီမိတက်)",
    "Financial Year From": 0,
    "Financial Year To": 0,
    "Permit Number": "မနသ-၉၆၇/၂၀၁၄",
    "Permit Date": "2014-03-03T03:38:01Z",
    "Meeting Number": "၆/၂၀၁၄",
    "Meeting Date": "2014-01-13T03:38:34Z",
    Sector: "",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 0,
    "Currency Of Total Amount": "",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "",
    "Form Of Investment": "",
    "Land Owner": "",
    "Land Area (units not specified in file)": 1.25,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်(၇၄)၊ မြေညီထပ်၊ (၅)လမ်း၊ ၂ ရပ်ကွက်၊ လမ်းမတော်မြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၉၂)၊ ဆိပ်ကမ်းသာလမ်းနှင့် ပြင်စည်မင်းသားကြီးလမ်းထောင့်၊ စက်မှုဇုန်(၄)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 2631,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Jy Young Kim",
    "Name of Principal Organization": "NEXXT NIC ",
    "Place of Incorporation": "MALAYSIA",
    "Company Name In Myanmar": "Lia International Company Limited",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "494/2012",
    "Permit Date": "2002-07-30T05:15:43Z",
    "Meeting Number": "21/2012",
    "Meeting Date": "2012-07-18T05:17:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Socks on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3.024,
    "Total Amount Of Capital (in Millions)": 3.024,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Malaysia",
    "Form Of Investment": "FDII",
    "Land Owner": "U Moharmed Yusoof @ Mg Mg",
    "Land Area (units not specified in file)": 2.01,
    "Lease Term": 30,
    "Annual Lease Fee": 0.045,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "#213 Dong 610 Ho, Sinbanpo Hanshin APT, Jamwon-Dong, Seocho-Gu, Seoul, Republic of Korea",
    "Organization Address":
      "U0195, JALAN MERDEKA, 87007 LABUAN FEDERAL TERRITORY, MALAYSIA",
    "Investment Permitted Address":
      "Plot No. 41, Bamaw Atwin Winn Street, Hlaing Tharyar Industry Zone (3), Hlaing Tharyar Township, Yangon",
  },
  {
    ID: 2632,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kim Jung Heon",
    "Name of Principal Organization": "E-Land Asia Holdings Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "E-Land Myanmar Company Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "678/2014",
    "Permit Date": "2014-03-03T06:20:18Z",
    "Meeting Number": "3/2014",
    "Meeting Date": "2014-01-24T06:20:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.5,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Tin Aye",
    "Land Area (units not specified in file)": 1.798,
    "Lease Term": 50,
    "Annual Lease Fee": 0.048,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.36, Tay Thanh Street, Tay Thanh Ward, Tan Phu Dist, HCM City, Vietnam",
    "Organization Address":
      "50 Raffles Place, # 11-03B, Singapore Land Tower, Singapore 048623",
    "Investment Permitted Address":
      "Plot No. 84, Than Chat Wun U Nyunt Street, Industrial Zone 2, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 2633,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr. Zhang, Guangjie",
    "Name of Principal Organization": "America Asstex Corporation Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Myanmar I-Tex Garment Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "133/2018",
    "Permit Date": "2018-12-10T07:01:54Z",
    "Meeting Number": "20/2018",
    "Meeting Date": "2018-12-07T07:02:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 6.13,
    "Total Amount Of Capital (in Millions)": 6.13,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Thi Thi",
    "Land Area (units not specified in file)": 7.554,
    "Lease Term": 10,
    "Annual Lease Fee": 0.18,
    "Land Use Premium": null,
    "Number Of Local Employees": 2500,
    "Number Of Foreign Employees": 30,
    Status: "Approved",
    "Investor Address":
      "Room 06, 13 A/F, South Tower, World Finance Centre, Harbour City, Tsim Sha Tsui, Kowloon, Hong Kong",
    "Organization Address":
      "17 Canton Road, Room 06, 13 A/F, South Tower, World Finance Centre, Harbour City, Tsim Sha Tsui, Kowloon, Hong Kong",
    "Investment Permitted Address":
      "Plot No. 62+67, Myay Taing Block No. 21, Mya Sein Yaung Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2634,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Jeroem Herms",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "BSK Leather Myanmar Co.,Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "031/2017",
    "Permit Date": "2017-07-24T04:18:03Z",
    "Meeting Number": "10/2017",
    "Meeting Date": "2017-07-11T04:18:46Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kind of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.217,
    "Total Amount Of Capital (in Millions)": 1.217,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": 1,
    "Lease Term": null,
    "Annual Lease Fee": 0.106,
    "Land Use Premium": 0.03,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "1601 F, Building Mingmen, Yabao Xin Cheng ,Huadu District, Guangzhou City, People's Republic of China",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No.251/A, Industrial Zone(2), Hlaing Thar Yar Township, Yangon ",
  },
  {
    ID: 2635,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Managing Director, Myanma Textile Industries",
    "Name of Principal Organization": "Myanma Textile Industries",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Myanmar Knitwear Manufacturing Co., Ltd.",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "135/95",
    "Permit Date": "1995-03-28T04:54:51Z",
    "Meeting Number": "3/1995",
    "Meeting Date": "1995-02-27T04:55:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 1.1015,
    "Total Amount Of Capital (in Millions)": 12.609,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 90,
    "Validity Of Investment Permit (in Years)": 5,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Myanma Textile Industries",
    "Land Area (units not specified in file)": null,
    "Lease Term": 5,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Terminated",
    "Investor Address": "192, Kabar Aye Pagoda Road, Bahan Township, Tangon",
    "Organization Address": "192, Kaba Aye Pagoda Road, Bahan Township, Yangon",
    "Investment Permitted Address":
      "Towel Factory No.1, Branch-3, No.79, Oak Pone Seik Street, Mayangon Township, Yangon",
  },
  {
    ID: 2636,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Zhao Huanchen",
    "Name of Principal Organization":
      "Shandong D & Y Textile & Garment Group Share Co.,Ltd.",
    "Place of Incorporation": "People's Republic of China",
    "Company Name In Myanmar": "Myanmar D & Y Textitle Co.,Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "545/2013",
    "Permit Date": "2013-01-16T05:11:19Z",
    "Meeting Number": "3/2013",
    "Meeting Date": "2013-01-16T05:12:11Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Spinning and Processing  of Cotton Yarn on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 10.066,
    "Total Amount Of Capital (in Millions)": 10.006,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Manmed Esoof and Myanmar D & Y Textile Co.,Ltd.",
    "Land Area (units not specified in file)": 3.12,
    "Lease Term": 10,
    "Annual Lease Fee": 0.032,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.12, Dongyue Street, Taishan District, Taian City, Shandong Province , China",
    "Organization Address":
      "No. 12 Dongyue Street, Taishan District, Taian City, Shandong Province, China",
    "Investment Permitted Address":
      "No.(61 -62), Kanaung Min Thar Gyi Road, East Dagon Industrial Zone, Part-2, East Dagon Township, Yangon",
  },
  {
    ID: 2637,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Peter Hang Kin Chung",
    "Name of Principal Organization": "H.W.A Glory Limited",
    "Place of Incorporation": "British Virgin Islands",
    "Company Name In Myanmar": "Dragon State Limited",
    "Financial Year From": 1995,
    "Financial Year To": 1996,
    "Permit Number": "151/1995",
    "Permit Date": "1995-07-13T05:11:28Z",
    "Meeting Number": "6/1995",
    "Meeting Date": "1995-05-26T05:11:55Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Production and Marketing of Garment",
    "Amount Of Foreign Capital USD (in Millions)": 3,
    "Total Amount Of Capital (in Millions)": 3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Virgin Islands (British)",
    "Form Of Investment": "FDII",
    "Land Owner": "Myanmar Economic Holdings Limited",
    "Land Area (units not specified in file)": null,
    "Lease Term": 20,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "British Virgin Islands",
    "Organization Address": "British Virgin Islands",
    "Investment Permitted Address":
      "Pyin Ma Bin Industrial Area, Mingaladon Township",
  },
  {
    ID: 2638,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Director, Union of Myanmar Economic Holdings Limited",
    "Name of Principal Organization":
      "Union of Myanmar Economic Holdings Limited.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Myanmar Nouveau Company Limited",
    "Financial Year From": 1995,
    "Financial Year To": 1996,
    "Permit Number": "164/1995",
    "Permit Date": "1995-09-20T05:28:00Z",
    "Meeting Number": "9/1995",
    "Meeting Date": "1995-08-14T05:28:24Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Treating, Heating, Cutting and Polishing of Raw Precious Stones & Manufacturing and Marketing of Jewellery and Carvings of Precious and Semi-Precious Stones",
    "Amount Of Foreign Capital USD (in Millions)": 1.862,
    "Total Amount Of Capital (in Millions)": 22.8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "Myanmar Economic Holdings Limited",
    "Land Area (units not specified in file)": null,
    "Lease Term": 15,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "No.72-74 Shwedagon Pagoda Road, Dagon Township, Yangon",
    "Organization Address": "72-74, Shwedagon Pagoda, Dagon Township",
    "Investment Permitted Address":
      "No.22, Pyay Road, 7th Mile, Mayangone Township, Yangon",
  },
  {
    ID: 2639,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Managing Director, Myanma Petrochemical Enterprise",
    "Name of Principal Organization": "Myanma Petrochemical Enterprise",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Myanmar Carbonix Limited",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "205/1996",
    "Permit Date": "1996-08-06T05:47:22Z",
    "Meeting Number": "11/1996",
    "Meeting Date": "1996-07-26T05:47:50Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production, Distribution and Services for Carbon Dioxide(Co2)",
    "Amount Of Foreign Capital USD (in Millions)": 2.6,
    "Total Amount Of Capital (in Millions)": 24,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Myanma Petrochemical Enterprise",
    "Land Area (units not specified in file)": null,
    "Lease Term": 20,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "No.23, Min-Ye, Kyawzwa Raod, Yangon",
    "Organization Address": "No.23< Min-Ye-Kyawzwa Road, Yangon",
    "Investment Permitted Address": "Thanlyin Refinery No.1",
  },
  {
    ID: 2640,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Son Hoang",
    "Name of Principal Organization": "Guston Molinel SA",
    "Place of Incorporation": "France",
    "Company Name In Myanmar": "Myanmar Guston Molinel Co., Ltd.",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "219/1996",
    "Permit Date": "1996-10-15T05:58:50Z",
    "Meeting Number": "13/1996",
    "Meeting Date": "1996-08-23T05:59:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing & Marketing of Garment",
    "Amount Of Foreign Capital USD (in Millions)": 1.37,
    "Total Amount Of Capital (in Millions)": 1.37,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "France",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "42, Rue Breguei, Paris 11",
    "Organization Address": "42, Rue Breguei, Paris 11",
    "Investment Permitted Address": "Hlaingtharyar Industrial Zone, Yangon",
  },
  {
    ID: 2641,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Nobuaki Hayashi",
    "Name of Principal Organization": "Japan Tobacco INC.",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Myanmar Japan Tobacco Co., Ltd.",
    "Financial Year From": 201,
    "Financial Year To": 202,
    "Permit Number": "524/2012",
    "Permit Date": "2012-11-30T07:14:08Z",
    "Meeting Number": "35/2012",
    "Meeting Date": "2012-11-21T07:14:23Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing and Marketing of Cigarettes",
    "Amount Of Foreign Capital USD (in Millions)": 18,
    "Total Amount Of Capital (in Millions)": 18,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "U Myo Myint Aung and Daw Kyi Hlaing",
    "Land Area (units not specified in file)": null,
    "Lease Term": 30,
    "Annual Lease Fee": 0.063,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Rejected",
    "Investor Address":
      "Flat B,26/F, Tower 5, The Leighton Hill 2B Broadwood Road, Hong Kong",
    "Organization Address": "2-1, Toranomon 2-Chome, Minato-Ku, Tokyo, Japan",
    "Investment Permitted Address":
      "Block-9, Yangon Industrial Zone, Mingaladon Township, Yangon Region",
  },
  {
    ID: 2642,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Song Young Bok",
    "Name of Principal Organization": "Stone House Co., Ltd.",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "Myanmar Stone House Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "526/2012",
    "Permit Date": "2012-12-14T07:42:57Z",
    "Meeting Number": "36/2012",
    "Meeting Date": "2012-11-29T07:43:19Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Cubic Zirconia, Synthetic Stone Under CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.37,
    "Total Amount Of Capital (in Millions)": 1.37,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "Myanmar Stone House Co., Ltd.",
    "Land Area (units not specified in file)": 696.77,
    "Lease Term": 15,
    "Annual Lease Fee": 0.014,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Eunpyeong New Town Gupabal APT 919-306 Jingwan-Dong, Eunpyeong-Gu, Seoul, South Korea",
    "Organization Address":
      "Jewelry Centre #101,9-3 Bongik-Dong, Jonngno-Gu, Seoul, Republic of Korea",
    "Investment Permitted Address":
      "No.221, U Aung Thu Street, Hlaing Thar Yar Industrial Zone-2,Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2643,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်နန်းစံဆိုင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ဆွဲဆောင်မှုအထည်ချုပ်စက်မှုလုပ်ငန်းကုမ္ပဏီလီမိတက်(Charming Garments Manufacturing Co., Ltd.)",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "မနသ-၅၉၅/၂၀၀၃",
    "Permit Date": "2003-02-19T08:05:12Z",
    "Meeting Number": "၁/၂၀၁၃",
    "Meeting Date": "2003-01-06T08:05:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့်အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 10.51,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်နန်းစံဆိုင်",
    "Land Area (units not specified in file)": 1.433,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၁၉(ဘီ)၊ဗိုလ်ရာညွှန့်လမ်း၊ဒဂုံမြို့နယ်၊ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၃၈၊ဆိပ်ကမ်းသာလမ်း၊စက်မှုဇုန်-၂၊လှိုင်သာယာမြို့နယ်၊ရန်ကုန်တိုင်း",
  },
  {
    ID: 2644,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Lee Soowon",
    "Name of Principal Organization": "GB Style Co.,Ltd.",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "Real Strar Manufacturing Co.,Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "539/2012",
    "Permit Date": "2012-12-31T08:09:24Z",
    "Meeting Number": "39/2012",
    "Meeting Date": "2012-12-28T08:09:45Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.523,
    "Total Amount Of Capital (in Millions)": 0.523,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": 1.21,
    "Lease Term": null,
    "Annual Lease Fee": 0.031828,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "101-909, Hyun Dai APT, Yeon San 8 Dong, Yeon Je Gu, Busan, Republic of korea",
    "Organization Address":
      "56, Seoulleung-Ro,146-Gil, Gangnam-Gu, Seoul, Republic of korea",
    "Investment Permitted Address":
      "Plot No.2/26, Kanaungminthargyi Rioad, Dagon Seikkan Industrial Zone(2), Dagon Seikkan Township, Yangon",
  },
  {
    ID: 2645,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးကျော်ဝင်းထွန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ကောင်းပေစွ အပြည်ပြည်ဆိုင်ရာထုတ်လုပ်မှုကုမ္ပဏီလီမိတက်(Bravo International Manufacturing Co., Ltd.)",
    "Financial Year From": 2011,
    "Financial Year To": 2012,
    "Permit Number": "မနသ-၈၃၇/၂၀၁၂",
    "Permit Date": "2012-03-09T08:20:03Z",
    "Meeting Number": "၇/၂၀၁၂",
    "Meeting Date": "2012-02-29T08:20:32Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့်အထည်အမျိုးမျိုးထုတ်လုပ်သည့်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 200,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးဝင်းနိုင်",
    "Land Area (units not specified in file)": 0.408,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၁၆၅၊၃၇လမ်း၊၅ရပ်ကွက်၊ကျောက်တံတားမြို့နယ်၊ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၅၂-၅၃၊မြေတိုင်းရပ်ကွက်အမှတ်-၁၉/၂၊ဗိုလ်တေဇလမ်း၊ ရွှေပေါက်ကံစက်မှုဇုန်၊မြောက်ဥက္ကလာပမြို့နယ်၊ရန်ကုန်မြို့",
  },
  {
    ID: 2646,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဝင်းမင်းနိုင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "မြန်မာအထွေထွေမော်တာကုမ္ပဏီလီမိတက်(Myanmar General Motor Co., Ltd.)",
    "Financial Year From": 2011,
    "Financial Year To": 2012,
    "Permit Number": "မနသ-၈၃၈/၂၀၁၂",
    "Permit Date": "2012-03-15T09:41:15Z",
    "Meeting Number": "၁/၂၀၁၂",
    "Meeting Date": "2012-01-03T09:41:59Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "မော်တော်ယာဉ်အမျိုးမျိုးထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 5000,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးနေဝင်ဆွေ",
    "Land Area (units not specified in file)": 6.75,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "အမှတ်-၁၊သာယာအေးရိပ်သာလမ်း၊မရမ်းကုန်း-၃ ရပ်ကွက်၊ကျောက်တံတားမြို့နယ်။ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၁၄၊၁၁၅၊၁၄၁၊မြေတိုင်းရပ်ကွက်အမှတ်-၁၁၃၊ဒဂုံအရှေ့စက်မှုဇုန်၊ဒဂုံမြို့သစ်အရှေ့ပိုင်းမြို့နယ်၊ရန်ုကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2647,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမင်းမင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ထိပ်တန်းတံခွန်ကုမ္ပဏီလီမိတက်(Top Banner Co., Ltd.)",
    "Financial Year From": 2011,
    "Financial Year To": 2012,
    "Permit Number": "မနသ-၈၃၅/၂၀၁၂",
    "Permit Date": "2012-01-31T09:53:50Z",
    "Meeting Number": "2/2012",
    "Meeting Date": "2012-01-18T09:54:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့်အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 166.4,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးမိုးဝင်းမောင်",
    "Land Area (units not specified in file)": 2.578,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-မ/၅၄၀၊မင်းကြီးလမ်း၊ရွာမအရှေ့ရပ်ကွက်၊အင်းစိန်မြို့နယ်၊ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၃၇-က၊ခ၊မြေတိုင်းရပ်ကွက်အမှတ်-အပိုင်း-၄၊စက်မှုမြို့၊လှိုင်သာယာမြို့နယ်၊ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2648,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးသတိုးဟိန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Awba Industries Co., Ltd.",
    "Financial Year From": 2011,
    "Financial Year To": 2012,
    "Permit Number": "မနသ-၈၄၈/၂၀၁၂",
    "Permit Date": "2012-06-15T10:02:21Z",
    "Meeting Number": "17/2012",
    "Meeting Date": "2012-06-13T10:02:38Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "ကွန်ပေါင်းဓါတ်မြေသြဇာထုတ်လုပ်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 5476.55,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးသတိုးဟိန်း",
    "Land Area (units not specified in file)": 2.684,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "အမှတ်-၆၅-အေ၊တက္ကသိုလ်ရိပ်သာလမ်း၊ဗဟန်းမြို့နယ်၊ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၅၃၊မြေတိုင်းရပ်ကွက်အမှတ်-၂၄၊ငွေပင်လယ်စက်မှုဇုန်၊လှိုင်သာယာမြို့နယ်၊ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2649,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Managing Director, Myanma Oil and Gas Enterprise",
    "Name of Principal Organization":
      "Managing Director, Myanma Oil and Gas Enterprise",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Roundhay Limited",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "214/1996",
    "Permit Date": "1996-10-03T04:50:03Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 2.25,
    "Total Amount Of Capital (in Millions)": 2.25,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Malaysia",
    "Form Of Investment": "",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address": "No.74/80,Minyekyawzwa Road, Yangon",
    "Organization Address": "No.74/80,Minyekyawzwa Road, Yangon",
    "Investment Permitted Address": "Block M-4 in Offshore",
  },
  {
    ID: 2650,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor":
      "Managing Director,Myanmar-ACE Metal Industries Co., Ltd.",
    "Name of Principal Organization": "Myanmar-ACE Metal Industries Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Myanmar Sai Steel Industry Co., Ltd.",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "212/1996",
    "Permit Date": "1996-09-30T05:29:44Z",
    "Meeting Number": "13/96",
    "Meeting Date": "1996-08-23T05:30:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production of GI Sheets and Other Steel Related Products",
    "Amount Of Foreign Capital USD (in Millions)": 1.938,
    "Total Amount Of Capital (in Millions)": 22.8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner":
      "Myanma General and Maintenance Industries, Myanmar-ACE Metal Industries Co., Ltd.",
    "Land Area (units not specified in file)": null,
    "Lease Term": 10,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Rejected",
    "Investor Address":
      "No.2, Enamel Ware Factory, Okkyin Station Road, Hlaing Township, Yangon",
    "Organization Address":
      "No.2,Enamel Ware Factory, Okkyin Station Road, Hlaing Township, Yangon",
    "Investment Permitted Address":
      "Footware Factory No.3, Compound,Thanlyin Industrial Complex",
  },
  {
    ID: 2651,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw San San Yee",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "A&S International Company Limited",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "238/99",
    "Permit Date": "2019-03-25T08:57:48Z",
    "Meeting Number": "11/99",
    "Meeting Date": "1999-03-10T08:58:41Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အသင့်စားခေါက်ဆွဲ၊ ကြာဇံထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 77,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်စန်းစန်းရီ(အုပ်ချုပ်မှုဒါရိုက်တာ)",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No.(16), 123 rd Street, Mingalar Taungnyunt Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot number (232), HlaingTharYar, Industrial Zone (2), Yangon",
  },
  {
    ID: 2654,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Aung Chit Khin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ACK and CO Services Co., Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "149/2019",
    "Permit Date": "2019-03-16T10:36:31Z",
    "Meeting Number": "4/2019",
    "Meeting Date": "2019-03-15T10:36:48Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Education Services",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1854.74,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 0,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "Daw Aye Myat Mu, Daw Ei Hani Htay, Dr Hein Latt Win, U Phone Swe, Daw Naing Naing Oo, Daw Ei Ei Zin, Daw Khin Khin Win, U Lin Tun Oo, U Saw Wai, Daw Kyauk Chi Phone, U Nyi Thu",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 163,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "NO(360), MAWYAWADDY STREET, WARD NO.5, MAYANGONE TOWNSHIP, YANGON",
    "Organization Address": "",
    "Investment Permitted Address": "Yangon, Mandalay, Sagaing",
  },
  {
    ID: 2655,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Daw Nay Yi Aung",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Star Resources Co., Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "150/2019",
    "Permit Date": "2019-03-16T11:05:31Z",
    "Meeting Number": "4/2019",
    "Meeting Date": "2019-03-15T11:05:47Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "EDUCATION SERVICES FOR HOSPITALITY AND BUSINESS MANAGEMENT ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Nay Yi Aun, Daw Khin San Thint, Daw Phyu Phyu Kine",
    "Land Area (units not specified in file)": null,
    "Lease Term": 5,
    "Annual Lease Fee": 7.8,
    "Land Use Premium": null,
    "Number Of Local Employees": 42,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "NO. (141/149), ROOM NO. 904, BARGAYAR ROAD, BARGAYAR CONDO, SANCHAUNG TOWNSHIP, YANGON ",
    "Organization Address": "",
    "Investment Permitted Address":
      "NO. 267, ROOM NO. (201, 301, 302, 402, 501, 601, 702), MAC TOWER, PYAY ROAD, SANCHAUNG TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2656,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Soe Myint ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Lin Brother Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "147/2019",
    "Permit Date": "2019-03-16T03:11:47Z",
    "Meeting Number": "4/2019",
    "Meeting Date": "2019-03-15T03:11:55Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production and Marketing of Plastic Product (Plastic Mat, Plastic Nets, Plastic Film, Woven Ready Made Sheet etc.)",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 8548.94,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Nyunt Nyunt Yi",
    "Land Area (units not specified in file)": 2.02,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 215,
    "Number Of Foreign Employees": 3,
    Status: "Submitted",
    "Investor Address":
      "No.1 Zawtika Street, Ward No.16/2, Thingangyun Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.16, Myay Taing Block No.-112, Industrial Zone, Dagon Myo Thit (East) Township, Yangon Region",
  },
  {
    ID: 2658,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးစန်းယု(ခ) ဦးမောင်မောင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "SHWE ZIN AYE GARMENT & GENERAL TRADING CO-OP SOCIETY LIMITED",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "manatha-002/95",
    "Permit Date": "1995-01-31T04:41:22Z",
    "Meeting Number": "7/2010",
    "Meeting Date": "2010-02-23T04:42:06Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အသင့်ချုပ်ပြီး အထည်များထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 150,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Rejected",
    "Investor Address":
      "အမှတ်(၄၆)၊ ရွှေတောင်တန်းလမ်း၊ လမ်းမတော်မြို့နယ်၊ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "အထည်စက်ရုံအမှတ်(၁၀)၊ ရုံခွဲ(၄)၊ မေဓါဝီလမ်း၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 2659,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ding Yunsheng",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Meijie (Myanmar)  Clothing & Accessories Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "163/2019",
    "Permit Date": "2019-03-14T08:17:51Z",
    "Meeting Number": "4/2019",
    "Meeting Date": "2019-03-06T08:18:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production, Marketing & Selling Of Clothing Accessories For CMP Garment Enterprises",
    "Amount Of Foreign Capital USD (in Millions)": 3.825,
    "Total Amount Of Capital (in Millions)": 3.825,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Li Chi Kyin",
    "Land Area (units not specified in file)": 2.437,
    "Lease Term": 50,
    "Annual Lease Fee": 35,
    "Land Use Premium": null,
    "Number Of Local Employees": 339,
    "Number Of Foreign Employees": 9,
    Status: "Draft",
    "Investor Address":
      "Room 1402, Unit 2,7 Tong Building 101 Long South Road, Blue Constellation Garden, Qinhuai District, Nanjing, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.(405), Myay Taing Block No.25, Shwe Lin Ban Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2660,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Sai Hla Htwe",
    "Name of Principal Organization": "Tamura Corporation Singapore Pte Ltd",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar":
      "Earth Tamura Electronic (Myanmar) Company Limited (အာ့သ်တာမူရာ အီလက်ထရောနစ် (မြန်မာ)ကုမ္ပဏီလီမီတက်)",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "166/2019",
    "Permit Date": "2019-03-12T09:23:45Z",
    "Meeting Number": "4/2019",
    "Meeting Date": "2019-03-06T09:23:58Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production Of Fish Hooks And Relative Accessories On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.526,
    "Total Amount Of Capital (in Millions)": 0.876,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Khine Zaw ",
    "Land Area (units not specified in file)": 0.554,
    "Lease Term": 30,
    "Annual Lease Fee": 0.066,
    "Land Use Premium": null,
    "Number Of Local Employees": 71,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address": "No.(30/G), Innya Road, Kamayut Township, Yangon",
    "Organization Address":
      "No.1, Maritime Square, #09-30 Harbour Front Centre, Singapore",
    "Investment Permitted Address":
      "No.(475)-D, Block No.(23), Industrial Zone, South Dagon Township, Yangon Region",
  },
  {
    ID: 2661,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Liu, Shih- Ching",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Grand Corp (Myanmar) Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "167/2019",
    "Permit Date": "2019-03-12T09:59:40Z",
    "Meeting Number": "4/2019",
    "Meeting Date": "2019-03-06T10:00:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of Variety Of Mould On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.3,
    "Total Amount Of Capital (in Millions)": 0.3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "FDII",
    "Land Owner": "K & M Capital Company Limited",
    "Land Area (units not specified in file)": 0.189,
    "Lease Term": 5,
    "Annual Lease Fee": 0.0288,
    "Land Use Premium": null,
    "Number Of Local Employees": 26,
    "Number Of Foreign Employees": 6,
    Status: "Draft",
    "Investor Address":
      "No.1, Lane 32, First Street, Jiali Village, Xincheng District, Hualian Country, Taiwan, Province Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Unit #B-016, Skytech Industrial Park, Plot No.5, Myay Taing Block No. 143/1, South Dagon Myo Thit Township,Yangon",
  },
  {
    ID: 2662,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "SKM Steel Holdings Company Limited",
    "Name of Principal Organization": "Mitsui & Co., (Asia Pacific) PTE LTD",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "SKM Steel Holdings Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "168/2019",
    "Permit Date": "2019-03-11T03:27:16Z",
    "Meeting Number": "4/2019",
    "Meeting Date": "2019-03-06T03:27:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Processing and Local Distribution OF Construction Steel Products",
    "Amount Of Foreign Capital USD (in Millions)": 2.205,
    "Total Amount Of Capital (in Millions)": 4.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "U Kyaw Kyaw Oo",
    "Land Area (units not specified in file)": 1.846,
    "Lease Term": 10,
    "Annual Lease Fee": 0.183015,
    "Land Use Premium": null,
    "Number Of Local Employees": 64,
    "Number Of Foreign Employees": 1,
    Status: "Draft",
    "Investor Address":
      "Plot No.58, Myay Taing Block No, Thi Lah War Industrial Zone, Thanlwin- Kyout Tan Township, Yangon Region",
    "Organization Address":
      "12 Marina View, #31-01 Asia Square Tower 2, Singapore",
    "Investment Permitted Address":
      "Plot No. 58,Myay Taing Block No. Thi Lah War Industrial Zone, Thanlwin - Kyout Than Industrial Zone, Yangon Region",
  },
  {
    ID: 2663,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Tsai, Wen-Wei",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Wide Vision Enterprises Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "169/2019",
    "Permit Date": "2019-03-12T03:56:00Z",
    "Meeting Number": "4/2019",
    "Meeting Date": "2019-03-06T03:56:10Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of Various Kinds Of Bags On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.506,
    "Total Amount Of Capital (in Millions)": 4.506,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Maung Aye and U Zaw Zaw Aung",
    "Land Area (units not specified in file)": 1.82,
    "Lease Term": 3,
    "Annual Lease Fee": 206.46,
    "Land Use Premium": null,
    "Number Of Local Employees": 201,
    "Number Of Foreign Employees": 7,
    Status: "Draft",
    "Investor Address":
      "No. 85, SEC 1, Chang An Road, Situn District, Tai Chung City, Taiwan, Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.147, Servey No.14, Shwe Thanlwin Industrial Zone, Hlaing Tharyar Township, Yangon Region",
  },
  {
    ID: 2664,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yang Jianwu",
    "Name of Principal Organization": "Foshan Biaomei Fashion Co., LTD",
    "Place of Incorporation": " People's Republic Of China ",
    "Company Name In Myanmar": "Asia Link (Myanmar) Fashion Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "170/2019",
    "Permit Date": "2019-03-12T04:19:43Z",
    "Meeting Number": "4/2019",
    "Meeting Date": "2019-03-06T04:20:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of Brassier, Underwear and Swimwear On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.262,
    "Total Amount Of Capital (in Millions)": 1.262,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Thein Kyin, U Sai Won Si and U Sai Win Htun",
    "Land Area (units not specified in file)": 2.28,
    "Lease Term": 10,
    "Annual Lease Fee": 192.632,
    "Land Use Premium": null,
    "Number Of Local Employees": 848,
    "Number Of Foreign Employees": 20,
    Status: "Draft",
    "Investor Address":
      "11th Villager Group, Taining Village, Sanxianhu Town, Nan Country, Hunan Province, People's Republic Of China",
    "Organization Address":
      "No.89, Lian'an Avenue , Yanbu Comprehensive, Dali Town, Nanhai District, Foshan City , People's Republic Of China ",
    "Investment Permitted Address":
      "Plot No.85, Myay Taing Block No.51, Thar Du Kan Industrial Zone, Shwe Pyi Thar Township, Yangon  Region",
  },
  {
    ID: 2665,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Cao Shengli",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Ao Sheng Leather Goods Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "171/2019",
    "Permit Date": "2019-03-12T05:03:04Z",
    "Meeting Number": "4/2019",
    "Meeting Date": "2019-03-06T05:03:41Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of Various Kinds Of Bags On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.372,
    "Total Amount Of Capital (in Millions)": 0.372,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Zaw Min, U Tun Min, U Aung Min and U Aye Min",
    "Land Area (units not specified in file)": 2.312,
    "Lease Term": 10,
    "Annual Lease Fee": 234,
    "Land Use Premium": null,
    "Number Of Local Employees": 1363,
    "Number Of Foreign Employees": 30,
    Status: "Draft",
    "Investor Address":
      "No.150, Jinbi Yushui Villa, Shanqian Avenue, Shiling Town, Huadu District, Guangzhou, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.B-3, Myay Taing Block No. 21, Mya Sein Yaung Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2666,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yu Yuanki",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Golden Era Handbags Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "172/2019",
    "Permit Date": "2019-03-12T07:07:50Z",
    "Meeting Number": "4/2019",
    "Meeting Date": "2019-03-06T07:08:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of Various Kind Of Bags On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.5,
    "Total Amount Of Capital (in Millions)": 4.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Ohnmar Lwin",
    "Land Area (units not specified in file)": 2.954,
    "Lease Term": 10,
    "Annual Lease Fee": 0.094323,
    "Land Use Premium": null,
    "Number Of Local Employees": 1290,
    "Number Of Foreign Employees": 30,
    Status: "Draft",
    "Investor Address":
      "Rm-1104, Unit-2, Block-10, Tongjun Street, Sangyuan Roadm Xiangzhanghuayuan Neighbourhood, Tonglu Country, Zhejiang Province, People's Republic OF China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.252/253, Myay Taing Block No.49/War Ta Yar , setmhu (1) street, 23 Ward, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 2667,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Thinzar Htike",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Sujin Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "173/2019",
    "Permit Date": "2019-03-12T07:27:53Z",
    "Meeting Number": "4/2019",
    "Meeting Date": "2019-03-06T07:27:56Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.15,
    "Total Amount Of Capital (in Millions)": 0.435,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "U Than Aung",
    "Land Area (units not specified in file)": 0.11,
    "Lease Term": 10,
    "Annual Lease Fee": 24,
    "Land Use Premium": null,
    "Number Of Local Employees": 225,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address":
      "No.98,Thudamar Street,5 Quarter, Mayangone Township, Yangon Region",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.204+205, Myay Taing Block No.10, Shwe Pouk Kan Industrial Zone, North Oakkalarpa Township, Yangon Region",
  },
  {
    ID: 2674,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Thura Lwin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Asia  Starmar  Transport  Intelligent Co., Ltd.",
    "Financial Year From": 0,
    "Financial Year To": 0,
    "Permit Number": "141/2019",
    "Permit Date": "2019-02-06T08:36:54Z",
    "Meeting Number": "2/2019",
    "Meeting Date": "2019-02-04T08:36:29Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Electronic Ticketing  Service with E-Payment for Public Bus Transportation in Yangon Region ",
    "Amount Of Foreign Capital USD (in Millions)": 1.92,
    "Total Amount Of Capital (in Millions)": 6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 6,
    "Investing Country": "China",
    "Form Of Investment": "JV,BOT",
    "Land Owner": "U Thura Lwin",
    "Land Area (units not specified in file)": 518,
    "Lease Term": 6,
    "Annual Lease Fee": 36,
    "Land Use Premium": null,
    "Number Of Local Employees": 472,
    "Number Of Foreign Employees": 9,
    Status: "Approved",
    "Investor Address":
      "No.(38,39), Waizayantar Road, Za(South)Ward, Thingangyun Township, Yangon  Region.",
    "Organization Address": "",
    "Investment Permitted Address":
      "Tower I, Building (H), Commercial  Area, Shwe Moe  Kaung Condo, Yankin  Township, Yangon  Region",
  },
  {
    ID: 2679,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Zhong Zhixin",
    "Name of Principal Organization": "Sam Fashion Co., Ltd",
    "Place of Incorporation": "People's Republic Of China",
    "Company Name In Myanmar": "Sam Clothing (Myanmar) Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "174/2019",
    "Permit Date": "2019-03-14T08:40:08Z",
    "Meeting Number": "4/2019",
    "Meeting Date": "2019-03-06T08:40:14Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.3,
    "Total Amount Of Capital (in Millions)": 2.3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Than Lin @ Mon Lin, U Kyaw Lin",
    "Land Area (units not specified in file)": 4.356,
    "Lease Term": 10,
    "Annual Lease Fee": 0.389436,
    "Land Use Premium": null,
    "Number Of Local Employees": 1029,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "No.22, Mingcuiyuan, Shangri-La District, Tongxiang City, Zhejiang Province, People's Republic Of China",
    "Organization Address":
      "No.58,East Huashi Road, Longxiang Industrial Zone, Tongxiang, Jiaxing, People's Republic Of China",
    "Investment Permitted Address":
      "Plot No.(2,3), Myay Taing Block No.112, Industrial Zone, East Dagon Myothit Township,Yangon Region",
  },
  {
    ID: 2680,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Li Dongliang",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Bo Da (Myanamr) Fashion Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "175/2019",
    "Permit Date": "2019-03-14T09:45:28Z",
    "Meeting Number": "4/2019",
    "Meeting Date": "2019-03-06T09:45:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing OF Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.637,
    "Total Amount Of Capital (in Millions)": 0.637,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Shin Myin @ U Sai Aung Myint",
    "Land Area (units not specified in file)": 1.61,
    "Lease Term": 10,
    "Annual Lease Fee": 0.0847,
    "Land Use Premium": null,
    "Number Of Local Employees": 800,
    "Number Of Foreign Employees": 16,
    Status: "Draft",
    "Investor Address":
      "No.10, Lisheng Village, Dashengzhuang, Xinqiao Town, Jinghiang City, Jiangsu Province, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.239, Myay Taing Block No.25, Shwe Lin Ban Industrial Myo, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2683,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Bao, Rengao",
    "Name of Principal Organization": "Zhangjiagang Huaxia Headgear Co., Ltd",
    "Place of Incorporation": "People's Republic Of China",
    "Company Name In Myanmar": "Asia Caps Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "164/2019",
    "Permit Date": "2019-03-15T09:59:28Z",
    "Meeting Number": "4/2019",
    "Meeting Date": "2019-03-06T09:59:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Caps On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.98,
    "Total Amount Of Capital (in Millions)": 4.98,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Dr. Win Min Soe",
    "Land Area (units not specified in file)": 4.009,
    "Lease Term": 50,
    "Annual Lease Fee": 0.15,
    "Land Use Premium": null,
    "Number Of Local Employees": 1185,
    "Number Of Foreign Employees": 31,
    Status: "Draft",
    "Investor Address":
      "Room 301, Building 30, Jiyang Middle Road, Jiyang Garden Zhangjiangang City, Jiangsu Province, People's Republic Of China",
    "Organization Address":
      "Zhangjiagang Economic Development Zone, 28 Jingang Road, Tangshi Yangshe Town, Jiangsu Province, People's Republic Of China",
    "Investment Permitted Address":
      "Plot No.(126+127), Yangon Industrial Zone, Mingalardon Township, Yangon Region",
  },
  {
    ID: 2685,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Hein Htet Aung",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "True Green City Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "165/2019",
    "Permit Date": "2019-03-11T10:16:22Z",
    "Meeting Number": "4/2019",
    "Meeting Date": "2019-03-06T10:16:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMPစနစ်ဖြင့်PEကော်ဖီစေ့ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1095.45,
    "Total Amount Of Capital (in Millions)": 1095.45,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါအဲခွေ",
    "Land Area (units not specified in file)": 7.1,
    "Lease Term": 5,
    "Annual Lease Fee": 36000000,
    "Land Use Premium": null,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": 12,
    Status: "Draft",
    "Investor Address":
      "Room No.201,Building No.A-5, Shwe Kabar Aimyar, Mindama Street, Mayangone Township, Yangon Region",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.135, Myay Taing Block No.49, Wartayar Industrial Zone, Shwepyithar Township,Yangon Region",
  },
  {
    ID: 2716,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Sit Nyein",
    "Name of Principal Organization": "Stellar Myanmar Co.,Ltd.",
    "Place of Incorporation": "Yangon",
    "Company Name In Myanmar": "Myanmar Sigma Cable Co.,Ltd.",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "278/1997",
    "Permit Date": "1997-07-11T08:36:34Z",
    "Meeting Number": "10/1997",
    "Meeting Date": "1997-06-27T08:37:24Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Lv Power Cable & LV Underground Cable",
    "Amount Of Foreign Capital USD (in Millions)": 8.6585,
    "Total Amount Of Capital (in Millions)": 54.351,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": 25.588,
    "Lease Term": 25,
    "Annual Lease Fee": 0.003,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "No.142, Sule Pagoda Road, Kyauktada Township, Yangon",
    "Organization Address": "Yangon",
    "Investment Permitted Address":
      "Hlaing Thar Yar Industrial Zone Phase III ",
  },
  {
    ID: 2717,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Dong Hoon Suh",
    "Name of Principal Organization": "Dong Won Trading Co.,Ltd.",
    "Place of Incorporation": "Korea",
    "Company Name In Myanmar": "Myanmar Dong Won Co.,Ltd.",
    "Financial Year From": 0,
    "Financial Year To": 0,
    "Permit Number": "280/1997",
    "Permit Date": "1997-08-29T09:08:00Z",
    "Meeting Number": "11/1997",
    "Meeting Date": "1997-07-18T09:09:12Z",
    Sector: "",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 0,
    "Currency Of Total Amount": "",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "",
    "Form Of Investment": "",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "Chung AM Building # 601,707-25, Yeoksam -Dong , Kangnam-Ku, Seoul , Korea",
    "Organization Address": "Seoul Korea",
    "Investment Permitted Address":
      "Plot No.77 B & 78  , Hlaing Thar Yar Industrial Zone , Hlaing Thar Yar Township, Yangon",
  },
  {
    ID: 2718,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wei, Jianlin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Wanxinda (Myanmar) Travel Goods Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "176/2019",
    "Permit Date": "2019-03-28T04:53:33Z",
    "Meeting Number": "5/2019",
    "Meeting Date": "2019-03-19T04:55:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of Various Kind Of Bags On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.209,
    "Total Amount Of Capital (in Millions)": 2.209,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "ဒေါ်အိမ့်အိမ့်အောင်၊ ဒေါ်စန်းစန်း၀င်း (ခ) မစန်း၀င်း",
    "Land Area (units not specified in file)": 4.184,
    "Lease Term": 10,
    "Annual Lease Fee": 0.220116,
    "Land Use Premium": null,
    "Number Of Local Employees": 750,
    "Number Of Foreign Employees": 30,
    Status: "Draft",
    "Investor Address":
      "Lingxi Road, Guangzhou, Huancheng District, Huadu District, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.157,158, Myay Taing Block No.49, Wartayar Industrial Zone, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 2719,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. JINXING HUANG ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Yancheng Footwear Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "177/2019",
    "Permit Date": "2019-03-28T05:26:48Z",
    "Meeting Number": "5/2019",
    "Meeting Date": "2019-03-19T05:26:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of All Kinds Of Shoes On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3.5,
    "Total Amount Of Capital (in Millions)": 3.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Zaw Myo Myint",
    "Land Area (units not specified in file)": 2.003,
    "Lease Term": 10,
    "Annual Lease Fee": 0.12,
    "Land Use Premium": null,
    "Number Of Local Employees": 619,
    "Number Of Foreign Employees": 30,
    Status: "Draft",
    "Investor Address":
      "Lihe Road, Lishui Town, Nanhai Area, Desheng District Foshan City, Guang Dong Province, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.87, Yangon Industrial Zone, Mingaladon Township, Yangon Region",
  },
  {
    ID: 2720,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. He, Wei",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Myanmar Hongyuan International Garment Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "178/2019",
    "Permit Date": "2019-03-15T05:51:03Z",
    "Meeting Number": "5/2019",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 70,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Sky Vision Company Limited",
    "Land Area (units not specified in file)": 2.91,
    "Lease Term": 50,
    "Annual Lease Fee": 0.018547,
    "Land Use Premium": null,
    "Number Of Local Employees": 723,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "F12, No.32, Wuwu Road, Zhongshan District, Dalian, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "ဦးပိုင်အမှတ်-၃၃/၁ က၊ ၃၃/၁ ခ၊ N-၄ ကွင်းအမှတ်-၅၈၉-က၊ မရမ်းတလင်းကွင်း၊ ဘန့်ဘွေးကုန်းကျေးရွာအုပ်စု၊ မှော်ဘီမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2721,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "ARO COMMERCIAL Co,Ltd",
    "Name of Principal Organization": "MAKRO ROH Co,Ltd",
    "Place of Incorporation": "Thailand",
    "Company Name In Myanmar": "ARO COMMERCIAL Co,Ltd",
    "Financial Year From": 0,
    "Financial Year To": 0,
    "Permit Number": "145/2019",
    "Permit Date": "2019-02-20T05:16:35Z",
    "Meeting Number": "3/2019",
    "Meeting Date": "2019-02-20T05:16:23Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Wholesale and Retail Services",
    "Amount Of Foreign Capital USD (in Millions)": 28.7,
    "Total Amount Of Capital (in Millions)": 28.7,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "The Ministry of Commerce ",
    "Land Area (units not specified in file)": 9.22,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 1765,
    "Number Of Foreign Employees": 18,
    Status: "Draft",
    "Investor Address":
      "Room(409),4th Floor,No.37, La Pyae Wn Plaza, A Lan Pya Pagoda Road, Dagon Township, Yangon",
    "Organization Address":
      "No.1468, Pattanakan Road, Pattanakan Sub-District, Suanluang District, Bangkok ,Thailand",
    "Investment Permitted Address":
      "No.36, 36(A), 36(B), 19, Myay Taing Block No.5-C, Upper Pazaundaung Road, Mingalar TAungnyunt Township, Yangon Region",
  },
  {
    ID: 2722,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "MR. GODFREY TAN",
    "Name of Principal Organization": "FRONTIIR PTE. LTD",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Frontiir Co,Ltd",
    "Financial Year From": 0,
    "Financial Year To": 0,
    "Permit Number": "119/2018",
    "Permit Date": "2018-10-15T07:39:08Z",
    "Meeting Number": "17/2018",
    "Meeting Date": "2018-10-12T07:39:42Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Wholesale and Retail Business on IT Products",
    "Amount Of Foreign Capital USD (in Millions)": 3.14,
    "Total Amount Of Capital (in Millions)": 8.37,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "ဒေါ်ခင်ခင်စိုး",
    "Land Area (units not specified in file)": 0.75,
    "Lease Term": 60,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 32,
    "Number Of Foreign Employees": 2,
    Status: "Draft",
    "Investor Address":
      "1586,Parkview Ave#3, San Jose, CA 95130, United States of America",
    "Organization Address": "51 Goldhill Plaza # 07-10/11, Singapore (308900)",
    "Investment Permitted Address":
      "No.(33-B).Pan Toe Wun U Shwe Bin Street, Hlaing Tharyar Industry Zone (1), Hlaing Tharyar Township,Yangon Region",
  },
  {
    ID: 2723,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Nan Yinn San",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Blue Sky Myanmar Apparel Myanmar Company Limited ",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "179/2019",
    "Permit Date": "2019-03-15T08:49:12Z",
    "Meeting Number": "5/2019",
    "Meeting Date": "2019-03-15T08:49:21Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.35,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 35,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "ဦးစိုင်းစံအိုက်၊ ဒေါ်နန်းလောင်မွန်",
    "Land Area (units not specified in file)": 0.44,
    "Lease Term": 30,
    "Annual Lease Fee": 0.010698,
    "Land Use Premium": null,
    "Number Of Local Employees": 173,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "No.84, Shwe Sabel Street (7), FMI City, Hlaing Thar Yar Township, Yangon Region",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.128+138, Myay Taing Block No.Part 5, Industrial Zone, Hlaing Thar Yar Township,Yangon Region",
  },
  {
    ID: 2726,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Zay Htet",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "GEO-PSI DRILLING CO, LTD",
    "Financial Year From": 0,
    "Financial Year To": 0,
    "Permit Number": "004/2017",
    "Permit Date": "2017-06-22T03:58:25Z",
    "Meeting Number": "8/2017",
    "Meeting Date": "2017-05-19T03:57:56Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Drilling Services ",
    "Amount Of Foreign Capital USD (in Millions)": 6.96,
    "Total Amount Of Capital (in Millions)": 9.28,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "ဦးကစ္စနားကူးမား",
    "Land Area (units not specified in file)": 0.229,
    "Lease Term": 10,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 25,
    "Number Of Foreign Employees": 5,
    Status: "Approved",
    "Investor Address":
      "No.64,Yadanar Street,Pauk Taw Ward, Insein Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.(89-A), WArd No.19 (MWE Zone), Hlaing Tharyar Township, Yangon",
  },
  {
    ID: 2728,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chen, Gexing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Fook Hing Paper Packing Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "180/2019",
    "Permit Date": "2019-03-15T06:55:11Z",
    "Meeting Number": "5/2019",
    "Meeting Date": "2019-03-15T06:55:16Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ကတ်ထူစက္ကူဗူးနှင့် ထုပ်ပိုးပစ္စည်းထုတ်လုပ်၍ ပြည်တွင်း၌ ရာနှုန်းပြည့် ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 2.222,
    "Total Amount Of Capital (in Millions)": 2.777,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 70,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "U Aung Kaung Sein @ U Aung Myint, U Ye Thu Aung",
    "Land Area (units not specified in file)": 4.38,
    "Lease Term": 50,
    "Annual Lease Fee": 0.03,
    "Land Use Premium": null,
    "Number Of Local Employees": 185,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address":
      "Unit 13,19th Floor, Globle Gateway Tower,63 Wing Hong  Street, Cheung Sha Wan, Kowloon, Hong Kong, Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.259,260,261,Myay Taing Block No.49, Wartayar Industrial Zone, Yangon Region",
  },
  {
    ID: 2732,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Zhu, Ronghua",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Myanmar Guotai Huasheng Glory Fashion Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "181/2019",
    "Permit Date": "2019-02-15T03:50:29Z",
    "Meeting Number": "5/2019",
    "Meeting Date": "2019-03-15T03:50:42Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.5,
    "Total Amount Of Capital (in Millions)": 2.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Hla Thein",
    "Land Area (units not specified in file)": 1.976,
    "Lease Term": 10,
    "Annual Lease Fee": 0.174,
    "Land Use Premium": null,
    "Number Of Local Employees": 900,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "Wanhong Garden Building 8738 Zhangjiagang City, Jiangsu province, People's Republic Of China ",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.171, Industrial Zone(2), Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2733,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Qian DanChu",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Unifa Handbag Myanmar Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "182/2019",
    "Permit Date": "2019-03-28T05:16:00Z",
    "Meeting Number": "5/2019",
    "Meeting Date": "2019-03-19T05:16:04Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of Various Kind Of Bags On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.57,
    "Total Amount Of Capital (in Millions)": 1.57,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Shwe Hlaing",
    "Land Area (units not specified in file)": 2.739,
    "Lease Term": 10,
    "Annual Lease Fee": 0.1716,
    "Land Use Premium": null,
    "Number Of Local Employees": 700,
    "Number Of Foreign Employees": 20,
    Status: "Draft",
    "Investor Address":
      "WenZhou Avenue, WenZhou, ZheJiang Province, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.67, Myay Taing Block No.14, Shwe Than Lwin, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 2734,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms.Chen Qiuyun",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Brightberg Enterprises (Myanmar) Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "183/2019",
    "Permit Date": "2019-03-28T07:32:04Z",
    "Meeting Number": "5/2019",
    "Meeting Date": "2019-03-19T07:32:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Bags On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.666,
    "Total Amount Of Capital (in Millions)": 0.666,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Ma Za Lay Char Bi @ Daw Than Than Htwe",
    "Land Area (units not specified in file)": 0.688,
    "Lease Term": 5,
    "Annual Lease Fee": 115.2,
    "Land Use Premium": null,
    "Number Of Local Employees": 629,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "No.276, Chengyibei Road, Jimei District, Xiamen, Fujian, People's Republic Of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.76, Myay Taing Block No. Industrial Zone(2), Dagon Seikkan Township, Yangon Region",
  },
  {
    ID: 2735,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Jin Ye",
    "Name of Principal Organization":
      "Anhui Xinlin Import And Export Trade (Group) Co., Ltd",
    "Place of Incorporation": "People's Republic Of China",
    "Company Name In Myanmar": "New Plus Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "184/2019",
    "Permit Date": "2019-03-28T07:57:05Z",
    "Meeting Number": "5/2019",
    "Meeting Date": "2019-03-19T07:57:09Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.839,
    "Total Amount Of Capital (in Millions)": 2.839,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 18,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "ဒေါ်ကျင်ရှိန်",
    "Land Area (units not specified in file)": 2.401,
    "Lease Term": 8,
    "Annual Lease Fee": 0.077712,
    "Land Use Premium": null,
    "Number Of Local Employees": 1200,
    "Number Of Foreign Employees": 30,
    Status: "Draft",
    "Investor Address":
      "Yanyuan 2 Dong, Jiang Shu SHeng,101 SHi Nantongshi, Chong Chuan Qu, People's Republic Of China",
    "Organization Address":
      "No.14-3, Jiadachuangzhi Logistics Park, Suma Par, Suzhou City, People's Republic Of China",
    "Investment Permitted Address":
      "Plot No.82,Myay Taing Block No.51, Thar Du Kan Industrial Zone, Shwe Pyi Thar Township,Yangon Region",
  },
  {
    ID: 2736,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Leung Pak Lung Thomas",
    "Name of Principal Organization": "Yu Jia Rainwear Garment Ltd., Flst/Rma",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Rainwear House (Myanmar) Manufactory Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "185/2019",
    "Permit Date": "2019-03-28T09:23:38Z",
    "Meeting Number": "5/2019",
    "Meeting Date": "2019-03-19T09:23:42Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.896,
    "Total Amount Of Capital (in Millions)": 0.896,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Nilar Myint",
    "Land Area (units not specified in file)": null,
    "Lease Term": 10,
    "Annual Lease Fee": 0.147541,
    "Land Use Premium": null,
    "Number Of Local Employees": 503,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address":
      "Flat 4/E, Block No.5, Laguna Street, Laguna City, Kowloon, Hong Kong",
    "Organization Address":
      "12/F,31 Hing Yip Street, Hing Yip Center, Kwun Tong, Kl, Hong Kong",
    "Investment Permitted Address":
      "Plot No.120, Myay Taing Block No. Industrial Zone(2), Dagon Seikkan Township,Yangon Region\n",
  },
  {
    ID: 2739,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Moe Moe",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Capital Development Limited (မြို့ တော်ဖွံ့ဖြိုးတိုးတက်ရေး လီမိတက်)",
    "Financial Year From": 15,
    "Financial Year To": 16,
    "Permit Number": "Ma Na Tha 1117/2016",
    "Permit Date": "2016-01-26T08:50:58Z",
    "Meeting Number": "22/2015",
    "Meeting Date": "2015-12-11T07:24:14Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "စားသောက်ကုန်များ၊ စိုက်ပျိုးရေး အခြေခံလယ်ယာ ထွက်ကုန်သီးနှံများအား သန့်စင်ခြင်း၊ ပြုပြင်ထုတ်ပိုးခြင်း၊ ရောင်းချခြင်း၊ သိုလှောင်ခြင်းနှင့် ငှားရမ်းခြင်း ဝန်ဆောင်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 9660.992,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "မြန်မာ့စက်မှုသီးနှံ ဖွံ့ဖြိုးရေးဦးစီးဌာန",
    "Land Area (units not specified in file)": 39.839,
    "Lease Term": 50,
    "Annual Lease Fee": 150,
    "Land Use Premium": null,
    "Number Of Local Employees": 563,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "No. 126, Kabaaye Pagoda Road, Saya San Ward,",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေတိုင်းရပ်ကွက်အမှတ်-၂၊မြေကွက်အမှတ်-၂၅၊၂၅E၊၂၅F၊၆A၊၆H၊၄၃၁၊၂၅A၊၂၅B၊၂၅C၊၂၅D၊၄၁၊၄၇",
  },
  {
    ID: 2740,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Michael Bui Phin",
    "Name of Principal Organization": "Valentis Group Ltd",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Titeline Valentis Ltd. ",
    "Financial Year From": 0,
    "Financial Year To": 0,
    "Permit Number": "1086/2016",
    "Permit Date": "2016-02-17T04:00:59Z",
    "Meeting Number": "3/2016",
    "Meeting Date": "2016-01-30T04:01:36Z",
    Sector: "Mining",
    "Type Of Investment Business":
      "Providing of Drilling Services To The MIning Industry",
    "Amount Of Foreign Capital USD (in Millions)": 26.74,
    "Total Amount Of Capital (in Millions)": 26.74,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 10,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U La Min Win",
    "Land Area (units not specified in file)": 0.103,
    "Lease Term": 10,
    "Annual Lease Fee": 2.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 46,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "6 Yandalla Street, Marsfield Sydney Nsw 2122, Australia",
    "Organization Address":
      "Plot No. C4, Thazin (1) Street, Hlaing Yadanar Housing, Hlaing Township,Yangon",
    "Investment Permitted Address":
      "Plot No. C4, Thazin (1) Street,  Hlaing Yadanar Housing , Hlaing Township, Yangon Region, Plot No.3, Myay Taing Block No. A-1-KA, Kankauk Quarter, Chan Aye Tharzan Township, Mandalay Region",
  },
  {
    ID: 2747,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်တိုးနန္ဒာတင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Anawa Dewi Fishin g And General Tradin g Co -Operative Ltd.",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "MaNaTha-044/1996",
    "Permit Date": "1996-10-29T03:43:08Z",
    "Meeting Number": "15/1996",
    "Meeting Date": "1996-10-10T03:43:40Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "·ထုတ်လုပ်မှုနှင့် ဝန်ဆောင်မှုလုပ်ငန်း (ငါးအအေးခန်း နှင့် ရေခဲစက်ရုံလုပ်ငန်း)",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 78.66,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်တိုးနန္ဒာတင်",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "အမှတ်-၅၅၄၊ မမဦးလမ်း၊ အနောက်ကြို့ကုန်း၊",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၃၆/အေ၊ မြေတိုင်းအမှတ်-၆/အီး၊",
  },
  {
    ID: 2748,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးရဲနိုင်ဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MayKha Industrial Ltd",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "MaNaTha-067/1997",
    "Permit Date": "1997-04-24T03:59:12Z",
    "Meeting Number": "5/1997",
    "Meeting Date": "1997-03-20T04:07:01Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "တိရစ္ဆာန်နှင့် တိရစ္ဆာန်အစားအစာများ ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 47.072,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "မွေးမြူရေးနှင့်ရေလုပ်ငန်းဦးစီးဌာန၊မွေးမြူရေး၊အစားအစာနှင့်နို့ထွက်ပစ္စည်းလုပ်ငန်း",
    "Land Area (units not specified in file)": 43,
    "Lease Term": 252525,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "၇၀/​တ၊ ငွေဝတ်မှုံရပ်ကွက်၊ ရွှေတောင်ကြားရိပ်သာ၊",
    "Organization Address": "",
    "Investment Permitted Address": "ရွာသာကြီးဘက်စုံမွေးမြူရေးစခန်း၊ ",
  },
  {
    ID: 2752,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမင်းသန်းဌေး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Sea Wolf Co., Ltd",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "MaNaTha-341/2000",
    "Permit Date": "2000-02-29T04:36:45Z",
    "Meeting Number": "22/1999",
    "Meeting Date": "1999-11-12T04:37:13Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "အအေးခန်းသိုလှောင်ရံဒ တည်ဆောက်၍ သန့်ရှင်းလတ်ဆတ်သော၊ ငါး၊ ပုစွန်များ ပြုပြင်ထုတ်လုပ်ခြင်း။",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 42.6,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "မြို့ရွာနှင့် အိုးအိမ်ဖွံ့ဖြိုးရေး ဦးစီးဌာနပိုင်",
    "Land Area (units not specified in file)": 4046.86,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "အမှတ်-၇၊ ကွင်းကျောင်း ၃-လမ်း၊",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၁၊ မြေတိုင်းရပ်ကွက် အမှတ်-၆၄၊ စက်မှုဇုံ-၃၊",
  },
  {
    ID: 2755,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဇော်လင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myeik Zenith Industrial Co., ltd",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "MaNaTha-433-2000",
    "Permit Date": "2000-10-06T05:10:45Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "တန်-၁၆၀ ဆန့် အအေးခန်း သိုလှောင်ရုံ တည်ဆောက်၍ သန့်ရှင်း လတ်ဆတ်သော ငါး၊ ပုစွန်များ ပြုပြင် ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 36.7,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "၅၆၊ ဘူတာရုံလမ်း၊ သမိုင်း၊",
    "Organization Address": "",
    "Investment Permitted Address":
      "ငါးလုပ်ငန်းဦးစီးဌာန ပိုင်၊ ကမ်းနား၊ အင်းစိန်မြို့နယ်",
  },
  {
    ID: 2757,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်သက်မန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Shwe Yamone Manufacturing Co., Ltd",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "MaNaTha-537-2002",
    "Permit Date": "2002-02-15T06:19:17Z",
    "Meeting Number": "2-2002",
    "Meeting Date": "2002-02-07T06:21:52Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "တန်-၂၅၀ ဆန့်၊ ငါး၊ ပုဇွန် အအေးခန်း၊ စက်ရုံလုပ်ငန်း၊",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 229,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "မြို့ရွာနှင့် အိုးအိမ်ဦးစီးဌာန",
    "Land Area (units not specified in file)": 8093.72,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "၈၄၊ သုနန္ဒာလမ်း၊ ရတနာကွန်းရိပ်သာ၊",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၇၄-ခ၊ ဆိပ်ကမ်းသာလမ်း၊ စက်မှုဇုန်-၄၊ ",
  },
  {
    ID: 2759,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "ဦးဆောင်ညွှန်ကြားရေးမှူး၊မြန်မာ့ရေလုပ်ငန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Seafooda Ltd.",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "97/1994",
    "Permit Date": "1994-03-23T06:49:16Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "Procurement, Processing, Handing, Storage, Transporting and Marketinf of Aqua & Marine Produsts",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 47.91,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "အအေးခန်းသိုလှောင်ရုံဝင်း၊ဆင်မင်းလမ်း၊ ",
    "Organization Address": "",
    "Investment Permitted Address": "အင်းစိန်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး။",
  },
  {
    ID: 2762,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Myanmar- Segye Intetnational ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar- Segye International Ltd.",
    "Financial Year From": 1889,
    "Financial Year To": 1890,
    "Permit Number": "019/1990",
    "Permit Date": "1990-03-28T08:24:47Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 5.635,
    "Total Amount Of Capital (in Millions)": 5.635,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "Singapore",
    "Organization Address": "",
    "Investment Permitted Address": "PyinMaBin , Yangon",
  },
  {
    ID: 2763,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Myanmar Andes Corporation Limited",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Andes Corporation Limited",
    "Financial Year From": 1990,
    "Financial Year To": 1991,
    "Permit Number": "023/1990",
    "Permit Date": "1990-05-03T08:31:21Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 5.345,
    "Total Amount Of Capital (in Millions)": 5.345,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "Hong Kong",
    "Organization Address": "",
    "Investment Permitted Address": "Yangon",
  },
  {
    ID: 2765,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Myanmar Songserm No. 1 Co., Ltd.",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Songserm No.1 Co., Ltd.",
    "Financial Year From": 1990,
    "Financial Year To": 1991,
    "Permit Number": "028/1990",
    "Permit Date": "1990-06-25T08:52:45Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သကြား၊ ဘီယာနှင့် စိုက်ပျိုးမြေများအတွက် ကုန်ကြမ်းပစ္စည်းများ ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 54.167,
    "Total Amount Of Capital (in Millions)": 54.167,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Thailand",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address": "Thailand",
    "Organization Address": "",
    "Investment Permitted Address": "Yangon",
  },
  {
    ID: 2766,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Myanmar Singapura Uninted Tobacco Co., Ltd.",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Singapura Uninted Tobacco Co., Ltd.",
    "Financial Year From": 1990,
    "Financial Year To": 1991,
    "Permit Number": "035/1990",
    "Permit Date": "1990-09-27T08:58:04Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "စီးကရက်နှင့် ဆေးရွက်ကြီးထုတ်ကုန်များ ထုတ်လုပ်ခြင်းနှင့် ဖြန့်ဖြူးရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 4.859,
    "Total Amount Of Capital (in Millions)": 4.859,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "Singapore",
    "Organization Address": "",
    "Investment Permitted Address": "Dagon Township, Yangon ",
  },
  {
    ID: 2767,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Myanmar Rice Engineering Co., Ltd.",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Rice Engineering Co., Ltd.",
    "Financial Year From": 1991,
    "Financial Year To": 1992,
    "Permit Number": "043/1991",
    "Permit Date": "1991-06-03T09:07:04Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ဆန်စက်တွင်အသုံးပြုသည့် စက်ပစ္စည်းနှင့်အခြားအစိတ်အပိုင်းများ ထုတ်လုပ်ခြင်းနှင့် ဖြန့်ဖြူးရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.619,
    "Total Amount Of Capital (in Millions)": 1.619,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "South Korea",
    "Organization Address": "",
    "Investment Permitted Address": "Dawbon Township, Yangon Region",
  },
  {
    ID: 2768,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Zaw Win",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Seagram Myanmar Company Limited",
    "Financial Year From": 18,
    "Financial Year To": 19,
    "Permit Number": "147/2019",
    "Permit Date": "2019-04-08T09:10:35Z",
    "Meeting Number": "5/2019",
    "Meeting Date": "2019-04-05T09:10:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Distribution of Spirits Including High Class Whiskey ",
    "Amount Of Foreign Capital USD (in Millions)": 14.7,
    "Total Amount Of Capital (in Millions)": 18.38,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "U Zaw Win",
    "Land Area (units not specified in file)": 18.983,
    "Lease Term": 50,
    "Annual Lease Fee": 18.98,
    "Land Use Premium": null,
    "Number Of Local Employees": 806,
    "Number Of Foreign Employees": 802,
    Status: "Approved",
    "Investor Address":
      "No. 295, Room. A-4, Myoma Kyaung Road, Pyay Road East Ward, ",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 138, 139, 142, 143, 144, Thardukan Industrial Zone, ",
  },
  {
    ID: 2769,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Myanmar Plastic Co., Ltd.",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Plastic Co., Ltd.",
    "Financial Year From": 1991,
    "Financial Year To": 1992,
    "Permit Number": "045/1991",
    "Permit Date": "1991-06-18T09:13:17Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ပလတ်စတစ်ပစ္စည်းများ ထုတ်လုပ်ခြင်းနှင့် ဖြန့်ဖြူးရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.865,
    "Total Amount Of Capital (in Millions)": 1.865,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Thailand",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "Thailand",
    "Organization Address": "",
    "Investment Permitted Address": "Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 2770,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Myanmar Winner Garment Manufacturing Co., Ltd.",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Winner Garment Manufacturing Co., Ltd.",
    "Financial Year From": 1991,
    "Financial Year To": 1992,
    "Permit Number": "046/1992 ",
    "Permit Date": "1992-03-05T09:18:13Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.734,
    "Total Amount Of Capital (in Millions)": 1.734,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "Singapore",
    "Organization Address": "",
    "Investment Permitted Address": "Mayangone Township, Yangon Region",
  },
  {
    ID: 2771,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor":
      "ရွှေဇင်အေးအထည်ချုပ်နှင့် အထွေထွေရောင်းဝယ်ရေး သမဝါယမအသင်းလီမိတက်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ရွှေဇင်အေးအထည်ချုပ်နှင့် အထွေထွေရောင်းဝယ်ရေး သမဝါယမအသင်းလီမိတက်",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "002/95",
    "Permit Date": "1995-01-31T09:29:14Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အသင့်ချုပ်ပြီးအထည်များထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.94,
    "Total Amount Of Capital (in Millions)": 27,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "အထည်စက်ရုံအမှတ် ၁၀၊ ရုံခွဲ ၄ ၊ မေဓါဝီလမ်း၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "အထည်စက်ရုံအမှတ် ၁၀၊ ရုံခွဲ ၄ ၊ မေဓါဝီလမ်း၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 2772,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "သီလဝါစက်မှုလုပ်ငန်းလီမိတက်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "သီလဝါစက်မှုလုပ်ငန်းလီမိတက်",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "026/96",
    "Permit Date": "1996-06-28T09:33:12Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ဘိလပ်မြေအုတ်ကြွပ်နှင့် ခေါင်အုပ်များထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.49,
    "Total Amount Of Capital (in Millions)": 45.27,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "သန္ဓေပင်ကျေးရွာ၊ မှော်ဘီမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "သန္ဓေပင်ကျေးရွာ၊ မှော်ဘီမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2773,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "အပိုလိုဂါးမင့်ကုမ္ပဏီလီမိတက်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "အပိုလိုဂါးမင့်ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "030/96",
    "Permit Date": "1996-07-22T09:36:44Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အသင့်ချုပ်ပြီးအထည်များထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 6.14,
    "Total Amount Of Capital (in Millions)": 20,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "မြေကွက်အမှတ် ၄၁ ၊ လှိုင်သာယာစက်မှုဇုန် ၁၊ ကနောင်မင်းသားကြီးလမ်း၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၄၁ ၊ လှိုင်သာယာစက်မှုဇုန် ၁၊ ကနောင်မင်းသားကြီးလမ်း၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2774,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "မြန်မာမင်းဒွန်းဂါးမင့်မင်နျူဖက်ချားရင်းကုမ္ပဏီလီမိတက်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "မြန်မာမင်းဒွန်းဂါးမင့်မင်နျူဖက်ချားရင်းကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "038/96",
    "Permit Date": "1996-08-30T09:40:07Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အသင့်ချုပ်ပြီးအထည်များထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.9,
    "Total Amount Of Capital (in Millions)": 28,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "မြေတိုင်းရပ်ကွက်အမှတ် ၂၄၊ ၁၆၂၊ ၁၆၃၊ စက်မှုဇုန်ဒေသ၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေတိုင်းရပ်ကွက်အမှတ် ၂၄၊ ၁၆၂၊ ၁၆၃၊ စက်မှုဇုန်ဒေသ၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2775,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ထရိုင်းဒင့်မြန်မာဂျင်နရယ်ထရိတ်ဒင်းကုမ္ပဏီလီမိတက်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ထရိုင်းဒင့်မြန်မာဂျင်နရယ်ထရိတ်ဒင်းကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "049/96",
    "Permit Date": "1996-11-22T09:44:44Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "အိမ်မိုးသွပ်ပြားများထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 2.2,
    "Total Amount Of Capital (in Millions)": 40.4,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "မြေကွက်အမှတ် ၁၆၁၊၁၆၂၊ မြေတိုင်းအမှတ် ၄၂၊ စက်မှုဒေသ၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၆၁၊၁၆၂၊ မြေတိုင်းအမှတ် ၄၂၊ စက်မှုဒေသ၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2777,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Sanfoco Wood Industries Co.,Ltd.",
    "Financial Year From": 94,
    "Financial Year To": 95,
    "Permit Number": "118/1994",
    "Permit Date": "1994-10-28T09:55:23Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Various types Teak & Hardwood Furniture.",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 111,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address": "Dagon-Myothist(South)",
  },
  {
    ID: 2779,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Yangon Wood INDS Ltd.",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "111/1994",
    "Permit Date": "1994-07-25T10:04:31Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Various types of Teak & Hardwood Furniture.",
    "Amount Of Foreign Capital USD (in Millions)": 4,
    "Total Amount Of Capital (in Millions)": 4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Netherlands",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address": "Hlaing , Yangon\n",
  },
  {
    ID: 2781,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar SLP Wood Co.,Ltd.",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "357/2001",
    "Permit Date": "2001-01-10T10:13:45Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Wood- Base Industry.",
    "Amount Of Foreign Capital USD (in Millions)": 3.53,
    "Total Amount Of Capital (in Millions)": 3.53,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address": "Yangon Industrial Park, North Okkapala",
  },
  {
    ID: 2782,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.  laurent Scheercousse",
    "Name of Principal Organization": "Red Ink Ltd. ",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Myanmar Peltier Bois Co.,Ltd.",
    "Financial Year From": 2001,
    "Financial Year To": 2002,
    "Permit Number": "369/2002",
    "Permit Date": "2002-01-10T10:17:52Z",
    "Meeting Number": "39/2001",
    "Meeting Date": "2001-11-16T08:00:29Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production of Value Added Forest Production and Marketing of Wood Base Products.",
    "Amount Of Foreign Capital USD (in Millions)": 1.516,
    "Total Amount Of Capital (in Millions)": 1.516,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 15,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "Myanma Timber Enterprise",
    "Land Area (units not specified in file)": 1.24,
    "Lease Term": 15,
    "Annual Lease Fee": 15000,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Kinwick Center, 16th Floor, 32 Hollywood Road, Hong Kong",
    "Organization Address":
      "Sulte 1-3, 16th Floor, Kinwick Center,  32 Hollywood Road, Hong Kong",
    "Investment Permitted Address":
      "Plot No.(WI-4), Watayar Industrial Estate, Yangon",
  },
  {
    ID: 2783,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Aung Gyi",
    "Name of Principal Organization": "Global Star Company Limited",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Global Woodcraft Industries Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "634/2013",
    "Permit Date": "2013-11-07T10:31:02Z",
    "Meeting Number": "26/2013",
    "Meeting Date": "2013-10-02T10:02:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "(Manufacturing and Marketing of Veneer and Plywood)",
    "Amount Of Foreign Capital USD (in Millions)": 7.283,
    "Total Amount Of Capital (in Millions)": 14.57,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 4,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "U Win Aung, Daw Moe Mya Mya",
    "Land Area (units not specified in file)": 6.606,
    "Lease Term": 15,
    "Annual Lease Fee": 133640,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "19, Thurane Yeikmon Estate, Nyaungsi Yaekan Street, Block 2, Hlaing Township, Yangon",
    "Organization Address":
      "No.2, Bayint Naung Main Road, Ywama Curve, Block-2, Hlaing Township , Yangon",
    "Investment Permitted Address": "Yangon",
  },
  {
    ID: 2785,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Daw Khin Aye Win",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Science and Tech International Myanmar University Co., Ltd.",
    "Financial Year From": 0,
    "Financial Year To": 0,
    "Permit Number": "106/18",
    "Permit Date": "2018-08-27T03:04:14Z",
    "Meeting Number": "13/2018",
    "Meeting Date": "2018-08-25T03:05:58Z",
    Sector: "",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 0,
    "Currency Of Total Amount": "",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "",
    "Form Of Investment": "",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "NO. (36/A), PYAY ROAD, 7 1/2 MILE, MAYANGONE  TOWNSHIP, YANGON ",
    "Organization Address": "",
    "Investment Permitted Address":
      "NO. 605, MAHARTHUKHITAR ROAD, PLOT NO. 344/B, MYAY TAING BLOCK NO. 6 D 14, 15, 16, EAST GYOGONE WARD, INSEIN TOWNSHIP, YANGON REGION AND NO. MA (23), MYOTHIT WARD NO. 1, CHANMYATHAZI TOWNSHIP, MANDALAY REGION ",
  },
  {
    ID: 2786,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Nay Min Han",
    "Name of Principal Organization": "Eastern Nova Holdings Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Eastern Nova Logistics Co., Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "136/19",
    "Permit Date": "2019-01-14T03:43:39Z",
    "Meeting Number": "1/2019",
    "Meeting Date": "2019-01-11T03:44:01Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Warehousing and Logistics Services",
    "Amount Of Foreign Capital USD (in Millions)": 10.5,
    "Total Amount Of Capital (in Millions)": 15,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "MK Co., Ltd.",
    "Land Area (units not specified in file)": 12.981,
    "Lease Term": 10,
    "Annual Lease Fee": 0.92,
    "Land Use Premium": null,
    "Number Of Local Employees": 126,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "ROOM NO. 301, NO.23, MYAY NU STREET, MYAYNIGONE (NORTH) WARD, SANCHAUNG TOWNSHIP, YANGON",
    "Organization Address": "21, B Duxton Hill, Singapore (089604)",
    "Investment Permitted Address":
      "PLOT NO. 245, 246, 247, YANGON INDUSTRIAL ZONE, MINGALARDON TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2787,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးသန့်ဇင်ထွန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ရွှေခြင်္သေ့အင်တာနေရှင်နယ်ဟိုးလ်ဒင်းကုမ္ပဏီလီမိတက်(Shwe Chinthe International Holding Co.,Ltd)",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "MaNaTha-052/96",
    "Permit Date": "1996-12-18T03:44:48Z",
    "Meeting Number": "18/96",
    "Meeting Date": "1996-11-29T03:40:58Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "ပရိဘောဂထုတ်လုပ်ရောင်းချမှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 12.25,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်ခင်ရင်၊ ဗိုလ်ကြီးတိုးတက်၊ ဗိုလ်ကြီးမျိုးထက်၊ ဦးဖြိုးဆက်",
    "Land Area (units not specified in file)": 1.28,
    "Lease Term": 20,
    "Annual Lease Fee": 0.76,
    "Land Use Premium": null,
    "Number Of Local Employees": 54,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "အမှတ်(၅)မေခလမ်း၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်၂၄၈မှ၂၅၅အထိ၊ ပုလဲမြို့သစ်၊ မင်္ဂလာဒုံမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2790,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ယုံဖတ်အပြည်ပြည်ဆိုင်ရာ ကုမ္ပဏီလီမိတက်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ယုံဖတ်အပြည်ပြည်ဆိုင်ရာ ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "Manatha 055/97",
    "Permit Date": "1997-01-03T05:52:18Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီဖိနပ်အမျိုးမျိုးချုပ်လုပ်သည့်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.12,
    "Total Amount Of Capital (in Millions)": 20.73,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "မြေကွက်အမှတ် ၁၆၊ မြေတိုင်းအမှတ် ၄၊ စက်မှုလက်မှုဇုံ၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၆၊ မြေတိုင်းအမှတ် ၄၊ စက်မှုလက်မှုဇုံ၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2792,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "မွန်းကရဲ(စ်) ကုမ္ပဏီလီမိတက်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "မွန်းကရဲ(စ်) ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "Manatha - 147/98",
    "Permit Date": "1998-07-03T05:59:10Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီအထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.9,
    "Total Amount Of Capital (in Millions)": 27.4,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "မြေကွက်အမှတ် ၅၊ လှိုင်သာယာစက်မှုဇုန် ၃၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၅၊ လှိုင်သာယာစက်မှုဇုန် ၃၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2794,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "စူပါဂါးမင့်န်ကုမ္ပဏီလီမိတက်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "စူပါဂါးမင့်န်ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "Manatha - 155/98",
    "Permit Date": "1998-07-15T07:00:26Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အသင့်ချုပ်ပြီးအထည်များထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.41,
    "Total Amount Of Capital (in Millions)": 13.45,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "အကွက် ၁၂၈၊ မြေတိုင်းရပ်ကွက် ၄၂၊ ရွှေပြည်သာစက်မှုဇုန်၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "အကွက် ၁၂၈၊ မြေတိုင်းရပ်ကွက် ၄၂၊ ရွှေပြည်သာစက်မှုဇုန်၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2795,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ခင်ချိုကုမ္ပဏီလီမိတက်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ခင်ချိုကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "Manatha- 159/98",
    "Permit Date": "1998-07-31T07:05:25Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ ဂျာကင်အမျိုးမျိုးထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.83,
    "Total Amount Of Capital (in Millions)": 25,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "အမှတ် ၁၁၆၈၊ အကွက်အမှတ် ၂၊ လှိုင်သာယာစက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ် ၁၁၆၈၊ အကွက်အမှတ် ၂၊ လှိုင်သာယာစက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2797,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "အမ်ဂျီအမ်အင်ဒတ်(စ်)ထရီ(စ်)လီမိတက်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "အမ်ဂျီအမ်အင်ဒတ်(စ်)ထရီ(စ်)လီမိတက်",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "Manatha- 220/99",
    "Permit Date": "1999-01-28T07:20:14Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အမှတ်တံဆိပ်ဓါတ်ခဲအမျိုးမျိုးထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 5.46,
    "Total Amount Of Capital (in Millions)": 176.76,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "မြေကွက်အမှတ် ၃၅၊ စက်မှုဇုံ ၁၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၃၅၊ စက်မှုဇုံ ၁၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2798,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "လပ်ကီးဟန်း(ဒ်)ဂါးမဲန့်လီမိတက်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "လပ်ကီးဟန်း(ဒ်)ဂါးမဲန့်လီမိတက်",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "Manatha- 232/99",
    "Permit Date": "1999-02-26T07:24:38Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီအထည်အမျိုးမျိုးချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 37,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "မြေကွက်အမှတ် ၄၆-က၊ စက်မှုဇုန် ၁၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၄၆-က၊ စက်မှုဇုန် ၁၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2800,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ထွဋ်ကျော်အင်တာပရိုက်(စ်) လီမိတက်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ထွဋ်ကျော်အင်တာပရိုက်(စ်) လီမိတက်",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "Manatha- 236/99",
    "Permit Date": "1999-03-23T07:37:58Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီပလပ်စတစ်အမျိုးမျိုးထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.66,
    "Total Amount Of Capital (in Millions)": 59.96,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "မြေကွက်အမှတ် ၂၈၊ စက်မှုဇုံ ၁ ၊ ဒဂုံမြို့သစ် ဆိပ်ကမ်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၂၈၊ စက်မှုဇုံ ၁ ၊ ဒဂုံမြို့သစ် ဆိပ်ကမ်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2801,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "အရှေ့တိုင်းအထည်ချုပ်ကုမ္ပဏီလီမိတက်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "အရှေ့တိုင်းအထည်ချုပ်ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "Manatha- 260/99",
    "Permit Date": "1999-06-15T07:48:40Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "လက်ခစားထုတ်လုပ်မှုစနစ် (CMP) ဖြင့် အသင့်ချုပ်ပြီးအထည်များထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.09,
    "Total Amount Of Capital (in Millions)": 30,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "မြေတိုင်းရပ်ကွက်အမှတ် ၂၃၊ မြေကွက်အမှတ် ၇၄၊ ၇၆၊ ဒဂုံတောင်စက်မှုဇုန် ၁၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေတိုင်းရပ်ကွက်အမှတ် ၂၃၊ မြေကွက်အမှတ် ၇၄၊ ၇၆၊ ဒဂုံတောင်စက်မှုဇုန် ၁၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2802,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor":
      "ရန်ကုန်ထိုက်ရှန်းအီကောနောမစ်(ခ်) ဒီဗလော့မဲန့်(တ်)ကုမ္ပဏီလီမိတက်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ရန်ကုန်ထိုက်ရှန်းအီကောနောမစ်(ခ်) ဒီဗလော့မဲန့်(တ်)ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "Manatha- 261/99",
    "Permit Date": "1999-06-17T07:53:25Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "ဓါတ်ခဲထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": 2.47,
    "Total Amount Of Capital (in Millions)": 34.82,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "မြေကွက်အမှတ် ၃၅၊ မြေတိုင်းရပ်ကွက်အမှတ် အပိုင်း ၁၊ စက်မှုဇုံ၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၃၅၊ မြေတိုင်းရပ်ကွက်အမှတ် အပိုင်း ၁၊ စက်မှုဇုံ၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2803,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "အေးကိုမိသားစုလီမိတက်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "အေးကိုမိသားစုလီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "Manatha- 296/99",
    "Permit Date": "1999-10-29T07:58:01Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "ပလပ်စတစ်လူသုံးကုန်ပစ္စည်းထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.3,
    "Total Amount Of Capital (in Millions)": 37.8,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "မြေကွက်အမှတ် ၄၉၂၊ စက်မှုဇုံ ၁၊ ဒဂုံမြို့သစ်တောင်ပိုင်းစက်မှုဇုံ၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၄၉၂၊ စက်မှုဇုံ ၁၊ ဒဂုံမြို့သစ်တောင်ပိုင်းစက်မှုဇုံ၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2804,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "အုန်းမိသားစုကုမ္ပဏီလီမိတက်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "အုန်းမိသားစုကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "Manatha- 301/99",
    "Permit Date": "1999-10-29T08:01:25Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "လက်ခစားထုတ်လုပ်မှုစနစ် (CMP) အရ အထည်အမျိုးမျိုးချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.25,
    "Total Amount Of Capital (in Millions)": 58.5,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "မြေကွက်အမှတ် ၇၇၊ လှိုင်သာယာစက်မှုဇုန် အပိုင်း ၄၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၇၇၊ လှိုင်သာယာစက်မှုဇုန် အပိုင်း ၄၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2805,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "သိန်းငှက်အပြည်ပြည်ဆိုင်ရာစက်မှုလီမိတက်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "သိန်းငှက်အပြည်ပြည်ဆိုင်ရာစက်မှုလီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "Manatha- 318/99",
    "Permit Date": "1999-12-13T08:04:24Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အသင့်ချုပ်ပြီး အထည်များထုတ်လုပ်သည့်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.31,
    "Total Amount Of Capital (in Millions)": 28.55,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "မြေကွက်အမှတ် ၁၆၊ မြေတိုင်းရပ်ကွက်အမှတ် ၄၂၊ စက်မှုဇုန်၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၆၊ မြေတိုင်းရပ်ကွက်အမှတ် ၄၂၊ စက်မှုဇုန်၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2806,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr. Thomas Joseph Lim Kim Guan",
    "Name of Principal Organization": "Wilmar Investment Holdings Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Wilmar Myanmar Logistics Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "003/17",
    "Permit Date": "2017-07-17T07:50:32Z",
    "Meeting Number": "9/2017",
    "Meeting Date": "2017-06-16T07:57:35Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Construction and Operation of Storage Tanks, Terminals, Warehouses and other Storage Facilities for Edible Oils and its Related Products",
    "Amount Of Foreign Capital USD (in Millions)": 1.679,
    "Total Amount Of Capital (in Millions)": 6.997,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Wilmar Myanmar Port Terminals (Thilawa) Limited",
    "Land Area (units not specified in file)": 6.622,
    "Lease Term": 50,
    "Annual Lease Fee": 0.134,
    "Land Use Premium": null,
    "Number Of Local Employees": 28,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "56 Neil Road, Singapore 088830",
    "Organization Address": "56 Neil Road, Singapore 088830",
    "Investment Permitted Address":
      "Thilawa Port area, Plot No. 20 & 21 and the Parcel of Land Adjoining Thilawa Port area Plot No. 21 & 22, Yangon Region",
  },
  {
    ID: 2808,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "American International Partners Limited",
    "Name of Principal Organization": "MYANMAR  STRATEGIC  HOLDINGS LTD",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar":
      "             AMERICAN INTERNATIONAL PARTNERS LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "152/2019",
    "Permit Date": "2019-04-08T08:26:08Z",
    "Meeting Number": "5/2019",
    "Meeting Date": "2019-04-05T08:26:18Z",
    Sector: "Other Services",
    "Type Of Investment Business": "PRIVATE INTERNATIONAL SCHOOL(S)",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "Lucky One Co.,Ltd.",
    "Land Area (units not specified in file)": 0.502,
    "Lease Term": 10,
    "Annual Lease Fee": 480000,
    "Land Use Premium": null,
    "Number Of Local Employees": 37,
    "Number Of Foreign Employees": 11,
    Status: "Submitted",
    "Investor Address":
      "AUNG ZEYA LANE 2, 27B-1, SHWE TAUNG KYAR ROAD (1), BAHAN TOWNSHIP, YANGON ",
    "Organization Address":
      "80 RAFFLES PLACE  #  32-01 UOB  PLAZA, SINGAPORE (048624)",
    "Investment Permitted Address":
      "NO.(2/KA), PLOT NO. A1, B1, G, BUILDING 2, YANGON-INSEIN ROAD, WARD - 9, HLAING TOWNSHIP, YANGON REGION",
  },
  {
    ID: 2809,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr. SM Abul Kalam Azad",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "TTFN Express Limited",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "046/17",
    "Permit Date": "2017-08-20T08:44:38Z",
    "Meeting Number": "11/2017",
    "Meeting Date": "2017-08-07T08:45:07Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Logistics and Warehousing Services",
    "Amount Of Foreign Capital USD (in Millions)": 1.5,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Bangladesh",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myint Oo",
    "Land Area (units not specified in file)": 2.722,
    "Lease Term": 30,
    "Annual Lease Fee": 0.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 92,
    "Number Of Foreign Employees": 2,
    Status: "Approved",
    "Investor Address":
      "VILL-AREPARA, P.O-N.S TOWN, THANA-KOTOWALI, JESSORE, BANGLADESH",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.518, MYAY TAING BLOCK NO.23, INDUSTRIAL ZONE (1), DAGON MYOTHIT (SOUTH) TOWNSHIP, YANGON  REGION",
  },
  {
    ID: 2810,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Daw Poht Poht Kyi",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Imperial Investment Capital Co., Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "117/18",
    "Permit Date": "2018-10-15T08:52:55Z",
    "Meeting Number": "17/2018",
    "Meeting Date": "2018-10-12T08:53:16Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Myanmar Imperial University",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 500,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Soe Oo @ U Zaw Hein Oo",
    "Land Area (units not specified in file)": 0.586,
    "Lease Term": 10,
    "Annual Lease Fee": 108,
    "Land Use Premium": null,
    "Number Of Local Employees": 25,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "no.(62/C), Inya Road, Ward(10), Kamaryut Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.1, Plot No.6, Myay Taing Block No.64, Zay Myauk Street, Phayar Gyi Ward, Dagon Township, Yangon",
  },
  {
    ID: 2812,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Zaw Zaw (kha) U Phoe Zaw",
    "Name of Principal Organization": "Max (Myanmar) Services Company Limited",
    "Place of Incorporation": "Yangon",
    "Company Name In Myanmar": "Max (Myanmar) Services Company Limited",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "878/2013",
    "Permit Date": "2013-01-16T09:12:55Z",
    "Meeting Number": "3/2013",
    "Meeting Date": "2013-01-16T09:13:20Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "construction of oil tanks, Importation, Storage Services of fuel on BOT basis owned by Myanmar Port Authority",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 20838.56,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Myanmar Port Authority ",
    "Land Area (units not specified in file)": 24.71,
    "Lease Term": 30,
    "Annual Lease Fee": 160.32,
    "Land Use Premium": 370.65,
    "Number Of Local Employees": 75,
    "Number Of Foreign Employees": 2,
    Status: "Approved",
    "Investor Address":
      "No(9), Inya Revenue Road, Ward (10), Ma Yan Gone Township, Yangon.",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.(15/16)(c), Thilawa Port Region, Thanlyin-Kyauktan Region, Yangon",
  },
  {
    ID: 2813,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Daw Zar Chi Tin",
    "Name of Principal Organization": "First Myanmar Investment Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "FMIDecaux Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "045/2017",
    "Permit Date": "2017-12-30T09:36:46Z",
    "Meeting Number": "17/2017",
    "Meeting Date": "2017-12-22T09:37:11Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "DESIGN, FABRICATION, INSTALLATION, MAINTENANCE AND OPERATION OF STREET  FURNITURE  ITEMS AND  OPERATION  OF ADVERTISEMENT  ON  THOSE  ITEMS IN THE CITY OF YANGON\t",
    "Amount Of Foreign Capital USD (in Millions)": 7.8,
    "Total Amount Of Capital (in Millions)": 13,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "YCDC",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 17,
    "Number Of Foreign Employees": 1,
    Status: "Submitted",
    "Investor Address":
      "1 OFFICE PARK, RAIN TREE DRIVE, PUN HLAING ESTATE, HLAING THARYAR TOWNSHIP, YANGON",
    "Organization Address":
      "FMI CENTER, LEVEL 10, BOGYOKE AUNG SAN ROAD, PABEDAN TOWNSHIP, YANGON",
    "Investment Permitted Address": "YANGON  REGION",
  },
  {
    ID: 2815,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Tun Nwe",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Pyin Nyar Nan Taw Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "093/2018",
    "Permit Date": "2018-03-27T10:16:46Z",
    "Meeting Number": "4/2018",
    "Meeting Date": "2018-03-20T10:18:59Z",
    Sector: "Other Services",
    "Type Of Investment Business": "ပုဂ္ဂလိကအခြေခံပညာအထက်တန်းကျောင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 6517.64,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Myint Myint Kyi",
    "Land Area (units not specified in file)": 0.326,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 213,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်-၁၁၈A/B၊ ကျွန်းရွှေမြိုင်လမ်း၊ ၂၃ ရပ်ကွက်၊ သုဝဏ္ဏ၊  သင်္ဃန်းကျွန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၁/A၊10/ခ)၊ မြေတိုင်း ရပ်ကွက်အမှတ်-၂၄/သုဝဏ္ဏ၊ သံသုမာလမ်း၊ သုဝဏ္ဏအိမ်ရာ၊ သင်္ဃန်းကျွန်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး  ",
  },
  {
    ID: 2823,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "တော်ဝင်မိသားစု ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "MaNaTha-126/98",
    "Permit Date": "1998-03-10T04:09:13Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်ခွဲသားအမျိုးအမျိုးနှင့် သစ်အခြေခံတန်းဖိုးမြှင့်ပစ္စည်းများထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 159,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြန်မာသစ်လုပ်ငန်းပိုင်၊ ဝါတစ်ရာစက်မှုနယ်မြေ၊ ရွှေပြည်သာမြို့နယ်",
  },
  {
    ID: 2824,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ခိုင်လင်းအင်ဒတ်စရီလီမိတက်",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "MaNaTha-148/98",
    "Permit Date": "1998-07-15T04:15:51Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်ခွဲသားအမျိုးမျိုးနှင့်သစ်အခြေခံတန်ဖိုးမြှင့်ပစ္စည်းများထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 86,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "ငါးဆူးတောင်ကျေးရွာ၊ လှည်းကူးမြို့နယ်၊ရန်ကုန်မြို့",
  },
  {
    ID: 2826,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ယဉ်မာမြတ်နိုးကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "MaNaTha-172/98",
    "Permit Date": "1998-09-14T04:23:01Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်အခြေခံစက်မှုလုပ်ငန်း(သစ်အချောထည်များထုတ်လုပ်ဖြန့်ဖြူးခြင်း)",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 35.4,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၂၀/က၊ မြေတိုင်းရပ်ကွက်အမှတ်-၄၂၊ စက်မှုဒေသ၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 2828,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ဂရိတ်ဂလိုရီအင်ဒတ်စထရီ လီမိတက်",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "MaNaTha-223/99",
    "Permit Date": "1999-02-05T04:33:52Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ ခေတ်မီ ပရိဘောဂ အမျိုးအမျိုးထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 81.01,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်-၉၃၊ ဗမာ့ဂုဏ်ရည်လမ်း၊ စက်မှုလက်မှုရပ်ကွက်၊ သာကေတမြို့နယ်၊ ရန်ကုန်",
  },
  {
    ID: 2829,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ပေါက်ရန်အင်ဒတ်စထရီ ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 98,
    "Financial Year To": 99,
    "Permit Number": "MaNaTha-224/99",
    "Permit Date": "1998-02-05T04:42:24Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "သစ်အခြေခံပစ္စည်းများထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 92,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၄၀/၄၃၊ စက်မှုဇုန်-၁၊ ဒဂုံဆိပ်ကမ်းမြို့နယ်၊ ရန်ကုန်",
  },
  {
    ID: 2831,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "မြို့တော်ပရိဘောဂကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "MaNaTha-226/99",
    "Permit Date": "1998-02-11T04:54:19Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်အခြေခံတန်ဖိုးမြှင့်ကုန်ချောပစ္စည်းများထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 100,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြန်မာ့သစ်လုပ်ငန်းပိုင်၊ ဝါတစ်ရာစက်မှုနယ်မြေ၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်",
  },
  {
    ID: 2832,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "မြန်မာဆန်တဝါကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "MaNaTha-230/99",
    "Permit Date": "1999-02-26T04:59:30Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အိမ်သုံးကုန်ပစ္စည်းများ၊ လက်မှုအနုပညာပစ္စည်းများနှင့် ပရိဘောဂများထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 20,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "သံလျင်တံတားအနီး၊ မြန်မာ့မီးရထားပိုင်မြေ၊ သာကေတမြို့နယ်၊ ရန်ကုန်",
  },
  {
    ID: 2834,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "မြန်မာစကိုင်းလင့်(ခ်) အင်ဒတ်(စ်)ထရီလီမိတက်",
    "Financial Year From": 98,
    "Financial Year To": 99,
    "Permit Number": "MaNaTha-231/99",
    "Permit Date": "1999-02-26T05:10:00Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "သစ်အခြေခံကုန်ချောပစ္စည်းများထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 612,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၀၅/က-ခ-ဂ-ဃ-င-စ၊ ဒဂုံမြို့သစ်တောင်ပိုင်း၊ စက်မှုဇုန်အပိုင်း-၁",
  },
  {
    ID: 2837,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Daw The Theint Wah",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myamar Cinematic Co., Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "124/18",
    "Permit Date": "2018-11-08T05:24:17Z",
    "Meeting Number": "18/2018",
    "Meeting Date": "2018-11-02T05:23:52Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Construction of Cinema and Operation of Cinema",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 6109.65,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "Capital Development Limited, Hoang Anh Gia Lai Myanmar Co., Ltd., U Sai Zaw Zaw",
    "Land Area (units not specified in file)": null,
    "Lease Term": 10,
    "Annual Lease Fee": 20.711,
    "Land Use Premium": null,
    "Number Of Local Employees": 90,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "8th Floor, Room No.5, Crystal Tower, Kyun Taw Street, Kamaryut Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "NO.14-C, CAPITAL HYPERMARKET, 4th FLOOR, MINNANDA STREET, DAWBON TOWNSHIP, YANGON REGION, NO. 192, MYANMAR PLAZA, 4th FLOOR, KABARAYE PAGODA ROAD, BAHAN TOWNSHIP, YANGON REGION AND N0. 48, CITY SQUARE SHOPPING CENTER, 4th FLOOR, BOGYOKE AUNG SAN STREET, TAUNGYI TOWNSHIP, SHAN STATE",
  },
  {
    ID: 2838,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "သမာဓိဝု(ဒ်)အင်ဒတ်စထရီကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "MaNaTha-250/99",
    "Permit Date": "1999-05-14T05:28:58Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်အချောထည်ပစ္စည်းများထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 39.2,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၅၇၊ စက်မှုဇုန်-၂၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 2839,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "သမ္မာဆန္ဒစက်မှုလုပ်ငန်းလီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "MaNaTha-264/99",
    "Permit Date": "1998-06-25T05:35:42Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်အခြေခံပစ္စည်းများထုတ်လုပ်ဖြန့်ဖြူးခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 63.31,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေတိုင်းရပ်ကွက်အမှတ်-၄၊ မြေကွက်အမှတ်-၉၊ လှိုင်သာယာစက်မှုဇုန်၊ ရန်ကုန်",
  },
  {
    ID: 2841,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "အာရှသစ် ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "MaNaTha-273/99",
    "Permit Date": "1999-07-23T06:34:50Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "သစ်အခြေခံကုန်ချောပစ္စည်းများထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 32.5,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၂၄၊ စက်မှုဇုန်အပိုင်း-၄၊ လှိုင်သာယာမြို့နယ်၊ရန်ကုန်မြို့",
  },
  {
    ID: 2842,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ရွှေဝါးကုမ္ပဏီလီမိတက်",
    "Financial Year From": 2001,
    "Financial Year To": 2002,
    "Permit Number": "MaNaTha-362/2000",
    "Permit Date": "2000-04-18T06:45:31Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "ဝါးအခြခံပစ္စည်းထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 113.92,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၄၂)မင်းသိဒ္ဓိကျော်စွာလမ်းစက်မှုဇုန်(၂) လှိုင်သာယာ",
  },
  {
    ID: 2843,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဌေးမြင့်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ယုဇနကုမ္ပဏီလီမိတက်",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "၀၉၆/၂၀၁၈",
    "Permit Date": "2018-07-30T06:43:36Z",
    "Meeting Number": "၁၀/၂၀၁၈",
    "Meeting Date": "2018-07-26T06:44:11Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "စားအုန်းဆီနှင့် ဆက်စပ်ပစ္စည်းများ ထုတ်လုပ်ခြင်းနှင့် ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 37800,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးဌေးမြင့်",
    "Land Area (units not specified in file)": 42.517,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 631,
    "Number Of Foreign Employees": 7,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၁၃၀, ရွှေဂုံတိုင်လမ်း၊ ရေတာရှည်ရပ်ကွက်၊ ဗဟန်းမြို့နယ်၊  ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၄၁၄၊ မြေတိုင်းရပ်ကွက်အမှတ်-၂၅၊ ဆိပ်ကမ်းသာလမ်း၊ ရွှေလင်ပန်းစက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 2844,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "မြန်မာပွင့်သစ်စက်မှု ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "MaNaTha-286/99",
    "Permit Date": "1999-08-31T06:53:44Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်ခွဲသားအမျိုးမျိုးနှင့် သစ်အခြေခံတန်ဖိုးမြှင့် ပစ္စည်းများထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 62.75,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "အကွက်အမှတ်-၅၇-၅၈-၅၉-၆၀-၇၂-၇၃-၇၄-၇၅၊ မြေတိုင်းရပ်ကွက်အမှတ်၁၈၊ ရွှေပေါက်ကံစက်မှုဇုန်၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်",
  },
  {
    ID: 2845,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "စိုးသန်းညီအစ်ကိုများကုမ္ပဏီလီမိတက်",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "MaNaTha-410/2000",
    "Permit Date": "2000-07-20T06:54:08Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်အခြေခံတန်ဖိုးမြင့်ပစ္စည်းများထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 78,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၈၉)ဘီ(၂)စက်မှုဇုန်(၁)လှိုင်သာယာမြို့နယ်။",
  },
  {
    ID: 2846,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ထူးကူးသန်းရောင်းဝယ်ရေးကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "MaNaTha-290/99",
    "Permit Date": "1999-09-10T07:00:44Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်အခြေခံကုန်ချောများထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 109,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေတိုင်းအမှတ်-၅၉မှ၆၂၊ မြန်မာသစ်လုပ်ငန်း၊ ဝါးတစ်ရာစက်မှုဇုန်၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 2847,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Thu Rein Aung",
    "Name of Principal Organization":
      "Thuriya Energy Depot Management Company Limited",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Thuriya Energy Depot Management Company Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "908/2013",
    "Permit Date": "2013-05-14T06:48:38Z",
    "Meeting Number": "14/2013",
    "Meeting Date": "2013-05-10T06:49:12Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Construction of Fuel Tanks and Fuel Storage and Distribution Services on BOT Basis",
    "Amount Of Foreign Capital USD (in Millions)": 6.51,
    "Total Amount Of Capital (in Millions)": 17772.933,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Myanma Port Authority",
    "Land Area (units not specified in file)": 24.71,
    "Lease Term": 30,
    "Annual Lease Fee": 160.281,
    "Land Use Premium": 370.65,
    "Number Of Local Employees": 50,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "No,105, University Avenue Road, Ward (10), Kamayut Township, Yangon.",
    "Organization Address": "",
    "Investment Permitted Address":
      "plot No(17,18)(C), Thilawa Port Terminal, Thanlyin-Kyauktan Region, Yangon",
  },
  {
    ID: 2848,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "မေမြတ်နိုးသူစက်မှုလုပ်ငန်းကုမ္ပဏီလီမိတက်",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "MaNaTha-424/2000",
    "Permit Date": "2000-08-31T07:06:21Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်ခွဲသားအမျိုးမျိုးနှင့်သစ်အခြေခံတန်ဖိုးမြင့်ပစ္စည်းများထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 60.27,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၉-၁၀)မြေတိုင်းရပ်ကွက်အမှတ်(၁၈)ရွှေပေါက်ကံ၊စက်မှုဇုန်၊မြောက်ဉက္ကလာပမြို့နယ်။",
  },
  {
    ID: 2851,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ရွှေသစ်စက်မှုလုပ်ငန်းများကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "MaNaTha-304/99",
    "Permit Date": "1999-11-19T07:16:32Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီသစ်အချောထည်ပစ္စည်းထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 66.64,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၆၃၊ စက်မှုဇုန်-၁၊ ဒဂုံဆိပ်ကမ်းမြို့နယ်၊ ရန်ကုန်",
  },
  {
    ID: 2852,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ဟိန်းစိုးကုမ္ပဏီလီမိတက်",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "MaNaTha-483/2001",
    "Permit Date": "2001-03-18T07:22:05Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်အခြေခံတန်ဖိုးမြင့်ပစ္စည်းများထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 90,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၅၄)မြေတိုင်းရပ်ကွက်(၆၄-စက်မှု)ရွှေပြည်သာစက်မှုဇုန်။",
  },
  {
    ID: 2854,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ခေတ်သစ် သစ်အခြေခံစက်မှုလုပ်ငန်းလီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "MaNaTha-313/99",
    "Permit Date": "1999-12-13T07:27:29Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "သစ်အခြေခံပစ္စည်းများ ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 44.3,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၄၅-၄၆၊ မြေတိုင်းအမှတ်၅၊ လှိုင်သာယာစက်မှုဇုန်၊ ရန်ကုန်",
  },
  {
    ID: 2857,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "မြန်မာသစ်သားထည်စက်မှုလီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "MaNaTha-348/2000",
    "Permit Date": "2000-03-09T07:46:53Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်ခွဲသားအမျိုးမျိုးနှင့် သစ်အခြေခံတန်ဖိုးမြှင့်ပစ္စည်းများထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 133.5,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်၁၆၃-၁၆၄၊ မြေတိုင်းရပ်ကွက်၄၂၊ စက်မှုဇုန် ၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်",
  },
  {
    ID: 2859,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "​ရွှေမဲစက်မှုကုမ္ပဏီလီမိတက်",
    "Financial Year From": 2001,
    "Financial Year To": 2002,
    "Permit Number": "MaNaTha-486/2001",
    "Permit Date": "2001-04-21T07:54:53Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သစ်အခြေခံစက်မှုလုပ်ငန်း(သစ်အချောထည်များထုတ်လုပ်ဖြန့်ဖြူးခြင်း)",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 56,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၅၄) မြေတိုင်းရပ်ကွက်(၆၄-စက်မှု)ရွှေပြည်သာမြို့နယ်",
  },
  {
    ID: 2870,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Zaw Naing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Shwe Taung Energy Services Company Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "909/2013",
    "Permit Date": "2013-05-14T09:19:18Z",
    "Meeting Number": "14/2013",
    "Meeting Date": "2013-05-10T09:19:33Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Construction of Jetty for Loading and Uploading of Fuel and Fuel Tanks and Fuel Storage and Distribution Services on BOT Basis",
    "Amount Of Foreign Capital USD (in Millions)": 6.35,
    "Total Amount Of Capital (in Millions)": 12305.15,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Myanma Port Authority",
    "Land Area (units not specified in file)": null,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 83,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Ahlone Tower, River View Garden Housing , Strand Road, Ahlone Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No-1,2(C), Thilawa Port Area, Thanlyin-Kyauktan Area, Yangon Region, area 24.71 acres, owned by Myanma Port Authority",
  },
  {
    ID: 2876,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Bennett Neo",
    "Name of Principal Organization": "APBM PTE LTD",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "APB Alliance Brewery Company Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "580/2013",
    "Permit Date": "2013-05-14T06:33:33Z",
    "Meeting Number": "14/2013",
    "Meeting Date": "2013-05-10T06:33:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Beer, Cider, non-alcoholic beverages and related products",
    "Amount Of Foreign Capital USD (in Millions)": 30.8,
    "Total Amount Of Capital (in Millions)": 54,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "A&A International Company Limited",
    "Land Area (units not specified in file)": 24.86,
    "Lease Term": 30,
    "Annual Lease Fee": 2,
    "Land Use Premium": null,
    "Number Of Local Employees": 29,
    "Number Of Foreign Employees": 1,
    Status: "Rejected",
    "Investor Address": "61,Jalan Remaja, Singapore,668715",
    "Organization Address": "459, Jalan Ahmad Ibrahim\nSingapore,639934",
    "Investment Permitted Address":
      "Plot No.560(C), No. 73+74/2,77/2,78/1,72/1,77/1, Tawywa Kwin, Leikpoke Village, Hmawbi Township, Yangon Region",
  },
  {
    ID: 2877,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Aye Aye Sein",
    "Name of Principal Organization": "Myat Myint Mo Co., Ltd. ",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Myat Myint Mo Co., Ltd. ",
    "Financial Year From": 97,
    "Financial Year To": 98,
    "Permit Number": "Ma Na Tha 092/97",
    "Permit Date": "1997-10-20T06:35:21Z",
    "Meeting Number": "15/97",
    "Meeting Date": "1997-09-12T06:48:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      " အသင့်သုံးနိုင်သော 3 in 1 Instant Coffee Mix ထုတ်လုပ်ခြင်း လုပ် ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 20.69,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Aye Aye Sein",
    "Land Area (units not specified in file)": 0.696,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 38,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၁၄/၃၊ စဉ့်အိုးတန်းလမ်း၊ လသာမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address":
      "ရွှေပြည်သာမြို့နယ်၊ စက်မှုဒေသ၊ မြေတိုင်းရပ်ကွက် ၄၂၊ မြေကွက်အမှတ် ၁၃၈/က၊ ရန်ကုန်",
    "Investment Permitted Address":
      "ရွှေပြည်သာမြို့နယ်၊ စက်မှုဒေသ၊ မြေတိုင်းရပ်ကွက် ၄၂၊ မြေကွက်အမှတ် ၁၃၈/က၊ ",
  },
  {
    ID: 2881,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Nwe Ni Aye",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Mikko Snack Industry Limited (မီကိုစနက်ခ် အင်ဒတ်စ်ထရီ လီမိတက်)",
    "Financial Year From": 97,
    "Financial Year To": 98,
    "Permit Number": "Ma Na Tha 120/98",
    "Permit Date": "1997-02-25T07:47:28Z",
    "Meeting Number": "1/98",
    "Meeting Date": "1998-01-09T07:48:02Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Mikko အမှတ်တံဆိပ်ဖြင့် Snack Food များဖြစ်သည့် (Prawn Cracker, Pillow Cracker, Prawn Stick) များ ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 61.6,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Nyi Nyi Aung",
    "Land Area (units not specified in file)": 0.751,
    "Lease Term": 50,
    "Annual Lease Fee": 0.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 270,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address": "No 63, Nguwah Road,",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၄၆/က၊ မြေတိုင်းရပ်ကွက်အမှတ် ဇုန် (၁)၊ စက်မှုဇုန်၊ ",
  },
  {
    ID: 2888,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဗိုလ်မှူးကြီး ဝင်းမောင် (ငြိမ်း)",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Myanmar Liwayway Food Industries Limited (မြန်မာလီဝေဝေစားသောက်ကုန်လုပ်ငန်းလီမိတက်)",
    "Financial Year From": 98,
    "Financial Year To": 99,
    "Permit Number": "Ma Na Tha 160/98",
    "Permit Date": "1998-07-31T08:42:36Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "စားသောက်ကုန်ပစ္စည်းများထုတ်လုပ်ခြင်း (မုန့်မျိုးစုံ)",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 345.02,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Myanmar Liwayway Food Industries Limited ",
    "Land Area (units not specified in file)": 11.512,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 385,
    "Number Of Foreign Employees": 6,
    Status: "Monitoring Approved",
    "Investor Address": "No.22, Bawdi Yaikthar Road, Shwe Taungjar 2 Ward, ",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၄၇၄၊ မြေတိုင်းရပ်ကွက်အမှတ် ၂၃၊ စက်မှုဇုန်-၁၊ ဒဂုံမြို့သစ်တောင်ပိုင်းမြို့နယ်",
  },
  {
    ID: 2889,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Zin Win",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanbisco Food Industries Co., Ltd. ",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "Ma Na Tha- 244/99",
    "Permit Date": "1999-04-27T09:09:37Z",
    "Meeting Number": "6/99",
    "Meeting Date": "1999-03-26T09:10:04Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 59.17,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Myanbisco Food Industries Co., Ltd.",
    "Land Area (units not specified in file)": 3.566,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 35,
    "Number Of Foreign Employees": 4,
    Status: "Approved",
    "Investor Address": "No. 12, Shan Gone Street, Myaynigone",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၁၀၉၊ ၁၁၀၊ မြေတိုင်းရပ်ကွက်အမှတ် ၆၄၊ စက်မှုဇုန် ၁၊",
  },
  {
    ID: 2890,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw San San Yee",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Super Ace International Co., Ltd. (စူပါအေ့စ်အင်တာနေရှင်နယ်ကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "Ma Na Tha- 249/99",
    "Permit Date": "1999-05-14T10:06:07Z",
    "Meeting Number": "7/99",
    "Meeting Date": "1999-04-23T10:06:40Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "မုန့်မျိုးစုံထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 61,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Super Ace International Co., Ltd.",
    "Land Area (units not specified in file)": 1.024,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 281,
    "Number Of Foreign Employees": 5,
    Status: "Approved",
    "Investor Address":
      "အမှတ်-၈၆၊ ၁၂၃ လမ်း၊ မင်္ဂလာတောင်ညွန့်မြို့နယ်၊ ရန်ကုန်",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်၂၁၅၊ စက်မှုဇုန် ၂၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်",
  },
  {
    ID: 2892,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Tin Oo",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "U Kyu Family Grains & Manufacturing Co., Ltd. ",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "Ma Na Tha- 274/99",
    "Permit Date": "1999-07-23T04:29:34Z",
    "Meeting Number": "10/99",
    "Meeting Date": "1999-06-25T04:30:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာ အဆင့်မီ သန့်ရှင်းလတ်ဆတ်သော ဂျုံမှုန့်ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 122,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Tin Oo, U Myo Oo",
    "Land Area (units not specified in file)": 1.292,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 120,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "No. 11, Aung Bawga Road, Phaw Kan Ward, ",
    "Organization Address": "",
    "Investment Permitted Address": "Plot No 26, Industrial Zone 2, ",
  },
  {
    ID: 2893,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးမြင့်ဦး (ခ) ချန်ရင်ဟုတ်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Thiha Yarzar Co.,Ltd",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "၃၁၀/၉၉",
    "Permit Date": "1999-12-13T04:41:20Z",
    "Meeting Number": "၁၇/၉၉",
    "Meeting Date": "1999-10-01T04:42:05Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Low-Fat, Refined and Fresh Edible Oil",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 111.6,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "သီဟရာဇာကုမ္ပဏီလီမိတက်",
    "Land Area (units not specified in file)": 1.19,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 74,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ်(၈၄)၊ ၁၈ လမ်း၊ လသာမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၁၂/၁၃) လှိုင်သာယာ စက်မှုဇုန် (၁)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်း",
  },
  {
    ID: 2894,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Sa Lin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Gon Mingalar Foodstuffs Ltd. ",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "Ma Na Tha-391/2000",
    "Permit Date": "2000-05-20T06:07:08Z",
    "Meeting Number": "5/2000",
    "Meeting Date": "2000-02-18T06:42:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ ဘီစကွတ်မုန့်အမျိုးမျိုး ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 103.92,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Gon Mingalar Trading Co., Ltd.",
    "Land Area (units not specified in file)": 3.189,
    "Lease Term": 10,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 95,
    "Number Of Foreign Employees": 6,
    Status: "Monitoring Approved",
    "Investor Address": "No-557, အပေါ်ဆုံးထပ်၊ မဟာဗန္ဓုလလမ်း၊ ",
    "Organization Address": "",
    "Investment Permitted Address": "Plot-45,46, Industrial Zone (3), ",
  },
  {
    ID: 2900,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Doopung International Company Limited",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "110/1994",
    "Permit Date": "1994-07-18T08:14:05Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Electrical Products ",
    "Amount Of Foreign Capital USD (in Millions)": 0.439,
    "Total Amount Of Capital (in Millions)": 0.439,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address": "-",
  },
  {
    ID: 2901,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar GJM International Limited",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "112/1994",
    "Permit Date": "1994-09-06T08:45:53Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment",
    "Amount Of Foreign Capital USD (in Millions)": 1.487,
    "Total Amount Of Capital (in Millions)": 1.487,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "United Kingdom of Great Britain and Northern Ireland",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address": "-",
  },
  {
    ID: 2902,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "United Kingdom",
    "Company Name In Myanmar": "Myanmar Sampoerna Tobacco Company Limited",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "113/1994",
    "Permit Date": "1994-09-30T08:54:52Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Cigarette",
    "Amount Of Foreign Capital USD (in Millions)": 17.3,
    "Total Amount Of Capital (in Millions)": 17.3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "United Kingdom of Great Britain and Northern Ireland",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address": "Thanlyin Township, Yangon Region",
  },
  {
    ID: 2903,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-L.P International Company Limited",
    "Name of Principal Organization": "",
    "Place of Incorporation": "Thailand",
    "Company Name In Myanmar": "L.P International Company Limited",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "115/19994",
    "Permit Date": "1994-10-28T09:16:38Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 4.392,
    "Total Amount Of Capital (in Millions)": 4.392,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "Pyinmabin Industrial Zone, Mingalardom, Yangon Region",
  },
  {
    ID: 2904,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Myanmar China Tha Ma Huan Yu Minghu Flask Co., Ltd.",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "China",
    "Company Name In Myanmar":
      "Myanmar China Tha Ma Huan Yu Minghu Flask Co., Ltd.",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "117/1994",
    "Permit Date": "1994-10-28T09:45:58Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 4.39,
    "Total Amount Of Capital (in Millions)": 4.39,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address": "Shwe Pyi Thar, Yangon Region",
  },
  {
    ID: 2905,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Jade International Limited",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "123/1994",
    "Permit Date": "1994-12-30T09:50:42Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 3,
    "Total Amount Of Capital (in Millions)": 3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address": "Pyin Ma Bin, Mingaladon, Yangon Region",
  },
  {
    ID: 2906,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "Germany",
    "Company Name In Myanmar": "Asia-Pacific Edible Oil Ltd.",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "186/1996",
    "Permit Date": "1996-06-24T10:05:54Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 3.5,
    "Total Amount Of Capital (in Millions)": 3.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Germany",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address": "Kyauk Tan Township, Yangon",
  },
  {
    ID: 2909,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Managing Director/ Myanmar Economic Holdings Ltd.",
    "Name of Principal Organization":
      "The Union of Myanmar Economic Holdings Ltd.",
    "Place of Incorporation": "Myanmar ",
    "Company Name In Myanmar": "Myanmar Brewery Ltd. ",
    "Financial Year From": 94,
    "Financial Year To": 95,
    "Permit Number": "136/95",
    "Permit Date": "1995-03-28T06:20:02Z",
    "Meeting Number": "3/95",
    "Meeting Date": "1995-02-27T06:20:28Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 21.4,
    "Total Amount Of Capital (in Millions)": 174,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "No. 72, 74, Shwedagon Pagoda Road, ",
    "Organization Address": "No. 72, 74, Shwedagon Pagoda Road, ",
    "Investment Permitted Address": "Pyinmabin Area, ",
  },
  {
    ID: 2910,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Htay Naing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Green Circle Company Limited (ဂရင်းဆာကယ်လ် ကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 96,
    "Financial Year To": 97,
    "Permit Number": "Ma Na Tha-048/96",
    "Permit Date": "1996-11-22T07:20:32Z",
    "Meeting Number": "16/96",
    "Meeting Date": "1996-10-25T07:21:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "(Ve Ve) အမှတ်တံဆိပ် အချိုရည် (ဘိလပ်ရည်)များ ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 41.2,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "No.172, Ahnawrahta Road",
    "Organization Address": "",
    "Investment Permitted Address":
      "1) မြေကွက်အမှတ်-၁၄၂၊ မြေတိုင်းရပ်ကွက်အမှတ် ၄၂၊ စက်မှုဒေသ၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်\n၂) မြေကွက်အမှတ်ဘီ-၃-၃၊ မြေတိုင်းရပ်ကွက် (စ)၊ ပြည်ကြီးတံခွန်မြို့နယ်၊ မန္တလေးတိုင်းဒေသကြီး",
  },
  {
    ID: 2911,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Ko Ko Gyi@ U Soe Naing",
    "Name of Principal Organization": "Lluvia Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Lluvia Limited",
    "Financial Year From": 15,
    "Financial Year To": 16,
    "Permit Number": "939/2015",
    "Permit Date": "2015-04-27T08:01:31Z",
    "Meeting Number": "5/2015",
    "Meeting Date": "2019-04-27T08:02:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 1.564,
    "Total Amount Of Capital (in Millions)": 10.426,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "PAC Link Trading Limited",
    "Land Area (units not specified in file)": 2.25,
    "Lease Term": 50,
    "Annual Lease Fee": 218484,
    "Land Use Premium": null,
    "Number Of Local Employees": 291,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "No.126/A, Kabaraye Pagoda Road,",
    "Organization Address": "No.126/A, Kabaraye Pagoda Road,",
    "Investment Permitted Address":
      "Plot No. 50, Myay Taing Block No. 113, Industrial Zone",
  },
  {
    ID: 2912,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Katsuyuki Nakamura",
    "Name of Principal Organization": "Ajinomoto (Thailand) Ltd.",
    "Place of Incorporation": "Thailand",
    "Company Name In Myanmar": "Myanmar Ajinomoto Industry Co., Ltd.",
    "Financial Year From": 96,
    "Financial Year To": 97,
    "Permit Number": "234/96",
    "Permit Date": "1996-12-11T08:43:32Z",
    "Meeting Number": "18/96",
    "Meeting Date": "1996-11-29T08:44:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အချိုမှုန့်ထုတ်လုပ်ခြင်းနှင့် ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 2.6,
    "Total Amount Of Capital (in Millions)": 12.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 9,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Mingalardon Industrial Park Co., Ltd.",
    "Land Area (units not specified in file)": 10004,
    "Lease Term": null,
    "Annual Lease Fee": 3001.2,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Room.1&2, Building 18, 10th Mile, Highway Bus Station Compound",
    "Organization Address": "487/1, Siayutthaya Road,",
    "Investment Permitted Address": "Mingalardon Industrial Zone",
  },
  {
    ID: 2913,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Zaw Win",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Super Coffeemix Limited",
    "Financial Year From": 97,
    "Financial Year To": 98,
    "Permit Number": "292/97",
    "Permit Date": "1997-11-28T08:54:37Z",
    "Meeting Number": "18/97",
    "Meeting Date": "1997-11-07T08:56:04Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 4.2,
    "Total Amount Of Capital (in Millions)": 42,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 24,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "Department of Human Settlement and Housing Development",
    "Land Area (units not specified in file)": 16236,
    "Lease Term": 20,
    "Annual Lease Fee": 48708,
    "Land Use Premium": 200000,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "No.715, Traders Road, ",
    "Organization Address": "",
    "Investment Permitted Address":
      "အကွက်အမှတ် ၁၃၉/၁၄၀၊ ဒဂုံမြို့သစ်ဆိပ်ကမ်းစက်မှုဇုန်၊ ",
  },
  {
    ID: 2914,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Thein",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Crony Commercial Co.,Ltd.",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "Ma Na Tha-245/99",
    "Permit Date": "1999-05-11T09:06:09Z",
    "Meeting Number": "6/99",
    "Meeting Date": "1999-03-26T09:06:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "3 in 1 Coffee mix, Tea mix, Cereal Mix, Cocoa Mix များထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 36.2,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Crony Commercial Co., Ltd.",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "No.807, 3rd Street, 1 Ward,",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၃၃၊ မြေတိုင်းရပ်ကွက်အမှတ် အပိုင်း ၄၊ စက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 2915,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Htay Naing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Nagar Devi Co., Ltd.",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "Ma Na Tha - 309/99",
    "Permit Date": "1999-12-13T09:13:29Z",
    "Meeting Number": "18/99",
    "Meeting Date": "1999-10-08T09:14:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ ဘီစကွက်မုန့်အမျိုးမျိုး ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 50,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Htay Naing",
    "Land Area (units not specified in file)": 2,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "No. 156/160, 36 street",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေတိုင်းရပ်ကွက်-၄၂၊ ရွှေပြည်သာစက်မှုဇုန် -၁၁၆အေ/၂၊ ",
  },
  {
    ID: 2916,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဉီးချင်ကြုံ (ခ) ဉီးစံလွင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Nay Lin & Brothers Industry Co., Ltd. (နေလင်းနှင့် ညီအစ်ကိုများ စက်မှု ကုမ္ပဏီလီမိတက်)",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "Ma Na Tha- 315/99",
    "Permit Date": "1999-12-13T09:21:45Z",
    "Meeting Number": "19/99",
    "Meeting Date": "1999-10-22T09:22:11Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "မြေပဲဆီ၊ နှမ်းဆီ၊ နေကြာဆီ၊ ပဲပုပ်ဆီများ ထုတ်လုပ်၍ ပြည်တွင်းတွင် ဖြန့်ဖြူးရန်",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 94.27,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U San Lwin",
    "Land Area (units not specified in file)": 1.015,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "No. 8/47, Aung Thapyae Road, ဘုရင့်နောင် ပွဲရုံတန်း၊ ",
    "Organization Address": "",
    "Investment Permitted Address": "မြေကွက်အမှတ်-၃၀၊ စက်မှုဇုန်အပိုင်း-၄၊ ",
  },
  {
    ID: 2917,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Soe Paing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Paing ETG Company Limited",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "821/2014",
    "Permit Date": "2014-10-21T09:11:10Z",
    "Meeting Number": "821/2014",
    "Meeting Date": "2014-09-19T09:12:26Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Establlishing of 200 MT per day factory and processing value added beans & pulses",
    "Amount Of Foreign Capital USD (in Millions)": 3.159,
    "Total Amount Of Capital (in Millions)": 6.318,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "U Soe Paing",
    "Land Area (units not specified in file)": 4.684,
    "Lease Term": 50,
    "Annual Lease Fee": 94.55,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No.3(C), Yuzana Street, Ward No.4, Hlaing Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.380, 381, Myay Taing Block No.49, Wartayar Industrial Zone, Shwe Pyi Thar Township, Yangon",
  },
  {
    ID: 2918,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Pedro Felipe Sintes",
    "Name of Principal Organization":
      "Coca-Cola Myanmar Overseas Holdings Pte. Ltd. ",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Coca-Cola Pinya Beverages Myanmar Limited",
    "Financial Year From": 12,
    "Financial Year To": 13,
    "Permit Number": "540/2013",
    "Permit Date": "2013-01-02T03:24:54Z",
    "Meeting Number": "39/2012",
    "Meeting Date": "2012-12-28T03:25:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production, Bottling, distribution, marketing and sales of non-alcoholic beverages and purified drinking water",
    "Amount Of Foreign Capital USD (in Millions)": 88,
    "Total Amount Of Capital (in Millions)": 92.632,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Amend",
    "Investor Address": "9 Battery Road, #15-01 Straits Trading Building",
    "Organization Address":
      "9 Battery Road, #15-01 Straits Trading Building, 049910",
    "Investment Permitted Address":
      "1) No. 37, 38 & 65, Bamaw Atwin Wun Street, Hlaing Tharyar Industrial Zone-3,  Hlaingthaya Township, Yangon\n2) NO 42/A, 43, 44, 45, 47, 49, 50, 51, 52, 53, Myoe Shaung Road, Hmawbi Township, Yangon",
  },
  {
    ID: 2920,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Sridharan Arumugan",
    "Name of Principal Organization":
      "Vans' International Wines & Spirits (M) Sdn. Bhd.",
    "Place of Incorporation": "Malaysia",
    "Company Name In Myanmar":
      "Premier International Wines & Spirits Company Limited",
    "Financial Year From": 12,
    "Financial Year To": 13,
    "Permit Number": "491/2012",
    "Permit Date": "2013-07-31T03:59:41Z",
    "Meeting Number": "18/2012",
    "Meeting Date": "2012-06-27T04:00:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of all kinds of spirits wines and other brewery products",
    "Amount Of Foreign Capital USD (in Millions)": 1.3,
    "Total Amount Of Capital (in Millions)": 1.3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Malaysia",
    "Form Of Investment": "JV",
    "Land Owner": "U Kyaw Kyaw Aung and Daw Win Yee",
    "Land Area (units not specified in file)": 1170.54,
    "Lease Term": 20,
    "Annual Lease Fee": 15000,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "U-36 A Taman Chit Loong",
    "Organization Address":
      "No. 25, Jalan Selat Selatan 4, Off Jalan Banting. Landpac, Industrial Park, Pandamaran, 42000 Port Klang",
    "Investment Permitted Address":
      "Plot No 82, Shwe Pauk Kan Industrial Zone, ",
  },
  {
    ID: 2921,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Maung Maung Oo @ Deepak Kumar",
    "Name of Principal Organization": "Drink Tech Co.,Ltd",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Myanmar Consumer Beverages Ltd.",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "749/2014",
    "Permit Date": "2014-07-23T04:01:40Z",
    "Meeting Number": "16/2014",
    "Meeting Date": "2014-06-13T04:03:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing, Bottling, Distribution, Marketing and Sale of Non-Alcoholic Beverages",
    "Amount Of Foreign Capital USD (in Millions)": 24,
    "Total Amount Of Capital (in Millions)": 29.25,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 24,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Virgin Islands (British)",
    "Form Of Investment": "JV",
    "Land Owner": "Daw San Myint, U Tun Tun Win",
    "Land Area (units not specified in file)": 8,
    "Lease Term": 30,
    "Annual Lease Fee": 14.4,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "NO.715, Room No.19, Second Floor, Merchant Street, Ward No.3, Pabedan  Township, Yangon",
    "Organization Address":
      "No.15, Junction Square Complex, 37-G,  Pyay Road, Kamaryut Township, Yangon",
    "Investment Permitted Address":
      "Block No.217/218/219/220, Yangon Industrial Zone",
  },
  {
    ID: 2923,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Tun Naing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Padauk Shwe War Port and Petroleum Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "907/2013",
    "Permit Date": "2013-05-14T04:40:10Z",
    "Meeting Number": "14/2013",
    "Meeting Date": "2013-05-10T04:40:41Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Construction of pipeline jetty and Storage tanks, Importation, Storage, distribution and sales of fuels on BOT basis",
    "Amount Of Foreign Capital USD (in Millions)": 21.58,
    "Total Amount Of Capital (in Millions)": 26420.76,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "Myanma Port Authority",
    "Land Area (units not specified in file)": 37.06,
    "Lease Term": 30,
    "Annual Lease Fee": 272.4,
    "Land Use Premium": 555.9,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No.E18, Kabar Aye Villa, No 5 Ward, Mayangone Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.33, Thilawa Port area, Thanlyin-Kyauktan Area, Yangon Region, land area 37.06 acres owned by Myanmar Port Authority ",
  },
  {
    ID: 2925,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Byoung Tak Hur",
    "Name of Principal Organization":
      "Lotte Beverage Holdings (Singapore) Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Lotte MGS Beverage (Myanmar) Co., Ltd.",
    "Financial Year From": 13,
    "Financial Year To": 14,
    "Permit Number": "667/2014",
    "Permit Date": "2014-01-29T05:13:47Z",
    "Meeting Number": "3/2014",
    "Meeting Date": "2014-01-24T05:14:22Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production, Bottling, Distribution and Sales of Non-alcoholic Beverages and Purified Drinking Water",
    "Amount Of Foreign Capital USD (in Millions)": 56.7,
    "Total Amount Of Capital (in Millions)": 81,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner":
      "MGS Beverages Co., Ltd., U Thein Tun, U Oo Oo Tun, Daw Mar Mar Tun",
    "Land Area (units not specified in file)": 10.68,
    "Lease Term": 50,
    "Annual Lease Fee": 340162.68,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Pangyowonmaeul 1101-301, 147, Seopangyo-ro, Bundang-gu,",
    "Organization Address": "20 Cecilst., # 14-01, Equity Plaza",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၄၈/၁က)၊ (၄၈/၂၊ ၄၉) (၅၀/၂၊ ၇၂/၂)၊ သန္ဂေပင်ကျေးရွာ၊ မှော်ဘီမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး\n၂) မြေကွက်အမှတ် (H-၅၁၊ ၅၂၊ ၅၇၊ ၅၈၊ ၇၉၊ ၈၀)၊ ချည်မျှင်လမ်းနှင့် စွယ်တော်လမ်းထောင့်၊ ပြည်ကြီးတံခွန်မြို့နယ်၊ မန္တလေးတိုင်းဒေသကြီး",
  },
  {
    ID: 2928,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kwok Kian Hai",
    "Name of Principal Organization": "KOG Investments Pte., Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Yangon Oils and Grains Limited ",
    "Financial Year From": 97,
    "Financial Year To": 98,
    "Permit Number": "211/96",
    "Permit Date": "1996-09-30T07:36:19Z",
    "Meeting Number": "14/96",
    "Meeting Date": "1996-09-20T07:37:58Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production, Sales and Distribution of edible oils, flour, instant noodles, packaging materials and animal feeds",
    "Amount Of Foreign Capital USD (in Millions)": 95,
    "Total Amount Of Capital (in Millions)": 95,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "Thanlyin-Kyauktan Development Co., Ltd. ",
    "Land Area (units not specified in file)": 30,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "15, Carpenter Street 059904",
    "Organization Address": "15, Carpenter Street 059904",
    "Investment Permitted Address": "Thanlyin-Kyauktan Industrial Zone",
  },
  {
    ID: 2936,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဝင်းသိန်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Yathacho Industrial Limited ( ရသာချို စက်မှုလုပ်ငန်းလီမိတက်)",
    "Financial Year From": 96,
    "Financial Year To": 97,
    "Permit Number": "Ma Na Tha-032/96",
    "Permit Date": "1996-07-22T08:57:50Z",
    "Meeting Number": "9/96",
    "Meeting Date": "1996-06-21T08:58:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အသင့်စားခေါက်ဆွဲခြောက်နှင့် စားသောက်ကုန်ထုတ်လု်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 62.99,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "110 C, Pyay Road,",
    "Organization Address": "",
    "Investment Permitted Address":
      "နွယ်ခွေကျေးရွာ၊ ကွင်းအမှတ် ၅၂၈ (ခ)၊ မင်္ဂလာဒုံမြို့နယ်၊ ",
  },
  {
    ID: 2938,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Zaw Moe Khine",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Pacific Medical Industries Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "153/2019",
    "Permit Date": "2019-04-08T09:13:19Z",
    "Meeting Number": "5/2019",
    "Meeting Date": "2019-04-05T09:13:25Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Pharmaceutical and related products",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 25006.124,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "No. 126, 35th Street, Kyauktada Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 209,210,211, Zone 1, Dagon Myothit Seikkan Township, Yangon Region",
  },
  {
    ID: 2939,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Yangon Sportswear Manufacturing Company Limited",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "108/1994",
    "Permit Date": "2019-05-18T04:52:59Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.962,
    "Total Amount Of Capital (in Millions)": 1.962,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address": "Thanlyin Township, Yangon",
  },
  {
    ID: 2940,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "Malaysia",
    "Company Name In Myanmar": "Myanmar Elcon Gold Lit",
    "Financial Year From": 0,
    "Financial Year To": 0,
    "Permit Number": "109/1994",
    "Permit Date": "2019-05-18T05:16:55Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သားရေထုတ်ကုန်အမျိုးမျိုးထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 6,
    "Total Amount Of Capital (in Millions)": 6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address": "-",
  },
  {
    ID: 2941,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr Han Sang Shoe",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "Korea",
    "Company Name In Myanmar": "Myanmar Yes Co.,Ltd",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "257/1997",
    "Permit Date": "2019-05-30T06:46:30Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment",
    "Amount Of Foreign Capital USD (in Millions)": 1.8,
    "Total Amount Of Capital (in Millions)": 1.8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": 4334.187,
    "Lease Term": null,
    "Annual Lease Fee": 3,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address": "-",
  },
  {
    ID: 2942,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Managing Director",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "Yangon",
    "Company Name In Myanmar": "Myanmar Posco Steel Co.,Ltd",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "252/1997",
    "Permit Date": "2019-05-19T07:16:16Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အိမ်မိုးသွပ်ပြားများနှင့် Steel ပစ္စည်းအမျိုးမျိုးထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 4.04,
    "Total Amount Of Capital (in Millions)": 30,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "No.72/74, Shwedagon Pagoda Road, Dagon Towmship, Yangon",
    "Organization Address": "-",
    "Investment Permitted Address": "-",
  },
  {
    ID: 2944,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor":
      "Managing Director, The Union of Myanmar Economic Holdings Limited",
    "Name of Principal Organization": "",
    "Place of Incorporation": "Yangon",
    "Company Name In Myanmar": "  NEWCO Co.,Ltd",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "255/97",
    "Permit Date": "2019-05-30T07:59:39Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Gems and Jewelleries of International Standard",
    "Amount Of Foreign Capital USD (in Millions)": 2.4,
    "Total Amount Of Capital (in Millions)": 24,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": 1858.06,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "No.72/74 Shwedagon Pagoda Road, Dagon Township Yangon",
    "Organization Address": "",
    "Investment Permitted Address": "-",
  },
  {
    ID: 2945,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. SHIN HYO SUB",
    "Name of Principal Organization": "KOREA LAND AND HOUSING CORPORATION",
    "Place of Incorporation": "Korea",
    "Company Name In Myanmar": "KMIC   DEVELOPMENT COMPANY  LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "143/2019",
    "Permit Date": "2019-02-20T03:08:39Z",
    "Meeting Number": "3/2019",
    "Meeting Date": "2019-02-20T03:09:20Z",
    Sector: "Industrial Estate",
    "Type Of Investment Business":
      "DEVELOPMENT AND OPERATION OF INDUSTRIAL COMPLEX    (PHASE-1)",
    "Amount Of Foreign Capital USD (in Millions)": 29.07,
    "Total Amount Of Capital (in Millions)": 48.451,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "JV",
    "Land Owner": "Department of Urban and Housing Development  ",
    "Land Area (units not specified in file)": 314.69,
    "Lease Term": 50,
    "Annual Lease Fee": 127351.4,
    "Land Use Premium": null,
    "Number Of Local Employees": 16,
    "Number Of Foreign Employees": 9,
    Status: "Approved",
    "Investor Address":
      "19, CHUNGUI-RO, JINJU-SI, GYEONGSANGNAM-DO,            REPUBLIC OF KOREA, 660-31",
    "Organization Address":
      "19, CHUNGUI-RO, JINJU-SI, GYEONGSANGNAM-DO, REPUBLIC OF KOREA",
    "Investment Permitted Address":
      "Office Suite 2001, Pyay Garden Office Tower, 346-354, Pyay Road, Sanchaung Township, Yangon.",
  },
  {
    ID: 2947,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar VES Joint Venture Co., Ltd.",
    "Financial Year From": 1992,
    "Financial Year To": 1993,
    "Permit Number": "059/1992",
    "Permit Date": "1992-08-19T03:18:48Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing and Marketing of Gem",
    "Amount Of Foreign Capital USD (in Millions)": 5,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Thailand",
    "Form Of Investment": "",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address": "Mayangone Township, Yangon Region",
  },
  {
    ID: 2948,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Mokyan Co., Ltd.",
    "Financial Year From": 1993,
    "Financial Year To": 1994,
    "Permit Number": "081/1993",
    "Permit Date": "1993-09-23T03:25:06Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of PVC Pipe and Related Product",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address": "Kamaryut, Yangon",
  },
  {
    ID: 2949,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Rothmans of Pall Mall Myanmar Pte. Ltd.",
    "Financial Year From": 1993,
    "Financial Year To": 1994,
    "Permit Number": "090/1993",
    "Permit Date": "1993-12-13T03:29:11Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 6.457,
    "Total Amount Of Capital (in Millions)": 6.457,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Singapore",
    "Form Of Investment": "",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address": "Pyinmabin, Yangon",
  },
  {
    ID: 2950,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Best Industrial Co., Ltd.",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "094/1994",
    "Permit Date": "1994-01-24T03:33:13Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.483,
    "Total Amount Of Capital (in Millions)": 1.483,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address": "Shwe Pyi Thar, Yangon",
  },
  {
    ID: 2951,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Win ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Phoenix Company Limited",
    "Financial Year From": 96,
    "Financial Year To": 97,
    "Permit Number": "MaNaTha-039/1996",
    "Permit Date": "1996-09-16T03:30:48Z",
    "Meeting Number": "13/1996",
    "Meeting Date": "1996-08-23T03:31:36Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 35,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Mg Mg Win (or) Tin Tat Hu",
    "Land Area (units not specified in file)": 0.229,
    "Lease Term": 20,
    "Annual Lease Fee": 0.24,
    "Land Use Premium": null,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Number 35, Insein Main Road, 1 ward, Kamaryut Township, Yangon. ",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot 2 A/1, Myay Taing Ward 24 E,  Number (205), WarDan Road, Lanmadaw Township, Yangon",
  },
  {
    ID: 2952,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Goup Link (Myanmar) Ltd.",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "095/1994",
    "Permit Date": "1994-12-12T03:37:31Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment",
    "Amount Of Foreign Capital USD (in Millions)": 1.3,
    "Total Amount Of Capital (in Millions)": 1.3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address": "Shwepyithar, Yangon",
  },
  {
    ID: 2953,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Zaw Min",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Mingalar Co., Ltd.",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "manatha 001/1994",
    "Permit Date": "1994-09-26T03:40:41Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Service",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 30,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "59, Shangone Street, Myaynegone North Ward, Sanguang TS",
    "Organization Address": "",
    "Investment Permitted Address":
      "No 30. Inya Myaing Road, Bahan Township, Yangon",
  },
  {
    ID: 2954,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "အောင်သပြေခိုင်စက်မှုကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "မနသ ၃၂၁/၉၉",
    "Permit Date": "1999-12-24T03:44:47Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Plastic",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 49.8,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်မြေတိုင်း-၁၂၀၊၂ ရပ်ကွက်၊စက်မှုဇုန်၊လှိုင်သာယာမြို့နယ်၊ရန်ကုန်",
  },
  {
    ID: 2955,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ဇင်ယော်ဖြူအထည်ချုပ်ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "မနသ ၅၃၂/၂၀၀၂",
    "Permit Date": "2002-02-05T03:50:30Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 11.66,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၇၇၊မြေတိုင်းရပ်ကွက်-င၊စက်မှုလက်မှုရပ်ကွက်၊မြောက်ဥက္ကလာပမြို့နယ်၊ရန်ကုန်",
  },
  {
    ID: 2956,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Zaw Zaw ",
    "Name of Principal Organization":
      "Max Myanmar Construction Company Limited ",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Max Myanmar Construction Company Limited ",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "manatha 755/2010",
    "Permit Date": "2010-08-05T03:41:01Z",
    "Meeting Number": "17/2010",
    "Meeting Date": "2010-05-21T03:45:51Z",
    Sector: "Construction",
    "Type Of Investment Business":
      "Road Construction with BOT System and Collecting Road Toll ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 9175,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 325,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "No. 19, ကုက္ကိုင်းရိပ်သာလမ်း၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်",
    "Organization Address":
      "အမှတ် ၁၊ ရွာမကွေ့၊ အမှတ် ၂ ရပ်ကွက်၊ ဘုရင့်နောင်လမ်း၊ လှိုင်မြို့နယ်၊ ရန်ကုန်",
    "Investment Permitted Address":
      "အမှတ် ၁၊ ရွာမကွေ့၊ အမှတ် ၂ ရပ်ကွက်၊ ဘုရင့်နောင်လမ်း၊ လှိုင်မြို့နယ်၊ ရန်ကုန်",
  },
  {
    ID: 2957,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Chit Khaing",
    "Name of Principal Organization": "Eden Hotels and Resorts Co.,Ltd.",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Eden Hotels and Resorts Co.,Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "036/2017",
    "Permit Date": "2017-12-12T03:57:19Z",
    "Meeting Number": "16/2017",
    "Meeting Date": "2017-11-30T03:58:13Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Service",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 25114.89,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Defence",
    "Land Area (units not specified in file)": 247.06,
    "Lease Term": 50,
    "Annual Lease Fee": 90,
    "Land Use Premium": 124500000,
    "Number Of Local Employees": 250,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "No.100F, Inya Road,Kamayut Ts,Yangon",
    "Organization Address": "No.32D,New University Avenue Road,Bahan Ts,Yangon",
    "Investment Permitted Address":
      "No.32D,New University Avenue Road,Bahan Ts,Yangon",
  },
  {
    ID: 2958,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Htay Myint",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Yuzuna Hotel  Ltd.",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "manatha 003/1995",
    "Permit Date": "1995-02-23T04:23:33Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Service",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 100,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "No.30 Wardan Street, Lanmadaw TS, Yangon",
    "Organization Address": "",
    "Investment Permitted Address": "Alanpya Bagoda Road, Dagon TS, Yangon",
  },
  {
    ID: 2959,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. Lee Hyung Jin",
    "Name of Principal Organization": "TAE KWANG INDUSTRIAL CO., LTD",
    "Place of Incorporation": "Korea",
    "Company Name In Myanmar": "TAE KWANG MYANMAR  DEVELOPMENT COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "098/2018",
    "Permit Date": "2018-07-30T04:24:45Z",
    "Meeting Number": "10/2018",
    "Meeting Date": "2018-07-26T04:25:22Z",
    Sector: "Industrial Estate",
    "Type Of Investment Business":
      "CONSTRUCTION, OPERATION AND LEASING OF INDUSTRIAL PARK  ",
    "Amount Of Foreign Capital USD (in Millions)": 28,
    "Total Amount Of Capital (in Millions)": 28,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner":
      "U Soe Linn, U Zaw Htain, Daw Thae Hsu Han, Daw Kyu May Lwin, Daw Cho May Lwin ",
    "Land Area (units not specified in file)": 203.6,
    "Lease Term": 50,
    "Annual Lease Fee": 288380,
    "Land Use Premium": null,
    "Number Of Local Employees": 30,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address":
      "104 HO, 115 DONG, Union Village , Apartment, Sungjoo Dong Sungsan Gu, Chagwon City,  Republic of Korea  ",
    "Organization Address":
      "26, GIMHAE-DAERO 2635 BEON-GIL, GIMHAE-SI , GYEONGSANGNAM –DO, REPUBLIC OF KOREA",
    "Investment Permitted Address":
      "Room No.104, Marina Residence, Kabaraye Pagoda Road, Mayangone Township, Yangon.",
  },
  {
    ID: 2960,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyaw Paing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "FMI Syndication Ltd. ",
    "Financial Year From": 1995,
    "Financial Year To": 1996,
    "Permit Number": "manatha 005/1995",
    "Permit Date": "1995-05-08T04:30:29Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "FMI Center (leasing of office building and shop house)",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 276,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "No. 111, Ngahtetgyi Pagoda Road, Bahan TS, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No. 380, Bogyoke Aung San Road, Pabedan TS, Yangon",
  },
  {
    ID: 2962,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Maung Sein",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Growing Construction Co., Ltd.",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "manatha 051/1996",
    "Permit Date": "1996-11-29T04:47:33Z",
    "Meeting Number": "17/1996",
    "Meeting Date": "1996-11-08T04:48:07Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Construction and leasing of Plaza, office, shop and residences",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 173,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Information ",
    "Land Area (units not specified in file)": null,
    "Lease Term": 30,
    "Annual Lease Fee": 1,
    "Land Use Premium": null,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": 6,
    Status: "Approved",
    "Investor Address": "No.54, Sintohdan Road, Latha TS, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No. 165,175, Seikkantha Road, Kyauktada TS, Yangon",
  },
  {
    ID: 2967,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor":
      "မန်နေဂျင်းဒါရိုက်တာ၊ မြန်မာနိုင်ငံစီးပွားရေးဦးပိုင်လီမိတက် ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "National Development Corporation ",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "manatha 119/1998",
    "Permit Date": "1998-02-25T06:36:44Z",
    "Meeting Number": "1/1998",
    "Meeting Date": "1998-01-09T06:37:38Z",
    Sector: "Real Estate",
    "Type Of Investment Business": "အဆင့်မြင့်အိမ်ရာစီမံကိန်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1637.13,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 60,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Defence ",
    "Land Area (units not specified in file)": 30.147,
    "Lease Term": 60,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "၇၂/၇၄၊ ရွှေတိဂုံဘုရားလမ်း၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေတိုင်းအမှတ် ၄၆ (၁-က)၊ မရမ်းကုန်မြို့နယ်၊ ရန်ကုန်",
  },
  {
    ID: 2969,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးအောင်မျိုးမင်းဒင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Adventure Myanmar Tours & Incentives Co., Ltd. ",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "manatha 1161/2016",
    "Permit Date": "2016-03-26T08:16:42Z",
    "Meeting Number": "10/2016",
    "Meeting Date": "2016-03-18T08:15:52Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business":
      "B.O.T စနစ်ဖြင့် ကြယ်လေးပွင့်ဟိုတယ်၊ Office & Services Apartment (၁)လုံး နှင့် Apartment(၃)လုံးတည်ဆောက်၍ ငှားရမ်းခြင်းဝန်ဆောင်မှုလုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 62400,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner":
      "ဆောက်လုပ်ရေးဝန်ကြီးဌာန၊မြို့ပြနှင့် အိမ်ရာဖွံ့ဖြိုးရေးဦးစီးဌာနပိုင်",
    "Land Area (units not specified in file)": 4.98,
    "Lease Term": 50,
    "Annual Lease Fee": 1127236,
    "Land Use Premium": 9960000,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် (၂၉)၊မင်းရဲကျော်စွာလမ်း၊ ကကခ (၁) ၊လမ်းမတော်မြို့နယ်၊ရန်ကုန်မြို့နယ်",
    "Organization Address": "",
    "Investment Permitted Address":
      "လမ်းမတော်မြို့နယ်၊မင်းရဲကျော်စွာလမ်း၊မြေတိုင်းရပ်ကွက်အမှတ် (၂၀-အေ၊၄၆-ဘီ)၊ မြေကွက်အမှတ် (၈-A/၁ နှင့် ၂-A ၂/၄)၊စိန်ဂျွန်းအုပ်စု သိုလှောင်ရုံဝန်း",
  },
  {
    ID: 2970,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဂျော်နသန်မျိုးကျော်သောင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "KT Development Co., Ltd.",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "manatha 1186/2016",
    "Permit Date": "2016-03-26T09:04:21Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T04:26:22Z",
    Sector: "Other Services",
    "Type Of Investment Business": "B.O.T ",
    "Amount Of Foreign Capital USD (in Millions)": 351.9,
    "Total Amount Of Capital (in Millions)": 439914.74,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 50,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "ကာကွယ်ရေးဝန်ကြီးဌာန",
    "Land Area (units not specified in file)": 11.753,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": 23.5,
    "Number Of Local Employees": 910,
    "Number Of Foreign Employees": 9,
    Status: "Approved",
    "Investor Address":
      "၉၁(အိုင်)၊သံလွင်လမ်း၊ရွှေတောင်ကြား (၁) ရပ်ကွက်၊ဗဟန်းမြို့နယ်၊ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကင်းမြို့နယ်၊မြေတိုင်းရပ်ကွက်အမှတ် (၈၉ ကံဘဲ့)၊မြေကွက်အမှတ် (၄ အေနှင့် ၄ ဘီ၏  တစ်စိတ် တစ်ဒေသ)ရှိ မြေဧရိယာ ၁၁.၇၅၃ ဧက",
  },
  {
    ID: 2971,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr Koki Onodera",
    "Name of Principal Organization": "MCG Corporation",
    "Place of Incorporation": "Yangon",
    "Company Name In Myanmar": "Myanmar MCG Corporation",
    "Financial Year From": 1990,
    "Financial Year To": 1991,
    "Permit Number": "033/1990",
    "Permit Date": "1990-08-29T09:32:38Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business":
      "Yangon International Hotel တည်ဆောက်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 60,
    "Total Amount Of Capital (in Millions)": 60,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 50,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Yangon International Hotel (Myanmar MCG Corporation Ltd.",
    "Land Area (units not specified in file)": 10.29,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "1-27-17 Kami ike gami, Outaku, Tokyo , Japan",
    "Organization Address": "Japan",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ ဒဂုံမြို့နယ်၊ပြည်လမ်းနှင့် အလုံလမ်းထောင့်",
  },
  {
    ID: 2972,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "JV",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Savoy Hotel Co.,Ltd.",
    "Financial Year From": 1993,
    "Financial Year To": 1994,
    "Permit Number": "072/1993",
    "Permit Date": "1993-03-03T09:39:21Z",
    "Meeting Number": "8/1995",
    "Meeting Date": "1995-07-07T04:44:49Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Investment Holding Company ",
    "Amount Of Foreign Capital USD (in Millions)": 0.625,
    "Total Amount Of Capital (in Millions)": 10,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 50,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Ukraine",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Kyi Kyi Tun",
    "Land Area (units not specified in file)": 3237,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 66,
    "Number Of Foreign Employees": 5,
    Status: "Amend",
    "Investor Address": "၃၂-ဘီ၊ ဦးဝီစာရလမ်း၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address": "၃၂-ဘီ၊ ဦးဝီစာရလမ်း၊ ရန်ကုန်မြို့",
  },
  {
    ID: 2973,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Mar Mar Khin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Supreme Services Team Hotel Co.,Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "075/2018",
    "Permit Date": "2018-04-29T09:48:59Z",
    "Meeting Number": "5/2018",
    "Meeting Date": "2018-04-20T09:49:53Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 3109.233,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "",
    "Land Area (units not specified in file)": 15,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 56,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၁၇၀/ သုခလမ်း၊ ၆ ရပ်ကွက်၊ လှိုင်မြို့နယ်၊ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်-၁၇၀/ သုခလမ်း၊ ၆ ရပ်ကွက်၊ လှိုင်မြို့နယ်၊ရန်ကုန်မြို့",
  },
  {
    ID: 2974,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyaw Sein",
    "Name of Principal Organization": "Kappa International Ltd.",
    "Place of Incorporation": "Yangon, Myanmar",
    "Company Name In Myanmar": "Kappa International Ltd.",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "manatha 598/2003",
    "Permit Date": "2003-03-08T03:56:31Z",
    "Meeting Number": "28/2002",
    "Meeting Date": "2002-08-23T03:56:53Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1200,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Hotels and Tourism",
    "Land Area (units not specified in file)": 4.7,
    "Lease Term": 20,
    "Annual Lease Fee": 44,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "No.11, Kokai Yeikthar street, Bahan Ts, Yangon",
    "Organization Address": "No.11, Kokai Yeikthar street, Bahan Ts, Yangon",
    "Investment Permitted Address":
      "No.11, Kokai Yeikthar street, Bahan Ts, Yangon",
  },
  {
    ID: 2975,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr. Sunil Seth",
    "Name of Principal Organization": "Adani International Terminals Pte Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar":
      "Adani Yangon International Terminal Company Limited.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "155/2019",
    "Permit Date": "2019-04-26T04:03:32Z",
    "Meeting Number": "6/2019",
    "Meeting Date": "2019-04-26T04:03:56Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "development, operation and maintenance of Ahlon International Port Terminal (2) and container yard on Build, Operate and Transfer (BOT) basis",
    "Amount Of Foreign Capital USD (in Millions)": 290.124,
    "Total Amount Of Capital (in Millions)": 290.124,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 30,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII,BOT",
    "Land Owner": "Myanmar Economic Corporation",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 1176,
    "Number Of Foreign Employees": 66,
    Status: "Approved",
    "Investor Address": "No. 1026, Sector: 15-B, Chandigarh, India",
    "Organization Address":
      "80 Raffles Place, # 33-20, UOB Plaza, Singapore 048624.",
    "Investment Permitted Address":
      "HAGL Myanmar Centre No.192, Kaba Aye Pagoda Road\nTower 2, Unit 15, Level 10,\nBahan Township, Yangon Region, Myanmar. \nPLOT NO. 23 G/4, 23R/2A, AHLON PORT COMPOUND, AHLON TOWNSHIP, YANGON REGION.",
  },
  {
    ID: 2982,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "SERGE PUN",
    "Name of Principal Organization": "Serge Pun & Associates Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "MEEYAHTA INTERNATIONAL HOTEL LIMITED",
    "Financial Year From": 1993,
    "Financial Year To": 1994,
    "Permit Number": "080/1993",
    "Permit Date": "1993-08-05T08:12:42Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": 16,
    "Total Amount Of Capital (in Millions)": 16,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 4,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "Myanma Railways",
    "Land Area (units not specified in file)": null,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Terminated",
    "Investor Address":
      "21/ F SPA Centre, 53-55 Lockhart Road, Wanchai, Hongkong",
    "Organization Address": "Hong Kong",
    "Investment Permitted Address":
      "The Campus, 1 Office Park, Rain Tree Drive, Pun Hlaing Estate\nHlaing Thayar Township, Yangon, Myanmar 11401",
  },
  {
    ID: 2983,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Win",
    "Name of Principal Organization": "Yaung Ni Oo Company Limited",
    "Place of Incorporation": "Yangon ",
    "Company Name In Myanmar": "Yaung Ni Oo Company Limited",
    "Financial Year From": 97,
    "Financial Year To": 98,
    "Permit Number": "manatha 090/1997",
    "Permit Date": "1997-09-30T08:10:54Z",
    "Meeting Number": "14/1997",
    "Meeting Date": "1997-08-29T08:56:17Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "ရုံးခန်း၊ ဆိုင်ခန်းနှင့် လူနေအိမ်ခန်းများ ပါရှိသည့် ၈ ထပ် နှင့် ၇ ထပ် အဆောက်အအုံ တည်ဆောက်၍ ငှားရမ်းခြင်းလုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 108,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "မီးသတ်ဦးစီးဌာန",
    "Land Area (units not specified in file)": 0.3,
    "Lease Term": 30,
    "Annual Lease Fee": 1.6254,
    "Land Use Premium": null,
    "Number Of Local Employees": 85,
    "Number Of Foreign Employees": 5,
    Status: "Amend",
    "Investor Address":
      "Number 33(B), DaMaYon Road, 15 ward,  Yankin Township, Yangon",
    "Organization Address": "Number 150, 2 nd Floor, Anawrahta Road, Yangon ",
    "Investment Permitted Address":
      "၁။ မြေကွက်အမှတ် ၁၆၊ ၁၆(က)၊ မြေတိုင်းအမှတ်(၂၂ ဇက်၁)၊ ဘုန်းကြီးလမ်း၊ လမ်းမတော်မြို့နယ်၊ ရန်ကုန်မြို့ ။  ၂။ မြေကွက်အမှတ်၊ -၄၇၊ မြေတိုင်းအမှတ်(၁၆ ဒီ၂)၊ ၃၂ လမ်း၊ ပန်းဘဲတန်းမြို့နယ်၊ ရန်ကုန်မြို့ ။ ",
  },
  {
    ID: 2985,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Hla Myint",
    "Name of Principal Organization": "Taing Yin May International Co., Ltd. ",
    "Place of Incorporation": "Yangon",
    "Company Name In Myanmar": "Taing Yin May International Co., Ltd. ",
    "Financial Year From": 97,
    "Financial Year To": 98,
    "Permit Number": "101/1997",
    "Permit Date": "1997-12-16T09:56:16Z",
    "Meeting Number": "19/1997",
    "Meeting Date": "1997-11-11T09:56:48Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "ရုံးခန်း၊ လူနေ အိမ်ခန်းနှင့် စျေးဆိုင်ခန်းများ ပါဝင်သော စီးပွားရေး အဆောက်အအုံ ဆောက်လုပ်ငှားရမ်းခြင်း လုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 92.2,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "အထွေထွေအုပ်ချုပ်ရေးဦးစီးဌာန ",
    "Land Area (units not specified in file)": 0.16,
    "Lease Term": 30,
    "Annual Lease Fee": 2.21,
    "Land Use Premium": null,
    "Number Of Local Employees": 96,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "Number 89, 38 road, First floor, Kyauktada township, Yangon",
    "Organization Address":
      "Number 89, 38 road, First floor, Kyauktada township, Yangon",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ၄၆၈ ကေ၊ မြေတိုင်းရပ်ကွက်အမှတ် ၂-ဒီ၊ ဝင်္ကဘာလမ်း၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်မြို့ ( စာပေစိစစ်ရေးရုံးဝင်း)",
  },
  {
    ID: 2986,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Daw Yin Yin Win",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Mian Hua Co., Ltd.",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "148/19",
    "Permit Date": "2019-04-08T02:54:01Z",
    "Meeting Number": "5/2019",
    "Meeting Date": "2019-04-05T02:54:15Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Foreign Language (Chinese) Training Services",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 300,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Mar Lar@ Daw Mar Lar Tint",
    "Land Area (units not specified in file)": 0.372,
    "Lease Term": 5,
    "Annual Lease Fee": 60,
    "Land Use Premium": null,
    "Number Of Local Employees": 18,
    "Number Of Foreign Employees": 10,
    Status: "Submitted",
    "Investor Address":
      "No.7(A), Pyitaw Aye Avenue Road, Yankin Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.7(A), Plot No.32/5, Myay Taing Block No.85(Kanbae), Pyitaw Aye Avenue Road, Yankin Township, Yangon Region",
  },
  {
    ID: 2987,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးဝင်းကြုံ(ခ)ဦးအကျန် ",
    "Name of Principal Organization": "Lion Brothers Construction Co., Ltd. ",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Lion Brothers Construction Co., Ltd. ",
    "Financial Year From": 97,
    "Financial Year To": 98,
    "Permit Number": "098/1997",
    "Permit Date": "1997-11-28T03:03:10Z",
    "Meeting Number": "16/1997",
    "Meeting Date": "1997-10-17T03:09:05Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "နိုင်ငံတကာ အဆင့်မီ ရုံးခန်း၊ ဆိုင်ခန်း၊ လူနေအိမ်ခန်းများ ပါရှိသည့် အဆောက်အဦ ဆောက်လုပ်၍ ငှားရမ်းခြင်းလုပ်ငန်း ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 78.6,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "မီးသတ်ဦးစီးဌာန",
    "Land Area (units not specified in file)": 0.336,
    "Lease Term": 30,
    "Annual Lease Fee": 2.02,
    "Land Use Premium": 30.24,
    "Number Of Local Employees": 60,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ် ၁၅၄၊ ဒုတိယသီရိရိပ်သာ ၊ အောက်ကြည့်မြင်တိုင်လမ်း၊ အလုံမြို့နယ်၊ ရန်ကုန်မြို့ ",
    "Organization Address": "",
    "Investment Permitted Address":
      "၁၃၈/၁၅၀၊ မြေကွက်အမှတ် ၃-ဘီ/၁၊ မြေတိုင်းရပ်ကွက်အမှတ် (၂၃ ဂျီ၁)၊ ကမ်းနားလမ်း၊ အလုံမြို့နယ်၊ ရန်ကုန်မြို့ ",
  },
  {
    ID: 2991,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Kyay 'O' Kyee Petroleum Products Co., Ltd.",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Kyay 'o' Kyee Petroleum Products Co., Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "103/18",
    "Permit Date": "2018-06-23T05:40:45Z",
    "Meeting Number": "8/2018",
    "Meeting Date": "2018-07-22T05:41:04Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "အင်ဂျင်ဝိုင်ရောစပ်ထုတ်လုပ်၍ ဖြန့်ဖြူး ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 6100,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Kyaw Win",
    "Land Area (units not specified in file)": 2.251,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 22,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No.353, Upper Pazundaung Street, Satsan Ward, Mingalartaungnyunt Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.68, Myaung Ta Kar Steel Founding Industry, Hmawbi Township, Yangon Region",
  },
  {
    ID: 2995,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Daw Wityi Htwe",
    "Name of Principal Organization": "Taw Win Family Construction Co., Ltd.",
    "Place of Incorporation": "myanmar",
    "Company Name In Myanmar": "Taw Win Family Construction Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "094/18",
    "Permit Date": "2018-03-27T07:44:55Z",
    "Meeting Number": "4/2018",
    "Meeting Date": "2018-03-20T07:45:08Z",
    Sector: "Other Services",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 52000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Taw Win Family Construction Co., Ltd.",
    "Land Area (units not specified in file)": 1.208,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 1849,
    "Number Of Foreign Employees": 65,
    Status: "Approved",
    "Investor Address":
      "No.19, Mahamyaing Street, Kyuntaw Ahale Ward, Sanchaung Township, Yangon",
    "Organization Address":
      "No.45, Pyay Road, Taw Win Center, Dagon Township, Yangon",
    "Investment Permitted Address":
      "No.68, Sakawar Street, Dagon Township, Yangon Region",
  },
  {
    ID: 2996,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Zaw Naing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Shwe Taung Development Company Limited",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "Manatha 929/2013",
    "Permit Date": "2013-08-26T08:28:36Z",
    "Meeting Number": "21/2013",
    "Meeting Date": "2013-08-15T03:56:29Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် ငှားရမ်း၍ နိုင်ငံတကာအဆင့်မီ Hotel, Service Apartment နှင့် Shopping Complex တည်ဆောက်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 101908.69,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "Quarter Master General Office",
    "Land Area (units not specified in file)": 8.844,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": 25208000,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Terminated",
    "Investor Address":
      "Ahlone Tower, River View Garden Housing, Strand Road, Ahlone Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Myay Taing Block No.63, The old place of Nation defence University, Campus (2), Dagon Township, Yangon, Quartermaster General Office, Ministry of Defence",
  },
  {
    ID: 2998,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr. Tham Kwong Wing",
    "Name of Principal Organization": "UPC Resources Pte. Ltd",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Air Products(Myanmar) Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "028/2017",
    "Permit Date": "2017-10-03T04:10:13Z",
    "Meeting Number": "13/2017",
    "Meeting Date": "2017-09-25T04:10:31Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Refining , Distribution and Sales of Oxygen, Nitrogen, Carbon Dioxide And Argon",
    "Amount Of Foreign Capital USD (in Millions)": 0.9,
    "Total Amount Of Capital (in Millions)": 1.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "K&M Capital Co., Ltd.",
    "Land Area (units not specified in file)": 480.17,
    "Lease Term": 5,
    "Annual Lease Fee": 0.036,
    "Land Use Premium": null,
    "Number Of Local Employees": 23,
    "Number Of Foreign Employees": 5,
    Status: "Approved",
    "Investor Address": "757, Choa Chu Kang North 5# 03-123, Singapore 680757",
    "Organization Address": "208, Toa  Pay North # 05-1269, Singapore 310208",
    "Investment Permitted Address":
      "Plot No.5, Myay Taing Block No.143/1, No.A-08, Kyansitthar Road, Kyansitthar Industrial Zone, Dagon Myothit (South) Township, Yangon Region",
  },
  {
    ID: 2999,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Koh Kim Song",
    "Name of Principal Organization": "Marplan Pte Ltd",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Marplan Company Limited",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "289/97",
    "Permit Date": "1997-11-28T04:22:03Z",
    "Meeting Number": "16/1997",
    "Meeting Date": "1997-10-17T05:56:46Z",
    Sector: "Real Estate",
    "Type Of Investment Business": "Residence Cum Commercial Complex",
    "Amount Of Foreign Capital USD (in Millions)": 2.25,
    "Total Amount Of Capital (in Millions)": 2.25,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII,BOT",
    "Land Owner": "Yangon City Development Committee",
    "Land Area (units not specified in file)": 0.721,
    "Lease Term": 30,
    "Annual Lease Fee": 60201.12,
    "Land Use Premium": 500000,
    "Number Of Local Employees": 15,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address": "15, Astrid Hill, Singapore 269939",
    "Organization Address": "181-B Thomson Road, Singapore 307627",
    "Investment Permitted Address":
      "No.666, Strand Road, Lanmadaw Township, Yangon",
  },
  {
    ID: 3000,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Toshio Yoneda",
    "Name of Principal Organization": "Hopeson Pacific Pte. Ltd",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Hopeson Myanmar Company Limited",
    "Financial Year From": 1995,
    "Financial Year To": 1996,
    "Permit Number": "152/1995",
    "Permit Date": "1995-07-13T04:31:52Z",
    "Meeting Number": "7/1995",
    "Meeting Date": "1995-05-20T04:37:20Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "International Class Office Building for Lease",
    "Amount Of Foreign Capital USD (in Millions)": 6.75,
    "Total Amount Of Capital (in Millions)": 6.75,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 24,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII,BOT",
    "Land Owner": "Directorate of Hotels and Tourism",
    "Land Area (units not specified in file)": 3344.5,
    "Lease Term": 30,
    "Annual Lease Fee": 0.79,
    "Land Use Premium": 1000000,
    "Number Of Local Employees": 32,
    "Number Of Foreign Employees": 3,
    Status: "Approved",
    "Investor Address": "17-20, Shinbasiii 6 Chome, Minato-KU Tokyo 105, Japan",
    "Organization Address":
      "BLK 162, Bukit Merah Central, No. 06-3555, Singapore",
    "Investment Permitted Address":
      "No. 73-75, Sulea Pagoda Road, Kyauktada Township, Yangon",
  },
  {
    ID: 3001,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yoshiki Takeda",
    "Name of Principal Organization": "YKK Development (s) PTE Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Golden Hill Tower Limited",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "233/96",
    "Permit Date": "1996-12-10T06:23:03Z",
    "Meeting Number": "23/2000",
    "Meeting Date": "2000-07-14T06:23:47Z",
    Sector: "Real Estate",
    "Type Of Investment Business": "Service Apartment",
    "Amount Of Foreign Capital USD (in Millions)": 63,
    "Total Amount Of Capital (in Millions)": 63,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII,BOT",
    "Land Owner":
      "Myanma Port Authority, Ministry of Transport & Communications",
    "Land Area (units not specified in file)": 2.3,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": 4.6,
    "Number Of Local Employees": 60,
    "Number Of Foreign Employees": 5,
    Status: "Approved",
    "Investor Address":
      "21, Parkhay Road, # 12-21, Venus Mansion, Singapore - 228314",
    "Organization Address":
      "10, Anson Road, # 30-15/16 International Plaza, Singapore - 079903",
    "Investment Permitted Address":
      "No.24/26, Kaba Aye Pagoda Road, Bahan Township, Yangon",
  },
  {
    ID: 3002,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Daw The Theint Wah",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Cinematic Co., Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "E124/18",
    "Permit Date": "2018-11-08T06:51:41Z",
    "Meeting Number": "18/2018",
    "Meeting Date": "2018-11-02T06:52:00Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Construction of Cinema And Operation of cinema",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 6109.65,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "Capital Development Limited, Hoang Anh Gia Lai Myanmar Co., Ltd., U Sai Zaw Zaw",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 90,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "8th Floor, Room No.5, Crystal Tower, Kyun Taw Street, Kamaryut Townhsip, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "NO.14-C, CAPITAL HYPERMARKET, 4th FLOOR, MINNANDA STREET, DAWBON TOWNSHIP, YANGON REGION, NO. 192, MYANMAR PLAZA, 4th FLOOR, KABARAYE PAGODA ROAD, BAHAN TOWNSHIP, YANGON REGION AND N0. 48, CITY SQUARE SHOPPING CENTER, 4th FLOOR, BOGYOKE AUNG SAN STREET, TAUNGYI TOWNSHIP, SHAN STATE",
  },
  {
    ID: 3003,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Hito Shi Tani",
    "Name of Principal Organization":
      "EXE-Sakura Tower Yangon Development Pte Ltd",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "EXE Sakura (Myanmar) Company Limited",
    "Financial Year From": 1995,
    "Financial Year To": 1996,
    "Permit Number": "142/1995",
    "Permit Date": "1995-07-10T06:48:57Z",
    "Meeting Number": "22/1995",
    "Meeting Date": "1995-06-14T06:50:22Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Office Building  and Commercial Complex, and Management",
    "Amount Of Foreign Capital USD (in Millions)": 30,
    "Total Amount Of Capital (in Millions)": 30,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII,BOT",
    "Land Owner": "Deperment of Hotels and Tourism",
    "Land Area (units not specified in file)": 1094.5,
    "Lease Term": 30,
    "Annual Lease Fee": 0.3,
    "Land Use Premium": 2000000,
    "Number Of Local Employees": 40,
    "Number Of Foreign Employees": 4,
    Status: "Approved",
    "Investor Address":
      "1F Sogo Kojimachi Dai 3 Bldg 1-6 Kojimachi Chiyoda-KU, Tokyo, 102 Japan",
    "Organization Address": "Singapore",
    "Investment Permitted Address":
      "Southeast Corner of Sule Pagoda Road and Bogyoke Aung San Road, Yangon",
  },
  {
    ID: 3004,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Director General,Department of Urban and Housing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Royal Mingalardon Golf & Country Club Co., Ltd.",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "manatha 125/1998",
    "Permit Date": "1998-03-10T08:59:57Z",
    "Meeting Number": "3/1998",
    "Meeting Date": "1998-02-06T09:03:47Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ (၁၈)ကျင်းပါ ဂေါက်ကွင်း၊တင်းနစ်ကွင်း၊ ရေကူးကန် နှင့် အဆင့်မြင့်လုံးချင်းအိမ် (၁၀၀) လုံးတည်ဆောက်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 3346.7,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Department of Urban and Housing",
    "Land Area (units not specified in file)": 286,
    "Lease Term": 30,
    "Annual Lease Fee": 1001,
    "Land Use Premium": null,
    "Number Of Local Employees": 662,
    "Number Of Foreign Employees": 10,
    Status: "Approved",
    "Investor Address": "No,220/234,Boyoke Aungsan Road,Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေတိုင်းအမှတ် ၅၃၄-ဘီ၊အမှတ် (၃) လမ်းမကြီး အရှေ့ဘက် မင်္ဂလာဒုံမြို့နယ်။",
  },
  {
    ID: 3005,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Major Zaw Phay (Retired)",
    "Name of Principal Organization": "16th Batch Brothers Co., Ltd.",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "16th Batch Brothers Co., Ltd.",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "manatha 184/1998",
    "Permit Date": "1998-10-16T04:02:57Z",
    "Meeting Number": "16/98",
    "Meeting Date": "1998-09-14T04:03:29Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Construction and Leasing of Office and Apartments, Shopping Centre & Plaza",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 231,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Information,Myanmar Film Work",
    "Land Area (units not specified in file)": 0.161,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 99,
    "Number Of Foreign Employees": 5,
    Status: "Approved",
    "Investor Address":
      "No. 235, Okka 8th Street, 8 Quarter, North Okkalapa Ts, Yangon.",
    "Organization Address": "No. 202-206, Lanmadaw Ts, Yangon",
    "Investment Permitted Address":
      "N0. 202-206, Conor of Bhone gyi Road and Kyone gyi Road, Lanmadaw Ts, Yangon.",
  },
  {
    ID: 3006,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Soe Win",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Golden J Construction Co., Ltd.",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "manatha 206/1998",
    "Permit Date": "1998-11-25T05:12:51Z",
    "Meeting Number": "20/98",
    "Meeting Date": "1998-11-09T05:13:48Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Constriction and Leasing Office, Apartments and Shops with B.O.T System",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 359,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "Ministry of Information, Myanmar Film Work",
    "Land Area (units not specified in file)": 0.2,
    "Lease Term": 30,
    "Annual Lease Fee": 120,
    "Land Use Premium": 305,
    "Number Of Local Employees": 99,
    "Number Of Foreign Employees": 6,
    Status: "Approved",
    "Investor Address":
      "No.609-F, Shwe Hnin Si Street, 5 Quarter, Mayangone Ts, Yangon.",
    "Organization Address": "",
    "Investment Permitted Address":
      "Bayin Cinema, between MaharBandula Park Road and 34th Street, Bo Gyoke Aung San Road, Kyauktada Ts, Yangon.",
  },
  {
    ID: 3007,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor":
      "Director General, Department of Urban and Housing Development ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Hlaing River Golf and Country Club Co., Ltd.",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "Manatha 212/98",
    "Permit Date": "1998-12-11T07:21:05Z",
    "Meeting Number": "13/98",
    "Meeting Date": "1998-07-31T07:22:00Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Construction of International Standard,including 18-loop, Golf Club and High standard Housing Project (304 houses and 240 buildings)",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 7616.7,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,JV",
    "Land Owner": "Department of Urban and Housing Development ",
    "Land Area (units not specified in file)": 651.89,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 53,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "No. 228/234, BoGyokeAgSan Road, Yangon.",
    "Organization Address": "",
    "Investment Permitted Address":
      "(651.89) Acres,  Department of Urban and Housing Development estate, Central place of Pun Hlaing River & Hlaing River, Hlaing Thayar Township, Yangon.",
  },
  {
    ID: 3008,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Moe Hein",
    "Name of Principal Organization": "WKG General Trading Co., Ltd.",
    "Place of Incorporation": "myanmar",
    "Company Name In Myanmar": "WKG Kossco Co., Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "112/18",
    "Permit Date": "2018-08-27T03:21:14Z",
    "Meeting Number": "13/2018",
    "Meeting Date": "2018-08-25T03:21:30Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Zinc Galvanizing And Related Business",
    "Amount Of Foreign Capital USD (in Millions)": 9,
    "Total Amount Of Capital (in Millions)": 15,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "JV",
    "Land Owner": "WKG General Trading Co., Ltd.",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 10,
    "Annual Lease Fee": 0.016,
    "Land Use Premium": null,
    "Number Of Local Employees": 48,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Building C1, No.603, Bo Mhu Ba Htoo Housing Complex, North Dagon Township, Yangon",
    "Organization Address":
      "No.68, Bo Mhu Ba Htoo Road, Ward No.43, Dagon Myothit (North) Township, Yangon",
    "Investment Permitted Address":
      "No.476, Mogok Street, Ward No.23, Dagon Myothit(South) Township, Yangon Region",
  },
  {
    ID: 3009,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Hitoshi Tani",
    "Name of Principal Organization":
      "EXE- SAKURA Residense Development Pte Ltd. ",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "EXE- DESIGN(MYANMAR) Co., Ltd.",
    "Financial Year From": 1995,
    "Financial Year To": 1996,
    "Permit Number": "158/1995",
    "Permit Date": "1995-08-02T04:21:52Z",
    "Meeting Number": "7/1995",
    "Meeting Date": "1995-06-20T04:31:57Z",
    Sector: "Real Estate",
    "Type Of Investment Business": "Serviced apartment Complex ",
    "Amount Of Foreign Capital USD (in Millions)": 30,
    "Total Amount Of Capital (in Millions)": 30,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII,BOT",
    "Land Owner":
      "Ministry of Construction, Department of Human Settlement and Housing Development",
    "Land Area (units not specified in file)": 1.88,
    "Lease Term": 30,
    "Annual Lease Fee": 0.25,
    "Land Use Premium": 2000000,
    "Number Of Local Employees": 40,
    "Number Of Foreign Employees": 3,
    Status: "Approved",
    "Investor Address":
      "1 F SoGo Kojimachi Dai 3 BLDG 1-6 Kojimachi Chiyoda- Ku, Tokyo , 102 Japan",
    "Organization Address":
      "10 Collyer Quay No.21-01 Ocean Building Singapore 0104",
    "Investment Permitted Address":
      "Corner of Inya Road and Panwa Road, Yangon.\n339 Bogyoke Aung San Road,\nSakura Tower,Kyauktada, Yangon, Myanmar",
  },
  {
    ID: 3011,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "ဒေါ်ရှောက်ဖွေ",
    "Name of Principal Organization": "Mottama Holding Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Mottama Logistic Co., Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "108/18",
    "Permit Date": "2018-07-30T07:38:10Z",
    "Meeting Number": "10/2018",
    "Meeting Date": "2018-07-26T07:38:23Z",
    Sector: "Other Services",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 14636.45,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးရန်ဟော်",
    "Land Area (units not specified in file)": 6.634,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 107,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်-၅ဇ-၂/၂၊ အောင်မင်္ဂလာလမ်း၊ အမှတ်(၄)ရပ်ကွက်၊ မရမ်းကကုန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address":
      "No.56, Room No.501, Kabaraye Pagoda Road, Yankin Township, Yangon",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၂၁၊ ဆိပ်ကမ်းသာလမ်း၊ ဇုန်(၇)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 3012,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "ဒေါ်ရှောက်ဖွေ",
    "Name of Principal Organization": "Mottama Holding Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Mottama Logistic Co., Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "107/18",
    "Permit Date": "2018-07-30T08:09:20Z",
    "Meeting Number": "10/2018",
    "Meeting Date": "2018-07-26T08:09:29Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "ဆိပ်ခံတံတားမှ ကုန်သေတ္တာ တင်/ချခြင်း၊ ကုန်သေတ္တာသိုလှောင်ခြင်းနှင့် ထိန်းသိမ်း ပို့ဆောင်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 8455.24,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးရန်ဟော်",
    "Land Area (units not specified in file)": 2.715,
    "Lease Term": 50,
    "Annual Lease Fee": 37.081,
    "Land Use Premium": null,
    "Number Of Local Employees": 107,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်-၅ဇ-၂/၂၊ အောင်မင်္ဂလာလမ်း၊ အမှတ်(၄)ရပ်ကွက်၊ မရမ်းကုန်းမြို့နယ်၊     ရန်ကုန်မြို့",
    "Organization Address":
      "No.56, Room No. 501, Kabaraye Road, Yankin Township, Yangon",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၂၄(A,B)၊ မြေတိုင်းရပ်ကွက်အမှတ်-၃၉(စက်မှု)၊ ဆိပ်ကမ်းသာလမ်း၊ စက်မှုဇုန်အပိုင်း(၂)၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 3015,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Thein Shwe",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": " La Pyayt Wun Co., Ltd.",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "080/1997",
    "Permit Date": "1997-07-17T03:52:14Z",
    "Meeting Number": "10/1997",
    "Meeting Date": "1997-06-25T03:52:40Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Construction and Leasing  of  Commercial Complex, Office & Apartment and Shopping Center.",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 230,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "နယ်စပ်ဒေသနှင့် တိုင်းရင်းသားလူမျိုးများ ဖွံ့ဖြိုးတိုးတက်ရေးနှင့် စည်ပင်သာယာရေး ဝန်ကြီးဌာန၊ စည်ပင်သာယာရေး ဦးစီးဌာန",
    "Land Area (units not specified in file)": 0.51,
    "Lease Term": 30,
    "Annual Lease Fee": 10.02,
    "Land Use Premium": 76.5,
    "Number Of Local Employees": 105,
    "Number Of Foreign Employees": 6,
    Status: "Approved",
    "Investor Address":
      "No. 82, Ground Floor, 32 Street, Pabedan Township, Yangon.",
    "Organization Address": "",
    "Investment Permitted Address":
      "Alanpya Pagoda Road, Dagon Township, Yangon Region.",
  },
  {
    ID: 3016,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "System-Bilt(Myanmar)Co., Ltd. ",
    "Financial Year From": 0,
    "Financial Year To": 0,
    "Permit Number": "086/1993",
    "Permit Date": "1993-11-16T03:57:42Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 85,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Singapore",
    "Form Of Investment": "",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "Singapore ",
    "Organization Address": "",
    "Investment Permitted Address": "Dagon Township, Yangon ",
  },
  {
    ID: 3017,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LERTSAK NO PMA NEECHAMRASLERT ",
    "Name of Principal Organization": "L.S GROUP CO., LTD. ",
    "Place of Incorporation": "thailand ",
    "Company Name In Myanmar": "LP HOLDINGS CO., LTD. ",
    "Financial Year From": 93,
    "Financial Year To": 94,
    "Permit Number": "087/1993",
    "Permit Date": "1993-11-16T04:12:27Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Business ",
    "Amount Of Foreign Capital USD (in Millions)": 2.1,
    "Total Amount Of Capital (in Millions)": 20,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 34,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII,BOT",
    "Land Owner": "ဟိုတယ်နှင့်ခရီးသွားလာရေးလုပ်ငန်းဝန်ကြီးဌာန ",
    "Land Area (units not specified in file)": 1.07,
    "Lease Term": 30,
    "Annual Lease Fee": 0.42,
    "Land Use Premium": null,
    "Number Of Local Employees": 350,
    "Number Of Foreign Employees": 3,
    Status: "Monitoring Approved",
    "Investor Address":
      "99/2 MOO 1 SOI WACHI RA THUMSATHIT, SUKHUMVIT, 101/1, RD, NONGBON PRAVES. ",
    "Organization Address":
      "3354/23, RAMA 4 RD 7th FI, MANOROM BUILDING , BANGKOK",
    "Investment Permitted Address":
      "CORNER OF SULAE PAGODA ROAD AND STRAND ROAD , YANGON ",
  },
  {
    ID: 3019,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Doopung International Company Limited",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "110/94",
    "Permit Date": "2019-05-25T06:54:31Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "လျှပ်စစ်ဆိုင်ရာပစ္စည်းများထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.439,
    "Total Amount Of Capital (in Millions)": 0.439,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address": "-",
  },
  {
    ID: 3021,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Triumph International Limited",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "187/1996",
    "Permit Date": "1996-06-24T08:12:32Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "FOB စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": 15,
    "Total Amount Of Capital (in Millions)": 15,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address": "-",
  },
  {
    ID: 3022,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Noveau Steel Company Limited",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "239/1996",
    "Permit Date": "1996-12-18T08:23:08Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "သွပ်ပြားများထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 7.84,
    "Total Amount Of Capital (in Millions)": 7.84,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address": "-",
  },
  {
    ID: 3023,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Texcamp Industrial Limited",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "282/1997",
    "Permit Date": "1997-09-04T17:30:01Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် ဇာထိုးခြင်းနှင့်အထည်ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address": "-\n",
  },
  {
    ID: 3024,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR,  LE HUNG",
    "Name of Principal Organization":
      "Hoang Anh Construction and Development House Joint Stock Company",
    "Place of Incorporation": "Socialist Republic Of Vietnam",
    "Company Name In Myanmar": "Hoang Anh Gia Lai Myanmar Company Limited",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "525/2012",
    "Permit Date": "2012-11-30T04:20:59Z",
    "Meeting Number": "36/2012",
    "Meeting Date": "2012-11-29T04:22:31Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business":
      "Construction and Operation of Hotel   ,Commercial  Center , Office Building, Serviced Apartment ",
    "Amount Of Foreign Capital USD (in Millions)": 440,
    "Total Amount Of Capital (in Millions)": 440,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII,BOT",
    "Land Owner": "Ministry of Hotel and Tourism",
    "Land Area (units not specified in file)": 18.131,
    "Lease Term": 30,
    "Annual Lease Fee": 6.332,
    "Land Use Premium": 54.39,
    "Number Of Local Employees": 450,
    "Number Of Foreign Employees": 72,
    Status: "Monitoring Approved",
    "Investor Address":
      "18/5Q Pham No.18/5Q Pham   Van  Chieu Street ,Ward 9  ,Go Vap Dist, Ho Chi Minh City ,Vitenam",
    "Organization Address":
      "783, Tran Xuan Soan Street, Tan Hung Ward, District 7, Ho Chi Minh City, Vietnam",
    "Investment Permitted Address":
      "No.192, Kaba Aye Pagoda Road, Bahan Township, Yangon Region",
  },
  {
    ID: 3026,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kuok Khoon Ean",
    "Name of Principal Organization": "Kuok(Singapore)Ltd. ",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Shangri-La Yangon Co., Ltd. ",
    "Financial Year From": 93,
    "Financial Year To": 94,
    "Permit Number": "099/1994",
    "Permit Date": "1994-03-26T02:44:52Z",
    "Meeting Number": "6/1994",
    "Meeting Date": "1994-03-16T02:47:26Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 100,
    "Total Amount Of Capital (in Millions)": 600,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "BOT,FDII",
    "Land Owner": "Directorate of Hotels and Tourism ",
    "Land Area (units not specified in file)": 14.85,
    "Lease Term": 50,
    "Annual Lease Fee": 0.4,
    "Land Use Premium": 3.93,
    "Number Of Local Employees": 974,
    "Number Of Foreign Employees": 4,
    Status: "Monitoring Approved",
    "Investor Address":
      "BLK 11, Nathan Road, 24-02 Regency Park, Singapore 1024. ",
    "Organization Address":
      "BLK 11, Nathan Road, 24-02 Regency Park, Singapore 1024. ",
    "Investment Permitted Address":
      "At the Junction of Upper Pansondan Street and Kan Yeik Tha Street, Yangon",
  },
  {
    ID: 3029,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Thaw Dar Sein, MD, MHTS",
    "Name of Principal Organization": "Myanmar Hotel & Tourism Services",
    "Place of Incorporation": "Yangon",
    "Company Name In Myanmar": "Myanmar Hotels International Ltd.",
    "Financial Year From": 1990,
    "Financial Year To": 1991,
    "Permit Number": "026/1990",
    "Permit Date": "2019-05-15T08:05:48Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business":
      "Hotel Services (Strand Hotel, Inya Lake Hotel and Thamada Hotel)",
    "Amount Of Foreign Capital USD (in Millions)": 5,
    "Total Amount Of Capital (in Millions)": 12,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 30,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Virgin Islands (British)",
    "Form Of Investment": "JV",
    "Land Owner": "Ministry of Hotel & Tourism ",
    "Land Area (units not specified in file)": null,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 294,
    "Number Of Foreign Employees": 184,
    Status: "Monitoring Approved",
    "Investor Address": "No 77-91, Sule Pagoda Road, Yangon",
    "Organization Address": "No 77-91, Sule Pagoda Road, Yangon",
    "Investment Permitted Address": "No 77-91, Sule Pagoda Road, Yangon",
  },
  {
    ID: 3032,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေါ်မြမြဝင်း",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Syiza Company Limited ",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "မနသ ၁၀၆/၁၉၉၇",
    "Permit Date": "1997-12-26T03:20:29Z",
    "Meeting Number": "20/1997",
    "Meeting Date": "1997-12-05T03:21:33Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "ရုံးခန်း၊ လူနေအိမ်ခန်းနှင့် ဈေးဆိုင်ခန်းများပါဝင်သော စီးပွားရေးအဆောက်အအုံ ဆောက်လုပ်ငှားရမ်းခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 103.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Mya Mya Win ",
    "Land Area (units not specified in file)": 0.086,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 78,
    "Number Of Foreign Employees": 3,
    Status: "Approved",
    "Investor Address":
      "၁၃/၂၃ (က)၊ ရွှေဝါလမ်း၊ မာန်အောင်ရပ်ကွက်၊ တာမွေမြို့နယ်၊ ရန်ကုန်",
    "Organization Address": "",
    "Investment Permitted Address": "၆၉၃၊ ကုန်သည်လမ်း၊ ပန်ဘဲတန်း၊ ရန်ကုန်",
  },
  {
    ID: 3035,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Kurosawa Trust Company Limited",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "285/1997",
    "Permit Date": "1997-09-30T06:17:16Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အလှဆင်ကျောက်များထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 7.49,
    "Total Amount Of Capital (in Millions)": 7.49,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address": "-",
  },
  {
    ID: 3036,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms.Hsu Shu Fon",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Tah Hsin Industrial Company Limited",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "358/2001",
    "Permit Date": "2001-03-11T06:23:37Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 9,
    "Total Amount Of Capital (in Millions)": 9,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address": "-",
  },
  {
    ID: 3037,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Hae Wae Company Limited",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "294/1997",
    "Permit Date": "1997-11-28T06:36:29Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 3.4,
    "Total Amount Of Capital (in Millions)": 3.4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Guinea-Bissau",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address": "-",
  },
  {
    ID: 3038,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Glogon Company Limited",
    "Financial Year From": 2001,
    "Financial Year To": 2002,
    "Permit Number": "359/2001",
    "Permit Date": "2001-03-11T06:41:17Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 3.335,
    "Total Amount Of Capital (in Millions)": 3.335,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address": "-",
  },
  {
    ID: 3039,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Htun Myint Naing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Asia World Co., Ltd.",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "manatha 152/1998",
    "Permit Date": "1998-07-15T10:44:52Z",
    "Meeting Number": "10/1998",
    "Meeting Date": "1998-06-12T10:46:40Z",
    Sector: "Construction",
    "Type Of Investment Business": "Naung cho - Lashio Road ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1238,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No. 20-23, Masoeyein kyaung street, ward No.5 , Mayangone TS, Yangon ",
    "Organization Address": "",
    "Investment Permitted Address":
      " No.(61/62), Bahosi Development, Wardan Street, , Lanmadaw Township, YANGON",
  },
  {
    ID: 3040,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ဒီဖရက်ဒရစ်(ခ်)အင်တာနေရှင်နယ်ကုမ္ပဏီလိမိတက်",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "မနသ ၆၂၂/၂၀၀၃",
    "Permit Date": "2003-05-06T02:00:33Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီအထည်အမျိုးမျိုးချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.01,
    "Total Amount Of Capital (in Millions)": 13.03,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address": "-",
  },
  {
    ID: 3041,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ရွှေစပယ်ချစ်သူများထုတ်လုပ်မှုကုမ္ပဏီလိမိတက်",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "မနသ ၆၂၇/၂၀၀၃",
    "Permit Date": "2003-05-07T04:48:43Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီအဝတ်ထည်များချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 21.02,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်(၁၆)၊မြေတိုင်းရပ်ကွက်(၉)၊အမရာ(၂)လမ်း၊လှိုင်သာယာမြို့နယ်",
  },
  {
    ID: 3042,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "လမ်းသစ်စက်မှုလုပ်ငန်းများကုမ္ပဏီလိမိတက်",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "မနသ၆၃၁/၂၀၀၃",
    "Permit Date": "2003-06-20T04:56:56Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့်အမျိုးသား၊အမျိုးသမီးဝတ် သားရေရှူးဖိနပ်များထုတ်လုပ်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 125.18,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address": "-",
  },
  {
    ID: 3043,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "လင်းထက်စက်မှုလုပ်ငန်းကုမ္ပဏီလိမိတက်",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "မနသ ၆၃၄/၂၀၀၃",
    "Permit Date": "2003-07-14T05:01:40Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် ဆွယ်တာနှင့်သိုးမွှေးထိုးထည်ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.07,
    "Total Amount Of Capital (in Millions)": 38.44,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "(၅၁)။အမှတ်၃/စျ၊အမှတ်(၆ က)ကြိုးစက်ရုံလမ်း၊သုဝဏ္ဏ၊ သင်္ဃကျွန်းမြို့နယ်",
  },
  {
    ID: 3044,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "မီးပြတိုက်ထုတ်လုပ်မှုကုမ္ပဏီလိမိတက်",
    "Financial Year From": 2005,
    "Financial Year To": 2006,
    "Permit Number": "မနသ ၆၅၉/၂၀၀၅",
    "Permit Date": "2005-02-09T05:13:27Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Standard Crumb Rubber များထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.46,
    "Total Amount Of Capital (in Millions)": 33.28,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(174/184/185/186/187)၊စက်မှု(၁၀)လမ်းဦ၊မြေတိုင်းအမှတ်(၄၂)၊ စက်မှုဇုံ(၁) ရွှေပြည်သာမြို့နယ်",
  },
  {
    ID: 3045,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ဇီးကွက်ဖြူဖက်ရှင် ကုမ္ပဏီလိမိတက်",
    "Financial Year From": 2006,
    "Financial Year To": 2007,
    "Permit Number": "မနသ၆၇၃/၂၀၀၆",
    "Permit Date": "2005-10-25T05:27:40Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 45,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်(၄၁)၊မြေတိုင်းရပ်ကွက်(၆၅)၊စက်မှုဇုံ(၄)၊ ရွှေပြည်သာမြို့နယ်၊ရန်ကုန်မြို့",
  },
  {
    ID: 3046,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Htun Myint Naing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Asia World Co., Ltd.",
    "Financial Year From": 2001,
    "Financial Year To": 2002,
    "Permit Number": "manatha 534/2002",
    "Permit Date": "2002-02-12T07:00:10Z",
    "Meeting Number": "42/2001",
    "Meeting Date": "2001-12-14T07:02:20Z",
    Sector: "Construction",
    "Type Of Investment Business": "BOT Road",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 2845,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Conner of pannita street and Insein Road, Ward No 8/9, Hlaing T/S, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      " No.(61/62), Bahosi Development, Wardan Street, , Lanmadaw Township, YANGON",
  },
  {
    ID: 3047,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Zaw Win Htun",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Shwe Than Lwin High Way Co., Ltd.",
    "Financial Year From": 2006,
    "Financial Year To": 2007,
    "Permit Number": "manatha 668/2006",
    "Permit Date": "2006-05-28T07:11:40Z",
    "Meeting Number": "6/2004",
    "Meeting Date": "2004-01-05T07:12:10Z",
    Sector: "Construction",
    "Type Of Investment Business": "BOT Road",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1127,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No 25/26, Thiri Mon Road, Thiri Mon Plaza, Mayangone T/S, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No 262, Yarzardirit compound, lower puzundaung Road, Yangon",
  },
  {
    ID: 3048,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Zaw Win Htun ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Shwe Than Lwin Highway Co., Ltd.",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "manatha 714/2009",
    "Permit Date": "2009-11-26T07:27:09Z",
    "Meeting Number": "26/2009",
    "Meeting Date": "2009-07-22T07:27:59Z",
    Sector: "Construction",
    "Type Of Investment Business": "BOT Road ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 6823.77,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 249,
    "Number Of Foreign Employees": 3,
    Status: "Approved",
    "Investor Address":
      "No. W 66, Thirimon Housing, Bayintnaung Road, Haling T/S, Yangon ",
    "Organization Address": "",
    "Investment Permitted Address":
      "No 262, Yarzardirit compound, lower puzundaung Road, Yangon",
  },
  {
    ID: 3049,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Zaw Win Htun",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Shwe Than Lwin Highway Co., Ltd.",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "manatha 715/2009 ",
    "Permit Date": "2009-11-26T07:50:49Z",
    "Meeting Number": "26/2009",
    "Meeting Date": "2009-07-22T07:51:29Z",
    Sector: "Construction",
    "Type Of Investment Business": "BOT Road",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 19700.89,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 978,
    "Number Of Foreign Employees": 3,
    Status: "Approved",
    "Investor Address":
      "No W-66, Bayint Naung Road, Thiri Mon Housing, Hlaing T/S, Yangon ",
    "Organization Address": "",
    "Investment Permitted Address":
      "No 262, Yarzardirit compound, lower puzundaung Road, Yangon",
  },
  {
    ID: 3050,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Kyaw Soe Lwin ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myat Noe Thu Construction Co., Ltd.",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "manatha 716/2009",
    "Permit Date": "2009-11-26T08:57:26Z",
    "Meeting Number": "34/2009",
    "Meeting Date": "2009-09-22T08:57:58Z",
    Sector: "Construction",
    "Type Of Investment Business": "BOT Road",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 12991.21,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 62,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "No 7(B), Kanyeiktha Road, Ward No .10, Mayangone T/S, Yangon ",
    "Organization Address": "",
    "Investment Permitted Address":
      "Building A 1, Room No 508, Shwe Gon Thu Housing, Lower Kyee Myin Daing Road, Yangon",
  },
  {
    ID: 3052,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Htun Myint Naing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Asia World Co., Ltd. ",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "manatha 720/2009",
    "Permit Date": "2009-12-14T09:38:24Z",
    "Meeting Number": "35/2009",
    "Meeting Date": "2009-09-29T09:39:11Z",
    Sector: "Construction",
    "Type Of Investment Business": "BOT Road",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 7260,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 325,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "Conner of pannita street and Insein Road, Ward No 8/9, Hlaing T/S, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No 61/62, Bahosi Housing, Wardan Street, Lanmadaw T/S, Yangon",
  },
  {
    ID: 3053,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Htun Myint Naing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Asia World Co., Ltd.",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "manatha 721/2009",
    "Permit Date": "2009-12-14T10:03:50Z",
    "Meeting Number": "35/2009",
    "Meeting Date": "2009-09-29T10:04:49Z",
    Sector: "Construction",
    "Type Of Investment Business": "BOT road ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 29589.11,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 381,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "Conner of pannita street and Insein Road, Ward No 8/9, Hlaing T/S, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No 61/62, Bahosi Housing, Wardan Street, Lanmadaw T/S, Yangon",
  },
  {
    ID: 3054,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Maria Fong Lee",
    "Name of Principal Organization": "Emerald Development LTD",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "EMERALD ROSE GARDEN LIMITED",
    "Financial Year From": 1993,
    "Financial Year To": 1994,
    "Permit Number": "079/1993",
    "Permit Date": "1993-07-30T03:16:49Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel & Tourism Related Services",
    "Amount Of Foreign Capital USD (in Millions)": 12,
    "Total Amount Of Capital (in Millions)": 12,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII,BOT",
    "Land Owner": "Department of Hotel and Tourism",
    "Land Area (units not specified in file)": null,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address":
      "A 11, A 13, 5 th Floor., BLK A., Industrial Centre, 489-491, Castle Peak Road, Kowloon, Hong Kong ",
    "Organization Address": "Hong Kong",
    "Investment Permitted Address":
      "Upper Pansodan Road\nNo.171Garden Quarter, Mingalar Taungnyunt Township, Yangon, Myanmar",
  },
  {
    ID: 3055,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ကမ္ဘာတဝှမ်းလျှပ်စစ်နည်းပညာကုမ္ပဏီလိမိတက်",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "မနသ ၈၄၅/၂၀၁၂",
    "Permit Date": "2012-05-09T03:43:04Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီထရန်စ​ဖ​ော်မာအပိုပစ္စည်းထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.16,
    "Total Amount Of Capital (in Millions)": 214.21,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address": "-",
  },
  {
    ID: 3056,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ရွေ့လျားသော စက်မှုလုပ်ငန်းကုမ္ပဏီလိမိတက်",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "မနသ၈၄၇/၂၀၁၂",
    "Permit Date": "2012-05-31T03:51:26Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "မော်တော်ယာဉ်ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 4.16,
    "Total Amount Of Capital (in Millions)": 3771.39,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၅၂၊၇၉)၊ ဒဂုံဆိပ်ကမ်းစက်မှုဇုန်၊ဒဂုံဆိပ်ကမ်းမြို့နယ်၊ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 3057,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Global Alliance Industiral and Production Co.,Ltd",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "မနသ ၈၅၁/၂၀၀၁၂",
    "Permit Date": "2012-07-11T04:04:23Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "စီးကရက်ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.62,
    "Total Amount Of Capital (in Millions)": 6682.47,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၆၄)၊မြေတိုင်းရပ်ကွက်အမှတ်(၁၄)၊ရွှေသံလွင်စက်မှုဇုန်၊လှိုင်သာယာမြို့နယ်၊",
  },
  {
    ID: 3058,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Ture Faith Company Limited",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "မနသ ၈၅၄/၂၀၁၂",
    "Permit Date": "2012-07-11T04:13:50Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အထည်အမျိုးမျိုးချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 189.33,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၅၈/၅၉/၆၀/၇၃/၇၄/၇၅)၊ မြေတိုင်းရပ်ကွက်အမှတ်(၁၈)၊ရွေ့ပေါက်ကံစက်မှုဇုံ၊မြောက်ဉက္ကလာပမြို့နယ်",
  },
  {
    ID: 3059,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Tough Way Garment Manufacturing Company Limited",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "မနသ ၈၆၁/၂၀၁၂",
    "Permit Date": "2012-07-27T04:26:19Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အထည်အမျိုးမျိုးချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 80.63,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "ကနောင်မင်းသားကြီးလမ်း၊ ရွှေပြည်သာစက်မှုဇုန်(၁)၊ ရွှေပြည်သာမြို့နယ်၊ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 3062,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Tay Za",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "CENTRAL MARKETING COMPANY LIMITED",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "Ma Na Tha 544/2002",
    "Permit Date": "2002-06-06T06:00:11Z",
    "Meeting Number": "14/2002",
    "Meeting Date": "2002-05-03T06:01:00Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "ရုံးခန်း၊ လူနေအိမ်ခန်း၊ စျေးဆိုင်ခန်းနှင့် ပလာဇာများ တည်ဆောက်၍ ဖွင့်လှစ်လုပ်ကိုင်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 37.81,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Thida Zaw (ပုဂ္ဂလိကပိုင်မြေ)",
    "Land Area (units not specified in file)": 0.42,
    "Lease Term": 10,
    "Annual Lease Fee": 2.4,
    "Land Use Premium": null,
    "Number Of Local Employees": 40,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "No. 86, Innyar Road, Kamayut Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Pyay Road,No.(5),Hlaing Township, Yangon, Myanmar 11052",
  },
  {
    ID: 3063,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Htun Myint Naing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Asia World Co., Ltd.",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "manatha 722/2009",
    "Permit Date": "2009-12-14T06:09:59Z",
    "Meeting Number": "35/2009",
    "Meeting Date": "2009-09-29T06:10:51Z",
    Sector: "Construction",
    "Type Of Investment Business": "BOT Road ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 7093.11,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 338,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "Conner of pannita street and Insein Road, Ward No 8/9, Hlaing T/S, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No 61/62, Bahosi Housing, Wardan Street, Lanmadaw T/S, Yangon",
  },
  {
    ID: 3067,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Ne Win Kyaw ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "High Land Road Construction Co., Ltd.",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "manatha 723/2009",
    "Permit Date": "2009-12-14T06:37:22Z",
    "Meeting Number": "35/2009",
    "Meeting Date": "2009-09-29T06:37:54Z",
    Sector: "Construction",
    "Type Of Investment Business": "BOT Road ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 30658.99,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 300,
    "Number Of Foreign Employees": 5,
    Status: "Approved",
    "Investor Address":
      "building 3 , Room 302 , conner of kabaaye pagoda road and pyay road, Mayangone T/S, Yangon ",
    "Organization Address": "",
    "Investment Permitted Address":
      "building 3 , Room 302 , conner of kabaaye pagoda road and pyay road, Mayangone T/S, Yangon ",
  },
  {
    ID: 3068,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Zaw Naing ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Shwe Taung Development Co., Ltd. ",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "manatha 732/2010",
    "Permit Date": "2010-02-08T07:12:43Z",
    "Meeting Number": "42/2009",
    "Meeting Date": "2009-12-01T07:13:33Z",
    Sector: "Construction",
    "Type Of Investment Business": "BOT Road ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 29822.49,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 109,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address": "2 ne floor, Olympic Tower, Ahlone T/S, Yangon ",
    "Organization Address": "",
    "Investment Permitted Address":
      "No 584, 4 th Floor, Strand Road, Ahlone T/S, Yangon ",
  },
  {
    ID: 3071,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Zaw naing",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Shwe Taung Development Co., Ltd. ",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "manatha 733/2010",
    "Permit Date": "2010-02-08T08:47:18Z",
    "Meeting Number": "42/2009",
    "Meeting Date": "2009-12-01T08:48:11Z",
    Sector: "Construction",
    "Type Of Investment Business": "BOT Road ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 23757.08,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 91,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "2nd Floor, Olympic Tower, Strand Road, Ahlone T/S, Yangon ",
    "Organization Address": "",
    "Investment Permitted Address":
      "No 584, 4 th Floor, Strand Road, Ahlone T/S, Yangon ",
  },
  {
    ID: 3075,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Austral Amalgamated Tin Bhd",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Austral Amalgamated ",
    "Financial Year From": 0,
    "Financial Year To": 0,
    "Permit Number": "120/1994",
    "Permit Date": "1994-12-07T01:59:40Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 0,
    "Currency Of Total Amount": "",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "",
    "Form Of Investment": "",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Monitoring Approved",
    "Investor Address": "Malaysia ",
    "Organization Address": "",
    "Investment Permitted Address": "Malaysia ",
  },
  {
    ID: 3076,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Thai Industrial Connection Co., Ltd.",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Royal Lake Hotel Co., Ltd. ",
    "Financial Year From": 0,
    "Financial Year To": 0,
    "Permit Number": "121/1994",
    "Permit Date": "1994-12-12T02:04:38Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 0,
    "Currency Of Total Amount": "",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "",
    "Form Of Investment": "",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "Thailand",
    "Organization Address": "",
    "Investment Permitted Address": "Thailand ",
  },
  {
    ID: 3077,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Zaw Zaw",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Max Highway Co., Ltd. ",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "manatha 1179/2016",
    "Permit Date": "2016-03-26T03:49:34Z",
    "Meeting Number": "11/2016",
    "Meeting Date": "2016-03-25T03:50:28Z",
    Sector: "Construction",
    "Type Of Investment Business": "BOT Road ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 21916.91,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": 45,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 221,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "No 9, Inya Avenue Road, Ward No 10, Mayangone T/S, Yangon ",
    "Organization Address": "",
    "Investment Permitted Address": "No 528, Yar Kyaw Street, Insein New T/S",
  },
  {
    ID: 3078,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Yin Htwe Thet",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "CENTRAL MARKETING COMPANY LIMITED",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "Ma Na Tha 053/96",
    "Permit Date": "1996-12-18T04:10:34Z",
    "Meeting Number": "18/96",
    "Meeting Date": "1996-11-29T04:51:33Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီပလာဇာ၊ ရုံးခန်း၊ စျေးဆိုင်ခန်းနှင့် လူနေအိမ်ခန်းများ ဆောက်လုပ်၍ ငှားရမ်းခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 32.2,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ပုဂ္ဂလိကပိုင်မြေ( ကုမ္ပဏီပိုင်မြေ)",
    "Land Area (units not specified in file)": 0.624,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 75,
    "Number Of Foreign Employees": 4,
    Status: "Approved",
    "Investor Address":
      "No.31 (F), Mahar Myaing Street, Sanchaung Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Pyay Road,No.(5),Hlaing Township, Yangon, Myanmar 11052\nMay Taing Block No. 81, No.7 B-4, Pyay Road, Kamaryut Township, Yangon",
  },
  {
    ID: 3079,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Tay Za",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Ayeyarwaddy Resorts & Lodges Company Limited ",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "Ma Na Tha 786/2011",
    "Permit Date": "2011-02-10T04:22:19Z",
    "Meeting Number": "2/2011",
    "Meeting Date": "2011-01-13T04:22:50Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business":
      "Kandawgyi Palace Hotel Project အား ဟိုတယ်ဝန်ဆောင်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 43387.29,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Government Land",
    "Land Area (units not specified in file)": 5.507,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 176,
    "Number Of Foreign Employees": 3,
    Status: "Approved",
    "Investor Address": "No. 86, Inn Yar Street, Kamayut Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Khapaung Street,No.(11/A),Hlaing Township, Yangon, Myanmar 11051\nMay Taing Block No-1, No-1, 2-A, 2- B, 2-C, Kanyeik Thar Street, Bahan Township, Yangon,",
  },
  {
    ID: 3081,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U La San",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Nothern Royal Jade Co.,Ltd",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "manatha 1066/2015",
    "Permit Date": "2015-07-24T06:55:40Z",
    "Meeting Number": "12/2015",
    "Meeting Date": "2015-07-03T06:58:06Z",
    Sector: "Construction",
    "Type Of Investment Business":
      "မူလလမ်းဟောင်းအား BOT စနစ်ဖြင့် လမ်းအဆင့်မြှင့်တင်၍ လမ်းအသုံးပြုခကောက်ခံခြင်းလုပ်ငန်း  ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 20879.5,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 45,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 70,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "No.28, 7 mine Housing, conner of Pyay Road and Parami Road,  Mayangone T/S, Yangon ",
    "Organization Address": "",
    "Investment Permitted Address":
      "No .45, Aungthapyay Road, Middle  kyuntaw Quarter, Sanchaung T/S, Yangon ",
  },
  {
    ID: 3082,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဗိုလ်ချုပ်ဝင်းသန်း ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ပြည်ထောင်စုမြန်မာနိုင်ငံစီးပွားရေးဦးပိုင်လီမိတက် ",
    "Financial Year From": 2010,
    "Financial Year To": 2011,
    "Permit Number": "manatha 761/2010",
    "Permit Date": "2010-10-22T09:33:16Z",
    "Meeting Number": "20/2010",
    "Meeting Date": "2010-06-18T09:39:59Z",
    Sector: "Construction",
    "Type Of Investment Business": "BOT Road ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 65512.1,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 818,
    "Number Of Foreign Employees": 0,
    Status: "Monitoring Approved",
    "Investor Address": "အမှတ် -၇၉၊ ကမ်းနားလမ်း၊ မဟာဗောဓိရပ်ကွက်၊ မအူပင်မြို့ ",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ် ၁၈၉/၁၉၁၊ မဟာဗန္ဓုလလမ်း၊ ဗိုလ်တစ်ထောင်မြို့နယ်၊ ရန်ကုန်မြို့ ",
  },
  {
    ID: 3083,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyaw Soe Lwin",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myat Noe Thu Construction Co., Ltd. ",
    "Financial Year From": 2009,
    "Financial Year To": 2010,
    "Permit Number": "manatha 734/2010",
    "Permit Date": "2010-02-08T10:20:14Z",
    "Meeting Number": "42/2009",
    "Meeting Date": "2009-12-01T10:21:43Z",
    Sector: "Construction",
    "Type Of Investment Business": "BOT Road ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 5970.28,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "Ministry of Construction",
    "Land Area (units not specified in file)": null,
    "Lease Term": 40,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 32,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address":
      "No.7(kha), kanyeiktha Street, Ward no(10), Mayangone T/S, Yangon ",
    "Organization Address": "",
    "Investment Permitted Address":
      "No. A(1), Room 508, Shwegonthu Housing, Lower kyeemyindaing Road, Yangon ",
  },
  {
    ID: 3084,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Yaw Sett",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Golden Butterfly Company Limited",
    "Financial Year From": 1995,
    "Financial Year To": 1996,
    "Permit Number": "Ma Na Tha 011/96",
    "Permit Date": "1996-03-06T03:35:26Z",
    "Meeting Number": "15/1995",
    "Meeting Date": "1995-12-08T03:38:19Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 59,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ပုဂ္ဂလိကပိုင်မြေ",
    "Land Area (units not specified in file)": 0.604,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 110,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No.12, Ko Min Ko Chin Street, Bo Cho Quarter, Bahan Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.12, Ko Min Ko Chin Street, Bo Cho Quarter, Bahan Township, Yangon",
  },
  {
    ID: 3086,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Than Htay",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Forest Joint Venture Commercial Centre Co., Ltd.",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "MaNaTha 131/1998",
    "Permit Date": "1998-04-03T06:30:11Z",
    "Meeting Number": "5/1998",
    "Meeting Date": "1998-03-06T06:31:11Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "စီးပွားရေးအဆောက်အဦ( Commercial Centre) တစ်ခုတည်ဆောက်ငှားရမ်းခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 60.64,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT",
    "Land Owner": "သစ်တောရေးရာဝန်ကြီးဌာန၊မြန်မာ့သစ်လုပ်ငန်း",
    "Land Area (units not specified in file)": 0.41,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": 0.8,
    "Number Of Local Employees": 61,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "သစ်တောထွက်ပစ္စည်းဖက်စပ်ကော်ပိုရေးရှင်း လီမီတက် သစ်တောလမ်းနှင့် ကမ်းနားလမ်းထောင့်၊ အလုံမြို့နယ်",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ် (၄၂၂၊၄၂၆)၊ ဗိုလ်တထောင်ဘုရားလမ်းနှင့် ကမ်းနားလမ်းထောင့်၊ဗိုလ်တထောင်မြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 3092,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lien Ian George Winston",
    "Name of Principal Organization": "SCCP Lakeside Pte. Ltd",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "SCCP LAKESIDE COMPANY LIMITED",
    "Financial Year From": 2014,
    "Financial Year To": 2015,
    "Permit Number": "719/2014",
    "Permit Date": "2014-04-29T09:42:07Z",
    "Meeting Number": "12/2014",
    "Meeting Date": "2014-04-10T03:56:01Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business":
      "Construction and Operation of Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": 23.713,
    "Total Amount Of Capital (in Millions)": 23.713,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII,BOT",
    "Land Owner": "U Zaw Myint Aung, U Ye Myint Aung, Daw Sabae Myint Aung",
    "Land Area (units not specified in file)": 0.361,
    "Lease Term": 50,
    "Annual Lease Fee": 0.342,
    "Land Use Premium": null,
    "Number Of Local Employees": 150,
    "Number Of Foreign Employees": 10,
    Status: "Terminated",
    "Investor Address": "12 Greenleaf View, Singapore 279252",
    "Organization Address":
      "390, Orchid Road, # 09-03/04 Palais Renaissance, Singapore 238871",
    "Investment Permitted Address":
      "No. 9, 6 Miles\nHlaing Township, Yangon Region, Myanmar 11051",
  },
  {
    ID: 3094,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Max James Beresford Horsley",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Sanctuary Retreats Myanmar Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "622/2013",
    "Permit Date": "2013-09-16T05:44:19Z",
    "Meeting Number": "21/2013",
    "Meeting Date": "2013-08-15T05:44:34Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "မြစ်ကြောင်းသွားအပျော်စီးသင်္ဘောနှင့် ခရီးသွားလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 5.2,
    "Total Amount Of Capital (in Millions)": 5.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Luxembourg",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 48,
    "Number Of Foreign Employees": 4,
    Status: "Approved",
    "Investor Address":
      "MAS DU FAUCON CHEMAIN DE FAUCOM 1040. COGOLIN VAR 83310,FRANCE.",
    "Organization Address": "",
    "Investment Permitted Address":
      "Shwe Taung Dan Street,No.(67) Lanmadaw Township, Yangon Region, Myanmar",
  },
  {
    ID: 3095,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor":
      "ညွှန်ကြားရေးမှူးချုပ်၊ မြို့ရွာနှင့် အိုးအိမ်ဖွံ့ဖြိုးရေးဦးစီးဌာန",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Myanmar S.I  Recreation Development Company Limited",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "manatha 133/1998",
    "Permit Date": "1998-04-30T07:47:00Z",
    "Meeting Number": "6/1998",
    "Meeting Date": "1998-03-26T07:47:54Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ (၁၈) ကျင်းပါ ဂေါက်ကွင်း၊ ဂေါက်ကလပ်နှင့် အဆင့်မြင့်အိမ်ရာများ တည်ဆောင်လုပ်ကိုင်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 6591.72,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "မြို့ရွာနှင့် အိုးအိမ်ဖွံ့ဖြိုးရေးဦးစီးဌာန",
    "Land Area (units not specified in file)": 221.29,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 62,
    "Number Of Foreign Employees": 5,
    Status: "Amend",
    "Investor Address": "No.228/234 BoyokeAungSan Street,Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၇၃/၇၄)၊ ဒဂုံမြို့သစ်ဆိပ်ကမ်းမြို့နယ်၊ရန်ကုန်မြို့နယ်",
  },
  {
    ID: 3096,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Thatoe Hein",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Heritage Property Development Co., Ltd",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "Manatha-1138/2016",
    "Permit Date": "2016-03-09T08:26:32Z",
    "Meeting Number": "5/2016",
    "Meeting Date": "2016-02-15T08:31:37Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "No.10 Pyay Tower အမည်ဖြင့်အဆောက်အဦးဆောက်လုပ်ပြီးရုံးခန်းများ ငှားရမ်းခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 34075.75,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Thatoe Hein",
    "Land Area (units not specified in file)": 0.266,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 158,
    "Number Of Foreign Employees": 8,
    Status: "Approved",
    "Investor Address":
      "အမှတ် (၆၅/ အေ)၊တက္ကသိုလ်ရိပ်သာလမ်း၊ ရွှေတောင်ကြား(၁)ရပ်ကွက်၊ ဗဟန်းမြို့နယ်၊ရန်ကုန်တိုင်းဒေသကြီး။ ",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေတိုင်းရပ်ကွက် အမှတ်(၃၂)၊ မြေကွက်အမှတ် ၃/ဋ(၁)၊ အမှတ်(၁၀)၊ ပြည်လမ်း၊ လှိုင်မြို့နယ်၊ ရန်ကုန်မြို့။\nKyaik Wine Pagoda Road\nNo.(95/A), Mayangone Township, Yangon, Myanmar",
  },
  {
    ID: 3097,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Unknown",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Venture Private Limited",
    "Financial Year From": 1995,
    "Financial Year To": 1996,
    "Permit Number": "Ma Na Tha 006/95",
    "Permit Date": "1995-09-11T07:26:49Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 53.4,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Private Land",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No. 149, Thriri Yatanar Lane, 8 miles, Pyay Road, Mayangone Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No. 149, Thriri Yatanar Lane, 8 miles, Pyay Road, Mayangone Township, Yangon",
  },
  {
    ID: 3098,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Unknown ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Diamond Arrow International Company Limited",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "Ma Na Tha 076/97",
    "Permit Date": "1997-07-08T07:38:35Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ ရုံးခန်း၊ ဆိုင်ခန်းနှင့် လူနေအိမ်ခန်းများ ဆောက်လုပ်၍ ငှားရမ်းခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 216,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Private Land",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "Thiha Cinema, Between 39 and 40 street, Anawyahtar Road, Kyauktada Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Thiha Cinema, Between 39 and 40 street, Anawyahtar Road, Kyauktada Township, Yangon",
  },
  {
    ID: 3102,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Moe San Aung",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Thu Kha Yadanar Co., Ltd",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "Manatha-969/2014",
    "Permit Date": "2014-03-13T06:24:23Z",
    "Meeting Number": "7/2014",
    "Meeting Date": "2014-02-19T06:24:56Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "B.O.T စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီဟိုတယ်၊Residence၊ Office Building နှင့် Commercial Building များတည်ဆောက်၍ ငှားရမ်းခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 70000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Terminated",
    "Investor Address":
      "အမှတ်(၈၀/စီ)၊ ကမ္ဘောဇ(၂)လမ်း၊ ရွှေတောင်ကြား(၁)ရပ်ကွက်၊ဗဟန်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး။",
    "Organization Address": "",
    "Investment Permitted Address":
      "ကာကွယ်ရေးဦးစီးချုပ်ရုံး(ကြည်း)၊စစ်ထောက်ချုပ်ရုံးပိုင် ရန်ကုန်တိုင်းဒေသကြီး၊ဒဂုံမြို့နယ်၊ကမ္ဘာအေးဘုရားလမ်း၊အမှတ်(၁)မော်တော်ယာဉ်တပ်ရင်း (နေရာဟောင်း)၊ မြေတိုင်းရပ်ကွက် အမှတ်(၆၁)(၆၃)",
  },
  {
    ID: 3105,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Kyaw Soe ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "AGB Communication Company Limited ",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "158/2019",
    "Permit Date": "2019-05-30T08:56:46Z",
    "Meeting Number": "",
    "Meeting Date": "2019-05-29T08:56:53Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Network Facilities Services, Network Services and Application Services  ",
    "Amount Of Foreign Capital USD (in Millions)": 11.473,
    "Total Amount Of Capital (in Millions)": 19646.544,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 11,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ၁၂၊ အေးရိပ်မွန် ၉ လမ်း၊ လှိုင်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "Investment Location - Nationwide \nOffice Address- မြေကွက်အမှတ် (၁၀၁/၁)၊ တွင်းသင်းတိုက်ဝန်ဦးထွန်းညို လမ်း၊ စက်မှုဇုန် (၁)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်း ဒေသကြီး ",
  },
  {
    ID: 3107,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr. Zhai Meng ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Unilink Communication Company Limited ",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "160/2019",
    "Permit Date": "2019-05-30T03:48:45Z",
    "Meeting Number": "8/2019",
    "Meeting Date": "2019-06-29T03:49:00Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "NETWORK FACILITIES SERVICES, NETWORK  SERVICES  AND  APPLICATION  SERVICES ",
    "Amount Of Foreign Capital USD (in Millions)": 28.62,
    "Total Amount Of Capital (in Millions)": 28.62,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 14,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "ဒေါ်အေးနွဲ့ကြည်",
    "Land Area (units not specified in file)": null,
    "Lease Term": 5,
    "Annual Lease Fee": 0.126,
    "Land Use Premium": null,
    "Number Of Local Employees": 300,
    "Number Of Foreign Employees": 50,
    Status: "Approved",
    "Investor Address":
      "C 10-806, FULI YOU YICHENG HUANG CHANG NANLI, \tCHAOYANG, BEIJING, CHINA",
    "Organization Address": "",
    "Investment Permitted Address":
      "Investment Location - Nationwide \nOffice Address-  မြေကွက်အမှတ် (၈၁၆)၊ မြေတိုင်းရပ်ကွက်အမှတ် (၁၃)၊ သံသုမာလမ်း၊ တောင်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်တိုင်း ဒေသကြီး ",
  },
  {
    ID: 3108,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "ဦးဇော်မင်းဦး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MTG DC Company Limited ",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "043/2017",
    "Permit Date": "2017-12-30T05:08:50Z",
    "Meeting Number": "17/2017",
    "Meeting Date": "2017-12-22T05:09:10Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "ဆက်သွယ်ရေးကွန်ယက် အထောက်အကူပြု တာဝါတိုင် တည်ဆောက်ခြင်းနှင့် ပြင်ဆင်မွမ်းမံခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 16.008,
    "Total Amount Of Capital (in Millions)": 26490.267,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 58,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်-စီ/၇၊ ကမ္ဘာအေးဗီလာအိမ်ရာ၊ ကမ္ဘာအေးဘုရားလမ်း၊ အမှတ် (၅) ရပ်ကွက်၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "တိုက်အမှတ် ၁၁၊ အမှတ် ၅၀၅၊ MICT Park၊ လှိုင်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး\n\n  နေပြည်တော်၊ ရှမ်းပြည်နယ်အရှေ့ပိုင်း၊ ရှမ်းပြည်နယ်တောင်ပိုင်း၊ ရှမ်းပြည်နယ်မြောက်ပိုင်း",
  },
  {
    ID: 3110,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "ဦးဇော်မင်းဦး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Myanmar National Telecom Infra Company Limited ",
    "Financial Year From": 2016,
    "Financial Year To": 2017,
    "Permit Number": "066/2018",
    "Permit Date": "2018-03-27T08:37:49Z",
    "Meeting Number": "4/2018",
    "Meeting Date": "2018-03-20T08:39:08Z",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "တာဝါတိုင် ၆၀၀ တည်ဆောက်၍ ဆက်သွယ်ရေးကွန်ယက် အထောက်အကူပြု တာဝါတိုင် တည်ဆောက်ခြင်းနှင့် ပြင်ဆင်မွမ်းမံခြင်းလုပ်ငန်းဆောင်ရွက်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 15.34,
    "Total Amount Of Capital (in Millions)": 36000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ် ဂ/၁၇၊ ကမ္ဘာအေးဗီလာအိမ်ရာ၊ ကမ္ဘာအေးဘုရားလမ်း၊ မရမ်းကုန်မြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "အခန်းအမှတ် ၄၊ တိုက်အမှတ် ၄၊ MICT Park ၊ လှိုင်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 3112,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Daw Thin Thin Thwe",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myat Thit Oo Co.,Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "151/2019",
    "Permit Date": "2019-06-18T03:44:11Z",
    "Meeting Number": "9/2019",
    "Meeting Date": "2019-06-14T03:44:38Z",
    Sector: "Other Services",
    "Type Of Investment Business": "BASIC EDUCATION SERVICES",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 800,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Khin Sandar Naing, Daw Aye Sandar Myaing",
    "Land Area (units not specified in file)": 0.457,
    "Lease Term": 10,
    "Annual Lease Fee": 72,
    "Land Use Premium": null,
    "Number Of Local Employees": 54,
    "Number Of Foreign Employees": 13,
    Status: "Approved",
    "Investor Address": "3/A, BAWDIYEIKTHA ROAD, BAHAN TOWNSHIP, YANGON",
    "Organization Address": "",
    "Investment Permitted Address":
      "BUILDING (A), NO.72, CHINDWIN ROAD, KAMAYUT TOWNSHIP, YANGON REGION ",
  },
  {
    ID: 3113,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Paing Tha Htoo",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Novelty Service Co.,Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "149/2019",
    "Permit Date": "2019-05-30T04:28:44Z",
    "Meeting Number": "8/2019",
    "Meeting Date": "2019-05-29T04:28:53Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Education Services",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 1289.446,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Yee Yee Tha, U Dane Yain, Daw Khaw Win",
    "Land Area (units not specified in file)": 1.269,
    "Lease Term": 10,
    "Annual Lease Fee": 960,
    "Land Use Premium": null,
    "Number Of Local Employees": 82,
    "Number Of Foreign Employees": 36,
    Status: "Approved",
    "Investor Address":
      "No.35/B, Sein Lei Thar Street,Takkatho Yeikmon Housing Complex, Bahan Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Myay Taing Block No.35(B),Plot No.17(A,B,C),18(A,B), University Avenue Part (2), Bahan Township,Yangon Region and Myay Taing Block No.35(B),Plot No.(4/2 B,4 C4, 4C/1A), University Avenue Road, Bahan Township, Yangon Region",
  },
  {
    ID: 3114,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr. Yao Lang Chang",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Everclever (Myanmar) Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "156/2019",
    "Permit Date": "2019-05-30T05:57:30Z",
    "Meeting Number": "7/2019",
    "Meeting Date": "2019-05-11T05:57:41Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Education Services",
    "Amount Of Foreign Capital USD (in Millions)": 2.8,
    "Total Amount Of Capital (in Millions)": 4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "JV",
    "Land Owner": "U Kyi Yin",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 30,
    "Annual Lease Fee": 558,
    "Land Use Premium": null,
    "Number Of Local Employees": 24,
    "Number Of Foreign Employees": 12,
    Status: "Approved",
    "Investor Address":
      "2209, Sukhumvit road, bandchak, prakhanong, Bangkok, Thailand.",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.50, Pyay Road, Ward (11), Hlaing Township, Yangon Region",
  },
  {
    ID: 3115,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Nay Min Han",
    "Name of Principal Organization": "Eastern Nova Holdings PTE.LTD. ",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Everclever (Myanmar) Co.,Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "136/2019",
    "Permit Date": "2019-01-14T06:28:00Z",
    "Meeting Number": "1/2019",
    "Meeting Date": "2019-01-11T06:28:08Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Warehouse and Logistics Services",
    "Amount Of Foreign Capital USD (in Millions)": 10.5,
    "Total Amount Of Capital (in Millions)": 15,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "MK Co.,Ltd.",
    "Land Area (units not specified in file)": 12981,
    "Lease Term": 50,
    "Annual Lease Fee": 0.92,
    "Land Use Premium": null,
    "Number Of Local Employees": 126,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "Room No.301, No.23, Myay Nu Street, MyayNiGone (North) ward, Sanchaung Township, Yangon",
    "Organization Address": "21 B Duxion Hill , Singapore(089604)",
    "Investment Permitted Address":
      "Plot No. 245,246,247, Industrial Zone, Mingaladon Township, Yangon Region",
  },
  {
    ID: 3117,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Daw Khin Sandar Tun",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "AWRA ENERGY PUBLIC COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "159/2019",
    "Permit Date": "2019-05-30T04:41:28Z",
    "Meeting Number": "8/2019",
    "Meeting Date": "2019-05-29T04:42:29Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "construction of jetty and LPG storage tanks, importation, storage, distribution and sales of LPG",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 31000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Khin Sandar Tun",
    "Land Area (units not specified in file)": 8.77,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 35,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "Building No.1 (A2), Ywa Ma Kyaung Street, ",
    "Organization Address": "",
    "Investment Permitted Address":
      "Holding No.24/26, Kwin No.232, Danote Kwin, Danote Village Tract,  Dala Township, ",
  },
  {
    ID: 3118,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Than Tun",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "GOLDEN MYANMAR AIRLINES PUBLIC COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "154/2019",
    "Permit Date": "2019-04-08T05:17:04Z",
    "Meeting Number": "5/2019",
    "Meeting Date": "2019-04-05T05:18:15Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "importation, storage, distribution and transportation of jet fuel",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 44078.63,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Department of civil aviation",
    "Land Area (units not specified in file)": null,
    "Lease Term": 30,
    "Annual Lease Fee": 74.42,
    "Land Use Premium": 5000,
    "Number Of Local Employees": 180,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No.(52/KHA), Golden Valley Ward(2), Bahan Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Tachileik Airport, Kawthaung Airport, Nyaung Oo Airport, Heho Airport, Sittway Airport, Myitkyina AIrport, Mandalay International AIrport and Yangon Region, Thanlyin-Kyauktan Area, No.31/32(C), Thilawa Oil Tanks and Jetty Area",
  },
  {
    ID: 3126,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Yangon Sportswear Manufacturing Co.,Ltd.",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "108 /1994",
    "Permit Date": "1994-07-18T08:13:26Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments",
    "Amount Of Foreign Capital USD (in Millions)": 1.962,
    "Total Amount Of Capital (in Millions)": 1.962,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "Houng Kaung",
    "Organization Address": "-",
    "Investment Permitted Address": "-",
  },
  {
    ID: 3127,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar Elcon Gold Ltd.",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "109 /1994",
    "Permit Date": "1994-07-18T08:19:06Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သားရေထုတ်ကုန်အမျိုးမျိုးထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 6,
    "Total Amount Of Capital (in Millions)": 6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Malaysia",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address": "-",
  },
  {
    ID: 3128,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Doopung International Ltd.",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "110 /1994",
    "Permit Date": "1994-07-25T08:26:43Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "လျှပ်စစ်ပစ္စည်းဆိုင်ရာပစ္စည်းများ ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.439,
    "Total Amount Of Capital (in Millions)": 0.439,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address": "-",
  },
  {
    ID: 3129,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar GJM International Ltd.",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "112 /1994",
    "Permit Date": "1994-09-06T08:31:11Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.487,
    "Total Amount Of Capital (in Millions)": 1.487,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "United Kingdom of Great Britain and Northern Ireland",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address": "ပျဉ်းမပင်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 3130,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar Sampoerna Tobacco Co.,Ltd.",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "113 /1994",
    "Permit Date": "1994-09-30T08:36:19Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "စီးကရက်နှင့် ဆေးရွက်ကြီးထုတ်ကုန်များ ထုတ်လုပ်ဖြန့်ဖြူးခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 17.3,
    "Total Amount Of Capital (in Millions)": 17.3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "United Kingdom of Great Britain and Northern Ireland",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address": "သန်လျင်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 3131,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "L.P International Co.,Ltd.",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "115 /1994",
    "Permit Date": "1994-10-28T08:47:48Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သားရေလက်အိတ်အမျိုးမျိုးထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 4.392,
    "Total Amount Of Capital (in Millions)": 4.392,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Thailand",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address": "ပျဉ်းမပင်၊ရန်ကုန်မြို့",
  },
  {
    ID: 3132,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "Myanmar China Tha Ma Huan Yu Minghu Flask Co.,Ltd.",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "117 /1994",
    "Permit Date": "1994-10-28T03:45:44Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "-",
    "Amount Of Foreign Capital USD (in Millions)": 4.39,
    "Total Amount Of Capital (in Millions)": 4.39,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address": "ရွှေပြည်သာ၊ ရန်ကုန်",
  },
  {
    ID: 3133,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar Jade International Ltd.",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "123/ 1994",
    "Permit Date": "1994-12-30T03:50:14Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "လက်ဝတ်ရတနာပစ္စည်းများနှင့် ကျောက်အလှဆင်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 3,
    "Total Amount Of Capital (in Millions)": 3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address": "ပျဉ်းမပင်စက်မှုဇုန်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 3134,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Asia- Pacific Edible Oil Ltd.",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "186/ 1996",
    "Permit Date": "1996-06-24T03:55:17Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "ဖန်ပုလင်းထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 3.5,
    "Total Amount Of Capital (in Millions)": 3.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address": "ကျောက်တန်း၊ ရန်ကုန်မြို့",
  },
  {
    ID: 3135,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar Triumph International Ltd.",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "187 /1996",
    "Permit Date": "1996-06-24T04:02:41Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "FOB စနစ်ဖြင့်အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 15,
    "Total Amount Of Capital (in Millions)": 15,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address": "မင်္ဂလာဒုံမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 3136,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "xxxxxxx",
    "Name of Principal Organization": "Highsonic Enterprise Pte Ltd",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "MYANMAR AIRWAYS INTERNATIONAL COMPANY LIMITED",
    "Financial Year From": 1992,
    "Financial Year To": 1993,
    "Permit Number": "070/1993",
    "Permit Date": "1993-02-19T04:00:37Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Transport & Communication",
    "Type Of Investment Business": "Airline (International Airline Services)",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address": "xxxxxxxxxx",
    "Organization Address": "Singapore",
    "Investment Permitted Address":
      "Pyay Road\nNo.(88), Room No.(111), International Business Center\nNo.(11) Quarter, Hlaing Township, Yangon, Myanmar",
  },
  {
    ID: 3137,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar Noveau Steel Co.,Ltd.",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "239 /1996",
    "Permit Date": "1996-12-18T04:10:21Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "သွပ်ပြားများထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 7.84,
    "Total Amount Of Capital (in Millions)": 7.84,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Thailand",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address": "ပျဉ်းမပင်စက်မှုဇုန်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 3138,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "xxxxxxxx",
    "Name of Principal Organization": "Air Mandalay Holdings Pte. Ltd",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "AIR MANDALAY LIMITED",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "114/1994",
    "Permit Date": "1994-10-04T04:16:43Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Transport & Communication",
    "Type Of Investment Business": "Airline",
    "Amount Of Foreign Capital USD (in Millions)": 6.385,
    "Total Amount Of Capital (in Millions)": 6.385,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address": "xxxxxxxxxxxxxxxx",
    "Organization Address": "Singapore",
    "Investment Permitted Address":
      "Air Mandalay Building,Yangon International Airport\nMingaladon Township, Yangon, Myanmar",
  },
  {
    ID: 3139,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Myanmar Texcamp Industries Ltd.",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "282 /1997",
    "Permit Date": "1997-09-05T04:17:35Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      " CMP စနစ်ဖြင့် ဇာထိုးခြင်းနှင့် အထည်ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address": "Hlaingtharya, Yangon",
  },
  {
    ID: 3140,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "xxxxxxx",
    "Name of Principal Organization": "Pointo Enterprises Ltd.",
    "Place of Incorporation": "xxxxxxxxxxxx",
    "Company Name In Myanmar":
      "MYANMAR INTERNATIONAL TERMINALS THILAWA LIMITED",
    "Financial Year From": 1995,
    "Financial Year To": 1996,
    "Permit Number": "163/1995",
    "Permit Date": "1995-08-29T04:31:39Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "To Construct and Operate a Container Terminal",
    "Amount Of Foreign Capital USD (in Millions)": 110.91,
    "Total Amount Of Capital (in Millions)": 110.91,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "United Kingdom of Great Britain and Northern Ireland",
    "Form Of Investment": "FDII",
    "Land Owner": "Myanma Port Authority ",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address": "xxxxxxxxxxxx",
    "Organization Address":
      "United Kingdom of Great Britain and Northern Ireland",
    "Investment Permitted Address":
      "Berth 5-9, Thilawa, Kyauktan Township, Yangon, Myanmar 11301",
  },
  {
    ID: 3141,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Managing Director",
    "Name of Principal Organization": "Myanma Port Authority",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "MPA-ALLIED YANGON INLAND CONTAINER DEPOT LIMITED",
    "Financial Year From": 1995,
    "Financial Year To": 1996,
    "Permit Number": "169/1995",
    "Permit Date": "1995-12-12T05:14:54Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "To Construct and Operate Island Container Depots",
    "Amount Of Foreign Capital USD (in Millions)": 7.012,
    "Total Amount Of Capital (in Millions)": 7.012,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Myanma Port Authority",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address": "BOTAHTAUNG ZAY STREET, SEIKKAN , YANGON, Myanmar",
    "Organization Address": "BOTAHTAUNG ZAY STREET, SEIKKAN , YANGON, Myanmar",
    "Investment Permitted Address":
      "BOTAHTAUNG ZAY STREET, SEIKKAN , YANGON, Myanmar",
  },
  {
    ID: 3142,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "xxxxxxxxxxx",
    "Name of Principal Organization":
      "Myanmar Integrated Port Services Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "MYANMAR INTEGRATED PORT LIMITED",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "185/1996",
    "Permit Date": "1996-06-24T05:23:48Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "Construct and Operate a Wharf and Related Facilities",
    "Amount Of Foreign Capital USD (in Millions)": 11.1,
    "Total Amount Of Capital (in Millions)": 11.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "Myanmar Port Aurtority",
    "Land Area (units not specified in file)": null,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address": "xxxxxxxxxxx",
    "Organization Address": "Singapore",
    "Investment Permitted Address":
      "Thilawa Port,No.(4)Thanlyin Kyauktan, Yangon, Myanmar",
  },
  {
    ID: 3143,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "ဇင်ယော်ဖြူအထည်ချုပ် ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "532/2002",
    "Permit Date": "2002-02-05T06:07:56Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့်အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.11,
    "Total Amount Of Capital (in Millions)": 11.66,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၇၇)၊ မြေတိုင်းရပ်ကွက်(င)၊ စက်မှုလက်မှုရပ်ကွက်၊မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်မြို့.",
  },
  {
    ID: 3144,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "New Talent Co.,Ltd.",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "540/2002",
    "Permit Date": "2002-03-18T06:14:01Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 109,
    "Total Amount Of Capital (in Millions)": 109,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၆၇/ခ)၊ မြေတိုင်းရပ်ကွက်အမှတ်(၄၂)၊ စက်မှုဇုန်၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 3145,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "သီရိစန္ဒာအထည်ချုပ်လုပ်ငန်း နှင့် အထွေထွေရောင်းဝယ်ရေး သမဝါယမ လီမိတက်",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "567/2003",
    "Permit Date": "2003-01-01T06:19:11Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့်အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.11,
    "Total Amount Of Capital (in Millions)": 20,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး အထည်ချုပ်စက်ရုံ၊ အမှတ်(၁)၊ ရုံခွဲ(၃)၊ အောက်မင်္ဂလာဒုံလမ်း၊ အောင်ဆန်းကွင်ရပ်ကွက်၊ အင်းစိန်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 3146,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "ငွေကြယ်ဖြူ ထုတ်လုပ်မှု ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "569/2003",
    "Permit Date": "2003-01-06T06:25:20Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် Steel Wares ပစ္စည်းများ ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 130.1,
    "Total Amount Of Capital (in Millions)": 130.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၅၃)၊ စက်မှုဇုန်(၂)၊ ဒဂုံမြို့သစ်ဆိပ်ကမ်းမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 3147,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "နိဗ္ဗာန်အလင်းရောင်ကုန်ထုတ်လုပ်မှု ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "577/2003",
    "Permit Date": "2003-01-16T06:49:02Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": " စနစ်ဖြင့် အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 15.52,
    "Total Amount Of Capital (in Millions)": 15.52,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "အမှတ်(၁)၊(၃)ရပ်ကွက်၊ မင်းကျောင်းလမ်း၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 3148,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "အဲဗားနိုဝင်ဘာအင်ဒတ်(စ်)ထရီ ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "580/2003",
    "Permit Date": "2003-02-12T06:56:47Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "စနစ်ဖြင့် အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.07,
    "Total Amount Of Capital (in Millions)": 27.03,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "အမှတ်(၁၅၃)၊ တွင်းသင်းတိုက်ဝန်ဦးထွန်းညိုလမ်း၊ စက်မှုဇုန်(၁)၊လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 3149,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "ချင်းတွင်းတံခွန် အထည်ချုပ်လုပ်ငန်း သမဝါယမအသင်း လီမိတက်",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "590/2003",
    "Permit Date": "2003-02-20T07:06:31Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 26,
    "Total Amount Of Capital (in Millions)": 26,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "လမ်းသစ်လမ်းနှင့် ဝါးတန်းလမ်းကြားရှိ မြန်မာ့ဆိပ်ကမ်းအဏာပိုင်မှ ပိုင်ဆိုင်သော ယခင်ဖက်စပ်(၂)လေးထပ်အဆောက်အဦအပေါ်ဆုံးထပ်နှင့် ဒုတိယထပ်၊ ဆိပ်ကမ်းမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 3150,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "ထရိုင်ဒိုင်းမွန်း ထရေးဒင်း ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "593/2003",
    "Permit Date": "2003-02-27T07:16:09Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.07,
    "Total Amount Of Capital (in Millions)": 18.29,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "အကွက်အမှတ်(၁၂၄)၊ ကျိုက်ဝိုင်းအောင်မင်္ဂလာ(၂)လမ်း၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 3151,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "လီလ်ရဲန် ဖက်ရှင်မန်ညူဖက်ချားရင်း ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "596/2003",
    "Permit Date": "2003-02-27T07:22:25Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီ သိုးမွှေးထည်အမျိုးမျိုးယက်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.03,
    "Total Amount Of Capital (in Millions)": 11.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၃၉)၊ မြေတိုင်းရပ်ကွက်(၄၂)၊ စက်မှုဇုန်၊ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 3152,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "xxxxx",
    "Name of Principal Organization":
      "Canadian Helicopters (International) Limited",
    "Place of Incorporation": "xxxxxxxxxx",
    "Company Name In Myanmar": "Myanmar Helicopters International Limited",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "279/1997",
    "Permit Date": "1997-08-08T06:35:01Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Transport & Communication",
    "Type Of Investment Business": "Airline Services by Helicopters",
    "Amount Of Foreign Capital USD (in Millions)": 0.3,
    "Total Amount Of Capital (in Millions)": 0.3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Canada",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Terminated",
    "Investor Address": "xxx",
    "Organization Address": "xxxxxxxxx",
    "Investment Permitted Address": "Airline Services By Helicopters",
  },
  {
    ID: 3153,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Daw Thin Thin Thwe",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MYAT THIT OO COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "152/2019",
    "Permit Date": "2019-06-24T04:56:50Z",
    "Meeting Number": "9/2019",
    "Meeting Date": "2019-06-14T04:57:08Z",
    Sector: "Other Services",
    "Type Of Investment Business": "HIGHER EDUCATION SERVICES",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 500,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်ခင်စန္ဒာနိုင်၊ ဒေါ်အေးစန္ဒာမြိုင်",
    "Land Area (units not specified in file)": 0.457,
    "Lease Term": 10,
    "Annual Lease Fee": 72,
    "Land Use Premium": null,
    "Number Of Local Employees": 54,
    "Number Of Foreign Employees": 13,
    Status: "Approved",
    "Investor Address": "3/A, BAWDIYEIKTHA ROAD, BAHAN TOWNSHIP, YANGON",
    "Organization Address": "",
    "Investment Permitted Address":
      "BUILDING (B), NO.72, CHINDWIN ROAD, KAMAYUT TOWNSHIP, YANGON REGION ",
  },
  {
    ID: 3166,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "MR. UTHAI TANTIPIMOLPHAN",
    "Name of Principal Organization": "MYANMAR C.P. LIVESTOCK COMPANY LIMITED",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "MYANMAR C.P. LIVESTOCK COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "164/2019",
    "Permit Date": "2019-07-05T04:42:21Z",
    "Meeting Number": "10/2019",
    "Meeting Date": "2019-06-28T04:42:24Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business": "Layer Pullet Farm",
    "Amount Of Foreign Capital USD (in Millions)": 3.964,
    "Total Amount Of Capital (in Millions)": 3.964,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Thailand",
    "Form Of Investment": "FDII",
    "Land Owner": "U Zaw Lin Zan",
    "Land Area (units not specified in file)": 10,
    "Lease Term": 30,
    "Annual Lease Fee": 0.024,
    "Land Use Premium": null,
    "Number Of Local Employees": 36,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "NO. 99/160 MOO 5, BANGLUCKNOI, MUANG  NONTHABURI, NONTHABURI 11000 THAILAND",
    "Organization Address":
      "135, PYAY ROAD, 8 1/2 MILE, MYANGONE TOWNSHIP, YANGON",
    "Investment Permitted Address":
      "PLOT NO. 128, 129, C (8) STREET, VEGETABLE PRODUCTION AND CHICKEN/ FISH LIVESTOCK SPECIAL ZONE (3), KWIN NO. 977, KALI HTAW WEST VILLAGE TRACT, KWIN NO. 987, KYAR INN TRACT, HLEGU TOWNSHIP, YANGON REGION",
  },
  {
    ID: 3167,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Daw Aye Aye Khaing",
    "Name of Principal Organization": "Crown Advanced Construction Co.,Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "School City Company limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "174/2019",
    "Permit Date": "2019-07-10T04:41:00Z",
    "Meeting Number": "11/2019",
    "Meeting Date": "2019-07-10T04:41:04Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Basic Education Services",
    "Amount Of Foreign Capital USD (in Millions)": 4.5,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "Crown Advanced Co.,Ltd.",
    "Land Area (units not specified in file)": 20000,
    "Lease Term": 10,
    "Annual Lease Fee": 120000,
    "Land Use Premium": null,
    "Number Of Local Employees": 23,
    "Number Of Foreign Employees": 30,
    Status: "Approved",
    "Investor Address":
      "No.17, Sharzaybo street, sharzaybo ward, zeya thiri Township, Naypyitaw",
    "Organization Address":
      "No.41/472(A), Corner of pyay nawaday street of yadanar moe lane, industrial zone (3), shwe pyi thar township,yangon",
    "Investment Permitted Address":
      "11th floor, Times City office tower-2A, ward (8), Kyun taw street, kamaryut township, yangon region",
  },
  {
    ID: 3170,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Daw Nu Nu Thant",
    "Name of Principal Organization":
      "IMCS(Institute of Management & Computer Studies) Co.,Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "IMCS(Institute of Management & Computer Studies) Co.,Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "157/2019",
    "Permit Date": "2019-07-05T08:35:44Z",
    "Meeting Number": "10/2019",
    "Meeting Date": "2019-06-28T08:36:10Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Education Services",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1500,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Wai Wai Myint, U Kaung Myat Paing, Daw Nu Nu Thant",
    "Land Area (units not specified in file)": 0.364,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 88,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "No.56, Aung Min Khaung (1) Street, ward (10),Windarmieyar, Kamaryut Township, Yangon",
    "Organization Address":
      "No.507/7, Pyi Yeik Thar Street, Pyay Road, ward (8), Kamaryut Township, Yangon",
    "Investment Permitted Address":
      "No.507/7, Pyi Yeik Thar Street, Pyay Road, ward (8), Kamaryut Township, Yangon and plot No.102C/39,102C/40, Myay Taing Block No.36(E), Aung MIn Khaung Street, Ward(10), Windemere, Kamaryut Township, Yangon Region",
  },
  {
    ID: 3171,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Kyaw Thu Aung",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Inno Power Company LImited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "150/2019",
    "Permit Date": "2019-05-30T09:25:39Z",
    "Meeting Number": "8/2019",
    "Meeting Date": "2019-05-29T09:26:28Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Higher Education Services",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 2000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Khun Oo, U Aung Aung, U Tin Maung Swe, Daw Thiri Khit",
    "Land Area (units not specified in file)": 44059,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 42,
    "Number Of Foreign Employees": 3,
    Status: "Approved",
    "Investor Address":
      "No.728, Bagan Road, Shwe Pauk Kan Myot Thit, Ward 14,North Okkalapa Township,Yangon",
    "Organization Address": "",
    "Investment Permitted Address": "Yangon Region and Mandalay Region ",
  },
  {
    ID: 3175,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Cheah Kim Teck",
    "Name of Principal Organization": "Jardine Cycle & Carriage Limited",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Cycle & Carriage Automobile Myanmar Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "558/2013",
    "Permit Date": "2013-02-18T08:41:10Z",
    "Meeting Number": "6/2013",
    "Meeting Date": "2013-02-06T08:41:39Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Automobile Maintenance and Repair Services",
    "Amount Of Foreign Capital USD (in Millions)": 1.8,
    "Total Amount Of Capital (in Millions)": 3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Hla Win, Daw Nan Lin Lin Htun",
    "Land Area (units not specified in file)": 1.025,
    "Lease Term": 3,
    "Annual Lease Fee": 5647.058,
    "Land Use Premium": null,
    "Number Of Local Employees": 31,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "530 East Coast Road, #10-01, Eucalia Block Ocean Park Condominium, Singapore 458970",
    "Organization Address": "239 Alexandra Road, Singapore 159930",
    "Investment Permitted Address":
      "No 7, Kabaraye Pagoda Road, Mayankone Township and No. 4/5/15/16, Ywar Ma Kyaung Road, Hlaing Township, Yangon Region",
  },
  {
    ID: 3177,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Takaichi Hamada",
    "Name of Principal Organization": "Japan Logistics Systems Corp",
    "Place of Incorporation": "Japan",
    "Company Name In Myanmar": "Logitem Myanmar Co., Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "598/2013",
    "Permit Date": "2013-07-23T09:13:27Z",
    "Meeting Number": "17/2013",
    "Meeting Date": "2016-06-29T09:15:31Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Passenger, Transport and Logistic Services (only for foreigners)",
    "Amount Of Foreign Capital USD (in Millions)": 2.09,
    "Total Amount Of Capital (in Millions)": 3.14,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "U Thun Shein",
    "Land Area (units not specified in file)": 0.14,
    "Lease Term": 5,
    "Annual Lease Fee": 18000,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "4-23-20, Nishikoigakubo, Kokubun Ji City, Tokyo, Japan",
    "Organization Address":
      "5-11-3, Shimbashi, Minato-Ku, Tokyo 105-0004 Japan",
    "Investment Permitted Address":
      "No. 529-A, Gone Nyin Ni Taw (West), Beside No 1 Road, Pyin Ma Pin Village Tract, Mingaladon Township, Yangon Region",
  },
  {
    ID: 3178,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Tit Beng Teh",
    "Name of Principal Organization": "Leisure Holdings Asia Ltd.",
    "Place of Incorporation": "United Kingdom",
    "Company Name In Myanmar": "Myanmar Cruises Ltd.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "590/2013",
    "Permit Date": "2013-06-24T09:36:13Z",
    "Meeting Number": "16/2013",
    "Meeting Date": "2013-06-12T09:36:39Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "River Cruise Operation and Tourism Related Business",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 12,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "United Kingdom of Great Britain and Northern Ireland",
    "Form Of Investment": "FDII",
    "Land Owner": "Casuarina Shipping Pte Ltd",
    "Land Area (units not specified in file)": null,
    "Lease Term": 30,
    "Annual Lease Fee": 799800,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "6-12, Nursey Street, Hornsby, New South Wales, Australia",
    "Organization Address":
      "Canon's Court, 22 Victoria street, Hamilton, Bermuda",
    "Investment Permitted Address":
      "Yangon, Bagan, Mandalay, Bhamo, Mawlaik and Homalin",
  },
  {
    ID: 3179,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yoshihiko Hismatsu",
    "Name of Principal Organization": "GOSHU KOHSAN Co., Ltd.",
    "Place of Incorporation": "Thailand",
    "Company Name In Myanmar": "Goshu-A1 Eco Business Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "934/2015",
    "Permit Date": "2015-05-15T10:16:02Z",
    "Meeting Number": "7/2015",
    "Meeting Date": "2015-04-28T10:16:28Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "\nLaboratory Testing, Consulting, Supply and Installation of Machinery and Equipment and Maintenance Services for Water and Waste Water",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "U Yan Win, U Kyaw Thint",
    "Land Area (units not specified in file)": 1.2,
    "Lease Term": 30,
    "Annual Lease Fee": 24500,
    "Land Use Premium": null,
    "Number Of Local Employees": 10,
    "Number Of Foreign Employees": 2,
    Status: "Submitted",
    "Investor Address":
      "374,7-Chome, Nishi-Gotanda, Shinagawa-Ku, Tokyo, Japan",
    "Organization Address":
      "70 MOO 5 Kingkaew Road, Rachatheva, Bangphli, Samutprakarn 10540, Thailand",
    "Investment Permitted Address":
      "Plot No. 19, Yangon Industrial Zone, North Okkalapa Township, Yangon",
  },
  {
    ID: 3180,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Han Soe Kyaw",
    "Name of Principal Organization": "Two Element Trading Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Two Elephant Asia Group Co., Ltd.",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "963/2015",
    "Permit Date": "2015-06-12T05:05:50Z",
    "Meeting Number": "10/2015",
    "Meeting Date": "2015-06-05T05:06:04Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Rental Services of Heavy Crane",
    "Amount Of Foreign Capital USD (in Millions)": 1.877,
    "Total Amount Of Capital (in Millions)": 3.61,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "U Kyaw Pe",
    "Land Area (units not specified in file)": 11.71,
    "Lease Term": 15,
    "Annual Lease Fee": 60751.38,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "No.11, Manawhari Street, Pyay West Quarter, Dagon Township, Yangon",
    "Organization Address":
      "Plot No. 116, Myay Taing Block No 65, Corner of Peral Road & Depel Yin Won Htout Oo Mye Road, Shwe Pyi Thar Industrial Zone (4), Yangon Region",
    "Investment Permitted Address":
      "Plot No. 116, Myay Taing Block No 65, Corner of Peral Road & Depel Yin Won Htout Oo Mye Road, Shwe Pyi Thar Industrial Zone (4), Yangon Region",
  },
  {
    ID: 3181,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr Liaw Yit Ming",
    "Name of Principal Organization": "Parkway Healthcare Indo-China Pte. Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Adanman Alliance Healthcare Limited",
    "Financial Year From": 2015,
    "Financial Year To": 2016,
    "Permit Number": "1045/2016",
    "Permit Date": "2016-01-29T06:37:02Z",
    "Meeting Number": "1/2016",
    "Meeting Date": "2016-01-15T06:37:31Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Private Hospital Services",
    "Amount Of Foreign Capital USD (in Millions)": 54.44,
    "Total Amount Of Capital (in Millions)": 87.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 7,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Ministry of Health",
    "Land Area (units not specified in file)": 4.3,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": 2000000,
    "Number Of Local Employees": 314,
    "Number Of Foreign Employees": 36,
    Status: "Submitted",
    "Investor Address": "6 Keng Chin Road, # 05-05 Cyan, Singapore, 258709",
    "Organization Address":
      "111 Somerset Road, # 15-01 Tripleone Somerset Singapore 238164",
    "Investment Permitted Address":
      "Plot No 10 B, Myay Taing Block No 20 F, Corner of Pyay Road and Bogyoke Aung San Road, Lanmadaw Township, Yangon Region",
  },
  {
    ID: 3182,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "DAW  YEE  KYU    ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "SAYARSAN     COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "153/2019",
    "Permit Date": "2019-06-24T06:40:34Z",
    "Meeting Number": "9/2019",
    "Meeting Date": "2019-06-14T06:41:14Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Service",
    "Amount Of Foreign Capital USD (in Millions)": 7.22,
    "Total Amount Of Capital (in Millions)": 13219.68,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Khin Maung Win & Daw Yee Kyu",
    "Land Area (units not specified in file)": 0.249,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 105,
    "Number Of Foreign Employees": 4,
    Status: "Approved",
    "Investor Address":
      "NO. 4 , BUILDING NO. 2 , ROOM NO. 01 , 31ST  FLOOR, YANKIN STREET, WARD 1 , GOLDEN CITY CONDOMINIUM ",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 47-39/ 12-A1  AND 12-B, 6B,  MYAY TAING BLOCK NO. 35 - D , SAYARSAN  ROAD, SAYARSAN WARD,               ",
  },
  {
    ID: 3184,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Hironobu Iriya",
    "Name of Principal Organization": "Toyo Thai Power Corporation Pte., Ltd.",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Toyo Thai Power Myanmar Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "548/2013",
    "Permit Date": "2013-01-21T07:13:37Z",
    "Meeting Number": "1/2013",
    "Meeting Date": "2013-01-02T07:16:05Z",
    Sector: "Power",
    "Type Of Investment Business":
      "Construction of 100 MW Gas Fired Combined Cycle Power Plant (Ahlone) for Electricity Generation and Power Supply",
    "Amount Of Foreign Capital USD (in Millions)": 170.423,
    "Total Amount Of Capital (in Millions)": 120.423,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "Ministry of Electricity and Energy",
    "Land Area (units not specified in file)": 1527,
    "Lease Term": null,
    "Annual Lease Fee": 25200,
    "Land Use Premium": null,
    "Number Of Local Employees": 825,
    "Number Of Foreign Employees": 145,
    Status: "Submitted",
    "Investor Address":
      "LE Raffine Sukhumvit SOI 31 Condominium Room No.21-A, 3/60, Sukhumvit 31 Klongton Nua, Wattana Bangkok 10110",
    "Organization Address":
      "10 Marina Boulevard # 39-00 Marina Bay Financial Centre, Singapore",
    "Investment Permitted Address":
      "No,39, Kannar Street, Ahlone Power Plant Compound, Ahlone Township, Yangon Region.",
  },
  {
    ID: 3186,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Wang Yiqiang",
    "Name of Principal Organization": "NIL",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "FULL STRONG TEXTILE COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "206",
    "Permit Date": "2019-06-21T07:56:40Z",
    "Meeting Number": "9",
    "Meeting Date": "2019-06-12T07:56:28Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF VARIOUS KINDS OF GLOVE",
    "Amount Of Foreign Capital USD (in Millions)": 1.725,
    "Total Amount Of Capital (in Millions)": 1.725,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 35,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Win Zaw Oo",
    "Land Area (units not specified in file)": 0.97,
    "Lease Term": 15,
    "Annual Lease Fee": 0.024,
    "Land Use Premium": null,
    "Number Of Local Employees": 701,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "Haizhun Street, Room 308, Unit 4, Yunxia Court 14, Lily New City, Haining City",
    "Organization Address": "Nil",
    "Investment Permitted Address":
      "LAND PLOT No. (69), OUT OF LAND PLOT  NO.(60,61,62,69,70,71), MYAY TAING BLOCK NO. INDUSTRIAL ZONE (2), ",
  },
  {
    ID: 3187,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ကင့်(တ်)အင်ဒတ်စရီး(စ်)(မြန်မာ)လီမိတက်",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "မနသ ၅၉၉/၂၀၀၃",
    "Permit Date": "2003-03-08T07:13:44Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.01,
    "Total Amount Of Capital (in Millions)": 17.47,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Guinea-Bissau",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "အမှတ်(၇၇)ဘီ/၃၆၂၊ မြေကွက်အမှတ် (၆-က)၊အောက်မင်္ဂလာဒုံလမ်း၊ အရှေ့ရွာမ၊အင်စိန်",
  },
  {
    ID: 3188,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ဟန်ဂျင်းမန်နျူဖက်ချားရင်းကုမ္ပဏီလီမိတက်",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "မနသ ၆၀၁/၂၀၀၃",
    "Permit Date": "2003-03-13T07:24:30Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.127,
    "Total Amount Of Capital (in Millions)": 246.04,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Guinea-Bissau",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေတိုင်းရပ်ကွက်အမှတ် (၁၆)၊ (၁၃)ရပ်ကွက်၊ လှိုင်မြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 3189,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "မြန်မာအက်(စ်)အမ်စီဂါးမန့်လီမိတက်",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "မနသ ၆၀၆/၂၀၀၃",
    "Permit Date": "2003-04-22T08:08:29Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီ အထည်အမျိုးမျိုးချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 19.64,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Guinea-Bissau",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "ကွင်းအမှတ်(၅၁-၈-အေ)၊ဦးပိုင်အမှတ်(၆၃-ခ)၊ ဆတ်သွားတောကျေးရွာ၊ မှော်ဘီမြို့နယ်၊ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 3190,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ကြိုးကြာဖြူအထည်အလိပ်လုပ်ငန်း လီမိတက်",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "မနသ ၆၁၃/၂၀၀၃",
    "Permit Date": "2003-04-26T08:20:18Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီအထည်အမျိုးမျိုး ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 10.4,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁-ဟ၂)၊ မြေတိုင်းရပ်ကွက်အမှတ် ၁၈/အေ၊လှိုင်သာယာမြို့နယ်၊ ",
  },
  {
    ID: 3191,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "သိန်းသီဟအင်ဒတ်(စ်)ထရီကုမ္ပဏီလီမိတက်",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "မနသ ၆၂၁/၂၀၀၃",
    "Permit Date": "2003-05-06T09:57:07Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့်အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 20.08,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Guinea-Bissau",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်(၁၅-က၂)၊မြေတိုင်းရပ်ကွက် (၁၂)  အမှတ်၁၃၄၊ ဦးဘဟန်လမ်း၊၂ရပ်ကွက်၊ မရမ်းကုန်းမြို့နယ်၊ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 3192,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Myat Swe",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Lucky Fortune Company Limited(ကံကောင်းသော အခွင့်အလမ်း ကုမၸဏီလီမိတက်)",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "188/2019",
    "Permit Date": "2019-04-19T07:48:16Z",
    "Meeting Number": "6/2019",
    "Meeting Date": "2019-04-10T07:48:32Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Garment And industrial used Gloves on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 0.275,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 45,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Kyin Kyin Hla",
    "Land Area (units not specified in file)": 2.18,
    "Lease Term": 5,
    "Annual Lease Fee": 78,
    "Land Use Premium": null,
    "Number Of Local Employees": 513,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "ရပ်ကွက်ၾကီး( ၁) ၊ပြင်ဉီးလွင်မြိဳ.နယ်၊မနၱေလးတိုင်းဒေသၾကီးနှင်\nအခန်း(၁၃)၊တိုက်(၂၃)၊ရန်ရှင်းလမ်း၊(၅\n)ရပ်ကွက်၊ရန်ကုန်တိုင်းဒေသၾကီး။  ",
    "Organization Address": "",
    "Investment Permitted Address":
      "ၿေမကွက်အမှတ်(၃၆)၊ၿေမတိုင်းရပ်ကွက်အမှတ်(၂၄)၊ ငွေပင်လယ်စက်မှုဇုန်၊\nၾကီး။",
  },
  {
    ID: 3193,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Yu Zifen",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "JIA MEI CARTON PRODUCTS COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "219/2019",
    "Permit Date": "2019-07-09T03:35:30Z",
    "Meeting Number": "10/2019",
    "Meeting Date": "2019-06-26T03:36:50Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Distribution of Carton box",
    "Amount Of Foreign Capital USD (in Millions)": 1.6,
    "Total Amount Of Capital (in Millions)": 1.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Jocky @ Sein Htay ",
    "Land Area (units not specified in file)": 2.257,
    "Lease Term": 5,
    "Annual Lease Fee": 840,
    "Land Use Premium": null,
    "Number Of Local Employees": 150,
    "Number Of Foreign Employees": 8,
    Status: "Draft",
    "Investor Address":
      "NO.22, YONGPING VILLAGE DAHETOU WANG HOME ZAUTANG TOWN JIANGYIN CITY, JIANGSU PROVINCE ",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.(22), MYAY TAING BLOCK NO.(25), SHWE LIN BAN INDUSTRIAL ZONE ",
  },
  {
    ID: 3194,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LI, XIANG",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "TIANJIN FASHION MILESTONE COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "218/2019",
    "Permit Date": "2019-07-09T04:47:59Z",
    "Meeting Number": "10/2019",
    "Meeting Date": "2019-06-26T04:48:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.412,
    "Total Amount Of Capital (in Millions)": 0.412,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Tin Win, U Tin Oo",
    "Land Area (units not specified in file)": 1.157,
    "Lease Term": 5,
    "Annual Lease Fee": 37458,
    "Land Use Premium": null,
    "Number Of Local Employees": 600,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "NO.4-401,RIFANGLI,WUMA ROAD, HEBEI DISTRICT,TIANJIN CITY, PEOPLE'S REPUBLIC OF CHINA.",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.(392), MYAY TAING BLOCK NO.(25), SHWE LIN BAN SETHMU MYO.",
  },
  {
    ID: 3195,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. GU YUJIE",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "SEN MA TE (MYANMAR) APPAREL COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "210/2019",
    "Permit Date": "2019-06-21T06:32:35Z",
    "Meeting Number": "9/2019",
    "Meeting Date": "2019-06-12T06:33:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT ON CMP BASIS ",
    "Amount Of Foreign Capital USD (in Millions)": 3.284,
    "Total Amount Of Capital (in Millions)": 3.284,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Khin Htun , Daw Yin Yin Htay",
    "Land Area (units not specified in file)": 2.292,
    "Lease Term": 10,
    "Annual Lease Fee": 149424,
    "Land Use Premium": null,
    "Number Of Local Employees": 974,
    "Number Of Foreign Employees": 16,
    Status: "Draft",
    "Investor Address":
      "THE MOUNTAIN VILLAGE OF XIANGSHAN COUNTY  NINGBO CITY,ZHEJIANG PROVINCE  ",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. (272,273), MYAY TAING BLOCK NO.(25), SHWE LIN BAN INDUSTRIAL ZONE,",
  },
  {
    ID: 3196,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LIN, BUSHENG",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "HONE SHENG (MYANMAR) INDUSTRIAL COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "198/2019",
    "Permit Date": "2019-06-11T07:30:45Z",
    "Meeting Number": "8/2019",
    "Meeting Date": "2019-05-19T07:31:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ၿဖင့် အိတ်အမဳိဴးမဳိဴး ထုတ်လုပ်ဲၿခင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.688,
    "Total Amount Of Capital (in Millions)": 0.688,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Ma Yan Gay @ Ma Khin Pyone",
    "Land Area (units not specified in file)": 1.055,
    "Lease Term": 5,
    "Annual Lease Fee": 24,
    "Land Use Premium": null,
    "Number Of Local Employees": 800,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address":
      "QIYUN FOREST FARM, HULING TOWN, RUIAN CITY,ZHEJIANG PROVINCE",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.(16),MYAY TAING BLOCK NO. (Zone 4), INDUSTRIAL ZONE",
  },
  {
    ID: 3197,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw Myint Myint Wai",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "UNITED SMOOTH ANG HARMONY COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "191/2019",
    "Permit Date": "2019-04-19T08:10:45Z",
    "Meeting Number": "6/2019",
    "Meeting Date": "2019-04-10T08:11:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production Plastic Pellets Using Local Plastic Flakes and Selling  for local and Exporting",
    "Amount Of Foreign Capital USD (in Millions)": 1.482,
    "Total Amount Of Capital (in Millions)": 1.482,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "",
    "Land Owner": "Daw Shwe ",
    "Land Area (units not specified in file)": 2.336,
    "Lease Term": 10,
    "Annual Lease Fee": 21,
    "Land Use Premium": null,
    "Number Of Local Employees": 121,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "အမှတ် (၈)၊၀ေဇယႏၱာလမ်း ၊ ( ၆ ) ရပ်ကွက် ၊တောင်ဥကၠလာပ မြိဳ့နယ်။\n",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက် အမှတ် (၃၆)၊ မြေတိုင်းရပ်ကွက်  အမှတ် -၁၁၃၊ စက်မှုဇုန်၊ ဒဂုံ မြိဳ့သစ် (အရှေ့ ပိုင်း) မြိဳ့နယ်၊",
  },
  {
    ID: 3198,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Daw Thin Thin Mar",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "UNITED CENTUS COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "214/2019",
    "Permit Date": "2019-07-21T09:33:40Z",
    "Meeting Number": "9/2019",
    "Meeting Date": "2019-06-12T09:34:11Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and local distribution of various kinds of energy drink,soft drink",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "MCI",
    "Land Owner": "U Sai Win Aung, U Sai Win Htun , U Sai Hlan @ U Htay Win",
    "Land Area (units not specified in file)": 3.378,
    "Lease Term": 10,
    "Annual Lease Fee": 54672,
    "Land Use Premium": null,
    "Number Of Local Employees": 115,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "အမှတ် (၂၀၉) ၊ အနော်ရထာလမ်း ၊ ( ၅ ) ရပ်ကွက် လမ်းမတော် မြိဳ့နယ်။\n",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက် အမှတ် (၇၄)၊ မြေတိုင်းရပ်ကွက်  အမှတ် -၅၀၊သာဓုကန် စက်မှုဇုန် ရွေၿပည်သာမြိဳ့နယ်။",
  },
  {
    ID: 3199,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. HUNG CHUAN HSIANG",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "JIA HONG INDUSTRY COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "226/2019",
    "Permit Date": "2019-07-22T05:23:15Z",
    "Meeting Number": "11/2019",
    "Meeting Date": "2019-07-09T05:23:33Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "သကြားအစားထိုးကုန်နှင့် ကပ်စေးနှဲ ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 2.5,
    "Total Amount Of Capital (in Millions)": 2.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Khin San Myint",
    "Land Area (units not specified in file)": 2.002,
    "Lease Term": 30,
    "Annual Lease Fee": 36,
    "Land Use Premium": null,
    "Number Of Local Employees": 26,
    "Number Of Foreign Employees": 2,
    Status: "Draft",
    "Investor Address":
      "NO.20, PIN- AN STREET SAN CHONG DIST, TAIPEI TAIWAI, PEOPLE'S REPUBLIC OF CHINA.",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 219, MYAY TAING BLOCK NO. MYAUNGTAGAR STEEL INDUSTRIAL ZONE",
  },
  {
    ID: 3200,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဒေၚအင်ၾကင်းခိုင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "CHEEN CHEEN MYANMAR COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "192/2019",
    "Permit Date": "2019-05-23T09:35:43Z",
    "Meeting Number": "7/2019",
    "Meeting Date": "2019-05-06T09:36:05Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ၿဖင့် Cashew Nuts Kernal ထုတ်လုပ်တင်ပို့ႄခင်းလုပ်ငန်း။",
    "Amount Of Foreign Capital USD (in Millions)": 0.552,
    "Total Amount Of Capital (in Millions)": 0.552,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေၚအင်ၾကင်းခိုင်",
    "Land Area (units not specified in file)": 1.827,
    "Lease Term": 20,
    "Annual Lease Fee": 30000000,
    "Land Use Premium": null,
    "Number Of Local Employees": 422,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address": "အမႇတ် (၃၁) ၊ ၅ လမ်း ၊ လမ်းမတော်ၿမိဳ့နယ် ",
    "Organization Address": "",
    "Investment Permitted Address":
      "ႄေမကွက်အမႇတ် ( ၂၀၀) ၊ႄေမတိုင်းရပ်ကွက် အမႇတ်(၂၅) ၊\nရေႊလင်ပန်း စက်မႈၿမိဳ့ ၊ ",
  },
  {
    ID: 3201,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "ဒီဖရက်ဒရစ်(ခ်) အင်တာနေရှင်နယ်ကုမ္ပဏီလိမိတက်",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "မနသ၆၂၂/၂၀၀၃",
    "Permit Date": "2003-05-06T03:14:41Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီ အထည်အမျိုးမျိုးချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.01,
    "Total Amount Of Capital (in Millions)": 13.03,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Guinea-Bissau",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်(၂၃၉/၂၄၀)၊ မြေတိုင်းရပ်ကွက်အမှတ် (၃)၊(၁၂၃)၊(၁၂၄)၇လမ်း၊ တောင်ဥက္ကလာပမြို့နယ်",
  },
  {
    ID: 3202,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ရွှေစပယ်ချစ်သူများထုတ်လုပ်မှုကုမ္ပဏီလိမိတက်",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "  မနသ၆၂၇/၂၀၀၃",
    "Permit Date": "2003-05-07T03:28:02Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့်နိုင်ငံတကာအဆင့်မီ အဝတ်အထည်အမျိုးမျိုးချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 21.02,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Guinea-Bissau",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်(၁၆)၊ မြေတိုင်းရပ်ကွက်အမှတ်(၉)၊ အမရာ(၂)လမ်း၊လှိုင်သာယာမြို့နယ်",
  },
  {
    ID: 3203,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "လမ်းသစ်စက်မှုလုပ်ငန်းများကုမ္ပဏီလီမိတက်",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "မနသ ၆၃၁/၂၀၀၃",
    "Permit Date": "2003-06-20T03:38:41Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့်အမျိုးသား၊အမျိုးသမီးဝတ် သားရေရှူးဖိနပ်များထုတ်လုပ်မှုလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 125.18,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Guinea-Bissau",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်(၁၈၀-ခ)၊ကျန်စစ်သားလမ်းဇုန်(၄)၊လှိုင်သာယာမြို့နယ်",
  },
  {
    ID: 3204,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "လင်းထက်စက်မှုလုပ်ငန်းကုမ္ပဏီလီမိတက်",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "မနသ ၆၃၂/၂၀၀၃",
    "Permit Date": "2003-07-07T03:45:16Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMp စနစ်ဖြင့်အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.04,
    "Total Amount Of Capital (in Millions)": 26.26,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Guinea-Bissau",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မီးရထားစက်ခေါင်းစက်ရုံဝင်း၊စျေးကုန်း၊အင်စိန်မြို့",
  },
  {
    ID: 3205,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. WANG YIQIANG",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "FULL STRONG TEXTILE COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "205/2019",
    "Permit Date": "2019-06-21T03:42:50Z",
    "Meeting Number": "9/2019",
    "Meeting Date": "2019-06-12T03:43:10Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ချည်မျှင် ထုတ်လုပ်၍ ပြည်ပသို့ ရာခိုင်နှုန်းပြည့် တင်ပို့ရောင်းချခြင်းလုပ်ငန်း ။",
    "Amount Of Foreign Capital USD (in Millions)": 1.567,
    "Total Amount Of Capital (in Millions)": 1.567,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 35,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Win Zaw Oo",
    "Land Area (units not specified in file)": 0.97,
    "Lease Term": 15,
    "Annual Lease Fee": 23700,
    "Land Use Premium": null,
    "Number Of Local Employees": 200,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "HAIZHUN STREET, ROOM 308, UNIT 4, YUNXIA COURT 14, LILY NEW CITY, HAINING CITY, ZHEJIANG PROVINCE,",
    "Organization Address": "",
    "Investment Permitted Address":
      "စုစုပေါင်းမြေကွက်အမှတ် (၆၀၊၆၁၊၆၂၊၆၉၊၇၀၊၇၁) အနက်မှ မြေကွက်အမှတ် (၆၉)၊ မြေတိုင်းရပ်ကွက် အမှတ် စက်မှုဇုန် (၂)၊ ဒဂုံဆိပ်ကမ်း မြို့နယ်။ ",
  },
  {
    ID: 3206,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "လင်းထက်စက်မှုလုပ်ငန်းကုမ္ပဏီလီမိတက်",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "မနသ၆၃၄/၂၀၀၃",
    "Permit Date": "2003-07-14T03:55:55Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် ဆွတ်တာနှင့် သိုးမွှေးထိုးထည်ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.07,
    "Total Amount Of Capital (in Millions)": 38.44,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Guinea-Bissau",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "(၅၁)၊အမှတ်၃/စျ၊အမှတ်(၆က)၊ကြိုးစက်ရုံးလမ်း၊သုဝဏ္ဏ၊သင်္ဃကျွန်းမြို့နယ်",
  },
  {
    ID: 3207,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Wiseman Hsu",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Asia Optical International Co.,Ltd.",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "377/2003",
    "Permit Date": "2003-02-12T03:53:19Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of all Kinds of lens ,Lens Units Optical Apparatuses, Electronic Apparatuses and Other apparatuses on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 12.88,
    "Total Amount Of Capital (in Millions)": 12.88,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 45,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Thailand",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "605/99,City Village, Bangpoo industry Zone, Samutprakarn,",
    "Organization Address": "-",
    "Investment Permitted Address":
      "No.2/F Continental Electric Bldg.17 Wang Chiu Road,Kin Bay Kowloon Hong Kong",
  },
  {
    ID: 3209,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. SUN CHENGMING",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "BRILLIANCE TEXTILE CORPORATION LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "213/2019",
    "Permit Date": "2019-06-21T04:22:12Z",
    "Meeting Number": "9/2019",
    "Meeting Date": "2019-06-12T04:22:39Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အထည်အမျိုးမျိူး ချုပ်လုပ်ခြင်းလုပ်ငန်း။",
    "Amount Of Foreign Capital USD (in Millions)": 5,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Myat Myat Maw",
    "Land Area (units not specified in file)": 3.005,
    "Lease Term": 15,
    "Annual Lease Fee": 66000,
    "Land Use Premium": null,
    "Number Of Local Employees": 1250,
    "Number Of Foreign Employees": 21,
    Status: "Draft",
    "Investor Address": "NO.6 , YANTI STREET , HAIYANG , YANTI, SHANDONG ",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၁၉၈/၆ ၊ ၁၉၈/၇) မြေတိုင်းရပ်ကွက် အမှတ် စက်မှုဇုန်အပိုင်း (၁)၊ ဒဂုံဆိပ်ကမ်း မြို့နယ်။",
  },
  {
    ID: 3210,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MD, The Union of Myanmar Ecomomic Holding Ltd.",
    "Name of Principal Organization": "Union of Myanmar Economic Holdings Ltd,",
    "Place of Incorporation": "Yangon",
    "Company Name In Myanmar": "Myanmar Daewoo International Ltd.",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "284/1997",
    "Permit Date": "1997-09-30T04:40:20Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufactrung and Marketing of all kinds of garment and apparel products ",
    "Amount Of Foreign Capital USD (in Millions)": 5,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "72/74 Shwe Dagon Pagoda Road Dagon Township, Yangon",
    "Organization Address":
      "72/74 Shwe Dagon Pagoda Road, Dagon Township,Yangon",
    "Investment Permitted Address":
      "Pyinma bin Industrial Complex, Mingaladon Township, Yangon",
  },
  {
    ID: 3211,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.XIANG ZHONG",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "LUEN FAT (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "201/2019",
    "Permit Date": "2019-06-11T04:59:50Z",
    "Meeting Number": "8/2019",
    "Meeting Date": "2019-05-28T05:00:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် စက်မှုလုံခြုံရေးသုံး နှင့် အားကစားသုံးလက်အိတ်အမျိုးမျိူး ထုပ်လုပ်ခြင်းလုပ်ငန်း။",
    "Amount Of Foreign Capital USD (in Millions)": 0.463,
    "Total Amount Of Capital (in Millions)": 0.463,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U San Buu Nat , U He Day Yar Nan @ U Sein Win",
    "Land Area (units not specified in file)": 3.181,
    "Lease Term": 5,
    "Annual Lease Fee": 156,
    "Land Use Premium": null,
    "Number Of Local Employees": 375,
    "Number Of Foreign Employees": 14,
    Status: "Draft",
    "Investor Address":
      "NO.30, NO.162, HANDONG STREET, PUJIA TOWN, TONGCHUAN DISTRICT, DAZHOU CITY,SICHUAN PROVICE.",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် ( ၅၁)၊ မြေတိုင်းရပ်ကွက် အမှတ်-၅၁၊သာဓုကန်စက်မှုဇုန် ၊ ",
  },
  {
    ID: 3212,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U KYAW MYINT",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "TUN DHANA PYAE SONE COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "202/2019",
    "Permit Date": "2019-06-11T05:38:26Z",
    "Meeting Number": "8/2019",
    "Meeting Date": "2019-05-29T05:39:03Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF VALUE- ADDED FROZEN BUFFALO, BEEF AND FROZEN SALTED OMASUM TRIPLE ON CONTRACT MANUFACTURING PROCESS (CMP) BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 2.744,
    "Total Amount Of Capital (in Millions)": 4654.669,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U KYAW LWIN",
    "Land Area (units not specified in file)": 0.918,
    "Lease Term": 5,
    "Annual Lease Fee": 24,
    "Land Use Premium": null,
    "Number Of Local Employees": 61,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "NO.30, GROUNG FLOOR, PATHEIN STREET, KYUN (ALE) WARD, SANCHAUNG TOWNSHIP.",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 33, MYAY TAING BLOCK NO. 172, DAGON SEIK KAN) TOWNSHIP",
  },
  {
    ID: 3213,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LI ZUOLONG",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MYANMAR YULIN COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "204/2019",
    "Permit Date": "2019-06-11T06:55:38Z",
    "Meeting Number": "8/2019",
    "Meeting Date": "2019-05-29T06:55:56Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် ပြည်တွင်းမှ ရာဘာသစ် ကုန်ကြမ်းကိုရယူပြီး ရာဘာသစ် ထုတ်လုပ်၍  ပြည်ပသို့ ရာခိုင်နှုန်းပြည့် တင်ပို့ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.203,
    "Total Amount Of Capital (in Millions)": 0.203,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U YE TUN OO@ U HTIN KYAW",
    "Land Area (units not specified in file)": 3.417,
    "Lease Term": 5,
    "Annual Lease Fee": 105672,
    "Land Use Premium": null,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "ROOM NO.607, BUILDING D2, FUYINGMEN XIXIANG, LIUTANG BAOAN DISTRICT, SHENZHEN GUANGDONG",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (C-10) )၊ မြေတိုင်းရပ်ကွက် အမှတ်၁၇၅ (ကျီစု စက်မှုဇုန်)၊ ",
  },
  {
    ID: 3214,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS. LI LI",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "TIANJIN FASHION ORIGIN INTERNATIONAL COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "203/2019",
    "Permit Date": "2019-06-11T07:16:58Z",
    "Meeting Number": "8/2019",
    "Meeting Date": "2019-05-29T07:17:29Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အ၀တ်အထည်အမျိုးမျိူး ထုတ်လုပ်ခြင်းလုပ်ငန်း။",
    "Amount Of Foreign Capital USD (in Millions)": 2.735,
    "Total Amount Of Capital (in Millions)": 2.735,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Ni Lar Win",
    "Land Area (units not specified in file)": 1.637,
    "Lease Term": 10,
    "Annual Lease Fee": 46372.62,
    "Land Use Premium": 46372.62,
    "Number Of Local Employees": 1642,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address": "MAOCHUANLI 2-701, NANKAI DISTRICT,TIANJIN CITY.",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၃၉၀) ၊ မြေတိုင်းရပ်ကွက် အမှတ်-၂၅၊ရွှေလင်ဗန်း စက်မှုဇုန်",
  },
  {
    ID: 3215,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. KWAN KELVIN YUET MING",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MYANTON INDUSTRIAL LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "208/2019",
    "Permit Date": "2019-06-21T08:09:24Z",
    "Meeting Number": "9/2019",
    "Meeting Date": "2019-06-12T08:09:38Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MODELS FOR CAR AND CAR PARTS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.274,
    "Total Amount Of Capital (in Millions)": 0.274,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Htin Lin",
    "Land Area (units not specified in file)": null,
    "Lease Term": 5,
    "Annual Lease Fee": 75600,
    "Land Use Premium": null,
    "Number Of Local Employees": 76,
    "Number Of Foreign Employees": 4,
    Status: "Draft",
    "Investor Address":
      "NO.3 , TOPASIL PLAZA, 11 ON SUM STREET, SHATIN,NT, HONG KONG",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 210, YANGON INDUSTRY ZONE, MINGALARDON TOWNSHIP.",
  },
  {
    ID: 3216,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": " U NYAN WIN",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "WAA COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "197/2019",
    "Permit Date": "2019-06-11T08:37:59Z",
    "Meeting Number": "8/2019",
    "Meeting Date": "2019-05-29T08:38:21Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "ရေခဲမုန့် ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 0.113,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U PYAY AYE",
    "Land Area (units not specified in file)": null,
    "Lease Term": 0,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 110,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "NO. (4-A),10 QUARTER, PARAMI ROAD,CHAWDWINGONE,MAYANGONE TOWNSHIP.",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO-(521), MYAY TAING BLOCK NO- 532/BI MINGALARDON TOWNSHIP",
  },
  {
    ID: 3217,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MRS. LIN, CHIU-CHUN",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ESLITE GARMENT FACTORY (2) LIMITED ",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "196/2019",
    "Permit Date": "2019-06-11T09:19:27Z",
    "Meeting Number": "8/2019",
    "Meeting Date": "2019-05-29T09:19:38Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အဝတ်အထည်များ ချုပ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 3.7,
    "Total Amount Of Capital (in Millions)": 3.7,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "FDII",
    "Land Owner": "လိုင်ဟောင်ရီ (ခ) ဦးသိန်းဟန်",
    "Land Area (units not specified in file)": 2.002,
    "Lease Term": 10,
    "Annual Lease Fee": 49.2,
    "Land Use Premium": null,
    "Number Of Local Employees": 1037,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "NO.95, 5F, SEC 2, ANHE RD, TAIPEI CITY,TAIWAN",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. (169), MYAY TAING NO. (25), SHWE LIN BAN INDYSTRIAL ZONE ",
  },
  {
    ID: 3218,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.CHOI KWANG TAE",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "PNA MYANMAR COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "195/2019",
    "Permit Date": "2019-06-11T10:01:14Z",
    "Meeting Number": "8/2019",
    "Meeting Date": "2019-06-29T10:01:32Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည် ချုပ်လုပ်ခြင်းလုပ်ငန်း။",
    "Amount Of Foreign Capital USD (in Millions)": 1.049,
    "Total Amount Of Capital (in Millions)": 1.049,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Tin Soe",
    "Land Area (units not specified in file)": 1.597,
    "Lease Term": 30,
    "Annual Lease Fee": 45245,
    "Land Use Premium": null,
    "Number Of Local Employees": 694,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "WUSUNGRUBOA PARK 1103 GHO, 226 MISA GANGBYUN JUNGANG _RO,HANAM CITY.",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၃၃၂) ၊ မြေတိုင်းရပ်ကွက် အမှတ်(၂၅)၊  ရွှေလင်ဗန်း စက်မှုဇုန်မြို့",
  },
  {
    ID: 3219,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦကျော်ထူး",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "KYI & INGYN COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "194/2019",
    "Permit Date": "2019-06-11T03:46:44Z",
    "Meeting Number": "8/2019",
    "Meeting Date": "2019-05-29T03:47:05Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် ငါးမျှားချိတ်များတွင်  ငါးမျှားကြိုးများ တပ်ဆင်ခြင်းလုပ်ငန်း။",
    "Amount Of Foreign Capital USD (in Millions)": 200,
    "Total Amount Of Capital (in Millions)": 200,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Nandar Win , U Than Win",
    "Land Area (units not specified in file)": 0.112,
    "Lease Term": 5,
    "Annual Lease Fee": 5400000,
    "Land Use Premium": null,
    "Number Of Local Employees": 33,
    "Number Of Foreign Employees": 1,
    Status: "Draft",
    "Investor Address": "အမှတ် (၄၇)၊ ဓမဝိဟာရလမ်း၊ ကျောက်မြောင်း၊ တာမွေမြို့နယ်",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၁၁၆၉+၁၁၇၀)၊ မြေတိုင်းရပ်ကွက် အမှတ်-၆၃/ စက်မှုဇုန် (၂)၊",
  },
  {
    ID: 3220,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. YU, NAIYOU  ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "DAHUI (MYANMAR) INDUSTRY COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "217/2019",
    "Permit Date": "2019-07-09T04:28:57Z",
    "Meeting Number": "10/2019",
    "Meeting Date": "2019-06-26T04:29:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အိတ်အမျိုးမျိူး ထုတ်လုပ်ခြင်းလုပ်ငန်း။",
    "Amount Of Foreign Capital USD (in Millions)": 1.104,
    "Total Amount Of Capital (in Millions)": 1.104,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "ဦးနေဝင်း (ခ) ဦးတင်စိန်",
    "Land Area (units not specified in file)": 2.535,
    "Lease Term": 10,
    "Annual Lease Fee": 60000000,
    "Land Use Premium": null,
    "Number Of Local Employees": 1000,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address":
      "NO. 4, DANG YANG ROAD, KUN YANG TOWN, PING YANG COUNTY, ZHEJIANG PROVINCE",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 140, MYAY TAING BLOCK NO.14/SHWE THN LWIN, ",
  },
  {
    ID: 3221,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. HU, JINGUI",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "SAN XIN MYANMAR GARMENT COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "216/2019",
    "Permit Date": "2019-07-09T06:23:47Z",
    "Meeting Number": "10/2019",
    "Meeting Date": "2019-06-26T06:24:25Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည် ချုပ်လုပ်ခြင်းလုပ်ငန်း။",
    "Amount Of Foreign Capital USD (in Millions)": 1.177,
    "Total Amount Of Capital (in Millions)": 1.177,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Ni Ni Aye",
    "Land Area (units not specified in file)": 1.015,
    "Lease Term": 10,
    "Annual Lease Fee": 27226.8,
    "Land Use Premium": null,
    "Number Of Local Employees": 450,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "NO.386, WEST ROAD LINPING STREET , YUHANG DISTRICT , HANGZHOU CITY , ZHEJIANG PROVINCE , ",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၃၆)၊မြေတိုင်းရပ်ကွက် အမှတ်( စက်မှုဇုန် - ၄)",
  },
  {
    ID: 3222,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Zaw Win @ U Win Khine",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "CORE PACIFIC PIONEER (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "215/2019",
    "Permit Date": "2019-07-09T06:48:35Z",
    "Meeting Number": "10/2019",
    "Meeting Date": "2019-06-26T06:48:52Z",
    Sector: "Construction",
    "Type Of Investment Business":
      "DEVELOPMENT SALES  AND LEASE OF RESIDENTIAL",
    "Amount Of Foreign Capital USD (in Millions)": 4.9,
    "Total Amount Of Capital (in Millions)": 4.9,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 70,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "U Nyan Soe Lwin, Daw Nwe Nwe Swe",
    "Land Area (units not specified in file)": 0.146,
    "Lease Term": 50,
    "Annual Lease Fee": 21428571,
    "Land Use Premium": null,
    "Number Of Local Employees": 4,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address":
      "NO.153/A , KYUN SHWE MYAING LANE (2) , 23- WARD , THINGANGYUN TOWNSHIP ,YANGON.",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. (28/A), MYAY TAING NO. (50), RESIDENTIAL BLOCK_ KANBAE, MAYANGONG TOWNSHIP, ",
  },
  {
    ID: 3223,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.JIN, HAIXING",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "MYANMAR SINYOUNG FASHION CLOTHES COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "209/2019",
    "Permit Date": "2019-06-21T07:21:23Z",
    "Meeting Number": "9/2019",
    "Meeting Date": "2019-06-12T07:21:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အထည်အမျိုးမျိူး ချုပ်လုပ်ခြင်းလုပ်ငန်း။",
    "Amount Of Foreign Capital USD (in Millions)": 0.877,
    "Total Amount Of Capital (in Millions)": 0.877,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U SOE HLAING",
    "Land Area (units not specified in file)": 1.9,
    "Lease Term": 10,
    "Annual Lease Fee": 111120,
    "Land Use Premium": null,
    "Number Of Local Employees": 835,
    "Number Of Foreign Employees": 20,
    Status: "Draft",
    "Investor Address": "SI JIA TUAN ER CUN, DAXIN TOWN, JIMO CITY, QINGDOAO, ",
    "Organization Address": "",
    "Investment Permitted Address":
      "NO.12/A , KWIN NO. (363), ASHUGYI EAST , AHSUGYI VILLAGE TRACT.",
  },
  {
    ID: 3224,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. XIE ZUYI",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "RAINBOWTEX ( MYANMAR) GARMENTS COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "193/2019",
    "Permit Date": "2019-05-23T08:02:08Z",
    "Meeting Number": "7/2019",
    "Meeting Date": "2019-05-06T08:02:28Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အဝတ်အထည် အမျိုးမျိုး ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.599,
    "Total Amount Of Capital (in Millions)": 0.599,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Win TIn",
    "Land Area (units not specified in file)": 3,
    "Lease Term": 10,
    "Annual Lease Fee": 163200,
    "Land Use Premium": null,
    "Number Of Local Employees": 600,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address":
      "NO.139,CHANGFU ROAD, JIN AN DISTRICT,FUZHOU, FUJIAN PROVINCE,",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO-75,MYAY TAING BLOCK NO-49, WAR TA YAR INDUSTRIAL ZONE,",
  },
  {
    ID: 3225,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. SUN GE",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "SANYUAN OVERSEA (MYANMAR) APPAREL MANUFACTURING COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "190/2019",
    "Permit Date": "2019-04-19T08:30:29Z",
    "Meeting Number": "6/2019",
    "Meeting Date": "2019-04-10T08:31:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အထည်အမျိုးမျိူး ချုပ်လုပ်ခြင်းလုပ်ငန်း။",
    "Amount Of Foreign Capital USD (in Millions)": 1.435,
    "Total Amount Of Capital (in Millions)": 1.435,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Yu Yu Win",
    "Land Area (units not specified in file)": 4.146,
    "Lease Term": 10,
    "Annual Lease Fee": 72,
    "Land Use Premium": null,
    "Number Of Local Employees": 1001,
    "Number Of Foreign Employees": 20,
    Status: "Draft",
    "Investor Address": "NO.649, NINGSHUI ROAD, XIAOSHAN, HANGZHOU",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၁၅၊၁၆) မြေတိုင်းရပ်ကွက် အမှတ်-၁၀၉၊ စက်မှု",
  },
  {
    ID: 3226,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. ZHUANG JUN YU",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MAYFAIR (MYANMAR) INDUSTRY COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "189/2019",
    "Permit Date": "2019-04-19T09:02:01Z",
    "Meeting Number": "6/2019",
    "Meeting Date": "2019-04-10T09:02:36Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် လက်အိတ်၊ခြေအိတ် နှင့် အိမ်တွင်းစီးဖိနပ် အမျိုးမျိူးထုပ်လုပ်ခြင်းလုပ်ငန်း။",
    "Amount Of Foreign Capital USD (in Millions)": 1.5,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 36,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Yin Aung",
    "Land Area (units not specified in file)": 3.023,
    "Lease Term": 16,
    "Annual Lease Fee": 93600,
    "Land Use Premium": null,
    "Number Of Local Employees": 186,
    "Number Of Foreign Employees": 18,
    Status: "Draft",
    "Investor Address":
      "ROOM-2, BUILDING 137, FUDI LANGXIANG VILLA, MOLING STREET, JANGNING DISTRICT, NANJING CITY",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၁၁၉)၊မြေတိုင်းရပ်ကွက် အမှတ်( စက်မှုဇုန် - ၂)",
  },
  {
    ID: 3227,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS. YIP LAI TING",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "GREENLINE GLOVES MANUFACTORY (MYANMAR) LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "212/2019",
    "Permit Date": "2019-06-21T09:43:20Z",
    "Meeting Number": "9/2019",
    "Meeting Date": "2019-06-12T09:44:04Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အ၀တ်အထည် (လက်အိတ်နှင့်ရှေ့ဖုံးခါးစည်း)အမျိုးမျိူး ချုပ်လုပ်ခြင်းလုပ်ငန်း။",
    "Amount Of Foreign Capital USD (in Millions)": 0.67,
    "Total Amount Of Capital (in Millions)": 0.67,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 70,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Zaw Tun Win",
    "Land Area (units not specified in file)": 1.089,
    "Lease Term": 6,
    "Annual Lease Fee": 48,
    "Land Use Premium": null,
    "Number Of Local Employees": 340,
    "Number Of Foreign Employees": 6,
    Status: "Draft",
    "Investor Address":
      "FLAT D, 28/F, TOWER E, THE GRANDVILLE, 2 LOK KWAI PATH,FO TAN ,SHATING, HONG KONG",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.249, MYAY TAING BLOCK NO.25, SHWE LIN BAN INDUSTRIAL ZONE",
  },
  {
    ID: 3228,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LEUNG YU KE JACKIE",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "TWINKLE (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "211/2019",
    "Permit Date": "2019-06-21T03:28:32Z",
    "Meeting Number": "9/2019",
    "Meeting Date": "2019-06-12T03:30:04Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့်  အိတ်အမျိုးမျိူးထုပ်လုပ်ခြင်း လုပ်ငန်း။",
    "Amount Of Foreign Capital USD (in Millions)": 4.089,
    "Total Amount Of Capital (in Millions)": 4.089,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner":
      "ဦးတင်မောင်သိန်း ၊ ဦးတင်မောင်ဇော်၊ ဦးတင်မောင်မြင့်၊ ဒေါ်သန်းသန်းအေး",
    "Land Area (units not specified in file)": 4.6,
    "Lease Term": 5,
    "Annual Lease Fee": 226476,
    "Land Use Premium": null,
    "Number Of Local Employees": 1149,
    "Number Of Foreign Employees": 33,
    Status: "Draft",
    "Investor Address":
      "FLAT 17B, BLOCK-3, 18 PIK TIN STREET, GRANVILLE GARDEN, TAI WAI ,N.T. HONG KONG ",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၁၆၇၊၁၆၈) ၊ မြေတိုင်းရပ်ကွက် အမှတ်( စက်မှုဇုန် - ၄၉) ၊ဝါးတစ်ရာ စက်မှုဇုန်",
  },
  {
    ID: 3229,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "CORE ELECTRONICS MYANMAR COMPANY LIMITED",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "CORE ELECTRONICS MYANMAR COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "207/2019",
    "Permit Date": "2019-06-21T04:38:27Z",
    "Meeting Number": "9/2019",
    "Meeting Date": "2019-06-12T04:39:03Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF ELECTRONIC COMPONENTS",
    "Amount Of Foreign Capital USD (in Millions)": 0.5,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaw Htay Min , Daw Mee Mee Aye",
    "Land Area (units not specified in file)": 1.065,
    "Lease Term": 5,
    "Annual Lease Fee": 66,
    "Land Use Premium": null,
    "Number Of Local Employees": 133,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address":
      "UNIT 19-10, 19th FLOOR, SULE SQUARE OFFICE TOWER, SULE PAGODA ROAD.",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. -60/A, MYAY TAING NO. INDUSTRIAL ZONE (1) ,",
  },
  {
    ID: 3230,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. DAI JIANWEI",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "RUIFA ENTERPRISE LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "200/2019",
    "Permit Date": "2019-06-11T05:05:23Z",
    "Meeting Number": "8/2019",
    "Meeting Date": "2019-05-29T05:05:52Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အိတ်အမျိုးမျိူး ထုပ်လုပ်ခြင်းလုပ်ငန်း။",
    "Amount Of Foreign Capital USD (in Millions)": 1.573,
    "Total Amount Of Capital (in Millions)": 1.573,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Lwin",
    "Land Area (units not specified in file)": 2.117,
    "Lease Term": 10,
    "Annual Lease Fee": 118523.72,
    "Land Use Premium": null,
    "Number Of Local Employees": 821,
    "Number Of Foreign Employees": 12,
    Status: "Draft",
    "Investor Address":
      "SUITES 103,106 & 107, PREMIER BUILDING, VICTORIA, MAHE, SEYCHELLES",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၄၉၈)၊မြေတိုင်းရပ်ကွက် အမှတ်(၂၅) ၊ရွှေလင်ဗန်း စက်မှုဇုန်",
  },
  {
    ID: 3231,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR.WANG YIQIANG",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "FULL STRONG TEXTILE COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "206/2019",
    "Permit Date": "2019-06-21T06:30:08Z",
    "Meeting Number": "9/2019",
    "Meeting Date": "2019-06-12T06:31:16Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": " လက်အိတ် အမျိုးမျိူးထုပ်လုပ်ခြင်းလုပ်ငန်း။",
    "Amount Of Foreign Capital USD (in Millions)": 1.725,
    "Total Amount Of Capital (in Millions)": 1.725,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 35,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Win Zaw Oo",
    "Land Area (units not specified in file)": 0.97,
    "Lease Term": 15,
    "Annual Lease Fee": 23700,
    "Land Use Premium": null,
    "Number Of Local Employees": 701,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "HAIZHUN STREET, ROOM 308, UNIT 4,YUNXIA COURT14, LILY NEW CITY, HAINING CITY, ZHEJIANG PROVINCE",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၆၉)၊မြေတိုင်းရပ်ကွက် အမှတ်( စက်မှုဇုန် - ၂)",
  },
  {
    ID: 3232,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MRS. CHEN,SU- HUA",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "FUYUN MYANMAR COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "199/2019",
    "Permit Date": "2019-06-11T06:51:51Z",
    "Meeting Number": "8/2019",
    "Meeting Date": "2019-05-29T06:52:56Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အီလက်ထရောနစ် စနစ်ဖြင့် ပြုလုပ်ထားသော လက်ဆောင်၊ အလှဆင်ပစ္စည်းများနှင့် ဆက်စပ်သော ပစ္စည်းများ ထုတ်လုပ်ခြင်းလုပ်ငန်း။",
    "Amount Of Foreign Capital USD (in Millions)": 0.5,
    "Total Amount Of Capital (in Millions)": 0.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Nay Linn Zaw",
    "Land Area (units not specified in file)": 0.906,
    "Lease Term": 5,
    "Annual Lease Fee": 56.88,
    "Land Use Premium": null,
    "Number Of Local Employees": 50,
    "Number Of Foreign Employees": 8,
    Status: "Draft",
    "Investor Address": "FU XI INDUSTRIAL, ZHUHAI CITY, GUANG DONG.",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၄၆၇-ခ)၊မြေတိုင်းရပ်ကွက် အမှတ်( ၂၅)၊ရွှေလင်ဗန်း စက်မှုမြို့။",
  },
  {
    ID: 3234,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. WU, YINGYUAN",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "HUNG YANG LEATHER COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "224/2019",
    "Permit Date": "2019-07-22T08:08:33Z",
    "Meeting Number": "11/2019",
    "Meeting Date": "2019-07-09T08:09:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အိတ်အမျိုးမျိူး ချုပ်လုပ်ခြင်းလုပ်ငန်း။",
    "Amount Of Foreign Capital USD (in Millions)": 0.15,
    "Total Amount Of Capital (in Millions)": 0.15,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 18,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Lin Kim Sein@U Khin Sein, U Win Myint",
    "Land Area (units not specified in file)": 1.262,
    "Lease Term": 6,
    "Annual Lease Fee": 72,
    "Land Use Premium": null,
    "Number Of Local Employees": 172,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "TIEFO VILLAGE,NO. 38, 6 GROUP, XIANFENG TOWN, YILONG COUNTY, SICHUAN PROVINCE.",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၃၅၆)၊မြေတိုင်းရပ်ကွက် အမှတ်( ၂၅)၊ရွှေလင်ဗန်း စက်မှုဇုန်",
  },
  {
    ID: 3235,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LIU LUNQUAN",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "YINGSHENG (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "225/2019",
    "Permit Date": "2019-07-22T09:34:31Z",
    "Meeting Number": "11/2019",
    "Meeting Date": "2019-07-09T09:34:55Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ဖိနပ်အောက်ခံ ဆိုးလ်များ ထုတ်လုပ်၍ပြည်တွင်းရှိ CMP လုပ်ငန်းများသို့ ရောင်းချခြင်းလုပ်ငန်း။",
    "Amount Of Foreign Capital USD (in Millions)": 0.382,
    "Total Amount Of Capital (in Millions)": 0.382,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Lwin",
    "Land Area (units not specified in file)": 2.347,
    "Lease Term": 10,
    "Annual Lease Fee": 47489,
    "Land Use Premium": null,
    "Number Of Local Employees": 71,
    "Number Of Foreign Employees": 4,
    Status: "Draft",
    "Investor Address":
      "VILLAAREA, PUTAOZHUANYUAN ROOM 4601,DONGGUANCITY, WANJIANG DISTRICT, GUANGDONG PROVINCE.",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၁၀၂)၊မြေတိုင်းရပ်ကွက် အမှတ်(၂၅)၊ရွှေလင်ဗန်း စက်မှုဇုန်",
  },
  {
    ID: 3237,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS. LE DUONG UYEN KHNAH",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "DOUNG LINH HOLDINGS (MYANMAR ) COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "222/2019",
    "Permit Date": "2019-07-09T03:50:03Z",
    "Meeting Number": "10/2019",
    "Meeting Date": "2019-06-26T03:50:33Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Recycle Products (ဉပမာ -Metal scraps ) အား ခွဲခြားထုတ်ပိုး တင်ပို့ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.6,
    "Total Amount Of Capital (in Millions)": 0.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Vietnam",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Khin  Oo Lwin",
    "Land Area (units not specified in file)": 1.065,
    "Lease Term": 5,
    "Annual Lease Fee": 15024,
    "Land Use Premium": null,
    "Number Of Local Employees": 25,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "69/2/18 D2 STREET , WARD 25, BINH THANH DIST, HO CHI MINH",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. (76/b), MYAY TAING NO.  INDYSTRIAL ZONE",
  },
  {
    ID: 3238,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးသန်းလွင်",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Hein Myanmar Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "220/2019",
    "Permit Date": "2019-07-09T04:40:53Z",
    "Meeting Number": "10/2019",
    "Meeting Date": "2019-06-26T04:41:27Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အိတ်အမျိုးမျိူး ချုပ်လုပ်ခြင်းလုပ်ငန်း။",
    "Amount Of Foreign Capital USD (in Millions)": 2500,
    "Total Amount Of Capital (in Millions)": 2500,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "မိမိပိုင်မြေတွင် လုပ်ငန်းဆောင်ရွက်ခြင်းဖြစ်ပါသည်။",
    "Land Area (units not specified in file)": 3.72,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 400,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "အမှတ် -၂၅/က၊ စက်မှု (၂)လမ်း၊ မေဝ္တာာညွန့်ရပ်ကွက်၊ တာမွေမြို့နယ်",
    "Organization Address": "",
    "Investment Permitted Address":
      "ဦးပိုင်းအမှတ် -(စက်မှု-၁၉၊၂၀၊၂၁၊၅၀၊၅၁၊၅၂) ၊အကွက်အမှတ် -(၁)ကံကြီးကုန်းကွင်း ၊အမှတ် (၄)ရပ်ကွက်",
  },
  {
    ID: 3239,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MRS. WANG, MINGXIA",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "HUIYUAN GARMENT COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "221/2019",
    "Permit Date": "2019-07-09T05:39:21Z",
    "Meeting Number": "10/2019",
    "Meeting Date": "2019-06-26T05:39:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အထည်အမျိုးမျိူး ချုပ်လုပ်ခြင်းလုပ်ငန်း။",
    "Amount Of Foreign Capital USD (in Millions)": 0.55,
    "Total Amount Of Capital (in Millions)": 0.55,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 70,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "ဦးသိန်းထွန်း",
    "Land Area (units not specified in file)": 1.969,
    "Lease Term": 6,
    "Annual Lease Fee": 41833.366,
    "Land Use Premium": null,
    "Number Of Local Employees": 545,
    "Number Of Foreign Employees": 4,
    Status: "Draft",
    "Investor Address":
      "NO. 35, VILLAGE GROUP, LANSHAN VILLAGE, PAILOU TOWN, CHIZHOU CITY, GUI CHI DISTRICT, ANHUI PROVINCE",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. (126), MYAY TAING  BLOCK NO.SETHMYU ZONE",
  },
  {
    ID: 3240,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. SHE, WEIWEI",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MING YU MATERIAL PRODUCTS COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "223/2019",
    "Permit Date": "2019-07-22T06:48:17Z",
    "Meeting Number": "11/2019",
    "Meeting Date": "2019-07-09T06:50:05Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အိတ်နှင့် ဖိနပ်များချုပ်လုပ်ရာတွင် ထည့်သွင်းအသုံးပြုသော (ဥပမာ -Lining, Nylon Paper နှင့် Non-Woven) များထုတ်လုပ်၍ပြည်တွင်းရှိ CMP လုပ်ငန်းများသို့ ရောင်းချခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.3,
    "Total Amount Of Capital (in Millions)": 0.3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw  Win Mar Oo",
    "Land Area (units not specified in file)": 1.045,
    "Lease Term": 10,
    "Annual Lease Fee": 21144.85,
    "Land Use Premium": null,
    "Number Of Local Employees": 104,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "NO. 005, GANGLING VILLAGE, SHUANGXIKOU TOWNSHIP, TAOYUAN COUNTY, HUNAN PROVINCE",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ် (၁၈၇)၊မြေတိုင်းရပ်ကွက် အမှတ်( ဇုန် - ၅)",
  },
  {
    ID: 3241,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. SAMEER KAUSHAL",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "CONCORDE INDUSTRIES LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "227/2019",
    "Permit Date": "2019-07-22T07:54:37Z",
    "Meeting Number": "11/2019",
    "Meeting Date": "2019-07-09T07:55:20Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ဆန်၊ စပါး ဝယ်ယူ ကြိတ်ခွဲပြီး ဆန် နှင်  ဆန်ကွဲများ ထုတ်လုပ်၍ ရာနှုန်းပြည် တင်ပို့ ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 5,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "India",
    "Form Of Investment": "FDII",
    "Land Owner": "U Maung maung Oo",
    "Land Area (units not specified in file)": 16.93,
    "Lease Term": 25,
    "Annual Lease Fee": 100000,
    "Land Use Premium": null,
    "Number Of Local Employees": 94,
    "Number Of Foreign Employees": 6,
    Status: "Draft",
    "Investor Address":
      "HOUSING NO. (155), SECTOR-29, NOIDA,  GAURAM BUDH NAGAR UPTAR PRADESH",
    "Organization Address": "",
    "Investment Permitted Address":
      "ဦးပိုင်းအမှတ် (၆/၂+၇+၈+၉+၁၀+၁၁+၁၂+၁၃)၊ အကွက်အမှတ် (၁၇၉)၊ ခနောင်တိုကွင်း၊ လက်ပံဂွကျေးရွာအုပ်စု",
  },
  {
    ID: 3242,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "ဦးသန်းအောင်",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myin Za Yi Co.,Ltd.(မဉ္ဇရီ ကုမ္ပဏီ လီမိတက်)",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "MaNaTha-370/2000",
    "Permit Date": "2000-04-20T03:12:20Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 48.93,
    "Total Amount Of Capital (in Millions)": 48.93,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "အမှတ်(၆၉)၊ ရှမ်းလမ်း၊ အလုံမြို့နယ်၊ ရန်ကုန်မြို့။",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၅၃/၅၄)၊ ရွှေပေါက်ကံစက်မှုဇုန်၊ မြေတိုင်းရပ်ကွက်အမှတ်(၁၈)၊ မြောက်ဥက္ကလာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 3244,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Aung Moe Kyaw",
    "Name of Principal Organization": "Total Supply Chain Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "Myanmar Supply Chain and Marketing Services Co., Ltd.",
    "Financial Year From": 2012,
    "Financial Year To": 2013,
    "Permit Number": "565/2013",
    "Permit Date": "2013-02-24T07:13:28Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Logistics (Transportation and Warehousing), Marketing Services (Branding, Trade Marketing) for FMCG Industry",
    "Amount Of Foreign Capital USD (in Millions)": 4.63,
    "Total Amount Of Capital (in Millions)": 9.26,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 28,
    "Investing Country": "Brunei Darussalam",
    "Form Of Investment": "JV",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "No.18, Aungmingalar Street, Aung Theikdi Road, 3 Ward, Mayangone Township,Yangon Region",
    "Organization Address":
      "No. R-18, S-19, Sittaung Street, Pyainnyawaddy Avenue, Yankin Township, Yangon Region",
    "Investment Permitted Address":
      "Yangon, Mandalay, Naypitaw, Muse, Magwe, Taunggyi, Kyaingtone, Lashio, Myitkyinar, Sittwe, Mawlamyaing",
  },
  {
    ID: 3246,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. WANG, GUANDONG",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "DONG CHEN HANDBAG (MYANMAR) LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "186/2019",
    "Permit Date": "2019-04-19T08:44:28Z",
    "Meeting Number": "6/2019",
    "Meeting Date": "2019-04-10T08:45:02Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF VARIOUS KINDS OF BAGS ON CMO BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.691,
    "Total Amount Of Capital (in Millions)": 0.691,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 35,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Ni Lar Myint , U Maung Maung Owne",
    "Land Area (units not specified in file)": 3.46,
    "Lease Term": 15,
    "Annual Lease Fee": 192000,
    "Land Use Premium": null,
    "Number Of Local Employees": 823,
    "Number Of Foreign Employees": 7,
    Status: "Draft",
    "Investor Address":
      "NO.22, GROUP 2, YUEJIN VILLAGE, FUSHI TOWN, FUSHUN COUNTY, SICHUAN PROVINCE",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.80,81, MYAY TAING BLOCK NO. INDUSTRY ZONE 2, DAGON (SEIK KAN) TOWNSHIP",
  },
  {
    ID: 3247,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "HYATT KNITWEAR COMPANY LIMITED",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "HYATT KNITWEAR COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "187/2019",
    "Permit Date": "2019-04-19T09:14:00Z",
    "Meeting Number": "6/2019",
    "Meeting Date": "2019-04-10T09:14:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF GARMENTS AND KNITTING WEARS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.9,
    "Total Amount Of Capital (in Millions)": 0.9,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Ei Ei Chaw, U Myat Thu Naing",
    "Land Area (units not specified in file)": 0.92,
    "Lease Term": 50,
    "Annual Lease Fee": 12000000,
    "Land Use Premium": null,
    "Number Of Local Employees": 145,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "PLOT NO.(105), INDUSTRIAL ZONE (5), HLAING THAR YAR TOWNSHIP",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.(105), INDUSTRIAL ZONE (5), HLAING THAR YAR TOWNSHIP",
  },
  {
    ID: 3248,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Yoma Siloam Hospital Pun Hlaing Limited",
    "Name of Principal Organization": "",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Yoma Siloam Hospital Pun Hlaing Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "115/18",
    "Permit Date": "2018-09-07T03:01:42Z",
    "Meeting Number": "14/2018",
    "Meeting Date": "2018-09-07T03:01:56Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "International Standard Hospital, Diagnosis Center, Clinic and Healthcare Services",
    "Amount Of Foreign Capital USD (in Millions)": 0.38,
    "Total Amount Of Capital (in Millions)": 0.95,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Indonesia",
    "Form Of Investment": "JV",
    "Land Owner":
      "Daw Htwe Htwe, Daw Ohn Mar Sein, ThanLyin Estate Development Limited",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 51,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "The Campus, 1 Office Park, Rain Tree Drive, Pun Hlaing Estate, Hlaing Tharyar Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "NO.238-240, PLOT NO. 19, MYAY TAING BLOCK NO.12-B, BOGYOKE AUNG SAN ROAD, BOTAHTAUNG TOWNSHIP, YANGON REGION , BUILDING A-5, WING A, STAR CITY, THANLYIN TOWNSHIP, YANGON REGION AND NO. 37, THARSI WARD (2) ROAD, NYAUNG SHWE TOWNSHIP, SHAN STATE",
  },
  {
    ID: 3249,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ကင့်(တ်)အင်ဒတ်စထရီး(စ်)(မြန်မာ) လီမိတက်",
    "Financial Year From": 0,
    "Financial Year To": 0,
    "Permit Number": "599/2003",
    "Permit Date": "2003-03-08T03:09:50Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.01,
    "Total Amount Of Capital (in Millions)": 17.47,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "အမှတ်(၇၇)ဘီ/၃၆၂ မြေကွက်အမှတ်(၆-က)၊ အောက်မင်္ဂလာဒုံလမ်း၊ အရှေ့ရွာမ၊ အင်းစိန်",
  },
  {
    ID: 3250,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ဟန်ဂျင်းမန်နျူဖက်ချားရင်း ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 2002,
    "Financial Year To": 2003,
    "Permit Number": "မနသ-၆၀၁/၂၀၀၃",
    "Permit Date": "2003-03-13T03:17:12Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.127,
    "Total Amount Of Capital (in Millions)": 246.04,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်း၊ လှိုင်မြို့နယ်၊ မြေတိုင်းရက်ကွက်အမှတ် (၁၆)၊ (၁၃)ရပ်ကွက်",
  },
  {
    ID: 3251,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "မြန်မာအက်(စ်) အမ်စီဂါးမန့် လီမိတက်",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "မနသ-၆၀၆/၂၀၀၃",
    "Permit Date": "2003-04-22T03:22:29Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် နိုင်ငံတကာ အဆင့်မီအထည်အမျိုးမျိုး ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 19.64,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-\n",
    "Organization Address": "",
    "Investment Permitted Address":
      "ကွင်းအမှတ်(၅၁-၈-အေ)၊ ဦးပိုင်အမှတ်(၆၃-ခ)ဆတ်သွားတောကျေးရွာ၊ မှော်ဘီမြို့နယ်၊ ရန်ကုန်",
  },
  {
    ID: 3252,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar VES Joint Venture Co.,Ltd",
    "Financial Year From": 1992,
    "Financial Year To": 1993,
    "Permit Number": "057/1992",
    "Permit Date": "1992-08-19T03:25:27Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ကျောက်မျက်ရတနာထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 5,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Guinea-Bissau",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address": "မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 3256,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. MITSUHIRO KITSUWA",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MYANMAR SAKICHI GARMENT LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "155/2019",
    "Permit Date": "2019-02-21T07:03:49Z",
    "Meeting Number": "3/2019",
    "Meeting Date": "2019-02-13T07:04:40Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့်အမျိုးသမီးဝတ် ဘရာစီယာ ၊ အတွင်းခံဘောင်းဘီချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.327,
    "Total Amount Of Capital (in Millions)": 0.327,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Japan",
    "Form Of Investment": "FDII",
    "Land Owner": "ဦးအောင်ဆွေ",
    "Land Area (units not specified in file)": 0.344,
    "Lease Term": 10,
    "Annual Lease Fee": 24000,
    "Land Use Premium": null,
    "Number Of Local Employees": 87,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address":
      "5F2-2-3, EDGE SHINSAIEASHI, NISHISHINSAIBASHI, CHUO-KU, OSAKA",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. 141, 141(kA), MYAY TAING NO. (NGA), SETHMU LATHMU",
  },
  {
    ID: 3257,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS. WANG, JING",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "JIASHIHAO (MYANMAR) LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "153/2019",
    "Permit Date": "2019-02-21T07:41:10Z",
    "Meeting Number": "3/2019",
    "Meeting Date": "2019-02-13T07:41:38Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အဝတ်အထည်အမျိုးမျိူး ချုပ်လုပ်ခြင်းလုပ်ငန်း။",
    "Amount Of Foreign Capital USD (in Millions)": 2.848,
    "Total Amount Of Capital (in Millions)": 2.848,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 40,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "ဦးတင်ဆွေ (ခ) ဦးအောင်ခြည်",
    "Land Area (units not specified in file)": 4.096,
    "Lease Term": 20,
    "Annual Lease Fee": 60000000,
    "Land Use Premium": null,
    "Number Of Local Employees": 750,
    "Number Of Foreign Employees": 20,
    Status: "Draft",
    "Investor Address":
      "ROOM NO.1101, 10-16 CONCHRANE STREET, WINNING HOUSE, HONG KONG",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. (77-KA), MYAY TAING BLOCK NO. (42),  INDYSTRIAL",
  },
  {
    ID: 3258,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. DING, WEILIN",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "DA CHENG MYANMAR COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "152/2019",
    "Permit Date": "2019-02-21T09:28:33Z",
    "Meeting Number": "3/2019",
    "Meeting Date": "2019-03-13T09:28:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF VARIOUS KINDS OF LABELS FOR GARMENTS",
    "Amount Of Foreign Capital USD (in Millions)": 20696,
    "Total Amount Of Capital (in Millions)": 20696,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Att Sa Tar",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 20,
    "Annual Lease Fee": 24,
    "Land Use Premium": null,
    "Number Of Local Employees": 200,
    "Number Of Foreign Employees": 8,
    Status: "Draft",
    "Investor Address":
      "NO.8, XINMING STREET, ZHOUZHUANG TOWN,KUNSHAN CITY,JIANGSU PROVINCE",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO.88, MYAY TAING BLOCKNO.(51). THAR DU KAN INDYSTRIAL ZONE,",
  },
  {
    ID: 3259,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. JIANG, ZHANGPING",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "MANJIANG RED PLASTIC INDUSTRY (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "154/2019",
    "Permit Date": "2019-02-21T10:08:35Z",
    "Meeting Number": "3/2019",
    "Meeting Date": "2019-02-13T10:08:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MNUFACTURING AND EXPORTING OF PLASTIC BELTS FOR PARKING",
    "Amount Of Foreign Capital USD (in Millions)": 1.161,
    "Total Amount Of Capital (in Millions)": 1.161,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Tin Aung Myo",
    "Land Area (units not specified in file)": 0.404,
    "Lease Term": 10,
    "Annual Lease Fee": 4000000,
    "Land Use Premium": null,
    "Number Of Local Employees": 47,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address":
      "NAN VILLAGE, SOUTH GUANGXI TOWNSHIP, LEO COUNTY, FUJIAN PROVINCE",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT NO. (172), MYAY TAING BLOCK NO.(113), SETTHMU",
  },
  {
    ID: 3260,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Kyaw Swar Oo",
    "Name of Principal Organization": "Myanmar Mobile Money Services Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Myanmar Mobile Money Services Co., Ltd.",
    "Financial Year From": 2017,
    "Financial Year To": 2018,
    "Permit Number": "045/2017",
    "Permit Date": "2017-08-20T04:49:51Z",
    "Meeting Number": "11/2017",
    "Meeting Date": "2017-08-07T04:50:26Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Mobile Money Services",
    "Amount Of Foreign Capital USD (in Millions)": 0,
    "Total Amount Of Capital (in Millions)": 4000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 0,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "No. 51, Bo Ywar Hnunt Street, Dagon Township, Yangon",
    "Organization Address":
      "No. 51, Bo Ywar Hnunt Street, Dagon Township, Yangon",
    "Investment Permitted Address":
      "ရန်ကုန်တိုင်းဒေသကြီး၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ဌ တိုးချဲ့ရပ်ကွက်၊ လက်လီလက်ကားနှင့် အဝေးပြေးကုန်တင်ယာဉ်ရပ်နားစခန်း၊ အမှတ် D-8",
  },
  {
    ID: 3261,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "ရွှေဇင်အေးအထည်ချုပ်နှင့် အထွေထွေ ရောင်းဝယ်ရေး သမဝါယမအသင်း လီမိတက်",
    "Financial Year From": 1995,
    "Financial Year To": 1996,
    "Permit Number": "002/1995",
    "Permit Date": "1995-01-31T05:01:26Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အသင့်ချုပ်ပြီးအထည်များ ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.94,
    "Total Amount Of Capital (in Millions)": 27,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "အထည်စက်ရုံအမှတ်(၁၀)၊ ရုံခွဲ(၄)၊မေဓါဝီလမ်း၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 3262,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "သီလဝါစက်မှုလုပ်ငန်း လီမိတက်",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "026/1996",
    "Permit Date": "1996-06-28T05:11:37Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ဘိလပ်မြေ အုတ်ကြွပ်နှင့် ခေါင်အုပ်များ ထုတ်လုပ်ရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.49,
    "Total Amount Of Capital (in Millions)": 45.27,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "သန္ဓေပင်ကျေးရွာ၊ မှော်ဘီမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 3263,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "အပိုလိုဂါးမင့် ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "030/1996",
    "Permit Date": "1996-07-22T05:22:07Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အသင့်ချုပ်ပြီးအထည်များ ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 6.14,
    "Total Amount Of Capital (in Millions)": 20,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၄၁)၊ လှိုင်သာယာစက်မှုဇုန်(၁)၊ကနောင်မင်းသားကြီး",
  },
  {
    ID: 3264,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "မြန်မာမင်းဒွန်းဂါးမင့်မင်နျူဖက်ချားရင်း ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "038/1996",
    "Permit Date": "1996-08-30T06:46:56Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အသင့်ချုပ်ပြီး အထည်များ ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.9,
    "Total Amount Of Capital (in Millions)": 28,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေတိုင်းရပ်ကွက်အမှတ်(၂၄)၊ ၁၆၂ ၊၁၆၃၊ စက်မှုဇုန်ဒေသ၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 3265,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "ထရိုင်းဒင့်မြန်မာဂျင််နရယ် ထရိတ်ဒင်း ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1996,
    "Financial Year To": 1997,
    "Permit Number": "049/1996",
    "Permit Date": "1996-11-22T06:53:22Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "အိမ်မိုးသွပ်ပြားများ ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 2.2,
    "Total Amount Of Capital (in Millions)": 40.4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၆၁၊၁၆၂)၊ မြေတိုင်းအမှတ်(၄၂)၊၊ စက်မှုဒေသ၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 3266,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "ယုံဖတ်အပြည်ပြည်ဆိုင်ရာ ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 1997,
    "Financial Year To": 1998,
    "Permit Number": "055/1997",
    "Permit Date": "1997-01-03T07:18:31Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ ဖိနပ်အမျိုးမျိုးချုပ်လုပ်သည့်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.12,
    "Total Amount Of Capital (in Millions)": 20.73,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၆)၊ မြေတိုင်းအမှတ်(၄)၊ စက်မှုလက်မှုဇုံ၊ရွှေပြည်သာမြို့နယ်၊ရန်ကုန်မြို့",
  },
  {
    ID: 3267,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "မွန်းကရဲ(စ်) ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "147/1998",
    "Permit Date": "1998-07-03T07:23:22Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.9,
    "Total Amount Of Capital (in Millions)": 27.4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၅)၊ လှိုင်သာယာစက်မှုဇုန်(၃)၊လှိုင်သာယာမြို့နယ်၊ရန်ကုန်မြို့။",
  },
  {
    ID: 3268,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "စူပါဂါးမင့်န် ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 0,
    "Financial Year To": 0,
    "Permit Number": "155/1998",
    "Permit Date": "1998-07-15T07:29:54Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 0,
    "Currency Of Total Amount": "",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "",
    "Form Of Investment": "",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "အကွက်(၁၂၈)၊ မြေတိုင်းရပ်ကွက်(၄၂)၊ ရွှေပြည်သာစက်မှုဇုန်၊ရွေပြည်သာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 3269,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "ခင်ချို ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1998,
    "Financial Year To": 1999,
    "Permit Number": "159/1998",
    "Permit Date": "1998-07-31T07:35:35Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင်မီ ဂျာကင်အမျိုးမျိုး ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.83,
    "Total Amount Of Capital (in Millions)": 25,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "အမှတ်(၁၁၆၈)၊ အကွက်အမှတ်(၂)၊ လှိုင်သာယာစက်မှုဇုန်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 3270,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "အမ်ဂျီအမ်အင်ဒတ်(စ်)ထရီ(စ်)လီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "220/1999",
    "Permit Date": "1999-01-28T07:42:40Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "အမှတ်တံဆိပ် ဓါတ်ခဲအမျိုးမျိုး ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 5.46,
    "Total Amount Of Capital (in Millions)": 176.76,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၃၅)၊ စက်မှုဇုံ(၁) ၊ လှိုင်သာယာမြို့နယ်၊ရန်ကုန်မြို့။",
  },
  {
    ID: 3271,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "လပ်ကီးဟန်း(ဒ်)ဂါးမဲန့် လီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "232/1999",
    "Permit Date": "1999-02-26T07:52:00Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတကာအဆင့်မီ အထည်အမျိုးမျိုး ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 37,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၄၆-က)၊ စက်မှုဇုန်-၁၊၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 3272,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "ထွဋ်ကျော်အင်တာပရိုက်(စ်) လီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "236/1999",
    "Permit Date": "1999-03-23T04:45:28Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "နိုင်ငံတတကာအဆင့်မီ ပလပ်စတစ် အမျိုးမျိုးထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.66,
    "Total Amount Of Capital (in Millions)": 59.96,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၂၈)၊ စက်မှုဇုံ(၁)ဒဂုံမြို့သစ်၊ဆိပ်ကမ်းမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 3273,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "အရှေ့တိုင်းအထည်ချုပ် ကမ္ပဏီ လီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "260/1999",
    "Permit Date": "1999-06-15T04:50:25Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "လက်ခစားထုတ်လုပ်မှုစနစ်(CMP)ဖြင့် အသင့်ချုပ်ပြီးအထည်များ ထုတ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.09,
    "Total Amount Of Capital (in Millions)": 30,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေတိုင်းရပ်ကွက်အမှတ်(၂၃)၊ မြေကွက်အမှတ်(၇၄)(၇၆)၊ ဒဂုံတောင်စက်မှုဇုန်(၁)၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 3274,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "ရန်ကုန်ထိုက်ရှန်း အီီကောနောမစ်(ခ်) ဒီဗလော့မဲန့်(တ်) ကုမ္ပဏီလီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "261/1999",
    "Permit Date": "1999-06-17T04:57:15Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "ဓါတ်ခဲထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": 2.47,
    "Total Amount Of Capital (in Millions)": 34.82,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၃၅)၊ မြေတိုင်းရပ်ကွက်အပိုင်း(၁)၊ စက်မှုဇုံ၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 3275,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "အေးကိုမိသားစု လီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "296/1999",
    "Permit Date": "1999-10-29T05:04:13Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "ပလပ်စတစ်လူသုံးကုန်ပစ္စည်းထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.3,
    "Total Amount Of Capital (in Millions)": 37.8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၃၅)၊ မြေတိုင်းရပ်ကွက်အပိုင်း(၁)၊ စက်မှုဇုံ၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 3276,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "အုန်းမိသားစု ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "301/1999",
    "Permit Date": "1999-10-29T05:11:28Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "လက်ခစားထုတ်လုပ်မှုစနစ်( CMP)အရ အထည်အမျိုးမျိုးချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.25,
    "Total Amount Of Capital (in Millions)": 58.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၇၇)၊ လှိုင်သာယာစက်မှုဇုန်အပိုင်း(၄)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 3277,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "သိန်းငှက်အပြည်ပြည်ဆိုင်ရာ စက်မှုလီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "318/1999",
    "Permit Date": "1999-12-13T05:23:50Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အသင့်ချုပ်ပြီးအထည်များထုတ်လုပ်သည့်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.31,
    "Total Amount Of Capital (in Millions)": 28.55,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၆)၊ မြေတိုင်းရပ်ကွက်အမှတ်(၄၂) ၊ စက်မှုဇုန်၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 3278,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "အောင်သပြေခိုင်စက်မှု ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "321/1999",
    "Permit Date": "1999-12-24T05:31:15Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "အဆင့်မြင့်ပလပ်စတစ်ဗူးမျိုးစုံထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.8,
    "Total Amount Of Capital (in Millions)": 49.8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်မြေတိုင်း(၁၂၀)၊ ၂ ရပ်ကွက်၊ စက်မှုဇုံ ၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 3279,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "အမျိုးသားဆပ်ပြာ ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 1999,
    "Financial Year To": 2000,
    "Permit Number": "327/1999",
    "Permit Date": "1999-12-30T05:36:41Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ဆပ်ပြာထောင့်၊ ဆပ်ပြာမှုန့်များ ထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.72,
    "Total Amount Of Capital (in Millions)": 34.32,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၃၂)၊ သံချပ်ဝန်ဦးညွှန့်လမ်း၊ စက်မှုဇုံ(၁)၊ စက်မှုဇုန်၊လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့",
  },
  {
    ID: 3280,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "ကောင်းချီးမင်္ဂလာနိုင်ငံ တကာရောင်းဝယ်ရေး ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "332/2000",
    "Permit Date": "2000-02-14T06:05:07Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင် အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.5,
    "Total Amount Of Capital (in Millions)": 53,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၉၉)၊ မြေတိုင်းရပ်ကွက်အမှတ်ဇုန်(၁)၊ စက်မှုဇုန်၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 3281,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "ဗဟိုအိမ်သုတ်ဆေးဂေဟာစက်မှု ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "340/2000",
    "Permit Date": "2000-02-25T06:39:19Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "အိမ်သုတ်ဆေးအမျိုးမျိုးထုတ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.15,
    "Total Amount Of Capital (in Millions)": 77.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၄၆)၊ စက်မှုဇုံ(၂) ၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 3282,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ပိုကောင်း ကုန်ထုတ်လုပ်မှု ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "344/2000",
    "Permit Date": "2000-02-29T06:47:19Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ဆပ်ပြာတောင့်၊ ဆပ်ပြာမှုန့်များ ထုတ်လုပ်ခြင်းး",
    "Amount Of Foreign Capital USD (in Millions)": 0.85,
    "Total Amount Of Capital (in Millions)": 60,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၈၇/၁၈၈)၊ မြေတိုင်းရပ်ကွက်၊ စက်မှုဇုံ(၁)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 3283,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ခုနှစ်စင်ကြယ်ထုတ်လုပ်မှု ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "365/2000",
    "Permit Date": "2000-04-20T07:00:13Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.32,
    "Total Amount Of Capital (in Millions)": 61,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၂၆)၊ ကနောင်မင်းသားကြီးလမ်း၊ စက်မှုဇုန်(၂)၊ ဒဂုံဆိပ်ကမ်းမြို့နယ်၊ရန်ကုန်မြို့",
  },
  {
    ID: 3284,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "ရွှေအာရှအာရာ ထုတ်လုပ်မှု ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "397/2000",
    "Permit Date": "2000-06-29T07:12:38Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "စက်ဘီးတာယာနှင့် ကျွတ်ထုတ်လုပ်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 2.26,
    "Total Amount Of Capital (in Millions)": 163.55,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၉၇)၊ စက်မဇုံ(၅)၊ လှိုင်သာယာမြို့နယ်၊ရန်ကုန်မြို့။",
  },
  {
    ID: 3285,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "ငွေကံ့ကော်စက်မှုလုပ်ငန်း ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "401/2000",
    "Permit Date": "2000-06-29T07:19:02Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အသင့်ချုပ်ပြီး အထည်များ ထုတ်လုပ်သည့်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.31,
    "Total Amount Of Capital (in Millions)": 75.15,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်(၁၆၁/၁၆၂)၊ စက်မှုဇုန်(၅)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 3286,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "တောက်ပတိုးပွားသောအထည်ထုတ်လုပ်မှု ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "403/2000",
    "Permit Date": "2000-07-12T07:32:58Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 1.08,
    "Total Amount Of Capital (in Millions)": 22.48,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၅၉)၊ မြေတိုင်းအမှတ်(၄၂)၊ ရွှေပြည်သာစက်မှုဇုန်၊ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 3287,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ရွှေနွေဦး အထည်ချုပ် ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "420/2000",
    "Permit Date": "2000-08-31T07:57:27Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် အသင့်ချုပ်ပြီးအထည်များ ထုတ်လုပ်သည့်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.08,
    "Total Amount Of Capital (in Millions)": 25.45,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၃၃)၊ စက်မှုဇုန်(၁)၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 3288,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "မားမိတ်(ဒ်)စမိုင်း(လ်)ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "441/2000",
    "Permit Date": "2000-10-21T08:02:41Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.38,
    "Total Amount Of Capital (in Millions)": 75,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၂၀)၊ စက်မှုဇုန်(၁)၊ ဒဂုံဆိပ်ကမ်းမြို့နယ်၊ ရန်ကုန်မြို့.",
  },
  {
    ID: 3289,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar":
      "ရွှေဇီဇဝါလင်းအထည်ချုပ်စက်ရုံများ ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "447/2000",
    "Permit Date": "2000-12-01T05:07:15Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "CMP စနစ်ဖြင့် နိုင်ငံတကာအဆင့်မီ အထည်အမျိုးမျိုး ချုပ်လုပ်ခြင်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.25,
    "Total Amount Of Capital (in Millions)": 50,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေတိုင်းရပ်ကွက်အမှတ်(၁၉/၂)၊ မြေကွက်အမှတ်(၇)၊ရွှေပေါက္ကံစက်မှုဇုန်၊ မြောက်ဥက္ကလာပမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 3290,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "ကြီးမားပျော်ရွှင်ဘွယ် ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 2000,
    "Financial Year To": 2001,
    "Permit Number": "451/2000",
    "Permit Date": "2000-12-10T05:13:18Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.24,
    "Total Amount Of Capital (in Millions)": 34.8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၂၉၅)၊ မြေတိုင်းရပ်ကွက်(၄၂)၊ စက်မှုဇုန်၊ ရွှေပြည်သာမြို့နယ်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 3291,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "-",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "စံပြအထည်ချုပ်ကုမ္ပဏီ လီမိတက်",
    "Financial Year From": 2001,
    "Financial Year To": 2002,
    "Permit Number": "458/2001",
    "Permit Date": "2001-01-10T05:52:47Z",
    "Meeting Number": "-",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business": "CMP စနစ်ဖြင့် အထည်ချုပ်လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 0.75,
    "Total Amount Of Capital (in Millions)": 81,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "-",
    "Organization Address": "-",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်(၁၁၅/က)၊ (၁၁၅/ခ)၊ မြေတိုင်းရပ်ကွက်အမှတ်(၄၂)၊ ရွှေပြည်သာစက်မှုဇုန်၊ ရန်ကုန်မြို့။",
  },
  {
    ID: 3334,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Fresco Myanmar Company Limited",
    "Name of Principal Organization": "Fresco Myanmar Company Limited",
    "Place of Incorporation": "Yangon",
    "Company Name In Myanmar": "Fresco Myanmar Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "162/2019",
    "Permit Date": "2019-09-02T03:56:23Z",
    "Meeting Number": "14/2019",
    "Meeting Date": "2019-08-30T03:57:20Z",
    Sector: "Agriculture",
    "Type Of Investment Business":
      "Plantation, Production and Sales of Vegetable",
    "Amount Of Foreign Capital USD (in Millions)": 0.077,
    "Total Amount Of Capital (in Millions)": 0.099,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "Valle Verde Company Limited",
    "Land Area (units not specified in file)": 4.54,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": 3000000,
    "Number Of Local Employees": 35,
    "Number Of Foreign Employees": 1,
    Status: "Draft",
    "Investor Address":
      "NO.5 Shwe Sa Pal, Aung Theik Hti Road, Mayangon Township, Yangon",
    "Organization Address":
      "NO.5 Shwe Sa Pal, Aung Theik Hti Road, Mayangon Township, Yangon",
    "Investment Permitted Address":
      "NO.5 Shwe Sa Pal, Aung Theik Hti Road, Mayangon Township, Yangon",
  },
  {
    ID: 3341,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr. Zhu, Jianyong",
    "Name of Principal Organization": "Gold Emperor Group Co., Ltd.",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Gold Emperor (Myanmar) Co. Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "177/2019",
    "Permit Date": "2019-08-08T09:47:41Z",
    "Meeting Number": "12/2019",
    "Meeting Date": "2019-07-31T09:47:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 13.36,
    "Total Amount Of Capital (in Millions)": 13.36,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "",
    "Land Owner": "U Pyae Phyo Kyaw and U Shin Win @ May Fu Gam @ Myint Swe",
    "Land Area (units not specified in file)": 7.88,
    "Lease Term": 50,
    "Annual Lease Fee": 48000000,
    "Land Use Premium": null,
    "Number Of Local Employees": 1241,
    "Number Of Foreign Employees": 50,
    Status: "Rejected",
    "Investor Address":
      "Puzhong Road C11, Tongren Garden Lu Cheng District, Wenzhou, Zhejiang, The People's Republic of China",
    "Organization Address":
      "No.1288,2nd Binhai Road, Economic and Technological Development Zone, Wenzhou, The People's Republic of China",
    "Investment Permitted Address":
      "Plot No. 306,307,308,309, Myay Taing Block No.25, Shwe Lin Ban Sethmu Myo, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 3344,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr. He, Qinghua",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Packtech Co., Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "E 160/2019",
    "Permit Date": "2019-08-08T05:41:40Z",
    "Meeting Number": "12/2019",
    "Meeting Date": "2019-07-31T05:41:47Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production  of Aluminium Foils and Related Products",
    "Amount Of Foreign Capital USD (in Millions)": 6,
    "Total Amount Of Capital (in Millions)": 6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Esther",
    "Land Area (units not specified in file)": 4,
    "Lease Term": null,
    "Annual Lease Fee": 16000,
    "Land Use Premium": null,
    "Number Of Local Employees": 357,
    "Number Of Foreign Employees": 6,
    Status: "Rejected",
    "Investor Address":
      "No.88 Suxiu Road, Room 2# 1003, Block 2, Horizon Resort, SIP, Jiangsu, China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Holding No.74/1,76/1b, Leik Pote Kwin, Kwin No-560 C, Leik Pote Village, Hmawbi Township, Yangon Region",
  },
  {
    ID: 3347,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Myo Tun",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "2-Go Packaging Co., Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "170/2019",
    "Permit Date": "2019-07-05T09:26:32Z",
    "Meeting Number": "10/2019",
    "Meeting Date": "2019-06-28T09:26:58Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 6490.202,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "",
    "Land Owner": "U Myo Tun And U Aung Min Wai",
    "Land Area (units not specified in file)": 1.835,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 148,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "No.70, Yaw Min Gyi street, Yaw Min Gyi Quarter, Dagon Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.127, Myay Taing Block No.(Thilawa Industrial Zone), thanhlyin-Kyauk Tan Township, Yangon Region",
  },
  {
    ID: 3368,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhu Guofu",
    "Name of Principal Organization":
      "Danyang Baisheng Import & Export Co., Ltd",
    "Place of Incorporation": "People's Republic Of China",
    "Company Name In Myanmar": "Hosheng (Myanmar) Garment Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "235/2019",
    "Permit Date": "2019-08-27T07:56:32Z",
    "Meeting Number": "13/2019",
    "Meeting Date": "2019-09-13T07:56:45Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.329,
    "Total Amount Of Capital (in Millions)": 2.329,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Ye' Win Oo",
    "Land Area (units not specified in file)": 3.182,
    "Lease Term": 10,
    "Annual Lease Fee": 27.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 800,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address":
      "No.1 , Lujia Village, Lingkou Town, Danyang City, Jiangsu Province",
    "Organization Address":
      "No. 145, Zhongshan Street, Lingkou Town, Danyang City, Jiangsu Province",
    "Investment Permitted Address":
      "Plot No. 52, Myay Taing Block No. (51), Thardukan Industrial zone,",
  },
  {
    ID: 3369,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhou Jiming",
    "Name of Principal Organization": "Jia He Li Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Jia He Li Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "229/2019",
    "Permit Date": "2019-07-30T08:53:26Z",
    "Meeting Number": "12/2019",
    "Meeting Date": "2019-07-24T08:54:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Soles For CMP Enterprises",
    "Amount Of Foreign Capital USD (in Millions)": 0.48,
    "Total Amount Of Capital (in Millions)": 480000,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Maung Maung Hlaing",
    "Land Area (units not specified in file)": 1.04,
    "Lease Term": 10,
    "Annual Lease Fee": 12303,
    "Land Use Premium": null,
    "Number Of Local Employees": 150,
    "Number Of Foreign Employees": 2,
    Status: "Draft",
    "Investor Address":
      "Huangchuan Country, Henan Province, Zhangji, Fangang Village, Caiying Group",
    "Organization Address": "Plot No. (35), Block No. 144 (Industrial Zone) , ",
    "Investment Permitted Address":
      "Plot No. (35), Block No. 144 (Industrial Zone) , ",
  },
  {
    ID: 3370,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Li Feizhou",
    "Name of Principal Organization": "Randoo (Myanmar) Silk Corp., Ltd",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Randoo (Myanmar) Silk Corp., Ltd",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "228/2019",
    "Permit Date": "2019-07-30T09:22:38Z",
    "Meeting Number": "12/2019",
    "Meeting Date": "2019-07-24T09:22:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Fabric and Yarn On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.807,
    "Total Amount Of Capital (in Millions)": 807000,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Kyi Kyi Khine",
    "Land Area (units not specified in file)": 2.003,
    "Lease Term": 10,
    "Annual Lease Fee": 168000000,
    "Land Use Premium": null,
    "Number Of Local Employees": 150,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "Room 3303, No. 7th Building 99",
    "Organization Address": "Plot No. 109, Yangon Industrial Zone",
    "Investment Permitted Address": "Plot No. 109, Yangon Industrial Zone",
  },
  {
    ID: 3371,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhiping Wang",
    "Name of Principal Organization": "Heng Mei Company Limited ",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "HENG MEI COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "237/2019",
    "Permit Date": "2019-08-27T07:39:51Z",
    "Meeting Number": "13/2019",
    "Meeting Date": "2019-08-13T07:39:58Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.5,
    "Total Amount Of Capital (in Millions)": 500000,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaw Myint",
    "Land Area (units not specified in file)": 3.934,
    "Lease Term": 30,
    "Annual Lease Fee": 136039.365,
    "Land Use Premium": null,
    "Number Of Local Employees": 700,
    "Number Of Foreign Employees": 11,
    Status: "Draft",
    "Investor Address": "Liang Ting Apartment, No. 16-801 Room, Wuxi, Jiansu",
    "Organization Address":
      "Plot no. (174/175) , Myay Taing Block No. (25), Shwe Lin Ban Industrial Zone",
    "Investment Permitted Address":
      "Plot no. (174/175) , Myay Taing Block No. (25), Shwe Lin Ban Industrial Zone",
  },
  {
    ID: 3373,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor":
      "Mr. Li Ming                                                                                      ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar Lny Caps Co., Ltd",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "245/2019",
    "Permit Date": "2019-09-12T09:22:47Z",
    "Meeting Number": "14/2019",
    "Meeting Date": "2019-08-28T09:22:52Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Caps On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.373,
    "Total Amount Of Capital (in Millions)": 1373000,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 28,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Than Aye",
    "Land Area (units not specified in file)": 1.896,
    "Lease Term": 8,
    "Annual Lease Fee": 78000000,
    "Land Use Premium": null,
    "Number Of Local Employees": 486,
    "Number Of Foreign Employees": 2,
    Status: "Draft",
    "Investor Address": "Habitacion 701, No. 12, Carril 1955, Luoxi Roau Md,",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. (28), Myay Tine Block No.14- Shwe Than Lwin, ",
  },
  {
    ID: 3376,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Tao Bingfa",
    "Name of Principal Organization":
      "Changshu Runfa Garment Decoration Co., Ltd",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "HUAFA (MYANMAR) GARMENTCOMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "243/2019",
    "Permit Date": "2019-09-12T08:16:37Z",
    "Meeting Number": "14/2019",
    "Meeting Date": "2019-08-28T08:16:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.2,
    "Total Amount Of Capital (in Millions)": 1200000,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Zaw Moe Thu",
    "Land Area (units not specified in file)": 1.496,
    "Lease Term": 20,
    "Annual Lease Fee": 30272.45,
    "Land Use Premium": null,
    "Number Of Local Employees": 518,
    "Number Of Foreign Employees": 7,
    Status: "Draft",
    "Investor Address": "No.21, Miaodong Road, Guli Town, Changshu City",
    "Organization Address": "No.21, Miaodong Road, Guli Town, Changshu City",
    "Investment Permitted Address":
      "Plot NO. 1, Myay Taing Block No.(143/1), Kyansittthar Yeik Mon Industrial Zone",
  },
  {
    ID: 3377,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Hu Xianjia",
    "Name of Principal Organization":
      "Junc Order Handbag (Hong Kong)  Company Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Richway Handbag (Myanmar) Co., Ltd",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "236/2019",
    "Permit Date": "2019-08-30T08:55:28Z",
    "Meeting Number": "13/2019",
    "Meeting Date": "2019-08-13T08:55:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of various kinds of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.606,
    "Total Amount Of Capital (in Millions)": 606000,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner":
      "U Wong Law Shein (or) U Hla Thein,Daw Koe Kyin Hon (or) Khin Khin Yee",
    "Land Area (units not specified in file)": 2.756,
    "Lease Term": 10,
    "Annual Lease Fee": 1080,
    "Land Use Premium": null,
    "Number Of Local Employees": 1000,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address": "No. 1802, Building 10, New Century Shangju",
    "Organization Address":
      "Flat/RM , 02, 13/F. On Hong Hennessy Road, Commerical Building 145, Wanchai ",
    "Investment Permitted Address":
      "Plot (39/48), Myay Taing Block Industrial Zone (2), ",
  },
  {
    ID: 3378,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Qin Xiaolin",
    "Name of Principal Organization": "Xin Xin Handbag Company Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Weixin (Myanmar)  Bags Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "244/2019",
    "Permit Date": "2019-09-12T09:57:53Z",
    "Meeting Number": "14/2019",
    "Meeting Date": "2019-08-28T09:58:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags on CMP basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.876,
    "Total Amount Of Capital (in Millions)": 876000,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Zaw Thant",
    "Land Area (units not specified in file)": 2.102,
    "Lease Term": 10,
    "Annual Lease Fee": 960,
    "Land Use Premium": null,
    "Number Of Local Employees": 600,
    "Number Of Foreign Employees": 12,
    Status: "Draft",
    "Investor Address":
      "No. 7, Group 7, Welfare Village, Fengwei Town, Linshui Country",
    "Organization Address": "RM 517, New City Centre, 2Lei Yun  Mun Road",
    "Investment Permitted Address":
      "Plot No. (44+45) /C, Myay Taing Block No. Industrial Zone 2, ",
  },
  {
    ID: 3379,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wu Ying Hong",
    "Name of Principal Organization": "JOC International Limited",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "JOC Myanmar Knitwear Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "246/2019",
    "Permit Date": "2019-09-12T07:00:31Z",
    "Meeting Number": "14/2019",
    "Meeting Date": "2019-08-28T07:03:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.428,
    "Total Amount Of Capital (in Millions)": 2428000,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Soe Aung",
    "Land Area (units not specified in file)": 2.07,
    "Lease Term": 10,
    "Annual Lease Fee": 84000,
    "Land Use Premium": null,
    "Number Of Local Employees": 806,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "No. 8, South Li Yuan Road, Nan Jin City ",
    "Organization Address": "No. 8, South Li Yuan Road, Nan Jin City ",
    "Investment Permitted Address":
      "Plot no. 84, Myay Tine Block no. 65- Sethmu, ",
  },
  {
    ID: 3380,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Xiong Ruqing",
    "Name of Principal Organization": "Feng Teng Garment Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Feng Teng Garment Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "240/2019",
    "Permit Date": "2019-08-30T07:49:52Z",
    "Meeting Number": "13/2019",
    "Meeting Date": "2019-08-13T07:54:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.1,
    "Total Amount Of Capital (in Millions)": 1100000,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myint Thein",
    "Land Area (units not specified in file)": 0.581,
    "Lease Term": 5,
    "Annual Lease Fee": 72000000,
    "Land Use Premium": null,
    "Number Of Local Employees": 587,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "No. 136, Min Gyi Mahar MIn Kaung Road, Industrial Zone 3",
    "Organization Address":
      "Plot No. 163, Myay Taing Block No. Industrial Zone 5",
    "Investment Permitted Address":
      "Plot No. 163, Myay Taing Block No. Industrial Zone 5",
  },
  {
    ID: 3381,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Fengquan Kong",
    "Name of Principal Organization":
      "Far East International Trading Shares Ltd",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Yangon Wan Ping Garment Company LimitedPlot ",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "232/2019",
    "Permit Date": "2019-07-30T08:30:12Z",
    "Meeting Number": "12/2019",
    "Meeting Date": "2019-07-24T08:30:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.987,
    "Total Amount Of Capital (in Millions)": 4987000,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 60,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Yangon WP Company Limited",
    "Land Area (units not specified in file)": null,
    "Lease Term": 50,
    "Annual Lease Fee": 34000,
    "Land Use Premium": null,
    "Number Of Local Employees": 2500,
    "Number Of Foreign Employees": 30,
    Status: "Draft",
    "Investor Address":
      "Room D,10/F , Tower A, Billion Center , 1 Wang KwongRoad",
    "Organization Address":
      "Room D,10/F , Tower A, Billion Center , 1 Wang KwongRoad",
    "Investment Permitted Address":
      "Plot No. 44+ 55 Myay Tine Block no. Myaung Dagar Thanmani Industrial Zone",
  },
  {
    ID: 3387,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Wang Yuecai",
    "Name of Principal Organization": "",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "Rui De Plastic Products (Myanmar) Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "248/2019",
    "Permit Date": "2019-09-12T06:42:46Z",
    "Meeting Number": "14/2019",
    "Meeting Date": "2019-08-28T06:43:11Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Sales of Tape , Plastic Sheet & Packing Materials For Local CMP Enterprises And For Export",
    "Amount Of Foreign Capital USD (in Millions)": 0.58,
    "Total Amount Of Capital (in Millions)": 580000,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Mya Mya San (or) Ma Kim Kie , U Kyaw Kyaw Aung",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 30,
    "Annual Lease Fee": 20234.3,
    "Land Use Premium": null,
    "Number Of Local Employees": 90,
    "Number Of Foreign Employees": 6,
    Status: "Draft",
    "Investor Address": "No.28, Fuhua Village,Shuanggang Town, ",
    "Organization Address":
      "Plot No. 251/B, Myay Taing Block No. Industrial Zone (2) , ",
    "Investment Permitted Address":
      "Plot No. 251/B, Myay Taing Block No. Industrial Zone (2) , ",
  },
  {
    ID: 3388,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "UK Bakery (Myanmar) Company Limited",
    "Name of Principal Organization": "Sapphire Legacy SDN. BHD",
    "Place of Incorporation": "Malaysia",
    "Company Name In Myanmar": "UK Bakery (Myanmar) Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "241/2019",
    "Permit Date": "2019-08-30T07:07:22Z",
    "Meeting Number": "13/2019",
    "Meeting Date": "2019-08-13T07:07:39Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Distribution of Confectioner and Bakery Products",
    "Amount Of Foreign Capital USD (in Millions)": 0.33,
    "Total Amount Of Capital (in Millions)": 330000,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Malaysia",
    "Form Of Investment": "JV",
    "Land Owner": "Daw Myint Myint Oo",
    "Land Area (units not specified in file)": 0.165,
    "Lease Term": 5,
    "Annual Lease Fee": 27600000,
    "Land Use Premium": null,
    "Number Of Local Employees": 30,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "Plot No. 159, Myay Taing Block No.23, Industrial Zone (1), ",
    "Organization Address": "Lot 11, West Industrial Area, Jinjang North",
    "Investment Permitted Address":
      "Plot No. 159, Myay Taing Block No.23, Industrial Zone (1), ",
  },
  {
    ID: 3389,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ng Yiu Kwok Ringo",
    "Name of Principal Organization":
      "ACE Elite Developments Limited                                                                      ",
    "Place of Incorporation": "British Virgin Islands",
    "Company Name In Myanmar": "Myanmar ACE Elite Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "247/2019",
    "Permit Date": "2019-09-12T07:54:32Z",
    "Meeting Number": "14/2019",
    "Meeting Date": "2019-08-28T07:55:25Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Prinring and Embroidery Fabric on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.796,
    "Total Amount Of Capital (in Millions)": 796000,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Thida Linn Thein",
    "Land Area (units not specified in file)": 0.79,
    "Lease Term": 10,
    "Annual Lease Fee": 116400000,
    "Land Use Premium": null,
    "Number Of Local Employees": 130,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "No. 98, Texaco Road, 19/F, ADP Pentagon Center",
    "Organization Address": "No. 98, Texaco Road, 19/F, ADP Pentagon Center",
    "Investment Permitted Address":
      "Plot No. 22, Myay Taing Block No. 112- Industrial City, Dagon Myo Thit (East) , ",
  },
  {
    ID: 3390,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wu Guanjun",
    "Name of Principal Organization": "",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "Yu Chang (Myanmar) Spray Cotton company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "231/2019",
    "Permit Date": "2019-07-30T08:39:49Z",
    "Meeting Number": "12/2019",
    "Meeting Date": "2019-07-24T08:40:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Sales of Synthetic Resin for Clothing such as Jacket and Warm Coat",
    "Amount Of Foreign Capital USD (in Millions)": 1.92,
    "Total Amount Of Capital (in Millions)": 1920000,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Nan Khin Win Kyi",
    "Land Area (units not specified in file)": 2.82,
    "Lease Term": 10,
    "Annual Lease Fee": 31200000,
    "Land Use Premium": null,
    "Number Of Local Employees": 193,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address": "No.11, Group 20, Linyi town, Neighborhood Committee",
    "Organization Address":
      "Holding No. (11/3) , Kwin No. 577 and Holding No. (13/4+14/1), Kwin No. 577- Kyaut Pone,Innluk Village Tract",
    "Investment Permitted Address":
      "Holding No. (11/3) , Kwin No. 577 and Holding No. (13/4+14/1), Kwin No. 577- Kyaut Pone,Innluk Village Tract",
  },
  {
    ID: 3391,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yang Wenxuan",
    "Name of Principal Organization": "",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Myanmar S. Flamingo Garment Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "239/2019",
    "Permit Date": "2019-08-30T09:22:38Z",
    "Meeting Number": "13/2019",
    "Meeting Date": "2019-08-13T09:22:55Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Safety Clothing On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.997,
    "Total Amount Of Capital (in Millions)": 997000,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Kyauk Chee Phone",
    "Land Area (units not specified in file)": 2.05,
    "Lease Term": 10,
    "Annual Lease Fee": 99552.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 798,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "Room 402, Unit 1, Building 1, Shuxi Street, Hengxing ming Yuan, Wuyi County",
    "Organization Address": "Plot No. 165, Myay Taing Block No. 113, ",
    "Investment Permitted Address": "Plot No. 165, Myay Taing Block No. 113, ",
  },
  {
    ID: 3394,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mrs. Yu Zifen",
    "Name of Principal Organization": "Shen Mei Garment Co., Ltd",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Sheng Mei Garment Co., Ltd",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "252/2019",
    "Permit Date": "2019-09-12T07:31:01Z",
    "Meeting Number": "14/2019",
    "Meeting Date": "2019-08-28T07:31:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.2,
    "Total Amount Of Capital (in Millions)": 1200000,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Moe Thida",
    "Land Area (units not specified in file)": 1.78,
    "Lease Term": 20,
    "Annual Lease Fee": 50424,
    "Land Use Premium": null,
    "Number Of Local Employees": 1106,
    "Number Of Foreign Employees": 24,
    Status: "Draft",
    "Investor Address": "1#2101, He Fei, Quan Jiao Bei Lu, ",
    "Organization Address":
      "Plot No. (12), Myay Taing Block No. (49), Wartayar Industrial Zone, Shwe Pyi Thar Township,",
    "Investment Permitted Address":
      "Plot No. (12), Myay Taing Block No. (49), Wartayar Industrial Zone, Shwe Pyi Thar Township,",
  },
  {
    ID: 3395,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wu Congan",
    "Name of Principal Organization": "Sino Protection Holdings Co., Ltd",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar":
      "Sino Protection (Yangon ) Non- Woven Products Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "233/2019",
    "Permit Date": "2019-07-30T08:23:35Z",
    "Meeting Number": "12/2019",
    "Meeting Date": "2019-07-24T08:23:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Protective Clothing (such as Surgical Gown, Isolation Clothing, Shoes Cover, Round Cap) on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3,
    "Total Amount Of Capital (in Millions)": 3000000,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Jorky (or) U Sein Htay",
    "Land Area (units not specified in file)": 2.265,
    "Lease Term": 10,
    "Annual Lease Fee": 120,
    "Land Use Premium": null,
    "Number Of Local Employees": 875,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "C.C. Wu Building 302-308, Hennssy Road, Wan Chai",
    "Organization Address": "C.C. Wu Building 302-308, Hennssy Road, Wan Chai",
    "Investment Permitted Address":
      "Plot NO.18, Myay Taing Block No. 25, Shwe Lin Ban Industrial Zone",
  },
  {
    ID: 3397,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Liu Yue Jun",
    "Name of Principal Organization": "Earthlings Fiber Glass Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Earthlings Fiber Glass Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "251/2019",
    "Permit Date": "2019-09-12T09:29:52Z",
    "Meeting Number": "14/2019",
    "Meeting Date": "2019-08-28T09:30:19Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Fiberglass on Contract Manufacturing Process (CMP) Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.54,
    "Total Amount Of Capital (in Millions)": 540000,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "U Mg Mg Aye",
    "Land Area (units not specified in file)": 2.304,
    "Lease Term": 5,
    "Annual Lease Fee": 156000,
    "Land Use Premium": null,
    "Number Of Local Employees": 74,
    "Number Of Foreign Employees": 4,
    Status: "Draft",
    "Investor Address": "NO. (13-5), Tian Shun Street, Wu xi City, ",
    "Organization Address":
      "Plot No. 107, Myay Taing Block No. 65 (Sethmu), Industrial Zone part (4)",
    "Investment Permitted Address":
      "Plot No. 107, Myay Taing Block No. 65 (Sethmu), Industrial Zone part (4)",
  },
  {
    ID: 3398,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Gao Jian Bing",
    "Name of Principal Organization": "P&T products Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Myanmar Fuwah Sportware Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "242/2019",
    "Permit Date": "2018-08-27T10:05:55Z",
    "Meeting Number": "13/2019",
    "Meeting Date": "2019-08-13T10:06:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Sportsware Products & Accessories on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.084,
    "Total Amount Of Capital (in Millions)": 1084000,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Nandar Daewi",
    "Land Area (units not specified in file)": 0.9,
    "Lease Term": 10,
    "Annual Lease Fee": 24000,
    "Land Use Premium": null,
    "Number Of Local Employees": 430,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address": "No.(10), Jiu Tang Road, Hi-tech district,",
    "Organization Address": "Room 1502, King's Road,",
    "Investment Permitted Address":
      "Plot No. 599, Myay Taing B;ock No. Tha Ka Ta(11). Corner of Pun Hlaing golf Estate Road and Seik Kan Thar Road, Nyaung Village Tract, ",
  },
  {
    ID: 3400,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lin Yi Chieh",
    "Name of Principal Organization": "New Season Enterprise Company Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar":
      "New Season Enterprise (Myanmar) Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "249/2019",
    "Permit Date": "2019-09-12T07:28:59Z",
    "Meeting Number": "14/2019",
    "Meeting Date": "2019-08-28T07:29:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags and it's accessories on CMP basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.869,
    "Total Amount Of Capital (in Millions)": 869000,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Thiha Kyaw",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 50,
    "Annual Lease Fee": 14400000,
    "Land Use Premium": null,
    "Number Of Local Employees": 300,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "NNo.16, Shinshen Road, Chushen Town, Nomton County",
    "Organization Address":
      "Flat/RME -105, 3/F Building 3, Tsun Wen Road, Tak Wing Industrial,",
    "Investment Permitted Address":
      "Plot No.366,Myay Taing Block No. 49, Wartayar Industrial Zone",
  },
  {
    ID: 3401,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kao Cheng Yang",
    "Name of Principal Organization": "Jinn Shern Industry Co.,",
    "Place of Incorporation": "Taiwan",
    "Company Name In Myanmar": "Mao Hsin Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "250/2019",
    "Permit Date": "2019-09-12T08:24:53Z",
    "Meeting Number": "14/2019",
    "Meeting Date": "2019-08-28T08:25:23Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of various kinds of Products for Sport on Contract Manufacturing Process (CMP) Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.534,
    "Total Amount Of Capital (in Millions)": 534000,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "FDII",
    "Land Owner": "K & M Capital Co., Ltd",
    "Land Area (units not specified in file)": 0.378,
    "Lease Term": 5,
    "Annual Lease Fee": 55200,
    "Land Use Premium": null,
    "Number Of Local Employees": 158,
    "Number Of Foreign Employees": 2,
    Status: "Draft",
    "Investor Address":
      "No. 67, 98th Street, Zhi An (4) Road, Near Xi Xin Li (28)",
    "Organization Address": "1F,No. 67, LN. 98, Zhi-AN 4th Street",
    "Investment Permitted Address":
      "unit # B-011 & B 012, Plot No.5 , Myay Taing Block No. 143/2,",
  },
  {
    ID: 3412,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr.Uthai Tantipimolphan",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Myanmar C.P Livestock Co. ,Ltd",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "163/2019",
    "Permit Date": "2019-09-04T04:57:00Z",
    "Meeting Number": "10/2019",
    "Meeting Date": "2019-06-28T04:57:25Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "အသားစားကြက်၊ ဥစားကြက် နှင့် ဝက်မွေးမြူ ရောင်းချခြင်း လုပ်ငန်း (breeder farm and sales of broiler , layer and pig)",
    "Amount Of Foreign Capital USD (in Millions)": 25,
    "Total Amount Of Capital (in Millions)": 25,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 50,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Thailand",
    "Form Of Investment": "FDII",
    "Land Owner":
      "မွေးမြူရေးနှင့်ကုသရေးဦးစီးဌာန (မြေလွတ်၊ မြေလပ်နှင့် မြေရိုင်းမြေ)",
    "Land Area (units not specified in file)": 200,
    "Lease Term": 150,
    "Annual Lease Fee": 3600000,
    "Land Use Premium": 612000000,
    "Number Of Local Employees": 180,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "No-99/160 Moo-5, Banglucknol, Muang Nonthaburi, Nonthaburi 11000",
    "Organization Address": "",
    "Investment Permitted Address":
      "Holding No-N-102/1, N-103/1, N-104/1 and N-102/2, N-104/3, Kwin No-511-B, Auk Chin Kan North Kwin, Nyaung Napin Village Tract, Hmawbi Township, Yangon",
  },
  {
    ID: 3421,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "ISE-OVO Co., Ltd",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "ISE-OVO Co., Ltd",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "196/2019",
    "Permit Date": "2019-09-30T08:45:57Z",
    "Meeting Number": "16/2019",
    "Meeting Date": "2019-09-27T08:46:22Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "Layer Breeder farm and sales of chicken and egg",
    "Amount Of Foreign Capital USD (in Millions)": 2.25,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "ISE-OVO Co., Ltd",
    "Land Area (units not specified in file)": 22.8,
    "Lease Term": 20,
    "Annual Lease Fee": 0.47,
    "Land Use Premium": null,
    "Number Of Local Employees": 80,
    "Number Of Foreign Employees": 2,
    Status: "Approved",
    "Investor Address": "No-26/A, Aung Min Khaung Pagoda Road, Ward-10,",
    "Organization Address": "",
    "Investment Permitted Address":
      "Holding No-15/2, Kwin No-998/A, Makyee Kan Kwin, Kalihtaw (East) Village Tract, holdinng No-N-2, Kwin No-964, Ywar Thit Kwin. Kalihtaw (west)  Village Tract, Hlegu",
  },
  {
    ID: 3428,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyaw Win Tun",
    "Name of Principal Organization": "Europe & Asia Beverages Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Europe & Asia Beverages Co., Ltd.",
    "Financial Year From": 19,
    "Financial Year To": 20,
    "Permit Number": "168/2019",
    "Permit Date": "2019-10-23T04:40:01Z",
    "Meeting Number": "17/2019",
    "Meeting Date": "2019-10-21T04:45:58Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and distribution of purified drinking water and beverages",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 32863.01,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Sein Myint",
    "Land Area (units not specified in file)": 4.081,
    "Lease Term": 50,
    "Annual Lease Fee": 53330.4,
    "Land Use Premium": null,
    "Number Of Local Employees": 225,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "No.58, Sagaing Street, Myakanthar Housing Complex, Ward-14, ",
    "Organization Address":
      "No.19, 4 Za (2-Kha), Corner of Baho Road and Nilar Street, ",
    "Investment Permitted Address":
      "Plot No. 66, 67, Myay Taing Block No. 65 (Sethmu), Industrial Zone-4, Shwe Pyi Thar Industrial Zone, ",
  },
  {
    ID: 3429,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyaw Win Tun",
    "Name of Principal Organization": "Europe & Asia Beverages Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Europe & Asia Beverages Co., Ltd.",
    "Financial Year From": 19,
    "Financial Year To": 20,
    "Permit Number": "169/2019",
    "Permit Date": "2019-10-23T03:49:57Z",
    "Meeting Number": "17/2019",
    "Meeting Date": "2019-10-21T03:50:20Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and distribution of beverages",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 5520,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Sein Myint",
    "Land Area (units not specified in file)": 1.267,
    "Lease Term": 50,
    "Annual Lease Fee": 331.195,
    "Land Use Premium": null,
    "Number Of Local Employees": 165,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "No.58, Sagaing Street, Myakanthar Housing Complex, Ward-14, ",
    "Organization Address":
      "No.19, 4 Za (2-Kha), Corner of Baho Road and Nilar Street, ",
    "Investment Permitted Address":
      "Plot No. 66, 67, Myay Taing Block No. 65 (Sethmu), Industrial Zone-4, Shwe Pyi Thar Industrial Zone, ",
  },
  {
    ID: 3451,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ou Yunguo",
    "Name of Principal Organization":
      "GY SEN (MYANMAR) APPAREL COMPANY LIMITED",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "GY SEN (MYANMAR) APPAREL COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "253/2019",
    "Permit Date": "2019-09-27T05:02:32Z",
    "Meeting Number": "15/2019",
    "Meeting Date": "2019-09-13T05:03:03Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.141,
    "Total Amount Of Capital (in Millions)": 1.141,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Zaw Myo Htet, U Zaw Latt, U Kyaw Min Htun",
    "Land Area (units not specified in file)": 2.674,
    "Lease Term": 10,
    "Annual Lease Fee": 9.272,
    "Land Use Premium": null,
    "Number Of Local Employees": 625,
    "Number Of Foreign Employees": 13,
    Status: "Draft",
    "Investor Address":
      "No.9, 302, Juying Ying Road, Dandong, Xiangshan County",
    "Organization Address":
      "Plot no. 141, Myay Taing Block No. 49, Wartayar, Botitechun Street",
    "Investment Permitted Address":
      "Plot no. 141, Myay Taing Block No. 49, Wartayar, Botitechun Street",
  },
  {
    ID: 3452,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aung Ko Latt@ Mohamed Esoof",
    "Name of Principal Organization":
      "UNITEDS PU FOOTWEAR INDUSTRY COMPANY LIMITED",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "UNITEDS PU FOOTWEAR INDUSTRY COMPANY LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "254/2019",
    "Permit Date": "2019-09-27T06:50:33Z",
    "Meeting Number": "15/2019",
    "Meeting Date": "2019-09-13T06:50:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing And Marketing of Various Kinds Of Footwear",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 380,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Soe Moe",
    "Land Area (units not specified in file)": 0.275,
    "Lease Term": 5,
    "Annual Lease Fee": 18,
    "Land Use Premium": null,
    "Number Of Local Employees": 34,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "No. 186, 5th floor (A), Pansodan Street (Middle Block)",
    "Organization Address":
      "Plot No. 251 KA6 , Myay Taing Block No. 64/ Dagon Yadanar , Industrial Zone",
    "Investment Permitted Address":
      "Plot No. 251 KA6 , Myay Taing Block No. 64/ Dagon Yadanar , Industrial Zone",
  },
  {
    ID: 3453,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Lai Sawl Zama",
    "Name of Principal Organization":
      "Step Centre International Services Co.,Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Step Centre International Services Co.,Ltd.",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "166/2019",
    "Permit Date": "2019-10-23T07:59:29Z",
    "Meeting Number": "17/2019",
    "Meeting Date": "2019-10-21T07:59:25Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Education Services",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 350,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Yin Thuzar Lwin",
    "Land Area (units not specified in file)": 0.25,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 10,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "No.671/K, Marlar Lane Thwe Street, Ward(2), Kamayut Township, Yangon",
    "Organization Address":
      "No.671/K, Marlar Lane Thwe Street, Ward(2), Kamayut Township, Yangon",
    "Investment Permitted Address":
      "No.671/K, Marlar Lane Thwe Street, Ward(2), Kamayut Township, Yangon\n",
  },
  {
    ID: 3454,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. HONG ZHENMEI",
    "Name of Principal Organization":
      "LONG HENG SUPPLY CHAIN MANAGEMENT COMPANY LIMITED ",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar":
      "LONG HENG(MYANMAR) MANUFACTURING COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "276/2019",
    "Permit Date": "2019-10-27T09:21:17Z",
    "Meeting Number": "17/2019",
    "Meeting Date": "2019-10-09T09:21:37Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds Of Stationery for Office and Education on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.808,
    "Total Amount Of Capital (in Millions)": 0.808,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Naing Tun @ U Hide Aye",
    "Land Area (units not specified in file)": 2.445,
    "Lease Term": 10,
    "Annual Lease Fee": 780,
    "Land Use Premium": null,
    "Number Of Local Employees": 500,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address": "240 Xindu Street, Longgang Town",
    "Organization Address": "Flat/ RM A 20/ F KIU FU Commercial BLDG",
    "Investment Permitted Address": "Plot no. 5, Myay Taing Block No. 144, ",
  },
  {
    ID: 3455,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. YANG JIAN",
    "Name of Principal Organization":
      "HE XING DA LEATHER MANUFACTURING COMPANY LIMITED",
    "Place of Incorporation": "MYANMAR",
    "Company Name In Myanmar":
      "HE XIN DA LEATHER MANUFACTURING COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "263/2019",
    "Permit Date": "2019-10-08T09:58:18Z",
    "Meeting Number": "16/2019",
    "Meeting Date": "2019-09-30T09:58:40Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags & Belts on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.5,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Soe",
    "Land Area (units not specified in file)": 1.009,
    "Lease Term": 5,
    "Annual Lease Fee": 480,
    "Land Use Premium": null,
    "Number Of Local Employees": 700,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "NO. 16, UNIT 5, LONG SHA VILLAGE ,FEI FONG TOWN",
    "Organization Address": "PLOT NO. 31, MYAY TAING BLOCK NO. 39(SET HMUE)",
    "Investment Permitted Address":
      "Plot No. 31, Myay Taing Block No. 39 ( Sethmue ), ",
  },
  {
    ID: 3456,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. XIN ZHEN",
    "Name of Principal Organization": "GAOTAI GARMENT(MYANMAR) COMPANY LIMITED",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "GAOTAI GARMENT (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "275/2019",
    "Permit Date": "2019-10-29T04:07:57Z",
    "Meeting Number": "17/2019",
    "Meeting Date": "2019-10-09T04:08:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.896,
    "Total Amount Of Capital (in Millions)": 0.896,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Eain Chun",
    "Land Area (units not specified in file)": 0.716,
    "Lease Term": 6,
    "Annual Lease Fee": 54,
    "Land Use Premium": null,
    "Number Of Local Employees": 400,
    "Number Of Foreign Employees": 8,
    Status: "Draft",
    "Investor Address": "No. 31, Six groups, Xingu, Xicun, Zhangoiao Town",
    "Organization Address": "Plot no. 72, Myay Taing Block No. 42,",
    "Investment Permitted Address": "Plot no. 72, Myay Taing Block No. 42,",
  },
  {
    ID: 3457,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. PU YANYU",
    "Name of Principal Organization": "XUANCAI (HK) COMPANY LIMITED",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "XUANCAI LEATHER (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "265/2019",
    "Permit Date": "2019-10-08T04:30:57Z",
    "Meeting Number": "16/2019",
    "Meeting Date": "2019-09-30T04:31:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of Various Kinds Of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.952,
    "Total Amount Of Capital (in Millions)": 0.952,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw War War Aung",
    "Land Area (units not specified in file)": 1.836,
    "Lease Term": 10,
    "Annual Lease Fee": 720,
    "Land Use Premium": null,
    "Number Of Local Employees": 823,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address": "NO.231, GROUP 2, ZHAIZHAI VILLAGE",
    "Organization Address":
      "ROOM 15, 11/F ,CHINA UNITED PLAZA, 1008 TAI NAN WEST STREET",
    "Investment Permitted Address":
      "PLOT NO. 65, MYAY TAING BLOCK NO. THILAWAR INDUSTRIAL ZONE",
  },
  {
    ID: 3459,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS. ZHANG RONG",
    "Name of Principal Organization":
      "SHI AN (MYANMAR) GARMENT COMPANY LIMITED",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "SHI AN (MYANMAR) GARMENT COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "264/2019",
    "Permit Date": "2019-10-08T07:36:26Z",
    "Meeting Number": "16/2019",
    "Meeting Date": "2019-09-30T07:37:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.1,
    "Total Amount Of Capital (in Millions)": 1.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Sein Win",
    "Land Area (units not specified in file)": 1.484,
    "Lease Term": 10,
    "Annual Lease Fee": 960,
    "Land Use Premium": null,
    "Number Of Local Employees": 700,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "NO.31, HOU KOU STREET ,XUANGNG TOWN",
    "Organization Address": "PLOT NO. 227, MYAY TAING BLOCK NO. PART (2),",
    "Investment Permitted Address":
      "PLOT NO. 227, MYAY TAING BLOCK NO. PART (2),",
  },
  {
    ID: 3460,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS. LI YUAN",
    "Name of Principal Organization": "HEDERA INTERNATIONAL TRADING LIMITED",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar":
      "HIGE FASHION ACCESSORIES (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "266/2019",
    "Permit Date": "2019-10-08T08:03:23Z",
    "Meeting Number": "16/2019",
    "Meeting Date": "2019-09-30T08:03:40Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Wearing Apparel on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.2,
    "Total Amount Of Capital (in Millions)": 1.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Tin Tin Moe",
    "Land Area (units not specified in file)": 2.204,
    "Lease Term": 5,
    "Annual Lease Fee": 737,
    "Land Use Premium": null,
    "Number Of Local Employees": 333,
    "Number Of Foreign Employees": 7,
    Status: "Draft",
    "Investor Address": "NO. 1601, BUILDING T2, NO. 1717, TIANSHAN ROAD,",
    "Organization Address": "UNT2 LG1, MIRROR TOWER, 61 MODY ROAD, ",
    "Investment Permitted Address":
      "Plot no. 48, Myay Taing Block No. 25, Shwelinban Industrial Zone",
  },
  {
    ID: 3462,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Ko Ko Latt",
    "Name of Principal Organization": "ZEST TANG COMPANY LIMITED",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "ZEST TANG COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "261/2019",
    "Permit Date": "2019-10-08T09:06:38Z",
    "Meeting Number": "16/2019",
    "Meeting Date": "2019-09-30T09:07:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Cashew Nuts for 100% Export",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 751.03,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Nan Wyne",
    "Land Area (units not specified in file)": 1.713,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 70,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "ZA/59B, Baynitnaung Warehouse,Ahthawka Street, (1) Quarter,",
    "Organization Address":
      "PLOT NO. 206, MYAY TAING BLOCK NO. 49,WARTAYAR SETHMUE",
    "Investment Permitted Address":
      "PLOT NO. 206, MYAY TAING BLOCK NO. 49,WARTAYAR SETHMUE",
  },
  {
    ID: 3464,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS. ZHANG ZUWEI",
    "Name of Principal Organization": "Rich Line Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Rich Line Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "282/2019",
    "Permit Date": "2019-11-08T06:33:50Z",
    "Meeting Number": "18/2019",
    "Meeting Date": "2019-10-30T06:34:21Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Garments (Costumes for Cartoon Actors/Actresses And Sporting Characters) On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.2,
    "Total Amount Of Capital (in Millions)": 1.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Thein Han",
    "Land Area (units not specified in file)": 1.247,
    "Lease Term": 5,
    "Annual Lease Fee": 24,
    "Land Use Premium": null,
    "Number Of Local Employees": 700,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "NO. 45, LANE 1316. XIANXIA ROAD 102, SHANGHAI",
    "Organization Address":
      "Plot no. 127, Myay Taibg Block No. Zone 2, Industrial Zone",
    "Investment Permitted Address":
      "Plot no. 127, Myay Taibg Block No. Zone 2, Industrial Zone",
  },
  {
    ID: 3465,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. WANG JIALE",
    "Name of Principal Organization": "TIANJIN HUANTAI GARMENT COMPANY LIMITED",
    "Place of Incorporation": "China",
    "Company Name In Myanmar":
      "GLOBAL THAI (MYANMAR) FIBER PRODUCT COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "283/2019",
    "Permit Date": "2019-11-08T07:30:41Z",
    "Meeting Number": "18/2019",
    "Meeting Date": "2019-10-30T07:30:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 3.37,
    "Total Amount Of Capital (in Millions)": 3.37,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 5,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Zaw Linn",
    "Land Area (units not specified in file)": 3.5,
    "Lease Term": 5,
    "Annual Lease Fee": 144,
    "Land Use Premium": null,
    "Number Of Local Employees": 412,
    "Number Of Foreign Employees": 12,
    Status: "Draft",
    "Investor Address": "DAGANG DEVELOPMENT ZONE",
    "Organization Address":
      "WUQI ROAD, EAST ZONE, DAGANG DEVELOPMENT ZONE, BINHAI NEW DISTRICT",
    "Investment Permitted Address":
      "PLOT NO. 182/183, MYAY TAING BLOCK NO. ZONE 1, INDUSTRIAL ZONE",
  },
  {
    ID: 3466,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LIU GUOWEI",
    "Name of Principal Organization": "Lordroad Textile Company ",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "MYANMAR LORDROAD FASHION COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "284/2019",
    "Permit Date": "2019-11-08T03:38:06Z",
    "Meeting Number": "18/2019",
    "Meeting Date": "2019-10-30T03:38:51Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.1,
    "Total Amount Of Capital (in Millions)": 1.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Wai Phyo , U Lin @ Chaung Chu Yin , U Khin Maung Latt",
    "Land Area (units not specified in file)": 0.702,
    "Lease Term": 6,
    "Annual Lease Fee": 15624.895,
    "Land Use Premium": null,
    "Number Of Local Employees": 218,
    "Number Of Foreign Employees": 7,
    Status: "Draft",
    "Investor Address":
      "6th / F, #8 Building , # 28, Shunyuan Road, Xinbei District",
    "Organization Address":
      "Flat/ RM 813, 8/F , Asia Trade Centre ,79  Lei Muk Road",
    "Investment Permitted Address":
      "PLOT NO- 309, MYAY TAING BLOCK NO. YANGON INDUSTRIAL ZONE, ",
  },
  {
    ID: 3467,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Thet Sein @ U Tin Shwe",
    "Name of Principal Organization": "H.M INTERNATIONAL COMPANY LIMITED",
    "Place of Incorporation": "MYANMAR",
    "Company Name In Myanmar": "H.M INTERNATIONAL COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "260/2019",
    "Permit Date": "2019-10-08T04:24:17Z",
    "Meeting Number": "16/2019",
    "Meeting Date": "2019-10-30T04:24:36Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of Dry Meat And Dry Meat Rod on Contract Manufacturing Process CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1799.015,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": 12.93,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 295,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address": "No. 49, Thirimon 6th Street, Ward 15",
    "Organization Address":
      "PLOT NO. 1025, SIN GAUNG INN KWIN, U PAING NO. 19+ N/62, YEMON VILLAGE TRACK",
    "Investment Permitted Address":
      "PLOT NO. 1025, SIN GAUNG INN KWIN, U PAING NO. 19+ N/62, YEMON VILLAGE TRACK",
  },
  {
    ID: 3468,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Jeongsu Kweon ",
    "Name of Principal Organization": "Dae Ryun Ind. Comapny Limited",
    "Place of Incorporation": "Republic Of Korea",
    "Company Name In Myanmar": "DAERYUN ASIA COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "269/2019",
    "Permit Date": "2019-10-08T04:53:20Z",
    "Meeting Number": "16/2019",
    "Meeting Date": "2019-09-30T04:53:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of Fan, Blower & Electric Motor",
    "Amount Of Foreign Capital USD (in Millions)": 0.637,
    "Total Amount Of Capital (in Millions)": 0.637,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myo Myint Oo",
    "Land Area (units not specified in file)": 0.05,
    "Lease Term": 10,
    "Annual Lease Fee": 8.4,
    "Land Use Premium": null,
    "Number Of Local Employees": 20,
    "Number Of Foreign Employees": 1,
    Status: "Draft",
    "Investor Address": "104-103, 59-69-Gil Hanaro, Busongdong",
    "Organization Address": "115, Wanjusandan 7-Ro, Bongdong-Eup",
    "Investment Permitted Address":
      "Plot No. 302, Myay Taing Block No. Zone(5)",
  },
  {
    ID: 3469,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wei Jinming",
    "Name of Principal Organization":
      "TONGXIANG JINXIANG TEXTILE COMPANY LIMITED",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "JIN XIANG (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "268/2019",
    "Permit Date": "2019-10-08T06:23:18Z",
    "Meeting Number": "16/2019",
    "Meeting Date": "2019-09-30T06:24:19Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.97,
    "Total Amount Of Capital (in Millions)": 0.97,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 16,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Tin Tin Myint @ Woung Chaung Tin",
    "Land Area (units not specified in file)": 2.594,
    "Lease Term": 6,
    "Annual Lease Fee": 120,
    "Land Use Premium": null,
    "Number Of Local Employees": 522,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address": "No.15, Wutong Street, Weijiamen, Chengdong Village",
    "Organization Address": "Industrial Zone, Longxiang Street",
    "Investment Permitted Address":
      "Plot No. 185+186, Myay Taing Block No. 25, Shwelinban Industrial Zone",
  },
  {
    ID: 3470,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. WANG DONGMING",
    "Name of Principal Organization": "MING FAI BAND KNITTED LIMITED",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "MING FAI WEBBING (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "255/2019",
    "Permit Date": "2019-09-27T07:01:02Z",
    "Meeting Number": "15/2019",
    "Meeting Date": "2019-09-13T07:01:20Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing And Selling of Various Kinds of Webbing For Local CMP Enterprises",
    "Amount Of Foreign Capital USD (in Millions)": 0.588,
    "Total Amount Of Capital (in Millions)": 0.588,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 38,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Zin Mar Zaw",
    "Land Area (units not specified in file)": 0.735,
    "Lease Term": 18,
    "Annual Lease Fee": 23783,
    "Land Use Premium": null,
    "Number Of Local Employees": 64,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address": "7C, BUILDING 2, XIUJIANG, BINJIANG GARDEN,SHIJIE TOWN",
    "Organization Address": "FLAT/RM - 903, 9/F , 6 SUN YIP ST, ",
    "Investment Permitted Address": "Plot no. (A-5), Myay Taing Block No. 175",
  },
  {
    ID: 3471,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. WU YAN HONG",
    "Name of Principal Organization": "",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "MYANMAR YUAN SHOES COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "256/2019",
    "Permit Date": "2019-09-27T07:40:23Z",
    "Meeting Number": "15/2019",
    "Meeting Date": "2019-09-13T07:40:45Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of All Kinds of Shoes on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Sin Kyuu @ Chin Naing",
    "Land Area (units not specified in file)": 0.296,
    "Lease Term": 5,
    "Annual Lease Fee": 6600,
    "Land Use Premium": null,
    "Number Of Local Employees": 619,
    "Number Of Foreign Employees": 12,
    Status: "Draft",
    "Investor Address": "BUILDING A, DONGXI EAST ROAD 88, NAMU, HOUJIE TOWN",
    "Organization Address":
      "PLOT NO. 309, MYAY TAING BOCK NO, YANGON INDUSTRIAL ZONE, ",
    "Investment Permitted Address":
      "PLOT NO. 309, MYAY TAING BOCK NO, YANGON INDUSTRIAL ZONE, ",
  },
  {
    ID: 3472,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. LEE CHIN-CHI",
    "Name of Principal Organization": "YIN KU PLASTICS INDUSTRIAL CORP",
    "Place of Incorporation": "bRITISH VIRGIN ISLANDS",
    "Company Name In Myanmar": "WINCO BAG INDUSTRIAL CORPORATION LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "267/2019",
    "Permit Date": "2019-10-08T07:59:52Z",
    "Meeting Number": "16/2019",
    "Meeting Date": "2019-09-30T08:00:10Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 1.251,
    "Total Amount Of Capital (in Millions)": 1.251,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 26,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Kyaw Soe",
    "Land Area (units not specified in file)": 2.002,
    "Lease Term": 6,
    "Annual Lease Fee": 216,
    "Land Use Premium": null,
    "Number Of Local Employees": 410,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "NO. 92-2, JIAN KUO ROAD, CHIN SHIU ",
    "Organization Address": "P.O.BOX 96, 30 DECASRO STREET",
    "Investment Permitted Address":
      "Plot no. 81, Myay Taing Block No. Industrial Zone 1, ",
  },
  {
    ID: 3473,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. WU, PING-HSUAN",
    "Name of Principal Organization": "Alticy Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Alticy Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "280/2019",
    "Permit Date": "2019-11-08T03:30:38Z",
    "Meeting Number": "18/2019",
    "Meeting Date": "2019-10-30T03:30:59Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Naing Moe",
    "Land Area (units not specified in file)": 0.111,
    "Lease Term": 5,
    "Annual Lease Fee": 54,
    "Land Use Premium": null,
    "Number Of Local Employees": 151,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address": "NO.7, LANE 11, ASIA ROAD TUCHENG DISTRICT",
    "Organization Address":
      "Plot No. 1239,1240, Myay Taing Block No. 63, Industry Zone",
    "Investment Permitted Address":
      "Plot No. 1239,1240, Myay Taing Block No. 63, Industry Zone",
  },
  {
    ID: 3474,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. YU JUN",
    "Name of Principal Organization": "ABLE BETTER GARMENT COMPAY LIMITED",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "ABLE BETTER GARMENT COMPAY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "285/2019",
    "Permit Date": "2019-11-08T04:01:39Z",
    "Meeting Number": "18/2019",
    "Meeting Date": "2018-10-30T04:01:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.538,
    "Total Amount Of Capital (in Millions)": 2.538,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Sein Win",
    "Land Area (units not specified in file)": 2.301,
    "Lease Term": 10,
    "Annual Lease Fee": 60,
    "Land Use Premium": null,
    "Number Of Local Employees": 1037,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "NO. 27, HUAN XI ROAD, ZHUTANG TOWN",
    "Organization Address":
      "PLOT NO. 111, MYAY TAING BLOCK NO. MYAUNG DAGAR THANMANI INDUSTRIAL ZONE",
    "Investment Permitted Address":
      "PLOT NO. 111, MYAY TAING BLOCK NO. MYAUNG DAGAR THANMANI INDUSTRIAL ZONE",
  },
  {
    ID: 3475,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. PAN YUXIANG",
    "Name of Principal Organization": "MYANMAR RUI XIN SHOES COMPANY LIMITED",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "MYANMAR RUI XIN SHOES COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "287/2019",
    "Permit Date": "2019-11-08T04:37:27Z",
    "Meeting Number": "18/2019",
    "Meeting Date": "2019-10-30T04:37:36Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Shoes on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3.68,
    "Total Amount Of Capital (in Millions)": 3.68,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Easter",
    "Land Area (units not specified in file)": 5.09,
    "Lease Term": 5,
    "Annual Lease Fee": 24,
    "Land Use Premium": null,
    "Number Of Local Employees": 800,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address":
      "NO.10, LANE(130), SHIXIN ROAD, SONGTAI STREET, WENZHOU",
    "Organization Address":
      "PLOT NO. (E6), MYAY TAING BLOCK NO. 21, MYA SEIN YAUNG INDUSTRIAL ZONE 3",
    "Investment Permitted Address":
      "PLOT NO. (E6), MYAY TAING BLOCK NO. 21, MYA SEIN YAUNG INDUSTRIAL ZONE 3",
  },
  {
    ID: 3476,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. XIE ZUOSHEN",
    "Name of Principal Organization":
      "C STAR MYANMAR GOLDEN BAG FACTORY COMPANY LIMITED",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "C STAR MYANMAR GOLDEN BAG FACTORY COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "286/2019",
    "Permit Date": "2019-11-08T06:00:11Z",
    "Meeting Number": "18/2019",
    "Meeting Date": "2019-10-30T06:00:23Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.1,
    "Total Amount Of Capital (in Millions)": 1.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Hla Aung",
    "Land Area (units not specified in file)": 2.484,
    "Lease Term": 5,
    "Annual Lease Fee": 24,
    "Land Use Premium": null,
    "Number Of Local Employees": 700,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "ROOM -101, UNIT(1), BUILDING -3, JINXIU MINGYUAN",
    "Organization Address":
      "PLOT NO. 204, MYAY TAING BLOCK NO.(113), INSDUSTRIAL ZONE PART (1)",
    "Investment Permitted Address":
      "PLOT NO. 204, MYAY TAING BLOCK NO.(113), INSDUSTRIAL ZONE PART (1)",
  },
  {
    ID: 3478,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. ZHENGPING XIONG",
    "Name of Principal Organization":
      "SOKI AG & ACCESSORIES (MYANMAR) COMPANY LIMITED",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "SOKI AG & ACCESSORIES (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "270/2019",
    "Permit Date": "2019-10-08T07:00:43Z",
    "Meeting Number": "16/2019",
    "Meeting Date": "2019-09-30T07:01:03Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of Accessories (Such as Bags, Hair Band, Tiara, Hair Pin, Keychain, Necklace , earring, Bracelet, Ring, Wallet)",
    "Amount Of Foreign Capital USD (in Millions)": 0.423,
    "Total Amount Of Capital (in Millions)": 0.423,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Nwan Kyu",
    "Land Area (units not specified in file)": 0.459,
    "Lease Term": 5,
    "Annual Lease Fee": 42672,
    "Land Use Premium": null,
    "Number Of Local Employees": 300,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address": "NO.2, VILLAGERS GROUP OF DEMOCRACY BAY WUTAN TOWN",
    "Organization Address":
      "Plot No. 80, Myay Taing Block No. 113, Industrial Zone",
    "Investment Permitted Address":
      "Plot No. 80, Myay Taing Block No. 113, Industrial Zone",
  },
  {
    ID: 3479,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MS. BAO TINGTING",
    "Name of Principal Organization": "MYANMAR YANGON EVEREACH COMPANY LIMITED",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "MYANMAR YANGON EVEREACH COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "271/2019",
    "Permit Date": "2019-10-08T07:26:44Z",
    "Meeting Number": "16/2019",
    "Meeting Date": "2019-09-30T07:27:10Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.9,
    "Total Amount Of Capital (in Millions)": 0.9,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Kyawt Sein",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 5,
    "Annual Lease Fee": 102,
    "Land Use Premium": 102,
    "Number Of Local Employees": 313,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "NO.99, 16th FLOOR, BUILDING 7,XIANGYUN NORTH ROAD, HIGH-TECH ZONE",
    "Organization Address":
      "PLOT NO. 80, MYAY TAING BLOCK NO. INDUSTRIAL ZONE 1",
    "Investment Permitted Address":
      "PLOT NO. 80, MYAY TAING BLOCK NO. INDUSTRIAL ZONE 1",
  },
  {
    ID: 3480,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. QIAN JIGAO",
    "Name of Principal Organization": "DONNGUAN YUQIU ELECTRONICS CO., LTD",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "YUQIU (MYANMAR) ELECTRONICS CO., LTD",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "272/2019",
    "Permit Date": "2019-10-08T07:49:44Z",
    "Meeting Number": "16/2019",
    "Meeting Date": "2019-09-30T07:50:05Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Electrical Appliances on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 26,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Thein Han",
    "Land Area (units not specified in file)": 2,
    "Lease Term": 6,
    "Annual Lease Fee": 234,
    "Land Use Premium": null,
    "Number Of Local Employees": 548,
    "Number Of Foreign Employees": 12,
    Status: "Draft",
    "Investor Address": "LIUWUXIANG PRECINCT, LIAOBU TOWN",
    "Organization Address": "LIUWUXIANG VILLAGE",
    "Investment Permitted Address":
      "PLOT NO. 72, MYAY TAING BLOCK NO. INDUSTRIAL ZONE 1",
  },
  {
    ID: 3483,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. QIAO LIANG",
    "Name of Principal Organization": "HANDA INDUSTRIES LTD",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "HANBOOM (MYANMAR) GARMENT COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "259/2019",
    "Permit Date": "2019-09-27T04:02:53Z",
    "Meeting Number": "15/2019",
    "Meeting Date": "2019-09-13T04:03:19Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.319,
    "Total Amount Of Capital (in Millions)": 2.319,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 32,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Pyae Phyo Kyaw",
    "Land Area (units not specified in file)": 2,
    "Lease Term": 12,
    "Annual Lease Fee": 230400,
    "Land Use Premium": null,
    "Number Of Local Employees": 1100,
    "Number Of Foreign Employees": 20,
    Status: "Draft",
    "Investor Address": "NO. 57, DONGYUAN NEW RESIDENCE, XISHAN DISTRICT",
    "Organization Address":
      "FLAT/RM 318, 3/F,13 HOK YUEN STREET, CONOC INVESTMENT BUILDING",
    "Investment Permitted Address":
      "PLOT NO. 480, MYAY TAING BLOCK NO. 25, SHWE LIN BAN SET HMU MYO",
  },
  {
    ID: 3484,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. TANG LING",
    "Name of Principal Organization": "QUANTENCY TOOLS PTE LTD",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar": "FEILING TOOLS (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "258/2019",
    "Permit Date": "2019-09-27T04:37:05Z",
    "Meeting Number": "15/2019",
    "Meeting Date": "2019-09-13T04:37:23Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": 0.325,
    "Total Amount Of Capital (in Millions)": 0.325,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "K & M Capital Co., Ltd",
    "Land Area (units not specified in file)": 0.118,
    "Lease Term": 5,
    "Annual Lease Fee": 16800,
    "Land Use Premium": null,
    "Number Of Local Employees": 30,
    "Number Of Foreign Employees": 4,
    Status: "Draft",
    "Investor Address": "ROOM 3001, BUILDING LANE 737,CAOXI NORTH ROAD",
    "Organization Address": "2 VENTURE DRV# 11-31 VISION ",
    "Investment Permitted Address":
      "UNIT#C-20, PLOT NO.5, MYAY TAING BLOCK NO. 143/1,",
  },
  {
    ID: 3485,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. SONG LIMING",
    "Name of Principal Organization": "VUINO GEAR MYANMAR COMPANY LIMITED",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "VUINO GEAR MYANMAR COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "257/2019",
    "Permit Date": "2019-09-27T05:06:34Z",
    "Meeting Number": "15/2019",
    "Meeting Date": "2019-09-13T05:06:47Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Various Kinds of Bags",
    "Amount Of Foreign Capital USD (in Millions)": 1.583,
    "Total Amount Of Capital (in Millions)": 1.583,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaw Kyaw @ U Kyaw Kyaw Hlaing",
    "Land Area (units not specified in file)": 1.99,
    "Lease Term": 10,
    "Annual Lease Fee": 102000,
    "Land Use Premium": null,
    "Number Of Local Employees": 277,
    "Number Of Foreign Employees": 6,
    Status: "Draft",
    "Investor Address": "NO. 46, ROOM 506, BUILDING 12, CANGJI STREET",
    "Organization Address":
      "PLOT NO. 25, 26(2) , MYAY TAING BLOCK NO. (525)(KA), YE SU ANOUT TAW",
    "Investment Permitted Address":
      "PLOT NO. 25, 26(2) , MYAY TAING BLOCK NO. (525)(KA), YE SU ANOUT TAW",
  },
  {
    ID: 3486,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. ZHANG JIE",
    "Name of Principal Organization": "YINGFA INC. (CAYMAN ISLAND)",
    "Place of Incorporation": "United Kingdom",
    "Company Name In Myanmar": "Myanmar Yinfa Solar Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "289/2019",
    "Permit Date": "2019-11-08T06:52:42Z",
    "Meeting Number": "18/2019",
    "Meeting Date": "2019-10-30T06:52:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Solar Panels to be Exported on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.9,
    "Total Amount Of Capital (in Millions)": 4.9,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner":
      "U Than Maung, U Hla Thaung, Daw Myint Myint Win, Daw Khin Thein, Daw Khin Htar Yee, Daw Thein Thein Mya",
    "Land Area (units not specified in file)": 1.471,
    "Lease Term": 5,
    "Annual Lease Fee": 24,
    "Land Use Premium": null,
    "Number Of Local Employees": 600,
    "Number Of Foreign Employees": 20,
    Status: "Draft",
    "Investor Address":
      "NO.8, MIDDLE YINCHENG ROAD,NO(1207), ZHONGRONG JASPER TOWER,LUJIAZUI",
    "Organization Address": "NO. (4-210), 23 LINE TREE BASSAVENUE",
    "Investment Permitted Address":
      "Plot No. 240, Myay Taing Block No. Industry (2)",
  },
  {
    ID: 3487,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "DAW Yi Mon Oo",
    "Name of Principal Organization":
      "Paragon Machinery Power Group Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Paragon Machinery Power Group Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "278/2019",
    "Permit Date": "2019-11-08T07:22:58Z",
    "Meeting Number": "18/2019",
    "Meeting Date": "2019-10-30T07:23:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Assembling, Manufacturing and Distribution of Three Wheeler Vehicles Under Semi Knocked",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 800,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 7,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Soe Min Thant",
    "Land Area (units not specified in file)": 0.22,
    "Lease Term": 7,
    "Annual Lease Fee": 12,
    "Land Use Premium": null,
    "Number Of Local Employees": 43,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "Building No. 18, Room No. 4, Gyogone Yeik Thar Street, Gyogone(west) Ward",
    "Organization Address":
      "No. 12/B(43), Shwe Kainnayi Housing Complex, Nanattaw Street",
    "Investment Permitted Address":
      "Plot no. 201, Myay Taing Block n.(1/A), Mya Sein Young housing Complex",
  },
  {
    ID: 3488,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yan, Guomin",
    "Name of Principal Organization":
      "Hangzhou Kelong Electrical Appliance Tools Corp.",
    "Place of Incorporation": "Britsh Virgin Islands",
    "Company Name In Myanmar": "Ke Long Dian Gong (Myanmar) Co., Ltd",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "279/2019",
    "Permit Date": "2019-11-08T07:45:32Z",
    "Meeting Number": "18/2019",
    "Meeting Date": "2019-10-30T07:45:59Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Punch on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.664,
    "Total Amount Of Capital (in Millions)": 0.664,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "K & M Capital Co., Ltd",
    "Land Area (units not specified in file)": 0.118,
    "Lease Term": 5,
    "Annual Lease Fee": 16800,
    "Land Use Premium": null,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "Room 501, unit 1, Building 1, No. 20, Xin' anjiang Peninsula, Jiande City",
    "Organization Address":
      "Wickhams Cay II, Virgin Corporate Services Center, VG 1110, Road Town",
    "Investment Permitted Address":
      "Unit#C-021, Skytech Industrial Park, Plot No. 5, Myay Taing Block No. (143/1)",
  },
  {
    ID: 3489,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Tang Qinghai",
    "Name of Principal Organization": "Qingdao Kseng Apparel Co., Ltd",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Kseng (Myanmar) Apparel Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "288/2019",
    "Permit Date": "2019-11-08T08:04:50Z",
    "Meeting Number": "18/2019",
    "Meeting Date": "2019-10-30T08:04:59Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.2,
    "Total Amount Of Capital (in Millions)": 1.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myin Shin Yone",
    "Land Area (units not specified in file)": 2.85,
    "Lease Term": 5,
    "Annual Lease Fee": 24,
    "Land Use Premium": null,
    "Number Of Local Employees": 1200,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address": "No. 501, Huangqian Team, Taozhung Village, Mashan",
    "Organization Address": "Room 1503, No. 328, Building 1, Dunhua Road ",
    "Investment Permitted Address":
      "Plot No. 49, Myay Taing Block No. 51, Thar Du Kan Industrial Zone",
  },
  {
    ID: 3491,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. GAO ZHI YU",
    "Name of Principal Organization":
      "QUANZHOU MINGCHENG SPORTS PRODUCTS CO., LTD",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Mingcheng (Myanmar) Footwear Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "262/2019",
    "Permit Date": "2019-10-08T03:56:17Z",
    "Meeting Number": "16/2019",
    "Meeting Date": "2019-09-30T03:56:37Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Varity of Shoes on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.54,
    "Total Amount Of Capital (in Millions)": 4.54,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Than Soe",
    "Land Area (units not specified in file)": 2.465,
    "Lease Term": 50,
    "Annual Lease Fee": 30026,
    "Land Use Premium": null,
    "Number Of Local Employees": 1030,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address": "6 CHAOJIANG ZHONE LU, BAOSHANHUAYUAN,FENGZE DISTRICT",
    "Organization Address": "HOUXI,HUANG TANG TOWN,HUIAN",
    "Investment Permitted Address":
      "Plot No. 47, Myay Taing Block no. 112, Industrial Zone,",
  },
  {
    ID: 3492,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. HUANG FABIN",
    "Name of Principal Organization": "VANTAGE RIGHT HOLDINGS LIMITED",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Belink (Myanamr) Technology Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "274/2019",
    "Permit Date": "2019-10-29T04:33:29Z",
    "Meeting Number": "17/2019",
    "Meeting Date": "2019-10-09T04:33:40Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Signal Cable On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.5,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Zaw Linn",
    "Land Area (units not specified in file)": 1.899,
    "Lease Term": 5,
    "Annual Lease Fee": 18,
    "Land Use Premium": null,
    "Number Of Local Employees": 800,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address": "NO.2, YAOBEIJIANG , JIANJIA VILLAGE, SHIBI TOWNSHIP",
    "Organization Address": "11/F,CAPITAL CENTRE, 151 GLOUCESTER ROAD",
    "Investment Permitted Address": "Plot No. 21, Myay Taing Block NO. (112)",
  },
  {
    ID: 3493,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. HANG,TIANYONG",
    "Name of Principal Organization": "MYANMAR KINGTONG BAGS COMPANY LIMITED",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "MYANMAR KINGTONG BAGS COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "273/2019",
    "Permit Date": "2019-11-07T05:03:06Z",
    "Meeting Number": "17/2019",
    "Meeting Date": "2019-10-09T05:02:25Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Various Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.707,
    "Total Amount Of Capital (in Millions)": 0.707,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Htun Linn",
    "Land Area (units not specified in file)": 1.998,
    "Lease Term": 10,
    "Annual Lease Fee": 72,
    "Land Use Premium": null,
    "Number Of Local Employees": 354,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "NO. 328, ROOM1501, KECUO ROAD, SIMING DISTRICT",
    "Organization Address":
      "PLOT NO. 480,MYAY TAING BLOCK NO.PART 4, INDUSTRIAL ZONE",
    "Investment Permitted Address":
      "PLOT NO. 480,MYAY TAING BLOCK NO.PART 4, INDUSTRIAL ZONE",
  },
  {
    ID: 3494,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. ZHANG, QING",
    "Name of Principal Organization": "DA MEI GARMENT COMPANY LIMITED",
    "Place of Incorporation": "MYANMAR",
    "Company Name In Myanmar": "DA MEI GARMENT COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "238/2019",
    "Permit Date": "2019-08-23T06:45:21Z",
    "Meeting Number": "13/2019",
    "Meeting Date": "2019-08-13T06:45:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.2,
    "Total Amount Of Capital (in Millions)": 1.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaw Thu Ya",
    "Land Area (units not specified in file)": 0.356,
    "Lease Term": 15,
    "Annual Lease Fee": 54,
    "Land Use Premium": null,
    "Number Of Local Employees": 587,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "ROOM NO. 201, CHOUNG QING NAN ROAD, NO.34, BUILDING 4",
    "Organization Address":
      "PLOT NO. 55, MYAY TAING BLOCK NO. PART.5 (THA KA MA-18),SETHMU MYO",
    "Investment Permitted Address":
      "PLOT NO. 55, MYAY TAING BLOCK NO. PART.5 (THA KA MA-18),SETHMU MYO",
  },
  {
    ID: 3495,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. HU SHENGQI",
    "Name of Principal Organization": "E & C SMART LINK TECHNOLOGY CO., LTD",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "SONO SMART LINK TECHNOLOGY (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "230/2019",
    "Permit Date": "2019-07-30T07:13:31Z",
    "Meeting Number": "12/2019",
    "Meeting Date": "2019-07-24T07:13:47Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Electrical Accessories on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.351,
    "Total Amount Of Capital (in Millions)": 0.351,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "K & M Capital Company Limited",
    "Land Area (units not specified in file)": 0.398,
    "Lease Term": 5,
    "Annual Lease Fee": 57600,
    "Land Use Premium": null,
    "Number Of Local Employees": 1000,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "NO.10, GAOXIN SOUTH,NANSHAN DISTRICT",
    "Organization Address": "FLAT /RM 803, CHEVALIER HOUSE, 45-51 CHATHAM ROAD",
    "Investment Permitted Address":
      "Unit # A-003, A-004, Plot no. 5, Myay Taing Block no. 14361",
  },
  {
    ID: 3496,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. XIA, TIANWEN",
    "Name of Principal Organization": "MTM CORPORATION LIMITED",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "MTM (YANGON) LIMITED ",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "281/2019",
    "Permit Date": "2019-11-08T07:44:35Z",
    "Meeting Number": "18/2019",
    "Meeting Date": "2019-10-30T07:44:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags & Belts on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.6,
    "Total Amount Of Capital (in Millions)": 1.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Tai On Company Limited",
    "Land Area (units not specified in file)": 2.128,
    "Lease Term": 50,
    "Annual Lease Fee": 17229.84,
    "Land Use Premium": null,
    "Number Of Local Employees": 200,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "NO.11055,CUI HU STRET (8), HUANG PU ROAD",
    "Organization Address":
      "BLDG 99-103, FLAT 1B, NAM CHEONG STREET, LOK MOON SHAM",
    "Investment Permitted Address": "PLOT NO.2, INDUSTRIAL ZONE 2",
  },
  {
    ID: 3513,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "MR. Lo Siu Yuen",
    "Name of Principal Organization": "CNTIC VPower Group Holdings Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "CNTIC VPOWER YG1 LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "210/2019",
    "Permit Date": "2019-11-29T03:39:07Z",
    "Meeting Number": "19/2019",
    "Meeting Date": "2019-11-29T03:39:20Z",
    Sector: "Power",
    "Type Of Investment Business":
      "GENERATION OF 400 MW ELECTRICITY FROM LNG, SUPPLY AND SALE OF ELECTRICITY ON IPP (BOO) BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 363.07,
    "Total Amount Of Capital (in Millions)": 363.07,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 5,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "MOEE, MOGE",
    "Land Area (units not specified in file)": 40,
    "Lease Term": null,
    "Annual Lease Fee": 12141,
    "Land Use Premium": null,
    "Number Of Local Employees": 266,
    "Number Of Foreign Employees": 57,
    Status: "Submitted",
    "Investor Address":
      "Flat D, 1/F, Block 3, Lakeview Garden, 21 Yau on Street, Tai Wai, New Territories, Hong Kong",
    "Organization Address":
      "Unit 2701-15, 27/F, Office Tower, The Harbourfront, 18-22 Tak Fung Street, Hung Hom, Kowloon, Hong Kong",
    "Investment Permitted Address": "THAKETA POWER PLANT, THAKETA TOWNSHIP, ",
  },
  {
    ID: 3516,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Mr. Koo Ja Yong",
    "Name of Principal Organization":
      "Tae Hyun (Myanmar) Industry Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "TAE HYUN (MYANMAR) INDUSTRY COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "277/2019",
    "Permit Date": "2019-10-29T03:56:55Z",
    "Meeting Number": "17/2019",
    "Meeting Date": "2019-10-09T03:59:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Wearing Apparel (Such as Various Kinds of Jacket and Cap) on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1245,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Mya Mya @ Ma A Kwan @ Kwan Kwan",
    "Land Area (units not specified in file)": 0.977,
    "Lease Term": 5,
    "Annual Lease Fee": 6500000,
    "Land Use Premium": null,
    "Number Of Local Employees": 565,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "No. 13-301, 262-GA-Jeung Ro Sko Ku, Incheon ",
    "Organization Address":
      "Plot No. 139, Myay Taing Block No. Part-4, Industrial Zone",
    "Investment Permitted Address":
      "Plot No. 139, Myay Taing Block No. Part-4, Industrial Zone",
  },
  {
    ID: 3517,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Xia, Yin",
    "Name of Principal Organization":
      "DONGGUAN XINSHENG HANDBAG CRAFT CO., LTD",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "XINSHENG (MYANMAR) INDUSTRIAL COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "290/2019",
    "Permit Date": "2019-11-20T05:01:10Z",
    "Meeting Number": "19/2019",
    "Meeting Date": "2019-11-13T05:01:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Handbags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Dr. Phay Thet Zaw",
    "Land Area (units not specified in file)": 2.8,
    "Lease Term": 10,
    "Annual Lease Fee": 113311.98,
    "Land Use Premium": null,
    "Number Of Local Employees": 500,
    "Number Of Foreign Employees": 13,
    Status: "Draft",
    "Investor Address": "Unit-2, Room-1203, Building-3, Huashan Town, ",
    "Organization Address": "Unit-2, Room-1203, Building-3, Huashan Town, ",
    "Investment Permitted Address":
      "Holding No. (8/B+ 9/A+10/A) and (7+11/C), Kwin no. 710, Kalawye  North Kwin, KAlawye Village Tract",
  },
  {
    ID: 3518,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Li Yingyu",
    "Name of Principal Organization": "Wellgreen Outdoor Ltd",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Wellgreen Outdoor (Myanmar) Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "291/2019",
    "Permit Date": "2019-11-20T03:34:43Z",
    "Meeting Number": "19/2019",
    "Meeting Date": "2019-11-13T03:35:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing Of Various Kinds of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.968,
    "Total Amount Of Capital (in Millions)": 0.968,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 26,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Win Win Myint",
    "Land Area (units not specified in file)": 4.141,
    "Lease Term": 6,
    "Annual Lease Fee": 198000,
    "Land Use Premium": null,
    "Number Of Local Employees": 254,
    "Number Of Foreign Employees": 8,
    Status: "Draft",
    "Investor Address":
      "NO.1, 9th Mid Rd Ying, Tieling Industrial Zone 1, MInhou",
    "Organization Address": "11/F Capital Center.151 Gloucester Road",
    "Investment Permitted Address":
      "Plot No. A-6, Myay Taing Block No. 21, Mya Sein Yaung Industrial Zone",
  },
  {
    ID: 3519,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Sein Win",
    "Name of Principal Organization": "Green Indo Myanmar Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Green Indo Myanmar Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "292/2019",
    "Permit Date": "2019-11-20T04:16:41Z",
    "Meeting Number": "19/2019",
    "Meeting Date": "2019-11-13T04:16:53Z",
    Sector: "Agriculture",
    "Type Of Investment Business":
      "Buying raw rice and broken rice in local and making processing for white and broken rice for export",
    "Amount Of Foreign Capital USD (in Millions)": 2.402,
    "Total Amount Of Capital (in Millions)": 1.586,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "U Gu Yu Sar Mi @ U Myint Thein",
    "Land Area (units not specified in file)": 0.778,
    "Lease Term": 10,
    "Annual Lease Fee": 30000,
    "Land Use Premium": null,
    "Number Of Local Employees": 115,
    "Number Of Foreign Employees": 4,
    Status: "Draft",
    "Investor Address": "No. 27, 123 Street, Thapyae Gone Ward",
    "Organization Address":
      "Plot No- 391, Myay Taing Block No-25, Shwe Lin Ban Industrial Zone",
    "Investment Permitted Address":
      "Plot No- 391, Myay Taing Block No-25, Shwe Lin Ban Industrial Zone",
  },
  {
    ID: 3521,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wu Chih-Yu",
    "Name of Principal Organization": "World Atlantic Co., Ltd",
    "Place of Incorporation": "Seychelles",
    "Company Name In Myanmar": "World Atlantic ( Myanmar) Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "293/2019",
    "Permit Date": "2019-11-25T07:06:32Z",
    "Meeting Number": "19/2019",
    "Meeting Date": "2019-11-13T07:06:46Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Chandelier on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.686,
    "Total Amount Of Capital (in Millions)": 0.686,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Kyu Shu Houng @ Daw Tin Tin Hway",
    "Land Area (units not specified in file)": 1.864,
    "Lease Term": 5,
    "Annual Lease Fee": 145.8,
    "Land Use Premium": null,
    "Number Of Local Employees": 126,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address":
      "Room 2, Flat C,15/F, Lee Kwan Building , 42v Argyle Street",
    "Organization Address": "No.4, Franky Building, ",
    "Investment Permitted Address":
      "Plot No. 19, Myay Taing Block no. Thilawa Industrial Zone",
  },
  {
    ID: 3522,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Virender Kumar",
    "Name of Principal Organization": " Bansal Overseas Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Bansal Overseas Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "294/2019",
    "Permit Date": "2019-12-20T07:41:14Z",
    "Meeting Number": "19/2019",
    "Meeting Date": "2019-11-13T07:41:25Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Products for Household Utensils such as Plate, Bowls and Circle Plate for Industrial Use",
    "Amount Of Foreign Capital USD (in Millions)": 0.519,
    "Total Amount Of Capital (in Millions)": 0.519,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U San Nee Kumar",
    "Land Area (units not specified in file)": 3.189,
    "Lease Term": 5,
    "Annual Lease Fee": 46.8,
    "Land Use Premium": null,
    "Number Of Local Employees": 64,
    "Number Of Foreign Employees": 8,
    Status: "Draft",
    "Investor Address": "H. No. 329, Gur Mandi , Ward No. 23, Haryana",
    "Organization Address":
      "Plot no. (45,46) , Myay Taing Block no. Industrial Zone (3), ",
    "Investment Permitted Address":
      "Plot no. (45,46) , Myay Taing Block no. Industrial Zone (3), ",
  },
  {
    ID: 3523,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Shi Xiangwen",
    "Name of Principal Organization": "HONG KONG REFWEAR GARMENTS LTD",
    "Place of Incorporation": "HONGKONG",
    "Company Name In Myanmar": "SHUNRONG GARMENTS (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "295/2019",
    "Permit Date": "2019-11-20T08:09:20Z",
    "Meeting Number": "19/2019",
    "Meeting Date": "2019-11-13T08:09:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.891,
    "Total Amount Of Capital (in Millions)": 0.891,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 26,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Nwe Nwe Aung",
    "Land Area (units not specified in file)": 1.027,
    "Lease Term": 6,
    "Annual Lease Fee": 60,
    "Land Use Premium": 60,
    "Number Of Local Employees": 400,
    "Number Of Foreign Employees": 12,
    Status: "Draft",
    "Investor Address":
      "WUZHONG STREET, WUAHONG AVENUE, 2588 FIRST INDUSTRIAL PARK C9, WUZHONG DISTRICT",
    "Organization Address":
      "NO. 9, ROOM NO. 01, 21/F, XINGFA COMMERCIAL BUILDING, YANCHANG STREET",
    "Investment Permitted Address":
      "Plot No. 77,78, Myay Taing Block No. Park (5), Industrial Zone",
  },
  {
    ID: 3524,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhang Changqing",
    "Name of Principal Organization": "Utrend Co., Ltd",
    "Place of Incorporation": "HONG KONG",
    "Company Name In Myanmar": "NEWEL INDUSTRY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "296/2019",
    "Permit Date": "2019-11-20T09:08:52Z",
    "Meeting Number": "19/2019",
    "Meeting Date": "2019-11-13T09:09:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.385,
    "Total Amount Of Capital (in Millions)": 1.385,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw San San Maw",
    "Land Area (units not specified in file)": 2.81,
    "Lease Term": 10,
    "Annual Lease Fee": 96,
    "Land Use Premium": null,
    "Number Of Local Employees": 500,
    "Number Of Foreign Employees": 12,
    Status: "Draft",
    "Investor Address": "No. 995, Longxiang Road, Longgang City",
    "Organization Address": "Room 1902, EASEY COMM BLDG, 253-261 HENNESY ROAD",
    "Investment Permitted Address": "PLOT NO. 176, MYAY TAING BLOCK NO. 113, ",
  },
  {
    ID: 3540,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Aung Zaw Naing",
    "Name of Principal Organization": "Shwe Taung Solar Energy Co., Ltd. ",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Shwe Taung Solar Energy Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "173/2019",
    "Permit Date": "2019-12-19T04:09:04Z",
    "Meeting Number": "20/2019",
    "Meeting Date": "2019-12-14T04:09:35Z",
    Sector: "Power",
    "Type Of Investment Business":
      "to provide off-grid electricity through solar-powered micro power plants",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1922.804,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner":
      "U Aung Zaw Naing, Shwe Taung Development Co., Ltd. Daw Ni Ni",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 20,
    "Number Of Foreign Employees": 3,
    Status: "Submitted",
    "Investor Address":
      "Ahlon Tower, River View Garden Housing Complex, Strand Road, Sin Min Quarter, ",
    "Organization Address":
      "Ahlon Tower, River View Garden Housing Complex, Strand Road, Sin Min Quarter, ",
    "Investment Permitted Address":
      "MALIKHA TOWN HOUSE & OTHER RESIDENTIAL, THINGANGYUN TOWNSHIP, JUNCTION SQUARE MULTI-STOREY CARPARK, KAMAYUT TOWNSHIP, YANGON REGION, PARK ROYAL HOTEL & JUNCTION SHOPPING CENTER, DEKKHINA THIRI TOWNSHIP, NAY PYI TAW COUNCIL",
  },
  {
    ID: 3542,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr. Teruo Takahashi",
    "Name of Principal Organization": "Ehime Nissan Motor Co., Ltd.",
    "Place of Incorporation": "japan",
    "Company Name In Myanmar": "Enatic Automotive Co., Ltd.",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "165/2019(E)",
    "Permit Date": "2019-10-23T07:35:05Z",
    "Meeting Number": "17/2019",
    "Meeting Date": "2019-10-21T07:43:00Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Automobile Maintenance and repair Training Center",
    "Amount Of Foreign Capital USD (in Millions)": 0.84,
    "Total Amount Of Capital (in Millions)": 4.8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "U Moe Win Maung",
    "Land Area (units not specified in file)": 2.578,
    "Lease Term": 5,
    "Annual Lease Fee": 0.084,
    "Land Use Premium": null,
    "Number Of Local Employees": 27,
    "Number Of Foreign Employees": 5,
    Status: "Submitted",
    "Investor Address":
      "4 Chome-9-22, Tarumi, Matsuyama, Ehime, Japan 790-0905",
    "Organization Address":
      "8-27, Miyanishi 2, Matsuyama, Ehime, Japan 790-0065",
    "Investment Permitted Address":
      "Plot No. 173(A) And 173(B), Corner of Myawaddy Mingyi Road and Sakekanthar Road, Industrial Zone 4, Hlaingthaya Township, Yangon Region",
  },
  {
    ID: 3543,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Nyi Nyi Lwin@ U Nyi Nyi Thein Myint",
    "Name of Principal Organization": "Baho Animals Care Center Co., Ltd.",
    "Place of Incorporation": "myanmar",
    "Company Name In Myanmar": "Baho Animals Care Center Co., Ltd.",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "164/2019(E)",
    "Permit Date": "2019-10-23T08:13:30Z",
    "Meeting Number": "17/2019",
    "Meeting Date": "2019-10-21T08:13:47Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Animals Health Care Service",
    "Amount Of Foreign Capital USD (in Millions)": 0.32,
    "Total Amount Of Capital (in Millions)": 0.4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "U Kan Tun Win",
    "Land Area (units not specified in file)": null,
    "Lease Term": 10,
    "Annual Lease Fee": 12,
    "Land Use Premium": null,
    "Number Of Local Employees": 12,
    "Number Of Foreign Employees": 4,
    Status: "Submitted",
    "Investor Address": "No.134, University Road, Kamayut Township, Yangon",
    "Organization Address":
      "No.A/29, Thazin (1) Street, FMI City, Hlaingthaya Township, Yangon",
    "Investment Permitted Address":
      "No.A/29, Thazin (1) Street, FMI City, Hlaingthaya Township, Yangon Region",
  },
  {
    ID: 3544,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Daw Yin Yin Win",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Mian Hua Company Limited",
    "Financial Year From": 18,
    "Financial Year To": 19,
    "Permit Number": "148/2019",
    "Permit Date": "2019-04-08T08:42:49Z",
    "Meeting Number": "5/2019",
    "Meeting Date": "2019-04-05T08:42:57Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Foreign Language (Chinese) Training Services",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 300,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Marlar",
    "Land Area (units not specified in file)": 0.372,
    "Lease Term": 5,
    "Annual Lease Fee": 60,
    "Land Use Premium": null,
    "Number Of Local Employees": 18,
    "Number Of Foreign Employees": 10,
    Status: "Submitted",
    "Investor Address":
      "No.7(A), Pyitaw Aye Avenue Road, yankin Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "No.7(A), Plot No. 32/5, Myay Taing Block No.85(Kanbae), Pyitaw Aye Avenue Road, Yankin Township, Yangon Region",
  },
  {
    ID: 3545,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Kyay 'O' Kyee Petroleum Products Co., Ltd.",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Kyay 'O' Kyee Petroleum Products Co., Ltd.",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "103/2018",
    "Permit Date": "2018-06-23T08:58:32Z",
    "Meeting Number": "8/2018",
    "Meeting Date": "2018-06-22T08:58:50Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "အင်ဂျင်ဝိုင်ရောစပ်ထုတ်လုပ်၍ ဖြန့်ဖြူးရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 6100,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Kyaw Win",
    "Land Area (units not specified in file)": 2.251,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 22,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "No.353, Upper Pazundaung Street, Satsan Ward, Mingalar Taungnunt Township, Yangon",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 68, Myaungdarkar  Steel Founding Industrial Zone, Hmawbi Township, Yangon",
  },
  {
    ID: 3554,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "MR. TONG KOOI ONG",
    "Name of Principal Organization": "UPP HOLDINGS LTD.",
    "Place of Incorporation": "SINGAPORE",
    "Company Name In Myanmar": "UPP POWER (MYANMAR) LTD.",
    "Financial Year From": 2013,
    "Financial Year To": 2014,
    "Permit Number": "631/2013",
    "Permit Date": "2013-10-18T09:45:21Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Power",
    "Type Of Investment Business":
      "CONSTRUCTION OF 50 MW GAS ENGINE POWER PLANT FOR ELECTRICITY GENERATION",
    "Amount Of Foreign Capital USD (in Millions)": 46.511,
    "Total Amount Of Capital (in Millions)": 46.511,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "1 KIM SENG PROMENADE, # 14-01, GREAT WORLD CITY EAST TOWER, SINGAPORE 237994",
    "Organization Address":
      "1 KIM SENG PROMENADE, # 14-01, GREAT WORLD CITY EAST TOWER, SINGAPORE 237994",
    "Investment Permitted Address": "YWAMA, INSEIN TOWNSHIP,",
  },
  {
    ID: 3560,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Daw Aye Mya Aung",
    "Name of Principal Organization": "Myanmar Green Century Co., Ltd.",
    "Place of Incorporation": "Yangon",
    "Company Name In Myanmar": "Myanmar Green Century Co., Ltd.",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "179/2019",
    "Permit Date": "2019-08-08T03:11:24Z",
    "Meeting Number": "12/2019",
    "Meeting Date": "2019-07-31T03:12:23Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": 1.6,
    "Total Amount Of Capital (in Millions)": 3.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Italy",
    "Form Of Investment": "JV,BOT",
    "Land Owner": "Taninthayi Region Government",
    "Land Area (units not specified in file)": 17,
    "Lease Term": 50,
    "Annual Lease Fee": 13.759,
    "Land Use Premium": 1700000,
    "Number Of Local Employees": 97,
    "Number Of Foreign Employees": 10,
    Status: "Approved",
    "Investor Address":
      "No 2(A), Masoeyein Kyaung Street, Lane 3, 9 mile, Mayangone T/S, Yangon",
    "Organization Address":
      "No 2(A), Masoeyein Kyaung Street, Lane 3, 9 mile, Mayangone T/S, Yangon",
    "Investment Permitted Address":
      "No 2(A), Masoeyein Kyaung Street, Lane 3, 9 mile, Mayangone T/S, Yangon",
  },
  {
    ID: 3561,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Lesso Mall (Myanmar) Investment Ltd.",
    "Name of Principal Organization": "Lesso Mall (Myanmar) Investment Ltd.",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Lesso Home Development (Yangon) Ltd.",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "173/2019",
    "Permit Date": "2019-07-11T05:13:48Z",
    "Meeting Number": "11/2019",
    "Meeting Date": "2019-07-10T05:14:39Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Construction, Selling ,Leasing and Management of Commercial, Office, Wholesale and  Retail Buildings and Units  ",
    "Amount Of Foreign Capital USD (in Millions)": 52.5,
    "Total Amount Of Capital (in Millions)": 87.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "U Aike Htwe and U Pyae Phyo Aung",
    "Land Area (units not specified in file)": 74.214,
    "Lease Term": 50,
    "Annual Lease Fee": 0.88,
    "Land Use Premium": null,
    "Number Of Local Employees": 224,
    "Number Of Foreign Employees": 26,
    Status: "Amend",
    "Investor Address":
      "Unit 3, 12th Floor, Tower 2, South Seas Center, 75 Mody Road, Tsim Sha Tsui East, Kowloon, Hongkong ",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No 2, 4, 8 and 9, Myaytaing Block No 59, Corner of Bago River and yadanar Street, Dagon Myothit (Seik) Township, Yangon Region ",
  },
  {
    ID: 3571,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Loo Heng Shuen ",
    "Name of Principal Organization": "yangon investment pte.ltd.",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "yangon hotel limited.",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "107/1994",
    "Permit Date": "1994-07-18T03:34:28Z",
    "Meeting Number": "8/1994",
    "Meeting Date": "1994-06-17T03:35:29Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel and Tourism Services",
    "Amount Of Foreign Capital USD (in Millions)": 14,
    "Total Amount Of Capital (in Millions)": 84,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 30,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Singapore",
    "Form Of Investment": "JV",
    "Land Owner": "Ministry of Trade",
    "Land Area (units not specified in file)": 7409,
    "Lease Term": 30,
    "Annual Lease Fee": 1.1,
    "Land Use Premium": 2.5,
    "Number Of Local Employees": 465,
    "Number Of Foreign Employees": 29,
    Status: "Monitoring Approved",
    "Investor Address": "8, parkvale ,Singapore 1128",
    "Organization Address": "8, parkvale ,Singapore 1128",
    "Investment Permitted Address":
      "At the junction of Alan pya paya road and Yaw min gyi road",
  },
  {
    ID: 3572,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Ko Ko Htoo",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "MYANMA ANNAWA SWAN :A:SHIN GROUP(S) COMPANY LIMITED",
    "Financial Year From": 2003,
    "Financial Year To": 2004,
    "Permit Number": "Ma Na Tha 572/2003",
    "Permit Date": "2003-01-01T09:11:41Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Transport & Communication",
    "Type Of Investment Business":
      "BOT စနစ်ဖြင့် ဆိပ်ခံတံတားနှင့် ကွန်တိန်နာလွင်ပြင် သိုလှောင်မှုစခန်း တည်ဆောက်ခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 4836.52,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI,BOT",
    "Land Owner": "Myanma Port Authorities ",
    "Land Area (units not specified in file)": null,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address": "No.7/2 B, Strand Road, alone township",
    "Organization Address": "",
    "Investment Permitted Address":
      "Strand Road,\nNo.(7/2-B),\nAhlone Township,, Yangon Region,, Myanmar",
  },
  {
    ID: 3575,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Managing Director, Road Transport",
    "Name of Principal Organization": "Ministry of Post and Telecommunications",
    "Place of Incorporation": "Nay Pyi Taw",
    "Company Name In Myanmar": "San Yaung Ni Road Transport Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "213/2019",
    "Permit Date": "2019-12-06T09:08:00Z",
    "Meeting Number": "19/2019",
    "Meeting Date": "2019-11-29T09:08:12Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Operating and Leasing of Commercial and Office Building Including Taxi Waiting Area",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 23223,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Post and Telecommunication, Road Transport",
    "Land Area (units not specified in file)": 1.56,
    "Lease Term": 30,
    "Annual Lease Fee": 56.16,
    "Land Use Premium": null,
    "Number Of Local Employees": 480,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "Building No.29, Road Transport Head Office, Ministry of Post and Telecommunications, Nay Pyi Taw",
    "Organization Address":
      "Building No.29, Road Transport Head Office, Ministry of Post and Telecommunications, Nay Pyi Taw",
    "Investment Permitted Address":
      "Myay Taing Block No. 34 C, Plot No. 2 A 1 + 16 G, East Horse Race Course Street, Tamwe Township, Yangon Region.",
  },
  {
    ID: 3579,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yasuo Tsutsui",
    "Name of Principal Organization": "Amata (Asia) Myanmar Limited",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Yangon Amata Smart and Eco City Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "200/2019",
    "Permit Date": "2019-10-23T09:10:59Z",
    "Meeting Number": "17/2019",
    "Meeting Date": "2019-10-21T09:11:19Z",
    Sector: "Industrial Estate",
    "Type Of Investment Business":
      "Smart and Eco City Development Operation and Related Business",
    "Amount Of Foreign Capital USD (in Millions)": 161.874,
    "Total Amount Of Capital (in Millions)": 274.678,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner":
      "Urban and Housing Development Department, Ministry of Construction",
    "Land Area (units not specified in file)": 2000,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 32640,
    "Number Of Foreign Employees": 1011,
    Status: "Draft",
    "Investor Address":
      "899/74 Moo Baan Nantawan Onnut-Rama 9, Sukhumvit-Latkrabang Road,Pravet, Bangkok 10250, Thailand",
    "Organization Address":
      "4th Floor, Haven Commmercial Building, 6-8 Tsing Fung Street, North Point, Hong Kong",
    "Investment Permitted Address":
      "Near Lay Daung Kan Village, Dagon (East) Township And Dagon (South) Township, Yangon Region",
  },
  {
    ID: 3584,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr. Chow Yun Kit",
    "Name of Principal Organization": "Green urban Ventures Pte. Ltd.",
    "Place of Incorporation": "singapore",
    "Company Name In Myanmar": "Green Urban Ventures Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "215/2019",
    "Permit Date": "2019-12-16T06:52:31Z",
    "Meeting Number": "18/2019",
    "Meeting Date": "2019-11-15T06:52:36Z",
    Sector: "Real Estate",
    "Type Of Investment Business": "Real Estate Development",
    "Amount Of Foreign Capital USD (in Millions)": 132.676,
    "Total Amount Of Capital (in Millions)": 142.418,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "Department of Urban and Housing Development",
    "Land Area (units not specified in file)": 6.382,
    "Lease Term": 50,
    "Annual Lease Fee": 1.2,
    "Land Use Premium": 25.53,
    "Number Of Local Employees": 291,
    "Number Of Foreign Employees": 21,
    Status: "Draft",
    "Investor Address":
      "Flat D, 22/F, Block 9, Beverly Garden, NO. 1 Tong Ming Street, Tseung Kwan Oo, New Territorise, Hong Kong",
    "Organization Address":
      "6 Temasek Boulevard, # 29-30, Suntec Tower Four, Singapore 038986",
    "Investment Permitted Address":
      "Block No. 24 A, Lot No. 17-A1, 17-A2, 17-A3, 17-A4, 41, Baho Road, Ahlon Township, Yangon Region",
  },
  {
    ID: 3586,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Dong, Jianqiu",
    "Name of Principal Organization": "Poushing Industrial Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Poushing Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "297/2019",
    "Permit Date": "2019-12-09T08:57:05Z",
    "Meeting Number": "20/2019",
    "Meeting Date": "2019-12-03T08:57:36Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Shoes on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Hla YIn",
    "Land Area (units not specified in file)": 1.78,
    "Lease Term": 20,
    "Annual Lease Fee": 21.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 168,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "No. 09013, Group 7, Sunjiazui Village, Shimen County",
    "Organization Address":
      "Room 1508, 15/F , Office Tower Two, Grand Plaza, 625 Nathan Road",
    "Investment Permitted Address":
      "Plot No. 364, Myay Taing Block No. 49 , Wartayar industrial Zone",
  },
  {
    ID: 3592,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ye, Zhen Fa",
    "Name of Principal Organization":
      "Quanzhou Hengxuan Imp. & Exp. Trading Co., Ltd",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Myanmar Myanbag Industrial Co., Ltd",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "298/2019",
    "Permit Date": "2019-12-09T04:41:22Z",
    "Meeting Number": "20/2019",
    "Meeting Date": "2020-02-03T04:41:41Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.876,
    "Total Amount Of Capital (in Millions)": 0.876,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Mg Mg",
    "Land Area (units not specified in file)": 2.493,
    "Lease Term": 10,
    "Annual Lease Fee": 252,
    "Land Use Premium": null,
    "Number Of Local Employees": 1000,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address": "No. 10, Dasong Village, Daxi Town, Pinghe County",
    "Organization Address":
      "Building 1, 4th Floor, Tianxiang Tongyuan Street, ",
    "Investment Permitted Address":
      "Plot no. 17, Myay Taing Block No. Zone(1), Industrial Zone",
  },
  {
    ID: 3594,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lu Chonggao",
    "Name of Principal Organization": "Sunny Arts & Crafts Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Sunny Arts & Crafts Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "299/2019",
    "Permit Date": "2019-12-09T06:31:52Z",
    "Meeting Number": "20/2019",
    "Meeting Date": "2019-12-03T06:32:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Dolls on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.2,
    "Total Amount Of Capital (in Millions)": 1.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U San Ji Ku Marl",
    "Land Area (units not specified in file)": 1.104,
    "Lease Term": 5,
    "Annual Lease Fee": 30,
    "Land Use Premium": null,
    "Number Of Local Employees": 300,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "Room 1002, Unit 4, Building 2, No. 1 , Jida Road",
    "Organization Address": "Plot no. 102, Myay Taing Block No. Part 4",
    "Investment Permitted Address": "Plot no. 102, Myay Taing Block No. Part 4",
  },
  {
    ID: 3595,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "MR. SHENTU, YUE",
    "Name of Principal Organization":
      "AA DOUBLE ACE CONSTRUCTION MATERIAL COMPANY LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "AA DOUBLE ACE CONSTRUCTION MATERIAL COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "224/2020",
    "Permit Date": "2020-01-15T06:53:06Z",
    "Meeting Number": "1-2020",
    "Meeting Date": "2020-01-10T06:53:25Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING AND MARKETING OF COMPOSITE CEMENT ",
    "Amount Of Foreign Capital USD (in Millions)": 19.326,
    "Total Amount Of Capital (in Millions)": 20.343,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "JV",
    "Land Owner": "U Tint Lwin @ U Tun Aung Lwin ",
    "Land Area (units not specified in file)": 1.233,
    "Lease Term": 30,
    "Annual Lease Fee": 1080000,
    "Land Use Premium": null,
    "Number Of Local Employees": 130,
    "Number Of Foreign Employees": 20,
    Status: "Draft",
    "Investor Address":
      "ROOM 920, DONG FONG BUILDING, 1500 CENTURY AVENUE, PUDONG, SHANGHAI, THE PEOPLE’S REPUBLIC OF CHINA",
    "Organization Address":
      "PLOT NO. 228/3/E, MYAY TAING BLOCK NO. INDUSTRIAL ZONE(1) EXTENSION, DAGON (SEIKKAN) TOWNSHIP, YANGON ",
    "Investment Permitted Address":
      "PLOT NO. 228/3/E, MYAY TAING BLOCK NO. INDUSTRIAL ZONE(1) EXTENSION, DAGON (SEIKKAN) TOWNSHIP, YANGON ",
  },
  {
    ID: 3597,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Wang Jie",
    "Name of Principal Organization":
      "Changs Huhongbo Telecommunication Technology Co., Ltd",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Hongbo Telecomminication (Myanmar) Co., Ltd",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "300/2019",
    "Permit Date": "2019-12-09T07:58:13Z",
    "Meeting Number": "",
    "Meeting Date": "",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of FFC Cable on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.5,
    "Total Amount Of Capital (in Millions)": 2.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Kyu Kyu Hlaing @ Daw Kay Thi Aung",
    "Land Area (units not specified in file)": 1.132,
    "Lease Term": 10,
    "Annual Lease Fee": 24,
    "Land Use Premium": null,
    "Number Of Local Employees": 400,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "No. 8, Liu Zhou Road, High & New Technology Industrial Park",
    "Organization Address":
      "No. 8, Liu Zhou Road, High & New Technology Industrial Park",
    "Investment Permitted Address":
      "Plot No. 42. Myay Taing Block No. 112, Industrial Zone",
  },
  {
    ID: 3599,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lu Yanghang",
    "Name of Principal Organization": "Xinmen Sunsome Industrial Co., Ltd",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Vogue (Myanmar) Industry Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "301/2019",
    "Permit Date": "2019-12-09T09:02:16Z",
    "Meeting Number": "20/2019",
    "Meeting Date": "2019-12-03T09:02:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.789,
    "Total Amount Of Capital (in Millions)": 0.789,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Khine Yadanar Oo",
    "Land Area (units not specified in file)": 3.848,
    "Lease Term": 10,
    "Annual Lease Fee": 210000,
    "Land Use Premium": null,
    "Number Of Local Employees": 614,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "Room 1909, No. 299, Hubin East Road, Siming District ",
    "Organization Address":
      "No. 2 , Factory Building 5/F-3, No.8 Xiayang Road, Xiayang Street",
    "Investment Permitted Address":
      "Plot no. 25, Myay Taing Block No. 112, Industrial Zone",
  },
  {
    ID: 3603,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Daw Sandar Tun",
    "Name of Principal Organization":
      "Shwe Taung Junction City Development Co., Ltd.",
    "Place of Incorporation": "Yangon",
    "Company Name In Myanmar": "City Square Commercial Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "214/2019",
    "Permit Date": "2019-12-16T03:22:27Z",
    "Meeting Number": "19/2019",
    "Meeting Date": "2019-11-29T03:22:36Z",
    Sector: "Real Estate",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 149.28,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Yangon City Development Comittee",
    "Land Area (units not specified in file)": 103586,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 352,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "Ahlone Tower, River View Garden Housing, Strand Road, Alone Township, Yangon.",
    "Organization Address": "No. 584, Strand Road, Lamadaw Township, Yangon",
    "Investment Permitted Address":
      "Corner of Bo Gyoke Aung San Road and Shwe Dagon Pagoda Road, Pabedan Township, Yangon Region",
  },
  {
    ID: 3604,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "MR. ZHAO, XUEFU",
    "Name of Principal Organization":
      "FAR EAST INTERNATIONAL TRADING SHARES LIMITED",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "MYANMAR WAN LI GARMENT LIMITED",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "170/2019",
    "Permit Date": "2019-11-27T03:50:29Z",
    "Meeting Number": "18/2019",
    "Meeting Date": "2019-11-16T03:50:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF VARIOUS KINDS OF KNITTED WEAR            ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 15,
    "Total Amount Of Capital (in Millions)": 15,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Yangon W P Company Limited",
    "Land Area (units not specified in file)": 2.345,
    "Lease Term": 30,
    "Annual Lease Fee": 24,
    "Land Use Premium": null,
    "Number Of Local Employees": 1000,
    "Number Of Foreign Employees": 20,
    Status: "Submitted",
    "Investor Address":
      "NO.(49), (2) NIU QIAO, SHI JU JIAO, LINHU, SUZHAOU DU, JIANGSU DISTRICT, CHINA",
    "Organization Address":
      "ROOM (D-10/F), 1 WANG KWONG, TOWER A BILLION CTR, KOWLOON BAY KL, HONG KONG",
    "Investment Permitted Address":
      "PLOT NO.46, MYAUNG TAKAR THANMANI INDUSTRIAL ZONE, HMAWBI TOWNSHIP, YANGON REGION",
  },
  {
    ID: 3605,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "ဦးကျော်လာ",
    "Name of Principal Organization":
      "ASIA GLORY INTERNATIONAL COMPANY LIMITED",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "ASIA GLORY INTERNATIONAL COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "219/2019",
    "Permit Date": "2019-12-14T03:52:55Z",
    "Meeting Number": "20-2019",
    "Meeting Date": "2019-12-14T03:53:33Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING AND SALES OF PAPER PULP",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 10087.5,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Tin Win, U Maung Myint ",
    "Land Area (units not specified in file)": 4.47,
    "Lease Term": 20,
    "Annual Lease Fee": 40,
    "Land Use Premium": null,
    "Number Of Local Employees": 63,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address":
      "အမှတ်- မ/၁(၃-စ)၊ ၆၄ လမ်း၊ ၄၃ လမ်းနှင့် သိပ္ပံလမ်းကြား၊ မန္တလေးမြို့",
    "Organization Address":
      "မြေကွက်အမှတ်- ၂၅၃၊ ၂၅၄၊ ၂၅၅၊ ရတနာလမ်း၊ မြောင်းတကာသံမဏိ စက်မှုဇုန်၊ မှော်ဘီမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်- ၂၅၃၊ ၂၅၄၊ ၂၅၅၊ ရတနာလမ်း၊ မြောင်းတကာသံမဏိ စက်မှုဇုန်၊ မှော်ဘီမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 3606,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Tin Nyein",
    "Name of Principal Organization": "Shwe Sin La Min Company Limited",
    "Place of Incorporation": "Yangon",
    "Company Name In Myanmar": "Shwe Sin La Min Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "204/2019",
    "Permit Date": "2019-10-25T04:31:52Z",
    "Meeting Number": "14/2019",
    "Meeting Date": "2019-08-30T04:32:06Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Construction and Leasing of Business Center and Shop Houses",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 13660,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Ministry of Home Affair",
    "Land Area (units not specified in file)": 1.83,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 56,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address": "No.62, First Road, Ward 4, Pyapon",
    "Organization Address":
      "Room 808, No.25, Yuzana Business Tower, Dhammazedi Road, Sanchaung Township, Yangon",
    "Investment Permitted Address":
      "Plot No. 1(E), Myay Taing Block No. 37(F). Corner of Hanthawady Road and Kyun Taw Road, Drup Elimination Museum Compound, Kamaryut Township, Yangon Region.",
  },
  {
    ID: 3607,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kuok khoon Ean",
    "Name of Principal Organization": "Kuok (Singapore)Limited ",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Trader Hotel ",
    "Financial Year From": 1994,
    "Financial Year To": 1995,
    "Permit Number": "100/94",
    "Permit Date": "1994-03-26T07:14:27Z",
    "Meeting Number": "6/1994",
    "Meeting Date": "1994-03-16T07:14:52Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotels and Tourism Services ",
    "Amount Of Foreign Capital USD (in Millions)": 50,
    "Total Amount Of Capital (in Millions)": 300,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Directorate of Hotels and Toursim ",
    "Land Area (units not specified in file)": 0.8,
    "Lease Term": 50,
    "Annual Lease Fee": 2.2,
    "Land Use Premium": null,
    "Number Of Local Employees": 484,
    "Number Of Foreign Employees": 17,
    Status: "Submitted",
    "Investor Address":
      "B1K 11 Nathan Road #24-02 Regency Park ,Singapore  1024",
    "Organization Address":
      "P.O. BOX 1714, 13& 15, Carpenter Street, Singapore  0105",
    "Investment Permitted Address":
      "At the Junction of Sule  Pagoda Road and Bogyoke Aung San Road ",
  },
  {
    ID: 3608,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ha Kwok Ping",
    "Name of Principal Organization":
      "Ka Hung (Myanmar) Leather Glove Company Limited",
    "Place of Incorporation": "",
    "Company Name In Myanmar":
      "Ka Hung (Myanmar) Leather Glove Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "302/2019",
    "Permit Date": "2019-12-13T03:44:27Z",
    "Meeting Number": "20/2019",
    "Meeting Date": "2019-12-03T03:45:54Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Gloves on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.2,
    "Total Amount Of Capital (in Millions)": 1.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myo Kyi , Daw Tin Tin Myint",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 10,
    "Annual Lease Fee": 66,
    "Land Use Premium": null,
    "Number Of Local Employees": 500,
    "Number Of Foreign Employees": 8,
    Status: "Draft",
    "Investor Address": "Floor 37, 15Chong Yip Street",
    "Organization Address":
      "Plot no. 55, Myay Taing Block no. 25, Shwe Lin Ban Set Hmu Myo",
    "Investment Permitted Address":
      "Plot no. 55, Myay Taing Block no. 25, Shwe Lin Ban Set Hmu Myo",
  },
  {
    ID: 3609,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Gao Chang Li",
    "Name of Principal Organization": "Hui Zhou Dehong Technology Co., Ltd",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Dehong Technology (Myanmar) Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "303/2019",
    "Permit Date": "2019-12-13T05:34:12Z",
    "Meeting Number": "20/2019",
    "Meeting Date": "2019-12-03T05:37:51Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Signal Cable on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3,
    "Total Amount Of Capital (in Millions)": 3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Kyu Kyu Hlaing@ Daw Kay Thi Aung",
    "Land Area (units not specified in file)": 1.132,
    "Lease Term": 10,
    "Annual Lease Fee": 24,
    "Land Use Premium": null,
    "Number Of Local Employees": 1195,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "Shangdong Province, Linyi City",
    "Organization Address": "Shandong Province, Linyi City ",
    "Investment Permitted Address":
      "Plot No. 42, Myay Taing Block no. 112, Industrial Zone,",
  },
  {
    ID: 3610,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Huang, Xin",
    "Name of Principal Organization":
      "Hongkong Zhengxin Int'l Trading Co., Ltd",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Myanmar zhengxin Footwear Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "304/2019",
    "Permit Date": "2019-12-13T07:38:35Z",
    "Meeting Number": "20/2019",
    "Meeting Date": "2019-12-03T07:38:51Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Footwear on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.05,
    "Total Amount Of Capital (in Millions)": 1.05,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Zaw Latt, U Zaw Myo Htet, U Kyaw Min Htun",
    "Land Area (units not specified in file)": 2.6,
    "Lease Term": 10,
    "Annual Lease Fee": 279450,
    "Land Use Premium": null,
    "Number Of Local Employees": 452,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "Yangguan Road, Industrial PArk Longyang",
    "Organization Address": "No.165-171, Flat 1506, 15/F Lucky Center",
    "Investment Permitted Address":
      "Plot no. 143, Myay Taing Block No. 49, War Ta Yar Set Hmu",
  },
  {
    ID: 3611,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Square Development Company Limited",
    "Name of Principal Organization": "Square Development Company Limited",
    "Place of Incorporation": "Yangon",
    "Company Name In Myanmar": "Square Development Company Limited",
    "Financial Year From": 2018,
    "Financial Year To": 2019,
    "Permit Number": "161/2019",
    "Permit Date": "2019-08-08T07:57:37Z",
    "Meeting Number": "12/2019",
    "Meeting Date": "2019-07-31T07:57:46Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Selling, Leasing and Management of Office And Residential Buildings and Units Comprising Crystal Tower and Crystal Residences",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 100693.85,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Square Development Company Limited",
    "Land Area (units not specified in file)": 1.25,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 59,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "Ahlone Tower, River View Garden Housing, Strand Road, Sin Min Quarter, Ahlone Township, Yangon",
    "Organization Address":
      "Ahlone Tower, River View Garden Housing, Strand Road, Sin Min Quarter, Ahlone Township, Yangon",
    "Investment Permitted Address":
      "No.1F(A)/1B+1G(b)B+1D(3)B, Myay Taing Block No. 37(G), Between Pyay Road and Kyun Taw Road, Kamayut Townshi, Yangon",
  },
  {
    ID: 3613,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lyu Zhiqiang",
    "Name of Principal Organization": "Sunling (Myanmar) Company limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Sunlong (Myanmar) Sports Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "305/2019",
    "Permit Date": "2019-12-11T03:41:32Z",
    "Meeting Number": "20/2019",
    "Meeting Date": "2019-12-03T03:41:46Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.2,
    "Total Amount Of Capital (in Millions)": 1.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw May Gyee Taung",
    "Land Area (units not specified in file)": 0.838,
    "Lease Term": 5,
    "Annual Lease Fee": 24,
    "Land Use Premium": null,
    "Number Of Local Employees": 700,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "No. 37, Jiyuan Nanli, Xiamen City",
    "Organization Address":
      "Plot No. 123/A, Myay Taing Block No. 51, Thar Du Kan Industrial Zone",
    "Investment Permitted Address":
      "Plot No. 123/A, Myay Taing Block No. 51, Thar Du Kan Industrial Zone",
  },
  {
    ID: 3615,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mrs. Wang Xueqin",
    "Name of Principal Organization": "Zhejiang Jiaxin Silk Company Limited",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "JIa Xin (Myanmar) Garment Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "306/2019",
    "Permit Date": "2019-12-11T04:17:57Z",
    "Meeting Number": "20/2019",
    "Meeting Date": "2019-12-03T04:18:09Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3.5,
    "Total Amount Of Capital (in Millions)": 3.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Wai Wai",
    "Land Area (units not specified in file)": 2.4,
    "Lease Term": 20,
    "Annual Lease Fee": 24,
    "Land Use Premium": null,
    "Number Of Local Employees": 1200,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "Room no. 201, Building 17, Jiaheyuan, Jiaye Sunshine City",
    "Organization Address": "No. 588, Central West Road, ",
    "Investment Permitted Address":
      "Plot No. 109, Myay Taing BLock No. 49, War Ta Yar Wood Base",
  },
  {
    ID: 3616,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Hu Xiang",
    "Name of Principal Organization": "Corolado Outdoor Gear (HK) Co., ltd",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Colorado Outdoor Gear (Myanmar) Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "307/2019",
    "Permit Date": "2019-12-11T04:59:08Z",
    "Meeting Number": "20/2019",
    "Meeting Date": "2019-12-03T04:59:16Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.16,
    "Total Amount Of Capital (in Millions)": 1.16,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Sai Win Tun , U Zaw Myo Htet",
    "Land Area (units not specified in file)": 3.945,
    "Lease Term": 10,
    "Annual Lease Fee": 285672,
    "Land Use Premium": null,
    "Number Of Local Employees": 800,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "No. 118. Block NO. 2, Building 1, Shane East Road 5A",
    "Organization Address": "RM 1902, Easy Comm. Bldg 253-261",
    "Investment Permitted Address":
      "Plot no. (A-5) , Myay Taing Block no. 21, Mya Sein Yaung Industrial Zone",
  },
  {
    ID: 3618,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Min Swe Hlaing ",
    "Name of Principal Organization": "Shwe Gon Development Group Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Shwe Gon Development Group Co., Ltd.",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "202/2019",
    "Permit Date": "2019-10-25T05:52:02Z",
    "Meeting Number": "17/2019",
    "Meeting Date": "2019-10-21T05:52:31Z",
    Sector: "Real Estate",
    "Type Of Investment Business":
      "Construction, Leasing and Management of Residential , Services  Apartment , Office and Commercial Complex ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 83197,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "BOT,MCI",
    "Land Owner": "Ministry of Defense ",
    "Land Area (units not specified in file)": 4.001,
    "Lease Term": 50,
    "Annual Lease Fee": 9,
    "Land Use Premium": 2.5,
    "Number Of Local Employees": 35,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "Building (16), Room (3-01), MICT Park , Hlaing Campus",
    "Organization Address":
      "Building (16), Room (3-01), MICT Park , Hlaing Campus",
    "Investment Permitted Address":
      "Plot No. (1,2,3,3A,4,4A,5,6,7,8,20), Myay Taing Block No (51), Corner of Shwe Gon  Daing Road and Link Road , ",
  },
  {
    ID: 3619,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Malaysia",
    "Name of Principal Organization": "Range Pharma SDN.BHD",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Range Veterinary Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "207/2019",
    "Permit Date": "2018-11-27T07:28:01Z",
    "Meeting Number": "18/2019",
    "Meeting Date": "2019-11-16T07:28:26Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "တိရစ္ဆာန်များ၏ ကျန်းမာရေး အထောက်အကူပြုအားဆေးနှင့် ဆေးဝါးအမျိုးမျိုး ထုတ်လုပ်ခြင်းနှင့် ရောင်းချခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 0.935,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Malaysia",
    "Form Of Investment": "FDII",
    "Land Owner": "ဒေါ်စန်းကြည်၊ ဒေါ်အေးအေးမေ",
    "Land Area (units not specified in file)": 4519.147,
    "Lease Term": 50,
    "Annual Lease Fee": 60000,
    "Land Use Premium": null,
    "Number Of Local Employees": 46,
    "Number Of Foreign Employees": 0,
    Status: "Approved",
    "Investor Address": "25, Jalan Pju 1A/54, Petaling Jaya, Selangor, Malasia",
    "Organization Address": "",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်-၁၅၉၊ မြို့ဝန်ဦးအောင်သူလမ်း၊ စက်မှုဇုန်-၂၊ လှိုင်သာယာမြို့နယ်၊ ရနကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 3621,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Jurgen Eckmann",
    "Name of Principal Organization": "Outskin Sportswear Myanmar Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Outskin Sportswear Myanmar Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "308/2019",
    "Permit Date": "2019-12-27T04:40:46Z",
    "Meeting Number": "21/2019",
    "Meeting Date": "2019-12-18T04:40:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of All Kinds of Sportswear on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.54,
    "Total Amount Of Capital (in Millions)": 1.54,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Owne Owne Myint",
    "Land Area (units not specified in file)": 0.867,
    "Lease Term": 5,
    "Annual Lease Fee": 200000,
    "Land Use Premium": null,
    "Number Of Local Employees": 140,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address": "3232 4th Street, Boulding Colorado, USA 80304",
    "Organization Address":
      "Unit 1,Level 8, Uniteam Marine Office Building. No. 84, Pan Hlaing Street",
    "Investment Permitted Address":
      "Plot No. (149/5, 149/6), Myay Taing Block no. 113, ",
  },
  {
    ID: 3622,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Qiao Liang",
    "Name of Principal Organization": "Handa Industries Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Heng Mao(Myanmar) Garment Co., Ltd",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "309/2019",
    "Permit Date": "2019-12-27T05:27:29Z",
    "Meeting Number": "21/2019",
    "Meeting Date": "2019-12-13T05:27:43Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.05,
    "Total Amount Of Capital (in Millions)": 4.05,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Tun @ Mg Khway , Daw San San Yee",
    "Land Area (units not specified in file)": 2.532,
    "Lease Term": 10,
    "Annual Lease Fee": 1000,
    "Land Use Premium": null,
    "Number Of Local Employees": 1100,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "No. 57, Dongyuan New Residence, Xishan District",
    "Organization Address":
      "Flat/RM 318, 3/F Conoc Investmeny Building, 13 Hok Yuen Street",
    "Investment Permitted Address":
      "Plot no. 93, Myay Taing Block no. 14, Shwe Than Lwin Industrial Zone",
  },
  {
    ID: 3623,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhuang Junyu",
    "Name of Principal Organization":
      "Nan Jing Mayfair Textiles Imp. & Exp. Co., Ltd",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Mayfair (Myanmar) Industry Co., Ltd",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "310/2019",
    "Permit Date": "2019-12-27T06:12:40Z",
    "Meeting Number": "21/2019",
    "Meeting Date": "2019-12-13T06:12:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.268,
    "Total Amount Of Capital (in Millions)": 1.268,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Yin Aung",
    "Land Area (units not specified in file)": 2.619,
    "Lease Term": 16,
    "Annual Lease Fee": 93600,
    "Land Use Premium": null,
    "Number Of Local Employees": 1996,
    "Number Of Foreign Employees": 8,
    Status: "Draft",
    "Investor Address":
      "Room-2, Building 137, Fudilangxiang Villa, Molingstreet, Jinagning District",
    "Organization Address":
      "21/F, Building 02, Changfa Center, No. 300, East Zhongshan Road",
    "Investment Permitted Address":
      "Plot No. 119, Myay Taing Block NO. Industrial Zone 2",
  },
  {
    ID: 3624,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhang Jinsuo",
    "Name of Principal Organization":
      "G-Yuan Packaging Material (Myanmar) Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "G-Yuan Packaging Material (Myanmar) Company LImited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "311/2019",
    "Permit Date": "2019-12-27T07:41:38Z",
    "Meeting Number": "21/2019",
    "Meeting Date": "2019-12-13T07:42:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Carton Boxes for Local CMP Enterprises",
    "Amount Of Foreign Capital USD (in Millions)": 2.752,
    "Total Amount Of Capital (in Millions)": 2.752,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Win Tin",
    "Land Area (units not specified in file)": 6.803,
    "Lease Term": 10,
    "Annual Lease Fee": 391500,
    "Land Use Premium": null,
    "Number Of Local Employees": 354,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "Jiang Zongxi, Room 604, Building 3, Jingxiang Huayuan, Yangshe Town",
    "Organization Address":
      "Plot No. 63,64, Myay Taing Block no. 49, Wartayar Industrial Zone",
    "Investment Permitted Address":
      "Plot No. 63,64, Myay Taing Block no. 49, Wartayar Industrial Zone",
  },
  {
    ID: 3625,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Fang Chongduo",
    "Name of Principal Organization":
      "Wenzhou Mianya Import and Export Company Limited",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Xin Fa (Myanmar) Textile Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "312/2019",
    "Permit Date": "2019-12-27T09:26:12Z",
    "Meeting Number": "21/2019",
    "Meeting Date": "2019-12-13T09:26:24Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Cotton Yarn for Local CMP Enterprises",
    "Amount Of Foreign Capital USD (in Millions)": 0.757,
    "Total Amount Of Capital (in Millions)": 0.757,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Kyaw Min",
    "Land Area (units not specified in file)": 1.936,
    "Lease Term": 5,
    "Annual Lease Fee": 420,
    "Land Use Premium": null,
    "Number Of Local Employees": 70,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address":
      "Room 422, Wenzhou City Two Gifts, C-D District, Longgang Town, Cangnan County",
    "Organization Address":
      "Room 422, Wenzhou City Two Gifts, C-D District, Longgang Town, Cangnan County",
    "Investment Permitted Address": "Plot no. 91, Myay Taing Block No. ",
  },
  {
    ID: 3626,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wong Kwan Tat",
    "Name of Principal Organization": "Wick PTE Limited",
    "Place of Incorporation": "Singapore",
    "Company Name In Myanmar": "Wick (Myanmar) Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "313/2019",
    "Permit Date": "2019-12-27T03:30:25Z",
    "Meeting Number": "21/2019",
    "Meeting Date": "2019-12-13T03:30:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Plastic Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "U Lin Hu Yan @ U Tin Htun",
    "Land Area (units not specified in file)": 2.39,
    "Lease Term": 6,
    "Annual Lease Fee": 48360,
    "Land Use Premium": null,
    "Number Of Local Employees": 1016,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "Flat 50 A, 50/ F, Block 1, 1Tong Tak Street, Tseung Kwan O Plaza",
    "Organization Address":
      "18 Kaki Bukiit Road, 3# 02-01, Enrepreneur Business Center",
    "Investment Permitted Address":
      "Plot no. D-4, Myay Taing Block no. 20, A Naw Ya Htar Industrial Zone",
  },
  {
    ID: 3628,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Li Ming",
    "Name of Principal Organization": "Myanmar Eason Lee Company Limited",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Myanmar Eason Lee Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "314/2019",
    "Permit Date": "2019-12-27T08:24:26Z",
    "Meeting Number": "21/2019",
    "Meeting Date": "2019-12-13T08:24:41Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.664,
    "Total Amount Of Capital (in Millions)": 1.664,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myint Soe , Daw Than Than Su",
    "Land Area (units not specified in file)": 2.651,
    "Lease Term": 10,
    "Annual Lease Fee": 180,
    "Land Use Premium": null,
    "Number Of Local Employees": 1000,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "H Building 1505, Pingbu Avenue, Guang Zhou City, Yabao New city",
    "Organization Address":
      "Plot No. K9, Myay Taing Block bo. 20, Anawyahtar Industrial Zone",
    "Investment Permitted Address":
      "Plot No. K9, Myay Taing Block bo. 20, Anawyahtar Industrial Zone",
  },
  {
    ID: 3629,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wang Bizhong",
    "Name of Principal Organization": "Texpack International Limited ",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Texpack MAnufacturing (Myanmar) Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "315/2019",
    "Permit Date": "2019-12-27T08:49:45Z",
    "Meeting Number": "21/2019",
    "Meeting Date": "2019-12-13T08:49:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Cushion, Mattress, Mat, Pillow and Accessories on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.101,
    "Total Amount Of Capital (in Millions)": 1.101,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 26,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Yin Yin Win",
    "Land Area (units not specified in file)": 4.199,
    "Lease Term": 6,
    "Annual Lease Fee": 72000,
    "Land Use Premium": null,
    "Number Of Local Employees": 1045,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "No. 1, Jilong West Road, dalong Village, Shiji Town ",
    "Organization Address": "RM D-10/F, Tower A , Billion CTR, 1 Wang Kwong rd",
    "Investment Permitted Address":
      "Plot no. 45, Myay Taing Block no. 65, Set Hmue",
  },
  {
    ID: 3630,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Pham Anh Tuan",
    "Name of Principal Organization": "Han Viet Company Limited",
    "Place of Incorporation": "Vietnam",
    "Company Name In Myanmar": "Hanvico International Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "316/2019",
    "Permit Date": "2019-12-27T04:13:40Z",
    "Meeting Number": "21/2019",
    "Meeting Date": "2019-12-13T04:14:01Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Mattress, Accessories of Bedroom Linen and Bathroom Linen",
    "Amount Of Foreign Capital USD (in Millions)": 3,
    "Total Amount Of Capital (in Millions)": 3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Tin Soe , U Tun Tun Aung",
    "Land Area (units not specified in file)": 1.5,
    "Lease Term": 50,
    "Annual Lease Fee": 96,
    "Land Use Premium": null,
    "Number Of Local Employees": 80,
    "Number Of Foreign Employees": 6,
    Status: "Draft",
    "Investor Address": "DN-1, CT-5, Hoang Mai District",
    "Organization Address": "No. 1 (A), KM 14 Road,",
    "Investment Permitted Address": "Plot No. 99, Myay Taing Block No. Zone 2",
  },
  {
    ID: 3631,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhou Xin",
    "Name of Principal Organization":
      "Anhui Xinlin Import and Export Trade (Group) Co., Ltd",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Xinda Home Textile (Myanmar) Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "317/2019",
    "Permit Date": "2019-12-27T04:43:53Z",
    "Meeting Number": "21/2019",
    "Meeting Date": "2019-12-13T04:45:29Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bed Accessories on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.5,
    "Total Amount Of Capital (in Millions)": 4.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 28,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Min Thein , Daw Nan War @ Daw Than Than Sint",
    "Land Area (units not specified in file)": 2.52,
    "Lease Term": 8,
    "Annual Lease Fee": 96,
    "Land Use Premium": null,
    "Number Of Local Employees": 400,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "Room 101, Flat-2, Yanyuan, Nantong City",
    "Organization Address": "No. 14-3, Jiadachuangzhi Logistics Park Suma Park",
    "Investment Permitted Address":
      "Plot No. (140/ka, 140/Kha , 140/ Ga, 140/ Sa ) , Myay Taing Block no. 42/Set H mue",
  },
  {
    ID: 3632,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhou Hong Liang",
    "Name of Principal Organization": "Myanka Garment Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Myanka Garment Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "318/2019",
    "Permit Date": "2019-12-27T08:03:43Z",
    "Meeting Number": "21/2019",
    "Meeting Date": "2019-12-13T08:04:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.311,
    "Total Amount Of Capital (in Millions)": 2.311,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Phyu Phyu Win @ Hong Phay Kyin",
    "Land Area (units not specified in file)": 2.429,
    "Lease Term": 8,
    "Annual Lease Fee": 82.56,
    "Land Use Premium": null,
    "Number Of Local Employees": 807,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "No. 5, Group 17, Guo Yuan Neignborhood Committee Changjiang Town",
    "Organization Address":
      "Plot no. 23, Myay Taing Block no. 112, Industrial Zone",
    "Investment Permitted Address":
      "Plot no. 23, Myay Taing Block no. 112, Industrial Zone",
  },
  {
    ID: 3633,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Tan Song Shui",
    "Name of Principal Organization": "Lippotex Industries SDN. BHD ",
    "Place of Incorporation": "Malaysia",
    "Company Name In Myanmar": "Worker Appparel Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "319/2019",
    "Permit Date": "2019-12-27T08:43:17Z",
    "Meeting Number": "21/2019",
    "Meeting Date": "2019-12-13T08:43:27Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.25,
    "Total Amount Of Capital (in Millions)": 0.25,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "K & M Capital Co., Ltd",
    "Land Area (units not specified in file)": 0.2,
    "Lease Term": 5,
    "Annual Lease Fee": 35.37,
    "Land Use Premium": null,
    "Number Of Local Employees": 38,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address": "No. 98, Jalan Tembikai Taman Mutiara",
    "Organization Address": "No. 2678, MK 15, Jalan Seladan Alma ",
    "Investment Permitted Address":
      "Unit (B-009), Skytech Industrial Park, Plot no. 8, Myay Taing Block no. 143/1",
  },
  {
    ID: 3634,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Xiao Xiangwu",
    "Name of Principal Organization": "Hong Kong Jin Sen Ltd",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Jin Sen Myanmar Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "320/2019",
    "Permit Date": "2019-12-27T09:43:26Z",
    "Meeting Number": "21/2019",
    "Meeting Date": "2019-12-13T09:43:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags and Bag's Strings on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.936,
    "Total Amount Of Capital (in Millions)": 0.936,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Lee Shin Fein",
    "Land Area (units not specified in file)": 1.429,
    "Lease Term": 10,
    "Annual Lease Fee": 60,
    "Land Use Premium": null,
    "Number Of Local Employees": 436,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "Chashan Town, Subin Industrial Area",
    "Organization Address": "RM 1502-A,Easy Comm Bldg, 253-261",
    "Investment Permitted Address":
      "Plot no. (154,171) , Myay Taing Block Part (5) , Sethmu Myo ",
  },
  {
    ID: 3636,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kong Ling Qiang",
    "Name of Principal Organization": "Bondsin Metal (Myanmar) Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Bondsin Metal (Myanmar) Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "321/2019",
    "Permit Date": "2019-12-27T03:45:30Z",
    "Meeting Number": "21/2019",
    "Meeting Date": "2019-12-13T03:45:40Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Production and Export of Steel Tube and Aluminium Profile",
    "Amount Of Foreign Capital USD (in Millions)": 4.004,
    "Total Amount Of Capital (in Millions)": 4.004,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Great Shwe Taung Development Co., Ltd",
    "Land Area (units not specified in file)": 5.225,
    "Lease Term": 50,
    "Annual Lease Fee": 40754987.5,
    "Land Use Premium": null,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "C7- 506, Aocheng Commercial Plaza, Binshui West road",
    "Organization Address":
      "Plot no. E-2, Myay Taing Block no. 21, Mya Sein Yaung Industrial Zone(3)",
    "Investment Permitted Address":
      "Plot no. E-2, Myay Taing Block no. 21, Mya Sein Yaung Industrial Zone(3)",
  },
  {
    ID: 3637,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Gao Liming ",
    "Name of Principal Organization":
      "Sinoma (Handan) Construction Company Limited",
    "Place of Incorporation": "China",
    "Company Name In Myanmar":
      "Handan Sinoma Engineering and Construction (Myanmar) Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "322/2020",
    "Permit Date": "2020-01-27T07:15:11Z",
    "Meeting Number": "1/2020",
    "Meeting Date": "2020-01-22T07:15:37Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Structural Metal Products ",
    "Amount Of Foreign Capital USD (in Millions)": 2.156,
    "Total Amount Of Capital (in Millions)": 2.156,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Shwe Htoo",
    "Land Area (units not specified in file)": 11.28,
    "Lease Term": 50,
    "Annual Lease Fee": 40.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 98,
    "Number Of Foreign Employees": 13,
    Status: "Draft",
    "Investor Address": "No.87, Jianshe Street",
    "Organization Address": "Jianshe Street",
    "Investment Permitted Address":
      "Plot no. 18,19,20,21,22,23, Myay Taing Block no. A Nant Zone A Nee ( Dala Ban) ",
  },
  {
    ID: 3638,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wang Xiaocheng",
    "Name of Principal Organization": "Weihai Shiny Star Clothing Co., Ltd",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Myanmar Bestex Garment Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "323/2020",
    "Permit Date": "2020-01-27T07:42:23Z",
    "Meeting Number": "1/2020",
    "Meeting Date": "2020-01-22T07:42:32Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.92,
    "Total Amount Of Capital (in Millions)": 0.92,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 35,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Thein Win",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 15,
    "Annual Lease Fee": 180,
    "Land Use Premium": null,
    "Number Of Local Employees": 504,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address": "No. 5, Longzhuanggou Village, Facheng Town",
    "Organization Address":
      "No.1011, No. 96, Qingdao Middle Road, Economic and Technological Development Zone",
    "Investment Permitted Address":
      "Plot no. 117, Myay Taing Block no. 14, Shwe Than Lwin Industrial Zone",
  },
  {
    ID: 3639,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kai William",
    "Name of Principal Organization": "Elisa (Myanmar) Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Elisa (Myanmar) Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "324/2020",
    "Permit Date": "2020-01-27T08:24:50Z",
    "Meeting Number": "1/2020",
    "Meeting Date": "2020-01-22T08:25:24Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.773,
    "Total Amount Of Capital (in Millions)": 0.773,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Kyaw Than",
    "Land Area (units not specified in file)": 0.93,
    "Lease Term": 10,
    "Annual Lease Fee": 54,
    "Land Use Premium": null,
    "Number Of Local Employees": 104,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "Room 3109,The Metropolis Residence Tower 1, Metropolis Drive",
    "Organization Address": "Plot No. 29, Myay Taing Block No. 112, ",
    "Investment Permitted Address": "Plot No. 29, Myay Taing Block No. 112",
  },
  {
    ID: 3640,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Du Yuan Jiang",
    "Name of Principal Organization": "Hengan Luggage Industry Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Hengan Luggage Industry Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "325/2020",
    "Permit Date": "2020-01-27T09:11:42Z",
    "Meeting Number": "1/2020",
    "Meeting Date": "2020-01-22T09:12:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 26,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner":
      "U Myo Nyunt @ Shar Pway Tate, U Ye' Lwin @ T Kyin Ywat, U Nay Lin @ Boe Too , U Kyaw Htoo @ Kyaw Khin",
    "Land Area (units not specified in file)": 2.007,
    "Lease Term": 6,
    "Annual Lease Fee": 123123.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 630,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "No. 159, Room 404, Building 3, Futian Road, Fengze District",
    "Organization Address": "Plot no.40, Myay Taing Block no. 65 (Set Hmue) ",
    "Investment Permitted Address":
      "Plot no.40, Myay Taing Block no. 65 (Set Hmue) ",
  },
  {
    ID: 3641,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Li Qiaosheng",
    "Name of Principal Organization":
      "Mingzhi Sports Equipment (China) Co., Ltd",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Mingshang sports Myanmar Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "326/2020",
    "Permit Date": "2020-01-27T04:15:08Z",
    "Meeting Number": "1/2020",
    "Meeting Date": "2020-01-22T04:15:26Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Varieties of Footwear Pon CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.7,
    "Total Amount Of Capital (in Millions)": 4.7,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Kyi Thar Win Pyae",
    "Land Area (units not specified in file)": 5.667,
    "Lease Term": 50,
    "Annual Lease Fee": 41280.372,
    "Land Use Premium": null,
    "Number Of Local Employees": 1191,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "No. 331, Xindian Industrial Zone, Chidian Town",
    "Organization Address": "No. 331, Xindian Industrial Zone, Chidian Town",
    "Investment Permitted Address":
      "Plot no. 13, Myay Taing Block no. 143/1, Kyansittthar Yeik Mon Sethmyu Zone Part (2) ",
  },
  {
    ID: 3642,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Xu Bo",
    "Name of Principal Organization": "Great Craft and Gift (Myanmar) Co., Ltd",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Great Craft and Gift (Myanmar) Co., Ltd",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "327/2020",
    "Permit Date": "2020-01-27T06:52:20Z",
    "Meeting Number": "1/2020",
    "Meeting Date": "2020-01-22T06:52:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Seasonal Decorations and Gifts on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.068,
    "Total Amount Of Capital (in Millions)": 1.068,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Tin Tin Owne",
    "Land Area (units not specified in file)": 1.718,
    "Lease Term": 10,
    "Annual Lease Fee": 84000,
    "Land Use Premium": null,
    "Number Of Local Employees": 312,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "402# No. 4, BLDG, Shijing Industrial Zone, Pingkui Road, Shijing Community, Shijing Street",
    "Organization Address": "Plot no. 130, Myay Taing Block no. 113",
    "Investment Permitted Address": "Plot no. 130, Myay Taing Block no. 113",
  },
  {
    ID: 3643,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Son Chul Min",
    "Name of Principal Organization": "Inno Industry Co., Ltd",
    "Place of Incorporation": "Korea",
    "Company Name In Myanmar": "Inno Steel Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "328/2020",
    "Permit Date": "2020-01-27T07:18:28Z",
    "Meeting Number": "1/2020",
    "Meeting Date": "2020-01-22T07:18:42Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Fire Proof Door and Frame, Sheet Metal and Architectural Exterior Panel",
    "Amount Of Foreign Capital USD (in Millions)": 4.3,
    "Total Amount Of Capital (in Millions)": 4.3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaw Myint @ U Kyaw Kyee Kyone , Daw Tin Tin Maw",
    "Land Area (units not specified in file)": 2.666,
    "Lease Term": 5,
    "Annual Lease Fee": 557431636,
    "Land Use Premium": null,
    "Number Of Local Employees": 92,
    "Number Of Foreign Employees": 7,
    Status: "Draft",
    "Investor Address":
      "No. 408-1201, Munchon Maeul, Juyeop 2dong, Ilsan Seogu",
    "Organization Address":
      "No.32-12, (4th Floor, 402) , Bangwha- Daero 6MA- Gil",
    "Investment Permitted Address":
      "Plot no. (65+66) , Block no-51, Thardukan Industrial Zone",
  },
  {
    ID: 3644,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Bi Wen Jie",
    "Name of Principal Organization":
      "Zhejiang Native Produce & Animal By-Products I/E Group Company Limited",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "G & B Manufacturing (Myanmar) Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "329/2020",
    "Permit Date": "2020-01-27T08:11:18Z",
    "Meeting Number": "1/2020",
    "Meeting Date": "2020-01-22T08:11:28Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Golden Wax Co., Ltd",
    "Land Area (units not specified in file)": 3.203,
    "Lease Term": 10,
    "Annual Lease Fee": 363.837,
    "Land Use Premium": null,
    "Number Of Local Employees": 1000,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "No. 308, North Zhongshan Road",
    "Organization Address": "No. 308, North Zhongshan Road",
    "Investment Permitted Address":
      "Plot no. 57, Myay Taing Block no. 51, Thardukan Industrial Zone",
  },
  {
    ID: 3645,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhang Yuqiang",
    "Name of Principal Organization":
      "Yixin Leather Products (HK) Company Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Milestone Leatherware Co., Ltd",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "330/2020",
    "Permit Date": "2020-01-27T09:33:09Z",
    "Meeting Number": "1/2020",
    "Meeting Date": "2020-01-22T09:33:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags and Belts on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.219,
    "Total Amount Of Capital (in Millions)": 1.219,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Century Rattan and Furniture Co., Ltd",
    "Land Area (units not specified in file)": 4.5,
    "Lease Term": 10,
    "Annual Lease Fee": 240383.88,
    "Land Use Premium": null,
    "Number Of Local Employees": 824,
    "Number Of Foreign Employees": 7,
    Status: "Draft",
    "Investor Address": "No. 54, Group 8, Xiebutan Village, Anfu Street",
    "Organization Address": "6/F, Commercial Building no. 302, Queen's Road",
    "Investment Permitted Address":
      "Plot no. 198/11, 198/ 14, 198/15, Myay Taing Block no. Industrial Zone (1)",
  },
  {
    ID: 3646,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Liao Shengying",
    "Name of Principal Organization": "Taima Shoes Company Limited",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Taima (Myanmar) Shoes Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "331/2019",
    "Permit Date": "2020-01-27T10:02:09Z",
    "Meeting Number": "1/2020",
    "Meeting Date": "2020-01-22T10:02:20Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufactruing of Various Kinds of Shoes & Semi- Finished Product Goods of Shoes on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3.68,
    "Total Amount Of Capital (in Millions)": 3.68,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Easter",
    "Land Area (units not specified in file)": 4,
    "Lease Term": 5,
    "Annual Lease Fee": 960,
    "Land Use Premium": null,
    "Number Of Local Employees": 1800,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "Room no. 8-1501, Textile Road, Park Land Lucheng District",
    "Organization Address":
      "No. 35, YAnfan Road, Yangyi Subdistrict, Lucheng District",
    "Investment Permitted Address":
      "Plot No. J-1, Myay Taing Block no. 20, Anawyahtar Industrial Zone",
  },
  {
    ID: 3647,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wu Binyou",
    "Name of Principal Organization":
      "Topasia (Myanmar) Handbag Company Limited",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Topasia (Myanmar) Handbag Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "332/2020",
    "Permit Date": "2020-01-27T05:03:01Z",
    "Meeting Number": "1/2020",
    "Meeting Date": "2020-01-22T05:03:11Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaw Zaw",
    "Land Area (units not specified in file)": 0.95,
    "Lease Term": 5,
    "Annual Lease Fee": 240,
    "Land Use Premium": null,
    "Number Of Local Employees": 300,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "No. 383, Wen Tang Middle Road, No. 5 Lian Yi Industrial Building, Dongcheng District",
    "Organization Address":
      "Plot no. 684, Myay Taing Block no. 144, Yoma Yeiktha Industrial Zone",
    "Investment Permitted Address":
      "Plot no. 684, Myay Taing Block no. 144, Yoma Yeiktha Industrial Zone",
  },
  {
    ID: 3648,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Feng Yiwen",
    "Name of Principal Organization": "Pinnacle Sporting Goods Co., Ltd",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Pinnacle Sporting Goods (Myanmar) Co., Ltd",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "333/2020",
    "Permit Date": "2020-01-27T05:07:15Z",
    "Meeting Number": "1/2020",
    "Meeting Date": "2020-01-22T05:07:23Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Sport Bags On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.9,
    "Total Amount Of Capital (in Millions)": 0.9,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Maung Maung Hlaing",
    "Land Area (units not specified in file)": 1.057,
    "Lease Term": 10,
    "Annual Lease Fee": 12552.356,
    "Land Use Premium": null,
    "Number Of Local Employees": 168,
    "Number Of Foreign Employees": 2,
    Status: "Draft",
    "Investor Address": "RM 9-306, #1 Weiye Rd, Dongcheng",
    "Organization Address": "RM 702, 7/F Spa Ctr, No. 53-55, Lockhart Rd",
    "Investment Permitted Address":
      "Plot no. 35, Myay Taing BLock no. 144, Industrial Zone",
  },
  {
    ID: 3649,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Tu Dexin",
    "Name of Principal Organization": "Baisheng Industry Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Baisheng (Myanmar)  Industry Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "334/2020",
    "Permit Date": "2020-01-27T05:11:21Z",
    "Meeting Number": "1/2020",
    "Meeting Date": "2020-01-22T05:11:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Shoes on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.85,
    "Total Amount Of Capital (in Millions)": 2.85,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Soe Hlaing",
    "Land Area (units not specified in file)": 4.6,
    "Lease Term": 10,
    "Annual Lease Fee": 444000000,
    "Land Use Premium": null,
    "Number Of Local Employees": 1000,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "No. 79, Shangfeng Village ",
    "Organization Address":
      "Plot no. (12/A) , Kwin no - 363, Asu Gyi (East), Asu Gyi Village Tract",
    "Investment Permitted Address":
      "Plot no. (12/A) , Kwin no - 363, Asu Gyi (East), Asu Gyi Village Tract",
  },
  {
    ID: 3650,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Thiha",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Ko Ko Toke Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "335/2020",
    "Permit Date": "2020-01-27T05:27:09Z",
    "Meeting Number": "1/2020",
    "Meeting Date": "2020-01-22T05:27:19Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing & Production of Dried Beef on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 110,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Thiha",
    "Land Area (units not specified in file)": 2.193,
    "Lease Term": 5,
    "Annual Lease Fee": 12000000,
    "Land Use Premium": null,
    "Number Of Local Employees": 99,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "Plot no. 170, No. (128/6), 85th Street, (Between 24th street & 25 Street) , Pyi Gyi Kyat Tha Yay West Quarter",
    "Organization Address": "",
    "Investment Permitted Address": "Plot no. 23, Myay Taing Block no. 113,",
  },
  {
    ID: 3651,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Aik Sai",
    "Name of Principal Organization": "",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Diamond Printing (Myanmar) Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "336/2020",
    "Permit Date": "2020-01-27T05:30:41Z",
    "Meeting Number": "1/2020",
    "Meeting Date": "2020-01-22T05:30:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Plastic Bags & Printing on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 4160.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Aik Sai , U Myo Chit",
    "Land Area (units not specified in file)": 3.03,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 121,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address": "No. 30, Gong Nyaung, Nant Lan Village",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot no. 1/30, Myay Taing Block no. Yangon Industrial Zone Extend (1)",
  },
  {
    ID: 3652,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Cao Haidong",
    "Name of Principal Organization":
      "Flare Star Garment Manufacturing Co., Ltd",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Flare Star Garment Manufacturing Co., Ltd",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "337/2020",
    "Permit Date": "2020-01-27T05:33:58Z",
    "Meeting Number": "1/2020",
    "Meeting Date": "2020-01-22T05:34:09Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Garments, Textile And Clothing On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Win Myint @ Gan Son Sein",
    "Land Area (units not specified in file)": 2.007,
    "Lease Term": 30,
    "Annual Lease Fee": 72,
    "Land Use Premium": null,
    "Number Of Local Employees": 944,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "Yihe Garden 6-303 Nantong",
    "Organization Address":
      "Plot no. 41, Myay Taing Block no. 65, Shwe Pyi Thar Industrial Zone(4)",
    "Investment Permitted Address":
      "Plot no. 41, Myay Taing Block no. 65, Shwe Pyi Thar Industrial Zone(4)",
  },
  {
    ID: 3653,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lau Chi Hung",
    "Name of Principal Organization": "Reton Industrial (HK) Co., Ltd",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Reton Industrial (Myanmar) Co., Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "338/2020",
    "Permit Date": "2020-01-27T05:48:42Z",
    "Meeting Number": "1/2020",
    "Meeting Date": "2020-01-22T05:49:49Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.725,
    "Total Amount Of Capital (in Millions)": 0.725,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Than Zaw Htway",
    "Land Area (units not specified in file)": 1.214,
    "Lease Term": 10,
    "Annual Lease Fee": 158.686,
    "Land Use Premium": null,
    "Number Of Local Employees": 450,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "Room 2807, Tower E ",
    "Organization Address": "Room 2007, 16 Wang Hoi Road",
    "Investment Permitted Address":
      "Plot no. 18, Myay Taing Block no. 21, Mya Sein Yaung Industrial Zone",
  },
  {
    ID: 3654,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lin Yi Lai",
    "Name of Principal Organization": "Tian Yu Shoes International Co., Ltd",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Tian Chengs Shoes Co., Ltd",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "339/2020",
    "Permit Date": "2020-01-27T05:54:58Z",
    "Meeting Number": "1/2020",
    "Meeting Date": "2020-01-22T05:55:09Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Shoes on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.921,
    "Total Amount Of Capital (in Millions)": 2.921,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Si Si Tin @ Daw Nyo Nyo Aye",
    "Land Area (units not specified in file)": 1.589,
    "Lease Term": 10,
    "Annual Lease Fee": 19291.38,
    "Land Use Premium": null,
    "Number Of Local Employees": 500,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "582-592, Room no. 1702, Nathan Road, Seno Center",
    "Organization Address": "582-592, Room no. 1702, Nathan Road, Seno Center",
    "Investment Permitted Address":
      "Plot no. 489, Myay Taing Block no. 25, Shwe Lin Ban Set Hmu Myo",
  },
  {
    ID: 3655,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Ye Lwin",
    "Name of Principal Organization":
      "Than Lwin Aye Yar Export Import Co., Ltd",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "My Press Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "340/2020",
    "Permit Date": "2020-01-27T06:39:28Z",
    "Meeting Number": "1/2020",
    "Meeting Date": "2020-01-22T06:39:37Z",
    Sector: "Other Services",
    "Type Of Investment Business": "Printing Services",
    "Amount Of Foreign Capital USD (in Millions)": 2.308,
    "Total Amount Of Capital (in Millions)": 4.711,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "U Ye Lwin",
    "Land Area (units not specified in file)": 3,
    "Lease Term": 30,
    "Annual Lease Fee": 90,
    "Land Use Premium": null,
    "Number Of Local Employees": 66,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "No. (350-354) , Anawyahtar Street ",
    "Organization Address":
      "No. (269/271) , Ground Floor (A-1) , Lower Pazuntaung Road",
    "Investment Permitted Address":
      " Plot no.249, Myay Taing Block no. Part (2), Set Hmu Myo, Hlaing Thar Yar ",
  },
  {
    ID: 3656,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Peng Chengpan",
    "Name of Principal Organization":
      "Long Heng Supply Chain Management Co., Ltd",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Longheng (Myanmar) Enterprise Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "341/2020",
    "Permit Date": "2020-01-27T06:53:44Z",
    "Meeting Number": "1/2020",
    "Meeting Date": "2020-01-22T06:53:55Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.785,
    "Total Amount Of Capital (in Millions)": 2.785,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Amin",
    "Land Area (units not specified in file)": 1.243,
    "Lease Term": 10,
    "Annual Lease Fee": 72000,
    "Land Use Premium": null,
    "Number Of Local Employees": 620,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "No. 169, East road",
    "Organization Address":
      "Flat/ RM , A 20/ F, Kiu Fu Commercial Building. 300 Lockhart Road",
    "Investment Permitted Address": "Plot no. 166, Myay Taing Block no. 113",
  },
  {
    ID: 3657,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhao Dongfen",
    "Name of Principal Organization": "Myanmar Jufeng Bags Company Limited",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Myanmar Jufeng Bags Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "342/2020",
    "Permit Date": "2020-02-19T07:23:22Z",
    "Meeting Number": "2/2020",
    "Meeting Date": "2020-01-29T07:23:41Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.9,
    "Total Amount Of Capital (in Millions)": 0.9,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Thein Htwe @ Nhan Kin Shin",
    "Land Area (units not specified in file)": 1.228,
    "Lease Term": 5,
    "Annual Lease Fee": 11891.51,
    "Land Use Premium": null,
    "Number Of Local Employees": 200,
    "Number Of Foreign Employees": 7,
    Status: "Draft",
    "Investor Address":
      "No. 38, Commercial Second Street , Lingnan Industrial Park, Shiling Town",
    "Organization Address": "Plot no. 122, Myay Taing Block no. 42 (Set Hmu)",
    "Investment Permitted Address":
      "Plot no. 122, Myay Taing Block no. 42 (Set Hmu)",
  },
  {
    ID: 3658,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Maung Maung",
    "Name of Principal Organization": "Myanmar HJ Packaging Company Limited",
    "Place of Incorporation": "Taiwan",
    "Company Name In Myanmar": "Myanmar HJ Packaging Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "343/2020",
    "Permit Date": "2020-02-19T08:03:21Z",
    "Meeting Number": "2/2020",
    "Meeting Date": "2020-01-29T08:03:45Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Selling of Paper Box and Paper Sheet",
    "Amount Of Foreign Capital USD (in Millions)": 0.971,
    "Total Amount Of Capital (in Millions)": 1.942,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "U Maung Maung",
    "Land Area (units not specified in file)": 5,
    "Lease Term": 50,
    "Annual Lease Fee": 144,
    "Land Use Premium": null,
    "Number Of Local Employees": 100,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address": "No. 192, First Floor, Bo Min Yaung Street",
    "Organization Address": "Plot no, 355, Yangon Industrial Zone",
    "Investment Permitted Address": "Plot no, 355, Yangon Industrial Zone",
  },
  {
    ID: 3659,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yu, Chunguang",
    "Name of Principal Organization": "Robinlo Inc",
    "Place of Incorporation": "SamoaAqua ",
    "Company Name In Myanmar": "Aqua Shoes Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "344/2020",
    "Permit Date": "2020-02-19T08:50:39Z",
    "Meeting Number": "2/2020",
    "Meeting Date": "2020-01-29T09:09:02Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Shoes on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.5,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 117,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Myanmar Brilliant Sky Industry Company Limited",
    "Land Area (units not specified in file)": 2.972,
    "Lease Term": 10,
    "Annual Lease Fee": 30068,
    "Land Use Premium": null,
    "Number Of Local Employees": 800,
    "Number Of Foreign Employees": 18,
    Status: "Draft",
    "Investor Address": "Zhon Ying Village, Wang Dian Town",
    "Organization Address": "Vaea Street, Le Sanalele Complex, Ground Floor",
    "Investment Permitted Address":
      "Plot no. 57, Myay Taing Block no. 21, Mya Sein Yaung Industrial Zone",
  },
  {
    ID: 3660,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wu Jianyi",
    "Name of Principal Organization": "Hong Yun (Myanmar) Garment Co., Ltd",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Hong Yun (Myanmar) Garment Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "345/2020",
    "Permit Date": "2020-02-19T09:41:54Z",
    "Meeting Number": "2/2020",
    "Meeting Date": "2020-01-29T09:42:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aye Sein",
    "Land Area (units not specified in file)": 2.427,
    "Lease Term": 5,
    "Annual Lease Fee": 36,
    "Land Use Premium": null,
    "Number Of Local Employees": 300,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "No. 26, Qinglong Port, Danyang City",
    "Organization Address":
      "Plot no. 61,62, Myay Taing Block no. 64 (Sethmue), Industrial Zone (3)",
    "Investment Permitted Address":
      "Plot no. 61,62, Myay Taing Block no. 64 (Sethmue), Industrial Zone (3)",
  },
  {
    ID: 3661,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wang Hua",
    "Name of Principal Organization": "Mynice Optoelectronics Co. Ltd",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar":
      "Mynice Optoelectronics (Myanmar) Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "346/2020",
    "Permit Date": "2020-02-19T09:56:15Z",
    "Meeting Number": "2/2020",
    "Meeting Date": "2020-01-29T09:56:25Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Optoelectronic Devices on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Tun Tun Aye",
    "Land Area (units not specified in file)": 0.383,
    "Lease Term": 5,
    "Annual Lease Fee": 82800000,
    "Land Use Premium": null,
    "Number Of Local Employees": 256,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "Room 21B, Unit 1, Building A, No. 149, Qinghui Longgang District, Zhonghai , Kangcheng Garden",
    "Organization Address":
      "Room 11, 27th Floor K.wah International Centre 191",
    "Investment Permitted Address":
      "Plot no. (86-KA), Myay Taing Block no. 25, Shwe Linn Ban Sethmu Myo",
  },
  {
    ID: 3662,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Li JIngqiang",
    "Name of Principal Organization":
      "Gold Marcati (Myanmar) Optics Manufacture Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "Gold Marcati (Myanmar) Optics Manufacture Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "347/2020",
    "Permit Date": "2020-02-19T03:40:03Z",
    "Meeting Number": "2/2020",
    "Meeting Date": "2020-01-29T03:40:19Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Eye Glasses Frames and Boxes on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3.51,
    "Total Amount Of Capital (in Millions)": 3.51,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Ye Lwin Tint , Daw Su Su Hlaing",
    "Land Area (units not specified in file)": 3.082,
    "Lease Term": 10,
    "Annual Lease Fee": 79378,
    "Land Use Premium": null,
    "Number Of Local Employees": 248,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "No. 1, Central Road,  Xin He Industrial Zone,Xin He County",
    "Organization Address":
      "Plot no. 8, Myay Taing Block no. 50, Thar Du Kan Industrial Zone",
    "Investment Permitted Address":
      "Plot no. 8, Myay Taing Block no. 50, Thar Du Kan Industrial Zone",
  },
  {
    ID: 3665,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "MR. VASiT TAEPAISITPHONGSE",
    "Name of Principal Organization": "Betagro Public Co., Ltd",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Betagro (Myanmar) Company Limited",
    "Financial Year From": 2020,
    "Financial Year To": 2021,
    "Permit Number": "227/2020",
    "Permit Date": "2020-01-28T07:37:32Z",
    "Meeting Number": "2/2020",
    "Meeting Date": "2020-01-24T07:37:51Z",
    Sector: "Livestock & Fisheries",
    "Type Of Investment Business":
      "မျိုးကြက် မွေးမြူရေးနှင့် သားဖောက်ခြင်း လုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 3.2,
    "Total Amount Of Capital (in Millions)": 7.75,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "ဦးနိုင်မိုး",
    "Land Area (units not specified in file)": 30,
    "Lease Term": 50,
    "Annual Lease Fee": 2967.15,
    "Land Use Premium": null,
    "Number Of Local Employees": 57,
    "Number Of Foreign Employees": 2,
    Status: "Approved",
    "Investor Address":
      "323, No-6, vibhavadi Rangsit Road, Thung Song Hong Lak Si Bangkok,",
    "Organization Address":
      "323,No.6, Vibhavadi Rangsit Road, Thung Song Hong Lak Si, ",
    "Investment Permitted Address":
      "Holding No. 260,261,262,292,293,294,kwin No-997, Ahhtayu Kwin, Kalihtaw West Village Tract, Hlegu Township, Yangon",
  },
  {
    ID: 3666,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr. VasitTaepaisitphongse (Thai",
    "Name of Principal Organization": "Betagro Public Co., Ltd",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Betagro (Myanmar) Company Limited",
    "Financial Year From": 2020,
    "Financial Year To": 2021,
    "Permit Number": "228/2020",
    "Permit Date": "2020-01-28T08:14:41Z",
    "Meeting Number": "2/2020",
    "Meeting Date": "2020-01-24T08:14:55Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "-တိရစ္ဆာန် အစားအစာ ထုတ်လုပ်ဖြန့်ဖြူးရောင်းချခြင်းလုပ်ငန်း",
    "Amount Of Foreign Capital USD (in Millions)": 4.628,
    "Total Amount Of Capital (in Millions)": 10.8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 5,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "-ဦးထွန်းလွင် နှင့် ဦးနိုင်မိုး",
    "Land Area (units not specified in file)": 11.201,
    "Lease Term": 50,
    "Annual Lease Fee": 27047.14,
    "Land Use Premium": null,
    "Number Of Local Employees": 172,
    "Number Of Foreign Employees": 13,
    Status: "Approved",
    "Investor Address":
      "323, No-6, Vibhadi Rangsit Road, Thung Song Hong Lak Si,",
    "Organization Address":
      "323, No.6, Vibhavadi Rangsit Road, Thung Song Hong Lak Si,",
    "Investment Permitted Address":
      "မြေကွက်အမှတ်- ၁၀၁၊ ၁၀၂၊ ၁၀၃၊ ၁၀၄၊ ၁၇၉၊ မြေတိုင်းရပ်ကွက်မှတ်- သီလဝါစက်မှုဇုန်၊ သန်လျင်-ကျောက်တန်းမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 3672,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyaw Win Tun",
    "Name of Principal Organization": "Europe & Asia Beverages Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Europe & Asia Beverages Company Limited",
    "Financial Year From": 18,
    "Financial Year To": 19,
    "Permit Number": "168",
    "Permit Date": "2019-10-23T09:37:03Z",
    "Meeting Number": "17/2019",
    "Meeting Date": "2019-10-21T09:37:22Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Distribution of Purified Drinking Water and Beverages",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 32863.01,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Sein Myint",
    "Land Area (units not specified in file)": 4.081,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 225,
    "Number Of Foreign Employees": null,
    Status: "Submitted",
    "Investor Address":
      "No. 5B, Sagaing Street, Myakanthar Housing Complex, Ward-14,",
    "Organization Address":
      "No. 19, 4 ZA, (2-Kha), Shwepyithar Industrial Zone, ",
    "Investment Permitted Address":
      "Plot No. 66, 67, Myay Taing Block No. 65 (Sethmu), Industrial Zone-4, Shwepyithar Industrial Zone,",
  },
  {
    ID: 3674,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Dong Lei",
    "Name of Principal Organization":
      "Nantong Gust International Trade Company Limited",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Gust (Myanmar) Garment Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "348/2020",
    "Permit Date": "2020-02-26T03:34:43Z",
    "Meeting Number": "3/2020",
    "Meeting Date": "2020-02-19T03:35:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Soe Min Thein",
    "Land Area (units not specified in file)": 1.134,
    "Lease Term": 5,
    "Annual Lease Fee": 44594,
    "Land Use Premium": null,
    "Number Of Local Employees": 524,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "Room# 1-501, Lijiadng Garden",
    "Organization Address":
      "Room-100510 , No. 1 Building, No. 2 Haide Road, Nantong Development Zone",
    "Investment Permitted Address":
      "Plot no. 79, Myay Taing Block no. 14, Shwe Than Lwin",
  },
  {
    ID: 3675,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Jia Hua",
    "Name of Principal Organization": "Huainan Fuhua Clothing Company Limited",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Drago Garment Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "349/2020",
    "Permit Date": "2020-02-26T03:46:25Z",
    "Meeting Number": "3/2020",
    "Meeting Date": "2020-02-19T03:46:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Than Zaw Htwe",
    "Land Area (units not specified in file)": 2.535,
    "Lease Term": 5,
    "Annual Lease Fee": 72000000,
    "Land Use Premium": null,
    "Number Of Local Employees": 800,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "No. 2, Building 7, Nanqi Street, Hinggang Community Committee, Miaogang Shushan Zone",
    "Organization Address":
      "No. 2, Phase 3, Industrial New Area, Datong District",
    "Investment Permitted Address":
      "Plot no. 19, Myay Taing Block no. 21, Mya Sein Yaung Industrial Zone",
  },
  {
    ID: 3676,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. He Bing Xiang",
    "Name of Principal Organization":
      "Guangdong Oleno Underwear Group Co., Ltd",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Kingsley Garment (Myanmar) Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "350/2020",
    "Permit Date": "2020-02-26T03:52:51Z",
    "Meeting Number": "3/2020",
    "Meeting Date": "2020-02-19T03:52:59Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Brassiers and Underwears on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.262,
    "Total Amount Of Capital (in Millions)": 1.262,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Sai Win Tun , U Sai Win Aung",
    "Land Area (units not specified in file)": 2.72,
    "Lease Term": 10,
    "Annual Lease Fee": 369111600,
    "Land Use Premium": null,
    "Number Of Local Employees": 562,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "No. 1, North of Jianshe Road, Bichong, Huangqi Nanhai District",
    "Organization Address":
      "No. 1, North of Jianshe Road, Bichong, Huangqi Nanhai District",
    "Investment Permitted Address":
      "Plot no. 132, Myay Taing Block No.51, Thar Du Kan Industrial Zone",
  },
  {
    ID: 3677,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Pang Man Wai",
    "Name of Principal Organization":
      "Huan Yao Manufacturing (Myanmar) Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Huan Yao Manufacturing (Myanmar) Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "351/2020",
    "Permit Date": "2020-02-26T04:03:59Z",
    "Meeting Number": "3/2020",
    "Meeting Date": "2020-02-19T04:04:06Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Safety Apparel and Tool Lanyards on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.68,
    "Total Amount Of Capital (in Millions)": 0.68,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Tun Nay Win",
    "Land Area (units not specified in file)": 1.164,
    "Lease Term": 30,
    "Annual Lease Fee": 23400,
    "Land Use Premium": null,
    "Number Of Local Employees": 150,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address": "Room G, 20.F, Aegean Coast",
    "Organization Address":
      "PLot no. 23, Myay Taing Block no. 109(Industrial Zone)",
    "Investment Permitted Address":
      "PLot no. 23, Myay Taing Block no. 109(Industrial Zone)",
  },
  {
    ID: 3679,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Huang Tianshu",
    "Name of Principal Organization":
      "Jiangsu Soho Silk Industry Company Limited",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Jiangsu Soho (Myanmar) Garment Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "352/2020",
    "Permit Date": "2020-02-26T04:15:27Z",
    "Meeting Number": "3/2020",
    "Meeting Date": "2020-02-19T04:15:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.2,
    "Total Amount Of Capital (in Millions)": 1.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myo Hlaing",
    "Land Area (units not specified in file)": 1.252,
    "Lease Term": 10,
    "Annual Lease Fee": 380.16,
    "Land Use Premium": null,
    "Number Of Local Employees": 945,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "No. 48, Ruan Jian Road, Yu Hua",
    "Organization Address": "No. 48, Ruan Jian Road, Yu Hua",
    "Investment Permitted Address":
      "Plot no. 88, Myay Taing Block no. 64 (Sethmu)",
  },
  {
    ID: 3680,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Qian Jianhong",
    "Name of Principal Organization":
      "Jiayi Embroidery & Printing (Myanmar) Company Limited",
    "Place of Incorporation": "China",
    "Company Name In Myanmar":
      "Jiayi Embroidery & Printing (Myanmar) Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "353/2020",
    "Permit Date": "2020-02-26T04:28:19Z",
    "Meeting Number": "3/2020",
    "Meeting Date": "2020-02-19T04:28:26Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Printing And Embroidery Designs For Fabrics and Clothes",
    "Amount Of Foreign Capital USD (in Millions)": 1.8,
    "Total Amount Of Capital (in Millions)": 1.8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 18,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Than Zaw Myint",
    "Land Area (units not specified in file)": 2.211,
    "Lease Term": 6,
    "Annual Lease Fee": 48,
    "Land Use Premium": null,
    "Number Of Local Employees": 300,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "Room 602, Building 18, Yunpanyi Village, Yangshe Town",
    "Organization Address":
      "Plot no. 278/9, Myay Taing BLock no. 25, Shwe Lin Ban Industrial Zone",
    "Investment Permitted Address":
      "Plot no. 278/9, Myay Taing BLock no. 25, Shwe Lin Ban Industrial Zone",
  },
  {
    ID: 3681,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Yar Zar Myo",
    "Name of Principal Organization": "Paungde Shwe Myay Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Paungde Shwe Myay Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "354/2020",
    "Permit Date": "2020-02-26T04:40:13Z",
    "Meeting Number": "3/2020",
    "Meeting Date": "2020-02-19T04:40:19Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Buying Raw Rice & Related Material in Local And Making Processing For White  Rice and Broken Rice For Export",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 3003.98,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Yarzar Myo, Daw Me Me San",
    "Land Area (units not specified in file)": 2.002,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 166,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address": "No. (G-45), Padauk Street , Ba Yint Naung Quarter",
    "Organization Address":
      "Pot no. 465, B2, Myay Taing Block no. 25, Shwe Lin Ban Sethmu Myo",
    "Investment Permitted Address":
      "Pot no. 465, B2, Myay Taing Block no. 25, Shwe Lin Ban Sethmu Myo",
  },
  {
    ID: 3682,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wang Zhongzhi",
    "Name of Principal Organization": "Hong Kong Si Yuan Company Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Si Yuan (Myanmar) Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "355/2020",
    "Permit Date": "2020-02-26T04:54:26Z",
    "Meeting Number": "3/2020",
    "Meeting Date": "2020-02-19T04:54:33Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.906,
    "Total Amount Of Capital (in Millions)": 0.906,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Thiri Yu Wai",
    "Land Area (units not specified in file)": 1.118,
    "Lease Term": 30,
    "Annual Lease Fee": 24884.12,
    "Land Use Premium": null,
    "Number Of Local Employees": 318,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "201, Building C, No. 442 Suang Cai Li, West Xinqiao Road, Xiangqiao District",
    "Organization Address":
      "Unit no. 1, 11/F Fu Hang Ind Bldg No. 1 Hok Yuen Street",
    "Investment Permitted Address":
      "Plot no. 27-KA , Myay Taing Block no. Part 4, Industrial Zone",
  },
  {
    ID: 3683,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Jin Ye",
    "Name of Principal Organization":
      "Sunrise (Myanmar) Fashion Company Limited",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Sunrise (Myanmar) Fashion Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "356/2020",
    "Permit Date": "2020-02-26T06:49:04Z",
    "Meeting Number": "3/2020",
    "Meeting Date": "2020-02-19T06:49:11Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.5,
    "Total Amount Of Capital (in Millions)": 4.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 28,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Kyin Shein",
    "Land Area (units not specified in file)": 2.401,
    "Lease Term": 8,
    "Annual Lease Fee": 77712,
    "Land Use Premium": null,
    "Number Of Local Employees": 800,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "Yanyuan 2 Dong, 101 Shi, Jiang Su Sheng",
    "Organization Address":
      "Plot no. 81, Myay Taing Block no. 51, Thar Du Kan Industrial Zone",
    "Investment Permitted Address":
      "Plot no. 81, Myay Taing Block no. 51, Thar Du Kan Industrial Zone",
  },
  {
    ID: 3685,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "MR. XIE KAI",
    "Name of Principal Organization":
      "WE HAI TEXTILE GROUP IMPORT & EXPORT CO., LTD",
    "Place of Incorporation": "SHANDONG PROVINCE",
    "Company Name In Myanmar": "DISHANG GROUP (MYANMAR) COMPANY LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "229/2020",
    "Permit Date": "2020-01-28T08:15:51Z",
    "Meeting Number": "2/2020",
    "Meeting Date": "2020-01-24T08:16:18Z",
    Sector: "Real Estate",
    "Type Of Investment Business": "CONSTRUCTION AND LEASING OF FACTORIES",
    "Amount Of Foreign Capital USD (in Millions)": 60,
    "Total Amount Of Capital (in Millions)": 60,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 3,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Top Focus Investment Company Limited  ",
    "Land Area (units not specified in file)": 19.635,
    "Lease Term": 50,
    "Annual Lease Fee": 0.198,
    "Land Use Premium": null,
    "Number Of Local Employees": 930,
    "Number Of Foreign Employees": 17,
    Status: "Approved",
    "Investor Address":
      "ROOM 210, NO. 33, TORCH HI-TECH INDUSTRIAL DEVELOPMENT ZONE, AREA A TIANCUN DISTRICT, WEIHAI CITY, SHANGDONG PROVINCE, THE PEOPLE’S REPUBLIC OF CHINA",
    "Organization Address":
      "16, SHICHANG AVENUE, WEIHAI CITY, SHANDONG PROVINCE, THE PEOPLE’S REPUBLIC OF CHINA",
    "Investment Permitted Address":
      "PLOT NO. E2, E3, E6, E7, E8, E9, E10, MYAY TAING BLOCK  NO. (20), ANAWRAHTA INDUSTRIAL ZONE, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 3686,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Shi Shanghai",
    "Name of Principal Organization":
      "Hongkong Nature New Material Group Company Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Ziran Non-Woven (Myanmar) Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "357/2020",
    "Permit Date": "2020-02-26T03:39:54Z",
    "Meeting Number": "3/2020",
    "Meeting Date": "2020-02-19T03:40:05Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Polyster Fiber  (Local CMP Enterprises 80% and Direct Export 20%)",
    "Amount Of Foreign Capital USD (in Millions)": 2.9,
    "Total Amount Of Capital (in Millions)": 2.9,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 8,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Soe Min @ U Khin Soe Min",
    "Land Area (units not specified in file)": 2.284,
    "Lease Term": 8,
    "Annual Lease Fee": 48,
    "Land Use Premium": null,
    "Number Of Local Employees": 60,
    "Number Of Foreign Employees": 7,
    Status: "Draft",
    "Investor Address": "Shixia Village, Jinjiang City",
    "Organization Address":
      "Flat Room 02, 11/F, BLDG 339 Castle Peak Road, Hang Seng Castle Peak Road",
    "Investment Permitted Address":
      "Plot no. 35, Myay Taing Block no. 65, Industrial Zone 4",
  },
  {
    ID: 3687,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Chung Wei-Ling",
    "Name of Principal Organization": "Winley Co., Ltd",
    "Place of Incorporation": "Seychelles",
    "Company Name In Myanmar": "Genesis Myanmar Garment Co., Ltd",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "358/2020",
    "Permit Date": "2020-02-26T03:58:46Z",
    "Meeting Number": "3/2020",
    "Meeting Date": "2020-02-19T03:59:16Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.285,
    "Total Amount Of Capital (in Millions)": 4.285,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Seychelles",
    "Form Of Investment": "FDII",
    "Land Owner": "GKMG Enterprises Co., Ltd",
    "Land Area (units not specified in file)": 5.068,
    "Lease Term": 50,
    "Annual Lease Fee": 102547.43,
    "Land Use Premium": null,
    "Number Of Local Employees": 1435,
    "Number Of Foreign Employees": 12,
    Status: "Draft",
    "Investor Address": "No. 39, LN. 540, Sec2, Zhongshan Rd",
    "Organization Address": "Suite 1, Commercial House One",
    "Investment Permitted Address":
      "Plot no. (5+6) , Myay Taing Block no. 113, Industrial Zone",
  },
  {
    ID: 3688,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zou Wangsuo",
    "Name of Principal Organization": "Alland Fashion Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Alland Fashion Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "359/2019",
    "Permit Date": "2020-02-26T05:00:16Z",
    "Meeting Number": "3/2020",
    "Meeting Date": "2020-02-19T05:00:34Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.002,
    "Total Amount Of Capital (in Millions)": 1.002,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Theingi Htun",
    "Land Area (units not specified in file)": 2.011,
    "Lease Term": 10,
    "Annual Lease Fee": 44760.32,
    "Land Use Premium": null,
    "Number Of Local Employees": 365,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "Room no. 502, Buikding 4, Entertainment Village, Suzhou City, Wuzhong District",
    "Organization Address":
      "Plot no. 63, Myay Taing Block no. Part(3), Industrial Zone",
    "Investment Permitted Address":
      "Plot no. 63, Myay Taing Block no. Part(3), Industrial Zone",
  },
  {
    ID: 3689,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chai Yuanhua",
    "Name of Principal Organization":
      "Wei Hua (Myanmar) Garment Company LImited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Wei Hua (Myanmar) Garment Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "360/2020",
    "Permit Date": "2020-02-26T07:07:33Z",
    "Meeting Number": "3/2020",
    "Meeting Date": "2020-02-19T07:07:38Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.5,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Zaw Min, Daw Mya Mya Cho, U Aung Min, Daw Htike Shwe Sin",
    "Land Area (units not specified in file)": 1.398,
    "Lease Term": 5,
    "Annual Lease Fee": 48,
    "Land Use Premium": null,
    "Number Of Local Employees": 400,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "Room 706, No. 117, Suyuan Avenue,Lianggang Building",
    "Organization Address": "Plot no. 308 C/A , Myay Taing Block no. 42/Sethmu",
    "Investment Permitted Address":
      "Plot no. 308 C/A , Myay Taing Block no. 42/Sethmu",
  },
  {
    ID: 3690,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhu Zhaobing",
    "Name of Principal Organization": "Greatwall Investment (H.K) Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Myanmar Journey Bags Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "361/2020",
    "Permit Date": "2020-02-26T07:13:20Z",
    "Meeting Number": "3/2020",
    "Meeting Date": "2020-02-19T07:13:26Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.622,
    "Total Amount Of Capital (in Millions)": 1.622,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Hla Win",
    "Land Area (units not specified in file)": 2.187,
    "Lease Term": 10,
    "Annual Lease Fee": 156480,
    "Land Use Premium": null,
    "Number Of Local Employees": 632,
    "Number Of Foreign Employees": 8,
    Status: "Draft",
    "Investor Address": "21 Building, Jianfa Longjing Bay, Licheng District, ",
    "Organization Address":
      "Unit E 5/F , World Tech Centre, 95 How Ming Street",
    "Investment Permitted Address":
      "Plot no. 263, Myay Taing Block no. 49, Wartayar Industrial Zone",
  },
  {
    ID: 3691,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Veljo Toodo",
    "Name of Principal Organization": "Wasteman Ou",
    "Place of Incorporation": "Estonia",
    "Company Name In Myanmar": "South Frame Myanmar Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "362/2020",
    "Permit Date": "2020-02-26T07:36:48Z",
    "Meeting Number": "3/2020",
    "Meeting Date": "2020-02-19T07:36:55Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Photo Frame on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.852,
    "Total Amount Of Capital (in Millions)": 0.852,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Mg Sein",
    "Land Area (units not specified in file)": 1.423,
    "Lease Term": 5,
    "Annual Lease Fee": 72,
    "Land Use Premium": null,
    "Number Of Local Employees": 136,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address": "Kiili. 75401,Allika 28",
    "Organization Address": "Harju Maakond, Haabneeme Alevik",
    "Investment Permitted Address":
      "Plot no. 110+111 (B) , Myay Taing Block no. Industrial Zone 1",
  },
  {
    ID: 3692,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Cheng, Wen Chin",
    "Name of Principal Organization":
      "Kai Sheng (Myanmar) Industrial Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Kai Sheng (Myanmar) Industrial Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "363/2020",
    "Permit Date": "2020-02-26T08:00:15Z",
    "Meeting Number": "3/2020",
    "Meeting Date": "2020-02-19T08:00:28Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.911,
    "Total Amount Of Capital (in Millions)": 0.911,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "U Saw Htoo Ael War",
    "Land Area (units not specified in file)": 0.707,
    "Lease Term": 5,
    "Annual Lease Fee": 130.618,
    "Land Use Premium": null,
    "Number Of Local Employees": 355,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "4F, No. 6, ALY 34, LN 451, Xinming Rd",
    "Organization Address": "Plot no. 86, Myay Taing Block no. 42, ",
    "Investment Permitted Address": "Plot no. 86, Myay Taing Block no. 42, ",
  },
  {
    ID: 3693,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yang Xu",
    "Name of Principal Organization": "Nan Xiang Enterprises Ltd",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Fineline Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "364/2020",
    "Permit Date": "2020-02-26T08:31:02Z",
    "Meeting Number": "3/2020",
    "Meeting Date": "2020-02-19T08:32:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.087,
    "Total Amount Of Capital (in Millions)": 2.087,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner":
      "Wung Law Shin @ U Hla Thein , Koe Kyin Hoon @ Daw Khin Khin Yee",
    "Land Area (units not specified in file)": 2.388,
    "Lease Term": 10,
    "Annual Lease Fee": 120000000,
    "Land Use Premium": null,
    "Number Of Local Employees": 972,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "Room 601, Building 15, No. 150, dongyi Road, Panyu District",
    "Organization Address":
      "Flat /RM 9, 11/F , 53-55 Au Pui Wan Street, Mecco Industrial Building",
    "Investment Permitted Address":
      "Plot no. 107, Myay Taing Block no. Thilawa Industrial Zone",
  },
  {
    ID: 3699,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Liu Xiangliu",
    "Name of Principal Organization":
      "Myanmar Huaxian Hardware & Plastic Products Co., Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "Myanmar Huaxian Hardware & Plastic Products Co., Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "365/2020",
    "Permit Date": "2020-03-13T04:26:01Z",
    "Meeting Number": "4/2020",
    "Meeting Date": "2020-03-26T04:26:31Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Eye Glasses (Hardware & Plastic) Box on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.1,
    "Total Amount Of Capital (in Millions)": 1.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Tin Shwe",
    "Land Area (units not specified in file)": 1.291,
    "Lease Term": 5,
    "Annual Lease Fee": 50400000,
    "Land Use Premium": null,
    "Number Of Local Employees": 200,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "Huya Formation, Yansha Village, Jiangkou Town",
    "Organization Address":
      "Plot no. 65, Myay Taing Block no. 25, Shwe Lin Ban Industrial Zone",
    "Investment Permitted Address":
      "Plot no. 65, Myay Taing Block no. 25, Shwe Lin Ban Industrial Zone",
  },
  {
    ID: 3700,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhao Xiaomin",
    "Name of Principal Organization":
      "Chu Yang Myanmar Garment Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Chu Yang Myanmar Garment Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "366/2020",
    "Permit Date": "2020-03-13T05:07:08Z",
    "Meeting Number": "4/2020",
    "Meeting Date": "2020-02-26T05:07:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.136,
    "Total Amount Of Capital (in Millions)": 2.136,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Nan Swe",
    "Land Area (units not specified in file)": 2.279,
    "Lease Term": 6,
    "Annual Lease Fee": 203245,
    "Land Use Premium": null,
    "Number Of Local Employees": 495,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "Room no. 2004, No. 5, Lane 968, Tianyaoqiao Road",
    "Organization Address":
      "Plot no. 303, Myay Taing Block no. 49, Wartayar Industrial Zone",
    "Investment Permitted Address":
      "Plot no. 303, Myay Taing Block no. 49, Wartayar Industrial Zone",
  },
  {
    ID: 3701,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yip Siu Tung",
    "Name of Principal Organization": "Keme Garment (Myanmar) Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Keme Garment (Myanmar) Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "367/2020",
    "Permit Date": "2020-03-13T06:05:13Z",
    "Meeting Number": "4/2020",
    "Meeting Date": "2020-02-26T06:05:22Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.044,
    "Total Amount Of Capital (in Millions)": 4.044,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 18,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Soe Paing , Daw Khin Myat Swe",
    "Land Area (units not specified in file)": 7.22,
    "Lease Term": 5,
    "Annual Lease Fee": 937.412,
    "Land Use Premium": null,
    "Number Of Local Employees": 1960,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address":
      "Flat G-H, 14/F , Wing Hong Industrial Building, 18-26 Kwai Fung Crescent Kwai Fong",
    "Organization Address":
      "Holding no. 25/2+32/2, Kwin no. 577 Kyauk Pone ,Innlayat Village",
    "Investment Permitted Address":
      "Holding no. 25/2+32/2, Kwin no. 577 Kyauk Pone ,Innlayat Village",
  },
  {
    ID: 3712,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Daw Li Li Myaint ",
    "Name of Principal Organization": "Allin Pwint Construction Co., Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Allin Pwint Construction Co., Ltd.",
    "Financial Year From": 2020,
    "Financial Year To": 2021,
    "Permit Number": "233/2020",
    "Permit Date": "2020-02-24T02:49:53Z",
    "Meeting Number": "3/2020",
    "Meeting Date": "2020-02-13T02:50:16Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Service",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 41985,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 154,
    "Number Of Foreign Employees": 1,
    Status: "Approved",
    "Investor Address": "Building No.17/A, Tha Pye Nyo Street,",
    "Organization Address": "No.281,Shwe Gone Daing Road, ",
    "Investment Permitted Address":
      "Plot No. 406 A6/2B, 406 B2/B, Myay Taing Plot 2-E, No.281, Shwe Gone Daing Road, Middle Shwe Gone Daing Ward, ",
  },
  {
    ID: 3726,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Li Liping",
    "Name of Principal Organization":
      "Nanjing Maiyibei Garment Manufacturing Co., Ltd",
    "Place of Incorporation": "China",
    "Company Name In Myanmar":
      "Maiyibei (Yangon) Garment Manufacturing Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "368/2020",
    "Permit Date": "2020-03-24T07:18:11Z",
    "Meeting Number": "5/2020",
    "Meeting Date": "2020-03-13T07:18:42Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing Of Garment On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.203,
    "Total Amount Of Capital (in Millions)": 1.203,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 38,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Mr. Li Liping",
    "Land Area (units not specified in file)": 3.6,
    "Lease Term": 18,
    "Annual Lease Fee": 72,
    "Land Use Premium": null,
    "Number Of Local Employees": 910,
    "Number Of Foreign Employees": 8,
    Status: "Draft",
    "Investor Address": "No.147, Ton Zhai Cun (South) Village",
    "Organization Address": "Jin Liu Hu Industrial Zone ",
    "Investment Permitted Address":
      "Plot No. (491,492,493), Yalapa-25 Shwe Lin Ban Industrial Zone, ",
  },
  {
    ID: 3727,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wang Guoqiang",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "LYC Garment Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "369/2020",
    "Permit Date": "2020-03-24T08:07:21Z",
    "Meeting Number": "5/2020",
    "Meeting Date": "2020-03-13T08:07:29Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kind of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.942,
    "Total Amount Of Capital (in Millions)": 1.942,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Newswell Development Ltd",
    "Land Area (units not specified in file)": 2.305,
    "Lease Term": 50,
    "Annual Lease Fee": 36,
    "Land Use Premium": null,
    "Number Of Local Employees": 1185,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "Taishan Road No. 51, Singapore Garden North Area",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot no. 138, Myay Taing Block No. Myaung Ta Gar Steel Industrial Zone",
  },
  {
    ID: 3730,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chang Hao Han",
    "Name of Principal Organization":
      "East West International Products Co., Ltd",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Habit Technology Ltd",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "370/2020",
    "Permit Date": "2020-03-24T03:38:58Z",
    "Meeting Number": "5/2020",
    "Meeting Date": "2020-03-13T03:38:55Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Shoes on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 5,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Seychelles",
    "Form Of Investment": "FDII",
    "Land Owner": "Steel House International Company Limited",
    "Land Area (units not specified in file)": 5.847,
    "Lease Term": 50,
    "Annual Lease Fee": 84,
    "Land Use Premium": null,
    "Number Of Local Employees": 1181,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "2F, 252, SEC 4, Changping Road",
    "Organization Address":
      "De Zippora St. Po Box 456, 1st Floor, #5 Dekk House, ",
    "Investment Permitted Address": "Plot no. 1, Myay Taing Block no. 164,",
  },
  {
    ID: 3731,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Huang Cheng Chung",
    "Name of Principal Organization":
      "Sawa Corp No. 84, Section 1, Daoing Street",
    "Place of Incorporation": "Taiwan",
    "Company Name In Myanmar": "Newtek (Myanmar) Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "371/2020",
    "Permit Date": "2020-03-13T04:25:37Z",
    "Meeting Number": "5/2020",
    "Meeting Date": "2020-03-24T04:25:48Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Electrical Consumer Products On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.9,
    "Total Amount Of Capital (in Millions)": 0.9,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Thiha Kyaw",
    "Land Area (units not specified in file)": 1,
    "Lease Term": 50,
    "Annual Lease Fee": 9.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 150,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address": "No. 84-3, Sec .1, Ta Ching Street",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot no. 366, Myay Taing Block no. 49, Wartayar Industrial Zone ",
  },
  {
    ID: 3737,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lin Shaoyue",
    "Name of Principal Organization":
      "Create Beauty (Myanmar) Knitted Wear Co., Ltd",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Create Beauty (Myanmar) Knitted Wear Co., Ltd",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "372/2020",
    "Permit Date": "2020-03-13T07:07:37Z",
    "Meeting Number": "5/2020",
    "Meeting Date": "2020-03-24T07:08:02Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Wearing Apparel On CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3.177,
    "Total Amount Of Capital (in Millions)": 3.177,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Than Aung",
    "Land Area (units not specified in file)": 1.148,
    "Lease Term": 10,
    "Annual Lease Fee": 74332.64,
    "Land Use Premium": null,
    "Number Of Local Employees": 1000,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "21 Yanshan, Wutongwu Village, Quanbo Town,Guangfeng County",
    "Organization Address":
      "Plot No. 334,335,336 , Myay Taing BLock no. Myaung Dagar Thanmani Industrial Zone",
    "Investment Permitted Address":
      "Plot No. 334,335,336 , Myay Taing BLock no. Myaung Dagar Thanmani Industrial Zone",
  },
  {
    ID: 3738,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Chan Wai Kam Monica",
    "Name of Principal Organization": "Sino Worldwide International Ltd",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Nay Shwe Lin Co., Ltd",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "373/2020",
    "Permit Date": "2020-03-13T07:51:56Z",
    "Meeting Number": "5/2020",
    "Meeting Date": "2020-03-24T07:52:29Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.251,
    "Total Amount Of Capital (in Millions)": 2.251,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Zaw Win @ U Khin Zaw",
    "Land Area (units not specified in file)": 2.446,
    "Lease Term": 5,
    "Annual Lease Fee": 720,
    "Land Use Premium": null,
    "Number Of Local Employees": 1408,
    "Number Of Foreign Employees": 7,
    Status: "Draft",
    "Investor Address": "Room 1809, Block B, Ling Poon Court",
    "Organization Address": "Suite 2611, 26/F, Office Tower",
    "Investment Permitted Address":
      "Plot no. 3, Myay Taing BLock no. 49, Wartayar Industrial Zone",
  },
  {
    ID: 3739,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "NR Modular Co., Ltd",
    "Name of Principal Organization": "NR Engineering Co., Ltd",
    "Place of Incorporation": "Thailand",
    "Company Name In Myanmar": "NR Modular Co., Ltd",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "374/2020",
    "Permit Date": "2020-03-24T08:47:59Z",
    "Meeting Number": "5/2020",
    "Meeting Date": "2020-03-13T08:48:09Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing, Selling and Installation of Hot-Rolled and Cold-Rolled Steel Products",
    "Amount Of Foreign Capital USD (in Millions)": 3.2,
    "Total Amount Of Capital (in Millions)": 3.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Thailand",
    "Form Of Investment": "FDII",
    "Land Owner": "U Maung Thaung",
    "Land Area (units not specified in file)": 2.243,
    "Lease Term": 50,
    "Annual Lease Fee": 32,
    "Land Use Premium": null,
    "Number Of Local Employees": 20,
    "Number Of Foreign Employees": 4,
    Status: "Draft",
    "Investor Address":
      "Plot no. 26, Myay Taing Block no. 25, Shwe Lin Ban Industrial Zone",
    "Organization Address": "No. 23, Soi Phet Kasem 32, Phet Kasem Road",
    "Investment Permitted Address":
      "Plot no. 26, Myay Taing Block no. 25, Shwe Lin Ban Industrial Zone",
  },
  {
    ID: 3742,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Kim Youngha",
    "Name of Principal Organization": "Tonbo  Company Limited",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "Tonbo HK Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "375/2020",
    "Permit Date": "2020-03-24T04:16:04Z",
    "Meeting Number": "5/2020",
    "Meeting Date": "2020-03-13T04:16:10Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.303,
    "Total Amount Of Capital (in Millions)": 1.303,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Toe Toe Myint",
    "Land Area (units not specified in file)": 2.246,
    "Lease Term": 30,
    "Annual Lease Fee": 49990,
    "Land Use Premium": null,
    "Number Of Local Employees": 992,
    "Number Of Foreign Employees": 8,
    Status: "Approved",
    "Investor Address": "Room 1911, 708, Heatae Borame Tower, Shindaebang Dong",
    "Organization Address": "No. 288, Digital Ro",
    "Investment Permitted Address":
      "Plot no. 153, Myay Taing Block no. 18, Industrial Zone (5) /Extension ",
  },
  {
    ID: 3744,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ling Xheng Yin",
    "Name of Principal Organization":
      "Jiangsu Sanhe Shoes And Garments Co., Ltd.",
    "Place of Incorporation": "China",
    "Company Name In Myanmar":
      "China Jiangsu Sanhe Group Myanmar Shoes Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "376/2020",
    "Permit Date": "2020-03-24T05:21:31Z",
    "Meeting Number": "5/2020",
    "Meeting Date": "2020-03-13T05:21:38Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Slipper on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myo Aung @ Lin Young Aein , U Maung Shein",
    "Land Area (units not specified in file)": 1.516,
    "Lease Term": 5,
    "Annual Lease Fee": 96,
    "Land Use Premium": null,
    "Number Of Local Employees": 188,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "No. 65, Jinhu Road, Licheng Town",
    "Organization Address": "No. 2,  Li Tong Road ,",
    "Investment Permitted Address":
      "Plot no. 179. Myay Taing Block No. Industrial Zone 2",
  },
  {
    ID: 3745,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Li Haoyang",
    "Name of Principal Organization": "Myanmar Tencent Fashion Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Myanmar Tencent Fashion Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "377/2020",
    "Permit Date": "2020-03-24T06:11:15Z",
    "Meeting Number": "5/2020",
    "Meeting Date": "2020-03-13T06:11:22Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Wool Products on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.004,
    "Total Amount Of Capital (in Millions)": 2.004,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 5,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Saw Ael Htoo War",
    "Land Area (units not specified in file)": 0.7,
    "Lease Term": 5,
    "Annual Lease Fee": 54.179,
    "Land Use Premium": null,
    "Number Of Local Employees": 300,
    "Number Of Foreign Employees": 6,
    Status: "Draft",
    "Investor Address": "No. 61, Peiyuan Ercun, Zhpuzhung Town",
    "Organization Address": "Plot no. 86, Myay Taing Block No. 42 (Sethmue)",
    "Investment Permitted Address":
      "Plot no. 86, Myay Taing Block No. 42 (Sethmue)",
  },
  {
    ID: 3748,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U San Win @ Shusan",
    "Name of Principal Organization": "Shu San Industry Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Shu San Industry Company Limited",
    "Financial Year From": 19,
    "Financial Year To": 20,
    "Permit Number": "222/2020",
    "Permit Date": "2020-01-15T08:52:41Z",
    "Meeting Number": "1/2020",
    "Meeting Date": "2020-01-10T08:52:58Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Processing and Sales of Rice and Rice Related Products",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 10811.56,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U San Win @ Shusan",
    "Land Area (units not specified in file)": 5.13,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address": "No.9, Aung Theik Hti Street, Ward-3, ",
    "Organization Address": "No.9, Aung Theik Hti Street, Ward-3, ",
    "Investment Permitted Address":
      "Holding No. 4/Ka, Kwin No. 292-A, Kalahmine North Kwin, Wartayar Village Tract, ",
  },
  {
    ID: 3759,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr. Hettiyahandi Gehan Kaminda De Silva",
    "Name of Principal Organization":
      "HDDES Natural Products (Myanmar) Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "HDDES Natural Products (Myanmar) Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "241/2020",
    "Permit Date": "2020-03-17T03:34:43Z",
    "Meeting Number": "4/2020",
    "Meeting Date": "2020-03-06T03:36:05Z",
    Sector: "Agriculture",
    "Type Of Investment Business":
      "Processing and Sales of Value Added Agricultural Products",
    "Amount Of Foreign Capital USD (in Millions)": 4.398,
    "Total Amount Of Capital (in Millions)": 5.493,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner": "ဦးမြတ်သူ၊ ဒေါ်မြတ်စန္ဒာထွန်း",
    "Land Area (units not specified in file)": 3.668,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": 72000000,
    "Number Of Local Employees": 2614,
    "Number Of Foreign Employees": 9,
    Status: "Submitted",
    "Investor Address":
      "No.64/6, Asiri Mawatha, Kalubowila, Colombo, Sri Lanka",
    "Organization Address":
      "No.148/B. Dhamma Zedi Road, Bahan Township, Yangon Region",
    "Investment Permitted Address":
      "No.148/B. Dhamma Zedi Road, Bahan Township, Yangon Region",
  },
  {
    ID: 3761,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Ye Min",
    "Name of Principal Organization": "Min Nwe Trading Co.,Ltd.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Habras-MZZ Plantation Myanmar Co.,Ltd.",
    "Financial Year From": 2020,
    "Financial Year To": 2021,
    "Permit Number": "250/2020",
    "Permit Date": "2020-04-06T06:45:37Z",
    "Meeting Number": "5/2020",
    "Meeting Date": "2020-04-03T06:46:29Z",
    Sector: "Agriculture",
    "Type Of Investment Business":
      "Plantation of Eucalyptus, Acacia and Sales of Pulpwood Chips",
    "Amount Of Foreign Capital USD (in Millions)": 6.93,
    "Total Amount Of Capital (in Millions)": 12.6,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 9,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "JV",
    "Land Owner":
      "သစ်တောဦးစီးဌာန၊ သယံဇာတနှင့် သဘာဝပတ်ဝန်းကျင်ထိန်းသိမ်းရေးဝန်ကြီးဌာန",
    "Land Area (units not specified in file)": 12501,
    "Lease Term": 30,
    "Annual Lease Fee": null,
    "Land Use Premium": 18.75,
    "Number Of Local Employees": 301,
    "Number Of Foreign Employees": 9,
    Status: "Submitted",
    "Investor Address":
      "No.126/A, Dhamazedi Road, Corner of Inya Road, Bahan Township, Yangon",
    "Organization Address":
      "No.126/A, Dhamazedi Road, Corner of Inya Road, Bahan Township, Yangon",
    "Investment Permitted Address":
      "No.23/D, Swamahar Street, Bo Cho(2) Ward, Bahan Township, Yangon",
  },
  {
    ID: 3785,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "DAW THIRI  AUNG ",
    "Name of Principal Organization": "HANLEY  GROUP LTD",
    "Place of Incorporation": "MYANMAR",
    "Company Name In Myanmar": "HANLEY GROUP LTD",
    "Financial Year From": 2020,
    "Financial Year To": 2021,
    "Permit Number": "258/2020",
    "Permit Date": "2020-05-29T04:54:36Z",
    "Meeting Number": "22/2020",
    "Meeting Date": "2020-05-22T04:55:21Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "hotel serviceh",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 61670,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "NO.(H-17),DAMA ZAY DI ROAD, BA YINT NAUNG AVENUE, ",
    "Organization Address": "KAN YEIK THAR(4) STREET, NO.(L-55D),FMI CITY,",
    "Investment Permitted Address":
      "MYAYTAING BLOCK NO.(4/6), PLOT NO. 1945, WARD-5,",
  },
  {
    ID: 3787,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U HLA WAI",
    "Name of Principal Organization": "MYAT MIN CO., LTD.",
    "Place of Incorporation": "MYANMAR",
    "Company Name In Myanmar": "MYAT MIN CO., LTD.",
    "Financial Year From": 2020,
    "Financial Year To": 2021,
    "Permit Number": "260/200",
    "Permit Date": "2020-05-29T06:18:44Z",
    "Meeting Number": "7/2020",
    "Meeting Date": "2020-05-22T06:19:20Z",
    Sector: "Real Estate",
    "Type Of Investment Business": "Supporting Service For Livestock Breeding",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 10580.73,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address": "NO.56, KABARAYE PAGODA ROAD, WARD-10, ",
    "Organization Address": "NO.18-B, OAK PONE SEIK STREET, WARD-18, ",
    "Investment Permitted Address":
      "KWIN NO.6/MAHUYAR KWIN , PLOT NO.(N152+N153) MINGONE VILLAGE TRACT, ",
  },
  {
    ID: 3792,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "ဦးအောင်စိုးလင်း(ခ)ဦးအောင်ထွန်းလင်း",
    "Name of Principal Organization": " ပြည့်စုံဝင်းအောင်ကုမ္ပဏီလီမိတက်",
    "Place of Incorporation": "Yangon",
    "Company Name In Myanmar": "ပြည့်စုံဝင်းအောင်ကုမ္ပဏီလီမိတက် ",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "231/2020",
    "Permit Date": "2020-01-28T09:24:30Z",
    "Meeting Number": "2/2020",
    "Meeting Date": "2020-01-24T09:24:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ASSEMBLING, MANUFACTURING AND SALES OF MOTOR VEHICLES",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 5000,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအောင်စိုးလင်း(ခ)ဦးအောင်ထွန်းလင်း ",
    "Land Area (units not specified in file)": 4.243,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 45,
    "Number Of Foreign Employees": null,
    Status: "Approved",
    "Investor Address":
      "အမှတ်-၉၊ အနောက်ရွှေဂုံတိုင်-၄ လမ်း၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address":
      "မြေကွက် အမှတ်-၄၉၉၊ ၅၀၀၊ မြေတိုင်းရပ်ကွက် အမှတ်- ၂၅၊ ရွှေလင်ပန်းစက်မှုမြို့၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
    "Investment Permitted Address":
      "မြေကွက် အမှတ်-၄၉၉၊ ၅၀၀၊ မြေတိုင်းရပ်ကွက် အမှတ်- ၂၅၊ ရွှေလင်ပန်းစက်မှုမြို့၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 3793,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr. Yau Yeung Cheung  ",
    "Name of Principal Organization":
      "Wiseley Enterprises Limited (Hong Kong)         ",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "WISELEY ENTERPRISES LIMITED ",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "248/2020",
    "Permit Date": "2020-04-06T03:47:12Z",
    "Meeting Number": "5/2020",
    "Meeting Date": "2020-04-03T03:46:46Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "MANUFACTURING OF GARMENT  ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 2.8,
    "Total Amount Of Capital (in Millions)": 2.8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "ရန်ကုန်တိုင်းဒေသကြီးအစိုးရအဖွဲ့",
    "Land Area (units not specified in file)": 2.366,
    "Lease Term": 50,
    "Annual Lease Fee": 10,
    "Land Use Premium": 520,
    "Number Of Local Employees": 585,
    "Number Of Foreign Employees": 13,
    Status: "Amend",
    "Investor Address":
      "OCEAN SHORES, FLAT-B, 39 FLOOR, TSEUNG KWAN O, NEW TERRITORY, HONG KONG ",
    "Organization Address":
      "UNIT 1506, 15/F, ONE HARBOURFRONT, 18 TAK FUNG STREET, HUNGHOM, KOWLOON, HONG KONG ",
    "Investment Permitted Address":
      "PLOT NO 189, BLOCK NO 113, INDUSTRIAL ZONE PART 1, DAGON MYOTHIT (EAST) TOWNSHIP, YANGON REGION     ",
  },
  {
    ID: 3795,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "ဦးအောင်စိုးလင်း(ခ)ဦးအောင်ထွန်းလင်း",
    "Name of Principal Organization": "ပြည့်စုံဝင်းအောင်ကုမ္ပဏီလီမိတက်  ",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Pyai Sone Win Aung Co., Ltd. ",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": " 231/2020",
    "Permit Date": "2020-01-28T07:23:54Z",
    "Meeting Number": "2/2020",
    "Meeting Date": "2020-01-24T07:24:29Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ASSEMBLING, MANUFACTURING AND SALES OF MOTOR VEHICLES",
    "Amount Of Foreign Capital USD (in Millions)": 0.817,
    "Total Amount Of Capital (in Millions)": 5000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအောင်စိုးလင်း(ခ)ဦးအောင်ထွန်းလင်း ",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "အမှတ်-၉၊ အနောက်ရွှေဂုံတိုင်-၄ လမ်း၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address":
      "  အမှတ်-၉၊ အနောက်ရွှေဂုံတိုင်-၄ လမ်း၊ ဗဟန်းမြို့နယ်၊ ရန်ကုန်မြို့",
    "Investment Permitted Address":
      "မြေကွက် အမှတ်-၄၉၉၊ ၅၀၀၊ မြေတိုင်းရပ်ကွက် အမှတ်- ၂၅၊ ရွှေလင်ပန်းစက်မှုမြို့၊ လှိုင်သာယာမြို့နယ်၊ ရန်ကုန်တိုင်းဒေသကြီး",
  },
  {
    ID: 3796,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Lee Ping Hung",
    "Name of Principal Organization": "Lebros Technology Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Lebros Technology Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "073/2020",
    "Permit Date": "2020-06-26T03:39:39Z",
    "Meeting Number": "8/2020",
    "Meeting Date": "2020-06-18T03:40:02Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF COMPUTER AND COMMUNICATION PRODUCTS FOR 100% EXPORT",
    "Amount Of Foreign Capital USD (in Millions)": 1.4,
    "Total Amount Of Capital (in Millions)": 1.4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 36,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Lin Soe Lin @ U Soe Lin",
    "Land Area (units not specified in file)": 0.318,
    "Lease Term": 10,
    "Annual Lease Fee": 25738,
    "Land Use Premium": null,
    "Number Of Local Employees": 43,
    "Number Of Foreign Employees": 4,
    Status: "Approved",
    "Investor Address":
      "FLAT 11, 3/F, CENTURY CENTRE 44-46, HUNG TO ROAD, KWUN TONG, HONG KONG",
    "Organization Address":
      "PLOT NO.40, MYAY TAING BLOCK NO. ZONE-5, HLAING THAR YAR TOWNSHIP, YANGON REGION",
    "Investment Permitted Address":
      "PLOT NO.40, MYAY TAING BLOCK NO. ZONE-5, HLAING THAR YAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 3797,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "ဦးနိုင်ထွန်း",
    "Name of Principal Organization": "MYANMAR SWM MOTOR COMPANY LIMITED ",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MYANMAR SWM MOTOR COMPANY LIMITED ",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "236/2020",
    "Permit Date": "2020-02-24T04:37:02Z",
    "Meeting Number": "3/2020",
    "Meeting Date": "2020-02-13T04:38:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ASSEMBLING, MANUFACTURING AND SALES OF MOTOR VEHICLES",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 3315.885,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဒေါ်နန်းလိပ်  ",
    "Land Area (units not specified in file)": 1.651,
    "Lease Term": 30,
    "Annual Lease Fee": 96,
    "Land Use Premium": null,
    "Number Of Local Employees": 102,
    "Number Of Foreign Employees": 5,
    Status: "Monitoring Approved",
    "Investor Address":
      "NO.3, YADARNAR MON 7th STREET, 3 WARD, \t\t\tHLAING TOWNSHIP,YANGON  ",
    "Organization Address":
      "NO.3, YADARNAR MON 7th STREET, 3 WARD, \t\t\tHLAING TOWNSHIP,YANGON  ",
    "Investment Permitted Address":
      "PLOT NO.9/B, 10/A, 10/B, \tMYAY TAING BLOCK NO- 538/A, SHWE PYI THAR TOWNSHIP, YANGON REGION",
  },
  {
    ID: 3798,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "ဦးအေးမင်းထွန်း",
    "Name of Principal Organization": "DONGFENG MOTOR CORPORATION LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "DONGFENG MOTOR CORPORATION LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "244/2020",
    "Permit Date": "2020-03-17T03:37:19Z",
    "Meeting Number": "4/2020",
    "Meeting Date": "2020-03-06T03:37:45Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "ASSEMBLING, MANUFACTURING AND SALES OF MOTOR VEHICLES ",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 12545,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "ဦးအေးမင်းထွန်း",
    "Land Area (units not specified in file)": 1.932,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 93,
    "Number Of Foreign Employees": 10,
    Status: "Monitoring Approved",
    "Investor Address":
      "အမှတ်-၂၄၄၊ ၂၅၄၊ ဆိပ်ကမ်းသာလမ်း၊ အခန်းအမှတ်(၇၃)၊ အမ်တီအမ်တာဝါ၊ ကျောက်တံတားမြို့နယ်၊ ရန်ကုန်မြို့",
    "Organization Address": "",
    "Investment Permitted Address":
      "PLOT No.147, \t\tMYAY \tTAING BLOCK NO. THILAWA INDUSTRIAL ZONE, THANLYIN-KYAUT \t\tTAN TOWNSHIP, YANGON REGION",
  },
  {
    ID: 3803,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr. Huang Xiang",
    "Name of Principal Organization": "Panda Kitchen and Bath",
    "Place of Incorporation": "The United states of America",
    "Company Name In Myanmar": "Prodiso USA Co.,Ltd.",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "272/2020",
    "Permit Date": "2020-07-17T04:25:35Z",
    "Meeting Number": "9/2020",
    "Meeting Date": "2020-07-10T04:26:01Z",
    Sector: "",
    "Type Of Investment Business":
      "Maunfacturing of Funiture made of rubber wood for 100% export",
    "Amount Of Foreign Capital USD (in Millions)": 5.01,
    "Total Amount Of Capital (in Millions)": 5.01,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Sein Yee @ Sai Pone",
    "Land Area (units not specified in file)": 2.34,
    "Lease Term": 50,
    "Annual Lease Fee": null,
    "Land Use Premium": 17046,
    "Number Of Local Employees": 300,
    "Number Of Foreign Employees": 20,
    Status: "Submitted",
    "Investor Address": "5460 Sw, 190th Ave, Miramar, Fl 33029, USA",
    "Organization Address": "3250 NW 77th Ct, Doral, Fl 33122, USA",
    "Investment Permitted Address":
      "Plot No. 6+7, Myay Taing Block Np.144 Industrial Zone, Dagon Myothit (South) Township, Yangon Region",
  },
  {
    ID: 3809,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "MR.LO SIU YUEN",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "CNTIC VPOWER YG2 LIMITED",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "225/2020",
    "Permit Date": "2020-01-28T08:13:27Z",
    "Meeting Number": "2/2020",
    "Meeting Date": "2020-01-24T08:15:10Z",
    Sector: "Oil and Gas",
    "Type Of Investment Business":
      "GENERATION OF 350 MW ELECTRICITY FROM LNG, SUPPLY AND SALE OF EKECTRICITY ON IPP (BOO) BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 297.39,
    "Total Amount Of Capital (in Millions)": 297.39,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 5,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "MEHPCL",
    "Land Area (units not specified in file)": 20,
    "Lease Term": 5,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 159,
    "Number Of Foreign Employees": 49,
    Status: "Submitted",
    "Investor Address":
      "FLAT D, 1/F, BLOCK 3, LAKEVIEW GARDEN, 21 YAU ON STREET, TAI WAI, NEW TERRITORIES, HONG KONG",
    "Organization Address": "",
    "Investment Permitted Address":
      "BLOCK NO (14), THILAWA PORT DEVELOPMENT PROJECT, THANLYIN TOWNSHIP, YANGON REGION",
  },
  {
    ID: 3810,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr. Chen, Shilin",
    "Name of Principal Organization": "-",
    "Place of Incorporation": "-",
    "Company Name In Myanmar": "Zhong Lian Feng Co., Ltd.",
    "Financial Year From": 2020,
    "Financial Year To": 2021,
    "Permit Number": "249/2020",
    "Permit Date": "2020-04-06T07:33:54Z",
    "Meeting Number": "5/2020",
    "Meeting Date": "2020-04-03T07:34:14Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Production and Sales of Mind Steel (MS) Rods",
    "Amount Of Foreign Capital USD (in Millions)": 2.967,
    "Total Amount Of Capital (in Millions)": 2.967,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Mi Mi Khaine",
    "Land Area (units not specified in file)": 3.716,
    "Lease Term": 20,
    "Annual Lease Fee": 39600000,
    "Land Use Premium": null,
    "Number Of Local Employees": 132,
    "Number Of Foreign Employees": 30,
    Status: "Submitted",
    "Investor Address":
      "Block 2, No. 1901, Kaiyuan Winlin Zhejiang, Zhejiang, The People's Republic of China",
    "Organization Address": "-",
    "Investment Permitted Address":
      "Plot No. 109, 112, Myaung Takar Thanmani Industrial Zone, Hmawbi Township, Yangon Region",
  },
  {
    ID: 3811,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Mr. Chen, I-Fu",
    "Name of Principal Organization": "Charm Idea Co., Ltd.",
    "Place of Incorporation": "Seychelles",
    "Company Name In Myanmar": "Aureate Lighting Limited",
    "Financial Year From": 2020,
    "Financial Year To": 2021,
    "Permit Number": "265/2020",
    "Permit Date": "2020-06-26T08:14:38Z",
    "Meeting Number": "8/2020",
    "Meeting Date": "2020-06-18T08:15:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of all Kinds of Lighting Fixtures and Accessories on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 8,
    "Total Amount Of Capital (in Millions)": 8,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Ae Ye (a Lay Nwe Htun",
    "Land Area (units not specified in file)": 3.111,
    "Lease Term": 5,
    "Annual Lease Fee": 338466.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 800,
    "Number Of Foreign Employees": 30,
    Status: "Submitted",
    "Investor Address":
      "No. 1130, 21 Floor, 26 Neighborhood,Zhongzheng Road, Tong an Village, Taoyuan District, Taoyuan City 330, Taiwan, Republic of China",
    "Organization Address":
      "No.4, Franky Building, Providence Industrial Estate, Mahe, Repubic of Seychelles",
    "Investment Permitted Address":
      "Plot No. 29, Myay Taing Block No. 51, Thar Du Kan Industrial Zone, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 3812,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Chit Khine",
    "Name of Principal Organization": "Eden Group Co., Ltd.",
    "Place of Incorporation": "Yangon",
    "Company Name In Myanmar": "Eden Group Co., Ltd.",
    "Financial Year From": 0,
    "Financial Year To": 0,
    "Permit Number": "279/2020",
    "Permit Date": "2020-08-07T09:51:39Z",
    "Meeting Number": "10/2020",
    "Meeting Date": "2020-07-31T09:51:47Z",
    Sector: "",
    "Type Of Investment Business": "",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 0,
    "Currency Of Total Amount": "",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "",
    "Form Of Investment": "",
    "Land Owner": "",
    "Land Area (units not specified in file)": null,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": null,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address": "No. 100 F, Inya Road ,Kamayut T/s, Yangon",
    "Organization Address": "No. 30,Shwe Padauk Yeik Mon, Kamayut T/s, Yangon",
    "Investment Permitted Address":
      "No. 30,Shwe Padauk Yeik Mon, Kamayut T/s, Yangon",
  },
  {
    ID: 3818,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Song, Yunxia",
    "Name of Principal Organization": "United Ascent Travel Ware Co., Ltd",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "United Ascent Travel Ware Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "378/2020",
    "Permit Date": "2020-05-08T05:15:26Z",
    "Meeting Number": "6/2020",
    "Meeting Date": "2020-04-29T05:15:36Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Luggages and Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Hla Htun Aung",
    "Land Area (units not specified in file)": 2,
    "Lease Term": 5,
    "Annual Lease Fee": 84,
    "Land Use Premium": null,
    "Number Of Local Employees": 400,
    "Number Of Foreign Employees": 7,
    Status: "Draft",
    "Investor Address": "Jin Yuan, Room 202, Unit 3, Building 30.",
    "Organization Address":
      "Plot No. 367, Myay Taing Block No. 49, Wartayar Industrial Zone",
    "Investment Permitted Address":
      "Plot No. 367, Myay Taing Block No. 49, Wartayar Industrial Zone",
  },
  {
    ID: 3819,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Baixianzhi",
    "Name of Principal Organization": "Yisheng Hardware Co.,Limited.",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "Pinter Industrial Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "379/2020",
    "Permit Date": "2020-05-08T05:59:57Z",
    "Meeting Number": "6/2020",
    "Meeting Date": "2020-04-29T06:00:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags Appliances on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.721,
    "Total Amount Of Capital (in Millions)": 1.721,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aike Loon",
    "Land Area (units not specified in file)": 4.252,
    "Lease Term": 5,
    "Annual Lease Fee": 0.0516,
    "Land Use Premium": null,
    "Number Of Local Employees": 475,
    "Number Of Foreign Employees": 7,
    Status: "Draft",
    "Investor Address":
      "No.3,  Room 202, Building 1, Nange Dong San Road, Lamma Industrial Zone",
    "Organization Address": "610, Nathan Road, Hollywood Business Center",
    "Investment Permitted Address":
      "Plot No. 106,107, Myaytaingblock No. Myaungtagarthanmani Industrial Zone",
  },
  {
    ID: 3822,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "Daw Yin Wai Chin",
    "Name of Principal Organization": "Orange Steel Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Orange Steel Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "380/2020",
    "Permit Date": "2020-05-04T04:14:51Z",
    "Meeting Number": "6/2020",
    "Meeting Date": "2020-04-29T04:15:36Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Steel Production (Such as Roof Sheet, Wall Sheet, Deck Sheet, Steel Angel)",
    "Amount Of Foreign Capital USD (in Millions)": 0.29,
    "Total Amount Of Capital (in Millions)": 1255.05,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Tin Nyunt",
    "Land Area (units not specified in file)": 1.325,
    "Lease Term": 20,
    "Annual Lease Fee": 84,
    "Land Use Premium": null,
    "Number Of Local Employees": 51,
    "Number Of Foreign Employees": 6,
    Status: "Draft",
    "Investor Address": "No.1A/3, Myin Thar (11) Street, Than Thu Mar Road",
    "Organization Address":
      "Plot No.129/A, Myay Taing Block No.65 (Sethmu), Industrial Zone Part-4",
    "Investment Permitted Address":
      "Plot No.129/A, Myay Taing Block No.65 (Sethmu), Industrial Zone Part-4",
  },
  {
    ID: 3823,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhu Xiaodong",
    "Name of Principal Organization": "Chang Shu Kefu Clothing Company Limited",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Myanmar Huasheng Kefu Fashion Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "381/2020",
    "Permit Date": "2020-05-08T07:27:27Z",
    "Meeting Number": "6/2020",
    "Meeting Date": "2020-04-29T07:36:39Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis ",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 6,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyein Shi",
    "Land Area (units not specified in file)": 3.931,
    "Lease Term": 10,
    "Annual Lease Fee": 0.32,
    "Land Use Premium": null,
    "Number Of Local Employees": 714,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "No.45, Zhangjia Qiao Ma Jia Bei, Xin Zhuang town",
    "Organization Address": "Zhang Qiao Xiejia Tang Village, Xin Zhuang town",
    "Investment Permitted Address":
      "Plot No. 23, Myay Taing Block No. 21, Mya Sein Yaung Industrial Zone",
  },
  {
    ID: 3824,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhao Hu",
    "Name of Principal Organization": "Su Zhong Clothing Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Su Zhong Clothing Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "382/2020",
    "Permit Date": "2020-05-08T08:18:36Z",
    "Meeting Number": "6/2020",
    "Meeting Date": "2020-04-29T08:19:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.1,
    "Total Amount Of Capital (in Millions)": 1.1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Mar Lar & U Thi Han Min Shein",
    "Land Area (units not specified in file)": 0.542,
    "Lease Term": 5,
    "Annual Lease Fee": 36,
    "Land Use Premium": null,
    "Number Of Local Employees": 250,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "Building 15, Dayang Village, Binjiang Town",
    "Organization Address":
      "Plot No.35, Myay Taing Block No.25, Shwe Lin Pan Sethmu Myo",
    "Investment Permitted Address":
      "Plot No.35, Myay Taing Block No.25, Shwe Lin Pan Sethmu Myo",
  },
  {
    ID: 3825,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ren Xin Dong",
    "Name of Principal Organization": "NTC Interlining Myanmar Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "NTC Interlining Myanmar Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "383/2020",
    "Permit Date": "2020-05-18T09:24:24Z",
    "Meeting Number": "7/2020",
    "Meeting Date": "2020-05-13T09:24:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Coating Fabric for Local CMP Garment Enterprise",
    "Amount Of Foreign Capital USD (in Millions)": 2.088,
    "Total Amount Of Capital (in Millions)": 2.088,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Khin Thandar Swe",
    "Land Area (units not specified in file)": 0.75,
    "Lease Term": 15,
    "Annual Lease Fee": 0.0539,
    "Land Use Premium": null,
    "Number Of Local Employees": 52,
    "Number Of Foreign Employees": 2,
    Status: "Draft",
    "Investor Address":
      "819, Suite A Xianggeli Office Bidg No.580, Renmin Road",
    "Organization Address": "Plot No. (167/B), Myay Taing Block No (42)",
    "Investment Permitted Address":
      "Plot No. (167/B), Myay Taing Block No (42)",
  },
  {
    ID: 3826,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Aye Thiha",
    "Name of Principal Organization": "Hidaka Thiha Recycle Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Hidaka Thiha Recycle Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "384/2020",
    "Permit Date": "2020-05-18T04:16:08Z",
    "Meeting Number": "7/2020",
    "Meeting Date": "2020-05-13T04:16:39Z",
    Sector: "Other Services",
    "Type Of Investment Business":
      "Separating, Sorting, Packaging, Export and Local Sales of Recycle Products (Such as Metal, Aluminum)",
    "Amount Of Foreign Capital USD (in Millions)": 1.08,
    "Total Amount Of Capital (in Millions)": 1.2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "Thailand",
    "Form Of Investment": "JV",
    "Land Owner": "U Thein Zaw Oo",
    "Land Area (units not specified in file)": 2.122,
    "Lease Term": 5,
    "Annual Lease Fee": 132,
    "Land Use Premium": null,
    "Number Of Local Employees": 29,
    "Number Of Foreign Employees": 2,
    Status: "Draft",
    "Investor Address": "No.123(A), Shwegondine Road",
    "Organization Address": "Plot No.105, Thilawa Industrial Zone",
    "Investment Permitted Address": "Plot No.105, Thilawa Industrial Zone",
  },
  {
    ID: 3827,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Tan Dongjie",
    "Name of Principal Organization": "Cherry Group Co.,Ltd",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Cherry Apparel (Myanmar) Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "385/2020",
    "Permit Date": "2020-05-18T05:44:32Z",
    "Meeting Number": "7/2020",
    "Meeting Date": "2020-05-13T05:44:51Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 5,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Dishang Group (Myanmar) Co., Ltd.",
    "Land Area (units not specified in file)": 1.601,
    "Lease Term": 10,
    "Annual Lease Fee": 0.065,
    "Land Use Premium": null,
    "Number Of Local Employees": 1800,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "Room 407, Unit 4, Building 2, No.521, Laizhou North Road",
    "Organization Address": "No.2, Nanjing Road",
    "Investment Permitted Address":
      "Unit-A6, Plot No. E2, E3, E6, E7, E8, E9, E10, Myay Taing Block No.20, Anawrahta Industrial Zone",
  },
  {
    ID: 3828,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Kyaw Zay Ya",
    "Name of Principal Organization": "Innofood Myanmar Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Innofood Myanmar Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "386/2020",
    "Permit Date": "2020-06-04T07:55:35Z",
    "Meeting Number": "8/2020",
    "Meeting Date": "2020-05-27T07:56:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Sales of Snack Products (Rice Crackers, Rice Cookies and Rice Biscuits, etc)",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1604,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Wai Wai Htwe",
    "Land Area (units not specified in file)": 2.226,
    "Lease Term": 5,
    "Annual Lease Fee": 166.54,
    "Land Use Premium": null,
    "Number Of Local Employees": 125,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "Awaiyar Orchids, 22nd Street, Between 63rd & 64th Street",
    "Organization Address":
      "Plot No.I4, Myay Taing Block No.20, Anawrahta Industrial Zone",
    "Investment Permitted Address":
      "Plot No.I4, Myay Taing Block No.20, Anawrahta Industrial Zone ",
  },
  {
    ID: 3829,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Bao Yusen",
    "Name of Principal Organization":
      "Jiangyin Xinfeng Clothes Manufacturing Co., Ltd",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Lang Si Garment Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "387/2020",
    "Permit Date": "2020-06-04T08:38:56Z",
    "Meeting Number": "8/2020",
    "Meeting Date": "2020-05-27T08:39:18Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis ",
    "Amount Of Foreign Capital USD (in Millions)": 4.82,
    "Total Amount Of Capital (in Millions)": 4.82,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Thi Ha",
    "Land Area (units not specified in file)": 4.62,
    "Lease Term": 30,
    "Annual Lease Fee": 0.243,
    "Land Use Premium": null,
    "Number Of Local Employees": 2871,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "No.8, Renmin Road, Zhutang Town",
    "Organization Address": "No.8, Renmin Road, Zhutang Town",
    "Investment Permitted Address":
      "Holding No. (25-A), Kwin No.1056, Na Be Pin Kwin, Sar Ta Lin Village Tract",
  },
  {
    ID: 3830,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Nay Lin Zin",
    "Name of Principal Organization": "Excel Myanmar Rice Mill Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Excel Myanmar Rice Mill Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "388/2020",
    "Permit Date": "2020-06-11T09:25:29Z",
    "Meeting Number": "9/2020",
    "Meeting Date": "2020-06-10T09:25:49Z",
    Sector: "Agriculture",
    "Type Of Investment Business": "Rice Mill, Rice Reprocessing Plan",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 1000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Nay Lin Zin",
    "Land Area (units not specified in file)": 0.433,
    "Lease Term": 10,
    "Annual Lease Fee": 10.8,
    "Land Use Premium": null,
    "Number Of Local Employees": 61,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address": "No.D-001, Thirimingalar Garden Housing",
    "Organization Address":
      "Plot No.467 (b), Myay Taing Block No. 25, Shwe Lin Pann Sethmu Myo",
    "Investment Permitted Address":
      "Plot No.467(b), Myay Taing Block No. 25, Shwe Lin Pann Sethmu Myo",
  },
  {
    ID: 3831,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Xu, Liangsheng",
    "Name of Principal Organization": "Wonderful Apparel Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Wonderful Apparel Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "389/2020",
    "Permit Date": "2020-06-11T03:41:27Z",
    "Meeting Number": "9/2020",
    "Meeting Date": "2020-06-10T03:41:56Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.707,
    "Total Amount Of Capital (in Millions)": 1.897,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "U Than Aung",
    "Land Area (units not specified in file)": 6.86,
    "Lease Term": 20,
    "Annual Lease Fee": 0.083,
    "Land Use Premium": null,
    "Number Of Local Employees": 400,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "Room-1801, 18 Floor, Building-A, CFC, 300 East Zhongshan Road",
    "Organization Address":
      "Plot No. 294+295+296, Myay Taing Block No. Myaung Takar Industrial Zone",
    "Investment Permitted Address":
      "Plot No. 294+295+296, Myay Taing Block No. Myaung Tagar Thanmani Industrial Zone",
  },
  {
    ID: 3832,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Xiao.Zhiyuan",
    "Name of Principal Organization":
      "Hong Kong Ruotian International Company Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar": "BBL Floor (Myanmar) Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "390/2020",
    "Permit Date": "2020-06-11T05:29:24Z",
    "Meeting Number": "9/2020",
    "Meeting Date": "2020-06-10T05:29:42Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Selling of SPC Floor, Microcellular Wallboard, Hollow Wallboard and Skirting Line",
    "Amount Of Foreign Capital USD (in Millions)": 3.4,
    "Total Amount Of Capital (in Millions)": 4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "JV",
    "Land Owner": "U Yin Lin",
    "Land Area (units not specified in file)": 1.515,
    "Lease Term": 5,
    "Annual Lease Fee": 203.4,
    "Land Use Premium": null,
    "Number Of Local Employees": 150,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "9A-801, Hutang Yucheng",
    "Organization Address":
      "Unit 303, 3/F, Sam Cheong Building, 216-220 Des Voeux Road Central",
    "Investment Permitted Address":
      "Plot No.382, Myay Taing Block No.25, Shwe Lin Ban Sethmumyo",
  },
  {
    ID: 3833,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lei, Peijun",
    "Name of Principal Organization":
      "Myanmar Cotton Spinning Garment Accessories Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "Myanmar Cotton Spinning Garment Accessories Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "391/2020",
    "Permit Date": "2020-06-11T06:49:11Z",
    "Meeting Number": "9/2020",
    "Meeting Date": "2020-06-10T06:49:35Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Gunned Cotton, Eiderdown Cotton, Honing for Local CMP Garment Enterprises",
    "Amount Of Foreign Capital USD (in Millions)": 1.5,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Zaw Hla@U Khway Lay, Daw San San Yee @ An Yote Kyote",
    "Land Area (units not specified in file)": 1.003,
    "Lease Term": 5,
    "Annual Lease Fee": 48,
    "Land Use Premium": null,
    "Number Of Local Employees": 106,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address": "Licheng Village 44-5",
    "Organization Address": "Plot No.93/A, Hlaing Thar Yar Industrial Zone (3)",
    "Investment Permitted Address":
      "Plot No.93/A, Hlaing Thar Yar Industrial Zone (3)",
  },
  {
    ID: 3834,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. He, Chaobin",
    "Name of Principal Organization": "Myanmar Chaofa Leatherware Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Myanmar Chaofa Leatherware Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "392/2020",
    "Permit Date": "2020-06-25T07:29:38Z",
    "Meeting Number": "10/2020",
    "Meeting Date": "2020-06-24T07:30:15Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Belts and Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.98,
    "Total Amount Of Capital (in Millions)": 4.98,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Kyi Thar Win Pyae",
    "Land Area (units not specified in file)": 1.883,
    "Lease Term": 50,
    "Annual Lease Fee": 0.0167,
    "Land Use Premium": null,
    "Number Of Local Employees": 1874,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "Unit 1, Daliantang Industrial Zone, Wanjiang District",
    "Organization Address":
      "Plot No.65, Myay Taing Block No.49 (Wartayar Industrial Zone)",
    "Investment Permitted Address":
      "Plot No.65, Myay Taing Block No.49 (Wartayar Industrial Zone)",
  },
  {
    ID: 3835,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yan Xu Zhong",
    "Name of Principal Organization": "Shinysun Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Shinysun Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "393/2020",
    "Permit Date": "2020-06-25T05:04:01Z",
    "Meeting Number": "10/2020",
    "Meeting Date": "2020-06-24T05:04:24Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Bra Cup Underwear Mold for Local CMP Enterprises",
    "Amount Of Foreign Capital USD (in Millions)": 1.4,
    "Total Amount Of Capital (in Millions)": 1.4,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Great Shwe Taung Development Co.,Ltd",
    "Land Area (units not specified in file)": 1.131,
    "Lease Term": 50,
    "Annual Lease Fee": 5,
    "Land Use Premium": null,
    "Number Of Local Employees": 250,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "Room No. (603), Building (12), Jiasheng Haoting, Xiashan",
    "Organization Address":
      "Plot No. 56-KA2, Myay Taing Block No.21, Mya Sein Yaung Industrial Zone",
    "Investment Permitted Address":
      "Plot No.56-KA2, Myay Taing Block No.21, Mya Sein Yaung Industrial Zone",
  },
  {
    ID: 3836,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Zhang Xiaobing",
    "Name of Principal Organization":
      "Jiaxing Jingrui Garments Company Limited",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Jing Rui Apparel (Myanmar) Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "394/2020",
    "Permit Date": "2020-06-25T06:03:41Z",
    "Meeting Number": "10/2020",
    "Meeting Date": "2020-06-24T06:04:02Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.794,
    "Total Amount Of Capital (in Millions)": 2.794,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 60,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyaw Zaw Win",
    "Land Area (units not specified in file)": 1.832,
    "Lease Term": 50,
    "Annual Lease Fee": 15.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 800,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "156, Xiangdao Manor Tanxiang Road, Shangzhi",
    "Organization Address":
      "2/F, Building 2, Deyi Printing Factory, West Yinhe Road",
    "Investment Permitted Address":
      "Plot No. 162, Myay Taing Block No. Myaung Ta Kar Than Ma Ni Industrial Zone",
  },
  {
    ID: 3837,
    "Type Of Investment": "Myanmar Citizen Investment Law (MCIL)",
    "Name Of Investor": "U Yone Ann",
    "Name of Principal Organization": "Chu Kabar International Company Limited",
    "Place of Incorporation": "Myanamr",
    "Company Name In Myanmar": "Chu Kabar International Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "395/2020",
    "Permit Date": "2020-06-25T07:20:29Z",
    "Meeting Number": "10/2020",
    "Meeting Date": "2020-06-24T07:20:50Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Seasoning Spices on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 2290,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Chu Kabar International Company Limited",
    "Land Area (units not specified in file)": 1.689,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 114,
    "Number Of Foreign Employees": 6,
    Status: "Draft",
    "Investor Address": "No.143. U Tayokegyi Street, Industrial Zone-4",
    "Organization Address":
      "Ahkwet No. (F/8), No. (A/4), Corner of Yangon-Mandalay and Industrial Garden Street",
    "Investment Permitted Address":
      "Plot No.356, Myay Taing Block No. Yangon Industrial Zone",
  },
  {
    ID: 3838,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Chao, Li-Ping",
    "Name of Principal Organization":
      "William (Myanmar) Industrial Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "William (Myanmar) Industrial Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "396/2020",
    "Permit Date": "2020-07-15T08:48:50Z",
    "Meeting Number": "11/2020",
    "Meeting Date": "2020-07-08T08:49:12Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.125,
    "Total Amount Of Capital (in Millions)": 1.125,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Samoa",
    "Form Of Investment": "FDII",
    "Land Owner": "Mingaladon Industrial Park Co.,Ltd",
    "Land Area (units not specified in file)": 0.42,
    "Lease Term": 50,
    "Annual Lease Fee": 0.99,
    "Land Use Premium": null,
    "Number Of Local Employees": 181,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "5th Floor, 354 Youyuan Be I Lu, Donghai Village",
    "Organization Address": "Plot No.A-8, Mingalardon Industrial Zone",
    "Investment Permitted Address": "Plot No.A-8, Mingalardon Industrial Zone",
  },
  {
    ID: 3839,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Tan, Dan",
    "Name of Principal Organization":
      "Jessie Myanmar Apparel Manufacturing Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar":
      "Jessie Myanmar Apparel Manufacturing Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "397/2020",
    "Permit Date": "2020-07-15T03:35:36Z",
    "Meeting Number": "11/2020",
    "Meeting Date": "2020-07-08T03:35:56Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Knitted Wear on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.069,
    "Total Amount Of Capital (in Millions)": 4.069,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Maung Sein",
    "Land Area (units not specified in file)": 1.195,
    "Lease Term": 10,
    "Annual Lease Fee": 72,
    "Land Use Premium": null,
    "Number Of Local Employees": 1400,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "7,4 Road, Tie Park",
    "Organization Address":
      "Plot No.(130), Myay Taing Block No. Zone(2), Industrial Zone",
    "Investment Permitted Address":
      "Plot No. (130), Myay Taing Block No. Zone (2), Industrial Zone",
  },
  {
    ID: 3840,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Hui Ki Hung Seline",
    "Name of Principal Organization": "Hydrodynamic Enterprise Company Limited",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar":
      "Hydrodynamic Enterprise (Myanmar) Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "398/2020",
    "Permit Date": "2020-07-16T04:17:16Z",
    "Meeting Number": "11/2020",
    "Meeting Date": "2020-07-08T04:17:30Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Sporting Goods on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.257,
    "Total Amount Of Capital (in Millions)": 4.257,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kyway Chein",
    "Land Area (units not specified in file)": 1.87,
    "Lease Term": 5,
    "Annual Lease Fee": 9.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 800,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "Block F,6/F, Wah Hing Industrial Mansions, 36 Tai Yau Street",
    "Organization Address":
      "Block F,6/F, Wah Hing Industrial Mansions, 36 Tai Yau Street",
    "Investment Permitted Address":
      "Holding No. (13/C), Kwin No. & Name- 300(A)/Kone Ywar Kwin, Ya Khaing Yoe Gyi Village",
  },
  {
    ID: 3841,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lin Gaoping",
    "Name of Principal Organization": "Weihai Yongsui Trade Company Limited",
    "Place of Incorporation": "China",
    "Company Name In Myanmar":
      "Myanmar Fortress Wealth Garment Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "399/2020",
    "Permit Date": "2020-07-15T08:05:39Z",
    "Meeting Number": "11/2020",
    "Meeting Date": "2020-07-08T08:05:53Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3.466,
    "Total Amount Of Capital (in Millions)": 3.466,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Dishang Group (Myanmar) Company Limited",
    "Land Area (units not specified in file)": 1.601,
    "Lease Term": 10,
    "Annual Lease Fee": 0.064,
    "Land Use Premium": null,
    "Number Of Local Employees": 1380,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "No.53, Software Avenue, Unit 408, Block, 3, Fuzhou City, 5 Fengxin New District",
    "Organization Address": "No.2, 4th Floor Shenyang Road",
    "Investment Permitted Address":
      "UNIT-A5, Plot No. E2, E3, E6, E7, E8, E9, E10, MyayTaing Block No. 20, Anawrahta Industrial Zone",
  },
  {
    ID: 3842,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Chu Mingxin",
    "Name of Principal Organization":
      "Weihai Dihuali Import and Export Co., Ltd",
    "Place of Incorporation": "China",
    "Company Name In Myanmar": "Myanmar Dihuali Garment Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "400/2020",
    "Permit Date": "2020-07-15T08:09:51Z",
    "Meeting Number": "11/2020",
    "Meeting Date": "2020-07-08T08:10:03Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3.626,
    "Total Amount Of Capital (in Millions)": 3.626,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Dishang Group (Myanmar) Co.,Ltd.",
    "Land Area (units not specified in file)": 1.816,
    "Lease Term": 10,
    "Annual Lease Fee": 0.073,
    "Land Use Premium": null,
    "Number Of Local Employees": 1340,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address": "No. 3188, Hengxing North Street, Beicheng District",
    "Organization Address": "No. 2, 4th Floor, Shenyang Road",
    "Investment Permitted Address":
      "Unit A10, Plot No. E2, E3, E6, E7, E8, E9, E10, Myay Taing Block No. 20, Anawrahta Industrial Zone",
  },
  {
    ID: 3843,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Pham Anh Tuan",
    "Name of Principal Organization": "Han Viet Company Limited",
    "Place of Incorporation": "Vietnam",
    "Company Name In Myanmar": "Hanvico International Company Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "401/2020",
    "Permit Date": "2020-07-15T08:29:58Z",
    "Meeting Number": "11/2020",
    "Meeting Date": "2020-07-08T08:30:15Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": 2.5,
    "Total Amount Of Capital (in Millions)": 2.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Vietnam",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Tin Nu Yee",
    "Land Area (units not specified in file)": 0.269,
    "Lease Term": 20,
    "Annual Lease Fee": 96,
    "Land Use Premium": null,
    "Number Of Local Employees": 26,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address": "DN-1, CT-, Dinh Cong",
    "Organization Address": "Highway 1(A), KM 14 Road, Thanh Tri",
    "Investment Permitted Address":
      "Plot No.13/KA 1E.2D, Myay Taing Block No. 61, Kanbe, Inya Yeikthar Street",
  },
  {
    ID: 3844,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Gao, Yonghong",
    "Name of Principal Organization":
      "Beaume (Hong Kong) International Co., Ltd., ",
    "Place of Incorporation": "Hong Kong",
    "Company Name In Myanmar":
      "Beaume International Garment Manufacturing Limited",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "402/2020",
    "Permit Date": "2020-07-15T07:50:05Z",
    "Meeting Number": "11/2020",
    "Meeting Date": "2020-07-08T07:50:33Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2,
    "Total Amount Of Capital (in Millions)": 2,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "Hong Kong",
    "Form Of Investment": "FDII",
    "Land Owner": "U Thein Lwin",
    "Land Area (units not specified in file)": 1.912,
    "Lease Term": 5,
    "Annual Lease Fee": 120,
    "Land Use Premium": null,
    "Number Of Local Employees": 266,
    "Number Of Foreign Employees": 6,
    Status: "Draft",
    "Investor Address":
      "No. 11, Yingning Road, East Tian;yuan Road, Nanjing 211100, Jingsu, The People's of China",
    "Organization Address":
      "Unit 2 LG1 Mirror Tower 61 Mody Rd, TST KLN, Hong Kong.",
    "Investment Permitted Address":
      "Plot No. 25, Hlaing Thar Yar Industrial Zone (2), Hlaing Thar Yar Township, Yangon Region.",
  },
  {
    ID: 3845,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Chan Chi Wong Dalen ",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "Mountain Tree Industrial Co. Ltd.",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "403/2020",
    "Permit Date": "2020-07-15T09:00:29Z",
    "Meeting Number": "11/2020",
    "Meeting Date": "2020-07-08T09:01:07Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various kinds of Hat on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.714,
    "Total Amount Of Capital (in Millions)": 2.714,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 10,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Saw Win, U Soe Win, U Kyaw Win and Daw Nilar Aye ",
    "Land Area (units not specified in file)": 15158,
    "Lease Term": 10,
    "Annual Lease Fee": 30671,
    "Land Use Premium": null,
    "Number Of Local Employees": 600,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "Room B, 18/F, 28 Nassau Street, Mei Foo Sun Chuen, Kowloon , Hong Kong",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No.182/6, Mya Taing Block -25, Shwe Lin Pan Set Hmu Myo, Hlaing Thar Yar Township, Yangon Region.",
  },
  {
    ID: 3846,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Daw Min Min Thet",
    "Name of Principal Organization": "",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "MYANMAR AGROSEED COMPANY LIMITED\t",
    "Financial Year From": 2019,
    "Financial Year To": 2020,
    "Permit Number": "404/2020",
    "Permit Date": "2020-07-28T07:43:25Z",
    "Meeting Number": "12/2020",
    "Meeting Date": "2020-07-22T07:44:20Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "NO. 8B, SAGAING STREET, MYA KAN THAR GARDEN HOME HLAING TOWNSHIP, YANGON.",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 2400,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Kyaw win",
    "Land Area (units not specified in file)": 2.5,
    "Lease Term": 60,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 84,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "No.8B , Sagaing Street , Mya Kan Thar Housing Hlaing Township , Yangon Region. ",
    "Organization Address": "",
    "Investment Permitted Address":
      "HOLDING NO.( 21/SA ), ( 668 )  MOE KAUNG KWIN, NAUNG TONE PIN VILLAGE ,THANLYIN TOWNSHIP , YANGON REGION",
  },
  {
    ID: 3859,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.. Fan, Wensheng",
    "Name of Principal Organization":
      "ZHEJIANG GLORY HOME \t\t\tFURNISHINGS CO.,LTD. ",
    "Place of Incorporation":
      "Building 1, Building No. 555, Park in Dayun Town, Kangxing West Road, Industry, Jiashan Country, Jiaxing Country, Jiaxing Zhejiang, The People’s Republic of China",
    "Company Name In Myanmar": "GLORY HOME(MYANMAR) \t\t\t\t\tLIMITED",
    "Financial Year From": 0,
    "Financial Year To": 0,
    "Permit Number": "405",
    "Permit Date": "2020-08-14T06:15:18Z",
    "Meeting Number": "13-2020",
    "Meeting Date": "2020-08-12T06:16:44Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING  OF  VARIOUS KINDS OF FOAM & FOAM \t\tMATTRESS ON CMP BASIS ",
    "Amount Of Foreign Capital USD (in Millions)": 4.355,
    "Total Amount Of Capital (in Millions)": 4.355,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner":
      "ဦးအောင်မင်းသူ၊ ဒေါ်မိုးမိုးနိုင်(ခ)စောင်ကျူရင်၊ ဦးဖုန်းမြင့်",
    "Land Area (units not specified in file)": 12.933,
    "Lease Term": 5,
    "Annual Lease Fee": 461148480,
    "Land Use Premium": null,
    "Number Of Local Employees": 332,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "1103, Building 26, Taoyuanji 7, Qianjin 2nd Road, Xixiang, Bao’an, District, Shenzhen City, Guangdong Province, The People’s Republic of China",
    "Organization Address":
      "Building 1, Building No. 555, Park in Dayun Town, Kangxing West Road, Industry, Jiashan Country, Jiaxing Country, Jiaxing Zhejiang, The People’s Republic of China",
    "Investment Permitted Address":
      "PLOT NO. (E1,E3,E5), MYAY TAING BLOCK \t\t\tNO. 21, MYA SEIN YAUNG\tINDUSTRIAL ZONE(3), HLAING THARYAR \t\t\t\tTOWNSHIP, YANGON REGION",
  },
  {
    ID: 3860,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Daw Khin Sandar",
    "Name of Principal Organization": "KANEKO MYANMAR COMPANY LIMITED",
    "Place of Incorporation": "",
    "Company Name In Myanmar": "KANEKO MYANMAR COMPANY LIMITED",
    "Financial Year From": 0,
    "Financial Year To": 0,
    "Permit Number": "406/2020",
    "Permit Date": "2020-08-14T08:42:21Z",
    "Meeting Number": "13/2020",
    "Meeting Date": "2020-08-12T08:42:37Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "MANUFACTURING OF VARIETY OF CAMERA BAGS ON CMP BASIS",
    "Amount Of Foreign Capital USD (in Millions)": 0.544,
    "Total Amount Of Capital (in Millions)": 2174.2,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "Daw Kyu Kyu Han",
    "Land Area (units not specified in file)": 0.152,
    "Lease Term": 20,
    "Annual Lease Fee": 12,
    "Land Use Premium": null,
    "Number Of Local Employees": 45,
    "Number Of Foreign Employees": 1,
    Status: "Draft",
    "Investor Address": "191-192, KHAYAEBIN STREET",
    "Organization Address": "PLOT NO.1/15, MYAY TAING BLOCK NO. 532/CKA, ",
    "Investment Permitted Address":
      "PLOT NO.1/15, MYAY TAING BLOCK NO. 532/CKA, ",
  },
  {
    ID: 3861,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr.Hsieh Ting Tsai",
    "Name of Principal Organization": "Perfect Trading Ltd",
    "Place of Incorporation": "samoa",
    "Company Name In Myanmar": "Topmode (Myanmar) Co., Ltd.",
    "Financial Year From": 19,
    "Financial Year To": 20,
    "Permit Number": "407/2020",
    "Permit Date": "2020-08-14T06:32:15Z",
    "Meeting Number": "13/2020",
    "Meeting Date": "2020-08-12T06:32:57Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Virious Kinds of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.609,
    "Total Amount Of Capital (in Millions)": 2.609,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Aung Myat Htwe ",
    "Land Area (units not specified in file)": 4.206,
    "Lease Term": 50,
    "Annual Lease Fee": 53511.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 706,
    "Number Of Foreign Employees": 15,
    Status: "Draft",
    "Investor Address": "No.Room 2B29, Xinyi Road,Section 5, Taipei, Taiwan.",
    "Organization Address":
      "Beach Road, Ground Floor, NPE Building, VIstra Corporate Services Centre, Apia, Samoa.",
    "Investment Permitted Address":
      "Plot No. 113, Myay Taing Block No.49, War Ta Yar Industrial Zone, Shwe Pyi Thar Township, Yangon.",
  },
  {
    ID: 3862,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Pu Yao-Nan",
    "Name of Principal Organization": "Rich Aroma Co., Ltd",
    "Place of Incorporation": "Samoa",
    "Company Name In Myanmar": "Kai-Xin Enterprise Company Limited",
    "Financial Year From": 19,
    "Financial Year To": 20,
    "Permit Number": "408/2020",
    "Permit Date": "2020-08-28T07:32:26Z",
    "Meeting Number": "14/2020",
    "Meeting Date": "2020-08-26T07:32:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Modern Furniture on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 4.532,
    "Total Amount Of Capital (in Millions)": 4.532,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 60,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Htar Htar Nwe",
    "Land Area (units not specified in file)": 10.978,
    "Lease Term": 50,
    "Annual Lease Fee": 2.6347,
    "Land Use Premium": null,
    "Number Of Local Employees": 400,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "No.18, LN.40, Deyang RD, Jiaoxi Township, Yilan Country 262, China (Taipei)",
    "Organization Address":
      "Level 2, Lotemau Center Building, Vaea Street, Apia, Samoa",
    "Investment Permitted Address":
      "Plot No. (307,308,309), Myay Taing Block No. (49), Wartayar Industrial Zone, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 3863,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Wei, Yu-Tsen",
    "Name of Principal Organization": "Chong International Co., LTD",
    "Place of Incorporation": "Republic of Seychelles",
    "Company Name In Myanmar": "B.C.C. Jewelry MFG. Company Limited",
    "Financial Year From": 19,
    "Financial Year To": 20,
    "Permit Number": "409/2020",
    "Permit Date": "2020-08-28T08:18:31Z",
    "Meeting Number": "14/2020",
    "Meeting Date": "2020-08-26T08:20:02Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Artificial Jewellery on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 2.25,
    "Total Amount Of Capital (in Millions)": 3,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "JV",
    "Land Owner": "U Kyaw Htay, Daw Khaing Thet Mon",
    "Land Area (units not specified in file)": 4.593,
    "Lease Term": 30,
    "Annual Lease Fee": 0.15,
    "Land Use Premium": null,
    "Number Of Local Employees": 380,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "No.311, 8F, Sec.4, Hsin-Yi Road, Da-an District, Taipei City 10681, China (Taipei)",
    "Organization Address":
      "Room S203A, Second Floor, Orion Complex, Victoria, Mahe, Republic of Seychelles",
    "Investment Permitted Address":
      "Plot No. 37,38, Myay Taing Block No.109, Sethmu. East Dagon Myothit Township, Yangon Region",
  },
  {
    ID: 3864,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Xiang Jun",
    "Name of Principal Organization": "",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Jun Sheng Garment Company Limited",
    "Financial Year From": 19,
    "Financial Year To": 20,
    "Permit Number": "410/2020",
    "Permit Date": "2020-08-28T09:19:16Z",
    "Meeting Number": "14/2020",
    "Meeting Date": "2020-08-26T09:14:13Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.42,
    "Total Amount Of Capital (in Millions)": 1.42,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 15,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Myo Myint",
    "Land Area (units not specified in file)": 1.044,
    "Lease Term": 5,
    "Annual Lease Fee": 3.6,
    "Land Use Premium": null,
    "Number Of Local Employees": 800,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "No.1, Gaofeng Road, Gaoming District, Foshan City, Guangdong Province, The People's Republic of China",
    "Organization Address":
      "Plot No. 482, Myay Taing Block No.25, Shwe Lin Ban Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
    "Investment Permitted Address":
      "Plot No. 482, Myay Taing Block No.25, Shwe Lin Ban Industrial Zone, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 3865,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Li Fuyun",
    "Name of Principal Organization":
      "3R Non Woven Manufacture Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "3R Non Woven Manufacture Company Limited",
    "Financial Year From": 19,
    "Financial Year To": 20,
    "Permit Number": "411/2020",
    "Permit Date": "2020-08-28T09:59:06Z",
    "Meeting Number": "14/2020",
    "Meeting Date": "2020-08-26T09:59:14Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Htun San",
    "Land Area (units not specified in file)": 1.099,
    "Lease Term": 5,
    "Annual Lease Fee": 10,
    "Land Use Premium": null,
    "Number Of Local Employees": 80,
    "Number Of Foreign Employees": 8,
    Status: "Draft",
    "Investor Address":
      "No.292, Xicheng Road, Longgang city, zhejiang province, The People's Republic of China",
    "Organization Address":
      "Plot No. 40, Myay Taing Block No. 144, Dagon Myothit (South) Industrial Zone, Dagon Myothit (South) Township, Yangon",
    "Investment Permitted Address":
      "Plot No. 40, Myay Taing Block No. 144, Dagon Myothit (South) Industrial Zone, Dagon Myothit (South) Township, Yangon",
  },
  {
    ID: 3866,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "U Nyan Wai",
    "Name of Principal Organization": "Kyun Shwe Pyi Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Miyako Food Myanmar Company Limited",
    "Financial Year From": 19,
    "Financial Year To": 20,
    "Permit Number": "412/2020",
    "Permit Date": "2020-08-28T04:16:14Z",
    "Meeting Number": "14/2020",
    "Meeting Date": "2020-08-26T04:16:27Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Selling of Roasted Sesame Oil, Natural Ordinary Sesame and Sesame Cookies",
    "Amount Of Foreign Capital USD (in Millions)": 0.7,
    "Total Amount Of Capital (in Millions)": 0.7,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Japan",
    "Form Of Investment": "JV",
    "Land Owner": "U Myint Kyu, U Kyi Win, U Thaung Tint, U Phone Tint",
    "Land Area (units not specified in file)": 0.1,
    "Lease Term": 20,
    "Annual Lease Fee": 7200,
    "Land Use Premium": null,
    "Number Of Local Employees": 84,
    "Number Of Foreign Employees": 1,
    Status: "Draft",
    "Investor Address":
      "No. Y-22, Mya Kan Thar (3) Street, (5) Ward, Hlaing Township, Yangon",
    "Organization Address":
      "No. (A-68), Second Floor, Bahosi Housing Complex, (10) Ward, Lanmadaw Township, Yangon",
    "Investment Permitted Address":
      "Plot No. 50+51, Myay Taing Block No. 42 (Sethmu), Industrial Zone (1), Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 3867,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "Myanmar Agribusiness Public Company Limited",
    "Name of Principal Organization":
      "Myanmar Agribusiness Public Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Myanmar Agribusiness Public Company Limited",
    "Financial Year From": 19,
    "Financial Year To": 20,
    "Permit Number": "413/2020",
    "Permit Date": "2020-08-28T04:46:17Z",
    "Meeting Number": "14/2020",
    "Meeting Date": "2020-08-26T04:46:28Z",
    Sector: "",
    "Type Of Investment Business":
      "Processing and Sales of Rice and By Products",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 6000,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Thaung Win",
    "Land Area (units not specified in file)": 1.371,
    "Lease Term": 50,
    "Annual Lease Fee": 15,
    "Land Use Premium": null,
    "Number Of Local Employees": 84,
    "Number Of Foreign Employees": null,
    Status: "Draft",
    "Investor Address":
      "No.100, Wardan Street and Kan Nar Street, Beside The Concrete Express Way, Wardan Port Area, Lanmadaw Township, Yangon",
    "Organization Address":
      "No.100, Wardan Street and Kan Nar Street, Beside The Concrete Express Way, Wardan Port Area, Lanmadaw Township, Yangon",
    "Investment Permitted Address":
      "Plot No. (143/A), (144/B), (145/A), (146/B), Industrial Zone (1), Hlaing Thar  Yar Township, Yangon Region",
  },
  {
    ID: 3868,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Liu, Hao",
    "Name of Principal Organization": "Good Luck Sports Myanmar Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Good Luck Sports Myanmar Limited",
    "Financial Year From": 19,
    "Financial Year To": 20,
    "Permit Number": "414/2020",
    "Permit Date": "2020-09-28T07:34:07Z",
    "Meeting Number": "15/2020",
    "Meeting Date": "2020-09-23T07:34:17Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Varieties of Bags on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.5,
    "Total Amount Of Capital (in Millions)": 1.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Kyi Thar Win Pyae (Winway Myanmar Co., Ltd",
    "Land Area (units not specified in file)": 1.965,
    "Lease Term": 50,
    "Annual Lease Fee": 0.0166,
    "Land Use Premium": null,
    "Number Of Local Employees": 600,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "No.268, Room 1703, Meiha Road, Mingshi Garden, Unit 1, Xiangzhou District, Guangdong Province, The People's Republic of China",
    "Organization Address":
      "Plot No. (76), Myay Taing Block No. (49), Warta Yar Industrial Zone, Shwe Pyi Thar Township, Yangon Region",
    "Investment Permitted Address":
      "Plot No. (76), Myay Taing Block No. (49), Warta Yar Industrial Zone, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 3869,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Lin, Hsiu-Hua",
    "Name of Principal Organization": "Para Light Electronics Co., Ltd",
    "Place of Incorporation": "China (Taipei)",
    "Company Name In Myanmar":
      "Myanmar Para Light Led & Lighting Accessory Company Limited",
    "Financial Year From": 19,
    "Financial Year To": 20,
    "Permit Number": "415/2020",
    "Permit Date": "2020-09-28T08:09:32Z",
    "Meeting Number": "15/2020",
    "Meeting Date": "2020-09-23T08:09:39Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of LED and Lighting Accessories",
    "Amount Of Foreign Capital USD (in Millions)": 4.5,
    "Total Amount Of Capital (in Millions)": 4.5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "Taiwan, Province of China",
    "Form Of Investment": "FDII",
    "Land Owner": "Yangon Lida Co., Ltd",
    "Land Area (units not specified in file)": 1.278,
    "Lease Term": 50,
    "Annual Lease Fee": 0.17,
    "Land Use Premium": null,
    "Number Of Local Employees": 267,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "No. 188, 4F, Xin Hai Road, Banqiao Dist, New Taipei City 220, China (Taipei)",
    "Organization Address":
      "No.8, 11F, Jiankang Road, Zhonghe Dist, New Taipei City 23586, China (Taipei)",
    "Investment Permitted Address":
      "Plot No. (212), Myay Taing Block No. (25), Shwe Lin Ban Sethmu Myo, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 3870,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Shi Yu",
    "Name of Principal Organization": "Qi Cai (Myanmar) Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Qi Cai (Myanmar) Company Limited",
    "Financial Year From": 19,
    "Financial Year To": 20,
    "Permit Number": "416/2020",
    "Permit Date": "2020-09-28T08:49:37Z",
    "Meeting Number": "15/2020",
    "Meeting Date": "2020-09-23T08:49:58Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.085,
    "Total Amount Of Capital (in Millions)": 1.085,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kwe Chaung",
    "Land Area (units not specified in file)": 1.625,
    "Lease Term": 15,
    "Annual Lease Fee": 42,
    "Land Use Premium": null,
    "Number Of Local Employees": 443,
    "Number Of Foreign Employees": 5,
    Status: "Draft",
    "Investor Address":
      "No. 819, Suite A XiangGeLi Office Bidg No.580, Renmin Road, QiDong JingSu, The People's Republic of China",
    "Organization Address":
      "Plot No. 7, Myay Taing Block No. 25, Shwe Lin Pan Sethmu Myo, Hlaing Thar Yar Township, Yangon",
    "Investment Permitted Address":
      "Plot No. 7, Myay Taing Block No. 25, Shwe Lin Pan Sethmu Myo, Hlaing Thar Yar Township, Yangon",
  },
  {
    ID: 3871,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Josephine Wu",
    "Name of Principal Organization": "Well Success Investment Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Well Success Investment Company Limited",
    "Financial Year From": 19,
    "Financial Year To": 20,
    "Permit Number": "417/2020",
    "Permit Date": "2020-09-28T09:16:35Z",
    "Meeting Number": "15/2020",
    "Meeting Date": "2020-09-23T09:17:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3.864,
    "Total Amount Of Capital (in Millions)": 3.864,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 2,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "A Dream of Kind Garment Factory Co., Ltd",
    "Land Area (units not specified in file)": 0.766,
    "Lease Term": 30,
    "Annual Lease Fee": 0.02,
    "Land Use Premium": null,
    "Number Of Local Employees": 560,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "No. 75, 16F, Zhongxiao RD, New Taipei City 244, Linkou Dist, China (Taipei)",
    "Organization Address":
      "Plot No. (181), Yangon Industrial Zone, Min Ga Lar Don Township, Yangon",
    "Investment Permitted Address":
      "Plot No. (181), Yangon Industrial Zone, Min Ga Lar Don Township, Yangon Region",
  },
  {
    ID: 3872,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Yu Rong Biao",
    "Name of Principal Organization": "Rong Da Garments Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Rong Da Garments Company Limited",
    "Financial Year From": 19,
    "Financial Year To": 20,
    "Permit Number": "418/2020",
    "Permit Date": "2020-09-28T09:40:59Z",
    "Meeting Number": "15/2020",
    "Meeting Date": "2020-09-23T09:41:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.368,
    "Total Amount Of Capital (in Millions)": 1.368,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Kaung Myat, U Lway Lwin",
    "Land Area (units not specified in file)": 4.47,
    "Lease Term": 10,
    "Annual Lease Fee": 0.359,
    "Land Use Premium": null,
    "Number Of Local Employees": 806,
    "Number Of Foreign Employees": 8,
    Status: "Draft",
    "Investor Address":
      "Ren Min Nan Lu, GuiBao ZhuangJiaLou Jiang Yin Zhu Tang Zheng, JiangSu, The People's Republic of China",
    "Organization Address":
      "Plot No. (163+164), Myay Taing Block No. (49), Wartayar Industrial Zone, Shwe Pyi Thar Township, Yangon",
    "Investment Permitted Address":
      "Plot No. (163+164), Myay Taing Block No. (49), Wartayar Industrial Zone, Shwe Pyi Thar Township, Yangon",
  },
  {
    ID: 3873,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Ou YunGuo",
    "Name of Principal Organization":
      "Prisen Guo (Myanmar) Apparel Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Prisen Guo (Myanmar) Apparel Company Limited",
    "Financial Year From": 19,
    "Financial Year To": 20,
    "Permit Number": "419/2020",
    "Permit Date": "2020-09-28T03:19:04Z",
    "Meeting Number": "15/2020",
    "Meeting Date": "2020-09-23T03:19:55Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 3.41,
    "Total Amount Of Capital (in Millions)": 3.41,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Zaw Latt, U Zaw Myo Htet, U Kyaw Min Tun",
    "Land Area (units not specified in file)": 4.68,
    "Lease Term": 10,
    "Annual Lease Fee": 72,
    "Land Use Premium": null,
    "Number Of Local Employees": 1200,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "No.9, Juying Bihaiyuan, Room No. 302, Juexi Street, Ningbo City, XiangShan County, Zhejiang Province, The People's Republic of China",
    "Organization Address":
      "Plot No. 144,145 and 146, Myay Taing Block No. 49, WarTaYar Industrial Zone, Shwe Pyi Thar Township, Yangon Region",
    "Investment Permitted Address":
      "Plot No. 144,145 and 146, Myay Taing Block No. 49, WarTaYar Industrial Zone, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 3874,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Dam Thi Thu",
    "Name of Principal Organization": "Phan Long Product Trading Co., Ltd",
    "Place of Incorporation": "Socialist Republic of Vietnam",
    "Company Name In Myanmar": "Khanh Nhi Steel Manufacturing Company Limited",
    "Financial Year From": 20,
    "Financial Year To": 21,
    "Permit Number": "420/2020",
    "Permit Date": "2020-10-16T03:59:54Z",
    "Meeting Number": "16/2020",
    "Meeting Date": "2020-10-14T03:59:46Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing and Marketing of Construction Materials Based on Steel, Aluminum and Galvanize Iron",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 20,
    "Investing Country": "Vietnam",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Thida Win, Daw Cho Cho Win",
    "Land Area (units not specified in file)": 1.271,
    "Lease Term": 20,
    "Annual Lease Fee": 43.2,
    "Land Use Premium": null,
    "Number Of Local Employees": 46,
    "Number Of Foreign Employees": 7,
    Status: "Draft",
    "Investor Address":
      "No. 168, Hoang Quoc Viet Street, Trung Thanh Award, Pho Yen District, Thai Nguyan City, Socialist Republic of Vietnam",
    "Organization Address":
      "No. 3/4, 4th Quarter, Ninhtrung Tay Ward, Ho Chi Minh City, 2nd District, Socialist Republic of Vietnam",
    "Investment Permitted Address":
      "Plot No. (69), Myay Taing Block No. (25), Shwe Lin Pan Sethmu Myo, Hlaing Thar Yar Township, Yangon Region",
  },
  {
    ID: 3875,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Ms. Lyu Jian Xiu",
    "Name of Principal Organization": "",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "Kamra Manufacturing (Myanmar) Company Limited",
    "Financial Year From": 20,
    "Financial Year To": 21,
    "Permit Number": "421/2020",
    "Permit Date": "2020-10-16T04:43:40Z",
    "Meeting Number": "16/2020",
    "Meeting Date": "2020-10-14T04:44:08Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 0.904,
    "Total Amount Of Capital (in Millions)": 0.904,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 25,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "U Chan Aye",
    "Land Area (units not specified in file)": 1.5,
    "Lease Term": 5,
    "Annual Lease Fee": 120,
    "Land Use Premium": null,
    "Number Of Local Employees": 600,
    "Number Of Foreign Employees": 3,
    Status: "Draft",
    "Investor Address":
      "No.1, Jintai Road, Shangwu 2nd Industrial District, Shiyan Town, Shenzhen Guangdong, The People's Republic of China",
    "Organization Address": "",
    "Investment Permitted Address":
      "Plot No. 56/A, Myay Taing Block No. 65 (Sethmu), Industrial Zone 4, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 3876,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Jung Hae Jin",
    "Name of Principal Organization": "ZIC Trading Co., Ltd",
    "Place of Incorporation": "Republic of Korea",
    "Company Name In Myanmar": "Westwood Myanmar Company Limited",
    "Financial Year From": 20,
    "Financial Year To": 21,
    "Permit Number": "422/2020",
    "Permit Date": "2020-10-16T05:37:02Z",
    "Meeting Number": "16/2020",
    "Meeting Date": "2020-10-14T05:37:13Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garments on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 5,
    "Total Amount Of Capital (in Millions)": 5,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 30,
    "Investing Country": "Korea (Republic of)",
    "Form Of Investment": "FDII",
    "Land Owner": "Daw Ohn Ohn Myint",
    "Land Area (units not specified in file)": 3.83,
    "Lease Term": 30,
    "Annual Lease Fee": 0.217,
    "Land Use Premium": null,
    "Number Of Local Employees": 1633,
    "Number Of Foreign Employees": 6,
    Status: "Draft",
    "Investor Address":
      "12 F, Forhu, 58 Wangsimni- Ro, SeongDong-Gu, Seoul, Republic of Korea",
    "Organization Address":
      "1201-1014, 12 F, Forhu, 58 Wangsimni- Ro, Seongdong-Gu, Seoul, Republic of Korea",
    "Investment Permitted Address":
      "Plot No. 149/3, 149/4, 149/5, 149/6, Myay Taing Block No. 113, East Dagon Industrial Zone, Dagon Myothit (East) Township, Yangon Region",
  },
  {
    ID: 3877,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Fang Mansen",
    "Name of Principal Organization": "South Victory Shoes Company Limited",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "South Victory Shoes Company Limited",
    "Financial Year From": 20,
    "Financial Year To": 21,
    "Permit Number": "423/2020",
    "Permit Date": "2020-11-03T07:22:39Z",
    "Meeting Number": "17/2020",
    "Meeting Date": "2020-10-28T06:42:23Z",
    Sector: "Manufacturing",
    "Type Of Investment Business":
      "Manufacturing of Various Kinds of Shoes on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1.65,
    "Total Amount Of Capital (in Millions)": 1.65,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 50,
    "Investing Country": "China",
    "Form Of Investment": "FDII",
    "Land Owner": "Conpak Property Company Limited",
    "Land Area (units not specified in file)": 2.771,
    "Lease Term": 50,
    "Annual Lease Fee": 0.023549,
    "Land Use Premium": null,
    "Number Of Local Employees": 164,
    "Number Of Foreign Employees": 10,
    Status: "Draft",
    "Investor Address":
      "No. 11, Shitang South Street, Second Alley Xitou, Houjie Town, DongGuan City, GuangDong Province, The People's republic of China",
    "Organization Address":
      "Plot No. 12, Myay Taing Block No. 143/1, Dagon Myothit (South) Township, Yangon",
    "Investment Permitted Address":
      "Plot No. 12, Myay Taing Block No. 143/1, Dagon Myothit (South) Township, Yangon Region",
  },
  {
    ID: 3878,
    "Type Of Investment": "Foreign Direct Investment (FDI)",
    "Name Of Investor": "Mr. Liu, Xin",
    "Name of Principal Organization": "Unippro Trading PTE. LTD.",
    "Place of Incorporation": "Republic of Singapore",
    "Company Name In Myanmar": "Unippro Apparel Company Limited",
    "Financial Year From": 20,
    "Financial Year To": 21,
    "Permit Number": "424/2020",
    "Permit Date": "2020-11-03T07:26:43Z",
    "Meeting Number": "17/2020",
    "Meeting Date": "2020-10-28T07:27:00Z",
    Sector: "Manufacturing",
    "Type Of Investment Business": "Manufacturing of Garment on CMP Basis",
    "Amount Of Foreign Capital USD (in Millions)": 1,
    "Total Amount Of Capital (in Millions)": 1,
    "Currency Of Total Amount": "USD",
    "Period For Bringing in Foreign Capital (in years)": 1,
    "Validity Of Investment Permit (in Years)": 28,
    "Investing Country": "Singapore",
    "Form Of Investment": "FDII",
    "Land Owner": "U Htay Win, U Htun Htun",
    "Land Area (units not specified in file)": 1.86,
    "Lease Term": 8,
    "Annual Lease Fee": 0.151428,
    "Land Use Premium": null,
    "Number Of Local Employees": 443,
    "Number Of Foreign Employees": 7,
    Status: "Draft",
    "Investor Address":
      "3, Lihong South Road, Huadu District, GuangZhou, People's Republic of China",
    "Organization Address": "#14-06, 6 Raffles Quay, Republic of Singapore",
    "Investment Permitted Address":
      "Plot No. (95+96), Myay Taing Block No. 51, Thardukan Industrial Zone, Shwe Pyi Thar Township, Yangon Region",
  },
  {
    ID: 3882,
    "Type Of Investment": "Myanmar Investment Law (MIL)",
    "Name Of Investor": "U Aung Than Myint ",
    "Name of Principal Organization":
      "SHWE PAN KABAR(HEINN CONSTRUCTION) CO., LTD.",
    "Place of Incorporation": "Myanmar",
    "Company Name In Myanmar": "SHWE PAN KABAR(HEINN CONSTRUCTION) CO., LTD.",
    "Financial Year From": 2020,
    "Financial Year To": 2021,
    "Permit Number": "203/2020",
    "Permit Date": "2020-10-09T03:20:34Z",
    "Meeting Number": "13/2020",
    "Meeting Date": "2020-09-29T03:21:32Z",
    Sector: "Hotel and Tourism",
    "Type Of Investment Business": "Hotel Services",
    "Amount Of Foreign Capital USD (in Millions)": null,
    "Total Amount Of Capital (in Millions)": 6050,
    "Currency Of Total Amount": "MMK",
    "Period For Bringing in Foreign Capital (in years)": null,
    "Validity Of Investment Permit (in Years)": null,
    "Investing Country": "Myanmar",
    "Form Of Investment": "MCI",
    "Land Owner": "U Aung Than Myint , Daw Thin Thin Zaw",
    "Land Area (units not specified in file)": 0.059,
    "Lease Term": null,
    "Annual Lease Fee": null,
    "Land Use Premium": null,
    "Number Of Local Employees": 51,
    "Number Of Foreign Employees": 2,
    Status: "Approved",
    "Investor Address":
      "Plot No.(13/G-2C), Myay Taing Block No.7-B, Nant Thar Gone Ward, ",
    "Organization Address":
      "No.(Ma/71), Tan Myint Kyaung Street, Taung Thu Gone Ward, ",
    "Investment Permitted Address":
      "Plot No.(13/G-2C), Myay Taing Block No.7-B, Nant Thar Gone Ward, ",
  },
];

export const DATA_INDEX = lunr(function () {
  this.ref("Company Name In Myanmar");
  this.field("Company Name In Myanmar");
  this.field("ID");
  this.field("Type Of Investment");
  this.field("Investing Country");
});

DATA.forEach((doc) => {
  DATA_INDEX.add(doc);
});
